export default {
  "a": ["ey1", "dt"],
  "abalone": ["ae b-ah l-ow1 n-iy", "nn"],
  "abandon": ["ah b-ae1-n d-ah-n", "vb vbp"],
  "abandoned": ["ah b-ae1-n d-ah-n-d", "vbn vbd jj"],
  "abandonment": ["ah b-ae1-n d-ah-n m-ah-n-t", "nn"],
  "abashed": ["ah b-ae1-sh-t", "jj"],
  "abate": ["ah b-ey1-t", "vb"],
  "abbey": ["ae1 b-iy", "nn"],
  "abbot": ["ae1 b-ah-t", "nn"],
  "abbreviated": ["ah b-r-iy1 v-iy ey t-ah-d", "jj"],
  "abbreviation": ["ah b-r-iy v-iy ey1 sh-ah-n", "nn"],
  "abdicate": ["ae1-b d-ah k-ey-t", "vbp vb"],
  "abdomen": ["ae-b d-ow1 m-ah-n", "nn"],
  "abdominal": ["ae-b d-aa1 m-ah n-ah-l", "jj"],
  "abduct": ["ae-b-d-ah1-k-t", "vb"],
  "abduction": ["ae-b d-ah1-k sh-ah-n", "nn"],
  "aberrant": ["ae b-eh1 r-ah-n-t", "jj"],
  "aberration": ["ae b-er ey1 sh-ah-n", "nn"],
  "abet": ["ah b-eh1-t", "vb"],
  "abhor": ["ae-b hh-ao1-r", "vb"],
  "abhorrent": ["ae-b hh-ao1 r-ah-n-t", "jj"],
  "abide": ["ah b-ay1-d", "vb vbp"],
  "abiding": ["ah b-ay1 d-ih-ng", "jj"],
  "ability": ["ah b-ih1 l-ah t-iy", "nn"],
  "abject": ["ae1-b jh-eh-k-t", "jj"],
  "ablaze": ["ah b-l-ey1-z", "jj rb"],
  "able": ["ey1 b-ah-l", "jj"],
  "abnormal": ["ae-b n-ao1-r m-ah-l", "jj"],
  "abnormality": ["ae-b n-ao-r m-ae1 l-ah t-iy", "nn"],
  "abnormally": ["ae-b n-ao1-r m-ah l-iy", "rb"],
  "aboard": ["ah b-ao1-r-d", "in rb rp"],
  "abode": ["ah b-ow1-d", "nn"],
  "abolish": ["ah b-aa1 l-ih-sh", "vb"],
  "abolition": ["ae b-ah l-ih1 sh-ah-n", "nn"],
  "abolitionist": ["ae b-ah l-ih1 sh-ah n-ah-s-t", "nn"],
  "abominable": ["ah b-aa1 m-ah n-ah b-ah-l", "jj"],
  "abomination": ["ah b-aa m-ah n-ey1 sh-ah-n", "nn"],
  "aboriginal": ["ae b-er ih1 jh-ah n-ah-l", "jj"],
  "aborigine": ["ae b-er ih1 jh-ah n-iy", "nn"],
  "abort": ["ah b-ao1-r-t", "vb"],
  "aborted": ["ah b-ao1-r t-ih-d", "jj vbd vbn"],
  "abortion": ["ah b-ao1-r sh-ah-n", "nn"],
  "abortionist": ["ah b-ao1-r sh-ah-n ih-s-t", "nn"],
  "abortive": ["ah b-ao1-r t-ih-v", "jj"],
  "abound": ["ah b-aw1-n-d", "vbp vb"],
  "about": ["ah b-aw1-t", "in rb rp rbr"],
  "above": ["ah b-ah1-v", "in jj rb"],
  "aboveboard": ["ah b-ah1-v b-ao-r-d", "jj"],
  "abrasive": ["ah b-r-ey1 s-ih-v", "jj"],
  "abreast": ["ah b-r-eh1-s-t", "rb"],
  "abridge": ["ah-b-r-ih1-jh", "vb"],
  "abroad": ["ah b-r-ao1-d", "rb"],
  "abrogate": ["ae1 b-r-ah g-ey-t", "vb"],
  "abrupt": ["ah b-r-ah1-p-t", "jj"],
  "abruptly": ["ah b-r-ah1-p-t l-iy", "rb"],
  "abruptness": ["ah b-r-ah1-p-t n-ah-s", "nn"],
  "abscess": ["ae1-b s-eh-s", "nn"],
  "absence": ["ae1-b s-ah-n-s", "nn"],
  "absent": ["ae1-b s-ah-n-t", "jj vb"],
  "absentee": ["ae-b s-ah-n t-iy1", "jj nn"],
  "absolute": ["ae1-b s-ah l-uw-t", "jj nn"],
  "absolutely": ["ae-b s-ah l-uw1-t l-iy", "rb"],
  "absoluteness": ["ae1-b s-ah l-uw-t n-ah-s", "nn"],
  "absolution": ["ae-b s-ah l-uw1 sh-ah-n", "nn"],
  "absolve": ["ah-b z-aa1-l-v", "vb vbp"],
  "absorb": ["ah-b z-ao1-r-b", "vb vbp"],
  "absorbed": ["ah-b z-ao1-r-b-d", "vbn jj vbd"],
  "absorbency": ["ah-b z-ao1-r b-ah-n s-iy", "nn"],
  "absorbent": ["ah-b z-ao1-r b-ah-n-t", "jj"],
  "absorber": ["ah-b z-ao1-r b-er", "nn"],
  "absorbing": ["ah-b z-ao1-r b-ih-ng", "vbg jj"],
  "absorption": ["ah-b z-ao1-r-p sh-ah-n", "nn"],
  "abstain": ["ah-b s-t-ey1-n", "vb vbp"],
  "abstention": ["ah-b s-t-eh1-n ch-ah-n", "nn"],
  "abstinence": ["ae1-b s-t-ah n-ah-n-s", "nn"],
  "abstract": ["ae-b s-t-r-ae1-k-t", "jj nn vb vbp"],
  "abstracted": ["ae1-b s-t-r-ae-k t-ih-d", "jj vbd"],
  "abstraction": ["ae-b s-t-r-ae1-k sh-ah-n", "nn"],
  "abstruse": ["ah-b s-t-r-uw1-s", "jj"],
  "absurd": ["ah-b s-er1-d", "jj"],
  "absurdist": ["ah-b s-er1 d-ih-s-t", "jj nn"],
  "absurdity": ["ah-b s-er1 d-ah t-iy", "nn"],
  "absurdly": ["ah-b s-er1-d l-iy", "rb"],
  "abundance": ["ah b-ah1-n d-ah-n-s", "nn"],
  "abundant": ["ah b-ah1-n d-ah-n-t", "jj"],
  "abundantly": ["ah b-ah1-n d-ah-n-t l-iy", "rb"],
  "abuse": ["ah b-y-uw1-s", "nn vb vbp"],
  "abused": ["ah b-y-uw1-z-d", "vbn jj vbd"],
  "abuser": ["ah b-y-uw1 z-er", "nn"],
  "abusive": ["ah b-y-uw1 s-ih-v", "jj"],
  "abuzz": ["ah b-ah1-z", "jj"],
  "abysmal": ["ah b-ih1-z m-ah-l", "jj"],
  "abyss": ["ah b-ih1-s", "nn"],
  "acacia": ["ah k-ey1 sh-ah", "nn"],
  "academia": ["ae k-ah d-iy1 m-iy ah", "nn"],
  "academic": ["ae k-ah d-eh1 m-ih-k", "jj nn"],
  "academically": ["ae k-ah d-eh1 m-ih-k l-iy", "rb"],
  "academician": ["ae k-ah d-ah m-ih1 sh-ah-n", "nn"],
  "academy": ["ah k-ae1 d-ah m-iy", "nn"],
  "accede": ["ae-k s-iy1-d", "vb"],
  "accelerate": ["ae-k s-eh1 l-er ey-t", "vb vbp"],
  "accelerated": ["ae-k s-eh1 l-er ey t-ih-d", "vbn jj vbd"],
  "accelerating": ["ae-k s-eh1 l-er ey t-ih-ng", "vbg jj"],
  "acceleration": ["ae-k s-eh l-er ey1 sh-ah-n", "nn"],
  "accelerator": ["ae-k s-eh1 l-er ey t-er", "nn"],
  "accelerometer": ["ae-k s-eh l-er aa1 m-ah t-er", "nn"],
  "accent": ["ah-k s-eh1-n-t", "nn vb"],
  "accented": ["ae1-k s-eh-n t-ih-d", "vbn jj"],
  "accentuate": ["ae-k s-eh1-n ch-uw ey-t", "vb"],
  "accept": ["ae-k s-eh1-p-t", "vb vbp"],
  "acceptability": ["ah-k s-eh-p t-ah b-ih1 l-ah t-iy", "nn"],
  "acceptable": ["ae-k s-eh1-p t-ah b-ah-l", "jj"],
  "acceptance": ["ae-k s-eh1-p t-ah-n-s", "nn"],
  "accepted": ["ae-k s-eh1-p t-ih-d", "vbn jj vbd"],
  "accepting": ["ae-k s-eh1-p t-ih-ng", "vbg jj"],
  "access": ["ae1-k s-eh-s", "nn vb"],
  "accessibility": ["ae-k s-eh s-ah b-ih1 l-ih t-iy", "nn"],
  "accessible": ["ae-k s-eh1 s-ah b-ah-l", "jj"],
  "accessory": ["ae-k s-eh1 s-er iy", "nn jj"],
  "accident": ["ae1-k s-ah d-ah-n-t", "nn"],
  "accidental": ["ae-k s-ah d-eh1-n t-ah-l", "jj"],
  "accidentally": ["ae-k s-ah d-eh1-n t-ah l-iy", "rb"],
  "accidently": ["ae1-k s-ah d-ah-n-t l-iy", "rb"],
  "acclaim": ["ah k-l-ey1-m", "nn vb"],
  "acclaimed": ["ah k-l-ey1-m-d", "vbn vbd jj"],
  "accolade": ["ae1 k-ah l-ey-d", "nn"],
  "accommodate": ["ah k-aa1 m-ah d-ey-t", "vb vbp"],
  "accommodation": ["ah k-aa m-ah d-ey1 sh-ah-n", "nn"],
  "accompaniment": ["ah k-ah1-m-p n-ih m-ah-n-t", "nn"],
  "accompanist": ["ah k-ah1-m p-ah n-ah-s-t", "nn"],
  "accompany": ["ah k-ah1-m p-ah n-iy", "vb vbp"],
  "accompanying": ["ah k-ah1-m p-ah n-iy ih-ng", "vbg jj"],
  "accomplice": ["ah k-aa1-m p-l-ah-s", "nn"],
  "accomplish": ["ah k-aa1-m p-l-ih-sh", "vb vbp"],
  "accomplished": ["ah k-aa1-m p-l-ih-sh-t", "vbn jj vbd"],
  "accomplishment": ["ah k-aa1-m p-l-ih-sh m-ah-n-t", "nn"],
  "accord": ["ah k-ao1-r-d", "nn vbp rb vb"],
  "accordance": ["ah k-ao1-r d-ah-n-s", "nn"],
  "accordingly": ["ah k-ao1-r d-ih-ng l-iy", "rb"],
  "accordion": ["ah k-ao1-r d-iy ah-n", "nn"],
  "accost": ["ah-k-ao1-s-t", "vb"],
  "account": ["ah k-aw1-n-t", "nn vbp vb"],
  "accountability": ["ah k-aw1-n t-ah b-ih l-ih t-iy", "nn"],
  "accountable": ["ah k-aw1-n t-ah b-ah-l", "jj"],
  "accountant": ["ah k-aw1-n t-ah-n-t", "nn"],
  "accouterment": ["ah k-uw1 t-er m-ah-n-t", "nn"],
  "accredit": ["ah-k-r-eh1-d-ih-t", "vb"],
  "accreditation": ["ah k-r-eh d-ah t-ey1 sh-ah-n", "nn"],
  "accretion": ["ah k-r-iy1 sh-ah-n", "nn"],
  "accrual": ["ah k-r-uw1 ah-l", "nn"],
  "accrue": ["ah k-r-uw1", "vb"],
  "accrued": ["ah k-r-uw1-d", "vbn jj"],
  "accumulate": ["ah k-y-uw1 m-y-ah l-ey-t", "vb vbp"],
  "accumulated": ["ah k-y-uw1 m-y-ah l-ey t-ih-d", "vbn jj vbd"],
  "accumulating": ["ah k-y-uw1 m-y-ah l-ey t-ih-ng", "vbg jj"],
  "accumulation": ["ah k-y-uw m-y-ah l-ey1 sh-ah-n", "nn"],
  "accuracy": ["ae1 k-y-er ah s-iy", "nn"],
  "accurate": ["ae1 k-y-er ah-t", "jj"],
  "accurately": ["ae1 k-y-er ah-t l-iy", "rb"],
  "accusation": ["ae k-y-ah z-ey1 sh-ah-n", "nn"],
  "accusatory": ["ah k-y-uw1 z-ah t-ao r-iy", "jj"],
  "accuse": ["ah k-y-uw1-z", "vb vbp"],
  "accused": ["ah k-y-uw1-z-d", "vbn vbd jj nn"],
  "accuser": ["ah k-y-uw1 z-er", "nn"],
  "accusing": ["ah k-y-uw1 z-ih-ng", "vbg jj"],
  "accusingly": ["ah k-y-uw1 z-ih-ng l-iy", "rb"],
  "accustom": ["ah-k-ah1-s-t-ah-m", "vb"],
  "accustomed": ["ah k-ah1 s-t-ah-m-d", "vbn jj"],
  "ace": ["ey1-s", "nn"],
  "acerbic": ["ah s-eh1-r b-ih-k", "jj"],
  "acetate": ["ae1 s-ah t-ey-t", "nn"],
  "acetone": ["ae1 s-ah t-ow-n", "nn"],
  "acetylene": ["ah s-eh1 t-ah l-iy-n", "nn"],
  "ache": ["ey1-k", "nn vb vbp"],
  "achievable": ["ah ch-iy1 v-ah b-ah-l", "jj"],
  "achieve": ["ah ch-iy1-v", "vb vbp"],
  "achieved": ["ah ch-iy1-v-d", "vbn vbd jj"],
  "achievement": ["ah ch-iy1-v m-ah-n-t", "nn"],
  "aching": ["ey1 k-ih-ng", "vbg jj"],
  "acid": ["ae1 s-ah-d", "nn jj"],
  "acidified": ["ah s-ih1 d-ah f-ay-d", "vbn"],
  "acidify": ["ah-s-ih1-d-ah-f-ay", "vb"],
  "acidity": ["ah s-ih1 d-ah t-iy", "nn"],
  "acidly": ["ae1 s-ah-d l-iy", "rb"],
  "aciduria": ["ae s-ah d-uh1 r-iy ah", "nn"],
  "acknowledge": ["ae-k n-aa1 l-ih-jh", "vbp vb"],
  "acknowledged": ["ae-k n-aa1 l-ih-jh-d", "vbd vbn jj"],
  "acknowledgement": ["ae-k n-aa1 l-ih-jh m-ah-n-t", "nn"],
  "acknowledgment": ["ae-k n-aa1 l-ih-jh m-ah-n-t", "nn"],
  "acne": ["ae1-k n-iy", "nn"],
  "acolyte": ["ae1 k-ah l-ay-t", "nn"],
  "acorn": ["ey1 k-ao-r-n", "nn"],
  "acoustic": ["ah k-uw1 s-t-ih-k", "jj"],
  "acoustical": ["ah k-uw1 s-t-ih k-ah-l", "jj"],
  "acoustically": ["ah k-uw1 s-t-ih-k l-iy", "rb"],
  "acquaint": ["ah k-w-ey1-n-t", "vb"],
  "acquaintance": ["ah k-w-ey1-n t-ah-n-s", "nn"],
  "acquiesce": ["ae k-w-iy eh1-s", "vb"],
  "acquiescence": ["ae k-w-iy eh1 s-ah-n-s", "nn"],
  "acquire": ["ah k-w-ay1 er", "vb nn vbp"],
  "acquired": ["ah k-w-ay1 er-d", "vbn jj vbd"],
  "acquirer": ["ah k-w-ay1 er er", "nn"],
  "acquisition": ["ae k-w-ah z-ih1 sh-ah-n", "nn"],
  "acquisitive": ["ah k-w-ih1 z-ah t-ih-v", "jj"],
  "acquit": ["ah k-w-ih1-t", "vb"],
  "acquittal": ["ah k-w-ih1 t-ah-l", "nn"],
  "acre": ["ey1 k-er", "nn"],
  "acreage": ["ey1 k-er ih-jh", "nn"],
  "acrimonious": ["ae k-r-ah m-ow1 n-iy ah-s", "jj"],
  "acrimony": ["ae1 k-r-ih m-ow n-iy", "nn"],
  "acrobat": ["ae1 k-r-ah b-ae-t", "nn"],
  "acrobatic": ["ae k-r-ah b-ae1 t-ih-k", "jj"],
  "acronym": ["ae1 k-r-ah n-ih-m", "nn"],
  "across": ["ah k-r-ao1-s", "in rb rp"],
  "acrylic": ["ah k-r-ih1 l-ih-k", "nn"],
  "act": ["ae1-k-t", "nn vbp vb"],
  "acting": ["ae1-k t-ih-ng", "vbg jj nn"],
  "action": ["ae1-k sh-ah-n", "nn"],
  "actionable": ["ae1-k sh-ah-n ah b-ah-l", "jj"],
  "activate": ["ae1-k t-ah v-ey-t", "vbp vb"],
  "activated": ["ae1-k t-ah v-ey t-ah-d", "vbn jj"],
  "activation": ["ae-k t-ah v-ey1 sh-ah-n", "nn"],
  "active": ["ae1-k t-ih-v", "jj nn"],
  "actively": ["ae1-k t-ih-v l-iy", "rb"],
  "activism": ["ae1-k t-ih v-ih z-ah-m", "nn"],
  "activist": ["ae1-k t-ah v-ah-s-t", "nn jj"],
  "activity": ["ae-k t-ih1 v-ah t-iy", "nn"],
  "actor": ["ae1-k t-er", "nn"],
  "actress": ["ae1-k t-r-ah-s", "nn"],
  "actual": ["ae1-k ch-uw ah-l", "jj"],
  "actuality": ["ae-k ch-uw ae1 l-ah t-iy", "nn"],
  "actually": ["ae1-k ch-uw ah l-iy", "rb"],
  "actuarial": ["ae-k ch-uw eh1 r-iy ah-l", "jj"],
  "actuary": ["ae1-k ch-uw eh r-iy", "nn"],
  "acumen": ["ah k-y-uw1 m-ah-n", "nn"],
  "acupuncture": ["ae1 k-y-uw p-ah-ng-k ch-er", "nn"],
  "acute": ["ah k-y-uw1-t", "jj nn"],
  "acutely": ["ah k-y-uw1-t l-iy", "rb"],
  "ad": ["ae1-d", "nn"],
  "adage": ["ae1 d-ah-jh", "nn"],
  "adagio": ["ah d-aa1 zh-iy ow", "nn rb"],
  "adamant": ["ae1 d-ah m-ah-n-t", "jj"],
  "adamantly": ["ae1 d-ah m-ah-n-t l-iy", "rb"],
  "adapt": ["ah d-ae1-p-t", "vb vbp"],
  "adaptability": ["ah d-ae-p t-ah b-ih1 l-ah t-iy", "nn"],
  "adaptable": ["ah d-ae1-p t-ah b-ah-l", "jj"],
  "adaptation": ["ae d-ah-p t-ey1 sh-ah-n", "nn"],
  "adapter": ["ah d-ae1-p t-er", "nn"],
  "adaptor": ["ah d-ae1-p t-er", "nn"],
  "add": ["ae1-d", "vb vbp"],
  "added": ["ae1 d-ah-d", "vbd jj vbn"],
  "addict": ["ah d-ih1-k-t", "nn vb"],
  "addicted": ["ah d-ih1-k t-ah-d", "vbn jj"],
  "addiction": ["ah d-ih1-k sh-ah-n", "nn"],
  "addictive": ["ah d-ih1-k t-ih-v", "jj"],
  "addition": ["ah d-ih1 sh-ah-n", "nn"],
  "additional": ["ah d-ih1 sh-ah n-ah-l", "jj"],
  "additionally": ["ah d-ih1 sh-ah-n ah l-iy", "rb"],
  "additive": ["ae1 d-ah t-ih-v", "nn"],
  "addle": ["ae1-d-ah-l", "vb"],
  "addled": ["ae1 d-ah-l-d", "jj vbn"],
  "address": ["ae1 d-r-eh-s", "nn vbp vb"],
  "addressed": ["ah d-r-eh1-s-t", "vbn jj vbd"],
  "addressee": ["ae d-r-eh s-iy1", "nn"],
  "adept": ["ah d-eh1-p-t", "jj"],
  "adequacy": ["ae1 d-ah k-w-ah s-iy", "nn"],
  "adequate": ["ae1 d-ah k-w-ah-t", "jj"],
  "adequately": ["ae1 d-ah k-w-ah-t l-iy", "rb"],
  "adhere": ["ah-d hh-ih1-r", "vb vbp"],
  "adherence": ["ah-d hh-ih1 r-ah-n-s", "nn"],
  "adherent": ["ah-d hh-ih1 r-ah-n-t", "jj nn"],
  "adhesive": ["ae-d hh-iy1 s-ih-v", "jj nn"],
  "adjacent": ["ah jh-ey1 s-ah-n-t", "jj"],
  "adjective": ["ae1 jh-ih-k t-ih-v", "nn"],
  "adjoin": ["ah-jh-oy1-n", "vb"],
  "adjoining": ["ah jh-oy1 n-ih-ng", "vbg jj"],
  "adjourn": ["ah jh-er1-n", "vb"],
  "adjournment": ["ah jh-er1-n m-ah-n-t", "nn"],
  "adjudge": ["ah-jh-ah1-jh", "vb"],
  "adjudicate": ["ah jh-uw1 d-ih k-ey-t", "vb"],
  "adjudication": ["ah jh-uw d-ah k-ey1 sh-ah-n", "nn"],
  "adjunct": ["ae1 jh-ah-ng-k-t", "nn jj"],
  "adjust": ["ah jh-ah1-s-t", "vb vbp"],
  "adjustable": ["ah jh-ah1 s-t-ah b-ah-l", "jj"],
  "adjusted": ["ah jh-ah1 s-t-ah-d", "vbn jj vbd"],
  "adjuster": ["ah jh-ah1 s-t-er", "nn"],
  "adjustment": ["ah jh-ah1-s-t m-ah-n-t", "nn"],
  "adman": ["ae1-d m-ah-n", "nn"],
  "administer": ["ah-d m-ih1 n-ah s-t-er", "vb vbp"],
  "administrate": ["ae-d m-ih1 n-ih s-t-r-ey-t", "vb"],
  "administration": ["ae-d m-ih n-ih s-t-r-ey1 sh-ah-n", "nn"],
  "administrative": ["ah-d m-ih1 n-ah s-t-r-ey t-ih-v", "jj"],
  "administratively": ["ae-d m-ih n-ah s-t-r-ey1 t-ih-v l-iy", "rb"],
  "administrator": ["ah-d m-ih1 n-ah s-t-r-ey t-er", "nn"],
  "admirable": ["ae1-d m-er ah b-ah-l", "jj"],
  "admirably": ["ae1-d m-er ah b-l-iy", "rb"],
  "admiral": ["ae1-d m-er ah-l", "nn"],
  "admiralty": ["ae1-d m-er ah-l t-iy", "nn"],
  "admiration": ["ae-d m-er ey1 sh-ah-n", "nn"],
  "admire": ["ae-d m-ay1-r", "vb vbp"],
  "admired": ["ah-d m-ay1 er-d", "vbd vbn jj"],
  "admirer": ["ae-d m-ay1 r-er", "nn"],
  "admiringly": ["ae-d m-ay1 r-ih-ng l-iy", "rb"],
  "admissible": ["ah-d m-ih1 s-ah b-ah-l", "jj"],
  "admission": ["ae-d m-ih1 sh-ah-n", "nn"],
  "admit": ["ah-d m-ih1-t", "vb vbp"],
  "admittance": ["ah-d m-ih1 t-ah-n-s", "nn"],
  "admitted": ["ah-d m-ih1 t-ah-d", "vbd vbn jj"],
  "admittedly": ["ae-d m-ih1 t-ih-d l-iy", "rb"],
  "admonish": ["ae-d-m-aa1-n-ih-sh", "vb"],
  "admonition": ["ae-d m-ah n-ih1 sh-ah-n", "nn"],
  "adobe": ["ah d-ow1 b-iy", "nn"],
  "adolescence": ["ae d-ah l-eh1 s-ah-n-s", "nn"],
  "adolescent": ["ae d-ah l-eh1 s-ah-n-t", "nn jj"],
  "adopt": ["ah d-aa1-p-t", "vb vbp"],
  "adoptable": ["ah d-aa1-p t-ah b-ah-l", "jj"],
  "adopted": ["ah d-aa1-p t-ah-d", "vbn vbd jj"],
  "adoptee": ["ah d-aa1-p t-iy1", "nn"],
  "adoption": ["ah d-aa1-p sh-ah-n", "nn"],
  "adoptive": ["ah d-aa1-p t-ih-v", "jj"],
  "adorable": ["ah d-ao1 r-ah b-ah-l", "jj"],
  "adore": ["ah d-ao1-r", "vbp vb"],
  "adorn": ["ah d-ao1-r-n", "vb vbp"],
  "adrenal": ["ah d-r-iy1 n-ah-l", "jj nn"],
  "adrenaline": ["ah d-r-eh1 n-ah l-ah-n", "nn"],
  "adrift": ["ah d-r-ih1-f-t", "rb"],
  "adroit": ["ah d-r-oy1-t", "jj"],
  "adroitly": ["ah d-r-oy1-t l-iy", "rb"],
  "adulation": ["ae jh-ah l-ey1 sh-ah-n", "nn"],
  "adult": ["ah d-ah1-l-t", "nn jj"],
  "adulterate": ["ah-d-ah1-l-t-er-ey-t", "vb"],
  "adulterated": ["ah d-ah1-l t-er ey t-ih-d", "vbn jj"],
  "adulterer": ["ah d-ah1-l t-er er", "nn"],
  "adulterous": ["ah d-ah1-l t-er ah-s", "jj"],
  "adultery": ["ah d-ah1-l t-er iy", "nn"],
  "adulthood": ["ah d-ah1-l-t hh-uh-d", "nn"],
  "advance": ["ah-d v-ae1-n-s", "nn jj vb vbp"],
  "advanced": ["ah-d v-ae1-n-s-t", "vbd vbn jj"],
  "advancement": ["ah-d v-ae1-n-s m-ah-n-t", "nn"],
  "advancer": ["ah-d v-ae1-n s-er", "nn"],
  "advancing": ["ah-d v-ae1-n s-ih-ng", "vbg jj"],
  "advantage": ["ae-d v-ae1-n t-ih-jh", "nn vb"],
  "advantageous": ["ae-d v-ah-n t-ey1 jh-ah-s", "jj"],
  "advent": ["ae1-d v-eh-n-t", "nn"],
  "adventure": ["ae-d v-eh1-n ch-er", "nn vb"],
  "adventurer": ["ae-d v-eh1-n ch-er er", "nn"],
  "adventuresome": ["ae-d v-eh1-n ch-er s-ah-m", "jj"],
  "adventurous": ["ae-d v-eh1-n ch-er ah-s", "jj"],
  "adverb": ["ae1-d v-er-b", "nn"],
  "adverbial": ["ae-d v-er1 b-iy ah-l", "jj"],
  "adversarial": ["ae-d v-er s-eh1 r-iy ah-l", "jj"],
  "adversary": ["ae1-d v-er s-eh r-iy", "nn jj"],
  "adverse": ["ae-d v-er1-s", "jj"],
  "adversely": ["ae-d v-er1-s l-iy", "rb"],
  "adversity": ["ae-d v-er1 s-ih t-iy", "nn"],
  "advertise": ["ae1-d v-er t-ay-z", "vb vbp"],
  "advertised": ["ae1-d v-er t-ay-z-d", "vbn jj vbd"],
  "advertisement": ["ah-d v-er1 t-ah-z m-ah-n-t", "nn"],
  "advertiser": ["ae1-d v-er t-ay z-er", "nn"],
  "advertorial": ["ae-d v-er t-ao1 r-iy ah-l", "jj"],
  "advice": ["ae-d v-ay1-s", "nn"],
  "advisable": ["ah-d v-ay1 z-ah b-ah-l", "jj"],
  "advise": ["ae-d v-ay1-z", "vb vbp"],
  "advised": ["ae-d v-ay1-z-d", "vbn vbd jj"],
  "advisedly": ["ae-d v-ay1 z-ah-d l-iy", "rb"],
  "advisement": ["ah-d v-ay1-z m-ah-n-t", "nn"],
  "adviser": ["ae-d v-ay1 z-er", "nn"],
  "advisor": ["ae-d v-ay1 z-er", "nn"],
  "advisory": ["ae-d v-ay1 z-er iy", "jj nn"],
  "advocacy": ["ae1-d v-ah k-ah s-iy", "nn"],
  "advocate": ["ae1-d v-ah k-ah-t", "nn vb vbp"],
  "aegis": ["iy1 jh-ah-s", "nn"],
  "aerial": ["eh1 r-iy ah-l", "jj"],
  "aerobic": ["eh r-ow1 b-ih-k", "jj"],
  "aerobics": ["er ow1 b-ih-k-s", "nn"],
  "aerodynamic": ["eh r-ow d-ay n-ae1 m-ih-k", "jj"],
  "aeronautical": ["eh r-ow n-aa1 t-ah k-ah-l", "jj"],
  "aerosol": ["eh1 r-ah s-aa-l", "nn"],
  "aerospace": ["eh1 r-ow s-p-ey-s", "nn jj"],
  "aesthetic": ["eh-s th-eh1 t-ih-k", "jj nn"],
  "aesthetically": ["eh-s th-eh1 t-ih-k l-iy", "rb"],
  "afar": ["ah f-aa1-r", "rb"],
  "affable": ["ae1 f-ah b-ah-l", "jj"],
  "affair": ["ah f-eh1-r", "nn"],
  "affect": ["ah f-eh1-k-t", "vb vbp nn"],
  "affectation": ["ae f-eh-k t-ey1 sh-ah-n", "nn"],
  "affected": ["ah f-eh1-k t-ah-d", "vbn jj vbd"],
  "affection": ["ah f-eh1-k sh-ah-n", "nn"],
  "affectionate": ["ah f-eh1-k sh-ah-n ah-t", "jj"],
  "affectionately": ["ah f-eh1-k sh-ah-n ah-t l-iy", "rb"],
  "afferent": ["ae1 f-er ah-n-t", "jj"],
  "affidavit": ["ae f-ah d-ey1 v-ah-t", "nn"],
  "affiliate": ["ah f-ih1 l-iy ey-t", "nn vb"],
  "affiliated": ["ah f-ih1 l-iy ey t-ah-d", "vbn jj"],
  "affiliation": ["ah f-ih l-iy ey1 sh-ah-n", "nn"],
  "affinity": ["ah f-ih1 n-ah t-iy", "nn"],
  "affirm": ["ah f-er1-m", "vb vbp"],
  "affirmation": ["ae f-er m-ey1 sh-ah-n", "nn"],
  "affirmative": ["ah f-er1 m-ah t-ih-v", "jj nn"],
  "affix": ["ae1 f-ih-k-s", "vb"],
  "affixed": ["ah f-ih1-k-s-t", "vbn jj"],
  "afflict": ["ah f-l-ih1-k-t", "vb"],
  "afflicted": ["ah f-l-ih1-k t-ah-d", "vbn jj"],
  "affliction": ["ah f-l-ih1-k sh-ah-n", "nn"],
  "affluence": ["ae1 f-l-uw ah-n-s", "nn"],
  "affluent": ["ae1 f-l-uw ah-n-t", "jj nn"],
  "afford": ["ah f-ao1-r-d", "vb vbp"],
  "affordability": ["ah f-ao-r d-ah b-ih1 l-ah t-iy", "nn"],
  "affordable": ["ah f-ao1-r d-ah b-ah-l", "jj"],
  "affront": ["ah f-r-ah1-n-t", "nn vb"],
  "afghan": ["ae1-f g-ae-n", "nn"],
  "aficionado": ["ah f-iy sh-y-ah n-aa1 d-ow", "nn"],
  "afraid": ["ah f-r-ey1-d", "jj"],
  "after": ["ae1-f t-er", "in rb rp"],
  "afterburner": ["ae1-f t-er b-er n-er", "nn"],
  "aftereffect": ["ae1-f t-er ah f-eh-k-t", "nn"],
  "afterglow": ["ae1-f t-er g-l-ow", "nn"],
  "aftermarket": ["ae1-f t-er m-aa-r k-ih-t", "jj nn"],
  "aftermath": ["ae1-f t-er m-ae-th", "nn"],
  "afternoon": ["ae-f t-er n-uw1-n", "nn"],
  "aftershock": ["ae1-f t-er sh-aa-k", "nn"],
  "afterthought": ["ae1-f t-er th-aa-t", "nn"],
  "afterward": ["ae1-f t-er w-er-d", "rb"],
  "afterwards": ["ae1-f t-er w-er-d-z", "rb"],
  "again": ["ah g-eh1-n", "rb"],
  "against": ["ah g-eh1-n-s-t", "in"],
  "agate": ["ae1 g-ah-t", "nn"],
  "age": ["ey1-jh", "nn vb vbp"],
  "aged": ["ey1-jh-d", "vbn jj vbd"],
  "ageless": ["ey1-jh l-ah-s", "jj"],
  "agency": ["ey1 jh-ah-n s-iy", "nn"],
  "agenda": ["ah jh-eh1-n d-ah", "nn"],
  "agent": ["ey1 jh-ah-n-t", "nn"],
  "agglomeration": ["ah g-l-aa m-er ey1 sh-ah-n", "nn"],
  "aggrandize": ["ah-g-r-ae1-n-d-ay-z", "vb"],
  "aggravate": ["ae1 g-r-ah v-ey-t", "vbp vb"],
  "aggravating": ["ae1 g-r-ah v-ey t-ih-ng", "vbg jj"],
  "aggregate": ["ae1 g-r-ah g-ah-t", "jj nn"],
  "aggression": ["ah g-r-eh1 sh-ah-n", "nn"],
  "aggressive": ["ah g-r-eh1 s-ih-v", "jj"],
  "aggressively": ["ah g-r-eh1 s-ih-v l-iy", "rb"],
  "aggressiveness": ["ah g-r-eh1 s-ih-v n-ah-s", "nn"],
  "aggressor": ["ah g-r-eh1 s-er", "nn"],
  "aggrieve": ["ah-g-r-iy1-v", "vb"],
  "aggrieved": ["ah g-r-iy1-v-d", "vbn jj"],
  "aghast": ["ah g-ae1-s-t", "jj"],
  "agile": ["ae1 jh-ah-l", "jj"],
  "agility": ["ah jh-ih1 l-ah t-iy", "nn"],
  "aging": ["ey1 jh-ih-ng", "vbg jj nn"],
  "agitate": ["ae1 jh-ah t-ey-t", "vb vbp"],
  "agitation": ["ae jh-ah t-ey1 sh-ah-n", "nn"],
  "agitator": ["ae1 jh-ah t-ey t-er", "nn"],
  "agleam": ["ah-g l-iy1-m", "jj"],
  "ago": ["ah g-ow1", "rb in"],
  "agonize": ["ae1 g-ah n-ay-z", "vb vbp"],
  "agonized": ["ae1 g-ah n-ay-z-d", "vbd jj"],
  "agonizing": ["ae1 g-ah n-ay z-ih-ng", "jj"],
  "agony": ["ae1 g-ah n-iy", "nn"],
  "agrarian": ["ah g-r-eh1 r-iy ah-n", "jj nn"],
  "agree": ["ah g-r-iy1", "vb vbp"],
  "agreeable": ["ah g-r-iy1 ah b-ah-l", "jj"],
  "agreed": ["ah g-r-iy1-d", "vbd vbn jj"],
  "agreement": ["ah g-r-iy1 m-ah-n-t", "nn"],
  "agricultural": ["ae g-r-ah k-ah1-l ch-er ah-l", "jj"],
  "agriculture": ["ae1 g-r-ih k-ah-l ch-er", "nn"],
  "agronomist": ["ah g-r-aa1 n-ah m-ih-s-t", "nn"],
  "aground": ["ah g-r-aw1-n-d", "rb"],
  "ahead": ["ah hh-eh1-d", "rb jj"],
  "ahs": ["aa1-z", "uh"],
  "aid": ["ey1-d", "nn vb vbp"],
  "aide": ["ey1-d", "nn"],
  "ail": ["ey1-l", "vb"],
  "aileron": ["ey1 l-er aa-n", "nn"],
  "ailing": ["ey1 l-ih-ng", "vbg jj"],
  "ailment": ["ey1-l m-ah-n-t", "nn"],
  "aim": ["ey1-m", "nn vbp vb"],
  "aimless": ["ey1-m l-ah-s", "jj"],
  "aimlessly": ["ey1-m l-ah-s l-iy", "rb"],
  "air": ["eh1-r", "nn vb"],
  "airbag": ["eh1-r b-ae-g", "nn"],
  "airborne": ["eh1-r b-ao-r-n", "jj"],
  "aircraft": ["eh1-r k-r-ae-f-t", "nn"],
  "airfare": ["eh1-r f-eh-r", "nn"],
  "airfield": ["eh1-r f-iy-l-d", "nn"],
  "airflow": ["eh1-r f-l-ow", "nn"],
  "airframe": ["eh1-r f-r-ey-m", "nn"],
  "airless": ["eh1-r l-ah-s", "jj"],
  "airlift": ["eh1-r l-ih-f-t", "nn vb"],
  "airline": ["eh1-r l-ay-n", "nn"],
  "airliner": ["eh1-r l-ay n-er", "nn"],
  "airmail": ["eh1-r m-ey-l", "nn"],
  "airman": ["eh1-r m-ah-n", "nn"],
  "airplane": ["eh1-r p-l-ey-n", "nn"],
  "airport": ["eh1-r p-ao-r-t", "nn"],
  "airspeed": ["eh1-r s-p-iy-d", "nn"],
  "airstrip": ["eh1-r s-t-r-ih-p", "nn"],
  "airtime": ["eh1-r t-ay-m", "nn"],
  "airwave": ["eh1-r w-ey-v", "nn"],
  "airway": ["eh1-r w-ey", "nn"],
  "airy": ["eh1 r-iy", "jj"],
  "aisle": ["ay1-l", "nn"],
  "ajar": ["ah jh-aa1-r", "rb"],
  "alabaster": ["ae1 l-ah b-ae s-t-er", "jj"],
  "alarm": ["ah l-aa1-r-m", "nn vb"],
  "alarmed": ["ah l-aa1-r-m-d", "vbn jj"],
  "alarming": ["ah l-aa1-r m-ih-ng", "jj vbg"],
  "alarmingly": ["ah l-aa1-r m-ih-ng l-iy", "rb"],
  "alarmist": ["ah l-aa1-r m-ah-s-t", "jj"],
  "alas": ["ah l-ae1-s", "uh"],
  "albatross": ["ae1-l b-ah t-r-aa-s", "nn"],
  "albeit": ["ao-l b-iy1 ih-t", "in rb"],
  "albino": ["ae-l b-ay1 n-ow", "nn"],
  "album": ["ae1-l b-ah-m", "nn"],
  "albumin": ["ae-l b-y-uw1 m-ah-n", "nn"],
  "alchemy": ["ae1-l k-ah m-iy", "nn"],
  "alcohol": ["ae1-l k-ah hh-aa-l", "nn"],
  "alcoholic": ["ae-l k-ah hh-aa1 l-ih-k", "jj nn"],
  "alcoholism": ["ae1-l k-ah hh-ao l-ih z-ah-m", "nn"],
  "alcove": ["ae1-l k-ow-v", "nn"],
  "alderman": ["ao1-l d-er m-ah-n", "nn"],
  "ale": ["ey1-l", "nn"],
  "alert": ["ah l-er1-t", "jj vbp nn vb"],
  "alertness": ["ah l-er1-t n-ah-s", "nn"],
  "alfalfa": ["ae-l f-ae1-l f-ah", "nn"],
  "algae": ["ae1-l jh-iy", "nn"],
  "algebra": ["ae1-l jh-ah b-r-ah", "nn"],
  "algebraic": ["ae-l jh-ah b-r-ey1 ih-k", "jj"],
  "algorithm": ["ae1-l g-er ih dh-ah-m", "nn"],
  "alias": ["ey1 l-iy ah-s", "nn"],
  "alibi": ["ae1 l-ah b-ay", "nn"],
  "alien": ["ey1 l-iy ah-n", "jj nn"],
  "alienate": ["ey1 l-y-ah n-ey-t", "vb"],
  "alienating": ["ey1 l-iy ah n-ey t-ih-ng", "vbg jj"],
  "alienation": ["ey l-iy ah n-ey1 sh-ah-n", "nn"],
  "alight": ["ah l-ay1-t", "jj vb"],
  "align": ["ah l-ay1-n", "vb vbp"],
  "aligned": ["ah l-ay1-n-d", "vbn jj"],
  "alignment": ["ah l-ay1-n m-ah-n-t", "nn"],
  "alike": ["ah l-ay1-k", "rb jj"],
  "alimony": ["ae1 l-ah m-ow n-iy", "nn"],
  "alive": ["ah l-ay1-v", "jj rb"],
  "alkali": ["ae1-l k-ah l-ay", "nn"],
  "alkaline": ["ae1-l k-ah l-ay-n", "jj"],
  "alkaloid": ["ae1-l k-ah l-oy-d", "nn"],
  "all": ["ao1-l", "dt rb pdt"],
  "allay": ["ah l-ey1", "vb"],
  "allegation": ["ae l-ah g-ey1 sh-ah-n", "nn"],
  "allege": ["ah l-eh1-jh", "vbp vb"],
  "alleged": ["ah l-eh1-jh-d", "vbn jj vbd"],
  "allegedly": ["ah l-eh1 jh-ah-d l-iy", "rb"],
  "allegiance": ["ah l-iy1 jh-ah-n-s", "nn"],
  "allegorical": ["ae l-ah g-ao1 r-ah k-ah-l", "jj"],
  "allegory": ["ae1 l-ah g-ao r-iy", "nn"],
  "allegro": ["ah l-eh1 g-r-ow", "jj"],
  "allergic": ["ah l-er1 jh-ih-k", "jj"],
  "allergy": ["ae1 l-er jh-iy", "nn"],
  "alleviate": ["ah l-iy1 v-iy ey-t", "vb vbp"],
  "alley": ["ae1 l-iy", "nn"],
  "alleyway": ["ae1 l-iy w-ey", "nn"],
  "alliance": ["ah l-ay1 ah-n-s", "nn"],
  "allied": ["ah l-ay1-d", "vbn jj vbd"],
  "alligator": ["ae1 l-ah g-ey t-er", "nn"],
  "alliterative": ["ah l-ih1 t-er ah t-ih-v", "jj"],
  "allocate": ["ae1 l-ah k-ey-t", "vb vbp"],
  "allocation": ["ae l-ah k-ey1 sh-ah-n", "nn"],
  "allocator": ["ae1 l-ah k-ey t-er", "nn"],
  "allot": ["ah l-aa1-t", "vb"],
  "allotment": ["ah l-aa1-t m-ah-n-t", "nn"],
  "allow": ["ah l-aw1", "vb vbp"],
  "allowable": ["ah l-aw1 ah b-ah-l", "jj"],
  "allowance": ["ah l-aw1 ah-n-s", "nn"],
  "allowed": ["ah l-aw1-d", "vbn jj vbd"],
  "alloy": ["ae1 l-oy", "nn"],
  "allude": ["ah-l-uw1-d", "vb"],
  "allure": ["ah l-uh1-r", "nn"],
  "alluring": ["ah l-uh1 r-ih-ng", "jj"],
  "allusion": ["ah l-uw1 zh-ah-n", "nn"],
  "alluvial": ["ae l-uw1 v-iy ah-l", "jj"],
  "ally": ["ae1 l-ay", "nn"],
  "alma": ["ae1-l m-ah", "jj nn"],
  "almanac": ["ao1-l m-ah n-ae-k", "nn"],
  "almond": ["aa1 m-ah-n-d", "nn"],
  "almost": ["ao1-l m-ow-s-t", "rb jj"],
  "aloft": ["ah l-ao1-f-t", "rb"],
  "alone": ["ah l-ow1-n", "rb jj"],
  "along": ["ah l-ao1-ng", "in rb rp"],
  "alongside": ["ah l-ao1-ng s-ay1-d", "in rb"],
  "aloof": ["ah l-uw1-f", "jj rb"],
  "aloofness": ["ah l-uw1-f n-ah-s", "nn"],
  "aloud": ["ah l-aw1-d", "rb"],
  "alpha": ["ae1-l f-ah", "jj nn"],
  "alphabet": ["ae1-l f-ah b-eh-t", "nn"],
  "alphabetic": ["ae-l f-ah b-eh1 t-ih-k", "jj"],
  "alphabetical": ["ae-l f-ah b-eh1 t-ih k-ah-l", "jj"],
  "alphabetically": ["ae-l f-ah b-eh1 t-ih-k l-iy", "rb"],
  "already": ["ao-l r-eh1 d-iy", "rb"],
  "also": ["ao1-l s-ow", "rb ."],
  "altar": ["ao1-l t-er", "nn"],
  "alter": ["ao1-l t-er", "vb vbp"],
  "alteration": ["ao-l t-er ey1 sh-ah-n", "nn"],
  "altercation": ["aa-l t-er k-ey1 sh-ah-n", "nn"],
  "altered": ["ao1-l t-er-d", "vbn jj vbd"],
  "alternate": ["ao1-l t-er n-ah-t", "jj vbp nn vb"],
  "alternately": ["ao1-l t-er n-ah-t l-iy", "rb"],
  "alternative": ["ao-l t-er1 n-ah t-ih-v", "nn jj"],
  "alternatively": ["ao-l t-er1 n-ah t-ih-v l-iy", "rb"],
  "although": ["ao-l dh-ow1", "in"],
  "altitude": ["ae1-l t-ah t-uw-d", "nn"],
  "altogether": ["ao-l t-ah g-eh1 dh-er", "rb"],
  "altruism": ["ae1-l t-r-uw ih z-ah-m", "nn"],
  "altruistic": ["ao-l t-r-uw ih1 s-t-ih-k", "jj"],
  "alum": ["ae1 l-ah-m", "nn"],
  "aluminum": ["ah l-uw1 m-ah n-ah-m", "nn jj"],
  "alumnus": ["ah l-ah1-m n-ah-s", "nn"],
  "always": ["ao1-l w-ey-z", "rb"],
  "am": ["ae1-m", "vbp rb"],
  "amalgam": ["ah m-ae1-l g-ah-m", "nn"],
  "amalgamate": ["ah-m-ae1-l-g-ah-m-ey-t", "vb"],
  "amalgamation": ["ah m-ae-l g-ah m-ey1 sh-ah-n", "nn"],
  "amass": ["ah m-ae1-s", "vb vbp"],
  "amateur": ["ae1 m-ah t-er", "nn jj"],
  "amateurish": ["ae1 m-ah ch-er ih-sh", "jj"],
  "amaze": ["ah m-ey1-z", "vb vbp"],
  "amazed": ["ah m-ey1-z-d", "vbn vbd jj"],
  "amazement": ["ah m-ey1-z m-ah-n-t", "nn"],
  "amazing": ["ah m-ey1 z-ih-ng", "jj"],
  "amazingly": ["ah m-ey1 z-ih-ng l-iy", "rb"],
  "amazon": ["ae1 m-ah z-aa-n", "nn"],
  "ambassador": ["ae-m b-ae1 s-ah d-er", "nn"],
  "amber": ["ae1-m b-er", "jj nn"],
  "ambiance": ["ae1-m b-iy ah-n-s", "nn"],
  "ambidextrous": ["ae-m b-ah d-eh1-k-s t-r-ah-s", "jj"],
  "ambiguity": ["ae-m b-ih g-y-uw1 ah t-iy", "nn"],
  "ambiguous": ["ae-m b-ih1 g-y-uw ah-s", "jj"],
  "ambition": ["ae-m b-ih1 sh-ah-n", "nn"],
  "ambitious": ["ae-m b-ih1 sh-ah-s", "jj"],
  "ambitiously": ["ae-m b-ih1 sh-ah-s l-iy", "rb"],
  "ambivalence": ["ae-m b-ih1 v-ah l-ah-n-s", "nn"],
  "ambivalent": ["ae-m b-ih1 v-ah l-ah-n-t", "jj"],
  "amble": ["ae1-m b-ah-l", "vb"],
  "ambrosial": ["ae-m b-r-ow1 zh-ah-l", "jj"],
  "ambulance": ["ae1-m b-y-ah l-ah-n-s", "nn"],
  "ambulatory": ["ae1-m b-y-ah l-ah t-ao r-iy", "jj"],
  "ambush": ["ae1-m b-uh-sh", "nn vb"],
  "amelioration": ["ah m-iy l-y-er ey1 sh-ah-n", "nn"],
  "amen": ["ey m-eh1-n", "uh"],
  "amenable": ["ah m-eh1 n-ah b-ah-l", "jj"],
  "amend": ["ah m-eh1-n-d", "vb vbp"],
  "amendment": ["ah m-eh1-n-d m-ah-n-t", "nn"],
  "amenity": ["ah m-eh1 n-ah t-iy", "nn"],
  "amiable": ["ey1 m-iy ah b-ah-l", "jj"],
  "amicable": ["ae1 m-ih k-ah b-ah-l", "jj"],
  "amicably": ["ae1 m-ih k-ah b-l-iy", "rb"],
  "amicus": ["ah m-iy1 k-ah-s", "nn"],
  "amid": ["ah m-ih1-d", "in"],
  "amidst": ["ah m-ih1-d-s-t", "in"],
  "amiss": ["ah m-ih1-s", "jj"],
  "amity": ["ae1 m-ih t-iy", "nn"],
  "ammo": ["ae1 m-ow", "nn"],
  "ammonia": ["ah m-ow1 n-y-ah", "nn"],
  "ammonium": ["ah m-ow1 n-iy ah-m", "nn"],
  "ammunition": ["ae m-y-ah n-ih1 sh-ah-n", "nn"],
  "amnesty": ["ae1-m n-ah s-t-iy", "nn"],
  "amniotic": ["ae1-m n-iy ao t-ih-k", "jj"],
  "amok": ["ah m-ah1-k", "rb"],
  "among": ["ah m-ah1-ng", "in"],
  "amongst": ["ah m-ah1-ng-s-t", "in"],
  "amoral": ["ey m-ao1 r-ah-l", "jj"],
  "amorist": ["ae1 m-er ah-s-t", "nn"],
  "amorous": ["ae1 m-er ah-s", "jj"],
  "amorphous": ["ah m-ao1-r f-ah-s", "jj"],
  "amortize": ["ae1 m-er t-ay-z", "vb"],
  "amount": ["ah m-aw1-n-t", "nn vb vbp"],
  "amphetamine": ["ae-m f-eh1 t-ah m-iy-n", "nn"],
  "amphibious": ["ae-m f-ih1 b-iy ah-s", "jj"],
  "amphitheater": ["ae1-m f-ah th-iy ah t-er", "nn"],
  "ample": ["ae1-m p-ah-l", "jj"],
  "amplification": ["ae-m p-l-ah f-ah k-ey1 sh-ah-n", "nn"],
  "amplifier": ["ae1-m p-l-ah f-ay er", "nn"],
  "amplify": ["ae1-m p-l-ah f-ay", "vb"],
  "amplitude": ["ae1-m p-l-ah t-uw-d", "nn"],
  "amply": ["ae1-m p-l-iy", "rb"],
  "amputate": ["ae1-m-p-y-ah-t-ey-t", "vb"],
  "amputation": ["ae-m p-y-ah t-ey1 sh-ah-n", "nn"],
  "amulet": ["ae1 m-y-ah l-ah-t", "nn"],
  "amuse": ["ah m-y-uw1-z", "vb vbp"],
  "amused": ["ah m-y-uw1-z-d", "vbn jj vbd"],
  "amusement": ["ah m-y-uw1-z m-ah-n-t", "nn"],
  "amusing": ["ah m-y-uw1 z-ih-ng", "jj"],
  "amusingly": ["ah m-y-uw1 z-ih-ng l-iy", "rb"],
  "an": ["ae1-n", "dt cc jj"],
  "anachronism": ["ah n-ae1 k-r-ah n-ih z-ah-m", "nn"],
  "anachronistic": ["ah n-ae k-r-ah n-ih1 s-t-ih-k", "jj"],
  "anaconda": ["ae n-ah k-aa1-n d-ah", "nn"],
  "anaerobic": ["ae n-er ow1 b-ih-k", "jj"],
  "anaesthesia": ["ae n-ah-s th-iy1 zh-ah", "nn"],
  "anagram": ["ae1 n-ah g-r-ae-m", "nn"],
  "analgesic": ["ae n-ah-l jh-iy1 s-ih-k", "jj nn"],
  "analog": ["ae1 n-ah l-ao-g", "nn jj"],
  "analogous": ["ah n-ae1 l-ah g-ah-s", "jj"],
  "analogue": ["ae1 n-ah l-ao-g", "nn"],
  "analogy": ["ah n-ae1 l-ah jh-iy", "nn"],
  "analyse": ["ah n-ae1 l-ah-z", "vb"],
  "analysis": ["ah n-ae1 l-ah s-ah-s", "nn"],
  "analyst": ["ae1 n-ah l-ah-s-t", "nn"],
  "analytic": ["ae n-ah l-ih1 t-ih-k", "jj nn"],
  "analytical": ["ae n-ah l-ih1 t-ih k-ah-l", "jj"],
  "analytically": ["ae n-ah l-ih1 t-ih-k l-iy", "rb"],
  "analyticity": ["ae n-ah l-ah t-ih1 s-ah t-iy", "nn"],
  "analyzable": ["ae1 n-ah l-ay z-ah b-ah-l", "jj"],
  "analyze": ["ae1 n-ah l-ay-z", "vb vbp"],
  "analyzer": ["ae1 n-ah l-ay z-er", "nn"],
  "anarchic": ["ae n-aa1-r k-ih-k", "jj"],
  "anarchical": ["ae n-aa1-r k-ah k-ah-l", "jj"],
  "anarchist": ["ae1 n-er k-ah-s-t", "nn"],
  "anarchy": ["ae1 n-er k-iy", "nn"],
  "anathema": ["ah n-ae1 th-ah m-ah", "nn"],
  "anatomical": ["ae n-ah t-aa1 m-ah k-ah-l", "jj nn"],
  "anatomically": ["ae n-ah t-aa1 m-ah-k l-iy", "rb"],
  "anatomy": ["ah n-ae1 t-ah m-iy", "nn"],
  "ancestor": ["ae1-n s-eh s-t-er", "nn"],
  "ancestral": ["ae-n s-eh1-s t-r-ah-l", "jj"],
  "ancestry": ["ae1-n s-eh-s t-r-iy", "nn"],
  "anchor": ["ae1-ng k-er", "nn vbp vb"],
  "anchorage": ["ae1-ng k-er ah-jh", "nn"],
  "anchored": ["ae1-ng k-er-d", "vbn vbd jj"],
  "anchovy": ["ae-n ch-ow1 v-iy", "nn"],
  "ancient": ["ey1-n ch-ah-n-t", "jj nn"],
  "ancillary": ["ae1-n s-ah l-eh r-iy", "jj"],
  "and": ["ae1-n-d", "cc"],
  "anecdotal": ["ae n-ah-k d-ow1 t-ah-l", "jj"],
  "anecdote": ["ae1 n-ah-k d-ow-t", "nn"],
  "anemia": ["ah n-iy1 m-iy ah", "nn"],
  "anemic": ["ah n-iy1 m-ih-k", "jj"],
  "anesthetic": ["ae n-ah-s th-eh1 t-ih-k", "nn"],
  "anew": ["ah n-uw1", "rb"],
  "angel": ["ey1-n jh-ah-l", "nn"],
  "angelfish": ["ey1-n jh-ah-l f-ih-sh", "nn"],
  "angelic": ["ae-n jh-eh1 l-ih-k", "jj"],
  "angelica": ["ae-n jh-eh1 l-ih k-ah", "nn"],
  "anger": ["ae1-ng g-er", "nn vb vbp"],
  "angered": ["ae1-ng g-er-d", "vbn jj vbd"],
  "angina": ["ae-n jh-ay1 n-ah", "nn"],
  "angle": ["ae1-ng g-ah-l", "nn vb"],
  "angler": ["ae1-ng g-l-er", "nn"],
  "angora": ["ae-ng g-ao1 r-ah", "nn"],
  "angrily": ["ae1-ng g-r-ah l-iy", "rb"],
  "angry": ["ae1-ng g-r-iy", "jj"],
  "angst": ["aa1-ng-k-s-t", "nn"],
  "anguish": ["ae1-ng g-w-ih-sh", "nn"],
  "anguished": ["ae1-ng g-w-ih-sh-t", "jj"],
  "angular": ["ae1-ng g-y-ah l-er", "jj"],
  "animal": ["ae1 n-ah m-ah-l", "nn jj"],
  "animate": ["ae1 n-ah m-ah-t", "jj vb"],
  "animated": ["ae1 n-ah m-ey t-ah-d", "jj vbd vbn"],
  "animation": ["ae n-ah m-ey1 sh-ah-n", "nn"],
  "animism": ["ae1 n-ah m-ih z-ah-m", "nn"],
  "animosity": ["ae n-ah m-aa1 s-ah t-iy", "nn"],
  "anise": ["ae1 n-ah-s", "nn"],
  "ankle": ["ae1-ng k-ah-l", "nn"],
  "annals": ["ae1 n-ah-l-z", "nn"],
  "annex": ["ae1 n-eh-k-s", "nn vb"],
  "annexation": ["ae n-eh-k s-ey1 sh-ah-n", "nn"],
  "annihilate": ["ah n-ay1 ah l-ey-t", "vb"],
  "annihilation": ["ah n-ay ah l-ey1 sh-ah-n", "nn"],
  "anniversary": ["ae n-ah v-er1 s-er iy", "nn"],
  "annotate": ["ae1-n-ah-t-ey-t", "vb"],
  "announce": ["ah n-aw1-n-s", "vb vbp"],
  "announced": ["ah n-aw1-n-s-t", "vbd vbn jj"],
  "announcement": ["ah n-aw1-n s-m-ah-n-t", "nn"],
  "announcer": ["ah n-aw1-n s-er", "nn"],
  "announcment": ["ah n-aw1-n s-m-ah-n-t", "nn"],
  "annoy": ["ah n-oy1", "vb vbp"],
  "annoyance": ["ah n-oy1 ah-n-s", "nn"],
  "annoyed": ["ah n-oy1-d", "vbn vbd jj"],
  "annoying": ["ah n-oy1 ih-ng", "jj nn"],
  "annual": ["ae1 n-y-uw ah-l", "jj nn vb"],
  "annualize": ["ae1-n-y-uw-w-ah-l-ay-z", "vb"],
  "annualized": ["ae1 n-y-uw w-ah l-ay-z-d", "vbn vbd jj"],
  "annually": ["ae1 n-y-uw ah l-iy", "rb"],
  "annuity": ["ah n-uw1 ah t-iy", "nn"],
  "annul": ["ae1-n-ah-l", "vb"],
  "annum": ["ae1 n-ah-m", "nn"],
  "anode": ["ae1 n-ow-d", "nn"],
  "anomalous": ["ah n-aa1 m-ah l-ah-s", "jj"],
  "anomaly": ["ah n-aa1 m-ah l-iy", "nn"],
  "anonymity": ["ae n-ah n-ih1 m-ih t-iy", "nn"],
  "anonymous": ["ah n-aa1 n-ah m-ah-s", "jj"],
  "anonymously": ["ah n-aa1 n-ah m-ah-s l-iy", "rb"],
  "anorexia": ["ae n-er eh1-k s-iy ah", "nn"],
  "another": ["ah n-ah1 dh-er", "dt jj nn"],
  "answer": ["ae1-n s-er", "nn vb vbp"],
  "answerable": ["ae1-n s-er ah b-ah-l", "jj"],
  "ant": ["ae1-n-t", "nn"],
  "antacid": ["ae-n t-ae1 s-ah-d", "nn"],
  "antagonism": ["ae-n t-ae1 g-ah n-ih z-ah-m", "nn"],
  "antagonist": ["ae-n t-ae1 g-ah n-ah-s-t", "nn"],
  "antagonistic": ["ae-n t-ae g-ah n-ih1 s-t-ih-k", "jj"],
  "antagonize": ["ae-n t-ae1 g-ah n-ay-z", "vb vbp"],
  "ante": ["ae1-n t-iy", "nn vb"],
  "anteater": ["ae1-n-t iy t-er", "nn"],
  "antebellum": ["ae-n t-ih b-eh1 l-ah-m", "jj"],
  "antecedent": ["ae-n t-ih s-iy1 d-ah-n-t", "nn"],
  "antelope": ["ae1-n t-ah l-ow-p", "nn"],
  "antenna": ["ae-n t-eh1 n-ah", "nn"],
  "anterior": ["ae-n t-ih1 r-iy er", "jj"],
  "anthem": ["ae1-n th-ah-m", "nn"],
  "anthology": ["ae-n th-aa1 l-ah jh-iy", "nn"],
  "anthrax": ["ae1-n th-r-ae-k-s", "nn"],
  "anthropologist": ["ae-n th-r-ah p-aa1 l-ah jh-ah-s-t", "nn"],
  "anthropology": ["ae-n th-r-ah p-aa1 l-ah jh-iy", "nn"],
  "antibacterial": ["ae-n t-iy b-ae-k t-ih1 r-iy ah-l", "jj"],
  "antibiotic": ["ae-n t-iy b-iy aa1 t-ih-k", "nn jj"],
  "antibody": ["ae1-n t-ih b-aa d-iy", "nn"],
  "antic": ["ae1-n t-ih-k", "jj"],
  "anticipate": ["ae-n t-ih1 s-ah p-ey-t", "vb vbp"],
  "anticipated": ["ae-n t-ih1 s-ah p-ey t-ah-d", "vbn jj vbd"],
  "anticipation": ["ae-n t-ih s-ah p-ey1 sh-ah-n", "nn"],
  "anticipatory": ["ae-n t-ih1 s-ah p-ah t-ao r-iy", "jj"],
  "antidepressant": ["ae-n t-iy d-ih p-r-eh1 s-ah-n-t", "nn"],
  "antidote": ["ae1-n t-ih d-ow-t", "nn"],
  "antifreeze": ["ae1-n t-iy f-r-iy-z", "nn"],
  "antigen": ["ae1-n t-ah jh-ah-n", "nn"],
  "antihistamine": ["ae-n t-iy hh-ih1 s-t-ah m-ah-n", "nn"],
  "antipathy": ["ae-n t-ih1 p-ah th-iy", "nn"],
  "antiquated": ["ae1-n t-ah k-w-ey t-ah-d", "jj"],
  "antique": ["ae-n t-iy1-k", "jj nn"],
  "antiquity": ["ae-n t-ih1 k-w-ah t-iy", "nn"],
  "antiseptic": ["ae-n t-ah s-eh1-p t-ih-k", "jj nn"],
  "antisocial": ["ae-n t-ih s-ow1 sh-ah-l", "jj"],
  "antithesis": ["ae-n t-ih1 th-ah s-ah-s", "nn"],
  "antithetical": ["ae-n t-ah th-eh1 t-ih k-ah-l", "jj"],
  "antiviral": ["ae-n t-iy v-ay1 r-ah-l", "jj nn"],
  "antsy": ["ae1-n-t s-iy", "jj rb"],
  "anvil": ["ae1-n v-ah-l", "nn"],
  "anxiety": ["ae-ng z-ay1 ah t-iy", "nn"],
  "anxious": ["ae1-ng-k sh-ah-s", "jj"],
  "anxiously": ["ae1-ng-k sh-ah-s l-iy", "rb"],
  "any": ["eh1 n-iy", "dt rb"],
  "anybody": ["eh1 n-iy b-ah d-iy", "nn"],
  "anyhow": ["eh1 n-iy hh-aw", "rb"],
  "anymore": ["eh n-iy m-ao1-r", "rb"],
  "anyone": ["eh1 n-iy w-ah-n", "nn"],
  "anyplace": ["eh1 n-iy p-l-ey-s", "rb"],
  "anything": ["eh1 n-iy th-ih-ng", "nn"],
  "anytime": ["eh1 n-iy t-ay-m", "rb"],
  "anyway": ["eh1 n-iy w-ey", "rb"],
  "anyways": ["eh1 n-iy w-ey-z", "uh"],
  "anywhere": ["eh1 n-iy w-eh-r", "rb"],
  "aorta": ["ey ao1-r t-ah", "nn"],
  "apace": ["ah p-ey1-s", "rb"],
  "apart": ["ah p-aa1-r-t", "rb rp jj"],
  "apartheid": ["ah p-aa1-r-t ay-t", "nn"],
  "apartment": ["ah p-aa1-r-t m-ah-n-t", "nn"],
  "apathetic": ["ae p-ah th-eh1 t-ih-k", "jj"],
  "apathy": ["ae1 p-ah th-iy", "nn"],
  "ape": ["ey1-p", "nn vb"],
  "aperture": ["ae1 p-er ch-er", "nn"],
  "apex": ["ey1 p-eh-k-s", "nn"],
  "aphorism": ["ae1 f-er ih z-ah-m", "nn"],
  "apiece": ["ah p-iy1-s", "rb jj"],
  "aplenty": ["ah p-l-eh1-n t-iy", "jj rb"],
  "aplomb": ["ah p-l-aa1-m", "nn"],
  "apocalypse": ["ah p-aa1 k-ah l-ih-p-s", "nn"],
  "apocalyptic": ["ah p-aa k-ah l-ih1-p t-ih-k", "jj"],
  "apocryphal": ["ah p-aa1 k-r-ah f-ah-l", "jj"],
  "apogee": ["ae1 p-ah jh-iy", "nn"],
  "apologetic": ["ah p-aa l-ah jh-eh1 t-ih-k", "jj"],
  "apologetically": ["ah p-aa l-ah jh-eh1 t-ih-k l-iy", "rb"],
  "apologist": ["ah p-aa1 l-ah jh-ah-s-t", "nn"],
  "apologize": ["ah p-aa1 l-ah jh-ay-z", "vb"],
  "apology": ["ah p-aa1 l-ah jh-iy", "nn"],
  "apoplectic": ["ae p-ah p-l-eh1-k t-ih-k", "jj"],
  "apostle": ["ah p-aa1 s-ah-l", "nn"],
  "apothecary": ["ah p-aa1 th-ah k-eh r-iy", "nn"],
  "apotheosis": ["ah p-aa th-iy ow1 s-ah-s", "nn"],
  "appall": ["ah-p-ao1-l", "vb"],
  "appalled": ["ah p-ao1-l-d", "vbn jj"],
  "appalling": ["ah p-ao1 l-ih-ng", "jj"],
  "appallingly": ["ah p-ao1 l-ih-ng l-iy", "rb"],
  "apparatus": ["ae p-er ae1 t-ah-s", "nn"],
  "apparel": ["ah p-ae1 r-ah-l", "nn vb"],
  "apparent": ["ah p-eh1 r-ah-n-t", "jj nn"],
  "apparently": ["ah p-eh1 r-ah-n-t l-iy", "rb"],
  "apparition": ["ae p-er ih1 sh-ah-n", "nn"],
  "appeal": ["ah p-iy1-l", "nn vbp vb"],
  "appealing": ["ah p-iy1 l-ih-ng", "jj vbg"],
  "appear": ["ah p-ih1-r", "vb vbp"],
  "appearance": ["ah p-ih1 r-ah-n-s", "nn"],
  "appease": ["ah p-iy1-z", "vb"],
  "appeasement": ["ah p-iy1-z m-ah-n-t", "nn"],
  "appeasing": ["ah p-iy1 z-ih-ng", "nn"],
  "appellate": ["ah p-eh1 l-ih-t", "jj nn"],
  "append": ["ah p-eh1-n-d", "vb"],
  "appendage": ["ah p-eh1-n d-ih jh-ih", "nn"],
  "appetite": ["ae1 p-ah t-ay-t", "nn"],
  "appetizer": ["ae1 p-ah t-ay z-er", "nn"],
  "appetizing": ["ae1 p-ih t-ay z-ih-ng", "jj"],
  "applaud": ["ah p-l-ao1-d", "vbp vb"],
  "applause": ["ah p-l-ao1-z", "nn"],
  "apple": ["ae1 p-ah-l", "nn"],
  "appliance": ["ah p-l-ay1 ah-n-s", "nn"],
  "applicability": ["ae p-l-ah k-ah b-ih1 l-ah t-iy", "nn"],
  "applicable": ["ae1 p-l-ah k-ah b-ah-l", "jj"],
  "applicant": ["ae1 p-l-ih k-ah-n-t", "nn"],
  "application": ["ae p-l-ah k-ey1 sh-ah-n", "nn"],
  "applicator": ["ae1 p-l-ah k-ey t-er", "nn"],
  "applied": ["ah p-l-ay1-d", "vbn vbd jj"],
  "apply": ["ah p-l-ay1", "vb vbp"],
  "appoint": ["ah p-oy1-n-t", "vb"],
  "appointed": ["ah p-oy1-n t-ah-d", "vbn jj vbd"],
  "appointee": ["ah p-oy-n t-iy1", "nn"],
  "appointment": ["ah p-oy1-n-t m-ah-n-t", "nn"],
  "apportion": ["ah p-ao1-r sh-ah-n", "vb"],
  "appraisal": ["ah p-r-ey1 z-ah-l", "nn"],
  "appraise": ["ah p-r-ey1-z", "vb"],
  "appraiser": ["ah p-r-ey1 z-er", "nn"],
  "appreciable": ["ah p-r-iy1 sh-ah b-ah-l", "jj"],
  "appreciably": ["ah p-r-iy1 sh-ah b-l-iy", "rb"],
  "appreciate": ["ah p-r-iy1 sh-iy ey-t", "vb vbp"],
  "appreciated": ["ah p-r-iy1 sh-iy ey t-ih-d", "vbn vbd jj"],
  "appreciation": ["ah p-r-iy sh-iy ey1 sh-ah-n", "nn"],
  "appreciative": ["ah p-r-iy1 sh-iy ey t-ih-v", "jj"],
  "appreciatively": ["ah p-r-iy1 sh-iy ey t-ih-v l-iy", "rb"],
  "apprehend": ["ae p-r-ih hh-eh1-n-d", "vb"],
  "apprehension": ["ae p-r-ih hh-eh1-n sh-ah-n", "nn"],
  "apprehensive": ["ae p-r-ih hh-eh1-n s-ih-v", "jj"],
  "apprentice": ["ah p-r-eh1-n t-ah-s", "nn vb"],
  "apprenticeship": ["ah p-r-eh1-n t-ah-s sh-ih-p", "nn"],
  "apprise": ["ah-p-r-ay1-z", "vb"],
  "approach": ["ah p-r-ow1-ch", "nn vb vbp"],
  "approachable": ["ah p-r-ow1 ch-ah b-ah-l", "jj"],
  "appropriate": ["ah p-r-ow1 p-r-iy ah-t", "jj vbp vb"],
  "appropriately": ["ah p-r-ow1 p-r-iy ih-t l-iy", "rb"],
  "appropriateness": ["ah p-r-ow1 p-r-iy ah-t n-ah-s", "nn"],
  "appropriation": ["ah p-r-ow p-r-iy ey1 sh-ah-n", "nn"],
  "appropriator": ["ah p-r-ow1 p-r-iy ey t-er", "nn"],
  "approval": ["ah p-r-uw1 v-ah-l", "nn"],
  "approve": ["ah p-r-uw1-v", "vb vbp"],
  "approved": ["ah p-r-uw1-v-d", "vbd vbn jj"],
  "approvingly": ["ah p-r-uw1 v-ih-ng l-iy", "rb"],
  "approximate": ["ah p-r-aa1-k s-ah m-ah-t", "jj vbp nn vb"],
  "approximated": ["ah p-r-aa1-k s-ah m-ey t-ah-d", "vbn jj vbd"],
  "approximately": ["ah p-r-aa1-k s-ah m-ah-t l-iy", "rb jj"],
  "approximation": ["ah p-r-aa-k s-ah m-ey1 sh-ah-n", "nn"],
  "apricot": ["ey1 p-r-ah k-aa-t", "nn"],
  "april": ["ey1 p-r-ah-l", "nn"],
  "apron": ["ey1 p-r-ah-n", "nn"],
  "apt": ["ae1-p-t", "jj"],
  "aptitude": ["ae1-p t-ah t-uw-d", "nn"],
  "aquamarine": ["aa k-w-ah m-er iy1-n", "nn"],
  "aquarium": ["ah k-w-eh1 r-iy ah-m", "nn"],
  "aquatic": ["ah k-w-aa1 t-ih-k", "jj"],
  "aqueduct": ["ae1 k-w-ah d-ah-k-t", "nn"],
  "aqueous": ["ey1 k-w-iy ah-s", "jj"],
  "aquifer": ["ae1 k-w-ah f-er", "nn"],
  "arabic": ["ae1 r-ah b-ih-k", "jj"],
  "arable": ["eh1 r-ah b-ah-l", "jj"],
  "arbiter": ["aa1-r b-ih t-er", "nn"],
  "arbitrage": ["aa1-r b-ih t-r-aa-zh", "nn"],
  "arbitrarily": ["aa1-r b-ih t-r-eh r-ah l-iy", "rb"],
  "arbitrary": ["aa1-r b-ah t-r-eh r-iy", "jj"],
  "arbitrate": ["aa1-r b-ah t-r-ey-t", "vb"],
  "arbitration": ["aa-r b-ih t-r-ey1 sh-ah-n", "nn"],
  "arbitrator": ["aa1-r b-ih t-r-ey t-er", "nn"],
  "arboreal": ["aa-r b-ao1 r-iy ah-l", "jj"],
  "arc": ["aa1-r-k", "nn vb"],
  "arcade": ["aa-r k-ey1-d", "nn"],
  "arcane": ["aa-r k-ey1-n", "jj"],
  "arch": ["aa1-r-ch", "nn vb vbp"],
  "archaeological": ["aa-r k-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "archaeologist": ["aa-r k-iy aa1 l-ah jh-ih-s-t", "nn"],
  "archaeology": ["aa-r k-iy aa1 l-ah jh-iy", "nn"],
  "archaic": ["aa-r k-ey1 ih-k", "jj"],
  "archbishop": ["aa1-r-ch b-ih1 sh-ah-p", "nn"],
  "archdiocese": ["aa1-r-ch d-ay1 ah s-ah-s", "nn"],
  "arched": ["aa1-r-ch-t", "jj vbd vbn"],
  "archenemy": ["aa1-r ch-eh1 n-ah m-iy", "nn"],
  "archeological": ["aa-r k-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "archery": ["aa1-r ch-er iy", "nn"],
  "archetype": ["aa1-r k-ih t-ay-p", "nn"],
  "archipelago": ["aa-r k-ah p-eh1 l-ah g-ow", "nn"],
  "architect": ["aa1-r k-ah t-eh-k-t", "nn"],
  "architectural": ["aa-r k-ah t-eh1-k ch-er ah-l", "jj"],
  "architecturally": ["aa-r k-ih t-eh1-k ch-er ah l-iy", "rb"],
  "architecture": ["aa1-r k-ah t-eh-k ch-er", "nn"],
  "archival": ["aa-r k-ay1 v-ah-l", "jj"],
  "archive": ["aa1-r k-ay-v", "nn"],
  "archivist": ["aa1-r k-ah v-ih-s-t", "nn"],
  "archrival": ["aa1-r-ch r-ay v-ah-l", "jj nn"],
  "arctic": ["aa1-r-k t-ih-k", "jj"],
  "ardent": ["aa1-r d-ah-n-t", "jj"],
  "ardently": ["aa1-r d-ah-n-t l-iy", "rb"],
  "ardor": ["aa1-r d-er", "nn"],
  "arduous": ["aa1-r jh-uw ah-s", "jj"],
  "are": ["aa1-r", "vbp"],
  "aren't": ["aa1-r-ah-n-t", "vbp"],
  "area": ["eh1 r-iy ah", "nn"],
  "arena": ["er iy1 n-ah", "nn"],
  "argon": ["aa1-r g-aa-n", "nn"],
  "argot": ["aa1-r g-ah-t", "nn"],
  "arguably": ["aa1-r g-y-uw ah b-l-iy", "rb"],
  "argue": ["aa1-r g-y-uw", "vbp vb"],
  "argument": ["aa1-r g-y-ah m-ah-n-t", "nn"],
  "aria": ["aa1 r-iy ah", "nn"],
  "arid": ["ae1 r-ah-d", "jj"],
  "arise": ["er ay1-z", "vb vbp"],
  "arisen": ["er ih1 z-ah-n", "vbn"],
  "aristocracy": ["eh r-ah s-t-aa1 k-r-ah s-iy", "nn"],
  "aristocrat": ["er ih1 s-t-ah k-r-ae-t", "nn"],
  "aristocratic": ["er ih s-t-ah k-r-ae1 t-ih-k", "jj"],
  "arithmetic": ["eh r-ih-th m-eh1 t-ih-k", "nn"],
  "arm": ["aa1-r-m", "nn vb"],
  "armadillo": ["aa-r m-ah d-ih1 l-ow", "nn"],
  "armament": ["aa1-r m-ah m-ah-n-t", "nn"],
  "armchair": ["aa1-r-m ch-eh-r", "nn jj"],
  "armed": ["aa1-r-m-d", "vbn jj"],
  "arming": ["aa1-r m-ih-ng", "nn"],
  "armistice": ["aa1-r m-ah s-t-ah-s", "nn"],
  "armor": ["aa1-r m-er", "nn vb"],
  "armored": ["aa1-r m-er-d", "jj vbn"],
  "armory": ["aa1-r m-er iy", "nn"],
  "armpit": ["aa1-r-m p-ih-t", "nn"],
  "army": ["aa1-r m-iy", "nn"],
  "aroma": ["er ow1 m-ah", "nn"],
  "aromatic": ["eh r-ah m-ae1 t-ih-k", "jj"],
  "arose": ["er ow1-z", "vbd"],
  "around": ["er aw1-n-d", "in rb rp"],
  "arousal": ["er aw1 z-ah-l", "jj"],
  "arouse": ["er aw1-z", "vb vbp"],
  "arraign": ["er-ey1-n", "vb"],
  "arrange": ["er ey1-n-jh", "vb vbp"],
  "arrangement": ["er ey1-n-jh m-ah-n-t", "nn"],
  "array": ["er ey1", "nn vb"],
  "arrearage": ["er iy1 r-ih-jh", "nn"],
  "arrears": ["er ih1-r-z", "nn"],
  "arrest": ["er eh1-s-t", "nn vbp vb"],
  "arresting": ["er eh1 s-t-ih-ng", "vbg jj"],
  "arrival": ["er ay1 v-ah-l", "nn"],
  "arrive": ["er ay1-v", "vb vbp"],
  "arrogance": ["eh1 r-ah g-ah-n-s", "nn"],
  "arrogant": ["eh1 r-ah g-ah-n-t", "jj"],
  "arrogantly": ["eh1 r-ah g-ah-n-t l-iy", "rb"],
  "arrogate": ["ae1 r-ow g-ey-t", "vb"],
  "arrow": ["ae1 r-ow", "nn"],
  "arrowhead": ["ae1 r-ow hh-eh-d", "nn"],
  "arsenal": ["aa1-r s-ah n-ah-l", "nn"],
  "arsenic": ["aa1-r s-ah n-ih-k", "nn"],
  "arson": ["aa1-r s-ah-n", "nn"],
  "arsonist": ["aa1-r s-ah n-ah-s-t", "nn"],
  "art": ["aa1-r-t", "nn"],
  "arterial": ["aa-r t-ih1 r-iy ah-l", "jj"],
  "artery": ["aa1-r t-er iy", "nn"],
  "artful": ["aa1-r-t f-ah-l", "jj"],
  "artfully": ["aa1-r-t f-ah l-iy", "rb"],
  "arthritic": ["aa-r th-r-ih1 t-ih-k", "jj"],
  "arthritis": ["aa-r-th r-ay1 t-ah-s", "nn"],
  "artichoke": ["aa1-r t-ah ch-ow-k", "nn"],
  "article": ["aa1-r t-ah k-ah-l", "nn"],
  "articulate": ["aa-r t-ih1 k-y-ah l-ey-t", "jj vb"],
  "articulation": ["aa-r t-ih k-y-ah l-ey1 sh-ah-n", "nn"],
  "artifact": ["aa1-r t-ah f-ae-k-t", "nn"],
  "artifice": ["aa1-r t-ah f-ih-s", "nn"],
  "artificial": ["aa-r t-ah f-ih1 sh-ah-l", "jj nn"],
  "artificially": ["aa-r t-ah f-ih1 sh-ah l-iy", "rb"],
  "artillery": ["aa-r t-ih1 l-er iy", "nn"],
  "artisan": ["aa1-r t-ah z-ah-n", "nn"],
  "artist": ["aa1-r t-ah-s-t", "nn"],
  "artistic": ["aa-r t-ih1 s-t-ih-k", "jj"],
  "artistically": ["aa-r t-ih1 s-t-ih-k l-iy", "rb"],
  "artistry": ["aa1-r t-ih-s t-r-iy", "nn"],
  "artsy": ["aa1-r-t s-iy1", "jj"],
  "artwork": ["aa1-r-t w-er-k", "nn"],
  "arty": ["aa1-r t-iy", "jj"],
  "as": ["ae1-z", "in rb"],
  "asbestos": ["ae-s b-eh1 s-t-ah-s", "nn"],
  "ascend": ["ah s-eh1-n-d", "vb"],
  "ascendancy": ["ah s-eh1-n d-ah-n s-iy", "nn"],
  "ascendency": ["ah s-eh1-n d-ah-n s-iy", "nn"],
  "ascension": ["ah s-eh1-n sh-ah-n", "nn"],
  "ascent": ["ah s-eh1-n-t", "nn"],
  "ascertain": ["ae s-er t-ey1-n", "vb"],
  "ascetic": ["ah s-eh1 t-ih-k", "nn"],
  "ascribe": ["ah s-k-r-ay1-b", "vb"],
  "ash": ["ae1-sh", "nn"],
  "ashamed": ["ah sh-ey1-m-d", "jj"],
  "ashen": ["ae1 sh-ah-n", "jj"],
  "ashore": ["ah sh-ao1-r", "rb jj"],
  "ashtray": ["ae1-sh t-r-ey", "nn"],
  "aside": ["ah s-ay1-d", "rb rp"],
  "asinine": ["ae1 s-ah n-ay-n", "jj"],
  "ask": ["ae1-s-k", "vb vbp"],
  "askance": ["ah s-k-ae1-n-s", "rb"],
  "askew": ["ah s-k-y-uw1", "rb"],
  "asleep": ["ah s-l-iy1-p", "rb jj"],
  "asparagus": ["ah s-p-eh1 r-ah g-ah-s", "nn"],
  "aspect": ["ae1 s-p-eh-k-t", "nn"],
  "aspen": ["ae1 s-p-ah-n", "nn jj"],
  "aspersion": ["ah s-p-er1 zh-ah-n", "nn"],
  "asphalt": ["ae1-s f-ao-l-t", "nn jj"],
  "aspirant": ["ae1 s-p-er ah-n-t", "nn"],
  "aspiration": ["ae s-p-er ey1 sh-ah-n", "nn"],
  "aspire": ["ah s-p-ay1-r", "vb vbp"],
  "aspirin": ["ae1 s-p-r-ih-n", "nn"],
  "aspiring": ["ah s-p-ay1 r-ih-ng", "jj vbg"],
  "ass": ["ae1-s", "nn"],
  "assail": ["ah s-ey1-l", "vb"],
  "assailant": ["ah s-ey1 l-ah-n-t", "nn"],
  "assassin": ["ah s-ae1 s-ah-n", "nn"],
  "assassinate": ["ah s-ae1 s-ah n-ey-t", "vb"],
  "assassination": ["ah s-ae s-ah n-ey1 sh-ah-n", "nn"],
  "assault": ["ah s-ao1-l-t", "nn vb vbp"],
  "assay": ["ae1 s-iy", "nn"],
  "assemblage": ["ah s-eh1-m b-l-ah-jh", "nn"],
  "assemble": ["ah s-eh1-m b-ah-l", "vb vbp"],
  "assembled": ["ah s-eh1-m b-ah-l-d", "vbn vbd jj"],
  "assembly": ["ah s-eh1-m b-l-iy", "nn"],
  "assent": ["ah s-eh1-n-t", "vb"],
  "assert": ["ah s-er1-t", "vb vbp"],
  "assertedly": ["ah s-er1 t-ih-d l-iy", "rb"],
  "assertion": ["ah s-er1 sh-ah-n", "nn"],
  "assertive": ["ah s-er1 t-ih-v", "jj"],
  "assertiveness": ["ah s-er1 t-ih-v n-ah-s", "nn"],
  "assess": ["ah s-eh1-s", "vb vbp"],
  "assessment": ["ah s-eh1-s m-ah-n-t", "nn"],
  "assessor": ["ah s-eh1 s-er", "nn"],
  "asset": ["ae1 s-eh-t", "nn"],
  "assiduously": ["ah s-ih1 d-w-ah-s l-iy", "rb"],
  "assign": ["ah s-ay1-n", "vb vbp"],
  "assigned": ["ah s-ay1-n-d", "vbn vbd jj"],
  "assignment": ["ah s-ay1-n m-ah-n-t", "nn"],
  "assimilate": ["ah s-ih1 m-ah l-ey-t", "vb"],
  "assimilated": ["ah s-ih1 m-ah l-ey t-ih-d", "vbn jj"],
  "assimilation": ["ah s-ih m-ah l-ey1 sh-ah-n", "nn"],
  "assist": ["ah s-ih1-s-t", "vb nn vbp"],
  "assistance": ["ah s-ih1 s-t-ah-n-s", "nn"],
  "assistant": ["ah s-ih1 s-t-ah-n-t", "nn jj"],
  "associate": ["ah s-ow1 s-iy ah-t", "jj vbp nn vb"],
  "associated": ["ah s-ow1 s-iy ey t-ah-d", "vbn vbd jj"],
  "association": ["ah s-ow s-iy ey1 sh-ah-n", "nn"],
  "assort": ["ah-s-ao1-r-t", "vb"],
  "assorted": ["ah s-ao1-r t-ih-d", "jj vbn"],
  "assortment": ["ah s-ao1-r-t m-ah-n-t", "nn"],
  "assuage": ["ah s-w-ey1-jh", "vb"],
  "assume": ["ah s-uw1-m", "vb vbp"],
  "assumed": ["ah s-uw1-m-d", "vbn vbd jj"],
  "assumption": ["ah s-ah1-m-p sh-ah-n", "nn"],
  "assurance": ["ah sh-uh1 r-ah-n-s", "nn"],
  "assure": ["ah sh-uh1-r", "vb vbp"],
  "assured": ["ah sh-uh1-r-d", "vbn vbd jj nn"],
  "assuredly": ["ah sh-uh1 r-ah-d l-iy", "rb"],
  "aster": ["ae1 s-t-er", "nn"],
  "asteroid": ["ae1 s-t-er oy-d", "jj nn"],
  "asthma": ["ae1-z m-ah", "nn"],
  "astonish": ["ah-s-t-aa1-n-ih-sh", "vb"],
  "astonishing": ["ah s-t-aa1 n-ih sh-ih-ng", "jj"],
  "astonishingly": ["ah s-t-aa1 n-ih sh-ih-ng l-iy", "rb"],
  "astonishment": ["ah s-t-aa1 n-ih-sh m-ah-n-t", "nn"],
  "astound": ["ah s-t-aw1-n-d", "vb"],
  "astounded": ["ah s-t-aw1-n d-ih-d", "vbn jj"],
  "astounding": ["ah s-t-aw1-n d-ih-ng", "jj"],
  "astoundingly": ["ah s-t-aw1-n d-ih-ng l-iy", "rb"],
  "astral": ["ae1-s t-r-ah-l", "jj"],
  "astray": ["ah s-t-r-ey1", "rb"],
  "astride": ["ah s-t-r-ay1-d", "in"],
  "astringent": ["ah s-t-r-ih1-n jh-ah-n-t", "jj"],
  "astrological": ["ae-s t-r-ah l-aa1 jh-ih k-ah-l", "jj"],
  "astrology": ["ah s-t-r-aa1 l-ah jh-iy", "nn"],
  "astronaut": ["ae1 s-t-r-ah n-aa-t", "nn"],
  "astronomer": ["ah s-t-r-aa1 n-ah m-er", "nn"],
  "astronomical": ["ae s-t-r-ah n-aa1 m-ih k-ah-l", "jj"],
  "astronomically": ["ae s-t-r-ah n-aa1 m-ih-k l-iy", "rb"],
  "astronomy": ["ah s-t-r-aa1 n-ah m-iy", "nn"],
  "astrophysicist": ["ae s-t-r-ow f-ih1 s-ih s-ih-s-t", "nn"],
  "astute": ["ah s-t-uw1-t", "jj"],
  "astuteness": ["ah s-t-uw1-t n-ah-s", "nn"],
  "asunder": ["ah s-ah1-n d-er", "rb"],
  "asylum": ["ah s-ay1 l-ah-m", "nn"],
  "asymmetry": ["ey s-ih1 m-ah t-r-iy", "nn"],
  "at": ["ae1-t", "in rb rp"],
  "atavistic": ["ae1 t-ah v-ih s-t-ih-k", "jj"],
  "ataxia": ["ey1 t-ae1-k s-iy ah", "nn"],
  "ate": ["ey1-t", "vbd"],
  "atheism": ["ah th-ay1 s-ah-m", "nn"],
  "atheist": ["ey1 th-iy ah-s-t", "jj nn"],
  "atheistic": ["ey th-iy ih1 s-t-ih-k", "jj"],
  "athlete": ["ae1-th l-iy-t", "nn"],
  "athletic": ["ae-th l-eh1 t-ih-k", "jj"],
  "athletically": ["ae-th l-eh1 t-ih-k l-iy", "rb"],
  "atmosphere": ["ae1-t m-ah s-f-ih-r", "nn"],
  "atmospheric": ["ae-t m-ah-s f-eh1 r-ih-k", "jj"],
  "atom": ["ae1 t-ah-m", "nn"],
  "atomic": ["ah t-aa1 m-ih-k", "jj"],
  "atonal": ["ey t-ow1 n-ah-l", "jj"],
  "atone": ["ah t-ow1-n", "vb"],
  "atonement": ["ah t-ow1-n m-ah-n-t", "nn"],
  "atop": ["ah t-aa1-p", "in"],
  "atrium": ["ey1 t-r-iy ah-m", "nn"],
  "atrocious": ["ah t-r-ow1 sh-ah-s", "jj"],
  "atrocity": ["ah t-r-aa1 s-ah t-iy", "nn"],
  "atrophied": ["ae1 t-r-ah f-iy-d", "vbn"],
  "atrophy": ["ae1 t-r-ah f-iy", "nn vb vbp"],
  "attach": ["ah t-ae1-ch", "vb vbp"],
  "attache": ["ae t-ah sh-ey1", "nn"],
  "attached": ["ah t-ae1-ch-t", "vbn jj vbd"],
  "attachment": ["ah t-ae1-ch m-ah-n-t", "nn"],
  "attack": ["ah t-ae1-k", "nn vbp vb"],
  "attacker": ["ah t-ae1 k-er", "nn"],
  "attain": ["ah t-ey1-n", "vb vbp"],
  "attainable": ["ah t-ey1 n-ah b-ah-l", "jj"],
  "attainment": ["ah t-ey1-n m-ah-n-t", "nn"],
  "attempt": ["ah t-eh1-m-p-t", "nn vbp vb"],
  "attempted": ["ah t-eh1-m-p t-ah-d", "vbd jj vbn"],
  "attend": ["ah t-eh1-n-d", "vb vbp"],
  "attendance": ["ah t-eh1-n d-ah-n-s", "nn"],
  "attendant": ["ah t-eh1-n d-ah-n-t", "nn jj"],
  "attendee": ["ah t-eh1-n d-iy1", "nn"],
  "attention": ["ah t-eh1-n sh-ah-n", "nn"],
  "attentive": ["ah t-eh1-n t-ih-v", "jj"],
  "attentively": ["ah t-eh1-n t-ih-v l-iy", "rb"],
  "attest": ["ah t-eh1-s-t", "vb vbp"],
  "attic": ["ae1 t-ih-k", "nn"],
  "attire": ["ah t-ay1 er", "nn vb"],
  "attired": ["ah t-ay1-r-d", "jj vbn"],
  "attitude": ["ae1 t-ah t-uw-d", "nn"],
  "attorney": ["ah t-er1 n-iy", "nn"],
  "attract": ["ah t-r-ae1-k-t", "vb vbp"],
  "attraction": ["ah t-r-ae1-k sh-ah-n", "nn"],
  "attractive": ["ah t-r-ae1-k t-ih-v", "jj"],
  "attractively": ["ah t-r-ae1-k t-ih-v l-iy", "rb"],
  "attractiveness": ["ah t-r-ae1-k t-ih-v n-ah-s", "nn"],
  "attributable": ["ah t-r-ih1 b-y-ah t-ah b-ah-l", "jj"],
  "attribute": ["ae1 t-r-ah b-y-uw-t", "vbp nn vb"],
  "attrition": ["ah t-r-ih1 sh-ah-n", "nn"],
  "attune": ["ah-t-uw1-n", "vb"],
  "attuned": ["ah t-uw1-n-d", "vbn jj"],
  "atypical": ["ey t-ih1 p-ih k-ah-l", "jj"],
  "auburn": ["aa1 b-er-n", "jj"],
  "auction": ["aa1-k sh-ah-n", "nn vb"],
  "auctioneer": ["aa-k sh-ah n-ih1-r", "nn"],
  "auctioning": ["ao1-k sh-ah-n ih-ng", "nn"],
  "audacious": ["aa d-ey1 sh-ah-s", "jj"],
  "audacity": ["aa d-ae1 s-ah t-iy", "nn"],
  "audible": ["aa1 d-ah b-ah-l", "jj"],
  "audibly": ["aa1 d-ah b-l-iy", "rb"],
  "audience": ["aa1 d-iy ah-n-s", "nn"],
  "audio": ["aa1 d-iy ow", "jj nn"],
  "audiophile": ["ao d-iy1 ow f-iy-l", "nn"],
  "audiotex": ["ao1 d-iy ow t-eh-k-s", "nn"],
  "audiovisual": ["ao d-iy ow v-ih1 zh-uw ah-l", "jj"],
  "audit": ["ao1 d-ih-t", "nn vb"],
  "audited": ["ao1 d-ih t-ih-d", "vbn jj vbd"],
  "audition": ["aa d-ih1 sh-ah-n", "nn vb"],
  "auditor": ["ao1 d-ih t-er", "nn"],
  "auditorium": ["ao d-ah t-ao1 r-iy ah-m", "nn"],
  "augment": ["ao-g m-eh1-n-t", "vb vbp"],
  "augmented": ["aa-g m-eh1-n t-ah-d", "vbn jj vbd"],
  "augur": ["ao1 g-er", "vb vbp"],
  "august": ["aa1 g-ah-s-t", "jj"],
  "aunt": ["ae1-n-t", "nn"],
  "aura": ["ao1 r-ah", "nn"],
  "aural": ["ao1 r-ah-l", "jj"],
  "auspice": ["ao1 s-p-ih s-ih", "nn"],
  "auspicious": ["aa s-p-ih1 sh-ah-s", "jj"],
  "austere": ["ao s-t-ih1-r", "jj"],
  "austerely": ["ao s-t-ih1-r l-iy", "rb"],
  "austerity": ["ao s-t-eh1 r-ih t-iy", "nn"],
  "authentic": ["ah th-eh1-n t-ih-k", "jj"],
  "authentically": ["ao th-eh1-n t-ih-k l-iy", "rb"],
  "authenticate": ["ao th-eh1-n t-ah k-ey-t", "vb vbp"],
  "authentication": ["ao th-eh-n t-ah k-ey1 sh-ah-n", "nn"],
  "authenticity": ["ao th-ah-n t-ih1 s-ih t-iy", "nn"],
  "author": ["ao1 th-er", "nn vb"],
  "authoritarian": ["ah th-ao r-ah t-eh1 r-iy ah-n", "jj"],
  "authoritarianism": ["ah th-ao r-ah t-eh1 r-iy ah n-ih z-ah-m", "nn"],
  "authoritative": ["ah th-ao1 r-ah t-ey t-ih-v", "jj"],
  "authority": ["ah th-ao1 r-ah t-iy", "nn"],
  "authorization": ["ao th-er ah z-ey1 sh-ah-n", "nn"],
  "authorize": ["ao1 th-er ay-z", "vb"],
  "authorized": ["ao1 th-er ay-z-d", "vbn jj vbd"],
  "authorship": ["ao1 th-er sh-ih-p", "nn"],
  "autism": ["ao1 t-ih z-ah-m", "nn"],
  "autistic": ["ao t-ih1 s-t-ih-k", "jj"],
  "auto": ["ao1 t-ow", "nn"],
  "autobiographical": ["ao t-ah b-ay ah g-r-ae1 f-ih k-ah-l", "jj"],
  "autobiography": ["ao t-ah b-ay aa1 g-r-ah f-iy", "nn"],
  "autoclave": ["ao1 t-ow k-l-ey-v", "nn"],
  "autocracy": ["ao t-aa1 k-r-ah s-iy", "nn"],
  "autocrat": ["ao1 t-ah k-r-ae-t", "nn"],
  "autocratic": ["ao t-ah k-r-ae1 t-ih-k", "jj"],
  "autograph": ["ao1 t-ah g-r-ae-f", "nn vb"],
  "autographed": ["ao1 t-ah g-r-ae-f-t", "vbn jj"],
  "autoimmune": ["ao t-oy1 m-y-uw-n", "jj"],
  "automaker": ["ao1 t-ow m-ey k-er", "nn"],
  "automate": ["ao1 t-ah m-ey-t", "vb"],
  "automated": ["ao1 t-ah m-ey t-ih-d", "vbn jj vbd"],
  "automatic": ["ao t-ah m-ae1 t-ih-k", "jj nn"],
  "automatically": ["ao t-ah m-ae1 t-ih-k l-iy", "rb"],
  "automation": ["ao t-ah m-ey1 sh-ah-n", "nn"],
  "automaton": ["ao t-aa1 m-ah t-aa-n", "nn"],
  "automobile": ["ao1 t-ah m-ow b-iy-l", "nn"],
  "automotive": ["ao t-ah m-ow1 t-ih-v", "jj"],
  "autonomic": ["ao t-ah n-aa1 m-ih-k", "jj"],
  "autonomous": ["ao t-aa1 n-ah m-ah-s", "jj"],
  "autonomously": ["ao t-aa1 n-ow m-ah-s l-iy", "rb"],
  "autonomy": ["ao t-aa1 n-ah m-iy", "nn"],
  "autopsy": ["ao1 t-aa-p s-iy", "nn vb"],
  "autumn": ["ao1 t-ah-m", "nn"],
  "autumnal": ["ao t-ah1-m n-ah-l", "jj"],
  "auxiliary": ["aa-g z-ih1 l-y-er iy", "jj nn"],
  "avail": ["ah v-ey1-l", "nn vb"],
  "availability": ["ah v-ey l-ah b-ih1 l-ah t-iy", "nn"],
  "available": ["ah v-ey1 l-ah b-ah-l", "jj"],
  "avalanche": ["ae1 v-ah l-ae-n-ch", "nn"],
  "avarice": ["ae1 v-er ah-s", "nn"],
  "avenge": ["ah v-eh1-n-jh", "vb"],
  "avenger": ["ah v-eh1-n jh-er", "nn"],
  "avenging": ["ah v-eh1-n jh-ih-ng", "jj vbg"],
  "avenue": ["ae1 v-ah n-uw", "nn"],
  "average": ["ae1 v-er ih-jh", "jj nn vb vbp"],
  "averaging": ["ae1 v-r-ih jh-ih-ng", "vbg jj nn"],
  "averse": ["ah v-er1-s", "jj"],
  "aversion": ["ah v-er1 zh-ah-n", "nn"],
  "avert": ["ah v-er1-t", "vb"],
  "aviary": ["ey1 v-iy eh r-iy", "nn"],
  "aviation": ["ey v-iy ey1 sh-ah-n", "nn"],
  "aviator": ["ey1 v-iy ey t-er", "nn"],
  "avid": ["ae1 v-ah-d", "jj"],
  "avidly": ["ae1 v-ah-d l-iy", "rb"],
  "avionics": ["ey v-iy aa1 n-ih-k-s", "nn"],
  "avocado": ["ae v-ah k-aa1 d-ow", "nn"],
  "avocation": ["ae v-ah k-ey1 sh-ah-n", "nn"],
  "avoid": ["ah v-oy1-d", "vb jj vbp"],
  "avoidable": ["ah v-oy1 d-ah b-ah-l", "jj"],
  "avoidance": ["ah v-oy1 d-ah-n-s", "nn"],
  "avoided": ["ah v-oy1 d-ah-d", "vbn jj vbd"],
  "avowed": ["ah v-aw1-d", "jj"],
  "avowedly": ["ah v-aw1 ah-d l-iy", "rb"],
  "avuncular": ["ah v-ah1-ng k-y-ah l-er", "jj"],
  "await": ["ah w-ey1-t", "vb vbp"],
  "awaited": ["ah w-ey1 t-ah-d", "vbd jj vbn"],
  "awake": ["ah w-ey1-k", "jj rb vb"],
  "awaken": ["ah w-ey1 k-ah-n", "vb vbp"],
  "award": ["ah w-ao1-r-d", "nn vbp vb"],
  "aware": ["ah w-eh1-r", "jj"],
  "awareness": ["ah w-eh1-r n-ah-s", "nn"],
  "awash": ["ah w-aa1-sh", "jj rb"],
  "away": ["ah w-ey1", "rb rp"],
  "awe": ["aa1", "nn vb"],
  "awed": ["ao1-d", "vbn jj"],
  "awesome": ["aa1 s-ah-m", "jj"],
  "awful": ["aa1 f-ah-l", "jj rb"],
  "awfully": ["aa1-f l-iy", "rb"],
  "awfulness": ["ao1 f-ah-l n-ah-s", "nn"],
  "awhile": ["ah w-ay1-l", "rb"],
  "awkward": ["aa1 k-w-er-d", "jj"],
  "awkwardly": ["ao1 k-w-er-d l-iy", "rb"],
  "awkwardness": ["ao1 k-w-er-d n-ah-s", "nn"],
  "awoke": ["ah w-ow1-k", "vbd"],
  "awoken": ["ah w-ow1 k-ah-n", "vbn"],
  "awry": ["er ay1", "rb jj"],
  "axe": ["ae1-k-s", "nn"],
  "axiom": ["ae1-k s-iy ah-m", "nn"],
  "axiomatic": ["ae-k s-iy ah m-ae1 t-ih-k", "jj"],
  "axis": ["ae1-k s-ah-s", "nn"],
  "axle": ["ae1-k s-ah-l", "nn"],
  "ayatollah": ["ay ah t-ow1 l-ah", "nn"],
  "azalea": ["ah z-ey1 l-y-ah", "nn"],
  "azure": ["ae1 zh-er", "jj"],
  "babble": ["b-ae1 b-ah-l", "nn vb"],
  "babe": ["b-ey1-b", "nn"],
  "baboon": ["b-ah b-uw1-n", "nn"],
  "baby": ["b-ey1 b-iy", "nn uh"],
  "babyhood": ["b-ey1 b-iy hh-uh-d", "nn"],
  "bachelor": ["b-ae1 ch-ah l-er", "nn"],
  "back": ["b-ae1-k", "rb in jj nn rp vb vbp"],
  "backbone": ["b-ae1-k b-ow-n", "nn"],
  "backdate": ["b-ae1-k-d-ey-t", "vb"],
  "backdoor": ["b-ae1-k d-ao-r", "jj"],
  "backdrop": ["b-ae1-k d-r-aa-p", "nn"],
  "backed": ["b-ae1-k-t", "vbn jj vbd"],
  "backer": ["b-ae1 k-er", "nn"],
  "backfield": ["b-ae1-k f-iy-l-d", "nn"],
  "backfire": ["b-ae1-k f-ay-r", "vb vbp"],
  "background": ["b-ae1-k g-r-aw-n-d", "nn jj"],
  "backhand": ["b-ae1-k hh-ae-n-d", "nn"],
  "backhanded": ["b-ae1-k hh-ae-n d-ah-d", "jj"],
  "backhoe": ["b-ae1-k hh-ow", "nn"],
  "backlash": ["b-ae1-k l-ae-sh", "nn"],
  "backlog": ["b-ae1-k l-aa-g", "nn"],
  "backpack": ["b-ae1-k p-ae-k", "nn"],
  "backpedal": ["b-ae1-k-p-eh-d-ah-l", "vb"],
  "backroom": ["b-ae1-k r-uw-m", "nn"],
  "backside": ["b-ae1-k s-ay-d", "nn"],
  "backslap": ["b-ae1-k-s-l-ae-p", "vb"],
  "backstage": ["b-ae1-k s-t-ey1-jh", "rb"],
  "backstitch": ["b-ae1-k s-t-ih-ch", "nn vb"],
  "backstop": ["b-ae1-k s-t-aa-p", "nn vb"],
  "backtrack": ["b-ae1-k-t-r-ae-k", "vb"],
  "backup": ["b-ae1-k ah-p", "nn jj"],
  "backward": ["b-ae1-k w-er-d", "rb jj"],
  "backwardness": ["b-ae1 k-w-er-d n-ah-s", "nn"],
  "backwards": ["b-ae1-k w-er-d-z", "rb jj"],
  "backwater": ["b-ae1-k w-ao t-er", "nn jj"],
  "backwoods": ["b-ae1-k w-uh1-d-z", "nn"],
  "backyard": ["b-ae1-k y-aa-r-d", "nn"],
  "bacon": ["b-ey1 k-ah-n", "nn"],
  "bacterial": ["b-ae-k t-ih1 r-iy ah-l", "jj"],
  "bacterium": ["b-ae-k t-ih1 r-iy ah-m", "nn"],
  "bad": ["b-ae1-d", "jj nn rb"],
  "bade": ["b-ey1-d", "vbd"],
  "badge": ["b-ae1-jh", "nn"],
  "badger": ["b-ae1-jh-er", "vb"],
  "badly": ["b-ae1-d l-iy", "rb"],
  "badminton": ["b-ae1-d m-ih-n t-ah-n", "nn"],
  "badness": ["b-ae1-d n-ah-s", "nn"],
  "baffle": ["b-ae1 f-ah-l", "vb"],
  "baffled": ["b-ae1 f-ah-l-d", "vbn jj vbd"],
  "baffling": ["b-ae1 f-ah-l ih-ng", "jj"],
  "bag": ["b-ae1-g", "nn vb"],
  "bagel": ["b-ey1 g-ah-l", "nn"],
  "baggage": ["b-ae1 g-ah-jh", "nn"],
  "bagged": ["b-ae1-g-d", "vbd jj"],
  "baggy": ["b-ae1 g-iy", "jj"],
  "bagpipe": ["b-ae1-g p-ay-p", "nn"],
  "bail": ["b-ey1-l", "vb nn"],
  "bailiff": ["b-ey1 l-ah-f", "nn"],
  "bailout": ["b-ey1-l aw-t", "nn"],
  "bait": ["b-ey1-t", "nn vb"],
  "bake": ["b-ey1-k", "jj vb"],
  "baked": ["b-ey1-k-t", "jj vbd vbn"],
  "baker": ["b-ey1 k-er", "nn"],
  "bakery": ["b-ey1 k-er iy", "nn"],
  "bakeware": ["b-ey1-k w-eh-r", "nn"],
  "balance": ["b-ae1 l-ah-n-s", "nn vbp jj rb vb"],
  "balanced": ["b-ae1 l-ah-n-s-t", "jj vbd vbn"],
  "balcony": ["b-ae1-l k-ah n-iy", "nn"],
  "bald": ["b-ao1-l-d", "jj"],
  "balding": ["b-ao1-l d-ih-ng", "jj"],
  "baldness": ["b-ao1-l-d n-ah-s", "nn"],
  "bale": ["b-ey1-l", "nn vb vbp"],
  "baleful": ["b-ey1-l f-ah-l", "jj"],
  "balk": ["b-ao1-k", "vb vbp"],
  "balkanized": ["b-ao1-l k-ah n-ay-z-d", "jj"],
  "ball": ["b-ao1-l", "nn vb"],
  "ballad": ["b-ae1 l-ah-d", "nn"],
  "ballast": ["b-ae1 l-ah-s-t", "nn vb"],
  "ballerina": ["b-ae l-er iy1 n-ah", "nn"],
  "ballet": ["b-ae l-ey1", "nn"],
  "ballistic": ["b-ah l-ih1 s-t-ih-k", "jj"],
  "balloon": ["b-ah l-uw1-n", "nn vbp vb"],
  "ballot": ["b-ae1 l-ah-t", "nn"],
  "balloting": ["b-ae1 l-ah t-ih-ng", "nn"],
  "ballpark": ["b-ao1-l p-aa-r-k", "nn"],
  "ballplayer": ["b-ao1-l p-l-ey er", "nn"],
  "ballroom": ["b-ao1-l r-uw-m", "nn"],
  "ballyhoo": ["b-ae1 l-iy hh-uw1", "nn vb"],
  "balm": ["b-aa1-m", "nn"],
  "balmy": ["b-aa1 m-iy", "jj"],
  "baloney": ["b-ah l-ow1 n-iy", "nn"],
  "bam": ["b-ae1-m", "uh"],
  "bambino": ["b-ae-m b-iy1 n-ow", "nn"],
  "bamboo": ["b-ae-m b-uw1", "nn"],
  "ban": ["b-ae1-n", "nn vb vbp"],
  "banal": ["b-ah n-aa1-l", "jj"],
  "banality": ["b-ah n-ae1 l-ih t-iy", "nn"],
  "banana": ["b-ah n-ae1 n-ah", "nn"],
  "band": ["b-ae1-n-d", "nn vb"],
  "bandage": ["b-ae1-n d-ih-jh", "nn vb"],
  "bandaged": ["b-ae1-n d-ah-jh-d", "vbn jj"],
  "bandied": ["b-ae1-n d-iy-d", "vbn"],
  "bandit": ["b-ae1-n d-ah-t", "nn"],
  "bandstand": ["b-ae1-n-d s-t-ae-n-d", "nn"],
  "bandwagon": ["b-ae1-n-d w-ae g-ah-n", "nn"],
  "bandwidth": ["b-ae1-n-d w-ih-d-th", "nn"],
  "bandy": ["b-ae1-n-d-iy", "vb"],
  "bane": ["b-ey1-n", "nn"],
  "bang": ["b-ae1-ng", "nn vb uh vbp"],
  "bangish": ["b-ae1 ng-ih-sh", "jj"],
  "banish": ["b-ae1 n-ih-sh", "vb"],
  "banishment": ["b-ae1 n-ih-sh m-ah-n-t", "nn"],
  "banister": ["b-ae1 n-ih s-t-er", "nn"],
  "banjo": ["b-ae1-n jh-ow", "nn"],
  "bank": ["b-ae1-ng-k", "nn vbp vb"],
  "banked": ["b-ae1-ng-k-t", "vbd jj vbn"],
  "banker": ["b-ae1-ng k-er", "nn"],
  "bankroll": ["b-ae1-ng-k r-ow-l", "vb vbp"],
  "bankrupt": ["b-ae1-ng k-r-ah-p-t", "jj nn vb vbp"],
  "bankruptcy": ["b-ae1-ng k-r-ah-p s-iy", "nn"],
  "banner": ["b-ae1 n-er", "nn"],
  "banquet": ["b-ae1-ng k-w-ah-t", "nn"],
  "banshee": ["b-ae-n sh-iy1", "nn"],
  "banter": ["b-ae1-n t-er", "nn"],
  "baptism": ["b-ae1-p t-ih z-ah-m", "nn"],
  "baptismal": ["b-ae-p t-ih1-z m-ah-l", "jj"],
  "baptistery": ["b-ae1-p t-ah-s t-r-iy", "nn"],
  "baptize": ["b-ae-p-t-ay1-z", "vb"],
  "bar": ["b-aa1-r", "nn vb vbp"],
  "barb": ["b-aa1-r-b", "nn vb"],
  "barbarian": ["b-aa-r b-eh1 r-iy ah-n", "nn"],
  "barbaric": ["b-aa-r b-ae1 r-ih-k", "jj"],
  "barbarous": ["b-aa1-r b-er ah-s", "jj"],
  "barbecue": ["b-aa1-r b-ih k-y-uw", "nn vb"],
  "barbed": ["b-aa1-r-b-d", "jj vbn"],
  "barbequed": ["b-aa1-r b-ih k-y-uw-d", "jj"],
  "barber": ["b-aa1-r b-er", "nn"],
  "bard": ["b-aa1-r-d", "nn"],
  "bare": ["b-eh1-r", "jj vb"],
  "barefoot": ["b-eh1-r f-uh-t", "rb jj"],
  "barely": ["b-eh1-r l-iy", "rb"],
  "barest": ["b-eh1 r-ah-s-t", "jjs"],
  "bargain": ["b-aa1-r g-ah-n", "nn vb"],
  "bargaining": ["b-aa1-r g-ih n-ih-ng", "nn jj vbg"],
  "barge": ["b-aa1-r-jh", "nn vb vbp"],
  "baritone": ["b-eh1 r-ah t-ow-n", "nn jj"],
  "barium": ["b-eh1 r-iy ah-m", "nn"],
  "bark": ["b-aa1-r-k", "nn vb"],
  "barley": ["b-aa1-r l-iy", "nn"],
  "barn": ["b-aa1-r-n", "nn"],
  "barnacle": ["b-aa1-r n-ah k-ah-l", "nn"],
  "barnyard": ["b-aa1-r-n y-aa-r-d", "nn"],
  "barometer": ["b-er aa1 m-ih t-er", "nn"],
  "barometric": ["b-ae r-ah m-eh1 t-r-ih-k", "jj"],
  "baron": ["b-ae1 r-ah-n", "nn"],
  "baroque": ["b-er ow1-k", "jj nn"],
  "barrack": ["b-ae1 r-ah-k", "nn"],
  "barrage": ["b-er aa1-zh", "nn"],
  "barrel": ["b-ae1 r-ah-l", "nn vb"],
  "barren": ["b-ae1 r-ah-n", "jj"],
  "barricade": ["b-ae1 r-ah k-ey-d", "nn vb"],
  "barrier": ["b-ae1 r-iy er", "nn"],
  "barrio": ["b-aa1 r-iy ow", "nn"],
  "barrister": ["b-ae1 r-ih-s t-er", "nn"],
  "barroom": ["b-aa1-r r-uw-m", "nn"],
  "barrow": ["b-ae1 r-ow", "nn"],
  "bartender": ["b-aa1-r t-eh-n d-er", "nn"],
  "barter": ["b-aa1-r t-er", "nn vb"],
  "base": ["b-ey1-s", "nn vbp jj vb"],
  "baseball": ["b-ey1-s b-ao1-l", "nn"],
  "baseless": ["b-ey1-s l-ah-s", "jj"],
  "baseline": ["b-ey1-s l-ay-n", "nn jj"],
  "baseman": ["b-ey1-s m-ah-n", "nn"],
  "basement": ["b-ey1-s m-ah-n-t", "nn"],
  "bash": ["b-ae1-sh", "nn vb"],
  "basher": ["b-ae1 sh-er", "nn"],
  "bashful": ["b-ae1-sh f-ah-l", "jj"],
  "bashing": ["b-ae1 sh-ih-ng", "jj vbg"],
  "basic": ["b-ey1 s-ih-k", "jj nn"],
  "basically": ["b-ey1 s-ih-k l-iy", "rb"],
  "basil": ["b-ae1 z-ah-l", "nn"],
  "basin": ["b-ey1 s-ah-n", "nn"],
  "basis": ["b-ey1 s-ah-s", "nn"],
  "bask": ["b-ae1-s-k", "vb"],
  "basket": ["b-ae1 s-k-ah-t", "nn"],
  "basketball": ["b-ae1 s-k-ah-t b-ao-l", "nn"],
  "bass": ["b-ae1-s", "nn"],
  "bassist": ["b-ey1 s-ih-s-t", "nn"],
  "bassoon": ["b-ah s-uw1-n", "nn"],
  "bastard": ["b-ae1 s-t-er-d", "nn"],
  "bastion": ["b-ae1 s-ch-ah-n", "nn"],
  "bat": ["b-ae1-t", "nn vb"],
  "batch": ["b-ae1-ch", "nn"],
  "bated": ["b-ey1 t-ih-d", "jj"],
  "bath": ["b-ae1-th", "nn"],
  "bathe": ["b-ey1-dh", "vb"],
  "bather": ["b-ey1 dh-er", "nn"],
  "bathrobe": ["b-ae1-th r-ow-b", "nn"],
  "bathroom": ["b-ae1-th r-uw-m", "nn"],
  "bathtub": ["b-ae1-th t-ah-b", "nn"],
  "baton": ["b-ah t-aa1-n", "nn"],
  "battalion": ["b-ah t-ae1 l-y-ah-n", "nn"],
  "batted": ["b-ae1 t-ih-d", "vbd vbn"],
  "batter": ["b-ae1 t-er", "nn vb"],
  "battered": ["b-ae1 t-er-d", "vbn vbd jj"],
  "battery": ["b-ae1 t-er iy", "nn"],
  "battle": ["b-ae1 t-ah-l", "nn vbp vb"],
  "battlefield": ["b-ae1 t-ah-l f-iy-l-d", "nn"],
  "battlefront": ["b-ae1 t-ah-l f-r-ah-n-t", "nn"],
  "battleground": ["b-ae1 t-ah-l g-r-aw-n-d", "nn"],
  "battlement": ["b-ae1 t-ah-l m-ah-n-t", "nn"],
  "bauble": ["b-ao1 b-ah-l", "nn"],
  "bawdy": ["b-ao1 d-iy", "jj"],
  "bawl": ["b-ao1-l", "vb"],
  "bay": ["b-ey1", "nn vb"],
  "bayonet": ["b-ey1 ah n-eh-t", "nn"],
  "bazaar": ["b-ah z-aa1-r", "nn"],
  "be": ["b-iy1", "vb"],
  "beach": ["b-iy1-ch", "nn vb"],
  "beachfront": ["b-iy1-ch f-r-aa-n-t", "nn jj"],
  "beachhead": ["b-iy1-ch hh-eh-d", "nn"],
  "beacon": ["b-iy1 k-ah-n", "nn"],
  "bead": ["b-iy1-d", "vb"],
  "beadle": ["b-iy1 d-ah-l", "nn"],
  "beadwork": ["b-iy1-d w-er-k", "nn"],
  "beady": ["b-iy1 d-iy", "jj"],
  "beak": ["b-iy1-k", "nn"],
  "beaker": ["b-iy1 k-er", "nn"],
  "beam": ["b-iy1-m", "nn vb"],
  "beaming": ["b-iy1 m-ih-ng", "vbg jj"],
  "bean": ["b-iy1-n", "nn vbn jj"],
  "bear": ["b-eh1-r", "vb nn vbp"],
  "bearable": ["b-eh1 r-ah b-ah-l", "jj"],
  "beard": ["b-ih1-r-d", "nn vb"],
  "bearded": ["b-ih1-r d-ah-d", "jj vbd vbn"],
  "bearer": ["b-eh1 r-er", "nn"],
  "bearing": ["b-eh1 r-ih-ng", "vbg jj nn"],
  "bearish": ["b-eh1 r-ih-sh", "jj"],
  "bearishly": ["b-eh1 r-ih-sh l-iy", "rb"],
  "bearishness": ["b-eh1 r-ih-sh n-ah-s", "nn"],
  "beast": ["b-iy1-s-t", "nn"],
  "beat": ["b-iy1-t", "vb jj nn vbd vbp"],
  "beaten": ["b-iy1 t-ah-n", "vbn jj"],
  "beatnik": ["b-iy1-t n-ih-k", "nn"],
  "beau": ["b-ow1", "nn"],
  "beautiful": ["b-y-uw1 t-ah f-ah-l", "jj"],
  "beautifully": ["b-y-uw1 t-ah f-l-iy", "rb"],
  "beautify": ["b-y-uw1 t-ih f-ay", "vb vbp"],
  "beauty": ["b-y-uw1 t-iy", "nn"],
  "beaver": ["b-iy1 v-er", "nn"],
  "bebop": ["b-iy1 b-aa-p", "nn"],
  "becalmed": ["b-ih k-aa1-m-d", "jj"],
  "became": ["b-ih k-ey1-m", "vbd"],
  "because": ["b-ih k-ao1-z", "in rb"],
  "beckon": ["b-eh1 k-ah-n", "vbp vb"],
  "become": ["b-ih k-ah1-m", "vb vbn vbp"],
  "bed": ["b-eh1-d", "nn vb vbp"],
  "bedding": ["b-eh1 d-ih-ng", "nn"],
  "bedevil": ["b-ih d-eh1 v-ah-l", "vb"],
  "bedfellow": ["b-eh1-d f-eh l-ow", "nn"],
  "bedlam": ["b-eh1-d l-ah-m", "nn"],
  "bedpan": ["b-eh1-d p-ae-n", "nn"],
  "bedraggled": ["b-ih d-r-ae1 g-ah-l-d", "jj"],
  "bedridden": ["b-eh1-d r-ih d-ah-n", "jj"],
  "bedrock": ["b-eh1-d r-aa-k", "nn"],
  "bedroom": ["b-eh1-d r-uw-m", "nn"],
  "bedside": ["b-eh1-d s-ay-d", "nn"],
  "bedspread": ["b-eh1-d s-p-r-eh-d", "nn"],
  "bedstraw": ["b-eh1-d s-t-r-ao", "nn"],
  "bedtime": ["b-eh1-d t-ay-m", "nn"],
  "bee": ["b-iy1", "nn"],
  "beech": ["b-iy1-ch", "nn"],
  "beef": ["b-iy1-f", "nn vb vbp"],
  "beefsteak": ["b-iy1-f s-t-ey-k", "nn"],
  "beefy": ["b-iy1 f-iy", "jj"],
  "beehive": ["b-iy1 hh-ay-v", "nn"],
  "been": ["b-ih1-n", "vbn"],
  "beep": ["b-iy1-p", "nn"],
  "beeper": ["b-iy1 p-er", "nn"],
  "beer": ["b-ih1-r", "nn"],
  "beet": ["b-iy1-t", "nn"],
  "beetle": ["b-iy1 t-ah-l", "nn"],
  "befall": ["b-ih f-ao1-l", "vb vbp"],
  "befallen": ["b-ah f-aa1 l-ah-n", "vbn"],
  "befell": ["b-ih f-eh1-l", "vbd"],
  "befit": ["b-ih-f-ih1-t", "vb"],
  "befitting": ["b-ih f-ih1 t-ih-ng", "vbg jj"],
  "before": ["b-ih f-ao1-r", "in rb rp"],
  "beforehand": ["b-ih f-ao1-r hh-ae-n-d", "rb"],
  "befriend": ["b-ih-f-r-eh1-n-d", "vb"],
  "befuddle": ["b-ih-f-ah1-d-ah-l", "vb"],
  "beg": ["b-eh1-g", "vbp vb"],
  "began": ["b-ih g-ae1-n", "vbd"],
  "begat": ["b-ih g-ae1-t", "vbd"],
  "beget": ["b-ih g-eh1-t", "vb vbp"],
  "beggar": ["b-eh1 g-er", "nn"],
  "begin": ["b-ih g-ih1-n", "vb vbp"],
  "beginner": ["b-ih g-ih1 n-er", "nn"],
  "beginning": ["b-ih g-ih1 n-ih-ng", "vbg jj nn"],
  "begonia": ["b-ih g-ow1 n-y-ah", "nn"],
  "begrudge": ["b-ih g-r-ah1-jh", "vb"],
  "beguile": ["b-ih-g-ay1-l", "vb"],
  "beguiling": ["b-ih g-ay1 l-ih-ng", "jj"],
  "begun": ["b-ih g-ah1-n", "vbn"],
  "behave": ["b-ih hh-ey1-v", "vb vbp"],
  "behavior": ["b-ih hh-ey1 v-y-er", "nn"],
  "behavioral": ["b-ih hh-ey1 v-y-er ah-l", "jj"],
  "behead": ["b-ih-hh-eh1-d", "vb"],
  "beheading": ["b-ih hh-eh1 d-ih-ng", "nn vbg"],
  "behemoth": ["b-ah hh-iy1 m-ah-th", "nn"],
  "behest": ["b-ih hh-eh1-s-t", "nn"],
  "behind": ["b-ih hh-ay1-n-d", "in nn rb rp"],
  "behold": ["b-ih hh-ow1-l-d", "vb"],
  "beholden": ["b-ih hh-ow1-l d-ah-n", "jj"],
  "beholder": ["b-iy hh-ow1-l d-er", "nn"],
  "beige": ["b-ey1-zh", "jj"],
  "being": ["b-iy1 ih-ng", "vbg jj nn"],
  "belabor": ["b-ih-l-ey1-b-er", "vb"],
  "belated": ["b-ih l-ey1 t-ih-d", "jj"],
  "belatedly": ["b-ih l-ey1 t-ah-d l-iy", "rb"],
  "belch": ["b-eh1-l-ch", "nn vb"],
  "beleaguer": ["b-ih-l-iy1-g-er", "vb"],
  "beleaguered": ["b-ih l-iy1 g-er-d", "jj vbn"],
  "belfry": ["b-eh1-l f-r-iy", "nn"],
  "belie": ["b-ih l-ay1", "vbp vb"],
  "belief": ["b-ih l-iy1-f", "nn"],
  "believable": ["b-ah l-iy1 v-ah b-ah-l", "jj"],
  "believe": ["b-ih l-iy1-v", "vbp vb"],
  "believer": ["b-ah l-iy1 v-er", "nn"],
  "belittle": ["b-ih l-ih1 t-ah-l", "vbp vb"],
  "belittled": ["b-ih l-ih1 t-ah-l-d", "jj"],
  "bell": ["b-eh1-l", "nn"],
  "bellhop": ["b-eh1-l hh-aa-p", "nn"],
  "belligerence": ["b-ah l-ih1 jh-er ah-n-s", "nn"],
  "belligerent": ["b-ah l-ih1 jh-er ah-n-t", "jj"],
  "bellow": ["b-eh1 l-ow", "nn vb"],
  "bellows": ["b-eh1 l-ow-z", "vbz nn"],
  "bellwether": ["b-eh1-l w-eh dh-er", "nn jj"],
  "belly": ["b-eh1 l-iy", "nn rb"],
  "belong": ["b-ih l-ao1-ng", "vb vbp jj"],
  "beloved": ["b-ih l-ah1-v-d", "jj vbn nn"],
  "below": ["b-ih l-ow1", "in rb"],
  "belt": ["b-eh1-l-t", "nn vb"],
  "beltway": ["b-eh1-l-t w-ey", "nn"],
  "beluga": ["b-ih l-uw1 g-ah", "nn"],
  "bely": ["b-ah-l-ay1", "vb"],
  "bemoan": ["b-ih m-ow1-n", "vb"],
  "bemused": ["b-ih m-y-uw1-z-d", "jj"],
  "bench": ["b-eh1-n-ch", "nn vb"],
  "benchmark": ["b-eh1-n-ch m-aa-r-k", "nn jj"],
  "bend": ["b-eh1-n-d", "vb nn"],
  "beneath": ["b-ih n-iy1-th", "in rb"],
  "benefactor": ["b-eh1 n-ah f-ae-k t-er", "nn"],
  "beneficence": ["b-ah n-eh1 f-ah s-ah-n-s", "nn"],
  "beneficial": ["b-eh n-ah f-ih1 sh-ah-l", "jj"],
  "beneficially": ["b-eh n-ah f-ih1 sh-ah l-iy", "rb"],
  "beneficiary": ["b-eh n-ah f-ih1 sh-iy eh r-iy", "nn jj"],
  "benefit": ["b-eh1 n-ah f-ih-t", "nn vb vbp"],
  "benevolence": ["b-ah n-eh1 v-ah l-ah-n-s", "nn"],
  "benevolent": ["b-ah n-eh1 v-ah l-ah-n-t", "jj"],
  "benighted": ["b-ih n-ay1 t-ih-d", "jj"],
  "benign": ["b-ih n-ay1-n", "jj"],
  "bent": ["b-eh1-n-t", "vbd vbn jj nn"],
  "benzene": ["b-eh-n z-iy1-n", "nn"],
  "bequeath": ["b-ih k-w-iy1-th", "vb"],
  "bequest": ["b-ih k-w-eh1-s-t", "nn"],
  "berate": ["b-ih-r-ey1-t", "vb"],
  "bereavement": ["b-er iy1-v m-ah-n-t", "nn"],
  "bereft": ["b-er eh1-f-t", "jj vbn"],
  "beret": ["b-eh1 r-ah-t", "nn"],
  "berg": ["b-er1-g", "nn"],
  "berry": ["b-eh1 r-iy", "nn"],
  "berserk": ["b-er s-er1-k", "jj rb"],
  "berth": ["b-er1-th", "nn"],
  "beryllium": ["b-er ih1 l-iy ah-m", "nn"],
  "beset": ["b-ih s-eh1-t", "vbn jj vbd"],
  "beside": ["b-ih s-ay1-d", "in rb"],
  "besides": ["b-ih s-ay1-d-z", "in rb"],
  "besiege": ["b-ih s-iy1-jh", "vb"],
  "besieged": ["b-ih s-iy1-jh-d", "vbn jj"],
  "bespeak": ["b-ih-s-p-iy1-k", "vb"],
  "bespectacled": ["b-ih s-p-eh1-k t-ah k-ah-l-d", "jj"],
  "best": ["b-eh1-s-t", "jjs rbs jjss nn rb vb"],
  "bestial": ["b-eh1 s-ch-ah-l", "jj"],
  "bestow": ["b-ih s-t-ow1", "vb"],
  "bestseller": ["b-eh1-s-t s-eh1 l-er", "nn"],
  "bestselling": ["b-eh1-s-t s-eh1 l-ih-ng", "jj"],
  "bet": ["b-eh1-t", "nn rb vb vbd vbn vbp"],
  "beta": ["b-ey1 t-ah", "nn jj"],
  "betide": ["b-ih t-ay1-d", "vb"],
  "betray": ["b-ih t-r-ey1", "vb vbp"],
  "betrayal": ["b-ih t-r-ey1 ah-l", "nn"],
  "better": ["b-eh1 t-er", "jjr rbr jj rb vb"],
  "betterment": ["b-eh1 t-er m-ah-n-t", "nn"],
  "between": ["b-ih t-w-iy1-n", "in rb"],
  "bevel": ["b-eh1 v-ah-l", "vb"],
  "beverage": ["b-eh1 v-er ih-jh", "nn"],
  "bevy": ["b-eh1 v-iy", "nn"],
  "beware": ["b-ih w-eh1-r", "vb vbp"],
  "bewilder": ["b-ih-w-ih1-l-d-er", "vb"],
  "bewildered": ["b-ih w-ih1-l d-er-d", "vbn jj"],
  "bewildering": ["b-ih w-ih1-l d-er ih-ng", "vbg jj"],
  "bewilderment": ["b-ih w-ih1-l d-er m-ah-n-t", "nn"],
  "bewitch": ["b-ih-w-ih1-ch", "vb"],
  "beyond": ["b-ih aa1-n-d", "in rb"],
  "bi": ["b-ay1", "in"],
  "bianco": ["b-iy aa1-ng k-ow", "nn"],
  "biannual": ["b-ay ae1 n-uw ah-l", "jj"],
  "bias": ["b-ay1 ah-s", "nn vb"],
  "bib": ["b-ih1-b", "nn"],
  "bible": ["b-ay1 b-ah-l", "jj nn"],
  "biblical": ["b-ih1 b-l-ah k-ah-l", "jj"],
  "bibliography": ["b-ih b-l-iy aa1 g-r-ah f-iy", "nn"],
  "bicarbonate": ["b-ay k-aa1-r b-ah n-ah-t", "nn"],
  "bicentennial": ["b-ay s-eh-n t-eh1 n-iy ah-l", "nn jj"],
  "bicker": ["b-ih1-k-er", "vb"],
  "bicycle": ["b-ay1 s-ih k-ah-l", "nn"],
  "bicycling": ["b-ay1 s-ih k-ah l-ih-ng", "nn"],
  "bid": ["b-ih1-d", "nn vbd vbn vbp vb"],
  "bidden": ["b-ih1 d-ih-n", "vbn"],
  "bidder": ["b-ih1 d-er", "nn"],
  "bide": ["b-ay1-d", "vb"],
  "biennial": ["b-ay eh1 n-iy ah-l", "jj"],
  "bifocal": ["b-ay1 f-ow k-ah-l", "nn"],
  "bifurcated": ["b-ih1 f-er k-ey t-ih-d", "jj"],
  "big": ["b-ih1-g", "jj rb"],
  "bigger": ["b-ih1 g-er", "jjr rbr"],
  "biggest": ["b-ih1 g-ah-s-t", "jjs rbs"],
  "biggie": ["b-ih1 g-iy", "nn"],
  "bigness": ["b-ih1-g n-ah-s", "nn"],
  "bigot": ["b-ih1 g-ah-t", "nn"],
  "bigoted": ["b-ih1 g-ah t-ih-d", "jj"],
  "bigotry": ["b-ih1 g-ah t-r-iy", "nn"],
  "bike": ["b-ay1-k", "nn"],
  "biker": ["b-ay1 k-er", "nn"],
  "biking": ["b-ay1 k-ih-ng", "nn"],
  "bikini": ["b-ih k-iy1 n-iy", "nn"],
  "bilateral": ["b-ay l-ae1 t-er ah-l", "jj"],
  "bile": ["b-ay1-l", "nn"],
  "bilingual": ["b-ay l-ih1-ng g-w-ah-l", "jj"],
  "bilious": ["b-ih1 l-iy ah-s", "jj"],
  "bilk": ["b-ih1-l-k", "vb"],
  "bill": ["b-ih1-l", "nn vbp vb"],
  "billable": ["b-ih1 l-ah b-ah-l", "jj"],
  "billboard": ["b-ih1-l b-ao-r-d", "nn"],
  "billed": ["b-ih1-l-d", "vbn jj vbd"],
  "billet": ["b-ih1 l-ah-t", "nn"],
  "billfold": ["b-ih1-l f-ow-l-d", "nn"],
  "billiard": ["b-ih1 l-y-er-d", "nn"],
  "billiards": ["b-ih1 l-y-er-d-z", "nn"],
  "billing": ["b-ih1 l-ih-ng", "nn vbg"],
  "billion": ["b-ih1 l-y-ah-n", "nn"],
  "billionaire": ["b-ih l-y-ah n-eh1-r", "nn"],
  "billon": ["b-ih1 l-ah-n", "nn"],
  "billow": ["b-ih1-l-ow", "vb"],
  "bimbo": ["b-ih1-m b-ow", "nn"],
  "bimonthly": ["b-ay m-ah1-n-th l-iy", "jj"],
  "bin": ["b-ih1-n", "nn"],
  "binary": ["b-ay1 n-er iy", "jj"],
  "binational": ["b-ay n-ae1 sh-ah n-ah-l", "jj"],
  "bind": ["b-ay1-n-d", "nn vb vbp"],
  "binder": ["b-ay1-n d-er", "nn"],
  "binding": ["b-ay1-n d-ih-ng", "nn jj vbg"],
  "binge": ["b-ih1-n-jh", "nn"],
  "bingo": ["b-ih1-ng g-ow", "nn"],
  "binocular": ["b-ah n-aa1 k-y-ah l-er", "nn"],
  "binomial": ["b-ay n-ow1 m-iy ah-l", "nn"],
  "bio": ["b-ay ow1", "nn jj"],
  "biochemical": ["b-ay ow k-eh1 m-ah k-ah-l", "jj"],
  "biochemist": ["b-ay ow k-eh1 m-ah-s-t", "nn"],
  "biochemistry": ["b-ay ow k-eh1 m-ah s-t-r-iy", "nn"],
  "biodegradable": ["b-ay ow d-ah g-r-ey1 d-ah b-ah-l", "jj"],
  "biofeedback": ["b-ay ow f-iy1-d b-ae-k", "nn"],
  "biographer": ["b-ay aa1 g-r-ah f-er", "nn"],
  "biographical": ["b-ay ah g-r-ae1 f-ih k-ah-l", "jj"],
  "biography": ["b-ay aa1 g-r-ah f-iy", "nn"],
  "biological": ["b-ay ah l-aa1 jh-ih k-ah-l", "jj nn"],
  "biologically": ["b-ay ah l-aa1 jh-ih-k l-iy", "rb"],
  "biologist": ["b-ay aa1 l-ah jh-ah-s-t", "nn"],
  "biology": ["b-ay aa1 l-ah jh-iy", "nn"],
  "biomedical": ["b-ay ow m-eh1 d-ih k-ah-l", "jj"],
  "biopsy": ["b-ay1 aa-p s-iy", "nn"],
  "biotech": ["b-ay1 ow t-eh-k", "jj nn"],
  "biotechnology": ["b-ay ow t-eh-k n-aa1 l-ah jh-iy", "nn"],
  "bipartisan": ["b-ay p-aa1-r t-ih z-ah-n", "jj"],
  "biplane": ["b-ay1 p-l-ey-n", "nn"],
  "biracial": ["b-ay r-ey1 sh-ah-l", "jj"],
  "birch": ["b-er1-ch", "nn"],
  "bird": ["b-er1-d", "nn"],
  "birdie": ["b-er1 d-iy", "nn vb"],
  "birth": ["b-er1-th", "nn"],
  "birthday": ["b-er1-th d-ey", "nn"],
  "birthplace": ["b-er1-th p-l-ey-s", "nn"],
  "birthrate": ["b-er1-th r-ey-t", "nn"],
  "birthright": ["b-er1-th r-ay-t", "nn"],
  "biscuit": ["b-ih1 s-k-ah-t", "nn"],
  "bisexual": ["b-ay s-eh1-k sh-uw ah-l", "jj"],
  "bishop": ["b-ih1 sh-ah-p", "nn"],
  "bison": ["b-ay1 s-ah-n", "nn"],
  "bisque": ["b-ih1-s-k", "nn"],
  "bit": ["b-ih1-t", "vbd nn rb"],
  "bitch": ["b-ih1-ch", "nn vb"],
  "bitchy": ["b-ih1 ch-iy", "jj"],
  "bite": ["b-ay1-t", "vb vbp nn"],
  "biting": ["b-ay1 t-ih-ng", "vbg jj"],
  "bitten": ["b-ih1 t-ah-n", "vbn"],
  "bitter": ["b-ih1 t-er", "jj"],
  "bitterest": ["b-ih1 t-er ah-s-t", "jjs"],
  "bitterly": ["b-ih1 t-er l-iy", "rb"],
  "bitterness": ["b-ih1 t-er n-ah-s", "nn"],
  "bittersweet": ["b-ih1 t-er s-w-iy-t", "jj"],
  "bituminous": ["b-ih t-uw1 m-ah n-ah-s", "jj"],
  "bivouac": ["b-ih1-v w-ae-k", "nn"],
  "biweekly": ["b-ay w-iy1-k l-iy", "jj nn"],
  "bizarre": ["b-ah z-aa1-r", "jj"],
  "black": ["b-l-ae1-k", "jj nn vb"],
  "blackberry": ["b-l-ae1-k b-eh r-iy", "nn"],
  "blackboard": ["b-l-ae1-k b-ao-r-d", "nn"],
  "blacken": ["b-l-ae1-k-ah-n", "vb"],
  "blackened": ["b-l-ae1 k-ah-n-d", "vbn jj"],
  "blacker": ["b-l-ae1 k-er", "jjr"],
  "blackest": ["b-l-ae1 k-ah-s-t", "jjs"],
  "blackjack": ["b-l-ae1-k jh-ae-k", "nn"],
  "blacklist": ["b-l-ae1-k l-ih-s-t", "vb"],
  "blackmail": ["b-l-ae1-k m-ey-l", "nn vb"],
  "blackness": ["b-l-ae1-k n-ah-s", "nn"],
  "blackout": ["b-l-ae1-k aw-t", "nn"],
  "blacksmith": ["b-l-ae1-k s-m-ih-th", "nn"],
  "bladder": ["b-l-ae1 d-er", "nn"],
  "blade": ["b-l-ey1-d", "nn"],
  "blame": ["b-l-ey1-m", "vb nn vbp"],
  "blanche": ["b-l-ae1-n-ch", "jj nn"],
  "bland": ["b-l-ae1-n-d", "jj"],
  "blander": ["b-l-ae1-n d-er", "jjr"],
  "blandly": ["b-l-ae1-n-d l-iy", "rb"],
  "blandness": ["b-l-ae1-n-d n-ah-s", "nn"],
  "blank": ["b-l-ae1-ng-k", "jj nn rb vb"],
  "blanket": ["b-l-ae1-ng k-ah-t", "nn vbp jj vb"],
  "blare": ["b-l-eh1-r", "vb"],
  "blase": ["b-l-ey1-z", "jj nn"],
  "blasphemous": ["b-l-ae1-s f-ah m-ah-s", "jj"],
  "blasphemy": ["b-l-ae1-s f-ah m-iy", "nn"],
  "blast": ["b-l-ae1-s-t", "nn vb"],
  "blastdown": ["b-l-ae1-s-t d-aw-n", "nn"],
  "blasting": ["b-l-ae1 s-t-ih-ng", "vbg jj"],
  "blatant": ["b-l-ey1 t-ah-n-t", "jj"],
  "blatantly": ["b-l-ey1 t-ah-n-t l-iy", "rb"],
  "blaze": ["b-l-ey1-z", "nn vb vbp"],
  "blazer": ["b-l-ey1 z-er", "nn"],
  "blazing": ["b-l-ey1 z-ih-ng", "vbg jj"],
  "bleach": ["b-l-iy1-ch", "nn vb"],
  "bleached": ["b-l-iy1-ch-t", "jj vbn"],
  "bleacher": ["b-l-iy1 ch-er", "nn"],
  "bleak": ["b-l-iy1-k", "jj nn"],
  "bleaker": ["b-l-iy1 k-er", "jjr"],
  "bleary": ["b-l-ih1 r-iy", "jj"],
  "bled": ["b-l-eh1-d", "vbd"],
  "bleed": ["b-l-iy1-d", "vb vbp"],
  "blemish": ["b-l-eh1 m-ih-sh", "nn"],
  "blend": ["b-l-eh1-n-d", "nn vbp vb"],
  "blended": ["b-l-eh1-n d-ah-d", "jj vbd vbn"],
  "blender": ["b-l-eh1-n d-er", "nn"],
  "bless": ["b-l-eh1-s", "vb"],
  "blessed": ["b-l-eh1-s-t", "vbn jj vbd"],
  "blessing": ["b-l-eh1 s-ih-ng", "nn vbg"],
  "blew": ["b-l-uw1", "vbd"],
  "blight": ["b-l-ay1-t", "nn vb"],
  "blind": ["b-l-ay1-n-d", "jj vb"],
  "blindfold": ["b-l-ay1-n-d f-ow-l-d", "nn vb"],
  "blindfolded": ["b-l-ay1-n-d f-ow-l d-ih-d", "vbn jj vbd"],
  "blinding": ["b-l-ay1-n d-ih-ng", "jj vbg"],
  "blindly": ["b-l-ay1-n-d l-iy", "rb"],
  "blindness": ["b-l-ay1-n-d n-ah-s", "nn"],
  "blindside": ["b-l-ay1-n-d-s-ay-d", "vb"],
  "blindsided": ["b-l-ay1-n-d s-ay d-ih-d", "vbn jj"],
  "blink": ["b-l-ih1-ng-k", "vb nn"],
  "blinking": ["b-l-ih1-ng k-ih-ng", "jj vbg rb"],
  "blip": ["b-l-ih1-p", "nn vbp vb"],
  "bliss": ["b-l-ih1-s", "nn"],
  "blissful": ["b-l-ih1-s f-ah-l", "jj"],
  "blissfully": ["b-l-ih1-s f-ah l-iy", "rb"],
  "blister": ["b-l-ih1 s-t-er", "nn vb"],
  "blistering": ["b-l-ih1 s-t-er ih-ng", "vbg jj"],
  "blithe": ["b-l-ay1-dh", "jj"],
  "blithely": ["b-l-ay1-th l-iy", "rb"],
  "blitz": ["b-l-ih1-t-s", "nn"],
  "blitzkrieg": ["b-l-ih1-t s-k-r-iy-g", "nn"],
  "blizzard": ["b-l-ih1 z-er-d", "nn"],
  "bloat": ["b-l-ow1-t", "nn vb"],
  "bloated": ["b-l-ow1 t-ih-d", "jj vbn"],
  "blob": ["b-l-aa1-b", "nn"],
  "blobby": ["b-l-aa1 b-iy", "jj"],
  "bloc": ["b-l-aa1-k", "nn"],
  "block": ["b-l-aa1-k", "nn vbp jj vb"],
  "blockade": ["b-l-aa k-ey1-d", "nn vb"],
  "blockage": ["b-l-aa1 k-ih jh-ih", "nn"],
  "blockbuster": ["b-l-aa1-k b-ah s-t-er", "nn jj"],
  "blocked": ["b-l-aa1-k-t", "vbn jj vbd"],
  "blocker": ["b-l-aa1 k-er", "nn"],
  "blocking": ["b-l-aa1 k-ih-ng", "vbg jj nn"],
  "bloke": ["b-l-ow1-k", "nn"],
  "blond": ["b-l-aa1-n-d", "jj nn"],
  "blonde": ["b-l-aa1-n-d", "jj nn"],
  "blood": ["b-l-ah1-d", "nn vb"],
  "bloodbath": ["b-l-ah1-d b-ae-th", "nn"],
  "bloodied": ["b-l-ah1 d-iy-d", "jj vbn"],
  "bloodiest": ["b-l-ah1 d-iy ah-s-t", "jjs"],
  "bloodless": ["b-l-ah1-d l-ah-s", "jj"],
  "bloodshed": ["b-l-ah1-d sh-eh-d", "nn"],
  "bloodstain": ["b-l-ah1-d s-t-ey-n", "nn"],
  "bloodstained": ["b-l-ah1-d s-t-ey-n-d", "jj"],
  "bloodstream": ["b-l-ah1-d s-t-r-iy-m", "nn"],
  "bloodsucking": ["b-l-ah1-d s-ah k-ih-ng", "vbg jj"],
  "bloodthirsty": ["b-l-ah1-d th-er s-t-iy", "jj"],
  "bloody": ["b-l-ah1 d-iy", "jj"],
  "bloom": ["b-l-uw1-m", "nn vbp vb"],
  "blooper": ["b-l-uw1 p-er", "nn"],
  "blossom": ["b-l-aa1 s-ah-m", "vb jj nn"],
  "blot": ["b-l-aa1-t", "nn vb"],
  "blouse": ["b-l-aw1-s", "nn"],
  "blow": ["b-l-ow1", "nn vb vbp"],
  "blower": ["b-l-ow1 er", "nn"],
  "blown": ["b-l-ow1-n", "vbn"],
  "blowout": ["b-l-ow1 aw-t", "nn"],
  "blowtorch": ["b-l-ow1 t-ao-r-ch", "nn"],
  "blowup": ["b-l-ow1 ah-p", "nn"],
  "blubber": ["b-l-ah1 b-er", "nn"],
  "bludgeon": ["b-l-ah1 jh-ah-n", "vb nn"],
  "blue": ["b-l-uw1", "jj nn"],
  "blueberry": ["b-l-uw1 b-eh r-iy", "nn"],
  "bluebonnet": ["b-l-uw1 b-aa n-ah-t", "nn"],
  "bluechip": ["b-l-uw1 ch-ih-p", "jj"],
  "blueprint": ["b-l-uw1 p-r-ih-n-t", "nn"],
  "bluest": ["b-l-uw1 ah-s-t", "jjs"],
  "bluff": ["b-l-ah1-f", "nn vb"],
  "bluing": ["b-l-uw1 ih-ng", "nn"],
  "bluish": ["b-l-uw1 ih-sh", "jj"],
  "blunder": ["b-l-ah1-n d-er", "nn vb"],
  "blunt": ["b-l-ah1-n-t", "vb jj"],
  "blunted": ["b-l-ah1-n t-ah-d", "vbd jj vbn"],
  "blunter": ["b-l-ah1-n t-er", "nn"],
  "bluntest": ["b-l-ah1-n t-ah-s-t", "rbs"],
  "bluntly": ["b-l-ah1-n-t l-iy", "rb"],
  "bluntness": ["b-l-ah1-n-t n-ah-s", "nn"],
  "blur": ["b-l-er1", "nn vb vbp"],
  "blurred": ["b-l-er1-d", "vbn jj vbd"],
  "blurry": ["b-l-er1 iy", "jj"],
  "blurt": ["b-l-er1-t", "nn vb vbp"],
  "blush": ["b-l-ah1-sh", "nn vb"],
  "bluster": ["b-l-ah1 s-t-er", "nn vb"],
  "blustery": ["b-l-ah1 s-t-er iy", "jj"],
  "boa": ["b-ow1 ah", "nn"],
  "boar": ["b-ao1-r", "nn"],
  "board": ["b-ao1-r-d", "nn rb vb"],
  "boarded": ["b-ao1-r d-ah-d", "vbd vbn jj"],
  "boardinghouse": ["b-ao1-r d-ih-ng hh-aw-s", "nn"],
  "boardroom": ["b-ao1-r-d r-uw-m", "nn"],
  "boast": ["b-ow1-s-t", "vbp nn vb"],
  "boastful": ["b-ow1-s-t f-ah-l", "jj"],
  "boat": ["b-ow1-t", "nn vb"],
  "boater": ["b-ow1 t-er", "nn"],
  "boatload": ["b-ow1-t l-ow-d", "nn"],
  "boatman": ["b-ow1-t m-ah-n", "nn"],
  "bobby": ["b-aa1 b-iy", "nn jj"],
  "bode": ["b-ow1-d", "vb vbp"],
  "bodega": ["b-ow d-ey1 g-ah", "nn"],
  "bodied": ["b-aa1 d-iy-d", "jj"],
  "bodily": ["b-aa1 d-ah l-iy", "jj rb"],
  "body": ["b-aa1 d-iy", "nn"],
  "bodyguard": ["b-aa1 d-iy g-aa-r-d", "nn"],
  "bog": ["b-aa1-g", "vb nn"],
  "bogey": ["b-ow1 g-iy", "nn vb"],
  "boggle": ["b-aa1-g-ah-l", "vb"],
  "bogus": ["b-ow1 g-ah-s", "jj"],
  "bohemian": ["b-ow hh-iy1 m-iy ah-n", "jj"],
  "boil": ["b-oy1-l", "vb nn"],
  "boiled": ["b-oy1-l-d", "vbn vbd jj"],
  "boiler": ["b-oy1 l-er", "nn"],
  "boilerplate": ["b-oy1 l-er p-l-ey-t", "nn"],
  "boisterous": ["b-oy1 s-t-er ah-s", "jj"],
  "bold": ["b-ow1-l-d", "jj"],
  "bolder": ["b-ow1-l d-er", "jjr"],
  "boldest": ["b-ow1-l d-ih-s-t", "jjs"],
  "boldly": ["b-ow1-l-d l-iy", "rb"],
  "boldness": ["b-ow1-l-d n-ah-s", "nn"],
  "boll": ["b-ow1-l", "nn"],
  "bolster": ["b-ow1-l s-t-er", "vb vbp nn"],
  "bolt": ["b-ow1-l-t", "nn vb"],
  "bomb": ["b-aa1-m", "nn vb"],
  "bombard": ["b-aa-m b-aa1-r-d", "vb"],
  "bombardment": ["b-aa-m b-aa1-r-d m-ah-n-t", "nn"],
  "bombast": ["b-aa1-m b-ae-s-t", "nn"],
  "bombastic": ["b-aa-m b-ae1 s-t-ih-k", "jj"],
  "bomber": ["b-aa1 m-er", "nn"],
  "bombing": ["b-aa1 m-ih-ng", "nn vbg"],
  "bombshell": ["b-aa1-m sh-eh-l", "nn"],
  "bonanza": ["b-ah n-ae1-n z-ah", "nn"],
  "bond": ["b-aa1-n-d", "nn vb"],
  "bondage": ["b-aa1-n d-ih-jh", "nn"],
  "bonded": ["b-aa1-n d-ah-d", "vbn jj"],
  "bondholder": ["b-aa1-n-d hh-ow-l d-er", "nn"],
  "bone": ["b-ow1-n", "nn vb"],
  "bonfire": ["b-aa1-n f-ay er", "nn"],
  "bonkers": ["b-aa1-ng k-er-z", "jj"],
  "bonnet": ["b-aa1 n-ah-t", "nn"],
  "bonus": ["b-ow1 n-ah-s", "nn"],
  "bony": ["b-ow1 n-iy", "jj"],
  "boo": ["b-uw1", "vb"],
  "booby": ["b-uw1 b-iy", "jj nn"],
  "boogie": ["b-uw1 g-iy", "nn"],
  "book": ["b-uh1-k", "nn vb"],
  "bookcase": ["b-uh1-k k-ey-s", "nn"],
  "booker": ["b-uh1-k er", "nn"],
  "bookie": ["b-uh1-k iy", "nn"],
  "booking": ["b-uh1 k-ih-ng", "nn vbg"],
  "bookish": ["b-uh1-k ih-sh", "jj"],
  "bookkeeper": ["b-uh1-k k-iy p-er", "nn"],
  "booklet": ["b-uh1-k l-ih-t", "nn"],
  "bookseller": ["b-uh1-k s-eh l-er", "nn"],
  "bookshelf": ["b-uh1-k sh-eh-l-f", "nn"],
  "bookstore": ["b-uh1-k s-t-ao-r", "nn"],
  "boom": ["b-uw1-m", "nn vb"],
  "boomer": ["b-uw1 m-er", "nn"],
  "boomerang": ["b-uw1 m-er ae-ng", "nn vb"],
  "booming": ["b-uw1 m-ih-ng", "jj vbg"],
  "boomtown": ["b-uw1-m t-aw-n", "nn"],
  "boon": ["b-uw1-n", "nn jj"],
  "boondoggle": ["b-uw-n d-aa1 g-ah-l", "nn"],
  "boor": ["b-uh1-r", "nn"],
  "boorish": ["b-uh1 r-ih-sh", "jj"],
  "boost": ["b-uw1-s-t", "vb nn vbp"],
  "booster": ["b-uw1 s-t-er", "nn"],
  "boot": ["b-uw1-t", "nn vb"],
  "booted": ["b-uw1 t-ih-d", "vbn vbd jj"],
  "booth": ["b-uw1-th", "nn"],
  "bootleg": ["b-uw1-t l-eh-g", "jj nn"],
  "bootlegger": ["b-uw1-t l-eh g-er", "nn"],
  "bootlegging": ["b-uw1-t l-eh g-ih-ng", "nn"],
  "booty": ["b-uw1 t-iy", "nn"],
  "booze": ["b-uw1-z", "nn"],
  "bop": ["b-aa1-p", "nn"],
  "borax": ["b-ao1 r-ae-k-s", "nn"],
  "border": ["b-ao1-r d-er", "nn vb"],
  "borderline": ["b-ao1-r d-er l-ay-n", "jj nn rb"],
  "bore": ["b-ao1-r", "vbp jj nn vb vbd"],
  "bored": ["b-ao1-r-d", "vbn jj vbd"],
  "boredom": ["b-ao1-r d-ah-m", "nn"],
  "borer": ["b-ao1 r-er", "nn"],
  "boring": ["b-ao1 r-ih-ng", "jj vbg"],
  "born": ["b-ao1-r-n", "vbn"],
  "borough": ["b-er1 ow", "nn"],
  "borrow": ["b-aa1 r-ow", "vb vbp"],
  "borrowed": ["b-aa1 r-ow-d", "vbn vbd jj"],
  "borrower": ["b-aa1 r-ow er", "nn"],
  "borrowing": ["b-aa1 r-ow ih-ng", "nn jj vbg"],
  "bosom": ["b-uh1 z-ah-m", "nn"],
  "boss": ["b-aa1-s", "nn"],
  "bossman": ["b-ao1-s m-ah-n", "nn"],
  "botanical": ["b-ah t-ae1 n-ih k-ah-l", "jj"],
  "botanist": ["b-aa1 t-ah n-ah-s-t", "nn"],
  "botany": ["b-aa1 t-ah n-iy", "nn"],
  "botch": ["b-aa1-ch", "vb"],
  "botched": ["b-aa1-ch-t", "vbn jj"],
  "both": ["b-aa1-th", "jj rb prp"],
  "bother": ["b-aa1 dh-er", "vb vbp"],
  "bothersome": ["b-aa1 dh-er s-ah-m", "jj"],
  "bottle": ["b-aa1 t-ah-l", "nn vb"],
  "bottled": ["b-aa1 t-ah-l-d", "jj vbd vbn"],
  "bottleneck": ["b-aa1 t-ah-l n-eh-k", "nn"],
  "bottler": ["b-aa1-t l-er", "nn"],
  "bottling": ["b-aa1 t-ah-l ih-ng", "nn vbg"],
  "bottom": ["b-aa1 t-ah-m", "nn jj vb"],
  "bottomless": ["b-aa1 t-ah-m l-ah-s", "jj"],
  "bough": ["b-aw1", "nn"],
  "bought": ["b-aa1-t", "vbd vbn"],
  "boulder": ["b-ow1-l d-er", "nn"],
  "boulevard": ["b-uh1 l-ah v-aa-r-d", "nn"],
  "bounce": ["b-aw1-n-s", "vb vbp nn"],
  "bouncy": ["b-aw1-n s-iy", "jj"],
  "bound": ["b-aw1-n-d", "vbn jj nn vbd"],
  "boundary": ["b-aw1-n d-er iy", "nn"],
  "bounded": ["b-aw1-n d-ah-d", "vbn vbd jj"],
  "boundless": ["b-aw1-n-d l-ah-s", "jj"],
  "bounty": ["b-aw1-n t-iy", "nn"],
  "bouquet": ["b-uw k-ey1", "nn"],
  "bourbon": ["b-er1 b-ah-n", "nn"],
  "bourgeois": ["b-uh-r zh-w-aa1", "jj"],
  "bourgeoisie": ["b-uh-r zh-w-aa z-iy1", "nn"],
  "bout": ["b-aw1-t", "nn"],
  "boutique": ["b-uw t-iy1-k", "nn"],
  "bovine": ["b-ow1 v-ay-n", "jj nn"],
  "bow": ["b-aw1", "nn vb vbp"],
  "bowed": ["b-aw1-d", "vbd vbn jj"],
  "bowel": ["b-aw1 ah-l", "nn"],
  "bower": ["b-aw1 er", "nn"],
  "bowl": ["b-ow1-l", "nn vb vbp"],
  "box": ["b-aa1-k-s", "nn vb"],
  "boxcar": ["b-aa1-k-s k-aa-r", "nn"],
  "boxer": ["b-aa1-k s-er", "nn"],
  "boxing": ["b-aa1-k s-ih-ng", "nn"],
  "boxy": ["b-aa1-k s-iy", "jj"],
  "boy": ["b-oy1", "nn uh"],
  "boycott": ["b-oy1 k-aa-t", "nn vb vbp"],
  "boyfriend": ["b-oy1 f-r-eh-n-d", "nn"],
  "boyhood": ["b-oy1 hh-uh-d", "nn"],
  "boyish": ["b-oy1 ih-sh", "jj"],
  "bra": ["b-r-aa1", "nn"],
  "brace": ["b-r-ey1-s", "nn vb vbp"],
  "bracelet": ["b-r-ey1-s l-ah-t", "nn"],
  "bracket": ["b-r-ae1 k-ih-t", "nn"],
  "brackish": ["b-r-ae1 k-ih-sh", "jj"],
  "brad": ["b-r-ae1-d", "nn"],
  "bradykinin": ["b-r-ah d-ih1 k-ih n-ih-n", "nn"],
  "brag": ["b-r-ae1-g", "vb vbp nn"],
  "braggadocio": ["b-r-ae g-ah d-ow1 sh-iy ow", "nn"],
  "braid": ["b-r-ey1-d", "vb"],
  "braided": ["b-r-ey1 d-ih-d", "jj vbn"],
  "brain": ["b-r-ey1-n", "nn"],
  "brainchild": ["b-r-ey1-n ch-ay-l-d", "nn"],
  "brainpower": ["b-r-ey1-n p-aw er", "nn"],
  "brainstorm": ["b-r-ey1-n s-t-ao-r-m", "nn"],
  "brainwash": ["b-r-ey1-n-w-aa-sh", "vb"],
  "brainwashing": ["b-r-ey1-n w-aa sh-ih-ng", "nn"],
  "brainy": ["b-r-ey1 n-iy", "jj"],
  "brake": ["b-r-ey1-k", "nn vb"],
  "bramble": ["b-r-ae1-m b-ah-l", "nn"],
  "bran": ["b-r-ae1-n", "nn"],
  "branch": ["b-r-ae1-n-ch", "nn vb"],
  "branched": ["b-r-ae1-n-ch-t", "vbn jj vbd"],
  "brand": ["b-r-ae1-n-d", "nn vb vbp jj rb"],
  "branded": ["b-r-ae1-n d-ih-d", "vbn jj"],
  "brandish": ["b-r-ae1-n-d-ih-sh", "vb"],
  "brandy": ["b-r-ae1-n d-iy", "nn vb"],
  "brash": ["b-r-ae1-sh", "jj"],
  "brashness": ["b-r-ae1-sh n-ah-s", "nn"],
  "brass": ["b-r-ae1-s", "nn jj"],
  "brassy": ["b-r-ae1 s-iy", "jj"],
  "brat": ["b-r-ae1-t", "nn"],
  "bratwurst": ["b-r-ae1-t w-er-s-t", "nn"],
  "bravado": ["b-r-ah v-aa1 d-ow", "nn"],
  "brave": ["b-r-ey1-v", "jj vb"],
  "bravely": ["b-r-ey1-v l-iy", "rb"],
  "braver": ["b-r-ey1 v-er", "jjr"],
  "bravery": ["b-r-ey1 v-er iy", "nn"],
  "bravest": ["b-r-ey1 v-ah-s-t", "jjs"],
  "bravura": ["b-r-ah v-y-uh1 r-ah", "nn jj"],
  "brawl": ["b-r-ao1-l", "nn"],
  "brawling": ["b-r-ao1 l-ih-ng", "nn"],
  "brawny": ["b-r-ao1 n-iy", "jj"],
  "brazen": ["b-r-ey1 z-ah-n", "jj vb"],
  "brazenly": ["b-r-ey1 z-ah-n l-iy", "rb"],
  "brazier": ["b-r-ey1 z-iy er", "nn"],
  "brazil": ["b-r-ah z-ih1-l", "nn"],
  "breach": ["b-r-iy1-ch", "nn vb"],
  "bread": ["b-r-eh1-d", "nn"],
  "breadbasket": ["b-r-eh1-d b-ae s-k-ah-t", "nn"],
  "breadbox": ["b-r-eh1-d b-aa-k-s", "nn"],
  "breaded": ["b-r-eh1 d-ih-d", "jj"],
  "breadth": ["b-r-eh1-d-th", "nn"],
  "break": ["b-r-ey1-k", "vb nn vbp"],
  "breakage": ["b-r-ey1 k-ih-jh", "nn"],
  "breakaway": ["b-r-ey1-k ah w-ey", "nn"],
  "breakdown": ["b-r-ey1-k d-aw-n", "nn"],
  "breaker": ["b-r-ey1 k-er", "nn"],
  "breakeven": ["b-r-ey1 k-iy v-ah-n", "jj nn"],
  "breakfast": ["b-r-eh1-k f-ah-s-t", "nn"],
  "breaking": ["b-r-ey1 k-ih-ng", "vbg jj nn"],
  "breakneck": ["b-r-ey1-k n-eh-k", "jj"],
  "breakthrough": ["b-r-ey1-k th-r-uw", "nn"],
  "breakup": ["b-r-ey1-k ah-p", "nn"],
  "breakwater": ["b-r-ey1-k w-ao t-er", "nn"],
  "breast": ["b-r-eh1-s-t", "nn"],
  "breath": ["b-r-eh1-th", "nn vb"],
  "breathe": ["b-r-iy1-dh", "vb vbp"],
  "breather": ["b-r-iy1 dh-er", "nn"],
  "breathless": ["b-r-eh1-th l-ah-s", "jj"],
  "breathlessly": ["b-r-eh1-th l-ah-s l-iy", "rb"],
  "breathtaking": ["b-r-eh1-th t-ey k-ih-ng", "jj"],
  "breathy": ["b-r-eh1 th-iy", "jj"],
  "bred": ["b-r-eh1-d", "vbn vbd"],
  "breed": ["b-r-iy1-d", "nn vb vbp"],
  "breeder": ["b-r-iy1 d-er", "nn"],
  "breeze": ["b-r-iy1-z", "nn vb"],
  "breezy": ["b-r-iy1 z-iy", "jj"],
  "brevity": ["b-r-eh1 v-ah t-iy", "nn"],
  "brew": ["b-r-uw1", "nn vb"],
  "brewer": ["b-r-uw1 er", "nn"],
  "brewery": ["b-r-uw1 er iy", "nn"],
  "bribe": ["b-r-ay1-b", "nn vb"],
  "bribery": ["b-r-ay1 b-er iy", "nn"],
  "brick": ["b-r-ih1-k", "nn"],
  "bricklayer": ["b-r-ih1-k l-ey er", "nn"],
  "bridal": ["b-r-ay1 d-ah-l", "jj"],
  "bride": ["b-r-ay1-d", "nn"],
  "bridegroom": ["b-r-ay1-d g-r-uw-m", "nn"],
  "bridesmaid": ["b-r-ay1-d-z m-ey-d", "nn"],
  "bridge": ["b-r-ih1-jh", "nn jj vb"],
  "bridgehead": ["b-r-ih1-jh hh-eh-d", "nn"],
  "bridging": ["b-r-ih1 jh-ih-ng", "vbg jj"],
  "bridle": ["b-r-ay1 d-ah-l", "nn vb"],
  "brie": ["b-r-iy1", "nn"],
  "brief": ["b-r-iy1-f", "jj nn vb"],
  "briefcase": ["b-r-iy1-f k-ey-s", "nn"],
  "briefer": ["b-r-iy1 f-er", "jjr"],
  "briefing": ["b-r-iy1 f-ih-ng", "nn vbg"],
  "briefly": ["b-r-iy1-f l-iy", "nn rb"],
  "brig": ["b-r-ih1-g", "nn"],
  "brigade": ["b-r-ah g-ey1-d", "nn"],
  "brigadier": ["b-r-ih g-ah d-ih1-r", "nn"],
  "bright": ["b-r-ay1-t", "jj rb"],
  "brighten": ["b-r-ay1 t-ah-n", "vb"],
  "brighter": ["b-r-ay1 t-er", "jjr"],
  "brightest": ["b-r-ay1 t-ah-s-t", "jjs"],
  "brightly": ["b-r-ay1-t l-iy", "rb"],
  "brightness": ["b-r-ay1-t n-ah-s", "nn"],
  "brilliance": ["b-r-ih1-l y-ah-n-s", "nn"],
  "brilliant": ["b-r-ih1-l y-ah-n-t", "jj"],
  "brilliantly": ["b-r-ih1-l y-ah-n-t l-iy", "rb"],
  "brim": ["b-r-ih1-m", "nn"],
  "brimmed": ["b-r-ih1-m-d", "vbd vbn"],
  "brindle": ["b-r-ih1-n d-ah-l", "nn"],
  "brine": ["b-r-ay1-n", "nn"],
  "bring": ["b-r-ih1-ng", "vb vbp"],
  "brink": ["b-r-ih1-ng-k", "nn"],
  "brinkmanship": ["b-r-ih1-ng-k m-ah-n sh-ih-p", "nn"],
  "brinksmanship": ["b-r-ih1-ng-k-s m-ah-n sh-ih-p", "nn"],
  "brisk": ["b-r-ih1-s-k", "jj"],
  "brisker": ["b-r-ih1 s-k-er", "jjr"],
  "briskly": ["b-r-ih1-s-k l-iy", "rb"],
  "bristle": ["b-r-ih1 s-ah-l", "vbp vb nn"],
  "bristling": ["b-r-ih1 s-ah-l ih-ng", "vbg jj"],
  "brittle": ["b-r-ih1 t-ah-l", "jj"],
  "broach": ["b-r-ow1-ch", "vb"],
  "broad": ["b-r-ao1-d", "jj"],
  "broadcast": ["b-r-ao1-d k-ae-s-t", "nn jj vb vbd vbn"],
  "broadcaster": ["b-r-ao1-d k-ae s-t-er", "nn"],
  "broaden": ["b-r-ao1 d-ah-n", "vb vbp"],
  "broader": ["b-r-ao1 d-er", "jjr"],
  "broadest": ["b-r-ao1 d-ih-s-t", "jjs"],
  "broadly": ["b-r-ao1-d l-iy", "rb"],
  "broadside": ["b-r-ao1-d s-ay-d", "jj nn rb"],
  "brocade": ["b-r-ow k-ey1-d", "nn"],
  "broccoli": ["b-r-aa1 k-ah l-iy", "nn"],
  "brochure": ["b-r-ow sh-uh1-r", "nn"],
  "broil": ["b-r-oy1-l", "nn vb"],
  "broiler": ["b-r-oy1 l-er", "nn"],
  "brok": ["b-r-aa1-k", "vbd"],
  "broke": ["b-r-ow1-k", "vbd jj rb"],
  "broken": ["b-r-ow1 k-ah-n", "vbn jj"],
  "broker": ["b-r-ow1 k-er", "nn vb"],
  "brokerage": ["b-r-ow1 k-er ih-jh", "nn"],
  "bromide": ["b-r-ow1 m-ay-d", "nn"],
  "bronc": ["b-r-aa1-ng-k", "nn"],
  "bronchial": ["b-r-aa1-n ch-iy ah-l", "jj"],
  "bronchitis": ["b-r-aa-ng k-ay1 t-ah-s", "nn"],
  "bronze": ["b-r-aa1-n-z", "nn jj"],
  "bronzed": ["b-r-aa1-n-z-d", "jj"],
  "brooch": ["b-r-uw1-ch", "nn"],
  "brood": ["b-r-uw1-d", "nn jj vb"],
  "brooding": ["b-r-uw1 d-ih-ng", "vbg jj nn"],
  "broody": ["b-r-uw1 d-iy", "jj"],
  "brook": ["b-r-uh1-k", "nn"],
  "broom": ["b-r-uw1-m", "nn"],
  "broth": ["b-r-ao1-th", "nn"],
  "brothel": ["b-r-aa1 th-ah-l", "nn"],
  "brother": ["b-r-ah1 dh-er", "nn"],
  "brotherhood": ["b-r-ah1 dh-er hh-uh-d", "nn"],
  "brotherly": ["b-r-ah1 dh-er l-iy", "jj"],
  "brought": ["b-r-ao1-t", "vbn vbd"],
  "brouhaha": ["b-r-uw1 hh-aa hh-aa", "nn"],
  "brow": ["b-r-aw1", "nn"],
  "browbeat": ["b-r-aw1 b-iy-t", "vb"],
  "brown": ["b-r-aw1-n", "jj nn vb"],
  "brownie": ["b-r-aw1 n-iy", "nn"],
  "brownish": ["b-r-aw1 n-ih-sh", "jj"],
  "brownout": ["b-r-aw1-n aw-t", "nn"],
  "browse": ["b-r-aw1-z", "vb"],
  "bruise": ["b-r-uw1-z", "nn vb"],
  "bruised": ["b-r-uw1-z-d", "vbn jj"],
  "bruising": ["b-r-uw1 z-ih-ng", "jj vbg"],
  "brunch": ["b-r-ah1-n-ch", "nn"],
  "brunette": ["b-r-uw n-eh1-t", "jj nn"],
  "brunt": ["b-r-ah1-n-t", "nn"],
  "brush": ["b-r-ah1-sh", "nn jj vb vbp"],
  "brushed": ["b-r-ah1-sh-t", "vbd vbn jj"],
  "brushwork": ["b-r-ah1-sh w-er-k", "nn"],
  "brushy": ["b-r-ah1 sh-iy", "jj"],
  "brusquely": ["b-r-ah1-s-k l-iy", "rb"],
  "brutal": ["b-r-uw1 t-ah-l", "jj"],
  "brutality": ["b-r-uw t-ae1 l-ah t-iy", "nn"],
  "brutalize": ["b-r-uw1-t-ah-l-ay-z", "vb"],
  "brutalized": ["b-r-uw1 t-ah l-ay-z-d", "vbn jj"],
  "brutally": ["b-r-uw1 t-ah l-iy", "rb"],
  "brute": ["b-r-uw1-t", "nn jj"],
  "brutish": ["b-r-uw1 t-ih-sh", "jj"],
  "bubble": ["b-ah1 b-ah-l", "nn vbp vb"],
  "bubbly": ["b-ah1 b-l-iy", "jj nn"],
  "buccaneer": ["b-ah k-ah n-iy1-r", "nn"],
  "buck": ["b-ah1-k", "nn vbp vb"],
  "bucket": ["b-ah1 k-ah-t", "nn"],
  "buckle": ["b-ah1 k-ah-l", "vb nn"],
  "buckled": ["b-ah1 k-ah-l-d", "vbd vbn jj"],
  "buckshot": ["b-ah1-k sh-aa-t", "nn"],
  "buckskin": ["b-ah1-k s-k-ih-n", "nn"],
  "buckwheat": ["b-ah1-k w-iy-t", "nn"],
  "bucolic": ["b-y-uw k-aa1 l-ih-k", "jj"],
  "bud": ["b-ah1-d", "nn vb"],
  "budding": ["b-ah1 d-ih-ng", "vbg jj"],
  "buddy": ["b-ah1 d-iy", "nn"],
  "budge": ["b-ah1-jh", "vb"],
  "budget": ["b-ah1 jh-ih-t", "nn vb"],
  "budgetary": ["b-ah1 jh-ih t-eh r-iy", "jj"],
  "budgeteer": ["b-ah jh-ih t-ih1-r", "nn"],
  "buff": ["b-ah1-f", "nn jj"],
  "buffalo": ["b-ah1 f-ah l-ow", "nn"],
  "buffer": ["b-ah1 f-er", "nn vb"],
  "buffet": ["b-ah1 f-ah-t", "nn vb vbp"],
  "buffoon": ["b-ah f-uw1-n", "nn"],
  "bug": ["b-ah1-g", "nn vb vbp"],
  "bugaboo": ["b-ah1 g-ah b-uw", "nn"],
  "bugeyed": ["b-ah1 g-ay-d", "jj"],
  "bugger": ["b-ah1 g-er", "nn"],
  "bugging": ["b-ah1 g-ih-ng", "nn"],
  "buggy": ["b-ah1 g-iy", "nn"],
  "bugle": ["b-y-uw1 g-ah-l", "nn"],
  "build": ["b-ih1-l-d", "vb vbp nn"],
  "builder": ["b-ih1-l d-er", "nn"],
  "building": ["b-ih1-l d-ih-ng", "nn vbg"],
  "buildup": ["b-ih1-l-d ah-p", "nn"],
  "built": ["b-ih1-l-t", "vbn jj vbd"],
  "bulb": ["b-ah1-l-b", "nn"],
  "bulge": ["b-ah1-l-jh", "nn vb"],
  "bulging": ["b-ah1-l jh-ih-ng", "vbg jj"],
  "bulk": ["b-ah1-l-k", "nn jj"],
  "bulkhead": ["b-ah1-l-k hh-eh-d", "nn"],
  "bulky": ["b-ah1-l k-iy", "jj"],
  "bull": ["b-uh1-l", "nn vb"],
  "bulldog": ["b-uh1-l d-ao-g", "jj"],
  "bulldoze": ["b-uh1-l d-ow-z", "vb"],
  "bulldozer": ["b-uh1-l d-ow z-er", "nn"],
  "bullet": ["b-uh1 l-ah-t", "nn"],
  "bulletin": ["b-uh1 l-ih t-ah-n", "nn vb"],
  "bulletproof": ["b-uh1 l-ah-t p-r-uw-f", "jj"],
  "bullfighter": ["b-uh1-l f-ay t-er", "nn"],
  "bullhorn": ["b-uh1-l hh-ao-r-n", "nn"],
  "bullied": ["b-uh1 l-iy-d", "vbd vbn"],
  "bullion": ["b-uh1 l-y-ah-n", "nn"],
  "bullish": ["b-uh1 l-ih-sh", "jj"],
  "bullishly": ["b-uh1 l-ih-sh l-iy", "rb"],
  "bullishness": ["b-uh1 l-ih-sh n-ah-s", "nn"],
  "bullock": ["b-uh1 l-ah-k", "nn"],
  "bully": ["b-uh1 l-iy", "nn vbp vb"],
  "bulwark": ["b-uh1-l w-er-k", "nn"],
  "bum": ["b-ah1-m", "nn vb jj vbp"],
  "bumble": ["b-ah1-m b-ah-l", "vb vbp"],
  "bumbling": ["b-ah1-m b-ah-l ih-ng", "jj vbg"],
  "bump": ["b-ah1-m-p", "vb nn vbp"],
  "bumper": ["b-ah1-m p-er", "nn jj"],
  "bumpy": ["b-ah1-m p-iy", "jj"],
  "bun": ["b-ah1-n", "nn"],
  "bunch": ["b-ah1-n-ch", "nn vb"],
  "bundle": ["b-ah1-n d-ah-l", "nn vb"],
  "bungalow": ["b-ah1-ng g-ah l-ow", "nn"],
  "bungle": ["b-ah1-ng g-ah-l", "vb"],
  "bunk": ["b-ah1-ng-k", "nn"],
  "bunker": ["b-ah1-ng k-er", "nn"],
  "bunny": ["b-ah1 n-iy", "nn"],
  "bunt": ["b-ah1-n-t", "nn vb"],
  "buoy": ["b-uw1 iy", "vb"],
  "buoyancy": ["b-oy1 ah-n s-iy", "nn"],
  "buoyant": ["b-oy1 ah-n-t", "jj"],
  "burden": ["b-er1 d-ah-n", "nn vb vbp"],
  "burdensome": ["b-er1 d-ah-n s-ah-m", "jj"],
  "bureau": ["b-y-uh1 r-ow", "nn"],
  "bureaucracy": ["b-y-uh r-aa1 k-r-ah s-iy", "nn"],
  "bureaucrat": ["b-y-uh1 r-ah k-r-ae-t", "nn"],
  "bureaucratic": ["b-y-uh r-ah k-r-ae1 t-ih-k", "jj"],
  "burgeon": ["b-er1-jh-ah-n", "vb"],
  "burgeoning": ["b-er1 jh-ah n-ih-ng", "vbg jj"],
  "burger": ["b-er1 g-er", "nn"],
  "burglar": ["b-er1 g-l-er", "nn"],
  "burglary": ["b-er1 g-l-er iy", "nn"],
  "burgundy": ["b-er1 g-ah-n d-iy", "nn"],
  "burial": ["b-eh1 r-iy ah-l", "nn"],
  "buried": ["b-eh1 r-iy-d", "vbn jj vbd"],
  "burl": ["b-er1-l", "nn"],
  "burlap": ["b-er1 l-ae-p", "nn"],
  "burlesque": ["b-er l-eh1-s-k", "jj"],
  "burley": ["b-er1 l-iy", "nn"],
  "burly": ["b-er1 l-iy", "jj"],
  "burn": ["b-er1-n", "vb vbp nn"],
  "burne": ["b-er1-n", "vb"],
  "burned": ["b-er1-n-d", "vbn jj vbd"],
  "burner": ["b-er1 n-er", "nn"],
  "burning": ["b-er1 n-ih-ng", "vbg jj nn"],
  "burnish": ["b-er1-n-ih-sh", "vb"],
  "burnout": ["b-er1-n aw-t", "nn"],
  "burnt": ["b-er1-n-t", "vbn jj"],
  "burp": ["b-er1-p", "vb"],
  "burr": ["b-er1", "nn"],
  "burrow": ["b-er1 ow", "nn vb"],
  "burst": ["b-er1-s-t", "nn vbd vbn vbp vb"],
  "bury": ["b-eh1 r-iy", "vb vbp"],
  "bus": ["b-ah1-s", "nn vb vbp"],
  "busboy": ["b-ah1-s b-oy", "nn"],
  "bush": ["b-uh1-sh", "nn"],
  "bushel": ["b-uh1 sh-ah-l", "nn"],
  "bushy": ["b-uh1 sh-iy", "jj"],
  "busied": ["b-ih1 z-iy-d", "vbd"],
  "busier": ["b-ih1 z-iy er", "jjr"],
  "busiest": ["b-ih1 z-iy ah-s-t", "jjs"],
  "busily": ["b-ih1 z-ah l-iy", "rb"],
  "business": ["b-ih1-z n-ah-s", "nn"],
  "busload": ["b-ah-s l-ow1-d", "nn"],
  "bust": ["b-ah1-s-t", "nn jj rb vb"],
  "busted": ["b-ah1 s-t-ih-d", "jj vbd vbn"],
  "buster": ["b-ah1 s-t-er", "nn"],
  "bustle": ["b-ah1 s-ah-l", "nn vb"],
  "bustling": ["b-ah1 s-ah l-ih-ng", "jj vbg"],
  "busy": ["b-ih1 z-iy", "jj"],
  "but": ["b-ah1-t", "cc"],
  "butane": ["b-y-uw t-ey1-n", "nn"],
  "butcher": ["b-uh1 ch-er", "nn vb"],
  "butchering": ["b-uh1 ch-er ih-ng", "nn"],
  "butchery": ["b-uh1 ch-er iy", "nn"],
  "butler": ["b-ah1-t l-er", "nn"],
  "butt": ["b-ah1-t", "nn"],
  "butter": ["b-ah1 t-er", "nn"],
  "butterfly": ["b-ah1 t-er f-l-ay", "nn"],
  "buttery": ["b-ah1 t-er iy", "jj"],
  "buttock": ["b-ah1 t-ah-k", "nn"],
  "button": ["b-ah1 t-ah-n", "nn vb"],
  "buttonhole": ["b-ah1 t-ah-n hh-ow-l", "nn"],
  "buttress": ["b-ah1 t-r-ah-s", "vb"],
  "buxom": ["b-ah1-k s-ah-m", "jj"],
  "buy": ["b-ay1", "vb vbp nn jj"],
  "buyback": ["b-ay1 b-ae-k", "jj nn"],
  "buyer": ["b-ay1 er", "nn"],
  "buying": ["b-ay1 ih-ng", "vbg jj"],
  "buyout": ["b-ay1 aw-t", "nn"],
  "buzz": ["b-ah1-z", "nn jj vb"],
  "buzzer": ["b-ah1 z-er", "nn"],
  "buzzing": ["b-ah1 z-ih-ng", "vbg jj"],
  "buzzword": ["b-ah1-z w-er-d", "nn"],
  "by": ["b-ay1", "in rb rp"],
  "bygone": ["b-ay1 g-ao-n", "jj"],
  "bylaw": ["b-ay1 l-ao", "nn"],
  "byline": ["b-ay1 l-ay-n", "nn"],
  "bypass": ["b-ay1 p-ae-s", "vb nn"],
  "byproduct": ["b-ay1 p-r-aa d-ah-k-t", "nn"],
  "bystander": ["b-ay1 s-t-ae-n d-er", "nn"],
  "byte": ["b-ay1-t", "nn"],
  "byway": ["b-ay1 w-ey", "nn"],
  "byword": ["b-ay1 w-er-d", "nn"],
  "byzantine": ["b-ih1 z-ah-n t-ay-n", "jj"],
  "cab": ["k-ae1-b", "nn"],
  "cabal": ["k-ah b-aa1-l", "nn"],
  "cabana": ["k-ah b-ae1 n-ah", "nn"],
  "cabaret": ["k-ae b-er ey1", "nn"],
  "cabbage": ["k-ae1 b-ih-jh", "nn"],
  "cabdriver": ["k-ae1-b d-r-ay v-er", "nn"],
  "cabin": ["k-ae1 b-ah-n", "nn"],
  "cabinet": ["k-ae1 b-ah n-ah-t", "nn"],
  "cable": ["k-ey1 b-ah-l", "nn vb vbp"],
  "cacao": ["k-ah k-ey1 ow", "nn"],
  "cache": ["k-ae1-sh", "nn"],
  "cachet": ["k-ae1 sh-ey", "nn"],
  "cacophony": ["k-ae k-aa1 f-ah n-iy", "nn"],
  "cactus": ["k-ae1-k t-ah-s", "nn"],
  "cadaver": ["k-ah d-ae1 v-er", "nn"],
  "cadence": ["k-ey1 d-ah-n-s", "nn"],
  "cadet": ["k-ah d-eh1-t", "nn"],
  "cadmium": ["k-ae1-d m-iy ah-m", "nn"],
  "cadre": ["k-ae1 d-r-iy", "nn"],
  "cafe": ["k-ah f-ey1", "nn"],
  "cafeteria": ["k-ae f-ah t-ih1 r-iy ah", "nn"],
  "caffeine": ["k-ae f-iy1-n", "nn"],
  "cage": ["k-ey1-jh", "nn vb"],
  "cagey": ["k-ey1 jh-iy", "jj"],
  "cahoot": ["k-ah hh-uw1-t", "nn"],
  "cajole": ["k-ah jh-ow1-l", "vb"],
  "cajun": ["k-ey1 jh-ah-n", "jj"],
  "cake": ["k-ey1-k", "nn"],
  "calamitous": ["k-ah l-ae1 m-ah t-ah-s", "jj"],
  "calamity": ["k-ah l-ae1 m-ah t-iy", "nn"],
  "calcified": ["k-ae1-l s-ah f-ay-d", "vbd"],
  "calcify": ["k-ae1-l-s-ah-f-ay", "vb"],
  "calcium": ["k-ae1-l s-iy ah-m", "nn"],
  "calculate": ["k-ae1-l k-y-ah l-ey-t", "vb vbp"],
  "calculated": ["k-ae1-l k-y-ah l-ey t-ah-d", "vbn vbd jj"],
  "calculating": ["k-ae1-l k-y-ah l-ey t-ih-ng", "vbg jj nn"],
  "calculation": ["k-ae-l k-y-ah l-ey1 sh-ah-n", "nn"],
  "calculator": ["k-ae1-l k-y-ah l-ey t-er", "nn"],
  "calculus": ["k-ae1-l k-y-ah l-ah-s", "nn"],
  "calendar": ["k-ae1 l-ah-n d-er", "nn"],
  "calf": ["k-ae1-f", "nn"],
  "caliber": ["k-ae1 l-ah b-er", "nn"],
  "calibrate": ["k-ae1-l-ah-b-r-ey-t", "vb"],
  "calibration": ["k-ae l-ah b-r-ey1 sh-ah-n", "nn"],
  "calico": ["k-ae1 l-ah k-ow", "jj"],
  "caliper": ["k-ae1 l-ah p-er", "nn"],
  "calisthenics": ["k-ae l-ah-s th-eh1 n-ih-k", "nn"],
  "call": ["k-ao1-l", "vb nn vbp"],
  "called": ["k-ao1-l-d", "vbd vbn"],
  "caller": ["k-ao1 l-er", "nn"],
  "calligraphy": ["k-ah l-ih1 g-r-ah f-iy", "nn"],
  "callous": ["k-ae1 l-ah-s", "jj"],
  "calloused": ["k-ae1 l-ah-s-t", "jj"],
  "callously": ["k-ae1 l-ah-s l-iy", "rb"],
  "callousness": ["k-ae1 l-ah-s n-ah-s", "nn"],
  "calm": ["k-aa1-m", "jj nn vb"],
  "calmer": ["k-aa1 m-er", "jjr"],
  "calming": ["k-aa1 m-ih-ng", "vbg jj"],
  "calmly": ["k-aa1-m l-iy", "rb"],
  "calmness": ["k-aa1-m n-ah-s", "nn"],
  "caloric": ["k-ah l-ao1 r-ih-k", "jj"],
  "calorie": ["k-ae1 l-er iy", "nn"],
  "calve": ["k-ae1-v", "vb"],
  "calypso": ["k-ah l-ih1-p s-ow", "nn jj"],
  "camaraderie": ["k-aa m-er aa1 d-er iy", "nn"],
  "camcorder": ["k-ae1-m k-ao-r d-er", "nn"],
  "came": ["k-ey1-m", "vbd"],
  "camel": ["k-ae1 m-ah-l", "nn"],
  "cameo": ["k-ae1 m-iy ow", "nn jj"],
  "camera": ["k-ae1 m-er ah", "nn"],
  "cameraman": ["k-ae1 m-er ah m-ah-n", "nn"],
  "camouflage": ["k-ae1 m-ah f-l-aa-zh", "nn vb"],
  "camouflaged": ["k-ae1 m-ah f-l-aa-zh-d", "vbn jj"],
  "camp": ["k-ae1-m-p", "nn vb"],
  "campaign": ["k-ae-m p-ey1-n", "nn vb"],
  "campaigner": ["k-ae-m p-ey1 n-er", "nn"],
  "camper": ["k-ae1-m p-er", "nn"],
  "campfire": ["k-ae1-m-p f-ay er", "nn"],
  "campground": ["k-ae1-m-p g-r-aw-n-d", "nn"],
  "campsite": ["k-ae1-m-p s-ay-t", "nn"],
  "campus": ["k-ae1-m p-ah-s", "nn"],
  "can": ["k-ae1-n", "md nn vb"],
  "canal": ["k-ah n-ae1-l", "nn"],
  "canard": ["k-ah n-aa1-r-d", "nn"],
  "cancel": ["k-ae1-n s-ah-l", "vb nn"],
  "canceled": ["k-ae1-n s-ah-l-d", "vbn vbd jj"],
  "cancellation": ["k-ae-n s-ah l-ey1 sh-ah-n", "nn"],
  "cancelled": ["k-ae1-n s-ah-l-d", "vbn"],
  "cancer": ["k-ae1-n s-er", "nn"],
  "cancerous": ["k-ae1-n s-er ah-s", "jj"],
  "candid": ["k-ae1-n d-ah-d", "jj"],
  "candidacy": ["k-ae1-n d-ih d-ah s-iy", "nn"],
  "candidate": ["k-ae1-n d-ah d-ey-t", "nn"],
  "candidly": ["k-ae1-n d-ih-d l-iy", "rb"],
  "candle": ["k-ae1-n d-ah-l", "nn"],
  "candlelight": ["k-ae1-n d-ah-l l-ay-t", "nn"],
  "candor": ["k-ae1-n d-er", "nn"],
  "candy": ["k-ae1-n d-iy", "nn"],
  "cane": ["k-ey1-n", "nn"],
  "canine": ["k-ey1 n-ay-n", "jj nn"],
  "caning": ["k-ey1 n-ih-ng", "nn"],
  "canister": ["k-ae1 n-ah s-t-er", "nn"],
  "canker": ["k-ae1-ng k-er", "nn"],
  "canned": ["k-ae1-n-d", "jj vbn"],
  "cannery": ["k-ae1 n-er iy", "nn"],
  "cannibalism": ["k-ae1 n-ah b-ah l-ih z-ah-m", "nn"],
  "cannibalize": ["k-ae1 n-ah b-ah l-ay-z", "vb"],
  "cannister": ["k-ae1 n-ih s-t-er", "nn"],
  "cannon": ["k-ae1 n-ah-n", "nn"],
  "cannot": ["k-ae1 n-aa-t", "md"],
  "canny": ["k-ae1 n-iy", "jj"],
  "canoe": ["k-ah n-uw1", "nn vb"],
  "canon": ["k-ae1 n-ah-n", "nn"],
  "canopy": ["k-ae1 n-ah p-iy", "nn"],
  "cantaloupe": ["k-ae1-n t-ah l-ow-p", "nn"],
  "canteen": ["k-ae-n t-iy1-n", "nn"],
  "canter": ["k-ae1-n t-er", "nn vb"],
  "canvas": ["k-ae1-n v-ah-s", "nn"],
  "canvassed": ["k-ae1-n v-ah-s-t", "vbn"],
  "canvasser": ["k-ae1-n v-ah s-er", "nn"],
  "canyon": ["k-ae1 n-y-ah-n", "nn"],
  "can't": ["k-ae1-n-t", "md"],
  "cap": ["k-ae1-p", "nn vbp vb"],
  "capability": ["k-ey p-ah b-ih1 l-ah t-iy", "nn"],
  "capable": ["k-ey1 p-ah b-ah-l", "jj"],
  "capacious": ["k-ah p-ey1 sh-ah-s", "jj"],
  "capacitance": ["k-ah p-ae1 s-ah t-ah-n-s", "nn"],
  "capacitor": ["k-ah p-ae1 s-ah t-er", "nn"],
  "capacity": ["k-ah p-ae1 s-ah t-iy", "nn"],
  "cape": ["k-ey1-p", "nn"],
  "caper": ["k-ey1 p-er", "nn"],
  "capillary": ["k-ae1 p-ah l-eh r-iy", "nn"],
  "capital": ["k-ae1 p-ah t-ah-l", "nn jj"],
  "capitalism": ["k-ae1 p-ih t-ah l-ih z-ah-m", "nn"],
  "capitalist": ["k-ae1 p-ah t-ah l-ah-s-t", "jj nn"],
  "capitalistic": ["k-ae p-ih t-ah l-ih1 s-t-ih-k", "jj"],
  "capitalization": ["k-ae p-ih t-ah l-ih z-ey1 sh-ah-n", "nn"],
  "capitalize": ["k-ae1 p-ah t-ah l-ay-z", "vb"],
  "capitalized": ["k-ae1 p-ih t-ah l-ay-z-d", "vbn jj vbd"],
  "capitulate": ["k-ah p-ih1 ch-uw l-ey-t", "vb"],
  "capitulation": ["k-ah p-ih ch-ah l-ey1 sh-ah-n", "nn"],
  "capo": ["k-aa1 p-ow", "nn"],
  "cappuccino": ["k-ae p-uw ch-iy1 n-ow", "nn"],
  "capricious": ["k-ah p-r-ih1 sh-ah-s", "jj"],
  "capriciously": ["k-ah p-r-ih1 sh-ih-s l-iy", "rb"],
  "capstan": ["k-ae1-p s-t-ah-n", "nn"],
  "capsule": ["k-ae1-p s-ah-l", "nn"],
  "captain": ["k-ae1-p t-ah-n", "nn vb vbp"],
  "caption": ["k-ae1-p sh-ah-n", "nn"],
  "captivate": ["k-ae1-p-t-ih-v-ey-t", "vb"],
  "captivated": ["k-ae1-p t-ih v-ey t-ih-d", "vbn vbd jj"],
  "captivating": ["k-ae1-p t-ih v-ey t-ih-ng", "jj vbg"],
  "captive": ["k-ae1-p t-ih-v", "jj nn"],
  "captivity": ["k-ae-p t-ih1 v-ah t-iy", "nn"],
  "captor": ["k-ae1-p t-er", "nn"],
  "capture": ["k-ae1-p ch-er", "vb vbp nn"],
  "captured": ["k-ae1-p ch-er-d", "vbn jj vbd"],
  "car": ["k-aa1-r", "nn"],
  "caramel": ["k-eh1 r-ah m-ah-l", "nn"],
  "carat": ["k-eh1 r-ah-t", "nn"],
  "caravan": ["k-ae1 r-ah v-ae-n", "nn"],
  "caraway": ["k-ae1 r-ah w-ey", "jj"],
  "carbide": ["k-aa1-r b-ay-d", "nn"],
  "carbine": ["k-aa1-r b-ay-n", "nn"],
  "carbohydrate": ["k-aa-r b-ow hh-ay1 d-r-ey-t", "nn"],
  "carbon": ["k-aa1-r b-ah-n", "nn"],
  "carbonate": ["k-aa1-r b-ah n-ey-t", "nn"],
  "carcass": ["k-aa1-r k-ah-s", "nn"],
  "carcinogen": ["k-aa-r s-ih1 n-ah jh-ah-n", "nn"],
  "carcinogenic": ["k-aa-r s-ah n-ow jh-eh1 n-ih-k", "jj"],
  "carcinoma": ["k-aa-r s-ah n-ow1 m-ah", "nn"],
  "card": ["k-aa1-r-d", "nn"],
  "cardboard": ["k-aa1-r-d b-ao-r-d", "nn jj"],
  "cardholder": ["k-aa1-r-d hh-ow-l d-er", "nn"],
  "cardiac": ["k-aa1-r d-iy ae-k", "jj"],
  "cardigan": ["k-aa1-r d-ih g-ah-n", "nn"],
  "cardinal": ["k-aa1-r d-ah n-ah-l", "jj nn"],
  "cardiologist": ["k-aa-r d-iy aa1 l-ah jh-ih-s-t", "nn"],
  "cardiovascular": ["k-aa-r d-iy ow v-ae1 s-k-y-ah l-er", "jj"],
  "care": ["k-eh1-r", "nn vb vbp"],
  "careen": ["k-er iy1-n", "vb"],
  "career": ["k-er ih1-r", "nn"],
  "careerist": ["k-er ih1 r-ih-s-t", "nn"],
  "carefree": ["k-eh1-r f-r-iy", "jj"],
  "careful": ["k-eh1-r f-ah-l", "jj"],
  "carefully": ["k-eh1-r f-ah l-iy", "rb"],
  "caregiver": ["k-eh1-r g-ih v-er", "nn"],
  "careless": ["k-eh1-r l-ah-s", "jj"],
  "carelessly": ["k-eh1-r l-ah-s l-iy", "rb"],
  "carelessness": ["k-eh1-r l-ah-s n-ah-s", "nn"],
  "caress": ["k-er eh1-s", "vb"],
  "caretaker": ["k-eh1-r t-ey k-er", "nn"],
  "cargo": ["k-aa1-r g-ow", "nn"],
  "caribou": ["k-eh1 r-ih b-uw", "nn"],
  "caricature": ["k-eh1 r-ah k-ah ch-er", "nn vb"],
  "caricaturist": ["k-eh1 r-ah k-ah ch-er ah-s-t", "nn"],
  "caring": ["k-eh1 r-ih-ng", "vbg jj nn"],
  "carload": ["k-aa1-r l-ow-d", "nn"],
  "carnage": ["k-aa1-r n-ih-jh", "nn"],
  "carnal": ["k-aa1-r n-ah-l", "jj"],
  "carnival": ["k-aa1-r n-ah v-ah-l", "nn"],
  "carnivore": ["k-aa1-r n-ah v-ao-r", "nn"],
  "carnivorous": ["k-aa-r n-ih1 v-er ah-s", "jj"],
  "carob": ["k-eh1 r-ah-b", "nn"],
  "carousel": ["k-eh1 r-ah s-eh-l", "nn"],
  "carousing": ["k-er aw1 z-ih-ng", "nn"],
  "carp": ["k-aa1-r-p", "vbp vb nn"],
  "carpenter": ["k-aa1-r p-ah-n t-er", "nn"],
  "carpentry": ["k-aa1-r p-ah-n t-r-iy", "nn"],
  "carpet": ["k-aa1-r p-ah-t", "nn vb"],
  "carpetbagger": ["k-aa1-r p-ah-t b-ae g-er", "nn"],
  "carpeting": ["k-aa1-r p-ah t-ih-ng", "nn"],
  "carping": ["k-aa1-r p-ih-ng", "vbg jj"],
  "carport": ["k-aa1-r p-ao-r-t", "nn"],
  "carriage": ["k-ae1 r-ih-jh", "nn"],
  "carried": ["k-ae1 r-iy-d", "vbd vbn"],
  "carrier": ["k-ae1 r-iy er", "nn"],
  "carrion": ["k-eh1 r-iy ah-n", "jj nn"],
  "carrot": ["k-ae1 r-ah-t", "nn"],
  "carry": ["k-ae1 r-iy", "vb nn vbp"],
  "carrying": ["k-ae1 r-iy ih-ng", "vbg jj nn"],
  "carryover": ["k-eh1 r-y-ow v-er", "nn"],
  "cart": ["k-aa1-r-t", "nn vbp vb"],
  "cartel": ["k-aa-r t-eh1-l", "nn"],
  "cartilage": ["k-aa1-r t-ah l-ah-jh", "nn"],
  "carton": ["k-aa1-r t-ah-n", "nn"],
  "cartoon": ["k-aa-r t-uw1-n", "nn"],
  "cartoonist": ["k-aa-r t-uw1 n-ah-s-t", "nn"],
  "cartridge": ["k-aa1-r t-r-ah-jh", "nn"],
  "cartwheel": ["k-aa1-r-t w-iy-l", "nn"],
  "carve": ["k-aa1-r-v", "vb vbp"],
  "carved": ["k-aa1-r-v-d", "vbn jj vbd"],
  "cascade": ["k-ae s-k-ey1-d", "nn vb"],
  "cascading": ["k-ae s-k-ey1 d-ih-ng", "vbg jj"],
  "case": ["k-ey1-s", "nn vb"],
  "caseload": ["k-ey1-s l-ow-d", "nn"],
  "caseworker": ["k-ey1-s w-er k-er", "nn"],
  "cash": ["k-ae1-sh", "nn vb"],
  "cashew": ["k-ae1 sh-uw", "nn"],
  "cashflow": ["k-ae1-sh f-l-ow", "nn"],
  "cashier": ["k-ae sh-ih1-r", "nn"],
  "cashmere": ["k-ae1-zh m-ih-r", "nn"],
  "casing": ["k-ey1 s-ih-ng", "nn"],
  "casino": ["k-ah s-iy1 n-ow", "nn"],
  "cask": ["k-ae1-s-k", "nn"],
  "casket": ["k-ae1 s-k-ah-t", "nn"],
  "cassette": ["k-ah s-eh1-t", "nn"],
  "cast": ["k-ae1-s-t", "nn vb vbd vbn vbp"],
  "caste": ["k-ae1-s-t", "nn"],
  "caster": ["k-ae1 s-t-er", "nn"],
  "castigate": ["k-ae1 s-t-ah g-ey-t", "vb"],
  "castle": ["k-ae1 s-ah-l", "nn"],
  "castor": ["k-ae1 s-t-er", "nn"],
  "casual": ["k-ae1 zh-ah w-ah-l", "jj rb"],
  "casually": ["k-ae1 zh-ah-w ah l-iy", "rb"],
  "casualty": ["k-ae1 zh-ah w-ah-l t-iy", "nn"],
  "cat": ["k-ae1-t", "nn"],
  "cataclysmic": ["k-ae t-ah k-l-ih1-z m-ih-k", "jj"],
  "catalog": ["k-ae1 t-ah l-ao-g", "nn vb"],
  "catalogue": ["k-ae1 t-ah l-ao-g", "nn vb"],
  "catalyst": ["k-ae1 t-ah l-ah-s-t", "nn"],
  "catalytic": ["k-ae t-ah l-ih1 t-ih-k", "jj"],
  "catalyze": ["k-ae1-t-ah-l-ay-z", "vb"],
  "catamaran": ["k-ae t-ah m-er ae1-n", "nn"],
  "catapult": ["k-ae1 t-ah p-ah-l-t", "vb vbp"],
  "cataract": ["k-ae1 t-er ae-k-t-s", "nn"],
  "catastrophe": ["k-ah t-ae1-s t-r-ah f-iy", "nn"],
  "catastrophic": ["k-ae t-ah s-t-r-aa1 f-ih-k", "jj"],
  "catbird": ["k-ae1-t b-er-d", "jj"],
  "catcall": ["k-ae1-t k-ao-l", "nn"],
  "catch": ["k-ae1-ch", "vb vbp nn"],
  "catchall": ["k-ae1 ch-ao-l", "nn"],
  "catcher": ["k-ae1 ch-er", "nn"],
  "catchup": ["k-ae1 ch-ah-p", "jj nn"],
  "catchword": ["k-ae1-ch w-er-d", "nn"],
  "catchy": ["k-ae1 ch-iy", "jj"],
  "catechism": ["k-ae1 t-ah k-ih z-ah-m", "nn"],
  "categorical": ["k-ae t-ah g-aa1 r-ih k-ah-l", "jj"],
  "categorically": ["k-ae t-ah g-aa1 r-ih-k l-iy", "rb"],
  "categorize": ["k-ae1 t-ah g-er ay-z", "vb"],
  "category": ["k-ae1 t-ah g-ao r-iy", "nn"],
  "cater": ["k-ey1 t-er", "vbp vb"],
  "catered": ["k-ey1 t-er-d", "vbd jj"],
  "caterer": ["k-ey1 t-er er", "nn"],
  "caterpillar": ["k-ae1 t-ah p-ih l-er", "nn"],
  "catfish": ["k-ae1-t f-ih-sh", "nn"],
  "catharsis": ["k-ah th-aa1-r s-ah-s", "nn"],
  "cathartic": ["k-ah th-aa1-r t-ih-k", "jj"],
  "cathedral": ["k-ah th-iy1 d-r-ah-l", "nn"],
  "catheter": ["k-ae1 th-ah t-er", "nn"],
  "cathode": ["k-ae1 th-ow-d", "nn"],
  "catlike": ["k-ae1-t l-ay-k", "jj"],
  "catsup": ["k-eh1 ch-ah-p", "nn"],
  "cattle": ["k-ae1 t-ah-l", "nn"],
  "catty": ["k-ae1 t-iy", "jj"],
  "caucus": ["k-ao1 k-ah-s", "nn vb"],
  "caught": ["k-aa1-t", "vbn vbd"],
  "cauliflower": ["k-aa1 l-ah f-l-aw er", "nn"],
  "causal": ["k-ao1 z-ah-l", "jj"],
  "causative": ["k-aa1 z-ah t-ih-v", "jj"],
  "cause": ["k-aa1-z", "nn vb vbg vbp"],
  "causeway": ["k-aa1-z w-ey", "nn"],
  "caustic": ["k-aa1 s-t-ih-k", "jj"],
  "caution": ["k-aa1 sh-ah-n", "nn vbp vb"],
  "cautionary": ["k-ao1 sh-ah-n eh r-iy", "jj"],
  "cautious": ["k-ao1 sh-ah-s", "jj"],
  "cautiously": ["k-ao1 sh-ah-s l-iy", "rb"],
  "cautiousness": ["k-ao1 sh-ah-s n-ah-s", "nn"],
  "cavalier": ["k-ae v-ah l-ih1-r", "jj"],
  "cavalry": ["k-ae1 v-ah-l r-iy", "nn"],
  "cave": ["k-ey1-v", "nn vb"],
  "caveat": ["k-ey1 v-iy ae-t", "nn"],
  "cavern": ["k-ae1 v-er-n", "nn"],
  "cavernous": ["k-ae1 v-er n-ah-s", "jj"],
  "caviar": ["k-ae1 v-iy aa-r", "nn"],
  "cavity": ["k-ae1 v-ah t-iy", "nn"],
  "cavort": ["k-ah v-ao1-r-t", "vbp vb"],
  "cayenne": ["k-ay eh1-n", "nn"],
  "cease": ["s-iy1-s", "vb vbp"],
  "ceasefire": ["s-iy1-s f-ay1 er", "nn"],
  "ceaseless": ["s-iy1-s l-ih-s", "jj"],
  "ceaselessly": ["s-iy1-z l-ah-s l-iy", "rb"],
  "cedar": ["s-iy1 d-er", "nn"],
  "cede": ["s-iy1-d", "vb"],
  "ceiling": ["s-iy1 l-ih-ng", "nn"],
  "celebrant": ["s-eh1 l-ah b-r-ah-n-t", "nn"],
  "celebrate": ["s-eh1 l-ah b-r-ey-t", "vb vbp"],
  "celebrated": ["s-eh1 l-ah b-r-ey t-ah-d", "vbd jj vbn"],
  "celebration": ["s-eh l-ah b-r-ey1 sh-ah-n", "nn"],
  "celebrity": ["s-ah l-eh1 b-r-ih t-iy", "nn"],
  "celery": ["s-eh1 l-er iy", "nn"],
  "celestial": ["s-ah l-eh1 s-ch-ah-l", "jj"],
  "cell": ["s-eh1-l", "nn"],
  "cellar": ["s-eh1 l-er", "nn"],
  "cellist": ["ch-eh1 l-ah-s-t", "nn"],
  "cellophane": ["s-eh1 l-ah f-ey-n", "nn"],
  "cellular": ["s-eh1-l y-ah l-er", "jj"],
  "cellulose": ["s-eh1-l y-ah l-ow-s", "nn"],
  "cement": ["s-ah m-eh1-n-t", "nn vb"],
  "cemetery": ["s-eh1 m-ah t-eh r-iy", "nn"],
  "censor": ["s-eh1-n s-er", "vbp vb"],
  "censorship": ["s-eh1-n s-er sh-ih-p", "nn"],
  "censure": ["s-eh1-n sh-er", "nn vb"],
  "census": ["s-eh1-n s-ah-s", "nn"],
  "cent": ["s-eh1-n-t", "nn"],
  "centaur": ["s-eh1-n t-ao-r", "nn"],
  "centenarian": ["s-eh-n t-ah n-eh1 r-iy ah-n", "nn"],
  "centenary": ["s-eh1-n t-ah n-eh r-iy", "jj"],
  "centennial": ["s-eh-n t-eh1 n-iy ah-l", "nn jj"],
  "center": ["s-eh1-n t-er", "nn jj rb vb vbp"],
  "centerfielder": ["s-eh1-n t-er f-iy-l d-er", "nn"],
  "centerfold": ["s-eh1-n t-er f-ow-l-d", "nn"],
  "centerpiece": ["s-eh1-n t-er p-iy-s", "nn"],
  "centigrade": ["s-eh1-n t-ah g-r-ey-d", "jj"],
  "centimeter": ["s-eh1-n t-ah m-iy t-er", "nn"],
  "central": ["s-eh1-n t-r-ah-l", "jj nn"],
  "centralization": ["s-eh-n t-r-ah l-ih z-ey1 sh-ah-n", "nn"],
  "centralize": ["s-eh1-n t-r-ah l-ay-z", "vb"],
  "centralized": ["s-eh1-n t-r-ah l-ay-z-d", "jj vbd vbn"],
  "centralizing": ["s-eh1-n t-r-ah l-ay z-ih-ng", "vbg jj"],
  "centrally": ["s-eh1-n t-r-ah l-iy", "rb"],
  "centre": ["s-eh1-n t-er", "nn"],
  "centrex": ["s-eh1-n t-r-ah-k-s", "nn"],
  "centrifugal": ["s-eh-n t-r-ih1 f-y-ih g-ah-l", "jj"],
  "centrifuge": ["s-eh1-n t-r-ah f-y-uw-jh", "nn"],
  "centrist": ["s-eh1-n t-r-ih-s-t", "jj"],
  "centum": ["k-eh1-n t-ah-m", "nn"],
  "century": ["s-eh1-n ch-er iy", "nn"],
  "ceramic": ["s-er ae1 m-ih-k", "jj"],
  "cereal": ["s-ih1 r-iy ah-l", "nn"],
  "cerebral": ["s-eh1 r-ah b-r-ah-l", "jj"],
  "ceremonial": ["s-eh r-ah m-ow1 n-iy ah-l", "jj"],
  "ceremony": ["s-eh1 r-ah m-ow n-iy", "nn"],
  "certain": ["s-er1 t-ah-n", "jj rb"],
  "certainly": ["s-er1 t-ah-n l-iy", "rb"],
  "certainty": ["s-er1 t-ah-n t-iy", "nn"],
  "certificate": ["s-er t-ih1 f-ih k-ah-t", "nn"],
  "certification": ["s-er t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "certified": ["s-er1 t-ah f-ay-d", "vbn jj"],
  "certify": ["s-er1 t-ah f-ay", "vb"],
  "cervical": ["s-er1 v-ah k-ah-l", "jj"],
  "cervix": ["s-er1 v-ih-k-s", "nn"],
  "cessation": ["s-eh s-ey1 sh-ah-n", "nn"],
  "chafe": ["ch-ey1-f", "vbp vb"],
  "chaff": ["ch-ae1-f", "nn"],
  "chafing": ["ch-ey1 f-ih-ng", "vbg jj"],
  "chagrin": ["sh-ah g-r-ih1-n", "nn"],
  "chain": ["ch-ey1-n", "nn vb vbp"],
  "chained": ["ch-ey1-n-d", "vbd vbn jj"],
  "chair": ["ch-eh1-r", "nn vb"],
  "chaired": ["ch-eh1-r-d", "vbn jj vbd"],
  "chairing": ["ch-eh1 r-ih-ng", "nn"],
  "chairman": ["ch-eh1-r m-ah-n", "nn"],
  "chairmanship": ["ch-eh1-r m-ah-n sh-ih-p", "nn"],
  "chairwoman": ["ch-eh1-r w-uh m-ah-n", "nn"],
  "chaise": ["sh-ey1-z", "nn"],
  "chalk": ["ch-aa1-k", "nn vbp vb"],
  "challenge": ["ch-ae1 l-ah-n-jh", "nn vb vbp"],
  "challenger": ["ch-ae1 l-ah-n jh-er", "nn"],
  "challenging": ["ch-ae1 l-ah-n jh-ih-ng", "vbg jj"],
  "chamber": ["ch-ey1-m b-er", "nn vb"],
  "chameleon": ["ch-ah m-eh1 l-iy ah-n", "nn"],
  "champ": ["ch-ae1-m-p", "nn"],
  "champagne": ["sh-ae-m p-ey1-n", "nn"],
  "champion": ["ch-ae1-m p-iy ah-n", "nn jj vb vbp"],
  "championship": ["ch-ae1-m p-iy ah-n sh-ih-p", "nn"],
  "chance": ["ch-ae1-n-s", "nn jj vb vbp"],
  "chancellor": ["ch-ae1-n s-ah l-er", "nn"],
  "chancery": ["ch-ae1-n s-er iy", "nn"],
  "chancy": ["ch-ae1-n s-iy", "jj"],
  "chandelier": ["sh-ae-n d-ah l-ih1-r", "nn"],
  "change": ["ch-ey1-n-jh", "nn vbp vb"],
  "changeable": ["ch-ey1-n jh-ah b-ah-l", "jj"],
  "changed": ["ch-ey1-n-jh-d", "vbn vbd jj"],
  "changeover": ["ch-ey1-n-jh ow v-er", "nn"],
  "changing": ["ch-ey1-n jh-ih-ng", "vbg jj nn"],
  "channel": ["ch-ae1 n-ah-l", "nn vb vbp"],
  "chant": ["ch-ae1-n-t", "nn vb"],
  "chaos": ["k-ey1 aa-s", "nn"],
  "chaotic": ["k-ey aa1 t-ih-k", "jj"],
  "chap": ["ch-ae1-p", "nn"],
  "chapel": ["ch-ae1 p-ah-l", "nn"],
  "chaperone": ["sh-ae1 p-er ow-n", "nn"],
  "chaplain": ["ch-ae1-p l-ah-n", "nn"],
  "chapter": ["ch-ae1-p t-er", "nn"],
  "char": ["ch-aa1-r", "vb"],
  "character": ["k-eh1 r-ih-k t-er", "nn"],
  "characteristic": ["k-eh r-ah-k t-er ih1 s-t-ih-k", "jj nn"],
  "characteristically": ["k-eh r-ah-k t-er ih1 s-t-ih-k l-iy", "rb"],
  "characterization": ["k-eh r-ah-k t-er ih z-ey1 sh-ah-n", "nn"],
  "characterize": ["k-eh1 r-ah-k t-er ay-z", "vb vbp"],
  "characterized": ["k-eh1 r-ah-k t-er ay-z-d", "vbn vbd jj"],
  "charcoal": ["ch-aa1-r k-ow-l", "nn"],
  "charge": ["ch-aa1-r-jh", "nn vbp vb"],
  "chargeable": ["ch-aa1-r jh-ah b-ah-l", "jj"],
  "charged": ["ch-aa1-r-jh-d", "vbn vbd jj"],
  "chariot": ["ch-eh1 r-iy ah-t", "nn"],
  "charisma": ["k-er ih1-z m-ah", "nn"],
  "charismatic": ["k-eh r-ih-z m-ae1 t-ih-k", "jj"],
  "charitable": ["ch-ae1 r-ah t-ah b-ah-l", "jj"],
  "charitably": ["ch-eh1 r-ih t-ah b-l-iy", "rb"],
  "charity": ["ch-eh1 r-ih t-iy", "nn"],
  "charlatan": ["sh-aa1-r l-ah t-ah-n", "nn"],
  "charlotte": ["sh-aa1-r l-ah-t", "nn"],
  "charm": ["ch-aa1-r-m", "nn vb"],
  "charmer": ["ch-aa1-r m-er", "nn"],
  "charming": ["ch-aa1-r m-ih-ng", "jj"],
  "charmingly": ["ch-aa1-r m-ih-ng l-iy", "rb"],
  "charred": ["ch-aa1-r-d", "jj vbn"],
  "chart": ["ch-aa1-r-t", "nn vb vbp"],
  "charter": ["ch-aa1-r t-er", "nn jj vb"],
  "chartered": ["ch-aa1-r t-er-d", "jj vbn vbd"],
  "chartist": ["ch-aa1-r t-ih-s-t", "nn"],
  "chary": ["ch-aa1 r-iy", "jj"],
  "chase": ["ch-ey1-s", "nn jj vb vbp"],
  "chaser": ["ch-ey1 s-er", "nn"],
  "chasm": ["k-ae1 z-ah-m", "nn"],
  "chassis": ["ch-ae1 s-iy", "nn"],
  "chaste": ["ch-ey1-s-t", "jj"],
  "chasten": ["ch-ey1-s-ah-n", "vb"],
  "chastise": ["ch-ae-s-t-ay1-z", "vb"],
  "chastity": ["ch-ae1 s-t-ah t-iy", "nn"],
  "chat": ["ch-ae1-t", "nn vbp vb"],
  "chateau": ["sh-ae t-ow1", "nn"],
  "chateaux": ["sh-ah t-ow1", "nn"],
  "chatter": ["ch-ae1 t-er", "nn vb vbp"],
  "chatty": ["ch-ae1 t-iy", "jj"],
  "chauffeur": ["sh-ow f-er1", "nn vb"],
  "chauvinism": ["sh-ow1 v-ah n-ih z-ah-m", "nn"],
  "chauvinistic": ["ch-ow v-ah n-ih1 s-t-ih-k", "jj"],
  "chaw": ["ch-ao1", "nn"],
  "cheap": ["ch-iy1-p", "jj nn rb"],
  "cheapen": ["ch-iy1-p-ah-n", "vb"],
  "cheaper": ["ch-iy1 p-er", "jjr rbr"],
  "cheapest": ["ch-iy1 p-ah-s-t", "jjs"],
  "cheaply": ["ch-iy1-p l-iy", "rb"],
  "cheat": ["ch-iy1-t", "vb vbp"],
  "cheated": ["ch-iy1 t-ah-d", "vbn jj vbd"],
  "cheater": ["ch-iy1 t-er", "nn"],
  "check": ["ch-eh1-k", "nn vbp vb"],
  "checkbook": ["ch-eh1-k b-uh-k", "nn"],
  "checked": ["ch-eh1-k-t", "vbn vbd jj"],
  "checker": ["ch-eh1 k-er", "nn"],
  "checklist": ["ch-eh1-k l-ih-s-t", "nn"],
  "checkout": ["ch-eh1-k aw-t", "nn"],
  "checkpoint": ["ch-eh1-k p-oy-n-t", "nn"],
  "checkup": ["ch-eh1-k ah-p", "nn"],
  "cheek": ["ch-iy1-k", "nn"],
  "cheekbone": ["ch-iy1-k b-ow-n", "nn"],
  "cheeky": ["ch-iy1 k-iy", "jj"],
  "cheer": ["ch-ih1-r", "nn vb vbp"],
  "cheerful": ["ch-ih1-r f-ah-l", "jj"],
  "cheerfully": ["ch-ih1-r f-ah l-iy", "rb"],
  "cheerleader": ["ch-ih1-r l-iy d-er", "nn"],
  "cheerleading": ["ch-ih1-r l-iy d-ih-ng", "nn"],
  "cheery": ["ch-ih1 r-iy", "jj"],
  "cheese": ["ch-iy1-z", "nn"],
  "cheeseburger": ["ch-iy1-z b-er g-er", "nn"],
  "cheesecake": ["ch-iy1-z k-ey-k", "nn"],
  "cheesy": ["ch-iy1 z-iy", "jj"],
  "cheetah": ["ch-iy1 t-ah", "nn"],
  "cheetal": ["ch-iy1 t-ah-l", "jj"],
  "chef": ["sh-eh1-f", "nn"],
  "chemical": ["k-eh1 m-ah k-ah-l", "nn jj"],
  "chemically": ["k-eh1 m-ah k-l-iy", "rb"],
  "chemise": ["sh-ah m-iy1-z", "nn"],
  "chemist": ["k-eh1 m-ih-s-t", "nn"],
  "chemistry": ["k-eh1 m-ah s-t-r-iy", "nn"],
  "chemotherapy": ["k-iy m-ow th-eh1 r-ah p-iy", "nn"],
  "cherish": ["ch-eh1 r-ih-sh", "vb vbp"],
  "cherished": ["ch-eh1 r-ih-sh-t", "vbn jj vbd"],
  "cherry": ["ch-eh1 r-iy", "jj nn"],
  "cherub": ["ch-eh1 r-ah-b", "nn"],
  "chess": ["ch-eh1-s", "nn"],
  "chest": ["ch-eh1-s-t", "nn"],
  "chestnut": ["ch-eh1-s n-ah-t", "nn"],
  "chevrolet": ["sh-eh-v r-ow l-ey1", "nnp"],
  "chew": ["ch-uw1", "vb vbp"],
  "chewing": ["ch-uw1 ih-ng", "vbg jj"],
  "chic": ["sh-iy1-k", "jj nn"],
  "chicanery": ["sh-ih k-ey1 n-er iy", "nn"],
  "chick": ["ch-ih1-k", "nn"],
  "chicken": ["ch-ih1 k-ah-n", "nn"],
  "chide": ["ch-ay1-d", "vb vbp"],
  "chief": ["ch-iy1-f", "jj nn"],
  "chiefdom": ["ch-iy1-f d-ah-m", "nn"],
  "chiefly": ["ch-iy1-f l-iy", "rb"],
  "chieftain": ["ch-iy1-f t-ah-n", "nn"],
  "child": ["ch-ay1-l-d", "nn"],
  "childbirth": ["ch-ay1-l-d b-er-th", "nn"],
  "childcare": ["ch-ay1-l-d k-eh-r", "nn"],
  "childhood": ["ch-ay1-l-d hh-uh-d", "nn"],
  "childish": ["ch-ay1-l d-ih-sh", "jj"],
  "childless": ["ch-ay1-l-d l-ah-s", "jj"],
  "childlike": ["ch-ay1-l-d l-ay-k", "jj"],
  "chili": ["ch-ih1 l-iy", "nn"],
  "chill": ["ch-ih1-l", "nn jj vb"],
  "chilled": ["ch-ih1-l-d", "vbn jj vbd"],
  "chillier": ["ch-ih1 l-iy er", "nn"],
  "chilling": ["ch-ih1 l-ih-ng", "vbg jj"],
  "chillingly": ["ch-ih1 l-ih-ng l-iy", "rb"],
  "chilly": ["ch-ih1 l-iy", "jj"],
  "chime": ["ch-ay1-m", "vb"],
  "chimney": ["ch-ih1-m n-iy", "nn"],
  "chimp": ["ch-ih1-m-p", "nn"],
  "chimpanzee": ["ch-ih-m p-ae1-n z-iy", "nn"],
  "chin": ["ch-ih1-n", "nn vb"],
  "china": ["ch-ay1 n-ah", "nn"],
  "chip": ["ch-ih1-p", "nn"],
  "chipped": ["ch-ih1-p-t", "vbn vbd jj"],
  "chipper": ["ch-ih1 p-er", "jj"],
  "chiropractor": ["k-ay1 r-ah p-r-ae-k t-er", "nn"],
  "chirp": ["ch-er1-p", "vb"],
  "chirpy": ["ch-er1 p-iy", "jj"],
  "chisel": ["ch-ih1 z-ah-l", "nn vb"],
  "chiseled": ["ch-ih1 z-ah-l-d", "vbn jj"],
  "chit": ["ch-ih1-t", "nn"],
  "chitchat": ["ch-ih1-t ch-ae-t", "nn"],
  "chivalry": ["sh-ih1 v-ah-l r-iy", "nn"],
  "chive": ["ch-ay1-v", "nn"],
  "chloride": ["k-l-ao1 r-ay-d", "nn"],
  "chlorine": ["k-l-ao1 r-iy-n", "nn"],
  "chocolate": ["ch-ao1-k l-ah-t", "nn jj"],
  "choice": ["ch-oy1-s", "nn jj"],
  "choicest": ["ch-oy1 s-ah-s-t", "jjs"],
  "choir": ["k-w-ay1 er", "nn"],
  "choke": ["ch-ow1-k", "vb vbp nn"],
  "choking": ["ch-ow1 k-ih-ng", "vbg jj nn"],
  "cholera": ["k-aa1 l-er ah", "nn"],
  "cholesterol": ["k-ah l-eh1-s t-er ao-l", "nn"],
  "cholla": ["ch-aa1 l-ah", "nn"],
  "chomp": ["ch-aa1-m-p", "nn vb vbp"],
  "choose": ["ch-uw1-z", "vb vbp"],
  "choosy": ["ch-uw1 z-iy", "jj"],
  "chop": ["ch-aa1-p", "vb nn"],
  "chopped": ["ch-aa1-p-t", "jj vbd vbn"],
  "chopper": ["ch-aa1 p-er", "nn"],
  "choppy": ["ch-aa1 p-iy", "jj"],
  "chopstick": ["ch-aa1-p s-t-ih-k", "nn"],
  "choral": ["k-ao1 r-ah-l", "jj"],
  "chord": ["k-ao1-r-d", "nn"],
  "chore": ["ch-ao1-r", "nn"],
  "choreograph": ["k-ao1-r-iy-ah-g-r-ae-f", "vb"],
  "choreographed": ["k-ao1 r-iy ah g-r-ae-f-t", "vbn jj"],
  "choreographer": ["k-ao r-iy aa1 g-r-ah f-er", "nn"],
  "choreography": ["k-ao r-iy aa1 g-r-ah f-iy", "nn"],
  "chortle": ["ch-ao1-r-t-ah-l", "vb"],
  "chorus": ["k-ao1 r-ah-s", "nn"],
  "chose": ["ch-ow1-z", "vbd"],
  "chosen": ["ch-ow1 z-ah-n", "vbn jj"],
  "chow": ["ch-aw1", "nn"],
  "chowder": ["ch-aw1 d-er", "nn"],
  "christen": ["k-r-ih1 s-ah-n", "vb"],
  "christening": ["k-r-ih1 s-ah-n ih-ng", "nn"],
  "chrome": ["k-r-ow1-m", "nn"],
  "chromium": ["k-r-ow1 m-iy ah-m", "nn"],
  "chromosome": ["k-r-ow1 m-ah s-ow-m", "nn"],
  "chronic": ["k-r-aa1 n-ih-k", "jj nn"],
  "chronically": ["k-r-aa1 n-ih k-ah l-iy", "rb"],
  "chronicle": ["k-r-aa1 n-ih k-ah-l", "nn vb"],
  "chronicler": ["k-r-aa1 n-ih k-l-er", "nn"],
  "chronological": ["k-r-aa n-ah l-aa1 jh-ih k-ah-l", "jj"],
  "chronologically": ["k-r-aa n-ah l-aa1 jh-ih-k l-iy", "rb"],
  "chronology": ["k-r-ah n-aa1 l-ah jh-iy", "nn"],
  "chrysanthemum": ["k-r-ih s-ae1-n th-ah m-ah-m", "nn"],
  "chubby": ["ch-ah1 b-iy", "jj"],
  "chuck": ["ch-ah1-k", "nn vb"],
  "chuckle": ["ch-ah1 k-ah-l", "nn vb vbp"],
  "chug": ["ch-ah1-g", "vb vbp"],
  "chum": ["ch-ah1-m", "nn"],
  "chump": ["ch-ah1-m-p", "nn"],
  "chunk": ["ch-ah1-ng-k", "nn"],
  "chunky": ["ch-ah1-ng k-iy", "jj"],
  "church": ["ch-er1-ch", "nn"],
  "churchgoer": ["ch-er1-ch g-ow er", "nn"],
  "churchyard": ["ch-er1-ch y-aa-r-d", "nn"],
  "churn": ["ch-er1-n", "vb vbp"],
  "chute": ["sh-uw1-t", "nn"],
  "chutney": ["ch-ah1-t n-iy", "nn"],
  "chutzpah": ["ch-ah1-t s-p-aa", "nn"],
  "cicada": ["s-ih k-ey1 d-ah", "nn"],
  "cider": ["s-ay1 d-er", "nn"],
  "cigar": ["s-ih g-aa1-r", "nn"],
  "cigarette": ["s-ih g-er eh1-t", "nn"],
  "ciliate": ["s-ih1 l-iy ah-t", "nn"],
  "cinch": ["s-ih1-n-ch", "nn vb"],
  "cinder": ["s-ih1-n d-er", "nn"],
  "cinema": ["s-ih1 n-ah m-ah", "nn"],
  "cinematic": ["s-ih n-ah m-ae1 t-ih-k", "jj"],
  "cinematographer": ["s-ih n-ih m-ah t-aa1 g-r-ah f-er", "nn"],
  "cinematography": ["s-ih n-ih m-ah t-aa1 g-r-ah f-iy", "nn"],
  "cipher": ["s-ay1 f-er", "vb"],
  "circle": ["s-er1 k-ah-l", "nn vb"],
  "circuit": ["s-er1 k-ah-t", "nn"],
  "circuitous": ["s-er k-y-uw1 ih t-ah-s", "jj"],
  "circuitry": ["s-er1 k-ah t-r-iy", "nn"],
  "circular": ["s-er1 k-y-ah l-er", "jj nn"],
  "circulate": ["s-er1 k-y-ah l-ey-t", "vb vbp"],
  "circulation": ["s-er1 k-y-ah l-ey sh-ah-n", "nn"],
  "circulatory": ["s-er1 k-y-ah l-ah t-ao r-iy", "jj"],
  "circumcision": ["s-er k-ah-m s-ih1 zh-ah-n", "nn"],
  "circumference": ["s-er k-ah1-m f-r-ah-n-s", "nn"],
  "circumscribed": ["s-er k-ah-m s-k-r-ay1-b-d", "jj"],
  "circumspect": ["s-er1 k-ah-m s-p-eh-k-t", "jj"],
  "circumspection": ["s-er k-ah-m s-p-eh1-k sh-ah-n", "nn"],
  "circumstance": ["s-er1 k-ah-m s-t-ae-n-s", "nn"],
  "circumstantial": ["s-er k-ah-m s-t-ae1-n ch-ah-l", "jj"],
  "circumvent": ["s-er k-ah-m v-eh1-n-t", "vb"],
  "circumvention": ["s-er k-ah-m v-eh1-n ch-ah-n", "nn"],
  "circus": ["s-er1 k-ah-s", "nn"],
  "cirrhosis": ["s-er ow1 s-ah-s", "nn"],
  "citation": ["s-ay t-ey1 sh-ah-n", "nn"],
  "cite": ["s-ay1-t", "vbp vb"],
  "citizen": ["s-ih1 t-ah z-ah-n", "nn"],
  "citizenry": ["s-ih1 t-ih z-ah-n r-iy", "nn"],
  "citizenship": ["s-ih1 t-ih z-ah-n sh-ih-p", "nn"],
  "citric": ["s-ih1 t-r-ih-k", "jj"],
  "citron": ["s-ih1 t-r-ah-n", "jj"],
  "citrus": ["s-ih1 t-r-ah-s", "jj nn"],
  "city": ["s-ih1 t-iy", "nn"],
  "citywide": ["s-ih1 t-iy w-ay-d", "jj"],
  "civic": ["s-ih1 v-ih-k", "jj"],
  "civil": ["s-ih1 v-ah-l", "jj"],
  "civilian": ["s-ah v-ih1-l y-ah-n", "jj nn"],
  "civility": ["s-ah v-ih1 l-ah t-iy", "nn"],
  "civilization": ["s-ih v-ah l-ih z-ey1 sh-ah-n", "nn"],
  "civilize": ["s-ih1 v-ah l-ay-z", "vb"],
  "civilized": ["s-ih1 v-ah l-ay-z-d", "jj vbn"],
  "clad": ["k-l-ae1-d", "vbd vbn jj"],
  "claim": ["k-l-ey1-m", "nn vbp vb"],
  "claimant": ["k-l-ey1 m-ah-n-t", "nn"],
  "clairvoyance": ["k-l-eh-r v-oy1 ah-n-s", "nn"],
  "clam": ["k-l-ae1-m", "nn"],
  "clamber": ["k-l-ae1-m-b-er", "vb"],
  "clammy": ["k-l-ae1 m-iy", "jj"],
  "clamor": ["k-l-ae1 m-er", "vb vbp nn"],
  "clamp": ["k-l-ae1-m-p", "vb nn"],
  "clampdown": ["k-l-ae1-m-p d-aw-n", "nn"],
  "clamshell": ["k-l-ae1-m sh-eh-l", "nn"],
  "clan": ["k-l-ae1-n", "nn"],
  "clandestine": ["k-l-ae-n d-eh1 s-t-ih-n", "jj"],
  "clang": ["k-l-ae1-ng", "nn vb"],
  "clanging": ["k-l-ae1 ng-ih-ng", "nn vbg"],
  "clank": ["k-l-ae1-ng-k", "vb"],
  "clannish": ["k-l-ae1 n-ih-sh", "jj"],
  "clap": ["k-l-ae1-p", "nn"],
  "clapboard": ["k-l-ae1-p b-ao-r-d", "nn"],
  "clapped": ["k-l-ae1-p-t", "vbd"],
  "clarification": ["k-l-eh r-ah f-ah k-ey1 sh-ah-n", "nn"],
  "clarified": ["k-l-eh1 r-ah f-ay-d", "vbn jj vbd"],
  "clarify": ["k-l-eh1 r-ah f-ay", "vb vbp"],
  "clarinet": ["k-l-eh r-ah n-eh1-t", "nn"],
  "clarinetist": ["k-l-eh r-ah n-eh1 t-ih-s-t", "nn"],
  "clarity": ["k-l-eh1 r-ah t-iy", "nn"],
  "clash": ["k-l-ae1-sh", "nn vbp vb"],
  "clasp": ["k-l-ae1-s-p", "vb"],
  "class": ["k-l-ae1-s", "nn vb"],
  "classic": ["k-l-ae1 s-ih-k", "jj nn"],
  "classical": ["k-l-ae1 s-ih k-ah-l", "jj"],
  "classically": ["k-l-ae1 s-ih-k l-iy", "rb"],
  "classification": ["k-l-ae s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "classified": ["k-l-ae1 s-ah f-ay-d", "vbn vbd jj"],
  "classify": ["k-l-ae1 s-ah f-ay", "vb vbp"],
  "classless": ["k-l-ae1-s l-ah-s", "jj"],
  "classmate": ["k-l-ae1-s m-ey-t", "nn"],
  "classroom": ["k-l-ae1-s r-uw-m", "nn"],
  "classy": ["k-l-ae1 s-iy", "jj"],
  "clatter": ["k-l-ae1 t-er", "nn vb"],
  "clause": ["k-l-ao1-z", "nn"],
  "claustrophobia": ["k-l-ao s-t-r-ah f-ow1 b-iy ah", "nn"],
  "claustrophobic": ["k-l-ao s-t-r-ah f-ow1 b-ih-k", "jj"],
  "claw": ["k-l-ao1", "nn vb"],
  "clay": ["k-l-ey1", "nn"],
  "clean": ["k-l-iy1-n", "jj vbp rb vb"],
  "cleaner": ["k-l-iy1 n-er", "jjr nn"],
  "cleanest": ["k-l-iy1 n-ah-s-t", "jjs"],
  "cleaning": ["k-l-iy1 n-ih-ng", "nn vbg"],
  "cleanliness": ["k-l-eh1-n l-iy n-ih-s", "nn"],
  "cleanly": ["k-l-iy1-n l-iy", "rb"],
  "cleanse": ["k-l-eh1-n-z", "vb"],
  "cleanser": ["k-l-eh1-n z-er", "nn"],
  "cleansing": ["k-l-eh1-n z-ih-ng", "nn vbg"],
  "cleanup": ["k-l-iy1-n ah-p", "nn"],
  "clear": ["k-l-ih1-r", "jj rb vb vbp"],
  "clearance": ["k-l-ih1 r-ah-n-s", "nn"],
  "clearer": ["k-l-ih1 r-er", "jjr rbr"],
  "clearest": ["k-l-ih1 r-ih-s-t", "jjs"],
  "clearing": ["k-l-ih1 r-ih-ng", "vbg jj nn"],
  "clearinghouse": ["k-l-ih1 r-ih-ng hh-aw-s", "nn"],
  "clearly": ["k-l-ih1-r l-iy", "rb"],
  "cleat": ["k-l-iy1-t", "nn"],
  "cleavage": ["k-l-iy1 v-ah-jh", "nn"],
  "cleaver": ["k-l-iy1 v-er", "nn"],
  "clemency": ["k-l-eh1 m-ah-n s-iy", "nn"],
  "clench": ["k-l-eh1-n-ch", "vb"],
  "clenched": ["k-l-eh1-n-ch-t", "jj vbd vbn"],
  "clergy": ["k-l-er1 jh-iy", "nn"],
  "clergyman": ["k-l-er1 jh-iy m-ah-n", "nn"],
  "cleric": ["k-l-eh1 r-ih-k", "nn"],
  "clerical": ["k-l-eh1 r-ah k-ah-l", "jj nn"],
  "clerk": ["k-l-er1-k", "nn"],
  "clever": ["k-l-eh1 v-er", "jj"],
  "cleverly": ["k-l-eh1 v-er l-iy", "rb"],
  "cleverness": ["k-l-eh1 v-er n-ah-s", "nn"],
  "cliche": ["k-l-iy sh-ey1", "nn"],
  "cliched": ["k-l-iy sh-ey1-d", "jj"],
  "click": ["k-l-ih1-k", "nn vb"],
  "client": ["k-l-ay1 ah-n-t", "nn"],
  "clientele": ["k-l-ay ah-n t-eh1-l", "nn"],
  "cliff": ["k-l-ih1-f", "nn"],
  "climactic": ["k-l-ay m-ae1-k t-ih-k", "jj"],
  "climate": ["k-l-ay1 m-ah-t", "nn"],
  "climatic": ["k-l-ay m-ae1 t-ih-k", "jj"],
  "climax": ["k-l-ay1 m-ae-k-s", "nn vb"],
  "climb": ["k-l-ay1-m", "vb vbp nn"],
  "climber": ["k-l-ay1 m-er", "nn"],
  "clime": ["k-l-ay1-m", "nn"],
  "clinch": ["k-l-ih1-n-ch", "vb"],
  "clincher": ["k-l-ih1-n ch-er", "nn"],
  "cling": ["k-l-ih1-ng", "vbp vb"],
  "clinic": ["k-l-ih1 n-ih-k", "nn"],
  "clinical": ["k-l-ih1 n-ah k-ah-l", "jj"],
  "clinically": ["k-l-ih1 n-ih k-ah l-iy", "rb"],
  "clinician": ["k-l-ih n-ih1 sh-ah-n", "nn"],
  "clip": ["k-l-ih1-p", "nn vb"],
  "clipboard": ["k-l-ih1-p b-ao-r-d", "nn"],
  "clipping": ["k-l-ih1 p-ih-ng", "nn"],
  "clique": ["k-l-iy1-k", "nn"],
  "cloak": ["k-l-ow1-k", "nn vb vbp"],
  "clobber": ["k-l-aa1 b-er", "vb"],
  "clock": ["k-l-aa1-k", "nn vb vbp"],
  "clockwork": ["k-l-aa1-k w-er-k", "nn"],
  "clog": ["k-l-aa1-g", "vb"],
  "clogged": ["k-l-ao1-g-d", "jj vbn vbd"],
  "cloister": ["k-l-oy1 s-t-er", "nn"],
  "cloistered": ["k-l-oy1 s-t-er-d", "jj"],
  "clone": ["k-l-ow1-n", "nn vb"],
  "clones": ["k-l-ow1-n", "nn"],
  "close": ["k-l-ow1-s", "vb vbp jj"],
  "closed": ["k-l-ow1-z-d", "vbd vbn jj"],
  "closeness": ["k-l-ow1-s n-ih-s", "nn"],
  "closest": ["k-l-ow1 s-ah-s-t", "jjs"],
  "closet": ["k-l-aa1 z-ah-t", "nn jj vb"],
  "closeted": ["k-l-aa1 z-ah t-ih-d", "jj vbd vbn"],
  "closeup": ["k-l-ow1 s-ah1-p", "jj"],
  "closing": ["k-l-ow1 z-ih-ng", "vbg jj nn"],
  "closure": ["k-l-ow1 zh-er", "nn"],
  "clot": ["k-l-aa1-t", "nn"],
  "cloth": ["k-l-ao1-th", "nn"],
  "clothe": ["k-l-ow1-dh", "vb"],
  "clothed": ["k-l-ow1-dh-d", "vbn jj"],
  "clothes": ["k-l-ow1-dh-z", "nns"],
  "clothier": ["k-l-ow1 dh-y-er", "nn"],
  "clothing": ["k-l-ow1 dh-ih-ng", "nn"],
  "clotted": ["k-l-aa1 t-ah-d", "jj"],
  "cloud": ["k-l-aw1-d", "nn vb vbp"],
  "cloudburst": ["k-l-aw1-d b-er-s-t", "nn"],
  "clouded": ["k-l-aw1 d-ih-d", "vbn jj vbd"],
  "clouding": ["k-l-aw1 d-ih-ng", "nn"],
  "cloudless": ["k-l-aw1-d l-ah-s", "jj"],
  "cloudy": ["k-l-aw1 d-iy", "jj"],
  "clout": ["k-l-aw1-t", "nn"],
  "clove": ["k-l-ow1-v-z", "nn"],
  "clover": ["k-l-ow1 v-er", "nn"],
  "clown": ["k-l-aw1-n", "nn"],
  "clowning": ["k-l-aw1 n-ih-ng", "nn"],
  "cloy": ["k-l-oy1", "vb"],
  "cloying": ["k-l-oy1 ih-ng", "jj vbg"],
  "club": ["k-l-ah1-b", "nn"],
  "clubbed": ["k-l-ah1-b-d", "jj vbd"],
  "clubby": ["k-l-ah1 b-iy", "jj"],
  "clubhouse": ["k-l-ah1-b hh-aw-s", "nn"],
  "cluck": ["k-l-ah1-k", "nn vb"],
  "clue": ["k-l-uw1", "nn"],
  "clump": ["k-l-ah1-m-p", "nn"],
  "clumsily": ["k-l-ah1-m s-ah l-iy", "rb"],
  "clumsy": ["k-l-ah1-m z-iy", "jj"],
  "clung": ["k-l-ah1-ng", "vbd vbn"],
  "clunky": ["k-l-ah1-ng k-iy", "jj"],
  "cluster": ["k-l-ah1 s-t-er", "nn vb"],
  "clutch": ["k-l-ah1-ch", "nn vbp vb"],
  "clutter": ["k-l-ah1 t-er", "nn vb"],
  "cluttered": ["k-l-ah1 t-er-d", "vbn jj"],
  "coach": ["k-ow1-ch", "nn vb"],
  "coachman": ["k-ow1-ch m-ah-n", "nn"],
  "coagulate": ["k-ow-ae1-g-y-ah-l-ey-t", "vb"],
  "coal": ["k-ow1-l", "nn"],
  "coalesce": ["k-ow ah l-eh1-s", "vb vbp"],
  "coalition": ["k-ow ah l-ih1 sh-ah-n", "nn"],
  "coarse": ["k-ao1-r-s", "jj"],
  "coast": ["k-ow1-s-t", "nn vb"],
  "coastal": ["k-ow1 s-t-ah-l", "jj"],
  "coaster": ["k-ow1 s-t-er", "nn"],
  "coastline": ["k-ow1-s-t l-ay-n", "nn"],
  "coat": ["k-ow1-t", "nn vb"],
  "coated": ["k-ow1 t-ah-d", "vbn jj"],
  "coating": ["k-ow1 t-ih-ng", "nn vbg"],
  "coattail": ["k-ow1-t t-ey-l", "nn"],
  "coax": ["k-ow1-k-s", "vb"],
  "coaxial": ["k-ow1 ae1-k s-iy ah-l", "jj"],
  "coaxing": ["k-ow1-k s-ih-ng", "jj vbg"],
  "cobalt": ["k-ow1 b-ao-l-t", "nn"],
  "cobble": ["k-aa1-b-ah-l", "vb"],
  "cobbler": ["k-aa1-b l-er", "nn"],
  "cobblestone": ["k-aa1 b-ah-l s-t-ow-n", "nn"],
  "cobra": ["k-ow1 b-r-ah", "nn"],
  "cobweb": ["k-aa1-b w-eh-b", "nn"],
  "coca": ["k-ow1 k-ah", "nn"],
  "cocaine": ["k-ow k-ey1-n", "nn"],
  "cock": ["k-aa1-k", "nn vb"],
  "cockatoo": ["k-aa1 k-ah t-uw", "nn"],
  "cockeyed": ["k-aa1-k ay-d", "jj"],
  "cockiness": ["k-aa1 k-iy n-ah-s", "nn"],
  "cockpit": ["k-aa1-k p-ih-t", "nn"],
  "cockroach": ["k-aa1-k r-ow-ch", "nn"],
  "cocktail": ["k-aa1-k t-ey-l", "nn"],
  "cocky": ["k-aa1 k-iy", "jj"],
  "coco": ["k-ow1 k-ow", "nn"],
  "cocoa": ["k-ow1 k-ow", "nn"],
  "coconut": ["k-ow1 k-ah n-ah-t", "nn"],
  "cocoon": ["k-ah k-uw1-n", "nn"],
  "cod": ["k-aa1-d", "nn"],
  "coddle": ["k-aa1 d-ah-l", "vb vbp"],
  "coddling": ["k-aa1 d-ah-l ih-ng", "nn"],
  "code": ["k-ow1-d", "nn vb"],
  "coded": ["k-ow1 d-ih-d", "vbn jj"],
  "codification": ["k-aa d-ah f-ah k-ey1 sh-ah-n", "nn"],
  "codify": ["k-ow1-d-ah-f-ay", "vb"],
  "coding": ["k-ow1 d-ih-ng", "nn"],
  "coed": ["k-ow1 eh-d", "nn"],
  "coefficient": ["k-ow ah f-ih1 sh-ah-n-t", "nn"],
  "coerce": ["k-ow er1-s", "vb"],
  "coerced": ["k-ow er1-s-t", "vbn vbd jj"],
  "coercion": ["k-ow er1 sh-ah-n", "nn"],
  "coercive": ["k-ow er1 s-ih-v", "jj"],
  "coexist": ["k-ow ah-g z-ih1-s-t", "vb vbp"],
  "coexistence": ["k-ow ih-g z-ih1 s-t-ah-n-s", "nn"],
  "coffee": ["k-aa1 f-iy", "nn"],
  "coffer": ["k-aa1 f-er", "nn"],
  "coffin": ["k-ao1 f-ih-n", "nn"],
  "cofounder": ["k-ow1 f-aw1-n d-er", "nn"],
  "cog": ["k-ao1-g", "nn"],
  "cogeneration": ["k-ow1 jh-eh1 n-er ey1 sh-ah-n", "nn"],
  "cognac": ["k-ow1-n y-ae-k", "nn"],
  "cognitive": ["k-aa1-g n-ih t-ih-v", "jj"],
  "cognizance": ["k-aa1-g n-ah z-ah-n-s", "nn"],
  "cognizant": ["k-aa1-g n-ah z-ah-n-t", "jj"],
  "cognoscenti": ["k-aa-g n-ao sh-eh1-n t-iy", "nn"],
  "coherence": ["k-ow hh-ih1 r-ah-n-s", "nn"],
  "coherent": ["k-ow hh-ih1 r-ah-n-t", "jj"],
  "coherently": ["k-ow hh-iy1 r-ah-n-t l-iy", "rb"],
  "cohesion": ["k-ow hh-iy1 zh-ah-n", "nn"],
  "cohesive": ["k-ow hh-iy1 s-ih-v", "jj"],
  "cohesively": ["k-ow hh-iy1 s-ih-v l-iy", "rb"],
  "cohesiveness": ["k-ow hh-iy1 s-ih-v n-ah-s", "nn"],
  "cohort": ["k-ow1 hh-ao-r-t", "nn"],
  "coiffed": ["k-oy1-f-t", "jj"],
  "coil": ["k-oy1-l", "nn vb"],
  "coin": ["k-oy1-n", "nn vb"],
  "coincide": ["k-ow ih-n s-ay1-d", "vb vbp"],
  "coincidence": ["k-ow ih1-n s-ih d-ah-n-s", "nn"],
  "coincident": ["k-ow ih1-n s-ah d-ah-n-t", "jj"],
  "coincidental": ["k-ow ih-n s-ah d-eh1-n t-ah-l", "jj"],
  "coincidentally": ["k-ow ih-n s-ih d-eh1-n t-ah l-iy", "rb"],
  "coinciding": ["k-ow ah-n s-ay1 d-ih-ng", "vbg jj"],
  "coke": ["k-ow1-k", "nn"],
  "cola": ["k-ow1 l-ah", "nn"],
  "cold": ["k-ow1-l-d", "jj nn"],
  "colder": ["k-ow1-l d-er", "jjr rbr"],
  "coldest": ["k-ow1-l d-ah-s-t", "jjs"],
  "coldly": ["k-ow1-l-d l-iy", "rb"],
  "coldness": ["k-ow1-l-d n-ah-s", "nn"],
  "coliseum": ["k-aa l-ah s-iy1 ah-m", "nn"],
  "collaborate": ["k-ah l-ae1 b-er ey-t", "vb vbp"],
  "collaboration": ["k-ah l-ae b-er ey1 sh-ah-n", "nn"],
  "collaborative": ["k-ah l-ae1 b-er ey t-ih-v", "jj"],
  "collaborator": ["k-ah l-ae1 b-er ey t-er", "nn"],
  "collage": ["k-ah l-aa1-zh", "nn"],
  "collagen": ["k-aa1 l-ah g-ah-n", "nn"],
  "collapse": ["k-ah l-ae1-p-s", "nn vb"],
  "collapsed": ["k-ah l-ae1-p-s-t", "vbd jj vbn"],
  "collapsible": ["k-ah l-ae1-p s-ah b-ah-l", "jj"],
  "collar": ["k-aa1 l-er", "nn vb"],
  "collarbone": ["k-aa1 l-er b-ow-n", "nn"],
  "collateral": ["k-ah l-ae1 t-er ah-l", "nn jj"],
  "collateralize": ["k-ah-l-ae1-t-er-ah-l-ay-z", "vb"],
  "collateralized": ["k-ah l-ae1 t-er ah l-ay-z-d", "jj vbn"],
  "colleague": ["k-aa1 l-iy-g", "nn"],
  "collect": ["k-ah l-eh1-k-t", "vb jj vbp"],
  "collectible": ["k-ah l-eh1-k t-ah b-ah-l", "jj"],
  "collection": ["k-ah l-eh1-k sh-ah-n", "nn"],
  "collective": ["k-ah l-eh1-k t-ih-v", "jj nn"],
  "collectively": ["k-ah l-eh1-k t-ih-v l-iy", "rb"],
  "collectivization": ["k-ah l-eh-k t-ih v-ih z-ey1 sh-ah-n", "nn"],
  "collector": ["k-ah l-eh1-k t-er", "nn"],
  "college": ["k-aa1 l-ih-jh", "nn"],
  "collegial": ["k-ah l-iy1 jh-iy ah-l", "jj"],
  "collegian": ["k-ah l-iy1 jh-ah-n", "nn"],
  "collegiate": ["k-ah l-iy1 jh-ih-t", "jj"],
  "collide": ["k-ah-l-ay1-d", "vb"],
  "collie": ["k-aa1 l-iy", "nn"],
  "collision": ["k-ah l-ih1 zh-ah-n", "nn"],
  "colloidal": ["k-ah l-oy1 d-ah-l", "jj"],
  "colloquial": ["k-ah l-ow1-k w-iy ah-l", "jj"],
  "colloquium": ["k-ah l-ow1 k-w-iy ah-m", "nn"],
  "colloquy": ["k-aa1 l-ah k-w-iy", "nn"],
  "collude": ["k-ah l-uw1-d", "vb"],
  "collusion": ["k-ah l-uw1 zh-ah-n", "nn"],
  "cologne": ["k-ah l-ow1-n", "nn"],
  "colon": ["k-ow1 l-ah-n", "nn"],
  "colonel": ["k-er1 n-ah-l", "nn"],
  "colonial": ["k-ah l-ow1 n-iy ah-l", "jj nn"],
  "colonialism": ["k-ah l-ow1 n-iy ah l-ih z-ah-m", "nn"],
  "colonialist": ["k-ah l-ow1 n-iy ah l-ih-s-t", "nn"],
  "colonist": ["k-aa1 l-ah n-ih-s-t", "nn"],
  "colonization": ["k-aa l-ah n-ih z-ey1 sh-ah-n", "nn"],
  "colonize": ["k-aa1-l-ah-n-ay-z", "vb"],
  "colonnade": ["k-aa l-ah n-ey1-d", "nn"],
  "colony": ["k-aa1 l-ah n-iy", "nn"],
  "color": ["k-ah1 l-er", "nn jj vb vbp"],
  "coloration": ["k-ah l-er ey1 sh-ah-n", "nn"],
  "coloratura": ["k-ah l-er ah t-uh1 r-ah", "nn"],
  "colorblind": ["k-ah1 l-er b-l-ay-n-d", "jj"],
  "colored": ["k-ah1 l-er-d", "jj vbn"],
  "colorful": ["k-ah1 l-er f-ah-l", "jj"],
  "coloring": ["k-ah1 l-er ih-ng", "nn"],
  "colorization": ["k-ah l-er ah z-ey1 sh-ah-n", "nn"],
  "colorless": ["k-ah1 l-er l-ah-s", "jj"],
  "colossal": ["k-ah l-aa1 s-ah-l", "jj"],
  "colossus": ["k-ah l-aa1 s-ah-s", "nn"],
  "coloured": ["k-ah1 l-er-d", "jj"],
  "colt": ["k-ow1-l-t", "nn"],
  "columbine": ["k-aa1 l-ah-m b-ay-n", "nn"],
  "column": ["k-aa1 l-ah-m", "nn"],
  "columnist": ["k-aa1 l-ah-m n-ah-s-t", "nn"],
  "coma": ["k-ow1 m-ah", "nn"],
  "comb": ["k-ow1-m", "nn vb"],
  "combat": ["k-aa1-m b-ae-t", "nn vb"],
  "combatant": ["k-ah-m b-ae1 t-ah-n-t", "jj nn"],
  "combative": ["k-ah-m b-ae1 t-ih-v", "jj"],
  "combinable": ["k-ah-m b-ay1 n-ah b-ah-l", "jj"],
  "combination": ["k-aa-m b-ah n-ey1 sh-ah-n", "nn"],
  "combine": ["k-aa1-m b-ay-n", "vb nn vbp"],
  "combined": ["k-ah-m b-ay1-n-d", "vbn jj vbd"],
  "combing": ["k-ow1 m-ih-ng", "vbg jj"],
  "combo": ["k-aa1-m b-ow", "nn"],
  "combustion": ["k-ah-m b-ah1-s ch-ah-n", "nn"],
  "come": ["k-ah1-m", "vb vbn vbp jj"],
  "comeback": ["k-ah1-m b-ae-k", "nn"],
  "comedian": ["k-ah m-iy1 d-iy ah-n", "nn"],
  "comedic": ["k-ah m-iy1 d-ih-k", "jj"],
  "comedy": ["k-aa1 m-ah d-iy", "nn"],
  "comely": ["k-ah1-m l-iy", "jj"],
  "comer": ["k-ah1 m-er", "nn"],
  "comet": ["k-aa1 m-ah-t", "nn"],
  "cometary": ["k-aa1 m-ah t-eh r-iy", "jj"],
  "comeuppance": ["k-ah m-ah1 p-ah-n-s", "nn"],
  "comfort": ["k-ah1-m f-er-t", "nn vb"],
  "comfortable": ["k-ah1-m f-er t-ah b-ah-l", "jj nn"],
  "comfortably": ["k-ah1-m f-er t-ah b-l-iy", "rb"],
  "comforting": ["k-ah1-m f-er t-ih-ng", "vbg jj"],
  "comfy": ["k-ah1-m f-iy", "jj"],
  "comic": ["k-aa1 m-ih-k", "jj nn"],
  "comical": ["k-aa1 m-ih k-ah-l", "jj"],
  "comically": ["k-aa1 m-ih k-ah l-iy", "rb"],
  "coming": ["k-ah1 m-ih-ng", "vbg jj nn"],
  "comma": ["k-aa1 m-ah", "nn"],
  "command": ["k-ah m-ae1-n-d", "nn vbp vb"],
  "commandant": ["k-aa m-ah-n d-aa1-n-t", "nn"],
  "commandeer": ["k-aa-m-ah-n-d-ih1-r", "vb"],
  "commander": ["k-ah m-ae1-n d-er", "nn"],
  "commanding": ["k-ah m-ae1-n d-ih-ng", "vbg jj nn"],
  "commandment": ["k-ah m-ae1-n-d m-ah-n-t", "nn"],
  "commando": ["k-ah m-ae1-n d-ow", "nn"],
  "commemorate": ["k-ah m-eh1 m-er ey-t", "vb vbp"],
  "commemorative": ["k-ah m-eh1-m r-ah t-ih-v", "jj nn"],
  "commence": ["k-ah m-eh1-n-s", "vb vbp"],
  "commencement": ["k-ah m-eh1-n s-m-ah-n-t", "nn"],
  "commend": ["k-ah m-eh1-n-d", "vb vbp"],
  "commendable": ["k-ah m-eh1-n d-ah b-ah-l", "jj"],
  "commendation": ["k-aa m-ah-n d-ey1 sh-ah-n", "nn"],
  "commensurate": ["k-ah m-eh1-n s-er ah-t", "jj"],
  "comment": ["k-aa1 m-eh-n-t", "vb vbp nn"],
  "commentary": ["k-aa1 m-ah-n t-eh r-iy", "nn"],
  "commentator": ["k-aa1 m-ah-n t-ey t-er", "nn"],
  "commerce": ["k-aa1 m-er-s", "nn"],
  "commercial": ["k-ah m-er1 sh-ah-l", "jj nn"],
  "commercialism": ["k-ah m-er1 sh-ah l-ih z-ah-m", "nn"],
  "commercialization": ["k-ah m-er sh-ah l-ih z-ey1 sh-ah-n", "nn"],
  "commercialize": ["k-ah m-er1 sh-ah l-ay-z", "vb"],
  "commercially": ["k-ah m-er1 sh-ah l-iy", "rb"],
  "commerical": ["k-ah m-er1 sh-ah-l", "jj"],
  "commie": ["k-aa1 m-iy", "jj"],
  "commingle": ["k-ah-m-ih1-ng-g-ah-l", "vb"],
  "commiserate": ["k-ah m-ih1 s-er ey-t", "vb"],
  "commissar": ["k-aa1 m-ah s-aa-r", "nn"],
  "commissary": ["k-aa1 m-ah s-eh r-iy", "nn"],
  "commission": ["k-ah m-ih1 sh-ah-n", "nn vb"],
  "commissioner": ["k-ah m-ih1 sh-ah-n er", "nn"],
  "commit": ["k-ah m-ih1-t", "vb jj vbp"],
  "commitment": ["k-ah m-ih1-t m-ah-n-t", "nn"],
  "committed": ["k-ah m-ih1 t-ah-d", "vbn jj vbd"],
  "committee": ["k-ah m-ih1 t-iy", "nn"],
  "commodity": ["k-ah m-aa1 d-ah t-iy", "nn"],
  "common": ["k-aa1 m-ah-n", "jj nn"],
  "commonality": ["k-aa m-ah n-ae1 l-ah t-iy", "nn"],
  "commoner": ["k-aa1 m-ah n-er", "nn"],
  "commonly": ["k-aa1 m-ah-n l-iy", "rb"],
  "commonplace": ["k-aa1 m-ah-n p-l-ey-s", "jj nn"],
  "commons": ["k-aa1 m-ah-n-z", "nn"],
  "commonwealth": ["k-aa1 m-ah-n w-eh-l-th", "nn"],
  "commotion": ["k-ah m-ow1 sh-ah-n", "nn"],
  "communal": ["k-ah m-y-uw1 n-ah-l", "jj"],
  "commune": ["k-aa1 m-y-uw-n", "nn vb"],
  "communicable": ["k-ah m-y-uw1 n-ah k-ah b-ah-l", "jj"],
  "communicate": ["k-ah m-y-uw1 n-ah k-ey-t", "vb vbp"],
  "communication": ["k-ah m-y-uw n-ah k-ey1 sh-ah-n", "nn"],
  "communicative": ["k-ah m-y-uw1 n-ah k-ah t-ih-v", "jj"],
  "communicator": ["k-ah m-y-uw1 n-ah k-ey t-er", "nn"],
  "communion": ["k-ah m-y-uw1 n-y-ah-n", "nn"],
  "communique": ["k-ah m-y-uw1 n-ah k-ey", "nn"],
  "communism": ["k-aa1 m-y-ah n-ih z-ah-m", "nn"],
  "communist": ["k-aa1 m-y-ah n-ah-s-t", "jj nn"],
  "community": ["k-ah m-y-uw1 n-ah t-iy", "nn"],
  "communize": ["k-aa1 m-y-ah n-ay-z", "vb"],
  "commute": ["k-ah m-y-uw1-t", "vb nn vbp"],
  "commuter": ["k-ah m-y-uw1 t-er", "nn"],
  "compact": ["k-aa1-m p-ae-k-t", "jj nn vb"],
  "compacted": ["k-ah-m p-ae1-k t-ih-d", "jj vbn"],
  "companion": ["k-ah-m p-ae1 n-y-ah-n", "nn jj"],
  "companionship": ["k-ah-m p-ae1 n-y-ah-n sh-ih-p", "nn"],
  "companionway": ["k-ah-m p-ae1 n-y-ah-n w-ey", "nn"],
  "company": ["k-ah1-m p-ah n-iy", "nn"],
  "companywide": ["k-ah1-m p-ah n-iy w-ay-d", "jj rb"],
  "comparability": ["k-aa-m p-er ah b-ih1 l-ih t-iy", "nn"],
  "comparable": ["k-aa1-m p-er ah b-ah-l", "jj"],
  "comparably": ["k-aa1-m p-er ah b-l-iy", "rb"],
  "comparative": ["k-ah-m p-eh1 r-ah t-ih-v", "jj nn"],
  "comparatively": ["k-ah-m p-eh1 r-ah t-ih-v l-iy", "rb"],
  "compare": ["k-ah-m p-eh1-r", "vb vbp nn"],
  "comparison": ["k-ah-m p-eh1 r-ah s-ah-n", "nn"],
  "compartment": ["k-ah-m p-aa1-r-t m-ah-n-t", "nn"],
  "compass": ["k-ah1-m p-ah-s", "nn vb"],
  "compassion": ["k-ah-m p-ae1 sh-ah-n", "nn"],
  "compassionate": ["k-ah-m p-ae1 sh-ah n-ah-t", "jj"],
  "compatibility": ["k-ah-m p-ae t-ah b-ih1 l-ah t-iy", "nn"],
  "compatible": ["k-ah-m p-ae1 t-ah b-ah-l", "jj"],
  "compatriot": ["k-ah-m p-ey1 t-r-iy ah-t", "nn"],
  "compel": ["k-ah-m p-eh1-l", "vb"],
  "compelled": ["k-ah-m p-eh1-l-d", "vbn vbd jj"],
  "compelling": ["k-ah-m p-eh1 l-ih-ng", "jj vbg"],
  "compellingly": ["k-ah-m p-eh1 l-ih-ng l-iy", "rb"],
  "compendium": ["k-ah-m p-eh1-n d-iy ah-m", "nn"],
  "compensate": ["k-aa1-m p-ah-n s-ey-t", "vb vbp"],
  "compensation": ["k-aa-m p-ah-n s-ey1 sh-ah-n", "nn"],
  "compensatory": ["k-ah-m p-eh1-n s-ah t-ao r-iy", "jj"],
  "compete": ["k-ah-m p-iy1-t", "vb vbp"],
  "competence": ["k-aa1-m p-ah t-ih-n-s", "nn"],
  "competency": ["k-aa1-m p-ah t-ih-n s-iy", "nn"],
  "competent": ["k-aa1-m p-ah t-ih-n-t", "jj"],
  "competently": ["k-aa1-m p-ah t-ih-n-t l-iy", "rb"],
  "competing": ["k-ah-m p-iy1 t-ih-ng", "vbg jj"],
  "competition": ["k-aa-m p-ah t-ih1 sh-ah-n", "nn"],
  "competitive": ["k-ah-m p-eh1 t-ah t-ih-v", "jj"],
  "competitively": ["k-ah-m p-eh1 t-ih t-ih-v l-iy", "rb"],
  "competitiveness": ["k-ah-m p-eh1 t-ih t-ih-v n-ih-s", "nn"],
  "competitor": ["k-ah-m p-eh1 t-ah t-er", "nn"],
  "compilation": ["k-aa-m p-ah l-ey1 sh-ah-n", "nn"],
  "compile": ["k-ah-m p-ay1-l", "vb"],
  "complacency": ["k-ah-m p-l-ey1 s-ah-n s-iy", "nn"],
  "complacent": ["k-ah-m p-l-ey1 s-ah-n-t", "jj"],
  "complacently": ["k-ah-m p-l-ey1 s-ah-n-t l-iy", "rb"],
  "complain": ["k-ah-m p-l-ey1-n", "vbp vb"],
  "complaint": ["k-ah-m p-l-ey1-n-t", "nn"],
  "complaisant": ["k-ah-m p-l-ey1 s-ah-n-t", "jj"],
  "complement": ["k-aa1-m p-l-ah m-ah-n-t", "nn vbp vb"],
  "complementary": ["k-aa-m p-l-ah m-eh1-n t-r-iy", "jj"],
  "complete": ["k-ah-m p-l-iy1-t", "jj vb vbp"],
  "completed": ["k-ah-m p-l-iy1 t-ah-d", "vbn jj vbd"],
  "completely": ["k-ah-m p-l-iy1-t l-iy", "rb"],
  "completeness": ["k-ah-m p-l-iy1-t n-ah-s", "nn"],
  "completion": ["k-ah-m p-l-iy1 sh-ah-n", "nn"],
  "complex": ["k-aa1-m p-l-eh-k-s", "jj nn"],
  "complexion": ["k-ah-m p-eh1-k sh-ah-n", "nn"],
  "complexity": ["k-ah-m p-l-eh1-k s-ah t-iy", "nn"],
  "compliance": ["k-ah-m p-l-ay1 ah-n-s", "nn"],
  "compliant": ["k-ah-m p-l-ay1 ah-n-t", "jj"],
  "complicate": ["k-aa1-m p-l-ah k-ey-t", "vb vbp"],
  "complicated": ["k-aa1-m p-l-ah k-ey t-ah-d", "vbn jj vbd"],
  "complication": ["k-aa-m p-l-ah k-ey1 sh-ah-n", "nn"],
  "complicity": ["k-ah-m p-l-ih1 s-ah t-iy", "nn"],
  "compliment": ["k-aa1-m p-l-ah m-eh-n-t", "nn vbp vb"],
  "complimentary": ["k-aa-m p-l-ah m-eh1-n t-er iy", "jj"],
  "comply": ["k-ah-m p-l-ay1", "vb vbp"],
  "component": ["k-ah-m p-ow1 n-ah-n-t", "nn"],
  "comportment": ["k-ah-m p-ao1-r-t m-ah-n-t", "nn"],
  "compose": ["k-ah-m p-ow1-z", "vb vbp"],
  "composed": ["k-ah-m p-ow1-z-d", "vbn vbd jj"],
  "composer": ["k-ah-m p-ow1 z-er", "nn"],
  "composite": ["k-ah-m p-aa1 z-ah-t", "jj nn"],
  "composition": ["k-aa-m p-ah z-ih1 sh-ah-n", "nn"],
  "compositional": ["k-aa-m p-ah z-ih1 sh-ah n-ah-l", "jj"],
  "compost": ["k-aa1-m p-ow-s-t", "nn"],
  "composting": ["k-aa1-m p-ow s-t-ih-ng", "nn"],
  "composure": ["k-ah-m p-ow1 zh-er", "nn"],
  "compote": ["k-aa1-m p-ow-t", "nn"],
  "compound": ["k-aa1-m p-aw-n-d", "nn jj vb vbp"],
  "compounded": ["k-ah-m p-aw1-n d-ah-d", "vbn jj vbd"],
  "comprehend": ["k-aa-m p-r-iy hh-eh1-n-d", "vb"],
  "comprehension": ["k-aa-m p-r-iy hh-eh1-n sh-ah-n", "nn"],
  "comprehensive": ["k-aa-m p-r-iy hh-eh1-n s-ih-v", "jj"],
  "comprehensively": ["k-aa-m p-r-ih hh-eh1-n s-ih-v l-iy", "rb"],
  "compress": ["k-aa1-m p-r-eh-s", "vb"],
  "compression": ["k-ah-m p-r-eh1 sh-ah-n", "nn"],
  "compressor": ["k-ah-m p-r-eh1 s-er", "nn"],
  "comprise": ["k-ah-m p-r-ay1-z", "vbp vb"],
  "compromise": ["k-aa1-m p-r-ah m-ay-z", "nn jj vb"],
  "compromising": ["k-aa1-m p-r-ah m-ay z-ih-ng", "vbg jj"],
  "comptroller": ["k-ah-n t-r-ow1 l-er", "nn"],
  "compulsion": ["k-ah-m p-ah1-l sh-ah-n", "nn"],
  "compulsive": ["k-ah-m p-ah1-l s-ih-v", "jj"],
  "compulsively": ["k-ah-m p-ah1-l s-ih-v l-iy", "rb"],
  "compulsory": ["k-ah-m p-ah1-l s-er iy", "jj"],
  "computation": ["k-aa-m p-y-ah t-ey1 sh-ah-n", "nn"],
  "computational": ["k-aa-m p-y-uw t-ey1 sh-ah n-ah-l", "jj"],
  "compute": ["k-ah-m p-y-uw1-t", "vb"],
  "computed": ["k-ah-m p-y-uw1 t-ah-d", "vbn jj"],
  "computer": ["k-ah-m p-y-uw1 t-er", "nn"],
  "computerize": ["k-ah-m p-y-uw1 t-er ay-z", "vb"],
  "computerized": ["k-ah-m p-y-uw1 t-er ay-z-d", "jj vbd vbn"],
  "comrade": ["k-aa1-m r-ae-d", "nn"],
  "con": ["k-aa1-n", "nn"],
  "concave": ["k-aa-n k-ey1-v", "jj"],
  "conceal": ["k-ah-n s-iy1-l", "vb"],
  "concealed": ["k-ah-n s-iy1-l-d", "vbn jj vbd"],
  "concealment": ["k-ah-n s-iy1-l m-ah-n-t", "nn"],
  "concede": ["k-ah-n s-iy1-d", "vbp vb"],
  "conceit": ["k-ah-n s-iy1-t", "nn"],
  "conceivable": ["k-ah-n s-iy1 v-ah b-ah-l", "jj"],
  "conceivably": ["k-ah-n s-iy1 v-ah b-l-iy", "rb"],
  "conceive": ["k-ah-n s-iy1-v", "vb vbp"],
  "conceived": ["k-ah-n s-iy1-v-d", "vbn vbd jj"],
  "concentrate": ["k-aa1-n s-ah-n t-r-ey-t", "vb vbp nn"],
  "concentrated": ["k-aa1-n s-ah-n t-r-ey t-ah-d", "vbn jj vbd"],
  "concentration": ["k-aa-n s-ah-n t-r-ey1 sh-ah-n", "nn"],
  "concentric": ["k-ah-n s-eh1-n t-r-ih-k", "jj"],
  "concept": ["k-aa1-n s-eh-p-t", "nn"],
  "conception": ["k-ah-n s-eh1-p sh-ah-n", "nn"],
  "conceptual": ["k-ah-n s-eh1-p ch-uw ah-l", "jj"],
  "conceptually": ["k-ah-n s-eh1-p ch-uw ah l-iy", "rb"],
  "concern": ["k-ah-n s-er1-n", "vbp vb nn"],
  "concerned": ["k-ah-n s-er1-n-d", "vbd jj vbn"],
  "concert": ["k-aa1-n s-er-t", "nn vb"],
  "concerted": ["k-ah-n s-er1 t-ah-d", "jj vbn"],
  "concertmaster": ["k-aa1-n s-er-t m-ae s-t-er", "nn"],
  "concerto": ["k-ah-n ch-eh1-r t-ow", "nn"],
  "concession": ["k-ah-n s-eh1 sh-ah-n", "nn"],
  "concierge": ["k-aa-n s-iy eh1-r-zh", "nn"],
  "conciliator": ["k-ah-n s-ih1 l-iy ey t-er", "nn"],
  "conciliatory": ["k-ah-n s-ih1 l-iy ah t-ao r-iy", "jj"],
  "concise": ["k-ah-n s-ay1-s", "jj"],
  "concisely": ["k-ah-n s-ay1-s l-iy", "rb"],
  "conclave": ["k-aa1-n k-l-ey-v", "nn"],
  "conclude": ["k-ah-n k-l-uw1-d", "vb vbp"],
  "concluding": ["k-ah-n k-l-uw1 d-ih-ng", "vbg jj"],
  "conclusion": ["k-ah-n k-l-uw1 zh-ah-n", "nn"],
  "conclusive": ["k-ah-n k-l-uw1 s-ih-v", "jj"],
  "conclusively": ["k-ah-n k-l-uw1 s-ih-v l-iy", "rb"],
  "concoct": ["k-ah-n k-aa1-k-t", "vb"],
  "concoction": ["k-ah-n k-aa1-k sh-ah-n", "nn"],
  "concomitant": ["k-aa-n k-aa1 m-ah t-ah-n-t", "jj nn"],
  "concomitantly": ["k-aa-n k-aa1 m-ah t-ah-n-t l-iy", "rb"],
  "concord": ["k-aa1-n k-ao-r-d", "nn"],
  "concrete": ["k-ah-n k-r-iy1-t", "jj nn"],
  "concretely": ["k-aa1-n k-r-iy-t l-iy", "rb"],
  "concur": ["k-ah-n k-er1", "vbp vb"],
  "concurrence": ["k-ah-n k-er1 ah-n-s", "nn"],
  "concurrent": ["k-ah-n k-er1 ah-n-t", "jj"],
  "concurrently": ["k-ah-n k-er1 ah-n-t l-iy", "rb"],
  "concussion": ["k-ah-n k-ah1 sh-ah-n", "nn"],
  "condemn": ["k-ah-n d-eh1-m", "vb vbp"],
  "condemnation": ["k-aa-n d-ah-m n-ey1 sh-ah-n", "nn"],
  "condemned": ["k-ah-n d-eh1-m-d", "vbn jj vbd"],
  "condensate": ["k-aa1-n d-ah-n s-ey-t", "nn"],
  "condensation": ["k-aa-n d-ah-n s-ey1 sh-ah-n", "nn"],
  "condense": ["k-ah-n d-eh1-n-s", "vb"],
  "condensed": ["k-ah-n d-eh1-n-s-t", "jj vbn"],
  "condenser": ["k-ah-n d-eh1-n s-er", "nn"],
  "condescend": ["k-aa-n-d-ih-s-eh1-n-d", "vb"],
  "condescending": ["k-aa-n d-ih s-eh1-n d-ih-ng", "jj vbg"],
  "condescension": ["k-aa-n d-ah s-eh1-n sh-ah-n", "nn"],
  "condiment": ["k-aa1-n d-ah m-ah-n-t", "nn"],
  "condition": ["k-ah-n d-ih1 sh-ah-n", "nn vbp vb"],
  "conditional": ["k-ah-n d-ih1 sh-ah n-ah-l", "jj nn"],
  "conditionally": ["k-ah-n d-ih1 sh-ah-n ah l-iy", "rb"],
  "conditioned": ["k-ah-n d-ih1 sh-ah-n-d", "vbn vbd jj"],
  "conditioner": ["k-ah-n d-ih1 sh-ah-n er", "nn"],
  "conditioning": ["k-ah-n d-ih1 sh-ah-n ih-ng", "nn vbg"],
  "condo": ["k-aa1-n d-ow", "nn"],
  "condolence": ["k-ah-n d-ow1 l-ah-n s-ah", "nn"],
  "condom": ["k-aa1-n d-ah-m", "nn"],
  "condominium": ["k-aa-n d-ah m-ih1 n-iy ah-m", "nn"],
  "condone": ["k-ah-n d-ow1-n", "vb"],
  "conducive": ["k-ah-n d-uw1 s-ih-v", "jj"],
  "conduct": ["k-ah-n d-ah1-k-t", "nn vbp vb"],
  "conduction": ["k-ah-n d-ah1-k sh-ah-n", "nn"],
  "conductivity": ["k-aa-n d-ah-k t-ih1 v-ah t-iy", "nn"],
  "conductor": ["k-ah-n d-ah1-k t-er", "nn"],
  "conduit": ["k-aa1-n d-uw ih-t", "nn"],
  "cone": ["k-ow1-n", "nn vb"],
  "confabulation": ["k-ah-n f-ae b-y-ah l-ey1 sh-ah-n", "nn"],
  "confectionary": ["k-ah-n f-eh1-k sh-ah-n eh r-iy", "jj"],
  "confectioner": ["k-ah-n f-eh1-k sh-ah-n er", "nn"],
  "confectionery": ["k-ah-n f-eh1-k sh-ah-n eh r-iy", "nn"],
  "confederacy": ["k-ah-n f-eh1 d-er ah s-iy", "nn"],
  "confederation": ["k-ah-n f-eh d-er ey1 sh-ah-n", "nn"],
  "confer": ["k-ah-n f-er1", "vb vbp"],
  "conferee": ["k-aa-n f-er iy1", "nn"],
  "conference": ["k-aa1-n f-er ah-n-s", "nn"],
  "confess": ["k-ah-n f-eh1-s", "vb vbp"],
  "confession": ["k-ah-n f-eh1 sh-ah-n", "nn"],
  "confessional": ["k-ah-n f-eh1 sh-ah n-ah-l", "nn jj"],
  "confidant": ["k-aa1-n f-ah d-aa-n-t", "nn"],
  "confidante": ["k-aa1-n f-ah d-ae-n-t", "nn"],
  "confide": ["k-ah-n f-ay1-d", "vb vbp"],
  "confidence": ["k-aa1-n f-ah d-ah-n-s", "nn"],
  "confident": ["k-aa1-n f-ah d-ah-n-t", "jj"],
  "confidential": ["k-aa-n f-ah d-eh1-n sh-ah-l", "jj"],
  "confidentiality": ["k-aa-n f-ah d-eh-n sh-iy ae1 l-ah t-iy", "nn"],
  "confidentially": ["k-aa-n f-ah d-eh1-n sh-ah l-iy", "rb"],
  "confidently": ["k-aa1-n f-ah d-ah-n-t l-iy", "rb"],
  "confiding": ["k-ah-n f-ay1 d-ih-ng", "vbg jj"],
  "configuration": ["k-ah-n f-ih g-y-er ey1 sh-ah-n", "nn"],
  "confine": ["k-ah-n f-ay1-n", "vb vbp"],
  "confined": ["k-ah-n f-ay1-n-d", "vbn jj vbd"],
  "confinement": ["k-ah-n f-ay1-n m-ah-n-t", "nn"],
  "confirm": ["k-ah-n f-er1-m", "vb vbp"],
  "confirmation": ["k-aa-n f-er m-ey1 sh-ah-n", "nn"],
  "confirmed": ["k-ah-n f-er1-m-d", "vbd vbn jj"],
  "confiscate": ["k-aa1-n f-ah s-k-ey-t", "vb"],
  "confiscation": ["k-aa-n f-ah s-k-ey1 sh-ah-n", "nn"],
  "confiscatory": ["k-ah-n f-ih1-s k-ah t-ao r-iy", "jj"],
  "conflagration": ["k-aa-n f-l-ah g-r-ey1 sh-ah-n", "nn"],
  "conflict": ["k-aa1-n f-l-ih-k-t", "nn vb vbp"],
  "conflicting": ["k-ah-n f-l-ih1-k t-ih-ng", "vbg jj"],
  "confluence": ["k-aa1-n f-l-uw ah-n-s", "nn"],
  "conform": ["k-ah-n f-ao1-r-m", "vb vbp"],
  "conformance": ["k-ah-n f-ao1-r m-ah-n-s", "nn"],
  "conformational": ["k-aa-n f-er m-ey1 sh-ah n-ah-l", "jj"],
  "conformist": ["k-ah-n f-ao1-r m-ih-s-t", "jj nn"],
  "conformity": ["k-ah-n f-ao1-r m-ah t-iy", "nn"],
  "confound": ["k-aa-n f-aw1-n-d", "vb"],
  "confront": ["k-ah-n f-r-ah1-n-t", "vb vbp"],
  "confrontation": ["k-aa-n f-r-ah-n t-ey1 sh-ah-n", "nn"],
  "confrontational": ["k-aa-n f-r-ah-n t-ey1 sh-ah n-ah-l", "jj"],
  "confuse": ["k-ah-n f-y-uw1-z", "vb vbp"],
  "confused": ["k-ah-n f-y-uw1-z-d", "vbn jj vbd"],
  "confusing": ["k-ah-n f-y-uw1 z-ih-ng", "jj vbg"],
  "confusion": ["k-ah-n f-y-uw1 zh-ah-n", "nn"],
  "congeal": ["k-ah-n jh-iy1-l", "vb"],
  "congenial": ["k-ah-n jh-iy1 n-y-ah-l", "jj"],
  "congeniality": ["k-ah-n jh-iy n-iy ae1 l-ah t-iy", "nn"],
  "congenital": ["k-ah-n jh-eh1 n-ah t-ah-l", "jj"],
  "congest": ["k-ah-n-jh-eh1-s-t", "vb"],
  "congested": ["k-ah-n jh-eh1 s-t-ah-d", "jj vbn"],
  "congestion": ["k-ah-n jh-eh1-s ch-ah-n", "nn"],
  "congestive": ["k-ah-n jh-eh1 s-t-ih-v", "jj"],
  "conglomerate": ["k-ah-n g-l-aa1 m-er ah-t", "nn jj"],
  "congratulate": ["k-ah-n g-r-ae1 ch-ah l-ey-t", "vbp vb"],
  "congratulating": ["k-ah-n g-r-ae1 ch-ah l-ey t-ih-ng", "nn"],
  "congratulation": ["k-ah-n g-r-ae ch-ah l-ey1 sh-ah-n", "nn"],
  "congratulatory": ["k-ah-n g-r-ae1 ch-ah l-ah t-ao r-iy", "jj"],
  "congregate": ["k-aa1-ng g-r-ah g-ey-t", "vb"],
  "congregation": ["k-aa-ng g-r-ah g-ey1 sh-ah-n", "nn"],
  "congregational": ["k-aa-ng g-r-ah g-ey1 sh-ah n-ah-l", "jj"],
  "congress": ["k-aa1-ng g-r-ah-s", "nn"],
  "congressman": ["k-aa1-ng g-r-ah-s m-ah-n", "nn"],
  "congruence": ["k-ao1-n g-r-uw ah-n-s", "nn"],
  "conjecture": ["k-ah-n jh-eh1-k ch-er", "nn"],
  "conjunction": ["k-ah-n jh-ah1-ng-k sh-ah-n", "nn"],
  "conjure": ["k-aa1-n jh-er", "vb vbp"],
  "connect": ["k-ah n-eh1-k-t", "vb vbp"],
  "connected": ["k-ah n-eh1-k t-ah-d", "vbn jj vbd"],
  "connecting": ["k-ah n-eh1-k t-ih-ng", "vbg jj"],
  "connection": ["k-ah n-eh1-k sh-ah-n", "nn"],
  "connective": ["k-ah n-eh1-k t-ih-v", "jj"],
  "connector": ["k-ah n-eh1-k t-er", "nn"],
  "conned": ["k-aa1-n-d", "vbn"],
  "connivance": ["k-ah n-ay1 v-ah-n-s", "nn"],
  "connoisseur": ["k-aa n-ah s-er1", "nn"],
  "connotation": ["k-aa n-ah t-ey1 sh-ah-n", "nn"],
  "connote": ["k-ah n-ow1-t", "vb vbp"],
  "conquer": ["k-aa1-ng k-er", "vb vbp"],
  "conqueror": ["k-aa1-ng k-er er", "nn"],
  "conquest": ["k-aa1-ng k-w-eh-s-t", "nn"],
  "conscience": ["k-aa1-n sh-ah-n-s", "nn"],
  "conscientious": ["k-aa-n sh-iy eh1-n sh-ah-s", "jj"],
  "conscious": ["k-aa1-n sh-ah-s", "jj nn"],
  "consciously": ["k-aa1-n sh-ah-s l-iy", "rb"],
  "consciousness": ["k-aa1-n sh-ah-s n-ah-s", "nn"],
  "conscript": ["k-aa1-n s-k-r-ih-p-t", "nn jj vb"],
  "conscription": ["k-ah-n s-k-r-ih1-p sh-ah-n", "nn"],
  "consecutive": ["k-ah-n s-eh1 k-y-ah t-ih-v", "jj"],
  "consensual": ["k-ah-n s-eh1-n s-uw ah-l", "jj"],
  "consensus": ["k-ah-n s-eh1-n s-ah-s", "nn"],
  "consent": ["k-ah-n s-eh1-n-t", "nn vb"],
  "consenting": ["k-ah-n s-eh1-n t-ih-ng", "vbg jj"],
  "consequence": ["k-aa1-n s-ah k-w-ah-n-s", "nn"],
  "consequent": ["k-aa1-n s-ah k-w-ah-n-t", "jj"],
  "consequential": ["k-aa-n s-ah k-w-eh1-n ch-ah-l", "jj"],
  "consequently": ["k-aa1-n s-ah k-w-ah-n-t l-iy", "rb"],
  "conservancy": ["k-ah-n s-er1 v-ah-n s-iy", "nn"],
  "conservation": ["k-aa-n s-er v-ey1 sh-ah-n", "nn"],
  "conservationist": ["k-aa-n s-er v-ey1 sh-ah-n ah-s-t", "nn"],
  "conservatism": ["k-ah-n s-er1 v-ah t-ih z-ah-m", "nn"],
  "conservative": ["k-ah-n s-er1 v-ah t-ih-v", "jj nn"],
  "conservatively": ["k-ah-n s-er1 v-ah t-ih-v l-iy", "rb"],
  "conservator": ["k-ah-n s-er1 v-ah t-er", "nn"],
  "conservatorship": ["k-ah-n s-er1 v-ah t-er sh-ih-p", "nn"],
  "conservatory": ["k-ah-n s-er1 v-ah t-ao r-iy", "nn"],
  "conserve": ["k-ah-n s-er1-v", "vb"],
  "consider": ["k-ah-n s-ih1 d-er", "vb vbp"],
  "considerable": ["k-ah-n s-ih1 d-er ah b-ah-l", "jj"],
  "considerably": ["k-ah-n s-ih1 d-er ah b-l-iy", "rb"],
  "considerate": ["k-ah-n s-ih1 d-er ah-t", "jj"],
  "consideration": ["k-ah-n s-ih d-er ey1 sh-ah-n", "nn"],
  "considered": ["k-ah-n s-ih1 d-er-d", "vbn vbd jj"],
  "consign": ["k-ah-n s-ay1-n", "vb"],
  "consist": ["k-ah-n s-ih1-s-t", "vb vbp"],
  "consistence": ["k-ah-n s-ih1 s-t-ah-n-s", "nn"],
  "consistency": ["k-ah-n s-ih1 s-t-ah-n s-iy", "nn"],
  "consistent": ["k-ah-n s-ih1 s-t-ah-n-t", "jj"],
  "consistently": ["k-ah-n s-ih1 s-t-ah-n-t l-iy", "rb"],
  "consolation": ["k-aa-n s-ah l-ey1 sh-ah-n", "nn"],
  "console": ["k-aa1-n s-ow-l", "vb vbp"],
  "consolidate": ["k-ah-n s-aa1 l-ih d-ey-t", "vb vbp"],
  "consolidated": ["k-ah-n s-aa1 l-ah d-ey t-ah-d", "jj vbd vbn"],
  "consolidating": ["k-ah-n s-aa1 l-ah d-ey t-ih-ng", "vbg jj"],
  "consolidation": ["k-ah-n s-aa l-ah d-ey1 sh-ah-n", "nn"],
  "consonant": ["k-aa1-n s-ah n-ah-n-t", "jj nn"],
  "consonantal": ["k-aa-n s-ah n-aa1-n t-ah-l", "jj"],
  "consort": ["k-ah-n-s-ao1-r-t", "vb"],
  "consortium": ["k-ah-n s-ao1-r sh-iy ah-m", "nn"],
  "conspicuous": ["k-ah-n s-p-ih1 k-y-uw ah-s", "jj"],
  "conspicuously": ["k-ah-n s-p-ih1 k-y-uw ah-s l-iy", "rb"],
  "conspiracy": ["k-ah-n s-p-ih1 r-ah s-iy", "nn"],
  "conspirator": ["k-ah-n s-p-ih1 r-ah t-er", "nn"],
  "conspiratorial": ["k-ah-n s-p-ih r-ah t-ao1 r-iy ah-l", "jj"],
  "conspire": ["k-ah-n s-p-ay1 er", "vbp vb"],
  "constable": ["k-aa1-n s-t-ah b-ah-l", "nn"],
  "constancy": ["k-aa1-n s-t-ah-n s-iy", "nn"],
  "constant": ["k-aa1-n s-t-ah-n-t", "jj nn rb"],
  "constantly": ["k-aa1-n s-t-ah-n-t l-iy", "rb"],
  "constellation": ["k-aa-n s-t-ah l-ey1 sh-ah-n", "nn"],
  "consternation": ["k-aa-n s-t-er n-ey1 sh-ah-n", "nn"],
  "constipation": ["k-aa-n s-t-ah p-ey1 sh-ah-n", "nn"],
  "constituency": ["k-ah-n s-t-ih1 ch-uw ah-n s-iy", "nn"],
  "constituent": ["k-ah-n s-t-ih1 ch-uw ah-n-t", "nn jj"],
  "constitute": ["k-aa1-n s-t-ah t-uw-t", "vbp vb"],
  "constitution": ["k-aa-n s-t-ah t-uw1 sh-ah-n", "nn"],
  "constitutional": ["k-aa-n s-t-ah t-uw1 sh-ah n-ah-l", "jj"],
  "constitutionality": ["k-aa-n s-t-ih t-uw sh-ah n-ae1 l-ih t-iy", "nn"],
  "constitutionally": ["k-aa-n s-t-ah t-uw1 sh-ah-n ah-l iy", "rb"],
  "constrain": ["k-ah-n s-t-r-ey1-n", "vb"],
  "constrained": ["k-ah-n s-t-r-ey1-n-d", "vbn jj"],
  "constraint": ["k-ah-n s-t-r-ey1-n-t", "nn"],
  "constrict": ["k-ah-n-s-t-r-ih1-k-t", "vb"],
  "constricted": ["k-ah-n s-t-r-ih1-k t-ah-d", "jj vbd vbn"],
  "constriction": ["k-ah-n s-t-r-ih1-k sh-ah-n", "nn"],
  "constrictor": ["k-ah-n s-t-r-ih1-k t-er", "nn"],
  "construct": ["k-ah-n s-t-r-ah1-k-t", "vb vbp"],
  "construction": ["k-ah-n s-t-r-ah1-k sh-ah-n", "nn"],
  "constructive": ["k-ah-n s-t-r-ah1-k t-ih-v", "jj"],
  "constructively": ["k-ah-n s-t-r-ah1-k t-ih-v l-iy", "rb"],
  "construe": ["k-ah-n s-t-r-uw1", "vb vbp"],
  "consul": ["k-aa1-n s-ah-l", "nn"],
  "consular": ["k-aa1-n s-ah l-er", "jj"],
  "consulate": ["k-aa1-n s-ah l-ah-t", "nn"],
  "consult": ["k-ah-n s-ah1-l-t", "vb"],
  "consultancy": ["k-ah-n s-ah1-l t-ah-n s-iy", "nn"],
  "consultant": ["k-ah-n s-ah1-l t-ah-n-t", "nn"],
  "consultation": ["k-aa-n s-ah-l t-ey1 sh-ah-n", "nn"],
  "consultative": ["k-ah-n s-ah1-l t-ah t-ih-v", "jj"],
  "consulting": ["k-ah-n s-ah1-l t-ih-ng", "jj vbg"],
  "consume": ["k-ah-n s-uw1-m", "vbp vb"],
  "consumer": ["k-ah-n s-uw1 m-er", "nn"],
  "consumerism": ["k-ah-n s-uw1 m-er ih z-ah-m", "nn"],
  "consummate": ["k-aa1-n s-ah m-ah-t", "jj vb"],
  "consummation": ["k-aa-n s-ah m-ey1 sh-ah-n", "nn"],
  "consumption": ["k-ah-n s-ah1-m-p sh-ah-n", "nn"],
  "contact": ["k-aa1-n t-ae-k-t", "nn jj vb"],
  "contagion": ["k-ah-n t-ey1 jh-ah-n", "nn"],
  "contagious": ["k-ah-n t-ey1 jh-ah-s", "jj"],
  "contain": ["k-ah-n t-ey1-n", "vb vbp"],
  "contained": ["k-ah-n t-ey1-n-d", "vbd vbn jj"],
  "container": ["k-ah-n t-ey1 n-er", "nn"],
  "containerboard": ["k-ah-n t-ey1 n-er b-ao-r-d", "nn"],
  "containment": ["k-ah-n t-ey1-n m-ah-n-t", "nn"],
  "contaminant": ["k-ah-n t-ae1 m-ah n-ah-n-t", "nn"],
  "contaminate": ["k-ah-n t-ae1 m-ah n-ey-t", "vb"],
  "contaminated": ["k-ah-n t-ae1 m-ah n-ey t-ah-d", "vbn vbd jj"],
  "contamination": ["k-ah-n t-ae m-ah n-ey1 sh-ah-n", "nn"],
  "contemplate": ["k-aa1-n t-ah-m p-l-ey-t", "vb vbp"],
  "contemplated": ["k-aa1-n t-ah-m p-l-ey t-ih-d", "vbn jj vbd"],
  "contemplation": ["k-aa-n t-ah-m p-l-ey1 sh-ah-n", "nn"],
  "contemplative": ["k-ah-n t-eh1-m p-l-ah t-ih-v", "jj"],
  "contemporary": ["k-ah-n t-eh1-m p-er eh r-iy", "jj nn"],
  "contempt": ["k-ah-n t-eh1-m-p-t", "nn"],
  "contemptible": ["k-ah-n t-eh1-m-p t-ah b-ah-l", "jj"],
  "contemptuous": ["k-ah-n t-eh1-m-p ch-uw ah-s", "jj"],
  "contemptuously": ["k-ah-n t-eh1-m-p ch-w-ah-s l-iy", "rb"],
  "contend": ["k-ah-n t-eh1-n-d", "vbp vb"],
  "contender": ["k-ah-n t-eh1-n d-er", "nn"],
  "content": ["k-aa1-n t-eh-n-t", "nn jj vb"],
  "contented": ["k-ah-n t-eh1-n t-ah-d", "vbn jj"],
  "contentedly": ["k-ah-n t-eh1-n t-ah-d l-iy", "rb"],
  "contention": ["k-ah-n t-eh1-n sh-ah-n", "nn"],
  "contentious": ["k-ah-n t-eh1-n sh-ah-s", "jj"],
  "contentment": ["k-ah-n t-eh1-n-t m-ah-n-t", "nn"],
  "contest": ["k-aa1-n t-eh-s-t", "nn vb"],
  "contestant": ["k-ah-n t-eh1 s-t-ah-n-t", "nn"],
  "contested": ["k-ah-n t-eh1 s-t-ah-d", "vbn jj vbd"],
  "context": ["k-aa1-n t-eh-k-s-t", "nn"],
  "contiguous": ["k-ah-n t-ih1 g-y-uw ah-s", "jj"],
  "continent": ["k-aa1-n t-ah n-ah-n-t", "nn"],
  "continental": ["k-aa-n t-ah n-eh1-n t-ah-l", "jj"],
  "continentally": ["k-aa-n t-ah n-eh1-n t-ah l-iy", "rb"],
  "contingency": ["k-ah-n t-ih1-n jh-ah-n s-iy", "nn"],
  "contingent": ["k-ah-n t-ih1-n jh-ah-n-t", "jj nn"],
  "continual": ["k-ah-n t-ih1 n-y-uw ah-l", "jj"],
  "continually": ["k-ah-n t-ih1 n-y-uw ah l-iy", "rb"],
  "continuance": ["k-ah-n t-ih1 n-y-uw ah-n-s", "nn"],
  "continuation": ["k-ah-n t-ih n-y-uw ey1 sh-ah-n", "nn"],
  "continue": ["k-ah-n t-ih1 n-y-uw", "vb vbp"],
  "continued": ["k-ah-n t-ih1 n-y-uw-d", "vbd jj vbn"],
  "continuing": ["k-ah-n t-ih1 n-y-uw ih-ng", "vbg jj"],
  "continuity": ["k-aa-n t-ah n-uw1 ah t-iy", "nn"],
  "continuous": ["k-ah-n t-ih1 n-y-uw ah-s", "jj"],
  "continuously": ["k-ah-n t-ih1 n-y-uw ah-s l-iy", "rb"],
  "continuum": ["k-ah-n t-ih1 n-y-uw ah-m", "nn"],
  "contorted": ["k-ah-n t-ao1-r t-ah-d", "jj"],
  "contortion": ["k-ah-n t-ao1-r sh-ah-n", "nn"],
  "contour": ["k-aa1-n t-uh-r", "nn"],
  "contraband": ["k-aa1-n t-r-ah b-ae-n-d", "jj nn"],
  "contraception": ["k-aa-n t-r-ah s-eh1-p sh-ah-n", "nn"],
  "contraceptive": ["k-aa-n t-r-ah s-eh1-p t-ih-v", "jj nn"],
  "contract": ["k-aa1-n t-r-ae-k-t", "nn vb vbp"],
  "contraction": ["k-ah-n t-r-ae1-k sh-ah-n", "nn"],
  "contractor": ["k-aa1-n t-r-ae-k t-er", "nn"],
  "contractual": ["k-ah-n t-r-ae1-k ch-uw ah-l", "jj"],
  "contractually": ["k-ah-n t-r-ae1-k ch-uw ah l-iy", "rb"],
  "contradict": ["k-aa-n t-r-ah d-ih1-k-t", "vb vbp"],
  "contradiction": ["k-aa-n t-r-ah d-ih1-k sh-ah-n", "nn"],
  "contradictorily": ["k-aa-n t-r-ah d-ih1-k t-er ah l-iy", "rb"],
  "contradictory": ["k-aa-n t-r-ah d-ih1-k t-er iy", "jj nn"],
  "contraption": ["k-ah-n t-r-ae1-p sh-ah-n", "nn"],
  "contrarian": ["k-aa-n t-r-eh1 r-iy ah-n", "jj nn"],
  "contrary": ["k-aa1-n t-r-eh r-iy", "jj nn"],
  "contrast": ["k-aa1-n t-r-ae-s-t", "nn vb vbp"],
  "contrasting": ["k-ah-n t-r-ae1 s-t-ih-ng", "vbg jj"],
  "contretemps": ["k-aa1-n t-r-ah t-eh-m-p-s", "nn"],
  "contribute": ["k-ah-n t-r-ih1 b-y-uw-t", "vb vbp"],
  "contributing": ["k-ah-n t-r-ih1 b-y-uw t-ih-ng", "vbg jj"],
  "contribution": ["k-aa-n t-r-ah b-y-uw1 sh-ah-n", "nn"],
  "contributor": ["k-ah-n t-r-ih1 b-y-ah t-er", "nn"],
  "contributory": ["k-ah-n t-r-ih1 b-y-ah t-ao r-iy", "jj"],
  "contrite": ["k-ah-n t-r-ay1-t", "jj"],
  "contrition": ["k-ah-n t-r-ih1 sh-ah-n", "nn"],
  "contrivance": ["k-ah-n t-r-ay1 v-ah-n-s", "nn"],
  "contrive": ["k-ah-n t-r-ay1-v", "vb"],
  "contrived": ["k-ah-n t-r-ay1-v-d", "vbn jj"],
  "control": ["k-ah-n t-r-ow1-l", "nn jj vb vbp"],
  "controllable": ["k-ah-n t-r-ow1 l-ah b-ah-l", "jj"],
  "controlled": ["k-ah-n t-r-ow1-l-d", "vbn jj vbd"],
  "controller": ["k-ah-n t-r-ow1 l-er", "nn"],
  "controlling": ["k-ah-n t-r-ow1 l-ih-ng", "vbg jj nn"],
  "controversial": ["k-aa-n t-r-ah v-er1 sh-ah-l", "jj"],
  "controversy": ["k-aa1-n t-r-ah v-er s-iy", "nn"],
  "conundrum": ["k-ah n-ah1-n d-r-ah-m", "nn"],
  "convalescence": ["k-aa-n v-ah l-eh1 s-ah-n-s", "nn"],
  "convene": ["k-ah-n v-iy1-n", "vb vbp"],
  "convenience": ["k-ah-n v-iy1 n-y-ah-n-s", "nn"],
  "convenient": ["k-ah-n v-iy1 n-y-ah-n-t", "jj"],
  "conveniently": ["k-ah-n v-iy1 n-y-ah-n-t l-iy", "rb"],
  "convent": ["k-aa1-n v-ah-n-t", "nn"],
  "convention": ["k-ah-n v-eh1-n sh-ah-n", "nn"],
  "conventional": ["k-ah-n v-eh1-n sh-ah n-ah-l", "jj"],
  "conventionally": ["k-ah-n v-eh1-n sh-ah-n ah l-iy", "rb"],
  "conventioneer": ["k-ah-n v-eh-n sh-ah n-ih1-r", "nn"],
  "converge": ["k-ah-n v-er1-jh", "vb vbp"],
  "conversant": ["k-ah-n v-er1 s-ah-n-t", "nn"],
  "conversation": ["k-aa-n v-er s-ey1 sh-ah-n", "nn"],
  "conversational": ["k-aa-n v-er s-ey1 sh-ah n-ah-l", "jj"],
  "converse": ["k-aa1-n v-er-s", "vb nn"],
  "conversely": ["k-aa1-n v-er-s l-iy", "rb"],
  "conversion": ["k-ah-n v-er1 zh-ah-n", "nn"],
  "convert": ["k-aa1-n v-er-t", "vb vbp nn"],
  "converted": ["k-ah-n v-er1 t-ih-d", "vbn jj vbd"],
  "converter": ["k-ah-n v-er1 t-er", "nn"],
  "convertibility": ["k-aa-n v-er t-ih b-ih1 l-ih t-iy", "nn"],
  "convertible": ["k-ah-n v-er1 t-ah b-ah-l", "jj nn"],
  "convex": ["k-ah-n v-eh1-k-s", "jj"],
  "convey": ["k-ah-n v-ey1", "vb vbp"],
  "conveyance": ["k-ah-n v-ey1 ah-n-s", "nn"],
  "conveyor": ["k-ah-n v-ey1 er", "nn"],
  "convict": ["k-aa1-n v-ih-k-t", "nn vb"],
  "conviction": ["k-ah-n v-ih1-k sh-ah-n", "nn"],
  "convince": ["k-ah-n v-ih1-n-s", "vb vbp"],
  "convinced": ["k-ah-n v-ih1-n-s-t", "vbn jj vbd"],
  "convincing": ["k-ah-n v-ih1-n s-ih-ng", "jj vbg"],
  "convincingly": ["k-ah-n v-ih1-n s-ih-ng l-iy", "rb"],
  "convivial": ["k-ah-n v-ih1 v-iy ah-l", "jj"],
  "convocation": ["k-aa-n v-ah k-ey1 sh-ah-n", "nn"],
  "convolute": ["k-aa1-n-v-ah-l-uw-t", "vb"],
  "convoluted": ["k-aa1-n v-ah l-uw t-ah-d", "jj vbn"],
  "convoy": ["k-aa1-n v-oy", "nn"],
  "convulsion": ["k-ah-n v-ah1-l sh-ah-n", "nn"],
  "convulsive": ["k-ah-n v-ah1-l s-ih-v", "jj"],
  "cook": ["k-uh1-k", "nn vb vbp"],
  "cookbook": ["k-uh1-k b-uh-k", "nn"],
  "cooker": ["k-uh1 k-er", "nn"],
  "cookie": ["k-uh1 k-iy", "nn"],
  "cooking": ["k-uh1 k-ih-ng", "nn vbg"],
  "cookware": ["k-uh1-k w-eh-r", "nn"],
  "cool": ["k-uw1-l", "jj vb vbp"],
  "coolant": ["k-uw1 l-ah-n-t", "nn"],
  "cooled": ["k-uw1-l-d", "vbn jj vbd"],
  "cooler": ["k-uw1 l-er", "jjr nn"],
  "coolest": ["k-uw1 l-ah-s-t", "jjs"],
  "coolly": ["k-uw1 l-iy", "rb"],
  "coolness": ["k-uw1-l n-ah-s", "nn"],
  "coop": ["k-uw1-p", "nn"],
  "cooperate": ["k-ow aa1 p-er ey-t", "vb vbp"],
  "cooperation": ["k-ow aa p-er ey1 sh-ah-n", "nn"],
  "cooperative": ["k-ow aa1 p-er ey t-ih-v", "jj nn"],
  "cooperatively": ["k-ow aa1 p-r-ah t-ih-v l-iy", "rb"],
  "coordinate": ["k-ow ao1-r d-ah-n ah-t", "vb nn vbp"],
  "coordinated": ["k-ow ao1-r d-ah n-ey t-ih-d", "vbn vbd jj"],
  "coordination": ["k-ow ao-r d-ah-n ey1 sh-ah-n", "nn"],
  "coordinator": ["k-ow ao1-r d-ah-n ey t-er", "nn"],
  "cop": ["k-aa1-p", "nn"],
  "cope": ["k-ow1-p", "vb nn"],
  "copied": ["k-aa1 p-iy-d", "vbn vbd"],
  "copier": ["k-aa1 p-iy er", "nn"],
  "copious": ["k-ow1 p-iy ah-s", "jj"],
  "copper": ["k-aa1 p-er", "nn"],
  "coppery": ["k-aa1 p-er iy", "jj nn"],
  "copy": ["k-aa1 p-iy", "nn vbp vb"],
  "copycat": ["k-aa1 p-iy k-ae-t", "nn"],
  "copyright": ["k-aa1 p-iy r-ay-t", "nn vb"],
  "copywriter": ["k-aa1 p-iy r-ay t-er", "nn"],
  "coral": ["k-ao1 r-ah-l", "jj"],
  "cord": ["k-ao1-r-d", "nn"],
  "corded": ["k-ao1-r d-ah-d", "vbn jj"],
  "cordial": ["k-ao1-r jh-ah-l", "jj nn"],
  "cordless": ["k-ao1-r-d l-ah-s", "jj"],
  "cordon": ["k-ao1-r d-ah-n", "nn vb"],
  "corduroy": ["k-ao1-r d-er oy", "nn"],
  "core": ["k-ao1-r", "nn"],
  "coriander": ["k-ao r-iy ae1-n d-er", "nn"],
  "corinthian": ["k-er ih1-n th-iy ah-n", "jj"],
  "cork": ["k-ao1-r-k", "nn"],
  "corkscrew": ["k-ao1-r-k s-k-r-uw", "nn"],
  "corn": ["k-ao1-r-n", "nn"],
  "cornea": ["k-ao1-r n-iy ah", "nn"],
  "corneal": ["k-ao-r n-iy1-l", "jj"],
  "corner": ["k-ao1-r n-er", "nn vb"],
  "cornered": ["k-ao1-r n-er-d", "vbn vbd jj"],
  "cornerstone": ["k-ao1-r n-er s-t-ow-n", "nn"],
  "cornfield": ["k-ao1-r-n f-iy-l-d", "nn"],
  "cornmeal": ["k-ao1-r-n m-iy-l", "nn"],
  "cornstarch": ["k-ao1-r-n s-t-aa-r-ch", "nn"],
  "cornucopia": ["k-ao-r n-ah k-ow1 p-iy ah", "nn"],
  "corny": ["k-ao1-r n-iy", "jj"],
  "corollary": ["k-ao1 r-ah l-eh r-iy", "nn"],
  "corona": ["k-er ow1 n-ah", "nn"],
  "coronary": ["k-ao1 r-ah n-eh r-iy", "jj"],
  "coroner": ["k-ao1 r-ah n-er", "nn"],
  "corporal": ["k-ao1-r p-er ah-l", "nn"],
  "corporate": ["k-ao1-r p-er ah-t", "jj"],
  "corporatewide": ["k-ao1-r p-er ih-t w-ay-d", "jj"],
  "corporation": ["k-ao-r p-er ey1 sh-ah-n", "nn"],
  "corporatist": ["k-ao1-r p-er ah t-ih-s-t", "nn"],
  "corpse": ["k-ao1-r-p-s", "nn"],
  "corpus": ["k-ao1-r p-ah-s", "nn"],
  "corral": ["k-er ae1-l", "nn vb"],
  "correct": ["k-er eh1-k-t", "jj vbp vb"],
  "corrected": ["k-er eh1-k t-ah-d", "vbn vbd jj"],
  "correction": ["k-er eh1-k sh-ah-n", "nn"],
  "correctional": ["k-er eh1-k sh-ah n-ah-l", "jj"],
  "corrective": ["k-er eh1-k t-ih-v", "jj"],
  "correctly": ["k-er eh1-k-t l-iy", "rb"],
  "correctness": ["k-er eh1-k-t n-ah-s", "nn"],
  "correlate": ["k-ao1 r-ah l-ey-t", "vb vbp"],
  "correlated": ["k-ao1 r-ah l-ey t-ah-d", "jj vbd vbn"],
  "correlation": ["k-ao r-ah l-ey1 sh-ah-n", "nn"],
  "correspond": ["k-ao r-ah s-p-aa1-n-d", "vb vbp"],
  "correspondence": ["k-ao r-ah s-p-aa1-n d-ah-n-s", "nn"],
  "correspondent": ["k-ao r-ah s-p-aa1-n d-ah-n-t", "nn"],
  "corresponding": ["k-ao r-ah s-p-aa1-n d-ih-ng", "jj vbg"],
  "correspondingly": ["k-ao r-ah s-p-aa1-n d-ih-ng l-iy", "rb"],
  "corridor": ["k-ao1 r-ah d-er", "nn"],
  "corroborate": ["k-er aa1 b-er ey-t", "vb vbp"],
  "corrode": ["k-er ow1-d", "vbp vb"],
  "corrosion": ["k-er ow1 zh-ah-n", "nn"],
  "corrosive": ["k-er ow1 s-ih-v", "jj"],
  "corrugate": ["k-ao1-r-ah-g-ey-t", "vb"],
  "corrugated": ["k-ao1 r-ah g-ey t-ah-d", "jj vbn"],
  "corrupt": ["k-er ah1-p-t", "jj vb"],
  "corrupting": ["k-er ah1-p t-ih-ng", "vbg jj nn"],
  "corruption": ["k-er ah1-p sh-ah-n", "nn"],
  "corsage": ["k-ao-r s-aa1-zh", "nn"],
  "corset": ["k-ao1-r s-ah-t", "nn"],
  "cortex": ["k-ao1-r t-eh-k-s", "nn"],
  "cortisone": ["k-ao1-r t-ah z-ow-n", "nn"],
  "corvette": ["k-ao-r v-eh1-t", "nn"],
  "cosmetic": ["k-aa-z m-eh1 t-ih-k", "jj nn"],
  "cosmetology": ["k-aa-z m-ah t-aa1 l-ah jh-iy", "nn"],
  "cosmic": ["k-aa1-z m-ih-k", "jj"],
  "cosmopolitan": ["k-aa-z m-ah p-aa1 l-ah t-ah-n", "jj"],
  "cosmos": ["k-aa1-z m-ow-s", "nn"],
  "cost": ["k-aa1-s-t", "nn vbp vb vbd vbn"],
  "costlier": ["k-ao1-s-t l-iy er", "jjr"],
  "costliest": ["k-ao1-s-t l-iy ih-s-t", "jjs"],
  "costly": ["k-aa1-s-t l-iy", "jj rb"],
  "costume": ["k-aa s-t-uw1-m", "nn vb"],
  "cot": ["k-aa1-t", "nn"],
  "coterie": ["k-ow1 t-er iy", "nn"],
  "cottage": ["k-aa1 t-ah-jh", "nn"],
  "cotton": ["k-aa1 t-ah-n", "nn"],
  "cottonmouth": ["k-aa1 t-ah-n m-aw-th", "nn"],
  "cottonseed": ["k-aa1 t-ah-n s-iy-d", "nn"],
  "couch": ["k-aw1-ch", "nn"],
  "cough": ["k-aa1-f", "nn vb"],
  "could": ["k-uh1-d", "md vbd"],
  "couldn't": ["k-uh1-d-ah-n-t", "md"],
  "council": ["k-aw1-n s-ah-l", "nn"],
  "councilman": ["k-aw1-n s-ah-l m-ah-n", "nn"],
  "councilor": ["k-aw1-n s-ah-l er", "nn"],
  "counsel": ["k-aw1-n s-ah-l", "nn vb vbp"],
  "counselor": ["k-aw1-n s-ah-l er", "nn"],
  "count": ["k-aw1-n-t", "nn vb vbp"],
  "countdown": ["k-aw1-n-t d-aw-n", "nn"],
  "countenance": ["k-aw1-n t-ah n-ah-n-s", "nn vb"],
  "counter": ["k-aw1-n t-er", "nn vb vbp"],
  "counteract": ["k-aw1-n t-er ae-k-t", "vb"],
  "counterattack": ["k-aw1-n t-er ah t-ae-k", "nn vb"],
  "counterbalance": ["k-aw1-n t-er b-ae l-ah-n-s", "vb nn"],
  "countercultural": ["k-aw-n t-er k-ah1-l ch-er ah-l", "jj"],
  "counterculture": ["k-aw1-n t-er k-ah-l ch-er", "jj"],
  "counterfeit": ["k-aw1-n t-er f-ih-t", "jj"],
  "counterforce": ["k-aw1-n t-er f-ao-r-s", "nn"],
  "countermeasure": ["k-aw1-n t-er m-eh zh-er", "nn"],
  "counteroffer": ["k-aw1-n t-er ao f-er", "nn"],
  "counterpart": ["k-aw1-n t-er p-aa-r-t", "nn jj"],
  "counterpoint": ["k-aw1-n t-er p-oy-n-t", "nn"],
  "countersue": ["k-aw1-n-t-er-s-uw", "vb"],
  "countersuit": ["k-aw1-n t-er s-uw-t", "nn"],
  "countertenor": ["k-aw1-n t-er t-eh n-er", "nn"],
  "counterterrorism": ["k-aw1-n t-er t-eh r-er ih z-ah-m", "nn"],
  "countertop": ["k-aw1-n t-er t-aa-p", "nn"],
  "counterweight": ["k-aw1-n t-er w-ey-t", "nn"],
  "countess": ["k-aw1-n t-ah-s", "nn"],
  "countless": ["k-aw1-n-t l-ah-s", "jj"],
  "country": ["k-ah1-n t-r-iy", "nn"],
  "countryman": ["k-ah1-n t-r-iy m-ah-n", "nn"],
  "countryside": ["k-ah1-n t-r-iy s-ay-d", "nn"],
  "county": ["k-aw1-n t-iy", "nn"],
  "coup": ["k-uw1", "nn"],
  "coupe": ["k-uw1-p", "nn"],
  "couple": ["k-ah1 p-ah-l", "nn jj vb"],
  "coupler": ["k-ah1-p l-er", "nn"],
  "coupon": ["k-uw1 p-ao-n", "nn"],
  "couponing": ["k-uw1 p-aa n-ih-ng", "nn"],
  "courage": ["k-er1 ah-jh", "nn"],
  "courageous": ["k-er ey1 jh-ah-s", "jj"],
  "courageously": ["k-er ey1 jh-ah-s l-iy", "rb"],
  "courier": ["k-er1 iy er", "nn"],
  "course": ["k-ao1-r-s", "nn rb vb"],
  "court": ["k-ao1-r-t", "nn vbp vb"],
  "courteous": ["k-er1 t-iy ah-s", "jj"],
  "courtesy": ["k-er1 t-ah s-iy", "nn"],
  "courthouse": ["k-ao1-r-t hh-aw-s", "nn"],
  "courtier": ["k-ao1-r t-iy er", "nn"],
  "courtly": ["k-ao1-r-t l-iy", "jj"],
  "courtroom": ["k-ao1-r-t r-uw-m", "nn"],
  "courtship": ["k-ao1-r ch-ih-p", "nn"],
  "courtyard": ["k-ao1-r-t y-aa-r-d", "nn"],
  "cousin": ["k-ah1 z-ah-n", "nn"],
  "couture": ["k-uw t-uh1-r", "nn"],
  "cove": ["k-ow1-v", "nn"],
  "covenant": ["k-ah1 v-ah n-ah-n-t", "nn vb"],
  "cover": ["k-ah1 v-er", "vb nn vbp"],
  "coverage": ["k-ah1 v-er ah-jh", "nn"],
  "covered": ["k-ah1 v-er-d", "vbn jj vbd"],
  "covert": ["k-ow1 v-er-t", "jj"],
  "covertly": ["k-ah1 v-er-t l-iy", "rb"],
  "coverup": ["k-ah1 v-er ah-p", "nn"],
  "covet": ["k-ah1 v-ah-t", "vb vbp"],
  "coveted": ["k-ah1 v-ah t-ih-d", "vbn jj"],
  "cow": ["k-aw1", "nn vb"],
  "coward": ["k-aw1 er-d", "nn"],
  "cowardice": ["k-aw1 er d-ah-s", "nn"],
  "cowardly": ["k-aw1 er-d l-iy", "jj"],
  "cowboy": ["k-aw1 b-oy", "nn"],
  "cower": ["k-aw1 er", "vbp vb"],
  "coworker": ["k-ow1 w-er1 k-er", "nn"],
  "coy": ["k-oy1", "jj"],
  "coyly": ["k-oy1 l-iy", "rb"],
  "coyote": ["k-ay ow1 t-iy", "nn"],
  "coziness": ["k-ow1 z-iy n-ah-s", "nn"],
  "cozy": ["k-ow1 z-iy", "jj rb"],
  "crab": ["k-r-ae1-b", "nn"],
  "crabbed": ["k-r-ae1-b-d", "jj"],
  "crabby": ["k-r-ae1 b-iy", "jj"],
  "crabmeat": ["k-r-ae1-b m-iy-t", "nn"],
  "crack": ["k-r-ae1-k", "nn jj vb vbp"],
  "crackdown": ["k-r-ae1-k d-aw-n", "nn"],
  "cracked": ["k-r-ae1-k-t", "vbd vbn jj"],
  "cracker": ["k-r-ae1 k-er", "nn"],
  "cracking": ["k-r-ae1 k-ih-ng", "vbg jj nn"],
  "crackle": ["k-r-ae1 k-ah-l", "nn vb vbp"],
  "crackling": ["k-r-ae1 k-l-ih-ng", "nn"],
  "crackpot": ["k-r-ae1-k p-aa-t", "nn"],
  "cradle": ["k-r-ey1 d-ah-l", "nn vb"],
  "craft": ["k-r-ae1-f-t", "nn vb"],
  "craftsman": ["k-r-ae1-f-t-s m-ah-n", "nn"],
  "craftsmanship": ["k-r-ae1-f-t-s m-ah-n sh-ih-p", "nn"],
  "crafty": ["k-r-ae1-f t-iy", "jj"],
  "craggy": ["k-r-ae1 g-iy", "jj"],
  "cram": ["k-r-ae1-m", "vb"],
  "cramp": ["k-r-ae1-m-p", "nn"],
  "cramped": ["k-r-ae1-m-p-t", "jj"],
  "cranberry": ["k-r-ae1-n b-eh r-iy", "nn"],
  "crane": ["k-r-ey1-n", "nn vb"],
  "crank": ["k-r-ae1-ng-k", "vb nn"],
  "crankshaft": ["k-r-ae1-ng-k sh-ae-f-t", "nn"],
  "cranky": ["k-r-ae1-ng k-iy", "jj"],
  "cranny": ["k-r-ae1 n-iy", "nn"],
  "crap": ["k-r-ae1-p", "nn uh"],
  "crapshoot": ["k-r-ae1-p sh-uw-t", "nn vb"],
  "crash": ["k-r-ae1-sh", "nn vbp jj vb"],
  "crashed": ["k-r-ae1-sh-t", "vbd jj vbn"],
  "crass": ["k-r-ae1-s", "jj"],
  "crate": ["k-r-ey1-t", "nn"],
  "crater": ["k-r-ey1 t-er", "nn vb"],
  "crave": ["k-r-ey1-v", "vbp vb"],
  "craven": ["k-r-ey1 v-ah-n", "jj"],
  "craving": ["k-r-ey1 v-ih-ng", "nn vbg"],
  "crawl": ["k-r-ao1-l", "vb nn"],
  "crayon": ["k-r-ey1 aa-n", "nn"],
  "craze": ["k-r-ey1-z", "nn vb"],
  "crazed": ["k-r-ey1-z-d", "jj vbd"],
  "crazily": ["k-r-ey1 z-ah l-iy", "rb"],
  "craziness": ["k-r-ey1 z-iy n-ah-s", "nn"],
  "crazy": ["k-r-ey1 z-iy", "jj"],
  "creak": ["k-r-iy1-k", "vb"],
  "cream": ["k-r-iy1-m", "nn jj vb"],
  "creamer": ["k-r-iy1 m-er", "nn"],
  "creamier": ["k-r-iy1 m-iy er", "jjr"],
  "creamy": ["k-r-iy1 m-iy", "jj"],
  "crease": ["k-r-iy1-s", "nn"],
  "create": ["k-r-iy ey1-t", "vb vbp"],
  "created": ["k-r-iy ey1 t-ah-d", "vbn vbd jj"],
  "creation": ["k-r-iy ey1 sh-ah-n", "nn"],
  "creationism": ["k-r-iy ey1 sh-ah-n ih z-ah-m", "nn"],
  "creative": ["k-r-iy ey1 t-ih-v", "jj"],
  "creatively": ["k-r-iy ey1 t-ih-v l-iy", "rb"],
  "creativeness": ["k-r-iy ey1 t-ih-v n-ah-s", "nn"],
  "creativity": ["k-r-iy ey t-ih1 v-ah t-iy", "nn"],
  "creator": ["k-r-iy ey1 t-er", "nn"],
  "creature": ["k-r-iy1 ch-er", "nn"],
  "credence": ["k-r-iy1 d-ah-n-s", "nn"],
  "credential": ["k-r-ih d-eh1-n ch-ah-l", "nn"],
  "credibility": ["k-r-eh d-ah b-ih1 l-ih t-iy", "nn"],
  "credible": ["k-r-eh1 d-ah b-ah-l", "jj"],
  "credibly": ["k-r-eh1 d-ah b-l-iy", "rb"],
  "credit": ["k-r-eh1 d-ah-t", "nn vb vbp"],
  "creditable": ["k-r-eh1 d-ah t-ah b-ah-l", "jj"],
  "creditably": ["k-r-eh1 d-ah t-ah b-l-iy", "rb"],
  "creditor": ["k-r-eh1 d-ah t-er", "nn"],
  "creditworthy": ["k-r-eh1 d-ih-t w-er dh-iy", "nn"],
  "credo": ["k-r-ey1 d-ow", "nn"],
  "credulity": ["k-r-ih d-uw1 l-ah t-iy", "nn"],
  "creed": ["k-r-iy1-d", "nn"],
  "creek": ["k-r-iy1-k", "nn"],
  "creep": ["k-r-iy1-p", "vb vbp jj nn"],
  "creeping": ["k-r-iy1 p-ih-ng", "vbg jj"],
  "creepy": ["k-r-iy1 p-iy", "jj"],
  "cremate": ["k-r-iy1 m-ey-t", "vb"],
  "cremation": ["k-r-iy m-ey1 sh-ah-n", "nn"],
  "creole": ["k-r-iy1 ow-l", "nn"],
  "crepe": ["k-r-ey1-p", "jj"],
  "crept": ["k-r-eh1-p-t", "vbd vbn"],
  "crescendo": ["k-r-ih sh-eh1-n d-ow", "nn"],
  "crescent": ["k-r-eh1 s-ah-n-t", "nn"],
  "crest": ["k-r-eh1-s-t", "nn vb"],
  "crested": ["k-r-eh1 s-t-ah-d", "jj"],
  "crestfallen": ["k-r-eh1-s-t f-ao l-ah-n", "jj"],
  "crevice": ["k-r-eh1 v-ah-s", "nn"],
  "crew": ["k-r-uw1", "nn"],
  "crewel": ["k-r-uw1 ah-l", "nn"],
  "crib": ["k-r-ih1-b", "nn jj"],
  "cricket": ["k-r-ih1 k-ah-t", "nn"],
  "cried": ["k-r-ay1-d", "vbd vbn"],
  "crime": ["k-r-ay1-m", "nn"],
  "criminal": ["k-r-ih1 m-ah n-ah-l", "jj nn"],
  "criminality": ["k-r-ih m-ah n-ae1 l-ih t-iy", "nn"],
  "criminalize": ["k-r-ih1 m-ah n-ah l-ay-z", "vb"],
  "criminally": ["k-r-ih1 m-ah n-ah l-iy", "rb"],
  "criminologist": ["k-r-ih m-ih n-aa1 l-ah jh-ih-s-t", "nn"],
  "criminology": ["k-r-ih m-ih n-aa1 l-ah jh-iy", "nn"],
  "crimp": ["k-r-ih1-m-p", "vb nn"],
  "crimped": ["k-r-ih1-m-p-t", "jj vbn"],
  "crimson": ["k-r-ih1-m z-ah-n", "jj nn"],
  "cringe": ["k-r-ih1-n-jh", "vbp vb"],
  "cripple": ["k-r-ih1 p-ah-l", "vb nn vbp"],
  "crippled": ["k-r-ih1 p-ah-l-d", "vbn jj vbd"],
  "crippling": ["k-r-ih1 p-ah-l ih-ng", "jj vbg"],
  "crisis": ["k-r-ay1 s-ah-s", "nn"],
  "crisp": ["k-r-ih1-s-p", "jj nn"],
  "crisper": ["k-r-ih1 s-p-er", "nn"],
  "crisply": ["k-r-ih1-s-p l-iy", "rb"],
  "crispness": ["k-r-ih1-s-p n-ah-s", "nn"],
  "crispy": ["k-r-ih1 s-p-iy", "jj"],
  "crisscross": ["k-r-ih1-s k-r-ao-s", "vb vbp"],
  "criterion": ["k-r-ay t-ih1 r-iy ah-n", "nn"],
  "critic": ["k-r-ih1 t-ih-k", "nn"],
  "critical": ["k-r-ih1 t-ih k-ah-l", "jj"],
  "criticality": ["k-r-ih t-ah k-ae1 l-ah t-iy", "nn"],
  "critically": ["k-r-ih1 t-ih k-ah l-iy", "rb"],
  "criticism": ["k-r-ih1 t-ih s-ih z-ah-m", "nn"],
  "criticize": ["k-r-ih1 t-ih s-ay-z", "vb vbp"],
  "critique": ["k-r-ah t-iy1-k", "nn"],
  "critter": ["k-r-ih1 t-er", "nn"],
  "croak": ["k-r-ow1-k", "nn vb vbp"],
  "croaking": ["k-r-ow1 k-ih-ng", "nn"],
  "crochet": ["k-r-ow sh-ey1", "vb"],
  "crocodile": ["k-r-aa1 k-ah d-ay-l", "nn"],
  "croissant": ["k-w-aa s-aa1-n-t", "nn"],
  "crone": ["k-r-ow1-n", "nn"],
  "crony": ["k-r-ow1 n-iy", "nn"],
  "cronyism": ["k-r-ow1 n-iy ih z-ah-m", "nn"],
  "crook": ["k-r-uh1-k", "nn"],
  "crooked": ["k-r-uh1 k-ah-d", "jj"],
  "croon": ["k-r-uw1-n", "vb"],
  "crooner": ["k-r-uw1 n-er", "nn"],
  "crop": ["k-r-aa1-p", "nn rp vb vbp"],
  "cross": ["k-r-ao1-s", "vb jj nn rb vbp"],
  "crossborder": ["k-r-ao1-s b-ao-r d-er", "jj"],
  "crosscurrent": ["k-r-ao1-s k-er ah-n-t", "nn"],
  "crossfire": ["k-r-ao1-s f-ay-r", "nn"],
  "crossover": ["k-r-ao1-s ow v-er", "nn"],
  "crossroads": ["k-r-ao1-s r-ow-d-z", "nn"],
  "crosswise": ["k-r-ao1-s w-ay-z", "rb"],
  "crotch": ["k-r-aa1-ch", "nn"],
  "crotchety": ["k-r-aa1 ch-ah t-iy", "jj"],
  "crouch": ["k-r-aw1-ch", "nn vb"],
  "crow": ["k-r-ow1", "nn vb"],
  "crowd": ["k-r-aw1-d", "nn vbp vb"],
  "crowded": ["k-r-aw1 d-ah-d", "vbn vbd jj"],
  "crown": ["k-r-aw1-n", "nn vb"],
  "crowning": ["k-r-aw1 n-ih-ng", "jj vbg"],
  "crucial": ["k-r-uw1 sh-ah-l", "jj"],
  "crucially": ["k-r-uw1 sh-ah l-l-iy", "rb"],
  "crucible": ["k-r-uw1 s-ah b-ah-l", "nn"],
  "crucified": ["k-r-uw1 s-ah f-ay-d", "vbd vbn"],
  "crucifix": ["k-r-uw1 s-ah f-ih-k-s", "nn"],
  "crucifixion": ["k-r-uw s-ih f-ih1-k sh-ah-n", "nn"],
  "crucify": ["k-r-uw1-s-ah-f-ay", "vb"],
  "crude": ["k-r-uw1-d", "nn jj"],
  "crudely": ["k-r-uw1-d l-iy", "rb"],
  "cruel": ["k-r-uw1 ah-l", "jj"],
  "cruelest": ["k-r-uw1 l-ah-s-t", "jjs"],
  "cruelly": ["k-r-uw1 l-iy", "rb"],
  "cruelty": ["k-r-uw1-l t-iy", "nn"],
  "cruise": ["k-r-uw1-z", "nn vb vbp"],
  "cruiser": ["k-r-uw1 z-er", "nn"],
  "crumble": ["k-r-ah1-m b-ah-l", "vb"],
  "crumbled": ["k-r-ah1-m b-ah-l-d", "vbd vbn jj"],
  "crumbling": ["k-r-ah1-m b-ah-l ih-ng", "vbg jj"],
  "crummy": ["k-r-ah1 m-iy", "jj"],
  "crumple": ["k-r-ah1-m-p-ah-l", "vb"],
  "crumpled": ["k-r-ah1-m p-ah-l-d", "jj vbd vbn"],
  "crunch": ["k-r-ah1-n-ch", "nn vb"],
  "crusade": ["k-r-uw s-ey1-d", "nn vb"],
  "crusader": ["k-r-uw s-ey1 d-er", "nn"],
  "crush": ["k-r-ah1-sh", "nn vb"],
  "crushed": ["k-r-ah1-sh-t", "vbn jj vbd"],
  "crusher": ["k-r-ah1 sh-er", "nn"],
  "crushing": ["k-r-ah1 sh-ih-ng", "vbg jj nn"],
  "crust": ["k-r-ah1-s-t", "nn"],
  "crusty": ["k-r-ah1 s-t-iy", "jj"],
  "crutch": ["k-r-ah1-ch", "nn"],
  "crux": ["k-r-ah1-k-s", "nn"],
  "cry": ["k-r-ay1", "nn vb vbp"],
  "crypt": ["k-r-ih1-p-t", "nn"],
  "cryptic": ["k-r-ih1-p t-ih-k", "jj"],
  "crystal": ["k-r-ih1 s-t-ah-l", "nn jj"],
  "crystalline": ["k-r-ih1 s-t-ah l-ay-n", "jj"],
  "crystallize": ["k-r-ih1 s-t-ah l-ay-z", "vb"],
  "crystallography": ["k-r-ih s-t-ah l-aa1 g-r-ah f-iy", "nn"],
  "cub": ["k-ah1-b", "nn"],
  "cubbyhole": ["k-ah1 b-iy hh-ow-l", "nn"],
  "cube": ["k-y-uw1-b", "nn"],
  "cubic": ["k-y-uw1 b-ih-k", "jj"],
  "cubism": ["k-y-uw1 b-ih z-ah-m", "nn"],
  "cubist": ["k-y-uw1 b-ih-s-t", "jj"],
  "cuckoo": ["k-ah1 k-uw", "nn"],
  "cucumber": ["k-y-uw1 k-ah-m b-er", "nn"],
  "cuddle": ["k-ah1-d-ah-l", "vb"],
  "cuddly": ["k-ah1-d l-iy", "jj"],
  "cudgel": ["k-ah1 jh-ah-l", "nn"],
  "cue": ["k-y-uw1", "nn vb"],
  "cuff": ["k-ah1-f", "nn vb"],
  "cuisine": ["k-w-ih z-iy1-n", "nn"],
  "cul": ["k-ah1-l", "nn"],
  "culinary": ["k-y-uw1 l-ih n-eh r-iy", "jj"],
  "cull": ["k-ah1-l", "vb vbp"],
  "culminate": ["k-ah1-l m-ih n-ey-t", "vb vbp"],
  "culmination": ["k-ah-l m-ah n-ey1 sh-ah-n", "nn"],
  "culpable": ["k-ah1-l p-ah b-ah-l", "jj"],
  "culprit": ["k-ah1-l p-r-ih-t", "nn"],
  "cult": ["k-ah1-l-t", "nn"],
  "cultist": ["k-ah1-l t-ah-s-t", "nn"],
  "cultivate": ["k-ah1-l t-ah v-ey-t", "vb"],
  "cultivated": ["k-ah1-l t-ah v-ey t-ah-d", "vbn jj vbd"],
  "cultivation": ["k-ah-l t-ih v-ey1 sh-ah-n", "nn"],
  "cultural": ["k-ah1-l ch-er ah-l", "jj"],
  "culturally": ["k-ah1-l ch-er ah l-iy", "rb"],
  "culture": ["k-ah1-l ch-er", "nn vb"],
  "cultured": ["k-ah1-l ch-er-d", "jj vbn"],
  "cumbersome": ["k-ah1-m b-er s-ah-m", "jj"],
  "cumulative": ["k-y-uw1 m-y-ah l-ah t-ih-v", "jj"],
  "cumulatively": ["k-y-uw1 m-y-ah l-ah t-ih-v l-iy", "rb"],
  "cunning": ["k-ah1 n-ih-ng", "jj nn"],
  "cup": ["k-ah1-p", "nn vb"],
  "cupboard": ["k-ah1 b-er-d", "nn"],
  "cupid": ["k-y-uw1 p-ih-d", "nn"],
  "curative": ["k-y-uh1 r-ah t-ih-v", "jj"],
  "curator": ["k-y-uh r-ey1 t-er", "nn"],
  "curb": ["k-er1-b", "vb nn"],
  "curbside": ["k-er1-b s-ay-d", "nn jj"],
  "curd": ["k-er1-d", "nn"],
  "cure": ["k-y-uh1-r", "nn vbp vb"],
  "curfew": ["k-er1 f-y-uw", "nn"],
  "curiosity": ["k-y-uh r-iy aa1 s-ah t-iy", "nn"],
  "curious": ["k-y-uh1 r-iy ah-s", "jj"],
  "curiously": ["k-y-uh1 r-iy ah-s l-iy", "rb"],
  "curl": ["k-er1-l", "vb vbp"],
  "curly": ["k-er1 l-iy", "jj"],
  "currency": ["k-er1 ah-n s-iy", "nn"],
  "current": ["k-er1 ah-n-t", "jj nn"],
  "currently": ["k-er1 ah-n-t l-iy", "rb jj"],
  "curricular": ["k-er ih1 k-y-ah l-er", "jj"],
  "curriculum": ["k-er ih1 k-y-ah l-ah-m", "nn"],
  "curry": ["k-ah1 r-iy", "vb nn"],
  "curse": ["k-er1-s", "nn vb"],
  "cursory": ["k-er1 s-er iy", "jj"],
  "curt": ["k-er1-t", "jj"],
  "curtail": ["k-er t-ey1-l", "vb vbp"],
  "curtailment": ["k-er t-ey1-l m-ah-n-t", "nn"],
  "curtain": ["k-er1 t-ah-n", "nn"],
  "curtly": ["k-er1-t l-iy", "rb"],
  "curve": ["k-er1-v", "nn vb"],
  "curved": ["k-er1-v-d", "jj vbn"],
  "curvy": ["k-er1 v-iy", "jj"],
  "cushion": ["k-uh1 sh-ah-n", "nn vb"],
  "cusp": ["k-ah1-s-p", "nn"],
  "custodial": ["k-ah s-t-ow1 d-iy ah-l", "jj"],
  "custodian": ["k-ah s-t-ow1 d-iy ah-n", "nn"],
  "custody": ["k-ah1 s-t-ah d-iy", "nn"],
  "custom": ["k-ah1 s-t-ah-m", "nn jj rb"],
  "customarily": ["k-ah s-t-ah m-eh1 r-ah l-iy", "rb"],
  "customary": ["k-ah1 s-t-ah m-eh r-iy", "jj"],
  "customer": ["k-ah1 s-t-ah m-er", "nn"],
  "customize": ["k-ah1-s-t-ah-m-ay-z", "vb"],
  "customized": ["k-ah1 s-t-ah m-ay-z-d", "vbn jj"],
  "cut": ["k-ah1-t", "vb vbd vbn vbp jj nn"],
  "cutback": ["k-ah1-t b-ae-k", "nn"],
  "cute": ["k-y-uw1-t", "jj"],
  "cuteness": ["k-y-uw1-t n-ah-s", "nn"],
  "cutlass": ["k-ah1-t l-ah-s", "nn"],
  "cutlery": ["k-ah1-t l-er iy", "nn"],
  "cutoff": ["k-ah1 t-ao-f", "nn jj"],
  "cutout": ["k-ah1-t aw-t", "nn"],
  "cutter": ["k-ah1 t-er", "nn"],
  "cutthroat": ["k-ah1-t th-r-ow-t", "jj"],
  "cutting": ["k-ah1 t-ih-ng", "vbg jj"],
  "cyanide": ["s-ay1 ah n-ay-d", "nn"],
  "cycle": ["s-ay1 k-ah-l", "nn vb"],
  "cyclical": ["s-ay1 k-l-ih k-ah-l", "jj"],
  "cyclicality": ["s-ih k-l-ih k-ae1 l-ih t-iy", "nn"],
  "cyclist": ["s-ay1 k-ah l-ih-s-t", "nn"],
  "cylinder": ["s-ih1 l-ah-n d-er", "nn"],
  "cylindrical": ["s-ah l-ih1-n d-r-ih k-ah-l", "jj"],
  "cynic": ["s-ih1 n-ih-k", "nn jj"],
  "cynical": ["s-ih1 n-ih k-ah-l", "jj"],
  "cynically": ["s-ih1 n-ih k-ah l-iy", "rb"],
  "cynicism": ["s-ih1 n-ih s-ih z-ah-m", "nn"],
  "cypress": ["s-ay1 p-r-ah-s", "nn"],
  "cyst": ["s-ih1-s-t", "nn"],
  "cystic": ["s-ih1 s-t-ih-k", "jj"],
  "cytoplasm": ["s-ay1 t-ah p-l-ae z-ah-m", "nn"],
  "czar": ["z-aa1-r", "nn"],
  "dabble": ["d-ae1 b-ah-l", "vb"],
  "dad": ["d-ae1-d", "nn"],
  "dada": ["d-aa1 d-aa", "nn"],
  "daddy": ["d-ae1 d-iy", "nn"],
  "daffodil": ["d-ae1 f-ah d-ih-l", "nn"],
  "daft": ["d-ae1-f-t", "jj"],
  "daily": ["d-ey1 l-iy", "jj nn rb"],
  "dainty": ["d-ey1-n t-iy", "jj"],
  "dairy": ["d-eh1 r-iy", "nn jj"],
  "dais": ["d-ey1-z", "nn"],
  "daisy": ["d-ey1 z-iy", "nn"],
  "dale": ["d-ey1-l", "nn"],
  "dally": ["d-ae1 l-iy", "vb"],
  "dam": ["d-ae1-m", "nn jj uh"],
  "damage": ["d-ae1 m-ah-jh", "nn vbp vb"],
  "damaged": ["d-ae1 m-ah-jh-d", "vbn jj vbd"],
  "damaging": ["d-ae1 m-ih jh-ih-ng", "jj vbg"],
  "dame": ["d-ey1-m", "nn"],
  "daminozide": ["d-ae m-ih1 n-ah z-ay-d", "nn"],
  "dammed": ["d-ae1-m-d", "vbd"],
  "damn": ["d-ae1-m", "jj nn rb vb uh"],
  "damnation": ["d-ae-m n-ey1 sh-ah-n", "nn"],
  "damned": ["d-ae1-m-d", "jj vbn rb"],
  "damp": ["d-ae1-m-p", "vb vbp jj nn"],
  "dampen": ["d-ae1-m p-ah-n", "vb"],
  "dampening": ["d-ae1-m p-ah n-ih-ng", "jj"],
  "damper": ["d-ae1-m p-er", "nn"],
  "damping": ["d-ae1-m p-ih-ng", "vbg jj"],
  "damsel": ["d-ae1-m z-ah-l", "nn"],
  "dance": ["d-ae1-n-s", "nn vb vbp"],
  "dancer": ["d-ae1-n s-er", "nn"],
  "dandelion": ["d-ae1-n d-ah l-ay ah-n", "nn"],
  "dandy": ["d-ae1-n d-iy", "jj"],
  "dang": ["d-ae1-ng", "jj"],
  "danger": ["d-ey1-n jh-er", "nn"],
  "dangerous": ["d-ey1-n jh-er ah-s", "jj"],
  "dangerously": ["d-ey1-n jh-er ah-s l-iy", "rb"],
  "dangle": ["d-ae1-ng g-ah-l", "vb"],
  "dangling": ["d-ae1-ng g-ah l-ih-ng", "vbg jj"],
  "dank": ["d-ae1-ng-k", "jj"],
  "dapper": ["d-ae1 p-er", "jj"],
  "dare": ["d-eh1-r", "vb vbp nn"],
  "darin": ["d-ae1 r-ih-n", "jj"],
  "daring": ["d-eh1 r-ih-ng", "jj vbg"],
  "dark": ["d-aa1-r-k", "jj nn rb"],
  "darken": ["d-aa1-r k-ah-n", "vb vbp"],
  "darkened": ["d-aa1-r k-ah-n-d", "vbd vbn jj"],
  "darker": ["d-aa1-r k-er", "jjr"],
  "darkest": ["d-aa1-r k-ah-s-t", "jjs"],
  "darkly": ["d-aa1-r-k l-iy", "rb"],
  "darkness": ["d-aa1-r-k n-ah-s", "nn"],
  "darkroom": ["d-aa1-r-k r-uw-m", "nn"],
  "darling": ["d-aa1-r l-ih-ng", "nn jj"],
  "darn": ["d-aa1-r-n", "jj vb"],
  "darned": ["d-aa1-r-n-d", "rb"],
  "dart": ["d-aa1-r-t", "nn vb vbp"],
  "dartboard": ["d-aa1-r-t b-ao-r-d", "nn"],
  "dash": ["d-ae1-sh", "nn vb"],
  "dashboard": ["d-ae1-sh b-ao-r-d", "nn"],
  "dashed": ["d-ae1-sh-t", "vbn jj vbd"],
  "dashing": ["d-ae1 sh-ih-ng", "vbg jj"],
  "dastardly": ["d-ae1 s-t-er-d l-iy", "jj"],
  "database": ["d-ey1 t-ah b-ey-s", "nn"],
  "date": ["d-ey1-t", "nn vbp vb"],
  "dated": ["d-ey1 t-ih-d", "vbn jj vbd"],
  "datum": ["d-ae1 t-ah-m", "nn"],
  "daub": ["d-ao1-b", "vb"],
  "daughter": ["d-ao1 t-er", "nn"],
  "daunt": ["d-ao1-n-t", "vb"],
  "daunted": ["d-ao1-n t-ih-d", "vbd vbn jj"],
  "daunting": ["d-ao1-n t-ih-ng", "jj vbg"],
  "davenport": ["d-ae1 v-ah-n p-ao-r-t", "nn"],
  "dawdle": ["d-ao1-d-ah-l", "vb"],
  "dawn": ["d-ao1-n", "nn vb"],
  "day": ["d-ey1", "nn"],
  "daybreak": ["d-ey1 b-r-ey-k", "nn"],
  "daydream": ["d-ey1 d-r-iy-m", "nn vb"],
  "daylight": ["d-ey1 l-ay-t", "nn"],
  "daylong": ["d-ey1 l-ao-ng", "jj"],
  "daytime": ["d-ey1 t-ay-m", "jj nn"],
  "daze": ["d-ey1-z", "nn vb"],
  "dazed": ["d-ey1-z-d", "jj vbd vbn"],
  "dazzle": ["d-ae1 z-ah-l", "vb"],
  "dazzled": ["d-ae1 z-ah-l-d", "vbn jj"],
  "dazzling": ["d-ae1 z-ah-l ih-ng", "jj vbg"],
  "deacon": ["d-iy1 k-ah-n", "nn"],
  "deactivate": ["d-iy-ae1-k-t-ih-v-ey-t", "vb"],
  "dead": ["d-eh1-d", "jj nn rb vbn"],
  "deadbeat": ["d-eh1-d b-iy-t", "nn"],
  "deader": ["d-eh1 d-er", "jjr"],
  "deadliest": ["d-eh1-d l-iy ah-s-t", "jjs"],
  "deadline": ["d-eh1-d l-ay-n", "nn"],
  "deadliness": ["d-eh1-d l-iy n-ah-s", "nn"],
  "deadlock": ["d-eh1-d l-aa-k", "nn vb"],
  "deadlocked": ["d-eh1-d l-aa-k-t", "vbn jj"],
  "deadly": ["d-eh1-d l-iy", "jj rb"],
  "deadpan": ["d-eh1-d p-ae-n", "jj"],
  "deadweight": ["d-eh1-d w-ey-t", "nn"],
  "deadwood": ["d-eh1-d w-uh-d", "nn"],
  "deaf": ["d-eh1-f", "jj"],
  "deafen": ["d-eh1-f-ah-n", "vb"],
  "deafening": ["d-eh1 f-ah-n ih-ng", "vbg jj"],
  "deafness": ["d-eh1-f n-ah-s", "nn"],
  "deal": ["d-iy1-l", "nn vb vbp"],
  "dealer": ["d-iy1 l-er", "nn"],
  "dealership": ["d-iy1 l-er sh-ih-p", "nn"],
  "dealt": ["d-eh1-l-t", "vbn vbd"],
  "dean": ["d-iy1-n", "nn"],
  "dear": ["d-ih1-r", "jj nn rb uh"],
  "dearest": ["d-ih1 r-ah-s-t", "jjs"],
  "dearly": ["d-ih1-r l-iy", "rb"],
  "dearth": ["d-er1-th", "nn"],
  "death": ["d-eh1-th", "nn"],
  "deathbed": ["d-eh1-th b-eh-d", "nn"],
  "deathly": ["d-eh1-th l-iy", "jj"],
  "deathwatch": ["d-eh1-th w-aa-ch", "nn"],
  "debacle": ["d-ah b-aa1 k-ah-l", "nn"],
  "debase": ["d-ah-b-ey1-s", "vb"],
  "debasement": ["d-ah b-ey1-s m-ah-n-t", "nn"],
  "debatable": ["d-ah b-ey1 t-ah b-ah-l", "jj"],
  "debate": ["d-ah b-ey1-t", "nn vb vbp"],
  "debating": ["d-ah b-ey1 t-ih-ng", "vbg jj"],
  "debauchery": ["d-ah b-ao1 ch-er iy", "nn"],
  "debilitate": ["d-ah-b-ih1-l-ah-t-ey-t", "vb"],
  "debilitated": ["d-ah b-ih1 l-ah t-ey t-ih-d", "vbn jj"],
  "debilitating": ["d-ah b-ih1 l-ah t-ey t-ih-ng", "jj"],
  "debility": ["d-ah b-ih1 l-ah t-iy", "nn"],
  "debit": ["d-eh1 b-ih-t", "nn"],
  "debonair": ["d-eh b-ah n-eh1-r", "jj"],
  "debris": ["d-ah b-r-iy1", "nn"],
  "debt": ["d-eh1-t", "nn"],
  "debtholder": ["d-eh1-t hh-ow-l d-er", "nn"],
  "debtor": ["d-eh1 t-er", "nn jj"],
  "debunk": ["d-ih b-ah1-ng-k", "vb"],
  "debunking": ["d-ih b-ah1-ng k-ih-ng", "nn"],
  "debut": ["d-ey b-y-uw1", "nn vb vbp"],
  "debutante": ["d-eh1 b-y-ah t-aa1-n-t", "nn"],
  "decade": ["d-eh k-ey1-d", "nn"],
  "decadence": ["d-eh1 k-ah d-ah-n-s", "nn"],
  "decadent": ["d-eh1 k-ah d-ah-n-t", "jj"],
  "decaffeinate": ["d-iy-k-ae1-f-ah-n-ey-t", "vb"],
  "decamp": ["d-ah-k-ae1-m-p", "vb"],
  "decant": ["d-ah-k-ae1-n-t", "vb"],
  "decay": ["d-ah k-ey1", "nn vb"],
  "decayed": ["d-ah k-ey1-d", "jj vbd vbn"],
  "decaying": ["d-ah k-ey1 ih-ng", "vbg jj"],
  "decease": ["d-ih-s-iy1-s", "vb"],
  "deceased": ["d-ih s-iy1-s-t", "jj nn vbn"],
  "decedent": ["d-eh s-iy1 d-ah-n-t", "nn"],
  "deceit": ["d-ah s-iy1-t", "nn"],
  "deceitful": ["d-ah s-iy1-t f-ah-l", "jj"],
  "deceive": ["d-ih s-iy1-v", "vb"],
  "decelerate": ["d-ih s-eh1 l-er ey-t", "vb"],
  "deceleration": ["d-ih s-eh l-er ey1 sh-ah-n", "nn"],
  "decency": ["d-iy1 s-ah-n s-iy", "nn"],
  "decent": ["d-iy1 s-ah-n-t", "jj"],
  "decently": ["d-iy1 s-ah-n-t l-iy", "rb"],
  "decentralization": ["d-ih s-eh-n t-r-ah l-ih z-ey1 sh-ah-n", "nn"],
  "decentralize": ["d-ih s-eh1-n t-r-ah l-ay-z", "vb"],
  "decentralized": ["d-ih s-eh1-n t-r-ah l-ay-z-d", "jj vbd vbn"],
  "deception": ["d-ih s-eh1-p sh-ah-n", "nn"],
  "deceptive": ["d-ih s-eh1-p t-ih-v", "jj"],
  "deceptively": ["d-ih s-eh1-p t-ih-v l-iy", "rb"],
  "decertified": ["d-iy s-er1 t-ah f-ay-d", "vbn"],
  "decertify": ["d-iy-s-er1-t-ah-f-ay", "vb"],
  "decide": ["d-ih s-ay1-d", "vb vbp"],
  "decided": ["d-ih s-ay1 d-ih-d", "vbd vbn jj"],
  "decidedly": ["d-ih s-ay1 d-ah-d l-iy", "rb"],
  "deciding": ["d-ah s-ay1 d-ih-ng", "vbg jj"],
  "decimal": ["d-eh1 s-ah m-ah-l", "nn jj"],
  "decimate": ["d-eh1-s-ah-m-ey-t", "vb"],
  "decipher": ["d-ih s-ay1 f-er", "vb"],
  "decision": ["d-ih s-ih1 zh-ah-n", "nn"],
  "decisionmaking": ["d-ih s-ih1 zh-ah-n m-ey k-ih-ng", "nn"],
  "decisive": ["d-ih s-ay1 s-ih-v", "jj"],
  "decisively": ["d-ih s-ay1 s-ih-v l-iy", "rb"],
  "decisiveness": ["d-ih s-ay1 s-ih-v n-ah-s", "nn"],
  "deck": ["d-eh1-k", "nn vb"],
  "declaim": ["d-ih-k-l-ey1-m", "vb"],
  "declaration": ["d-eh k-l-er ey1 sh-ah-n", "nn"],
  "declaratory": ["d-ih k-l-eh1 r-ah t-ao r-iy", "jj"],
  "declare": ["d-ih k-l-eh1-r", "vb vbp"],
  "declared": ["d-ih k-l-eh1-r-d", "vbd vbn jj"],
  "decline": ["d-ih k-l-ay1-n", "nn vb vbp"],
  "decliner": ["d-ih k-l-ay1 n-er", "nn"],
  "declining": ["d-ih k-l-ay1 n-ih-ng", "vbg jj nn"],
  "decode": ["d-ih k-ow1-d", "vb"],
  "decommission": ["d-iy-k-ah-m-ih1-sh-ah-n", "vb"],
  "decompose": ["d-iy k-ah-m p-ow1-z", "vb"],
  "decomposed": ["d-iy k-ah-m p-ow1-z-d", "jj"],
  "decompression": ["d-iy k-ah-m p-r-eh1 sh-ah-n", "nn"],
  "decontamination": ["d-iy k-ah-n t-ae m-ah n-ey1 sh-ah-n", "nn"],
  "decor": ["d-ih k-ao1-r", "nn"],
  "decorate": ["d-eh1 k-er ey-t", "vbp vb"],
  "decorated": ["d-eh1 k-er ey t-ah-d", "vbn vbd jj"],
  "decoration": ["d-eh k-er ey1 sh-ah-n", "nn"],
  "decorative": ["d-eh1 k-r-ah t-ih-v", "jj"],
  "decorator": ["d-eh1 k-er ey t-er", "nn"],
  "decorous": ["d-eh1 k-er ah-s", "jj"],
  "decorum": ["d-ih k-ao1 r-ah-m", "nn"],
  "decoy": ["d-ah k-oy1", "nn"],
  "decrease": ["d-ih k-r-iy1-s", "nn vb vbp"],
  "decree": ["d-ih k-r-iy1", "nn vb"],
  "decrepit": ["d-ah k-r-eh1 p-ih-t", "jj"],
  "decry": ["d-ih k-r-ay1", "vb vbp"],
  "dedicate": ["d-eh1 d-ah k-ey-t", "vb"],
  "dedicated": ["d-eh1 d-ah k-ey t-ah-d", "vbn jj vbd"],
  "dedication": ["d-eh d-ah k-ey1 sh-ah-n", "nn"],
  "deduce": ["d-ih d-uw1-s", "vb"],
  "deduct": ["d-ih d-ah1-k-t", "vb vbp"],
  "deductibility": ["d-ih d-ah-k t-ah b-ih1 l-ah t-iy", "nn"],
  "deductible": ["d-ih d-ah1-k t-ah b-ah-l", "jj"],
  "deduction": ["d-ih d-ah1-k sh-ah-n", "nn"],
  "deed": ["d-iy1-d", "nn"],
  "deem": ["d-iy1-m", "vbp vb"],
  "deep": ["d-iy1-p", "jj rb"],
  "deepen": ["d-iy1 p-ah-n", "vb"],
  "deeper": ["d-iy1 p-er", "jjr rbr rb"],
  "deepest": ["d-iy1 p-ah-s-t", "jjs"],
  "deeply": ["d-iy1-p l-iy", "rb"],
  "deer": ["d-ih1-r", "nn"],
  "defamation": ["d-eh f-ah m-ey1 sh-ah-n", "nn"],
  "defamatory": ["d-ih f-ae1 m-ah t-ao r-iy", "jj"],
  "defame": ["d-ih-f-ey1-m", "vb"],
  "default": ["d-ih f-ao1-l-t", "nn vb"],
  "defaulted": ["d-ih f-ao1-l t-ih-d", "vbd vbn jj"],
  "defaulter": ["d-ih f-ao1-l t-er", "nn"],
  "defeat": ["d-ih f-iy1-t", "nn vb vbp"],
  "defeatism": ["d-ih f-iy1 t-ih z-ah-m", "nn"],
  "defect": ["d-iy1 f-eh-k-t", "nn vb"],
  "defection": ["d-ih f-eh1-k sh-ah-n", "nn"],
  "defective": ["d-ih f-eh1-k t-ih-v", "jj"],
  "defector": ["d-ih f-eh1-k t-er", "nn"],
  "defend": ["d-ih f-eh1-n-d", "vb vbp"],
  "defendant": ["d-ih f-eh1-n d-ah-n-t", "nn"],
  "defender": ["d-ih f-eh1-n d-er", "nn"],
  "defending": ["d-ih f-eh1-n d-ih-ng", "vbg jj"],
  "defense": ["d-ih f-eh1-n-s", "nn"],
  "defenseless": ["d-ih f-eh1-n-s l-ah-s", "jj"],
  "defensible": ["d-ih f-eh1-n s-ah b-ah-l", "jj"],
  "defensive": ["d-ih f-eh1-n s-ih-v", "jj nn"],
  "defensively": ["d-ih f-eh1-n s-ih-v l-iy", "rb"],
  "defensiveness": ["d-ih f-eh1-n s-ih-v n-ah-s", "nn"],
  "defer": ["d-ih f-er1", "vb"],
  "deference": ["d-eh1 f-er ah-n-s", "nn"],
  "deferment": ["d-ih f-er1 m-ah-n-t", "nn"],
  "deferred": ["d-ih f-er1-d", "vbn vbd jj"],
  "defiance": ["d-ih f-ay1 ah-n-s", "nn"],
  "defiant": ["d-ih f-ay1 ah-n-t", "jj"],
  "defiantly": ["d-ih f-ay1 ah-n-t l-iy", "rb"],
  "deficiency": ["d-ih f-ih1 sh-ah-n s-iy", "nn"],
  "deficient": ["d-ih f-ih1 sh-ah-n-t", "jj"],
  "deficit": ["d-eh1 f-ah s-ah-t", "nn"],
  "definable": ["d-ih f-ay1 n-ah b-ah-l", "jj"],
  "define": ["d-ih f-ay1-n", "vb vbp"],
  "defined": ["d-ih f-ay1-n-d", "vbn jj vbd"],
  "definite": ["d-eh1 f-ah n-ah-t", "jj"],
  "definitely": ["d-eh1 f-ah n-ah-t l-iy", "rb"],
  "definition": ["d-eh f-ah n-ih1 sh-ah-n", "nn"],
  "definitive": ["d-ih f-ih1 n-ih t-ih-v", "jj"],
  "definitively": ["d-ih f-ih1 n-ih t-ih-v l-iy", "rb"],
  "deflate": ["d-ih f-l-ey1-t", "vb"],
  "deflated": ["d-ih f-l-ey1 t-ih-d", "vbd jj vbn"],
  "deflationary": ["d-ih f-l-ey1 sh-ah-n eh r-iy", "jj"],
  "deflator": ["d-ih f-l-ey1 t-er", "nn"],
  "deflect": ["d-ih f-l-eh1-k-t", "vb"],
  "deforestation": ["d-ih f-ao r-ih s-t-ey1 sh-ah-n", "nn"],
  "deform": ["d-iy-f-ao1-r-m", "vb"],
  "deformation": ["d-iy f-ao-r m-ey1 sh-ah-n", "nn"],
  "deformed": ["d-ih f-ao1-r-m-d", "jj vbn"],
  "deformity": ["d-ih f-ao1-r m-ah t-iy", "nn"],
  "defraud": ["d-ih f-r-ao1-d", "vb"],
  "defray": ["d-ih f-r-ey1", "vb"],
  "deft": ["d-eh1-f-t", "jj"],
  "deftly": ["d-eh1-f-t l-iy", "rb"],
  "defunct": ["d-ih f-ah1-ng-k-t", "jj vb"],
  "defuse": ["d-ih f-y-uw1-z", "vb"],
  "defy": ["d-ih f-ay1", "vb vbp"],
  "degeneracy": ["d-ih jh-eh1 n-er ah s-iy", "nn"],
  "degenerate": ["d-ih jh-eh1 n-er ah-t", "jj vb"],
  "degeneration": ["d-ih jh-eh n-er ey1 sh-ah-n", "nn"],
  "degenerative": ["d-ih jh-eh1 n-er ah t-ih-v", "jj"],
  "degradation": ["d-eh g-r-ah d-ey1 sh-ah-n", "nn"],
  "degrade": ["d-ih g-r-ey1-d", "vb"],
  "degraded": ["d-ih g-r-ey1 d-ah-d", "jj"],
  "degrading": ["d-ih g-r-ey1 d-ih-ng", "jj vbg"],
  "degree": ["d-ih g-r-iy1", "nn"],
  "dehumanize": ["d-ih-hh-y-uw1-m-ah-n-ay-z", "vb"],
  "dehydrate": ["d-ih-hh-ay1-d-r-ey-t", "vb"],
  "dehydrated": ["d-ih hh-ay1 d-r-ey t-ah-d", "jj vbn"],
  "dehydration": ["d-iy hh-ay d-r-ey1 sh-ah-n", "nn"],
  "deification": ["d-iy ah f-ah k-ey1 sh-ah-n", "nn"],
  "deinstitutionalization": ["d-iy ih-n s-t-ih t-uw sh-ah n-ah-l ah z-ey1 sh-ah-n", "nn"],
  "deity": ["d-iy1 ah t-iy", "nn"],
  "delay": ["d-ih l-ey1", "nn vb vbp"],
  "delayed": ["d-ih l-ey1-d", "vbn jj vbd"],
  "delaying": ["d-ih l-ey1 ih-ng", "vbg jj nn"],
  "delectable": ["d-ih l-eh1-k t-ah b-ah-l", "jj"],
  "delegate": ["d-eh1 l-ah g-ey-t", "nn vb"],
  "delegation": ["d-eh l-ah g-ey1 sh-ah-n", "nn"],
  "delete": ["d-ih l-iy1-t", "vb"],
  "deleterious": ["d-eh l-ah t-ih1 r-iy ah-s", "jj"],
  "deletion": ["d-ih l-iy1 sh-ah-n", "nn"],
  "deliberate": ["d-ih l-ih1 b-er ah-t", "jj vb"],
  "deliberately": ["d-ih l-ih1 b-er ah-t l-iy", "rb"],
  "deliberation": ["d-ih l-ih b-er ey1 sh-ah-n", "nn"],
  "deliberative": ["d-ih l-ih1 b-er ey t-ih-v", "jj"],
  "delicacy": ["d-eh1 l-ah k-ah s-iy", "nn"],
  "delicate": ["d-eh1 l-ah k-ah-t", "jj"],
  "delicately": ["d-eh1 l-ah k-ah-t l-iy", "rb"],
  "delicatessen": ["d-eh l-ih k-ah t-eh1 s-ah-n", "nn"],
  "delicious": ["d-ih l-ih1 sh-ah-s", "jj"],
  "deliciously": ["d-ih l-ih1 sh-ah-sh l-iy", "rb"],
  "delight": ["d-ih l-ay1-t", "nn vb vbp"],
  "delighted": ["d-ih l-ay1 t-ah-d", "vbn jj vbd"],
  "delightful": ["d-ih l-ay1-t f-ah-l", "jj"],
  "delightfully": ["d-ih l-ay1-t f-ah l-iy", "rb"],
  "delineate": ["d-ih l-ih1 n-iy ey-t", "vb"],
  "delineation": ["d-ih l-ih n-iy ey1 sh-ah-n", "nn"],
  "delinquency": ["d-ih l-ih1-ng k-w-ah-n s-iy", "nn"],
  "delinquent": ["d-ih l-ih1-ng k-w-ah-n-t", "jj nn"],
  "delirium": ["d-ih l-ih1 r-iy ah-m", "nn"],
  "deliver": ["d-ih l-ih1 v-er", "vb vbp"],
  "deliverable": ["d-ih l-ih1 v-er ah b-ah-l", "jj"],
  "deliverance": ["d-ih l-ih1 v-er ah-n-s", "nn"],
  "deliverer": ["d-ih l-ih1 v-er er", "nn"],
  "deliveries": ["d-ih l-ih1 v-er iy-z", "nn"],
  "delivery": ["d-ih l-ih1 v-er iy", "nn"],
  "dell": ["d-eh1-l", "nn"],
  "delphic": ["d-eh1-l f-ih-k", "jj"],
  "delta": ["d-eh1-l t-ah", "nn jj"],
  "delude": ["d-ih l-uw1-d", "vb vbp"],
  "deluded": ["d-ih l-uw1 d-ih-d", "jj vbd"],
  "deluge": ["d-eh1 l-y-uw-jh", "nn vb"],
  "delusion": ["d-ih l-uw1 zh-ah-n", "nn"],
  "deluxe": ["d-ah l-ah1-k-s", "jj"],
  "delve": ["d-eh1-l-v", "vb"],
  "demagogic": ["d-eh m-ah g-aa1 jh-ih-k", "jj"],
  "demagogue": ["d-eh1 m-ah g-aa-g", "nn"],
  "demagoguery": ["d-eh1 m-ah g-aa g-er iy", "nn"],
  "demand": ["d-ih m-ae1-n-d", "nn vb vbp"],
  "demanding": ["d-ih m-ae1-n d-ih-ng", "vbg jj"],
  "demandingly": ["d-ih m-ae1-n d-ih-ng l-iy", "rb"],
  "demarcation": ["d-iy m-aa-r k-ey1 sh-ah-n", "nn"],
  "demean": ["d-ih-m-iy1-n", "vb"],
  "demeaning": ["d-ih m-iy1 n-ih-ng", "jj"],
  "demeanor": ["d-ih m-iy1 n-er", "nn"],
  "dement": ["d-ah-m-eh1-n-t", "vb"],
  "demented": ["d-ih m-eh1-n t-ih-d", "jj vbn"],
  "dementia": ["d-ih m-eh1-n sh-iy ah", "nn"],
  "demilitarize": ["d-iy m-ih1 l-ah t-er ay-z", "vb"],
  "demise": ["d-ih m-ay1-z", "nn"],
  "demo": ["d-eh1 m-ow", "nn"],
  "demobilize": ["d-ih m-ow1 b-ah l-ay-z", "vb"],
  "democracy": ["d-ih m-aa1 k-r-ah s-iy", "nn"],
  "democrat": ["d-eh1 m-ah k-r-ae-t", "nn"],
  "democratic": ["d-eh m-ah k-r-ae1 t-ih-k", "jj"],
  "democratically": ["d-eh m-ah k-r-ae1 t-ih-k l-iy", "rb"],
  "democratization": ["d-ih m-aa k-r-ah t-ah z-ey1 sh-ah-n", "nn"],
  "democratize": ["d-ih m-aa1 k-r-ah t-ay-z", "vb"],
  "demographic": ["d-eh m-ah g-r-ae1 f-ih-k", "jj"],
  "demographically": ["d-eh m-ah g-r-ae1 f-ih-k l-iy", "rb"],
  "demography": ["d-ih m-aa1 g-r-ah f-iy", "nn"],
  "demolish": ["d-ih m-aa1 l-ih-sh", "vb"],
  "demolition": ["d-eh m-ah l-ih1 sh-ah-n", "nn jj"],
  "demon": ["d-iy1 m-ah-n", "nn"],
  "demonic": ["d-ih m-aa1 n-ih-k", "jj"],
  "demonize": ["d-iy1 m-ah n-ay-z", "vb"],
  "demonizing": ["d-iy1 m-ah n-ay z-ih-ng", "nn"],
  "demonstrable": ["d-eh1 m-ah-n s-t-r-ah b-ah-l", "jj"],
  "demonstrably": ["d-ih m-aa1-n s-t-r-ah b-l-iy", "rb"],
  "demonstrate": ["d-eh1 m-ah-n s-t-r-ey-t", "vb vbp"],
  "demonstrated": ["d-eh1 m-ah-n s-t-r-ey t-ah-d", "vbn vbd jj"],
  "demonstration": ["d-eh m-ah-n s-t-r-ey1 sh-ah-n", "nn"],
  "demonstrator": ["d-eh1 m-ah-n s-t-r-ey t-er", "nn"],
  "demoralization": ["d-ih m-ao r-ah l-ih z-ey1 sh-ah-n", "nn"],
  "demoralize": ["d-ih m-ao1 r-ah l-ay-z", "vb vbp"],
  "demoralized": ["d-ih m-ao1 r-ah l-ay-z-d", "vbn jj"],
  "demote": ["d-ih-m-ow1-t", "vb"],
  "demotion": ["d-ih m-ow1 sh-ah-n", "nn"],
  "demur": ["d-ih m-er1", "vb vbp"],
  "demure": ["d-ih m-y-uh1-r", "jj"],
  "den": ["d-eh1-n", "nn"],
  "denationalization": ["d-iy n-ae sh-ah-n ah l-ih z-ey1 sh-ah-n", "nn"],
  "denationalize": ["d-ih-n-ae1-sh-ah-n-ah-l-ay-z", "vb"],
  "denial": ["d-ih n-ay1 ah-l", "nn"],
  "denigrate": ["d-eh1 n-ah g-r-ey-t", "vb"],
  "denizen": ["d-eh1 n-ah z-ah-n", "nn"],
  "denominate": ["d-ih-n-aa1-m-ah-n-ey-t", "vb"],
  "denomination": ["d-ih n-ao m-ah n-ey1 sh-ah-n", "nn"],
  "denominator": ["d-ih n-aa1 m-ah n-ey t-er", "nn"],
  "denote": ["d-ih n-ow1-t", "vb vbp"],
  "denouement": ["d-ey n-uw m-aa1-n", "nn"],
  "denounce": ["d-ih n-aw1-n-s", "vbp vb"],
  "dense": ["d-eh1-n-s", "jj"],
  "densely": ["d-eh1-n-s l-iy", "rb"],
  "densest": ["d-eh1-n s-ah-s-t", "jjs"],
  "density": ["d-eh1-n s-ah t-iy", "nn"],
  "dent": ["d-eh1-n-t", "nn vb"],
  "dental": ["d-eh1-n t-ah-l", "jj nn"],
  "dentist": ["d-eh1-n t-ah-s-t", "nn"],
  "dentistry": ["d-eh1-n t-ah-s t-r-iy", "nn"],
  "denture": ["d-eh1-n ch-er", "nn"],
  "denuclearize": ["d-ih n-uw1 k-l-iy er ay-z", "vb"],
  "denude": ["d-ih-n-uw1-d", "vb"],
  "denunciation": ["d-ih n-ah-n s-iy ey1 sh-ah-n", "nn"],
  "deny": ["d-ih n-ay1", "vb vbp"],
  "deodorant": ["d-iy ow1 d-er ah-n-t", "nn jj"],
  "depart": ["d-ih p-aa1-r-t", "vb vbp"],
  "departed": ["d-ih p-aa1-r t-ah-d", "vbd jj vbn"],
  "department": ["d-ih p-aa1-r-t m-ah-n-t", "nn"],
  "departmental": ["d-ih p-aa-r-t m-eh1 n-ah-l", "jj"],
  "departure": ["d-ih p-aa1-r ch-er", "nn"],
  "depend": ["d-ih p-eh1-n-d", "vb vbp"],
  "dependable": ["d-ih p-eh1-n d-ah b-ah-l", "jj"],
  "dependence": ["d-ih p-eh1-n d-ah-n-s", "nn"],
  "dependency": ["d-ih p-eh1-n d-ah-n s-iy", "nn"],
  "dependent": ["d-ih p-eh1-n d-ah-n-t", "jj nn"],
  "depict": ["d-ih p-ih1-k-t", "vb vbp"],
  "depiction": ["d-ih p-ih1-k sh-ah-n", "nn"],
  "deplete": ["d-ih p-l-iy1-t", "vb"],
  "depletion": ["d-ih p-l-iy1 sh-ah-n", "nn"],
  "deplorable": ["d-ih p-l-ao1 r-ah b-ah-l", "jj"],
  "deplore": ["d-ih p-l-ao1-r", "vb"],
  "deploy": ["d-ih p-l-oy1", "vb vbp"],
  "deployable": ["d-ih p-l-oy1 ah b-ah-l", "jj"],
  "deployment": ["d-ih p-l-oy1 m-ah-n-t", "nn"],
  "deport": ["d-ih p-ao1-r-t", "vb"],
  "deportation": ["d-iy p-ao-r t-ey1 sh-ah-n", "nn"],
  "deportee": ["d-iy p-ao-r t-iy1", "nn"],
  "depose": ["d-ih p-ow1-z", "vb"],
  "deposit": ["d-ah p-aa1 z-ih-t", "nn vb vbp"],
  "depositary": ["d-ah p-aa1 z-ih t-eh r-iy", "nn jj"],
  "deposition": ["d-eh p-ah z-ih1 sh-ah-n", "nn"],
  "depositor": ["d-ah p-aa1 z-ih t-er", "nn"],
  "depository": ["d-ih p-aa1 z-ah t-ao r-iy", "nn jj"],
  "depot": ["d-iy1 p-ow", "nn"],
  "depravity": ["d-ih p-r-ae1 v-ah t-iy", "nn"],
  "depreciable": ["d-ih p-r-ih1 sh-ah b-ah-l", "jj"],
  "depreciate": ["d-ih-p-r-iy1-sh-iy-ey-t", "vb"],
  "depreciation": ["d-ih p-r-iy sh-iy ey1 sh-ah-n", "nn"],
  "depredation": ["d-eh p-r-ah d-ey1 sh-ah-n", "nn"],
  "depress": ["d-ih p-r-eh1-s", "vb vbp"],
  "depressant": ["d-ih p-r-eh1 s-ah-n-t", "nn"],
  "depressed": ["d-ih p-r-eh1-s-t", "jj vbd vbn"],
  "depressing": ["d-ih p-r-eh1 s-ih-ng", "jj vbg"],
  "depressingly": ["d-ih p-r-eh1 s-ih-ng l-iy", "rb"],
  "depression": ["d-ih p-r-eh1 sh-ah-n", "nn"],
  "deprivation": ["d-eh p-r-ah v-ey1 sh-ah-n", "nn"],
  "deprive": ["d-ih p-r-ay1-v", "vb"],
  "deprived": ["d-ih p-r-ay1-v-d", "vbn jj vbd"],
  "depth": ["d-eh1-p-th", "nn"],
  "deputy": ["d-eh1 p-y-ah t-iy", "nn jj"],
  "derail": ["d-ih r-ey1-l", "vb vbp"],
  "derailment": ["d-ih r-ey1-l m-ah-n-t", "nn"],
  "derange": ["d-ih-r-ey1-n-jh", "vb"],
  "deranged": ["d-ih r-ey1-n-jh-d", "jj vbn"],
  "derby": ["d-er1 b-iy", "nn"],
  "deregulate": ["d-iy r-eh1 g-y-ah l-ey-t", "vb nn"],
  "deregulated": ["d-iy r-eh1 g-y-ah l-ey t-ih-d", "vbn jj vbd"],
  "deregulation": ["d-iy r-eh g-y-ah l-ey1 sh-ah-n", "nn"],
  "derelict": ["d-eh1 r-ah l-ih-k-t", "nn jj"],
  "dereliction": ["d-eh r-ah l-ih1-k sh-ah-n", "nn"],
  "deride": ["d-ih r-ay1-d", "vb vbp"],
  "derision": ["d-er ih1 zh-ah-n", "nn"],
  "derisively": ["d-er ih1 s-ih-v l-iy", "rb"],
  "derivation": ["d-eh r-ah v-ey1 sh-ah-n", "nn"],
  "derivative": ["d-er ih1 v-ah t-ih-v", "jj nn"],
  "derive": ["d-er ay1-v", "vbp vb"],
  "dermal": ["d-er1 m-ah-l", "jj"],
  "dermatological": ["d-er m-ah t-ah l-aa1 jh-ih k-ah-l", "jj"],
  "derogatory": ["d-er aa1 g-ah t-ao r-iy", "jj"],
  "derrick": ["d-eh1 r-ih-k", "nn"],
  "derring": ["d-eh1 r-ih-ng", "nn"],
  "dervish": ["d-er1 v-ih-sh", "nn"],
  "descend": ["d-ih s-eh1-n-d", "vb vbp"],
  "descendant": ["d-ih s-eh1-n d-ah-n-t", "nn"],
  "descendent": ["d-ih s-eh1-n d-ah-n-t", "nn"],
  "descent": ["d-ih s-eh1-n-t", "nn"],
  "describe": ["d-ih s-k-r-ay1-b", "vb vbp"],
  "description": ["d-ih s-k-r-ih1-p sh-ah-n", "nn"],
  "descriptive": ["d-ih s-k-r-ih1-p t-ih-v", "jj"],
  "desecrate": ["d-eh-z-ah-k-r-ey1-t", "vb"],
  "desecration": ["d-eh s-ah k-r-ey1 sh-ah-n", "nn"],
  "desegregate": ["d-ih s-eh1 g-r-ah g-ey-t", "vb"],
  "desegregation": ["d-ih s-eh g-r-ah g-ey1 sh-ah-n", "nn"],
  "desert": ["d-eh1 z-er-t", "nn jj vb vbp"],
  "deserted": ["d-ih z-er1 t-ih-d", "vbn vbd jj"],
  "desertion": ["d-ih z-er1 sh-ah-n", "nn"],
  "deserve": ["d-ih z-er1-v", "vbp vb"],
  "deserving": ["d-ih z-er1 v-ih-ng", "jj nn"],
  "design": ["d-ih z-ay1-n", "nn vb vbp"],
  "designate": ["d-eh1 z-ah-g n-ey-t", "vb jj nn"],
  "designated": ["d-eh1 z-ih-g n-ey t-ih-d", "vbn vbd jj"],
  "designation": ["d-eh z-ah-g n-ey1 sh-ah-n", "nn"],
  "designee": ["d-eh z-ih-g n-iy1", "nn"],
  "designer": ["d-ih z-ay1 n-er", "nn"],
  "desirability": ["d-ih z-ay r-ah b-ih1 l-ih t-iy", "nn"],
  "desirable": ["d-ih z-ay1 r-ah b-ah-l", "jj"],
  "desire": ["d-ih z-ay1 er", "nn vbp vb"],
  "desired": ["d-ih z-ay1 er-d", "vbn vbd jj"],
  "desist": ["d-ih s-ih1-s-t", "vb vbp"],
  "desk": ["d-eh1-s-k", "nn"],
  "desktop": ["d-eh1-s-k t-aa-p", "nn jj"],
  "desolate": ["d-eh1 s-ah l-ah-t", "jj"],
  "desolation": ["d-eh s-ah l-ey1 sh-ah-n", "nn"],
  "despair": ["d-ih s-p-eh1-r", "nn vb"],
  "despairing": ["d-ih s-p-eh1 r-ih-ng", "jj vbg"],
  "desperado": ["d-eh s-p-er aa1 d-ow-z", "nn"],
  "desperate": ["d-eh1 s-p-r-ih-t", "jj"],
  "desperately": ["d-eh1 s-p-er ah-t l-iy", "rb"],
  "desperation": ["d-eh s-p-er ey1 sh-ah-n", "nn"],
  "despicable": ["d-ih s-p-ih1 k-ah b-ah-l", "jj"],
  "despise": ["d-ih s-p-ay1-z", "vbp vb"],
  "despite": ["d-ih s-p-ay1-t", "in"],
  "despondency": ["d-ih s-p-aa1-n d-ah-n s-iy", "nn"],
  "despondent": ["d-ih s-p-aa1-n d-ah-n-t", "jj"],
  "despot": ["d-eh1 s-p-ah-t", "nn"],
  "despotism": ["d-eh1 s-p-ah t-ih z-ah-m", "nn"],
  "dessert": ["d-ih z-er1-t", "nn"],
  "destabilize": ["d-ih s-t-ey1 b-ah l-ay-z", "vb"],
  "destabilizing": ["d-ih s-t-ey1 b-ah l-ay z-ih-ng", "vbg jj"],
  "destination": ["d-eh s-t-ah n-ey1 sh-ah-n", "nn"],
  "destine": ["d-eh1 s-t-ih-n", "vb"],
  "destiny": ["d-eh1 s-t-ah n-iy", "nn"],
  "destitute": ["d-eh1 s-t-ah t-uw-t", "jj"],
  "destroy": ["d-ih s-t-r-oy1", "vb vbp"],
  "destroyed": ["d-ih s-t-r-oy1-d", "vbn vbd jj"],
  "destroyer": ["d-ih s-t-r-oy1 er", "nn"],
  "destruction": ["d-ih-s t-r-ah1-k sh-ah-n", "nn"],
  "destructive": ["d-ih s-t-r-ah1-k t-ih-v", "jj"],
  "desultory": ["d-eh1 s-ah-l t-ao r-iy", "jj"],
  "detach": ["d-ih t-ae1-ch", "vb"],
  "detachable": ["d-ih t-ae1 ch-ah b-ah-l", "jj"],
  "detached": ["d-ih t-ae1-ch-t", "vbn jj vbd"],
  "detachment": ["d-ih t-ae1-ch m-ah-n-t", "nn"],
  "detail": ["d-ih t-ey1-l", "nn vb"],
  "detailed": ["d-ih t-ey1-l-d", "vbn jj vbd"],
  "detain": ["d-ih t-ey1-n", "vb"],
  "detect": ["d-ih t-eh1-k-t", "vb vbp"],
  "detectable": ["d-ih t-eh1-k t-ah b-ah-l", "jj"],
  "detection": ["d-ih t-eh1-k sh-ah-n", "nn"],
  "detective": ["d-ih t-eh1-k t-ih-v", "nn"],
  "detector": ["d-ih t-eh1-k t-er", "nn"],
  "detente": ["d-ey t-aa1-n-t", "nn"],
  "detention": ["d-ih t-eh1-n sh-ah-n", "nn"],
  "deter": ["d-ih t-er1", "vb vbp"],
  "detergent": ["d-ih t-er1 jh-ah-n-t", "nn"],
  "deteriorate": ["d-ih t-ih1 r-iy er ey-t", "vb vbp"],
  "deteriorated": ["d-ih t-ih1 r-iy er ey t-ih-d", "vbn jj vbd"],
  "deteriorating": ["d-ih t-ih1 r-iy er ey t-ih-ng", "vbg jj"],
  "deterioration": ["d-ih t-ih1 r-iy er ey sh-ah-n", "nn"],
  "determinable": ["d-ih t-er1 m-ah n-ah b-ah-l", "jj"],
  "determinant": ["d-ih t-er1 m-ah n-ah-n-t", "nn"],
  "determinate": ["d-ih t-er1 m-ah n-ey-t", "jj"],
  "determination": ["d-ih t-er m-ah n-ey1 sh-ah-n", "nn"],
  "determine": ["d-ah t-er1 m-ah-n", "vb vbp"],
  "determined": ["d-ih t-er1 m-ah-n-d", "vbn vbd jj"],
  "determinedly": ["d-ah t-er1 m-ah n-ah-d l-iy", "rb"],
  "determining": ["d-ih t-er1 m-ah n-ih-ng", "vbg jj nn"],
  "determinism": ["d-ih t-er1 m-ah n-ih z-ah-m", "nn"],
  "deterministic": ["d-ih t-er m-ah n-ih1 s-t-ih-k", "jj"],
  "deterrence": ["d-ih t-er1 ah-n-s", "nn"],
  "deterrent": ["d-ih t-er1 r-ah-n-t", "nn"],
  "detest": ["d-ih t-eh1-s-t", "vbp vb"],
  "dethrone": ["d-ih-th-r-ow1-n", "vb"],
  "detonate": ["d-eh1 t-ah n-ey-t", "vb vbp"],
  "detonation": ["d-eh t-ah n-ey1 sh-ah-n", "nn"],
  "detour": ["d-ih t-uh1-r", "nn"],
  "detoxification": ["d-ih t-aa-k s-ih f-ih k-ey1 sh-ah-n", "nn"],
  "detoxify": ["d-ih t-aa1-k s-ah f-ay", "vb"],
  "detract": ["d-ih t-r-ae1-k-t", "vb vbp"],
  "detractor": ["d-ih t-r-ae1-k t-er", "nn"],
  "detriment": ["d-eh1 t-r-ah m-ah-n-t", "nn"],
  "detrimental": ["d-eh t-r-ah m-eh1-n t-ah-l", "jj"],
  "deuterium": ["d-uw t-iy1 r-iy ah-m", "nn"],
  "devaluation": ["d-ih v-ae-l y-uw ey1 sh-ah-n", "nn"],
  "devalue": ["d-ih v-ae1-l y-uw", "vb"],
  "devastate": ["d-eh1 v-ah s-t-ey-t", "vb"],
  "devastated": ["d-eh1 v-ah s-t-ey t-ah-d", "vbn vbd jj"],
  "devastating": ["d-eh1 v-ah s-t-ey t-ih-ng", "jj vbg"],
  "devastatingly": ["d-eh1 v-ah s-t-ey t-ih-ng l-iy", "rb"],
  "devastation": ["d-eh v-ah s-t-ey1 sh-ah-n", "nn"],
  "develop": ["d-ih v-eh1 l-ah-p", "vb vbp"],
  "developed": ["d-ih v-eh1 l-ah-p-t", "vbn jj vbd"],
  "developer": ["d-ih v-eh1 l-ah p-er", "nn"],
  "developing": ["d-ih v-eh1 l-ah p-ih-ng", "vbg jj"],
  "development": ["d-ih v-eh1 l-ah-p m-ah-n-t", "nn"],
  "developmental": ["d-ih v-eh l-ah-p m-eh1-n t-ah-l", "jj"],
  "deviance": ["d-iy1 v-iy ah-n-s", "nn"],
  "deviant": ["d-iy1 v-iy ah-n-t", "jj"],
  "deviate": ["d-iy1 v-iy ey-t", "vb"],
  "deviation": ["d-iy v-iy ey1 sh-ah-n", "nn"],
  "device": ["d-ih v-ay1-s", "nn"],
  "devil": ["d-eh1 v-ah-l", "nn"],
  "devilish": ["d-eh1-v l-ih-sh", "jj"],
  "devious": ["d-iy1 v-iy ah-s", "jj"],
  "devise": ["d-ih v-ay1-z", "vb vbp"],
  "devoid": ["d-ih v-oy1-d", "jj"],
  "devote": ["d-ih v-ow1-t", "vb vbp"],
  "devoted": ["d-ih v-ow1 t-ah-d", "vbn vbd jj"],
  "devotee": ["d-eh v-ah t-iy1", "nn"],
  "devotion": ["d-ih v-ow1 sh-ah-n", "nn"],
  "devotional": ["d-ih v-ow1 sh-ah n-ah-l", "jj"],
  "devour": ["d-ih v-aw1 er", "vb vbp"],
  "devout": ["d-ih v-aw1-t", "jj"],
  "devoutly": ["d-ih v-aw1-t l-iy", "rb"],
  "dew": ["d-uw1", "nn"],
  "dexterity": ["d-eh-k s-t-eh1 r-ah t-iy", "nn"],
  "dextrous": ["d-eh1-k s-t-r-ah-s", "jj"],
  "diabetes": ["d-ay ah b-iy1 t-iy-z", "nn"],
  "diabetic": ["d-ay ah b-eh1 t-ih-k", "jj nn"],
  "diabolical": ["d-ay ah b-aa1 l-ih k-ah-l", "jj"],
  "diagnose": ["d-ay ah-g n-ow1-s", "vb vbp"],
  "diagnosis": ["d-ay ah-g n-ow1 s-ah-s", "nn"],
  "diagnostic": ["d-ay ah-g n-aa1 s-t-ih-k", "jj nn"],
  "diagonal": ["d-ay ae1 g-ah n-ah-l", "jj"],
  "diagonally": ["d-ay ae1 g-ah n-ah l-iy", "rb"],
  "diagram": ["d-ay1 ah g-r-ae-m", "nn"],
  "dial": ["d-ay1 ah-l", "nn vb"],
  "dialect": ["d-ay1 ah l-eh-k-t", "nn"],
  "dialectic": ["d-ay ah l-eh1-k t-ih-k", "nn"],
  "dialectical": ["d-ay ah l-eh1-k t-ih k-ah-l", "jj"],
  "dialogue": ["d-ay1 ah l-ao-g", "nn"],
  "dialysis": ["d-ay ae1 l-ah s-ah-s", "nn"],
  "diameter": ["d-ay ae1 m-ah t-er", "nn"],
  "diametrically": ["d-ay ah m-eh1 t-r-ih k-ah l-iy", "rb"],
  "diamond": ["d-ay1 m-ah-n-d", "nn"],
  "diaper": ["d-ay1 p-er", "nn"],
  "diaphragm": ["d-ay1 ah f-r-ae-m", "nn"],
  "diarrhea": ["d-ay er iy1 ah", "nn"],
  "diary": ["d-ay1 er iy", "nn"],
  "diatomic": ["d-ay ah t-aa1 m-ih-k", "jj"],
  "diatribe": ["d-ay1 ah t-r-ay-b", "nn"],
  "dibs": ["d-ih1-b-z", "nn"],
  "dice": ["d-ay1-s", "nn nns"],
  "dichotomy": ["d-ay k-aa1 t-ah m-iy", "nn"],
  "dick": ["d-ih1-k", "nn"],
  "dicker": ["d-ih1 k-er", "vb"],
  "dickering": ["d-ih1 k-er ih-ng", "nn"],
  "dictate": ["d-ih-k t-ey1-t", "vb vbp"],
  "dictation": ["d-ih-k t-ey1 sh-ah-n", "nn"],
  "dictator": ["d-ih-k t-ey1 t-er", "nn"],
  "dictatorial": ["d-ih-k t-ah t-ao1 r-iy ah-l", "jj"],
  "dictatorship": ["d-ih-k t-ey1 t-er sh-ih-p", "nn"],
  "diction": ["d-ih1-k sh-ah-n", "nn"],
  "dictionary": ["d-ih1-k sh-ah n-eh r-iy", "nn"],
  "dictum": ["d-ih1-k t-ah-m", "nn"],
  "did": ["d-ih1-d", "vbd"],
  "didn't": ["d-ih1-d-ah-n-t", "vbd"],
  "didactic": ["d-ay d-ae1-k t-ih-k", "jj"],
  "die": ["d-ay1", "vb vbp nn"],
  "diehard": ["d-ay1 hh-aa-r-d", "jj"],
  "diesel": ["d-iy1 s-ah-l", "nn jj"],
  "diet": ["d-ay1 ah-t", "nn vb"],
  "dietary": ["d-ay1 ah t-eh r-iy", "jj"],
  "dieter": ["d-ay1 ah t-er", "nn"],
  "differ": ["d-ih1 f-er", "vbp vb"],
  "difference": ["d-ih1 f-er ah-n-s", "nn"],
  "different": ["d-ih1 f-er ah-n-t", "jj"],
  "differential": ["d-ih f-er eh1-n ch-ah-l", "jj nn"],
  "differentiate": ["d-ih f-er eh1-n sh-iy ey-t", "vb vbp"],
  "differentiated": ["d-ih f-er eh1-n ch-iy ey t-ih-d", "vbn jj vbd"],
  "differentiation": ["d-ih f-er eh-n sh-iy ey1 sh-ah-n", "nn"],
  "differently": ["d-ih1 f-r-ah-n-t l-iy", "rb"],
  "differing": ["d-ih1 f-er ih-ng", "vbg jj"],
  "difficult": ["d-ih1 f-ah k-ah-l-t", "jj"],
  "difficulty": ["d-ih1 f-ah k-ah-l t-iy", "nn"],
  "diffraction": ["d-ih f-r-ae1-k sh-ah-n", "nn"],
  "diffuse": ["d-ih f-y-uw1-s", "jj vb"],
  "diffusion": ["d-ih f-y-uw1 zh-ah-n", "nn"],
  "dig": ["d-ih1-g", "vb nn vbp"],
  "digest": ["d-ay jh-eh1-s-t", "vb nn"],
  "digestible": ["d-ay jh-eh1 s-t-ah b-ah-l", "jj"],
  "digestion": ["d-ay jh-eh1-s ch-ah-n", "nn"],
  "digestive": ["d-ay jh-eh1 s-t-ih-v", "jj"],
  "digger": ["d-ih1 g-er", "nn"],
  "digit": ["d-ih1 jh-ah-t", "nn"],
  "digital": ["d-ih1 jh-ah t-ah-l", "jj"],
  "digitalis": ["d-ih jh-ah t-ae1 l-ah-s", "nn"],
  "dignified": ["d-ih1-g n-ah f-ay-d", "vbn jj"],
  "dignify": ["d-ih1-g n-ah f-ay", "vb"],
  "dignitary": ["d-ih1-g n-ah t-eh r-iy", "nn"],
  "dignity": ["d-ih1-g n-ah t-iy", "nn"],
  "digress": ["d-ay g-r-eh1-s", "vb"],
  "digression": ["d-ay g-r-eh1 sh-ah-n", "nn"],
  "dike": ["d-ay1-k", "nn"],
  "dilapidate": ["d-ih-l-ae1-p-ah-d-ey-t", "vb"],
  "dilapidated": ["d-ah l-ae1 p-ah d-ey t-ih-d", "jj vbn"],
  "dilatation": ["d-ih l-ah t-ey1 sh-ah-n", "nn"],
  "dilate": ["d-ay l-ey1-t", "vb"],
  "dilation": ["d-ay l-ey1 sh-ah-n", "nn"],
  "dilemma": ["d-ih l-eh1 m-ah", "nn"],
  "diligence": ["d-ih1 l-ah jh-ah-n-s", "nn"],
  "diligent": ["d-ih1 l-ih jh-ah-n-t", "jj"],
  "diligently": ["d-ih1 l-ah jh-ah-n-t l-iy", "rb"],
  "dill": ["d-ih1-l", "nn"],
  "dilute": ["d-ay l-uw1-t", "vb jj"],
  "diluted": ["d-ay l-uw1 t-ah-d", "vbn jj vbd"],
  "dilution": ["d-ay l-uw1 sh-ah-n", "nn"],
  "dilutive": ["d-ah l-uw1 t-ih-v", "jj"],
  "dim": ["d-ih1-m", "jj vb"],
  "dime": ["d-ay1-m", "nn"],
  "dimension": ["d-ih m-eh1-n sh-ah-n", "nn vb"],
  "dimensional": ["d-ih m-eh1-n sh-ah n-ah-l", "jj"],
  "diminish": ["d-ih m-ih1 n-ih-sh", "vb vbp"],
  "diminished": ["d-ih m-ih1 n-ih-sh-t", "vbn jj vbd"],
  "diminution": ["d-ih m-ah n-uw1 sh-ah-n", "nn"],
  "diminutive": ["d-ih m-ih1 n-y-ah t-ih-v", "jj"],
  "dimly": ["d-ih1-m l-iy", "rb"],
  "dimmer": ["d-ih1 m-er", "nn jjr"],
  "din": ["d-ih1-n", "nn"],
  "dine": ["d-ay1-n", "vb"],
  "diner": ["d-ay1 n-er", "nn"],
  "dinghy": ["d-ih1-ng iy", "nn"],
  "dingo": ["d-ih1-ng g-ow", "nn"],
  "dingy": ["d-ih1-n jh-iy", "jj"],
  "dining": ["d-ay1 n-ih-ng", "nn jj vbg"],
  "dinner": ["d-ih1 n-er", "nn"],
  "dinnertime": ["d-ih1 n-er t-ay-m", "nn"],
  "dinnerware": ["d-ih1 n-er w-eh-r", "nn"],
  "dinosaur": ["d-ay1 n-ah s-ao-r", "nn"],
  "dioxide": ["d-ay aa1-k s-ay-d", "nn"],
  "dioxin": ["d-ay aa1-k s-ih-n", "nn"],
  "dip": ["d-ih1-p", "nn vbp vb"],
  "diphtheria": ["d-ih-f th-ih1 r-iy ah", "nn"],
  "diploma": ["d-ih p-l-ow1 m-ah", "nn"],
  "diplomacy": ["d-ih p-l-ow1 m-ah s-iy", "nn"],
  "diplomat": ["d-ih1 p-l-ah m-ae-t", "nn"],
  "diplomatic": ["d-ih p-l-ah m-ae1 t-ih-k", "jj"],
  "diplomatically": ["d-ih p-l-ah m-ae1 t-ih-k l-iy", "rb"],
  "dipole": ["d-ay1 p-ow-l", "jj nn"],
  "dipper": ["d-ih1 p-er", "nn"],
  "dire": ["d-ay1-r", "jj"],
  "direct": ["d-er eh1-k-t", "jj vbp rb vb"],
  "directed": ["d-er eh1-k t-ah-d", "vbn vbd jj"],
  "direction": ["d-er eh1-k sh-ah-n", "nn"],
  "directional": ["d-er eh1-k sh-ah n-ah-l", "jj"],
  "directionless": ["d-er eh1-k sh-ah-n l-ah-s", "jj"],
  "directive": ["d-er eh1-k t-ih-v", "nn"],
  "directly": ["d-er eh1-k-t l-iy", "rb"],
  "directness": ["d-er eh1-k-t n-ah-s", "nn"],
  "director": ["d-er eh1-k t-er", "nn"],
  "directorate": ["d-er eh1-k t-er ah-t", "nn"],
  "directorial": ["d-er eh-k t-ao1 r-iy ah-l", "jj"],
  "directorship": ["d-er eh1-k t-er sh-ih-p", "nn"],
  "directory": ["d-er eh1-k t-er iy", "nn jj"],
  "dirge": ["d-er1-jh", "nn"],
  "dirt": ["d-er1-t", "nn jj"],
  "dirtier": ["d-er1 t-iy er", "jjr"],
  "dirtiest": ["d-er1 t-iy ah-s-t", "jjs"],
  "dirty": ["d-er1 t-iy", "jj vb"],
  "disability": ["d-ih-s ah b-ih1 l-ih t-iy", "nn"],
  "disable": ["d-ih-s ey1 b-ah-l", "vb"],
  "disabled": ["d-ih-s ey1 b-ah-l-d", "jj nn vbn"],
  "disadvantage": ["d-ih-s ah-d v-ae1-n t-ih-jh", "nn"],
  "disadvantaged": ["d-ih-s ah-d v-ae1-n t-ih-jh-d", "jj"],
  "disadvantageous": ["d-ih-s ae-d v-ae-n t-ey1 jh-ah-s", "jj"],
  "disaffected": ["d-ih-s ah f-eh1-k t-ih-d", "jj"],
  "disaffection": ["d-ih-s ah f-eh1-k sh-ah-n", "nn"],
  "disagree": ["d-ih-s ah g-r-iy1", "vbp vb"],
  "disagreeable": ["d-ih-s ah g-r-iy1 ah b-ah-l", "jj"],
  "disagreement": ["d-ih-s ah g-r-iy1 m-ah-n-t", "nn"],
  "disallow": ["d-ih-s ah l-aw1", "vb"],
  "disallowance": ["d-ih-s ah l-aw1 ah-n-s", "nn"],
  "disappear": ["d-ih-s ah p-ih1-r", "vb vbp"],
  "disappearance": ["d-ih-s ah p-ih1 r-ah-n-s", "nn"],
  "disappoint": ["d-ih-s ah p-oy1-n-t", "vb"],
  "disappointed": ["d-ih-s ah p-oy1-n t-ih-d", "vbn jj vbd"],
  "disappointing": ["d-ih-s ah p-oy1-n t-ih-ng", "jj"],
  "disappointingly": ["d-ih-s ah p-oy1-n t-ih-ng l-iy", "rb"],
  "disappointment": ["d-ih-s ah p-oy1-n-t m-ah-n-t", "nn"],
  "disapproval": ["d-ih-s ah p-r-uw1 v-ah-l", "nn"],
  "disapprove": ["d-ih-s ah p-r-uw1-v", "vbp vb"],
  "disapproving": ["d-ih-s ah p-r-uw1 v-ih-ng", "jj"],
  "disarm": ["d-ih-s aa1-r-m", "vb"],
  "disarmament": ["d-ih-s aa1-r m-ah m-ah-n-t", "nn"],
  "disarmed": ["d-ih-s aa1-r-m-d", "jj vbn"],
  "disarming": ["d-ih-s aa1-r m-ih-ng", "vbg jj"],
  "disarmingly": ["d-ih-s aa1-r m-ih-ng l-iy", "rb"],
  "disarray": ["d-ih-s er ey1", "nn"],
  "disassemble": ["d-ih-s-ah-s-eh1-m-b-ah-l", "vb"],
  "disassociate": ["d-ih-s ah s-ow1 sh-iy ey-t", "vb"],
  "disaster": ["d-ih z-ae1 s-t-er", "nn"],
  "disastrous": ["d-ih z-ae1 s-t-r-ah-s", "jj"],
  "disastrously": ["d-ih z-ae1 s-t-r-ah-s l-iy", "rb"],
  "disavow": ["d-ih-s-ah-v-aw1", "vb"],
  "disband": ["d-ih-s b-ae1-n-d", "vb"],
  "disbanded": ["d-ih-s b-ae1-n d-ih-d", "vbn vbd jj"],
  "disbelief": ["d-ih-s b-ih l-iy1-f", "nn"],
  "disbelieve": ["d-ih-s b-ah l-iy1-v", "vb"],
  "disburse": ["d-ih-s-b-er1-s", "vb"],
  "disbursement": ["d-ih-s b-er1-s m-ah-n-t", "nn"],
  "disc": ["d-ih1-s-k", "nn"],
  "discard": ["d-ih-s k-aa1-r-d", "vb vbp"],
  "discern": ["d-ih s-er1-n", "vb vbp"],
  "discernible": ["d-ih s-er1 n-ah b-ah-l", "jj"],
  "discerning": ["d-ih s-er1 n-ih-ng", "jj"],
  "discernment": ["d-ih s-er1-n m-ah-n-t", "nn"],
  "discharge": ["d-ih-s ch-aa1-r-jh", "nn vb"],
  "disciple": ["d-ih s-ay1 p-ah-l", "nn"],
  "disciplinary": ["d-ih1 s-ah p-l-ah n-eh r-iy", "jj"],
  "discipline": ["d-ih1 s-ah p-l-ah-n", "nn vb vbp"],
  "disciplined": ["d-ih1 s-ah p-l-ah-n-d", "vbn vbd jj"],
  "disclaim": ["d-ih-s-k-l-ey1-m", "vb"],
  "disclaimer": ["d-ih-s k-l-ey1 m-er", "nn"],
  "disclose": ["d-ih-s k-l-ow1-z", "vb vbp"],
  "disclosed": ["d-ih-s k-l-ow1-z-d", "vbn jj vbd"],
  "disclosure": ["d-ih-s k-l-ow1 zh-er", "nn"],
  "disco": ["d-ih1 s-k-ow", "nn"],
  "discolor": ["d-ih-s-k-ah1-l-er", "vb"],
  "discomfort": ["d-ih-s k-ah1-m f-er-t", "nn"],
  "disconcert": ["d-ih-s-k-ah-n-s-er1-t", "vb"],
  "disconcerting": ["d-ih-s k-ah-n s-er1 t-ih-ng", "jj vbg"],
  "disconnect": ["d-ih-s k-ah n-eh1-k-t", "vb"],
  "disconnected": ["d-ih-s k-ah n-eh1-k t-ih-d", "vbn jj"],
  "discontent": ["d-ih-s k-ah-n t-eh1-n-t", "nn"],
  "discontented": ["d-ih-s k-ah-n t-eh1-n t-ih-d", "jj"],
  "discontinuance": ["d-ih-s k-ah-n t-ih1 n-y-uw ah-n-s", "nn"],
  "discontinuation": ["d-ih-s k-ah-n t-ih n-y-uw ey1 sh-ah-n", "nn"],
  "discontinue": ["d-ih-s k-ah-n t-ih1 n-y-uw", "vb"],
  "discontinued": ["d-ih-s k-ah-n t-ih1 n-y-uw-d", "vbn jj vbd"],
  "discord": ["d-ih1 s-k-ao-r-d", "nn"],
  "discordant": ["d-ih s-k-ao1-r d-ah-n-t", "jj"],
  "discotheque": ["d-ih1 s-k-ow t-eh-k", "nn"],
  "discount": ["d-ih-s k-aw1-n-t", "nn vbp jj vb"],
  "discounted": ["d-ih1-s k-aw-n t-ih-d", "vbn jj vbd"],
  "discounter": ["d-ih1-s k-aw-n t-er", "nn"],
  "discourage": ["d-ih s-k-er1 ih-jh", "vb vbp"],
  "discouraged": ["d-ih s-k-er1 ah-jh-d", "vbn vbd jj"],
  "discouragement": ["d-ih s-k-er1 ih-jh m-ah-n-t", "nn"],
  "discouraging": ["d-ih s-k-er1 ah jh-ih-ng", "vbg jj"],
  "discourse": ["d-ih1-s k-ao-r-s", "nn vb"],
  "discover": ["d-ih s-k-ah1 v-er", "vb vbp"],
  "discovered": ["d-ih s-k-ah1 v-er-d", "vbn jj vbd"],
  "discovery": ["d-ih s-k-ah1 v-er iy", "nn"],
  "discredit": ["d-ih-s k-r-eh1 d-ah-t", "vb nn"],
  "discredited": ["d-ih-s k-r-eh1 d-ih t-ih-d", "vbn jj"],
  "discreet": ["d-ih s-k-r-iy1-t", "jj"],
  "discreetly": ["d-ih s-k-r-iy1-t l-iy", "rb"],
  "discrepancy": ["d-ih s-k-r-eh1 p-ah-n s-iy", "nn"],
  "discrete": ["d-ih s-k-r-iy1-t", "jj"],
  "discretion": ["d-ih s-k-r-eh1 sh-ah-n", "nn"],
  "discretionary": ["d-ih s-k-r-eh1 sh-ah-n eh r-iy", "jj"],
  "discriminate": ["d-ih s-k-r-ih1 m-ah n-ey-t", "vb vbp jj"],
  "discriminated": ["d-ih s-k-r-ih1 m-ah n-ey t-ah-d", "vbd vbn jj"],
  "discriminating": ["d-ih s-k-r-ih1 m-ah n-ey t-ih-ng", "vbg jj"],
  "discrimination": ["d-ih s-k-r-ih m-ah n-ey1 sh-ah-n", "nn"],
  "discriminatory": ["d-ih s-k-r-ih1 m-ah n-ah t-ao r-iy", "jj"],
  "discursive": ["d-ih s-k-er1 s-ih-v", "jj"],
  "discus": ["d-ih1 s-k-ah-s", "nn"],
  "discuss": ["d-ih s-k-ah1-s", "vb vbp"],
  "discussion": ["d-ih s-k-ah1 sh-ah-n", "nn"],
  "disdain": ["d-ih-s d-ey1-n", "nn vbp vb"],
  "disdainful": ["d-ih-s d-ey1-n f-ah-l", "jj"],
  "disease": ["d-ih z-iy1-z", "nn"],
  "diseased": ["d-ih z-iy1-z-d", "jj"],
  "disembodied": ["d-ih-s ih b-aa1 d-iy-d", "jj"],
  "disenchant": ["d-ih-s ih-n ch-ae1-n t-ih-d", "vb"],
  "disenchanted": ["d-ih-s ih-n ch-ae1-n t-ih-d", "vbn jj"],
  "disenfranchise": ["d-ih-s-ih-n-f-r-ae1-n-ch-ay-z", "vb"],
  "disenfranchisement": ["d-ih-s ih-n f-r-ae1-n ch-ay-z m-ah-n-t", "nn"],
  "disengage": ["d-ih-s ih-n g-ey1-jh", "vb"],
  "disengagement": ["d-ih-s ih-n g-ey1-jh m-ah-n-t", "nn"],
  "disentangle": ["d-ih-s ah-n t-ae1-ng g-ah-l", "vb"],
  "disfavor": ["d-ih-s f-ey1 v-er", "nn"],
  "disfigure": ["d-ih-s-f-ih1-g-y-er", "vb"],
  "disfigured": ["d-ih-s f-ih1 g-y-er-d", "vbd vbn jj"],
  "disgorge": ["d-ih-s g-ao1-r-jh", "vb"],
  "disgorgement": ["d-ih-s g-ao1-r-jh m-ah-n-t", "nn"],
  "disgrace": ["d-ih-s g-r-ey1-s", "nn vb"],
  "disgraceful": ["d-ih-s g-r-ey1-s f-ah-l", "jj"],
  "disgruntle": ["d-ih-s g-r-ah1-n t-ah-l", "vb"],
  "disgruntled": ["d-ih-s g-r-ah1-n t-ah-l-d", "jj vbn"],
  "disguise": ["d-ih-s g-ay1-z", "vb vbp nn"],
  "disguised": ["d-ih-s g-ay1-z-d", "vbn vbd jj"],
  "disgust": ["d-ih-s g-ah1-s-t", "nn vb"],
  "disgusted": ["d-ih-s g-ah1 s-t-ah-d", "vbn jj"],
  "disgusting": ["d-ih-s g-ah1 s-t-ih-ng", "jj"],
  "dish": ["d-ih1-sh", "nn vb"],
  "disharmony": ["d-ih-s hh-aa1-r m-ah n-iy", "nn"],
  "dishearten": ["d-ih-s hh-aa1-r t-ah-n", "vb"],
  "disheartening": ["d-ih-s hh-aa1-r t-ah-n ih-ng", "jj"],
  "disheveled": ["d-ih sh-eh1 v-ah-l-d", "jj"],
  "dishonest": ["d-ih-s aa1 n-ah-s-t", "jj"],
  "dishonestly": ["d-ih-s ao1 n-ah-s-t l-iy", "rb"],
  "dishonesty": ["d-ih-s aa1 n-ah s-t-iy", "nn"],
  "dishonor": ["d-ih-s aa1 n-er", "nn vb"],
  "dishonorable": ["d-ih-s aa1 n-er ah b-ah-l", "jj"],
  "dishwasher": ["d-ih1-sh w-aa sh-er", "nn"],
  "disillusion": ["d-ih-s-ih-l-uw1-zh-ah-n", "vb"],
  "disillusioned": ["d-ih-s ih l-uw1 zh-ah-n-d", "vbn jj"],
  "disillusioning": ["d-ih-s ih l-uw1 zh-ah-n ih-ng", "jj"],
  "disillusionment": ["d-ih-s ih l-uw1 zh-ah-n m-ah-n-t", "nn"],
  "disincentive": ["d-ih-s ih-n s-eh1-n t-ih-v", "nn"],
  "disinclination": ["d-ih-s ih-n k-l-ah n-ey1 sh-ah-n", "nn"],
  "disincline": ["d-ih-s-ih-n-k-l-ay1-n", "vb"],
  "disinclined": ["d-ih-s ih-n k-l-ay1-n-d", "vbn jj"],
  "disinfectant": ["d-ih-s ih-n f-eh1-k t-ah-n-t", "nn"],
  "disinflation": ["d-ih-s ih-n f-l-ey1 sh-ah-n", "nn"],
  "disinflationary": ["d-ih-s ih-n f-l-ey1 sh-ah-n eh r-iy", "jj"],
  "disingenuous": ["d-ih-s ih-n jh-eh1 n-y-uw ah-s", "jj"],
  "disintegrate": ["d-ih-s ih1-n t-ah g-r-ey-t", "vb"],
  "disintegration": ["d-ih-s ih-n t-ah g-r-ey1 sh-ah-n", "nn"],
  "disinterest": ["d-ih-s ih1-n t-er ah-s-t", "nn"],
  "disinterested": ["d-ih-s ih1-n t-r-ih s-t-ih-d", "jj"],
  "disjoint": ["d-ih-s-jh-oy1-n-t", "vb"],
  "disjointed": ["d-ih-s jh-oy1-n t-ih-d", "vbn jj"],
  "disk": ["d-ih1-s-k", "nn"],
  "diskette": ["d-ih s-k-eh1-t", "nn"],
  "dislike": ["d-ih-s l-ay1-k", "nn vb vbp"],
  "disliked": ["d-ih-s l-ay1-k-t", "vbd jj vbn"],
  "dislocated": ["d-ih1-s l-ow k-ey t-ih-d", "jj"],
  "dislocation": ["d-ih-s l-ow1 k-ey1 sh-ah-n", "nn"],
  "dislodge": ["d-ih-s l-aa1-jh", "vb"],
  "disloyal": ["d-ih-s l-oy1 ah-l", "jj"],
  "disloyalty": ["d-ih-s l-oy1 ah-l t-iy", "nn"],
  "dismal": ["d-ih1-z m-ah-l", "jj"],
  "dismally": ["d-ih1-z m-ah l-iy", "rb"],
  "dismantle": ["d-ih-s m-ae1-n t-ah-l", "vb"],
  "dismay": ["d-ih-s m-ey1", "nn vb"],
  "dismayed": ["d-ih-s m-ey1-d", "vbn jj"],
  "dismember": ["d-ih-s m-eh1-m b-er", "vb"],
  "dismemberment": ["d-ih-s m-eh1-m b-er m-ah-n-t", "nn"],
  "dismiss": ["d-ih-s m-ih1-s", "vb vbp"],
  "dismissal": ["d-ih-s m-ih1 s-ah-l", "nn"],
  "disobedience": ["d-ih-s ah b-iy1 d-iy ah-n-s", "nn"],
  "disobey": ["d-ih-s ah b-ey1", "vb"],
  "disorder": ["d-ih-s ao1-r d-er", "nn vb"],
  "disorderly": ["d-ih-s ao1-r d-er l-iy", "jj"],
  "disorganization": ["d-ih-s ao-r g-ah n-ah z-ey1 sh-ah-n", "nn"],
  "disorganize": ["d-ih-s-ao1-r-g-ah-n-ay-z", "vb"],
  "disorganized": ["d-ih-s ao1-r g-ah n-ay-z-d", "jj vbn"],
  "disorient": ["d-ih-s-ao1-r-iy-eh-n-t", "vb"],
  "disoriented": ["d-ih-s ao1 r-iy eh-n t-ih-d", "vbn jj"],
  "disown": ["d-ih-s-ow1-n", "vb"],
  "disparage": ["d-ih s-p-eh1 r-ih-jh", "vb"],
  "disparate": ["d-ih1 s-p-er ih-t", "jj"],
  "disparity": ["d-ih s-p-eh1 r-ah t-iy", "nn"],
  "dispassionate": ["d-ih s-p-ae1 sh-ah-n ah-t", "jj"],
  "dispassionately": ["d-ih s-p-ae1 sh-ah-n ah-t l-iy", "rb"],
  "dispatch": ["d-ih s-p-ae1-ch", "nn vb"],
  "dispatcher": ["d-ih s-p-ae1 ch-er", "nn"],
  "dispel": ["d-ih s-p-eh1-l", "vb"],
  "dispensable": ["d-ih s-p-eh1-n s-ah b-ah-l", "jj"],
  "dispense": ["d-ih s-p-eh1-n-s", "vb vbp"],
  "dispenser": ["d-ih s-p-eh1-n s-er", "nn"],
  "dispersal": ["d-ih s-p-er1 s-ah-l", "nn"],
  "dispersant": ["d-ih s-p-er1 s-ah-n-t", "nn"],
  "disperse": ["d-ih s-p-er1-s", "vb"],
  "dispersed": ["d-ih s-p-er1-s-t", "vbn jj vbd"],
  "dispersion": ["d-ih s-p-er1 zh-ah-n", "nn"],
  "displace": ["d-ih-s p-l-ey1-s", "vb"],
  "displacement": ["d-ih-s p-l-ey1-s m-ah-n-t", "nn"],
  "display": ["d-ih s-p-l-ey1", "nn vbp vb"],
  "displease": ["d-ih-s-p-l-iy1-z", "vb"],
  "displeased": ["d-ih-s p-l-iy1-z-d", "vbn jj"],
  "displeasure": ["d-ih-s p-l-eh1 zh-er", "nn"],
  "disposable": ["d-ih s-p-ow1 z-ah b-ah-l", "jj nn"],
  "disposal": ["d-ih s-p-ow1 z-ah-l", "nn"],
  "dispose": ["d-ih s-p-ow1-z", "vb"],
  "disposed": ["d-ih s-p-ow1-z-d", "vbn jj vbd"],
  "disposition": ["d-ih s-p-ah z-ih1 sh-ah-n", "nn"],
  "dispossess": ["d-ih-s-p-ah-z-eh1-s", "vb"],
  "dispossessed": ["d-ih-s p-ah z-eh1-s-t", "vbn jj"],
  "disprove": ["d-ih-s p-r-uw1-v", "vb"],
  "dispute": ["d-ih s-p-y-uw1-t", "nn vbp vb"],
  "disputed": ["d-ih s-p-y-uw1 t-ah-d", "vbn vbd jj"],
  "disqualification": ["d-ih-s k-w-aa l-ah f-ah k-ey1 sh-ah-n", "nn"],
  "disqualified": ["d-ih-s k-w-aa1 l-ah f-ay-d", "vbn vbd"],
  "disqualify": ["d-ih-s k-w-aa1 l-ah f-ay", "vb"],
  "disquiet": ["d-ih-s k-w-ay1 ah-t", "nn"],
  "disquieting": ["d-ih-s k-w-ay1 ah t-ih-ng", "jj"],
  "disregard": ["d-ih-s r-ih g-aa1-r-d", "nn vb"],
  "disrepair": ["d-ih-s r-ih p-eh1-r", "nn"],
  "disreputable": ["d-ih-s r-eh1 p-y-ah t-ah b-ah-l", "jj"],
  "disrepute": ["d-ih-s r-ih p-y-uw1-t", "nn"],
  "disrespect": ["d-ih-s r-ih s-p-eh1-k-t", "nn"],
  "disrupt": ["d-ih-s r-ah1-p-t", "vb vbp"],
  "disrupted": ["d-ih-s r-ah1-p t-ih-d", "vbn jj vbd"],
  "disruption": ["d-ih-s r-ah1-p sh-ah-n", "nn"],
  "disruptive": ["d-ih-s r-ah1-p t-ih-v", "jj"],
  "dissatisfaction": ["d-ih-s ae t-ih-s f-ae1-k sh-ah-n", "nn"],
  "dissatisfied": ["d-ih-s ae1 t-ah-s f-ay-d", "jj vbn"],
  "dissatisfy": ["d-ih-s-ae1-t-ah-s-f-ay", "vb"],
  "dissect": ["d-ay-s-eh1-k-t", "vb"],
  "dissection": ["d-ay s-eh1-k sh-ah-n", "nn"],
  "disseminate": ["d-ih s-eh1 m-ah n-ey-t", "vb"],
  "dissemination": ["d-ih s-eh m-ah n-ey1 sh-ah-n", "nn"],
  "dissension": ["d-ih s-eh1-n sh-ah-n", "nn"],
  "dissent": ["d-ih s-eh1-n-t", "nn vbp vb"],
  "dissenter": ["d-ih s-eh1-n t-er", "nn"],
  "dissenting": ["d-ih s-eh1-n t-ih-ng", "jj vbg"],
  "disservice": ["d-ih-s s-er1 v-ah-s", "nn"],
  "dissident": ["d-ih1 s-ah d-ih-n-t", "jj nn"],
  "dissimilar": ["d-ih s-s-ih1 m-ah l-er", "jj"],
  "dissipate": ["d-ih1 s-ah p-ey-t", "vb"],
  "dissociate": ["d-ih s-ow1 s-iy ey-t", "vb"],
  "dissociation": ["d-ih s-ow s-iy ey1 sh-ah-n", "nn"],
  "dissolution": ["d-ih s-ah l-uw1 sh-ah-n", "nn"],
  "dissolve": ["d-ih z-aa1-l-v", "vb vbp nn"],
  "dissolving": ["d-ih z-ao1-l v-ih-ng", "vbg jj"],
  "dissonance": ["d-ih1 s-ah n-ah-n-s", "nn"],
  "dissuade": ["d-ih s-w-ey1-d", "vb"],
  "distal": ["d-ih1 s-t-ah-l", "jj"],
  "distance": ["d-ih1 s-t-ah-n-s", "nn vb"],
  "distant": ["d-ih1 s-t-ah-n-t", "jj"],
  "distaste": ["d-ih-s t-ey1-s-t", "nn"],
  "distasteful": ["d-ih-s t-ey1-s-t f-ah-l", "jj"],
  "distill": ["d-ih-s-t-ih1-l", "vb"],
  "distillate": ["d-ih1 s-t-ah l-ey-t", "nn"],
  "distillation": ["d-ih s-t-ah l-ey1 sh-ah-n", "nn"],
  "distilled": ["d-ih s-t-ih1-l-d", "vbn jj"],
  "distiller": ["d-ih s-t-ih1 l-er", "nn"],
  "distillery": ["d-ih s-t-ih1 l-er iy", "nn"],
  "distinct": ["d-ih s-t-ih1-ng-k-t", "jj"],
  "distinction": ["d-ih s-t-ih1-ng-k sh-ah-n", "nn"],
  "distinctive": ["d-ih s-t-ih1-ng-k t-ih-v", "jj"],
  "distinctively": ["d-ih s-t-ih1-ng-k t-ih-v l-iy", "rb"],
  "distinctiveness": ["d-ih s-t-ih1-ng-k t-ih-v n-ah-s", "nn"],
  "distinctly": ["d-ih s-t-ih1-ng-k-t l-iy", "rb"],
  "distinguish": ["d-ih s-t-ih1-ng g-w-ih-sh", "vb vbp"],
  "distinguishable": ["d-ih s-t-ih1-ng g-w-ih sh-ah b-ah-l", "jj"],
  "distinguished": ["d-ih s-t-ih1-ng g-w-ih-sh-t", "vbn jj vbd"],
  "distinguishing": ["d-ih s-t-ih1-ng g-w-ih sh-ih-ng", "vbg jj"],
  "distort": ["d-ih s-t-ao1-r-t", "vb vbp"],
  "distorted": ["d-ih s-t-ao1-r t-ah-d", "vbn vbd jj"],
  "distortion": ["d-ih s-t-ao1-r sh-ah-n", "nn"],
  "distract": ["d-ih s-t-r-ae1-k-t", "vb"],
  "distracting": ["d-ih s-t-r-ae1-k t-ih-ng", "vbg jj"],
  "distraction": ["d-ih-s t-r-ae1-k sh-ah-n", "nn"],
  "distraught": ["d-ih s-t-r-ao1-t", "jj"],
  "distress": ["d-ih s-t-r-eh1-s", "nn vb"],
  "distressed": ["d-ih s-t-r-eh1-s-t", "jj vbn"],
  "distressing": ["d-ih s-t-r-eh1 s-ih-ng", "jj"],
  "distressingly": ["d-ih s-t-r-eh1 s-ih-ng l-iy", "rb"],
  "distribute": ["d-ih s-t-r-ih1 b-y-uw-t", "vb vbp"],
  "distributed": ["d-ih-s t-r-ih1 b-y-ah t-ah-d", "vbn vbd jj"],
  "distribution": ["d-ih-s t-r-ah b-y-uw1 sh-ah-n", "nn"],
  "distributive": ["d-ih s-t-r-ih1 b-y-uw t-ih-v", "jj"],
  "distributor": ["d-ih-s t-r-ih1 b-y-ah t-er", "nn"],
  "distributorship": ["d-ih s-t-r-ih1 b-y-uw t-er sh-ih-p", "nn"],
  "district": ["d-ih1 s-t-r-ih-k-t", "nn jj"],
  "distrust": ["d-ih-s t-r-ah1-s-t", "nn vbp vb"],
  "disturb": ["d-ih s-t-er1-b", "vb vbp"],
  "disturbance": ["d-ih s-t-er1 b-ah-n-s", "nn"],
  "disturbed": ["d-ih s-t-er1-b-d", "vbn vbd jj"],
  "disturbing": ["d-ih s-t-er1 b-ih-ng", "jj vbg"],
  "disturbingly": ["d-ih s-t-er1 b-ih-ng l-iy", "rb"],
  "disunion": ["d-ih-s y-uw1 n-y-ah-n", "nn"],
  "disunity": ["d-ih-s y-uw1 n-ah t-iy", "nn"],
  "ditch": ["d-ih1-ch", "nn vb"],
  "dither": ["d-ih1-dh-er", "vb"],
  "ditto": ["d-ih1 t-ow", "nn"],
  "ditty": ["d-ih1 t-iy", "nn"],
  "diuretic": ["d-ay uw r-eh1 t-ih-k", "nn jj"],
  "diurnal": ["d-ay er1 n-ah-l", "jj"],
  "diva": ["d-iy1 v-ah", "nn"],
  "divan": ["d-ih v-ae1-n", "nn"],
  "dive": ["d-ay1-v", "nn vbp vb"],
  "diver": ["d-ay1 v-er", "nn"],
  "diverge": ["d-ih v-er1-jh", "vb vbp"],
  "divergence": ["d-ay v-er1 jh-ah-n-s", "nn"],
  "divergent": ["d-ay v-er1 jh-ah-n-t", "jj"],
  "diverse": ["d-ay v-er1-s", "jj"],
  "diversification": ["d-ay v-er s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "diversified": ["d-ay v-er1 s-ah f-ay-d", "jj vbd vbn"],
  "diversify": ["d-ay v-er1 s-ah f-ay", "vb"],
  "diversion": ["d-ay v-er1 zh-ah-n", "nn"],
  "diversionary": ["d-ay v-er1 zh-ah-n eh r-iy", "jj"],
  "diversity": ["d-ih v-er1 s-ah t-iy", "nn"],
  "divert": ["d-ay v-er1-t", "vb vbp"],
  "divertimento": ["d-ih v-er t-ah m-eh1-n t-ow", "jj"],
  "divest": ["d-ay v-eh1-s-t", "vb vbp"],
  "divested": ["d-ay v-eh1 s-t-ih-d", "vbn jj vbd"],
  "divestiture": ["d-ih v-eh1 s-t-ih ch-er", "nn"],
  "divestment": ["d-ay v-eh1-s-t m-ah-n-t", "nn"],
  "divide": ["d-ih v-ay1-d", "vb nn vbp"],
  "divided": ["d-ih v-ay1 d-ah-d", "vbn vbd jj"],
  "dividend": ["d-ih1 v-ih d-eh-n-d", "nn"],
  "divider": ["d-ih v-ay1 d-er", "nn"],
  "dividing": ["d-ih v-ay1 d-ih-ng", "vbg jj"],
  "divination": ["d-ih v-ah n-ey1 sh-ah-n", "nn"],
  "divine": ["d-ih v-ay1-n", "jj nn vb"],
  "divinely": ["d-ih v-ay1-n l-iy", "rb"],
  "diving": ["d-ay1 v-ih-ng", "vbg jj nn"],
  "divinity": ["d-ih v-ih1 n-ah t-iy", "nn"],
  "divisible": ["d-ih v-ih1 z-ah b-ah-l", "jj"],
  "division": ["d-ih v-ih1 zh-ah-n", "nn"],
  "divisional": ["d-ih v-ih1 zh-ah n-ah-l", "jj"],
  "divisive": ["d-ih v-ay1 s-ih-v", "jj"],
  "divisiveness": ["d-ih v-ay1 s-ih-v n-ah-s", "nn"],
  "divorce": ["d-ih v-ao1-r-s", "nn vb vbp"],
  "divorced": ["d-ih v-ao1-r-s-t", "vbn jj vbd"],
  "divorcee": ["d-ah v-ao1-r s-iy", "nn"],
  "divulge": ["d-ih v-ah1-l-jh", "vb"],
  "divvied": ["d-ih1 v-iy-d", "vbn"],
  "divvy": ["d-ih1-v-iy", "vb"],
  "dizziness": ["d-ih1 z-iy n-ah-s", "nn"],
  "dizzy": ["d-ih1 z-iy", "jj vb"],
  "dizzying": ["d-ih1 z-iy ih-ng", "jj vbg"],
  "do": ["d-uw1", "vb"],
  "doable": ["d-uw1 ah b-ah-l", "jj"],
  "docile": ["d-aa1 s-ah-l", "jj"],
  "dock": ["d-aa1-k", "nn vb"],
  "docket": ["d-aa1 k-ah-t", "nn"],
  "dockside": ["d-aa1-k s-ay-d", "nn"],
  "dockworker": ["d-aa1-k w-er k-er", "nn"],
  "doctor": ["d-aa1-k t-er", "nn vb"],
  "doctoral": ["d-aa1-k t-er ah-l", "jj"],
  "doctorate": ["d-aa1-k t-er ah-t", "nn"],
  "doctoring": ["d-aa1-k t-er ih-ng", "nn"],
  "doctrinal": ["d-aa1-k t-r-ah n-ah-l", "jj"],
  "doctrine": ["d-aa1-k t-r-ah-n", "nn"],
  "document": ["d-aa1 k-y-ah m-eh-n-t", "nn vb vbp"],
  "documentary": ["d-aa k-y-ah m-eh1-n t-er iy", "nn jj"],
  "documentation": ["d-aa k-y-ah m-eh-n t-ey1 sh-ah-n", "nn"],
  "doddering": ["d-aa1 d-er ih-ng", "jj"],
  "dodge": ["d-aa1-jh", "vbp nn vb"],
  "doe": ["d-ow1", "nn"],
  "doer": ["d-uw1-r", "nn"],
  "doesn't": ["d-ah1-z-ah-n-t", "vbz"],
  "doff": ["d-ao1-f", "vb"],
  "dog": ["d-ao1-g", "nn"],
  "dogfight": ["d-aa1-g f-ay-t", "nn"],
  "dogged": ["d-ao1-g-d", "vbn jj vbd"],
  "doggedly": ["d-ao1 g-ah-d l-iy", "rb"],
  "doggerel": ["d-aa1 g-er ah-l", "nn"],
  "doghouse": ["d-ao1-g hh-aw-s", "nn"],
  "dogma": ["d-aa1-g m-ah", "nn"],
  "dogmatic": ["d-aa-g m-ae1 t-ih-k", "jj"],
  "dogmatically": ["d-aa-g m-ae1 t-ih-k l-iy", "rb"],
  "dogmatism": ["d-aa1-g m-ah t-ih z-ah-m", "nn"],
  "dogwood": ["d-ao1-g w-uh-d", "nn"],
  "doldrums": ["d-ow1-l d-r-ah-m-z", "nn"],
  "dole": ["d-ow1-l", "vb nn vbp"],
  "doleful": ["d-ow1-l f-ah-l", "jj"],
  "doll": ["d-aa1-l", "nn"],
  "dollar": ["d-aa1 l-er", "nn"],
  "dollop": ["d-aa1 l-ah-p", "nn"],
  "dolphin": ["d-aa1-l f-ah-n", "nn"],
  "domain": ["d-ow m-ey1-n", "nn"],
  "dome": ["d-ow1-m", "nn"],
  "domed": ["d-ow1-m-d", "jj"],
  "domestic": ["d-ah m-eh1 s-t-ih-k", "jj nn"],
  "domestically": ["d-ah m-eh1 s-t-ih-k l-iy", "rb"],
  "domesticity": ["d-ow m-eh s-t-ih1 s-ah t-iy", "nn"],
  "dominance": ["d-aa1 m-ah n-ah-n-s", "nn"],
  "dominant": ["d-aa1 m-ah n-ah-n-t", "jj"],
  "dominate": ["d-aa1 m-ah n-ey-t", "vb vbp"],
  "dominating": ["d-aa1 m-ah n-ey t-ih-ng", "vbg jj"],
  "domination": ["d-aa m-ah n-ey1 sh-ah-n", "nn"],
  "domineer": ["d-aa-m-ah-n-ih1-r", "vb"],
  "domineering": ["d-aa m-ah n-ih1 r-ih-ng", "vbg jj"],
  "dominion": ["d-ah m-ih1 n-y-ah-n", "nn"],
  "domino": ["d-aa1 m-ah n-ow", "nn"],
  "dominoes": ["d-aa1 m-ah n-ow-z", "nn"],
  "don": ["d-aa1-n", "vb nn vbp"],
  "donate": ["d-ow1 n-ey-t", "vb vbp"],
  "donation": ["d-ow n-ey1 sh-ah-n", "nn"],
  "done": ["d-ah1-n", "vbn jj rb vbd"],
  "donkey": ["d-aa1-ng k-iy", "nn"],
  "donna": ["d-aa1 n-ah", "nn"],
  "donnybrook": ["d-aa1 n-iy b-r-uh-k", "nn"],
  "donor": ["d-ow1 n-er", "nn"],
  "donut": ["d-ow1 n-ah-t", "nn"],
  "don't": ["d-ow1-n-t", "vbp"],
  "doo": ["d-uw1", "nn vb"],
  "doodad": ["d-uw1 d-ae-d", "nn"],
  "doom": ["d-uw1-m", "nn vb"],
  "doomed": ["d-uw1-m-d", "vbn vbd jj"],
  "doomsayer": ["d-uw-m s-ey1 er", "nn"],
  "doomsday": ["d-uw1-m-z d-ey", "nn"],
  "door": ["d-ao1-r", "nn rb"],
  "doorkeeper": ["d-ao1-r k-iy p-er", "nn"],
  "doorknob": ["d-uw1-r n-aa-b", "nn"],
  "doorman": ["d-ao1-r m-ae-n", "nn"],
  "doorstep": ["d-ao1-r s-t-eh-p", "nn"],
  "doorway": ["d-ao1-r w-ey", "nn"],
  "dope": ["d-ow1-p", "nn"],
  "doped": ["d-ow1-p-t", "jj"],
  "dorm": ["d-ao1-r-m", "nn"],
  "dormant": ["d-ao1-r m-ah-n-t", "jj"],
  "dormitory": ["d-ao1-r m-ah t-ao r-iy", "nn"],
  "dosage": ["d-ow1 s-ah-jh", "nn"],
  "dose": ["d-ow1-s", "nn"],
  "dossier": ["d-ao s-y-ey1", "nn"],
  "dot": ["d-aa1-t", "nn vbp vb"],
  "doting": ["d-ow1 t-ih-ng", "vbg jj"],
  "dotted": ["d-aa1 t-ah-d", "vbn vbd jj"],
  "double": ["d-ah1 b-ah-l", "jj vbp nn rb vb"],
  "doubly": ["d-ah1 b-l-iy", "rb"],
  "doubt": ["d-aw1-t", "nn vbp rb vb"],
  "doubter": ["d-aw1 t-er", "nn"],
  "doubtful": ["d-aw1-t f-ah-l", "jj"],
  "doubting": ["d-aw1 t-ih-ng", "vbg jj"],
  "doubtless": ["d-aw1-t l-ah-s", "rb"],
  "dough": ["d-ow1", "nn"],
  "doughnut": ["d-ow1 n-ah-t", "nn"],
  "dour": ["d-aw1 er", "jj"],
  "douse": ["d-aw1-s", "vb"],
  "dove": ["d-ah1-v", "nn vbd vbn"],
  "dovetail": ["d-ah1-v t-ey-l", "vbp vb"],
  "dovish": ["d-ow1 v-ih-sh", "jj"],
  "dowdy": ["d-aw1 d-iy", "jj"],
  "dowel": ["d-aw1 ah-l", "nn"],
  "dower": ["d-aw1-r", "nn"],
  "down": ["d-aw1-n", "rb in rbr vbp jj nn rp vb"],
  "downbeat": ["d-aw-n b-iy1-t", "jj nn"],
  "downcast": ["d-aw1-n k-ae-s-t", "jj"],
  "downdraft": ["d-aw1-n d-r-ae-f-t", "nn"],
  "downer": ["d-aw1 n-er", "nn"],
  "downfall": ["d-aw1-n f-ao-l", "nn"],
  "downgrade": ["d-aw1-n g-r-ey1-d", "nn vb"],
  "downhill": ["d-aw1-n hh-ih1-l", "rb jj"],
  "downpayment": ["d-aw-n p-ey1 m-ah-n-t", "nn"],
  "downplay": ["d-aw1-n p-l-ey", "vb"],
  "downpour": ["d-aw1-n p-ao-r", "nn"],
  "downright": ["d-aw1-n r-ay-t", "rb jj"],
  "downside": ["d-aw1-n s-ay-d", "nn jj"],
  "downsize": ["d-aw1-n s-ay-z", "vb"],
  "downstairs": ["d-aw1-n s-t-eh1-r-z", "nn rb"],
  "downstream": ["d-aw1-n s-t-r-iy1-m", "rb jj"],
  "downtime": ["d-aw1-n t-ay-m", "nn"],
  "downtown": ["d-aw1-n t-aw1-n", "nn jj rb"],
  "downtrend": ["d-aw1-n t-r-eh-n-d", "nn"],
  "downtrodden": ["d-aw-n t-r-aa1 d-ah-n", "jj"],
  "downturn": ["d-aw1-n t-er-n", "nn"],
  "downward": ["d-aw1-n w-er-d", "jj rb"],
  "dowry": ["d-aw1 r-iy", "nn"],
  "doze": ["d-ow1-z", "vb"],
  "dozen": ["d-ah1 z-ah-n", "nn"],
  "drab": ["d-r-ae1-b", "jj"],
  "drachma": ["d-r-ae1-k m-ah", "nn"],
  "draconian": ["d-r-ey k-ow1 n-iy ah-n", "jj"],
  "draft": ["d-r-ae1-f-t", "nn jj vb vbp"],
  "draftee": ["d-r-ae1-f t-iy1", "nn"],
  "drafter": ["d-r-ae1-f t-er", "nn"],
  "drafty": ["d-r-ae1-f t-iy", "jj"],
  "drag": ["d-r-ae1-g", "nn vbp vb"],
  "dragnet": ["d-r-ae1-g n-eh-t", "nn"],
  "dragon": ["d-r-ae1 g-ah-n", "nn"],
  "drain": ["d-r-ey1-n", "nn vbp vb"],
  "drainage": ["d-r-ey1 n-ah-jh", "nn"],
  "dram": ["d-r-ae1-m", "nn"],
  "drama": ["d-r-aa1 m-ah", "nn"],
  "dramas": ["d-r-aa1 m-ah-z", "nn"],
  "dramatic": ["d-r-ah m-ae1 t-ih-k", "jj"],
  "dramatically": ["d-r-ah m-ae1 t-ih-k l-iy", "rb"],
  "dramatist": ["d-r-aa1 m-ah t-ih-s-t", "nn"],
  "dramatization": ["d-r-ae m-ah t-ah z-ey1 sh-ah-n", "nn"],
  "dramatize": ["d-r-aa1 m-ah t-ay-z", "vb vbp"],
  "drank": ["d-r-ae1-ng-k", "vbd"],
  "drape": ["d-r-ey1-p", "nn vb"],
  "draped": ["d-r-ey1-p-t", "vbd jj vbn"],
  "draper": ["d-r-ey1 p-er", "nn"],
  "drapery": ["d-r-ey1 p-er iy", "nn"],
  "drastic": ["d-r-ae1 s-t-ih-k", "jj rb"],
  "drastically": ["d-r-ae1 s-t-ih-k l-iy", "rb"],
  "draught": ["d-r-ae1-f-t", "nn"],
  "draughts": ["d-r-ae1-f-t-s", "nn"],
  "draw": ["d-r-ao1", "vb vbp nn"],
  "drawback": ["d-r-ao1 b-ae-k", "nn"],
  "drawbridge": ["d-r-ao1 b-r-ih-jh", "nn"],
  "drawdown": ["d-r-ao1 d-aw-n", "nn"],
  "drawer": ["d-r-ao1-r", "nn"],
  "drawing": ["d-r-ao1 ih-ng", "vbg jj nn"],
  "drawl": ["d-r-ao1-l", "nn vb"],
  "drawn": ["d-r-ao1-n", "vbn jj"],
  "dread": ["d-r-eh1-d", "nn jj vb"],
  "dreaded": ["d-r-eh1 d-ih-d", "vbn vbd jj"],
  "dreadful": ["d-r-eh1-d f-ah-l", "jj nn"],
  "dreadfully": ["d-r-eh1-d f-ah l-iy", "rb"],
  "dream": ["d-r-iy1-m", "nn vb vbp"],
  "dreamer": ["d-r-iy1 m-er", "nn"],
  "dreamlike": ["d-r-iy1-m l-ay-k", "jj"],
  "dreamt": ["d-r-eh1-m-t", "vbd vbn"],
  "dreamy": ["d-r-iy1 m-iy", "jj"],
  "dreariness": ["d-r-iy1 r-iy n-ah-s", "nn"],
  "dreary": ["d-r-ih1 r-iy", "jj"],
  "dredge": ["d-r-eh1-jh", "vb"],
  "dreg": ["d-r-eh1-g", "nn"],
  "drenching": ["d-r-eh1-n ch-ih-ng", "nn"],
  "dress": ["d-r-eh1-s", "nn vbp vb"],
  "dressed": ["d-r-eh1-s-t", "vbn jj vbd"],
  "dresser": ["d-r-eh1 s-er", "nn"],
  "dressing": ["d-r-eh1 s-ih-ng", "nn vbg jj"],
  "dressmaking": ["d-r-eh1-s m-ey k-ih-ng", "nn"],
  "dressy": ["d-r-eh1 s-iy", "jj"],
  "drew": ["d-r-uw1", "vbd"],
  "dribble": ["d-r-ih1 b-ah-l", "nn vb"],
  "dried": ["d-r-ay1-d", "vbn vbd jj"],
  "drier": ["d-r-ay1 er", "nn jjr rbr"],
  "drift": ["d-r-ih1-f-t", "nn vbp vb"],
  "drifter": ["d-r-ih1-f t-er", "nn"],
  "drifting": ["d-r-ih1-f t-ih-ng", "vbg jj nn"],
  "driftnet": ["d-r-ih1-f-t n-eh-t", "nn"],
  "driftwood": ["d-r-ih1-f-t w-uh-d", "nn"],
  "drill": ["d-r-ih1-l", "nn vb"],
  "driller": ["d-r-ih1 l-er", "nn"],
  "drilling": ["d-r-ih1 l-ih-ng", "nn jj vbg"],
  "drink": ["d-r-ih1-ng-k", "nn vbp vb"],
  "drinker": ["d-r-ih1-ng k-er", "nn"],
  "drinking": ["d-r-ih1-ng k-ih-ng", "nn jj vbg"],
  "drip": ["d-r-ih1-p", "nn vb"],
  "drive": ["d-r-ay1-v", "nn vbp vb"],
  "driven": ["d-r-ih1 v-ah-n", "vbn jj"],
  "driver": ["d-r-ay1 v-er", "nn"],
  "driveway": ["d-r-ay1-v w-ey", "nn"],
  "driving": ["d-r-ay1 v-ih-ng", "vbg jj nn"],
  "drizzle": ["d-r-ih1 z-ah-l", "nn vb"],
  "drizzly": ["d-r-ih1-z l-iy", "jj"],
  "drone": ["d-r-ow1-n", "nn jj"],
  "drool": ["d-r-uw1-l", "vb"],
  "droop": ["d-r-uw1-p", "vb vbp nn"],
  "drop": ["d-r-aa1-p", "nn jj vb vbp"],
  "droplet": ["d-r-aa1 p-l-ah-t", "nn"],
  "dropoff": ["d-r-aa1 p-ao-f", "nn"],
  "dropout": ["d-r-aa1-p aw-t", "nn"],
  "dropper": ["d-r-aa1 p-er", "nn"],
  "dross": ["d-r-ao1-s", "nn"],
  "drought": ["d-r-aw1-t", "nn"],
  "drove": ["d-r-ow1-v", "vbd nn"],
  "drover": ["d-r-ow1 v-er", "nn"],
  "drown": ["d-r-aw1-n", "vb vbp"],
  "drowned": ["d-r-aw1-n-d", "vbn jj vbd"],
  "drowsy": ["d-r-aw1 z-iy", "jj"],
  "drub": ["d-r-ah1-b", "vb"],
  "drubbing": ["d-r-ah1 b-ih-ng", "nn"],
  "drudgery": ["d-r-ah1 jh-er iy", "nn"],
  "drug": ["d-r-ah1-g", "nn"],
  "drugged": ["d-r-ah1-g-d", "vbn jj"],
  "druggist": ["d-r-ah1 g-ih-s-t", "nn"],
  "drugstore": ["d-r-ah1-g s-t-ao-r", "nn"],
  "drum": ["d-r-ah1-m", "vb nn"],
  "drumbeat": ["d-r-ah1-m b-iy-t", "nn"],
  "drummer": ["d-r-ah1 m-er", "nn"],
  "drunk": ["d-r-ah1-ng-k", "jj nn vbn"],
  "drunkard": ["d-r-ah1-ng k-er-d", "nn"],
  "drunken": ["d-r-ah1-ng k-ah-n", "jj"],
  "drunkenness": ["d-r-ah1-ng k-ah-n n-ah-s", "nn"],
  "dry": ["d-r-ay1", "jj vb vbp"],
  "dryer": ["d-r-ay1 er", "nn"],
  "dryly": ["d-r-ay1 l-iy", "rb"],
  "dryness": ["d-r-ay1 n-ah-s", "nn"],
  "dual": ["d-uw1 ah-l", "jj"],
  "dualism": ["d-uw1 ah l-ih z-ah-m", "nn"],
  "dub": ["d-ah1-b", "vb"],
  "dubious": ["d-uw1 b-iy ah-s", "jj"],
  "duck": ["d-ah1-k", "nn vb"],
  "duckling": ["d-ah1 k-l-ih-ng", "nn"],
  "duct": ["d-ah1-k-t", "nn"],
  "dud": ["d-ah1-d", "nn"],
  "dudgeon": ["d-ah1 jh-ah-n", "nn"],
  "due": ["d-uw1", "jj nn "],
  "duel": ["d-uw1 ah-l", "nn vb"],
  "duet": ["d-uw eh1-t", "nn"],
  "duffel": ["d-ah1 f-ah-l", "nn"],
  "duffer": ["d-ah1 f-er", "nn"],
  "dug": ["d-ah1-g", "vbd vbn"],
  "dugout": ["d-ah1-g aw-t", "nn"],
  "duke": ["d-uw1-k", "nn"],
  "dull": ["d-ah1-l", "jj vb"],
  "duller": ["d-ah1 l-er", "jjr rbr"],
  "dullest": ["d-ah1 l-ah-s-t", "jjs"],
  "dullness": ["d-ah1-l n-ah-s", "nn"],
  "duly": ["d-uw1 l-iy", "rb"],
  "dumb": ["d-ah1-m", "jj"],
  "dumbbell": ["d-ah1-m b-eh-l", "nn"],
  "dumber": ["d-ah1 m-er", "jjr"],
  "dumbest": ["d-ah1 m-ah-s-t", "jjs"],
  "dumbfounded": ["d-ah1-m f-aw-n d-ih-d", "jj vbn"],
  "dummy": ["d-ah1 m-iy", "jj nn"],
  "dump": ["d-ah1-m-p", "vb vbp nn"],
  "dumpster": ["d-ah1-m-p s-t-er", "nn"],
  "dumpy": ["d-ah1-m p-iy", "jj"],
  "dun": ["d-ah1-n", "nn"],
  "dune": ["d-uw1-n", "nn"],
  "dung": ["d-ah1-ng", "nn"],
  "dungeon": ["d-ah1-n jh-ah-n", "nn"],
  "dunk": ["d-ah1-ng-k", "nn vb"],
  "duo": ["d-uw1 ow", "nn"],
  "duodenal": ["d-uw1 ah d-iy1 n-ah-l", "jj"],
  "duopoly": ["d-uw1 ow p-aa l-iy", "rb"],
  "dupe": ["d-uw1-p", "vb"],
  "duplex": ["d-uw1 p-l-eh-k-s", "nn jj"],
  "duplicate": ["d-uw1 p-l-ah k-ah-t", "vb jj"],
  "duplication": ["d-y-uw p-l-ah k-ey1 sh-ah-n", "nn"],
  "duplicative": ["d-uw p-l-ih1 k-ah t-ih-v", "jj"],
  "duplicity": ["d-uw p-l-ih1 s-ih t-iy", "nn"],
  "durability": ["d-er ah b-ih1 l-ih t-iy", "nn"],
  "durable": ["d-uh1 r-ah b-ah-l", "jj"],
  "duration": ["d-uh1 r-ey1 sh-ah-n", "nn"],
  "duress": ["d-uh1 r-eh-s", "nn"],
  "during": ["d-uh1 r-ih-ng", "in"],
  "durn": ["d-er1-n", "jj"],
  "dusk": ["d-ah1-s-k", "nn"],
  "dust": ["d-ah1-s-t", "nn vb vbp"],
  "dusty": ["d-ah1 s-t-iy", "jj"],
  "dutiful": ["d-uw1 t-iy f-ah-l", "jj"],
  "dutifully": ["d-uw1 t-iy f-ah l-iy", "rb"],
  "duty": ["d-uw1 t-iy", "nn"],
  "dwarf": ["d-w-ao1-r-f", "nn vbp vb"],
  "dwell": ["d-w-eh1-l", "vbp vb"],
  "dweller": ["d-w-eh1 l-er", "nn"],
  "dwelling": ["d-w-eh1 l-ih-ng", "nn vbg"],
  "dwelt": ["d-w-eh1-l-t", "vbd"],
  "dwindle": ["d-w-ih1-n d-ah-l", "vb"],
  "dye": ["d-ay1", "nn vb"],
  "dyeing": ["d-ay1 ih-ng", "nn"],
  "dying": ["d-ay1 ih-ng", "vbg jj nn"],
  "dyke": ["d-ay1-k", "nn"],
  "dynamic": ["d-ay n-ae1 m-ih-k", "jj nn"],
  "dynamism": ["d-ay1 n-ah m-ih z-ah-m", "nn"],
  "dynamite": ["d-ay1 n-ah m-ay-t", "nn jj"],
  "dynamo": ["d-ay1 n-ah m-ow", "nn"],
  "dynastic": ["d-ay n-ae1 s-t-ih-k", "jj"],
  "dynasty": ["d-ay1 n-ah s-t-iy", "nn"],
  "dysentery": ["d-ih1-s ah-n t-eh r-iy", "nn"],
  "dysfunction": ["d-ih-s f-ah1-ng-k sh-ah-n", "nn"],
  "dyslexia": ["d-ih-s l-eh1-k s-iy ah", "nn"],
  "dysplasia": ["d-ih s-p-l-ey1 zh-ah", "nn"],
  "dystrophy": ["d-ih1-s t-r-ah f-iy", "nn"],
  "each": ["iy1-ch", "dt"],
  "eager": ["iy1 g-er", "jj"],
  "eagerly": ["iy1 g-er l-iy", "rb"],
  "eagerness": ["iy1 g-er n-ah-s", "nn"],
  "eagle": ["iy1 g-ah-l", "nn"],
  "ear": ["ih1-r", "nn"],
  "eared": ["ih1-r-d", "jj"],
  "earful": ["iy1-r f-ah-l", "nn"],
  "earl": ["er1-l", "nn"],
  "earlier": ["er1 l-iy er", "rbr jjr jj nn rb"],
  "earliest": ["er1 l-iy ah-s-t", "jjs rbs"],
  "early": ["er1 l-iy", "jj rb"],
  "earmark": ["ih1-r m-aa-r-k", "vb"],
  "earmarked": ["ih1-r m-aa-r-k-t", "vbn vbd jj"],
  "earn": ["er1-n", "vb vbp"],
  "earned": ["er1-n-d", "vbd jj vbn"],
  "earner": ["er1 n-er", "nn"],
  "earnest": ["er1 n-ih-s-t", "nn jj"],
  "earnestly": ["er1 n-ah-s-t l-iy", "rb"],
  "earnestness": ["er1 n-ah-s-t n-ah-s", "nn"],
  "earphone": ["ih1-r f-ow-n", "nn"],
  "earring": ["ih1 r-ih-ng", "nn"],
  "earth": ["er1-th", "nn"],
  "earthbound": ["er1-th b-aw-n-d", "jj"],
  "earthenware": ["er1 th-ah-n w-eh-r", "nn"],
  "earthling": ["er1-th l-ih-ng", "nn"],
  "earthly": ["er1-th l-iy", "jj"],
  "earthmoving": ["er1-th m-uw v-ih-ng", "jj nn"],
  "earthquake": ["er1-th k-w-ey-k", "nn"],
  "earthshaking": ["er1-th sh-ey k-ih-ng", "jj"],
  "earthworm": ["er1-th w-er-m", "nn"],
  "earthy": ["er1 th-iy", "jj"],
  "ease": ["iy1-z", "vb nn vbp"],
  "easel": ["iy1 z-ah-l", "nn"],
  "easement": ["iy1-z m-ah-n-t", "nn"],
  "easier": ["iy1 z-iy er", "jjr rbr rb"],
  "easiest": ["iy1 z-iy ah-s-t", "jjs"],
  "easily": ["iy1 z-ah l-iy", "rb"],
  "easing": ["iy1 z-ih-ng", "vbg jj nn"],
  "east": ["iy1-s-t", "jj nn rb"],
  "eastern": ["iy1 s-t-er-n", "jj"],
  "eastward": ["iy1-s-t w-er-d", "rb"],
  "easy": ["iy1 z-iy", "jj rb"],
  "easygoing": ["iy1 z-iy g-ow1 ih-ng", "jj"],
  "eat": ["iy1-t", "vb vbp"],
  "eaten": ["iy1 t-ah-n", "vbn"],
  "eater": ["iy1 t-er", "nn"],
  "eatery": ["iy1 t-er iy", "nn"],
  "eating": ["iy1 t-ih-ng", "vbg jj nn"],
  "eave": ["iy1-v", "nn"],
  "eavesdrop": ["iy1-v-z d-r-aa-p", "vb"],
  "ebb": ["eh1-b", "nn vb"],
  "ebony": ["eh1 b-ah n-iy", "nn jj"],
  "ebullient": ["ih b-ah1-l y-ah-n-t", "jj"],
  "eccentric": ["ih-k s-eh1-n t-r-ih-k", "jj nn"],
  "eccentricity": ["eh-k s-ah-n t-r-ih1 s-ah t-iy", "nn"],
  "ecclesiastical": ["ih k-l-iy z-iy ae1 s-t-ih k-ah-l", "jj"],
  "echelon": ["eh1 sh-ah l-aa-n", "nn"],
  "echo": ["eh1 k-ow", "nn vbp vb"],
  "eclectic": ["ih k-l-eh1-k t-ih-k", "jj nn"],
  "eclipse": ["ih k-l-ih1-p-s", "vb nn vbp"],
  "ecliptic": ["ih k-l-ih1-p t-ih-k", "nn jj"],
  "ecological": ["iy k-ah l-aa1 jh-ih k-ah-l", "jj"],
  "ecologically": ["iy k-ah l-aa1 jh-ih-k l-iy", "rb"],
  "ecologist": ["ih k-aa1 l-ah jh-ih-s-t", "nn"],
  "ecology": ["ih k-aa1 l-ah jh-iy", "nn"],
  "economic": ["eh k-ah n-aa1 m-ih-k", "jj"],
  "economical": ["eh k-ah n-aa1 m-ih k-ah-l", "jj"],
  "economically": ["eh k-ah n-aa1 m-ih-k l-iy", "rb"],
  "economics": ["eh k-ah n-aa1 m-ih-k-s", "nn"],
  "economist": ["ih k-aa1 n-ah m-ih-s-t", "nn"],
  "economize": ["ih k-aa1 n-ah m-ay-z", "vb"],
  "economy": ["ih k-aa1 n-ah m-iy", "nn"],
  "ecstasy": ["eh1-k s-t-ah s-iy", "nn"],
  "ecstatic": ["eh-k s-t-ae1 t-ih-k", "jj nn"],
  "ecstatically": ["eh-k s-t-ae1 t-ih-k l-iy", "rb"],
  "ecumenical": ["eh k-y-uw m-eh1 n-ih k-ah-l", "jj"],
  "edema": ["ih d-iy1 m-ah", "nn"],
  "edge": ["eh1-jh", "nn vb"],
  "edged": ["eh1-jh-d", "vbd jj vbn"],
  "edginess": ["eh1 jh-iy n-ah-s", "nn"],
  "edgy": ["eh1 jh-iy", "jj"],
  "edible": ["eh1 d-ah b-ah-l", "jj"],
  "edict": ["iy1 d-ih-k-t", "nn"],
  "edifice": ["eh1 d-ah f-ah-s", "nn"],
  "edifying": ["eh1 d-ah f-ay ih-ng", "jj"],
  "edit": ["eh1 d-ah-t", "vb"],
  "edition": ["ah d-ih1 sh-ah-n", "nn"],
  "editor": ["eh1 d-ah t-er", "nn"],
  "editorial": ["eh d-ah t-ao1 r-iy ah-l", "nn jj"],
  "editorialist": ["eh d-ah t-ao1 r-iy ah l-ih-s-t", "nn"],
  "editorialize": ["eh d-ah t-ao1 r-iy ah l-ay-z", "vb"],
  "editorially": ["eh d-ah t-ao1 r-iy ah l-iy", "rb"],
  "editorship": ["eh1 d-ah t-er sh-ih-p", "nn"],
  "educate": ["eh1 jh-ah k-ey-t", "vb"],
  "educated": ["eh1 jh-ah k-ey t-ah-d", "vbn jj"],
  "education": ["eh jh-ah k-ey1 sh-ah-n", "nn"],
  "educational": ["eh jh-ah k-ey1 sh-ah n-ah-l", "jj"],
  "educator": ["eh1 jh-ah k-ey t-er", "nn"],
  "eel": ["iy1-l", "nn"],
  "eerie": ["ih1 r-iy", "jj"],
  "eerily": ["ih1 r-ah l-iy", "rb"],
  "effect": ["ih f-eh1-k-t", "nn jj vb vbp"],
  "effective": ["ih f-eh1-k t-ih-v", "jj vbn nn"],
  "effectively": ["ih f-eh1-k t-ih-v l-iy", "rb"],
  "effectiveness": ["ih f-eh1-k t-ih-v n-ah-s", "nn"],
  "effete": ["eh f-iy1-t", "jj"],
  "efficacious": ["eh f-ah k-ey1 sh-ah-s", "jj"],
  "efficacy": ["eh1 f-ih k-ae s-iy", "nn"],
  "efficiency": ["ih f-ih1 sh-ah-n s-iy", "nn"],
  "efficient": ["ih f-ih1 sh-ah-n-t", "jj"],
  "efficiently": ["ih f-ih1 sh-ah-n-t l-iy", "rb"],
  "effigy": ["eh1 f-ih jh-iy", "nn"],
  "effluent": ["eh1 f-l-uw ah-n-t", "nn jj"],
  "effort": ["eh1 f-er-t", "nn"],
  "effortless": ["eh1 f-er-t l-ah-s", "jj"],
  "effortlessly": ["eh1 f-er-t l-ah-s l-iy", "rb"],
  "effrontery": ["ih f-r-ah1-n t-er iy", "nn"],
  "effusive": ["eh1 f-y-uw s-ih-v", "jj"],
  "egalitarian": ["ih g-ae l-ah t-eh1 r-iy ah-n", "jj"],
  "egalitarianism": ["iy g-ae l-ah t-eh1 r-iy ah n-ih z-ah-m", "nn"],
  "egg": ["eh1-g", "nn vb"],
  "egghead": ["eh1-g hh-eh-d", "nn"],
  "eggplant": ["eh1-g p-l-ae-n-t", "nn"],
  "eggshell": ["eh1-g sh-eh-l", "jj"],
  "ego": ["iy1 g-ow", "nn"],
  "egocentric": ["iy g-ow s-eh1-n t-r-ih-k", "jj"],
  "egotism": ["iy1 g-ah t-ih z-ah-m", "nn"],
  "egotist": ["iy1 g-ah t-ih-s-t", "nn"],
  "egotistical": ["iy g-ah t-ih1 s-t-ih k-ah-l", "jj"],
  "egregious": ["ih g-r-iy1 jh-ah-s", "jj"],
  "egregiously": ["ih g-r-iy1 jh-ah-s l-iy", "rb"],
  "eight": ["ey1-t", "cd"],
  "eighth": ["ey1-t-th", "jj nn"],
  "eighty": ["ey1 t-iy", "nn"],
  "either": ["iy1 dh-er", "dt cc in rb rbr"],
  "eject": ["ih jh-eh1-k-t", "vb"],
  "ejection": ["ih jh-eh1-k sh-ah-n", "nn"],
  "eke": ["iy1-k", "vb"],
  "elaborate": ["ih l-ae1 b-r-ah-t", "vb jj"],
  "elaborately": ["ih l-ae1 b-r-ah-t l-iy", "rb"],
  "elaboration": ["ih l-ae b-er ey1 sh-ah-n", "nn"],
  "elapse": ["ih l-ae1-p-s", "vb"],
  "elastic": ["ih l-ae1 s-t-ih-k", "jj nn"],
  "elasticity": ["iy l-ae s-t-ih1 s-ah t-iy", "nn"],
  "elate": ["ih-l-ey1-t", "vb"],
  "elated": ["ih l-ey1 t-ah-d", "jj vbn"],
  "elation": ["ih l-ey1 sh-ah-n", "nn"],
  "elbow": ["eh1-l b-ow", "nn vb"],
  "elder": ["eh1-l d-er", "jjr jj nn"],
  "elderly": ["eh1-l d-er l-iy", "jj nn"],
  "eldest": ["eh1-l d-ah-s-t", "jjs"],
  "elect": ["ih l-eh1-k-t", "vb vbp"],
  "elected": ["ih l-eh1-k t-ah-d", "vbn jj vbd"],
  "election": ["ih l-eh1-k sh-ah-n", "nn"],
  "elective": ["ih l-eh1-k t-ih-v", "jj"],
  "elector": ["ih l-eh1-k t-er", "nn"],
  "electoral": ["ih l-eh1-k t-er ah-l", "jj"],
  "electorate": ["ih l-eh1-k t-er ah-t", "nn"],
  "electric": ["ih l-eh1-k t-r-ih-k", "jj nn"],
  "electrical": ["ih l-eh1-k t-r-ih k-ah-l", "jj"],
  "electrically": ["ih l-eh1-k t-r-ih k-ah l-iy", "rb"],
  "electrician": ["ih l-eh-k t-r-ih1 sh-ah-n", "nn"],
  "electricity": ["ih l-eh-k t-r-ih1 s-ah t-iy", "nn"],
  "electrified": ["ih l-eh1-k t-r-ah f-ay-d", "vbn"],
  "electrify": ["ih-l-eh1-k-t-r-ah-f-ay", "vb"],
  "electrifying": ["ih l-eh1-k t-r-ah f-ay ih-ng", "jj"],
  "electrocardiogram": ["ih l-eh-k t-r-ow k-aa1-r d-iy ah g-r-ae-m", "nn"],
  "electrode": ["ih l-eh1-k t-r-ow-d", "nn"],
  "electrodynamics": ["ih l-eh-k t-r-ow d-ay n-ae1 m-ih-k-s", "nn"],
  "electrolysis": ["ih l-eh-k t-r-aa1 l-ah s-ah-s", "nn"],
  "electrolytic": ["ih l-eh-k t-r-ah l-ih1 t-ih-k", "jj"],
  "electromagnet": ["ih l-eh-k t-r-ow m-ae1-g n-ah-t", "nn"],
  "electromagnetism": ["ih l-eh-k t-r-ow m-ae1-g n-ah t-ih z-ah-m", "nn"],
  "electromechanical": ["ih l-eh-k t-r-ow m-ah k-ae1 n-ih k-ah-l", "jj"],
  "electron": ["ih l-eh1-k t-r-aa-n", "nn"],
  "electronic": ["ih l-eh-k t-r-aa1 n-ih-k", "jj"],
  "electronically": ["ih l-eh-k t-r-aa1 n-ih k-ah l-iy", "rb"],
  "electronics": ["ih l-eh-k t-r-aa1 n-ih-k-s", "nn"],
  "electroplating": ["ih l-eh1-k t-r-ah p-l-ey t-ih-ng", "nn"],
  "electroshock": ["ih l-eh1-k t-r-ow sh-aa-k", "nn"],
  "electrostatic": ["ih l-eh-k t-r-ow s-t-ae1 t-ih-k", "jj"],
  "elegance": ["eh1 l-ah g-ah-n-s", "nn"],
  "elegant": ["eh1 l-ah g-ah-n-t", "jj"],
  "elegantly": ["eh1 l-ih g-ah-n-t l-iy", "rb"],
  "element": ["eh1 l-ah m-ah-n-t", "nn"],
  "elemental": ["eh l-ah m-eh1-n t-ah-l", "jj nn"],
  "elementary": ["eh l-ah m-eh1-n t-r-iy", "jj"],
  "elephant": ["eh1 l-ah f-ah-n-t", "nn"],
  "elephantine": ["eh l-ah f-ae1-n t-iy-n", "jj"],
  "elevate": ["eh1 l-ah v-ey-t", "vb vbp"],
  "elevated": ["eh1 l-ah v-ey t-ih-d", "vbn vbd jj"],
  "elevation": ["eh l-ah v-ey1 sh-ah-n", "nn"],
  "elevator": ["eh1 l-ah v-ey t-er", "nn"],
  "eleven": ["ih l-eh1 v-ah-n", "cd"],
  "eleventh": ["ih l-eh1 v-ah-n-th", "jj"],
  "elfin": ["eh1-l f-ih-n", "jj"],
  "elicit": ["ih l-ih1 s-ih-t", "vb"],
  "eligibility": ["eh l-ih jh-ah b-ih1 l-ih t-iy", "nn"],
  "eligible": ["eh1 l-ah jh-ah b-ah-l", "jj nn"],
  "eliminate": ["ih l-ih1 m-ah n-ey-t", "vb vbp"],
  "elimination": ["ih l-ih m-ah n-ey1 sh-ah-n", "nn"],
  "elite": ["ih l-iy1-t", "nn jj"],
  "elitist": ["ey l-iy1 t-ih-s-t", "jj"],
  "elixir": ["ih l-ih1-k s-er", "nn"],
  "elk": ["eh1-l-k", "nn"],
  "ellipsoid": ["ih l-ih1-p s-oy-d", "nn"],
  "elliptical": ["ih l-ih1-p t-ih k-ah-l", "jj"],
  "elm": ["eh1-l-m", "nn"],
  "elongate": ["ih l-ao1-ng g-ey-t", "vb"],
  "elongated": ["ih l-ao1-ng g-ey t-ah-d", "vbn jj"],
  "elongation": ["iy l-ao-ng g-ey1 sh-ah-n", "nn"],
  "eloquence": ["eh1 l-ah k-w-ah-n-s", "nn"],
  "eloquent": ["eh1 l-ah k-w-ah-n-t", "jj"],
  "eloquently": ["eh1 l-ah k-w-ah-n-t l-iy", "rb"],
  "else": ["eh1-l-s", "rb jj nn"],
  "elsewhere": ["eh1-l s-w-eh-r", "rb nn"],
  "elucidate": ["ih-l-uw1-s-ah-d-ey-t", "vb"],
  "elude": ["ih-l-uw1-d", "vb"],
  "elusive": ["ih l-uw1 s-ih-v", "jj"],
  "elusiveness": ["ih l-uw1 s-ih-v n-ah-s", "nn"],
  "emaciate": ["ih-m-ey1-sh-iy-ey-t", "vb"],
  "emaciated": ["ih m-ey1 sh-iy ey t-ih-d", "vbn jj"],
  "emanate": ["eh1-m-ah-n-ey-t", "vb"],
  "emanation": ["eh m-ah n-ey1 sh-ah-n", "nn"],
  "emancipate": ["ih m-ae1-n s-ah p-ey-t", "vb"],
  "emancipated": ["ih m-ae1-n s-ah p-ey t-ih-d", "vbn jj"],
  "emancipation": ["ih m-ae-n s-ah p-ey1 sh-ah-n", "nn"],
  "emasculate": ["ah m-ae1-s k-y-uw l-ih-t", "vb"],
  "embankment": ["eh-m b-ae1-ng-k m-ah-n-t", "nn"],
  "embargo": ["eh-m b-aa1-r g-ow", "nn vb"],
  "embargoed": ["ih-m b-aa1-r g-ow-d", "jj vbd vbn"],
  "embark": ["eh-m b-aa1-r-k", "vb vbp"],
  "embarrass": ["ih-m b-eh1 r-ah-s", "vb"],
  "embarrassed": ["ih-m b-eh1 r-ah-s-t", "vbn vbd jj"],
  "embarrassing": ["ih-m b-eh1 r-ah s-ih-ng", "jj vbg"],
  "embarrassingly": ["ih-m b-eh1 r-ah s-ih-ng l-iy", "rb"],
  "embarrassment": ["ih-m b-eh1 r-ah-s m-ah-n-t", "nn"],
  "embassy": ["eh1-m b-ah s-iy", "nn"],
  "embattle": ["eh-m-b-ae1-t-ah-l", "vb"],
  "embattled": ["eh-m b-ae1 t-ah-l-d", "jj vbn"],
  "embed": ["ih-m-b-eh1-d", "vb"],
  "embedded": ["eh-m b-eh1 d-ih-d", "vbn jj"],
  "embellish": ["ih-m b-eh1 l-ih-sh", "vb"],
  "embezzle": ["ih-m b-eh1 z-ah-l", "vb"],
  "embezzlement": ["eh-m b-eh1 z-ah-l m-ah-n-t", "nn"],
  "embezzler": ["ih-m b-eh1 z-ah-l er", "nn"],
  "embitter": ["eh-m-b-ih1-t-er", "vb"],
  "embittered": ["eh-m b-ih1 t-er-d", "vbn jj"],
  "emblazon": ["eh-m-b-l-ey1-z-ah-n", "vb"],
  "emblem": ["eh1-m b-l-ah-m", "nn"],
  "emblematic": ["eh-m b-l-ah m-ae1 t-ih-k", "jj"],
  "embodied": ["ih-m b-aa1 d-iy-d", "vbn jj vbd"],
  "embodiment": ["eh-m b-aa1 d-iy m-ah-n-t", "nn"],
  "embody": ["ih-m b-aa1 d-iy", "vb vbp"],
  "embolden": ["eh-m-b-ow1-l-d-ah-n", "vb"],
  "embolism": ["eh1-m b-ow l-ih z-ah-m", "nn"],
  "emboss": ["ih-m-b-ao1-s", "vb"],
  "embrace": ["eh-m b-r-ey1-s", "vb vbp nn"],
  "embroider": ["ih-m b-r-oy1 d-er", "vbp vb"],
  "embroidery": ["eh-m b-r-oy1 d-er iy", "nn"],
  "embroil": ["eh-m-b-r-oy1-l", "vb"],
  "embryo": ["eh1-m b-r-iy ow", "nn"],
  "embryonic": ["eh-m b-r-iy aa1 n-ih-k", "jj"],
  "emcee": ["eh1-m s-iy1", "nn"],
  "emerald": ["eh1-m r-ah-l-d", "jj nn"],
  "emerge": ["ih m-er1-jh", "vb vbp"],
  "emergence": ["ih m-er1 jh-ah-n-s", "nn"],
  "emergency": ["ih m-er1 jh-ah-n s-iy", "nn jj"],
  "emergent": ["ih m-er1 jh-ah-n-t", "jj"],
  "emeritus": ["ih m-eh1 r-ah t-ah-s", "nn jj"],
  "emigrant": ["eh1 m-ah g-r-ah-n-t", "nn"],
  "emigrate": ["eh1 m-ah g-r-ey-t", "vb vbp"],
  "emigration": ["eh m-ah g-r-ey1 sh-ah-n", "nn"],
  "emigre": ["eh1 m-ah g-r-ey", "nn"],
  "eminence": ["eh1 m-ah n-ah-n-s", "nn"],
  "eminent": ["eh1 m-ah n-ah-n-t", "jj"],
  "eminently": ["eh1 m-ah n-ah-n-t l-iy", "rb"],
  "emissary": ["eh1 m-ah s-eh r-iy", "nn"],
  "emission": ["ih m-ih1 sh-ah-n", "nn"],
  "emit": ["ih m-ih1-t", "vb vbp"],
  "emotion": ["ih m-ow1 sh-ah-n", "nn"],
  "emotional": ["ih m-ow1 sh-ah n-ah-l", "jj"],
  "emotionally": ["ih m-ow1-sh n-ah l-iy", "rb"],
  "empathetic": ["eh-m p-ah th-eh1 t-ih-k", "jj"],
  "empathize": ["eh1-m p-ah th-ay-z", "vb"],
  "empathy": ["eh1-m p-ah th-iy", "nn"],
  "emperor": ["eh1-m p-er er", "nn"],
  "emphasis": ["eh1-m f-ah s-ah-s", "nn"],
  "emphasize": ["eh1-m f-ah s-ay-z", "vb vbp"],
  "emphatic": ["eh-m f-ae1 t-ih-k", "jj"],
  "emphatically": ["eh-m f-ae1 t-ih-k l-iy", "rb"],
  "emphysema": ["eh-m f-ah z-iy1 m-ah", "nn"],
  "empire": ["eh1-m p-ay er", "nn"],
  "empirical": ["eh-m p-ih1 r-ih k-ah-l", "jj"],
  "empirically": ["eh-m p-ih1 r-ih k-ah l-iy", "rb"],
  "empiricism": ["eh-m p-ih1 r-ah s-ih z-ah-m", "nn"],
  "employ": ["eh-m p-l-oy1", "vb nn vbp"],
  "employee": ["eh-m p-l-oy1 iy", "nn"],
  "employer": ["eh-m p-l-oy1 er", "nn"],
  "employment": ["eh-m p-l-oy1 m-ah-n-t", "nn"],
  "empower": ["ih-m p-aw1 er", "vb vbp"],
  "empowerment": ["ih-m p-aw1 er m-ah-n-t", "nn"],
  "emptied": ["eh1-m-p t-iy-d", "vbn jj vbd"],
  "emptier": ["eh1-m-p t-iy er", "jjr rbr"],
  "emptiness": ["eh1-m-p t-iy n-ah-s", "nn"],
  "empty": ["eh1-m-p t-iy", "jj nn rb vb vbp"],
  "emulate": ["eh1 m-y-ah l-ey-t", "vb"],
  "emulsion": ["ih m-ah1-l sh-ah-n", "nn"],
  "enable": ["eh n-ey1 b-ah-l", "vb vbp"],
  "enact": ["ih n-ae1-k-t", "vb"],
  "enactment": ["eh n-ae1-k-t m-ah-n-t", "nn"],
  "enamel": ["ih n-ae1 m-ah-l", "nn"],
  "enamored": ["eh n-ae1 m-er-d", "jj"],
  "encamp": ["ih-n-k-ae1-m-p", "vb"],
  "encase": ["eh-n-k-ey1-s", "vb"],
  "encephalitis": ["eh-n s-eh f-ah l-ay1 t-ah-s", "nn"],
  "enchant": ["eh-n-ch-ae1-n-t", "vb"],
  "enchanted": ["eh-n ch-ae1-n t-ih-d", "vbn jj"],
  "enchanting": ["eh-n ch-ae1-n t-ih-ng", "jj"],
  "enchantment": ["eh-n ch-ae1-n-t m-ah-n-t", "nn"],
  "encircle": ["eh-n s-er1 k-ah-l", "vb"],
  "encircled": ["ih-n s-er1 k-ah-l-d", "vbd jj"],
  "enclave": ["aa1-n k-l-ey-v", "nn"],
  "enclose": ["ih-n-k-l-ow1-z", "vb"],
  "enclosure": ["eh-n k-l-ow1 zh-er", "nn"],
  "encode": ["eh-n-k-ow1-d", "vb"],
  "encompass": ["eh-n k-ah1-m p-ah-s", "vb"],
  "encore": ["aa1-n k-ao-r", "nn"],
  "encounter": ["ih-n k-aw1-n t-er", "nn vb vbp"],
  "encourage": ["eh-n k-er1 ih-jh", "vb vbp"],
  "encouraged": ["eh-n k-er1 ih-jh-d", "vbn vbd jj"],
  "encouragement": ["eh-n k-er1 ih-jh m-ah-n-t", "nn"],
  "encouraging": ["eh-n k-er1 ih jh-ih-ng", "vbg jj"],
  "encroach": ["ih-n k-r-ow1-ch", "vb"],
  "encroachment": ["eh-n k-r-ow1-ch m-ah-n-t", "nn"],
  "encrust": ["eh-n-k-r-ah1-s-t", "vb"],
  "encumber": ["eh-n k-ah1-m b-er", "vb"],
  "encyclopedia": ["ih-n s-ay k-l-ah p-iy1 d-iy ah", "nn"],
  "encyclopedic": ["ih-n s-ay k-l-ah p-iy1 d-ih-k", "jj"],
  "end": ["eh1-n-d", "nn vbp jj rb vb"],
  "endanger": ["eh-n d-ey1-n jh-er", "vb vbp"],
  "endangered": ["eh-n d-ey1-n jh-er-d", "vbn vbd jj"],
  "endangerment": ["eh-n d-ey1-n jh-er m-ah-n-t", "nn"],
  "endear": ["eh-n-d-iy1-r", "vb"],
  "endearing": ["eh-n d-iy1 r-ih-ng", "jj"],
  "endearment": ["ih-n d-ih1-r m-ah-n-t", "nn"],
  "endeavor": ["ih-n d-eh1 v-er", "nn"],
  "endeavored": ["ih-n d-eh1 v-er-d", "vbd vbn"],
  "ended": ["eh1-n d-ah-d", "vbd jj vbn"],
  "endemic": ["eh-n d-eh1 m-ih-k", "jj"],
  "ending": ["eh1-n d-ih-ng", "vbg jj nn vbn"],
  "endless": ["eh1-n-d l-ah-s", "jj"],
  "endlessly": ["eh1-n-d l-ah-s l-iy", "rb"],
  "endocrine": ["eh1-n d-ow k-r-ay-n", "jj"],
  "endocrinologist": ["eh-n d-ow k-r-ah n-aa1 l-ah jh-ah-s-t", "nn"],
  "endorse": ["eh-n d-ao1-r-s", "vb vbp"],
  "endorsement": ["eh-n d-ao1-r-s m-ah-n-t", "nn"],
  "endorser": ["ih-n d-ao1-r s-er", "nn"],
  "endosperm": ["eh1-n d-ah s-p-er-m", "nn"],
  "endothermic": ["eh-n d-ow th-er1 m-ih-k", "jj"],
  "endow": ["eh-n d-aw1", "vb vbp"],
  "endowed": ["eh-n d-aw1-d", "vbn vbd jj"],
  "endowment": ["eh-n d-aw1 m-ah-n-t", "nn"],
  "endurance": ["eh1-n d-er ah-n-s", "nn"],
  "endure": ["eh-n d-y-uh1-r", "vb vbp"],
  "enduring": ["eh-n d-y-uh1 r-ih-ng", "vbg jj"],
  "enemy": ["eh1 n-ah m-iy", "nn"],
  "energetic": ["eh n-er jh-eh1 t-ih-k", "jj"],
  "energetically": ["eh n-er jh-eh1 t-ih-k l-iy", "rb"],
  "energize": ["eh1 n-er jh-ay-z", "vb"],
  "energy": ["eh1 n-er jh-iy", "nn"],
  "enforce": ["eh-n f-ao1-r-s", "vb vbp"],
  "enforceable": ["eh-n f-ao1-r s-ah b-ah-l", "jj"],
  "enforced": ["eh-n f-ao1-r-s-t", "vbn vbd jj"],
  "enforcement": ["eh-n f-ao1-r-s m-ah-n-t", "nn"],
  "enforcer": ["eh-n f-ao1-r s-er", "nn"],
  "engage": ["eh-n g-ey1-jh", "vb vbp"],
  "engaged": ["eh-n g-ey1-jh-d", "vbn jj vbd"],
  "engagement": ["eh-n g-ey1-jh m-ah-n-t", "nn"],
  "engaging": ["eh-n g-ey1 jh-ih-ng", "vbg jj"],
  "engender": ["eh-n jh-eh1-n d-er", "vb"],
  "engine": ["eh1-n jh-ah-n", "nn"],
  "engineer": ["eh1-n jh-ah n-ih1-r", "nn vb"],
  "engineered": ["eh-n jh-ah n-iy1-r-d", "vbn vbd jj"],
  "engrave": ["ih-n g-r-ey1-v", "vb"],
  "engraved": ["ih-n g-r-ey1-v-d", "vbn jj"],
  "engraver": ["ih-n g-r-ey1 v-er", "nn"],
  "engraving": ["ih-n g-r-ey1 v-ih-ng", "nn"],
  "engross": ["ih-n-g-r-ow1-s", "vb"],
  "engrossed": ["ih-n g-r-ow1-s-t", "jj vbn"],
  "engrossing": ["ih-n g-r-ow1 s-ih-ng", "jj"],
  "engulf": ["ih-n g-ah1-l-f", "vb"],
  "engulfing": ["ih-n g-ah1-l f-ih-ng", "vbg jj"],
  "enhance": ["eh-n hh-ae1-n-s", "vb vbp"],
  "enhanced": ["eh-n hh-ae1-n-s-t", "vbn vbd jj"],
  "enhancement": ["eh-n hh-ae1-n-s m-ah-n-t", "nn"],
  "enigma": ["ih n-ih1-g m-ah", "nn"],
  "enigmatic": ["eh n-ih-g m-ae1 t-ih-k", "jj"],
  "enjoin": ["eh-n jh-oy1-n", "vb"],
  "enjoy": ["eh-n jh-oy1", "vb vbp"],
  "enjoyable": ["eh-n jh-oy1 ah b-ah-l", "jj"],
  "enjoyment": ["eh-n jh-oy1 m-ah-n-t", "nn"],
  "enlarge": ["eh-n l-aa1-r-jh", "vb"],
  "enlarged": ["eh-n l-aa1-r-jh-d", "vbn jj vbd"],
  "enlargement": ["ih-n l-aa1-r-jh m-ah-n-t", "nn"],
  "enlighten": ["eh-n l-ay1 t-ah-n", "vb"],
  "enlightened": ["eh-n l-ay1 t-ah-n-d", "jj vbn"],
  "enlightening": ["eh-n l-ay1 t-ah-n ih-ng", "vbg jj"],
  "enlightenment": ["eh-n l-ay1 t-ah-n m-ah-n-t", "nn"],
  "enlist": ["eh-n l-ih1-s-t", "vb"],
  "enlisted": ["eh-n l-ih1 s-t-ih-d", "vbd jj vbn"],
  "enlistment": ["eh-n l-ih1-s-t m-ah-n-t", "nn"],
  "enliven": ["eh-n l-ay1 v-ah-n", "vb vbp"],
  "enmesh": ["eh-n-m-eh1-sh", "vb"],
  "enmity": ["eh1-n m-ah t-iy", "nn"],
  "ennui": ["eh n-uw1 iy", "nn"],
  "enormity": ["ih n-ao1-r m-ah t-iy", "nn"],
  "enormous": ["ih n-ao1-r m-ah-s", "jj"],
  "enormously": ["ih n-ao1-r m-ah-s l-iy", "rb"],
  "enough": ["ih-n ah1-f", "rb jj nn"],
  "enrage": ["eh-n r-ey1-jh", "nn vb"],
  "enraged": ["eh-n r-ey1-jh-d", "jj vbd vbn"],
  "enrapture": ["eh-n-r-ae1-p-ch-er", "vb"],
  "enrich": ["eh-n r-ih1-ch", "vb vbp"],
  "enrichment": ["eh-n r-ih1-ch m-ah-n-t", "nn"],
  "enroll": ["eh-n r-ow1-l", "vb vbp"],
  "enrolled": ["eh-n r-ow1-l-d", "vbn vbd jj"],
  "enrollee": ["eh-n r-ow1 l-iy1", "nn"],
  "enrolling": ["eh-n r-ow1 l-ih-ng", "nn"],
  "enrollment": ["eh-n r-ow1-l m-ah-n-t", "nn"],
  "enroute": ["eh-n r-uw1-t", "rb"],
  "ensconce": ["ih-n-s-k-aa1-n-s", "vb"],
  "ensemble": ["aa-n s-aa1-m b-ah-l", "nn"],
  "enshrine": ["eh-n-sh-r-ay1-n", "vb"],
  "enslave": ["eh-n-s-l-ey1-v", "vb"],
  "enslavement": ["eh-n s-l-ey1-v m-ah-n-t", "nn"],
  "ensnare": ["ih-n s-n-eh1-r", "vb"],
  "ensnarl": ["ih-n-s-n-aa1-r-l", "vb"],
  "ensue": ["ih-n s-uw1", "vb vbp"],
  "ensure": ["eh-n sh-uh1-r", "vb vbp"],
  "entail": ["eh-n t-ey1-l", "vb vbp"],
  "entangle": ["eh-n-t-ae1-ng-g-ah-l", "vb"],
  "entangled": ["eh-n t-ae1-ng g-ah-l-d", "jj vbd vbn"],
  "entanglement": ["eh-n t-ae1-ng g-ah-l m-ah-n-t", "nn"],
  "enter": ["eh1-n t-er", "vb vbp"],
  "enterprise": ["eh1-n t-er p-r-ay-z", "nn"],
  "enterprising": ["eh1-n t-er p-r-ay z-ih-ng", "jj"],
  "entertain": ["eh-n t-er t-ey1-n", "vb"],
  "entertainer": ["eh-n t-er t-ey1 n-er", "nn"],
  "entertaining": ["eh-n t-er t-ey1 n-ih-ng", "vbg jj nn"],
  "entertainment": ["eh-n t-er t-ey1-n m-ah-n-t", "nn"],
  "enthral": ["eh-n th-r-ao1-l", "vb"],
  "enthralled": ["eh-n th-r-ao1-l-d", "jj vbn"],
  "enthusiasm": ["ih-n th-uw1 z-iy ae z-ah-m", "nn"],
  "enthusiast": ["eh-n th-uw1 z-iy ae-s-t", "nn"],
  "enthusiastic": ["ih-n th-uw z-iy ae1 s-t-ih-k", "jj"],
  "enthusiastically": ["ih-n th-uw z-iy ae1 s-t-ih-k l-iy", "rb"],
  "entice": ["ih-n t-ay1-s", "vb vbp"],
  "enticement": ["ih-n t-ay1-s m-ah-n-t", "nn"],
  "enticing": ["eh-n t-ay1 s-ih-ng", "vbg jj"],
  "entire": ["ih-n t-ay1 er", "jj nn"],
  "entirely": ["ih-n t-ay1 er l-iy", "rb"],
  "entirety": ["ih-n t-ay1 er t-iy", "nn"],
  "entitle": ["eh-n t-ay1 t-ah-l", "vb vbp"],
  "entitlement": ["eh-n t-ay1 t-ah-l m-ah-n-t", "nn jj"],
  "entity": ["eh1-n t-ah t-iy", "nn"],
  "entomb": ["eh-n-t-uw1-m", "vb"],
  "entomologist": ["eh-n t-ah m-aa1 l-ah jh-ah-s-t", "nn"],
  "entourage": ["aa-n t-uh r-aa1-zh", "nn"],
  "entrance": ["eh1-n t-r-ah-n-s", "nn vb"],
  "entrant": ["eh1-n t-r-ah-n-t", "nn"],
  "entrapment": ["ih-n t-r-ae1-p m-ah-n-t", "nn"],
  "entre": ["aa1-n t-r-ey", "nn"],
  "entreaty": ["eh-n t-r-iy1 t-iy", "nn"],
  "entrench": ["eh-n t-r-eh1-n-ch", "vb"],
  "entrenched": ["eh-n t-r-eh1-n-ch-t", "vbn vbd jj"],
  "entrenchment": ["eh-n t-r-eh1-n-ch m-ah-n-t", "nn"],
  "entrepreneur": ["aa-n t-r-ah p-r-ah n-er1", "nn"],
  "entrepreneurial": ["aa-n t-r-ah p-r-ah n-er1 iy ah-l", "jj"],
  "entrepreneurship": ["aa-n t-r-ah p-r-ah n-er1 sh-ih-p", "nn"],
  "entropy": ["eh1-n t-r-ah p-iy", "nn"],
  "entrust": ["eh-n t-r-ah1-s-t", "vb vbp"],
  "entry": ["eh1-n t-r-iy", "nn"],
  "entwine": ["eh-n-t-w-ay1-n", "vb"],
  "entwined": ["eh-n t-w-ay1-n-d", "vbn jj"],
  "enumerate": ["ih-n-uw1-m-er-ey-t", "vb"],
  "enumerated": ["ih n-uw1 m-er ey t-ih-d", "vbn jj"],
  "enumeration": ["ih n-uw m-er ey1 sh-ah-n", "nn"],
  "enunciate": ["ih-n-ah1-n-s-iy-ey-t", "vb"],
  "envelop": ["eh-n v-eh1 l-ah-p", "vb"],
  "envelope": ["eh1-n v-ah l-ow-p", "nn"],
  "enviable": ["eh1-n v-iy ah b-ah-l", "jj"],
  "envied": ["eh1-n v-iy-d", "vbd"],
  "envious": ["eh1-n v-iy ah-s", "jj"],
  "enviously": ["eh1-n v-iy ah-s l-iy", "rb"],
  "environ": ["ih-n v-ay1 r-ah-n", "nn"],
  "environment": ["ih-n v-ay1 r-ah-n m-ah-n-t", "nn"],
  "environmental": ["ih-n v-ay r-ah-n m-eh1-n t-ah-l", "jj"],
  "environmentalism": ["eh-n v-ay1 r-ah-n m-eh-n t-ah l-ih z-ah-m", "nn"],
  "environmentalist": ["ih-n v-ay r-ah-n m-eh1-n t-ah l-ih-s-t", "nn jj"],
  "environmentally": ["ih-n v-ay r-ah-n m-eh1-n t-ah l-iy", "rb"],
  "envisage": ["eh-n v-ih1 z-ih-jh", "vb"],
  "envision": ["eh-n v-ih1 zh-ah-n", "vbp vb"],
  "envoy": ["eh1-n v-oy", "nn"],
  "envy": ["eh1-n v-iy", "nn vbp vb"],
  "enzymatic": ["eh-n z-ay m-ae1 t-ih-k", "jj"],
  "enzyme": ["eh1-n z-ay-m", "nn"],
  "eon": ["iy1 ah-n", "nn"],
  "ephemeral": ["ih f-eh1 m-er ah-l", "jj"],
  "epic": ["eh1 p-ih-k", "nn jj"],
  "epicenter": ["eh1 p-ah s-eh-n t-er", "nn"],
  "epicure": ["eh1 p-ih k-y-uh-r", "nn"],
  "epicurean": ["eh p-ah k-y-uh r-iy1 ah-n", "nn"],
  "epidemic": ["eh p-ah d-eh1 m-ih-k", "nn jj"],
  "epidemiological": ["eh p-ah d-iy m-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "epidemiologist": ["eh p-ah d-iy m-iy aa1 l-ah jh-ih-s-t", "nn"],
  "epidermis": ["eh p-ah d-er1 m-ah-s", "nn"],
  "epigenetic": ["eh p-ah jh-ah n-eh1 t-ih-k", "jj"],
  "epilepsy": ["eh1 p-ah l-eh-p s-iy", "nn"],
  "epileptic": ["eh p-ah l-eh1-p t-ih-k", "jj"],
  "epilogue": ["eh1 p-ah l-ao-g", "nn"],
  "epiphany": ["ih p-ih1 f-ah n-iy", "nn"],
  "episode": ["eh1 p-ah s-ow-d", "nn"],
  "episodic": ["eh p-ah s-aa1 d-ih-k", "jj"],
  "epistemology": ["ih p-ih s-t-ah m-aa1 l-ah jh-iy", "nn"],
  "epitaph": ["eh1 p-ah t-ae-f", "nn"],
  "epithet": ["eh1 p-ah th-eh-t", "nn"],
  "epitome": ["ih p-ih1 t-ah m-iy", "nn"],
  "epitomize": ["ih p-ih1 t-ah m-ay-z", "vb vbp"],
  "epoch": ["eh1 p-ah-k", "nn"],
  "epochal": ["eh1 p-ah k-ah-l", "jj"],
  "epoxy": ["ih p-aa1-k s-iy", "jj"],
  "epsom": ["eh1-p s-ah-m", "nn"],
  "equal": ["iy1 k-w-ah-l", "jj nn vb vbp"],
  "equality": ["ih k-w-aa1 l-ah t-iy", "nn"],
  "equalization": ["iy k-w-ah l-ih z-ey1 sh-ah-n", "nn"],
  "equalize": ["iy1 k-w-ah l-ay-z", "vb"],
  "equalizer": ["iy1 k-w-ah l-ay z-er", "nn"],
  "equalizing": ["iy1 k-w-ah l-ay z-ih-ng", "nn"],
  "equally": ["iy1 k-w-ah l-iy", "rb"],
  "equanimity": ["iy k-w-ah n-ih1 m-ih t-iy", "nn"],
  "equate": ["ih k-w-ey1-t", "vb vbp"],
  "equation": ["ih k-w-ey1 zh-ah-n", "nn"],
  "equator": ["ih k-w-ey1 t-er", "nn"],
  "equatorial": ["iy k-w-ah t-ao1 r-iy ah-l", "jj"],
  "equestrian": ["ih k-w-eh1-s t-r-iy ah-n", "jj"],
  "equilibrium": ["iy k-w-ah l-ih1 b-r-iy ah-m", "nn"],
  "equine": ["iy1 k-w-ay-n", "nn"],
  "equip": ["ih k-w-ih1-p", "vb vbp"],
  "equipment": ["ih k-w-ih1-p m-ah-n-t", "nn"],
  "equitable": ["eh1 k-w-ah t-ah b-ah-l", "jj"],
  "equitably": ["eh1 k-w-ih t-ah b-l-iy", "rb"],
  "equity": ["eh1 k-w-ah t-iy", "nn"],
  "equivalence": ["ih k-w-ih1 v-ah l-ah-n-s", "nn"],
  "equivalent": ["ih k-w-ih1 v-ah l-ah-n-t", "nn jj"],
  "equivocal": ["ih k-w-ih1 v-ah k-ah-l", "jj"],
  "era": ["eh1 r-ah", "nn"],
  "eradicate": ["ih r-ae1 d-ah k-ey-t", "vb"],
  "eradication": ["ih r-ae d-ah k-ey1 sh-ah-n", "nn"],
  "erasable": ["ih r-ey1 s-ah b-ah-l", "jj"],
  "erase": ["ih r-ey1-s", "vb"],
  "eraser": ["ih r-ey1 s-er", "nn"],
  "erect": ["ih r-eh1-k-t", "vb vbp jj"],
  "erection": ["ih r-eh1-k sh-ah-n", "nn"],
  "erode": ["ih r-ow1-d", "vb vbp"],
  "eroded": ["ih r-ow1 d-ah-d", "vbn jj vbd"],
  "erosion": ["ih r-ow1 zh-ah-n", "nn"],
  "erotic": ["ih r-aa1 t-ih-k", "jj"],
  "errand": ["eh1 r-ah-n-d", "nn"],
  "errant": ["eh1 r-ah-n-t", "jj"],
  "erratic": ["ih r-ae1 t-ih-k", "jj"],
  "erratically": ["eh r-ae1 t-ih-k l-iy", "rb"],
  "erroneous": ["eh r-ow1 n-iy ah-s", "jj"],
  "erroneously": ["eh r-ow1 n-iy ah-s l-iy", "rb"],
  "error": ["eh1 r-er", "nn"],
  "ersatz": ["eh1-r s-aa-t-s", "jj"],
  "erstwhile": ["er1-s-t w-ay-l", "jj"],
  "erudite": ["eh1 r-ah d-ay-t", "jj"],
  "erudition": ["eh r-ah d-ih1 sh-ah-n", "nn"],
  "erupt": ["ih r-ah1-p-t", "vb vbp"],
  "eruption": ["ih r-ah1-p sh-ah-n", "nn"],
  "escalate": ["eh1 s-k-ah l-ey-t", "vb vbp"],
  "escalation": ["eh s-k-ah l-ey1 sh-ah-n", "nn"],
  "escalator": ["eh1 s-k-ah l-ey t-er", "nn"],
  "escapade": ["eh1 s-k-ah p-ey-d", "nn"],
  "escape": ["ih s-k-ey1-p", "vb nn vbp"],
  "escapee": ["ih s-k-ey p-iy1", "nn"],
  "eschew": ["eh-s ch-uw1", "vb"],
  "escort": ["eh s-k-ao1-r-t", "nn vb"],
  "escrow": ["eh s-k-r-ow1", "nn jj vb"],
  "escudo": ["eh s-k-uw1 d-ow", "nn"],
  "esophagus": ["ih s-aa1 f-ah g-ah-s", "nn"],
  "esoteric": ["eh s-ah t-eh1 r-ih-k", "jj"],
  "especially": ["ah s-p-eh1-sh l-iy", "rb"],
  "espionage": ["eh1 s-p-iy ah n-aa-jh", "nn"],
  "esplanade": ["eh-s p-l-ah n-aa1-d", "nn"],
  "espouse": ["ih s-p-aw1-z", "vb vbp"],
  "espresso": ["eh s-p-r-eh1 s-ow", "nn"],
  "essay": ["eh s-ey1", "nn"],
  "essayist": ["eh1 s-ey ih-s-t", "nn"],
  "essence": ["eh1 s-ah-n-s", "nn"],
  "essential": ["ih s-eh1-n sh-ah-l", "jj nn"],
  "essentially": ["ih s-eh1-n sh-ah l-iy", "rb"],
  "establish": ["ih s-t-ae1 b-l-ih-sh", "vb vbp"],
  "established": ["ih s-t-ae1 b-l-ih-sh-t", "vbn jj vbd"],
  "establishment": ["ih s-t-ae1 b-l-ih-sh m-ah-n-t", "nn"],
  "estate": ["ih s-t-ey1-t", "nn"],
  "esteem": ["ah s-t-iy1-m", "nn vb"],
  "estimable": ["eh1 s-t-ah m-ah b-ah-l", "jj"],
  "estimate": ["eh1 s-t-ah m-ah-t", "nn vb vbp"],
  "estimated": ["eh1 s-t-ah m-ey t-ah-d", "vbn jj vbd"],
  "estimation": ["eh s-t-ah m-ey1 sh-ah-n", "nn"],
  "estimator": ["eh s-t-ih1 m-ah t-er", "nn"],
  "estrange": ["eh-s-t-r-ey1-n-jh", "vb"],
  "estranged": ["eh s-t-r-ey1-n-jh-d", "vbn vbd jj"],
  "estrangement": ["ih s-t-r-ey1-n-jh m-ah-n-t", "nn"],
  "estrogen": ["eh1 s-t-r-ah jh-ah-n", "nn"],
  "estuary": ["eh1-s ch-uw eh r-iy", "nn"],
  "etcetera": ["eh1-t s-eh1 t-er ah", "nn"],
  "etch": ["eh1-ch", "vb"],
  "etching": ["eh1 ch-ih-ng", "nn"],
  "eternal": ["ih t-er1 n-ah-l", "jj"],
  "eternally": ["ih t-er1 n-ah l-iy", "rb"],
  "eternity": ["ih t-er1 n-ah t-iy", "nn"],
  "ethane": ["eh1 th-ey-n", "nn"],
  "ethanol": ["eh1 th-ah n-ao-l", "nn"],
  "ether": ["iy1 th-er", "nn cc"],
  "ethereal": ["ih th-ih1 r-iy ah-l", "jj"],
  "ethic": ["eh1 th-ih-k", "nn"],
  "ethical": ["eh1 th-ah k-ah-l", "jj"],
  "ethically": ["eh1 th-ih k-ah l-iy", "rb"],
  "ethicist": ["eh1 th-ih s-ih-s-t", "nn"],
  "ethics": ["eh1 th-ih-k-s", "nn"],
  "ethnic": ["eh1-th n-ih-k", "jj"],
  "ethnically": ["eh1-th n-ih-k l-iy", "rb"],
  "ethnicity": ["eh-th n-ih1 s-ih t-iy", "nn"],
  "ethos": ["iy1 th-aa-s", "nn"],
  "ethyl": ["eh1 th-ah-l", "nn"],
  "ethylene": ["eh1 th-ah l-iy-n", "nn"],
  "etiquette": ["eh1 t-ah k-ah-t", "nn"],
  "etymology": ["eh t-ah m-aa1 l-ah jh-iy", "nn"],
  "eucalyptus": ["y-uw k-ah l-ih1-p t-ah-s", "nn"],
  "eulogy": ["y-uw1 l-ah jh-iy", "nn"],
  "euphemism": ["y-uw1 f-ah m-ih z-ah-m", "nn"],
  "euphoria": ["y-uw f-ao1 r-iy ah", "nn"],
  "euphoric": ["y-uw f-aa1 r-ih-k", "jj"],
  "evacuate": ["ih v-ae1 k-y-ah ey-t", "vb"],
  "evacuation": ["ih v-ae k-y-ah-w ey1 sh-ah-n", "nn"],
  "evade": ["ih v-ey1-d", "vb"],
  "evader": ["ih v-ey1 d-er", "nn"],
  "evaluate": ["ih v-ae1-l y-uw ey-t", "vb vbp"],
  "evaluation": ["ih v-ae-l y-uw ey1 sh-ah-n", "nn"],
  "evangelical": ["iy v-ae-n jh-eh1 l-ih k-ah-l", "jj"],
  "evangelism": ["ih v-ae1-n jh-ah l-ih z-ah-m", "nn"],
  "evangelist": ["ih v-ae1-n jh-ah l-ah-s-t", "nn"],
  "evaporate": ["ih v-ae1 p-er ey-t", "vb vbp"],
  "evaporation": ["ih v-ae p-er ey1 sh-ah-n", "nn"],
  "evasion": ["ih v-ey1 zh-ah-n", "nn"],
  "evasive": ["ih v-ey1 s-ih-v", "jj"],
  "eve": ["iy1-v", "nn"],
  "even": ["iy1 v-ih-n", "rb vb"],
  "evenhanded": ["iy1 v-ah-n hh-ae1-n d-ih-d", "jj"],
  "evening": ["iy1-v n-ih-ng", "nn vbg"],
  "evenly": ["iy1 v-ah-n l-iy", "rb"],
  "event": ["ih v-eh1-n-t", "nn"],
  "eventful": ["ih v-eh1-n-t f-ah-l", "jj"],
  "eventual": ["ah v-eh1-n ch-uw ah-l", "jj"],
  "eventuality": ["ah v-eh-n ch-uw ae1 l-ih t-iy", "nn"],
  "eventually": ["ih v-eh1-n ch-ah-w ah l-iy", "rb"],
  "ever": ["eh1 v-er", "rb rbr rp"],
  "evergreen": ["eh1 v-er g-r-iy-n", "nn"],
  "everlasting": ["eh v-er l-ae1 s-t-ih-ng", "jj nn"],
  "every": ["eh1 v-er iy", "dt"],
  "everybody": ["eh1 v-r-iy b-aa d-iy", "nn"],
  "everyday": ["eh1 v-r-iy d-ey1", "jj"],
  "everyone": ["eh1 v-r-iy w-ah-n", "nn"],
  "everything": ["eh1 v-r-iy th-ih-ng", "nn"],
  "everywhere": ["eh1 v-r-iy w-eh-r", "rb"],
  "evict": ["ih v-ih1-k-t", "vb"],
  "evidence": ["eh1 v-ah d-ah-n-s", "nn vb"],
  "evident": ["eh1 v-ah d-ah-n-t", "jj"],
  "evidently": ["eh1 v-ah d-ah-n-t l-iy", "rb"],
  "evil": ["iy1 v-ah-l", "jj nn"],
  "evildoer": ["iy1 v-ah-l d-uw er", "nn"],
  "evince": ["ih-v-ih1-n-s", "vb"],
  "eviscerate": ["ah v-ih1 s-er ey-t", "vb"],
  "evocation": ["iy v-ow k-ey1 sh-ah-n", "nn"],
  "evocative": ["ih v-aa1 k-ah t-ih-v", "jj"],
  "evoke": ["ih v-ow1-k", "vb vbp"],
  "evolution": ["eh v-ah l-uw1 sh-ah-n", "nn"],
  "evolutionary": ["eh v-ah l-uw1 sh-ah-n eh r-iy", "jj"],
  "evolve": ["ih v-aa1-l-v", "vb vbp"],
  "evolved": ["ih v-aa1-l-v-d", "vbn jj vbd"],
  "exacerbate": ["ih-g z-ae1 s-er b-ey-t", "vb vbp"],
  "exacerbation": ["ih-g z-ae s-er b-ey1 sh-ah-n", "nn"],
  "exact": ["ih-g z-ae1-k-t", "jj vb"],
  "exacting": ["ih-g z-ae1-k t-ih-ng", "jj"],
  "exactly": ["ih-g z-ae1-k-t l-iy", "rb"],
  "exaggerate": ["ih-g z-ae1 jh-er ey-t", "vb vbp"],
  "exaggerated": ["ih-g z-ae1 jh-er ey t-ah-d", "vbn jj vbd"],
  "exaggeration": ["ih-g z-ae jh-er ey1 sh-ah-n", "nn"],
  "exalt": ["ih-g z-ao1-l-t", "vbp vb"],
  "exalted": ["ih-g z-ao1-l t-ih-d", "jj vbd"],
  "exam": ["ih-g z-ae1-m", "nn"],
  "examination": ["ih-g z-ae m-ah n-ey1 sh-ah-n", "nn"],
  "examine": ["ih-g z-ae1 m-ih-n", "vb vbp"],
  "examiner": ["ih-g z-ae1 m-ah n-er", "nn"],
  "example": ["ih-g z-ae1-m p-ah-l", "nn"],
  "exasperate": ["ih-g-z-ae1-s-p-er-ey-t", "vb"],
  "exasperated": ["ih-g z-ae1 s-p-er ey t-ih-d", "jj"],
  "exasperating": ["ih-g z-ae1 s-p-er ey t-ih-ng", "vbg jj"],
  "exasperation": ["eh-k s-ae s-p-er ey1 sh-ah-n", "nn"],
  "excavate": ["eh1-k s-k-ah v-ey-t", "vb"],
  "excavation": ["eh-k s-k-ah v-ey1 sh-ah-n", "nn"],
  "excavator": ["eh1-k s-k-ah v-ey t-er", "nn"],
  "exceed": ["ih-k s-iy1-d", "vb vbp"],
  "exceeding": ["ih-k s-iy1 d-ih-ng", "vbg jj"],
  "exceedingly": ["ih-k s-iy1 d-ih-ng l-iy", "rb"],
  "excel": ["ih-k s-eh1-l", "vbp vb"],
  "excellence": ["eh1-k s-ah l-ah-n-s", "nn"],
  "excellent": ["eh1-k s-ah l-ah-n-t", "jj"],
  "excellently": ["eh1-k s-ah l-ah-n-t l-iy", "rb"],
  "excelsior": ["ih-k s-eh1-l s-iy er", "nn"],
  "except": ["ih-k s-eh1-p-t", "in vb"],
  "exception": ["ih-k s-eh1-p sh-ah-n", "nn"],
  "exceptional": ["ih-k s-eh1-p sh-ah n-ah-l", "jj"],
  "exceptionally": ["ih-k s-eh1-p sh-ah-n ah l-iy", "rb"],
  "excerpt": ["eh1-k s-er-p-t", "nn"],
  "excess": ["eh1-k s-eh-s", "jj nn"],
  "excessive": ["ih-k s-eh1 s-ih-v", "jj"],
  "excessively": ["ih-k s-eh1 s-ih-v l-iy", "rb"],
  "exchange": ["ih-k-s ch-ey1-n-jh", "nn vb vbp"],
  "exchangeable": ["ih-k-s ch-ey1-n jh-ah b-ah-l", "jj"],
  "exchanger": ["ih-k-s ch-ey1-n jh-er", "nn"],
  "exchequer": ["eh1-k-s ch-eh k-er", "nn"],
  "excise": ["eh-k s-ay1-s", "nn jj vb"],
  "excision": ["ih-k s-ih1 zh-ah-n", "nn"],
  "excite": ["ih-k s-ay1-t", "vb"],
  "excited": ["ih-k s-ay1 t-ah-d", "vbn jj vbd"],
  "excitedly": ["ih-k s-ay1 t-ah-d l-iy", "rb"],
  "excitement": ["ih-k s-ay1-t m-ah-n-t", "nn"],
  "exciting": ["ih-k s-ay1 t-ih-ng", "jj vbg"],
  "exclaim": ["ih-k s-k-l-ey1-m", "vb"],
  "exclamation": ["eh-k s-k-l-ah m-ey1 sh-ah-n", "nn"],
  "exclude": ["ih-k s-k-l-uw1-d", "vb vbp"],
  "exclusion": ["ih-k s-k-l-uw1 zh-ah-n", "nn"],
  "exclusionary": ["ih-k s-k-l-uw1 zh-ah-n eh r-iy", "jj"],
  "exclusive": ["ih-k s-k-l-uw1 s-ih-v", "jj nn"],
  "exclusively": ["ih-k s-k-l-uw1 s-ih-v l-iy", "rb"],
  "exclusivity": ["eh-k s-k-l-uw s-ih1 v-ah t-iy", "nn"],
  "excommunicate": ["eh-k-s-k-ah-m-y-uw1-n-ah-k-ey-t", "vb"],
  "excoriate": ["eh-k-s-k-ao1-r-iy-ey-t", "vb"],
  "excrement": ["eh1-k s-k-r-ah m-ah-n-t", "nn"],
  "excrete": ["ih-k s-k-r-iy1-t", "vb"],
  "excretion": ["ih-k s-k-r-iy1 sh-ah-n", "nn"],
  "excretory": ["eh1-k s-k-r-ah t-ao r-iy", "jj"],
  "excruciating": ["ih-k s-k-r-uw1 sh-iy ey t-ih-ng", "jj"],
  "excursion": ["ih-k s-k-er1 zh-ah-n", "nn"],
  "excuse": ["ih-k s-k-y-uw1-s", "nn vbp vb"],
  "exec": ["eh-g z-eh1-k", "nn"],
  "execute": ["eh1-k s-ah k-y-uw-t", "vb vbp"],
  "executed": ["eh1-k s-ah k-y-uw t-ah-d", "vbn jj vbd"],
  "execution": ["eh-k s-ah k-y-uw1 sh-ah-n", "nn"],
  "executioner": ["eh-k s-ah k-y-uw1 sh-ah-n er", "nn"],
  "executive": ["ih-g z-eh1 k-y-ah t-ih-v", "nn jj"],
  "executor": ["ih-g z-eh1 k-y-ah t-er", "nn"],
  "exemplary": ["ih-g z-eh1-m p-l-er iy", "jj"],
  "exemplify": ["ih-g z-eh1-m p-l-ah f-ay", "vbp vb"],
  "exempt": ["ih-g z-eh1-m-p-t", "jj vb"],
  "exemption": ["ih-g z-eh1-m-p sh-ah-n", "nn"],
  "exercisable": ["eh1-k s-er s-ay z-ah b-ah-l", "jj"],
  "exercise": ["eh1-k s-er s-ay-z", "nn vbp vb"],
  "exercised": ["eh1-k s-er s-ay-z-d", "vbn vbd jj"],
  "exert": ["ih-g z-er1-t", "vb vbp"],
  "exertion": ["ih-g z-er1 sh-ah-n", "nn"],
  "exhale": ["eh-k-s-hh-ey1-l", "vb"],
  "exhaust": ["ih-g z-ao1-s-t", "nn vb vbp"],
  "exhausting": ["ih-g z-ao1 s-t-ih-ng", "vbg jj"],
  "exhaustion": ["ih-g z-ao1-s ch-ah-n", "nn"],
  "exhaustive": ["ih-g z-ao1 s-t-ih-v", "jj"],
  "exhaustively": ["ih-g z-aa1 s-t-ih-v l-iy", "rb"],
  "exhibit": ["ih-g z-ih1 b-ih-t", "nn vbp vb"],
  "exhibition": ["eh-k s-ah b-ih1 sh-ah-n", "nn"],
  "exhibitor": ["ih-g z-ih1 b-ah t-er", "nn"],
  "exhilarate": ["ih-g-z-ih1-l-er-ey-t", "vb"],
  "exhilarating": ["ih-g z-ih1 l-er ey t-ih-ng", "jj"],
  "exhilaration": ["ih-g z-ih l-er ey1 sh-ah-n", "nn"],
  "exhort": ["ih-g z-ao1-r-t", "vb"],
  "exhortation": ["eh-g z-ao-r t-ey1 sh-ah-n", "nn"],
  "exigency": ["eh-k s-ih1 jh-ah-n s-iy", "nn"],
  "exile": ["eh1-g z-ay-l", "nn vb"],
  "exiled": ["eh1-g z-ay-l-d", "vbn vbd jj"],
  "exist": ["ih-g z-ih1-s-t", "vb vbp"],
  "existence": ["eh-g z-ih1 s-t-ah-n-s", "nn"],
  "existent": ["eh-g z-ih1 s-t-ah-n-t", "jj nn"],
  "existential": ["eh-k s-ih s-t-eh1-n ch-ah-l", "jj"],
  "existing": ["ih-g z-ih1 s-t-ih-ng", "vbg jj"],
  "exit": ["eh1-g z-ih-t", "nn vb"],
  "exodus": ["eh1-k s-ah d-ah-s", "nn"],
  "exonerate": ["ih-g z-aa1 n-er ey-t", "vb"],
  "exorbitant": ["ih-g z-ao1-r b-ih t-ah-n-t", "jj"],
  "exorcism": ["eh1-k s-er s-ih1-z ah-m", "nn"],
  "exorcist": ["eh1-k s-er s-ah-s-t", "nn"],
  "exothermic": ["eh-k s-ow th-er1 m-ih-k", "jj"],
  "exotic": ["ih-g z-aa1 t-ih-k", "jj"],
  "expand": ["ih-k s-p-ae1-n-d", "vb vbp"],
  "expandable": ["ih-k s-p-ae1-n d-ah b-ah-l", "jj"],
  "expanded": ["ih-k s-p-ae1-n d-ah-d", "vbn vbd jj"],
  "expanding": ["ih-k s-p-ae1-n d-ih-ng", "vbg jj"],
  "expanse": ["ih-k s-p-ae1-n-s", "nn jj"],
  "expansion": ["ih-k s-p-ae1-n sh-ah-n", "nn jj"],
  "expansionism": ["ih-k s-p-ae1-n sh-ah n-ih z-ah-m", "nn"],
  "expansive": ["ih-k s-p-ae1-n s-ih-v", "jj"],
  "expatriate": ["eh-k-s p-ey1 t-r-iy ey-t", "nn"],
  "expect": ["ih-k s-p-eh1-k-t", "vbp vb in"],
  "expectancy": ["ih-k s-p-eh1-k t-ah-n s-iy", "nn"],
  "expectant": ["ih-k s-p-eh1-k t-ah-n-t", "jj"],
  "expectation": ["eh-k s-p-eh-k t-ey1 sh-ah-n", "nn"],
  "expected": ["ih-k s-p-eh1-k t-ah-d", "vbn vbd jj"],
  "expediency": ["ih-k s-p-iy1 d-iy ah-n s-iy", "nn"],
  "expedient": ["ih-k s-p-iy1 d-iy ah-n-t", "jj nn"],
  "expedite": ["eh1-k s-p-ih d-ay-t", "vb"],
  "expedited": ["eh1-k s-p-ih d-ay t-ih-d", "vbn vbd jj"],
  "expedition": ["eh-k s-p-ah d-ih1 sh-ah-n", "nn"],
  "expeditious": ["eh-k s-p-ah d-ih1 sh-ah-s", "jj"],
  "expeditiously": ["eh-k s-p-ah d-ih1 sh-ah-s l-iy", "rb"],
  "expel": ["ih-k s-p-eh1-l", "vb"],
  "expend": ["ih-k s-p-eh1-n-d", "vb vbp"],
  "expendable": ["ih-k s-p-eh1-n d-ah b-ah-l", "jj"],
  "expenditure": ["ih-k s-p-eh1-n d-ah ch-er", "nn"],
  "expense": ["ih-k s-p-eh1-n-s", "nn"],
  "expensive": ["ih-k s-p-eh1-n s-ih-v", "jj rb"],
  "experience": ["ih-k s-p-ih1 r-iy ah-n-s", "nn vbp vb"],
  "experienced": ["ih-k s-p-ih1 r-iy ah-n-s-t", "vbn jj vbd"],
  "experiment": ["ih-k s-p-eh1 r-ah m-ah-n-t", "nn vbp vb"],
  "experimental": ["ih-k s-p-eh r-ah m-eh1-n t-ah-l", "jj"],
  "experimentally": ["ih-k s-p-eh r-ah m-eh1-n t-ah l-iy", "rb"],
  "experimentation": ["ih-k s-p-eh r-ah m-ah-n t-ey1 sh-ah-n", "nn"],
  "experimenter": ["ih-k s-p-eh1 r-ah m-eh-n t-er", "nn"],
  "expert": ["eh1-k s-p-er-t", "nn jj"],
  "expertise": ["eh-k s-p-er t-iy1-z", "nn"],
  "expertly": ["eh1-k s-p-er-t l-iy", "rb"],
  "expiration": ["eh-k s-p-er ey1 sh-ah-n", "nn"],
  "expire": ["ih-k s-p-ay1-r", "vb vbp"],
  "expired": ["ih-k s-p-ay1-r-d", "vbd vbn jj"],
  "explain": ["ih-k s-p-l-ey1-n", "vb vbp"],
  "explanation": ["eh-k s-p-l-ah n-ey1 sh-ah-n", "nn"],
  "explanatory": ["ih-k s-p-l-ae1 n-ah t-ao r-iy", "jj"],
  "expletive": ["eh1-k s-p-l-ah t-ih-v", "nn"],
  "explicit": ["ih-k s-p-l-ih1 s-ah-t", "jj"],
  "explicitly": ["ih-k s-p-l-ih1 s-ah-t l-iy", "rb"],
  "explode": ["ih-k s-p-l-ow1-d", "vb vbp"],
  "exploit": ["eh1-k s-p-l-oy-t", "vb nn vbp"],
  "exploitation": ["eh-k s-p-l-oy t-ey1 sh-ah-n", "nn"],
  "exploitative": ["eh-k s-p-l-oy1 t-ah t-ih-v", "jj"],
  "exploration": ["eh-k s-p-l-er ey1 sh-ah-n", "nn"],
  "exploratory": ["ih-k s-p-l-ao1 r-ah t-ao r-iy", "jj"],
  "explore": ["ih-k s-p-l-ao1-r", "vb vbp"],
  "explorer": ["ih-k s-p-l-ao1 r-er", "nn"],
  "explosion": ["ih-k s-p-l-ow1 zh-ah-n", "nn"],
  "explosive": ["ih-k s-p-l-ow1 s-ih-v", "jj nn"],
  "explosively": ["eh-k s-p-l-ow1 s-ih-v l-iy", "rb"],
  "expo": ["eh1-k s-p-ow", "nn"],
  "exponent": ["ih-k s-p-ow1 n-ah-n-t", "nn"],
  "exponential": ["eh-k s-p-ow n-eh1-n ch-ah-l", "jj"],
  "exponentially": ["eh-k s-p-ow n-eh1-n sh-ah l-iy", "rb"],
  "export": ["eh1-k s-p-ao-r-t", "nn vbp jj vb"],
  "exporter": ["ih-k s-p-ao1-r t-er", "nn"],
  "expose": ["ih-k s-p-ow1-z", "vb nn vbp"],
  "exposed": ["ih-k s-p-ow1-z-d", "vbn jj vbd"],
  "exposing": ["ih-k s-p-ow1 z-ih-ng", "vbg jj"],
  "exposition": ["eh-k s-p-ah z-ih1 sh-ah-n", "nn"],
  "exposure": ["ih-k s-p-ow1 zh-er", "nn"],
  "expound": ["ih-k-s-p-aw1-n-d", "vb"],
  "express": ["ih-k s-p-r-eh1-s", "vb vbp jj nn"],
  "expressed": ["ih-k s-p-r-eh1-s-t", "vbn vbd jj"],
  "expression": ["ih-k s-p-r-eh1 sh-ah-n", "nn"],
  "expressionism": ["ih-k s-p-r-eh1 sh-ah-n ih z-ah-m", "nn"],
  "expressionist": ["ih-k s-p-r-eh1 sh-ah-n ah-s-t", "nn"],
  "expressionistic": ["ih-k s-p-r-eh sh-ah n-ih1 s-t-ih-k", "jj"],
  "expressive": ["ih-k s-p-r-eh1 s-ih-v", "jj"],
  "expressly": ["eh-k s-p-r-eh1-s l-iy", "rb"],
  "expressway": ["ih-k s-p-r-eh1-s w-ey", "nn"],
  "expropriated": ["eh-k-s p-r-ow1 p-r-iy ey t-ih-d", "jj"],
  "expulsion": ["ih-k s-p-ah1-l sh-ah-n", "nn"],
  "expunge": ["ih-k-s-p-ah1-n-jh", "vb"],
  "exquisite": ["eh1-k s-k-w-ah z-ah-t", "jj"],
  "exquisitely": ["eh-k s-k-w-ih1 z-ih-t l-iy", "rb"],
  "extant": ["eh1-k s-t-ah-n-t", "jj"],
  "extend": ["ih-k s-t-eh1-n-d", "vb vbp"],
  "extended": ["ih-k s-t-eh1-n d-ah-d", "vbn vbd jj"],
  "extendible": ["eh-k s-t-eh1-n d-ih b-ah-l", "jj"],
  "extension": ["ih-k s-t-eh1-n sh-ah-n", "nn"],
  "extensive": ["ih-k s-t-eh1-n s-ih-v", "jj"],
  "extensively": ["ih-k s-t-eh1-n s-ih-v l-iy", "rb"],
  "extent": ["ih-k s-t-eh1-n-t", "nn"],
  "extenuate": ["ih-k-s-t-eh1-n-y-uw-ey-t", "vb"],
  "exterior": ["ih-k s-t-ih1 r-iy er", "jj nn"],
  "exterminate": ["ih-k-s-t-er1-m-ah-n-ey-t", "vb"],
  "extermination": ["ih-k s-t-er m-ah n-ey1 sh-ah-n", "nn"],
  "exterminator": ["ih-k s-t-er1 m-ah n-ey t-er", "nn"],
  "external": ["ih-k s-t-er1 n-ah-l", "jj"],
  "externally": ["ih-k s-t-er1 n-ah l-iy", "rb"],
  "extinct": ["ih-k s-t-ih1-ng-k-t", "jj"],
  "extinction": ["ih-k s-t-ih1-ng-k sh-ah-n", "nn"],
  "extinguish": ["ih-k s-t-ih1-ng g-w-ih-sh", "vb"],
  "extinguisher": ["ih-k s-t-ih1-ng g-w-ih sh-er", "nn"],
  "extinguishment": ["ih-k s-t-ih1-ng g-w-ih-sh m-ah-n-t", "nn"],
  "extol": ["ih-k s-t-ow1-l", "vb"],
  "extort": ["ih-k s-t-ao1-r-t", "vb"],
  "extortion": ["ih-k s-t-ao1-r sh-ah-n", "nn"],
  "extortionate": ["ih-k s-t-ao1-r sh-ah-n ah-t", "jj"],
  "extra": ["eh1-k s-t-r-ah", "jj nn"],
  "extract": ["ih-k s-t-r-ae1-k-t", "vb nn vbp"],
  "extraction": ["ih-k s-t-r-ae1-k sh-ah-n", "nn"],
  "extracurricular": ["eh-k s-t-r-ah k-er ih1 k-y-ah l-er", "jj"],
  "extradite": ["eh1-k s-t-r-ah d-ay-t", "vb"],
  "extradition": ["eh-k s-t-r-ah d-ih1 sh-ah-n", "nn"],
  "extralegal": ["eh-k s-t-r-ah l-iy1 g-ah-l", "jj"],
  "extramarital": ["eh-k s-t-r-ah m-eh1 r-ah t-ah-l", "jj"],
  "extraneous": ["eh-k s-t-r-ey1 n-iy ah-s", "jj"],
  "extraordinarily": ["ih-k s-t-r-ao-r d-ah n-eh1 r-ah l-iy", "rb"],
  "extraordinary": ["ih-k s-t-r-ao1-r d-ah-n eh r-iy", "jj nn"],
  "extrapolate": ["ih-k s-t-r-ae1 p-ah l-ey-t", "vb"],
  "extrapolation": ["ih-k s-t-r-ae p-ah l-ey1 sh-ah-n", "nn"],
  "extraterrestrial": ["eh-k s-t-r-ah t-er eh1-s t-r-iy ah-l", "jj"],
  "extraterritorial": ["eh-k s-t-r-ah t-eh r-ih t-ao1 r-iy ah-l", "jj"],
  "extravagance": ["ih-k s-t-r-ae1 v-ah g-ah-n-s", "nn"],
  "extravagant": ["ih-k s-t-r-ae1 v-ah g-ah-n-t", "jj"],
  "extravagantly": ["eh-k s-t-r-ae1 v-ah g-ah-n-t l-iy", "rb"],
  "extravaganza": ["ih-k s-t-r-ae v-ah g-ae1-n z-ah", "nn"],
  "extreme": ["ih-k s-t-r-iy1-m", "jj nn"],
  "extremely": ["ih-k s-t-r-iy1-m l-iy", "rb"],
  "extremist": ["ih-k s-t-r-iy1 m-ih-s-t", "jj nn"],
  "extremity": ["ih-k-s t-r-eh1 m-ah t-iy", "nn"],
  "extricate": ["eh1-k s-t-r-ah k-ey-t", "vb"],
  "extrude": ["ih-k-s-t-r-uw1-d", "vb"],
  "extruded": ["ih-k s-t-r-uw1 d-ah-d", "vbn jj"],
  "extrusion": ["ih-k-s t-r-uw1 zh-ah-n", "nn"],
  "exuberance": ["ih-g z-uw1 b-er ah-n-s", "nn"],
  "exuberant": ["ih-g z-uw1 b-er ah-n-t", "jj"],
  "exude": ["ih-g z-uw1-d", "vb vbp"],
  "exult": ["ih-g-z-ah1-l-t", "vb"],
  "exultantly": ["ih-g z-ah1-l t-ah-n-t l-iy", "rb"],
  "eye": ["ay1", "nn vb"],
  "eyeball": ["ay1 b-ao-l", "nn"],
  "eyebrow": ["ay1 b-r-aw", "nn"],
  "eyeglasses": ["ay1 g-l-ae s-ah-z", "nn"],
  "eyelash": ["ay1 l-ae-sh", "nn"],
  "eyelet": ["ay1 l-ah-t", "nn"],
  "eyelid": ["ay1 l-ih-d", "nn"],
  "eyepiece": ["ay1 p-iy-s", "nn"],
  "eyesight": ["ay1 s-ay-t", "nn"],
  "eyesore": ["ay1 s-ao-r", "nn"],
  "eyewear": ["ay1 w-eh-r", "jj nn"],
  "eyewitness": ["ay1 w-ih1-t n-ah-s", "nn jj"],
  "fable": ["f-ey1 b-ah-l", "nn"],
  "fabled": ["f-ey1 b-ah-l-d", "jj"],
  "fabric": ["f-ae1 b-r-ih-k", "nn"],
  "fabricate": ["f-ae1 b-r-ah k-ey-t", "vb vbp"],
  "fabricated": ["f-ae1 b-r-ih k-ey t-ah-d", "vbn vbd jj"],
  "fabrication": ["f-ae b-r-ih k-ey1 sh-ah-n", "nn"],
  "fabricator": ["f-ae1 b-r-ih k-ey t-er", "nn"],
  "fabulous": ["f-ae1 b-y-ah l-ah-s", "jj"],
  "fabulously": ["f-ae1 b-y-uw l-ah-s l-iy", "rb"],
  "facade": ["f-ah s-aa1-d", "nn"],
  "face": ["f-ey1-s", "nn vbp jj rb vb"],
  "faceless": ["f-ey1-s l-ah-s", "jj"],
  "facelift": ["f-ey1-s l-ih-f-t", "nn"],
  "facet": ["f-ae1 s-ah-t", "nn"],
  "facetious": ["f-ah s-iy1 sh-ah-s", "jj"],
  "facetiously": ["f-ah s-iy1 sh-ah-s l-iy", "rb"],
  "facial": ["f-ey1 sh-ah-l", "jj"],
  "facile": ["f-ae1 s-ih-l", "jj"],
  "facilitate": ["f-ah s-ih1 l-ah t-ey-t", "vb vbp"],
  "facilitator": ["f-ah s-ih1 l-ah t-ey t-er", "nn"],
  "facility": ["f-ah s-ih1 l-ih t-iy", "nn"],
  "facing": ["f-ey1 s-ih-ng", "vbg jj"],
  "facsimile": ["f-ae-k s-ih1 m-ah l-iy", "nn jj"],
  "fact": ["f-ae1-k-t", "nn"],
  "faction": ["f-ae1-k sh-ah-n", "nn"],
  "factor": ["f-ae1-k t-er", "nn vb vbp"],
  "factored": ["f-ae1-k t-er-d", "vbn jj"],
  "factory": ["f-ae1-k t-er iy", "nn jj"],
  "factual": ["f-ae1-k ch-uw ah-l", "jj"],
  "factually": ["f-ae1-k ch-uw ah l-iy", "rb"],
  "faculty": ["f-ae1 k-ah-l t-iy", "nn"],
  "fad": ["f-ae1-d", "nn"],
  "faddish": ["f-ae1 d-ih-sh", "jj"],
  "fade": ["f-ey1-d", "vb vbp nn"],
  "faded": ["f-ey1 d-ah-d", "vbn vbd jj"],
  "fading": ["f-ey1 d-ih-ng", "vbg jj nn"],
  "fail": ["f-ey1-l", "vb vbp nn"],
  "failed": ["f-ey1-l-d", "vbd vbn jj"],
  "failure": ["f-ey1 l-y-er", "nn"],
  "faint": ["f-ey1-n-t", "jj nn vb"],
  "fainter": ["f-ey1-n t-er", "jjr"],
  "faintest": ["f-ey1-n t-ah-s-t", "jjs"],
  "faintly": ["f-ey1-n-t l-iy", "rb"],
  "fair": ["f-eh1-r", "jj nn rb"],
  "fairer": ["f-eh1 r-er", "jjr"],
  "fairest": ["f-eh1 r-ih-s-t", "jjs"],
  "fairly": ["f-eh1-r l-iy", "rb"],
  "fairness": ["f-eh1-r n-ah-s", "nn"],
  "fairway": ["f-eh1-r w-ey", "nn"],
  "fairy": ["f-eh1 r-iy", "jj nn"],
  "faith": ["f-ey1-th", "nn"],
  "faithful": ["f-ey1-th f-ah-l", "jj nn"],
  "faithfully": ["f-ey1-th f-ah l-iy", "rb"],
  "fajita": ["f-ah jh-iy1 t-ah", "nn"],
  "fake": ["f-ey1-k", "jj nn vb vbp"],
  "falcon": ["f-ae1-l k-ah-n", "nn"],
  "falconer": ["f-ae1-l k-ah n-er", "nn"],
  "falconry": ["f-ae1-l k-ah-n r-iy", "nn"],
  "fall": ["f-ao1-l", "nn vbp vb"],
  "fallacious": ["f-ah l-ey1 sh-ah-s", "jj"],
  "fallacy": ["f-ae1 l-ah s-iy", "nn"],
  "fallback": ["f-ao1-l b-ae-k", "nn jj"],
  "fallen": ["f-aa1 l-ah-n", "vbn jj"],
  "fallible": ["f-ae1 l-ah b-ah-l", "jj"],
  "falling": ["f-aa1 l-ih-ng", "vbg jj nn"],
  "falloff": ["f-ao1-l ao-f", "nn"],
  "fallout": ["f-ao1-l aw-t", "nn"],
  "fallow": ["f-ae1 l-ow", "jj"],
  "false": ["f-ao1-l-s", "jj rb"],
  "falsehood": ["f-ae1-l-s hh-uh-d", "nn"],
  "falsely": ["f-ao1-l-s l-iy", "rb"],
  "falsification": ["f-ae-l s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "falsified": ["f-ao1-l s-ah f-ay-d", "vbn"],
  "falsify": ["f-ao1-l s-ah f-ay", "vb"],
  "falsity": ["f-ao1-l s-ah t-iy", "nn"],
  "falter": ["f-ao1-l t-er", "vb vbp"],
  "fame": ["f-ey1-m", "nn vb"],
  "famed": ["f-ey1-m-d", "jj vbn"],
  "familial": ["f-ah m-ih1 l-y-ah-l", "jj"],
  "familiar": ["f-ah m-ih1 l-y-er", "jj nn"],
  "familiarity": ["f-ah m-ih l-y-eh1 r-ah t-iy", "nn"],
  "familiarize": ["f-ah m-ih1 l-y-er ay-z", "vb"],
  "family": ["f-ae1 m-ah l-iy", "nn"],
  "famine": ["f-ae1 m-ah-n", "nn"],
  "famous": ["f-ey1 m-ah-s", "jj"],
  "famously": ["f-ey1 m-ah-s l-iy", "rb"],
  "fan": ["f-ae1-n", "nn vbp vb"],
  "fanatic": ["f-ah n-ae1 t-ih-k", "nn jj"],
  "fanatical": ["f-ah n-ae1 t-ih k-ah-l", "jj"],
  "fanatically": ["f-ah n-ae1 t-ih k-ah l-iy", "rb"],
  "fanaticism": ["f-ah n-ae1 t-ah s-ih z-ah-m", "nn"],
  "fancier": ["f-ae1-n s-iy er", "jjr"],
  "fanciest": ["f-ae1-n s-iy ah-s-t", "jjs"],
  "fanciful": ["f-ae1-n s-ih f-ah-l", "jj"],
  "fancy": ["f-ae1-n s-iy", "jj nn vb"],
  "fanfare": ["f-ae1-n f-eh-r", "nn"],
  "fang": ["f-ae1-ng", "nn"],
  "fanny": ["f-ae1 n-iy", "nn"],
  "fantasia": ["f-ae-n t-ey1 zh-ah", "nn"],
  "fantasize": ["f-ae1-n t-ah s-ay-z", "vbp vb"],
  "fantastic": ["f-ae-n t-ae1 s-t-ih-k", "jj"],
  "fantastically": ["f-ae-n t-ae1 s-t-ih-k l-iy", "rb"],
  "fantasy": ["f-ae1-n t-ah s-iy", "nn"],
  "far": ["f-aa1-r", "rb in jj"],
  "faraway": ["f-aa1 r-ah w-ey1", "jj"],
  "farce": ["f-aa1-r-s", "nn"],
  "fare": ["f-eh1-r", "nn vbp vb"],
  "farewell": ["f-eh-r w-eh1-l", "nn uh"],
  "farfetched": ["f-aa1-r f-eh1-ch-t", "jj"],
  "farm": ["f-aa1-r-m", "nn vb"],
  "farmed": ["f-aa1-r-m-d", "vbd jj"],
  "farmer": ["f-aa1-r m-er", "nn"],
  "farmhand": ["f-aa1-r-m hh-ae-n-d", "nn"],
  "farmhouse": ["f-aa1-r-m hh-aw-s", "nn"],
  "farmland": ["f-aa1-r-m l-ae-n-d", "nn"],
  "faro": ["f-eh1 r-ow", "nn"],
  "farther": ["f-aa1-r dh-er", "rb rbr"],
  "farthest": ["f-aa1-r dh-ah-s-t", "jjs rbs"],
  "fascinate": ["f-ae1 s-ah n-ey-t", "vb vbp"],
  "fascinated": ["f-ae1 s-ah n-ey t-ah-d", "vbn jj vbd"],
  "fascinating": ["f-ae1 s-ah n-ey t-ih-ng", "jj"],
  "fascination": ["f-ae s-ah n-ey1 sh-ah-n", "nn"],
  "fascism": ["f-ae1 sh-ih z-ah-m", "nn"],
  "fascist": ["f-ae1 sh-ah-s-t", "jj"],
  "fashion": ["f-ae1 sh-ah-n", "nn vb"],
  "fashionable": ["f-ae1 sh-ah-n ah b-ah-l", "jj nn"],
  "fast": ["f-ae1-s-t", "rb jj nn rp"],
  "fastball": ["f-ae1-s-t b-ao-l", "nn"],
  "fasten": ["f-ae1 s-ah-n", "vb vbp"],
  "fastener": ["f-ae1 s-ah n-er", "nn"],
  "fastening": ["f-ae1 s-ah n-ih-ng", "nn"],
  "faster": ["f-ae1 s-t-er", "rbr jjr rb"],
  "fastest": ["f-ae1 s-t-ah-s-t", "jjs rbs"],
  "fastidious": ["f-ae s-t-ih1 d-iy ah-s", "jj"],
  "fastness": ["f-ae1-s-t n-ah-s", "nn"],
  "fat": ["f-ae1-t", "jj nn"],
  "fatal": ["f-ey1 t-ah-l", "jj"],
  "fatality": ["f-ah t-ae1 l-ah t-iy", "nn"],
  "fatally": ["f-ey1 t-ah l-iy", "rb"],
  "fate": ["f-ey1-t", "nn"],
  "fateful": ["f-ey1-t f-ah-l", "jj"],
  "father": ["f-aa1 dh-er", "nn vb"],
  "fatherly": ["f-aa1 dh-er l-iy", "jj"],
  "fathom": ["f-ae1 dh-ah-m", "vb"],
  "fatigue": ["f-ah t-iy1-g", "nn vb vbp"],
  "fatigued": ["f-ah t-iy1-g-d", "vbn jj"],
  "fatten": ["f-ae1 t-ah-n", "vb vbp"],
  "fatter": ["f-ae1 t-er", "jjr"],
  "fatty": ["f-ae1 t-iy", "jj"],
  "fatuous": ["f-ae1 ch-ah-w ah-s", "jj"],
  "faucet": ["f-ao1 s-ah-t", "nn"],
  "fault": ["f-ao1-l-t", "nn vb vbp"],
  "faulty": ["f-ao1-l t-iy", "jj"],
  "fauna": ["f-ao1 n-ah", "nn"],
  "faux": ["f-ao1-k-s", "jj"],
  "favor": ["f-ey1 v-er", "nn vbp vb"],
  "favorable": ["f-ey1 v-er ah b-ah-l", "jj"],
  "favorably": ["f-ey1 v-er ah b-l-iy", "rb"],
  "favored": ["f-ey1 v-er-d", "vbn vbd jj"],
  "favorite": ["f-ey1 v-er ih-t", "jj nn"],
  "favoritism": ["f-ey1 v-er ih t-ih z-ah-m", "nn"],
  "fawn": ["f-ao1-n", "nn jj vb"],
  "fax": ["f-ae1-k-s", "nn vb"],
  "faze": ["f-ey1-z", "vb"],
  "fealty": ["f-iy1 ah-l t-iy", "nn"],
  "fear": ["f-ih1-r", "nn vb vbp"],
  "feared": ["f-ih1-r-d", "vbd vbn jj"],
  "fearful": ["f-ih1-r f-ah-l", "jj"],
  "fearless": ["f-ih1-r l-ah-s", "jj"],
  "fearsome": ["f-ih1-r s-ah-m", "jj"],
  "feasibility": ["f-iy z-ah b-ih1 l-ah t-iy", "nn"],
  "feasible": ["f-iy1 z-ah b-ah-l", "jj"],
  "feast": ["f-iy1-s-t", "nn vb"],
  "feat": ["f-iy1-t", "nn"],
  "feather": ["f-eh1 dh-er", "nn vb"],
  "featherbedding": ["f-eh1 dh-er b-eh d-ih-ng", "nn"],
  "feathered": ["f-eh1 dh-er-d", "jj vbn"],
  "featherless": ["f-eh1 dh-er l-ah-s", "jj"],
  "feathery": ["f-eh1 dh-er iy", "jj"],
  "feature": ["f-iy1 ch-er", "nn vbp jj vb"],
  "featured": ["f-iy1 ch-er-d", "vbn vbd jj"],
  "featureless": ["f-iy1 ch-er l-ah-s", "jj"],
  "fecal": ["f-iy1 k-ah-l", "jj"],
  "feckless": ["f-eh1-k l-ih-s", "jj"],
  "fed": ["f-eh1-d", 'vbd vbn'],
  "federal": ["f-eh1 d-er ah-l", "jj"],
  "federalist": ["f-eh1 d-er ah l-ih-s-t", "nn"],
  "federalized": ["f-eh1 d-er ah l-ay-z-d", "jj"],
  "federally": ["f-eh1 d-er ah l-iy", "rb"],
  "federation": ["f-eh d-er ey1 sh-ah-n", "nn"],
  "fedora": ["f-ih d-ao1 r-ah", "nn"],
  "fee": ["f-iy1", "nn"],
  "feeble": ["f-iy1 b-ah-l", "jj"],
  "feebly": ["f-iy1 b-l-iy", "rb"],
  "feed": ["f-iy1-d", "nn vb"],
  "feedback": ["f-iy1-d b-ae-k", "nn"],
  "feeder": ["f-iy1 d-er", "nn"],
  "feedlot": ["f-iy1-d l-aa-t", "nn"],
  "feedstock": ["f-iy1-d s-t-aa-k", "nn"],
  "feel": ["f-iy1-l", "vb vbp nn"],
  "feeler": ["f-iy1 l-er", "nn"],
  "feeling": ["f-iy1 l-ih-ng", "nn vbg"],
  "feign": ["f-ey1-n", "vb"],
  "feigned": ["f-ey1-n-d", "jj vbn"],
  "feint": ["f-ey1-n-t", "nn vb"],
  "feisty": ["f-ay1 s-t-iy", "jj"],
  "felicitous": ["f-ih l-ih1 s-ah t-ah-s", "jj"],
  "felicity": ["f-ih l-ih1 s-ah t-iy", "nn"],
  "feline": ["f-iy1 l-ay-n", "jj"],
  "fell": ["f-eh1-l", "vbd jj nn vbn"],
  "felled": ["f-eh1-l-d", "vbn vbd"],
  "feller": ["f-eh1 l-er", "nn"],
  "fellow": ["f-eh1 l-ow", "nn jj"],
  "fellowship": ["f-eh1 l-ow sh-ih-p", "nn"],
  "felon": ["f-eh1 l-ah-n", "nn"],
  "felony": ["f-eh1 l-ah n-iy", "nn"],
  "felt": ["f-eh1-l-t", "vbd vbn"],
  "female": ["f-iy1 m-ey-l", "jj nn"],
  "feminine": ["f-eh1 m-ah n-ah-n", "jj nn"],
  "femininity": ["f-eh m-ah n-ih1 n-ah t-iy", "nn"],
  "feminism": ["f-eh1 m-ih n-ih z-ah-m", "nn"],
  "feminist": ["f-eh1 m-ah n-ah-s-t", "jj nn"],
  "fence": ["f-eh1-n-s", "nn vb"],
  "fenced": ["f-eh1-n-s-t", "jj vbn"],
  "fencing": ["f-eh1-n s-ih-ng", "nn"],
  "fend": ["f-eh1-n-d", "vb"],
  "fender": ["f-eh1-n d-er", "nn"],
  "fennel": ["f-eh1 n-ah-l", "nn"],
  "fenugreek": ["f-eh1 n-uw g-r-iy-k", "nn"],
  "ferment": ["f-er m-eh1-n-t", "nn vb"],
  "fermentation": ["f-er m-ah-n t-ey1 sh-ah-n", "jj nn"],
  "fern": ["f-er1-n", "nn"],
  "fernery": ["f-er1 n-er iy", "nn"],
  "ferocious": ["f-er ow1 sh-ah-s", "jj"],
  "ferociously": ["f-er ow1 sh-ih-s l-iy", "rb"],
  "ferocity": ["f-er aa1 s-ah t-iy", "nn"],
  "ferret": ["f-eh1 r-ah-t", "vb nn"],
  "ferried": ["f-eh1 r-iy-d", "vbd vbn"],
  "ferris": ["f-eh1 r-ih-s", "jj"],
  "ferromagnetic": ["f-eh r-ow m-ae-g n-eh1 t-ih-k", "jj"],
  "ferry": ["f-eh1 r-iy", "nn vb"],
  "fertile": ["f-er1 t-ah-l", "jj"],
  "fertility": ["f-er t-ih1 l-ah t-iy", "nn"],
  "fertilization": ["f-er t-ah l-ih z-ey1 sh-ah-n", "nn"],
  "fertilize": ["f-er1-t-ah-l-ay-z", "vb"],
  "fertilized": ["f-er1 t-ah l-ay-z-d", "vbn jj"],
  "fertilizer": ["f-er1 t-ah l-ay z-er", "nn"],
  "fervent": ["f-er1 v-ah-n-t", "jj"],
  "fervently": ["f-er1 v-ah-n-t l-iy", "rb"],
  "fervid": ["f-er1 v-ah-d", "nn"],
  "fervor": ["f-er1 v-er", "nn"],
  "fest": ["f-eh1-s-t", "nn jjs"],
  "fester": ["f-eh1 s-t-er", "vb"],
  "festival": ["f-eh1 s-t-ah v-ah-l", "nn"],
  "festive": ["f-eh1 s-t-ih-v", "jj"],
  "festivity": ["f-eh s-t-ih1 v-ah t-iy", "nn"],
  "festoon": ["f-eh-s-t-uw1-n", "vb"],
  "fetal": ["f-iy1 t-ah-l", "jj"],
  "fetch": ["f-eh1-ch", "vb vbp"],
  "fete": ["f-ey1-t", "vb"],
  "fetid": ["f-eh1 t-ah-d", "jj"],
  "fetish": ["f-eh1 t-ih-sh", "nn"],
  "fetter": ["f-eh1-t-er", "vb"],
  "fetus": ["f-iy1 t-ah-s", "nn"],
  "feud": ["f-y-uw1-d", "nn vb"],
  "feudal": ["f-y-uw1 d-ah-l", "jj"],
  "feudalism": ["f-y-uw1 d-ah l-ih z-ah-m", "nn"],
  "feudalistic": ["f-y-uw d-ah l-ih1 s-t-ih-k", "jj"],
  "fever": ["f-iy1 v-er", "nn"],
  "fevered": ["f-iy1 v-er-d", "jj"],
  "feverish": ["f-iy1 v-er ih-sh", "jj"],
  "feverishly": ["f-eh1 v-er ih-sh l-iy", "rb"],
  "few": ["f-y-uw1", "jj"],
  "fewer": ["f-y-uw1 er", "jjr rb rbr"],
  "fewest": ["f-y-uw1 ah-s-t", "jjs"],
  "fiance": ["f-iy aa1-n s-ey", "nn"],
  "fiancee": ["f-iy ae1-n s-iy", "nn"],
  "fiasco": ["f-iy ae1-s k-ow", "nn"],
  "fiat": ["f-ay1 ae-t", "nn"],
  "fiber": ["f-ay1 b-er", "nn"],
  "fiberglass": ["f-ay1 b-er g-l-ae-s", "nn"],
  "fiberoptic": ["f-ay1 b-er aa-p t-ih-k", "jj"],
  "fibrillation": ["f-ih b-r-ih l-ey1 sh-ah-n", "nn"],
  "fibrin": ["f-ay1 b-r-ah-n", "nn"],
  "fibrosis": ["f-ay b-r-ow1 s-ah-s", "nn"],
  "fibrous": ["f-ay1 b-r-ah-s", "jj"],
  "fickle": ["f-ih1 k-ah-l", "jj"],
  "fickleness": ["f-ih1 k-ah-l n-ah-s", "nn"],
  "fiction": ["f-ih1-k sh-ah-n", "nn"],
  "fictional": ["f-ih1-k sh-ah n-ah-l", "jj"],
  "fictionalize": ["f-ih1-k-sh-ah-n-ah-l-ay-z", "vb"],
  "fictitious": ["f-ih-k t-ih1 sh-ah-s", "jj"],
  "fiddle": ["f-ih1 d-ah-l", "nn vb"],
  "fiddling": ["f-ih1-d l-ih-ng", "nn jj vbg"],
  "fidelity": ["f-ah d-eh1 l-ah t-iy", "nn"],
  "fidget": ["f-ih1-jh-ih-t", "vb"],
  "fiduciary": ["f-ah d-uw1 sh-iy eh r-iy", "jj"],
  "fiefdom": ["f-iy1-f d-ah-m", "nn"],
  "field": ["f-iy1-l-d", "nn jj vb vbp"],
  "fielder": ["f-iy1-l d-er", "nn"],
  "fieldwork": ["f-iy1-l-d w-er-k", "nn"],
  "fiend": ["f-iy1-n-d", "nn"],
  "fiendish": ["f-iy1-n d-ih-sh", "jj"],
  "fierce": ["f-ih1-r-s", "jj"],
  "fiercely": ["f-ih1-r-s l-iy", "rb"],
  "fiercer": ["f-ih1-r s-er", "jjr"],
  "fiercest": ["f-ih1-r s-ah-s-t", "jjs"],
  "fiery": ["f-ay1 er iy", "jj"],
  "fiesta": ["f-iy eh1 s-t-ah", "nn"],
  "fifth": ["f-ih1-f-th", "jj nn rb"],
  "fig": ["f-ih1-g", "nn"],
  "fight": ["f-ay1-t", "nn vb vbp"],
  "fighter": ["f-ay1 t-er", "nn"],
  "fighting": ["f-ay1 t-ih-ng", "vbg jj"],
  "figurative": ["f-ih1 g-y-er ah t-ih-v", "jj"],
  "figuratively": ["f-ih g-y-uh1 r-ah t-ih-v l-iy", "rb"],
  "figure": ["f-ih1 g-y-er", "nn vb vbp vbz"],
  "figured": ["f-ih1 g-y-er-d", "vbd jj vbn"],
  "figurehead": ["f-ih1 g-y-er hh-eh-d", "nn"],
  "filament": ["f-ih1 l-ah m-ah-n-t", "nn"],
  "filbert": ["f-ih1-l b-er-t", "jj"],
  "filch": ["f-ih1-l-ch", "vb"],
  "file": ["f-ay1-l", "vb nn vbp"],
  "filer": ["f-ay1 l-er", "nn"],
  "filet": ["f-ih l-ey1", "nn"],
  "filial": ["f-ih1 l-iy ah-l", "jj"],
  "filibuster": ["f-ih1 l-ah b-ah s-t-er", "nn vb"],
  "filigree": ["f-ih1 l-ah g-r-iy", "jj nn"],
  "filing": ["f-ay1 l-ih-ng", "nn vbg"],
  "fill": ["f-ih1-l", "vb vbp nn"],
  "filled": ["f-ih1-l-d", "vbn jj vbd"],
  "filler": ["f-ih1 l-er", "nn"],
  "fillet": ["f-ah-l-ey1", "vb"],
  "fillip": ["f-ih1 l-ah-p", "nn"],
  "filly": ["f-ih1 l-iy", "nn"],
  "film": ["f-ih1-l-m", "nn vb"],
  "filmed": ["f-ih1-l-m-d", "vbn vbd jj"],
  "filmmaker": ["f-ih1-l m-ey k-er", "nn"],
  "filmmaking": ["f-ih1-l m-ey k-ih-ng", "nn"],
  "filter": ["f-ih1-l t-er", "nn vb"],
  "filtered": ["f-ih1-l t-er-d", "vbn jj"],
  "filth": ["f-ih1-l-th", "nn"],
  "filthy": ["f-ih1-l th-iy", "jj"],
  "filtration": ["f-ih-l t-r-ey1 sh-ah-n", "nn"],
  "fin": ["f-ih1-n", "nn"],
  "final": ["f-ay1 n-ah-l", "jj"],
  "finale": ["f-ah n-ae1 l-iy", "nn"],
  "finalist": ["f-ay1 n-ah l-ih-s-t", "nn"],
  "finality": ["f-ay n-ae1 l-ah t-iy", "nn"],
  "finalize": ["f-ay1-n-ah-l-ay-z", "vb"],
  "finally": ["f-ay1 n-ah l-iy", "rb"],
  "finance": ["f-ah n-ae1-n-s", "nn vbp vb"],
  "financed": ["f-ih n-ae1-n-s-t", "vbn jj vbd"],
  "financial": ["f-ah n-ae1-n sh-ah-l", "jj"],
  "financially": ["f-ah n-ae1-n sh-ah l-iy", "rb"],
  "financier": ["f-ih n-ah-n s-ih1-r", "nn"],
  "financing": ["f-ah n-ae1-n s-ih-ng", "nn jj vbg"],
  "find": ["f-ay1-n-d", "vb vbp nn"],
  "finder": ["f-ay1-n d-er", "nn"],
  "fine": ["f-ay1-n", "jj nn rb vb"],
  "finely": ["f-ay1-n l-iy", "rb"],
  "finer": ["f-ay1 n-er", "jjr"],
  "finery": ["f-ay1 n-er iy", "nn"],
  "finesse": ["f-ih n-eh1-s", "nn vb"],
  "finest": ["f-ay1 n-ah-s-t", "jjs"],
  "finger": ["f-ih1-ng g-er", "nn vb"],
  "fingernail": ["f-ih1-ng g-er n-ey-l", "nn"],
  "fingerprint": ["f-ih1-ng g-er p-r-ih-n-t", "nn vb"],
  "fingertip": ["f-ih1-ng g-er t-ih-p", "nn"],
  "finicky": ["f-ih1 n-ah k-iy", "jj"],
  "fining": ["f-ay1 n-ih-ng", "nn"],
  "finish": ["f-ih1 n-ih-sh", "vb nn vbp"],
  "finished": ["f-ih1 n-ih-sh-t", "vbd jj vbn"],
  "finisher": ["f-ih1 n-ih sh-er", "nn"],
  "finishing": ["f-ih1 n-ih sh-ih-ng", "vbg jj nn"],
  "finite": ["f-ay1 n-ay-t", "jj nn"],
  "fir": ["f-er1", "nn"],
  "fire": ["f-ay1 er", "nn vb"],
  "firearm": ["f-ay1 er aa-r-m", "nn"],
  "fireball": ["f-ay1 er b-ao-l", "nn"],
  "firebomb": ["f-ay1-er-b-aa-m", "vb"],
  "firebombing": ["f-ay1 er b-aa m-ih-ng", "nn"],
  "firebrand": ["f-ay1 er b-r-ae-n-d", "nn"],
  "firebug": ["f-ay1 er b-ah-g", "nn"],
  "firecracker": ["f-ay1 er k-r-ae k-er", "nn"],
  "firefighter": ["f-ay1-r f-ay t-er", "nn"],
  "firefighting": ["f-ay1-r f-ay t-ih-ng", "nn"],
  "firehouse": ["f-ay1 er hh-aw-s", "nn"],
  "fireman": ["f-ay1-r m-ah-n", "nn"],
  "fireplace": ["f-ay1 er p-l-ey-s", "nn"],
  "firepower": ["f-ay1-r p-aw er", "nn"],
  "fireproof": ["f-ay1-er-p-r-uw-f", "vb"],
  "firestorm": ["f-ay1-r s-t-ao-r-m", "nn"],
  "fireweed": ["f-ay1 er w-iy-d", "nn"],
  "firewood": ["f-ay1 er w-uh-d", "nn"],
  "firework": ["f-ay1-r w-er-k", "nn"],
  "firing": ["f-ay1 r-ih-ng", "vbg jj nn"],
  "firm": ["f-er1-m", "nn jj vb"],
  "firmer": ["f-er1 m-er", "jjr rb rbr"],
  "firmly": ["f-er1-m l-iy", "rb"],
  "firmness": ["f-er1-m n-ah-s", "nn"],
  "first": ["f-er1-s-t", "jj rb nn"],
  "firsthand": ["f-er-s-t hh-ae1-n-d", "rb jj nn"],
  "fiscal": ["f-ih1-s k-ah-l", "jj in nn"],
  "fiscally": ["f-ih1-s k-ah l-iy", "rb"],
  "fish": ["f-ih1-sh", "nn vb"],
  "fishbowl": ["f-ih1-sh b-ow-l", "nn"],
  "fisher": ["f-ih1 sh-er", "nn"],
  "fisherman": ["f-ih1 sh-er m-ae-n", "nn"],
  "fishery": ["f-ih1 sh-er iy", "nn"],
  "fishing": ["f-ih1 sh-ih-ng", "nn vbg jj"],
  "fishy": ["f-ih1 sh-iy", "jj"],
  "fission": ["f-ih1 sh-ah-n", "nn"],
  "fissionable": ["f-ih1 sh-ah-n ah b-ah-l", "jj"],
  "fissure": ["f-ih1-sh-er", "vb"],
  "fist": ["f-ih1-s-t", "nn vb"],
  "fit": ["f-ih1-t", "vb vbn vbp jj nn rb vbd"],
  "fitful": ["f-ih1-t f-ah-l", "jj"],
  "fitfully": ["f-ih1-t f-ah l-iy", "rb"],
  "fitness": ["f-ih1-t n-ah-s", "nn"],
  "fitted": ["f-ih1 t-ah-d", "vbn vbd jj"],
  "fittest": ["f-ih1 t-ah-s-t", "jjs"],
  "fitting": ["f-ih1 t-ih-ng", "jj nn vbg"],
  "five": ["f-ay1-v", "cd"],
  "fivefold": ["f-ay1-v f-ow-l-d", "jj rb"],
  "fix": ["f-ih1-k-s", "vb vbp nn"],
  "fixable": ["f-ih1-k s-ah b-ah-l", "jj"],
  "fixate": ["f-ih1-k-s-ey-t", "vb"],
  "fixation": ["f-ih-k s-ey1 sh-ah-n", "nn"],
  "fixed": ["f-ih1-k-s-t", "vbn jj vbd"],
  "fixture": ["f-ih1-k-s ch-er", "nn"],
  "fizzle": ["f-ih1-z-ah-l", "vb"],
  "fjord": ["f-y-ao1-r-d", "nn"],
  "flabbergast": ["f-l-ae1-b-er-g-ae-s-t", "vb"],
  "flabbergasted": ["f-l-ae1 b-er g-ae s-t-ih-d", "jj vbn"],
  "flaccid": ["f-l-ae1-k s-ih-d", "jj"],
  "flag": ["f-l-ae1-g", "nn vb"],
  "flagellate": ["f-l-ae1-jh-ah-l-ey-t", "vb"],
  "flageolet": ["f-l-ae jh-ah l-eh1-t", "nn"],
  "flagging": ["f-l-ae1 g-ih-ng", "jj vbg"],
  "flagpole": ["f-l-ae1-g p-ow-l", "nn"],
  "flagrant": ["f-l-ey1 g-r-ah-n-t", "jj"],
  "flagrantly": ["f-l-ey1 g-r-ah-n-t l-iy", "rb"],
  "flagship": ["f-l-ae1-g sh-ih-p", "nn jj"],
  "flail": ["f-l-ey1-l", "nn vb"],
  "flair": ["f-l-eh1-r", "nn"],
  "flak": ["f-l-ae1-k", "nn"],
  "flake": ["f-l-ey1-k", "nn"],
  "flaky": ["f-l-ey1 k-iy", "jj"],
  "flamboyant": ["f-l-ae-m b-oy1 ah-n-t", "jj"],
  "flamboyantly": ["f-l-ae-m b-oy1 ah-n-t l-iy", "rb"],
  "flame": ["f-l-ey1-m", "nn vbp vb"],
  "flaming": ["f-l-ey1 m-ih-ng", "jj vbg"],
  "flammable": ["f-l-ae1 m-ah b-ah-l", "jj"],
  "flange": ["f-l-ae1-n-jh", "nn"],
  "flank": ["f-l-ae1-ng-k", "nn vb"],
  "flannel": ["f-l-ae1 n-ah-l", "nn"],
  "flap": ["f-l-ae1-p", "nn"],
  "flapper": ["f-l-ae1 p-er", "nn"],
  "flapping": ["f-l-ae1 p-ih-ng", "vbg jj"],
  "flare": ["f-l-eh1-r", "nn vb vbp"],
  "flared": ["f-l-eh1-r-d", "vbd vbn jj"],
  "flaring": ["f-l-eh1 r-ih-ng", "vbg jj"],
  "flash": ["f-l-ae1-sh", "nn vbp jj vb"],
  "flashback": ["f-l-ae1-sh b-ae-k", "nn"],
  "flasher": ["f-l-ae1 sh-er", "nn"],
  "flashier": ["f-l-ae1 sh-iy er", "jjr"],
  "flashlight": ["f-l-ae1-sh l-ay-t", "nn"],
  "flashpoint": ["f-l-ae1-sh p-oy-n-t", "nn"],
  "flashy": ["f-l-ae1 sh-iy", "jj"],
  "flask": ["f-l-ae1-s-k", "nn"],
  "flat": ["f-l-ae1-t", "jj nn rb"],
  "flathead": ["f-l-ae1-t hh-eh-d", "jj"],
  "flatland": ["f-l-ae1-t l-ae-n-d", "nn"],
  "flatly": ["f-l-ae1-t l-iy", "rb"],
  "flatness": ["f-l-ae1-t n-ah-s", "nn"],
  "flatten": ["f-l-ae1 t-ah-n", "vb"],
  "flattened": ["f-l-ae1 t-ah-n-d", "vbn vbd jj"],
  "flatter": ["f-l-ae1 t-er", "vb"],
  "flattered": ["f-l-ae1 t-er-d", "vbn jj vbd"],
  "flattering": ["f-l-ae1 t-er ih-ng", "jj"],
  "flattery": ["f-l-ae1 t-er iy", "nn"],
  "flattish": ["f-l-ae1 t-ih-sh", "jj"],
  "flatulent": ["f-l-ae1 ch-ah l-ah-n-t", "jj"],
  "flatware": ["f-l-ae1-t w-eh-r", "nn"],
  "flaunt": ["f-l-ao1-n-t", "vb vbp"],
  "flavor": ["f-l-ey1 v-er", "nn vb"],
  "flavored": ["f-l-ey1 v-er-d", "jj vbn"],
  "flavorful": ["f-l-ey1 v-er f-ah-l", "jj"],
  "flaw": ["f-l-ao1", "nn vb"],
  "flawed": ["f-l-ao1-d", "jj vbn"],
  "flawless": ["f-l-ao1 l-ah-s", "jj"],
  "flax": ["f-l-ae1-k-s", "nn"],
  "flaxseed": ["f-l-ae1-k s-iy-d", "nn"],
  "flea": ["f-l-iy1", "nn"],
  "fleck": ["f-l-eh1-k", "nn"],
  "fled": ["f-l-eh1-d", "vbd vbn"],
  "fledge": ["f-l-eh1-jh", "vb"],
  "fledgling": ["f-l-eh1-jh l-ih-ng", "nn jj"],
  "flee": ["f-l-iy1", "vb"],
  "fleece": ["f-l-iy1-s", "nn vb"],
  "fleet": ["f-l-iy1-t", "nn jj"],
  "fleeting": ["f-l-iy1 t-ih-ng", "jj"],
  "flesh": ["f-l-eh1-sh", "nn vb"],
  "fleshy": ["f-l-eh1 sh-iy", "jj"],
  "flew": ["f-l-uw1", "vbd"],
  "flex": ["f-l-eh1-k-s", "nn jj vb"],
  "flexibility": ["f-l-eh-k s-ah b-ih1 l-ah t-iy", "nn"],
  "flexible": ["f-l-eh1-k s-ah b-ah-l", "jj"],
  "flextime": ["f-l-eh1-k s-t-ay-m", "nn"],
  "flick": ["f-l-ih1-k", "nn vb"],
  "flicker": ["f-l-ih1 k-er", "nn vb"],
  "flied": ["f-l-ay1-d", "vbd"],
  "flier": ["f-l-ay1 er", "nn"],
  "flight": ["f-l-ay1-t", "nn"],
  "flighty": ["f-l-ay1 t-iy", "jj"],
  "flimsy": ["f-l-ih1-m z-iy", "jj"],
  "flinch": ["f-l-ih1-n-ch", "vb"],
  "fling": ["f-l-ih1-ng", "nn vb"],
  "flint": ["f-l-ih1-n-t", "nn"],
  "flinty": ["f-l-ih1-n t-iy", "jj"],
  "flip": ["f-l-ih1-p", "jj vb"],
  "flippant": ["f-l-ih1 p-ah-n-t", "jj"],
  "flipper": ["f-l-ih1 p-er", "nn"],
  "flipping": ["f-l-ih1 p-ih-ng", "vbg jj rb"],
  "flirt": ["f-l-er1-t", "vb vbp"],
  "flirtation": ["f-l-er t-ey1 sh-ah-n", "nn"],
  "flirtatious": ["f-l-er t-ey1 sh-ah-s", "jj"],
  "flit": ["f-l-ih1-t", "vb vbp"],
  "float": ["f-l-ow1-t", "vb nn vbp"],
  "floater": ["f-l-ow1 t-er", "nn"],
  "floating": ["f-l-ow1 t-ih-ng", "vbg jj"],
  "flock": ["f-l-aa1-k", "nn vb vbp"],
  "flood": ["f-l-ah1-d", "nn vb vbp"],
  "floor": ["f-l-ao1-r", "nn"],
  "floorboard": ["f-l-ao1-r b-ao-r-d", "nn"],
  "flooring": ["f-l-ao1 r-ih-ng", "nn"],
  "flop": ["f-l-aa1-p", "nn vbp vb"],
  "floppy": ["f-l-aa1 p-iy", "jj"],
  "flora": ["f-l-ao1 r-ah", "nn"],
  "floral": ["f-l-ao1 r-ah-l", "jj"],
  "florid": ["f-l-ao1 r-ah-d", "jj"],
  "florist": ["f-l-aa1 r-ah-s-t", "nn"],
  "flotation": ["f-l-ow t-ey1 sh-ah-n", "nn"],
  "flotilla": ["f-l-ow t-ih1 l-ah", "nn"],
  "flounder": ["f-l-aw1-n d-er", "vb"],
  "floundering": ["f-l-aw1-n d-er ih-ng", "vbg jj"],
  "flour": ["f-l-aw1 er", "nn"],
  "flourish": ["f-l-er1 ih-sh", "vb nn vbp"],
  "flourishing": ["f-l-er1 ih sh-ih-ng", "vbg jj"],
  "flout": ["f-l-aw1-t", "vb"],
  "flow": ["f-l-ow1", "nn vbp vb"],
  "flower": ["f-l-aw1 er", "nn vb"],
  "flowered": ["f-l-aw1 er-d", "jj vbd vbn"],
  "flowerpot": ["f-l-aw1 er p-aa-t", "nn"],
  "flowing": ["f-l-ow1 ih-ng", "vbg jj"],
  "flown": ["f-l-ow1-n", "vbn"],
  "flu": ["f-l-uw1", "nn"],
  "fluctuate": ["f-l-ah1-k ch-ah-w ey-t", "vbp vb"],
  "fluctuation": ["f-l-ah-k ch-uw ey1 sh-ah-n", "nn"],
  "flue": ["f-l-uw1", "nn"],
  "fluency": ["f-l-uw1 ah-n s-iy", "nn"],
  "fluent": ["f-l-uw1 ah-n-t", "jj"],
  "fluff": ["f-l-ah1-f", "nn"],
  "fluffy": ["f-l-ah1 f-iy", "jj"],
  "fluid": ["f-l-uw1 ah-d", "nn jj"],
  "fluidity": ["f-l-uw ih1 d-ah t-iy", "nn"],
  "fluke": ["f-l-uw1-k", "nn"],
  "flung": ["f-l-ah1-ng", "vbd vbn"],
  "flunk": ["f-l-ah1-ng-k", "vb"],
  "fluorescent": ["f-l-uh r-eh1 s-ah-n-t", "jj"],
  "fluoride": ["f-l-uh1 r-ay-d", "nn"],
  "flurried": ["f-l-er1 iy-d", "vbd"],
  "flurry": ["f-l-er1 iy", "nn"],
  "flush": ["f-l-ah1-sh", "jj nn rb vb vbp"],
  "fluster": ["f-l-ah1-s-t-er", "vb"],
  "flute": ["f-l-uw1-t", "nn"],
  "flutist": ["f-l-uw1 t-ih-s-t", "nn"],
  "flutter": ["f-l-ah1 t-er", "nn vb"],
  "flux": ["f-l-ah1-k-s", "nn"],
  "fly": ["f-l-ay1", "vb nn vbp"],
  "flyer": ["f-l-ay1 er", "nn"],
  "flying": ["f-l-ay1 ih-ng", "vbg jj"],
  "foal": ["f-ow1-l", "nn"],
  "foam": ["f-ow1-m", "nn vb vbp"],
  "foamy": ["f-ow1 m-iy", "jj"],
  "focal": ["f-ow1 k-ah-l", "jj"],
  "focus": ["f-ow1 k-ah-s", "nn vbp vb"],
  "focused": ["f-ow1 k-ah-s-t", "vbn jj vbd"],
  "focussed": ["f-ow1 k-ah-s-t", "vbn vbd"],
  "fodder": ["f-aa1 d-er", "nn"],
  "foe": ["f-ow1", "nn"],
  "fog": ["f-aa1-g", "nn vb"],
  "foggy": ["f-aa1 g-iy", "jj"],
  "fogy": ["f-ow1 g-iy", "nn"],
  "foible": ["f-oy1 b-ah-l", "nn"],
  "foil": ["f-oy1-l", "nn vb"],
  "foiled": ["f-oy1-l-d", "vbn jj vbd"],
  "foist": ["f-oy1-s-t", "vb"],
  "fold": ["f-ow1-l-d", "vb nn vbp"],
  "folded": ["f-ow1-l d-ah-d", "vbn vbd jj"],
  "folder": ["f-ow1-l d-er", "nn"],
  "folding": ["f-ow1-l d-ih-ng", "vbg jj nn"],
  "foliage": ["f-ow1 l-ih-jh", "nn"],
  "folk": ["f-ow1-k", "nn"],
  "folkish": ["f-ow1 k-ih-sh", "jj"],
  "folklore": ["f-ow1-k l-ao-r", "nn"],
  "folksy": ["f-ow1-k s-iy", "jj"],
  "follow": ["f-aa1 l-ow", "vb vbp"],
  "followed": ["f-aa1 l-ow-d", "vbd vbn jj"],
  "follower": ["f-aa1 l-ow er", "nn"],
  "following": ["f-aa1 l-ow ih-ng", "vbg jj nn"],
  "followup": ["f-aa1 l-ow ah-p", "jj"],
  "folly": ["f-aa1 l-iy", "nn"],
  "foment": ["f-ow1 m-eh-n-t", "vb"],
  "fond": ["f-aa1-n-d", "jj nn vb"],
  "fonder": ["f-aa1-n d-er", "jjr"],
  "fondest": ["f-aa1-n d-ah-s-t", "jjs"],
  "fondly": ["f-aa1-n-d l-iy", "rb"],
  "fondness": ["f-aa1-n-d n-ah-s", "nn"],
  "font": ["f-aa1-n-t", "nn"],
  "food": ["f-uw1-d", "nn"],
  "foodservice": ["f-uw1-d s-er1 v-ih-s", "nn"],
  "foodstuff": ["f-uw1-d s-t-ah-f", "nn"],
  "fool": ["f-uw1-l", "nn jj vb"],
  "foolhardy": ["f-uw1-l hh-aa-r d-iy", "jj"],
  "foolish": ["f-uw1 l-ih-sh", "jj"],
  "foolishly": ["f-uw1 l-ih-sh l-iy", "rb"],
  "foolishness": ["f-uw1 l-ih-sh n-ah-s", "nn"],
  "foolproof": ["f-uw1-l p-r-uw-f", "jj"],
  "foot": ["f-uh1-t", "nn"],
  "footage": ["f-uh1 t-ih-jh", "nn"],
  "football": ["f-uh1-t b-ao-l", "nn"],
  "footfall": ["f-uh1-t f-ao-l", "nn"],
  "foothill": ["f-uh1-t hh-ih-l", "nn"],
  "foothold": ["f-uh1-t hh-ow-l-d", "nn"],
  "footing": ["f-uh1 t-ih-ng", "nn"],
  "footlight": ["f-uh1-t l-ay-t", "nn"],
  "footloose": ["f-uh1-t l-uw-s", "jj"],
  "footman": ["f-uh1-t m-ah-n", "nn"],
  "footnote": ["f-uh1-t n-ow-t", "nn vb"],
  "footpath": ["f-uh1-t p-ae-th", "nn"],
  "footprint": ["f-uh1-t p-r-ih-n-t", "nn"],
  "footstep": ["f-uh1-t s-t-eh-p", "nn"],
  "footwear": ["f-uh1-t w-eh-r", "nn"],
  "footwork": ["f-uh1-t w-er-k", "nn"],
  "for": ["f-ao1-r", "in cc jj rb rp"],
  "forage": ["f-ao1 r-ih-jh", "nn vb"],
  "foray": ["f-ao1 r-ey", "nn"],
  "forbade": ["f-er b-ey1-d", "vbd"],
  "forbearance": ["f-ao-r b-eh1 r-ah-n-s", "nn"],
  "forbid": ["f-er b-ih1-d", "vb vbp uh"],
  "forbidden": ["f-ao1-r b-ih d-ah-n", "vbn jj"],
  "forbidding": ["f-er b-ih1 d-ih-ng", "vbg jj"],
  "force": ["f-ao1-r-s", "nn vb vbp"],
  "forced": ["f-ao1-r-s-t", "vbn jj vbd"],
  "forceful": ["f-ao1-r-s f-ah-l", "jj"],
  "forcefully": ["f-ao1-r-s f-ah l-iy", "rb"],
  "forcefulness": ["f-ao1-r-s f-ah-l n-ah-s", "nn"],
  "forcibly": ["f-ao1-r s-ah b-l-iy", "rb"],
  "ford": ["f-ao1-r-d", "nn"],
  "fore": ["f-ao1-r", "nn rb"],
  "forearm": ["f-ao r-aa1-r-m", "nn"],
  "forebear": ["f-ao1-r b-eh-r", "nn"],
  "foreboding": ["f-ao-r b-ow1 d-ih-ng", "nn jj"],
  "forecast": ["f-ao1-r k-ae-s-t", "nn vbd vbn vbp vb"],
  "forecaster": ["f-ao1-r k-ae s-t-er", "nn"],
  "forecasting": ["f-ao1-r k-ae s-t-ih-ng", "nn jj vbg"],
  "foreclose": ["f-ao-r k-l-ow1-z", "vb"],
  "foreclosed": ["f-ao-r k-l-ow1-z-d", "vbn jj vbd"],
  "foreclosure": ["f-ao-r k-l-ow1 zh-er", "nn"],
  "forefather": ["f-ao1-r f-aa dh-er", "nn"],
  "forefinger": ["f-ao1-r f-ih-ng g-er", "nn"],
  "forefront": ["f-ao1-r f-r-ah-n-t", "nn"],
  "forego": ["f-ao-r g-ow1", "vb vbp"],
  "foregoing": ["f-ao-r g-ow1 ih-ng", "nn jj vbg"],
  "foregone": ["f-ao1-r g-ao1-n", "jj vbn"],
  "foreground": ["f-ao1-r g-r-aw-n-d", "nn"],
  "forehead": ["f-ao1 r-hh-eh-d", "nn"],
  "foreign": ["f-ao1 r-ah-n", "jj"],
  "foreigner": ["f-ao1 r-ah n-er", "nn"],
  "foreman": ["f-ao1-r m-ah-n", "nn"],
  "foremost": ["f-ao1-r m-ow-s-t", "jj rb"],
  "forensic": ["f-er eh1-n s-ih-k", "jj"],
  "forerunner": ["f-ao1 r-ah n-er", "nn"],
  "foresaw": ["f-ao-r s-ao1", "vbd"],
  "foresee": ["f-ao-r s-iy1", "vbp vb"],
  "foreseeable": ["f-ao-r s-iy1 ah b-ah-l", "jj"],
  "foreseen": ["f-ao-r s-iy1-n", "vbn"],
  "foreshadow": ["f-ao-r sh-ae1 d-ow", "vb vbp"],
  "foresight": ["f-ao1-r s-ay-t", "nn"],
  "forest": ["f-ao1 r-ah-s-t", "nn"],
  "forestall": ["f-ao-r s-t-ao1-l", "vb"],
  "forestry": ["f-ao1 r-ah s-t-r-iy", "nn"],
  "foretell": ["f-ao-r t-eh1-l", "vb"],
  "forethought": ["f-ao1-r th-ao-t", "nn"],
  "forever": ["f-er eh1 v-er", "rb"],
  "foreword": ["f-ao1-r w-er-d", "nn"],
  "forfeit": ["f-ao1-r f-ih-t", "vb nn"],
  "forfeitable": ["f-ao1-r f-ah t-ah b-ah-l", "jj"],
  "forfeiture": ["f-ao1-r f-ah ch-er", "nn"],
  "forgave": ["f-er g-ey1-v", "vbd"],
  "forge": ["f-ao1-r-jh", "vb vbp nn"],
  "forged": ["f-ao1-r-jh-d", "vbn jj vbd"],
  "forger": ["f-ao1-r jh-er", "nn"],
  "forgery": ["f-ao1-r jh-er iy", "nn"],
  "forget": ["f-er g-eh1-t", "vb vbp"],
  "forgetful": ["f-ao-r g-eh1-t f-ah-l", "jj"],
  "forgettable": ["f-ao-r g-eh1 t-ah b-ah-l", "jj"],
  "forgive": ["f-er g-ih1-v", "vb vbp"],
  "forgiven": ["f-er g-ih1 v-ah-n", "vbn"],
  "forgiveness": ["f-er g-ih1-v n-ah-s", "nn"],
  "forgiving": ["f-er g-ih1 v-ih-ng", "vbg jj"],
  "forgo": ["f-ao-r g-ow1", "vb vbp"],
  "forgone": ["f-ao-r g-aa1-n", "jj"],
  "forgot": ["f-er g-aa1-t", "vbd vbn"],
  "forgotten": ["f-er g-aa1 t-ah-n", "vbn jj"],
  "forint": ["f-ao1 r-ih-n-t", "nn"],
  "fork": ["f-ao1-r-k", "nn vb"],
  "forked": ["f-ao1-r-k-t", "jj vbd vbn"],
  "forklift": ["f-ao1-r-k l-ih-f-t", "nn"],
  "forlorn": ["f-er l-ao1-r-n", "jj"],
  "form": ["f-ao1-r-m", "nn vbp jj vb"],
  "formal": ["f-ao1-r m-ah-l", "jj"],
  "formaldehyde": ["f-ao-r m-ae1-l d-ah hh-ay-d", "nn"],
  "formalism": ["f-ao1-r m-ah l-ih z-ah-m", "nn"],
  "formality": ["f-ao-r m-ae1 l-ah t-iy", "nn"],
  "formalize": ["f-ao1-r m-ah l-ay-z", "vb"],
  "formalized": ["f-ao1-r m-ah l-ay-z-d", "jj vbn"],
  "formally": ["f-ao1-r m-ah l-iy", "rb"],
  "format": ["f-ao1-r m-ae-t", "nn"],
  "formation": ["f-ao-r m-ey1 sh-ah-n", "nn"],
  "formative": ["f-ao1-r m-ah t-ih-v", "jj nn"],
  "formed": ["f-ao1-r-m-d", "vbn vbd jj"],
  "former": ["f-ao1-r m-er", "jj nn"],
  "formerly": ["f-ao1-r m-er l-iy", "rb"],
  "formidable": ["f-ao1-r m-ah d-ah b-ah-l", "jj"],
  "formidably": ["f-ao1-r m-ah d-ah b-l-iy", "rb"],
  "formula": ["f-ao1-r m-y-ah l-ah", "nn"],
  "formulaic": ["f-ao-r m-y-ah l-ey1 ih-k", "jj"],
  "formulate": ["f-ao1-r m-y-ah l-ey-t", "vb"],
  "formulation": ["f-ao-r m-y-ah l-ey1 sh-ah-n", "nn"],
  "forsake": ["f-ao-r s-ey1-k", "vb"],
  "forsaken": ["f-ao-r s-ey1 k-ah-n", "vbn"],
  "forseeable": ["f-ao-r s-iy1 ah b-ah-l", "jj"],
  "fort": ["f-ao1-r-t", "nn"],
  "forth": ["f-ao1-r-th", "rb rp"],
  "forthcoming": ["f-ao1-r-th k-ah1 m-ih-ng", "jj vbg"],
  "forthright": ["f-ao1-r-th r-ay1-t", "jj"],
  "forthrightly": ["f-ao1-r-th r-ay1-t l-iy", "rb"],
  "forthrightness": ["f-ao1-r-th r-ay1-t n-ah-s", "nn"],
  "forthwith": ["f-ao1-r-th w-ih1-th", "rb"],
  "fortification": ["f-ao-r t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "fortified": ["f-ao1-r t-ah f-ay-d", "vbn vbd jj"],
  "fortify": ["f-ao1-r t-ih f-ay", "vb"],
  "fortitude": ["f-ao1-r t-ih t-uw-d", "nn"],
  "fortnight": ["f-ao1-r-t n-ay-t", "nn"],
  "fortress": ["f-ao1-r t-r-ah-s", "nn"],
  "fortuitous": ["f-ao-r t-uw1 ih t-ah-s", "jj"],
  "fortunate": ["f-ao1-r ch-ah n-ah-t", "jj"],
  "fortunately": ["f-ao1-r ch-ah n-ah-t l-iy", "rb"],
  "fortune": ["f-ao1-r ch-ah-n", "nn"],
  "forum": ["f-ao1 r-ah-m", "nn"],
  "forward": ["f-ao1-r w-er-d", "rb jj nn vb"],
  "forwarder": ["f-ao1-r w-er d-er", "nn"],
  "forwards": ["f-ao1-r w-er-d-z", "rb"],
  "fossil": ["f-aa1 s-ah-l", "jj nn"],
  "fossilized": ["f-aa1 s-ah l-ay-z-d", "jj"],
  "foster": ["f-aa1 s-t-er", "vb jj"],
  "fought": ["f-ao1-t", "vbd vbn"],
  "foul": ["f-aw1-l", "jj rb vb uh"],
  "fouled": ["f-aw1-l-d", "vbd jj vbn"],
  "found": ["f-aw1-n-d", "vbd vbn"],
  "foundation": ["f-aw-n d-ey1 sh-ah-n", "nn"],
  "founded": ["f-aw1-n d-ah-d", "vbn vbd"],
  "founder": ["f-aw1-n d-er", "nn vb"],
  "foundering": ["f-aw1-n d-er ih-ng", "vbg jj"],
  "foundling": ["f-aw1-n-d l-ih-ng", "nn"],
  "foundry": ["f-aw1-n d-r-iy", "nn"],
  "fountain": ["f-aw1-n t-ah-n", "nn"],
  "four": ["f-ao1-r", "cd"],
  "fourfold": ["f-ao1-r f-ow1-l-d", "rb jj"],
  "foursome": ["f-ao1-r s-ah-m", "nn"],
  "fourth": ["f-ao1-r-th", "jj rb"],
  "fowl": ["f-aw1-l", "nn"],
  "fox": ["f-aa1-k-s", "nn"],
  "foxhole": ["f-aa1-k-s hh-ow-l", "nn"],
  "foxtail": ["f-aa1-k-s t-ey-l", "nn"],
  "foyer": ["f-oy1 er", "nn"],
  "fracas": ["f-r-ey1 k-ah-s", "nn"],
  "fraction": ["f-r-ae1-k sh-ah-n", "nn"],
  "fractional": ["f-r-ae1-k sh-ah n-ah-l", "jj"],
  "fractionally": ["f-r-ae1-k sh-ah-n ah-l iy", "rb"],
  "fractious": ["f-r-ae1-k sh-ah-s", "jj"],
  "fracture": ["f-r-ae1-k ch-er", "nn vb"],
  "fractured": ["f-r-ae1-k ch-er-d", "vbn jj vbd"],
  "fragile": ["f-r-ae1 jh-ah-l", "jj"],
  "fragility": ["f-r-ah jh-ih1 l-ah t-iy", "nn"],
  "fragment": ["f-r-ae1-g m-ah-n-t", "nn vb"],
  "fragmentary": ["f-r-ae1-g m-ah-n t-eh r-iy", "jj rb"],
  "fragmentation": ["f-r-ae-g m-ah-n t-ey1 sh-ah-n", "nn"],
  "fragmented": ["f-r-ae1-g m-ah-n t-ih-d", "jj vbn"],
  "fragrance": ["f-r-ey1 g-r-ah-n-s", "nn"],
  "fragrant": ["f-r-ey1 g-r-ah-n-t", "jj"],
  "frail": ["f-r-ey1-l", "jj"],
  "frailty": ["f-r-ey1-l t-iy", "nn"],
  "frame": ["f-r-ey1-m", "nn vbp vb"],
  "framed": ["f-r-ey1-m-d", "vbn vbd jj"],
  "framer": ["f-r-ey1 m-er", "nn"],
  "framework": ["f-r-ey1-m w-er-k", "nn"],
  "franc": ["f-r-ae1-ng-k", "nn"],
  "franchise": ["f-r-ae1-n ch-ay-z", "nn vb"],
  "franchised": ["f-r-ae1-n ch-ay-z-d", "vbn jj"],
  "franchisee": ["f-r-ae1-n ch-ay z-iy1", "nn"],
  "franchiser": ["f-r-ae1-n ch-ay z-er", "nn"],
  "frank": ["f-r-ae1-ng-k", "jj nn vb"],
  "franked": ["f-r-ae1-ng-k-t", "jj vbn"],
  "frankfurter": ["f-r-ae1-ng-k f-er t-er", "nn"],
  "frankly": ["f-r-ae1-ng k-l-iy", "rb"],
  "frankness": ["f-r-ae1-ng-k n-ah-s", "nn"],
  "frantic": ["f-r-ae1-n t-ih-k", "jj"],
  "frantically": ["f-r-ae1-n t-ah k-ah l-iy", "rb"],
  "fraternity": ["f-r-ah t-er1 n-ah t-iy", "nn"],
  "frau": ["f-r-aw1", "nn"],
  "fraud": ["f-r-ao1-d", "nn"],
  "fraudulent": ["f-r-ao1 jh-ah l-ah-n-t", "jj"],
  "fraudulently": ["f-r-ao1 d-uw l-ah-n-t l-iy", "rb"],
  "fraught": ["f-r-ao1-t", "jj"],
  "fray": ["f-r-ey1", "nn vb"],
  "frayed": ["f-r-ey1-d", "jj vbn"],
  "frazzle": ["f-r-ae1-z-ah-l", "vb"],
  "freak": ["f-r-iy1-k", "nn vb vbp"],
  "freckled": ["f-r-eh1 k-ah-l-d", "jj"],
  "free": ["f-r-iy1", "jj rb vb vbp"],
  "freebie": ["f-r-iy1 b-iy", "nn"],
  "freed": ["f-r-iy1-d", "jj"],
  "freedom": ["f-r-iy1 d-ah-m", "nn"],
  "freefall": ["f-r-iy1 f-ao-l", "nn"],
  "freehand": ["f-r-iy1 hh-ae-n-d", "jj rb"],
  "freeholder": ["f-r-iy1 hh-ow-l d-er", "nn"],
  "freelance": ["f-r-iy1 l-ae-n-s", "jj"],
  "freely": ["f-r-iy1 l-iy", "rb"],
  "freeman": ["f-r-iy1 m-ah-n", "nn"],
  "freer": ["f-r-iy1 er", "jjr"],
  "freest": ["f-r-iy1 ih-s-t", "jjs"],
  "freethinker": ["f-r-iy1 th-ih1-ng k-er", "nn"],
  "freeway": ["f-r-iy1 w-ey", "nn"],
  "freewheeling": ["f-r-iy1 w-iy l-ih-ng", "jj"],
  "freeze": ["f-r-iy1-z", "nn vb vbp"],
  "freezer": ["f-r-iy1 z-er", "nn"],
  "freezing": ["f-r-iy1 z-ih-ng", "vbg jj nn"],
  "freight": ["f-r-ey1-t", "nn vb"],
  "freighter": ["f-r-ey1 t-er", "nn"],
  "french": ["f-r-eh1-n-ch", "jj"],
  "frenetic": ["f-r-ah n-eh1 t-ih-k", "jj"],
  "frenzied": ["f-r-eh1-n z-iy-d", "jj"],
  "frenzy": ["f-r-eh1-n z-iy", "nn"],
  "frequency": ["f-r-iy1 k-w-ah-n s-iy", "nn"],
  "frequent": ["f-r-iy1 k-w-ah-n-t", "jj vbp vb"],
  "frequently": ["f-r-iy1 k-w-ah-n-t l-iy", "rb"],
  "fresco": ["f-r-eh1-s k-ow", "nn"],
  "frescoed": ["f-r-eh1-s k-ow-d", "jj"],
  "fresh": ["f-r-eh1-sh", "jj rb"],
  "fresher": ["f-r-eh1 sh-er", "jjr"],
  "freshly": ["f-r-eh1-sh l-iy", "rb"],
  "freshman": ["f-r-eh1-sh m-ah-n", "nn"],
  "freshness": ["f-r-eh1-sh n-ah-s", "nn"],
  "fret": ["f-r-eh1-t", "vbp nn vb"],
  "friar": ["f-r-ay1 er", "nn"],
  "friction": ["f-r-ih1-k sh-ah-n", "nn"],
  "frictionless": ["f-r-ih1-k sh-ah-n l-ah-s", "jj"],
  "fridge": ["f-r-ih1-jh", "nn"],
  "fried": ["f-r-ay1-d", "jj vbn"],
  "friend": ["f-r-eh1-n-d", "nn"],
  "friendlier": ["f-r-eh1-n-d l-iy er", "jjr rbr"],
  "friendliness": ["f-r-eh1-n-d l-iy n-ih-s", "nn"],
  "friendly": ["f-r-eh1-n-d l-iy", "jj"],
  "friendship": ["f-r-eh1-n-d sh-ih-p", "nn"],
  "frieze": ["f-r-iy1-z", "nn"],
  "frigate": ["f-r-ih1 g-ah-t", "nn"],
  "fright": ["f-r-ay1-t", "nn"],
  "frighten": ["f-r-ay1 t-ah-n", "vb vbp"],
  "frightened": ["f-r-ay1 t-ah-n-d", "vbn jj vbd"],
  "frightening": ["f-r-ay1 t-ah-n ih-ng", "jj vbg"],
  "frighteningly": ["f-r-ay1 t-ah-n ih-ng l-iy", "rb"],
  "frightful": ["f-r-ay1-t f-ah-l", "jj"],
  "frightfully": ["f-r-ay1-t f-ah l-iy", "rb"],
  "frigid": ["f-r-ih1 jh-ah-d", "jj"],
  "frill": ["f-r-ih1-l", "nn"],
  "frilly": ["f-r-ih1 l-iy", "jj"],
  "fringe": ["f-r-ih1-n-jh", "nn jj"],
  "frisky": ["f-r-ih1-s k-iy", "jj"],
  "fritter": ["f-r-ih1-t-er", "vb"],
  "frivolity": ["f-r-ah v-aa1 l-ah t-iy", "nn"],
  "frivolous": ["f-r-ih1 v-ah l-ah-s", "jj"],
  "frock": ["f-r-aa1-k", "nn"],
  "frog": ["f-r-aa1-g", "nn"],
  "frolic": ["f-r-aa1 l-ih-k", "nn vb"],
  "from": ["f-r-ah1-m", "in rb rp"],
  "frond": ["f-r-aa1-n-d", "nn"],
  "front": ["f-r-ah1-n-t", "nn jj vb"],
  "frontage": ["f-r-ah1-n t-ih-jh", "nn"],
  "frontal": ["f-r-ah1-n t-ah-l", "jj"],
  "frontier": ["f-r-ah-n t-ih1-r", "nn"],
  "frontrunner": ["f-r-ah1-n t-r-ah n-er", "nn"],
  "frost": ["f-r-ao1-s-t", "nn vb"],
  "frostbite": ["f-r-ao1-s-t b-ay-t", "nn"],
  "frosting": ["f-r-ao1 s-t-ih-ng", "nn"],
  "frosty": ["f-r-ao1 s-t-iy", "jj"],
  "froth": ["f-r-ao1-th", "nn vb"],
  "frothy": ["f-r-ao1 th-iy", "jj"],
  "frown": ["f-r-aw1-n", "vb vbp"],
  "frowningly": ["f-r-aw1 n-ih-ng l-iy", "rb"],
  "froze": ["f-r-ow1-z", "vbd vbn"],
  "frozen": ["f-r-ow1 z-ah-n", "vbn jj"],
  "fructose": ["f-r-ah1-k t-ow-s", "nn"],
  "frugal": ["f-r-uw1 g-ah-l", "jj"],
  "frugality": ["f-r-uw g-ae1 l-ah t-iy", "nn"],
  "frugally": ["f-r-uw1 g-ah l-iy", "rb"],
  "fruit": ["f-r-uw1-t", "nn"],
  "fruitful": ["f-r-uw1-t f-ah-l", "jj"],
  "fruition": ["f-r-uw ih1 sh-ah-n", "nn"],
  "fruitless": ["f-r-uw1-t l-ah-s", "jj"],
  "fruitlessly": ["f-r-uw1-t l-ah-s l-iy", "rb"],
  "fruity": ["f-r-uw1 t-iy", "jj"],
  "frumpy": ["f-r-ah1-m p-iy", "jj"],
  "frustrate": ["f-r-ah1 s-t-r-ey-t", "vb"],
  "frustrated": ["f-r-ah1 s-t-r-ey t-ah-d", "vbn jj vbd"],
  "frustrating": ["f-r-ah1 s-t-r-ey t-ih-ng", "jj vbg"],
  "frustration": ["f-r-ah-s t-r-ey1 sh-ah-n", "nn"],
  "fry": ["f-r-ay1", "nn vbp vb"],
  "fryer": ["f-r-ay1 er", "nn"],
  "fudge": ["f-ah1-jh", "vb vbp nn"],
  "fudging": ["f-ah1 jh-ih-ng", "nn"],
  "fuel": ["f-y-uw1 ah-l", "nn vbp vb"],
  "fugitive": ["f-y-uw1 jh-ah t-ih-v", "jj nn"],
  "fulcrum": ["f-uh1-l k-r-ah-m", "nn"],
  "fulfill": ["f-uh-l f-ih1-l", "vb vbp"],
  "fulfillment": ["f-uh-l f-ih1-l m-ah-n-t", "nn"],
  "full": ["f-uh1-l", "jj rb"],
  "fullback": ["f-uh1-l b-ae-k", "nn"],
  "fuller": ["f-uh1 l-er", "jjr"],
  "fullest": ["f-uh1 l-ah-s-t", "jjs"],
  "fullness": ["f-uh1-l n-ah-s", "nn"],
  "fully": ["f-uh1 l-iy", "rb"],
  "fulminate": ["f-uh1-l m-ah n-ey-t", "vb"],
  "fumble": ["f-ah1-m b-ah-l", "nn vb"],
  "fumbling": ["f-ah1-m b-ah-l ih-ng", "vbg jj"],
  "fume": ["f-y-uw1-m", "vb"],
  "fun": ["f-ah1-n", "nn jj"],
  "function": ["f-ah1-ng-k sh-ah-n", "nn vb vbp"],
  "functional": ["f-ah1-ng-k sh-ah n-ah-l", "jj nn"],
  "functionally": ["f-ah1-ng-k sh-ah-n ah-l iy", "rb"],
  "functionary": ["f-ah1-ng-k sh-ah-n eh r-iy", "nn"],
  "fund": ["f-ah1-n-d", "nn vbp vb"],
  "fundamental": ["f-ah-n d-ah m-eh1-n t-ah-l", "jj"],
  "fundamentalism": ["f-ah-n d-ah m-eh1-n t-ah l-ih z-ah-m", "nn"],
  "fundamentalist": ["f-ah-n d-ah m-eh1-n t-ah l-ih-s-t", "jj nn"],
  "fundamentally": ["f-ah-n d-ah m-eh1-n t-ah l-iy", "rb"],
  "funded": ["f-ah1-n d-ah-d", "vbn vbd jj"],
  "funding": ["f-ah1-n d-ih-ng", "vbg jj"],
  "fundraiser": ["f-ah1-n d-r-ey z-er", "nn"],
  "funeral": ["f-y-uw1 n-er ah-l", "nn jj"],
  "fungal": ["f-ah1-ng g-ah-l", "jj"],
  "fungible": ["f-ah1-n jh-ih b-ah-l", "jj"],
  "fungicide": ["f-ah1-n jh-ah s-ay-d", "nn"],
  "fungus": ["f-ah1-ng g-ah-s", "nn"],
  "funk": ["f-ah1-ng-k", "nn"],
  "funky": ["f-ah1-ng k-iy", "jj"],
  "funnel": ["f-ah1 n-ah-l", "vb nn"],
  "funnier": ["f-ah1 n-iy er", "jjr"],
  "funniest": ["f-ah1 n-iy ah-s-t", "jjs"],
  "funny": ["f-ah1 n-iy", "jj"],
  "fur": ["f-er1", "nn"],
  "furbishing": ["f-er1 b-ih sh-ih-ng", "nn"],
  "furious": ["f-y-uh1 r-iy ah-s", "jj"],
  "furiouser": ["f-y-uh1 r-iy ah s-er", "rbr"],
  "furiously": ["f-y-uh1 r-iy ah-s l-iy", "rb"],
  "furlough": ["f-er1 l-ow", "nn vb"],
  "furnace": ["f-er1 n-ah-s", "nn"],
  "furnish": ["f-er1 n-ih-sh", "vb vbp"],
  "furnished": ["f-er1 n-ih-sh-t", "vbn vbd jj"],
  "furnishing": ["f-er1 n-ih sh-ih-ng", "nn vbg"],
  "furniture": ["f-er1 n-ih ch-er", "nn"],
  "furor": ["f-y-uh1 r-ao-r", "nn"],
  "furrier": ["f-er1 iy er", "nn"],
  "furrow": ["f-er1 ow", "nn"],
  "furry": ["f-er1 iy", "jj"],
  "further": ["f-er1 dh-er", "jj vb"],
  "furthermore": ["f-er1 dh-er m-ao-r", "rb"],
  "furthest": ["f-er1 th-ah-s-t", "jjs rbs"],
  "furtive": ["f-er1 t-ih-v", "jj"],
  "furtively": ["f-er1 t-ih-v l-iy", "rb"],
  "fury": ["f-y-uh1 r-iy", "nn"],
  "fuse": ["f-y-uw1-z", "nn vb"],
  "fuselage": ["f-y-uw1 s-ah l-aa-jh", "nn"],
  "fusillade": ["f-y-uw1 s-ih l-ey-d", "nn"],
  "fusion": ["f-y-uw1 zh-ah-n", "nn"],
  "fuss": ["f-ah1-s", "nn vb"],
  "fussy": ["f-ah1 s-iy", "jj"],
  "futile": ["f-y-uw1 t-ah-l", "jj"],
  "futility": ["f-y-uw t-ih1 l-ah t-iy", "nn"],
  "future": ["f-y-uw1 ch-er", "nn jj"],
  "futurist": ["f-y-uw1 ch-er ih-s-t", "nn"],
  "futuristic": ["f-y-uw ch-er ih1 s-t-ih-k", "jj"],
  "fuzz": ["f-ah1-z", "nn"],
  "fuzzier": ["f-ah1 z-iy er", "jjr"],
  "fuzzy": ["f-ah1 z-iy", "jj"],
  "gabardine": ["g-ae1 b-er d-iy-n", "nn"],
  "gable": ["g-ey1 b-ah-l", "nn"],
  "gadfly": ["g-ae1-d f-l-ay", "nn"],
  "gadget": ["g-ae1 jh-ah-t", "nn"],
  "gadgetry": ["g-ae1 jh-ah t-r-iy", "nn"],
  "gaffe": ["g-ae1-f", "nn"],
  "gag": ["g-ae1-g", "nn"],
  "gage": ["g-ey1-jh", "nn vb"],
  "gagged": ["g-ae1-g-d", "vbn vbd"],
  "gaggle": ["g-ae1 g-ah-l", "nn"],
  "gaily": ["g-ey1 l-iy", "rb"],
  "gain": ["g-ey1-n", "nn vbp vb"],
  "gained": ["g-ey1-n-d", "vbd vbn"],
  "gainer": ["g-ey1 n-er", "nn"],
  "gainful": ["g-ey1-n f-ah-l", "jj"],
  "gait": ["g-ey1-t", "nn"],
  "gal": ["g-ae1-l", "nn"],
  "gala": ["g-ae1 l-ah", "jj nn"],
  "galactic": ["g-ah l-ae1-k t-ih-k", "jj"],
  "galaxy": ["g-ae1 l-ah-k s-iy", "nn"],
  "gale": ["g-ey1-l", "nn"],
  "gall": ["g-ao1-l", "nn vb"],
  "gallant": ["g-ae1 l-ah-n-t", "jj"],
  "gallantry": ["g-ae1 l-ah-n t-r-iy", "nn"],
  "gallbladder": ["g-ao1-l b-l-ae d-er", "nn"],
  "gallery": ["g-ae1 l-er iy", "nn"],
  "galley": ["g-ae1 l-iy", "nn"],
  "galling": ["g-ao1 l-ih-ng", "jj"],
  "gallium": ["g-ae1 l-iy ah-m", "nn"],
  "gallon": ["g-ae1 l-ah-n", "nn"],
  "gallop": ["g-ae1 l-ah-p", "nn vb"],
  "galloping": ["g-ae1 l-ah p-ih-ng", "vbg jj"],
  "gallows": ["g-ae1 l-ow-z", "nn"],
  "gallstone": ["g-ao1-l s-t-ow-n", "nn"],
  "galvanic": ["g-ae-l v-ae1 n-ih-k", "jj"],
  "galvanize": ["g-ae1-l v-ah n-ay-z", "vb"],
  "galvanized": ["g-ae1-l v-ah n-ay-z-d", "jj vbd vbn"],
  "gambit": ["g-ae1-m b-ih-t", "nn"],
  "gamble": ["g-ae1-m b-ah-l", "nn vb"],
  "gambler": ["g-ae1-m b-l-er", "nn"],
  "game": ["g-ey1-m", "nn"],
  "gaming": ["g-ey1 m-ih-ng", "nn"],
  "gamma": ["g-ae1 m-ah", "nn jj"],
  "gamut": ["g-ae1 m-ah-t", "nn"],
  "gander": ["g-ae1-n d-er", "nn"],
  "gang": ["g-ae1-ng", "nn vb"],
  "gangbuster": ["g-ae1-ng b-ah s-t-er", "nn"],
  "gangplank": ["g-ae1-ng p-l-ae-ng-k", "nn"],
  "gangster": ["g-ae1-ng s-t-er", "nn"],
  "gantlet": ["g-ao1-n-t l-ah-t", "nn"],
  "gap": ["g-ae1-p", "nn vb"],
  "gaping": ["g-ey1 p-ih-ng", "vbg jj"],
  "garage": ["g-er aa1-zh", "nn"],
  "garb": ["g-aa1-r-b", "nn vb"],
  "garbage": ["g-aa1-r b-ih-jh", "nn"],
  "garble": ["g-aa1-r-b-ah-l", "vb"],
  "garden": ["g-aa1-r d-ah-n", "nn vb"],
  "gardener": ["g-aa1-r d-ah-n er", "nn"],
  "gardenia": ["g-aa-r d-iy1 n-y-ah", "nn"],
  "gargantuan": ["g-aa-r g-ae1-n ch-uw ah-n", "jj"],
  "garish": ["g-eh1 r-ih-sh", "jj"],
  "garland": ["g-aa1-r l-ah-n-d", "nn"],
  "garlic": ["g-aa1-r l-ih-k", "nn"],
  "garment": ["g-aa1-r m-ah-n-t", "nn"],
  "garner": ["g-aa1-r n-er", "vb vbp"],
  "garnet": ["g-aa1-r n-ah-t", "nn"],
  "garnish": ["g-aa1-r n-ih-sh", "nn"],
  "garrison": ["g-ae1 r-ih s-ah-n", "nn vb"],
  "garrulous": ["g-eh1 r-ah l-ah-s", "jj"],
  "garter": ["g-aa1-r t-er", "nn"],
  "gas": ["g-ae1-s", "nn vb"],
  "gaseous": ["g-ae1 s-iy ah-s", "jj"],
  "gash": ["g-ae1-sh", "nn"],
  "gasket": ["g-ae1-s k-ah-t", "nn"],
  "gasoline": ["g-ae1 s-ah l-iy-n", "nn"],
  "gasp": ["g-ae1-s-p", "nn vb"],
  "gass": ["g-ae1-s", "nn"],
  "gasser": ["g-ae1 s-er", "nn"],
  "gassing": ["g-ae1 s-ih-ng", "nn"],
  "gastric": ["g-ae1 s-t-r-ih-k", "jj"],
  "gastrointestinal": ["g-ae s-t-r-ow ih-n t-eh1 s-t-ah n-ah-l", "jj"],
  "gastronomy": ["g-ae-s t-r-aa1 n-ah m-iy", "nn"],
  "gate": ["g-ey1-t", "nn"],
  "gateway": ["g-ey1-t w-ey", "nn"],
  "gather": ["g-ae1 dh-er", "vb vbp"],
  "gathering": ["g-ae1 dh-er ih-ng", "nn vbg"],
  "gauche": ["g-ow1-sh", "jj"],
  "gaudy": ["g-ao1 d-iy", "jj"],
  "gauge": ["g-ey1-jh", "nn vb"],
  "gaunt": ["g-ao1-n-t", "jj"],
  "gauntlet": ["g-ao1-n-t l-ah-t", "nn"],
  "gauss": ["g-aw1-s", "nn"],
  "gauze": ["g-ao1-z", "nn"],
  "gave": ["g-ey1-v", "vbd"],
  "gawky": ["g-ao1 k-iy", "jj"],
  "gay": ["g-ey1", "jj"],
  "gaze": ["g-ey1-z", "nn vb vbp"],
  "gazelle": ["g-ah z-eh1-l", "nn"],
  "gear": ["g-ih1-r", "nn vb vbp"],
  "gearbox": ["g-ih1-r b-aa-k-s", "nn"],
  "geek": ["g-iy1-k", "nn"],
  "gel": ["jh-eh1-l", "nn vb"],
  "gelatin": ["jh-eh1 l-ah t-ah-n", "nn"],
  "gem": ["jh-eh1-m", "nn"],
  "gemstone": ["jh-eh1-m s-t-ow-n", "nn"],
  "gen": ["jh-eh1 n-er ah-l", "nn"],
  "gendarme": ["zh-aa1-n d-aa-r-m", "nn"],
  "gender": ["jh-eh1-n d-er", "nn vb"],
  "gene": ["jh-iy1-n", "nn"],
  "genera": ["jh-eh1 n-er ah", "nn"],
  "general": ["jh-eh1 n-er ah-l", "jj nn"],
  "generalist": ["jh-eh1 n-er ah l-ih-s-t", "nn"],
  "generality": ["jh-eh n-er ae1 l-ah t-iy", "nn"],
  "generalization": ["jh-eh n-er ah l-ih z-ey1 sh-ah-n", "nn"],
  "generalize": ["jh-eh1 n-er ah l-ay-z", "vb vbp"],
  "generalized": ["jh-eh1 n-er ah l-ay-z-d", "jj vbn"],
  "generally": ["jh-eh1 n-er ah l-iy", "rb"],
  "generalship": ["jh-eh1 n-er ah-l sh-ih-p", "nn"],
  "generate": ["jh-eh1 n-er ey-t", "vb vbp"],
  "generation": ["jh-eh n-er ey1 sh-ah-n", "nn"],
  "generational": ["jh-eh n-er ey1 sh-ah n-ah-l", "jj"],
  "generator": ["jh-eh1 n-er ey t-er", "nn"],
  "generic": ["jh-ah n-eh1 r-ih-k", "jj"],
  "generically": ["jh-ah n-eh1 r-ih-k l-iy", "rb"],
  "generosity": ["jh-eh n-er aa1 s-ah t-iy", "nn"],
  "generous": ["jh-eh1 n-er ah-s", "jj"],
  "generously": ["jh-eh1 n-er ah-s l-iy", "rb"],
  "genesis": ["jh-eh1 n-ah s-ah-s", "nn"],
  "genetic": ["jh-ah n-eh1 t-ih-k", "jj"],
  "genetically": ["jh-ah n-eh1 t-ih-k l-iy", "rb"],
  "geneticist": ["jh-ah n-eh1 t-ah s-ah-s-t", "nn"],
  "genial": ["jh-iy1 n-y-ah-l", "jj"],
  "genie": ["jh-iy1 n-iy", "nn"],
  "genital": ["jh-eh1 n-ah t-ah-l", "jj"],
  "genius": ["jh-iy1 n-y-ah-s", "nn"],
  "genocide": ["jh-eh1 n-ah s-ay-d", "nn"],
  "genome": ["jh-iy1 n-ow-m", "nn"],
  "genre": ["zh-aa1-n r-ah", "nn"],
  "genteel": ["jh-eh-n t-iy1-l", "jj"],
  "gentian": ["jh-eh1-n sh-ah-n", "nn"],
  "gentile": ["jh-eh1-n t-ay-l", "nn jj"],
  "gentility": ["jh-eh-n t-ih1 l-ih t-iy", "nn"],
  "gentle": ["jh-eh1-n t-ah-l", "jj vb"],
  "gentleman": ["jh-eh1-n t-ah-l m-ah-n", "nn"],
  "gentlemanly": ["jh-eh1-n t-ah-l m-ah-n l-iy", "jj"],
  "gentleness": ["jh-eh1-n t-ah-l n-ah-s", "nn"],
  "gentler": ["jh-eh1-n-t l-er", "jjr"],
  "gently": ["jh-eh1-n-t l-iy", "rb"],
  "gentrified": ["jh-eh1-n t-r-ih f-ay-d", "vbn"],
  "gentrify": ["jh-eh1-n-t-r-ih-f-ay", "vb"],
  "gentry": ["jh-eh1-n t-r-iy", "nn"],
  "genuine": ["jh-eh1-n y-uw w-ah-n", "jj"],
  "genuinely": ["jh-eh1-n y-uw w-ah-n l-iy", "rb"],
  "genus": ["jh-iy1 n-ah-s", "nn"],
  "geocentric": ["jh-iy ow s-eh1-n t-r-ih-k", "jj"],
  "geochemistry": ["jh-iy ow k-eh1 m-ah s-t-r-iy", "nn"],
  "geographer": ["jh-iy aa1 g-r-ah f-er", "nn"],
  "geographic": ["jh-iy ah g-r-ae1 f-ih-k", "jj"],
  "geographical": ["jh-iy ah g-r-ae1 f-ih k-ah-l", "jj"],
  "geographically": ["jh-iy ah g-r-ae1 f-ih k-ah l-iy", "rb"],
  "geography": ["jh-iy aa1 g-r-ah f-iy", "nn"],
  "geologic": ["jh-iy ah l-aa1 jh-ih-k", "jj"],
  "geological": ["jh-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "geologist": ["jh-iy aa1 l-ah jh-ah-s-t", "nn"],
  "geology": ["jh-iy aa1 l-ah jh-iy", "nn"],
  "geometric": ["jh-iy ah m-eh1 t-r-ih-k", "jj"],
  "geometrical": ["jh-iy ah m-eh1 t-r-ih k-ah-l", "jj"],
  "geometrically": ["jh-iy ah m-eh1 t-r-ih-k l-iy", "rb"],
  "geometry": ["jh-iy aa1 m-ah t-r-iy", "nn"],
  "geopolitical": ["jh-iy ow p-ah l-ih1 t-ih k-ah-l", "jj"],
  "geothermal": ["jh-iy ow th-er1 m-ah-l", "jj"],
  "geranium": ["jh-er ey1 n-iy ah-m", "nn"],
  "geriatric": ["jh-eh r-iy ae1 t-r-ih-k", "jj"],
  "germ": ["jh-er1-m", "nn"],
  "germane": ["jh-er m-ey1-n", "jj"],
  "germinate": ["jh-er1 m-ah n-ey-t", "vb vbp"],
  "germinated": ["jh-er1 m-ah n-ey t-ih-d", "jj"],
  "gerrymandering": ["jh-eh r-iy m-ae1-n d-er ih-ng", "nn"],
  "gesture": ["jh-eh1-s ch-er", "nn vb"],
  "get": ["g-eh1-t", "vb vbp"],
  "getaway": ["g-eh1-t ah w-ey", "nn"],
  "geyser": ["g-ay1 z-er", "nn"],
  "ghastly": ["g-ae1-s-t l-iy", "jj"],
  "ghetto": ["g-eh1 t-ow", "nn"],
  "ghost": ["g-ow1-s-t", "nn"],
  "ghostbuster": ["g-ow1-s-t b-ah s-t-er", "nn"],
  "ghostlike": ["g-ow1-s-t l-ay-k", "jj"],
  "ghostly": ["g-ow1-s-t l-iy", "jj"],
  "ghoulish": ["g-uw1 l-ih-sh", "jj"],
  "giant": ["jh-ay1 ah-n-t", "nn jj"],
  "gibberish": ["g-ih1 b-er ih-sh", "nn"],
  "giblet": ["jh-ih1 b-l-ah-t", "nn"],
  "giddy": ["g-ih1 d-iy", "jj"],
  "gift": ["g-ih1-f-t", "nn vb"],
  "gifted": ["g-ih1-f t-ah-d", "jj vbn"],
  "gig": ["g-ih1-g", "nn"],
  "gigantic": ["jh-ay g-ae1-n t-ih-k", "jj"],
  "giggle": ["g-ih1 g-ah-l", "nn vb"],
  "gigolo": ["jh-ih1-g ah l-ow", "nn"],
  "gilded": ["g-ih1-l d-ih-d", "jj"],
  "gilding": ["g-ih1-l d-ih-ng", "nn"],
  "gilt": ["g-ih1-l-t", "jj nn"],
  "gimmick": ["g-ih1 m-ih-k", "nn"],
  "gimmickry": ["g-ih1 m-ih k-r-iy", "nn"],
  "gimmicky": ["g-ih m-ih1 k-iy", "jj"],
  "gin": ["jh-ih1-n", "nn"],
  "ginger": ["jh-ih1-n jh-er", "nn"],
  "gingerly": ["jh-ih1-n jh-er l-iy", "rb jj"],
  "ginning": ["jh-ih1 n-ih-ng", "nn"],
  "ginseng": ["jh-ih1-n s-eh-ng", "nn"],
  "gird": ["g-er1-d", "vb"],
  "girder": ["g-er1 d-er", "nn"],
  "girdle": ["g-er1 d-ah-l", "nn"],
  "girl": ["g-er1-l", "nn"],
  "girlfriend": ["g-er1-l f-r-eh-n-d", "nn"],
  "girlie": ["g-er1 l-iy", "nn"],
  "girlish": ["g-er1 l-ih-sh", "jj"],
  "girlishly": ["g-er1 l-ih-sh l-iy", "rb"],
  "girth": ["g-er1-th", "nn"],
  "gist": ["jh-ih1-s-t", "nn"],
  "give": ["g-ih1-v", "vb vbp"],
  "giveaway": ["g-ih1 v-ah w-ey", "nn jj"],
  "giveback": ["g-ih1-v b-ae-k", "nn"],
  "given": ["g-ih1 v-ah-n", "vbn jj"],
  "givenness": ["g-ih1 v-ah n-ah-s", "nn"],
  "giver": ["g-ih1 v-er", "nn"],
  "gizmo": ["g-ih1-z m-ow", "nn"],
  "glacial": ["g-l-ey1 sh-ah-l", "jj"],
  "glacier": ["g-l-ey1 sh-er", "nn"],
  "glad": ["g-l-ae1-d", "jj"],
  "glade": ["g-l-ey1-d", "nn"],
  "gladiator": ["g-l-ae1 d-iy ey t-er", "nn"],
  "gladly": ["g-l-ae1-d l-iy", "rb"],
  "glamor": ["g-l-ae1 m-er", "nn"],
  "glamorous": ["g-l-ae1 m-er ah-s", "jj"],
  "glamour": ["g-l-ae1 m-er", "nn"],
  "glance": ["g-l-ae1-n-s", "nn vb"],
  "glancing": ["g-l-ae1-n s-ih-ng", "vbg jj"],
  "gland": ["g-l-ae1-n-d", "nn"],
  "glandular": ["g-l-ae1-n jh-ah l-er", "jj"],
  "glare": ["g-l-eh1-r", "nn vb"],
  "glasnost": ["g-l-ae1-s n-aa-s-t", "nn"],
  "glass": ["g-l-ae1-s", "nn"],
  "glassware": ["g-l-ae1-s w-eh-r", "nn"],
  "glassy": ["g-l-ae1 s-iy", "jj"],
  "glaucoma": ["g-l-ao k-ow1 m-ah", "nn"],
  "glaze": ["g-l-ey1-z", "nn vb vbp"],
  "gleam": ["g-l-iy1-m", "nn vb vbp"],
  "glean": ["g-l-iy1-n", "vb"],
  "glee": ["g-l-iy1", "nn"],
  "gleeful": ["g-l-iy1 f-ah-l", "jj"],
  "gleefully": ["g-l-iy1 f-ah l-iy", "rb"],
  "glen": ["g-l-eh1-n", "nn"],
  "glib": ["g-l-ih1-b", "jj"],
  "glibly": ["g-l-ih1 b-l-iy", "rb"],
  "glide": ["g-l-ay1-d", "vb vbp"],
  "glider": ["g-l-ay1 d-er", "nn"],
  "glimmer": ["g-l-ih1 m-er", "nn vb"],
  "glimpse": ["g-l-ih1-m-p-s", "nn vb"],
  "glint": ["g-l-ih1-n-t", "nn"],
  "glisten": ["g-l-ih1-s-ah-n", "vb"],
  "glitch": ["g-l-ih1-ch", "nn"],
  "glitter": ["g-l-ih1 t-er", "nn vb"],
  "glittery": ["g-l-ih1 t-er iy", "nn"],
  "glitz": ["g-l-ih1-t-s", "nn"],
  "glitzy": ["g-l-ih1-t s-iy", "jj nn"],
  "gloat": ["g-l-ow1-t", "vb nn"],
  "global": ["g-l-ow1 b-ah-l", "jj"],
  "globalization": ["g-l-ow b-ah-l ih z-ey1 sh-ah-n", "nn"],
  "globalized": ["g-l-ow1 b-ah-l ay-z-d", "jj"],
  "globally": ["g-l-ow1 b-ah-l iy", "rb"],
  "globe": ["g-l-ow1-b", "nn"],
  "globulin": ["g-l-aa1 b-y-ah l-ih-n", "nn"],
  "gloom": ["g-l-uw1-m", "nn"],
  "gloomier": ["g-l-uw1 m-iy er", "jjr rbr"],
  "gloomily": ["g-l-uw1 m-ah l-iy", "rb"],
  "gloomy": ["g-l-uw1 m-iy", "jj"],
  "glop": ["g-l-aa1-p", "nn"],
  "glorified": ["g-l-ao1 r-ah f-ay-d", "vbn jj"],
  "glorify": ["g-l-ao1 r-ah f-ay", "vb vbp"],
  "glorious": ["g-l-ao1 r-iy ah-s", "jj"],
  "gloriously": ["g-l-ao1 r-iy ah-s l-iy", "rb"],
  "glory": ["g-l-ao1 r-iy", "nn"],
  "gloss": ["g-l-ao1-s", "vb nn vbp"],
  "glossary": ["g-l-ao1 s-er iy", "nn"],
  "glossy": ["g-l-ao1 s-iy", "jj"],
  "glottal": ["g-l-aa1 t-ah-l", "jj"],
  "glove": ["g-l-ah1-v", "nn vb"],
  "gloved": ["g-l-ah1-v-d", "vbn jj"],
  "glover": ["g-l-ah1 v-er", "nn"],
  "glow": ["g-l-ow1", "nn vb"],
  "glower": ["g-l-aw1-er", "vb"],
  "glowing": ["g-l-ow1 ih-ng", "vbg jj"],
  "glucose": ["g-l-uw1 k-ow-s", "nn"],
  "glue": ["g-l-uw1", "nn vb"],
  "glum": ["g-l-ah1-m", "jj nn"],
  "glumly": ["g-l-ah1-m l-iy", "rb"],
  "glut": ["g-l-ah1-t", "nn vb"],
  "glutamate": ["g-l-uw1 t-ah m-ey-t", "nn"],
  "glutamic": ["g-l-uw t-ae1 m-ih-k", "jj"],
  "glutaric": ["g-l-uw t-ae1 r-ih-k", "jj"],
  "gluten": ["g-l-uw1 t-ah-n", "nn"],
  "glutted": ["g-l-ah1 t-ih-d", "vbn jj"],
  "glutton": ["g-l-ah1 t-ah-n", "nn"],
  "gluttony": ["g-l-ah1 t-ah-n iy", "nn"],
  "glycerol": ["g-l-ih1 s-er ow-l", "nn"],
  "glycol": ["g-l-ay1 k-ao-l", "nn"],
  "gnarled": ["n-aa1-r-l-d", "jj"],
  "gnash": ["n-ae1-sh", "vb"],
  "gnaw": ["n-ao1", "vb"],
  "gnawing": ["n-ao1 ih-ng", "nn"],
  "gnome": ["n-ow1-m", "nn"],
  "go": ["g-ow1", "vb jj nn rp vbp"],
  "goad": ["g-ow1-d", "nn vb"],
  "goal": ["g-ow1-l", "nn"],
  "goat": ["g-ow1-t", "nn"],
  "goatee": ["g-ow1 t-iy1", "nn"],
  "gob": ["g-aa1-b", "nn"],
  "gobble": ["g-aa1 b-ah-l", "nn vb"],
  "gobbledygook": ["g-aa b-ah-l d-iy g-uh1-k", "nn"],
  "gobbler": ["g-aa1 b-ah-l er", "nn"],
  "god": ["g-aa1-d", "nn"],
  "goddam": ["g-aa1 d-d-ae-m", "jj"],
  "goddamn": ["g-aa1 d-d-ae-m", "uh vbn jj"],
  "goddess": ["g-aa1 d-ah-s", "nn"],
  "godfather": ["g-aa1-d f-aa dh-er", "nn"],
  "godhead": ["g-aa1-d hh-eh-d", "nn"],
  "godless": ["g-aa1-d l-ah-s", "jj"],
  "godmother": ["g-aa1-d m-ah dh-er", "nn"],
  "godsend": ["g-aa1-d s-eh-n-d", "nn"],
  "goggle": ["g-aa1 g-ah-l", "nn vb"],
  "going": ["g-ow1 ih-ng", "vbg jj nn"],
  "gold": ["g-ow1-l-d", "nn jj"],
  "golden": ["g-ow1-l d-ah-n", "jj"],
  "goldfish": ["g-ow1-l-d f-ih-sh", "nn"],
  "goldsmith": ["g-ow1-l-d s-m-ih-th", "nn"],
  "goldstock": ["g-ow1-l-d s-t-aa-k", "nn"],
  "golf": ["g-aa1-l-f", "nn vb"],
  "golfer": ["g-aa1-l f-er", "nn"],
  "golfing": ["g-aa1-l f-ih-ng", "nn jj vbg"],
  "golly": ["g-aa1 l-iy", "uh"],
  "gone": ["g-ao1-n", "vbn jj"],
  "goo": ["g-uw1", "nn"],
  "good": ["g-uh1-d", "jj nn rb"],
  "goodbye": ["g-uh-d b-ay1", "nn uh"],
  "goodness": ["g-uh1-d n-ah-s", "nn"],
  "goodnight": ["g-uh1-d n-ay-t", "nn"],
  "goodwill": ["g-uh1-d w-ih1-l", "nn"],
  "goody": ["g-uh1 d-iy", "uh"],
  "gooey": ["g-uw1 iy", "jj"],
  "goof": ["g-uw1-f", "vb"],
  "goofy": ["g-uw1 f-iy", "jj"],
  "google": ["g-uw1 g-ah-l", "nn vb"],
  "goon": ["g-uw1-n", "nn"],
  "goose": ["g-uw1-s", "nn"],
  "gooseberry": ["g-uw1-s b-eh r-iy", "nn"],
  "goosey": ["g-uw1 s-iy", "jj"],
  "gore": ["g-ao1-r", "vb"],
  "gorge": ["g-ao1-r-jh", "nn"],
  "gorgeous": ["g-ao1-r jh-ah-s", "jj"],
  "gorilla": ["g-er ih1 l-ah", "nn"],
  "gory": ["g-ao1 r-iy", "jj"],
  "gosh": ["g-aa1-sh", "uh"],
  "gospel": ["g-aa1 s-p-ah-l", "nn"],
  "gossamer": ["g-aa1 s-ah m-er", "nn"],
  "gossip": ["g-aa1 s-ah-p", "nn vb"],
  "gossipy": ["g-aa1 s-ah p-iy", "jj"],
  "got": ["g-aa1-t", "vbd vbn"],
  "gothic": ["g-aa1 th-ih-k", "jj"],
  "gotten": ["g-aa1 t-ah-n", "vbn"],
  "gouge": ["g-aw1-jh", "vb vbp"],
  "gourd": ["g-ao1-r-d", "nn"],
  "gourmet": ["g-uh1-r m-ey", "nn jj"],
  "gout": ["g-aw1-t", "nn"],
  "gouty": ["g-aw1 t-iy", "jj"],
  "govern": ["g-ah1 v-er-n", "vb vbp"],
  "governance": ["g-ah1 v-er n-ah-n-s", "nn"],
  "governed": ["g-ah1 v-er-n-d", "vbn jj vbd"],
  "governess": ["g-ah1 v-er n-ah-s", "nn"],
  "governing": ["g-ah1 v-er n-ih-ng", "vbg jj nn"],
  "government": ["g-ah1 v-er m-ah-n-t", "nn"],
  "governmental": ["g-ah1 v-er m-eh-n t-ah-l", "jj"],
  "governor": ["g-ah1 v-er n-er", "nn"],
  "gown": ["g-aw1-n", "nn"],
  "grab": ["g-r-ae1-b", "vb jj nn vbp"],
  "grace": ["g-r-ey1-s", "nn vb vbp"],
  "graceful": ["g-r-ey1-s f-ah-l", "jj"],
  "gracefully": ["g-r-ey1-s f-ah l-iy", "rb"],
  "gracious": ["g-r-ey1 sh-ah-s", "jj"],
  "graciously": ["g-r-ey1 sh-ah-s l-iy", "rb"],
  "grad": ["g-r-ae1-d", "nn"],
  "grade": ["g-r-ey1-d", "nn vb"],
  "grader": ["g-r-ey1 d-er", "nn"],
  "gradual": ["g-r-ae1 jh-uw ah-l", "jj rb"],
  "gradualist": ["g-r-ae1 jh-ah-w ah l-ih-s-t", "nn"],
  "gradually": ["g-r-ae1 jh-uw ah l-iy", "rb"],
  "graduate": ["g-r-ae1 jh-ah-w ah-t", "nn jj vb vbp"],
  "graduated": ["g-r-ae1 jh-uw ey t-ih-d", "vbn vbd jj"],
  "graduation": ["g-r-ae jh-uw ey1 sh-ah-n", "nn"],
  "graffiti": ["g-r-ah f-iy1 t-iy", "nn"],
  "graft": ["g-r-ae1-f-t", "nn vb"],
  "grafted": ["g-r-ae1-f t-ih-d", "jj vbn"],
  "graham": ["g-r-ey1 ah-m", "nn"],
  "grain": ["g-r-ey1-n", "nn"],
  "grained": ["g-r-ey1-n-d", "jj"],
  "grainy": ["g-r-ey1 n-iy", "jj"],
  "gram": ["g-r-ae1-m", "nn"],
  "grammar": ["g-r-ae1 m-er", "nn"],
  "grammatical": ["g-r-ah m-ae1 t-ah k-ah-l", "jj"],
  "grand": ["g-r-ae1-n-d", "jj"],
  "grandchild": ["g-r-ae1-n-d ch-ay-l-d", "nn"],
  "granddaughter": ["g-r-ae1-n d-ao t-er", "nn"],
  "grander": ["g-r-ae1-n d-er", "jjr rbr"],
  "grandest": ["g-r-ae1-n d-ah-s-t", "jjs"],
  "grandeur": ["g-r-ae-n d-uw1-r", "nn"],
  "grandfather": ["g-r-ae1-n-d f-aa dh-er", "nn vb"],
  "grandiloquent": ["g-r-ae-n d-ih1 l-ah k-w-ah-n-t", "jj"],
  "grandiose": ["g-r-ae-n d-iy ow1-s", "jj"],
  "grandkid": ["g-r-ae1-n-d k-ih-d", "nn"],
  "grandly": ["g-r-ae1-n-d l-iy", "rb"],
  "grandma": ["g-r-ae1 m-aa", "nn"],
  "grandmother": ["g-r-ae1-n-d m-ah dh-er", "nn"],
  "grandmotherly": ["g-r-ae1-n-d m-ah dh-er l-iy", "jj"],
  "grandparent": ["g-r-ae1-n-d p-eh r-ah-n-t", "nn"],
  "grandson": ["g-r-ae1-n-d s-ah-n", "nn"],
  "grandstand": ["g-r-ae1-n-d s-t-ae-n-d", "nn"],
  "granite": ["g-r-ae1 n-ah-t", "nn"],
  "grant": ["g-r-ae1-n-t", "nn vbp vb"],
  "granted": ["g-r-ae1-n t-ah-d", "vbn jj vbd"],
  "grantor": ["g-r-ae1-n t-er", "nn"],
  "granular": ["g-r-ae1 n-y-ah l-er", "jj"],
  "grape": ["g-r-ey1-p", "nn"],
  "grapefruit": ["g-r-ey1-p f-r-uw-t", "nn"],
  "grapeshot": ["g-r-ey1-p sh-aa-t", "nn"],
  "grapevine": ["g-r-ey1-p v-ay-n", "nn"],
  "graph": ["g-r-ae1-f", "nn"],
  "graphic": ["g-r-ae1 f-ih-k", "jj"],
  "graphical": ["g-r-ae1 f-ih k-ah-l", "jj"],
  "graphically": ["g-r-ae1 f-ih-k l-iy", "rb"],
  "graphite": ["g-r-ae1 f-ay-t", "nn"],
  "grapple": ["g-r-ae1 p-ah-l", "vb"],
  "grasp": ["g-r-ae1-s-p", "vb vbp nn"],
  "grass": ["g-r-ae1-s", "nn vb"],
  "grasser": ["g-r-ae1 s-er", "nn"],
  "grasshopper": ["g-r-ae1-s hh-aa p-er", "nn"],
  "grassland": ["g-r-ae1-s l-ae-n-d", "nn"],
  "grassroot": ["g-r-ae1-s r-uw1-t", "nn"],
  "grassy": ["g-r-ae1 s-iy", "jj"],
  "grate": ["g-r-ey1-t", "nn vb"],
  "grated": ["g-r-ey1 t-ih-d", "vbd jj"],
  "grateful": ["g-r-ey1-t f-ah-l", "jj"],
  "gratefully": ["g-r-ey1-t f-ah l-iy", "rb"],
  "gratification": ["g-r-ae t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "gratified": ["g-r-ae1 t-ah f-ay-d", "vbn jj"],
  "gratify": ["g-r-ae1 t-ah f-ay", "vb"],
  "gratifying": ["g-r-ae1 t-ah f-ay ih-ng", "jj vbg"],
  "grating": ["g-r-ey1 t-ih-ng", "nn"],
  "gratis": ["g-r-ae1 t-ah-s", "jj rb"],
  "gratitude": ["g-r-ae1 t-ah t-uw-d", "nn"],
  "gratuitous": ["g-r-ah t-uw1 ah t-ah-s", "jj"],
  "gratuitously": ["g-r-ah t-uw1 ah t-ah-s l-iy", "rb"],
  "gratuity": ["g-r-ah t-uw1 ih t-iy", "nn"],
  "grave": ["g-r-ey1-v", "jj nn"],
  "gravel": ["g-r-ae1 v-ah-l", "nn"],
  "gravely": ["g-r-ey1-v l-iy", "rb"],
  "graven": ["g-r-ey1 v-ah-n", "jj"],
  "graver": ["g-r-ey1 v-er", "jjr rbr"],
  "gravest": ["g-r-ae1 v-ah-s-t", "jjs"],
  "graveyard": ["g-r-ey1-v y-aa-r-d", "nn"],
  "gravitate": ["g-r-ae1-v-ih-t-ey-t", "vb"],
  "gravitational": ["g-r-ae v-ih t-ey1 sh-ah n-ah-l", "jj"],
  "gravity": ["g-r-ae1 v-ah t-iy", "nn"],
  "gravy": ["g-r-ey1 v-iy", "nn"],
  "gray": ["g-r-ey1", "jj nn vb"],
  "grayer": ["g-r-ey1 er", "jjr"],
  "graze": ["g-r-ey1-z", "vbp vb"],
  "grazer": ["g-r-ey1 z-er", "nn"],
  "grazing": ["g-r-ey1 z-ih-ng", "vbg jj nn"],
  "grease": ["g-r-iy1-s", "nn vb"],
  "greasy": ["g-r-iy1 s-iy", "jj"],
  "great": ["g-r-ey1-t", "jj rb"],
  "greater": ["g-r-ey1 t-er", "jjr rbr"],
  "greatest": ["g-r-ey1 t-ah-s-t", "jjs"],
  "greatly": ["g-r-ey1-t l-iy", "rb"],
  "greatness": ["g-r-ey1-t n-ah-s", "nn"],
  "greed": ["g-r-iy1-d", "nn"],
  "greedily": ["g-r-iy1 d-ah l-iy", "rb"],
  "greedy": ["g-r-iy1 d-iy", "jj"],
  "green": ["g-r-iy1-n", "jj"],
  "greenback": ["g-r-iy1-n b-ae-k", "nn"],
  "greener": ["g-r-iy1 n-er", "jjr"],
  "greenfield": ["g-r-iy1-n f-iy-l-d", "nn"],
  "greenhouse": ["g-r-iy1-n hh-aw-s", "nn"],
  "greenish": ["g-r-iy1 n-ih-sh", "jj"],
  "greenly": ["g-r-iy1-n l-iy", "rb"],
  "greet": ["g-r-iy1-t", "vb vbp"],
  "greeting": ["g-r-iy1 t-ih-ng", "nn vbg jj"],
  "gregarious": ["g-r-ah g-eh1 r-iy ah-s", "jj"],
  "grenade": ["g-r-ah n-ey1-d", "nn"],
  "grew": ["g-r-uw1", "vbd vbn"],
  "grey": ["g-r-ey1", "jj"],
  "grid": ["g-r-ih1-d", "nn"],
  "gridiron": ["g-r-ih1-d ay er-n", "nn"],
  "gridlock": ["g-r-ih1-d l-aa-k", "nn vb"],
  "gridlocked": ["g-r-ih1-d l-aa-k-t", "vbn jj"],
  "grief": ["g-r-iy1-f", "nn"],
  "grievance": ["g-r-iy1 v-ah-n-s", "nn"],
  "grieve": ["g-r-iy1-v", "vb"],
  "grievous": ["g-r-iy1 v-ah-s", "jj"],
  "grill": ["g-r-ih1-l", "nn vb vbp"],
  "grille": ["g-r-ih1-l", "nn"],
  "grilled": ["g-r-ih1-l-d", "jj vbn"],
  "grim": ["g-r-ih1-m", "jj"],
  "grimace": ["g-r-ih1-m-ah-s", "vb"],
  "grime": ["g-r-ay1-m", "nn"],
  "grimly": ["g-r-ih1-m l-iy", "rb"],
  "grimmer": ["g-r-ih1 m-er", "rbr"],
  "grimmest": ["g-r-ih1 m-ah-s-t", "jjs"],
  "grimness": ["g-r-ih1-m n-ah-s", "nn"],
  "grimy": ["g-r-ay1 m-iy", "jj nn"],
  "grin": ["g-r-ih1-n", "nn vb"],
  "grind": ["g-r-ay1-n-d", "vbp nn vb"],
  "grinder": ["g-r-ay1-n d-er", "nn"],
  "grindstone": ["g-r-ay1-n-d s-t-ow-n", "nn"],
  "gringo": ["g-r-ih1-ng g-ow", "nn"],
  "grinning": ["g-r-ih1 n-ih-ng", "vbg jj"],
  "grip": ["g-r-ih1-p", "nn vb vbp"],
  "gripe": ["g-r-ay1-p", "vbp nn vb"],
  "griping": ["g-r-ay1 p-ih-ng", "nn"],
  "gripping": ["g-r-ih1 p-ih-ng", "vbg jj"],
  "grisly": ["g-r-ih1-z l-iy", "jj"],
  "grist": ["g-r-ih1-s-t", "nn"],
  "grit": ["g-r-ih1-t", "nn vb"],
  "gritty": ["g-r-ih1 t-iy", "jj"],
  "grizzled": ["g-r-ih1 z-ah-l-d", "jj"],
  "grizzly": ["g-r-ih1-z l-iy", "nn"],
  "groan": ["g-r-ow1-n", "nn vb"],
  "grocer": ["g-r-ow1 s-er", "nn"],
  "grocery": ["g-r-ow1 s-er iy", "nn"],
  "groggy": ["g-r-aa1 g-iy", "jj"],
  "groin": ["g-r-oy1-n", "nn"],
  "groom": ["g-r-uw1-m", "nn vb"],
  "groove": ["g-r-uw1-v", "nn"],
  "grope": ["g-r-ow1-p", "vb vbp"],
  "gross": ["g-r-ow1-s", "jj nn vb"],
  "grossly": ["g-r-ow1-s l-iy", "rb"],
  "grotesque": ["g-r-ow t-eh1-s-k", "jj"],
  "grotesquely": ["g-r-ow t-eh1-s-k l-iy", "rb"],
  "ground": ["g-r-aw1-n-d", "nn jj vb vbd vbn"],
  "grounded": ["g-r-aw1-n d-ih-d", "vbn vbd jj"],
  "groundless": ["g-r-aw1-n-d l-ah-s", "jj"],
  "groundwater": ["g-r-aw1-n-d w-aa t-er", "nn"],
  "groundwork": ["g-r-aw1-n-d w-er-k", "nn"],
  "group": ["g-r-uw1-p", "nn vb vbp"],
  "grouper": ["g-r-uw1 p-er", "nn"],
  "grouping": ["g-r-uw1 p-ih-ng", "nn vbg"],
  "grouse": ["g-r-aw1-s", "nn vb"],
  "grove": ["g-r-ow1-v", "nn"],
  "grovel": ["g-r-aa1 v-ah-l", "vb"],
  "grow": ["g-r-ow1", "vb vbp"],
  "grower": ["g-r-ow1 er", "nn"],
  "growing": ["g-r-ow1 ih-ng", "vbg jj nn"],
  "growl": ["g-r-aw1-l", "nn vb"],
  "grown": ["g-r-ow1-n", "vbn vbd jj"],
  "grownup": ["g-r-ow1 n-ah-p", "nn"],
  "growth": ["g-r-ow1-th", "nn jj vb"],
  "grub": ["g-r-ah1-b", "nn"],
  "grubby": ["g-r-ah1 b-iy", "jj"],
  "grudge": ["g-r-ah1-jh", "nn"],
  "grudging": ["g-r-ah1 jh-ih-ng", "jj"],
  "grudgingly": ["g-r-ah1 jh-ih-ng l-iy", "rb"],
  "grueling": ["g-r-uw1 ih l-ih-ng", "jj vbg"],
  "gruesome": ["g-r-uw1 s-ah-m", "jj"],
  "gruff": ["g-r-ah1-f", "jj"],
  "grumble": ["g-r-ah1-m b-ah-l", "vbp vb"],
  "grunt": ["g-r-ah1-n-t", "vb nn"],
  "guarantee": ["g-eh r-ah-n t-iy1", "nn vb vbp"],
  "guaranteed": ["g-eh r-ah-n t-iy1-d", "vbn jj vbd"],
  "guarantor": ["g-eh r-ah-n t-ao1-r", "nn"],
  "guaranty": ["g-eh r-ah-n t-iy1", "nn"],
  "guard": ["g-aa1-r-d", "nn jj vb vbp"],
  "guarded": ["g-aa1-r d-ah-d", "vbn jj vbd"],
  "guardedly": ["g-aa1-r d-ih-d l-iy", "rb"],
  "guardian": ["g-aa1-r d-iy ah-n", "nn"],
  "guardianship": ["g-aa1-r d-iy ah-n sh-ih-p", "nn"],
  "gubernatorial": ["g-uw b-er n-ah t-ao1 r-iy ah-l", "jj"],
  "guerilla": ["g-er ih1 l-ah", "nn"],
  "guerrilla": ["g-er ih1 l-ah", "nn jj"],
  "guess": ["g-eh1-s", "vbp nn vb"],
  "guesstimate": ["g-eh1 s-t-ih m-ih-t", "nn"],
  "guesswork": ["g-eh1-s w-er-k", "nn"],
  "guest": ["g-eh1-s-t", "nn jj"],
  "guffaw": ["g-ah f-ao1", "nn"],
  "guidance": ["g-ay1 d-ah-n-s", "nn"],
  "guide": ["g-ay1-d", "nn vbp vb"],
  "guidebook": ["g-ay1-d b-uh-k", "nn"],
  "guided": ["g-ay1 d-ah-d", "vbn vbd jj"],
  "guideline": ["g-ay1-d l-ay-n", "nn"],
  "guidepost": ["g-ay1-d p-ow-s-t", "nn"],
  "guiding": ["g-ay1 d-ih-ng", "vbg jj"],
  "guild": ["g-ih1-l-d", "nn"],
  "guilder": ["g-ih1-l d-er", "nn"],
  "guile": ["g-ay1-l", "nn"],
  "guileless": ["g-ay1-l l-ah-s", "jj"],
  "guillotine": ["g-ih1 l-ah t-iy-n", "nn"],
  "guilt": ["g-ih1-l-t", "nn"],
  "guilty": ["g-ih1-l t-iy", "jj rb"],
  "guinea": ["g-ih1 n-iy", "nn"],
  "guise": ["g-ay1-z", "nn"],
  "guitar": ["g-ih t-aa1-r", "nn"],
  "guitarist": ["g-ih t-aa1 r-ah-s-t", "nn"],
  "gulag": ["g-y-uw1 l-ae-g", "nn"],
  "gulf": ["g-ah1-l-f", "nn"],
  "gull": ["g-ah1-l", "nn"],
  "gullet": ["g-ah1 l-ah-t", "nn"],
  "gulley": ["g-ah1 l-iy", "nn"],
  "gullibility": ["g-ah l-ah b-ih1 l-ih t-iy", "nn"],
  "gullible": ["g-ah1 l-ah b-ah-l", "jj"],
  "gully": ["g-ah1 l-iy", "nn"],
  "gulp": ["g-ah1-l-p", "nn vb"],
  "gum": ["g-ah1-m", "nn vb"],
  "gummy": ["g-ah1 m-iy", "jj"],
  "gumption": ["g-ah1-m-p sh-ah-n", "nn"],
  "gun": ["g-ah1-n", "nn vb"],
  "gunboat": ["g-ah1-n b-ow-t", "nn"],
  "gunfight": ["g-ah1-n f-ay-t", "nn"],
  "gunfighter": ["g-ah1-n f-ay t-er", "nn"],
  "gunfire": ["g-ah1-n f-ay er", "nn"],
  "gunflint": ["g-ah1-n f-l-ih-n-t", "nn"],
  "gunman": ["g-ah1-n m-ah-n", "nn"],
  "gunner": ["g-ah1 n-er", "nn"],
  "gunny": ["g-ah1 n-iy", "nn"],
  "gunpoint": ["g-ah1-n p-oy-n-t", "nn"],
  "gunpowder": ["g-ah1-n p-aw d-er", "nn"],
  "gunship": ["g-ah1-n sh-ih-p", "nn"],
  "gunshot": ["g-ah1-n sh-aa-t", "nn"],
  "gunslinger": ["g-ah1-n s-l-ih ng-er", "nn"],
  "guppy": ["g-ah1 p-iy", "nn"],
  "gurgle": ["g-er1 g-ah-l", "nn vb"],
  "guru": ["g-uw1 r-uw", "nn"],
  "gush": ["g-ah1-sh", "vbp vb"],
  "gusher": ["g-ah1 sh-er", "nn"],
  "gussied": ["g-ah1 s-iy-d", "vbn"],
  "gussy": ["g-ah1-s-iy", "vb"],
  "gust": ["g-ah1-s-t", "nn rb"],
  "gusto": ["g-ah1 s-t-ow", "nn"],
  "gusty": ["g-ah1 s-t-iy", "jj"],
  "gut": ["g-ah1-t", "nn vb"],
  "gutsy": ["g-ah1-t s-iy1", "jj"],
  "gutter": ["g-ah1 t-er", "nn vb"],
  "guttural": ["g-ah1 t-er ah-l", "jj nn"],
  "guy": ["g-ay1", "nn"],
  "guzzle": ["g-ah1 z-ah-l", "vb"],
  "guzzler": ["g-ah1-z l-er", "nn"],
  "guzzling": ["g-ah1 z-ah-l ih-ng", "nn"],
  "gym": ["jh-ih1-m", "nn"],
  "gymnast": ["jh-ih1-m n-ah-s-t", "nn"],
  "gymnastic": ["jh-ih-m n-ae1 s-t-ih-k", "jj"],
  "gynecologic": ["g-ay n-ah k-ah l-aa1 jh-ih-k", "jj"],
  "gynecological": ["g-ay n-ah k-ah l-aa1 jh-ih k-ah-l", "jj"],
  "gynecologist": ["g-ay n-ah k-aa1 l-ah jh-ah-s-t", "nn"],
  "gynecology": ["g-ay n-ah k-aa1 l-ah jh-iy", "nn"],
  "gypsum": ["jh-ih1-p s-ah-m", "nn"],
  "gypsy": ["jh-ih1-p s-iy", "nn"],
  "gyrate": ["jh-ay1 r-ey-t", "vb"],
  "gyration": ["jh-ay r-ey1 sh-ah-n", "nn"],
  "gyro": ["jh-ay1 r-ow", "nn"],
  "gyroscope": ["jh-ay1 r-ah s-k-ow-p", "nn"],
  "haberdashery": ["hh-ae1 b-er d-ae sh-er iy", "nn"],
  "habit": ["hh-ae1 b-ah-t", "nn"],
  "habitable": ["hh-ae1 b-ah t-ah b-ah-l", "jj"],
  "habitat": ["hh-ae1 b-ah t-ae-t", "nn"],
  "habitual": ["hh-ah b-ih1 ch-uw ah-l", "jj"],
  "habitually": ["hh-ah b-ih1 ch-uw ah l-iy", "rb"],
  "habitue": ["hh-ae1 b-ih ch-uw", "nn"],
  "hable": ["hh-ey1 b-ah-l", "jj"],
  "hack": ["hh-ae1-k", "nn vb"],
  "hacker": ["hh-ae1 k-er", "nn"],
  "hacking": ["hh-ae1 k-ih-ng", "jj nn"],
  "hackle": ["hh-ae1 k-ah-l", "nn"],
  "hackneyed": ["hh-ae1-k n-iy-d", "jj"],
  "hacksaw": ["hh-ae1-k s-ao", "nn"],
  "had": ["hh-ae1-d", "vbd vbn"],
  "hadn't": ["hh-ae1-d-ah-n-d", "vbd vbn"],
  "hadd": ["hh-ae1-d", "vbn"],
  "haddock": ["hh-ae1 d-ah-k", "nn"],
  "hafta": ["hh-ae1-f t-ah", "vb vbp"],
  "haggard": ["hh-ae1 g-er-d", "jj"],
  "haggle": ["hh-ae1 g-ah-l", "vb nn"],
  "hail": ["hh-ey1-l", "nn vb vbp"],
  "hailstorm": ["hh-ey1-l s-t-ao-r-m", "nn"],
  "hair": ["hh-eh1-r", "nn"],
  "haircut": ["hh-eh1-r k-ah-t", "nn"],
  "hairdo": ["hh-eh1-r d-uw", "nn"],
  "hairdresser": ["hh-eh1-r d-r-eh s-er", "nn"],
  "hairless": ["hh-eh1-r l-ah-s", "jj"],
  "hairline": ["hh-eh1-r l-ay-n", "nn"],
  "hairspray": ["hh-eh1-r s-p-r-ey", "nn"],
  "hairy": ["hh-eh1 r-iy", "jj"],
  "halcyon": ["hh-ae1-l s-iy ah-n", "jj"],
  "half": ["hh-ae1-f", "nn jj prp"],
  "halfback": ["hh-ae1-f b-ae-k", "nn"],
  "halfhearted": ["hh-ae1-f hh-aa-r t-ih-d", "jj"],
  "halftime": ["hh-ae1-f t-ay-m", "nn"],
  "halfway": ["hh-ae1-f w-ey1", "rb jj"],
  "hall": ["hh-ao1-l", "nn"],
  "hallmark": ["hh-aa1-l m-aa-r-k", "nn"],
  "hallowed": ["hh-ae1 l-ow-d", "jj"],
  "hallucination": ["hh-ah l-uw s-ah n-ey1 sh-ah-n", "nn"],
  "hallucinatory": ["hh-ah l-uw1 s-ah n-ah t-ao r-iy", "jj"],
  "hallway": ["hh-ao1-l w-ey", "nn"],
  "halo": ["hh-ey1 l-ow", "nn"],
  "halogen": ["hh-ae1 l-ah jh-ah-n", "nn"],
  "halogenate": ["hh-ae1-l-ah-jh-ah-n-ey-t", "vb"],
  "halt": ["hh-ao1-l-t", "nn jj vb vbp"],
  "halted": ["hh-ao1-l t-ah-d", "vbn nn vbd"],
  "halter": ["hh-ao1-l t-er", "nn"],
  "halting": ["hh-ao1-l t-ih-ng", "vbg jj"],
  "haltingly": ["hh-ao1-l t-ih-ng l-iy", "rb"],
  "halve": ["hh-ae1-v", "vb"],
  "halved": ["hh-ae1-v-d", "vbn jj vbd"],
  "ham": ["hh-ae1-m", "nn"],
  "hamburger": ["hh-ae1-m b-er g-er", "nn"],
  "hamlet": ["hh-ae1-m l-ah-t", "nn"],
  "hammer": ["hh-ae1 m-er", "nn vbp vb"],
  "hammerlock": ["hh-ae1 m-er l-aa-k", "nn"],
  "hammock": ["hh-ae1 m-ah-k", "nn"],
  "hamper": ["hh-ae1-m p-er", "vb nn"],
  "hamstring": ["hh-ae1-m s-t-r-ih-ng", "vb"],
  "hand": ["hh-ae1-n-d", "nn rb vb vbp jj"],
  "handbag": ["hh-ae1-n-d b-ae-g", "nn"],
  "handbill": ["hh-ae1-n-d b-ih-l", "nn"],
  "handbook": ["hh-ae1-n-d b-uh-k", "nn"],
  "handclasp": ["hh-ae1-n-d k-l-ae-s-p", "nn"],
  "handcraft": ["hh-ae1-n-d-k-r-ae-f-t", "vb"],
  "handcuff": ["hh-ae1-n-d k-ah-f", "vb vbp"],
  "hander": ["hh-ae1-n d-er", "nn"],
  "handful": ["hh-ae1-n-d f-uh-l", "nn"],
  "handgun": ["hh-ae1-n-d g-ah-n", "nn"],
  "handheld": ["hh-ae1-n-d hh-eh1-l-d", "jj"],
  "handicap": ["hh-ae1-n d-iy k-ae-p", "nn vb"],
  "handicapped": ["hh-ae1-n d-iy k-ae-p-t", "jj vbn"],
  "handicraft": ["hh-ae1-n d-iy k-r-ae-f-t", "nn"],
  "handier": ["hh-ae1-n d-iy er", "jjr"],
  "handily": ["hh-ae1-n d-ah l-iy", "rb"],
  "handiwork": ["hh-ae1-n d-iy w-er-k", "nn"],
  "handkerchief": ["hh-ae1-ng k-er ch-ih-f", "nn"],
  "handle": ["hh-ae1-n d-ah-l", "vb nn vbp"],
  "handlebar": ["hh-ae1-n d-ah-l b-aa-r", "nn"],
  "handler": ["hh-ae1-n-d l-er", "nn"],
  "handmade": ["hh-ae1-n-d m-ey1-d", "jj"],
  "handout": ["hh-ae1-n-d aw-t", "nn"],
  "handpick": ["hh-ae1-n-d-p-ih1-k", "vb"],
  "handset": ["hh-ae1-n-d s-eh-t", "nn"],
  "handshake": ["hh-ae1-n-d sh-ey-k", "nn"],
  "handsome": ["hh-ae1-n s-ah-m", "jj"],
  "handsomely": ["hh-ae1-n s-ah-m l-iy", "rb"],
  "handstand": ["hh-ae1-n-d s-t-ae-n-d", "nn"],
  "handwriting": ["hh-ae1-n-d r-ay t-ih-ng", "nn"],
  "handwritten": ["hh-ae1-n-d r-ih t-ah-n", "jj"],
  "handy": ["hh-ae1-n d-iy", "jj"],
  "handyman": ["hh-ae1-n d-iy m-ae-n", "nn"],
  "hang": ["hh-ae1-ng", "vb jj vbp nn"],
  "hangar": ["hh-ae1 ng-er", "nn"],
  "hanger": ["hh-ae1 ng-er", "nn"],
  "hanging": ["hh-ae1 ng-ih-ng", "vbg jj nn"],
  "hangman": ["hh-ae1-ng m-ah-n", "nn"],
  "hangout": ["hh-ae1-ng aw-t", "nn"],
  "hangover": ["hh-ae1-ng ow v-er", "nn"],
  "hank": ["hh-ae1-ng-k", "nn"],
  "hanky": ["hh-ae1-ng k-iy", "nn"],
  "haphazard": ["hh-ae-p hh-ae1 z-er-d", "jj"],
  "haphazardly": ["hh-ae1-f ah z-er-d l-iy", "rb"],
  "hapless": ["hh-ae1-p l-ah-s", "jj"],
  "happen": ["hh-ae1 p-ah-n", "vb vbp"],
  "happenstance": ["hh-ae1 p-ah-n s-t-ae-n-s", "nn"],
  "happier": ["hh-ae1 p-iy er", "jjr"],
  "happiest": ["hh-ae1 p-iy ah-s-t", "jjs"],
  "happily": ["hh-ae1 p-ah l-iy", "rb"],
  "happiness": ["hh-ae1 p-iy n-ah-s", "nn"],
  "happy": ["hh-ae1 p-iy", "jj"],
  "harangue": ["hh-er-ae1-ng", "vb"],
  "harass": ["hh-er ae1-s", "vb vbp"],
  "harassment": ["hh-er ae1-s m-ah-n-t", "nn"],
  "harbinger": ["hh-aa1-r b-ih-n jh-er", "nn"],
  "harbor": ["hh-aa1-r b-er", "nn vb vbp"],
  "harborside": ["hh-aa1-r b-er s-ay-d", "nn"],
  "hard": ["hh-aa1-r-d", "jj rb"],
  "hardball": ["hh-aa1-r-d b-ao-l", "nn"],
  "hardboard": ["hh-aa1-r-d b-ao-r-d", "nn"],
  "hardcore": ["hh-aa1-r-d k-ao1-r", "jj nn"],
  "hardcover": ["hh-aa1-r-d k-ah v-er", "nn"],
  "harden": ["hh-aa1-r d-ah-n", "vb"],
  "hardened": ["hh-aa1-r d-ah-n-d", "vbn jj vbd"],
  "hardener": ["hh-aa1-r d-ah-n er", "nn"],
  "harder": ["hh-aa1-r d-er", "jjr rbr jj rb"],
  "hardest": ["hh-aa1-r d-ah-s-t", "jjs rbs rb"],
  "hardier": ["hh-aa1-r d-iy er", "jjr"],
  "hardline": ["hh-aa1-r-d l-ay-n", "jj nn"],
  "hardliner": ["hh-aa1-r-d l-ay n-er", "nn"],
  "hardly": ["hh-aa1-r-d l-iy", "rb"],
  "hardness": ["hh-aa1-r-d n-ah-s", "nn"],
  "hardship": ["hh-aa1-r-d sh-ih-p", "nn"],
  "hardware": ["hh-aa1-r-d w-eh-r", "nn"],
  "hardwood": ["hh-aa1-r-d w-uh-d", "nn"],
  "hardworking": ["hh-aa1-r-d w-er k-ih-ng", "jj"],
  "hardy": ["hh-aa1-r d-iy", "jj"],
  "hare": ["hh-eh1-r", "nn"],
  "harem": ["hh-eh1 r-ah-m", "nn"],
  "harm": ["hh-aa1-r-m", "nn vb vbp"],
  "harmful": ["hh-aa1-r-m f-ah-l", "jj"],
  "harmless": ["hh-aa1-r-m l-ah-s", "jj"],
  "harmlessly": ["hh-aa1-r-m l-ah-s l-iy", "rb"],
  "harmonic": ["hh-aa-r m-aa1 n-ih-k", "jj"],
  "harmonious": ["hh-aa-r m-ow1 n-iy ah-s", "jj"],
  "harmonization": ["hh-aa-r m-ah n-ih z-ey1 sh-ah-n", "nn"],
  "harmonize": ["hh-aa1-r m-ah n-ay-z", "vb"],
  "harmony": ["hh-aa1-r m-ah n-iy", "nn"],
  "harness": ["hh-aa1-r n-ah-s", "nn vbp vb"],
  "harp": ["hh-aa1-r-p", "nn vb"],
  "harpsichord": ["hh-aa1-r-p s-ah k-ao-r-d", "nn"],
  "harried": ["hh-eh1 r-iy-d", "vbn vbd"],
  "harrow": ["hh-ae1-r-ow", "vb"],
  "harrowing": ["hh-eh1 r-ow ih-ng", "jj vbg"],
  "harry": ["hh-eh1 r-iy", "vb"],
  "harsh": ["hh-aa1-r-sh", "jj"],
  "harsher": ["hh-aa1-r sh-er", "jjr rbr"],
  "harshest": ["hh-aa1-r sh-ah-s-t", "jjs"],
  "harshly": ["hh-aa1-r-sh l-iy", "rb"],
  "harshness": ["hh-aa1-r-sh n-ah-s", "nn"],
  "harvest": ["hh-aa1-r v-ah-s-t", "nn vb vbp"],
  "has": ["hh-ae1-z", "vbz vbn"],
  "hasn't": ["hh-ae1-z-ah-n-t", "vbz"],
  "hash": ["hh-ae1-sh", "nn"],
  "hashish": ["hh-ae1 sh-ih-sh", "nn"],
  "hassle": ["hh-ae1 s-ah-l", "nn vb"],
  "haste": ["hh-ey1-s-t", "nn"],
  "hasten": ["hh-ey1 s-ah-n", "vb vbp"],
  "hastily": ["hh-ey1 s-t-ah l-iy", "rb"],
  "hasty": ["hh-ey1 s-t-iy", "jj"],
  "hat": ["hh-ae1-t", "nn"],
  "hatch": ["hh-ae1-ch", "nn vbp vb"],
  "hatchback": ["hh-ae1-ch b-ae-k", "nn"],
  "hatchery": ["hh-ae1 ch-er iy", "nn"],
  "hatchet": ["hh-ae1 ch-ah-t", "nn"],
  "hatching": ["hh-ae1 ch-ih-ng", "nn vbg"],
  "hate": ["hh-ey1-t", "vb"],
  "hateful": ["hh-ey1-t f-ah-l", "jj"],
  "hater": ["hh-ey1 t-er", "nn"],
  "hatred": ["hh-ey1 t-r-ah-d", "nn"],
  "haughty": ["hh-ao1 t-iy", "jj"],
  "haul": ["hh-ao1-l", "nn vb"],
  "hauler": ["hh-ao1 l-er", "nn"],
  "haunt": ["hh-ao1-n-t", "vb vbp nn"],
  "haunted": ["hh-ao1-n t-ah-d", "vbn vbd jj"],
  "haunting": ["hh-ao1-n t-ih-ng", "jj vbg"],
  "hauntingly": ["hh-ao1-n t-ih-ng l-iy", "rb"],
  "have": ["hh-ae1-v", "vbp jj vb"],
  "haven": ["hh-ey1 v-ah-n", "nn"],
  "haven't": ["hh-ae1-v-ah-n-t", "vbp vbn"],
  "havoc": ["hh-ae1 v-ah-k", "nn"],
  "hawk": ["hh-ao1-k", "nn vbp vb"],
  "hawker": ["hh-ao1 k-er", "nn"],
  "hawkish": ["hh-ao1 k-ih-sh", "jj"],
  "hay": ["hh-ey1", "nn vb"],
  "hayfield": ["hh-ey1 f-iy-l-d", "nn"],
  "haystack": ["hh-ey1 s-t-ae-k", "nn"],
  "hazard": ["hh-ae1 z-er-d", "nn vb"],
  "hazardous": ["hh-ae1 z-er d-ah-s", "jj"],
  "haze": ["hh-ey1-z", "nn"],
  "hazel": ["hh-ey1 z-ah-l", "jj"],
  "hazelnut": ["hh-ey1 z-ah-l n-ah-t", "nn"],
  "hazy": ["hh-ey1 z-iy", "jj"],
  "he": ["hh-iy1", "prp"],
  "head": ["hh-eh1-d", "nn jj rb vb vbp"],
  "headache": ["hh-eh1-d ey-k", "nn"],
  "headboard": ["hh-eh1-d b-ao-r-d", "nn"],
  "headcount": ["hh-eh1-d k-aw-n-t", "nn"],
  "headdress": ["hh-eh1-d r-eh-s", "nn"],
  "header": ["hh-eh1 d-er", "nn"],
  "headhunter": ["hh-eh1-d hh-ah-n t-er", "nn"],
  "headless": ["hh-eh1-d l-ah-s", "jj"],
  "headlight": ["hh-eh1-d l-ay-t", "nn"],
  "headline": ["hh-eh1-d l-ay-n", "nn vb"],
  "headlong": ["hh-eh1-d l-ao-ng", "rb"],
  "headmaster": ["hh-eh1-d m-ae1 s-t-er", "nn"],
  "headphone": ["hh-eh1-d f-ow-n", "nn"],
  "headquartered": ["hh-eh1-d k-ao-r t-er-d", "vbn"],
  "headquarters": ["hh-eh1-d k-w-ao-r t-er-z", "nn"],
  "headrest": ["hh-eh1-d r-eh-s-t", "nn"],
  "headroom": ["hh-eh1-d r-uw-m", "nn"],
  "headset": ["hh-eh1-d s-eh-t", "nn"],
  "headship": ["hh-eh1-d sh-ih-p", "nn"],
  "headsman": ["hh-eh1-d-z m-ah-n", "nn"],
  "headstrong": ["hh-eh1-d s-t-r-ao-ng", "jj"],
  "headwaters": ["hh-eh1-d w-ao t-er-z", "nn"],
  "headway": ["hh-eh1-d w-ey", "nn"],
  "heady": ["hh-eh1 d-iy", "jj"],
  "heal": ["hh-iy1-l", "vb"],
  "healer": ["hh-iy1 l-er", "nn"],
  "healing": ["hh-iy1 l-ih-ng", "nn jj vbg"],
  "health": ["hh-eh1-l-th", "nn"],
  "healthcare": ["hh-eh1-l-th k-eh-r", "nn"],
  "healthful": ["hh-eh1-l-th f-ah-l", "jj"],
  "healthier": ["hh-eh1-l th-iy er", "jjr rbr"],
  "healthiest": ["hh-eh1-l th-iy ih-s-t", "jjs"],
  "healthy": ["hh-eh1-l th-iy", "jj"],
  "heap": ["hh-iy1-p", "nn vb"],
  "hear": ["hh-ih1-r", "vb vbp"],
  "heard": ["hh-er1-d", "vbd vbn"],
  "hearer": ["hh-ih1 r-er", "nn"],
  "hearing": ["hh-ih1 r-ih-ng", "nn vbg"],
  "hearsay": ["hh-ih1-r s-ey", "nn"],
  "hearse": ["hh-er1-s", "nn"],
  "heart": ["hh-aa1-r-t", "nn rb vb"],
  "heartbeat": ["hh-aa1-r-t b-iy-t", "nn"],
  "heartbreak": ["hh-aa1-r-t b-r-ey-k", "nn"],
  "heartbreaking": ["hh-aa1-r-t b-r-ey k-ih-ng", "jj"],
  "heartburn": ["hh-aa1-r-t b-er-n", "nn"],
  "hearten": ["hh-aa1-r-t-ah-n", "vb"],
  "heartening": ["hh-aa1-r t-ah-n ih-ng", "jj"],
  "heartfelt": ["hh-aa1-r-t f-eh-l-t", "jj"],
  "hearth": ["hh-aa1-r-th", "nn"],
  "heartily": ["hh-aa1-r t-ah l-iy", "rb"],
  "heartland": ["hh-aa1-r-t l-ae-n-d", "nn"],
  "heartless": ["hh-aa1-r-t l-ah-s", "jj"],
  "heartthrob": ["hh-aa1-r-t th-r-aa-b", "nn"],
  "hearty": ["hh-aa1-r t-iy", "jj"],
  "heat": ["hh-iy1-t", "nn vb vbp"],
  "heated": ["hh-iy1 t-ah-d", "vbn jj vbd"],
  "heatedly": ["hh-iy1 t-ih-d l-iy", "rb"],
  "heater": ["hh-iy1 t-er", "nn"],
  "heath": ["hh-iy1-th", "nn"],
  "heathen": ["hh-iy1 dh-ah-n", "jj nn"],
  "heather": ["hh-eh1 dh-er", "nn"],
  "heave": ["hh-iy1-v", "nn vb"],
  "heaven": ["hh-eh1 v-ah-n", "nn"],
  "heavenly": ["hh-eh1 v-ah-n l-iy", "jj"],
  "heaves": ["hh-iy1-v-z", "nn vbd"],
  "heavier": ["hh-eh1 v-iy er", "jjr rbr"],
  "heaviest": ["hh-eh1 v-iy ah-s-t", "jjs"],
  "heavily": ["hh-eh1 v-ah l-iy", "rb"],
  "heavy": ["hh-eh1 v-iy", "jj nn rb"],
  "heavyweight": ["hh-eh1 v-iy w-ey-t", "nn jj"],
  "heck": ["hh-eh1-k", "nn uh"],
  "heckle": ["hh-eh1-k-ah-l", "vb"],
  "hectare": ["hh-eh1-k t-aa-r", "nn"],
  "hectic": ["hh-eh1-k t-ih-k", "jj"],
  "hedge": ["hh-eh1-jh", "vb jj nn vbp"],
  "hedgehog": ["hh-eh1-jh hh-aa-g", "nn"],
  "hedger": ["hh-eh1 jh-er", "nn"],
  "hedging": ["hh-eh1 jh-ih-ng", "vbg jj nn"],
  "hedonism": ["hh-iy1 d-ah n-ih z-ah-m", "nn"],
  "hedonistic": ["hh-iy d-ah n-ih1 s-t-ih-k", "jj"],
  "heed": ["hh-iy1-d", "vb vbp nn"],
  "heel": ["hh-iy1-l", "nn"],
  "heft": ["hh-eh1-f-t", "nn"],
  "heftier": ["hh-eh1-f t-iy er", "jjr"],
  "heftiest": ["hh-eh1-f t-iy ah-s-t", "jjs"],
  "hefty": ["hh-eh1-f t-iy", "jj"],
  "hegemonic": ["hh-eh g-ah m-aa1 n-ih-k", "jj"],
  "hegemony": ["hh-iy jh-eh1 m-ah n-iy", "nn"],
  "heifer": ["hh-eh1 f-er", "nn"],
  "height": ["hh-ay1-t", "nn"],
  "heighten": ["hh-ay1 t-ah-n", "vb"],
  "heightened": ["hh-ay1 t-ah-n-d", "vbn vbd jj"],
  "heinous": ["hh-ey1 n-ah-s", "jj"],
  "heir": ["eh1-r", "nn"],
  "heiress": ["eh1 r-ah-s", "nn"],
  "heist": ["hh-ay1-s-t", "nn"],
  "held": ["hh-eh1-l-d", "vbn vbd jj"],
  "helicopter": ["hh-eh1 l-ih k-aa-p t-er", "nn"],
  "heliotrope": ["hh-iy1 l-iy ah t-r-ow-p", "nn"],
  "helium": ["hh-iy1 l-iy ah-m", "nn"],
  "helix": ["hh-iy1 l-ih-k-s", "nn"],
  "hell": ["hh-eh1-l", "nn uh"],
  "hellfire": ["hh-eh1-l f-ay-r", "nn"],
  "hello": ["hh-ah l-ow1", "uh nn"],
  "helluva": ["hh-eh l-uw1 v-ah", "jj"],
  "helm": ["hh-eh1-l-m", "nn"],
  "helmet": ["hh-eh1-l m-ah-t", "nn"],
  "helmsman": ["hh-eh1-l-m-z m-ae-n", "nn"],
  "help": ["hh-eh1-l-p", "vb nn vbp"],
  "helper": ["hh-eh1-l p-er", "nn"],
  "helpful": ["hh-eh1-l-p f-ah-l", "jj"],
  "helpfully": ["hh-eh1-l-p f-ah l-iy", "rb"],
  "helpless": ["hh-eh1-l-p l-ah-s", "jj"],
  "helplessly": ["hh-eh1-l-p l-ah-s l-iy", "rb"],
  "helplessness": ["hh-eh1-l-p l-ah-s n-ah-s", "nn"],
  "hem": ["hh-eh1-m", "nn"],
  "hemisphere": ["hh-eh1 m-ih s-f-ih-r", "nn"],
  "hemispheric": ["hh-eh m-ah s-f-ih1 r-ih-k", "jj"],
  "hemline": ["hh-eh1-m l-ay-n", "nn"],
  "hemmed": ["hh-eh1-m-d", "vbn"],
  "hemoglobin": ["hh-iy m-ah g-l-ow1 b-ah-n", "nn"],
  "hemolytic": ["hh-iy m-ah l-ih1 t-ih-k", "jj"],
  "hemophilia": ["hh-iy m-ah f-iy1 l-iy ah", "nn"],
  "hemophiliac": ["hh-iy m-ah f-ih1 l-iy ae-k", "nn"],
  "hemorrhage": ["hh-eh1 m-er ih-jh", "nn vb"],
  "hemorrhaging": ["hh-eh1 m-er ih jh-ih-ng", "vbg jj nn"],
  "hemorrhoid": ["hh-eh1 m-er oy-d", "nn"],
  "hen": ["hh-eh1-n", "nn"],
  "hence": ["hh-eh1-n-s", "rb"],
  "henceforth": ["hh-eh1-n-s f-ao1-r-th", "rb"],
  "henchman": ["hh-eh1-n-ch m-ah-n", "nn"],
  "henpecked": ["hh-eh1-n p-eh-k-t", "jj"],
  "hepatitis": ["hh-eh p-ah t-ay1 t-ah-s", "nn"],
  "her": ["hh-er", "prp$"],
  "herald": ["hh-eh1 r-ah-l-d", "vb vbp"],
  "heraldic": ["hh-eh r-ae1-l d-ih-k", "jj"],
  "herb": ["er1-b", "nn"],
  "herbaceous": ["er b-ey1 sh-ah-s", "jj"],
  "herbal": ["er1 b-ah-l", "jj"],
  "herbicide": ["hh-er1 b-ih s-ay-d", "nn"],
  "herculean": ["hh-er k-y-uw1 l-iy ah-n", "jj"],
  "herd": ["hh-er1-d", "nn vb"],
  "here": ["hh-ih1-r", "rb"],
  "hereabout": ["hh-ih1 r-ah b-aw-t", "jj"],
  "hereabouts": ["hh-ih1 r-ah b-aw-t-s", "rb"],
  "hereafter": ["hh-ih r-ae1-f t-er", "rb"],
  "hereby": ["hh-ih-r b-ay1", "rb"],
  "hereditary": ["hh-er eh1 d-ah t-eh r-iy", "jj"],
  "heredity": ["hh-er eh1 d-ah t-iy", "nn"],
  "herein": ["hh-ih r-ih1-n", "rb"],
  "heresy": ["hh-eh1 r-ah s-iy", "nn"],
  "heretical": ["hh-er eh1 t-ih k-ah-l", "jj"],
  "heretofore": ["hh-ih-r t-ah f-ao1-r", "rb"],
  "herewith": ["hh-ih1-r w-ih1-th", "rb"],
  "heritage": ["hh-eh1 r-ah t-ah-jh", "nn"],
  "hermetically": ["hh-er m-eh1 t-ih k-ah l-iy", "rb"],
  "hero": ["hh-ih1 r-ow", "nn"],
  "heroic": ["hh-ih r-ow1 ih-k", "jj"],
  "heroically": ["hh-ih r-ow1 ih-k l-iy", "rb"],
  "heroin": ["hh-eh1 r-ow ah-n", "nn"],
  "heroine": ["hh-eh1 r-ow ah-n", "nn"],
  "heroism": ["hh-eh1 r-ow ih z-ah-m", "nn"],
  "heron": ["hh-eh1 r-ah-n", "nn"],
  "herring": ["hh-eh1 r-ih-ng", "nn"],
  "hers": ["hh-er-z", "prp jj"],
  "herself": ["hh-er s-eh1-l-f", "prp"],
  "hesitancy": ["hh-eh1 z-ih t-ah-n s-iy", "nn"],
  "hesitant": ["hh-eh1 z-ih t-ah-n-t", "jj"],
  "hesitantly": ["hh-eh1 z-ih t-ah-n-t l-iy", "rb"],
  "hesitate": ["hh-eh1 z-ah t-ey-t", "vb vbp"],
  "hesitation": ["hh-eh z-ah t-ey1 sh-ah-n", "nn"],
  "heterogeneity": ["hh-eh t-er ah jh-ih n-iy1 ah t-iy", "nn"],
  "heterogeneous": ["hh-eh t-er ah jh-iy1 n-y-ah-s", "jj"],
  "heterozygous": ["hh-eh t-er ah z-ay1 g-ah-s", "jj"],
  "hew": ["hh-y-uw1", "vb"],
  "hewn": ["hh-y-uw1-n", "vbn"],
  "hexagon": ["hh-eh1-k s-ah g-aa-n", "nn"],
  "hexagonal": ["hh-eh-k s-ae1 g-ah n-ah-l", "jj"],
  "hey": ["hh-ey1", "uh"],
  "heyday": ["hh-ey1 d-ey", "nn"],
  "hiatus": ["hh-ay ey1 t-ah-s", "nn"],
  "hibachi": ["hh-ah b-aa1 ch-iy", "nn"],
  "hibernate": ["hh-ay1 b-er n-ey-t", "vbp vb"],
  "hiccup": ["hh-ih1 k-ah-p", "nn"],
  "hick": ["hh-ih1-k", "nn"],
  "hickory": ["hh-ih1 k-er iy", "nn"],
  "hid": ["hh-ih1-d", "vbd vbn"],
  "hidden": ["hh-ih1 d-ah-n", "vbn jj"],
  "hide": ["hh-ay1-d", "vb vbp nn"],
  "hideaway": ["hh-ay1 d-ah w-ey", "nn"],
  "hidebound": ["hh-ay1-d b-aw-n-d", "jj"],
  "hideous": ["hh-ih1 d-iy ah-s", "jj"],
  "hideously": ["hh-ih1 d-iy ah-s l-iy", "rb"],
  "hideout": ["hh-ay1 d-aw-t", "nn"],
  "hierarchical": ["hh-ay r-aa1-r k-ah k-ah-l", "jj"],
  "hierarchy": ["hh-ay1 er aa-r k-iy", "nn"],
  "high": ["hh-ay1", "jj nn rb rp"],
  "highboy": ["hh-ay1 b-oy", "nn"],
  "highbrow": ["hh-ay1 b-r-aw", "jj"],
  "higher": ["hh-ay1 er", "jjr rb rbr"],
  "highest": ["hh-ay1 ah-s-t", "jjs rb rbs"],
  "highfalutin": ["hh-ay f-ah l-uw1 t-ih-n", "jj"],
  "highflying": ["hh-ay1 f-l-ay ih-ng", "jj"],
  "highland": ["hh-ay1 l-ah-n-d", "nn"],
  "highlight": ["hh-ay1 l-ay-t", "vb vbp nn"],
  "highly": ["hh-ay1 l-iy", "rb"],
  "highness": ["hh-ay1 n-ah-s", "nn"],
  "highway": ["hh-ay1 w-ey", "nn"],
  "highyield": ["hh-ay1 y-iy1-l-d", "jj"],
  "hijack": ["hh-ay1-jh-ae-k", "vb"],
  "hijacker": ["hh-ay1 jh-ae k-er", "nn"],
  "hijacking": ["hh-ay1 jh-ae k-ih-ng", "nn vbg"],
  "hike": ["hh-ay1-k", "nn vb"],
  "hiker": ["hh-ay1 k-er", "nn"],
  "hilarious": ["hh-ih l-eh1 r-iy ah-s", "jj"],
  "hilariously": ["hh-ih l-eh1 r-iy ah-s l-iy", "rb"],
  "hilarity": ["hh-ih l-eh1 r-ah t-iy", "nn"],
  "hill": ["hh-ih1-l", "nn"],
  "hillbilly": ["hh-ih1-l b-ih l-iy", "nn"],
  "hillside": ["hh-ih1-l s-ay-d", "nn"],
  "hilltop": ["hh-ih1-l t-aa-p", "nn"],
  "hilly": ["hh-ih1 l-iy", "jj"],
  "hilt": ["hh-ih1-l-t", "nn"],
  "him": ["hh-ih1-m", "prp"],
  "himself": ["hh-ih-m s-eh1-l-f", "prp"],
  "hind": ["hh-ay1-n-d", "jj"],
  "hinder": ["hh-ih1-n d-er", "vb"],
  "hindering": ["hh-ih1-n d-er ih-ng", "vbg jj"],
  "hindquarter": ["hh-ay1-n-d k-w-ao-r t-er", "nn"],
  "hindrance": ["hh-ih1-n d-r-ah-n-s", "nn"],
  "hindsight": ["hh-ay1-n-d s-ay-t", "nn"],
  "hinge": ["hh-ih1-n-jh", "vb nn"],
  "hint": ["hh-ih1-n-t", "nn vbp vb"],
  "hinterland": ["hh-ih1-n t-er l-ae-n-d", "nn"],
  "hip": ["hh-ih1-p", "nn jj"],
  "hipper": ["hh-ih1 p-er", "jjr"],
  "hippie": ["hh-ih1 p-iy", "nn"],
  "hire": ["hh-ay1 er", "vb vbp nn"],
  "hired": ["hh-ay1 er-d", "vbn jj vbd"],
  "his": ["hh-ih1-z", "prp$"],
  "hissed": ["hh-ih1-s-t", "vbd"],
  "histology": ["hh-ih s-t-aa1 l-ah jh-iy", "nn"],
  "historian": ["hh-ih s-t-ao1 r-iy ah-n", "nn"],
  "historic": ["hh-ih s-t-ao1 r-ih-k", "jj"],
  "historical": ["hh-ih s-t-ao1 r-ih k-ah-l", "jj"],
  "historically": ["hh-ih s-t-ao1 r-ih k-ah l-iy", "rb"],
  "historiography": ["hh-ih s-t-ao r-iy aa1 g-r-ah f-iy", "nn"],
  "history": ["hh-ih1 s-t-er iy", "nn"],
  "hit": ["hh-ih1-t", "vbd jj nn vb vbn vbp"],
  "hitch": ["hh-ih1-ch", "nn vb"],
  "hither": ["hh-ih1 dh-er", "rb"],
  "hitherto": ["hh-ih1 dh-er t-uw1", "rb"],
  "hitter": ["hh-ih1 t-er", "nn"],
  "hive": ["hh-ay1-v", "nn"],
  "hoard": ["hh-ao1-r-d", "nn vb vbp"],
  "hoarse": ["hh-ao1-r-s", "jj"],
  "hoarseness": ["hh-ao1-r-s n-ah-s", "nn"],
  "hoax": ["hh-ow1-k-s", "nn"],
  "hob": ["hh-aa1-b", "nn"],
  "hobble": ["hh-aa1 b-ah-l", "vb"],
  "hobby": ["hh-aa1 b-iy", "nn"],
  "hobbyist": ["hh-aa1 b-iy ih-s-t", "nn"],
  "hobnob": ["hh-aa1-b n-aa-b", "vb"],
  "hock": ["hh-aa1-k", "nn vb"],
  "hockey": ["hh-aa1 k-iy", "nn"],
  "hodgepodge": ["hh-aa1-jh p-aa-jh", "nn"],
  "hoe": ["hh-ow1", "nn"],
  "hog": ["hh-aa1-g", "nn"],
  "hoist": ["hh-oy1-s-t", "vb"],
  "hoisting": ["hh-oy1 s-t-ih-ng", "nn"],
  "hokey": ["hh-ow1 k-iy", "jj"],
  "hold": ["hh-ow1-l-d", "vb nn rb vbp"],
  "holder": ["hh-ow1-l d-er", "nn"],
  "holding": ["hh-ow1-l d-ih-ng", "vbg jj nn"],
  "holdout": ["hh-ow1-l-d aw-t", "nn"],
  "holdover": ["hh-ow1-l-d ow v-er", "nn"],
  "holdup": ["hh-ow1-l-d ah-p", "nn"],
  "hole": ["hh-ow1-l", "nn vbp vb"],
  "holiday": ["hh-aa1 l-ah d-ey", "nn"],
  "holiest": ["hh-ow1 l-iy ih-s-t", "jjs"],
  "holistic": ["hh-ow l-ih1 s-t-ih-k", "jj"],
  "holler": ["hh-aa1 l-er", "vb"],
  "hollering": ["hh-aa1 l-er ih-ng", "vbg jj"],
  "hollow": ["hh-aa1 l-ow", "jj nn"],
  "hollyhock": ["hh-aa1 l-iy hh-aa-k", "nn"],
  "holocaust": ["hh-aa1 l-ah k-ao-s-t", "nn"],
  "holster": ["hh-ow1-l s-t-er", "nn"],
  "holy": ["hh-ow1 l-iy", "jj"],
  "homage": ["aa1 m-ah-jh", "nn"],
  "home": ["hh-ow1-m", "nn vbp rb vb"],
  "homebuilder": ["hh-ow1-m b-ih-l d-er", "nn"],
  "homebuilding": ["hh-ow1-m b-ih-l d-ih-ng", "nn"],
  "homecoming": ["hh-ow1-m k-ah m-ih-ng", "nn"],
  "homeland": ["hh-ow1-m l-ae-n-d", "nn"],
  "homeless": ["hh-ow1-m l-ah-s", "jj nn"],
  "homelessness": ["hh-ow1-m l-ah-s n-ah-s", "nn"],
  "homely": ["hh-ow1-m l-iy", "jj"],
  "homemade": ["hh-ow1-m m-ey1-d", "jj"],
  "homemaker": ["hh-ow1-m m-ey k-er", "nn"],
  "homeowner": ["hh-ow1 m-ow n-er", "nn"],
  "homer": ["hh-ow1 m-er", "nn vb"],
  "homesick": ["hh-ow1-m s-ih-k", "jj"],
  "homesickness": ["hh-ow1-m s-ih-k n-ah-s", "nn"],
  "homespun": ["hh-ow1-m s-p-ah-n", "jj"],
  "homestead": ["hh-ow1-m s-t-eh-d", "nn"],
  "hometown": ["hh-ow1-m t-aw-n", "nn jj"],
  "homeward": ["hh-ow1-m w-er-d", "rb"],
  "homework": ["hh-ow1-m w-er-k", "nn"],
  "homey": ["hh-ow1 m-iy", "jj"],
  "homicidal": ["hh-aa m-ah s-ay1 d-ah-l", "jj"],
  "homicide": ["hh-aa1 m-ah s-ay-d", "nn"],
  "homily": ["hh-ow1 m-ah l-iy", "nn"],
  "homogeneity": ["hh-aa m-ah jh-ah n-iy1 ah t-iy", "nn"],
  "homogeneous": ["hh-ow m-ah jh-iy1 n-iy ah-s", "jj"],
  "homogenize": ["hh-ow-m-aa1-jh-ah-n-ay-z", "vb"],
  "homogenous": ["hh-ah m-aa1 jh-ah n-ah-s", "jj"],
  "homologous": ["hh-ah m-aa1 l-ah g-ah-s", "rb"],
  "homophobia": ["hh-ow m-ah f-ow1 b-iy ah", "nn"],
  "homosexual": ["hh-ow m-ow s-eh1-k sh-ah w-ah-l", "jj nn"],
  "homosexuality": ["hh-ow m-ow s-eh-k sh-ah-w ae1 l-ah t-iy", "nn"],
  "hone": ["hh-ow1-n", "vb vbp nn"],
  "honed": ["hh-ow1-n-d", "vbn jj"],
  "honest": ["aa1 n-ah-s-t", "jj"],
  "honestly": ["aa1 n-ah-s-t l-iy", "rb"],
  "honesty": ["aa1 n-ah s-t-iy", "nn"],
  "honey": ["hh-ah1 n-iy", "nn vb uh jj"],
  "honeybee": ["hh-ah1 n-iy b-iy", "nn"],
  "honeymoon": ["hh-ah1 n-iy m-uw-n", "nn vb"],
  "honeymooner": ["hh-ah1 n-iy m-uw n-er", "nn"],
  "honk": ["hh-aa1-ng-k", "vb vbp"],
  "honor": ["aa1 n-er", "nn vbp vb"],
  "honorable": ["aa1 n-er ah b-ah-l", "jj nn"],
  "honorably": ["aa1 n-er ah b-l-iy", "rb"],
  "honorarium": ["aa n-er eh1 r-iy ah-m", "nn"],
  "honorary": ["aa1 n-er eh r-iy", "jj"],
  "honored": ["aa1 n-er-d", "vbn jj vbd"],
  "honorific": ["aa n-er ih1 f-ih-k", "nn"],
  "hooch": ["hh-uw1-ch", "nn"],
  "hood": ["hh-uh1-d", "nn"],
  "hoodlum": ["hh-uh1-d l-ah-m", "nn"],
  "hoodwink": ["hh-uh1-d-w-ih-ng-k", "vb"],
  "hoof": ["hh-uw1-f", "nn"],
  "hook": ["hh-uh1-k", "nn vb"],
  "hooked": ["hh-uh1-k-t", "vbn jj vbd"],
  "hooker": ["hh-uh1 k-er", "nn"],
  "hookup": ["hh-uh1-k ah-p", "nn"],
  "hookworm": ["hh-uh1-k w-er-m", "nn"],
  "hooliganism": ["hh-uw1 l-ih g-ah n-ih z-ah-m", "nn"],
  "hoop": ["hh-uw1-p", "nn"],
  "hoopla": ["hh-uw1 p-l-aa", "nn"],
  "hoot": ["hh-uw1-t", "nn vb vbp"],
  "hop": ["hh-aa1-p", "nn vb"],
  "hope": ["hh-ow1-p", "nn vb vbp"],
  "hopeful": ["hh-ow1-p f-ah-l", "jj nn"],
  "hopefully": ["hh-ow1-p f-ah l-iy", "rb"],
  "hopeless": ["hh-ow1-p l-ah-s", "jj"],
  "hopelessly": ["hh-ow1-p l-ah-s l-iy", "rb"],
  "hopelessness": ["hh-ow1-p l-ah-s n-ah-s", "nn"],
  "hopper": ["hh-aa1 p-er", "nn"],
  "hopscotch": ["hh-aa1-p s-k-aa-ch", "nn"],
  "horde": ["hh-ao1-r-d", "nn"],
  "horizon": ["hh-er ay1 z-ah-n", "nn"],
  "horizontal": ["hh-ao r-ah z-aa1-n t-ah-l", "jj nn"],
  "horizontally": ["hh-ao r-ih z-aa1-n t-ah l-iy", "rb"],
  "hormonal": ["hh-ao1-r m-ow n-ah-l", "jj"],
  "hormone": ["hh-ao1-r m-ow-n", "nn"],
  "horn": ["hh-ao1-r-n", "nn vb"],
  "horned": ["hh-ao1-r-n-d", "jj"],
  "hornet": ["hh-ao1-r n-ih-t", "nn"],
  "horoscope": ["hh-ao1 r-ah s-k-ow-p", "nn"],
  "horrendous": ["hh-ao r-eh1-n d-ah-s", "jj"],
  "horrible": ["hh-ao1 r-ah b-ah-l", "jj nn"],
  "horribly": ["hh-ao1 r-ah b-l-iy", "rb"],
  "horrid": ["hh-ao1 r-ah-d", "jj"],
  "horrific": ["hh-ao r-ih1 f-ih-k", "jj"],
  "horrified": ["hh-ao1 r-ah f-ay-d", "vbn jj"],
  "horrify": ["hh-ao1-r-ah-f-ay", "vb"],
  "horrifying": ["hh-ao1 r-ah f-ay ih-ng", "jj"],
  "horror": ["hh-ao1 r-er", "nn"],
  "horse": ["hh-ao1-r-s", "nn"],
  "horseback": ["hh-ao1-r-s b-ae-k", "nn jj rb"],
  "horseflesh": ["hh-ao1-r-s f-l-eh-sh", "nn"],
  "horseman": ["hh-ao1-r-s m-ah-n", "nn"],
  "horsemanship": ["hh-ao1-r-s m-ah-n sh-ih-p", "nn"],
  "horseplay": ["hh-ao1-r-s p-l-ey", "nn"],
  "horsepower": ["hh-ao1-r-s p-aw er", "nn"],
  "horseradish": ["hh-ao1-r-s r-ae d-ih-sh", "nn"],
  "horticultural": ["hh-ao-r t-ah k-ah1-l ch-er ah-l", "jj"],
  "horticulture": ["hh-ao1-r t-ih k-ah-l ch-er", "nn"],
  "horticulturist": ["hh-ao-r t-ih k-ah1-l ch-er ih-s-t", "nn"],
  "hose": ["hh-ow1-z", "nn vb"],
  "hospice": ["hh-aa1-s p-ah-s", "nn"],
  "hospitable": ["hh-aa1 s-p-ih1 t-ah b-ah-l", "jj"],
  "hospital": ["hh-aa1-s p-ih t-ah-l", "nn"],
  "hospitality": ["hh-aa-s p-ah t-ae1 l-ah t-iy", "nn"],
  "hospitalization": ["hh-aa-s p-ih t-ah-l ah z-ey1 sh-ah-n", "nn"],
  "hospitalize": ["hh-ao1-s-p-ih-t-ah-l-ay-z", "vb"],
  "hospitalized": ["hh-aa1-s p-ih t-ah-l ay-z-d", "vbn jj"],
  "hoss": ["hh-aa1-s", "nn"],
  "host": ["hh-ow1-s-t", "nn vb"],
  "hostage": ["hh-aa1 s-t-ih-jh", "nn"],
  "hosted": ["hh-ow1 s-t-ih-d", "vbn jj vbd"],
  "hostess": ["hh-ow1 s-t-ah-s", "nn"],
  "hostile": ["hh-aa1 s-t-ah-l", "jj nn"],
  "hostility": ["hh-aa s-t-ih1 l-ah t-iy", "nn"],
  "hostler": ["hh-aa1-s l-er", "nn"],
  "hot": ["hh-aa1-t", "jj"],
  "hotbed": ["hh-aa1-t b-eh-d", "nn"],
  "hotdog": ["hh-aa1-t d-ao-g", "nn"],
  "hotel": ["hh-ow t-eh1-l", "nn"],
  "hotelier": ["hh-ow t-eh1 l-y-er", "nn"],
  "hothouse": ["hh-aa1-t hh-aw-s", "jj"],
  "hotline": ["hh-aa1-t l-ay-n", "nn"],
  "hotly": ["hh-aa1-t l-iy", "rb"],
  "hotter": ["hh-aa1 t-er", "jjr"],
  "hottest": ["hh-aa1 t-ah-s-t", "jjs"],
  "hound": ["hh-aw1-n-d", "nn vb"],
  "hour": ["aw1 er", "nn"],
  "hourlong": ["aw1-r l-ao-ng", "jj"],
  "hourly": ["aw1-r l-iy", "jj"],
  "house": ["hh-aw1-s", "nn vbp vb"],
  "houseboat": ["hh-aw1-s b-ow-t", "nn"],
  "housebroken": ["hh-aw1-s b-r-ow k-ah-n", "jj"],
  "housecleaning": ["hh-aw1-s-k l-iy n-ih-ng", "nn"],
  "houseful": ["hh-aw1-s f-ah-l", "nn"],
  "household": ["hh-aw1-s hh-ow-l-d", "nn jj"],
  "householder": ["hh-aw1-s hh-ow-l d-er", "nn"],
  "housekeeper": ["hh-aw1-s k-iy p-er", "nn"],
  "housekeeping": ["hh-aw1-s k-iy p-ih-ng", "nn"],
  "houseman": ["hh-aw1-s m-ah-n", "nn"],
  "houseware": ["hh-aw1-s w-eh-r", "nn"],
  "housewife": ["hh-aw1-s w-ay-f", "nn"],
  "housework": ["hh-aw1-s w-er-k", "nn"],
  "housing": ["hh-aw1 z-ih-ng", "nn vbg jj"],
  "hove": ["hh-ow1-v", "vbd"],
  "hovel": ["hh-ah1 v-ah-l", "nn"],
  "hover": ["hh-ah1 v-er", "vb vbp"],
  "how": ["hh-aw1", "wrb"],
  "howdy": ["hh-aw1 d-iy", "uh"],
  "howe": ["hh-aw1", "wrb"],
  "however": ["hh-aw eh1 v-er", "rb rbr wrb"],
  "howitzer": ["hh-aw1 ah-t s-er", "nn"],
  "howl": ["hh-aw1-l", "nn vb"],
  "hub": ["hh-ah1-b", "nn"],
  "hubbub": ["hh-ah1 b-ah-b", "nn"],
  "hubby": ["hh-ah1 b-iy", "nn"],
  "hubris": ["hh-y-uw1 b-r-ah-s", "nn"],
  "huckster": ["hh-ah1-k s-t-er", "nn vb"],
  "huddle": ["hh-ah1 d-ah-l", "nn vb"],
  "huddled": ["hh-ah1 d-ah-l-d", "vbd vbn jj"],
  "hue": ["hh-y-uw1", "nn"],
  "huff": ["hh-ah1-f", "vb"],
  "hug": ["hh-ah1-g", "nn vb vbp"],
  "huge": ["hh-y-uw1-jh", "jj"],
  "hugely": ["hh-y-uw1-jh l-iy", "rb"],
  "huh": ["hh-ah1", "uh"],
  "hulk": ["hh-ah1-l-k", "nn vb"],
  "hulking": ["hh-ah1-l k-ih-ng", "jj vbg"],
  "hull": ["hh-ah1-l", "nn"],
  "hullabaloo": ["hh-ah l-ah b-ah l-uw1", "nn"],
  "hum": ["hh-ah1-m", "nn vb"],
  "human": ["hh-y-uw1 m-ah-n", "jj nn"],
  "humane": ["hh-y-uw m-ey1-n", "jj"],
  "humanism": ["hh-y-uw1 m-ah n-ih z-ah-m", "nn"],
  "humanist": ["hh-y-uw1 m-ah n-ih-s-t", "jj nn"],
  "humanistic": ["hh-y-uw m-ah n-ih1 s-t-ih-k", "jj"],
  "humanitarian": ["hh-y-uw m-ae n-ah t-eh1 r-iy ah-n", "jj nn"],
  "humanity": ["hh-y-uw m-ae1 n-ih t-iy", "nn"],
  "humanize": ["hh-y-uw1 m-ah n-ay-z", "vb"],
  "humankind": ["hh-y-uw1 m-ah-n k-ay-n-d", "nn"],
  "humanly": ["hh-y-uw1 m-ah-n l-iy", "rb"],
  "humanness": ["hh-y-uw1 m-ah-n n-ah-s", "nn"],
  "humble": ["hh-ah1-m b-ah-l", "jj vb"],
  "humblest": ["hh-ah1-m b-ah l-ah-s-t", "jjs"],
  "humbling": ["hh-ah1-m b-ah-l ih-ng", "jj"],
  "humbly": ["hh-ah1-m b-l-iy", "rb"],
  "humid": ["hh-y-uw1 m-ah-d", "jj"],
  "humidity": ["hh-y-uw m-ih1 d-ah t-iy", "nn"],
  "humiliate": ["hh-y-uw-m-ih1-l-iy-ey-t", "vb"],
  "humiliated": ["hh-y-uw m-ih1 l-iy ey t-ih-d", "vbn jj"],
  "humiliating": ["hh-y-uw m-ih1 l-iy ey t-ih-ng", "jj"],
  "humiliation": ["hh-y-uw m-ih l-iy ey1 sh-ah-n", "nn"],
  "humility": ["hh-y-uw m-ih1 l-ih t-iy", "nn"],
  "humongous": ["hh-y-uw m-ao1-ng g-ah-s", "jj"],
  "humor": ["hh-y-uw1 m-er", "nn vb"],
  "humorist": ["hh-y-uw1 m-er ah-s-t", "nn"],
  "humorless": ["hh-y-uw1 m-er l-ah-s", "jj"],
  "humorous": ["hh-y-uw1 m-er ah-s", "jj"],
  "hump": ["hh-ah1-m-p", "nn"],
  "humped": ["hh-ah1-m-p-t", "nn"],
  "hunch": ["hh-ah1-n-ch", "nn vb"],
  "hunched": ["hh-ah1-n-ch-t", "vbn vbd jj"],
  "hundred": ["hh-ah1-n d-r-ah-d", "nn"],
  "hundredth": ["hh-ah1-n d-r-ah-d-th", "jj"],
  "hundredweight": ["hh-ah1-n d-r-ah-d w-ey-t", "nn"],
  "hung": ["hh-ah1-ng", "vbd jj vbn"],
  "hunger": ["hh-ah1-ng g-er", "nn"],
  "hungrier": ["hh-ah1-ng g-r-iy er", "jjr"],
  "hungrily": ["hh-ah1-ng g-r-ah l-iy", "rb"],
  "hungry": ["hh-ah1-ng g-r-iy", "jj"],
  "hunk": ["hh-ah1-ng-k", "nn"],
  "hunker": ["hh-ah1-ng k-er", "vb"],
  "hunt": ["hh-ah1-n-t", "nn vb vbp"],
  "hunted": ["hh-ah1-n t-ah-d", "vbn vbd jj"],
  "hunter": ["hh-ah1-n t-er", "nn"],
  "hurdle": ["hh-er1 d-ah-l", "nn vb"],
  "hurl": ["hh-er1-l", "vb vbp"],
  "hurley": ["hh-er1 l-iy", "nn"],
  "hurrah": ["hh-uh r-aa1", "nn"],
  "hurricane": ["hh-er1 ah k-ey-n", "nn"],
  "hurried": ["hh-er1 iy-d", "vbd vbn jj"],
  "hurriedly": ["hh-er1 iy-d l-iy", "rb"],
  "hurry": ["hh-er1 iy", "nn vbp vb"],
  "hurrying": ["hh-er1 iy ih-ng", "vbg jj"],
  "hurt": ["hh-er1-t", "vbn jj nn vb vbd vbp"],
  "hurtle": ["hh-er1-t-ah-l", "vb"],
  "husband": ["hh-ah1-z b-ah-n-d", "nn"],
  "husbandry": ["hh-ah1-z b-ah-n d-r-iy", "nn"],
  "hush": ["hh-ah1-sh", "jj nn uh"],
  "hushed": ["hh-ah1-sh-t", "jj"],
  "husk": ["hh-ah1-s-k", "nn"],
  "husky": ["hh-ah1-s k-iy", "jj"],
  "hustings": ["hh-ah1 s-t-ih-ng-z", "nn"],
  "hustle": ["hh-ah1 s-ah-l", "vb nn"],
  "hustler": ["hh-ah1 s-ah l-er", "nn"],
  "hut": ["hh-ah1-t", "nn"],
  "hutch": ["hh-ah1-ch", "nn"],
  "hyacinth": ["hh-ay1 ah s-ih-n-th", "nn"],
  "hyaluronic": ["hh-ay ah l-er aa1 n-ih-k", "jj"],
  "hybrid": ["hh-ay1 b-r-ah-d", "jj nn"],
  "hydrated": ["hh-ay1 d-r-ey t-ah-d", "jj"],
  "hydration": ["hh-ay d-r-ey1 sh-ah-n", "nn"],
  "hydraulic": ["hh-ay d-r-ao1 l-ih-k", "jj"],
  "hydraulics": ["hh-ay d-r-ao1 l-ih-k-s", "nn"],
  "hydride": ["hh-ay1 d-r-ay-d", "nn"],
  "hydrocarbon": ["hh-ay d-r-ow k-aa1-r b-ah-n", "nn"],
  "hydroelectric": ["hh-ay d-r-ow ih l-eh1-k t-r-ih-k", "jj"],
  "hydrogen": ["hh-ay1 d-r-ah jh-ah-n", "nn"],
  "hydrolysis": ["hh-ay d-r-aa1 l-ah s-ah-s", "nn"],
  "hydrolyze": ["hh-ay1-d-r-ah-l-ay-z", "vb"],
  "hydrophilic": ["hh-ay d-r-ah f-ih1 l-ih-k", "jj"],
  "hydrotherapy": ["hh-ay d-r-ow th-eh1 r-ah p-iy", "nn"],
  "hydrous": ["hh-ay1 d-r-ah-s", "jj"],
  "hyena": ["hh-ay iy1 n-ah", "nn"],
  "hygiene": ["hh-ay1 jh-iy-n", "nn"],
  "hymn": ["hh-ih1-m", "nn"],
  "hype": ["hh-ay1-p", "nn vb"],
  "hyper": ["hh-ay1 p-er", "jj"],
  "hyperactive": ["hh-ay p-er ae1-k t-ih-v", "jj"],
  "hyperbole": ["hh-ay p-er1 b-ah l-iy", "nn"],
  "hyperbolic": ["hh-ay p-er b-aa1 l-ih-k", "jj"],
  "hyperinflation": ["hh-ay p-er ih-n f-l-ey1 sh-ah-n", "nn"],
  "hypermarket": ["hh-ay1 p-er m-aa-r k-ih-t", "nn"],
  "hypersonic": ["hh-ay p-er s-aa1 n-ih-k", "jj"],
  "hypertension": ["hh-ay p-er t-eh1-n sh-ah-n", "nn"],
  "hyphenate": ["hh-ay1-f-ah-n-ey-t", "vb"],
  "hyphenated": ["hh-ay1 f-ah n-ey t-ih-d", "jj vbn"],
  "hypnosis": ["hh-ih-p n-ow1 s-ah-s", "nn"],
  "hypnotic": ["hh-ih-p n-aa1 t-ih-k", "jj"],
  "hypnotize": ["hh-ih1-p-n-ah-t-ay-z", "vb"],
  "hypocrisy": ["hh-ih p-aa1 k-r-ah s-iy", "nn"],
  "hypocrite": ["hh-ih1 p-ah k-r-ih-t", "nn"],
  "hypocritical": ["hh-ih p-ah k-r-ih1 t-ih k-ah-l", "jj"],
  "hypodermic": ["hh-ay p-ah d-er1 m-ih-k", "jj"],
  "hypoglycemia": ["hh-ay p-ow g-l-ay s-iy1 m-iy ah", "nn"],
  "hypoglycemic": ["hh-ay p-ow g-l-ay s-iy1 m-ih-k", "jj"],
  "hypothalamic": ["hh-ay p-ow th-ah l-ae1 m-ih-k", "jj"],
  "hypothesis": ["hh-ay p-aa1 th-ah s-ah-s", "nn"],
  "hypothesize": ["hh-ay p-aa1 th-ah s-ay-z", "vb"],
  "hypothetical": ["hh-ay p-ah th-eh1 t-ah k-ah-l", "jj"],
  "hypothetically": ["hh-ay p-ah th-eh1 t-ih-k l-iy", "rb"],
  "hysterectomy": ["hh-ih s-t-er eh1-k t-ah m-iy", "nn"],
  "hysteria": ["hh-ih s-t-eh1 r-iy ah", "nn"],
  "hysterical": ["hh-ih s-t-eh1 r-ih k-ah-l", "jj"],
  "hysterically": ["hh-ih s-t-eh1 r-ih-k l-iy", "rb"],
  "i": ["ay1", "prp"],
  "ice": ["ay1-s", "nn jj"],
  "iceberg": ["ay1-s b-er-g", "nn"],
  "icebox": ["ay1-s b-aa-k-s", "nn"],
  "iced": ["ay1-s-t", "jj"],
  "icing": ["ay1 s-ih-ng", "nn"],
  "icon": ["ay1 k-aa-n", "nn"],
  "iconoclasm": ["ay k-aa1 n-ah k-l-ae z-ah-m", "nn"],
  "iconoclast": ["ay k-aa1 n-ah k-l-ae-s-t", "nn"],
  "iconoclastic": ["ay k-ah n-ah k-l-ae1 s-t-ih-k", "jj"],
  "icy": ["ay1 s-iy", "jj"],
  "idea": ["ay d-iy1 ah", "nn"],
  "ideal": ["ay d-iy1-l", "jj nn"],
  "idealism": ["ay d-iy1 l-ih z-ah-m", "nn"],
  "idealist": ["ay d-iy1 l-ih-s-t", "nn"],
  "idealistic": ["ay d-iy ah l-ih1 s-t-ih-k", "jj"],
  "idealize": ["ay-d-iy1-ah-l-ay-z", "vb"],
  "idealized": ["ay d-iy1 ah l-ay-z-d", "vbn jj"],
  "ideally": ["ay d-iy1 l-iy", "rb"],
  "identical": ["ay d-eh1-n t-ih k-ah-l", "jj"],
  "identifiable": ["ay d-eh1-n t-ah f-ay ah b-ah-l", "jj"],
  "identification": ["ay d-eh-n t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "identify": ["ay d-eh1-n t-ah f-ay", "vb vbp"],
  "identity": ["ay d-eh1-n t-ah t-iy", "nn"],
  "ideological": ["ay d-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "ideologically": ["ay d-iy ah l-aa1 jh-ih-k l-iy", "rb"],
  "ideologist": ["ay d-iy aa1 l-ah jh-ah-s-t", "nn"],
  "ideologue": ["ay1 d-iy ah l-ao-g", "nn"],
  "ideology": ["ay d-iy aa1 l-ah jh-iy", "nn"],
  "idiocy": ["ih1 d-iy ah s-iy", "nn"],
  "idiom": ["ih1 d-iy ah-m", "nn"],
  "idiomatic": ["ih d-iy ah m-ae1 t-ih-k", "jj"],
  "idiosyncratic": ["ih d-iy ow s-ih-n k-r-ae1 t-ih-k", "jj"],
  "idiot": ["ih1 d-iy ah-t", "jj nn"],
  "idiotic": ["ih d-iy aa1 t-ih-k", "jj"],
  "idiotically": ["ih d-iy aa1 t-ih-k l-iy", "rb"],
  "idle": ["ay1 d-ah-l", "jj vb"],
  "idleness": ["ay1 d-ah-l n-ah-s", "nn"],
  "idler": ["ay1 d-ah l-er", "nn"],
  "idly": ["ay1-d l-iy", "rb"],
  "idol": ["ay1 d-ah-l", "nn"],
  "idolize": ["ay1 d-ah l-ay-z", "vb vbp"],
  "idolized": ["ay1 d-ah l-ay-z-d", "jj"],
  "idyll": ["ay1 d-ah-l", "nn"],
  "idyllic": ["ay d-ih1 l-ih-k", "jj"],
  "if": ["ih1-f", "in"],
  "iffy": ["ih1 f-iy", "jj"],
  "igloo": ["ih1 g-l-uw", "nn"],
  "igneous": ["ih1-g n-iy ah-s", "jj"],
  "ignite": ["ih-g n-ay1-t", "vb"],
  "ignition": ["ih-g n-ih1 sh-ah-n", "nn"],
  "ignoble": ["ih-g n-ow1 b-ah-l", "jj"],
  "ignominious": ["ih-g n-ah m-ih1 n-iy ah-s", "jj"],
  "ignoramus": ["ih-g n-er ey1 m-ah-s", "nn"],
  "ignorance": ["ih1-g n-er ah-n-s", "nn"],
  "ignorant": ["ih1-g n-er ah-n-t", "jj"],
  "ignore": ["ih-g n-ao1-r", "vb vbp"],
  "iguana": ["ay g-w-aa1 n-ah", "jj"],
  "ilk": ["ih1-l-k", "nn"],
  "ill": ["ih1-l", "jj rb"],
  "illegal": ["ih l-iy1 g-ah-l", "jj"],
  "illegality": ["ih l-iy g-ae1 l-ih t-iy", "nn"],
  "illegally": ["ih l-iy1 g-ah l-iy", "rb"],
  "illegitimacy": ["ih l-ih jh-ih1 t-ah m-ah s-iy", "nn"],
  "illegitimate": ["ih l-ih jh-ih1 t-ah m-ih-t", "jj"],
  "illicit": ["ih l-ih1 s-ah-t", "jj"],
  "illicitly": ["ih1 l-ih s-ih-t l-iy", "rb"],
  "illiquid": ["ih l-ih1 k-w-ih-d", "jj"],
  "illiquidity": ["ih l-ih k-w-ih1 d-ih t-iy", "nn"],
  "illiteracy": ["ih l-ih1 t-er ah s-iy", "nn"],
  "illiterate": ["ih l-ih1 t-er ah-t", "jj"],
  "illness": ["ih1-l n-ah-s", "nn"],
  "illogic": ["ih l-aa1 jh-ih-k", "nn"],
  "illogical": ["ih l-aa1 jh-ih k-ah-l", "jj"],
  "illuminate": ["ih l-uw1 m-ih n-ih-t", "vb"],
  "illuminated": ["ih l-uw1 m-ah n-ey t-ah-d", "vbn jj vbd"],
  "illuminating": ["ih l-uw1 m-ah n-ey t-ih-ng", "jj vbg"],
  "illumination": ["ih l-uw m-ah n-ey1 sh-ah-n", "nn"],
  "illumine": ["ih l-uw1 m-ah-n", "vb"],
  "illusion": ["ih l-uw1 zh-ah-n", "nn"],
  "illusionary": ["ih l-uw1 zh-ah n-eh r-iy", "jj"],
  "illusionist": ["ih l-uw1 zh-ah n-ah-s-t", "nn"],
  "illusory": ["ih l-uw1 s-er iy", "jj"],
  "illustrate": ["ih1 l-ah-s t-r-ey-t", "vb vbp"],
  "illustrated": ["ih1 l-ah-s t-r-ey t-ah-d", "vbn jj vbd"],
  "illustration": ["ih l-ah-s t-r-ey1 sh-ah-n", "nn"],
  "illustrative": ["ih l-ah1-s t-r-ah t-ih-v", "jj"],
  "illustrator": ["ih1 l-ah-s t-r-ey t-er", "nn"],
  "illustrious": ["ih l-ah1-s t-r-iy ah-s", "jj"],
  "image": ["ih1 m-ah-jh", "nn vb"],
  "imagery": ["ih1 m-ah jh-r-iy", "nn"],
  "imaginable": ["ih m-ae1 jh-ah n-ah b-ah-l", "jj"],
  "imaginary": ["ih m-ae1 jh-ah n-eh r-iy", "jj nn"],
  "imagination": ["ih m-ae jh-ah n-ey1 sh-ah-n", "nn"],
  "imaginative": ["ih m-ae1 jh-ah n-ah t-ih-v", "jj"],
  "imaginatively": ["ih m-ae1 jh-ah n-ah t-ih-v l-iy", "rb"],
  "imagine": ["ih m-ae1 jh-ah-n", "vb vbp"],
  "imagined": ["ih m-ae1 jh-ah-n-d", "vbn vbd jj"],
  "imaging": ["ih1 m-ih jh-ih-ng", "nn jj"],
  "imbalance": ["ih-m b-ae1 l-ah-n-s", "nn"],
  "imbibe": ["ih-m b-ay1-b", "vb"],
  "imbroglio": ["ih-m b-r-ow1 l-y-ow", "nn"],
  "imbue": ["ih-m-b-y-uw1", "vb"],
  "imitate": ["ih1 m-ah t-ey-t", "vb vbp"],
  "imitation": ["ih m-ah t-ey1 sh-ah-n", "nn"],
  "imitative": ["ih1 m-ah t-ey t-ih-v", "jj"],
  "imitator": ["ih1 m-ih t-ey t-er", "nn"],
  "immaculate": ["ih m-ae1 k-y-uw l-ih-t-s", "jj"],
  "immanent": ["ih1 m-ah n-ah-n-t", "jj"],
  "immaterial": ["ih m-ah t-ih1 r-iy ah-l", "jj"],
  "immature": ["ih m-ah t-y-uh1-r", "jj"],
  "immaturity": ["ih m-ah ch-uh1 r-ih t-iy", "nn"],
  "immeasurably": ["ih m-eh1 zh-er ae b-l-iy", "rb"],
  "immediacy": ["ih m-iy1 d-iy ah s-iy", "nn"],
  "immediate": ["ih m-iy1 d-iy ah-t", "jj"],
  "immediately": ["ih m-iy1 d-iy ah-t l-iy", "rb"],
  "immemorial": ["ih m-ah m-ao1 r-iy ah-l", "jj"],
  "immense": ["ih m-eh1-n-s", "jj nn"],
  "immensely": ["ih m-eh1-n-s l-iy", "rb"],
  "immerse": ["ih-m-er1-s", "vb"],
  "immersion": ["ih m-er1 zh-ah-n", "nn"],
  "immigrant": ["ih1 m-ah g-r-ah-n-t", "nn jj"],
  "immigrate": ["ih1-m-ah-g-r-ey-t", "vb"],
  "immigration": ["ih m-ah g-r-ey1 sh-ah-n", "nn"],
  "imminent": ["ih1 m-ah n-ah-n-t", "jj"],
  "imminently": ["ih1 m-ah n-ah-n-t l-iy", "rb"],
  "immobility": ["ih m-ow b-ih1 l-ih t-iy", "nn"],
  "immobilize": ["ih-m-ow1-b-ah-l-ay-z", "vb"],
  "immoral": ["ih m-ao1 r-ah-l", "jj"],
  "immorality": ["ih m-er ae1 l-ih t-iy", "nn"],
  "immortal": ["ih m-ao1-r t-ah-l", "jj"],
  "immortality": ["ih m-ao-r t-ae1 l-ih t-iy", "nn"],
  "immortalize": ["ih-m-ao1-r-t-ah-l-ay-z", "vb"],
  "immovable": ["ih m-uw1 v-ah b-ah-l", "jj"],
  "immune": ["ih m-y-uw1-n", "jj nn"],
  "immunity": ["ih m-y-uw1 n-ah t-iy", "nn"],
  "immunization": ["ih m-y-uw n-ah z-ey1 sh-ah-n", "nn"],
  "immunize": ["ih1-m-y-uw-n-ay-z", "vb"],
  "immunological": ["ih m-y-uw n-ah l-aa1 jh-ih k-ah-l", "jj"],
  "immunologist": ["ih m-y-uw n-aa1 l-ah jh-ih-s-t", "nn"],
  "immunology": ["ih m-y-uw n-aa1 l-ah jh-iy", "nn"],
  "immutable": ["ih m-y-uw1 t-ah b-ah-l", "jj"],
  "impact": ["ih-m p-ae1-k-t", "nn vb"],
  "impacted": ["ih1-m p-ae-k t-ih-d", "vbn jj"],
  "impair": ["ih-m p-eh1-r", "vb nn"],
  "impaired": ["ih-m p-eh1-r-d", "vbn jj"],
  "impairment": ["ih-m p-eh1-r m-ah-n-t", "nn"],
  "impale": ["ih-m-p-ey1-l", "vb"],
  "impart": ["ih-m p-aa1-r-t", "vb"],
  "impartial": ["ih-m p-aa1-r sh-ah-l", "jj"],
  "impartiality": ["ih-m p-aa-r sh-iy ae1 l-ih t-iy", "nn"],
  "impassable": ["ih-m p-ae1 s-ah b-ah-l", "jj"],
  "impasse": ["ih-m p-ae1-s", "nn"],
  "impassioned": ["ih-m p-ae1 sh-ah-n-d", "jj"],
  "impassive": ["ih-m p-ae1 s-ih-v", "jj"],
  "impassively": ["ih-m p-ae1 s-ih-v l-iy", "rb"],
  "impatience": ["ih-m p-ey1 sh-ah-n-s", "nn"],
  "impatiens": ["ih-m p-ey1 sh-ah-n-z", "nn"],
  "impatient": ["ih-m p-ey1 sh-ah-n-t", "jj nn"],
  "impatiently": ["ih-m p-ey1 sh-ah-n-t l-iy", "rb"],
  "impeach": ["ih-m-p-iy1-ch", "vb"],
  "impeachment": ["ih-m p-iy1-ch m-ah-n-t", "nn"],
  "impeccable": ["ih-m p-eh1 k-ah b-ah-l", "jj"],
  "impeccably": ["ih-m p-eh1 k-ah b-l-iy", "rb"],
  "impede": ["ih-m p-iy1-d", "vb vbp"],
  "impediment": ["ih-m p-eh1 d-ah m-ah-n-t", "nn"],
  "impel": ["ih-m-p-eh1-l", "vb"],
  "impend": ["ih-m-p-eh1-n-d", "vb"],
  "impending": ["ih-m p-eh1-n d-ih-ng", "jj vbg"],
  "impenetrable": ["ih-m p-eh1 n-ah t-r-ah b-ah-l", "jj"],
  "imperative": ["ih-m p-eh1 r-ah t-ih-v", "jj nn"],
  "imperceptible": ["ih-m p-er s-eh1-p t-ih b-ah-l", "jj"],
  "imperceptibly": ["ih-m p-er s-eh1-p t-ih b-l-iy", "rb"],
  "imperfect": ["ih-m p-er1 f-ih-k-t", "jj"],
  "imperfection": ["ih-m p-er f-eh1-k sh-ah-n", "nn"],
  "imperfectly": ["ih-m p-er1 f-ih-k-t l-iy", "rb"],
  "imperial": ["ih-m p-ih1 r-iy ah-l", "jj"],
  "imperialism": ["ih-m p-ih1 r-iy ah l-ih z-ah-m", "nn"],
  "imperialist": ["ih-m p-ih1 r-iy ah l-ih-s-t", "nn"],
  "imperil": ["ih-m p-eh1 r-ah-l", "vb"],
  "imperiled": ["ih-m p-eh1 r-ah-l-d", "vbn jj"],
  "imperious": ["ih-m p-ih1 r-iy ah-s", "jj"],
  "impermissible": ["ih-m p-er m-ih1 s-ih b-ah-l", "jj"],
  "impersonal": ["ih-m p-er1 s-ah n-ah-l", "jj"],
  "impersonation": ["ih-m p-er s-ah n-ey1 sh-ah-n", "nn"],
  "impersonator": ["ih-m p-er1 s-ah n-ey t-er", "nn"],
  "impertinent": ["ih-m p-er1 t-ah n-ah-n-t", "jj"],
  "impervious": ["ih-m p-er1 v-iy ah-s", "jj"],
  "impetuous": ["ih-m p-eh1 ch-w-ah-s", "jj"],
  "impetus": ["ih1-m p-ah t-ah-s", "nn"],
  "impinge": ["ih-m p-ih1-n-jh", "vb vbp"],
  "implacable": ["ih-m p-l-ae1 k-ah b-ah-l", "jj"],
  "implant": ["ih-m p-l-ae1-n-t", "nn vb"],
  "implantable": ["ih1-m p-l-ae-n t-ah b-ah-l", "jj"],
  "implantation": ["ih-m p-l-ae-n t-ey1 sh-ah-n", "nn"],
  "implausible": ["ih-m p-l-ao1 z-ah b-ah-l", "jj"],
  "implausibly": ["ih-m p-l-ao1 z-ah b-l-iy", "rb"],
  "implement": ["ih1-m p-l-ah m-ah-n-t", "vb vbp"],
  "implementation": ["ih-m p-l-ah m-eh-n t-ey1 sh-ah-n", "nn"],
  "implicate": ["ih1-m p-l-ih k-ey-t", "vb"],
  "implication": ["ih-m p-l-ah k-ey1 sh-ah-n", "nn"],
  "implicit": ["ih-m p-l-ih1 s-ah-t", "jj"],
  "implicitly": ["ih-m p-l-ih1 s-ah-t l-iy", "rb"],
  "implied": ["ih-m p-l-ay1-d", "vbn jj vbd"],
  "implore": ["ih-m p-l-ao1-r", "vb"],
  "imply": ["ih-m p-l-ay1", "vb vbp"],
  "impolite": ["ih-m p-ah l-ay-t", "jj"],
  "impolitic": ["ih-m p-ao1 l-ih1 t-ih-k", "jj"],
  "imponderable": ["ih-m p-aa1-n d-er ah b-ah-l", "jj nn"],
  "import": ["ih-m p-ao1-r-t", "nn vb vbp"],
  "importance": ["ih-m p-ao1-r t-ah-n-s", "nn"],
  "important": ["ih-m p-ao1-r t-ah-n-t", "jj"],
  "importantly": ["ih-m p-ao1-r t-ah-n-t l-iy", "rb"],
  "importation": ["ih-m p-ao-r t-ey1 sh-ah-n", "nn"],
  "imported": ["ih-m p-ao1-r t-ih-d", "vbn vbd jj"],
  "importer": ["ih-m p-ao1-r t-er", "nn"],
  "impose": ["ih-m p-ow1-z", "vb vbp"],
  "imposed": ["ih-m p-ow1-z-d", "vbn vbd jj"],
  "imposing": ["ih-m p-ow1 z-ih-ng", "vbg jj"],
  "imposition": ["ih-m p-ah z-ih1 sh-ah-n", "nn"],
  "impossibility": ["ih-m p-ao s-ih b-ih1 l-ih t-iy", "nn"],
  "impossible": ["ih-m p-aa1 s-ah b-ah-l", "jj"],
  "impossibly": ["ih-m p-aa1 s-ah b-l-iy", "rb"],
  "impotence": ["ih1-m p-ah t-ah-n-s", "nn"],
  "impotent": ["ih1-m p-ah t-ah-n-t", "jj"],
  "impound": ["ih-m p-aw1-n-d", "vb"],
  "impoundment": ["ih-m p-aw1-n-d m-ah-n-t", "nn"],
  "impoverish": ["ih-m-p-aa1-v-r-ih-sh", "vb"],
  "impoverished": ["ih-m p-aa1 v-r-ih-sh-t", "jj vbn"],
  "impoverishment": ["ih-m p-aa1 v-r-ih-sh m-ah-n-t", "nn"],
  "impracticable": ["ih-m p-r-ae1-k t-ih k-ah b-ah-l", "jj"],
  "impractical": ["ih-m p-r-ae1-k t-ah k-ah-l", "jj"],
  "imprecise": ["ih1-m p-r-ah s-ay-s", "jj"],
  "impregnable": ["ih-m p-r-eh1-g n-ah b-ah-l", "jj"],
  "impresario": ["ih-m p-r-ih s-aa1 r-iy ow", "nn"],
  "impress": ["ih-m p-r-eh1-s", "vb nn vbp"],
  "impressed": ["ih-m p-r-eh1-s-t", "vbn jj vbd"],
  "impression": ["ih-m p-r-eh1 sh-ah-n", "nn"],
  "impressionism": ["ih-m p-r-eh1 sh-ah-n ih z-ah-m", "nn"],
  "impressionist": ["ih-m p-r-eh1 sh-ah-n ah-s-t", "nn jj"],
  "impressionistic": ["ih-m p-r-eh sh-ah n-ih1 s-t-ih-k", "jj"],
  "impressive": ["ih-m p-r-eh1 s-ih-v", "jj"],
  "impressively": ["ih-m p-r-eh1 s-ih-v l-iy", "rb"],
  "imprimatur": ["ih-m p-r-ih m-aa1 t-er", "nn"],
  "imprint": ["ih-m p-r-ih1-n-t", "vb nn"],
  "imprison": ["ih-m p-r-ih1 z-ah-n", "vb"],
  "imprisoned": ["ih-m p-r-ih1 z-ah-n-d", "vbn vbd jj"],
  "imprisonment": ["ih-m p-r-ih1 z-ah-n m-ah-n-t", "nn"],
  "improbable": ["ih-m p-r-aa1 b-ah b-ah-l", "jj"],
  "improbably": ["ih-m p-r-aa1 b-ah b-l-iy", "rb"],
  "impromptu": ["ih-m p-r-aa1-m-p t-uw", "jj nn"],
  "improper": ["ih-m p-r-aa1 p-er", "jj"],
  "improperly": ["ih-m p-r-aa1 p-er l-iy", "rb"],
  "impropriety": ["ih-m p-r-ah p-r-ay1 ah t-iy", "nn"],
  "improve": ["ih-m p-r-uw1-v", "vb vbp"],
  "improved": ["ih-m p-r-uw1-v-d", "vbn jj vbd"],
  "improvement": ["ih-m p-r-uw1-v m-ah-n-t", "nn"],
  "improvisation": ["ih-m p-r-aa v-ih z-ey1 sh-ah-n", "nn"],
  "improvisational": ["ih-m p-r-aa v-ih z-ey1 sh-ah n-ah-l", "jj"],
  "improvise": ["ih1-m p-r-ah v-ay-z", "vb"],
  "improvising": ["ih1-m p-r-ah v-ay z-ih-ng", "nn"],
  "imprudence": ["ih-m p-r-uw1 d-ah-n-s", "nn"],
  "imprudent": ["ih-m p-r-uw1 d-ah-n-t", "jj"],
  "imprudently": ["ih-m p-r-uw1 d-ah-n-t l-iy", "rb"],
  "impugn": ["ih-m p-y-uw1-n", "vb"],
  "impulse": ["ih1-m p-ah-l-s", "nn jj"],
  "impulsive": ["ih-m p-ah1-l s-ih-v", "jj"],
  "impulsively": ["ih-m p-ah1-l s-ih-v l-iy", "rb"],
  "impunity": ["ih-m p-y-uw1 n-ih t-iy", "nn"],
  "impure": ["ih-m p-y-uh1-r", "jj"],
  "impurity": ["ih-m p-y-uh1 r-ah t-iy", "nn"],
  "imputation": ["ih-m p-y-ah t-ey1 sh-ah-n", "nn"],
  "impute": ["ih-m-p-y-uw1-t", "vb"],
  "imputed": ["ih-m p-y-uw1 t-ih-d", "vbn jj"],
  "in": ["ih-n", "in nn rb rp rbr"],
  "inability": ["ih-n ah b-ih1 l-ih t-iy", "nn"],
  "inaccessible": ["ih-n ah-k s-eh1 s-ah b-ah-l", "jj"],
  "inaccuracy": ["ih-n ae1 k-y-er ah s-iy", "nn"],
  "inaccurate": ["ih-n ae1 k-y-er ah-t", "jj"],
  "inaccurately": ["ih-n ae1 k-y-er ah-t l-iy", "rb"],
  "inaction": ["ih-n ae1-k sh-ah-n", "nn"],
  "inactivate": ["ih-n-ae1-k-t-ih-v-ey-t", "vb"],
  "inactivation": ["ih-n ae-k t-ih v-ey1 sh-ah-n", "nn"],
  "inactive": ["ih-n ae1-k t-ih-v", "jj"],
  "inactivity": ["ih-n ae-k t-ih1 v-ih t-iy", "nn"],
  "inadequacy": ["ih-n ae1 d-ih k-w-ah s-iy", "nn"],
  "inadequate": ["ih-n ae1 d-ah k-w-ah-t", "jj"],
  "inadequately": ["ih-n ae1 d-ah k-w-ah-t l-iy", "rb"],
  "inadvertent": ["ih-n ah-d v-er1 t-ah-n-t", "jj"],
  "inadvertently": ["ih-n ah-d v-er1 t-ah-n-t l-iy", "rb"],
  "inadvisable": ["ih-n ah-d v-ay1 z-ah b-ah-l", "jj"],
  "inalienable": ["ih-n ey1 l-y-ah n-ah b-ah-l", "jj"],
  "inane": ["ih-n ey1-n", "jj"],
  "inanimate": ["ih-n ae1 n-ah m-ah-t", "jj"],
  "inapplicable": ["ih-n ae1 p-l-ih k-ah b-ah-l", "jj"],
  "inappropriate": ["ih-n ah p-r-ow1 p-r-iy ih-t", "jj"],
  "inappropriately": ["ih-n ah p-r-aa1 p-r-iy ah-t l-iy", "rb"],
  "inarticulate": ["ih-n aa-r t-ih1 k-y-ah l-ah-t", "jj"],
  "inasmuch": ["ih-n ae1-s m-ah-k", "rb"],
  "inattention": ["ih-n ah t-eh1-n ch-ah-n", "nn"],
  "inattentive": ["ih-n ah t-eh1-n t-ih-v", "jj"],
  "inaudible": ["ih-n ao1 d-ah b-ah-l", "jj"],
  "inaugural": ["ih n-ao1 g-er ah-l", "jj nn"],
  "inaugurate": ["ih-n-ao1-g-y-ah-r-ey-t", "vb"],
  "inauguration": ["ih n-ao g-y-er ey1 sh-ah-n", "nn"],
  "inauspicious": ["ih-n aw s-p-ih1 sh-ih-s", "jj"],
  "inboard": ["ih1-n b-ao-r-d", "jj rb"],
  "inbound": ["ih-n b-aw1-n-d", "jj"],
  "incalculable": ["ih-n k-ae1-l k-y-ah l-ah b-ah-l", "jj"],
  "incandescent": ["ih-n k-ah-n d-eh1 s-ah-n-t", "jj"],
  "incantation": ["ih-n k-ae1-n t-ey1 sh-ah-n", "nn"],
  "incapable": ["ih-n k-ey1 p-ah b-ah-l", "jj nn"],
  "incapacitate": ["ih-n-k-ah-p-ae1-s-ih-t-ey-t", "vb"],
  "incapacity": ["ih-n k-ah p-ae1 s-ah t-iy", "nn"],
  "incarcerate": ["ih-n k-aa1-r s-er ey-t", "vb"],
  "incarceration": ["ih-n k-aa-r s-er ey1 sh-ah-n", "nn"],
  "incarnate": ["ih-n k-aa1-r n-ah-t", "jj vb"],
  "incarnation": ["ih-n k-aa1-r n-ey1 sh-ah-n", "nn"],
  "incendiary": ["ih-n s-eh1-n d-iy eh r-iy", "jj"],
  "incense": ["ih-n s-eh1-n-s", "nn vb"],
  "incensed": ["ih1-n s-eh-n-s-t", "vbn jj"],
  "incentive": ["ih-n s-eh1-n t-ih-v", "nn jj"],
  "inception": ["ih-n s-eh1-p sh-ah-n", "nn"],
  "incessant": ["ih-n s-eh1 s-ah-n-t", "jj"],
  "incessantly": ["ih-n s-eh1 s-ah-n-t l-iy", "rb"],
  "incest": ["ih1-n s-eh-s-t", "nn"],
  "incestuous": ["ih-n s-eh1 s-ch-w-ah-s", "jj"],
  "inch": ["ih1-n-ch", "nn rb vb"],
  "inches": ["ih1-n ch-ah-z", "nn"],
  "incidence": ["ih1-n s-ah d-ah-n-s", "nn"],
  "incident": ["ih1-n s-ah d-ah-n-t", "nn jj"],
  "incidental": ["ih-n s-ih d-eh1-n t-ah-l", "jj"],
  "incidentally": ["ih-n s-ih d-eh1-n t-ah l-iy", "rb"],
  "incineration": ["ih-n s-ih1 n-er ey sh-ah-n", "nn"],
  "incinerator": ["ih-n s-ih1 n-er ey t-er", "nn"],
  "incipient": ["ih-n s-ih1 p-iy ah-n-t", "jj"],
  "incisive": ["ih-n s-ay1 s-ih-v", "jj"],
  "incite": ["ih-n s-ay1-t", "vb vbp"],
  "inclement": ["ih-n k-l-eh1 m-ah-n-t", "jj"],
  "inclination": ["ih-n k-l-ah n-ey1 sh-ah-n", "nn"],
  "incline": ["ih-n k-l-ay1-n", "nn vb"],
  "inclined": ["ih-n k-l-ay1-n-d", "vbn jj"],
  "include": ["ih-n k-l-uw1-d", "vbp vb"],
  "included": ["ih-n k-l-uw1 d-ah-d", "vbd vbn jj"],
  "inclusion": ["ih-n k-l-uw1 zh-ah-n", "nn"],
  "inclusive": ["ih-n k-l-uw1 s-ih-v", "jj"],
  "incoherence": ["ih-n k-ow hh-ih1 r-ah-n-s", "nn"],
  "incoherent": ["ih-n k-ow hh-ih1 r-ah-n-t", "jj"],
  "incoherently": ["ih-n k-ow hh-ih1 r-ah-n-t l-iy", "rb"],
  "income": ["ih1-n k-ah-m", "nn"],
  "incoming": ["ih1-n k-ah m-ih-ng", "jj"],
  "incomparable": ["ih-n k-aa1-m p-er ah b-ah-l", "jj"],
  "incomparably": ["ih-n k-aa1-m p-er ah b-l-iy", "rb"],
  "incompatibility": ["ih-n k-aa-m p-ah t-ih b-ih1 l-ih t-iy", "nn"],
  "incompatible": ["ih-n k-ah-m p-ae1 t-ah b-ah-l", "jj"],
  "incompetence": ["ih-n k-aa1-m p-ah t-ah-n-s", "nn"],
  "incompetent": ["ih-n k-aa1-m p-ah t-ah-n-t", "jj"],
  "incomplete": ["ih-n k-ah-m p-l-iy1-t", "jj"],
  "incomprehensible": ["ih-ng k-aa-m p-r-ah hh-eh1-n s-ih b-ah-l", "jj nn"],
  "inconceivable": ["ih-n k-ah-n s-iy1 v-ah b-ah-l", "jj"],
  "inconclusive": ["ih-n k-ah-n k-l-uw1 s-ih-v", "jj"],
  "inconclusively": ["ih-ng k-aa1-n k-l-uw s-ih-v l-iy", "rb"],
  "incongruity": ["ih-ng k-ao-ng r-uw1 ih t-iy", "nn"],
  "incongruous": ["ih-ng k-ao1-ng r-uw ah-s", "jj"],
  "inconsequential": ["ih-ng k-aa-n s-ah k-w-eh1-n ch-ah-l", "jj"],
  "inconsistency": ["ih-n k-ah-n s-ih1 s-t-ah-n s-iy", "nn"],
  "inconsistent": ["ih-n k-ah-n s-ih1 s-t-ah-n-t", "jj"],
  "inconspicuous": ["ih-ng k-aa1-n s-p-ih k-w-ah-s", "jj"],
  "incontrovertible": ["ih-ng k-aa-n t-r-ow v-er1 t-ih b-ah-l", "jj"],
  "inconvenience": ["ih-n k-ah-n v-iy1 n-y-ah-n-s", "nn"],
  "inconvenient": ["ih-n k-ah-n v-iy1 n-y-ah-n-t", "jj"],
  "incorporate": ["ih-n k-ao1-r p-er ey-t", "vb vbp jj"],
  "incorporated": ["ih-n k-ao1-r p-er ey t-ah-d", "vbn jj vbd"],
  "incorporating": ["ih-n k-ao1-r p-er ey t-ih-ng", "jj vbg"],
  "incorporation": ["ih-n k-ao-r p-er ey1 sh-ah-n", "nn"],
  "incorrect": ["ih-n k-er eh1-k-t", "jj"],
  "incorrectly": ["ih-n k-er eh1-k-t l-iy", "rb"],
  "incorrigible": ["ih-n k-aa1 r-ah jh-ah b-ah-l", "jj"],
  "increase": ["ih-n k-r-iy1-s", "nn vb vbp"],
  "increased": ["ih-n k-r-iy1-s-t", "vbn jj vbd"],
  "increasing": ["ih-n k-r-iy1 s-ih-ng", "vbg jj nn"],
  "increasingly": ["ih-n k-r-iy1 s-ih-ng l-iy", "rb"],
  "incredible": ["ih-n k-r-eh1 d-ah b-ah-l", "jj"],
  "incredibly": ["ih-n k-r-eh1 d-ah b-l-iy", "rb"],
  "incredulity": ["ih-n k-r-ah d-uw1 l-ih t-iy", "nn"],
  "increment": ["ih1-n k-r-ah m-ah-n-t", "nn"],
  "incremental": ["ih-n k-r-ah m-eh1-n t-ah-l", "jj"],
  "incriminate": ["ih-n-k-r-ih1-m-ah-n-ey-t", "vb"],
  "incriminating": ["ih-n k-r-ih1 m-ah n-ey t-ih-ng", "vbg jj"],
  "incubate": ["ih1-n-k-y-ah-b-ey-t", "vb"],
  "incubation": ["ih-ng k-y-uw b-ey1 sh-ah-n", "nn"],
  "incumbency": ["ih-n k-ah1-m b-ah-n s-iy", "nn"],
  "incumbent": ["ih-n k-ah1-m b-ah-n-t", "jj nn"],
  "incur": ["ih-n k-er1", "vb vbp"],
  "incurable": ["ih-n k-y-uh1 r-ah b-ah-l", "jj"],
  "incursion": ["ih-n k-er1 zh-ah-n", "nn"],
  "indebted": ["ih-n d-eh1 t-ah-d", "jj"],
  "indebtedness": ["ih-n d-eh1 t-ih-d n-ih-s", "nn"],
  "indecency": ["ih-n d-iy1 s-ah-n s-iy", "nn"],
  "indecent": ["ih-n d-iy1 s-ah-n-t", "jj"],
  "indecision": ["ih-n d-ih s-ih1 zh-ah-n", "nn"],
  "indecisive": ["ih-n d-ih s-ay1 s-ih-v", "jj"],
  "indecisiveness": ["ih-n d-eh1 s-ih s-ih-v n-ah-s", "nn"],
  "indeed": ["ih-n d-iy1-d", "rb uh"],
  "indefatigable": ["ih-n d-ih f-ae1 t-ih g-ah b-ah-l", "jj"],
  "indefensible": ["ih-n d-ih f-eh1-n s-ah b-ah-l", "jj"],
  "indefinable": ["ih-n d-ih f-ay1 n-ah b-ah-l", "jj"],
  "indefinite": ["ih-n d-eh1 f-ah n-ah-t", "jj nn"],
  "indefinitely": ["ih-n d-eh1 f-ah n-ah-t l-iy", "rb"],
  "indelible": ["ih-n d-eh1 l-ih b-ah-l", "jj"],
  "indelibly": ["ih-n d-eh1 l-ah b-l-iy", "rb"],
  "indelicate": ["ih-n d-eh1 l-ih k-ah-t", "jj"],
  "indemnification": ["ih-n d-eh-m n-ah f-ih k-ey1 sh-ah-n", "nn"],
  "indemnify": ["ih-n d-eh1-m n-ah f-ay", "vb"],
  "indemnity": ["ih-n d-eh1-m n-ah t-iy", "nn"],
  "indenture": ["ih-n d-eh1-n ch-er", "nn vb"],
  "independence": ["ih-n d-ih p-eh1-n d-ah-n-s", "nn"],
  "independent": ["ih-n d-ih p-eh1-n d-ah-n-t", "jj nn"],
  "independently": ["ih-n d-ih p-eh1-n d-ah-n-t l-iy", "rb"],
  "indestructibility": ["ih-n d-ah-s-t r-ah-k t-ih b-ih1 l-ih t-iy", "nn"],
  "indestructible": ["ih-n d-ah-s-t r-ah1-k t-ih b-ah-l", "jj"],
  "indeterminate": ["ih-n d-ih t-er1 m-ih n-ih-t", "jj"],
  "index": ["ih1-n d-eh-k-s", "nn vb"],
  "indexation": ["ih1-n d-eh-k s-ey1 sh-ah-n", "nn"],
  "indexed": ["ih1-n d-eh-k-s-t", "vbn jj"],
  "indexer": ["ih1-n d-eh-k s-er", "nn"],
  "indicate": ["ih1-n d-ah k-ey-t", "vb vbp"],
  "indicated": ["ih1-n d-ah k-ey t-ah-d", "vbd jj vbn"],
  "indication": ["ih-n d-ah k-ey1 sh-ah-n", "nn"],
  "indicative": ["ih-n d-ih1 k-ah t-ih-v", "jj"],
  "indicator": ["ih1-n d-ah k-ey t-er", "nn"],
  "indict": ["ih-n d-ay1-t", "vb"],
  "indictment": ["ih-n d-ay1-t m-ah-n-t", "nn"],
  "indifference": ["ih-n d-ih1 f-er ah-n-s", "nn"],
  "indifferent": ["ih-n d-ih1 f-r-ah-n-t", "jj"],
  "indigenous": ["ih-n d-ih1 jh-ah n-ah-s", "jj"],
  "indigent": ["ih1-n d-ih jh-ah-n-t", "jj"],
  "indigestion": ["ih-n d-ay jh-eh1-s ch-ah-n", "nn"],
  "indignant": ["ih-n d-ih1-g n-ah-n-t", "jj"],
  "indignantly": ["ih-n d-ih1-g n-ah-n-t l-iy", "rb"],
  "indignation": ["ih-n d-ih-g n-ey1 sh-ah-n", "nn"],
  "indignity": ["ih-n d-ih1-g n-ah t-iy", "nn"],
  "indirect": ["ih-n d-er eh1-k-t", "jj"],
  "indirectly": ["ih-n d-er eh1-k-t l-iy", "rb"],
  "indiscreet": ["ih-n d-ih s-k-r-iy1-t", "jj"],
  "indiscretion": ["ih-n d-ih s-k-r-eh1 sh-ah-n", "nn"],
  "indiscriminate": ["ih-n d-ih s-k-r-ih1 m-ah n-ah-t", "jj"],
  "indispensable": ["ih-n d-ih s-p-eh1-n s-ah b-ah-l", "jj nn"],
  "indispensible": ["ih-n d-ih s-p-eh1-n s-ih b-ah-l", "jj"],
  "indisputable": ["ih-n d-ih-s p-y-uw1 t-ah b-ah-l", "jj"],
  "indisputably": ["ih-n d-ih1 s-p-y-uw t-ae b-l-iy", "rb"],
  "indistinct": ["ih-n d-ih s-t-ih1-ng-k-t", "jj"],
  "indistinguishable": ["ih-n d-ih s-t-ih1-ng g-w-ih sh-ah b-ah-l", "jj"],
  "indium": ["ih1-n d-iy ah-m", "nn"],
  "individual": ["ih-n d-ah v-ih1 jh-ah w-ah-l", "jj nn"],
  "individualism": ["ih-n d-ih v-ih d-uw1 ah l-ih z-ah-m", "nn"],
  "individualist": ["ih-n d-ih v-ih d-uw1 ah l-ih-s-t", "nn"],
  "individualistic": ["ih-n d-ih v-ih jh-uw ah l-ih1 s-t-ih-k", "jj"],
  "individuality": ["ih-n d-ih v-ih jh-uw ae1 l-ih t-iy", "nn"],
  "individualize": ["ih-n-d-ih-v-ih1-jh-uw-ah-l-ay-z", "vb"],
  "individualized": ["ih-n d-ih v-ih1 jh-uw ah l-ay-z-d", "jj vbn"],
  "individually": ["ih-n d-ih v-ih1 jh-uw ah l-iy", "rb"],
  "indivisible": ["ih-n d-ih v-ih1 s-ih b-ah-l", "jj"],
  "indoctrinate": ["ih-n d-aa1-k t-r-ah n-ey-t", "vb"],
  "indoctrination": ["ih-n d-aa-k t-r-ah n-ey1 sh-ah-n", "nn"],
  "indolent": ["ih1-n d-ah l-ah-n-t", "jj"],
  "indomitable": ["ih-n d-aa1 m-ah t-ah b-ah-l", "jj"],
  "indoor": ["ih1-n d-ao-r", "jj"],
  "indoors": ["ih1-n d-ao-r-z", "nn rb"],
  "induce": ["ih-n d-uw1-s", "vb"],
  "inducement": ["ih-n d-uw1-s m-ah-n-t", "nn"],
  "induct": ["ih-n-d-ah1-k-t", "vb"],
  "inductee": ["ih-n d-ah1-k t-iy1", "nn"],
  "induction": ["ih-n d-ah1-k sh-ah-n", "nn"],
  "indulge": ["ih-n d-ah1-l-jh", "vb vbp"],
  "indulgence": ["ih-n d-ah1-l jh-ah-n-s", "nn"],
  "indulgent": ["ih-n d-ah1-l jh-ah-n-t", "jj"],
  "industrial": ["ih-n d-ah1-s t-r-iy ah-l", "jj"],
  "industrialist": ["ih-n d-ah1-s t-r-iy ah l-ih-s-t", "nn"],
  "industrialization": ["ih-n d-ah-s t-r-iy ah l-ih z-ey1 sh-ah-n", "nn"],
  "industrialize": ["ih-n d-ah1-s t-r-iy ah l-ay-z", "vb"],
  "industrialized": ["ih-n d-ah1-s t-r-iy ah l-ay-z-d", "vbn jj"],
  "industrially": ["ih-n d-ah1-s t-r-iy ah l-iy", "rb"],
  "industrious": ["ih-n d-ah1-s t-r-iy ah-s", "jj"],
  "industry": ["ih1-n d-ah-s t-r-iy", "nn"],
  "industrywide": ["ih1-n d-ah-s t-r-iy w-ay-d", "jj rb"],
  "inedible": ["ih-n eh1 d-ah b-ah-l", "jj"],
  "ineffable": ["ih-n eh1 f-ah b-ah-l", "jj"],
  "ineffective": ["ih-n ih f-eh1-k t-ih-v", "jj"],
  "ineffectiveness": ["ih-n ah f-eh1-k t-ih-v n-ah-s", "nn"],
  "ineffectual": ["ih-n ah f-eh1-k ch-uw ah-l", "jj"],
  "inefficiency": ["ih-n ih f-ih1 sh-ah-n s-iy", "nn"],
  "inefficient": ["ih-n ih f-ih1 sh-ah-n-t", "jj"],
  "ineligible": ["ih-n eh1 l-ih jh-ah b-ah-l", "jj"],
  "inept": ["ih-n eh1-p-t", "jj"],
  "ineptitude": ["ih-n eh1-p t-ih t-uw-d", "nn"],
  "ineptly": ["ih-n eh1-p-t l-iy", "rb"],
  "inequality": ["ih-n ih k-w-aa1 l-ah t-iy", "nn"],
  "inequitable": ["ih-n eh1 k-w-ah t-ah b-ah-l", "jj"],
  "inequity": ["ih-n eh1 k-w-ah t-iy", "nn"],
  "inert": ["ih n-er1-t", "jj"],
  "inertia": ["ih n-er1 sh-ah", "nn"],
  "inertial": ["ih n-er1 sh-ah-l", "jj"],
  "inescapable": ["ih-n ih-s k-ey1 p-ah b-ah-l", "jj"],
  "inevitability": ["ih-n eh v-ih t-ah b-ih1 l-ih t-iy", "nn"],
  "inevitable": ["ih-n eh1 v-ah t-ah b-ah-l", "jj"],
  "inevitably": ["ih-n eh1 v-ah t-ah b-l-iy", "rb"],
  "inexact": ["ih-n ih-g z-ae1-k-t", "jj"],
  "inexcusable": ["ih-n ih-k s-k-y-uw1 z-ah b-ah-l", "jj"],
  "inexhaustible": ["ih-n ih-g z-ao1 s-t-ah b-ah-l", "jj"],
  "inexorable": ["ih-n eh1-k s-er ah b-ah-l", "jj"],
  "inexorably": ["ih-n eh1-k s-er ah b-l-iy", "rb"],
  "inexpensive": ["ih-n ih-k s-p-eh1-n s-ih-v", "jj"],
  "inexperience": ["ih-n ih-k s-p-ih1 r-iy ah-n-s", "nn"],
  "inexperienced": ["ih-n ih-k s-p-ih1 r-iy ah-n-s-t", "jj"],
  "inexplicable": ["ih-n ah-k s-p-l-ih1 s-ah b-ah-l", "jj"],
  "inexplicably": ["ih-n ih-k s-p-l-ih1 k-ah b-l-iy", "rb"],
  "inextricably": ["ih-n eh1-k s-t-r-ih k-ah b-l-iy", "rb"],
  "infallibility": ["ih-n f-ae l-ih b-ih1 l-ih t-iy", "nn"],
  "infallible": ["ih-n f-ae1 l-ah b-ah-l", "jj nn"],
  "infamous": ["ih1-n f-ah m-ah-s", "jj"],
  "infamy": ["ih1-n f-ah m-iy", "nn"],
  "infancy": ["ih1-n f-ah-n s-iy", "nn"],
  "infant": ["ih1-n f-ah-n-t", "nn jj"],
  "infantile": ["ih1-n f-ah-n t-ih-l", "jj"],
  "infantry": ["ih1-n f-ah-n t-r-iy", "nn"],
  "infantryman": ["ih1-n f-ae-n t-r-iy m-ah-n", "nn"],
  "infarction": ["ih-n f-aa1-r-k sh-ah-n", "nn"],
  "infatuation": ["ih-n f-ae ch-uw ey1 sh-ah-n", "nn"],
  "infect": ["ih-n f-eh1-k-t", "vb"],
  "infected": ["ih-n f-eh1-k t-ah-d", "vbn vbd jj"],
  "infection": ["ih-n f-eh1-k sh-ah-n", "nn"],
  "infectious": ["ih-n f-eh1-k sh-ah-s", "jj"],
  "infer": ["ih-n f-er1", "vb"],
  "inference": ["ih1-n f-er ah-n-s", "nn"],
  "inferior": ["ih-n f-ih1 r-iy er", "jj"],
  "inferiority": ["ih-n f-ih r-iy ao1 r-ih t-iy", "nn"],
  "infernal": ["ih-n f-er1 n-ah-l", "jj"],
  "inferno": ["ih-n f-er1 n-ow", "nn"],
  "infertile": ["ih-n f-er1 t-ah-l", "jj"],
  "infertility": ["ih-n f-er t-ih1 l-ih t-iy", "nn"],
  "infest": ["ih-n f-eh1-s-t", "vb"],
  "infestation": ["ih-n f-eh1 s-t-ey1 sh-ah-n", "nn"],
  "infested": ["ih-n f-eh1 s-t-ah-d", "vbn jj"],
  "infidel": ["ih1-n f-ih d-eh-l", "jj"],
  "infidelity": ["ih-n f-ih d-eh1 l-ih t-iy", "nn"],
  "infield": ["ih1-n f-iy-l-d", "nn"],
  "infielder": ["ih1-n f-iy-l d-er", "nn"],
  "infighting": ["ih1-n f-ay t-ih-ng", "nn"],
  "infiltrate": ["ih-n f-ih1-l t-r-ey-t", "vb"],
  "infiltration": ["ih-n f-ih-l t-r-ey1 sh-ah-n", "nn"],
  "infinite": ["ih1-n f-ah n-ah-t", "jj nn"],
  "infinitely": ["ih1-n f-ah n-ah-t l-iy", "rb"],
  "infinitesimal": ["ih-n f-ih n-ih t-eh1 s-ih m-ah-l", "jj"],
  "infinity": ["ih-n f-ih1 n-ah t-iy", "nn"],
  "infirm": ["ih-n f-er1-m", "jj"],
  "infirmary": ["ih-n f-er1 m-er iy", "nn"],
  "inflame": ["ih-n f-l-ey1-m", "vb"],
  "inflamed": ["ih-n f-l-ey1-m-d", "jj vbd"],
  "inflammation": ["ih-n f-l-ah m-ey1 sh-ah-n", "nn"],
  "inflammatory": ["ih-n f-l-ae1 m-ah t-ao r-iy", "jj"],
  "inflate": ["ih-n f-l-ey1-t", "vb"],
  "inflated": ["ih-n f-l-ey1 t-ah-d", "jj vbd vbn"],
  "inflation": ["ih-n f-l-ey1 sh-ah-n", "nn"],
  "inflationary": ["ih-n f-l-ey1 sh-ah-n eh r-iy", "jj"],
  "inflect": ["ih-n f-l-eh1-k-t", "vb"],
  "inflected": ["ih-n f-l-eh1-k t-ah-d", "vbn jj"],
  "inflection": ["ih-n f-l-eh1-k sh-ah-n", "nn"],
  "inflexible": ["ih-n f-l-eh1-k s-ah b-ah-l", "jj"],
  "inflict": ["ih-n f-l-ih1-k-t", "vb"],
  "infliction": ["ih-n f-l-ih1-k sh-ah-n", "nn"],
  "inflight": ["ih1-n f-l-ay-t", "jj"],
  "inflow": ["ih1-n f-l-ow", "nn"],
  "influence": ["ih1-n f-l-uw ah-n-s", "nn vb vbp"],
  "influential": ["ih-n f-l-uw eh1-n ch-ah-l", "jj"],
  "influenza": ["ih-n f-l-uw eh1-n z-ah", "nn"],
  "influx": ["ih1-n f-l-ah-k-s", "nn"],
  "inform": ["ih-n f-ao1-r-m", "vb vbp"],
  "informal": ["ih-n f-ao1-r m-ah-l", "jj"],
  "informality": ["ih-n f-er m-ae1 l-ih t-iy", "nn"],
  "informally": ["ih-n f-ao1-r m-ah l-iy", "rb"],
  "informant": ["ih-n f-ao1-r m-ah-n-t", "nn"],
  "information": ["ih-n f-er m-ey1 sh-ah-n", "nn"],
  "informational": ["ih-n f-er m-ey1 sh-ah n-ah-l", "jj"],
  "informative": ["ih-n f-ao1-r m-ah t-ih-v", "jj"],
  "informed": ["ih-n f-ao1-r-m-d", "vbn vbd jj"],
  "informer": ["ih-n f-ao1-r m-er", "jj"],
  "infraction": ["ih-n f-r-ae1-k sh-ah-n", "nn"],
  "infrared": ["ih-n f-r-er eh1-d", "jj nn"],
  "infrastructural": ["ih-n f-r-ah s-t-r-ah1-k ch-er ah-l", "jj"],
  "infrastructure": ["ih-n f-r-ah s-t-r-ah1-k ch-er", "nn"],
  "infrequent": ["ih-n f-r-iy1 k-w-ah-n-t", "jj"],
  "infrequently": ["ih-n f-r-iy1 k-w-ah-n-t l-iy", "rb"],
  "infringe": ["ih-n f-r-ih1-n-jh", "vb vbp"],
  "infringement": ["ih-n f-r-ih1-n-jh m-ah-n-t", "nn"],
  "infuriate": ["ih-n f-y-uh1 r-iy ey-t", "vb"],
  "infuriating": ["ih-n f-y-uh1 r-iy ey t-ih-ng", "jj vbg"],
  "infuse": ["ih-n f-y-uw1-z", "vb"],
  "infusion": ["ih-n f-y-uw1 zh-ah-n", "nn"],
  "ingenious": ["ih-n jh-iy1 n-y-ah-s", "jj"],
  "ingeniously": ["ih-n jh-iy1 n-y-ah-s l-iy", "rb"],
  "ingenuity": ["ih-n jh-ah n-uw1 ah t-iy", "nn"],
  "ingest": ["ih-n jh-eh1-s-t", "vbp vb"],
  "ingestion": ["ih-n jh-eh1-s ch-ah-n", "nn"],
  "inglorious": ["ih-n g-l-ao1 r-iy ah-s", "jj"],
  "ingot": ["ih1-ng g-ah-t", "nn"],
  "ingrained": ["ih-n g-r-ey1-n-d", "jj"],
  "ingratiate": ["ih-ng g-r-ey1 sh-iy ey-t", "vb"],
  "ingratiating": ["ih-ng g-r-ey1 sh-iy ey t-ih-ng", "jj"],
  "ingredient": ["ih-n g-r-iy1 d-iy ah-n-t", "nn"],
  "inhabit": ["ih-n hh-ae1 b-ah-t", "vb vbp"],
  "inhabitant": ["ih-n hh-ae1 b-ah t-ah-n-t", "nn"],
  "inhabitation": ["ih-n hh-ae b-ah t-ey1 sh-ah-n", "nn"],
  "inhabited": ["ih-n hh-ae1 b-ah t-ah-d", "vbn vbd jj"],
  "inhalation": ["ih-n ah l-ey1 sh-ah-n", "nn"],
  "inhale": ["ih-n-hh-ey1-l", "vb"],
  "inherent": ["ih-n hh-ih1 r-ah-n-t", "jj"],
  "inherently": ["ih-n hh-ih1 r-ah-n-t l-iy", "rb"],
  "inherit": ["ih-n hh-eh1 r-ah-t", "vb vbp"],
  "inheritable": ["ih-n hh-eh1 r-ah t-ah b-ah-l", "jj"],
  "inheritance": ["ih-n hh-eh1 r-ah t-ah-n-s", "nn"],
  "inherited": ["ih-n hh-eh1 r-ah t-ih-d", "vbn vbd jj"],
  "inhibit": ["ih-n hh-ih1 b-ah-t", "vb vbp"],
  "inhibiting": ["ih-n hh-ih1 b-ah t-ih-ng", "vbg jj"],
  "inhibition": ["ih-n hh-ah b-ih1 sh-ah-n", "nn"],
  "inhibitor": ["ih-n hh-ih1 b-ah t-er", "nn"],
  "inhibitory": ["ih-n hh-ih1 b-ah t-ao r-iy", "jj"],
  "inhospitable": ["ih-n hh-aa1 s-p-ah t-ah b-ah-l", "jj"],
  "inhuman": ["ih-n hh-y-uw1 m-ah-n", "jj"],
  "inhumane": ["ih-n hh-y-uw m-ey1-n", "jj"],
  "inimical": ["ih n-ih1 m-ih k-ah-l", "jj"],
  "inimitable": ["ih n-ih1 m-ah t-ah b-ah-l", "jj"],
  "initial": ["ih n-ih1 sh-ah-l", "jj nn vb"],
  "initially": ["ih n-ih1 sh-ah l-iy", "rb"],
  "initiate": ["ih n-ih1 sh-iy ey-t", "vb nn vbp"],
  "initiation": ["ih n-ih sh-iy ey1 sh-ah-n", "nn"],
  "initiative": ["ih n-ih1 sh-ah t-ih-v", "nn"],
  "initiator": ["ih n-ih sh-iy1 ey t-er", "nn"],
  "inject": ["ih-n jh-eh1-k-t", "vb vbp"],
  "injection": ["ih-n jh-eh1-k sh-ah-n", "nn"],
  "injunction": ["ih-n jh-ah1-ng-k sh-ah-n", "nn"],
  "injunctive": ["ih-n jh-ah1-ng-k t-ih-v", "jj"],
  "injure": ["ih1-n jh-er", "vb vbp"],
  "injured": ["ih1-n jh-er-d", "vbn vbd jj"],
  "injurious": ["ih-n jh-uh1 r-iy ah-s", "jj"],
  "injury": ["ih1-n jh-er iy", "nn"],
  "injustice": ["ih-n jh-ah1 s-t-ih-s", "nn"],
  "ink": ["ih1-ng-k", "nn"],
  "inkling": ["ih1-ng k-l-ih-ng", "nn"],
  "inlaid": ["ih1-n l-ey-d", "vbn"],
  "inland": ["ih1-n l-ae-n-d", "rb jj"],
  "inlay": ["ih1-n l-ey", "nn"],
  "inlet": ["ih1-n l-eh-t", "nn"],
  "inmate": ["ih1-n m-ey-t", "nn"],
  "inn": ["ih1-n", "nn"],
  "innards": ["ih1 n-er-d-z", "nn"],
  "innate": ["ih n-ey1-t", "jj"],
  "inner": ["ih1 n-er", "jj"],
  "innermost": ["ih1 n-er m-ow-s-t", "jj"],
  "inning": ["ih1 n-ih-ng", "nn"],
  "innocence": ["ih1 n-ah s-ah-n-s", "nn"],
  "innocent": ["ih1 n-ah s-ah-n-t", "jj"],
  "innocently": ["ih1 n-ah s-ah-n-t l-iy", "rb"],
  "innocuous": ["ih-n aa1 k-y-uw ah-s", "jj"],
  "innovate": ["ih1 n-ah v-ey-t", "vb"],
  "innovation": ["ih n-ah v-ey1 sh-ah-n", "nn"],
  "innovative": ["ih1 n-ah v-ey t-ih-v", "jj"],
  "innovator": ["ih1 n-ah v-ey t-er", "nn"],
  "innuendo": ["ih n-y-uw eh1-n d-ow", "nn"],
  "innumerable": ["ih n-uw1 m-er ah b-ah-l", "jj"],
  "inoculate": ["ih-n aa1 k-y-ah l-ey-t", "vb"],
  "inoculation": ["ih-n aa k-y-ah l-ey1 sh-ah-n", "nn"],
  "inoperable": ["ih-n aa1 p-er ah b-ah-l", "jj"],
  "inoperative": ["ih-n aa1 p-er ah t-ih-v", "jj"],
  "inopportune": ["ih-n aa p-er t-uw1-n", "jj"],
  "inordinate": ["ih-n ao1-r d-ah n-ih-t", "jj"],
  "inordinately": ["ih-n ao1-r d-ah n-ah-t l-iy", "rb"],
  "inorganic": ["ih-n ao-r g-ae1 n-ih-k", "jj"],
  "inpatient": ["ih1-n p-ey sh-ah-n-t", "nn"],
  "input": ["ih1-n p-uh-t", "nn"],
  "inquest": ["ih1-n k-w-eh-s-t", "nn"],
  "inquire": ["ih-n k-w-ay1-r", "vb"],
  "inquiring": ["ih-n k-w-ay1 er ih-ng", "jj vbg"],
  "inquiry": ["ih-n k-w-ay1 r-iy", "nn"],
  "inquisitive": ["ih-n k-w-ih1 z-ih t-ih-v", "jj"],
  "inroad": ["ih1-n r-ow-d", "nn"],
  "insane": ["ih-n s-ey1-n", "jj"],
  "insanity": ["ih-n s-ae1 n-ah t-iy", "nn"],
  "insatiable": ["ih-n s-ey1 sh-ah b-ah-l", "jj"],
  "inscribe": ["ih-n-s-k-r-ay1-b", "vb"],
  "inscribed": ["ih-n s-k-r-ay1-b-d", "vbn vbd jj"],
  "inscription": ["ih-n s-k-r-ih1-p sh-ah-n", "nn"],
  "inscrutable": ["ih-n s-k-r-uw1 t-ah b-ah-l", "jj"],
  "insect": ["ih1-n s-eh-k-t", "nn jj"],
  "insecticide": ["ih-n s-eh1-k t-ah s-ay-d", "nn"],
  "insecure": ["ih1-n s-ah k-y-er", "jj"],
  "insecurity": ["ih-n s-ih k-y-uh1 r-ih t-iy", "nn"],
  "insemination": ["ih-n s-eh m-ah n-ey1 sh-ah-n", "nn"],
  "insensitive": ["ih-n s-eh1-n s-ah t-ih-v", "jj"],
  "insensitivity": ["ih-n s-eh-n s-ah t-ih1 v-ah t-iy", "nn"],
  "inseparable": ["ih-n s-eh1 p-er ah b-ah-l", "jj"],
  "insert": ["ih-n s-er1-t", "vb vbp nn"],
  "insertion": ["ih-n s-er1 sh-ah-n", "nn"],
  "inset": ["ih1-n s-eh-t", "nn"],
  "inshore": ["ih1-n sh-ao1-r", "jj rb"],
  "inside": ["ih-n s-ay1-d", "in jj nn rb"],
  "insider": ["ih-n s-ay1 d-er", "nn jj"],
  "insidious": ["ih-n s-ih1 d-iy ah-s", "jj"],
  "insight": ["ih1-n s-ay-t", "nn"],
  "insightful": ["ih1-n s-ay-t f-ah-l", "jj"],
  "insignificance": ["ih-n s-ih-g n-y-ih1 f-ih k-ah-n-s", "nn"],
  "insignificant": ["ih-n s-ih-g n-y-ih1 f-ih k-ah-n-t", "jj"],
  "insincere": ["ih-n s-ih-n s-ih1-r", "jj"],
  "insinuate": ["ih-n s-ih1 n-y-uw ey-t", "vb"],
  "insinuation": ["ih-n s-ih n-y-uw ey1 sh-ah-n", "nn"],
  "insist": ["ih-n s-ih1-s-t", "vbp vb"],
  "insistence": ["ih-n s-ih1 s-t-ah-n-s", "nn"],
  "insistent": ["ih-n s-ih1 s-t-ah-n-t", "jj"],
  "insistently": ["ih-n s-ih1 s-t-ah-n-t l-iy", "rb"],
  "insofar": ["ih1-n s-ah f-aa-r", "rb in"],
  "insolence": ["ih1-n s-ah l-ah-n-s", "nn"],
  "insolent": ["ih1-n s-ah l-ah-n-t", "jj"],
  "insoluble": ["ih-n s-aa1 l-y-ah b-ah-l", "jj nn"],
  "insolvency": ["ih-n s-aa1-l v-ah-n s-iy", "nn"],
  "insolvent": ["ih-n s-aa1-l v-ah-n-t", "jj nn"],
  "insomnia": ["ih-n s-aa1-m n-iy ah", "nn"],
  "inspect": ["ih-n s-p-eh1-k-t", "vb vbp"],
  "inspection": ["ih-n s-p-eh1-k sh-ah-n", "nn"],
  "inspector": ["ih-n s-p-eh1-k t-er", "nn"],
  "inspiration": ["ih-n s-p-er ey1 sh-ah-n", "nn"],
  "inspirational": ["ih-n s-p-er ey1 sh-ah n-ah-l", "jj"],
  "inspire": ["ih-n s-p-ay1-r", "vb vbp"],
  "inspired": ["ih-n s-p-ay1 er-d", "vbn jj vbd"],
  "inspiring": ["ih-n s-p-ay1 r-ih-ng", "jj vbg"],
  "instability": ["ih-n s-t-ah b-ih1 l-ih t-iy", "nn"],
  "install": ["ih-n s-t-ao1-l", "vb vbp"],
  "installation": ["ih-n s-t-ah l-ey1 sh-ah-n", "nn"],
  "installed": ["ih-n s-t-ao1-l-d", "vbn jj vbd"],
  "installer": ["ih-n s-t-ao1 l-er", "nn"],
  "installment": ["ih-n s-t-ao1-l m-ah-n-t", "nn jj"],
  "instance": ["ih1-n s-t-ah-n-s", "nn"],
  "instant": ["ih1-n s-t-ah-n-t", "nn jj"],
  "instantaneous": ["ih-n s-t-ah-n t-ae1 n-iy ah-s", "jj"],
  "instantaneously": ["ih-n s-t-ah-n t-ae1 n-iy ah-s l-iy", "rb"],
  "instantly": ["ih1-n s-t-ah-n-t l-iy", "rb"],
  "instead": ["ih-n s-t-eh1-d", "rb"],
  "instigate": ["ih1-n s-t-ah g-ey-t", "vb"],
  "instigation": ["ih-n s-t-ih g-ey1 sh-ah-n", "nn"],
  "instigator": ["ih1-n s-t-ah g-ey t-er", "nn"],
  "instill": ["ih-n s-t-ih1-l", "vb"],
  "instinct": ["ih1-n s-t-ih-ng-k-t", "nn"],
  "instinctive": ["ih-n s-t-ih1-ng-k t-ih-v", "jj"],
  "instinctively": ["ih-n s-t-ih1-ng-k t-ih-v l-iy", "rb"],
  "institute": ["ih1-n s-t-ah t-uw-t", "nn vb"],
  "institutes": ["ih1-n s-t-ah t-uw-t-s", "nn"],
  "institution": ["ih-n s-t-ih t-uw1 sh-ah-n", "nn"],
  "institutional": ["ih-n s-t-ih t-uw1 sh-ah n-ah-l", "jj"],
  "institutionalize": ["ih-n-s-t-ih-t-uw1-sh-ah-n-ah-l-ay-z", "vb"],
  "institutionalized": ["ih-n s-t-ih t-uw1 sh-ah n-ah-l ay-z-d", "vbn jj"],
  "institutionally": ["ih-n s-t-ih t-uw1 sh-ah n-ah-l iy", "rb"],
  "instruct": ["ih-n s-t-r-ah1-k-t", "vb vbp"],
  "instruction": ["ih-n s-t-r-ah1-k sh-ah-n", "nn"],
  "instructional": ["ih-n s-t-r-ah1-k sh-ah n-ah-l", "jj"],
  "instructive": ["ih-n s-t-r-ah1-k t-ih-v", "jj"],
  "instructor": ["ih-n s-t-r-ah1-k t-er", "nn"],
  "instrument": ["ih1-n s-t-r-ah m-ah-n-t", "nn"],
  "instrumental": ["ih-n-s t-r-ah m-eh1-n t-ah-l", "jj nn"],
  "instrumentalist": ["ih-n-s t-r-ah m-eh1-n t-ah l-ih-s-t", "nn"],
  "instrumentation": ["ih-n-s t-r-ah m-eh-n t-ey1 sh-ah-n", "nn"],
  "insubordination": ["ih-n s-ah b-ao-r d-ah n-ey1 sh-ah-n", "nn"],
  "insubstantial": ["ih-n s-ah-b s-t-ae1-n ch-ah-l", "jj"],
  "insufferable": ["ih-n s-ah1 f-er ah b-ah-l", "jj"],
  "insufficient": ["ih-n s-ah f-ih1 sh-ah-n-t", "jj"],
  "insufficiently": ["ih-n s-ah f-ih1 sh-ah-n-t l-iy", "rb"],
  "insularity": ["ih-n s-ah l-eh1 r-ih t-iy", "nn"],
  "insulate": ["ih1-n s-ah l-ey-t", "vb vbp"],
  "insulated": ["ih1-n s-ah l-ey t-ah-d", "vbn . jj"],
  "insulating": ["ih1-n s-ah l-ey t-ih-ng", "vbg jj nn"],
  "insulation": ["ih-n s-ah l-ey1 sh-ah-n", "nn"],
  "insulator": ["ih1-n s-ah l-ey t-er", "nn"],
  "insulin": ["ih1-n s-ah l-ah-n", "nn"],
  "insult": ["ih-n s-ah1-l-t", "nn vb"],
  "insulting": ["ih-n s-ah1-l t-ih-ng", "jj vbg"],
  "insupportable": ["ih-n s-ah p-ao1-r t-ah b-ah-l", "jj"],
  "insurance": ["ih-n sh-uh1 r-ah-n-s", "nn"],
  "insure": ["ih-n sh-uh1-r", "vb vbp"],
  "insured": ["ih-n sh-uh1-r-d", "vbn vbd jj nn"],
  "insurer": ["ih-n sh-uh1 r-er", "nn"],
  "insurgency": ["ih-n s-er1 jh-ah-n s-iy", "nn"],
  "insurgent": ["ih-n s-er1 jh-ah-n-t", "jj"],
  "insurmountable": ["ih-n s-er m-aw1-n t-ah b-ah-l", "jj"],
  "insurrection": ["ih-n s-er eh1-k sh-ah-n", "nn jj"],
  "intact": ["ih-n t-ae1-k-t", "jj"],
  "intake": ["ih1-n t-ey-k", "nn"],
  "intangible": ["ih-n t-ae1-n jh-ah b-ah-l", "jj nn"],
  "integer": ["ih1-n t-ah jh-er", "nn"],
  "integral": ["ih1-n t-ah g-r-ah-l", "nn jj"],
  "integrate": ["ih1-n t-ah g-r-ey-t", "vb vbp"],
  "integrated": ["ih1-n t-ah g-r-ey t-ah-d", "vbn jj"],
  "integration": ["ih-n t-ah g-r-ey1 sh-ah-n", "nn"],
  "integrator": ["ih1-n t-ah g-r-ey t-er", "nn"],
  "integrity": ["ih-n t-eh1 g-r-ah t-iy", "nn"],
  "intellect": ["ih1-n t-ah l-eh-k-t", "nn"],
  "intellectual": ["ih-n t-ah l-eh1-k ch-uw ah-l", "jj nn"],
  "intellectually": ["ih-n t-ah l-eh1-k ch-uw ah l-iy", "rb"],
  "intelligence": ["ih-n t-eh1 l-ah jh-ah-n-s", "nn"],
  "intelligent": ["ih-n t-eh1 l-ah jh-ah-n-t", "jj"],
  "intelligently": ["ih-n t-eh1 l-ih jh-ah-n-t l-iy", "rb"],
  "intelligentsia": ["ih-n t-eh l-ah jh-eh1-n-t s-iy ah", "nn"],
  "intelligible": ["ih-n t-eh1 l-ah jh-ah b-ah-l", "jj nn"],
  "intend": ["ih-n t-eh1-n-d", "vbp vb"],
  "intended": ["ih-n t-eh1-n d-ah-d", "vbn vbd jj"],
  "intense": ["ih-n t-eh1-n-s", "jj"],
  "intensely": ["ih-n t-eh1-n-s l-iy", "rb"],
  "intensification": ["ih-n t-eh-n s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "intensified": ["ih-n t-eh1-n s-ah f-ay-d", "vbn vbd jj"],
  "intensify": ["ih-n t-eh1-n s-ah f-ay", "vb vbp"],
  "intensifying": ["ih-n t-eh1-n s-ah f-ay ih-ng", "vbg jj"],
  "intensity": ["ih-n t-eh1-n s-ah t-iy", "nn"],
  "intensive": ["ih-n t-eh1-n s-ih-v", "jj nn"],
  "intensively": ["ih-n t-eh1-n s-ih-v l-iy", "rb"],
  "intent": ["ih-n t-eh1-n-t", "nn jj"],
  "intention": ["ih-n t-eh1-n ch-ah-n", "nn"],
  "intentional": ["ih-n t-eh1-n sh-ah n-ah-l", "jj"],
  "intentionally": ["ih-n t-eh1-n sh-ah-n ah l-iy", "rb"],
  "intentioned": ["ih-n t-eh1-n ch-ah-n-d", "jj"],
  "intently": ["ih-n t-eh1-n-t l-iy", "rb"],
  "inter": ["ih-n-t-er1", "vb"],
  "interact": ["ih-n t-er ae1-k-t", "vbp vb"],
  "interaction": ["ih-n t-er ae1-k sh-ah-n", "nn"],
  "interactive": ["ih-n t-er ae1-k t-ih-v", "jj"],
  "interagency": ["ih-n t-er ey1 jh-ah-n s-iy", "nn jj"],
  "interbank": ["ih-n t-er b-ae1-ng-k", "nn jj rb"],
  "intercede": ["ih-n t-er s-iy1-d", "vb"],
  "intercept": ["ih-n t-er s-eh1-p-t", "nn vbp vb"],
  "interception": ["ih-n t-er s-eh1-p sh-ah-n", "nn"],
  "interceptor": ["ih-n t-er s-eh1-p t-er", "nn"],
  "interchange": ["ih-n t-er ch-ey1-n-jh", "nn"],
  "interchangeable": ["ih-n t-er ch-ey1-n jh-ah b-ah-l", "jj"],
  "intercity": ["ih1-n t-er s-ih t-iy", "jj nn"],
  "intercollegiate": ["ih-n t-er k-ah l-iy1 jh-ah-t", "jj"],
  "intercom": ["ih1-n t-er k-aa-m", "nn"],
  "intercompany": ["ih-n t-er k-ah1-m p-ah n-iy", "nn"],
  "interconnect": ["ih-n t-er k-ah n-eh1-k-t", "nn vb"],
  "interconnection": ["ih-n t-er k-ah n-eh1-k sh-ah-n", "nn"],
  "intercontinental": ["ih-n t-er k-aa-n t-ah n-eh1-n t-ah-l", "jj"],
  "intercourse": ["ih1-n t-er k-ao-r-s", "nn"],
  "interdependence": ["ih-n t-er d-ah p-eh1-n d-ah-n-s", "nn"],
  "interdependent": ["ih-n t-er d-ih p-eh1-n d-ah-n-t", "jj"],
  "interdict": ["ih1-n-t-er-d-ih-k-t", "vb"],
  "interdiction": ["ih-n t-er d-ih1-k sh-ah-n", "nn"],
  "interest": ["ih1-n t-r-ah-s-t", "nn vbp vb"],
  "interested": ["ih1-n t-r-ah s-t-ah-d", "jj vbd vbn"],
  "interesting": ["ih1-n t-r-ah s-t-ih-ng", "jj"],
  "interestingly": ["ih1-n t-er eh s-t-ih-ng l-iy", "rb"],
  "interestrate": ["ih1-n t-er ah s-t-r-ey-t", "nn"],
  "interface": ["ih1-n t-er f-ey-s", "nn vb"],
  "interfaith": ["ih-n t-er f-ey1-th", "jj"],
  "interfere": ["ih-n t-er f-ih1-r", "vb vbp"],
  "interference": ["ih-n t-er f-ih1 r-ah-n-s", "nn"],
  "interferometer": ["ih-n t-er f-er aa1 m-ah t-er", "nn"],
  "interferon": ["ih-n t-er f-eh1 r-aa-n", "nn"],
  "intergenerational": ["ih-n t-er jh-eh1 n-er ey1 sh-ah n-ah-l", "jj"],
  "intergovernmental": ["ih-n t-er g-ah v-er-n m-eh1-n t-ah-l", "jj"],
  "intergroup": ["ih-n t-er g-r-uw1-p", "jj nn"],
  "interim": ["ih1-n t-er ah-m", "jj nn"],
  "interior": ["ih-n t-ih1 r-iy er", "jj nn"],
  "interject": ["ih-n t-er jh-eh1-k-t", "vb vbp"],
  "interlace": ["ih-n-t-er-l-ey1-s", "vb"],
  "interlaced": ["ih-n t-er l-ey1-s-t", "vbn jj"],
  "interlock": ["ih-n-t-er-l-aa1-k", "vb"],
  "interlocking": ["ih1-n t-er l-aa k-ih-ng", "jj"],
  "interloper": ["ih1-n t-er l-ow p-er", "nn"],
  "interlude": ["ih1-n t-er l-uw-d", "nn"],
  "intermediary": ["ih-n t-er m-iy1 d-iy eh r-iy", "nn jj"],
  "intermediate": ["ih-n t-er m-iy1 d-iy ih-t", "jj"],
  "interminable": ["ih-n t-er1 m-ah n-ah b-ah-l", "jj"],
  "intermingle": ["ih-n t-er m-ih1-ng g-ah-l", "vb vbp"],
  "intermission": ["ih-n t-er m-ih1 sh-ah-n", "nn"],
  "intermittent": ["ih-n t-er m-ih1 t-ah-n-t", "jj"],
  "intermittently": ["ih-n t-er m-ih1 t-ah-n-t l-iy", "rb"],
  "intern": ["ih1-n t-er-n", "nn vb"],
  "internal": ["ih-n t-er1 n-ah-l", "jj"],
  "internally": ["ih-n t-er1 n-ah l-iy", "rb"],
  "international": ["ih-n t-er n-ae1 sh-ah n-ah-l", "jj nn"],
  "internationalization": ["ih-n t-er n-ae sh-ah-n ah l-ih z-ey1 sh-ah-n", "nn"],
  "internationalize": ["ih-n t-er n-ae1 sh-ah-n ah l-ay-z", "vb"],
  "internationally": ["ih-n t-er n-ae1 sh-ah-n ah l-iy", "rb"],
  "internist": ["ih-n t-er1 n-ih-s-t", "nn"],
  "internment": ["ih-n t-er1-n m-ah-n-t", "nn"],
  "interoffice": ["ih-n t-er ao1 f-ah-s", "jj"],
  "interpersonal": ["ih-n t-er p-er1 s-ah n-ah-l", "jj"],
  "interplanetary": ["ih-n t-er p-l-ae1 n-ah t-eh r-iy", "jj"],
  "interplay": ["ih1-n t-er p-l-ey", "nn"],
  "interpolate": ["ih-t-er1-p-ah-l-ey-t", "vb"],
  "interpret": ["ih-n t-er1 p-r-ah-t", "vb vbp"],
  "interpretation": ["ih-n t-er p-r-ih t-ey1 sh-ah-n", "nn"],
  "interpreter": ["ih-n t-er1 p-r-ah t-er", "nn"],
  "interpretive": ["ih-n t-er1 p-r-ah t-ih-v", "jj"],
  "interprovincial": ["ih-n t-er p-r-ow v-ih1-n sh-ah-l", "jj"],
  "interrelate": ["ih-n-t-er-r-ih-l-ey1-t", "vb"],
  "interrelated": ["ih-n t-er r-ih l-ey1 t-ih-d", "vbn jj"],
  "interrogate": ["ih-n t-eh1 r-ah g-ey-t", "vb"],
  "interrogation": ["ih-n t-eh r-ah g-ey1 sh-ah-n", "nn"],
  "interrogator": ["ih-n t-eh1 r-ah g-ey t-er", "nn"],
  "interrupt": ["ih-n t-er ah1-p-t", "vb vbp"],
  "interrupted": ["ih-n t-er ah1-p t-ih-d", "vbn jj vbd"],
  "interruption": ["ih-n t-er ah1-p sh-ah-n", "nn"],
  "intersect": ["ih-n t-er s-eh1-k-t", "vb vbp"],
  "intersection": ["ih-n t-er s-eh1-k sh-ah-n", "nn"],
  "intersperse": ["ih-n-t-er-s-p-er1-s", "vb"],
  "interstate": ["ih-n t-er s-t-ey1-t", "jj nn"],
  "interstellar": ["ih-n t-er s-t-eh1 l-er", "jj"],
  "intertwine": ["ih-n-t-er-t-w-ay1-n", "vb"],
  "intertwined": ["ih-n t-er t-w-ay1-n-d", "vbn jj"],
  "intertwining": ["ih1-n t-er t-w-ay n-ih-ng", "vbg jj"],
  "interval": ["ih1-n t-er v-ah-l", "nn"],
  "intervene": ["ih-n t-er v-iy1-n", "vb"],
  "intervenor": ["ih-n t-er v-iy1 n-er", "nn"],
  "intervention": ["ih-n t-er v-eh1-n ch-ah-n", "nn"],
  "interventionist": ["ih-n t-er v-eh1-n sh-ah n-ih-s-t", "jj"],
  "interview": ["ih1-n t-er v-y-uw", "nn vb"],
  "interviewee": ["ih-n t-er v-y-uw iy1", "nn"],
  "interviewer": ["ih1-n t-er v-y-uw er", "nn"],
  "interweave": ["ih-n-t-er-w-iy1-v", "vb"],
  "interwoven": ["ih-n t-er w-ow1 v-ah-n", "vbn vbd"],
  "intestinal": ["ih-n t-eh1 s-t-ah n-ah-l", "jj"],
  "intestine": ["ih-n t-eh1 s-t-ah-n", "nn"],
  "intifada": ["ih-n t-ih f-aa1 d-ah", "nn"],
  "intimacy": ["ih1-n t-ah m-ah s-iy", "nn"],
  "intimate": ["ih1-n t-ah m-ah-t", "jj nn vb"],
  "intimately": ["ih1-n t-ah m-ah-t l-iy", "rb"],
  "intimation": ["ih-n t-ah m-ey1 sh-ah-n", "nn"],
  "intimidate": ["ih-n t-ih1 m-ih d-ey-t", "vb"],
  "intimidating": ["ih-n t-ih1 m-ih d-ey t-ih-ng", "vbg jj"],
  "intimidation": ["ih-n t-ih m-ih d-ey1 sh-ah-n", "nn"],
  "into": ["ih-n t-uw1", "in rp"],
  "intolerable": ["ih-n t-aa1 l-er ah b-ah-l", "jj"],
  "intolerably": ["ih-n t-aa1 l-er ah b-l-iy", "rb"],
  "intolerance": ["ih-n t-aa1 l-er ah-n-s", "nn"],
  "intolerant": ["ih-n t-aa1 l-er ah-n-t", "jj"],
  "intone": ["ih-n-t-ow1-n", "vb"],
  "intoxicated": ["ih-n t-aa1-k s-ah k-ey t-ah-d", "jj"],
  "intoxicating": ["ih-n t-aa1-k s-ih k-ey t-ih-ng", "jj"],
  "intoxication": ["ih-n t-aa-k s-ah k-ey1 sh-ah-n", "nn"],
  "intracompany": ["ih-n t-r-ah k-aa1-m p-ah n-iy", "jj"],
  "intractable": ["ih-n t-r-ae1-k t-ah b-ah-l", "jj"],
  "intramural": ["ih-n t-r-ah m-y-uh1 r-ah-l", "jj"],
  "intransigence": ["ih-n t-r-ae1-n s-ah jh-ah-n-s", "nn"],
  "intransigent": ["ih-n t-r-ae1-n s-ah jh-ah-n-t", "jj"],
  "intraocular": ["ih-n t-r-ah ow1 k-y-uw l-er", "jj"],
  "intraparty": ["ih1-n t-r-ah p-aa-r t-iy", "jj"],
  "intrastate": ["ih-n t-r-ah s-t-ey1-t", "jj"],
  "intrauterine": ["ih-n t-r-ah y-uw1 t-er ih-n", "jj"],
  "intravenous": ["ih-n t-r-ah v-iy1 n-ah-s", "jj"],
  "intravenously": ["ih-n t-r-ae1 v-ah n-ah-s l-iy", "rb"],
  "intrepid": ["ih-n t-r-eh1 p-ah-d", "jj"],
  "intricacy": ["ih1-n t-r-ah k-ah s-iy", "nn"],
  "intricate": ["ih1-n t-r-ah k-ah-t", "jj"],
  "intricately": ["ih1-n t-r-ah k-ah-t l-iy", "rb"],
  "intrigue": ["ih-n t-r-iy1-g", "nn vb"],
  "intrigued": ["ih1-n t-r-iy-g-d", "vbn jj"],
  "intriguing": ["ih-n t-r-iy1 g-ih-ng", "jj vbg"],
  "intriguingly": ["ih-n t-r-iy1 g-ih-ng l-iy", "rb"],
  "intrinsic": ["ih-n t-r-ih1-n s-ih-k", "jj"],
  "intrinsically": ["ih-n t-r-ih1-n s-ih k-ah l-iy", "rb"],
  "introduce": ["ih-n t-r-ah d-uw1-s", "vb vbp"],
  "introduction": ["ih-n t-r-ah d-ah1-k sh-ah-n", "nn"],
  "introductory": ["ih-n t-r-ah d-ah1-k t-er iy", "jj"],
  "introspection": ["ih-n t-r-ah s-p-eh1-k sh-ah-n", "nn"],
  "introspective": ["ih-n t-r-ah s-p-eh1-k t-ih-v", "jj"],
  "introvert": ["ih1-n-t-r-ow-v-er-t", "vb"],
  "introverted": ["ih1-n t-r-ow v-er t-ih-d", "vbn jj"],
  "intrude": ["ih-n t-r-uw1-d", "vb vbp"],
  "intruder": ["ih-n t-r-uw1 d-er", "nn"],
  "intrusion": ["ih-n t-r-uw1 zh-ah-n", "nn"],
  "intrusive": ["ih-n t-r-uw1 s-ih-v", "jj"],
  "intuition": ["ih-n t-uw ih1 sh-ah-n", "nn"],
  "intuitive": ["ih-n t-uw1 ah t-ih-v", "jj"],
  "intuitively": ["ih-n t-uw1 ih t-ih-v l-iy", "rb"],
  "inundate": ["ih1-n-ah-n-d-ey-t", "vb"],
  "inundated": ["ih1 n-ah-n d-ey t-ih-d", "vbn jj"],
  "inundation": ["ih n-ah-n d-ey1 sh-ah-n", "nn"],
  "inure": ["ih-n-y-uh1-r", "vb"],
  "invade": ["ih-n v-ey1-d", "vb vbp"],
  "invader": ["ih-n v-ey1 d-er", "nn"],
  "invalid": ["ih1-n v-ah l-ah-d", "jj nn"],
  "invalidate": ["ih-n v-ae1 l-ih d-ey-t", "vb"],
  "invaluable": ["ih-n v-ae1-l y-ah b-ah-l", "jj"],
  "invariably": ["ih-n v-eh1 r-iy ah b-l-iy", "rb"],
  "invariant": ["ih-n v-eh1 r-iy ah-n-t", "jj nn"],
  "invasion": ["ih-n v-ey1 zh-ah-n", "nn"],
  "invasive": ["ih-n v-ey1 s-ih-v", "jj"],
  "invective": ["ih-n v-eh1-k t-ih-v", "nn"],
  "invent": ["ih-n v-eh1-n-t", "vb vbp"],
  "invention": ["ih-n v-eh1-n sh-ah-n", "nn"],
  "inventive": ["ih-n v-eh1-n t-ih-v", "jj"],
  "inventiveness": ["ih-n v-eh1-n t-ih-v n-ah-s", "nn"],
  "inventor": ["ih-n v-eh1-n t-er", "nn"],
  "inventory": ["ih-n v-ah-n t-ao1 r-iy", "nn"],
  "inverse": ["ih-n v-er1-s", "jj nn"],
  "inversely": ["ih-n v-er1-s l-iy", "rb"],
  "inversion": ["ih-n v-er1 zh-ah-n", "nn"],
  "invert": ["ih-n-v-er1-t", "vb"],
  "invertebrate": ["ih-n v-er1 t-ah b-r-ah-t", "nn"],
  "inverted": ["ih-n v-er1 t-ih-d", "jj vbn"],
  "invest": ["ih-n v-eh1-s-t", "vb vbp"],
  "investable": ["ih-n v-eh1 s-t-ah b-ah-l", "jj"],
  "invested": ["ih-n v-eh1 s-t-ah-d", "vbn jj vbd"],
  "investigate": ["ih-n v-eh1 s-t-ah g-ey-t", "vb vbp"],
  "investigation": ["ih-n v-eh s-t-ah g-ey1 sh-ah-n", "nn"],
  "investigational": ["ih-n v-eh s-t-ih g-ey1 sh-ah n-ah-l", "jj"],
  "investigative": ["ih-n v-eh1 s-t-ah g-ey t-ih-v", "jj"],
  "investigator": ["ih-n v-eh1 s-t-ah g-ey t-er", "nn"],
  "investing": ["ih-n v-eh1 s-t-ih-ng", "vbg jj nn"],
  "investment": ["ih-n v-eh1-s-t m-ah-n-t", "nn jj"],
  "investor": ["ih-n v-eh1 s-t-er", "nn"],
  "inveterate": ["ih-n v-eh1 t-er ah-t", "jj"],
  "invidious": ["ih-n v-ih1 d-iy ah-s", "jj"],
  "invigorate": ["ih-n v-ih1 g-er ih-t", "vb"],
  "invincible": ["ih-n v-ih1-n s-ah b-ah-l", "jj"],
  "inviolable": ["ih-n v-ay1 ah l-ah b-ah-l", "jj"],
  "inviolate": ["ih-n v-ay1 ah l-ih-t", "jj"],
  "invisible": ["ih-n v-ih1 z-ah b-ah-l", "jj"],
  "invitation": ["ih-n v-ih t-ey1 sh-ah-n", "nn"],
  "invitational": ["ih-n v-ah t-ey1 sh-ah n-ah-l", "jj"],
  "invite": ["ih-n v-ay1-t", "vb vbp nn"],
  "inviting": ["ih-n v-ay1 t-ih-ng", "vbg jj"],
  "invocation": ["ih-n v-ah k-ey1 sh-ah-n", "nn"],
  "invoice": ["ih1-n v-oy s-ih", "nn"],
  "invoicing": ["ih1-n v-oy s-ih-ng", "nn"],
  "invoke": ["ih-n v-ow1-k", "vb"],
  "involuntarily": ["ih-n v-ow l-ah1-n t-er ih l-iy", "rb"],
  "involuntary": ["ih-n v-aa1 l-ah-n t-eh r-iy", "jj"],
  "involve": ["ih-n v-aa1-l-v", "vb vbp"],
  "involved": ["ih-n v-aa1-l-v-d", "vbn vbd jj"],
  "involvement": ["ih-n v-aa1-l-v m-ah-n-t", "nn"],
  "invulnerability": ["ih-n v-ah-l n-er ah b-ih1 l-ih t-iy", "nn"],
  "invulnerable": ["ih-n v-ah1-l n-er ah b-ah-l", "jj"],
  "inward": ["ih1-n w-er-d", "rb jj"],
  "inwardly": ["ih1-n w-er-d l-iy", "rb"],
  "iodide": ["ay1 ah d-ay-d", "nn"],
  "iodine": ["ay1 ah d-ay-n", "nn"],
  "ion": ["ay1 ah-n", "nn"],
  "ionic": ["ay aa1 n-ih-k", "jj"],
  "ionize": ["ay1-ah-n-ay-z", "vb"],
  "iota": ["ay ow1 t-ah", "nn"],
  "ip": ["ih1-p", "nn"],
  "irate": ["ay r-ey1-t", "jj"],
  "ire": ["ay1-r", "nn"],
  "iridescent": ["ih r-ah d-eh1 s-ah-n-t", "jj"],
  "iridium": ["ih r-ih1 d-iy ah-m", "nn"],
  "irk": ["er1-k", "vb"],
  "irksome": ["er1-k s-ah-m", "jj"],
  "iron": ["ay1 er-n", "nn vb"],
  "ironclad": ["ay1 er-n k-l-ae-d", "jj"],
  "ironic": ["ay r-aa1 n-ih-k", "jj"],
  "ironical": ["ay r-aa1 n-ih k-ah-l", "jj"],
  "ironically": ["ay r-aa1 n-ih-k l-iy", "rb"],
  "irony": ["ay1 r-ah n-iy", "nn"],
  "irradiate": ["ih-r-ey1-d-iy-ey-t", "vb"],
  "irradiated": ["ih r-ey1 d-iy ey t-ih-d", "vbn jj"],
  "irradiation": ["ih r-ey d-iy ey1 sh-ah-n", "nn"],
  "irrational": ["ih r-ae1 sh-ah n-ah-l", "jj"],
  "irrationality": ["ih r-ae sh-ah n-ae1 l-ah t-iy", "nn"],
  "irrationally": ["ih r-ae1 sh-ah-n ah l-iy", "rb"],
  "irreconcilable": ["ih r-eh1 k-ah-n s-ay l-ah b-ah-l", "jj"],
  "irrefutable": ["ih r-ah f-y-uw1 t-ah b-ah-l", "jj"],
  "irregular": ["ih r-eh1 g-y-ah l-er", "jj nn"],
  "irregularity": ["ih r-eh g-y-ah l-eh1 r-ah t-iy", "nn"],
  "irregularly": ["ih r-eh1 g-y-ah l-er l-iy", "rb"],
  "irrelevant": ["ih r-eh1 l-ah v-ah-n-t", "jj"],
  "irremediable": ["ih r-ih m-iy1 d-iy ah b-ah-l", "jj"],
  "irreparable": ["ih r-eh1 p-er ah b-ah-l", "jj"],
  "irreparably": ["ih r-eh1 p-er ah b-l-iy", "rb"],
  "irreplaceable": ["ih r-ah p-l-ey1 s-ah b-ah-l", "jj"],
  "irrepressible": ["ih r-ah p-r-eh1 s-ah b-ah-l", "jj"],
  "irresistible": ["ih r-ih z-ih1 s-t-ah b-ah-l", "jj"],
  "irresistibly": ["ih r-ih z-ih1 s-t-ah b-l-iy", "rb"],
  "irrespective": ["ih r-ah s-p-eh1-k t-ih-v", "rb"],
  "irresponsibility": ["ih r-ah s-p-aa-n s-ah b-ih1 l-ah t-iy", "nn"],
  "irresponsible": ["ih r-ah s-p-aa1-n s-ah b-ah-l", "jj nn"],
  "irresponsibly": ["ih r-ah s-p-aa1-n s-ah b-l-iy", "rb"],
  "irretrievably": ["ih r-ah t-r-iy1 v-ah b-l-iy", "rb"],
  "irreverence": ["ih r-eh1 v-er ah-n-s", "nn"],
  "irreverent": ["ih r-eh1 v-er ah-n-t", "jj"],
  "irreversible": ["ih r-ih v-er1 s-ah b-ah-l", "jj"],
  "irreversibly": ["ih r-ih v-er1 s-ah b-l-iy", "rb"],
  "irrevocable": ["ih r-eh1 v-ah k-ah b-ah-l", "jj"],
  "irrevocably": ["ih r-eh1 v-ah k-ah b-l-iy", "rb"],
  "irrigate": ["ih1 r-ah g-ey-t", "vb"],
  "irrigation": ["ih r-ah g-ey1 sh-ah-n", "nn"],
  "irritable": ["ih1 r-ah t-ah b-ah-l", "jj"],
  "irritant": ["ih1 r-ah t-ah-n-t", "nn"],
  "irritate": ["ih1 r-ih t-ey-t", "vb"],
  "irritated": ["ih1 r-ah t-ey t-ah-d", "vbn jj vbd"],
  "irritating": ["ih1 r-ah t-ey t-ih-ng", "jj"],
  "irritation": ["ih r-ih t-ey1 sh-ah-n", "nn"],
  "is": ["ih1-s", "vbz"],
  "isn't": ["ih1-z-ah-n-t", "vbz vbp"],
  "island": ["ay1 l-ah-n-d", "nn"],
  "islander": ["ay1 l-ah-n d-er", "nn"],
  "isle": ["ay1-l", "nn"],
  "isolate": ["ay1 s-ah l-ey-t", "vb vbp"],
  "isolated": ["ay1 s-ah l-ey t-ah-d", "vbn jj vbd"],
  "isolating": ["ay1 s-ah l-ey t-ih-ng", "vbg jj"],
  "isolation": ["ay s-ah l-ey1 sh-ah-n", "nn"],
  "isolationism": ["ay s-ah l-ey1 sh-ah-n ih z-ah-m", "nn"],
  "isomer": ["ay1 s-ah m-er", "nn"],
  "isothermal": ["ay s-ah th-er1 m-ah-l", "jj"],
  "isotonic": ["ay s-ah t-aa1 n-ih-k", "jj"],
  "isotopic": ["ay s-ah t-aa1 p-ih-k", "jj"],
  "issuable": ["ih1 sh-uw ah b-ah-l", "jj"],
  "issuance": ["ih1 sh-uw ah-n-s", "nn"],
  "issue": ["ih1 sh-uw", "nn vbp vb"],
  "issued": ["ih1 sh-uw-d", "vbn vbd jj"],
  "issuer": ["ih1 sh-uw er", "nn"],
  "isthmus": ["ih1-s m-ah-s", "nn"],
  "it": ["ih1-t", "prp"],
  "italic": ["ay t-ae1 l-ih-k", "nn"],
  "itch": ["ih1-ch", "vb nn"],
  "itchy": ["ih1 ch-iy", "jj"],
  "item": ["ay1 t-ah-m", "nn"],
  "itemize": ["ay1 t-ah m-ay-z", "vb"],
  "itinerant": ["ay t-ih1 n-er ah-n-t", "jj"],
  "itinerary": ["ay t-ih1 n-er eh r-iy", "nn"],
  "its": ["ih1-t-s", "prp$"],
  "itself": ["ih-t s-eh1-l-f", "prp"],
  "ivory": ["ay1 v-er iy", "nn jj"],
  "ivy": ["ay1 v-iy", "nn"],
  "jab": ["jh-ae1-b", "nn"],
  "jabbed": ["jh-ae1-b-d", "vbd"],
  "jack": ["jh-ae1-k", "vb nn"],
  "jackass": ["jh-ae1 k-ae-s", "nn"],
  "jacket": ["jh-ae1 k-ah-t", "nn vb"],
  "jackhammer": ["jh-ae1-k hh-ae m-er", "nn"],
  "jackpot": ["jh-ae1-k p-aa-t", "nn"],
  "jade": ["jh-ey1-d", "nn"],
  "jaded": ["jh-ey1 d-ah-d", "jj"],
  "jag": ["jh-ae1-g-d", "vb"],
  "jagged": ["jh-ae1-g-d", "jj vbn"],
  "jail": ["jh-ey1-l", "nn vb"],
  "jailed": ["jh-ey1-l-d", "vbn vbd jj"],
  "jailhouse": ["jh-ey1-l hh-aw-s", "nn"],
  "jalopy": ["jh-ah l-aa1 p-iy", "nn"],
  "jam": ["jh-ae1-m", "nn vb vbp"],
  "jammed": ["jh-ae1-m-d", "vbn vbd jj"],
  "jamming": ["jh-ae1 m-ih-ng", "nn"],
  "janitor": ["jh-ae1 n-ah t-er", "nn"],
  "jar": ["jh-aa1-r", "nn"],
  "jargon": ["jh-aa1-r g-ah-n", "nn"],
  "jarred": ["jh-aa1-r-d", "vbd vbn"],
  "jarring": ["jh-aa1 r-ih-ng", "vbg jj"],
  "jasmine": ["jh-ae1-z m-ah-n", "nn"],
  "jaunt": ["jh-ao1-n-t", "nn"],
  "jauntily": ["jh-ao1-n t-ah l-iy", "rb"],
  "jaunty": ["jh-ao1-n t-iy", "jj"],
  "java": ["jh-aa1 v-ah", "nn"],
  "jaw": ["jh-ao1", "nn"],
  "jawbone": ["jh-ao1 b-ow-n", "nn"],
  "jawboning": ["jh-ao1 b-ow n-ih-ng", "nn"],
  "jay": ["jh-ey1", "nn"],
  "jazz": ["jh-ae1-z", "nn"],
  "jazzy": ["jh-ae1 z-iy", "jj"],
  "jealous": ["jh-eh1 l-ah-s", "jj"],
  "jealously": ["jh-eh1 l-ah-s l-iy", "rb"],
  "jealousy": ["jh-eh1 l-ah s-iy", "nn"],
  "jeans": ["jh-iy1-n-s", "nn"],
  "jeep": ["jh-iy1-p", "nn"],
  "jeer": ["jh-iy1-r", "nn vb"],
  "jelly": ["jh-eh1 l-iy", "nn"],
  "jellyfish": ["jh-eh1 l-iy f-ih-sh", "nn"],
  "jeopardize": ["jh-eh1 p-er d-ay-z", "vb vbp"],
  "jeopardy": ["jh-eh1 p-er d-iy", "nn"],
  "jerk": ["jh-er1-k", "nn vb"],
  "jerky": ["jh-er1 k-iy", "jj nn"],
  "jest": ["jh-eh1-s-t", "nn"],
  "jester": ["jh-eh1 s-t-er", "nn"],
  "jet": ["jh-eh1-t", "nn vb vbp"],
  "jetliner": ["jh-eh1-t l-ay n-er", "nn"],
  "jettison": ["jh-eh1 t-ih s-ah-n", "vb"],
  "jetty": ["jh-eh1 t-iy", "nn"],
  "jewel": ["jh-uw1 ah-l", "nn"],
  "jeweler": ["jh-uw1 ah l-er", "nn"],
  "jewelry": ["jh-uw1 ah-l r-iy", "nn"],
  "jibe": ["jh-ay1-b", "nn"],
  "jiffy": ["jh-ih1 f-iy", "nn"],
  "jig": ["jh-ih1-g", "nn"],
  "jiggle": ["jh-ih1-g-ah-l", "vb"],
  "jigsaw": ["jh-ih1-g s-ao", "nn"],
  "jihad": ["jh-iy1 hh-ae-d", "nn"],
  "jillion": ["jh-ih1 l-y-ah-n", "nn"],
  "jilt": ["jh-ih1-l-t", "vb"],
  "jimmied": ["jh-ih1 m-iy-d", "vbd"],
  "jimmy": ["jh-ih1-m-iy", "vb"],
  "jingle": ["jh-ih1-ng g-ah-l", "nn"],
  "jink": ["jh-ih1-ng-k", "nn"],
  "jinx": ["jh-ih1-ng-k-s", "nn"],
  "jitter": ["jh-ih1 t-er", "vb"],
  "jitters": ["jh-ih1 t-er-z", "vbz nn"],
  "jittery": ["jh-ih1 t-er iy", "jj"],
  "jive": ["jh-ay1-v", "vb"],
  "job": ["jh-aa1-b", "nn"],
  "jobless": ["jh-aa1-b l-ah-s", "jj"],
  "joblessness": ["jh-aa1-b l-ah-s n-ah-s", "nn"],
  "jock": ["jh-aa1-k", "nn"],
  "jockey": ["jh-aa1 k-iy", "nn vb vbp"],
  "jocular": ["jh-aa1 k-y-ah l-er", "jj"],
  "jog": ["jh-aa1-g", "vb"],
  "jogger": ["jh-aa1 g-er", "nn"],
  "jogging": ["jh-aa1 g-ih-ng", "nn"],
  "john": ["jh-aa1-n", "nn"],
  "join": ["jh-oy1-n", "vb vbp"],
  "joiner": ["jh-oy1 n-er", "nn"],
  "joint": ["jh-oy1-n-t", "jj nn"],
  "jointly": ["jh-oy1-n-t l-iy", "rb"],
  "joke": ["jh-ow1-k", "nn vbp vb"],
  "joker": ["jh-ow1 k-er", "nn"],
  "jokingly": ["jh-ow1 k-ih-ng l-iy", "rb"],
  "jolly": ["jh-aa1 l-iy", "jj"],
  "jolt": ["jh-ow1-l-t", "nn vb"],
  "joss": ["jh-ao1-s", "nn"],
  "jostle": ["jh-aa1 s-ah-l", "vbp vb"],
  "jot": ["jh-aa1-t", "nn"],
  "jotted": ["jh-aa1 t-ih-d", "jj"],
  "journal": ["jh-er1 n-ah-l", "nn"],
  "journalism": ["jh-er1 n-ah l-ih z-ah-m", "nn"],
  "journalist": ["jh-er1 n-ah l-ah-s-t", "nn"],
  "journalistic": ["jh-er n-ah l-ih1 s-t-ih-k", "jj"],
  "journey": ["jh-er1 n-iy", "nn vb"],
  "joust": ["jh-aw1-s-t", "vb"],
  "jovial": ["jh-ow1 v-iy ah-l", "jj"],
  "jowl": ["jh-aw1-l", "nn"],
  "jowly": ["jh-aw1 l-iy", "jj"],
  "joy": ["jh-oy1", "nn"],
  "joyful": ["jh-oy1 f-ah-l", "jj"],
  "joyfully": ["jh-oy1 f-ah l-iy", "rb"],
  "joyous": ["jh-oy1 ah-s", "jj"],
  "joyride": ["jh-oy1 r-ay-d", "nn"],
  "jubilant": ["jh-uw1 b-ah l-ah-n-t", "jj"],
  "jubilation": ["jh-uw b-ah l-ey1 sh-ah-n", "nn"],
  "judge": ["jh-ah1-jh", "nn vb vbp"],
  "judgement": ["jh-ah1-jh m-ah-n-t", "nn"],
  "judgeship": ["jh-ah1-jh sh-ih-p", "nn"],
  "judgment": ["jh-ah1-jh m-ah-n-t", "nn"],
  "judgmental": ["jh-ah-jh m-eh1-n t-ah-l", "jj"],
  "judicial": ["jh-uw d-ih1 sh-ah-l", "jj"],
  "judicially": ["jh-uw d-ih1 sh-ah l-iy", "rb"],
  "judiciary": ["jh-uw d-ih1 sh-iy eh r-iy", "nn jj"],
  "judicious": ["jh-uw d-ih1 sh-ah-s", "jj"],
  "judiciously": ["jh-uw d-ih1 sh-ih-s l-iy", "rb"],
  "jug": ["jh-ah1-g", "nn"],
  "juggernaut": ["jh-ah1 g-er n-ao-t", "nn"],
  "juggle": ["jh-ah1 g-ah-l", "vb"],
  "juggler": ["jh-ah1 g-ah l-er", "nn"],
  "juice": ["jh-uw1-s", "nn"],
  "juiciest": ["jh-uw1 s-iy ah-s-t", "jjs"],
  "juicy": ["jh-uw1 s-iy", "jj"],
  "jumble": ["jh-ah1-m b-ah-l", "nn vb"],
  "jumbo": ["jh-ah1-m b-ow", "jj nn"],
  "jump": ["jh-ah1-m-p", "nn vbp jj vb"],
  "jumper": ["jh-ah1-m p-er", "nn"],
  "jumpy": ["jh-ah1-m p-iy", "jj"],
  "junction": ["jh-ah1-ng-k sh-ah-n", "nn"],
  "juncture": ["jh-ah1-ng-k ch-er", "nn"],
  "jungle": ["jh-ah1-ng g-ah-l", "nn"],
  "junior": ["jh-uw1 n-y-er", "jj nn"],
  "junk": ["jh-ah1-ng-k", "nn vb"],
  "junkbond": ["jh-ah1-ng-k b-aa-n-d", "nn"],
  "junket": ["jh-ah1-ng k-ih-t", "nn"],
  "junkholder": ["jh-ah1-ng-k hh-ow-l d-er", "nn"],
  "junkie": ["jh-ah1-ng k-iy", "nn"],
  "junkyard": ["jh-ah1-ng-k y-aa-r-d", "nn"],
  "junta": ["hh-uh1-n t-ah", "nn"],
  "jurisdiction": ["jh-uh r-ah-s d-ih1-k sh-ah-n", "nn"],
  "jurist": ["jh-uh1 r-ah-s-t", "nn"],
  "juror": ["jh-uh1 r-er", "nn"],
  "jury": ["jh-uh1 r-iy", "nn"],
  "just": ["jh-ah1-s-t", "rb jj rp"],
  "justice": ["jh-ah1 s-t-ah-s", "nn"],
  "justifiable": ["jh-ah1 s-t-ah f-ay ah b-ah-l", "jj"],
  "justifiably": ["jh-ah1 s-t-ah f-ay ah b-l-iy", "rb"],
  "justification": ["jh-ah s-t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "justified": ["jh-ah1 s-t-ah f-ay-d", "vbn vbd jj"],
  "justify": ["jh-ah1 s-t-ah f-ay", "vb vbp"],
  "justly": ["jh-ah1-s-t l-iy", "rb"],
  "jute": ["jh-uw1-t", "nn"],
  "juvenile": ["jh-uw1 v-ah n-ah-l", "jj nn"],
  "juxtapose": ["jh-ah-k-s-t-ah-p-ow1-z", "vb"],
  "juxtaposition": ["jh-ah-k s-t-ah p-ah z-ih1 sh-ah-n", "nn"],
  "kale": ["k-ey1-l", "nn"],
  "kaleidoscope": ["k-ah l-ay1 d-ah s-k-ow-p", "nn"],
  "kamikaze": ["k-aa m-ah k-aa1 z-iy", "nn"],
  "kangaroo": ["k-ae-ng g-er uw1", "nn"],
  "karaoke": ["k-eh r-iy ow1 k-iy", "nn"],
  "kayo": ["k-ey ow1", "vb"],
  "kazoo": ["k-ah z-uw1", "nn"],
  "keel": ["k-iy1-l", "nn vb"],
  "keelson": ["k-eh1-l s-ah-n", "nn"],
  "keen": ["k-iy1-n", "jj nn vb"],
  "keener": ["k-iy1 n-er", "jjr"],
  "keenest": ["k-iy1 n-ah-s-t", "jjs"],
  "keenly": ["k-iy1-n l-iy", "rb"],
  "keep": ["k-iy1-p", "vb nn vbp"],
  "keeper": ["k-iy1 p-er", "nn"],
  "keepsake": ["k-iy1-p s-ey-k", "nn"],
  "keg": ["k-eh1-g", "nn"],
  "kelp": ["k-eh1-l-p", "nn"],
  "kennel": ["k-eh1 n-ah-l", "nn"],
  "kenning": ["k-eh1 n-ih-ng", "nn"],
  "keno": ["k-iy1 n-ow", "jj"],
  "kept": ["k-eh1-p-t", "vbd vbn"],
  "kerchief": ["k-er1 ch-ah-f", "nn"],
  "kernel": ["k-er1 n-ah-l", "nn"],
  "kerosene": ["k-eh1 r-ah s-iy-n", "nn"],
  "ketchup": ["k-eh1 ch-ah-p", "nn vb in"],
  "kettle": ["k-eh1 t-ah-l", "nn"],
  "key": ["k-iy1", "nn vb"],
  "keyboard": ["k-iy1 b-ao-r-d", "nn"],
  "keyed": ["k-iy1-d", "vbn jj"],
  "keyhole": ["k-iy1 hh-ow-l", "nn"],
  "keyless": ["k-iy1 l-ah-s", "jj"],
  "keynote": ["k-iy1 n-ow-t", "vbp nn vb"],
  "keypad": ["k-iy1 p-ae-d", "nn"],
  "keystone": ["k-iy1 s-t-ow-n", "nn"],
  "khaki": ["k-aa1 k-iy", "jj"],
  "kibbutz": ["k-ih b-uh1-t-s", "nn"],
  "kick": ["k-ih1-k", "nn vb vbp"],
  "kickback": ["k-ih1-k b-ae-k", "nn"],
  "kicker": ["k-ih1 k-er", "nn"],
  "kickoff": ["k-ih1-k ao-f", "nn"],
  "kid": ["k-ih1-d", "nn vb"],
  "kiddie": ["k-ih1 d-iy", "nn"],
  "kidnap": ["k-ih1-d n-ae-p", "vb"],
  "kidnapper": ["k-ih1-d n-ae p-er", "nn"],
  "kidnapping": ["k-ih1-d n-ae p-ih-ng", "nn vbg"],
  "kidney": ["k-ih1-d n-iy", "nn"],
  "kill": ["k-ih1-l", "vb vbp nn"],
  "killer": ["k-ih1 l-er", "nn"],
  "killing": ["k-ih1 l-ih-ng", "vbg jj nn"],
  "kiln": ["k-ih1-l-n", "nn"],
  "kilobyte": ["k-ih1 l-ow b-ay-t", "nn"],
  "kilogram": ["k-ih1 l-ah g-r-ae-m", "nn"],
  "kilometer": ["k-ah l-aa1 m-ah t-er", "nn"],
  "kilowatt": ["k-ih1 l-ah w-aa-t", "nn"],
  "kilt": ["k-ih1-l-t", "nn"],
  "kilter": ["k-ih1-l t-er", "nn"],
  "kimchi": ["k-ih1-m ch-iy", "nn"],
  "kimono": ["k-ah m-ow1 n-ah", "nn"],
  "kin": ["k-ih1-n", "nn"],
  "kind": ["k-ay1-n-d", "nn jj rb"],
  "kinder": ["k-ay1-n d-er", "jjr"],
  "kindergarten": ["k-ih1-n d-er g-aa-r t-ah-n", "nn"],
  "kindest": ["k-ay1-n d-ah-s-t", "jjs"],
  "kindle": ["k-ih1-n d-ah-l", "vb"],
  "kindly": ["k-ay1-n-d l-iy", "rb jj"],
  "kindness": ["k-ay1-n-d n-ah-s", "nn"],
  "kindred": ["k-ih1-n d-r-ih-d", "jj"],
  "kinesthetic": ["k-ih n-ah-s th-eh1 t-ih-k", "jj"],
  "kinetic": ["k-ah n-eh1 t-ih-k", "jj"],
  "king": ["k-ih1-ng", "nn"],
  "kingdom": ["k-ih1-ng d-ah-m", "nn"],
  "kingmaker": ["k-ih1-ng m-ey k-er", "nn"],
  "kingpin": ["k-ih1-ng p-ih-n", "nn"],
  "kinship": ["k-ih1-n sh-ih-p", "nn"],
  "kiosk": ["k-iy1 ao-s-k", "nn"],
  "kiss": ["k-ih1-s", "nn vb vbp"],
  "kit": ["k-ih1-t", "nn"],
  "kitchen": ["k-ih1 ch-ah-n", "nn"],
  "kitchenette": ["k-ih ch-ah n-eh1-t", "nn"],
  "kitchenware": ["k-ih1 ch-ah-n w-eh-r", "nn"],
  "kite": ["k-ay1-t", "nn"],
  "kitten": ["k-ih1 t-ah-n", "nn"],
  "kitty": ["k-ih1 t-iy", "nn"],
  "kiwi": ["k-iy1 w-iy", "nn"],
  "klieg": ["k-l-iy1-g", "nn"],
  "knack": ["n-ae1-k", "nn"],
  "knead": ["n-iy1-d", "vb"],
  "knee": ["n-iy1", "nn"],
  "kneecap": ["n-iy1 k-ae-p", "nn"],
  "kneel": ["n-iy1-l", "vb"],
  "knell": ["n-eh1-l", "nn"],
  "knelt": ["n-eh1-l-t", "vbd vbn"],
  "knew": ["n-uw1", "vbd"],
  "knife": ["n-ay1-f", "nn"],
  "knifelike": ["n-ay1 f-l-ay-k", "jj"],
  "knight": ["n-ay1-t", "nn"],
  "knightly": ["n-ay1-t l-iy", "jj"],
  "knit": ["n-ih1-t", "vbn jj nn vbd vb"],
  "knitted": ["n-ih1 t-ah-d", "vbn vbd jj"],
  "knitwear": ["n-ih1-t w-eh-r", "nn"],
  "knob": ["n-aa1-b", "nn"],
  "knock": ["n-aa1-k", "vb vbp nn"],
  "knockdown": ["n-aa1-k d-aw-n", "nn"],
  "knockoff": ["n-aa1-k ao-f", "nn"],
  "knockout": ["n-aa1-k aw-t", "nn"],
  "knoll": ["n-ow1-l", "nn"],
  "knot": ["n-aa1-t", "nn vb"],
  "knotted": ["n-aa1 t-ih-d", "jj vbd vbn"],
  "knotty": ["n-aa1 t-iy", "jj"],
  "know": ["n-ow1", "vb nn vbp"],
  "knowing": ["n-ow1 ih-ng", "vbg jj nn"],
  "knowingly": ["n-ow1 ih-ng l-iy", "rb"],
  "knowledge": ["n-aa1 l-ah-jh", "nn"],
  "knowledgeable": ["n-aa1 l-ah jh-ah b-ah-l", "jj"],
  "known": ["n-ow1-n", "vbn jj"],
  "knuckle": ["n-ah1 k-ah-l", "nn vb"],
  "kook": ["k-uw1-k", "nn"],
  "kosher": ["k-ow1 sh-er", "jj"],
  "kraft": ["k-r-ae1-f-t", "nn"],
  "kraut": ["k-r-aw1-t", "nn"],
  "krona": ["k-r-ow1 n-ah", "nn"],
  "kroner": ["k-r-ow1 n-er", "nn"],
  "kronor": ["k-r-ow1 n-er", "nn"],
  "kudo": ["k-uw1 d-ow", "nn"],
  "lab": ["l-ae1-b", "nn"],
  "label": ["l-ey1 b-ah-l", "nn vb vbp"],
  "labor": ["l-ey1 b-er", "nn vbp vb"],
  "laboratory": ["l-ae1 b-r-ah t-ao r-iy", "nn"],
  "labored": ["l-ey1 b-er-d", "vbd vbn jj"],
  "laborer": ["l-ey1 b-er er", "nn"],
  "laborious": ["l-ah b-ao1 r-iy ah-s", "jj"],
  "laboriously": ["l-ah b-ao1 r-iy ah-s l-iy", "rb"],
  "labyrinth": ["l-ae1 b-er ih-n-th", "nn"],
  "lace": ["l-ey1-s", "nn vb"],
  "laced": ["l-ey1-s-t", "vbn vbd jj"],
  "lacerate": ["l-ae1 s-er ey-t", "vb"],
  "laceration": ["l-ae s-er ey1 sh-ah-n", "nn"],
  "lacey": ["l-ey1 s-iy", "jj nn"],
  "lack": ["l-ae1-k", "nn vb vbp"],
  "lackadaisical": ["l-ae k-ah d-ey1 z-ih k-ah-l", "jj"],
  "lackey": ["l-ae1 k-iy", "nn"],
  "lacking": ["l-ae1 k-ih-ng", "vbg jj"],
  "lackluster": ["l-ae1-k l-ah s-t-er", "jj nn rb"],
  "lacquer": ["l-ae1 k-er", "nn vb"],
  "lactate": ["l-ae1-k-t-ey-t", "vb"],
  "lacy": ["l-ey1 s-iy", "jj"],
  "lad": ["l-ae1-d", "nn"],
  "ladder": ["l-ae1 d-er", "nn"],
  "lade": ["l-ey1-d", "vb"],
  "laden": ["l-ey1 d-ah-n", "jj vbn"],
  "ladle": ["l-ey1 d-ah-l", "nn"],
  "lady": ["l-ey1 d-iy", "nn"],
  "ladylike": ["l-ey1 d-iy l-ay-k", "jj"],
  "lag": ["l-ae1-g", "vb nn vbp jj"],
  "laggard": ["l-ae1 g-er-d", "jj nn"],
  "lagging": ["l-ae1 g-ih-ng", "vbg jj nn"],
  "lagoon": ["l-ah g-uw1-n", "nn"],
  "laid": ["l-ey1-d", "vbn vbd"],
  "lain": ["l-ey1-n", "vbn"],
  "laity": ["l-ey1 ah t-iy", "nn"],
  "lak": ["l-ae1-k", "in"],
  "lake": ["l-ey1-k", "nn"],
  "lamb": ["l-ae1-m", "nn"],
  "lambaste": ["l-ae-m b-ae1-s-t", "vb vbp"],
  "lame": ["l-ey1-m", "jj"],
  "lament": ["l-ah m-eh1-n-t", "nn vb"],
  "laminate": ["l-ae1-m-ah-n-ah-t", "vb"],
  "laminated": ["l-ae1 m-ah n-ey t-ah-d", "vbn jj"],
  "lamp": ["l-ae1-m-p", "nn"],
  "lampoon": ["l-ae-m p-uw1-n", "vb"],
  "lamppost": ["l-ae1-m-p p-ow-s-t", "nn"],
  "lance": ["l-ae1-n-s", "nn"],
  "land": ["l-ae1-n-d", "nn vbp vb"],
  "landau": ["l-ae1-n d-aw", "nn"],
  "landes": ["l-ae1-n-d-z", "nn"],
  "landfall": ["l-ae1-n-d f-ao-l", "nn"],
  "landfill": ["l-ae1-n-d f-ih-l", "nn"],
  "landholding": ["l-ae1-n-d hh-ow-l d-ih-ng", "nn"],
  "landing": ["l-ae1-n d-ih-ng", "nn vbg"],
  "landlocked": ["l-ae1-n-d l-aa-k-t", "jj"],
  "landlord": ["l-ae1-n-d l-ao-r-d", "nn"],
  "landmark": ["l-ae1-n-d m-aa-r-k", "nn jj"],
  "landowner": ["l-ae1-n-d ow n-er", "nn"],
  "landscape": ["l-ae1-n-d s-k-ey-p", "nn vb"],
  "landscaped": ["l-ae1-n-d s-k-ey-p-t", "vbn jj"],
  "landscaper": ["l-ae1-n-d s-k-ey p-er", "nn"],
  "landslide": ["l-ae1-n-d s-l-ay-d", "nn"],
  "lane": ["l-ey1-n", "nn"],
  "language": ["l-ae1-ng g-w-ah-jh", "nn"],
  "languid": ["l-ae1-ng g-w-ah-d", "jj"],
  "languish": ["l-ae1-ng g-w-ih-sh", "vb"],
  "languishing": ["l-ae1-ng g-w-ih sh-ih-ng", "vbg jj"],
  "lanky": ["l-ae1-ng k-iy", "jj"],
  "lantern": ["l-ae1-n t-er-n", "nn"],
  "lanthanum": ["l-ae1-n th-ah n-ah-m", "nn"],
  "lap": ["l-ae1-p", "nn"],
  "lapel": ["l-ah p-eh1-l", "nn"],
  "lapidary": ["l-ae1 p-ah d-eh r-iy", "jj nn"],
  "lapped": ["l-ae1-p-t", "vbd vbn"],
  "lapse": ["l-ae1-p-s", "nn vb vbp"],
  "lapsed": ["l-ae1-p-s-t", "jj vbd vbn"],
  "laptop": ["l-ae1-p t-aa-p", "nn jj"],
  "larceny": ["l-aa1-r s-ah n-iy", "nn"],
  "lard": ["l-aa1-r-d", "nn"],
  "larder": ["l-aa1-r d-er", "nn"],
  "large": ["l-aa1-r-jh", "jj rb"],
  "largely": ["l-aa1-r-jh l-iy", "rb"],
  "larger": ["l-aa1-r jh-er", "jjr rbr"],
  "largess": ["l-aa1-r jh-ah-s", "nn"],
  "largesse": ["l-aa-r g-eh1-s", "nn vb"],
  "largest": ["l-aa1-r jh-ah-s-t", "jjs rbs"],
  "lark": ["l-aa1-r-k", "nn"],
  "larkspur": ["l-aa1-r-k s-p-er", "nn"],
  "larval": ["l-aa1-r v-ah-l", "jj"],
  "larynx": ["l-eh1 r-ih-ng-k-s", "nn"],
  "laser": ["l-ey1 z-er", "nn"],
  "lash": ["l-ae1-sh", "vb vbp nn"],
  "lass": ["l-ae1-s", "nn"],
  "lasso": ["l-ae1 s-ow", "nn vb"],
  "last": ["l-ae1-s-t", "jj nn rb vb vbp"],
  "lastest": ["l-ae1 s-t-ah-s-t", "jjs"],
  "lasting": ["l-ae1 s-t-ih-ng", "vbg jj"],
  "lastly": ["l-ae1-s-t l-iy", "rb"],
  "lat": ["l-aa1-t", "nn"],
  "latch": ["l-ae1-ch", "nn vb vbp"],
  "late": ["l-ey1-t", "jj rb"],
  "latecomer": ["l-ey1-t k-ah m-er", "nn"],
  "lately": ["l-ey1-t l-iy", "rb"],
  "latent": ["l-ey1 t-ah-n-t", "jj nn"],
  "later": ["l-ey1 t-er", "rb rp jjr rbr"],
  "lateral": ["l-ae1 t-er ah-l", "jj"],
  "latest": ["l-ey1 t-ah-s-t", "jjs jj"],
  "latex": ["l-ey1 t-eh-k-s", "nn"],
  "lathe": ["l-ey1-dh", "nn"],
  "lather": ["l-ae1 dh-er", "nn"],
  "latitude": ["l-ae1 t-ah t-uw-d", "nn"],
  "latter": ["l-ae1 t-er", "nn jj"],
  "lattice": ["l-ae1 t-ah-s", "nn"],
  "laud": ["l-ao1-d", "vb"],
  "laudable": ["l-ao1 d-ah b-ah-l", "jj"],
  "laudanum": ["l-ao1 d-ah n-ah-m", "nn"],
  "laudatory": ["l-ao1 d-ah t-ao r-iy", "jj"],
  "laugh": ["l-ae1-f", "nn vbp vb"],
  "laughing": ["l-ae1 f-ih-ng", "vbg jj nn"],
  "laughingly": ["l-ae1 f-ih-ng l-iy", "rb"],
  "laughingstock": ["l-ae1 f-ih-ng s-t-aa-k", "nn"],
  "laughter": ["l-ae1-f t-er", "nn"],
  "launch": ["l-ao1-n-ch", "vb nn"],
  "launched": ["l-ao1-n-ch-t", "vbn vbd"],
  "launcher": ["l-ao1-n ch-er", "nn"],
  "launder": ["l-ao1-n d-er", "vb"],
  "launderer": ["l-ao1-n d-er er", "nn"],
  "laundromat": ["l-ao1-n d-r-ah m-ae-t", "nn"],
  "laundry": ["l-ao1-n d-r-iy", "nn"],
  "laureate": ["l-ao1 r-iy ah-t", "nn"],
  "laurel": ["l-ao1 r-ah-l", "nn"],
  "lava": ["l-aa1 v-ah", "nn"],
  "lavatory": ["l-ae1 v-ah t-ao r-iy", "nn"],
  "lavender": ["l-ae1 v-ah-n d-er", "jj nn"],
  "lavish": ["l-ae1 v-ih-sh", "jj vb"],
  "lavishly": ["l-ae1 v-ih-sh l-iy", "rb"],
  "law": ["l-ao1", "nn"],
  "lawbreaker": ["l-ao1 b-r-ey k-er", "nn"],
  "lawful": ["l-ao1 f-ah-l", "jj"],
  "lawfully": ["l-ao1 f-ah l-iy", "rb"],
  "lawless": ["l-ao1 l-ah-s", "jj"],
  "lawlessness": ["l-ao1 l-ah-s n-ah-s", "nn"],
  "lawmaker": ["l-ao1 m-ey k-er", "nn"],
  "lawmaking": ["l-ao1 m-ey k-ih-ng", "jj nn"],
  "lawman": ["l-ao1 m-ah-n", "nn"],
  "lawn": ["l-ao1-n", "nn"],
  "lawnmower": ["l-ao1-n m-ow er", "nn"],
  "lawsuit": ["l-ao1 s-uw-t", "nn"],
  "lawyer": ["l-ao1 y-er", "nn"],
  "lax": ["l-ae1-k-s", "jj"],
  "laxative": ["l-ae1-k s-ah t-ih-v", "nn"],
  "laxity": ["l-ae1-k s-ah t-iy", "nn"],
  "lay": ["l-ey1", "vbd vbp jj vb"],
  "layer": ["l-ey1 er", "nn vb"],
  "layman": ["l-ey1 m-ah-n", "nn"],
  "layoff": ["l-ey1 ao-f", "nn"],
  "layout": ["l-ey1 aw-t", "nn"],
  "lazily": ["l-ae1 z-ah l-iy", "rb"],
  "lazy": ["l-ey1 z-iy", "jj"],
  "leach": ["l-iy1-ch", "vb"],
  "leaching": ["l-iy1 ch-ih-ng", "nn"],
  "lead": ["l-eh1-d", "vb vbp jj nn"],
  "leaded": ["l-eh1 d-ih-d", "jj"],
  "leaden": ["l-eh1 d-ah-n", "jj"],
  "leader": ["l-iy1 d-er", "nn"],
  "leaderless": ["l-iy1 d-er l-ah-s", "jj"],
  "leadership": ["l-iy1 d-er sh-ih-p", "nn"],
  "leading": ["l-iy1 d-ih-ng", "vbg jj nn"],
  "leadoff": ["l-iy1-d ao-f", "nn"],
  "leaf": ["l-iy1-f", "nn vb"],
  "leaflet": ["l-iy1-f l-ah-t", "nn"],
  "leafy": ["l-iy1 f-iy", "jj"],
  "league": ["l-iy1-g", "nn"],
  "leaguer": ["l-iy1 g-er", "nn"],
  "leak": ["l-iy1-k", "nn vb"],
  "leakage": ["l-iy1 k-ah-jh", "nn"],
  "leaker": ["l-iy1 k-er", "nn"],
  "leaky": ["l-iy1 k-iy", "jj"],
  "lean": ["l-iy1-n", "jj vbp vb"],
  "leant": ["l-iy1-n-t", "vbd vbn"],
  "leap": ["l-iy1-p", "nn vbp vb"],
  "leapfrog": ["l-iy1-p f-r-ao-g", "vb nn"],
  "leaping": ["l-iy1 p-ih-ng", "vbg jj"],
  "leapt": ["l-eh1-p-t", "vbd"],
  "learn": ["l-er1-n", "vb vbp"],
  "learned": ["l-er1-n-d", "jj"],
  "learner": ["l-er1 n-er", "nn"],
  "learnt": ["l-er1-n-t", "vbd vbn"],
  "lease": ["l-iy1-s", "nn vbp vb"],
  "leased": ["l-iy1-s-t", "vbn vbd jj"],
  "leash": ["l-iy1-sh", "nn"],
  "least": ["l-iy1-s-t", "jjs rbs jj"],
  "leather": ["l-eh1 dh-er", "nn jj"],
  "leathery": ["l-eh1 dh-er iy", "jj"],
  "leave": ["l-iy1-v", "vb nn vbp"],
  "leaven": ["l-eh1-v-ah-n", "vb"],
  "leavened": ["l-eh1 v-ah-n-d", "vbd vbn jj"],
  "lecher": ["l-eh1 ch-er", "nn"],
  "lecherous": ["l-eh1 ch-er ah-s", "jj"],
  "lectern": ["l-eh1-k t-er-n", "nn"],
  "lecture": ["l-eh1-k ch-er", "nn vbp vb"],
  "lecturer": ["l-eh1-k ch-er er", "nn"],
  "led": ["l-eh1-d", "vbd vbn"],
  "ledge": ["l-eh1-jh", "nn"],
  "ledger": ["l-eh1 jh-er", "nn"],
  "leech": ["l-iy1-ch", "nn vb"],
  "leery": ["l-ih1 r-iy", "jj"],
  "leeway": ["l-iy1 w-ey", "nn"],
  "left": ["l-eh1-f-t", "vbn jj nn rb vbd"],
  "leftist": ["l-eh1-f t-ih-s-t", "jj"],
  "leftover": ["l-eh1-f-t ow v-er", "jj"],
  "leftward": ["l-eh1-f-t w-er-d", "jj"],
  "leg": ["l-eh1-g", "nn"],
  "legacy": ["l-eh1 g-ah s-iy", "nn"],
  "legal": ["l-iy1 g-ah-l", "jj"],
  "legalistic": ["l-eh g-ah l-ih1 s-t-ih-k", "jj"],
  "legality": ["l-iy g-ae1 l-ah t-iy", "nn"],
  "legalization": ["l-iy g-ah l-ah z-ey1 sh-ah-n", "nn"],
  "legalize": ["l-iy1 g-ah l-ay-z", "vb vbp"],
  "legally": ["l-iy1 g-ah l-iy", "rb"],
  "legend": ["l-eh1 jh-ah-n-d", "nn"],
  "legendary": ["l-eh1 jh-ah-n d-eh r-iy", "jj"],
  "legged": ["l-eh1 g-ah-d", "jj"],
  "leggings": ["l-eh1 g-ih-ng-z", "nn"],
  "leggy": ["l-eh1 g-iy", "jj"],
  "legibility": ["l-eh jh-ah b-ih1 l-ah t-iy", "nn"],
  "legible": ["l-eh1 jh-ah b-ah-l", "jj"],
  "legion": ["l-iy1 jh-ah-n", "jj nn"],
  "legislate": ["l-eh1 jh-ih s-l-ey-t", "vb"],
  "legislation": ["l-eh jh-ah-s l-ey1 sh-ah-n", "nn"],
  "legislator": ["l-eh1 jh-ah-s l-ey t-er", "nn"],
  "legislature": ["l-eh1 jh-ah-s l-ey ch-er", "nn"],
  "legitimacy": ["l-ah jh-ih1 t-ah m-ah s-iy", "nn"],
  "legitimate": ["l-ah jh-ih1 t-ah m-ah-t", "jj"],
  "legitimately": ["l-ah jh-ih1 t-ah m-ah-t l-iy", "rb"],
  "legitimize": ["l-ah jh-ih1 t-ah m-ay-z", "vb"],
  "legume": ["l-eh1 g-y-uw-m", "nn"],
  "leisure": ["l-eh1 zh-er", "nn"],
  "leisurely": ["l-iy1 z-er l-iy", "jj rb"],
  "leitmotif": ["l-ay1-t m-ow t-iy-f", "nn"],
  "lemming": ["l-eh1 m-ih-ng", "nn"],
  "lemon": ["l-eh1 m-ah-n", "nn jj"],
  "lemonade": ["l-eh1 m-ah n-ey1-d", "nn"],
  "lend": ["l-eh1-n-d", "vb vbp"],
  "lender": ["l-eh1-n d-er", "nn"],
  "lending": ["l-eh1-n d-ih-ng", "vbg jj"],
  "length": ["l-eh1-ng-k-th", "nn"],
  "lengthen": ["l-eh1-ng th-ah-n", "vb vbp"],
  "lengthened": ["l-eh1-ng th-ah-n-d", "vbn vbd jj"],
  "lengthwise": ["l-eh1-ng-th w-ay-z", "rb jj"],
  "lengthy": ["l-eh1-ng th-iy", "jj"],
  "leniency": ["l-iy1 n-y-ah-n s-iy", "nn"],
  "lenient": ["l-iy1 n-iy ah-n-t", "jj"],
  "lens": ["l-eh1-n-z", "nn"],
  "lent": ["l-eh1-n-t", "vbd vbn"],
  "lentil": ["l-eh1-n t-ah-l", "nn"],
  "leopard": ["l-eh1 p-er-d", "nn"],
  "leprosy": ["l-eh1 p-r-ah s-iy", "nn"],
  "lesbian": ["l-eh1-z b-iy ah-n", "nn"],
  "lesion": ["l-iy1 zh-ah-n", "nn"],
  "less": ["l-eh1-s", "jjs cc rb rbr rbs"],
  "lessen": ["l-eh1 s-ah-n", "vb"],
  "lessened": ["l-eh1 s-ah-n-d", "vbn jj vbd"],
  "lesser": ["l-eh1 s-er", "jjr rbr"],
  "lesson": ["l-eh1 s-ah-n", "nn"],
  "let": ["l-eh1-t", "vb vbd vbn vbp nn"],
  "letdown": ["l-eh1-t d-aw-n", "nn"],
  "lethal": ["l-iy1 th-ah-l", "jj"],
  "lethality": ["l-iy th-ae1 l-ah t-iy", "nn"],
  "lethargic": ["l-ah th-aa1-r jh-ih-k", "jj"],
  "lethargy": ["l-eh1 th-er jh-iy", "nn"],
  "letter": ["l-eh1 t-er", "nn vb"],
  "letterhead": ["l-eh1 t-er hh-eh-d", "nn"],
  "lettering": ["l-eh1 t-er ih-ng", "nn"],
  "lettuce": ["l-eh1 t-ah-s", "nn"],
  "letup": ["l-eh1-t ah-p", "nn"],
  "leukemia": ["l-uw k-iy1 m-iy ah", "nn"],
  "levamisole": ["l-ah v-ae1 m-ih s-ow-l", "nn"],
  "levee": ["l-eh1 v-iy", "nn"],
  "level": ["l-eh1 v-ah-l", "nn vbp jj vb"],
  "lever": ["l-eh1 v-er", "nn"],
  "leverage": ["l-eh1 v-er ih-jh", "nn vb"],
  "leveraged": ["l-iy1 v-er ih-jh-d", "jj vbn nn"],
  "leviathan": ["l-ah v-ay1 ah th-ah-n", "jj nn"],
  "levied": ["l-eh1 v-iy-d", "vbn vbd"],
  "levitation": ["l-eh v-ih t-ey1 sh-ah-n", "nn"],
  "levity": ["l-eh1 v-ih t-iy", "nn"],
  "levy": ["l-eh1 v-iy", "nn vbp vb"],
  "lewd": ["l-uw1-d", "jj"],
  "lexical": ["l-eh1-k s-ih k-ah-l", "jj"],
  "lexicon": ["l-eh1-k s-ih k-aa-n", "nn"],
  "liability": ["l-ay ah b-ih1 l-ih t-iy", "nn"],
  "liable": ["l-ay1 ah b-ah-l", "jj"],
  "liaison": ["l-iy ey1 z-aa-n", "nn jj"],
  "liar": ["l-ay1 er", "nn"],
  "libel": ["l-ay1 b-ah-l", "nn vb"],
  "libelous": ["l-ay1 b-ah l-ah-s", "jj"],
  "liberal": ["l-ih1 b-er ah-l", "jj nn"],
  "liberalism": ["l-ih1 b-er ah l-ih z-ah-m", "nn"],
  "liberality": ["l-ih b-er ae1 l-ah t-iy", "nn"],
  "liberalization": ["l-ih b-r-ah l-ih z-ey1 sh-ah-n", "nn"],
  "liberalize": ["l-ih1 b-er ah l-ay-z", "vb vbp"],
  "liberalized": ["l-ih1 b-er ah l-ay-z-d", "vbn jj vbd"],
  "liberally": ["l-ih1 b-er ah l-iy", "rb"],
  "liberate": ["l-ih1 b-er ey-t", "vb"],
  "liberated": ["l-ih1 b-er ey t-ih-d", "vbn jj vbd"],
  "liberating": ["l-ih1 b-er ey t-ih-ng", "vbg jj"],
  "liberation": ["l-ih b-er ey1 sh-ah-n", "nn"],
  "libertarian": ["l-ih b-er t-eh1 r-iy ah-n", "jj"],
  "libertine": ["l-ih1 b-er t-iy-n", "nn"],
  "liberty": ["l-ih1 b-er t-iy", "nn"],
  "libido": ["l-ah b-iy1 d-ow", "nn"],
  "librarian": ["l-ay b-r-eh1 r-iy ah-n", "nn"],
  "library": ["l-ay1 b-r-eh r-iy", "nn"],
  "libretto": ["l-ah b-r-eh1 t-ow", "nn"],
  "lice": ["l-ay1-s", "nns"],
  "license": ["l-ay1 s-ah-n-s", "nn vbp vb"],
  "licensed": ["l-ay1 s-ah-n-s-t", "vbn vbd jj"],
  "licensee": ["l-ay s-ah-n s-iy1", "nn"],
  "licensing": ["l-ay1 s-ah-n s-ih-ng", "vbg jj"],
  "lichen": ["l-ay1 k-ah-n", "nn"],
  "lick": ["l-ih1-k", "vb"],
  "lid": ["l-ih1-d", "nn"],
  "lie": ["l-ay1", "vb vbp nn"],
  "lied": ["l-ay1-d", "vbd vbn"],
  "lieder": ["l-iy1 d-er", "jj nn"],
  "lien": ["l-iy1-n", "nn"],
  "lieutenant": ["l-uw t-eh1 n-ah-n-t", "nn"],
  "life": ["l-ay1-f", "nn rb"],
  "lifeblood": ["l-ay1-f b-l-ah-d", "nn"],
  "lifeboat": ["l-ay1-f b-ow-t", "nn"],
  "lifeguard": ["l-ay1-f g-aa-r-d", "nn"],
  "lifeless": ["l-ay1-f l-ah-s", "jj"],
  "lifelike": ["l-ay1-f l-ay-k", "jj"],
  "lifeline": ["l-ay1-f l-ay-n", "nn"],
  "lifelong": ["l-ay1-f l-ao1-ng", "jj"],
  "lifer": ["l-ay1 f-er", "nn"],
  "lifestyle": ["l-ay1-f s-t-ay-l", "nn"],
  "lifetime": ["l-ay1-f t-ay-m", "nn jj"],
  "lift": ["l-ih1-f-t", "vb nn vbp"],
  "lifter": ["l-ih1-f t-er", "nn"],
  "lifting": ["l-ih1-f t-ih-ng", "vbg jj nn"],
  "liftoff": ["l-ih1-f-t ao-f", "nn"],
  "ligament": ["l-ih1 g-ah m-ah-n-t", "nn"],
  "ligand": ["l-ih1 g-ah-n-d", "nn"],
  "light": ["l-ay1-t", "nn jj vb vbp"],
  "lighted": ["l-ay1 t-ah-d", "vbn vbd"],
  "lighten": ["l-ay1 t-ah-n", "vb"],
  "lighter": ["l-ay1 t-er", "jjr rbr nn"],
  "lightest": ["l-ay1 t-ah-s-t", "jjs"],
  "lighthearted": ["l-ay1-t hh-aa-r t-ih-d", "jj"],
  "lighthouse": ["l-ay1-t hh-aw-s", "nn"],
  "lighting": ["l-ay1 t-ih-ng", "nn vbg"],
  "lightly": ["l-ay1-t l-iy", "rb"],
  "lightness": ["l-ay1-t n-ah-s", "nn"],
  "lightning": ["l-ay1-t n-ih-ng", "nn"],
  "lightweight": ["l-ay1-t w-ey1-t", "jj nn"],
  "lignite": ["l-ih1-g n-ay-t", "jj nn"],
  "likable": ["l-ay1 k-ah b-ah-l", "jj"],
  "like": ["l-ay1-k", "vb"],
  "likelier": ["l-ay1-k l-iy er", "jjr"],
  "likeliest": ["l-ay1-k l-iy ah-s-t", "jjs"],
  "likelihood": ["l-ay1-k l-iy hh-uh-d", "nn"],
  "likely": ["l-ay1-k l-iy", "jj rb"],
  "liken": ["l-ay1-k-ah-n", "vb"],
  "likeness": ["l-ay1-k n-ah-s", "nn"],
  "likewise": ["l-ay1-k w-ay-z", "rb"],
  "lilac": ["l-ay1 l-ae-k", "jj"],
  "lilt": ["l-ih1-l-t", "nn"],
  "lily": ["l-ih1 l-iy", "nn"],
  "limb": ["l-ih1-m", "nn"],
  "limber": ["l-ih1-m b-er", "jj"],
  "limbo": ["l-ih1-m b-ow", "nn"],
  "lime": ["l-ay1-m", "nn"],
  "limelight": ["l-ay1-m l-ay-t", "nn"],
  "limestone": ["l-ay1-m s-t-ow-n", "nn"],
  "limit": ["l-ih1 m-ah-t", "nn vb vbp"],
  "limitation": ["l-ih m-ih t-ey1 sh-ah-n", "nn"],
  "limited": ["l-ih1 m-ah t-ah-d", "jj vbd vbn"],
  "limitless": ["l-ih1 m-ah-t l-ah-s", "jj"],
  "limo": ["l-ih1 m-ow", "nn"],
  "limousine": ["l-ih1 m-ah z-iy-n", "nn"],
  "limp": ["l-ih1-m-p", "jj nn vb"],
  "linchpin": ["l-ih1-n-ch p-ih-n", "nn"],
  "linden": ["l-ih1-n d-ah-n", "nn"],
  "line": ["l-ay1-n", "nn vbp rb vb"],
  "lineage": ["l-ih1 n-iy ah-jh", "nn"],
  "lineal": ["l-ih1 n-iy ah-l", "jj"],
  "linear": ["l-ih1 n-iy er", "jj"],
  "linearly": ["l-ih1 n-iy er l-iy", "rb"],
  "linebacker": ["l-ay1-n b-ae k-er", "nn"],
  "lined": ["l-ay1-n-d", "vbn vbd jj"],
  "lineman": ["l-ay1-n m-ah-n", "nn"],
  "linen": ["l-ih1 n-ah-n", "nn jj"],
  "lineup": ["l-ay1-n ah-p", "nn"],
  "linger": ["l-ih1-ng g-er", "vb vbp"],
  "lingerie": ["l-aa1-n zh-er ey", "nn"],
  "lingering": ["l-ih1-ng g-er ih-ng", "vbg jj"],
  "lingo": ["l-ih1-ng g-ow", "nn"],
  "linguist": ["l-ih1-ng g-w-ih-s-t", "nn"],
  "linguistic": ["l-ih-ng g-w-ih1 s-t-ih-k", "jj"],
  "link": ["l-ih1-ng-k", "nn vb vbp"],
  "linkage": ["l-ih1-ng k-ah-jh", "nn"],
  "linked": ["l-ih1-ng-k-t", "vbn vbd jj"],
  "linoleum": ["l-ah n-ow1 l-iy ah-m", "nn"],
  "lint": ["l-ih1-n-t", "nn"],
  "lion": ["l-ay1 ah-n", "nn"],
  "lionize": ["l-ay1-ah-n-ay-z", "vb"],
  "lip": ["l-ih1-p", "nn jj"],
  "lipid": ["l-ay1 p-ah-d", "nn"],
  "lipstick": ["l-ih1-p s-t-ih-k", "nn"],
  "liquefied": ["l-ih1 k-w-ah f-ay-d", "vbn"],
  "liquefy": ["l-ih1 k-w-ah f-ay", "vb vbp"],
  "liqueur": ["l-ih k-er1", "nn"],
  "liquid": ["l-ih1 k-w-ah-d", "jj nn"],
  "liquidate": ["l-ih1 k-w-ih d-ey-t", "vb"],
  "liquidation": ["l-ih k-w-ih d-ey1 sh-ah-n", "nn"],
  "liquidator": ["l-ih1 k-w-ih d-ey t-er", "nn"],
  "liquidity": ["l-ih k-w-ih1 d-ah t-iy", "nn"],
  "liquor": ["l-ih1 k-er", "nn"],
  "list": ["l-ih1-s-t", "nn vbp vb"],
  "listed": ["l-ih1 s-t-ah-d", "vbn vbd jj"],
  "listen": ["l-ih1 s-ah-n", "vb vbp"],
  "listener": ["l-ih1 s-ah-n er", "nn"],
  "listing": ["l-ih1 s-t-ih-ng", "nn vbg"],
  "listless": ["l-ih1-s-t l-ah-s", "jj"],
  "listlessly": ["l-ih1-s-t l-ah-s l-iy", "rb"],
  "lit": ["l-ih1-t", "vbd vbn jj nn"],
  "litany": ["l-ih1 t-ah n-iy", "nn"],
  "liter": ["l-iy1 t-er", "nn"],
  "literacy": ["l-ih1 t-er ah s-iy", "nn"],
  "literal": ["l-ih1 t-er ah-l", "jj"],
  "literally": ["l-ih1 t-er ah l-iy", "rb"],
  "literary": ["l-ih1 t-er eh r-iy", "jj nn"],
  "literate": ["l-ih1 t-er ah-t", "jj"],
  "literature": ["l-ih1 t-er ah ch-er", "nn"],
  "lithe": ["l-ay1-dh", "jj"],
  "lithium": ["l-ih1 th-iy ah-m", "nn"],
  "lithograph": ["l-ih1 th-ah g-r-ae-f", "nn"],
  "lithography": ["l-ah th-aa1 g-r-ah f-iy", "nn"],
  "litigant": ["l-ih1 t-ih g-ah-n-t", "nn"],
  "litigate": ["l-ih1 t-ih g-ey-t", "vb"],
  "litigation": ["l-ih t-ah g-ey1 sh-ah-n", "nn"],
  "litigator": ["l-ih1 t-ah g-ey t-er", "nn"],
  "litigious": ["l-ih t-ih1 jh-ah-s", "jj"],
  "litle": ["l-ay1 t-ah-l", "jj nn"],
  "litmus": ["l-ih1-t m-ah-s", "nn"],
  "litter": ["l-ih1 t-er", "nn vb vbp"],
  "littering": ["l-ih1 t-er ih-ng", "nn"],
  "little": ["l-ih1 t-ah-l", "jj rb"],
  "littlest": ["l-ih1 t-ah-l ah-s-t", "jjs"],
  "liturgical": ["l-ah t-er1 jh-ih k-ah-l", "jj"],
  "liturgy": ["l-ih1 t-er jh-iy", "nn"],
  "livable": ["l-ih1 v-ah b-ah-l", "jj"],
  "live": ["l-ay1-v", "vb rb vbp jj"],
  "lived": ["l-ay1-v-d", "vbd vbn"],
  "livelier": ["l-ay1-v l-iy er", "jjr"],
  "liveliest": ["l-ay1-v l-iy ah-s-t", "jjs"],
  "livelihood": ["l-ay1-v l-iy hh-uh-d", "nn"],
  "liveliness": ["l-ay1-v l-iy n-ah-s", "nn"],
  "lively": ["l-ay1-v l-iy", "jj rb"],
  "liver": ["l-ih1 v-er", "nn"],
  "liveried": ["l-ih1 v-r-iy-d", "jj"],
  "livestock": ["l-ay1-v s-t-aa-k", "nn"],
  "livid": ["l-ih1 v-ih-d", "jj"],
  "living": ["l-ih1 v-ih-ng", "vbg jj nn"],
  "lizard": ["l-ih1 z-er-d", "nn"],
  "lo": ["l-ow1", "uh"],
  "load": ["l-ow1-d", "nn vb vbp"],
  "loaded": ["l-ow1 d-ah-d", "vbn jj vbd"],
  "loader": ["l-ow1 d-er", "nn"],
  "loaf": ["l-ow1-f", "nn"],
  "loafer": ["l-ow1 f-er", "nn"],
  "loan": ["l-ow1-n", "nn vb"],
  "loath": ["l-ow1-th", "jj"],
  "loathe": ["l-ow1-dh", "vb"],
  "loathsome": ["l-ow1-dh s-ah-m", "jj"],
  "loave": ["l-ow1-v", "nn"],
  "lob": ["l-aa1-b", "vb"],
  "lobbied": ["l-aa1 b-iy-d", "vbd vbn"],
  "lobby": ["l-aa1 b-iy", "nn vb"],
  "lobbying": ["l-aa1 b-iy ih-ng", "vbg jj nn"],
  "lobbyist": ["l-aa1 b-iy ah-s-t", "nn"],
  "lobe": ["l-ow1-b", "nn"],
  "loblolly": ["l-aa1 b-l-aa l-iy", "nn"],
  "lobo": ["l-ow1 b-ow", "nn"],
  "lobster": ["l-aa1-b s-t-er", "nn"],
  "lobule": ["l-aa1 b-y-uw-l", "nn"],
  "local": ["l-ow1 k-ah-l", "jj nn"],
  "locale": ["l-ow k-ae1-l", "nn"],
  "locality": ["l-ow k-ae1 l-ah t-iy", "nn"],
  "localization": ["l-ow k-ah l-ah z-ey1 sh-ah-n", "nn"],
  "localize": ["l-ow1-k-ah-l-ay-z", "vb"],
  "localized": ["l-ow1 k-ah l-ay-z-d", "jj vbn"],
  "locally": ["l-ow1 k-ah l-iy", "rb"],
  "locate": ["l-ow1 k-ey-t", "vb vbp"],
  "located": ["l-ow1 k-ey t-ah-d", "vbn jj vbd"],
  "location": ["l-ow k-ey1 sh-ah-n", "nn"],
  "loch": ["l-aa1-k", "nn"],
  "lock": ["l-aa1-k", "vb vbp jj nn"],
  "locked": ["l-aa1-k-t", "vbn jj vbd"],
  "locker": ["l-aa1 k-er", "nn"],
  "locking": ["l-aa1 k-ih-ng", "jj vbg"],
  "lockout": ["l-aa1-k aw-t", "nn"],
  "lockstep": ["l-aa1-k s-t-eh-p", "nn"],
  "lockup": ["l-aa1-k ah-p", "nn"],
  "locomotive": ["l-ow k-ah m-ow1 t-ih-v", "nn"],
  "locus": ["l-ow1 k-ah-s", "nn"],
  "locust": ["l-ow1 k-ah-s-t", "nn"],
  "lodge": ["l-aa1-jh", "nn vb"],
  "lodging": ["l-aa1 jh-ih-ng", "nn vbg"],
  "loft": ["l-ao1-f-t", "nn"],
  "lofty": ["l-ao1-f t-iy", "jj"],
  "log": ["l-ao1-g", "nn vb vbp"],
  "logarithm": ["l-aa1 g-er ih dh-ah-m", "nn"],
  "logger": ["l-aa1 g-er", "nn"],
  "loggerhead": ["l-aa1 g-er hh-eh-d", "nn"],
  "logging": ["l-ao1 g-ih-ng", "vbg jj"],
  "logic": ["l-aa1 jh-ih-k", "nn"],
  "logical": ["l-aa1 jh-ih k-ah-l", "jj"],
  "logically": ["l-aa1 jh-ih-k l-iy", "rb"],
  "logistic": ["l-ah jh-ih1 s-t-ih-k", "jj"],
  "logistical": ["l-ah jh-ih1 s-t-ih k-ah-l", "jj"],
  "logjam": ["l-aa1-g jh-ae-m", "nn"],
  "logo": ["l-ow1 g-ow", "nn"],
  "loin": ["l-oy1-n", "nn"],
  "loincloth": ["l-oy1-n k-l-ao-th", "nn"],
  "loiter": ["l-oy1-t-er", "vb"],
  "loll": ["l-aa1-l", "vb"],
  "lollipop": ["l-aa1 l-iy p-aa-p", "nn"],
  "lone": ["l-ow1-n", "jj"],
  "loneliness": ["l-ow1-n l-iy n-ah-s", "nn"],
  "lonely": ["l-ow1-n l-iy", "jj"],
  "loner": ["l-ow1 n-er", "nn"],
  "lonesome": ["l-ow1-n s-ah-m", "jj"],
  "long": ["l-ao1-ng", "jj vb vbp rb"],
  "longer": ["l-ao1-ng g-er", "rb jjr rbr"],
  "longest": ["l-ao1-ng g-ah-s-t", "jjs"],
  "longevity": ["l-ao-n jh-eh1 v-ah t-iy", "nn"],
  "longhand": ["l-ao1-ng hh-ae-n-d", "jj nn"],
  "longhorn": ["l-ao1-ng hh-ao-r-n", "nn"],
  "longing": ["l-ao1 ng-ih-ng", "nn vbg"],
  "longish": ["l-ao1 ng-ih-sh", "jj"],
  "longitude": ["l-aa1-n jh-ah t-uw-d", "nn"],
  "longitudinal": ["l-aa-n jh-ah t-uw1 d-ah n-ah-l", "jj"],
  "longrange": ["l-ao1-ng r-ey-n-jh", "jj"],
  "longshot": ["l-ao1-ng sh-aa-t", "nn"],
  "longstanding": ["l-ao1-ng s-t-ae-n d-ih-ng", "jj"],
  "longterm": ["l-ao1-ng t-er-m", "jj nn"],
  "longtime": ["l-ao1-ng t-ay-m", "jj nn"],
  "look": ["l-uh1-k", "vb nn vbp"],
  "lookalike": ["l-uh1 k-ah l-ay-k", "jj"],
  "looking": ["l-uh1 k-ih-ng", "vbg jj nn"],
  "lookout": ["l-uh1-k aw-t", "nn"],
  "loom": ["l-uw1-m", "vbp nn vb"],
  "loon": ["l-uw1-n", "nn"],
  "loony": ["l-uw1 n-iy", "jj"],
  "loop": ["l-uw1-p", "nn vb"],
  "loophole": ["l-uw1-p hh-ow-l", "nn"],
  "loopy": ["l-uw1 p-iy", "jj"],
  "loose": ["l-uw1-s", "jj rb vb rp"],
  "loosely": ["l-uw1-s l-iy", "rb"],
  "loosen": ["l-uw1 s-ah-n", "vb"],
  "looser": ["l-uw1 s-er", "jjr"],
  "loot": ["l-uw1-t", "nn vb"],
  "lop": ["l-aa1-p", "jj"],
  "lope": ["l-ow1-p", "nn vb"],
  "lopped": ["l-aa1-p-t", "vbd vbn"],
  "lopping": ["l-aa1 p-ih-ng", "nn"],
  "lopsided": ["l-aa1-p s-ay1 d-ih-d", "jj"],
  "loquacious": ["l-ow k-w-ey1 sh-ah-s", "jj"],
  "lord": ["l-ao1-r-d", "nn"],
  "lore": ["l-ao1-r", "nn"],
  "lose": ["l-uw1-z", "vb vbp"],
  "loser": ["l-uw1 z-er", "nn jj"],
  "losing": ["l-uw1 z-ih-ng", "vbg jj nn"],
  "loss": ["l-ao1-s", "nn"],
  "lost": ["l-ao1-s-t", "vbd vbn jj"],
  "lot": ["l-aa1-t", "nn rb jj"],
  "lotion": ["l-ow1 sh-ah-n", "nn"],
  "lotter": ["l-aa1 t-er", "nn"],
  "lottery": ["l-aa1 t-er iy", "nn"],
  "lotus": ["l-ow1 t-ah-s", "nn"],
  "loud": ["l-aw1-d", "jj rb"],
  "louder": ["l-aw1 d-er", "jjr rb rbr"],
  "loudest": ["l-aw1 d-ah-s-t", "jjs rbs"],
  "loudly": ["l-aw1-d l-iy", "rb"],
  "loudspeaker": ["l-aw1-d s-p-iy k-er", "nn"],
  "lounge": ["l-aw1-n-jh", "nn vb"],
  "louse": ["l-aw1-s", "nn"],
  "lousy": ["l-aw1 z-iy", "jj"],
  "lovable": ["l-ah1 v-ah b-ah-l", "jj"],
  "love": ["l-ah1-v", "nn vb vbp"],
  "loved": ["l-ah1-v-d", "vbd vbn jj"],
  "lovely": ["l-ah1-v l-iy", "jj"],
  "lover": ["l-ah1 v-er", "nn"],
  "lovin": ["l-ow1 v-ih-n", "jj"],
  "loving": ["l-ah1 v-ih-ng", "jj vbg"],
  "lovingly": ["l-ah1 v-ih-ng l-iy", "rb"],
  "low": ["l-ow1", "jj nn rb rp"],
  "lower": ["l-ow1 er", "jjr rbr vbp jj rb vb"],
  "lowered": ["l-ow1 er-d", "vbd vbn jj"],
  "lowest": ["l-ow1 ah-s-t", "jjs jj"],
  "lowland": ["l-ow1 l-ae-n-d", "nn"],
  "lowly": ["l-ow1 l-iy", "jj rb"],
  "loyal": ["l-oy1 ah-l", "jj"],
  "loyalist": ["l-oy1 ah l-ih-s-t", "nn jj"],
  "loyalty": ["l-oy1 ah-l t-iy", "nn"],
  "lube": ["l-uw1-b", "nn"],
  "lubricant": ["l-uw1 b-r-ah k-ah-n-t", "nn jj"],
  "lubricate": ["l-uw1-b-r-ih-k-ey-t", "vb"],
  "lucid": ["l-uw1 s-ah-d", "jj"],
  "luck": ["l-ah1-k", "nn"],
  "luckier": ["l-ah1 k-iy er", "jjr"],
  "luckiest": ["l-ah1 k-iy ah-s-t", "jjs"],
  "luckily": ["l-ah1 k-ah l-iy", "rb"],
  "lucky": ["l-ah1 k-iy", "jj"],
  "lucrative": ["l-uw1 k-r-ah t-ih-v", "jj"],
  "lucy": ["l-uw1 s-iy", "nn"],
  "ludicrous": ["l-uw1 d-ah k-r-ah-s", "jj"],
  "ludicrously": ["l-uw1 d-ah k-r-ah-s l-iy", "rb"],
  "lug": ["l-ah1-g", "vb nn"],
  "luggage": ["l-ah1 g-ah-jh", "nn"],
  "lukewarm": ["l-uw1-k w-ao1-r-m", "jj"],
  "lull": ["l-ah1-l", "nn vb"],
  "lullaby": ["l-ah1 l-ah b-ay", "nn"],
  "lumbar": ["l-ah1-m b-aa-r", "jj"],
  "lumber": ["l-ah1-m b-er", "nn vb vbp"],
  "lumbering": ["l-ah1-m b-er ih-ng", "jj nn"],
  "lumberjack": ["l-ah1-m b-er jh-ae-k", "nn"],
  "lumberyard": ["l-ah1-m b-er y-aa-r-d", "nn"],
  "lumen": ["l-uw1 m-ah-n", "nn"],
  "luminary": ["l-uw1 m-ah n-eh r-iy", "nn"],
  "luminescence": ["l-uw m-ah n-eh1 s-ah-n-s", "nn"],
  "luminescent": ["l-uw m-ah n-eh1 s-ah-n-t", "jj"],
  "luminous": ["l-uw1 m-ah n-ah-s", "jj"],
  "lump": ["l-ah1-m-p", "nn vb vbp"],
  "lumpy": ["l-ah1-m p-iy", "jj"],
  "lunar": ["l-uw1 n-er", "jj"],
  "lunatic": ["l-uw1 n-ah t-ih-k", "jj"],
  "lunch": ["l-ah1-n-ch", "nn vb"],
  "luncheon": ["l-ah1-n ch-ah-n", "nn"],
  "lunchroom": ["l-ah1-n-ch r-uw-m", "nn"],
  "lunchtime": ["l-ah1-n-ch t-ay-m", "nn"],
  "lung": ["l-ah1-ng", "nn"],
  "lunge": ["l-ah1-n-jh", "vb"],
  "lunger": ["l-ah1 ng-er", "nn"],
  "lurch": ["l-er1-ch", "nn vb vbp"],
  "lure": ["l-uh1-r", "vb nn"],
  "lurid": ["l-uh1 r-ah-d", "jj"],
  "lurk": ["l-er1-k", "vb vbp"],
  "luscious": ["l-ah1 sh-ih-s", "jj"],
  "lush": ["l-ah1-sh", "jj"],
  "lust": ["l-ah1-s-t", "nn"],
  "luster": ["l-ah1 s-t-er", "nn"],
  "lustful": ["l-ah1-s-t f-ah-l", "jj"],
  "lustre": ["l-ah1 s-t-er", "nn"],
  "lustrous": ["l-ah1-s t-r-ah-s", "jj"],
  "lusty": ["l-ah1 s-t-iy", "jj"],
  "lute": ["l-uw1-t", "nn"],
  "luxurious": ["l-ah-g zh-er1 iy ah-s", "jj"],
  "luxury": ["l-ah1-g zh-er iy", "nn jj"],
  "lye": ["l-ay1", "nn"],
  "lymph": ["l-ih1-m-f", "nn"],
  "lymphocyte": ["l-ih1-m f-ah s-ay-t", "nn"],
  "lymphoma": ["l-ih-m f-ow1 m-ah", "nn"],
  "lynch": ["l-ih1-n-ch", "vb"],
  "lyric": ["l-ih1 r-ih-k", "jj nn"],
  "lyrical": ["l-ih1 r-ih k-ah-l", "jj"],
  "lyricism": ["l-ih1 r-ih s-ih z-ah-m", "nn"],
  "lyricist": ["l-ih1 r-ih s-ih-s-t", "nn"],
  "macabre": ["m-ah k-aa1 b-r-ah", "jj"],
  "macaroni": ["m-ae k-er ow1 n-iy", "nn"],
  "macaw": ["m-ah k-ao1", "nn"],
  "machete": ["m-ah sh-eh1 t-iy", "nn"],
  "machination": ["m-ae k-ah n-ey1 sh-ah-n", "nn"],
  "machine": ["m-ah sh-iy1-n", "nn"],
  "machinery": ["m-ah sh-iy1 n-er iy", "nn"],
  "machining": ["m-ah sh-iy1 n-ih-ng", "nn"],
  "machinist": ["m-ah sh-iy1 n-ah-s-t", "nn"],
  "macho": ["m-aa1 ch-ow", "jj nn"],
  "mackerel": ["m-ae1 k-er ah-l", "nn"],
  "mackinaw": ["m-ae1 k-ah n-ao", "nn"],
  "mackintosh": ["m-ae1 k-ah-n t-aa-sh", "nn"],
  "macroeconomic": ["m-ae k-r-ow eh k-ah n-aa1 m-ih-k", "jj"],
  "mad": ["m-ae1-d", "jj"],
  "madam": ["m-ae1 d-ah-m", "nn"],
  "madcap": ["m-ae1-d k-ae-p", "jj"],
  "madden": ["m-ae1-d-ah-n", "vb"],
  "maddening": ["m-ae1 d-ah-n ih-ng", "jj vbg"],
  "maddeningly": ["m-ae1 d-ah-n ih-ng l-iy", "rb"],
  "made": ["m-ey1-d", "vbn vbd jj"],
  "madhouse": ["m-ae1-d hh-aw-s", "nn"],
  "madly": ["m-ae1-d l-iy", "rb"],
  "madman": ["m-ae1-d m-ae-n", "nn"],
  "madness": ["m-ae1-d n-ah-s", "nn"],
  "madrigal": ["m-ae1 d-r-ah g-ah-l", "nn"],
  "madstone": ["m-ae1-d s-t-ow-n", "nn"],
  "maelstrom": ["m-ey1-l s-t-r-ah-m", "nn"],
  "maestro": ["m-ay1 s-t-r-ow", "nn"],
  "mafia": ["m-aa1 f-iy ah", "nn"],
  "magazine": ["m-ae1 g-ah z-iy-n", "nn"],
  "magenta": ["m-ah jh-eh1-n t-ah", "jj nn"],
  "maggot": ["m-ae1 g-ah-t", "nn"],
  "magic": ["m-ae1 jh-ih-k", "nn jj"],
  "magical": ["m-ae1 jh-ih k-ah-l", "jj"],
  "magically": ["m-ae1 jh-ih k-ah l-iy", "rb"],
  "magician": ["m-ah jh-ih1 sh-ah-n", "nn"],
  "magistrate": ["m-ae1 jh-ah s-t-r-ey-t", "nn"],
  "magnanimous": ["m-ae-g n-ae1 n-ah m-ah-s", "jj"],
  "magnate": ["m-ae1-g n-ah-t", "nn"],
  "magnesium": ["m-ae-g n-iy1 z-iy ah-m", "nn"],
  "magnet": ["m-ae1-g n-ah-t", "nn"],
  "magnetic": ["m-ae-g n-eh1 t-ih-k", "jj"],
  "magnetically": ["m-ae-g n-eh1 t-ih k-ah l-iy", "rb"],
  "magnetism": ["m-ae1-g n-ah t-ih z-ah-m", "nn"],
  "magnetize": ["m-ae1-g n-ih t-ay-z", "vb"],
  "magnification": ["m-ae-g n-ah f-ah k-ey1 sh-ah-n", "nn"],
  "magnificent": ["m-ae-g n-ih1 f-ah s-ah-n-t", "jj"],
  "magnificently": ["m-ae-g n-ih1 f-ah s-ah-n-t l-iy", "rb"],
  "magnify": ["m-ae1-g n-ah f-ay", "vb"],
  "magnitude": ["m-ae1-g n-ah t-uw-d", "nn"],
  "magnolia": ["m-ae-g n-ow1 l-y-ah", "nn"],
  "magnum": ["m-ae1-g n-ah-m", "nn"],
  "magpie": ["m-ae1-g p-ay", "nn"],
  "mahogany": ["m-ah hh-aa1 g-ah n-iy", "nn"],
  "maid": ["m-ey1-d", "nn"],
  "maiden": ["m-ey1 d-ah-n", "nn jj"],
  "mail": ["m-ey1-l", "nn vb vbp"],
  "mailbox": ["m-ey1-l b-aa-k-s", "nn"],
  "mailed": ["m-ey1-l-d", "vbn vbd jj"],
  "mailer": ["m-ey1 l-er-z", "nn"],
  "mailing": ["m-ey1 l-ih-ng", "nn vbg"],
  "mailman": ["m-ey1-l m-ae-n", "nn"],
  "mailroom": ["m-ey1-l r-uw-m", "nn jj"],
  "maimed": ["m-ey1-m-d", "jj"],
  "main": ["m-ey1-n", "jj nn"],
  "mainframe": ["m-ey1-n f-r-ey-m", "nn jj"],
  "mainland": ["m-ey1-n l-ae-n-d", "nn jj"],
  "mainline": ["m-ey1-n l-ay-n", "jj nn"],
  "mainly": ["m-ey1-n l-iy", "rb"],
  "mainstay": ["m-ey1-n s-t-ey", "nn jj"],
  "mainstream": ["m-ey1-n s-t-r-iy-m", "nn jj rb"],
  "maintain": ["m-ey-n t-ey1-n", "vb vbp"],
  "maintenance": ["m-ey1-n t-ah n-ah-n-s", "nn"],
  "majestic": ["m-ah jh-eh1 s-t-ih-k", "jj"],
  "majestically": ["m-ah jh-eh1 s-t-ih k-ah l-iy", "rb"],
  "majesty": ["m-ae1 jh-ah s-t-iy", "nn"],
  "major": ["m-ey1 jh-er", "jj nn vb vbp"],
  "majoritarian": ["m-ae jh-er ih t-eh1 r-iy ah-n", "jj"],
  "majority": ["m-ah jh-ao1 r-ah t-iy", "nn jj"],
  "make": ["m-ey1-k", "vb nn vbp"],
  "makeover": ["m-ae1-k ow v-er", "nn"],
  "maker": ["m-ey1 k-er", "nn"],
  "makeshift": ["m-ey1-k sh-ih-f-t", "jj nn"],
  "makeup": ["m-ey1-k ah-p", "nn"],
  "maladjusted": ["m-ae-l ah jh-ah1 s-t-ih-d", "jj"],
  "malady": ["m-ae1 l-ah d-iy", "nn"],
  "malaise": ["m-ae l-ey1-z", "nn"],
  "malaria": ["m-ah l-eh1 r-iy ah", "nn"],
  "male": ["m-ey1-l", "jj nn"],
  "malevolent": ["m-ah l-eh1 v-ah l-ah-n-t", "jj"],
  "malformation": ["m-ae-l f-ao-r m-ey1 sh-ah-n", "nn"],
  "malformed": ["m-ae-l f-ao1-r-m-d", "jj"],
  "malfunction": ["m-ae-l f-ah1-ng-k sh-ah-n", "nn"],
  "malfunctioning": ["m-ae-l f-ah1-ng-k sh-ah-n ih-ng", "jj"],
  "malice": ["m-ae1 l-ah-s", "nn"],
  "malicious": ["m-ah l-ih1 sh-ah-s", "jj"],
  "maliciously": ["m-ah l-ih1 sh-ih-s l-iy", "rb"],
  "malign": ["m-ah-l-ay1-n", "vb"],
  "malignancy": ["m-ah l-ih1-g n-ah-n s-iy", "nn"],
  "malignant": ["m-ah l-ih1-g n-ah-n-t", "jj"],
  "mall": ["m-ao1-l", "nn"],
  "malleable": ["m-ae1 l-iy ah b-ah-l", "jj"],
  "malnourished": ["m-ae-l n-er1 ih-sh-t", "jj"],
  "malnutrition": ["m-ae-l n-uw t-r-ih1 sh-ah-n", "nn"],
  "malpractice": ["m-ae-l p-r-ae1-k t-ah-s", "nn vb"],
  "malt": ["m-ao1-l-t", "nn vb"],
  "malted": ["m-ao1-l t-ah-d", "vbn jj"],
  "maltreat": ["m-ae-l t-r-iy1-t", "vb"],
  "maltreatment": ["m-ae-l t-r-iy1-t m-ah-n-t", "nn"],
  "mama": ["m-aa1 m-ah", "nn"],
  "mammal": ["m-ae1 m-ah-l", "nn"],
  "mammalian": ["m-ah m-ey1 l-iy ah-n", "jj"],
  "mammary": ["m-ae1 m-er iy", "jj"],
  "mammography": ["m-ah m-aa1 g-r-ah f-iy", "nn"],
  "mammoth": ["m-ae1 m-ah-th", "jj"],
  "man": ["m-ae1-n", "nn jj vb uh"],
  "mana": ["m-aa1 n-ah", "nn"],
  "manage": ["m-ae1 n-ah-jh", "vb vbp"],
  "manageable": ["m-ae1 n-ih jh-ah b-ah-l", "jj"],
  "managed": ["m-ae1 n-ah-jh-d", "vbd vbn jj"],
  "management": ["m-ae1 n-ah-jh m-ah-n-t", "nn"],
  "manager": ["m-ae1 n-ah jh-er", "nn"],
  "managerial": ["m-ae n-ih jh-ih1 r-iy ah-l", "jj"],
  "managing": ["m-ae1 n-ah jh-ih-ng", "vbg jj nn"],
  "mandamus": ["m-ae-n d-ey1 m-ah-s", "nn"],
  "mandate": ["m-ae1-n d-ey-t", "nn vb"],
  "mandatory": ["m-ae1-n d-ah t-ao r-iy", "jj nn"],
  "mane": ["m-ey1-n", "nn"],
  "maneuver": ["m-ah n-uw1 v-er", "nn vb"],
  "maneuvering": ["m-ah n-uw1 v-er ih-ng", "vbg jj"],
  "manger": ["m-ey1-n jh-er", "nn"],
  "mangle": ["m-ae1-ng-g-ah-l", "vb"],
  "mangled": ["m-ae1-ng g-ah-l-d", "jj vbn"],
  "manhandle": ["m-ae1-n-hh-ae-n-d-ah-l", "vb"],
  "manhole": ["m-ae1-n hh-ow-l", "nn"],
  "manhood": ["m-ae1-n hh-uh-d", "nn"],
  "mania": ["m-ey1 n-iy ah", "nn"],
  "maniac": ["m-ey1 n-iy ae-k", "nn"],
  "maniacal": ["m-ah n-ay1 ah k-ah-l", "jj"],
  "manic": ["m-ae1 n-ih-k", "jj"],
  "manicure": ["m-ae1-n-ih-k-y-er", "vb"],
  "manifest": ["m-ae1 n-ah f-eh-s-t", "jj vb vbp"],
  "manifestation": ["m-ae n-ah f-eh s-t-ey1 sh-ah-n", "nn"],
  "manifestly": ["m-ae1 n-ah f-eh-s-t l-iy", "rb"],
  "manifesto": ["m-ae n-ah f-eh1 s-t-ow", "nn"],
  "manifold": ["m-ae1 n-ah f-ow-l-d", "nn jj"],
  "manila": ["m-ah n-ih1 l-ah", "jj"],
  "manipulate": ["m-ah n-ih1 p-y-ah l-ey-t", "vb vbp"],
  "manipulation": ["m-ah n-ih p-y-ah l-ey1 sh-ah-n", "nn"],
  "manipulative": ["m-ah n-ih1 p-y-ah l-ey t-ih-v", "jj"],
  "manipulator": ["m-ah n-ih1 p-y-ah l-ey t-er", "nn"],
  "mankind": ["m-ae1-n k-ay1-n-d", "nn"],
  "manly": ["m-ae1-n l-iy", "jj"],
  "manmade": ["m-ae1-n m-ey1-d", "nn"],
  "manna": ["m-ae1 n-ah", "nn"],
  "manned": ["m-ae1-n-d", "jj vbd vbn"],
  "mannequin": ["m-ae1 n-ah k-ih-n", "nn"],
  "manner": ["m-ae1 n-er", "nn"],
  "mannered": ["m-ae1 n-er-d", "jj"],
  "mannerism": ["m-ae1 n-er ih z-ah-m", "nn"],
  "manor": ["m-ae1 n-er", "nn"],
  "manpower": ["m-ae1-n p-aw er", "nn"],
  "mansion": ["m-ae1-n sh-ah-n", "nn"],
  "manslaughter": ["m-ae1-n s-l-ao t-er", "nn"],
  "mantel": ["m-ae1-n t-ah-l", "nn"],
  "mantle": ["m-ae1-n t-ah-l", "nn"],
  "manual": ["m-ae1 n-y-uw ah-l", "jj nn"],
  "manually": ["m-ae1 n-y-uw ah l-iy", "rb"],
  "manufacture": ["m-ae n-y-ah f-ae1-k ch-er", "vb nn vbp"],
  "manufactured": ["m-ae n-y-ah f-ae1-k ch-er-d", "vbn vbd jj"],
  "manufacturer": ["m-ae n-y-ah f-ae1-k ch-er er", "nn"],
  "manure": ["m-ah n-uh1-r", "nn"],
  "manuscript": ["m-ae1 n-y-ah s-k-r-ih-p-t", "nn"],
  "many": ["m-eh1 n-iy", "jj dt rb vb pdt"],
  "map": ["m-ae1-p", "nn vbp vb"],
  "maple": ["m-ey1 p-ah-l", "nn jj"],
  "maquila": ["m-ah-k w-iy1 l-ah", "nn"],
  "mar": ["m-aa1-r", "vb"],
  "marathon": ["m-eh1 r-ah th-aa-n", "nn jj"],
  "marauder": ["m-er ao1 d-er", "nn"],
  "marble": ["m-aa1-r b-ah-l", "nn"],
  "march": ["m-aa1-r-ch", "nn vbp vb"],
  "marcher": ["m-aa1-r ch-er", "nn"],
  "mare": ["m-eh1-r", "nn"],
  "margarine": ["m-aa1-r jh-er ah-n", "nn"],
  "margin": ["m-aa1-r jh-ah-n", "nn vb"],
  "marginal": ["m-aa1-r jh-ah n-ah-l", "jj"],
  "marginalize": ["m-aa1-r-jh-ah-n-ah-l-ay-z", "vb"],
  "marginally": ["m-aa1-r jh-ah n-ah l-iy", "rb"],
  "marijuana": ["m-eh r-ah-w aa1 n-ah", "nn"],
  "marimba": ["m-er ih1-m b-ah", "nn"],
  "marina": ["m-er iy1 n-ah", "nn"],
  "marinate": ["m-eh1-r-ah-n-ey-t", "vb"],
  "marine": ["m-er iy1-n", "nn jj"],
  "mariner": ["m-eh1 r-ah n-er", "nn"],
  "marital": ["m-eh1 r-ah t-ah-l", "jj"],
  "maritime": ["m-eh1 r-ah t-ay-m", "jj"],
  "mark": ["m-aa1-r-k", "nn vbp vb"],
  "markdown": ["m-aa1-r-k d-aw-n", "nn jj"],
  "marked": ["m-aa1-r-k-t", "vbn jj vbd"],
  "markedly": ["m-aa1-r k-ah-d l-iy", "rb"],
  "marker": ["m-aa1-r k-er", "nn"],
  "market": ["m-aa1-r k-ah-t", "nn vbp vb"],
  "marketability": ["m-aa-r k-ih t-ah b-ih1 l-ih t-iy", "nn"],
  "marketable": ["m-aa1-r k-ah t-ah b-ah-l", "jj"],
  "marketeer": ["m-aa-r k-ah t-ih1-r", "nn"],
  "marketer": ["m-aa1-r k-ah t-er", "nn"],
  "marketing": ["m-aa1-r k-ah t-ih-ng", "vbg jj"],
  "marketplace": ["m-aa1-r k-ah-t p-l-ey-s", "nn"],
  "marketwide": ["m-aa1-r k-ah-t w-ay-d", "jj"],
  "marksmanship": ["m-aa1-r-k-s m-ah-n sh-ih-p", "nn"],
  "markup": ["m-aa1-r-k ah-p", "nn"],
  "marmalade": ["m-aa1-r m-ah l-ey-d", "nn"],
  "maroon": ["m-er uw1-n", "nn jj vb"],
  "marque": ["m-aa1-r-k", "nn"],
  "marquee": ["m-aa-r k-iy1", "nn"],
  "marred": ["m-aa1-r-d", "vbn jj vbd"],
  "marriage": ["m-eh1 r-ih-jh", "nn"],
  "married": ["m-eh1 r-iy-d", "vbn vbd jj"],
  "marrow": ["m-eh1 r-ow", "nn"],
  "marry": ["m-eh1 r-iy", "vb vbp"],
  "marsh": ["m-aa1-r-sh", "nn"],
  "marshal": ["m-aa1-r sh-ah-l", "nn vb vbp"],
  "marshmallow": ["m-aa1-r-sh m-eh l-ow", "nn"],
  "martial": ["m-aa1-r sh-ah-l", "jj"],
  "martingale": ["m-aa1-r t-ih ng-ey-l", "nn"],
  "martini": ["m-aa-r t-iy1 n-iy", "nn"],
  "martyr": ["m-aa1-r t-er", "nn"],
  "martyrdom": ["m-aa1-r t-er d-ah-m", "nn"],
  "marvel": ["m-aa1-r v-ah-l", "vb nn"],
  "marvelous": ["m-aa1-r v-ah l-ah-s", "jj"],
  "marvelously": ["m-aa1-r v-ah l-ah-s l-iy", "rb"],
  "mascara": ["m-ae s-k-eh1 r-ah", "nn"],
  "mascot": ["m-ae1 s-k-ah-t", "nn"],
  "masculine": ["m-ae1-s k-y-ah l-ah-n", "jj nn"],
  "masculinity": ["m-ae-s k-y-ah l-ih1 n-ah t-iy", "nn"],
  "mash": ["m-ae1-sh", "nn vb"],
  "mask": ["m-ae1-s-k", "nn vbp vb"],
  "masked": ["m-ae1-s-k-t", "vbn vbd jj"],
  "mason": ["m-ey1 s-ah-n", "nn"],
  "masonry": ["m-ey1 s-ah-n r-iy", "nn"],
  "masquerade": ["m-ae-s k-er ey1-d", "nn vb vbp"],
  "mass": ["m-ae1-s", "nn jj rb vb"],
  "massacre": ["m-ae1 s-ah k-er", "nn vb"],
  "massage": ["m-ah s-aa1-zh", "nn vb"],
  "massive": ["m-ae1 s-ih-v", "jj"],
  "massively": ["m-ae1 s-ih-v l-iy", "rb"],
  "mast": ["m-ae1-s-t", "nn"],
  "master": ["m-ae1 s-t-er", "nn vb"],
  "masterful": ["m-ae1 s-t-er f-ah-l", "jj"],
  "masterfully": ["m-ae1 s-t-er f-ah l-iy", "rb"],
  "masterly": ["m-ae1 s-t-er l-iy", "jj"],
  "mastermind": ["m-ae1 s-t-er m-ay-n-d", "nn vb"],
  "masterpiece": ["m-ae1 s-t-er p-iy-s", "nn"],
  "masterwork": ["m-ae1 s-t-er w-er-k", "nn"],
  "mastery": ["m-ae1 s-t-er iy", "nn"],
  "mastiff": ["m-ae1 s-t-ah-f", "nn"],
  "mat": ["m-ae1-t", "nn"],
  "matador": ["m-ae1 t-ah d-ao-r", "nn"],
  "match": ["m-ae1-ch", "vb vbp nn"],
  "matched": ["m-ae1-ch-t", "vbn jj vbd"],
  "matching": ["m-ae1 ch-ih-ng", "vbg jj nn"],
  "matchmaker": ["m-ae1-ch m-ey k-er", "nn"],
  "matchmaking": ["m-ae1-ch m-ey k-ih-ng", "nn"],
  "mate": ["m-ey1-t", "nn vbp vb uh"],
  "mater": ["m-aa1 t-er", "nn"],
  "material": ["m-ah t-ih1 r-iy ah-l", "nn jj"],
  "materialism": ["m-ah t-ih1 r-iy ah l-ih z-ah-m", "nn"],
  "materialistic": ["m-ah t-ih r-iy ah l-ih1 s-t-ih-k", "jj"],
  "materialize": ["m-ah t-ih1 r-iy ah l-ay-z", "vb vbp"],
  "materially": ["m-ah t-ih1 r-iy ah l-iy", "rb"],
  "materiel": ["m-ah t-ih r-iy eh1-l", "nn"],
  "maternal": ["m-ah t-er1 n-ah-l", "jj"],
  "maternity": ["m-ah t-er1 n-ih t-iy", "nn"],
  "math": ["m-ae1-th", "nn"],
  "mathematical": ["m-ae th-ah m-ae1 t-ih k-ah-l", "jj"],
  "mathematically": ["m-ae th-ah m-ae1 t-ih k-ah l-iy", "rb"],
  "mathematician": ["m-ae th-ah m-ah t-ih1 sh-ah-n", "nn"],
  "mathematics": ["m-ae th-ah m-ae1 t-ih-k-s", "nn"],
  "matinee": ["m-ae1 t-ih n-ey", "jj"],
  "mating": ["m-ey1 t-ih-ng", "nn jj vbg"],
  "matriarch": ["m-ey1 t-r-iy aa-r-k", "nn"],
  "matriarchal": ["m-ey t-r-iy aa1-r k-ah-l", "jj"],
  "matrimonial": ["m-ae t-r-ah m-ow1 n-iy ah-l", "jj"],
  "matrimony": ["m-ae1 t-r-ah m-ow n-iy", "nn"],
  "matrix": ["m-ey1 t-r-ih-k-s", "nn"],
  "matron": ["m-ey1 t-r-ah-n", "nn"],
  "matronly": ["m-ey1 t-r-ah-n l-iy", "jj"],
  "matt": ["m-ae1-t", "nn"],
  "matte": ["m-ae1-t", "nn"],
  "matter": ["m-ae1 t-er", "nn vbp vb"],
  "matting": ["m-ae1 t-ih-ng", "nn"],
  "mattress": ["m-ae1 t-r-ah-s", "nn"],
  "maturation": ["m-ae ch-er ey1 sh-ah-n", "nn"],
  "mature": ["m-ah ch-uh1-r", "jj vb vbp"],
  "maturity": ["m-ah ch-uh1 r-ah t-iy", "nn"],
  "maudlin": ["m-ao1-d l-ih-n", "jj"],
  "maul": ["m-ao1-l", "vb"],
  "mauler": ["m-ao1 l-er", "nn"],
  "mausoleum": ["m-ao s-ah l-iy1 ah-m", "nn"],
  "mauve": ["m-ao1-v", "jj"],
  "maven": ["m-ey1 v-ah-n", "nn"],
  "maverick": ["m-ae1 v-er ih-k", "nn jj"],
  "maw": ["m-ao1", "nn"],
  "mawkish": ["m-ao1 k-ih-sh", "jj"],
  "max": ["m-ae1-k-s", "nn"],
  "maxim": ["m-ae1-k s-ah-m", "nn"],
  "maximal": ["m-ae1-k s-ah m-ah-l", "jj"],
  "maximization": ["m-ae-k s-ih m-ih z-ey1 sh-ah-n", "nn"],
  "maximize": ["m-ae1-k s-ah m-ay-z", "vb vbp"],
  "maximum": ["m-ae1-k s-ah m-ah-m", "jj nn"],
  "may": ["m-ey1", "md"],
  "maybe": ["m-ey1 b-iy", "rb"],
  "mayhem": ["m-ey1 hh-eh-m", "nn"],
  "mayonnaise": ["m-ey1 ah n-ey-z", "nn"],
  "mayor": ["m-ey1 er", "nn"],
  "mayoral": ["m-ey1 er ah-l", "jj"],
  "mayoralty": ["m-ey1 er ah-l t-iy", "nn"],
  "maze": ["m-ey1-z", "nn"],
  "me": ["m-iy1", "prp"],
  "meadow": ["m-eh1 d-ow", "nn"],
  "meager": ["m-iy1 g-er", "jj"],
  "meal": ["m-iy1-l", "nn"],
  "mealtime": ["m-iy1-l t-ay-m", "nn"],
  "mealy": ["m-iy1 l-iy", "jj"],
  "mealynosed": ["m-iy1 l-iy n-ow-z-d", "jj"],
  "mean": ["m-iy1-n", "vb vbp jj"],
  "meander": ["m-iy-ae1-n-d-er", "vb"],
  "meaner": ["m-iy1 n-er", "jjr"],
  "meanest": ["m-iy1 n-ah-s-t", "jjs"],
  "meaning": ["m-iy1 n-ih-ng", "nn vbg"],
  "meaningful": ["m-iy1 n-ih-ng f-ah-l", "jj"],
  "meaningfully": ["m-iy1 n-ih-ng f-ah l-iy", "rb"],
  "meaningless": ["m-iy1 n-ih-ng l-ah-s", "jj"],
  "meanness": ["m-iy1-n n-ah-s", "nn"],
  "means": ["m-iy1-n-z", "nn"],
  "meant": ["m-eh1-n-t", "vbd vbn"],
  "meantime": ["m-iy1-n t-ay-m", "nn rb"],
  "meanwhile": ["m-iy1-n w-ay-l", "rb nn"],
  "measles": ["m-iy1 z-ah-l-z", "nn"],
  "measly": ["m-iy1-z l-iy", "jj"],
  "measurable": ["m-eh1 zh-er ah b-ah-l", "jj"],
  "measurably": ["m-eh1 zh-er ah b-l-iy", "rb"],
  "measure": ["m-eh1 zh-er", "nn vbp vb"],
  "measured": ["m-eh1 zh-er-d", "vbn vbd jj"],
  "measurement": ["m-eh1 zh-er m-ah-n-t", "nn"],
  "measuring": ["m-eh1 zh-er ih-ng", "vbg jj"],
  "meat": ["m-iy1-t", "nn"],
  "meatpacker": ["m-iy1-t p-ae k-er", "nn"],
  "meatpacking": ["m-iy1-t p-ae k-ih-ng", "nn"],
  "meaty": ["m-iy1 t-iy", "jj"],
  "mecca": ["m-eh1 k-ah", "nn"],
  "mechanic": ["m-ah k-ae1 n-ih-k", "nn"],
  "mechanical": ["m-ah k-ae1 n-ih k-ah-l", "jj"],
  "mechanically": ["m-ah k-ae1 n-ih-k l-iy", "rb"],
  "mechanism": ["m-eh1 k-ah n-ih z-ah-m", "nn"],
  "mechanistic": ["m-eh k-ah n-ih1 s-t-ih-k", "jj"],
  "mechanization": ["m-eh k-ah n-ah z-ey1 sh-ah-n", "nn"],
  "mechanize": ["m-eh1-k-ah-n-ay-z", "vb"],
  "mechanized": ["m-eh1 k-ah n-ay-z-d", "jj vbn"],
  "medal": ["m-eh1 d-ah-l", "nn"],
  "medalist": ["m-eh1 d-ah l-ih-s-t", "nn"],
  "medallion": ["m-ah d-ae1 l-y-ah-n", "nn"],
  "meddle": ["m-eh1 d-ah-l", "vb"],
  "median": ["m-iy1 d-iy ah-n", "jj nn"],
  "mediate": ["m-iy1 d-iy ey-t", "vb"],
  "mediation": ["m-iy d-iy ey1 sh-ah-n", "nn"],
  "mediator": ["m-iy1 d-iy ey t-er", "nn"],
  "medic": ["m-eh1 d-ih-k", "nn"],
  "medical": ["m-eh1 d-ah k-ah-l", "jj"],
  "medically": ["m-eh1 d-ah-k l-iy", "rb"],
  "medicare": ["m-eh1 d-ah k-eh-r", "nn"],
  "medication": ["m-eh d-ah k-ey1 sh-ah-n", "nn"],
  "medicinal": ["m-ah d-ih1 s-ah n-ah-l", "jj nn"],
  "medicine": ["m-eh1 d-ah s-ah-n", "nn"],
  "medico": ["m-eh1 d-ih k-ow", "nn"],
  "medieval": ["m-ih d-iy1 v-ah-l", "jj nn"],
  "mediocre": ["m-iy d-iy ow1 k-er", "jj"],
  "mediocrity": ["m-iy d-iy aa1 k-r-ah t-iy", "nn"],
  "meditate": ["m-eh1 d-ah t-ey-t", "vb"],
  "meditation": ["m-eh d-ah t-ey1 sh-ah-n", "nn"],
  "meditative": ["m-eh1 d-ah t-ey t-ih-v", "jj"],
  "medium": ["m-iy1 d-iy ah-m", "nn jj"],
  "medley": ["m-eh1-d l-iy", "nn"],
  "meek": ["m-iy1-k", "jj"],
  "meekly": ["m-iy1-k l-iy", "rb"],
  "meet": ["m-iy1-t", "vb vbp nn"],
  "meeting": ["m-iy1 t-ih-ng", "nn vbg"],
  "mega": ["m-eh1 g-ah", "jj"],
  "megabit": ["m-eh1 g-ah b-ih-t", "nn"],
  "megabyte": ["m-eh1 g-ah b-ay-t", "nn"],
  "megahertz": ["m-eh1 g-ah hh-er-t-s", "nn"],
  "megalomania": ["m-eh g-ah l-ow m-ey1 n-iy ah", "nn"],
  "megalomaniac": ["m-eh g-ah l-ow m-ey1 n-iy ae-k", "nn"],
  "megawatt": ["m-eh1 g-ah w-aa-t", "nn"],
  "melamine": ["m-eh1 l-ah m-iy-n", "nn"],
  "melancholy": ["m-eh1 l-ah-n k-aa l-iy", "nn jj"],
  "melange": ["m-eh1 l-ae-ng", "nn"],
  "melanin": ["m-eh1 l-ah n-ah-n", "nn"],
  "meld": ["m-eh1-l-d", "vb"],
  "melee": ["m-ey1 l-ey", "nn"],
  "mellow": ["m-eh1 l-ow", "jj vb"],
  "melodic": ["m-ah l-aa1 d-ih-k", "jj"],
  "melodious": ["m-ah l-ow1 d-iy ah-s", "jj"],
  "melodrama": ["m-eh1 l-ah d-r-aa m-ah", "nn"],
  "melodramatic": ["m-eh l-ah d-r-ah m-ae1 t-ih-k", "jj"],
  "melody": ["m-eh1 l-ah d-iy", "nn"],
  "melon": ["m-eh1 l-ah-n", "nn"],
  "melt": ["m-eh1-l-t", "vb vbp nn"],
  "meltdown": ["m-eh1-l-t d-aw-n", "nn jj"],
  "melted": ["m-eh1-l t-ah-d", "vbn jj vbd"],
  "melting": ["m-eh1-l t-ih-ng", "vbg jj nn"],
  "member": ["m-eh1-m b-er", "nn"],
  "membership": ["m-eh1-m b-er sh-ih-p", "nn"],
  "membrane": ["m-eh1-m b-r-ey-n", "nn"],
  "memento": ["m-ih m-eh1-n t-ow", "nn"],
  "memo": ["m-eh1 m-ow", "nn"],
  "memoir": ["m-eh1-m w-aa-r", "nn"],
  "memorabilia": ["m-eh m-er ah b-iy1 l-y-ah", "nn"],
  "memorable": ["m-eh1 m-er ah b-ah-l", "jj"],
  "memorandum": ["m-eh m-er ae1-n d-ah-m", "nn"],
  "memorial": ["m-ah m-ao1 r-iy ah-l", "nn jj"],
  "memorialize": ["m-ah-m-ao1-r-iy-ah-l-ay-z", "vb"],
  "memorize": ["m-eh1 m-er ay-z", "vb vbp"],
  "memory": ["m-eh1 m-er iy", "nn"],
  "menace": ["m-eh1 n-ah-s", "nn vb"],
  "menacing": ["m-eh1 n-ah s-ih-ng", "jj vbg"],
  "mend": ["m-eh1-n-d", "vb"],
  "mendacity": ["m-eh-n d-ae1 s-ih t-iy", "nn"],
  "menial": ["m-iy1 n-iy ah-l", "jj"],
  "menopause": ["m-eh1 n-ah p-aw-z", "nn"],
  "menstrual": ["m-eh1-n-s t-r-uw ah-l", "jj"],
  "menstruation": ["m-eh-n-s t-r-uw ey1 sh-ah-n", "jj"],
  "menswear": ["m-eh1-n-z w-ey-r", "nn"],
  "mental": ["m-eh1-n t-ah-l", "jj"],
  "mentality": ["m-eh-n t-ae1 l-ah t-iy", "nn"],
  "mentally": ["m-eh1-n t-ah l-iy", "rb nn jj"],
  "mention": ["m-eh1-n sh-ah-n", "vb nn vbp"],
  "mentor": ["m-eh1-n t-ao-r", "nn"],
  "menu": ["m-eh1 n-y-uw", "nn"],
  "mercenary": ["m-er1 s-ah n-eh r-iy", "jj"],
  "mercer": ["m-er1 s-er", "nn"],
  "merchandise": ["m-er1 ch-ah-n d-ay-z", "nn vb"],
  "merchandiser": ["m-er1 ch-ah-n d-ay z-er", "nn"],
  "merchant": ["m-er1 ch-ah-n-t", "nn jj"],
  "merciful": ["m-er1 s-ih f-ah-l", "jj"],
  "mercifully": ["m-er1 s-ih f-ah l-iy", "rb"],
  "merciless": ["m-er1 s-ah l-ah-s", "jj"],
  "mercilessly": ["m-er1 s-ah l-ah-s l-iy", "rb"],
  "mercurial": ["m-er k-y-uh1 r-iy ah-l", "jj"],
  "mercury": ["m-er1 k-y-er iy", "nn"],
  "mercy": ["m-er1 s-iy", "nn"],
  "mere": ["m-ih1-r", "jj"],
  "merely": ["m-ih1-r l-iy", "rb"],
  "merest": ["m-eh1 r-ah-s-t", "jjs"],
  "merge": ["m-er1-jh", "vb nn vbp"],
  "merged": ["m-er1-jh-d", "vbn jj vbd"],
  "merger": ["m-er1 jh-er", "nn"],
  "meridian": ["m-er ih1 d-iy ah-n", "nn"],
  "merit": ["m-eh1 r-ah-t", "nn vb vbp"],
  "meritless": ["m-eh1 r-ih-t l-ah-s", "jj"],
  "meritorious": ["m-eh r-ah t-ao1 r-iy ah-s", "jj"],
  "mermaid": ["m-er1 m-ey-d", "nn"],
  "merrily": ["m-eh1 r-ah l-iy", "rb"],
  "merry": ["m-eh1 r-iy", "jj"],
  "mesenteric": ["m-eh s-ah-n t-eh1 r-ih-k", "jj"],
  "mesh": ["m-eh1-sh", "nn vbp vb"],
  "mesmerize": ["m-eh1-z-m-er-ay-z", "vb"],
  "mesothelioma": ["m-eh s-ah th-iy l-iy ow1 m-ah", "nn"],
  "mess": ["m-eh1-s", "nn vbp vb"],
  "message": ["m-eh1 s-ah-jh", "nn vb"],
  "messenger": ["m-eh1 s-ah-n jh-er", "nn"],
  "messiah": ["m-ah s-ay1 ah", "nn"],
  "messianic": ["m-eh s-iy ae1 n-ih-k", "jj"],
  "messy": ["m-eh1 s-iy", "jj"],
  "met": ["m-eh1-t", "vbd vbn"],
  "metabolic": ["m-eh t-ah b-aa1 l-ih-k", "jj"],
  "metabolism": ["m-ah t-ae1 b-ah l-ih z-ah-m", "nn"],
  "metabolize": ["m-ah t-ae1 b-ah l-ay-z", "vb"],
  "metal": ["m-eh1 t-ah-l", "nn"],
  "metallic": ["m-ah t-ae1 l-ih-k", "jj"],
  "metallurgical": ["m-eh t-ah l-er1 jh-ih k-ah-l", "jj"],
  "metallurgy": ["m-eh1 t-ah l-er jh-iy", "nn"],
  "metalworker": ["m-eh1 t-ah-l w-er k-er", "nn"],
  "metalworking": ["m-eh1 t-ah-l w-er k-ih-ng", "nn"],
  "metamorphic": ["m-eh t-ah m-ao1-r f-ih-k", "jj"],
  "metamorphosis": ["m-eh t-ah m-ao1-r f-ah s-ah-s", "nn"],
  "metaphor": ["m-eh1 t-ah f-ao-r", "nn"],
  "metaphorical": ["m-eh t-ah f-ao1 r-ih k-ah-l", "jj"],
  "metaphysical": ["m-eh t-ah f-ih1 z-ih k-ah-l", "jj"],
  "metaphysics": ["m-eh t-ah f-ih1 z-ih-k-s", "nn"],
  "mete": ["m-iy1-t", "vb"],
  "meteor": ["m-iy1 t-iy er", "nn"],
  "meteoric": ["m-iy t-iy ao1 r-ih-k", "jj"],
  "meteorological": ["m-iy t-iy ao r-ah l-aa1 jh-ih k-ah-l", "jj"],
  "meteorologist": ["m-iy t-iy er aa1 l-ah jh-ih-s-t", "nn"],
  "meteorology": ["m-iy t-iy er aa1 l-ah jh-iy", "nn"],
  "meter": ["m-iy1 t-er", "nn vb"],
  "methadone": ["m-eh1 th-ah d-ow-n", "nn"],
  "methane": ["m-eh1 th-ey-n", "nn"],
  "methanol": ["m-eh1 th-ah n-aa-l", "nn"],
  "method": ["m-eh1 th-ah-d", "nn"],
  "methodical": ["m-ah th-aa1 d-ah k-ah-l", "jj"],
  "methodically": ["m-ah th-aa1 d-ih k-ah l-iy", "rb"],
  "methodological": ["m-eh th-ah d-ah l-aa1 jh-ih k-ah-l", "jj"],
  "methodology": ["m-eh th-ah d-aa1 l-ah jh-iy", "nn"],
  "methyl": ["m-eh1 th-ah-l", "nn"],
  "methylene": ["m-eh1 th-ih l-iy-n", "nn"],
  "meticulous": ["m-ah t-ih1 k-y-ah l-ah-s", "jj"],
  "meticulously": ["m-ah t-ih1 k-y-ah l-ah-s l-iy", "rb"],
  "metric": ["m-eh1 t-r-ih-k", "jj nn"],
  "metrical": ["m-eh1 t-r-ih k-ah-l", "jj"],
  "metro": ["m-eh1 t-r-ow", "nn"],
  "metropolis": ["m-ah t-r-aa1 p-ah l-ah-s", "nn"],
  "metropolitan": ["m-eh t-r-ah p-aa1 l-ah t-ah-n", "jj nn"],
  "mettle": ["m-eh1 t-ah-l", "nn"],
  "mew": ["m-y-uw1", "vb"],
  "miasma": ["m-iy ae1-z m-ah", "nn"],
  "mica": ["m-ay1 k-ah", "nn"],
  "micro": ["m-ay1 k-r-ow", "jj"],
  "microbe": ["m-ay1 k-r-ow-b", "nn"],
  "microbial": ["m-ay k-r-ow1 b-iy ah-l", "jj"],
  "microbiologist": ["m-ay k-r-ow b-iy aa1 l-ah jh-ih-s-t", "nn"],
  "microbiology": ["m-ay k-r-ow b-ay aa1 l-ah jh-iy", "nn"],
  "microchip": ["m-ay1 k-r-ow ch-ih1-p", "nn jj"],
  "microcircuit": ["m-ay1 k-r-ow s-er k-ah-t", "nn"],
  "microcosm": ["m-ay1 k-r-ah k-aa z-ah-m", "nn"],
  "microeconomic": ["m-ay k-r-ow eh k-ah n-aa1 m-ih-k", "jj"],
  "microeconomics": ["m-ay k-r-ow eh k-ah n-aa1 m-ih-k-s", "nn"],
  "microfilm": ["m-ay1 k-r-ah f-ih-l-m", "nn"],
  "microgram": ["m-ay1 k-r-ow g-r-ae-m", "nn"],
  "micromanage": ["m-ay k-r-ow m-ae1 n-ih-jh", "nn"],
  "micromanagement": ["m-ay k-r-ow m-ae1 n-ih-jh m-ah-n-t", "nn"],
  "micrometer": ["m-ay k-r-aa1 m-ah t-er", "nn"],
  "micron": ["m-ay1 k-r-aa-n", "nn"],
  "microorganism": ["m-ay k-r-ow ao1-r g-ah n-ih z-ah-m", "nn"],
  "microphone": ["m-ay1 k-r-ah f-ow-n", "nn"],
  "microscope": ["m-ay1 k-r-ah-s k-ow-p", "nn"],
  "microscopic": ["m-ay k-r-ah s-k-aa1 p-ih-k", "jj"],
  "microwavable": ["m-ay k-r-ow w-ey1 v-ah b-ah-l", "jj"],
  "microwave": ["m-ay1 k-r-ah w-ey-v", "nn vb"],
  "midafternoon": ["m-ih1-d ae-f t-er n-uw-n", "nn"],
  "midair": ["m-ih1-d eh1-r", "nn"],
  "midcontinent": ["m-ih-d k-aa1-n t-ih n-ah-n-t", "jj"],
  "midday": ["m-ih1-d d-ey", "nn rb"],
  "middle": ["m-ih1 d-ah-l", "nn jj"],
  "middleman": ["m-ih1 d-ah-l m-ae-n", "nn"],
  "middling": ["m-ih1 d-ah-l ih-ng", "jj"],
  "midland": ["m-ih1-d l-ae-n-d", "nn"],
  "midlevel": ["m-ih1-d l-ah v-ah-l", "jj"],
  "midmorning": ["m-ih1-d m-ao-r n-ih-ng", "nn"],
  "midnight": ["m-ih1-d n-ay-t", "nn rb"],
  "midpoint": ["m-ih1-d p-oy-n-t", "nn"],
  "midpriced": ["m-ih1-d p-r-ay1-s-t", "jj"],
  "midrange": ["m-ih1 d-r-ey-n-jh", "jj nn"],
  "midseason": ["m-ih1-d s-iy1 z-ah-n", "nn"],
  "midsession": ["m-ih1-d s-eh sh-ah-n", "nn"],
  "midsize": ["m-ih1-d s-ay-z", "jj"],
  "midsized": ["m-ih1-d s-ay-z-d", "jj"],
  "midst": ["m-ih1-d-s-t", "nn"],
  "midstream": ["m-ih1-d s-t-r-iy-m", "nn"],
  "midsummer": ["m-ih1-d s-ah1 m-er", "nn"],
  "midterm": ["m-ih1-d t-er-m", "jj"],
  "midtown": ["m-ih1-d t-aw-n", "jj nn"],
  "midway": ["m-ih1-d w-ey", "rb jj nn"],
  "midweek": ["m-ih1-d w-iy-k", "jj nn"],
  "midwest": ["m-ih-d w-eh1-s-t", "jjs"],
  "midwestern": ["m-ih-d w-eh1 s-t-er-n", "jj"],
  "midwife": ["m-ih1-d w-ay-f", "nn"],
  "midwinter": ["m-ih1-d w-ih1-n t-er", "nn"],
  "midyear": ["m-ih1 d-y-ih-r", "nn"],
  "mien": ["m-iy1-n", "nn"],
  "miffed": ["m-ih1-f-t", "jj"],
  "might": ["m-ay1-t", "md nn vbd"],
  "mightn't": ["m-ay1-t-ah-n-t", "md"],
  "mightiest": ["m-ay1 t-iy ah-s-t", "jjs"],
  "mightily": ["m-ay1 t-ah l-iy", "rb"],
  "mighty": ["m-ay1 t-iy", "jj rb"],
  "migraine": ["m-ay1 g-r-ey-n", "nn"],
  "migrant": ["m-ay1 g-r-ah-n-t", "jj nn"],
  "migrate": ["m-ay1 g-r-ey-t", "vb vbp"],
  "migration": ["m-ay g-r-ey1 sh-ah-n", "nn"],
  "migratory": ["m-ay1 g-r-ah t-ao r-iy", "jj"],
  "mild": ["m-ay1-l-d", "jj"],
  "milder": ["m-ay1-l d-er", "jjr"],
  "mildew": ["m-ih1-l d-uw", "nn"],
  "mildly": ["m-ay1-l-d l-iy", "rb"],
  "mile": ["m-ay1-l", "nn"],
  "mileage": ["m-ay1 l-ah-jh", "nn"],
  "milestone": ["m-ay1-l s-t-ow-n", "nn"],
  "milieu": ["m-ih l-y-uh1", "nn"],
  "militancy": ["m-ih1 l-ah t-ah-n s-iy", "nn"],
  "militant": ["m-ih1 l-ah t-ah-n-t", "nn jj"],
  "militarism": ["m-ih1 l-ah t-er ih z-ah-m", "nn"],
  "military": ["m-ih1 l-ah t-eh r-iy", "jj nn"],
  "militia": ["m-ah l-ih1 sh-ah", "nn"],
  "milk": ["m-ih1-l-k", "nn vb"],
  "milky": ["m-ih1-l k-iy", "jj"],
  "mill": ["m-ih1-l", "nn vb"],
  "milled": ["m-ih1-l-d", "jj"],
  "millennium": ["m-ah l-eh1 n-iy ah-m", "nn"],
  "milligram": ["m-ih1 l-ah g-r-ae-m", "nn"],
  "millimeter": ["m-ih1 l-ah m-iy t-er", "nn"],
  "million": ["m-ih1 l-y-ah-n", "nn"],
  "millionaire": ["m-ih l-y-ah n-eh1-r", "nn"],
  "millionth": ["m-ih1 l-y-ah-n-th", "jj"],
  "mimic": ["m-ih1 m-ih-k", "vb vbp"],
  "mimicked": ["m-ih1 m-ih-k-t", "vbn"],
  "min": ["m-ih1-n", "nn"],
  "minaret": ["m-ih n-er eh1-t", "nn"],
  "mince": ["m-ih1-n-s", "vb"],
  "mincemeat": ["m-ih1-n-s m-iy-t", "nn"],
  "mind": ["m-ay1-n-d", "nn rb vb"],
  "mindful": ["m-ay1-n-d f-ah-l", "jj"],
  "mindless": ["m-ay1-n-d l-ah-s", "jj"],
  "mindset": ["m-ay1-n-d s-eh-t", "nn"],
  "mine": ["m-ay1-n", "nn vb prp vbp"],
  "minefield": ["m-ay1-n f-iy-l-d", "nn"],
  "miner": ["m-ay1 n-er", "nn"],
  "mineral": ["m-ih1 n-er ah-l", "nn jj"],
  "mineralogy": ["m-ih n-er aa1 l-ah jh-iy", "nn"],
  "mineworker": ["m-ay1-n w-er k-er", "nn"],
  "mingle": ["m-ih1-ng g-ah-l", "vb vbp"],
  "mingled": ["m-ih1-ng g-ah-l-d", "vbd vbn jj"],
  "miniature": ["m-ih1 n-iy ah ch-uh-r", "jj nn"],
  "miniaturize": ["m-ih1-n-ih-ch-er-ay-z", "vb"],
  "minicar": ["m-ih1 n-iy k-aa-r", "nn"],
  "minimal": ["m-ih1 n-ah m-ah-l", "jj"],
  "minimalism": ["m-ih1 n-ah m-ah l-ih z-ah-m", "nn"],
  "minimalist": ["m-ih1 n-ah m-ah l-ih-s-t", "jj nn"],
  "minimally": ["m-ih1 n-ah m-ah-l iy", "rb"],
  "minimill": ["m-ih1 n-iy m-aa-l", "nn"],
  "minimize": ["m-ih1 n-ah m-ay-z", "vb"],
  "minimum": ["m-ih1 n-ah m-ah-m", "jj nn"],
  "minion": ["m-ih1 n-y-ah-n", "nn"],
  "miniscule": ["m-ih1 n-ih s-k-y-uw-l", "jj nn"],
  "miniseries": ["m-ih1 n-ih s-eh r-iy-z", "nn"],
  "miniskirt": ["m-ih1 n-iy s-k-er-t", "nn"],
  "minister": ["m-ih1 n-ah s-t-er", "nn"],
  "ministerial": ["m-ih n-ih s-t-iy1 r-iy ah-l", "jj"],
  "ministration": ["m-ih n-ah-s t-r-ey1 sh-ah-n", "nn"],
  "ministry": ["m-ih1 n-ah-s t-r-iy", "nn"],
  "minivan": ["m-ih1 n-iy v-ae1-n", "nn"],
  "mink": ["m-ih1-ng-k", "nn"],
  "minor": ["m-ay1 n-er", "jj nn"],
  "minority": ["m-ay n-ao1 r-ah t-iy", "nn jj"],
  "minstrel": ["m-ih1-n s-t-r-ah-l", "nn"],
  "mint": ["m-ih1-n-t", "nn vb"],
  "minter": ["m-ih1-n t-er", "nn"],
  "minuet": ["m-ih n-y-ah-w eh1-t", "nn"],
  "minus": ["m-ay1 n-ah-s", "cc in jj nn"],
  "minuscule": ["m-ih1 n-ah s-k-y-uw-l", "jj"],
  "minute": ["m-ih1 n-ah-t", "nn jj"],
  "minutely": ["m-ih1 n-ah-t l-iy", "rb"],
  "miracle": ["m-ih1 r-ah k-ah-l", "nn"],
  "miraculous": ["m-er ae1 k-y-ah l-ah-s", "jj"],
  "miraculously": ["m-er ae1 k-y-ah l-ah-s l-iy", "rb"],
  "mire": ["m-ay1-r", "nn vb"],
  "mired": ["m-ay1-r-d", "vbn jj"],
  "mirror": ["m-ih1 r-er", "nn vbp vb"],
  "mirth": ["m-er1-th", "nn"],
  "misadventure": ["m-ih-s ah-d v-eh1-n ch-er", "nn"],
  "misallocate": ["m-ih-s-ae1-l-ah-k-ey-t", "vb"],
  "misanthrope": ["m-ih1 s-ah-n th-r-ow-p", "nn"],
  "misapplication": ["m-ih-s ae p-l-ah k-ey1 sh-ah-n", "nn"],
  "misapplied": ["m-ih-s ah p-l-ay1-d", "vbn"],
  "misapply": ["m-ih-s-ah-p-l-ay1", "vb"],
  "misapprehension": ["m-ih-s ae p-r-iy hh-eh1-n sh-ah-n", "nn"],
  "misappropriate": ["m-ih-s-ah-p-r-ow1-p-r-iy-ey-t", "vb"],
  "misappropriation": ["m-ih-s ah p-r-ow p-r-iy ey1 sh-ah-n", "nn"],
  "misbegotten": ["m-ih-s b-ah g-aa1 t-ah-n", "jj"],
  "misbehave": ["m-ih-s-b-ah-hh-ey1-v", "vb"],
  "misbehavior": ["m-ih-s b-ah hh-ey1 v-y-er", "nn"],
  "miscalculate": ["m-ih-s-k-ae1-l-k-y-ah-l-ey-t", "vb"],
  "miscalculation": ["m-ih-s k-ae1-l k-y-ah l-ey1 sh-ah-n", "nn"],
  "miscarriage": ["m-ih-s k-eh1 r-ih jh-ih", "nn"],
  "miscellaneous": ["m-ih s-ah l-ey1 n-iy ah-s", "jj"],
  "miscellany": ["m-ih1 s-ah l-ey n-iy", "nn"],
  "mischarge": ["m-ih-s-ch-aa1-r-jh", "vb"],
  "mischarging": ["m-ih-s ch-aa1-r jh-ih-ng", "nn"],
  "mischief": ["m-ih1-s ch-ah-f", "nn"],
  "mischievous": ["m-ih1-s ch-ah v-ah-s", "jj"],
  "misconception": ["m-ih-s k-ah-n s-eh1-p sh-ah-n", "nn"],
  "misconduct": ["m-ih-s k-aa1-n d-ah-k-t", "nn"],
  "misconstrue": ["m-ih-s-k-ah-n-s-t-r-uw1", "vb"],
  "miscount": ["m-ih1-s k-aw1-n-t", "nn"],
  "miscreant": ["m-ih1-s k-r-iy ah-n-t", "jj nn"],
  "miscue": ["m-ih1-s k-y-uw", "nn"],
  "misdeed": ["m-ih-s d-iy1-d", "nn"],
  "misdemeanor": ["m-ih-s d-ah m-iy1 n-er", "nn"],
  "miserable": ["m-ih1 z-er ah b-ah-l", "jj"],
  "miserably": ["m-ih1 z-er ah b-l-iy", "rb"],
  "miserly": ["m-ay1 z-er l-iy", "jj"],
  "misery": ["m-ih1 z-er iy", "nn"],
  "misfit": ["m-ih1-s f-ih-t", "nn"],
  "misfortune": ["m-ih-s f-ao1-r ch-ah-n", "nn"],
  "misgiving": ["m-ih-s g-ih1 v-ih-ng", "nn"],
  "misguide": ["m-ih-s-g-ay1-d", "vb"],
  "misguided": ["m-ih-s g-ay1 d-ih-d", "jj vbn"],
  "mishandle": ["m-ih-s-hh-ae1-n-d-ah-l", "vb"],
  "mishandled": ["m-ih-s hh-ae1-n d-ah-l-d", "vbd jj vbn"],
  "mishap": ["m-ih1-s hh-ae-p", "nn"],
  "misinform": ["m-ih-s-ih-n-f-ao1-r-m", "vb"],
  "misinformation": ["m-ih-s ih-n f-er m-ey1 sh-ah-n", "nn"],
  "misinterpret": ["m-ih-s ih-n t-er1 p-r-ah-t", "vb vbp"],
  "misinterpretation": ["m-ih-s ih-n t-er p-r-ah t-ey1 sh-ah-n", "nn"],
  "misjudge": ["m-ih-s-jh-ah1-jh", "vb"],
  "misjudgment": ["m-ih-s jh-ah1-jh m-ah-n-t", "nn"],
  "mislaid": ["m-ih-s l-ey1-d", "vbn"],
  "mislead": ["m-ih-s-l-iy1-d", "vb"],
  "misleading": ["m-ih-s l-iy1 d-ih-ng", "jj vbg"],
  "misleadingly": ["m-ih-s l-iy1 d-ih-ng l-iy", "rb"],
  "misled": ["m-ih-s l-eh1-d", "vbd vbn"],
  "mismanage": ["m-ih-s-m-ae1-n-ih-jh", "vb"],
  "mismanagement": ["m-ih-s m-ae1 n-ih-jh m-ah-n-t", "nn"],
  "mismatch": ["m-ih-s m-ae1-ch", "nn vb"],
  "misnomer": ["m-ih-s n-ow1 m-er", "nn"],
  "misperceive": ["m-ih-s-p-er-s-iy1-v", "vb"],
  "misperception": ["m-ih-s p-er s-eh1-p sh-ah-n", "nn"],
  "misplace": ["m-ih-s p-l-ey1-s", "vb"],
  "misprice": ["m-ih-s-p-r-ay1-s", "vb"],
  "misquote": ["m-ih-s-k-w-ow1-t", "vb"],
  "misread": ["m-ih-s r-iy1-d", "vbd"],
  "misreading": ["m-ih-s r-iy1 d-ih-ng", "nn"],
  "misrepresent": ["m-ih-s r-eh p-r-ah z-eh1-n-t", "vb"],
  "misrepresentation": ["m-ih-s r-eh p-r-ih z-eh-n t-ey1 sh-ah-n", "nn"],
  "miss": ["m-ih1-s", "vb vbp nn"],
  "missed": ["m-ih1-s-t", "vbd vbn jj"],
  "misshapen": ["m-ih-s sh-ey1 p-ah-n", "jj"],
  "missile": ["m-ih1 s-ah-l", "nn"],
  "missing": ["m-ih1 s-ih-ng", "vbg jj"],
  "mission": ["m-ih1 sh-ah-n", "nn"],
  "missionary": ["m-ih1 sh-ah-n eh r-iy", "jj nn"],
  "missive": ["m-ih1 s-ih-v", "nn"],
  "misspell": ["m-ih-s-s-p-eh1-l", "vb"],
  "misspent": ["m-ih-s s-p-eh1-n-t", "vbn"],
  "misstate": ["m-ih-s-s-t-ey1-t", "vb"],
  "misstatement": ["m-ih-s t-ey1-t m-ah-n-t", "nn"],
  "misstep": ["m-ih-s s-t-eh1-p", "nn"],
  "missy": ["m-ih1 s-iy", "nn"],
  "mist": ["m-ih1-s-t", "nn"],
  "mistake": ["m-ih s-t-ey1-k", "nn vb"],
  "mistaken": ["m-ih s-t-ey1 k-ah-n", "vbn jj"],
  "mistakenly": ["m-ih s-t-ey1 k-ah-n l-iy", "rb"],
  "mister": ["m-ih1 s-t-er", "nn"],
  "mistletoe": ["m-ih1 s-ah-l t-ow", "nn"],
  "mistook": ["m-ih s-t-uh1-k", "vbd"],
  "mistreat": ["m-ih-s t-r-iy1-t", "vb"],
  "mistreatment": ["m-ih-s t-r-iy1-t m-ah-n-t", "nn"],
  "mistress": ["m-ih1-s t-r-ah-s", "nn"],
  "mistrial": ["m-ih-s t-r-ay1 ah-l", "nn"],
  "mistrust": ["m-ih-s t-r-ah1-s-t", "nn vb"],
  "mistrusted": ["m-ih-s t-r-ah1 s-t-ih-d", "vbd vbn jj"],
  "misty": ["m-ih1 s-t-iy", "jj"],
  "misunderstand": ["m-ih-s ah-n d-er s-t-ae1-n-d", "vb"],
  "misunderstanding": ["m-ih-s ah-n d-er s-t-ae1-n d-ih-ng", "nn"],
  "misunderstood": ["m-ih-s ah-n d-er s-t-uh1-d", "vbn vbd"],
  "misuse": ["m-ih-s y-uw1-z", "nn vb vbp"],
  "mite": ["m-ay1-t", "nn"],
  "miter": ["m-ay1 t-er", "vb"],
  "mitigate": ["m-ih1 t-ah g-ey-t", "vb"],
  "mitigating": ["m-ih1 t-ah g-ey t-ih-ng", "vbg jj"],
  "mitigation": ["m-ih t-ih g-ey1 sh-ah-n", "nn"],
  "mitral": ["m-ay1 t-r-ah-l", "jj"],
  "mitre": ["m-ih1 t-r-iy", "nn"],
  "mitt": ["m-ih1-t", "nn"],
  "mitten": ["m-ih1 t-ah-n", "nn"],
  "mix": ["m-ih1-k-s", "nn vbp vb"],
  "mixed": ["m-ih1-k-s-t", "vbn vbd jj"],
  "mixer": ["m-ih1-k s-er", "nn"],
  "mixture": ["m-ih1-k-s ch-er", "nn"],
  "moan": ["m-ow1-n", "vb"],
  "moat": ["m-ow1-t", "nn"],
  "mob": ["m-aa1-b", "nn"],
  "mobile": ["m-ow1 b-ah-l", "jj"],
  "mobility": ["m-ow b-ih1 l-ah t-iy", "nn"],
  "mobilization": ["m-ow b-ah l-ah z-ey1 sh-ah-n", "nn"],
  "mobilize": ["m-ow1 b-ah l-ay-z", "vb"],
  "mobster": ["m-aa1-b s-t-er", "nn"],
  "mock": ["m-aa1-k", "jj vbp vb"],
  "mockery": ["m-aa1 k-er iy", "nn"],
  "mocking": ["m-aa1 k-ih-ng", "vbg jj"],
  "mode": ["m-ow1-d", "nn"],
  "model": ["m-aa1 d-ah-l", "nn vb"],
  "modeled": ["m-aa1 d-ah-l-d", "vbn vbd jj"],
  "modeling": ["m-aa1 d-ah-l ih-ng", "nn jj vbg"],
  "modem": ["m-ow1 d-ah-m", "nn"],
  "moderate": ["m-aa1 d-er ah-t", "jj vbp vb"],
  "moderately": ["m-aa1 d-er ah-t l-iy", "rb"],
  "moderating": ["m-aa1 d-er ey t-ih-ng", "vbg jj"],
  "moderation": ["m-aa d-er ey1 sh-ah-n", "nn"],
  "moderator": ["m-aa1 d-er ey t-er", "nn"],
  "modern": ["m-aa1 d-er-n", "jj nn"],
  "modernism": ["m-aa1 d-er n-ih z-ah-m", "nn"],
  "modernist": ["m-aa1 d-er n-ah-s-t", "jj nn"],
  "modernity": ["m-aa d-er1 n-ah t-iy", "nn"],
  "modernization": ["m-aa d-er n-ah z-ey1 sh-ah-n", "nn"],
  "modernize": ["m-aa1 d-er n-ay-z", "vb"],
  "modernized": ["m-aa1 d-er n-ay-z-d", "vbn jj vbd"],
  "modest": ["m-aa1 d-ah-s-t", "jj"],
  "modestly": ["m-aa1 d-ah-s-t l-iy", "rb"],
  "modesty": ["m-aa1 d-ah s-t-iy", "nn"],
  "modicum": ["m-aa1 d-ih k-ah-m", "nn"],
  "modification": ["m-aa d-ah f-ah k-ey1 sh-ah-n", "nn"],
  "modified": ["m-aa1 d-ah f-ay-d", "vbn jj vbd"],
  "modify": ["m-aa1 d-ah f-ay", "vb vbp"],
  "modular": ["m-aa1 jh-ah l-er", "jj"],
  "modulate": ["m-ao1 jh-y-uw l-ey-t", "vbp vb"],
  "modulation": ["m-aa jh-ah l-ey1 sh-ah-n", "nn"],
  "module": ["m-aa1 jh-uw-l", "nn"],
  "mogul": ["m-ow1 g-ah-l", "nn"],
  "moist": ["m-oy1-s-t", "jj"],
  "moisten": ["m-oy1-s-ah-n", "vb"],
  "moistened": ["m-oy1 s-ah-n-d", "jj vbd"],
  "moisture": ["m-oy1-s ch-er", "nn"],
  "moisturizer": ["m-oy1-s ch-er ay z-er", "nn"],
  "molasses": ["m-ah l-ae1 s-ah-z", "nn"],
  "mold": ["m-ow1-l-d", "nn vb vbp"],
  "moldable": ["m-ow1-l d-ah b-ah-l", "jj"],
  "molded": ["m-ow1-l d-ah-d", "vbn jj vbd"],
  "molding": ["m-ow1-l d-ih-ng", "nn vbg"],
  "moldy": ["m-ow1-l d-iy", "jj"],
  "mole": ["m-ow1-l", "nn"],
  "molecular": ["m-ah l-eh1 k-y-ah l-er", "jj"],
  "molecule": ["m-aa1 l-ah k-y-uw-l", "nn"],
  "molehill": ["m-ow1-l hh-ih-l", "nn"],
  "molest": ["m-ah l-eh1-s-t", "vb"],
  "mollified": ["m-aa1 l-ah f-ay-d", "vbn vbd"],
  "mollify": ["m-aa1 l-ah f-ay", "vb"],
  "mollycoddle": ["m-aa1 l-iy k-aa d-ah-l", "nn"],
  "molt": ["m-ow1-l-t", "vb"],
  "molten": ["m-ow1-l t-ah-n", "jj"],
  "molton": ["m-ow1-l t-ah-n", "nn"],
  "mom": ["m-aa1-m", "nn"],
  "moment": ["m-ow1 m-ah-n-t", "nn"],
  "momentarily": ["m-ow m-ah-n t-eh1 r-ah l-iy", "rb"],
  "momentary": ["m-ow1 m-ah-n t-eh r-iy", "jj"],
  "momentous": ["m-ow m-eh1-n t-ah-s", "jj"],
  "momentum": ["m-ow m-eh1-n t-ah-m", "nn"],
  "monarch": ["m-aa1 n-aa-r-k", "nn"],
  "monarchy": ["m-aa1 n-aa-r k-iy", "nn"],
  "monastery": ["m-aa1 n-ah s-t-eh r-iy", "nn"],
  "monastic": ["m-ah n-ae1 s-t-ih-k", "jj"],
  "monetary": ["m-aa1 n-ah t-eh r-iy", "jj"],
  "money": ["m-ah1 n-iy", "nn"],
  "moneyed": ["m-ah1 n-iy-d", "jj"],
  "moneymaker": ["m-ah1 n-iy m-ey k-er", "nn"],
  "moneymaking": ["m-ah1 n-iy m-ey k-ih-ng", "jj nn"],
  "monied": ["m-ah1 n-iy-d", "jj"],
  "moniker": ["m-aa1 n-ih k-er", "nn"],
  "monitor": ["m-aa1 n-ah t-er", "vb nn vbp"],
  "monitored": ["m-aa1 n-ah t-er-d", "vbn vbd jj"],
  "monk": ["m-ah1-ng-k", "nn"],
  "monkey": ["m-ah1-ng k-iy", "nn"],
  "mono": ["m-ow1 n-ow", "jj nn"],
  "monochromatic": ["m-aa n-ah k-r-ow m-ae1 t-ih-k", "jj"],
  "monochrome": ["m-aa1 n-ah k-r-ow-m", "jj"],
  "monoclonal": ["m-aa n-ah k-l-ow1 n-ah-l", "jj"],
  "monogamous": ["m-ah n-aa1 g-ah m-ah-s", "jj"],
  "monogrammed": ["m-aa1 n-ah g-r-ae-m-d", "jj"],
  "monograph": ["m-aa1 n-ah g-r-ae-f", "nn"],
  "monohull": ["m-aa1 n-ah hh-ah-l", "nn"],
  "monolith": ["m-aa1 n-ah l-ih-th", "nn"],
  "monolithic": ["m-aa n-ah l-ih1 th-ih-k", "jj"],
  "monologue": ["m-aa1 n-ah l-ao-g", "nn"],
  "monomer": ["m-aa1 n-ah m-er", "nn"],
  "monophonic": ["m-aa n-ah f-aa1 n-ih-k", "jj"],
  "monopolistic": ["m-ah n-aa p-ah l-ih1 s-t-ih-k", "jj"],
  "monopolization": ["m-ah n-aa p-ah l-ih z-ey1 sh-ah-n", "nn"],
  "monopolize": ["m-ah n-aa1 p-ah l-ay-z", "vb"],
  "monopoly": ["m-ah n-aa1 p-ah l-iy", "nn"],
  "monotone": ["m-aa1 n-ah t-ow-n", "jj nn"],
  "monotonous": ["m-ah n-aa1 t-ah-n ah-s", "jj"],
  "monotony": ["m-ah n-aa1 t-ah-n iy", "nn"],
  "monsoon": ["m-aa-n s-uw1-n", "nn"],
  "monster": ["m-aa1-n s-t-er", "nn"],
  "monstrosity": ["m-aa-n-s t-r-aa1 s-ah t-iy", "nn"],
  "monstrous": ["m-aa1-n-s t-r-ah-s", "jj"],
  "montage": ["m-aa-n t-aa1-zh", "nn"],
  "month": ["m-ah1-n-th", "nn"],
  "monthlong": ["m-ah1-n th-l-ao-ng", "jj"],
  "monthly": ["m-ah1-n-th l-iy", "jj nn rb"],
  "monument": ["m-aa1 n-y-uw m-ah-n-t", "nn"],
  "monumental": ["m-aa n-y-ah m-eh1-n t-ah-l", "jj"],
  "mood": ["m-uw1-d", "nn"],
  "moody": ["m-uw1 d-iy", "jj"],
  "moon": ["m-uw1-n", "nn vb"],
  "moonlight": ["m-uw1-n l-ay-t", "nn vb"],
  "moonlike": ["m-uw1-n l-ay-k", "jj"],
  "moonlit": ["m-uw1-n l-ih-t", "jj"],
  "moor": ["m-uh1-r", "vb"],
  "mooring": ["m-uh1 r-ih-ng", "nn"],
  "moot": ["m-uw1-t", "jj"],
  "mop": ["m-aa1-p", "vb nn"],
  "moraine": ["m-er ey1-n", "nn"],
  "moral": ["m-ao1 r-ah-l", "jj nn"],
  "morale": ["m-er ae1-l", "nn"],
  "moralism": ["m-ao1 r-ah l-ih z-ah-m", "nn"],
  "moralist": ["m-ao1 r-ah l-ih-s-t", "nn"],
  "moralistic": ["m-ao r-ah l-ih1 s-t-ih-k", "jj"],
  "morality": ["m-er ae1 l-ah t-iy", "nn"],
  "moralize": ["m-ao1-r-ah-l-ay-z", "vb"],
  "moralizing": ["m-ao1 r-ah l-ay z-ih-ng", "vbg jj"],
  "morally": ["m-ao1 r-ah l-iy", "rb"],
  "morass": ["m-er ae1-s", "nn"],
  "moratorium": ["m-ao r-ah t-ao1 r-iy ah-m", "nn"],
  "morbid": ["m-ao1-r b-ah-d", "jj"],
  "morbidity": ["m-ao-r b-ih1 d-ah t-iy", "nn"],
  "more": ["m-ao1-r", "jjr rbr nn jj rb rp"],
  "moreover": ["m-ao r-ow1 v-er", "rb"],
  "morgue": ["m-ao1-r-g", "nn"],
  "moribund": ["m-ao1 r-ah b-ah-n-d", "jj"],
  "morning": ["m-ao1-r n-ih-ng", "nn"],
  "morose": ["m-er ow1-s", "jj"],
  "morphine": ["m-ao1-r f-iy-n", "nn"],
  "morphological": ["m-ao-r f-ah l-aa1 jh-ih k-ah-l", "jj"],
  "morphology": ["m-ao-r f-aa1 l-ah jh-iy", "nn"],
  "morrow": ["m-aa1 r-ow", "nn"],
  "morsel": ["m-ao1-r s-ah-l", "nn"],
  "mortal": ["m-ao1-r t-ah-l", "jj nn"],
  "mortality": ["m-ao-r t-ae1 l-ah t-iy", "nn"],
  "mortally": ["m-ao1-r t-ah l-iy", "rb"],
  "mortar": ["m-ao1-r t-er", "nn"],
  "mortgage": ["m-ao1-r g-ah-jh", "nn vb"],
  "mortis": ["m-ao1-r t-ih-s", "nn"],
  "mosaic": ["m-ow z-ey1 ih-k", "nn"],
  "mosey": ["m-ow1 z-iy", "vb"],
  "mosque": ["m-aa1-s-k", "nn"],
  "mosquito": ["m-ah s-k-iy1 t-ow", "nn"],
  "moss": ["m-ao1-s", "nn"],
  "most": ["m-ow1-s-t", "rbs jj nn rb jjs"],
  "mostly": ["m-ow1-s-t l-iy", "rb jj"],
  "motel": ["m-ow t-eh1-l", "nn"],
  "moth": ["m-ao1-th", "nn"],
  "mothball": ["m-ao1-th b-ao-l", "nn vb jj"],
  "mothballing": ["m-ao1-th b-ao1 l-ih-ng", "nn"],
  "mother": ["m-ah1 dh-er", "nn vb"],
  "motherhood": ["m-ah1 dh-er hh-uh-d", "nn"],
  "motherland": ["m-ah1 dh-er l-ae-n-d", "nn"],
  "motherly": ["m-ah1 dh-er l-iy", "jj"],
  "motif": ["m-ow t-iy1-f", "nn"],
  "motion": ["m-ow1 sh-ah-n", "nn vb"],
  "motionless": ["m-ow1 sh-ah-n l-ah-s", "jj"],
  "motivate": ["m-ow1 t-ah v-ey-t", "vb vbp"],
  "motivated": ["m-ow1 t-ah v-ey t-ah-d", "vbn vbd jj"],
  "motivating": ["m-ow1 t-ah v-ey t-ih-ng", "vbg jj"],
  "motivation": ["m-ow t-ah v-ey1 sh-ah-n", "nn"],
  "motive": ["m-ow1 t-ih-v", "nn jj"],
  "motley": ["m-aa1-t l-iy", "jj"],
  "motor": ["m-ow1 t-er", "nn jj vb"],
  "motorbike": ["m-ow1 t-er b-ay-k", "nn"],
  "motorcade": ["m-ow1 t-er k-ey-d", "nn"],
  "motorcycle": ["m-ow1 t-er s-ay k-ah-l", "nn"],
  "motorist": ["m-ow1 t-er ih-s-t", "nn"],
  "motorize": ["m-ow1-t-er-ay-z", "vb"],
  "motorized": ["m-ow1 t-er ay-z-d", "vbn jj"],
  "mottle": ["m-aa1 t-ah-l", "vb nn"],
  "mottled": ["m-aa1 t-ah-l-d", "vbn jj"],
  "motto": ["m-aa1 t-ow", "nn"],
  "mould": ["m-ow1-l-d", "vb"],
  "mound": ["m-aw1-n-d", "nn"],
  "mount": ["m-aw1-n-t", "vb nn vbp"],
  "mountain": ["m-aw1-n t-ah-n", "nn"],
  "mountainous": ["m-aw1-n t-ah n-ah-s", "jj"],
  "mountainside": ["m-aw1-n t-ah-n s-ay-d", "nn"],
  "mountaintop": ["m-aw1-n t-ah-n t-aa-p", "nn"],
  "mounted": ["m-aw1-n t-ah-d", "vbn jj vbd"],
  "mounting": ["m-aw1-n t-ih-ng", "vbg jj nn"],
  "mourn": ["m-ao1-r-n", "vb"],
  "mourner": ["m-ao1-r n-er", "nn"],
  "mournful": ["m-ao1-r-n f-ah-l", "jj"],
  "mouse": ["m-aw1-s", "nn"],
  "mousetrap": ["m-aw1-s t-r-ae-p", "nn"],
  "mousse": ["m-uw1-s", "nn"],
  "moustache": ["m-ah1 s-t-ae-sh", "nn"],
  "mouth": ["m-aw1-th", "nn vb"],
  "mouthful": ["m-aw1-th f-uh-l", "nn"],
  "mouthpiece": ["m-aw1-th p-iy-s", "nn"],
  "movable": ["m-uw1 v-ah b-ah-l", "jj nn"],
  "move": ["m-uw1-v", "nn vbp vb"],
  "movement": ["m-uw1-v m-ah-n-t", "nn"],
  "mover": ["m-uw1 v-er", "nn"],
  "movie": ["m-uw1 v-iy", "nn"],
  "moviegoer": ["m-uw1 v-iy g-ow er", "nn"],
  "moving": ["m-uw1 v-ih-ng", "vbg jj nn"],
  "movingly": ["m-uw1 v-ih-ng l-iy", "rb"],
  "mow": ["m-ow1", "vb"],
  "mown": ["m-ow1-n", "vbn"],
  "mower": ["m-ow1 er", "nn"],
  "moxie": ["m-aa1-k s-iy", "nn"],
  "much": ["m-ah1-ch", "jj dt nn rb"],
  "muck": ["m-ah1-k", "nn vb"],
  "mucky": ["m-ah1 k-iy", "jj"],
  "mucosa": ["m-y-uw k-ow1 s-ah", "nn"],
  "mucus": ["m-y-uw1 k-ah-s", "nn"],
  "mud": ["m-ah1-d", "nn"],
  "muddied": ["m-ah1 d-iy-d", "vbn jj"],
  "muddle": ["m-ah1 d-ah-l", "nn vb"],
  "muddleheaded": ["m-ah1 d-ah-l hh-eh d-ah-d", "jj"],
  "muddy": ["m-ah1 d-iy", "jj"],
  "mudslinging": ["m-ah1-d s-l-ih ng-ih-ng", "nn"],
  "mudwagon": ["m-ah1-d w-ae g-ah-n", "nn"],
  "muff": ["m-ah1-f", "nn"],
  "muffin": ["m-ah1 f-ah-n", "nn"],
  "muffle": ["m-ah1-f-ah-l", "vb"],
  "muffled": ["m-ah1 f-ah-l-d", "jj vbd vbn"],
  "muffler": ["m-ah1-f l-er", "nn"],
  "mug": ["m-ah1-g", "nn"],
  "mugged": ["m-ah1-g-d", "vbn"],
  "mugger": ["m-ah1 g-er", "nn"],
  "mugging": ["m-ah1 g-ih-ng", "nn"],
  "muggy": ["m-ah1 g-iy", "jj"],
  "mulatto": ["m-ah l-aa1 t-ow", "nn"],
  "mulch": ["m-ah1-l-ch", "nn vb"],
  "mule": ["m-y-uw1-l", "nn"],
  "mull": ["m-ah1-l", "vb"],
  "mullah": ["m-ah1 l-ah", "nn"],
  "multicolored": ["m-ah-l t-iy k-ah1 l-er-d", "jj"],
  "multifaceted": ["m-ah-l t-iy f-ae1 s-ah t-ih-d", "jj"],
  "multilateral": ["m-ah-l t-ih l-ae1 t-er ah-l", "jj"],
  "multilayered": ["m-ah-l t-iy l-ey1 er-d", "jj"],
  "multilevel": ["m-ah-l t-ay l-eh1 v-ah-l", "jj"],
  "multilingual": ["m-ah-l t-iy l-ih1-ng w-ah-l", "jj"],
  "multinational": ["m-ah-l t-ay n-ae1 sh-ah n-ah-l", "jj"],
  "multipart": ["m-ah1-l t-iy p-aa-r-t", "jj"],
  "multiparty": ["m-ah1-l t-iy p-aa-r t-iy", "nn jj"],
  "multiple": ["m-ah1-l t-ah p-ah-l", "jj nn"],
  "multiplexer": ["m-ah1-l t-iy p-l-eh-k s-er", "nn"],
  "multiplication": ["m-ah-l t-ah p-l-ah k-ey1 sh-ah-n", "nn"],
  "multiplicity": ["m-ah-l t-ah p-l-ih1 s-ih t-iy", "nn"],
  "multiply": ["m-ah1-l t-ah p-l-ay", "vb vbp"],
  "multipurpose": ["m-ah-l t-iy p-er1 p-ah-s", "jj"],
  "multistate": ["m-ah1-l t-iy s-t-ey1-t", "nn"],
  "multitask": ["m-ah1-l-t-iy-t-ae-s-k", "vb"],
  "multitude": ["m-ah1-l t-ah t-uw-d", "nn"],
  "multivalve": ["m-ah1-l t-iy v-ae-l-v", "jj"],
  "multiyear": ["m-ah1-l t-iy y-iy1-r", "jj"],
  "mum": ["m-ah1-m", "jj nn"],
  "mumble": ["m-ah1-m b-ah-l", "nn vb"],
  "mumbo": ["m-ah1-m b-ow", "nn"],
  "mummified": ["m-ah1 m-ih f-ay-d", "vbn"],
  "mummify": ["m-ah1-m-ah-f-ay", "vb"],
  "mummy": ["m-ah1 m-iy", "nn"],
  "munch": ["m-ah1-n-ch", "vb"],
  "mundane": ["m-ah-n d-ey1-n", "jj"],
  "municipal": ["m-y-uw n-ih1 s-ah p-ah-l", "jj nn"],
  "municipality": ["m-y-uw n-ih s-ah p-ae1 l-ah t-iy", "nn"],
  "municipally": ["m-y-uw n-ih1 s-ih p-ah l-iy", "rb"],
  "munition": ["m-y-uw n-ih1 sh-ah-n", "nn"],
  "mural": ["m-y-uh1 r-ah-l", "nn"],
  "murder": ["m-er1 d-er", "nn vb"],
  "murdered": ["m-er1 d-er-d", "vbn vbd jj"],
  "murderer": ["m-er1 d-er er", "nn"],
  "murdering": ["m-er1 d-er ih-ng", "vbg jj"],
  "murderous": ["m-er1 d-er ah-s", "jj"],
  "murkier": ["m-er1 k-iy er", "jjr"],
  "murky": ["m-er1 k-iy", "jj"],
  "murmur": ["m-er1 m-er", "nn vb"],
  "muscat": ["m-ah1-s k-ae-t", "jj"],
  "muscle": ["m-ah1 s-ah-l", "nn vb"],
  "muscular": ["m-ah1-s k-y-ah l-er", "jj"],
  "musculature": ["m-ah1-s k-y-ah l-ah ch-er", "nn"],
  "muse": ["m-y-uw1-z", "nn vb"],
  "museum": ["m-y-uw z-iy1 ah-m", "nn"],
  "mush": ["m-ah1-sh", "nn"],
  "mushroom": ["m-ah1-sh r-uw-m", "nn vbp vb"],
  "mushrooming": ["m-ah1-sh r-uh m-ih-ng", "nn"],
  "mushy": ["m-ah1 sh-iy", "jj"],
  "music": ["m-y-uw1 z-ih-k", "nn"],
  "musical": ["m-y-uw1 z-ih k-ah-l", "jj nn"],
  "musicality": ["m-y-uw z-ih k-ae1 l-ah t-iy", "nn"],
  "musically": ["m-y-uw1 z-ih-k l-iy", "rb"],
  "musician": ["m-y-uw z-ih1 sh-ah-n", "nn"],
  "musk": ["m-ah1-s-k", "nn"],
  "musket": ["m-ah1-s k-ah-t", "nn"],
  "mussel": ["m-ah1 s-ah-l", "nn"],
  "must": ["m-ah1-s-t", "md"],
  "mustn't": ["m-ah1-s-t-ah-n-t", "md"],
  "mustache": ["m-ah1 s-t-ae-sh", "nn"],
  "mustached": ["m-ah1 s-t-ae-sh-t", "jj"],
  "mustachioed": ["m-ah s-t-ae1 sh-iy ow-d", "jj"],
  "mustard": ["m-ah1 s-t-er-d", "nn jj vb"],
  "muster": ["m-ah1 s-t-er", "vb nn"],
  "mutant": ["m-y-uw1 t-ah-n-t", "jj"],
  "mutate": ["m-y-uw1 t-ey-t", "vb"],
  "mutation": ["m-y-uw t-ey1 sh-ah-n", "nn"],
  "mute": ["m-y-uw1-t", "jj vb"],
  "muted": ["m-y-uw1 t-ih-d", "vbn vbd jj"],
  "mutilate": ["m-y-uw1-t-ah-l-ey-t", "vb"],
  "mutilated": ["m-y-uw1 t-ah l-ey t-ah-d", "vbn jj"],
  "mutilation": ["m-y-uw t-ah l-ey1 sh-ah-n", "nn"],
  "mutineer": ["m-y-uw t-ah n-ih1-r", "nn"],
  "mutinous": ["m-y-uw1 t-ah n-ah-s", "jj"],
  "mutiny": ["m-y-uw1 t-ah n-iy", "nn"],
  "mutt": ["m-ah1-t", "nn"],
  "mutter": ["m-ah1 t-er", "vb"],
  "mutton": ["m-ah1 t-ah-n", "nn"],
  "mutual": ["m-y-uw1 ch-ah w-ah-l", "jj"],
  "mutually": ["m-y-uw1 ch-uw ah l-iy", "rb"],
  "muzzle": ["m-ah1 z-ah-l", "nn vb"],
  "my": ["m-ay1", "prp$"],
  "mycology": ["m-ay k-aa1 l-ah jh-iy", "nn"],
  "myopia": ["m-ay ow1 p-iy ah", "nn"],
  "myopic": ["m-ay aa1 p-ih-k", "jj"],
  "myriad": ["m-ih1 r-iy ah-d", "jj nn"],
  "myrrh": ["m-er1", "nn"],
  "myrtle": ["m-er1 t-ah-l", "nn"],
  "myself": ["m-ay s-eh1-l-f", "prp"],
  "mysterious": ["m-ih s-t-ih1 r-iy ah-s", "jj"],
  "mysteriously": ["m-ih s-t-ih1 r-iy ah-s l-iy", "rb"],
  "mystery": ["m-ih1 s-t-er iy", "nn"],
  "mystic": ["m-ih1 s-t-ih-k", "jj nn"],
  "mystical": ["m-ih1 s-t-ih k-ah-l", "jj"],
  "mysticism": ["m-ih1 s-t-ih s-ih z-ah-m", "nn"],
  "mystified": ["m-ih1 s-t-ah f-ay-d", "vbn"],
  "mystify": ["m-ih1-s-t-ah-f-ay", "vb"],
  "mystique": ["m-ih s-t-iy1-k", "nn"],
  "myth": ["m-ih1-th", "nn"],
  "mythic": ["m-ih1 th-ih-k", "jj"],
  "mythical": ["m-ih1 th-ah k-ah-l", "jj"],
  "mythological": ["m-ih th-ah l-aa1 jh-ih k-ah-l", "jj"],
  "mythology": ["m-ah th-aa1 l-ah jh-iy", "nn"],
  "nab": ["n-ae1-b", "vb"],
  "nadir": ["n-ey1 d-er", "nn"],
  "nag": ["n-ae1-g", "vb"],
  "nagging": ["n-ae1 g-ih-ng", "jj vbg"],
  "nail": ["n-ey1-l", "nn rb vb"],
  "naive": ["n-ay iy1-v", "jj nn"],
  "naively": ["n-aa iy1-v l-iy", "rb"],
  "naivete": ["n-aa iy v-ah t-ey1", "nn"],
  "naked": ["n-ey1 k-ah-d", "jj"],
  "name": ["n-ey1-m", "nn vb uh vbp"],
  "named": ["n-ey1-m-d", "vbn vbd jj"],
  "nameless": ["n-ey1-m l-ah-s", "jj"],
  "namely": ["n-ey1-m l-iy", "rb"],
  "nameplate": ["n-ey1-m p-l-ey-t", "nn"],
  "namesake": ["n-ey1-m s-ey-k", "nn"],
  "nanny": ["n-ae1 n-iy", "nn"],
  "nap": ["n-ae1-p", "nn vb vbp"],
  "napkin": ["n-ae1-p k-ih-n", "nn"],
  "narco": ["n-aa1-r k-ow", "nn"],
  "narcolepsy": ["n-aa1-r k-ah l-eh-p s-iy", "nn"],
  "narcotic": ["n-aa-r k-aa1 t-ih-k", "jj"],
  "narrate": ["n-eh1-r-ey-t", "vb"],
  "narration": ["n-eh r-ey1 sh-ah-n", "nn"],
  "narrative": ["n-ae1 r-ah t-ih-v", "nn jj"],
  "narrator": ["n-eh1 r-ey t-er", "nn"],
  "narrow": ["n-eh1 r-ow", "jj vb"],
  "narrower": ["n-eh1 r-ow er", "jjr"],
  "narrowest": ["n-eh1 r-ow ah-s-t", "jjs"],
  "narrowly": ["n-eh1 r-ow l-iy", "rb"],
  "narrowness": ["n-eh1 r-ow n-ah-s", "nn"],
  "nasal": ["n-ey1 z-ah-l", "jj"],
  "nascent": ["n-ey1 s-ah-n-t", "jj"],
  "nastier": ["n-ae1 s-t-iy er", "jjr"],
  "nastiest": ["n-ae1 s-t-iy ah-s-t", "jjs"],
  "nasty": ["n-ae1 s-t-iy", "jj"],
  "natal": ["n-ey1 t-ah-l", "jj"],
  "nation": ["n-ey1 sh-ah-n", "nn"],
  "national": ["n-ae1 sh-ah n-ah-l", "jj nn rb"],
  "nationalism": ["n-ae1 sh-ah-n ah l-ih z-ah-m", "nn"],
  "nationalist": ["n-ae1 sh-ah-n ah l-ah-s-t", "jj nn"],
  "nationalistic": ["n-ae sh-ah-n ah l-ih1 s-t-ih-k", "jj"],
  "nationality": ["n-ae sh-ah n-ae1 l-ah t-iy", "nn"],
  "nationalization": ["n-ae sh-ah-n ah l-ah z-ey1 sh-ah-n", "nn"],
  "nationalize": ["n-ae1 sh-ah-n ah l-ay-z", "vb"],
  "nationalized": ["n-ae1 sh-ah-n ah l-ay-z-d", "vbd vbn jj"],
  "nationally": ["n-ae1 sh-ah-n ah l-iy", "rb"],
  "nationhood": ["n-ey1 sh-ah-n hh-uh-d", "nn"],
  "nationwide": ["n-ey1 sh-ah-n w-ay1-d", "jj rb"],
  "native": ["n-ey1 t-ih-v", "jj nn"],
  "nattily": ["n-ae1 t-ah l-iy", "rb"],
  "natty": ["n-ae1 t-iy", "jj"],
  "natural": ["n-ae1 ch-er ah-l", "jj nn"],
  "naturalism": ["n-ae1 ch-er ah l-ih z-ah-m", "nn"],
  "naturalist": ["n-ae1 ch-er ah l-ah-s-t", "nn"],
  "naturalistic": ["n-ae ch-er ah l-ih1 s-t-ih-k", "jj"],
  "naturalize": ["n-ae1-ch-er-ah-l-ay-z", "vb"],
  "naturalized": ["n-ae1 ch-er ah l-ay-z-d", "vbn jj"],
  "naturally": ["n-ae1 ch-er ah l-iy", "rb"],
  "nature": ["n-ey1 ch-er", "nn jj"],
  "natured": ["n-ey1 ch-er-d", "jj"],
  "naught": ["n-ao1-t", "nn"],
  "naughty": ["n-ao1 t-iy", "jj"],
  "nausea": ["n-ao1 z-iy ah", "nn"],
  "nauseate": ["n-ao1-z-iy-ey-t", "vb"],
  "nauseated": ["n-ao1 z-iy ey t-ah-d", "vbn jj"],
  "nautical": ["n-ao1 t-ah k-ah-l", "jj"],
  "naval": ["n-ey1 v-ah-l", "jj"],
  "navel": ["n-ey1 v-ah-l", "nn"],
  "navigable": ["n-ae1 v-ah g-ah b-ah-l", "jj"],
  "navigate": ["n-ae1 v-ah g-ey-t", "vb"],
  "navigation": ["n-ae1 v-ah g-ey1 sh-ah-n", "nn"],
  "navigational": ["n-ae v-ah g-ey1 sh-ah n-ah-l", "jj"],
  "navigator": ["n-ae1 v-ah g-ey t-er", "nn"],
  "navy": ["n-ey1 v-iy", "nn jj"],
  "nay": ["n-ey1", "rb"],
  "naysayer": ["n-ey s-ey1 er", "nn"],
  "near": ["n-ih1-r", "in rb vb jj"],
  "nearby": ["n-ih1-r b-ay1", "jj rb"],
  "nearer": ["n-ih1 r-er", "jjr in rbr"],
  "nearest": ["n-ih1 r-ah-s-t", "jjs rbs in"],
  "nearly": ["n-ih1-r l-iy", "rb"],
  "nearsighted": ["n-iy1-r s-ay t-ih-d", "jj"],
  "neat": ["n-iy1-t", "jj"],
  "neater": ["n-iy1 t-er", "rbr"],
  "neatest": ["n-iy1 t-ah-s-t", "jjs"],
  "neatly": ["n-iy1-t l-iy", "rb"],
  "neatness": ["n-iy1-t n-ah-s", "nn"],
  "nebula": ["n-eh1 b-y-ah l-ah", "nn"],
  "nebulous": ["n-eh1 b-y-ah l-ah-s", "jj"],
  "necessarily": ["n-eh s-ah s-eh1 r-ah l-iy", "rb"],
  "necessary": ["n-eh1 s-ah s-eh r-iy", "jj"],
  "necessitate": ["n-ah s-eh1 s-ah t-ey-t", "vbp vb"],
  "necessity": ["n-ah s-eh1 s-ah t-iy", "nn"],
  "neck": ["n-eh1-k", "nn rb vb"],
  "necklace": ["n-eh1-k l-ah-s", "nn"],
  "necktie": ["n-eh1-k t-ay", "nn"],
  "necrosis": ["n-ah k-r-ow1 s-ah-s", "nn"],
  "nectar": ["n-eh1-k t-er", "nn"],
  "need": ["n-iy1-d", "nn vbp md vb"],
  "needed": ["n-iy1 d-ah-d", "vbn jj vbd"],
  "needle": ["n-iy1 d-ah-l", "nn vb"],
  "needlelike": ["n-iy1 d-ah-l l-ay-k", "jj"],
  "needless": ["n-iy1-d l-ah-s", "jj"],
  "needlessly": ["n-iy1-d l-ah-s l-iy", "rb"],
  "needy": ["n-iy1 d-iy", "jj"],
  "negate": ["n-ih g-ey1-t", "vb"],
  "negative": ["n-eh1 g-ah t-ih-v", "jj nn"],
  "negatively": ["n-eh1 g-ah t-ih-v l-iy", "rb"],
  "negativism": ["n-eh1 g-ah t-ih v-ih z-ah-m", "nn"],
  "neglect": ["n-ah g-l-eh1-k-t", "nn vb vbp"],
  "neglected": ["n-ah g-l-eh1-k t-ah-d", "vbn jj vbd"],
  "negligence": ["n-eh1-g l-ah jh-ah-n-s", "nn"],
  "negligent": ["n-eh1-g l-ah jh-ah-n-t", "jj"],
  "negligently": ["n-eh1-g l-ih jh-ah-n-t l-iy", "rb"],
  "negligible": ["n-eh1-g l-ah jh-ah b-ah-l", "jj"],
  "negotiable": ["n-ah g-ow1 sh-ah b-ah-l", "jj"],
  "negotiate": ["n-ah g-ow1 sh-iy ey-t", "vb vbp"],
  "negotiated": ["n-ah g-ow1 sh-iy ey t-ah-d", "vbn jj vbd"],
  "negotiating": ["n-ih g-ow1 sh-iy ey t-ih-ng", "vbg jj nn"],
  "negotiation": ["n-ih g-ow sh-iy ey1 sh-ah-n", "nn"],
  "negotiator": ["n-ah g-ow1 sh-iy ey t-er", "nn"],
  "neighbor": ["n-ey1 b-er", "nn vb"],
  "neighborhood": ["n-ey1 b-er hh-uh-d", "nn"],
  "neighboring": ["n-ey1 b-er ih-ng", "vbg jj"],
  "neighborly": ["n-ey1 b-er l-iy", "jj"],
  "neither": ["n-iy1 dh-er", "dt nn rb cc"],
  "nemesis": ["n-eh1 m-ah s-ih-s", "nn"],
  "neoclassical": ["n-iy ow k-l-ae1 s-ih k-ah-l", "jj"],
  "neoconservative": ["n-iy ow k-ah-n s-er1 v-ah t-ih-v", "jj"],
  "neoliberal": ["n-iy ow l-ih1 b-er ah-l", "jj"],
  "neon": ["n-iy1 aa-n", "nn"],
  "neonatal": ["n-iy ow n-ey1 t-ah-l", "jj"],
  "neophyte": ["n-iy1 ah f-ay-t", "jj nn"],
  "nephew": ["n-eh1 f-y-uw", "nn"],
  "nepotism": ["n-eh1 p-ah t-ih z-ah-m", "nn"],
  "nerd": ["n-er1-d", "nn"],
  "nerdy": ["n-er1 d-iy", "jj"],
  "nerve": ["n-er1-v", "nn"],
  "nervous": ["n-er1 v-ah-s", "jj"],
  "nervously": ["n-er1 v-ah-s l-iy", "rb"],
  "nervousness": ["n-er1 v-ah-s n-ah-s", "nn"],
  "nervy": ["n-er1 v-iy", "jj"],
  "nest": ["n-eh1-s-t", "nn vb vbp"],
  "nester": ["n-eh1 s-t-er", "nn"],
  "nesting": ["n-eh1 s-t-ih-ng", "vbg jj nn"],
  "nestle": ["n-eh1-s-ah-l", "vb"],
  "nestling": ["n-eh1-s-t l-ih-ng", "nn"],
  "net": ["n-eh1-t", "jj nn vb"],
  "nether": ["n-eh1 dh-er", "jj cc"],
  "nettle": ["n-eh1-t-ah-l", "vb"],
  "nettlesome": ["n-eh1 t-ah-l s-ah-m", "jj"],
  "network": ["n-eh1-t w-er-k", "nn vb"],
  "neural": ["n-uh1 r-ah-l", "jj"],
  "neurological": ["n-uh r-ah l-aa1 jh-ih k-ah-l", "jj"],
  "neurologist": ["n-uh r-aa1 l-ah jh-ah-s-t", "nn"],
  "neuropathy": ["n-uh1 r-ow p-ae th-iy", "nn"],
  "neurosurgeon": ["n-uh1 r-ow s-er jh-ah-n", "nn"],
  "neurotic": ["n-uh r-aa1 t-ih-k", "jj"],
  "neuter": ["n-uw1 t-er", "nn vb"],
  "neutral": ["n-uw1 t-r-ah-l", "jj"],
  "neutrality": ["n-uw t-r-ae1 l-ah t-iy", "nn"],
  "neutralization": ["n-uw t-r-ah l-ah z-ey1 sh-ah-n", "nn"],
  "neutralize": ["n-uw1 t-r-ah l-ay-z", "vb"],
  "neutrino": ["n-uw t-r-iy1 n-ow", "nn"],
  "neutron": ["n-uw1 t-r-aa-n", "nn"],
  "never": ["n-eh1 v-er", "rb rbr"],
  "nevertheless": ["n-eh v-er dh-ah l-eh1-s", "rb"],
  "new": ["n-uw1", "jj"],
  "newborn": ["n-uw1 b-ao-r-n", "jj"],
  "newcomer": ["n-uw1 k-ah m-er", "nn"],
  "newer": ["n-uw1 er", "jjr"],
  "newest": ["n-uw1 ah-s-t", "jjs jj"],
  "newfangled": ["n-uw f-ae1-ng g-ah-l-d", "jj"],
  "newfound": ["n-uw1 f-aw1-n-d", "jj"],
  "newly": ["n-uw1 l-iy", "rb jj"],
  "newlywed": ["n-uw1 l-iy w-eh-d", "nn"],
  "news": ["n-uw1-z", "nn"],
  "newscast": ["n-uw1-z k-ae-s-t", "nn"],
  "newscaster": ["n-uw1-z k-ae s-t-er", "nn"],
  "newsletter": ["n-uw1-z l-eh t-er", "nn"],
  "newsmaker": ["n-uw1-z m-ey k-er", "nn"],
  "newsman": ["n-uw1-z m-ae-n", "nn"],
  "newspaper": ["n-uw1-z p-ey p-er", "nn"],
  "newspaperman": ["n-uw1-z p-ey p-er m-ae-n", "nn"],
  "newsprint": ["n-uw1-z p-r-ih-n-t", "nn"],
  "newsreel": ["n-uw1-z r-iy-l", "nn"],
  "newsroom": ["n-uw1-z r-uw-m", "nn"],
  "newsstand": ["n-uw1-z s-t-ae-n-d", "nn"],
  "newsweekly": ["n-uw1-z w-iy-k l-iy", "rb"],
  "newswire": ["n-uw1-z w-ay-r", "nn"],
  "newsworthy": ["n-uw1-z w-er dh-iy", "jj"],
  "newt": ["n-uw1-t", "nn"],
  "next": ["n-eh1-k-s-t", "jj in rb"],
  "nexus": ["n-eh1-k s-ah-s", "nn"],
  "nib": ["n-ih1-b", "nn"],
  "nibble": ["n-ih1 b-ah-l", "vb nn"],
  "nice": ["n-ay1-s", "jj"],
  "nicely": ["n-ay1-s l-iy", "rb"],
  "nicer": ["n-ay1 s-er", "jjr"],
  "nicest": ["n-ay1 s-ih-s-t", "jjs"],
  "nicety": ["n-ay1 s-ih t-iy", "nn"],
  "niche": ["n-ih1-ch", "nn"],
  "nick": ["n-ih1-k", "vb"],
  "nickel": ["n-ih1 k-ah-l", "nn jj"],
  "nickname": ["n-ih1-k n-ey-m", "nn vb vbp"],
  "nicotine": ["n-ih1 k-ah t-iy-n", "nn"],
  "niece": ["n-iy1-s", "nn"],
  "nifty": ["n-ih1-f t-iy", "jj"],
  "niggardly": ["n-ih1 g-er-d l-iy", "jj"],
  "night": ["n-ay1-t", "nn rb"],
  "nightclub": ["n-ay1-t k-l-ah-b", "nn"],
  "nighter": ["n-ay1 t-er", "nn"],
  "nightfall": ["n-ay1-t f-ao-l", "nn"],
  "nightingale": ["n-ay1 t-ih-ng g-ey-l", "nn"],
  "nightly": ["n-ay1-t l-iy", "jj rb"],
  "nightmare": ["n-ay1-t m-eh-r", "nn"],
  "nightmarish": ["n-ay1-t m-eh r-ih-sh", "jj"],
  "nightshirt": ["n-ay1 ch-er-t", "nn"],
  "nighttime": ["n-ay1-t t-ay-m", "jj nn"],
  "nihilism": ["n-ay1 ah l-ih z-ah-m", "nn"],
  "nilly": ["n-ih1 l-iy", "rb"],
  "nimble": ["n-ih1-m b-ah-l", "jj"],
  "nimbly": ["n-ih1-m b-l-iy", "rb"],
  "nine": ["n-ih1-n", "cd"],
  "ninefold": ["n-ih1-n f-ow-l-d", "jj rb"],
  "ninety": ["n-ay1-n t-iy", "nn"],
  "ninth": ["n-ay1-n-th", "jj"],
  "nip": ["n-ih1-p", "vb"],
  "nirvana": ["n-ih-r v-aa1 n-ah", "nn"],
  "nitpicking": ["n-ih1-t p-ih k-ih-ng", "jj"],
  "nitrate": ["n-ay1 t-r-ey-t", "nn"],
  "nitrogen": ["n-ay1 t-r-ah jh-ah-n", "nn"],
  "nitrous": ["n-ih1 t-r-ah-s", "nn"],
  "nix": ["n-ih1-k-s", "vb"],
  "no": ["n-ow1", "dt jj nn rb uh"],
  "nobility": ["n-ow b-ih1 l-ah t-iy", "nn"],
  "noble": ["n-ow1 b-ah-l", "jj"],
  "nobleman": ["n-ow1 b-ah-l m-ah-n", "nn"],
  "nobly": ["n-aa1 b-l-iy", "rb"],
  "nobody": ["n-ow1 b-aa d-iy", "nn"],
  "nocturnal": ["n-aa-k t-er1 n-ah-l", "jj"],
  "nod": ["n-aa1-d", "nn vb vbp"],
  "nodding": ["n-aa1 d-ih-ng", "vbg jj"],
  "node": ["n-ow1-d", "nn"],
  "nodular": ["n-aa1 jh-ah l-er", "jj"],
  "nodule": ["n-aa1 jh-uw-l", "nn"],
  "noise": ["n-oy1-z", "nn"],
  "noisier": ["n-oy1 z-iy er", "jjr"],
  "noisily": ["n-oy1 z-ah l-iy", "rb"],
  "noisy": ["n-oy1 z-iy", "jj"],
  "nomad": ["n-ow1 m-ae-d", "nn"],
  "nomadic": ["n-ow m-ae1 d-ih-k", "jj"],
  "nomenclature": ["n-ow1 m-ah-n k-l-ey ch-er", "nn"],
  "nominal": ["n-aa1 m-ah n-ah-l", "jj nn"],
  "nominally": ["n-aa1 m-ah n-ah l-iy", "rb"],
  "nominate": ["n-aa1 m-ah n-ah-t", "vb vbp"],
  "nomination": ["n-aa m-ah n-ey1 sh-ah-n", "nn"],
  "nominee": ["n-aa m-ah n-iy1", "nn"],
  "nonbinding": ["n-aa1-n b-ay1-n d-ih-ng", "jj"],
  "nonchalant": ["n-aa-n sh-ah l-aa1-n-t", "jj"],
  "noncombatant": ["n-aa-n k-ah-m b-ae1 t-ah-n-t", "jj"],
  "noncommittal": ["n-aa1-n k-ah m-ih1 t-ah-l", "jj"],
  "noncompliance": ["n-aa-n k-ah-m p-l-ay1 ah-n-s", "nn"],
  "nonconformist": ["n-aa-n k-ah-n f-ao1-r m-ih-s-t", "nn"],
  "nondescript": ["n-aa1-n d-ih s-k-r-ih1-p-t", "jj"],
  "nondurable": ["n-aa-n d-uh1 r-ah b-ah-l", "jj"],
  "none": ["n-ah1-n", "nn"],
  "nonentity": ["n-aa-n eh1-n t-ah t-iy", "nn"],
  "nonessential": ["n-aa-n ih s-eh1-n ch-ah-l", "jj"],
  "nonetheless": ["n-ah-n dh-ah l-eh1-s", "rb"],
  "nonevent": ["n-aa1-n ih v-eh1-n-t", "nn"],
  "nonexistent": ["n-aa-n ah-g z-ih1 s-t-ah-n-t", "jj"],
  "nonfat": ["n-aa1-n f-ae1-t", "jj"],
  "nonferrous": ["n-aa-n f-eh1 r-ah-s", "jj"],
  "nonfiction": ["n-aa-n f-ih1-k sh-ah-n", "nn"],
  "nonlethal": ["n-aa-n l-iy1 th-ah-l", "jj"],
  "nonmember": ["n-aa-n m-eh1-m b-er", "nn"],
  "nonpartisan": ["n-aa-n p-aa1-r t-ah z-ah-n", "jj"],
  "nonpaying": ["n-aa-n p-ey1 ih-ng", "jj"],
  "nonpayment": ["n-aa-n p-ey1 m-ah-n-t", "nn"],
  "nonpoisonous": ["n-aa-n p-oy1 z-ah n-ah-s", "jj"],
  "nonproductive": ["n-aa-n p-r-ah d-ah1-k t-ih-v", "jj"],
  "nonprofit": ["n-aa-n p-r-aa1 f-ah-t", "nn jj"],
  "nonrecurring": ["n-aa-n r-ih k-er1 ih-ng", "jj"],
  "nonsense": ["n-aa1-n s-eh-n-s", "nn jj"],
  "nonsensical": ["n-aa-n s-eh1-n s-ih k-ah-l", "jj"],
  "nonsmoker": ["n-aa-n s-m-ow1 k-er", "nn"],
  "nonspecific": ["n-aa-n s-p-ah s-ih1 f-ih-k", "jj"],
  "nonstandard": ["n-aa-n s-t-ae1-n d-er-d", "jj"],
  "nonstop": ["n-aa-n s-t-aa1-p", "jj nn rb"],
  "nontoxic": ["n-aa-n t-aa1-k s-ih-k", "jj"],
  "nonviolence": ["n-aa-n v-ay1 ah l-ah-n-s", "nn"],
  "nonviolent": ["n-aa-n v-ay1 ah l-ah-n-t", "jj"],
  "nonvoting": ["n-aa-n v-ow1 t-ih-ng", "jj"],
  "noodle": ["n-uw1 d-ah-l", "nn"],
  "nook": ["n-uh1-k", "nn"],
  "noon": ["n-uw1-n", "nn"],
  "noose": ["n-uw1-s", "nn"],
  "norm": ["n-ao1-r-m", "nn"],
  "normal": ["n-ao1-r m-ah-l", "jj rb"],
  "normalcy": ["n-ao1-r m-ah-l s-iy", "nn"],
  "normalization": ["n-ao-r m-ah l-ih z-ey1 sh-ah-n", "nn"],
  "normalize": ["n-ao1-r m-ah l-ay-z", "vb"],
  "normally": ["n-ao1-r m-ah l-iy", "rb"],
  "normative": ["n-ao1-r m-ah t-ih-v", "jj"],
  "north": ["n-ao1-r-th", "rb jj nn"],
  "northeast": ["n-ao-r-th iy1-s-t", "nn jj rb"],
  "northeastern": ["n-ao-r-th iy1 s-t-er-n", "jj"],
  "northerly": ["n-ao1-r dh-er l-iy", "jj"],
  "northern": ["n-ao1-r dh-er-n", "jj"],
  "northerner": ["n-ao1-r dh-er n-er", "nn"],
  "northernmost": ["n-ao1-r dh-er-n m-ow-s-t", "jj"],
  "northward": ["n-ao1-r-th w-er-d", "rb"],
  "northwest": ["n-ao-r-th w-eh1-s-t", "rb nn jjs jj"],
  "northwestern": ["n-ao-r-th w-eh1 s-t-er-n", "jj"],
  "nose": ["n-ow1-z", "nn vb"],
  "nosebleed": ["n-ow1-z b-l-iy-d", "nn"],
  "nosedive": ["n-ow1-z d-ay-v", "nn jj vb"],
  "nostalgia": ["n-ao s-t-ae1-l jh-ah", "nn"],
  "nostalgic": ["n-ao s-t-ae1-l jh-ih-k", "jj"],
  "nostril": ["n-aa1-s t-r-ah-l", "nn"],
  "nostrum": ["n-aa1-s t-r-ah-m", "nn"],
  "nosy": ["n-ow1 z-iy", "jj"],
  "not": ["n-aa1-t", "rb"],
  "notable": ["n-ow1 t-ah b-ah-l", "jj"],
  "notably": ["n-ow1 t-ah b-l-iy", "rb"],
  "notation": ["n-ow t-ey1 sh-ah-n", "nn"],
  "notch": ["n-aa1-ch", "nn vb"],
  "note": ["n-ow1-t", "nn vbp vb"],
  "notebook": ["n-ow1-t b-uh-k", "nn"],
  "noted": ["n-ow1 t-ah-d", "vbd jj vbn"],
  "noteholder": ["n-ow1-t hh-ow-l d-er", "nn"],
  "noteworthy": ["n-ow1-t w-er dh-iy", "jj"],
  "nothing": ["n-ah1 th-ih-ng", "nn"],
  "nothingness": ["n-ah1 th-ih-ng n-ah-s", "nn"],
  "notice": ["n-ow1 t-ah-s", "nn vb vbp"],
  "noticeable": ["n-ow1 t-ah s-ah b-ah-l", "jj"],
  "noticeably": ["n-ow1 t-ih s-ah b-l-iy", "rb"],
  "noticed": ["n-ow1 t-ah-s-t", "vbd vbn jj"],
  "notification": ["n-ow t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "notify": ["n-ow1 t-ah f-ay", "vb vbp"],
  "notion": ["n-ow1 sh-ah-n", "nn"],
  "notoriety": ["n-ow t-er ay1 ah t-iy", "nn"],
  "notorious": ["n-ow t-ao1 r-iy ah-s", "jj"],
  "notoriously": ["n-ow t-ao1 r-iy ah-s l-iy", "rb"],
  "noun": ["n-aw1-n", "nn"],
  "nourish": ["n-er1 ih-sh", "vb"],
  "nourished": ["n-er1 ih-sh-t", "vbn jj"],
  "nourishment": ["n-er1 ih-sh m-ah-n-t", "nn"],
  "novel": ["n-aa1 v-ah-l", "nn jj"],
  "novelist": ["n-aa1 v-ah l-ah-s-t", "nn"],
  "novelistic": ["n-aa v-ah l-ih1 s-t-ih-k", "jj"],
  "novelty": ["n-aa1 v-ah-l t-iy", "nn"],
  "novice": ["n-aa1 v-ah-s", "nn jj"],
  "now": ["n-aw1", "rb jj nn uh"],
  "nowadays": ["n-aw1 ah d-ey-z", "rb"],
  "nowhere": ["n-ow1 w-eh-r", "rb nn"],
  "noxious": ["n-aa1-k sh-ah-s", "jj"],
  "nozzle": ["n-aa1 z-ah-l", "nn"],
  "nuance": ["n-uw1 aa-n-s", "nn"],
  "nuclear": ["n-uw1-k l-iy er", "jj"],
  "nucleus": ["n-uw1 k-l-iy ah-s", "nn"],
  "nude": ["n-uw1-d", "jj nn"],
  "nudge": ["n-ah1-jh", "vb nn"],
  "nudist": ["n-uw1 d-ih-s-t", "jj"],
  "nudity": ["n-uw1 d-ih t-iy", "nn"],
  "nugget": ["n-ah1 g-ih-t", "nn"],
  "nuisance": ["n-uw1 s-ah-n-s", "nn jj"],
  "nuke": ["n-uw1-k", "nn vb"],
  "null": ["n-ah1-l", "jj"],
  "nullified": ["n-ah1 l-ah f-ay-d", "vbn vbd"],
  "nullify": ["n-ah1 l-ah f-ay", "vb vbp"],
  "numb": ["n-ah1-m", "jj vb"],
  "number": ["n-ah1-m b-er", "nn vb vbp"],
  "numbing": ["n-ah1 m-ih-ng", "jj"],
  "numbingly": ["n-ah1 m-ih-ng l-iy", "rb"],
  "numbness": ["n-ah1-m n-ah-s", "nn"],
  "numeral": ["n-uw1 m-er ah-l", "nn"],
  "numerical": ["n-uw m-eh1 r-ah k-ah-l", "jj"],
  "numerically": ["n-uw m-eh1 r-ih-k l-iy", "rb"],
  "numerous": ["n-uw1 m-er ah-s", "jj"],
  "nun": ["n-ah1-n", "nn"],
  "nurse": ["n-er1-s", "nn vb"],
  "nursery": ["n-er1 s-er iy", "nn"],
  "nurture": ["n-er1 ch-er", "vb nn"],
  "nurturer": ["n-er1 t-er er", "nn"],
  "nut": ["n-ah1-t", "nn"],
  "nutmeg": ["n-ah1-t m-eh-g", "nn"],
  "nutrient": ["n-uw1 t-r-iy ah-n-t", "jj"],
  "nutrition": ["n-uw t-r-ih1 sh-ah-n", "nn"],
  "nutritional": ["n-uw t-r-ih1 sh-ah n-ah-l", "jj"],
  "nutritionist": ["n-uw t-r-ih1 sh-ah n-ih-s-t", "nn"],
  "nutritious": ["n-uw t-r-ih1 sh-ah-s", "jj"],
  "nutritive": ["n-uw1 t-r-ah t-ih-v", "jj"],
  "nutshell": ["n-ah1 ch-eh-l", "nn"],
  "nutty": ["n-ah1 t-iy", "jj"],
  "nyet": ["n-y-eh1-t", "uh"],
  "nylon": ["n-ay1 l-aa-n", "nn"],
  "nymph": ["n-ih1-m-f", "nn"],
  "nymphomaniac": ["n-ih-m f-ah m-ey1 n-iy ae-k", "nn jj"],
  "oak": ["ow1-k", "nn"],
  "oasis": ["ow ey1 s-ih-s", "nn"],
  "oat": ["ow1-t", "nn"],
  "oath": ["ow1-th", "nn"],
  "oatmeal": ["ow1-t m-iy-l", "nn"],
  "obedience": ["ow b-iy1 d-iy ah-n-s", "nn"],
  "obedient": ["ow b-iy1 d-iy ah-n-t", "jj"],
  "obediently": ["ow b-iy1 d-iy ah-n-t l-iy", "rb"],
  "obese": ["ow b-iy1-s", "jj"],
  "obesity": ["ow b-iy1 s-ah t-iy", "nn"],
  "obey": ["ow b-ey1", "vb vbp"],
  "obfuscate": ["aa1-b f-ah-s k-ey-t", "vb"],
  "obfuscation": ["aa-b f-ah s-k-ey1 sh-ah-n", "nn"],
  "obituary": ["ow b-ih1 ch-uw eh r-iy", "nn"],
  "object": ["aa1-b jh-eh-k-t", "nn vbp vb"],
  "objection": ["ah-b jh-eh1-k sh-ah-n", "nn"],
  "objectionable": ["ah-b jh-eh1-k sh-ah-n ah b-ah-l", "jj"],
  "objective": ["ah-b jh-eh1-k t-ih-v", "nn jj"],
  "objectively": ["aa-b jh-eh1-k t-ih-v l-iy", "rb"],
  "objectivity": ["aa-b jh-eh-k t-ih1 v-ih t-iy", "nn"],
  "objector": ["ah-b jh-eh1-k t-er", "nn"],
  "obligate": ["aa1-b-l-ah-g-ey-t", "vb"],
  "obligated": ["aa1 b-l-ah g-ey t-ih-d", "vbn vbd jj"],
  "obligation": ["aa b-l-ah g-ey1 sh-ah-n", "nn"],
  "obligatory": ["ah b-l-ih1 g-ah t-ao r-iy", "jj"],
  "oblige": ["ah b-l-ay1-jh", "vb nn"],
  "obliged": ["ah b-l-ay1-jh-d", "vbn jj vbd"],
  "obliging": ["ah b-l-ay1 jh-ih-ng", "jj"],
  "obligingly": ["ah b-l-ay1 jh-ih-ng l-iy", "rb"],
  "oblique": ["ah b-l-iy1-k", "jj"],
  "obliquely": ["ow b-l-iy1 k-l-iy", "rb"],
  "obliterate": ["ah b-l-ih1 t-er ey-t", "vb"],
  "oblivion": ["ah b-l-ih1 v-iy ah-n", "nn"],
  "oblivious": ["ah b-l-ih1 v-iy ah-s", "jj"],
  "oblong": ["aa1 b-l-ao-ng", "jj"],
  "obnoxious": ["aa-b n-aa1-k sh-ah-s", "jj"],
  "oboist": ["ow1 b-ow ah-s-t", "nn"],
  "obscene": ["aa-b s-iy1-n", "jj"],
  "obscenity": ["ah-b s-eh1 n-ih t-iy", "nn"],
  "obscure": ["ah-b s-k-y-uh1-r", "jj vb"],
  "obscured": ["ah-b s-k-y-uh1-r-d", "vbn jj vbd"],
  "obscurity": ["ah-b s-k-y-uh1 r-ah t-iy", "nn"],
  "obsequious": ["ah-b s-iy1 k-w-iy ah-s", "jj"],
  "observable": ["ah-b z-er1 v-ah b-ah-l", "jj"],
  "observance": ["ah-b z-er1 v-ah-n-s", "nn"],
  "observant": ["ah-b z-er1 v-ah-n-t", "jj"],
  "observation": ["aa-b z-er v-ey1 sh-ah-n", "nn"],
  "observatory": ["ah-b z-er1 v-ah t-ao r-iy", "nn"],
  "observe": ["ah-b z-er1-v", "vb vbp"],
  "observed": ["ah-b z-er1-v-d", "vbn jj vbd"],
  "observer": ["ah-b z-er1 v-er", "nn"],
  "obsess": ["ah-b-s-eh1-s", "vb"],
  "obsessed": ["ah-b s-eh1-s-t", "vbn jj"],
  "obsession": ["ah-b s-eh1 sh-ah-n", "nn"],
  "obsessive": ["ah-b s-eh1 s-ih-v", "jj nn"],
  "obsessively": ["aa-b s-eh1 s-ih-v l-iy", "rb"],
  "obsidian": ["ah-b s-ih1 d-iy ah-n", "nn"],
  "obsolescent": ["aa-b s-ah l-eh1 s-ah-n-t", "jj"],
  "obsolete": ["aa1-b s-ah l-iy-t", "jj"],
  "obstacle": ["aa1-b s-t-ah k-ah-l", "nn"],
  "obstetrician": ["aa-b s-t-ah t-r-ih1 sh-ah-n", "nn"],
  "obstinacy": ["aa1-b s-t-ah n-ah s-iy", "nn"],
  "obstinate": ["aa1-b s-t-ah n-ah-t", "jj"],
  "obstruct": ["ah-b s-t-r-ah1-k-t", "vb vbp"],
  "obstruction": ["ah-b s-t-r-ah1-k sh-ah-n", "nn"],
  "obstructive": ["ah-b s-t-r-ah1-k t-ih-v", "jj"],
  "obtain": ["ah-b t-ey1-n", "vb vbp"],
  "obtainable": ["ah-b t-ey1 n-ah b-ah-l", "jj"],
  "obtrude": ["ah-b-t-r-uw1-d", "vb"],
  "obtuse": ["aa-b t-uw1-s", "jj"],
  "obverse": ["ah-b v-er1-s", "nn"],
  "obviate": ["aa1-b v-iy ey-t", "vb"],
  "obvious": ["aa1-b v-iy ah-s", "jj"],
  "obviously": ["aa1-b v-iy ah-s l-iy", "rb"],
  "occasion": ["ah k-ey1 zh-ah-n", "nn vb"],
  "occasional": ["ah k-ey1 zh-ah n-ah-l", "jj"],
  "occasionally": ["ah k-ey1 zh-ah-n ah l-iy", "rb"],
  "occidental": ["aa-k s-ah d-eh1-n t-ah-l", "jj"],
  "occipital": ["aa-k s-ih1 p-ah t-ah-l", "jj"],
  "occlusion": ["ah k-l-uw1 zh-ah-n", "nn"],
  "occupancy": ["aa1 k-y-ah p-ah-n s-iy", "nn"],
  "occupant": ["aa1 k-y-ah p-ah-n-t", "nn"],
  "occupation": ["aa k-y-ah p-ey1 sh-ah-n", "nn"],
  "occupational": ["aa k-y-ah p-ey1 sh-ah n-ah-l", "jj"],
  "occupied": ["aa1 k-y-ah p-ay-d", "vbn jj vbd"],
  "occupy": ["aa1 k-y-ah p-ay", "vb vbp"],
  "occupying": ["aa1 k-y-ah p-ay ih-ng", "vbg jj"],
  "occur": ["ah k-er1", "vb vbp"],
  "occurrence": ["ah k-er1 ah-n-s", "nn"],
  "ocean": ["ow1 sh-ah-n", "nn"],
  "oceanfront": ["ow sh-ah-n f-r-ah-n-t", "jj nn"],
  "oceanographic": ["ow sh-ah-n ah g-r-ae1 f-ih-k", "jj"],
  "oceanography": ["ow sh-ah n-aa1 g-r-ah f-iy", "nn"],
  "ocelot": ["aa1 s-ah l-aa-t", "nn"],
  "ochre": ["ow1 k-er", "jj nn"],
  "octagonal": ["aa-k t-ae1 g-ah n-ah-l", "jj"],
  "octane": ["aa1-k t-ey-n", "nn"],
  "octave": ["aa1-k t-ih-v", "jj"],
  "octogenarian": ["aa-k t-ah jh-ih n-eh1 r-iy ah-n", "jj"],
  "octopus": ["aa1-k t-ah p-uh-s", "nn"],
  "odd": ["aa1-d", "jj"],
  "oddball": ["aa1-d b-ao-l", "jj"],
  "oddest": ["aa1 d-ah-s-t", "jjs"],
  "oddity": ["aa1 d-ah t-iy", "nn"],
  "oddly": ["aa1-d l-iy", "rb"],
  "ode": ["ow1-d", "nn"],
  "odious": ["ow1 d-iy ah-s", "jj"],
  "odor": ["ow1 d-er", "nn"],
  "odyssey": ["aa1 d-ah s-iy", "nn"],
  "oedipal": ["eh1 d-ah p-ah-l", "jj"],
  "of": ["ah1-v", "in rb rp"],
  "off": ["ao1-f", "in rb jj nn rp"],
  "offbeat": ["ao1-f b-iy1-t", "jj"],
  "offend": ["ah f-eh1-n-d", "vb"],
  "offended": ["ah f-eh1-n d-ah-d", "vbn jj vbd"],
  "offender": ["ah f-eh1-n d-er", "nn"],
  "offense": ["ah f-eh1-n-s", "nn"],
  "offensive": ["ah f-eh1-n s-ih-v", "jj nn"],
  "offensively": ["ah f-eh1-n s-ih-v l-iy", "rb"],
  "offer": ["ao1 f-er", "nn vb vbp"],
  "offered": ["ao1 f-er-d", "vbn jj vbd"],
  "offering": ["ao1 f-er ih-ng", "nn vbg"],
  "offhand": ["ao1-f hh-ae1-n-d", "jj"],
  "offical": ["ao1 f-ih k-ah-l", "nn"],
  "office": ["ao1 f-ah-s", "nn"],
  "officeholder": ["ao1 f-ah-s hh-ow-l d-er", "nn"],
  "officer": ["ao1 f-ah s-er", "nn"],
  "official": ["ah f-ih1 sh-ah-l", "nn jj"],
  "officialdom": ["ah f-ih1 sh-ah-l d-ah-m", "nn"],
  "officially": ["ah f-ih1 sh-ah l-iy", "rb"],
  "officiate": ["ah f-ih1 sh-iy ey-t", "vb"],
  "offing": ["ao1 f-ih-ng", "nn"],
  "offset": ["ao-f s-eh1-t", "vb jj vbd vbn vbp"],
  "offsetting": ["ao-f s-eh1 t-ih-ng", "vbg jj"],
  "offshoot": ["ao1-f sh-uw-t", "nn"],
  "offshore": ["ao1-f sh-ao1-r", "jj rb"],
  "offspring": ["ao1-f s-p-r-ih-ng", "nn"],
  "offstage": ["ao1-f s-t-ey1-jh", "rb jj"],
  "oft": ["ao1-f-t", "rb"],
  "often": ["ao1 f-ah-n", "rb"],
  "oftener": ["ao1 f-ah-n er", "rbr"],
  "oftentimes": ["ao1 f-ah-n t-ay-m-z", "rb"],
  "ogle": ["ow1-g-ah-l", "vb"],
  "ogre": ["ow1 g-r-ah", "nn"],
  "ogress": ["ow1 g-r-ah-s", "nn"],
  "oh": ["ow1", "uh"],
  "oil": ["oy1-l", "nn"],
  "oiled": ["oy1-l-d", "jj"],
  "oiler": ["oy1 l-er", "nn"],
  "oilfield": ["oy1-l f-iy-l-d", "nn"],
  "oilman": ["oy1-l m-ae-n", "nn"],
  "oilseed": ["oy1-l s-iy-d", "nn"],
  "oily": ["oy1 l-iy", "jj"],
  "ointment": ["oy1-n-t m-ah-n-t", "nn"],
  "okay": ["ow1 k-ey1", "jj rb vb uh"],
  "old": ["ow1-l-d", "jj"],
  "olden": ["ow1-l d-ah-n", "jj"],
  "older": ["ow1-l d-er", "jjr rbr jj"],
  "oldest": ["ow1-l d-ah-s-t", "jjs"],
  "ole": ["ow1-l", "jj nn"],
  "olfactory": ["ow-l f-ae1-k t-er iy", "jj"],
  "oligarch": ["ow1 l-ih g-aa-r-k", "nn"],
  "oligopoly": ["aa l-ih g-aa1 p-ah l-iy", "nn"],
  "olive": ["aa1 l-ah-v", "jj nn"],
  "ombudsman": ["aa1-m b-ah-d-z m-ah-n", "nn"],
  "omelet": ["aa1-m l-ah-t", "nn"],
  "omen": ["ow1 m-ah-n", "nn"],
  "ominous": ["aa1 m-ah n-ah-s", "jj"],
  "ominously": ["aa1 m-ah n-ah-s l-iy", "rb"],
  "omission": ["ow m-ih1 sh-ah-n", "nn"],
  "omit": ["ow m-ih1-t", "vb vbp"],
  "omnibus": ["aa1-m n-ah b-ah-s", "jj nn"],
  "omnipotence": ["aa-m n-ih1 p-ah t-ah-n-s", "nn"],
  "omnipresence": ["aa-m n-ah p-r-eh1 z-ah-n-s", "nn"],
  "omnipresent": ["aa-m n-ih p-r-eh1 z-ah-n-t", "jj"],
  "omniscient": ["aa-m n-ih1 sh-ah-n-t", "jj"],
  "on": ["aa1-n", "in rbr jj rb rp"],
  "onboard": ["aa1-n b-ao-r-d", "nn"],
  "once": ["w-ah1-n-s", "rb in"],
  "oncologist": ["aa-ng k-aa1 l-ah jh-ih-s-t", "nn"],
  "oncology": ["aa-ng k-aa1 l-ah jh-iy", "nn"],
  "oncoming": ["ao1-n k-ah m-ih-ng", "jj"],
  "one": ["w-ah1-n", "cd"],
  "oneness": ["w-ah1-n n-ah-s", "nn"],
  "onerous": ["ow1 n-er ah-s", "jj"],
  "oneself": ["w-ah-n s-eh1-l-f", "prp"],
  "onetime": ["w-ah1-n t-ay1-m", "jj"],
  "oneyear": ["w-ah1-n y-ih1-r", "jj"],
  "ongoing": ["aa1-n g-ow ih-ng", "jj"],
  "onion": ["ah1 n-y-ah-n", "nn"],
  "online": ["ao1-n l-ay-n", "jj"],
  "onlooker": ["ao1-n l-uh k-er", "nn"],
  "only": ["ow1-n l-iy", "rb in jj"],
  "onrushing": ["aa1-n r-ah sh-ih-ng", "jj"],
  "onscreen": ["aa-n s-k-r-iy1-n", "rb"],
  "onset": ["aa1-n s-eh-t", "nn"],
  "onslaught": ["ao1-n s-l-ao-t", "nn"],
  "onstage": ["aa-n s-t-ey1-jh", "nn rb"],
  "onto": ["aa1-n t-uw", "in"],
  "ontological": ["aa-n t-ah l-aa1 jh-ih k-ah-l", "jj"],
  "onus": ["ow1 n-ah-s", "nn"],
  "onward": ["ao1-n w-er-d", "rb"],
  "onwards": ["aa1-n w-er-d-z", "rb"],
  "onyx": ["aa1 n-ih-k-s", "nn"],
  "oodles": ["uw1 d-ah-l-z", "nn"],
  "ooze": ["uw1-z", "nn vb"],
  "opaque": ["ow p-ey1-k", "jj"],
  "open": ["ow1 p-ah-n", "jj vbp nn rb rp vb"],
  "opener": ["ow1 p-ah-n er", "nn"],
  "opening": ["ow1 p-ah-n ih-ng", "nn vbg jj"],
  "openly": ["ow1 p-ah-n l-iy", "rb"],
  "openness": ["ow1 p-ah-n n-ah-s", "nn"],
  "opera": ["aa1 p-r-ah", "nn"],
  "operable": ["aa1 p-er ah b-ah-l", "jj"],
  "operate": ["aa1 p-er ey-t", "vb vbp"],
  "operated": ["aa1 p-er ey t-ah-d", "vbn vbd jj"],
  "operatic": ["aa p-er ae1 t-ih-k", "jj"],
  "operating": ["aa1 p-er ey t-ih-ng", "vbg jj nn"],
  "operation": ["aa p-er ey1 sh-ah-n", "nn"],
  "operational": ["aa p-er ey1 sh-ah n-ah-l", "jj"],
  "operationally": ["aa1 p-er ey1 sh-ah-n ah l-iy", "rb"],
  "operative": ["aa1 p-er ah t-ih-v", "jj nn"],
  "operator": ["aa1 p-er ey t-er", "nn"],
  "operetta": ["aa p-er eh1 t-ah", "nn"],
  "ophthalmologist": ["aa-p th-ah m-aa1 l-ah jh-ih-s-t", "nn"],
  "opine": ["ow-p-ay1-n", "vb"],
  "opinion": ["ah p-ih1 n-y-ah-n", "nn"],
  "opinionated": ["ah p-ih1 n-y-ah n-ey t-ih-d", "jj"],
  "opium": ["ow1 p-iy ah-m", "nn"],
  "opponent": ["ah p-ow1 n-ah-n-t", "nn"],
  "opportune": ["aa p-er t-uw1-n", "jj"],
  "opportunism": ["aa p-er t-uw1 n-ih z-ah-m", "nn"],
  "opportunist": ["aa p-er t-uw1 n-ih-s-t", "nn"],
  "opportunistic": ["aa p-er t-uw n-ih1 s-t-ih-k", "jj"],
  "opportunity": ["aa p-er t-uw1 n-ah t-iy", "nn"],
  "oppose": ["ah p-ow1-z", "vb vbp"],
  "opposed": ["ah p-ow1-z-d", "vbn jj vbd"],
  "opposing": ["ah p-ow1 z-ih-ng", "vbg jj"],
  "opposite": ["aa1 p-ah z-ah-t", "jj in nn"],
  "opposition": ["aa p-ah z-ih1 sh-ah-n", "nn"],
  "oppress": ["ah-p-r-eh1-s", "vb"],
  "oppressed": ["ah p-r-eh1-s-t", "jj vbd vbn"],
  "oppression": ["ah p-r-eh1 sh-ah-n", "nn"],
  "oppressive": ["ah p-r-eh1 s-ih-v", "jj"],
  "oppressor": ["ah p-r-eh1 s-er", "nn"],
  "opprobrium": ["ah p-r-ow1 b-r-iy ah-m", "nn"],
  "opt": ["aa1-p-t", "vb vbp"],
  "optic": ["aa1-p t-ih-k", "jj"],
  "optical": ["aa1-p t-ih k-ah-l", "jj"],
  "optically": ["aa1-p t-ih-k l-iy", "rb"],
  "optician": ["aa-p t-ih1 sh-ah-n", "nn"],
  "optimal": ["aa1-p t-ah m-ah-l", "jj"],
  "optimism": ["aa1-p t-ah m-ih z-ah-m", "nn"],
  "optimist": ["aa1-p t-ah m-ih-s-t", "nn"],
  "optimistic": ["aa-p t-ah m-ih1 s-t-ih-k", "jj"],
  "optimistically": ["aa-p t-ih m-ih1 s-t-ih k-ah l-iy", "rb"],
  "optimization": ["aa-p t-ah m-ah z-ey1 sh-ah-n", "nn"],
  "optimize": ["aa1-p t-ah m-ay-z", "vb"],
  "optimum": ["aa1-p t-ah m-ah-m", "jj nn"],
  "option": ["aa1-p sh-ah-n", "nn vb"],
  "optional": ["aa1-p sh-ah n-ah-l", "jj"],
  "opulence": ["aa1 p-y-ah l-ah-n-s", "nn"],
  "opulent": ["aa1 p-y-ah l-ah-n-t", "jj"],
  "opus": ["ow1 p-ah-s", "nn"],
  "or": ["ao1-r", "cc"],
  "oracle": ["ao1 r-ah k-ah-l", "nn"],
  "oral": ["ao1 r-ah-l", "jj"],
  "orally": ["ao1 r-ah l-iy", "rb"],
  "orange": ["ao1 r-ah-n-jh", "jj nn"],
  "oration": ["ao r-ey1 sh-ah-n", "nn"],
  "orator": ["ao1 r-ah t-er", "nn"],
  "oratorical": ["ao r-ah t-ao1 r-ah k-ah-l", "jj"],
  "oratorio": ["aa r-ah t-ao1 r-iy ow", "nn"],
  "oratory": ["ao1 r-ah t-ao r-iy", "nn"],
  "orb": ["ao1-r-b", "nn"],
  "orbit": ["ao1-r b-ah-t", "nn vb"],
  "orbital": ["ao1-r b-ah t-ah-l", "jj nn"],
  "orchard": ["ao1-r ch-er-d", "nn"],
  "orchestra": ["ao1-r k-ah-s t-r-ah", "nn"],
  "orchestral": ["ao-r k-eh1-s t-r-ah-l", "jj"],
  "orchestrate": ["ao1-r k-ih s-t-r-ey-t", "vb"],
  "orchestration": ["ao-r k-ah-s t-r-ey1 sh-ah-n", "nn"],
  "orchid": ["ao1-r k-ah-d", "nn"],
  "ordain": ["ao-r d-ey1-n", "vb"],
  "ordeal": ["ao-r d-iy1-l", "nn"],
  "order": ["ao1-r d-er", "nn vbp in vb"],
  "ordered": ["ao1-r d-er-d", "vbd vbn jj"],
  "orderliness": ["ao1-r d-er l-iy n-ah-s", "nn"],
  "orderly": ["ao1-r d-er l-iy", "jj nn rb"],
  "ordinance": ["ao1-r d-ah n-ah-n-s", "nn"],
  "ordinarily": ["ao-r d-ah n-eh1 r-ah l-iy", "rb"],
  "ordinary": ["ao1-r d-ah n-eh r-iy", "jj nn"],
  "ordination": ["ao-r d-ah n-ey1 sh-ah-n", "nn"],
  "ordnance": ["ao1-r-d n-ah-n-s", "nn"],
  "ore": ["ao1-r", "nn"],
  "organ": ["ao1-r g-ah-n", "nn"],
  "organic": ["ao-r g-ae1 n-ih-k", "jj"],
  "organically": ["ao-r g-ae1 n-ih-k l-iy", "rb"],
  "organism": ["ao1-r g-ah n-ih z-ah-m", "nn"],
  "organismic": ["ao-r g-ah n-ih1-z m-ih-k", "jj"],
  "organist": ["ao1-r g-ah n-ah-s-t", "nn"],
  "organization": ["ao-r g-ah n-ah z-ey1 sh-ah-n", "nn"],
  "organizational": ["ao-r g-ah n-ah z-ey1 sh-ah n-ah-l", "jj"],
  "organize": ["ao1-r g-ah n-ay-z", "vb vbp"],
  "organized": ["ao1-r g-ah n-ay-z-d", "vbn vbd jj"],
  "organizer": ["ao1-r g-ah n-ay z-er", "nn"],
  "orgasm": ["ao1-r g-ae z-ah-m", "nn"],
  "orgy": ["ao1-r jh-iy", "nn"],
  "orient": ["ao1-r-iy-eh-n-t", "vb"],
  "oriental": ["ao r-iy eh1-n t-ah-l", "jj"],
  "orientation": ["ao r-iy eh-n t-ey1 sh-ah-n", "nn"],
  "oriented": ["ao1 r-iy eh-n t-ah-d", "vbn vbd jj"],
  "orifice": ["ao1 r-ah f-ah s-ah", "nn"],
  "origin": ["ao1 r-ah jh-ah-n", "nn"],
  "original": ["er ih1 jh-ah n-ah-l", "jj nn"],
  "originality": ["er ih jh-ah n-ae1 l-ih t-iy", "nn"],
  "originally": ["er ih1 jh-ah n-ah l-iy", "rb"],
  "originate": ["er ih1 jh-ah n-ey-t", "vb vbp"],
  "originated": ["er ih1 jh-ah n-ey t-ah-d", "vbd jj vbn"],
  "origination": ["er ih jh-ah n-ey1 sh-ah-n", "nn"],
  "originator": ["er ih1 jh-ah n-ey t-er", "nn"],
  "ornament": ["ao1-r n-ah m-ah-n-t", "nn vb"],
  "ornamental": ["ao-r n-ah m-eh1-n t-ah-l", "jj"],
  "ornamentation": ["ao-r n-ah m-eh-n t-ey1 sh-ah-n", "nn"],
  "ornate": ["ao-r n-ey1-t", "jj"],
  "ornery": ["ao1-r n-er iy", "jj"],
  "orphan": ["ao1-r f-ah-n", "jj nn vb"],
  "orphanage": ["ao1-r f-ah n-ah-jh", "nn"],
  "orphaned": ["ao1-r f-ah-n-d", "vbn jj"],
  "orthodontic": ["ao-r th-ah d-aa1-n t-ih-k", "jj"],
  "orthodontist": ["ao-r th-ah d-aa1-n t-ah-s-t", "nn"],
  "orthodox": ["ao1-r th-ah d-aa-k-s", "jj nn"],
  "orthodoxy": ["ao1-r th-ah d-aa-k s-iy", "nn"],
  "orthography": ["ao-r th-aa1 g-r-ah f-iy", "nn"],
  "orthopedic": ["ao-r th-ah p-iy1 d-ih-k", "jj"],
  "oscillate": ["aa1-s-ah-l-ey-t", "vb"],
  "oscillation": ["aa s-ah l-ey1 sh-ah-n", "nn"],
  "oscillator": ["aa1 s-ah l-ey t-er", "nn"],
  "osmium": ["aa1-z m-iy ah-m", "nn"],
  "osmotic": ["aa-z m-aa1 t-ah-k", "jj"],
  "ossification": ["aa s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "ossify": ["aa1 s-ah f-ay", "vb"],
  "ostensibly": ["aa s-t-eh1-n s-ah b-l-iy", "rb"],
  "ostentation": ["ao s-t-eh-n t-ey1 sh-ah-n", "nn"],
  "ostentatious": ["aa s-t-ah-n t-ey1 sh-ah-s", "jj"],
  "ostentatiously": ["aa s-t-ah-n t-ey1 sh-ah-s l-iy", "rb"],
  "ostinato": ["aa s-t-ah n-aa1 t-ow", "nn"],
  "ostracism": ["ao1 s-t-r-ah s-ih z-ah-m", "nn"],
  "ostracize": ["ao1-s-t-r-ah-s-ay-z", "vb"],
  "ostrich": ["ao1 s-t-r-ih-ch", "jj nn"],
  "other": ["ah1 dh-er", "jj nn"],
  "otherwise": ["ah1 dh-er w-ay-z", "rb jj"],
  "otherworldly": ["ah1 dh-er w-er1-l-d l-iy", "jj"],
  "otter": ["aa1 t-er", "nn"],
  "ought": ["ao1-t", "md"],
  "ounce": ["aw1-n-s", "nn"],
  "our": ["aw1 er", "prp$"],
  "ours": ["aw1 er-z", "prp"],
  "ourselves": ["aw er s-eh1-l-v-z", "prp"],
  "oust": ["aw1-s-t", "vb"],
  "ousted": ["aw1 s-t-ih-d", "vbn vbd jj"],
  "ouster": ["aw1 s-t-er", "nn"],
  "out": ["aw1-t", "in jj nn rb rp"],
  "outage": ["aw1 t-ah-jh", "nn"],
  "outback": ["aw1-t b-ae-k", "nn"],
  "outbid": ["aw1-t b-ih-d", "vb vbd vbn vbp"],
  "outboard": ["aw1-t b-ao-r-d", "jj"],
  "outbound": ["aw1-t b-aw-n-d", "jj"],
  "outbreak": ["aw1-t b-r-ey-k", "nn"],
  "outburst": ["aw1-t b-er-s-t", "nn"],
  "outcast": ["aw1-t k-ae-s-t", "nn"],
  "outclass": ["aw1-t k-l-ae-s", "vbp vb"],
  "outcome": ["aw1-t k-ah-m", "nn"],
  "outcry": ["aw1-t k-r-ay", "nn"],
  "outdate": ["aw1-t-d-ey-t", "vb"],
  "outdated": ["aw1-t d-ey t-ih-d", "jj vbn"],
  "outdid": ["aw1-t d-ih-d", "vbd"],
  "outdistance": ["aw1-t-d-ih1-s-t-ah-n-s", "vb"],
  "outdo": ["aw-t d-uw1", "vb vbp"],
  "outdone": ["aw1-t d-ah1-n", "vbn"],
  "outdoor": ["aw1-t d-ao-r", "jj"],
  "outdoors": ["aw1-t d-ao1-r-z", "rb nn"],
  "outdoorsman": ["aw1-t d-ao-r-z m-ah-n", "nn"],
  "outer": ["aw1 t-er", "jj"],
  "outfield": ["aw1-t f-iy-l-d", "nn"],
  "outfielder": ["aw1-t f-iy-l d-er", "nn"],
  "outfit": ["aw1-t f-ih-t", "nn vb vbp"],
  "outflank": ["aw1-t f-l-ae-ng-k", "vb"],
  "outflow": ["aw1-t f-l-ow", "nn"],
  "outgain": ["aw1-t-g-ey-n", "vb"],
  "outgoing": ["aw1-t g-ow ih-ng", "jj"],
  "outgrew": ["aw-t g-r-uw1", "vbd"],
  "outgrow": ["aw-t g-r-ow1", "vb"],
  "outgrown": ["aw-t g-r-ow1-n", "vbn"],
  "outgrowth": ["aw1-t g-r-ow-th", "nn"],
  "outguess": ["aw1-t g-eh-s", "vb"],
  "outhouse": ["aw1-t hh-aw-s", "nn"],
  "outing": ["aw1 t-ih-ng", "nn"],
  "outlandish": ["aw-t l-ae1-n d-ih-sh", "jj"],
  "outlast": ["aw1-t l-ae-s-t", "vb"],
  "outlaw": ["aw1-t l-ao", "vb nn"],
  "outlawed": ["aw1-t l-ao-d", "vbn jj vbd"],
  "outlawry": ["aw1-t l-ao r-iy", "nn"],
  "outlay": ["aw1-t l-ey", "nn"],
  "outlet": ["aw1-t l-eh-t", "nn"],
  "outline": ["aw1-t l-ay-n", "nn vb vbp"],
  "outlined": ["aw1-t l-ay-n-d", "vbn vbd jj"],
  "outlive": ["aw-t l-ih1-v", "vb"],
  "outlook": ["aw1-t l-uh-k", "nn"],
  "outlying": ["aw1-t l-ay ih-ng", "jj"],
  "outmaneuver": ["aw-t m-ah n-uw1 v-er", "vb"],
  "outmode": ["aw-t-m-ow1-d", "vb"],
  "outmoded": ["aw-t m-ow1 d-ah-d", "jj vbn"],
  "outnumber": ["aw-t n-ah1-m b-er", "vb"],
  "outpace": ["aw1-t p-ey-s", "vb vbp"],
  "outpaced": ["aw1-t p-ey-s-t", "vbd vbn"],
  "outpatient": ["aw1-t p-ey sh-ah-n-t", "nn jj"],
  "outperform": ["aw1-t p-er f-ao-r-m", "vb jj vbp"],
  "outplacement": ["aw1-t p-l-ey-s m-ah-n-t", "nn"],
  "outpost": ["aw1-t p-ow-s-t", "nn"],
  "outpouring": ["aw-t p-ao1 r-ih-ng", "nn"],
  "output": ["aw1-t p-uh-t", "nn vb"],
  "outrage": ["aw1-t r-ey-jh", "nn vb"],
  "outraged": ["aw1-t r-ey-jh-d", "vbn jj vbd"],
  "outrageous": ["aw-t r-ey1 jh-ah-s", "jj"],
  "outrageously": ["aw-t r-ey1 jh-ah-s l-iy", "rb"],
  "outreach": ["aw1-t r-iy-ch", "nn"],
  "outrigger": ["aw1-t r-ih g-er", "nn"],
  "outright": ["aw1-t r-ay1-t", "jj rb"],
  "outrun": ["aw-t r-ah1-n", "vb vbn"],
  "outscore": ["aw-t-s-k-ao1-r", "vb"],
  "outsell": ["aw-t s-eh1-l", "vb"],
  "outset": ["aw1-t s-eh-t", "nn"],
  "outshine": ["aw1 ch-ay-n", "vb"],
  "outshone": ["aw-t sh-ow1-n", "nn"],
  "outside": ["aw1-t s-ay1-d", "in jj nn rb"],
  "outsider": ["aw-t s-ay1 d-er", "nn"],
  "outsized": ["aw1-t s-ay-z-d", "jj"],
  "outskirt": ["aw1-t s-k-er-t", "nn"],
  "outsold": ["aw-t s-ow1-l-d", "vbd"],
  "outspend": ["aw1-t s-p-eh-n-d", "vb vbp"],
  "outspoken": ["aw1-t s-p-ow1 k-ah-n", "jj"],
  "outstanding": ["aw-t s-t-ae1-n d-ih-ng", "jj"],
  "outstretch": ["aw-t-s-t-r-eh1-ch", "vb"],
  "outstrip": ["aw-t s-t-r-ih1-p", "vb"],
  "outstripped": ["aw-t s-t-r-ih1-p-t", "nn vbd vbn"],
  "outta": ["uw1 t-ah", "in"],
  "outward": ["aw1-t w-er-d", "rb jj"],
  "outwardly": ["aw1-t w-er-d l-iy", "rb ."],
  "outweigh": ["aw1-t w-ey", "vbp vb"],
  "outwit": ["aw1-t w-ih-t", "vb"],
  "oval": ["ow1 v-ah-l", "jj nn"],
  "ovarian": ["ow v-eh1 r-iy ah-n", "jj"],
  "ovation": ["ow v-ey1 sh-ah-n", "nn"],
  "oven": ["ah1 v-ah-n", "nn"],
  "over": ["ow1 v-er", "in rp jj rb"],
  "overactive": ["ow1 v-er ae1-k t-ih-v", "jj"],
  "overall": ["ow1 v-er ao-l", "jj nn rb"],
  "overarch": ["ow1 v-er aa-r-ch", "vb"],
  "overarching": ["ow1 v-er aa-r ch-ih-ng", "vbg jj"],
  "overbearing": ["ow1 v-er b-eh1 r-ih-ng", "jj"],
  "overbill": ["ow-v-er-b-ih1-l", "vb"],
  "overblown": ["ow v-er b-l-ow1-n", "jj"],
  "overboard": ["ow1 v-er b-ao-r-d", "rb"],
  "overbought": ["ow1 v-er b-ao1-t", "vbn jj nn"],
  "overbuilding": ["ow1 v-er b-ih-l d-ih-ng", "nn"],
  "overbuilt": ["ow1 v-er b-ih1-l-t", "jj nn"],
  "overburden": ["ow1 v-er b-er1 d-ah-n", "vb"],
  "overburdened": ["ow1 v-er b-er1 d-ah-n-d", "vbn jj vbd"],
  "overcame": ["ow1 v-er k-ey1-m", "vbd"],
  "overcapacity": ["ow1 v-er k-ah p-ae1 s-ah t-iy", "nn"],
  "overcast": ["ow1 v-er k-ae-s-t", "nn jj"],
  "overcharge": ["ow1 v-er ch-aa-r-jh", "vb"],
  "overcoat": ["ow1 v-er k-ow-t", "nn"],
  "overcome": ["ow1 v-er k-ah-m", "vb vbn vbp"],
  "overconfident": ["ow v-er k-aa1-n f-ih d-ah-n-t", "jj"],
  "overcook": ["ow-v-er-k-uh1-k", "vb"],
  "overcrowd": ["ow-v-er-k-r-aw1-d", "vb"],
  "overcrowded": ["ow1 v-er k-r-aw d-ih-d", "jj vbn"],
  "overdo": ["ow1-v-er-d-uw1", "vb"],
  "overdone": ["ow1 v-er d-ah1-n", "vbn"],
  "overdose": ["ow1 v-er d-ow-s", "nn vb"],
  "overdraft": ["ow1 v-er d-r-ae-f-t", "nn"],
  "overdraw": ["ow1 v-er d-r-ao", "vb"],
  "overdrawn": ["ow1 v-er d-r-ao1-n", "jj"],
  "overdrive": ["ow1 v-er d-r-ay-v", "nn"],
  "overdue": ["ow1 v-er d-uw1", "jj"],
  "overeager": ["ow1 v-er iy g-er", "jj"],
  "overeat": ["ow1 v-er iy-t", "vb vbp"],
  "overemphasize": ["ow1 v-er eh1-m f-ah s-ay-z", "vb"],
  "overestimate": ["ow v-er eh1-s t-ah m-ey-t", "vb"],
  "overextend": ["ow-v-er-ih-k-s-t-eh1-n-d", "vb"],
  "overextended": ["ow v-er ih-k s-t-eh1-n d-ah-d", "vbn vbd jj"],
  "overfeed": ["ow v-er f-iy1-d", "vb"],
  "overfill": ["ow1 v-er f-ih-l", "vb"],
  "overflight": ["ow1 v-er f-l-ay-t", "nn"],
  "overflow": ["ow1 v-er f-l-ow", "nn vb"],
  "overfund": ["ow1-v-er-f-ah-n-d", "vb"],
  "overgenerous": ["ow1 v-er jh-eh n-er ah-s", "jj"],
  "overgrazing": ["ow1 v-er g-r-ey z-ih-ng", "nn"],
  "overgrown": ["ow1 v-er g-r-ow1-n", "vbn jj"],
  "overhang": ["ow1 v-er hh-ae-ng", "nn vb"],
  "overhaul": ["ow1 v-er hh-ao-l", "nn vb"],
  "overhead": ["ow1 v-er hh-eh1-d", "jj nn rb"],
  "overhear": ["ow1 v-er hh-ih1-r", "vb"],
  "overheat": ["ow1 v-er hh-iy-t", "vb"],
  "overheating": ["ow1 v-er hh-iy t-ih-ng", "vbg jj"],
  "overjoyed": ["ow v-er jh-oy1-d", "jj"],
  "overkill": ["ow1 v-er k-ih-l", "nn"],
  "overlaid": ["ow1 v-er l-ey-d", "vbn"],
  "overland": ["ow1 v-er l-ae-n-d", "rb"],
  "overlap": ["ow1 v-er l-ae-p", "nn vb vbp"],
  "overlapping": ["ow1 v-er l-ae p-ih-ng", "vbg jj nn"],
  "overlay": ["ow1 v-er l-ey", "nn vb vbp"],
  "overleveraged": ["ow1 v-er l-eh1 v-r-ih-jh-d", "jj"],
  "overload": ["ow1 v-er l-ow-d", "nn vbp vb"],
  "overloaded": ["ow1 v-er l-ow d-ih-d", "vbn jj"],
  "overlook": ["ow1 v-er l-uh-k", "vb vbp"],
  "overly": ["ow1 v-er l-iy", "rb"],
  "overlying": ["ow v-er l-ay1 ih-ng", "jj"],
  "overnight": ["ow1 v-er n-ay1-t", "jj nn rb"],
  "overnighter": ["ow v-er n-ay1 t-er", "nn"],
  "overpaid": ["ow1 v-er p-ey1-d", "vbn vbd jj"],
  "overpass": ["ow1 v-er p-ae-s", "nn"],
  "overpay": ["ow1 v-er p-ey", "vb"],
  "overpayment": ["ow1 v-er p-ey m-ah-n-t", "nn"],
  "overplay": ["ow1-v-er-p-l-ey1", "vb"],
  "overpopulation": ["ow v-er p-aa p-y-ah l-ey1 sh-ah-n", "nn"],
  "overpower": ["ow-v-er-p-aw1-er", "vb"],
  "overpowering": ["ow1 v-er p-aw1 r-ih-ng", "jj"],
  "overprice": ["ow-v-er-p-r-ay1-s", "vb"],
  "overpriced": ["ow1 v-er p-r-ay-s-t", "vbn jj"],
  "overproduce": ["ow1 v-er p-r-ah d-uw1-s", "vb"],
  "overproducer": ["ow1 v-er p-r-ah d-uw1 s-er", "nn"],
  "overran": ["ow1 v-er r-ae1-n", "vbd"],
  "overrate": ["ow-v-er-r-ey1-t", "vb"],
  "overreach": ["ow1 v-er r-iy-ch", "vb"],
  "overreact": ["ow1 v-er r-iy ae1-k-t", "vb vbp"],
  "overreaction": ["ow1 v-er r-iy ae-k sh-ah-n", "nn"],
  "overregulate": ["ow1-v-er-r-eh1-g-y-ah-l-ey-t", "vb"],
  "overregulated": ["ow v-er r-eh1 g-y-ah l-ey t-ih-d", "jj vbn"],
  "overregulation": ["ow v-er r-eh g-y-ah l-ey1 sh-ah-n", "nn"],
  "overridden": ["ow1 v-er r-ih1 d-ah-n", "vbn"],
  "override": ["ow1 v-er r-ay-d", "vb nn"],
  "overriding": ["ow1 v-er r-ay d-ih-ng", "vbg jj"],
  "overrode": ["ow1 v-er r-ow1-d", "vbd"],
  "overrule": ["ow1 v-er r-uw-l", "vb"],
  "overrun": ["ow1 v-er r-ah-n", "vbn jj nn"],
  "oversaw": ["ow1 v-er s-ao", "vbd"],
  "overseas": ["ow1 v-er s-iy1-z", "jj nn rb"],
  "oversee": ["ow1 v-er s-iy", "vb"],
  "overseen": ["ow1 v-er s-iy-n", "vbn nn"],
  "overseer": ["ow1 v-er s-iy1 er", "nn"],
  "oversell": ["ow1 v-er s-eh-l", "vb vbp"],
  "overshadow": ["ow1 v-er sh-ae1 d-ow", "vbp vb"],
  "overshot": ["ow1 v-er sh-aa-t", "vbd"],
  "oversight": ["ow1 v-er s-ay-t", "nn"],
  "oversimplified": ["ow v-er s-ih1-m p-l-ih f-ay-d", "vbn jj"],
  "oversimplify": ["ow-v-er-s-ih1-m-p-l-ih-f-ay", "vb"],
  "oversize": ["ow v-er s-ay1-z", "jj nn"],
  "oversized": ["ow1 v-er s-ay1-z-d", "jj"],
  "oversold": ["ow1 v-er s-ow-l-d", "vbn vbd jj"],
  "overspend": ["ow1-v-er-s-p-eh-n-d", "vb"],
  "overstaffed": ["ow1 v-er s-t-ae-f-t", "jj"],
  "overstate": ["ow1 v-er s-t-ey-t", "vb vbp"],
  "overstatement": ["ow1 v-er s-t-ey-t m-ah-n-t", "nn"],
  "overstep": ["ow1-v-er-s-t-eh-p", "vb"],
  "oversupplied": ["ow v-er s-ah p-l-ay1-d", "jj vbn"],
  "oversupply": ["ow v-er s-ah p-l-ay1", "nn"],
  "overt": ["ow v-er1-t", "jj"],
  "overtake": ["ow1 v-er t-ey-k", "vb vbp"],
  "overtaken": ["ow1 v-er t-ey k-ah-n", "vbn"],
  "overtax": ["ow1-v-er-t-ae-k-s", "vb"],
  "overtaxed": ["ow v-er t-ae1-k-s-t", "jj vbn"],
  "overthrow": ["ow1 v-er th-r-ow", "vb nn"],
  "overthrown": ["ow v-er th-r-ow1-n", "vbn"],
  "overtime": ["ow1 v-er t-ay-m", "nn jj rb"],
  "overtly": ["ow v-er1-t l-iy", "rb"],
  "overtone": ["ow1 v-er t-ow-n", "nn"],
  "overtook": ["ow v-er t-uh1-k", "vbd"],
  "overture": ["ow1 v-er ch-er", "nn"],
  "overturn": ["ow1 v-er t-er-n", "vb"],
  "overuse": ["ow v-er y-uw1-z", "nn vb"],
  "overused": ["ow v-er y-uw1-z-d", "vbn jj"],
  "overvalue": ["ow1-v-er-v-ae-l-y-uw", "vb"],
  "overvalued": ["ow1 v-er v-ae-l y-uw-d", "vbn jj vbd"],
  "overview": ["ow1 v-er v-y-uw", "nn"],
  "overweight": ["ow v-er w-ey1-t", "jj nn vb"],
  "overwhelm": ["ow v-er w-eh1-l-m", "vb vbp"],
  "overwhelmed": ["ow v-er w-eh1-l-m-d", "vbn vbd jj"],
  "overwhelming": ["ow v-er w-eh1-l m-ih-ng", "jj vbg"],
  "overwhelmingly": ["ow v-er w-eh1-l m-ih-ng l-iy", "rb"],
  "overwork": ["ow-v-er-w-er1-k", "vb"],
  "overworked": ["ow v-er w-er1-k-t", "vbn jj"],
  "overwritten": ["ow v-er r-ih1 t-ah-n", "jj"],
  "overwrought": ["ow v-er r-ao1-t", "jj"],
  "overzealous": ["ow v-er z-eh1 l-ah-s", "jj"],
  "ovulation": ["ow v-y-ah l-ey1 sh-ah-n", "nn"],
  "owe": ["ow1", "vbp vb"],
  "owing": ["ow1 ih-ng", "jj vbg"],
  "owl": ["aw1-l", "nn"],
  "own": ["ow1-n", "jj vbp vb"],
  "owned": ["ow1-n-d", "vbn vbd jj"],
  "owner": ["ow1 n-er", "nn"],
  "ownership": ["ow1 n-er sh-ih-p", "nn"],
  "ox": ["aa1-k-s", "nn"],
  "oxcart": ["aa1-k-s k-aa-r-t", "nn"],
  "oxidation": ["aa-k s-ah d-ey1 sh-ah-n", "nn"],
  "oxide": ["aa1-k s-ay-d", "nn"],
  "oxidized": ["aa1-k s-ah d-ay-z-d", "jj"],
  "oxygen": ["aa1-k s-ah jh-ah-n", "nn"],
  "oyster": ["oy1 s-t-er", "nn"],
  "ozone": ["ow1 z-ow-n", "nn"],
  "pace": ["p-ey1-s", "nn vb vbp"],
  "pacemaker": ["p-ey1-s m-ey k-er", "nn"],
  "pacer": ["p-ey1 s-er", "nn"],
  "pachinko": ["p-ah ch-ih1-ng k-ow", "nn"],
  "pacific": ["p-ah s-ih1 f-ih-k", "jj"],
  "pacified": ["p-ae1 s-ah f-ay-d", "vbd"],
  "pacifier": ["p-ae1 s-ah f-ay er", "nn"],
  "pacifism": ["p-ae1 s-ih f-ih z-ah-m", "nn"],
  "pacifist": ["p-ae1 s-ih f-ih-s-t", "nn"],
  "pacify": ["p-ae1 s-ah f-ay", "vb"],
  "pacing": ["p-ey1 s-ih-ng", "vbg jj nn"],
  "pack": ["p-ae1-k", "nn vb vbp"],
  "package": ["p-ae1 k-ah-jh", "nn vb"],
  "packaged": ["p-ae1 k-ih-jh-d", "vbn jj"],
  "packaging": ["p-ae1 k-ih jh-ih-ng", "nn vbg"],
  "packed": ["p-ae1-k-t", "vbn jj vbd"],
  "packer": ["p-ae1 k-er", "nn"],
  "packet": ["p-ae1 k-ah-t", "nn"],
  "pact": ["p-ae1-k-t", "nn"],
  "pad": ["p-ae1-d", "nn vb"],
  "padded": ["p-ae1 d-ah-d", "jj vbn"],
  "padding": ["p-ae1 d-ih-ng", "nn vbg"],
  "paddle": ["p-ae1 d-ah-l", "nn"],
  "paddock": ["p-ae1 d-ah-k", "nn"],
  "paddy": ["p-ae1 d-iy", "nn"],
  "padlock": ["p-ae1-d l-aa-k", "nn vb"],
  "paean": ["p-iy1 ah-n", "nn"],
  "pagan": ["p-ey1 g-ah-n", "jj"],
  "paganism": ["p-ey1 g-ah n-ih z-ah-m", "nn"],
  "page": ["p-ey1-jh", "nn vb"],
  "pageant": ["p-ae1 jh-ah-n-t", "nn"],
  "pageantry": ["p-ae1 jh-ah-n t-r-iy", "nn"],
  "pager": ["p-ey1 jh-er", "nn"],
  "paging": ["p-ey1 jh-ih-ng", "nn"],
  "pagoda": ["p-ah g-ow1 d-ah", "nn"],
  "paid": ["p-ey1-d", "vbn vbd jj"],
  "pail": ["p-ey1-l", "nn"],
  "pain": ["p-ey1-n", "nn vb"],
  "pained": ["p-ey1-n-d", "jj vbd vbn"],
  "painful": ["p-ey1-n f-ah-l", "jj"],
  "painfully": ["p-ey1-n f-ah l-iy", "rb"],
  "painkiller": ["p-ey1-n k-ih l-er", "nn"],
  "painless": ["p-ey1-n l-ah-s", "jj"],
  "painlessly": ["p-ey1-n l-ah-s l-iy", "rb"],
  "painstaking": ["p-ey1-n-s t-ey k-ih-ng", "jj"],
  "painstakingly": ["p-ey1-n-s t-ey k-ih-ng l-iy", "rb"],
  "paint": ["p-ey1-n-t", "nn vb vbp"],
  "paintbrush": ["p-ey1-n-t b-r-ah-sh", "nn"],
  "painted": ["p-ey1-n t-ah-d", "vbn vbd jj"],
  "painter": ["p-ey1-n t-er", "nn"],
  "painting": ["p-ey1-n t-ih-ng", "nn vbg"],
  "pair": ["p-eh1-r", "nn vb"],
  "paired": ["p-eh1-r-d", "vbn jj vbd"],
  "pairing": ["p-eh1 r-ih-ng", "nn vbg"],
  "pajama": ["p-ah jh-aa1 m-ah", "nn"],
  "pal": ["p-ae1-l", "nn jj"],
  "palace": ["p-ae1 l-ah-s", "nn"],
  "palatability": ["p-ae l-ah t-ah b-ih1 l-ah t-iy", "nn"],
  "palatable": ["p-ae1 l-ah t-ah b-ah-l", "jj"],
  "palate": ["p-ae1 l-ah-t", "nn"],
  "palatial": ["p-ah l-ey1 sh-ah-l", "jj"],
  "palazzo": ["p-ah l-aa1 z-ow", "nn"],
  "pale": ["p-ey1-l", "jj vb vbp nn"],
  "paled": ["p-ey1-l-d", "vbd vbn"],
  "palest": ["p-ey1 l-ah-s-t", "jjs"],
  "palette": ["p-ae1 l-ah-t", "nn"],
  "palisade": ["p-ae l-ih s-ey1-d", "nn"],
  "pall": ["p-aa1-l", "nn vb"],
  "palladium": ["p-ah l-ey1 d-iy ah-m", "nn"],
  "pallet": ["p-ae1 l-ah-t", "nn"],
  "palliative": ["p-ae1 l-iy ah t-ih-v", "jj"],
  "pallid": ["p-ae1 l-ah-d", "jj"],
  "palm": ["p-aa1-m", "nn vb"],
  "palpable": ["p-ae1-l p-ah b-ah-l", "jj"],
  "palpably": ["p-ae1-l p-ah b-l-iy", "rb"],
  "palpitation": ["p-ae-l p-ih t-ey1 sh-ah-n", "nn"],
  "palsy": ["p-ao1-l z-iy", "nn"],
  "paltry": ["p-ao1-l t-r-iy", "jj"],
  "pamper": ["p-ae1-m p-er", "vb"],
  "pampered": ["p-ae1-m p-er-d", "jj"],
  "pamphlet": ["p-ae1-m f-l-ah-t", "nn"],
  "pamphleteer": ["p-ae-m f-l-ah t-ih1-r", "nn"],
  "pan": ["p-ae1-n", "nn vb"],
  "panacea": ["p-ae n-ah s-iy1 ah", "nn"],
  "panache": ["p-ah n-aa1-sh", "nn"],
  "pancake": ["p-ae1-n k-ey-k", "nn"],
  "pancreas": ["p-ae1-n k-r-iy ah-s", "nn"],
  "pandanus": ["p-ae-n d-ey1 n-ah-s", "nn"],
  "pandemic": ["p-ae-n d-eh1 m-ih-k", "nn"],
  "pandemonium": ["p-ae-n d-ih m-ow1 n-iy ah-m", "nn"],
  "pander": ["p-ae1-n-d-er", "vb"],
  "pane": ["p-ey1-n", "nn"],
  "panel": ["p-ae1 n-ah-l", "nn"],
  "paneled": ["p-ae1 n-ah-l-d", "jj"],
  "paneling": ["p-ae1 n-ah l-ih-ng", "nn"],
  "panelist": ["p-ae1 n-ah l-ih-s-t", "nn"],
  "panelization": ["p-ae1 n-ah l-ah z-ey1 sh-ah-n", "nn"],
  "panelize": ["p-ae1-n-ah-l-ay-z", "vb"],
  "pang": ["p-ae1-ng", "nn"],
  "panhandle": ["p-ae1-n hh-ae-n d-ah-l", "nn"],
  "panic": ["p-ae1 n-ih-k", "nn vb vbp"],
  "panicked": ["p-ae1 n-ih-k-t", "vbd vbn jj"],
  "panicky": ["p-ae1 n-ih k-iy", "jj"],
  "panky": ["p-ae1-ng k-iy", "nn"],
  "panoply": ["p-ae1 n-aa p-l-iy", "nn"],
  "panorama": ["p-ae n-er ae1 m-ah", "nn"],
  "panoramic": ["p-ae n-er ae1 m-ih-k", "jj"],
  "pansy": ["p-ae1-n z-iy", "nn"],
  "pant": ["p-ae1-n-t", "nn vb"],
  "pantaloon": ["p-ae1-n t-ah l-uw-n", "nn"],
  "pantheon": ["p-ae1-n th-iy aa-n", "nn"],
  "panther": ["p-ae1-n th-er", "nn"],
  "pantie": ["p-ae1-n t-iy", "nn"],
  "panting": ["p-ae1-n t-ih-ng", "vbg jj nn"],
  "pantomime": ["p-ae1-n t-ah m-ay-m", "nn vb vbp"],
  "pantry": ["p-ae1-n t-r-iy", "nn"],
  "pap": ["p-ae1-p", "nn"],
  "papal": ["p-ey1 p-ah-l", "jj"],
  "paper": ["p-ey1 p-er", "nn vb"],
  "paperback": ["p-ey1 p-er b-ae-k", "nn jj"],
  "paperboard": ["p-ey1 p-er b-ao-r-d", "nn"],
  "paperboy": ["p-ey1 p-er b-ao-y", "nn"],
  "paperless": ["p-ey1 p-er l-ah-s", "jj"],
  "paperwork": ["p-ey1 p-er w-er-k", "nn"],
  "papery": ["p-ey1 p-er iy", "jj"],
  "paprika": ["p-ae p-r-iy1 k-ah", "nn"],
  "parable": ["p-eh1 r-ah b-ah-l", "nn"],
  "parachute": ["p-eh1 r-ah sh-uw-t", "nn vb"],
  "parade": ["p-er ey1-d", "nn vb vbp"],
  "paradigm": ["p-eh1 r-ah d-ay-m", "nn"],
  "paradise": ["p-eh1 r-ah d-ay-s", "nn"],
  "paradox": ["p-eh1 r-ah d-aa-k-s", "nn"],
  "paradoxical": ["p-eh r-ah d-aa1-k s-ih k-ah-l", "jj"],
  "paradoxically": ["p-eh r-ah d-aa1-k s-ah-k l-iy", "rb"],
  "paragon": ["p-eh1 r-ah g-aa-n", "nn"],
  "paragraph": ["p-ae1 r-ah g-r-ae-f", "nn"],
  "parakeet": ["p-eh1 r-ah k-iy-t", "nn"],
  "paralegal": ["p-eh r-ah l-iy1 g-ah-l", "nn"],
  "parallel": ["p-eh1 r-ah l-eh-l", "jj rb vb vbp nn"],
  "parallelism": ["p-eh1 r-ah l-eh l-ih z-ah-m", "nn"],
  "paralysis": ["p-er ae1 l-ah s-ah-s", "nn"],
  "paralyze": ["p-eh1 r-ah l-ay-z", "vb"],
  "paralyzed": ["p-eh1 r-ah l-ay-z-d", "vbn jj"],
  "paralyzing": ["p-eh1 r-ah l-ay z-ih-ng", "vbg jj"],
  "parameter": ["p-er ae1 m-ah t-er", "nn"],
  "parametric": ["p-eh r-ah m-eh1 t-r-ih-k", "jj"],
  "paramilitary": ["p-eh r-ah m-ih1 l-ah t-eh r-iy", "jj"],
  "paramount": ["p-eh1 r-ah m-aw-n-t", "jj"],
  "paranoia": ["p-eh r-ah n-oy1 ah", "nn"],
  "paranoiac": ["p-eh r-ah n-oy1 ae-k", "nn"],
  "paranoid": ["p-eh1 r-ah n-oy-d", "jj"],
  "paranormal": ["p-eh r-ah n-ao1-r m-ah-l", "jj"],
  "paraphernalia": ["p-eh r-ah f-ah n-ey1 l-y-ah", "nn"],
  "paraphrase": ["p-eh1 r-ah f-r-ey-z", "nn vb vbp"],
  "parasite": ["p-eh1 r-ah s-ay-t", "nn"],
  "parasitic": ["p-eh r-ah s-ih1 t-ih-k", "jj"],
  "paratrooper": ["p-eh1 r-ah t-r-uw p-er", "nn"],
  "parcel": ["p-aa1-r s-ah-l", "nn vbp jj vb"],
  "parceling": ["p-aa1-r s-ah-l ih-ng", "nn"],
  "parch": ["p-aa1-r-ch", "vb"],
  "parched": ["p-aa1-r-ch-t", "vbn vbd jj"],
  "parchment": ["p-aa1-r-ch m-ah-n-t", "nn"],
  "pardon": ["p-aa1-r d-ah-n", "vb nn"],
  "pare": ["p-eh1-r", "vb"],
  "parent": ["p-eh1 r-ah-n-t", "nn jj"],
  "parentage": ["p-eh1 r-ah-n t-ah-jh", "nn"],
  "parental": ["p-er eh1-n t-ah-l", "jj"],
  "parenthesis": ["p-er eh1-n th-ah s-ih-s", "nn"],
  "parenthood": ["p-eh1 r-ah-n-t hh-uh-d", "nn"],
  "parenting": ["p-eh1 r-ah-n t-ih-ng", "nn"],
  "pariah": ["p-er ay1 ah", "nn"],
  "parish": ["p-ae1 r-ih-sh", "nn"],
  "parishioner": ["p-er ih1 sh-ah n-er", "nn"],
  "parity": ["p-eh1 r-ah t-iy", "nn"],
  "park": ["p-aa1-r-k", "nn vb"],
  "parked": ["p-aa1-r-k-t", "vbn jj vbd"],
  "parking": ["p-aa1-r k-ih-ng", "nn jj vbg"],
  "parkway": ["p-aa1-r-k w-ey", "nn"],
  "parlance": ["p-aa1-r l-ah-n-s", "nn"],
  "parlay": ["p-aa1-r-l-ey", "vb"],
  "parley": ["p-aa1-r l-iy", "nn vb"],
  "parliament": ["p-aa1-r l-ah m-ah-n-t", "nn"],
  "parliamentarian": ["p-aa-r l-ah m-ah-n t-eh1 r-iy ah-n", "nn"],
  "parliamentary": ["p-aa-r l-ah m-eh1-n t-er iy", "jj"],
  "parlor": ["p-aa1-r l-er", "nn"],
  "parochial": ["p-er ow1 k-iy ah-l", "jj"],
  "parodied": ["p-eh1 r-ah d-iy-d", "vbd"],
  "parody": ["p-eh1 r-ah d-iy", "nn vb"],
  "parole": ["p-er ow1-l", "nn jj"],
  "parolee": ["p-er ow l-iy1", "nn"],
  "parried": ["p-eh1 r-iy-d", "vbd"],
  "parrot": ["p-eh1 r-ah-t", "nn"],
  "parry": ["p-eh1 r-iy", "vb"],
  "parse": ["p-aa1-r-s", "vb"],
  "parsimony": ["p-aa1-r s-ah m-ow n-iy", "nn"],
  "parsley": ["p-aa1-r-s l-iy", "nn"],
  "parson": ["p-aa1-r s-ah-n", "nn"],
  "parsonage": ["p-aa1-r s-ah-n ih-jh", "nn"],
  "part": ["p-aa1-r-t", "nn jj rb vb"],
  "partake": ["p-aa-r t-ey1-k", "vb vbp"],
  "parted": ["p-aa1-r t-ah-d", "vbd vbn jj"],
  "partial": ["p-aa1-r sh-ah-l", "jj nn"],
  "partially": ["p-aa1-r sh-ah l-iy", "rb"],
  "participant": ["p-aa-r t-ih1 s-ah p-ah-n-t", "nn"],
  "participate": ["p-aa-r t-ih1 s-ah p-ey-t", "vb vbp"],
  "participating": ["p-aa-r t-ih1 s-ah p-ey t-ih-ng", "vbg jj"],
  "participation": ["p-aa-r t-ih s-ah p-ey1 sh-ah-n", "nn"],
  "participative": ["p-aa-r t-ih1 s-ah p-ah t-ih-v", "jj"],
  "participatory": ["p-aa-r t-ih1 s-ah p-ah t-ao r-iy", "jj"],
  "particle": ["p-aa1-r t-ah k-ah-l", "nn"],
  "particular": ["p-er t-ih1 k-y-ah l-er", "jj nn rb"],
  "particularity": ["p-er t-ih k-y-ah l-ae1 r-ah t-iy", "nn"],
  "particularly": ["p-aa-r t-ih1 k-y-ah l-er l-iy", "rb"],
  "particulate": ["p-er t-ih1 k-y-ah l-ah-t", "jj"],
  "partisan": ["p-aa1-r t-ah z-ah-n", "jj nn"],
  "partisanship": ["p-aa1-r t-ah z-ah-n sh-ih-p", "nn"],
  "partition": ["p-aa-r t-ih1 sh-ah-n", "nn vb"],
  "partly": ["p-aa1-r-t l-iy", "rb"],
  "partner": ["p-aa1-r-t n-er", "nn"],
  "partnership": ["p-aa1-r-t n-er sh-ih-p", "nn"],
  "party": ["p-aa1-r t-iy", "nn vb"],
  "pass": ["p-ae1-s", "vb vbp nn"],
  "passable": ["p-ae1 s-ah b-ah-l", "jj"],
  "passably": ["p-ae1 s-ah b-l-iy", "rb"],
  "passage": ["p-ae1 s-ah-jh", "nn"],
  "passageway": ["p-ae1 s-ah-jh w-ey", "nn"],
  "passbook": ["p-ae1-s b-uh-k", "nn"],
  "passe": ["p-ae s-ey1", "jj"],
  "passel": ["p-ae1 s-ih-l", "nn"],
  "passenger": ["p-ae1 s-ah-n jh-er", "nn jj"],
  "passerby": ["p-ae1 s-er b-iy", "nn"],
  "passing": ["p-ae1 s-ih-ng", "vbg jj nn"],
  "passion": ["p-ae1 sh-ah-n", "nn"],
  "passionate": ["p-ae1 sh-ah n-ah-t", "jj"],
  "passionately": ["p-ae1 sh-ah n-ah-t l-iy", "rb"],
  "passive": ["p-ae1 s-ih-v", "jj nn"],
  "passively": ["p-ae1 s-ih-v l-iy", "rb"],
  "passivity": ["p-ah s-ih1 v-ih t-iy", "nn"],
  "passport": ["p-ae1-s p-ao-r-t", "nn"],
  "password": ["p-ae1-s w-er-d", "nn"],
  "past": ["p-ae1-s-t", "jj in nn rb"],
  "pasta": ["p-aa1 s-t-ah", "nn"],
  "paste": ["p-ey1-s-t", "nn vb"],
  "pastel": ["p-ae s-t-eh1-l", "jj nn"],
  "pasteurization": ["p-ae-s ch-er ah z-ey1 sh-ah-n", "nn"],
  "pasteurize": ["p-ae1-s-ch-er-ay-z", "vb"],
  "pastime": ["p-ae1 s-t-ay-m", "nn"],
  "pastor": ["p-ae1 s-t-er", "nn"],
  "pastoral": ["p-ae1 s-t-er ah-l", "jj"],
  "pastrami": ["p-ah s-t-r-aa1 m-iy", "nn"],
  "pastry": ["p-ey1-s t-r-iy", "nn"],
  "pasture": ["p-ae1-s ch-er", "nn jj vb"],
  "pat": ["p-ae1-t", "jj nn vb"],
  "patch": ["p-ae1-ch", "nn vb"],
  "patched": ["p-ae1-ch-t", "vbn jj"],
  "patchwork": ["p-ae1-ch w-er-k", "nn jj"],
  "pate": ["p-ey1-t", "nn"],
  "patent": ["p-ae1 t-ah-n-t", "nn jj vb"],
  "patented": ["p-ae1 t-ah-n t-ah-d", "vbn vbd jj"],
  "patently": ["p-ae1 t-ah-n-t l-iy", "rb"],
  "pater": ["p-ey1 t-er", "nn"],
  "paternal": ["p-ah t-er1 n-ah-l", "jj"],
  "paternalism": ["p-ah t-er1 n-ah l-ih z-ah-m", "nn jj"],
  "paternalistic": ["p-ah t-er n-ah l-ih1 s-t-ih-k", "jj"],
  "paternity": ["p-ah t-er1 n-ih t-iy", "nn"],
  "path": ["p-ae1-th", "nn"],
  "pathetic": ["p-ah th-eh1 t-ih-k", "jj"],
  "pathfinder": ["p-ae1-th f-ay-n d-er", "nn"],
  "pathogenic": ["p-ae th-ah jh-eh1 n-ih-k", "jj"],
  "pathological": ["p-ae th-ah l-aa1 jh-ih k-ah-l", "jj"],
  "pathologist": ["p-ah th-aa1 l-ah jh-ah-s-t", "nn"],
  "pathology": ["p-ah th-aa1 l-ah jh-iy", "nn"],
  "pathos": ["p-ey1 th-aa-s", "nn"],
  "pathway": ["p-ae1-th w-ey", "nn"],
  "patience": ["p-ey1 sh-ah-n-s", "nn"],
  "patient": ["p-ey1 sh-ah-n-t", "nn jj"],
  "patiently": ["p-ey1 sh-ah-n-t l-iy", "rb"],
  "patina": ["p-ah t-iy1 n-ah", "nn"],
  "patio": ["p-ae1 t-iy ow", "nn"],
  "patriarch": ["p-ey1 t-r-iy aa-r-k", "nn"],
  "patriarchal": ["p-ey t-r-iy aa1-r k-ah-l", "jj"],
  "patriarchy": ["p-ey1 t-r-iy aa-r k-iy", "nn"],
  "patrimony": ["p-ae1 t-r-ah m-ow n-iy", "nn"],
  "patriot": ["p-ey1 t-r-iy ah-t", "nn"],
  "patriotic": ["p-ey t-r-iy aa1 t-ih-k", "jj nn"],
  "patriotism": ["p-ey1 t-r-iy ah t-ih z-ah-m", "nn"],
  "patrol": ["p-ah t-r-ow1-l", "nn vbp vb"],
  "patrolman": ["p-ah t-r-ow1-l m-ae-n", "nn"],
  "patron": ["p-ey1 t-r-ah-n", "nn"],
  "patronage": ["p-ae1 t-r-ah n-ih-jh", "nn"],
  "patronize": ["p-ey1 t-r-ah n-ay-z", "vb"],
  "patronizing": ["p-ey1 t-r-ah n-ay z-ih-ng", "vbg jj"],
  "patsy": ["p-ae1-t s-iy", "nn"],
  "patter": ["p-ae1 t-er", "nn vb"],
  "pattern": ["p-ae1 t-er-n", "nn vb"],
  "patterned": ["p-ae1 t-er-n-d", "vbn jj"],
  "patty": ["p-ae1 t-iy", "nn"],
  "paucity": ["p-ao1 s-ah t-iy", "nn"],
  "paunchy": ["p-ao1-n ch-iy", "jj"],
  "pauper": ["p-ao1 p-er", "nn"],
  "pause": ["p-ao1-z", "nn vbp vb"],
  "pave": ["p-ey1-v", "vb"],
  "paved": ["p-ey1-v-d", "jj vbd vbn"],
  "pavement": ["p-ey1-v m-ah-n-t", "nn"],
  "pavilion": ["p-ah v-ih1-l y-ah-n", "nn"],
  "paw": ["p-ao1", "nn vb"],
  "pawn": ["p-ao1-n", "nn vb"],
  "pawnshop": ["p-ao1-n sh-aa-p", "nn"],
  "pay": ["p-ey1", "vb vbp nn"],
  "payable": ["p-ey1 ah b-ah-l", "jj"],
  "payback": ["p-ey1 b-ae-k", "nn"],
  "paycheck": ["p-ey1 ch-eh-k", "nn"],
  "payday": ["p-ey1 d-ey", "nn"],
  "payer": ["p-ey1 er", "nn"],
  "paying": ["p-ey1 ih-ng", "vbg jj"],
  "payload": ["p-ey1 l-ow-d", "nn"],
  "payment": ["p-ey1 m-ah-n-t", "nn"],
  "payoff": ["p-ey1 ao-f", "nn"],
  "payola": ["p-ey ow1 l-ah", "nn"],
  "payout": ["p-ey1 aw-t", "nn"],
  "payroll": ["p-ey1 r-ow-l", "nn"],
  "pea": ["p-iy1", "nn"],
  "peace": ["p-iy1-s", "nn"],
  "peaceable": ["p-iy1 s-ah b-ah-l", "jj"],
  "peaceful": ["p-iy1-s f-ah-l", "jj"],
  "peacefully": ["p-iy1-s f-ah l-iy", "rb"],
  "peacekeeping": ["p-iy1-s k-iy p-ih-ng", "jj"],
  "peacemaker": ["p-iy1-s m-ey k-er", "nn"],
  "peacemaking": ["p-iy1-s m-ey k-ih-ng", "nn jj"],
  "peacetime": ["p-iy1-s t-ay-m", "nn"],
  "peach": ["p-iy1-ch", "nn"],
  "peacock": ["p-iy1 k-aa-k", "nn"],
  "peak": ["p-iy1-k", "nn vbp jj vb"],
  "peaked": ["p-iy1-k-t", "vbd jj vbn"],
  "peal": ["p-iy1-l", "nn"],
  "peanut": ["p-iy1 n-ah-t", "nn jj"],
  "pear": ["p-eh1-r", "nn"],
  "pearl": ["p-er1-l", "nn"],
  "pearly": ["p-er1 l-iy", "jj"],
  "peasant": ["p-eh1 z-ah-n-t", "nn jj"],
  "pebble": ["p-eh1 b-ah-l", "nn"],
  "pecan": ["p-ah k-aa1-n", "nn"],
  "peck": ["p-eh1-k", "vbp nn vb"],
  "peculiar": ["p-ah k-y-uw1 l-y-er", "jj nn"],
  "peculiarity": ["p-ih k-y-uw l-iy eh1 r-ah t-iy", "nn"],
  "peculiarly": ["p-ih k-y-uw1 l-y-er l-iy", "rb"],
  "pecuniary": ["p-eh k-y-uw1 n-iy eh r-iy", "jj"],
  "pedagogical": ["p-eh d-ah g-aa1 jh-ih k-ah-l", "jj"],
  "pedal": ["p-eh1 d-ah-l", "vb nn"],
  "pedantic": ["p-ah d-ae1-n t-ih-k", "jj"],
  "peddle": ["p-eh1 d-ah-l", "vb vbp"],
  "peddler": ["p-eh1-d l-er", "nn"],
  "peddling": ["p-eh1 d-ah-l ih-ng", "vbg jj nn"],
  "pedestal": ["p-eh1 d-ah s-t-ah-l", "nn"],
  "pedestrian": ["p-ah d-eh1-s t-r-iy ah-n", "jj nn"],
  "pediatric": ["p-iy d-iy ae1 t-r-ih-k", "jj"],
  "pediatrician": ["p-iy d-iy ah t-r-ih1 sh-ah-n", "nn"],
  "pediatrics": ["p-iy d-iy ae1 t-r-ih-k-s", "nn"],
  "pedigree": ["p-eh1 d-ah g-r-iy", "nn"],
  "peed": ["p-iy1-d", "vbn"],
  "peek": ["p-iy1-k", "nn vb"],
  "peel": ["p-iy1-l", "vb"],
  "peep": ["p-iy1-p", "nn vb"],
  "peer": ["p-ih1-r", "nn vbp vb"],
  "peerless": ["p-ih1-r l-ih-s", "jj"],
  "peg": ["p-eh1-g", "vbp nn vb"],
  "pegboard": ["p-eh1-g b-ao-r-d", "nn"],
  "pegged": ["p-eh1-g-d", "vbn vbd jj"],
  "pejorative": ["p-ah jh-ao1 r-ah t-ih-v", "jj"],
  "pellet": ["p-eh1 l-ah-t", "nn"],
  "pelt": ["p-eh1-l-t", "nn"],
  "pelvic": ["p-eh1-l v-ih-k", "jj nn"],
  "pelvis": ["p-eh1-l v-ah-s", "nn"],
  "pen": ["p-eh1-n", "nn vb"],
  "penal": ["p-iy1 n-ah-l", "jj"],
  "penalize": ["p-eh1 n-ah l-ay-z", "vb vbp"],
  "penalty": ["p-eh1 n-ah-l t-iy", "nn"],
  "penance": ["p-eh1 n-ah-n-s", "nn"],
  "pence": ["p-eh1-n-s", "nn"],
  "penchant": ["p-eh1-n ch-ah-n-t", "nn"],
  "pencil": ["p-eh1-n s-ah-l", "nn vb"],
  "pendant": ["p-eh1-n d-ah-n-t", "nn"],
  "pending": ["p-eh1-n d-ih-ng", "vbg jj"],
  "pendulum": ["p-eh1-n jh-ah l-ah-m", "nn"],
  "penetrate": ["p-eh1 n-ah t-r-ey-t", "vb vbp"],
  "penetrating": ["p-eh1 n-ah t-r-ey t-ih-ng", "jj vbg"],
  "penetration": ["p-eh n-ah t-r-ey1 sh-ah-n", "nn"],
  "penicillin": ["p-eh n-ah s-ih1 l-ah-n", "nn"],
  "peninsula": ["p-ah n-ih1-n s-ah l-ah", "nn"],
  "penitentiary": ["p-eh n-ih t-eh1-n ch-er iy", "nn"],
  "penman": ["p-eh1-n m-ah-n", "nn"],
  "pennant": ["p-eh1 n-ah-n-t", "nn"],
  "penniless": ["p-eh1 n-iy l-ah-s", "jj"],
  "penny": ["p-eh1 n-iy", "nn"],
  "pension": ["p-eh1-n sh-ah-n", "nn"],
  "pensioner": ["p-eh1-n sh-ah n-er", "nn"],
  "pentagon": ["p-eh1-n t-ih g-aa-n", "nn"],
  "penthouse": ["p-eh1-n-t hh-aw-s", "nn"],
  "peony": ["p-iy1 ah n-iy", "nn"],
  "people": ["p-iy p-ah-l", "nn"],
  "pepper": ["p-eh1 p-er", "nn vb"],
  "peppered": ["p-eh1 p-er-d", "vbd vbn jj"],
  "peppermint": ["p-eh1 p-er m-ih-n-t", "nn"],
  "pepperoni": ["p-eh p-er ow1 n-iy", "nn"],
  "peppy": ["p-eh1 p-iy", "jj"],
  "perceive": ["p-er s-iy1-v", "vb vbp"],
  "perceived": ["p-er s-iy1-v-d", "vbn vbd jj"],
  "percent": ["p-er s-eh1-n-t", "nn"],
  "percentage": ["p-er s-eh1-n t-ah-jh", "nn"],
  "perceptible": ["p-er s-eh1-p t-ah b-ah-l", "jj"],
  "perception": ["p-er s-eh1-p sh-ah-n", "nn"],
  "perceptive": ["p-er s-eh1-p t-ih-v", "jj"],
  "perceptual": ["p-er s-eh1-p ch-ah w-ah-l", "jj"],
  "perch": ["p-er1-ch", "nn vb"],
  "perchlorate": ["p-er k-l-ao1 r-ey-t", "nn"],
  "percussion": ["p-er k-ah1 sh-ah-n", "nn"],
  "percussionist": ["p-er k-ah1 sh-ah n-ih-s-t", "nn"],
  "peremptory": ["p-er eh1-m-p t-er iy", "jj"],
  "perennial": ["p-er eh1 n-iy ah-l", "jj"],
  "perennially": ["p-er eh1 n-iy ah l-iy", "rb"],
  "perestroika": ["p-eh r-ah s-t-r-oy1 k-ah", "nn"],
  "perfect": ["p-er f-eh1-k-t", "jj nn vb"],
  "perfection": ["p-er f-eh1-k sh-ah-n", "nn"],
  "perfectionism": ["p-er f-eh1-k sh-ah n-ih z-ah-m", "nn"],
  "perfectly": ["p-er1 f-ah-k-t l-iy", "rb"],
  "perfidy": ["p-er1 f-ih d-iy", "nn"],
  "perforated": ["p-er1 f-er ey t-ah-d", "jj"],
  "perforation": ["p-er f-er ey1 sh-ah-n", "nn"],
  "perforce": ["p-er f-ao1-r-s", "rb"],
  "perform": ["p-er f-ao1-r-m", "vb vbp"],
  "performance": ["p-er f-ao1-r m-ah-n-s", "nn"],
  "performer": ["p-er f-ao1-r m-er", "nn jj"],
  "performing": ["p-er f-ao1-r m-ih-ng", "vbg jj"],
  "perfume": ["p-er f-y-uw1-m", "nn vb"],
  "perfumed": ["p-er f-y-uw1-m-d", "jj vbn"],
  "perfunctory": ["p-er f-ah1-ng-k t-er iy", "jj"],
  "perhaps": ["p-er hh-ae1-p-s", "rb"],
  "peril": ["p-eh1 r-ah-l", "nn"],
  "perilous": ["p-eh1 r-ah l-ah-s", "jj"],
  "perilously": ["p-eh1 r-ah l-ah-s l-iy", "rb"],
  "perimeter": ["p-er ih1 m-ah t-er", "nn"],
  "period": ["p-ih1 r-iy ah-d", "nn"],
  "periodic": ["p-ih r-iy aa1 d-ih-k", "jj"],
  "periodical": ["p-ih r-iy aa1 d-ih k-ah-l", "nn"],
  "periodically": ["p-iy r-iy aa1 d-ih k-ah l-iy", "rb"],
  "periodontal": ["p-eh r-iy ah d-aa1-n t-ah-l", "jj"],
  "peripheral": ["p-er ih1 f-er ah-l", "jj"],
  "periphery": ["p-er ih1 f-er iy", "nn"],
  "perish": ["p-eh1 r-ih-sh", "vb"],
  "perishable": ["p-eh1 r-ih sh-ah b-ah-l", "jj"],
  "perjury": ["p-er1 jh-er iy", "nn"],
  "perk": ["p-er1-k", "jj vb"],
  "perky": ["p-er1 k-iy", "jj"],
  "permanence": ["p-er1 m-ah n-ah-n-s", "nn"],
  "permanent": ["p-er1 m-ah n-ah-n-t", "jj"],
  "permanently": ["p-er1 m-ah n-ah-n-t l-iy", "rb"],
  "permeate": ["p-er1 m-iy ey-t", "vb"],
  "permissible": ["p-er m-ih1 s-ah b-ah-l", "jj nn"],
  "permission": ["p-er m-ih1 sh-ah-n", "nn"],
  "permissive": ["p-er m-ih1 s-ih-v", "jj"],
  "permit": ["p-er m-ih1-t", "vb vbp nn"],
  "permitted": ["p-er m-ih1 t-ah-d", "vbn jj vbd"],
  "pernicious": ["p-er n-ih1 sh-ah-s", "jj"],
  "peroxide": ["p-er aa1-k s-ay-d", "nn"],
  "perpendicular": ["p-er p-ah-n d-ih1 k-y-ah l-er", "jj"],
  "perpetrate": ["p-er1 p-ah t-r-ey-t", "vb"],
  "perpetrator": ["p-er1 p-ah t-r-ey t-er", "nn"],
  "perpetual": ["p-er p-eh1 ch-uw ah-l", "jj"],
  "perpetually": ["p-er p-eh1 ch-uw ah l-iy", "rb"],
  "perpetuate": ["p-er p-eh1 ch-ah-w ey-t", "vb vbp"],
  "perpetuation": ["p-er p-eh ch-ah-w ey1 sh-ah-n", "nn"],
  "perpetuity": ["p-er p-ih t-y-uw1 ih t-iy", "nn"],
  "perplex": ["p-er-p-l-eh1-k-s", "vb"],
  "perplexed": ["p-er p-l-eh1-k-s-t", "jj vbn"],
  "perplexing": ["p-er p-l-eh1-k s-ih-ng", "jj"],
  "perplexity": ["p-er p-l-eh1-k s-ah t-iy", "nn"],
  "perquisite": ["p-er1 k-w-ah z-ih-t", "nn"],
  "persecute": ["p-er1 s-ah k-y-uw-t", "vb vbp"],
  "persecution": ["p-er s-ah k-y-uw1 sh-ah-n", "nn"],
  "perseverance": ["p-er s-ah v-ih1 r-ah-n-s", "nn"],
  "persevere": ["p-er s-ah v-ih1-r", "vb vbp"],
  "pershare": ["p-er sh-eh1-r", "jj"],
  "persist": ["p-er s-ih1-s-t", "vb vbp"],
  "persistence": ["p-er s-ih1 s-t-ah-n-s", "nn jj"],
  "persistent": ["p-er s-ih1 s-t-ah-n-t", "jj nn"],
  "persistently": ["p-er s-ih1 s-t-ah-n-t l-iy", "rb"],
  "persisting": ["p-er s-ih1 s-t-ih-ng", "vbg jj"],
  "person": ["p-er1 s-ah-n", "nn"],
  "persona": ["p-er s-ow1 n-ah", "nn"],
  "personal": ["p-er1 s-ih n-ih-l", "jj nn"],
  "personality": ["p-er s-ah n-ae1 l-ih t-iy", "nn"],
  "personalize": ["p-er1 s-ah-n ah l-ay-z", "vb"],
  "personalized": ["p-er1 s-ah-n ah l-ay-z-d", "vbn jj"],
  "personally": ["p-er1 s-ah-n ah l-iy", "rb"],
  "personification": ["p-er s-aa n-ah f-ah k-ey1 sh-ah-n", "nn"],
  "personify": ["p-er-s-aa1-n-ah-f-ay", "vb"],
  "personnel": ["p-er s-ah n-eh1-l", "jj nn"],
  "perspective": ["p-er s-p-eh1-k t-ih-v", "nn jj"],
  "perspiration": ["p-er s-p-er ey1 sh-ah-n", "nn"],
  "persuade": ["p-er s-w-ey1-d", "vb vbp"],
  "persuasion": ["p-er s-w-ey1 zh-ah-n", "nn"],
  "persuasive": ["p-er s-w-ey1 s-ih-v", "jj"],
  "persuasively": ["p-er s-w-ey1 s-ih-v l-iy", "rb"],
  "persuasiveness": ["p-er s-w-ey1 s-ih-v n-ah-s", "nn"],
  "pert": ["p-er1-t", "jj"],
  "pertain": ["p-er t-ey1-n", "vbp vb"],
  "pertinent": ["p-er1 t-ah n-ah-n-t", "jj"],
  "perturb": ["p-er-t-er1-b", "vb"],
  "perturbation": ["p-er t-er b-ey1 sh-ah-n", "nn"],
  "perturbed": ["p-er t-er1-b-d", "jj vbd vbn"],
  "perusal": ["p-er uw1 z-ah-l", "nn"],
  "peruse": ["p-er uw1-z", "vb vbp"],
  "pervade": ["p-er v-ey1-d", "vb vbp"],
  "pervasive": ["p-er v-ey1 s-ih-v", "jj"],
  "pervasiveness": ["p-er v-ey1 s-ih-v n-ih-s", "nn"],
  "perverse": ["p-er v-er1-s", "jj"],
  "perversely": ["p-er v-er1-s l-iy", "rb"],
  "perversion": ["p-er v-er1 zh-ah-n", "nn"],
  "pervert": ["p-er1 v-er-t", "nn vb"],
  "perverted": ["p-er v-er1 t-ih-d", "vbn jj vbd"],
  "peso": ["p-ey1 s-ow", "nn"],
  "pessimism": ["p-eh1 s-ah m-ih z-ah-m", "nn"],
  "pessimist": ["p-eh1 s-ah m-ah-s-t", "nn"],
  "pessimistic": ["p-eh s-ah m-ih1 s-t-ih-k", "jj"],
  "pest": ["p-eh1-s-t", "nn jjs"],
  "pester": ["p-eh1 s-t-er", "vb"],
  "pesticide": ["p-eh1 s-t-ah s-ay-d", "nn"],
  "pestilence": ["p-eh1 s-t-ah l-ah-n-s", "nn"],
  "pet": ["p-eh1-t", "nn vb jj"],
  "petal": ["p-eh1 t-ah-l", "nn"],
  "peter": ["p-iy1 t-er", "vb"],
  "petite": ["p-ah t-iy1-t", "jj"],
  "petition": ["p-ah t-ih1 sh-ah-n", "nn vb"],
  "petitioner": ["p-ah t-ih1 sh-ah-n er", "nn"],
  "petrified": ["p-eh1 t-r-ah f-ay-d", "jj vbn"],
  "petrify": ["p-eh1-t-r-ah-f-ay", "vb"],
  "petrochemical": ["p-eh t-r-ow k-eh1 m-ih k-ah-l", "nn jj"],
  "petroleum": ["p-ah t-r-ow1 l-iy ah-m", "nn"],
  "pettiness": ["p-eh1 t-iy n-ah-s", "nn"],
  "petting": ["p-eh1 t-ih-ng", "nn"],
  "petty": ["p-eh1 t-iy", "jj"],
  "petulance": ["p-eh1 ch-ah l-ah-n-s", "nn"],
  "petulant": ["p-eh1 ch-ah l-ah-n-t", "jj"],
  "pew": ["p-y-uw1", "nn"],
  "pewter": ["p-y-uw1 t-er", "nn"],
  "phalanx": ["f-ey1 l-ae-ng-k-s", "nn"],
  "phantom": ["f-ae1-n t-ah-m", "jj nn"],
  "pharmaceutical": ["f-aa-r m-ah s-uw1 t-ih k-ah-l", "jj nn"],
  "pharmacist": ["f-aa1-r m-ah s-ih-s-t", "nn"],
  "pharmacological": ["f-aa-r m-ah k-ah l-aa1 jh-ih k-ah-l", "jj"],
  "pharmacology": ["f-aa-r m-ah k-aa1 l-ah jh-iy", "nn"],
  "pharmacy": ["f-aa1-r m-ah s-iy", "nn"],
  "phase": ["f-ey1-z", "nn vb"],
  "pheasant": ["f-eh1 z-ah-n-t", "nn"],
  "phenolic": ["f-ah n-aa1 l-ih-k", "nn jj"],
  "phenomenal": ["f-ah n-aa1 m-ah n-ah-l", "jj"],
  "phenomenally": ["f-ah n-aa1 m-ah n-ah l-iy", "rb"],
  "phenomenon": ["f-ah n-aa1 m-ah n-aa-n", "nn"],
  "philander": ["f-ah-l-ae1-n-d-er", "vb"],
  "philanthropic": ["f-ih l-ah-n th-r-aa1 p-ih-k", "jj"],
  "philanthropist": ["f-ah l-ae1-n th-r-ah p-ah-s-t", "nn"],
  "philanthropy": ["f-ih l-ae1-n th-r-ah p-iy", "nn"],
  "philharmonic": ["f-ih l-hh-aa-r m-aa1 n-ih-k", "nn"],
  "philodendron": ["f-ih l-ah d-eh1-n d-r-ah-n", "nn"],
  "philosopher": ["f-ah l-aa1 s-ah f-er", "nn"],
  "philosophic": ["f-ih l-ah s-aa1 f-ih-k", "jj"],
  "philosophical": ["f-ih l-ah s-aa1 f-ih k-ah-l", "jj"],
  "philosophically": ["f-ih l-ah s-aa1 f-ih k-ah l-iy", "rb"],
  "philosophy": ["f-ah l-aa1 s-ah f-iy", "nn"],
  "phobia": ["f-ow1 b-iy ah", "nn"],
  "phoenix": ["f-iy1 n-ih-k-s", "nn"],
  "phone": ["f-ow1-n", "nn vb vbp"],
  "phonetic": ["f-ah n-eh1 t-ih-k", "jj"],
  "phoney": ["f-ow1 n-iy", "jj"],
  "phonic": ["f-aa1 n-ih-k", "jj"],
  "phonograph": ["f-ow1 n-ah g-r-ae-f", "nn"],
  "phony": ["f-ow1 n-iy", "jj nn"],
  "phosphate": ["f-aa1-s f-ey-t", "nn"],
  "phosphor": ["f-aa1-s f-ao-r", "nn"],
  "photo": ["f-ow1 t-ow", "nn jj"],
  "photocopier": ["f-ow1 t-ow k-aa p-iy er", "nn"],
  "photocopy": ["f-ow1 t-ow k-aa p-iy", "vb"],
  "photogenic": ["f-ow t-ah jh-eh1 n-ih-k", "jj"],
  "photograph": ["f-ow1 t-ah g-r-ae-f", "nn vb"],
  "photographer": ["f-ah t-aa1 g-r-ah f-er", "nn"],
  "photographic": ["f-ow t-ah g-r-ae1 f-ih-k", "jj"],
  "photography": ["f-ah t-aa1 g-r-ah f-iy", "nn"],
  "photosynthesis": ["f-ow t-ow s-ih1-n th-ah s-ih-s", "nn"],
  "phrase": ["f-r-ey1-z", "nn vb"],
  "phrasing": ["f-r-ey1 z-ih-ng", "nn"],
  "phyla": ["f-ay1 l-ah", "nn"],
  "physical": ["f-ih1 z-ih k-ah-l", "jj nn"],
  "physically": ["f-ih1 z-ih k-ah l-iy", "rb"],
  "physician": ["f-ah z-ih1 sh-ah-n", "nn"],
  "physicist": ["f-ih1 z-ih s-ih-s-t", "nn"],
  "physics": ["f-ih1 z-ih-k-s", "nn"],
  "physiological": ["f-ih z-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "physiology": ["f-ih z-iy aa1 l-ah jh-iy", "nn"],
  "physique": ["f-ah z-iy1-k", "nn"],
  "pi": ["p-ay1", "nn"],
  "pianist": ["p-iy ae1 n-ah-s-t", "nn"],
  "piano": ["p-iy ae1 n-ow", "nn"],
  "piazza": ["p-iy ae1 z-ah", "nn"],
  "picayune": ["p-ih k-iy y-uw1-n", "jj"],
  "pick": ["p-ih1-k", "vb vbp nn"],
  "picker": ["p-ih1 k-er", "nn"],
  "picket": ["p-ih1 k-ah-t", "nn vb"],
  "picketer": ["p-ih1 k-ah t-er", "nn"],
  "pickier": ["p-ih1 k-iy er", "jjr"],
  "pickle": ["p-ih1 k-ah-l", "nn"],
  "pickled": ["p-ih1 k-ah-l-d", "jj"],
  "pickpocket": ["p-ih1-k p-aa k-ah-t", "nn"],
  "pickup": ["p-ih1 k-ah-p", "nn jj"],
  "picky": ["p-ih1 k-iy", "jj"],
  "picnic": ["p-ih1-k n-ih-k", "nn"],
  "pico": ["p-iy1 k-ow", "nn"],
  "pictorial": ["p-ih-k t-ao1 r-iy ah-l", "jj"],
  "picture": ["p-ih1-k ch-er", "nn vb vbp"],
  "picturesque": ["p-ih1-k ch-er ah-s-k", "jj nn"],
  "piddling": ["p-ih1 d-ah-l ih-ng", "jj"],
  "pie": ["p-ay1", "nn rp"],
  "piece": ["p-iy1-s", "nn vb"],
  "piecemeal": ["p-iy1-s m-iy-l", "rb nn"],
  "pier": ["p-ih1-r", "nn"],
  "pierce": ["p-ih1-r-s", "vb"],
  "piercing": ["p-ih1-r s-ih-ng", "vbg jj"],
  "piety": ["p-ay1 ah t-iy", "nn"],
  "pig": ["p-ih1-g", "nn"],
  "pigeon": ["p-ih1 jh-ah-n", "nn"],
  "piggyback": ["p-ih1 g-iy b-ae-k", "nn vb"],
  "pigment": ["p-ih1-g m-ah-n-t", "nn"],
  "pigskin": ["p-ih1-g s-k-ih-n", "nn"],
  "pike": ["p-ay1-k", "nn"],
  "piker": ["p-ay1 k-er", "nn"],
  "pile": ["p-ay1-l", "nn vbp vb"],
  "piled": ["p-ay1-l-d", "vbd vbn jj"],
  "piles": ["p-ay1-l-z", "nn"],
  "pileup": ["p-ay1 l-ah-p", "nn"],
  "pilfer": ["p-ih1-l-f-er", "vb"],
  "pilgrim": ["p-ih1-l g-r-ah-m", "nn"],
  "pilgrimage": ["p-ih1-l g-r-ah m-ah-jh", "nn"],
  "piling": ["p-ay1 l-ih-ng", "vbg nn"],
  "pill": ["p-ih1-l", "nn"],
  "pillage": ["p-ih1 l-ih-jh", "vb"],
  "pillar": ["p-ih1 l-er", "nn"],
  "pillory": ["p-ih1-l-er-iy", "vb"],
  "pillow": ["p-ih1 l-ow", "nn"],
  "pilot": ["p-ay1 l-ah-t", "nn jj vb"],
  "pimp": ["p-ih1-m-p", "nn"],
  "pimple": ["p-ih1-m p-ah-l", "nn"],
  "pin": ["p-ih1-n", "nn vbp vb"],
  "pinball": ["p-ih1-n b-ao-l", "nn"],
  "pinch": ["p-ih1-n-ch", "nn vb"],
  "pinched": ["p-ih1-n-ch-t", "vbn vbd jj"],
  "pine": ["p-ay1-n", "nn vb vbp"],
  "pineapple": ["p-ay1-n ae p-ah-l", "nn"],
  "ping": ["p-ih1-ng", "nn vb"],
  "pinhole": ["p-ih1-n hh-ow-l", "nn"],
  "pink": ["p-ih1-ng-k", "jj nn"],
  "pinnacle": ["p-ih1 n-ah k-ah-l", "nn"],
  "pinpoint": ["p-ih1-n p-oy-n-t", "vb nn vbp"],
  "pinpointed": ["p-ih1-n p-oy-n t-ih-d", "vbn jj vbd"],
  "pint": ["p-ay1-n-t", "nn"],
  "pinto": ["p-ih1-n t-ow", "nn"],
  "pioneer": ["p-ay ah n-ih1-r", "nn vb"],
  "pioneering": ["p-ay ah n-ih1 r-ih-ng", "vbg jj"],
  "pious": ["p-ay1 ah-s", "jj"],
  "piously": ["p-ay1 ah-s l-iy", "rb"],
  "pipe": ["p-ay1-p", "nn vb"],
  "pipeline": ["p-ay1-p l-ay-n", "nn"],
  "piper": ["p-ay1 p-er", "nn"],
  "piping": ["p-ay1 p-ih-ng", "nn"],
  "piquant": ["p-iy1 k-ah-n-t", "jj"],
  "pique": ["p-iy1-k", "jj nn vb"],
  "piracy": ["p-ay1 r-ah s-iy", "nn"],
  "piranha": ["p-ih r-ae1-n-hh ah", "nn"],
  "pirate": ["p-ay1 r-ah-t", "nn vb"],
  "piss": ["p-ih1-s", "vb"],
  "pistachio": ["p-ah s-t-ae1 sh-iy ow", "jj"],
  "pistol": ["p-ih1 s-t-ah-l", "nn"],
  "piston": ["p-ih1 s-t-ah-n", "nn"],
  "pit": ["p-ih1-t", "nn vbp vb"],
  "pitch": ["p-ih1-ch", "nn jj vb vbp"],
  "pitched": ["p-ih1-ch-t", "vbd jj vbn"],
  "pitcher": ["p-ih1 ch-er", "nn"],
  "pitchfork": ["p-ih1-ch f-ao-r-k", "nn"],
  "pitfall": ["p-ih1-t f-ao-l", "nn"],
  "pith": ["p-ih1-th", "nn"],
  "pithy": ["p-ih1 th-iy", "jj"],
  "pitiable": ["p-ih1 t-iy ah b-ah-l", "jj"],
  "pitiful": ["p-ih1 t-ah f-ah-l", "jj"],
  "pitifully": ["p-ih1 t-ih f-ah l-iy", "rb"],
  "pitiless": ["p-ih1 t-iy l-ah-s", "jj"],
  "pittance": ["p-ih1 t-ah-n-s", "nn"],
  "pity": ["p-ih1 t-iy", "nn vb vbp"],
  "pivot": ["p-ih1 v-ah-t", "jj nn vb"],
  "pivotal": ["p-ih1 v-ah t-ah-l", "jj"],
  "pizza": ["p-iy1-t s-ah", "nn"],
  "pizzazz": ["p-ih z-ae1-z", "nn"],
  "pizzeria": ["p-iy-t s-er iy1 ah", "nn"],
  "placard": ["p-l-ae1 k-er-d", "nn"],
  "placate": ["p-l-ey1 k-ey-t", "vb"],
  "place": ["p-l-ey1-s", "nn vbp rb vb"],
  "placebo": ["p-l-ah s-iy1 b-ow", "nn"],
  "placement": ["p-l-ey1-s m-ah-n-t", "nn"],
  "placid": ["p-l-ae1 s-ah-d", "jj"],
  "plagiarism": ["p-l-ey1 jh-er ih z-ah-m", "nn"],
  "plagiarize": ["p-l-ey1-jh-er-ay-z", "vb"],
  "plague": ["p-l-ey1-g", "nn vb vbp"],
  "plaid": ["p-l-ae1-d", "jj nn"],
  "plain": ["p-l-ey1-n", "jj nn rb"],
  "plainer": ["p-l-ey1 n-er", "jjr"],
  "plainly": ["p-l-ey1-n l-iy", "rb"],
  "plaintiff": ["p-l-ey1-n t-ah-f", "nn"],
  "plaintive": ["p-l-ey1-n t-ih-v", "jj"],
  "plaintively": ["p-l-ey1-n t-ay-v l-iy", "rb"],
  "plan": ["p-l-ae1-n", "nn vb vbp"],
  "planar": ["p-l-ey1 n-er", "jj"],
  "plane": ["p-l-ey1-n", "nn vb"],
  "planeload": ["p-l-ey1-n l-ow-d", "nn"],
  "planer": ["p-l-ey1 n-er", "nn"],
  "planet": ["p-l-ae1 n-ah-t", "nn"],
  "planetarium": ["p-l-ae n-ah t-eh1 r-iy ah-m", "nn"],
  "planetary": ["p-l-ae1 n-ah t-eh r-iy", "jj"],
  "plank": ["p-l-ae1-ng-k", "nn"],
  "planking": ["p-l-ae1-ng k-ih-ng", "nn"],
  "planned": ["p-l-ae1-n-d", "vbn jj vbd"],
  "planner": ["p-l-ae1 n-er", "nn"],
  "plant": ["p-l-ae1-n-t", "nn vb"],
  "plantain": ["p-l-ae1-n t-ah-n", "nn"],
  "plantation": ["p-l-ae-n t-ey1 sh-ah-n", "nn"],
  "planted": ["p-l-ae1-n t-ah-d", "vbn jj vbd"],
  "planter": ["p-l-ae1-n t-er", "nn"],
  "plaque": ["p-l-ae1-k", "nn"],
  "plasma": ["p-l-ae1-z m-ah", "nn"],
  "plaster": ["p-l-ae1 s-t-er", "nn vb"],
  "plastered": ["p-l-ae1 s-t-er-d", "vbn jj"],
  "plasterer": ["p-l-ae1 s-t-er er", "nn"],
  "plastering": ["p-l-ae1 s-t-er ih-ng", "nn"],
  "plastic": ["p-l-ae1 s-t-ih-k", "nn jj"],
  "plate": ["p-l-ey1-t", "nn vb"],
  "plateau": ["p-l-ae t-ow1", "nn"],
  "platform": ["p-l-ae1-t f-ao-r-m", "nn"],
  "platinum": ["p-l-ae1-t n-ah-m", "nn"],
  "platitude": ["p-l-ae1 t-ih t-uw-d", "nn"],
  "platoon": ["p-l-ah t-uw1-n", "nn"],
  "platter": ["p-l-ae1 t-er", "jj nn"],
  "plaudit": ["p-l-ao1 d-ih-t", "nn"],
  "plausibility": ["p-l-ao z-ih b-ih1 l-ih t-iy", "nn"],
  "plausible": ["p-l-ao1 z-ah b-ah-l", "jj nn"],
  "plausibly": ["p-l-ao1 z-ah b-l-iy", "rb"],
  "play": ["p-l-ey1", "vb nn vbp"],
  "playback": ["p-l-ey1 b-ae-k", "nn"],
  "playboy": ["p-l-ey1 b-oy", "nn"],
  "player": ["p-l-ey1 er", "nn"],
  "playful": ["p-l-ey1 f-ah-l", "jj"],
  "playfully": ["p-l-ey1 f-ah l-iy", "rb"],
  "playfulness": ["p-l-ey1 f-ah-l n-ah-s", "nn"],
  "playground": ["p-l-ey1 g-r-aw-n-d", "nn"],
  "playhouse": ["p-l-ey1 hh-aw-s", "nn"],
  "playing": ["p-l-ey1 ih-ng", "vbg jj nn"],
  "playmate": ["p-l-ey1 m-ey-t", "nn"],
  "playoff": ["p-l-ey1 ao-f", "nn"],
  "playpen": ["p-l-ey1 p-eh-n", "nn"],
  "playroom": ["p-l-ey1 r-uw-m", "nn"],
  "plaything": ["p-l-ey1 th-ih-ng", "nn"],
  "playwright": ["p-l-ey1 r-ay-t", "nn"],
  "plaza": ["p-l-aa1 z-ah", "nn"],
  "plea": ["p-l-iy1", "nn"],
  "plead": ["p-l-iy1-d", "vb vbp"],
  "pleading": ["p-l-iy1 d-ih-ng", "vbg jj"],
  "pleasant": ["p-l-eh1 z-ah-n-t", "jj"],
  "pleasantly": ["p-l-eh1 z-ah-n-t l-iy", "rb"],
  "pleasantry": ["p-l-eh1 z-ah-n t-r-iy", "nn"],
  "please": ["p-l-iy1-z", "vb uh vbp"],
  "pleased": ["p-l-iy1-z-d", "vbn jj vbd"],
  "pleasing": ["p-l-iy1 z-ih-ng", "jj vbg"],
  "pleasingly": ["p-l-iy1 z-ih-ng l-iy", "rb"],
  "pleasurable": ["p-l-eh1 zh-er ah b-ah-l", "jj"],
  "pleasure": ["p-l-eh1 zh-er", "nn jj vb"],
  "pleat": ["p-l-iy1-t", "nn"],
  "pled": ["p-l-eh1-d", "vbd"],
  "pledge": ["p-l-eh1-jh", "nn vb"],
  "plenary": ["p-l-eh1 n-er iy", "jj"],
  "plentiful": ["p-l-eh1-n t-ah f-ah-l", "jj"],
  "plenty": ["p-l-eh1-n t-iy", "nn jj rb"],
  "plenum": ["p-l-eh1 n-ah-m", "nn"],
  "plethora": ["p-l-eh1 th-er ah", "nn"],
  "pliable": ["p-l-ay1 ah b-ah-l", "jj"],
  "pliant": ["p-l-ay1 ah-n-t", "jj"],
  "plight": ["p-l-ay1-t", "nn"],
  "plinking": ["p-l-ih1-ng k-ih-ng", "jj"],
  "plod": ["p-l-aa1-d", "vb"],
  "plop": ["p-l-aa1-p", "vb"],
  "plot": ["p-l-aa1-t", "nn vb vbp"],
  "plotter": ["p-l-aa1 t-er", "nn"],
  "plough": ["p-l-aw1", "vb"],
  "plow": ["p-l-aw1", "nn vbp vb"],
  "plowed": ["p-l-aw1-d", "vbn vbd jj"],
  "ploy": ["p-l-oy1", "nn"],
  "pluck": ["p-l-ah1-k", "vb nn"],
  "plucky": ["p-l-ah1 k-iy", "jj"],
  "plug": ["p-l-ah1-g", "nn vbp vb"],
  "plum": ["p-l-ah1-m", "nn"],
  "plumage": ["p-l-uw1 m-ah-jh", "nn"],
  "plumb": ["p-l-ah1-m", "rb jj nn vb"],
  "plumber": ["p-l-ah1 m-er", "nn"],
  "plumbing": ["p-l-ah1 m-ih-ng", "nn"],
  "plume": ["p-l-uw1-m", "nn"],
  "plummet": ["p-l-ah1 m-ah-t", "vb nn vbp"],
  "plump": ["p-l-ah1-m-p", "jj vb"],
  "plunder": ["p-l-ah1-n d-er", "nn vb"],
  "plundering": ["p-l-ah1-n d-er ih-ng", "nn"],
  "plunge": ["p-l-ah1-n-jh", "nn vbp vb"],
  "plunk": ["p-l-ah1-ng-k", "vb"],
  "plural": ["p-l-uh1 r-ah-l", "nn jj"],
  "pluralism": ["p-l-uh1 r-ah l-ih z-ah-m", "nn"],
  "pluralistic": ["p-l-uh r-ah l-ih1 s-t-ih-k", "jj"],
  "plurality": ["p-l-er ae1 l-ih t-iy", "nn"],
  "plus": ["p-l-ah1-s", "cc in jj nn rb"],
  "plush": ["p-l-ah1-sh", "jj nn"],
  "plutonium": ["p-l-uw t-ow1 n-iy ah-m", "nn"],
  "ply": ["p-l-ay1", "vbp vb"],
  "plywood": ["p-l-ay1 w-uh-d", "nn"],
  "pneumatic": ["n-uw m-ae1 t-ih-k", "jj"],
  "pneumocystis": ["n-uw m-ow1 s-ih s-t-ih-s", "nn"],
  "pneumonia": ["n-uw m-ow1 n-y-ah", "nn"],
  "poach": ["p-ow1-ch", "vb"],
  "poacher": ["p-ow1 ch-er", "nn"],
  "pocket": ["p-aa1 k-ah-t", "nn vb"],
  "pocketbook": ["p-aa1 k-ah-t b-uh-k", "nn"],
  "pocketful": ["p-aa1 k-ah-t f-uh-l", "nn"],
  "pockmark": ["p-aa1-k-m-aa-r-k", "vb"],
  "pockmarked": ["p-aa1-k m-aa-r-k-t", "jj vbn"],
  "pod": ["p-aa1-d", "nn"],
  "podium": ["p-ow1 d-iy ah-m", "nn"],
  "poem": ["p-ow1 ah-m", "nn"],
  "poet": ["p-ow1 ah-t", "nn"],
  "poetic": ["p-ow eh1 t-ih-k", "jj"],
  "poetry": ["p-ow1 ah t-r-iy", "nn"],
  "pogrom": ["p-ah g-r-aa1-m", "nn"],
  "poignancy": ["p-oy1 n-y-ah-n s-iy", "nn"],
  "poignant": ["p-oy1 n-y-ah-n-t", "jj"],
  "poignantly": ["p-oy1 n-y-ah-n-t l-iy", "rb"],
  "point": ["p-oy1-n-t", "nn vbp rb vb"],
  "pointed": ["p-oy1-n t-ah-d", "vbd vbn jj"],
  "pointedly": ["p-oy1-n t-ih-d l-iy", "rb"],
  "pointer": ["p-oy1-n t-er", "nn"],
  "pointless": ["p-oy1-n-t l-ah-s", "jj"],
  "pointy": ["p-oy1-n t-iy", "jj"],
  "poise": ["p-oy1-z", "nn vb"],
  "poised": ["p-oy1-z-d", "vbn vbd jj"],
  "poison": ["p-oy1 z-ah-n", "nn jj vb"],
  "poisonous": ["p-oy1 z-ah n-ah-s", "jj"],
  "poke": ["p-ow1-k", "nn vb"],
  "poker": ["p-ow1 k-er", "nn"],
  "pokey": ["p-ow1 k-iy", "jj"],
  "polar": ["p-ow1 l-er", "jj"],
  "polarity": ["p-ow l-eh1 r-ah t-iy", "nn"],
  "polarization": ["p-ow l-er ah z-ey1 sh-ah-n", "nn"],
  "polarize": ["p-ow1 l-er ay-z", "vb"],
  "pole": ["p-ow1-l", "nn vb"],
  "polecat": ["p-ow1-l k-ae-t", "nn"],
  "polemic": ["p-ah l-eh1 m-ih-k", "jj"],
  "polemical": ["p-ah l-eh1 m-ah k-ah-l", "jj"],
  "police": ["p-ah l-iy1-s", "nn vb"],
  "policeman": ["p-ah l-iy1-s m-ah-n", "nn"],
  "policewoman": ["p-ah l-iy1-s w-uh m-ah-n", "nn"],
  "policy": ["p-aa1 l-ah s-iy", "nn"],
  "policyholder": ["p-aa1 l-ah s-iy hh-ow-l d-er", "nn"],
  "policymaker": ["p-aa1 l-ah s-iy m-ey k-er", "nn"],
  "policymaking": ["p-aa1 l-ah s-iy m-ey k-ih-ng", "jj"],
  "polio": ["p-ow1 l-iy ow", "nn"],
  "polis": ["p-ow1 l-ah-s", "nn"],
  "polish": ["p-aa1 l-ih-sh", "vb nn"],
  "polished": ["p-aa1 l-ih-sh-t", "vbn jj vbd"],
  "polite": ["p-ah l-ay1-t", "jj"],
  "politely": ["p-ah l-ay1-t l-iy", "rb"],
  "politeness": ["p-ah l-ay1-t n-ah-s", "nn"],
  "politic": ["p-aa1 l-ah t-ih-k", "jj nn"],
  "political": ["p-ah l-ih1 t-ah k-ah-l", "jj"],
  "politically": ["p-ah l-ih1 t-ih k-ah l-iy", "rb"],
  "politician": ["p-aa l-ah t-ih1 sh-ah-n", "nn"],
  "politicize": ["p-ah l-ih1 t-ih s-ay-z", "vb"],
  "politicized": ["p-ah l-ih1 t-ih s-ay-z-d", "vbn jj"],
  "politicking": ["p-aa1 l-ah t-ih k-ih-ng", "nn"],
  "politico": ["p-ah l-ih1 t-ih k-ow", "nn"],
  "politics": ["p-aa1 l-ah t-ih-k-s", "nn"],
  "polity": ["p-aa1 l-ah t-iy", "nn"],
  "polka": ["p-ow1-l k-ah", "nn"],
  "poll": ["p-ow1-l", "nn jj vb"],
  "pollen": ["p-aa1 l-ah-n", "nn"],
  "pollinate": ["p-aa1 l-ah n-ey-t", "vb vbp"],
  "pollination": ["p-aa l-ah n-ey1 sh-ah-n", "nn"],
  "polling": ["p-ow1 l-ih-ng", "nn jj vbg"],
  "pollster": ["p-ow1-l s-t-er", "nn"],
  "pollutant": ["p-ah l-uw1 t-ah-n-t", "nn"],
  "pollute": ["p-ah l-uw1-t", "vb"],
  "polluted": ["p-ah l-uw1 t-ah-d", "jj vbd vbn"],
  "polluter": ["p-ah l-uw1 t-er", "nn"],
  "polluting": ["p-ah l-uw1 t-ih-ng", "vbg jj"],
  "pollution": ["p-ah l-uw1 sh-ah-n", "nn"],
  "polo": ["p-ow1 l-ow", "nn"],
  "poltergeist": ["p-ow1-l t-er g-ay-s-t", "nn"],
  "polyester": ["p-aa l-iy eh1 s-t-er", "nn"],
  "polymer": ["p-aa1 l-ah m-er", "nn"],
  "polynomial": ["p-aa l-ih n-ow1 m-iy ah-l", "nn jj"],
  "polyp": ["p-aa1 l-ih-p", "nn"],
  "polyurethane": ["p-aa l-iy uh1 r-ah th-ey-n", "nn"],
  "pomp": ["p-aa1-m-p", "nn"],
  "pompon": ["p-aa1-m p-aa-n", "nn"],
  "pompous": ["p-aa1-m p-ah-s", "jj"],
  "pompousness": ["p-aa1-m p-ah-s n-ah-s", "nn"],
  "pond": ["p-aa1-n-d", "nn"],
  "ponder": ["p-aa1-n d-er", "vb vbp"],
  "ponderous": ["p-aa1-n d-er ah-s", "jj"],
  "pong": ["p-ao1-ng", "nn"],
  "ponied": ["p-ow1 n-iy-d", "vbd"],
  "pontiff": ["p-aa1-n t-ah-f", "nn"],
  "pony": ["p-ow1 n-iy", "nn"],
  "pooch": ["p-uw1-ch", "nn"],
  "poodle": ["p-uw1 d-ah-l", "nn"],
  "poof": ["p-uw1-f", "nn"],
  "pool": ["p-uw1-l", "nn vbp vb"],
  "pooled": ["p-uw1-l-d", "vbn jj"],
  "poolside": ["p-uw1-l s-ay-d", "nn"],
  "poor": ["p-uh1-r", "jj nn"],
  "poorer": ["p-uh1 r-er", "jjr rbr"],
  "poorest": ["p-uh1 r-ih-s-t", "jjs"],
  "poorly": ["p-uh1-r l-iy", "rb"],
  "pop": ["p-aa1-p", "nn jj vb vbp"],
  "popcorn": ["p-aa1-p k-ao-r-n", "nn"],
  "pope": ["p-ow1-p", "nn"],
  "poplar": ["p-aa1-p l-er", "nn"],
  "poplin": ["p-aa1-p l-ih-n", "nn"],
  "poppy": ["p-aa1 p-iy", "nn"],
  "populace": ["p-aa1 p-y-ah l-ah-s", "nn"],
  "popular": ["p-aa1 p-y-ah l-er", "jj"],
  "popularity": ["p-aa p-y-ah l-eh1 r-ah t-iy", "nn"],
  "popularize": ["p-aa1 p-y-ah l-er ay-z", "vb"],
  "popularly": ["p-aa1 p-y-ah l-er l-iy", "rb"],
  "populate": ["p-aa1 p-y-ah l-ey-t", "vb vbp"],
  "populated": ["p-aa1 p-y-ah l-ey t-ah-d", "vbn jj vbd"],
  "population": ["p-aa p-y-ah l-ey1 sh-ah-n", "nn"],
  "populism": ["p-aa1 p-y-ah l-ih z-ah-m", "nn"],
  "populist": ["p-aa1 p-y-ah l-ah-s-t", "jj nn"],
  "populous": ["p-aa1 p-y-ah l-ah-s", "jj"],
  "porcelain": ["p-ao1-r s-ah l-ah-n", "nn"],
  "porch": ["p-ao1-r-ch", "nn"],
  "porcupine": ["p-ao1-r k-y-ah p-ay-n", "nn"],
  "pore": ["p-ao1-r", "nn vb"],
  "pork": ["p-ao1-r-k", "nn"],
  "pornographic": ["p-ao-r n-ah g-r-ae1 f-ih-k", "jj"],
  "pornography": ["p-ao-r n-aa1 g-r-ah f-iy", "nn"],
  "porous": ["p-ao1 r-ah-s", "jj"],
  "porpoise": ["p-ao1-r p-ah-s", "nn"],
  "porridge": ["p-ao1 r-ah-jh", "nn"],
  "port": ["p-ao1-r-t", "nn jj"],
  "portability": ["p-ao-r t-ah b-ih1 l-ih t-iy", "nn"],
  "portable": ["p-ao1-r t-ah b-ah-l", "jj nn"],
  "portal": ["p-ao1-r t-ah-l", "nn"],
  "portend": ["p-ao-r t-eh1-n-d", "vbp vb"],
  "portent": ["p-ao1-r t-eh-n-t", "nn"],
  "portentous": ["p-ao-r t-eh1-n t-ah-s", "jj"],
  "porter": ["p-ao1-r t-er", "nn"],
  "portfolio": ["p-ao-r-t f-ow1 l-iy ow", "nn"],
  "portico": ["p-ao1-r t-ah k-ow", "nn"],
  "portion": ["p-ao1-r sh-ah-n", "nn"],
  "portly": ["p-ao1-r-t l-iy", "jj"],
  "portrait": ["p-ao1-r t-r-ah-t", "nn"],
  "portray": ["p-ao-r t-r-ey1", "vb vbp"],
  "portrayal": ["p-ao-r t-r-ey1 ah-l", "nn"],
  "pose": ["p-ow1-z", "vb vbp nn"],
  "posh": ["p-aa1-sh", "jj"],
  "position": ["p-ah z-ih1 sh-ah-n", "nn vbp vb"],
  "positioned": ["p-ah z-ih1 sh-ah-n-d", "vbn vbd jj"],
  "positive": ["p-aa1 z-ah t-ih-v", "jj nn"],
  "positively": ["p-aa1 z-ah t-ih-v l-iy", "rb"],
  "positivism": ["p-aa1 z-ah t-ih v-ih z-ah-m", "nn jj"],
  "posse": ["p-aa1 s-iy", "nn"],
  "possess": ["p-ah z-eh1-s", "vbp vb"],
  "possession": ["p-ah z-eh1 sh-ah-n", "nn"],
  "possessive": ["p-ah z-eh1 s-ih-v", "jj"],
  "possessor": ["p-ah z-eh1 s-er", "nn"],
  "possibility": ["p-aa s-ah b-ih1 l-ah t-iy", "nn"],
  "possible": ["p-aa1 s-ah b-ah-l", "jj rb"],
  "possibly": ["p-aa1 s-ah b-l-iy", "rb"],
  "possum": ["p-aa1 s-ah-m", "nn"],
  "post": ["p-ow1-s-t", "nn in jj vb vbp"],
  "postage": ["p-ow1 s-t-ah-jh", "nn"],
  "postal": ["p-ow1 s-t-ah-l", "jj"],
  "postcard": ["p-ow1-s-t k-aa-r-d", "nn"],
  "postdoctoral": ["p-ow-s-t d-aa1-k t-er ah-l", "jj"],
  "posted": ["p-ow1 s-t-ih-d", "vbd vbn jj"],
  "poster": ["p-ow1 s-t-er", "nn"],
  "posterity": ["p-aa s-t-eh1 r-ah t-iy", "nn"],
  "posthumous": ["p-aa1 s-ch-uh m-ah-s", "jj"],
  "postman": ["p-ow1-s-t m-ah-n", "nn"],
  "postmark": ["p-ow1-s-t-m-aa-r-k", "vb"],
  "postmaster": ["p-ow1-s-t m-ae s-t-er", "nn"],
  "postpone": ["p-ow-s-t p-ow1-n", "vb vbp"],
  "postponed": ["p-ow-s-t p-ow1-n-d", "vbn jj vbd"],
  "postponement": ["p-ow-s-t p-ow1-n m-ah-n-t", "nn"],
  "postscript": ["p-ow1-s k-r-ih-p-t", "nn"],
  "postulate": ["p-aa1 s-ch-ah l-ey-t", "vb"],
  "posture": ["p-aa1-s ch-er", "nn vb vbp"],
  "postwar": ["p-ow1-s-t w-ao1-r", "jj"],
  "pot": ["p-aa1-t", "nn vb"],
  "potable": ["p-ow1 t-ah b-ah-l", "jj"],
  "potash": ["p-aa1-t ae-sh", "nn"],
  "potassium": ["p-ah t-ae1 s-iy ah-m", "nn"],
  "potato": ["p-ah t-ey1 t-ow", "nn"],
  "potency": ["p-ow1 t-ah-n s-iy", "nn"],
  "potent": ["p-ow1 t-ah-n-t", "jj"],
  "potentate": ["p-ow1 t-ah-n t-ey-t", "nn"],
  "potential": ["p-ah t-eh1-n sh-ah-l", "jj nn"],
  "potentially": ["p-ah t-eh1-n sh-ah l-iy", "rb"],
  "pothole": ["p-aa1-t hh-ow-l", "nn"],
  "potion": ["p-ow1 sh-ah-n", "nn"],
  "potpourri": ["p-ow p-uh r-iy1", "nn"],
  "potted": ["p-aa1 t-ih-d", "jj vbn"],
  "potter": ["p-aa1 t-er", "nn"],
  "pottery": ["p-aa1 t-er iy", "nn"],
  "potty": ["p-aa1 t-iy", "nn"],
  "pouch": ["p-aw1-ch", "nn"],
  "poultice": ["p-ow1-l t-ah s-ih", "nn"],
  "poultry": ["p-ow1-l t-r-iy", "nn"],
  "pounce": ["p-aw1-n-s", "vb"],
  "pound": ["p-aw1-n-d", "nn vb vbp"],
  "pour": ["p-ao1-r", "vb in vbp"],
  "pout": ["p-aw1-t", "nn vb"],
  "poverty": ["p-aa1 v-er t-iy", "nn"],
  "powder": ["p-aw1 d-er", "nn vb"],
  "powdered": ["p-aw1 d-er-d", "jj vbn"],
  "powdery": ["p-aw1 d-er iy", "jj"],
  "power": ["p-aw1 er", "nn vbp vb"],
  "powerboat": ["p-aw1 er b-ow-t", "nn"],
  "powered": ["p-aw1 er-d", "vbn jj"],
  "powerful": ["p-aw1 er f-ah-l", "jj"],
  "powerfully": ["p-aw1 er-f l-iy", "rb"],
  "powerhouse": ["p-aw1 er hh-aw-s", "nn"],
  "powerless": ["p-aw1 er l-ah-s", "jj"],
  "powerlessness": ["p-aw1 er l-ah-s n-ah-s", "nn"],
  "powertrain": ["p-aw1-r t-r-ey-n", "nn"],
  "powwow": ["p-aw1 w-aw", "nn"],
  "pox": ["p-aa1-k-s", "nn"],
  "practical": ["p-r-ae1-k t-ah k-ah-l", "jj nn"],
  "practicality": ["p-r-ae-k t-ih k-ae1 l-ah t-iy", "nn"],
  "practically": ["p-r-ae1-k t-ah-k l-iy", "rb"],
  "practice": ["p-r-ae1-k t-ah-s", "nn vb vbp"],
  "practiced": ["p-r-ae1-k t-ah-s-t", "vbn vbd jj"],
  "practitioner": ["p-r-ae-k t-ih1 sh-ah-n er", "nn"],
  "pragmatic": ["p-r-ae-g m-ae1 t-ih-k", "jj"],
  "pragmatism": ["p-r-ae1-g m-ah t-ih z-ah-m", "nn"],
  "pragmatist": ["p-r-ae1-g m-ah t-ih-s-t", "nn"],
  "prairie": ["p-r-eh1 r-iy", "nn"],
  "praise": ["p-r-ey1-z", "nn vbp vb"],
  "praised": ["p-r-ey1-z-d", "vbd jj vbn"],
  "praiseworthy": ["p-r-ey1-z w-er dh-iy", "jj"],
  "prance": ["p-r-ae1-n-s", "vb"],
  "prank": ["p-r-ae1-ng-k", "nn"],
  "pratfall": ["p-r-ae1-t f-ao-l", "nn"],
  "prattle": ["p-r-ae1 t-ah-l", "nn"],
  "prawn": ["p-r-ao1-n", "nn"],
  "pray": ["p-r-ey1", "vb vbp"],
  "prayer": ["p-r-eh1-r", "nn"],
  "preach": ["p-r-iy1-ch", "vb vbp"],
  "preacher": ["p-r-iy1 ch-er", "nn"],
  "preaching": ["p-r-iy1 ch-ih-ng", "vbg jj"],
  "preamble": ["p-r-iy ae1-m b-ah-l", "nn"],
  "prearrange": ["p-r-iy-er-ey1-n-jh", "vb"],
  "prearranged": ["p-r-iy er ey1-n-jh-d", "vbn jj"],
  "precarious": ["p-r-iy k-eh1 r-iy ah-s", "jj"],
  "precariously": ["p-r-ih k-eh1 r-iy ah-s l-iy", "rb"],
  "precaution": ["p-r-iy k-ao1 sh-ah-n", "nn"],
  "precautionary": ["p-r-ih k-ao1 sh-ah-n eh r-iy", "jj"],
  "precede": ["p-r-ih s-iy1-d", "vb vbp"],
  "precedence": ["p-r-eh1 s-ah d-ah-n-s", "nn"],
  "precedent": ["p-r-eh1 s-ih d-ah-n-t", "nn jj"],
  "preceding": ["p-r-iy s-iy1 d-ih-ng", "vbg jj"],
  "precept": ["p-r-iy1 s-eh-p-t", "nn"],
  "precinct": ["p-r-iy1 s-ih-ng-k-t", "nn"],
  "precious": ["p-r-eh1 sh-ah-s", "jj rb"],
  "precipice": ["p-r-eh1 s-ah p-ah-s", "nn"],
  "precipitate": ["p-r-ih s-ih1 p-ih t-ey-t", "vb nn"],
  "precipitous": ["p-r-ih s-ih1 p-ih t-ah-s", "jj"],
  "precipitously": ["p-r-iy s-ih1 p-ih t-ah-s l-iy", "rb"],
  "precise": ["p-r-ih s-ay1-s", "jj"],
  "precisely": ["p-r-ih s-ay1-s l-iy", "rb"],
  "precision": ["p-r-iy s-ih1 zh-ah-n", "nn jj"],
  "preclinical": ["p-r-iy-k l-ih1 n-ih k-ah-l", "jj"],
  "preclude": ["p-r-ih k-l-uw1-d", "vb vbp"],
  "precluded": ["p-r-ih k-l-uw1 d-ih-d", "vbd vbn jj"],
  "precocious": ["p-r-ih k-ow1 sh-ah-s", "jj"],
  "preconceived": ["p-r-iy k-ah-n s-iy1-v-d", "jj"],
  "preconception": ["p-r-iy k-ah-n s-eh1-p sh-ah-n", "nn"],
  "precondition": ["p-r-iy k-ah-n d-ih1 sh-ah-n", "nn"],
  "precook": ["p-r-iy1-k-uh1-k", "vb"],
  "precrash": ["p-r-iy k-r-ae1-sh", "jj"],
  "precursor": ["p-r-iy k-er1 s-er", "nn"],
  "predate": ["p-r-iy-d-ey1-t", "vb"],
  "predator": ["p-r-eh1 d-ah t-er", "nn"],
  "predatory": ["p-r-eh1 d-ah t-ao r-iy", "jj"],
  "predawn": ["p-r-iy d-ao1-n", "jj"],
  "predecessor": ["p-r-eh1 d-ah s-eh s-er", "nn"],
  "predetermined": ["p-r-iy d-iy t-er1 m-ih-n-d", "jj"],
  "predicament": ["p-r-ih d-ih1 k-ah m-ah-n-t", "nn"],
  "predicate": ["p-r-eh1-d-ah-k-ey-t", "vb"],
  "predict": ["p-r-ih d-ih1-k-t", "vbp vb"],
  "predictability": ["p-r-ih d-ih-k t-ah b-ih1 l-ih t-iy", "nn"],
  "predictable": ["p-r-ih d-ih1-k t-ah b-ah-l", "jj"],
  "predictably": ["p-r-ih d-ih1-k t-ah b-l-iy", "rb"],
  "predicted": ["p-r-ih d-ih1-k t-ih-d", "vbd jj vbn"],
  "prediction": ["p-r-iy d-ih1-k sh-ah-n", "nn"],
  "predictive": ["p-r-ih d-ih1-k t-ih-v", "jj"],
  "predictor": ["p-r-ih d-ih1-k t-er", "nn"],
  "predilection": ["p-r-eh d-ah l-eh1-k sh-ah-n", "nn"],
  "predispose": ["p-r-iy d-ih s-p-ow1-z", "vb vbp"],
  "predisposition": ["p-r-iy d-ih-s p-ah z-ih1 sh-ah-n", "nn"],
  "predominance": ["p-r-ih d-aa1 m-ah n-ah-n-s", "nn"],
  "predominant": ["p-r-ih d-aa1 m-ah n-ah-n-t", "jj"],
  "predominantly": ["p-r-ih d-aa1 m-ah n-ah-n-t l-iy", "rb"],
  "predominate": ["p-r-ih d-aa1 m-ah n-ey-t", "vb vbp"],
  "preempt": ["p-r-iy1 eh-m-p-t", "vb"],
  "preemptive": ["p-r-iy eh1-m-p t-ih-v", "jj"],
  "preen": ["p-r-iy1-n", "vb"],
  "prefabricate": ["p-r-iy-f-ae1-b-r-ih-k-ey-t", "vb"],
  "preface": ["p-r-eh1 f-ah-s", "nn vb"],
  "prefecture": ["p-r-iy1 f-eh-k ch-er", "nn"],
  "prefer": ["p-r-ah f-er1", "vbp vb"],
  "preferable": ["p-r-eh1 f-er ah b-ah-l", "jj"],
  "preferably": ["p-r-eh1 f-er ah b-l-iy", "rb"],
  "preference": ["p-r-eh1 f-er ah-n-s", "nn"],
  "preferential": ["p-r-eh f-er eh1-n ch-ah-l", "jj"],
  "preferentially": ["p-r-eh f-er eh1-n ch-ah l-iy", "rb"],
  "preferred": ["p-r-ah f-er1-d", "jj vbd vbg vbn"],
  "pregnancy": ["p-r-eh1-g n-ah-n s-iy", "nn"],
  "pregnant": ["p-r-eh1-g n-ah-n-t", "jj"],
  "prehistoric": ["p-r-iy hh-ih s-t-ao1 r-ih-k", "jj"],
  "prejudge": ["p-r-iy-jh-ah1-jh", "vb"],
  "prejudice": ["p-r-eh1 jh-ah d-ih-s", "nn vb"],
  "prejudiced": ["p-r-eh1 jh-ah d-ah-s-t", "vbn jj"],
  "prejudicial": ["p-r-eh jh-ah d-ih1 sh-ah-l", "jj"],
  "preliminarily": ["p-r-ih l-ih m-ah n-eh1 r-ih l-iy", "rb"],
  "preliminary": ["p-r-ih l-ih1 m-ah n-eh r-iy", "jj nn"],
  "prelude": ["p-r-ey1 l-uw-d", "nn"],
  "premarital": ["p-r-iy m-eh1 r-ah t-ah-l", "jj"],
  "premature": ["p-r-iy m-ah ch-uh1-r", "jj"],
  "prematurely": ["p-r-iy m-ah ch-uh1-r l-iy", "rb"],
  "premeditated": ["p-r-iy m-eh1 d-ah t-ey t-ih-d", "jj"],
  "premier": ["p-r-eh m-ih1-r", "nn jj"],
  "premiere": ["p-r-eh m-ih1-r", "nn vbp vb"],
  "premise": ["p-r-eh1 m-ih-s", "nn"],
  "premium": ["p-r-iy1 m-iy ah-m", "nn jj"],
  "prenatal": ["p-r-iy n-ey1 t-ah-l", "jj rb"],
  "preoccupation": ["p-r-iy aa k-y-ah p-ey1 sh-ah-n", "nn"],
  "preoccupy": ["p-r-iy aa1 k-y-ah p-ay", "vb vbp"],
  "preordain": ["p-r-iy-ao-r-d-ey1-n", "vb"],
  "prepackage": ["p-r-iy-p-ae1-k-ah-jh", "vb"],
  "prepaid": ["p-r-iy p-ey1-d", "jj vbd vbn"],
  "preparation": ["p-r-eh p-er ey1 sh-ah-n", "nn"],
  "preparatory": ["p-r-ih p-eh1 r-ah t-ao r-iy", "jj"],
  "prepare": ["p-r-iy p-eh1-r", "vb vbp"],
  "prepared": ["p-r-iy p-eh1-r-d", "vbn vbd jj"],
  "preparedness": ["p-r-iy p-eh1 r-ah-d n-ah-s", "nn"],
  "preparer": ["p-r-iy p-eh1 r-er", "nn"],
  "prepay": ["p-r-iy p-ey1", "vb"],
  "prepayment": ["p-r-iy p-ey1 m-ah-n-t", "nn"],
  "preponderance": ["p-r-iy p-aa1-n d-r-ah-n-s", "nn"],
  "preposterous": ["p-r-ih p-aa1 s-t-er ah-s", "jj"],
  "preppie": ["p-r-eh1 p-iy", "nn"],
  "preppy": ["p-r-eh1 p-iy", "nn jj"],
  "prerecord": ["p-r-iy-r-iy-k-ao1-r-d", "vb"],
  "prerequisite": ["p-r-iy r-eh1 k-w-ah z-ah-t", "nn"],
  "prerogative": ["p-r-ih r-aa1 g-ah t-ih-v", "nn"],
  "presage": ["p-r-eh1 s-ih-jh", "vb vbp"],
  "presale": ["p-r-iy1 s-ey-l", "jj nn"],
  "preschool": ["p-r-iy s-k-uw1-l", "jj"],
  "preschooler": ["p-r-iy1 s-k-uw l-er", "nn"],
  "prescient": ["p-r-eh1 s-iy ah-n-t", "jj"],
  "prescribe": ["p-r-ah s-k-r-ay1-b", "vb vbp"],
  "prescribed": ["p-r-iy s-k-r-ay1-b-d", "vbn jj vbd"],
  "prescriber": ["p-r-iy s-k-r-ay1 b-er", "nn"],
  "prescription": ["p-r-ah s-k-r-ih1-p sh-ah-n", "nn"],
  "presence": ["p-r-eh1 z-ah-n-s", "nn"],
  "present": ["p-r-eh1 z-ah-n-t", "jj vbp rb nn vb"],
  "presentable": ["p-r-ah z-eh1-n t-ah b-ah-l", "jj"],
  "presentation": ["p-r-eh z-ah-n t-ey1 sh-ah-n", "nn"],
  "presenter": ["p-r-eh1 z-ah-n t-er", "nn"],
  "presently": ["p-r-eh1 z-ah-n-t l-iy", "rb"],
  "preservation": ["p-r-eh z-er v-ey1 sh-ah-n", "nn"],
  "preservative": ["p-r-iy z-er1 v-ah t-ih-v", "jj"],
  "preserve": ["p-r-ah z-er1-v", "vb vbp nn"],
  "preserved": ["p-r-ah z-er1-v-d", "vbn jj vbd"],
  "preset": ["p-r-iy s-eh1-t", "jj"],
  "preside": ["p-r-ih z-ay1-d", "vb"],
  "presidency": ["p-r-eh1 z-ah d-ah-n s-iy", "nn"],
  "president": ["p-r-eh1 z-ah d-eh-n-t", "nn"],
  "presidential": ["p-r-eh z-ah d-eh1-n ch-ah-l", "jj"],
  "press": ["p-r-eh1-s", "nn vbp vb"],
  "presser": ["p-r-eh1 s-er", "nn"],
  "pressing": ["p-r-eh1 s-ih-ng", "vbg jj"],
  "pressman": ["p-r-eh1-s m-ah-n", "nn"],
  "pressure": ["p-r-eh1 sh-er", "nn vb vbp"],
  "pressured": ["p-r-eh1 sh-er-d", "vbn jj vbd"],
  "pressurize": ["p-r-eh1-sh-er-ay-z", "vb"],
  "prestige": ["p-r-eh s-t-iy1-zh", "nn jj"],
  "prestigious": ["p-r-eh s-t-ih1 jh-ah-s", "jj"],
  "presto": ["p-r-eh1 s-t-ow", "rb"],
  "presumably": ["p-r-ah z-uw1 m-ah b-l-iy", "rb"],
  "presume": ["p-r-ih z-uw1-m", "vb vbp"],
  "presumed": ["p-r-ah z-uw1-m-d", "vbn jj vbd"],
  "presumption": ["p-r-ih z-ah1-m-p sh-ah-n", "nn"],
  "presumptuous": ["p-r-ih z-ah1-m-p ch-ah-w ah-s", "jj"],
  "presuppose": ["p-r-iy-s-ah-p-ow1-z", "vb"],
  "presupposition": ["p-r-iy s-ah p-ah z-ih1 sh-ah-n", "nn"],
  "pretax": ["p-r-iy1 t-ae1-k-s", "jj nn"],
  "pretend": ["p-r-iy t-eh1-n-d", "vb jj"],
  "pretense": ["p-r-iy t-eh1-n-s", "nn"],
  "pretension": ["p-r-ah t-eh1-n sh-ah-n", "nn"],
  "pretentious": ["p-r-iy t-eh1-n sh-ah-s", "jj"],
  "pretext": ["p-r-iy1 t-eh-k-s-t", "nn"],
  "pretrial": ["p-r-iy t-r-ay1 ah-l", "jj"],
  "prettier": ["p-r-ih1 t-iy er", "jjr"],
  "prettiest": ["p-r-ih1 t-iy ah-s-t", "jjs"],
  "pretty": ["p-r-ih1 t-iy", "rb jj"],
  "prevail": ["p-r-ih v-ey1-l", "vb vbp"],
  "prevailing": ["p-r-ih v-ey1 l-ih-ng", "vbg jj"],
  "prevalence": ["p-r-eh1 v-ah l-ah-n-s", "nn"],
  "prevalent": ["p-r-eh1 v-ah l-ah-n-t", "jj nn"],
  "prevent": ["p-r-ih v-eh1-n-t", "vb vbp"],
  "preventable": ["p-r-ih v-eh1-n t-ah b-ah-l", "jj"],
  "preventative": ["p-r-iy v-eh1-n t-ah t-ih-v", "jj"],
  "prevention": ["p-r-iy v-eh1-n sh-ah-n", "nn"],
  "preventive": ["p-r-ih v-eh1-n t-ih-v", "jj nn"],
  "preview": ["p-r-iy1 v-y-uw", "nn vb"],
  "previous": ["p-r-iy1 v-iy ah-s", "jj"],
  "previously": ["p-r-iy1 v-iy ah-s l-iy", "rb"],
  "prewar": ["p-r-iy w-ao1-r", "jj"],
  "prey": ["p-r-ey1", "nn vbp vb"],
  "price": ["p-r-ay1-s", "nn vbp vb"],
  "priced": ["p-r-ay1-s-t", "vbn jj vbd"],
  "priceless": ["p-r-ay1-s l-ah-s", "jj"],
  "pricey": ["p-r-ay1 s-iy", "jj"],
  "pricier": ["p-r-ay1 s-iy er", "jjr"],
  "priciest": ["p-r-ay s-iy ih-s-t", "jjs"],
  "prick": ["p-r-ih1-k", "nn vb"],
  "prickly": ["p-r-ih1-k l-iy", "jj rb"],
  "pride": ["p-r-ay1-d", "nn vb vbp"],
  "priest": ["p-r-iy1-s-t", "nn"],
  "priestly": ["p-r-iy1-s-t l-iy", "jj"],
  "prim": ["p-r-ih1-m", "jj"],
  "prima": ["p-r-iy1 m-ah", "nn"],
  "primacy": ["p-r-ay1 m-ah s-iy", "nn"],
  "primal": ["p-r-ay1 m-ah-l", "jj"],
  "primarily": ["p-r-ay m-eh1 r-ah l-iy", "rb"],
  "primary": ["p-r-ay1 m-eh r-iy", "jj nn"],
  "primate": ["p-r-ay1 m-ey-t", "nn"],
  "prime": ["p-r-ay1-m", "jj nn vb"],
  "primed": ["p-r-ay1-m-d", "vbn jj vbd"],
  "primetime": ["p-r-ay1-m t-ay-m", "nn"],
  "primeval": ["p-r-ay m-iy1 v-ah-l", "jj"],
  "primitive": ["p-r-ih1 m-ah t-ih-v", "jj"],
  "primly": ["p-r-ih1-m l-iy", "rb"],
  "primordial": ["p-r-ih m-ao1-r d-iy ah-l", "jj"],
  "prince": ["p-r-ih1-n-s", "nn"],
  "princely": ["p-r-ih1-n-s l-iy", "jj"],
  "princess": ["p-r-ih1-n s-eh-s", "nn"],
  "principal": ["p-r-ih1-n s-ah p-ah-l", "jj nn"],
  "principally": ["p-r-ih1-n s-ih p-l-iy", "rb"],
  "principle": ["p-r-ih1-n s-ah p-ah-l", "nn"],
  "principled": ["p-r-ih1-n s-ah p-ah-l-d", "jj"],
  "print": ["p-r-ih1-n-t", "nn vb vbp"],
  "printable": ["p-r-ih1-n t-ah b-ah-l", "jj"],
  "printed": ["p-r-ih1-n t-ah-d", "vbn vbd jj"],
  "printer": ["p-r-ih1-n t-er", "nn"],
  "printing": ["p-r-ih1-n t-ih-ng", "nn vbg"],
  "printout": ["p-r-ih1-n-t aw-t", "nn"],
  "prior": ["p-r-ay1 er", "rb nn jj"],
  "priority": ["p-r-ay ao1 r-ah t-iy", "nn jj"],
  "prison": ["p-r-ih1 z-ah-n", "nn vb"],
  "prisoner": ["p-r-ih1 z-ah-n er", "nn"],
  "pristine": ["p-r-ih1 s-t-iy-n", "jj"],
  "privacy": ["p-r-ay1 v-ah s-iy", "nn"],
  "private": ["p-r-ay1 v-ah-t", "jj nn rb"],
  "privately": ["p-r-ay1 v-ah-t l-iy", "rb"],
  "privation": ["p-r-ay v-ey1 sh-ah-n", "nn"],
  "privatization": ["p-r-ay1 v-ah t-ah z-ey1 sh-ah-n", "nn"],
  "privatize": ["p-r-ih1 v-ah t-ay-z", "vb"],
  "privatized": ["p-r-ay1 v-ah t-ay-z-d", "vbn vbd jj"],
  "privilege": ["p-r-ih1-v l-ah-jh", "nn"],
  "privileged": ["p-r-ih1-v l-ah-jh-d", "jj"],
  "privy": ["p-r-ih1 v-iy", "jj nn"],
  "prize": ["p-r-ay1-z", "nn jj vb vbp"],
  "prized": ["p-r-ay1-z-d", "vbn jj"],
  "pro": ["p-r-ow1", "nn"],
  "probability": ["p-r-aa b-ah b-ih1 l-ah t-iy", "nn"],
  "probable": ["p-r-aa1 b-ah b-ah-l", "jj"],
  "probably": ["p-r-aa1 b-ah b-l-iy", "rb"],
  "probate": ["p-r-ow1 b-ey-t", "nn"],
  "probation": ["p-r-ow b-ey1 sh-ah-n", "nn"],
  "probe": ["p-r-ow1-b", "nn vbp vb"],
  "probing": ["p-r-ow1 b-ih-ng", "vbg jj nn"],
  "probity": ["p-r-ow1 b-ah t-iy", "nn"],
  "problem": ["p-r-aa1 b-l-ah-m", "nn"],
  "problematic": ["p-r-aa b-l-ah m-ae1 t-ih-k", "jj"],
  "problematical": ["p-r-aa b-l-ah m-ae1 t-ih k-ah-l", "jj"],
  "proboscis": ["p-r-ow b-aa1 s-ah-s", "nn"],
  "procedural": ["p-r-ah s-iy1 jh-er ah-l", "jj"],
  "procedure": ["p-r-ah s-iy1 jh-er", "nn"],
  "proceed": ["p-r-ah s-iy1-d", "vb vbp"],
  "proceeding": ["p-r-ah s-iy1 d-ih-ng", "nn vbg"],
  "process": ["p-r-aa1 s-eh-s", "nn vbp vb"],
  "processed": ["p-r-aa1 s-eh-s-t", "vbn vbd jj"],
  "procession": ["p-r-ah s-eh1 sh-ah-n", "nn"],
  "processional": ["p-r-ah s-eh1 sh-ah n-ah-l", "nn"],
  "processor": ["p-r-aa1 s-eh s-er", "nn"],
  "proclaim": ["p-r-ow k-l-ey1-m", "vb vbp"],
  "proclaimed": ["p-r-ow k-l-ey1-m-d", "vbd jj vbn"],
  "proclamation": ["p-r-aa k-l-ah m-ey1 sh-ah-n", "nn"],
  "proclivity": ["p-r-ow k-l-ih1 v-ah t-iy", "nn"],
  "procrastinate": ["p-r-ah k-r-ae1 s-t-ah n-ey-t", "vb"],
  "procrastination": ["p-r-ah k-r-ae s-t-ah n-ey1 sh-ah-n", "nn"],
  "procreate": ["p-r-ow1 k-r-iy ey1-t", "vb"],
  "procreation": ["p-r-ow1 k-r-iy ey1 sh-ah-n", "nn"],
  "proctor": ["p-r-aa1-k t-er", "nn"],
  "procure": ["p-r-ow k-y-uh1-r", "vb"],
  "procurement": ["p-r-ow k-y-uh1-r m-ah-n-t", "nn jj"],
  "procurer": ["p-r-ow k-y-uh1 r-er", "nn"],
  "prod": ["p-r-aa1-d", "vb nn"],
  "prodigal": ["p-r-aa1 d-ih g-ah-l", "jj"],
  "prodigious": ["p-r-ah d-ih1 jh-ah-s", "jj"],
  "prodigiously": ["p-r-ow d-ih1 jh-ih-s l-iy", "rb"],
  "prodigy": ["p-r-aa1 d-ah jh-iy", "nn"],
  "produce": ["p-r-ah d-uw1-s", "vb vbp nn"],
  "producer": ["p-r-ah d-uw1 s-er", "nn"],
  "producing": ["p-r-ah d-uw1 s-ih-ng", "vbg jj nn"],
  "product": ["p-r-aa1 d-ah-k-t", "nn"],
  "production": ["p-r-ah d-ah1-k sh-ah-n", "nn"],
  "productive": ["p-r-ah d-ah1-k t-ih-v", "jj"],
  "productivity": ["p-r-ow d-ah-k t-ih1 v-ah t-iy", "nn"],
  "prof": ["p-r-aa1-f", "nn"],
  "profane": ["p-r-ow f-ey1-n", "jj"],
  "profanity": ["p-r-ow f-ae1 n-ah t-iy", "nn"],
  "profess": ["p-r-ah f-eh1-s", "vbp vb"],
  "professed": ["p-r-ah f-eh1-s-t", "vbd vbn jj"],
  "profession": ["p-r-ah f-eh1 sh-ah-n", "nn"],
  "professional": ["p-r-ah f-eh1 sh-ah n-ah-l", "jj nn"],
  "professionalism": ["p-r-ah f-eh1 sh-ah-n ah l-ih z-ah-m", "nn"],
  "professionally": ["p-r-ah f-eh1 sh-ah-n ah l-iy", "rb"],
  "professor": ["p-r-ah f-eh1 s-er", "nn"],
  "professorial": ["p-r-ow f-ah s-ao1 r-iy ah-l", "jj"],
  "professorship": ["p-r-ah f-eh1 s-er sh-ih-p", "nn"],
  "proffer": ["p-r-aa1 f-er", "vb"],
  "proficiency": ["p-r-ah f-ih1 sh-ah-n s-iy", "nn"],
  "proficient": ["p-r-aa f-ih1 sh-ah-n-t", "jj"],
  "profile": ["p-r-ow1 f-ay-l", "nn jj vb"],
  "profit": ["p-r-aa1 f-ah-t", "nn vbp vb"],
  "profitability": ["p-r-aa f-ih t-ah b-ih1 l-ih t-iy", "nn"],
  "profitable": ["p-r-aa1 f-ah t-ah b-ah-l", "jj"],
  "profitably": ["p-r-aa1 f-ah t-ah b-l-iy", "rb"],
  "profiteer": ["p-r-aa-f-ah-t-ih1-r", "vb"],
  "profittaking": ["p-r-aa1 f-ih-t t-ey k-ih-ng", "nn"],
  "profligacy": ["p-r-ao1 f-l-ih g-ae s-iy", "nn"],
  "profligate": ["p-r-ao1 f-l-ih g-ey-t", "jj"],
  "profound": ["p-r-ow f-aw1-n-d", "jj"],
  "profoundly": ["p-r-ow f-aw1-n-d l-iy", "rb"],
  "profuse": ["p-r-ah f-y-uw1-s", "jj"],
  "profusely": ["p-r-ah f-y-uw1-s l-iy", "rb"],
  "profusion": ["p-r-ah f-y-uw1 zh-ah-n", "nn"],
  "progeny": ["p-r-aa1 jh-ah n-iy", "nn"],
  "prognosis": ["p-r-aa-g n-ow1 s-ah-s", "nn"],
  "program": ["p-r-ow1 g-r-ae-m", "nn vbp vb"],
  "programmable": ["p-r-ow1 g-r-ae m-ah b-ah-l", "jj"],
  "programmatic": ["p-r-aa g-r-ah m-ae1 t-ih-k", "jj"],
  "programmed": ["p-r-ow1 g-r-ae-m-d", "vbn jj"],
  "programmer": ["p-r-ow1 g-r-ae m-er", "nn"],
  "progress": ["p-r-aa1 g-r-eh-s", "nn vb"],
  "progression": ["p-r-ah g-r-eh1 sh-ah-n", "nn"],
  "progressive": ["p-r-ah g-r-eh1 s-ih-v", "jj nn"],
  "progressively": ["p-r-aa g-r-eh1 s-ih-v l-iy", "rb"],
  "progressivity": ["p-r-aa g-r-eh s-ih1 v-ah t-iy", "nn"],
  "prohibit": ["p-r-ow hh-ih1 b-ah-t", "vb vbp"],
  "prohibition": ["p-r-ow ah b-ih1 sh-ah-n", "nn"],
  "prohibitive": ["p-r-ow hh-ih1 b-ah t-ih-v", "jj"],
  "prohibitively": ["p-r-ow hh-ih1 b-ah t-ih-v l-iy", "rb"],
  "project": ["p-r-aa1 jh-eh-k-t", "nn vb vbp"],
  "projected": ["p-r-ah jh-eh1-k t-ah-d", "vbn jj vbd"],
  "projectile": ["p-r-ah jh-eh1-k t-ah-l", "nn"],
  "projection": ["p-r-ah jh-eh1-k sh-ah-n", "nn"],
  "projective": ["p-r-ah jh-eh1-k t-ih-v", "jj"],
  "projector": ["p-r-ah jh-eh1-k t-er", "nn"],
  "proletarian": ["p-r-ow l-ah t-eh1 r-iy ah-n", "jj"],
  "proletariat": ["p-r-ow l-ah t-eh1 r-iy ah-t", "nn"],
  "proliferate": ["p-r-ow l-ih1 f-er ey-t", "vb vbp"],
  "proliferated": ["p-r-ah l-ih1 f-er ey t-ih-d", "vbn vbd"],
  "proliferation": ["p-r-ow l-ih f-er ey1 sh-ah-n", "nn"],
  "prolific": ["p-r-ow l-ih1 f-ih-k", "jj"],
  "prolong": ["p-r-ah l-ao1-ng", "vb"],
  "prolonged": ["p-r-ah l-ao1-ng-d", "vbn vbd jj"],
  "prom": ["p-r-aa1-m", "nn"],
  "promenade": ["p-r-aa m-ah n-ey1-d", "nn"],
  "prominence": ["p-r-aa1 m-ah n-ah-n-s", "nn"],
  "prominent": ["p-r-aa1 m-ah n-ah-n-t", "jj"],
  "prominently": ["p-r-aa1 m-ah n-ah-n-t l-iy", "rb"],
  "promiscuous": ["p-r-ow1 m-ih s-k-w-ah-s", "jj"],
  "promise": ["p-r-aa1 m-ah-s", "nn vb vbp"],
  "promised": ["p-r-aa1 m-ah-s-t", "vbd jj vbn"],
  "promising": ["p-r-aa1 m-ah s-ih-ng", "jj vbg"],
  "promissory": ["p-r-aa1 m-ah s-ao r-iy", "jj"],
  "promote": ["p-r-ah m-ow1-t", "vb vbp"],
  "promoter": ["p-r-ah m-ow1 t-er", "nn"],
  "promotion": ["p-r-ah m-ow1 sh-ah-n", "nn"],
  "promotional": ["p-r-ah m-ow1 sh-ah n-ah-l", "jj"],
  "prompt": ["p-r-aa1-m-p-t", "vb jj vbp"],
  "promptly": ["p-r-aa1-m-p-t l-iy", "rb"],
  "promulgate": ["p-r-ow-m-ah1-l-g-ey-t", "vb"],
  "prone": ["p-r-ow1-n", "jj rb"],
  "pronoun": ["p-r-ow1 n-aw-n", "nn"],
  "pronounce": ["p-r-ah n-aw1-n-s", "vb"],
  "pronounced": ["p-r-ah n-aw1-n-s-t", "vbn vbd jj"],
  "pronouncement": ["p-r-ah n-aw1-n s-m-ah-n-t", "nn"],
  "pronouncing": ["p-r-ah n-aw1-n s-ih-ng", "jj vbg"],
  "pronunciation": ["p-r-ow n-ah-n s-iy ey1 sh-ah-n", "nn"],
  "proof": ["p-r-uw1-f", "nn jj"],
  "proofread": ["p-r-uw1-f-r-iy-d", "vb"],
  "prop": ["p-r-aa1-p", "vb vbp nn"],
  "propaganda": ["p-r-aa p-ah g-ae1-n d-ah", "nn"],
  "propagandist": ["p-r-aa p-ah g-ae1-n d-ah-s-t", "nn"],
  "propagandize": ["p-r-aa p-ah g-ae1-n d-ay-z", "vb"],
  "propagate": ["p-r-aa1 p-ah g-ey-t", "vb"],
  "propagation": ["p-r-aa p-ah g-ey1 sh-ah-n", "nn"],
  "propane": ["p-r-ow1 p-ey-n", "nn"],
  "propel": ["p-r-ah p-eh1-l", "vb vbp"],
  "propellant": ["p-r-ah p-eh1 l-ah-n-t", "nn"],
  "propeller": ["p-r-ah p-eh1 l-er", "nn"],
  "propensity": ["p-r-ah p-eh1-n s-ih t-iy", "nn"],
  "proper": ["p-r-aa1 p-er", "jj"],
  "properly": ["p-r-aa1 p-er l-iy", "rb"],
  "property": ["p-r-aa1 p-er t-iy", "nn"],
  "prophecy": ["p-r-aa1 f-ah s-iy", "nn"],
  "prophesy": ["p-r-aa1 f-ah s-ay", "vb"],
  "prophet": ["p-r-aa1 f-ah-t", "nn"],
  "prophetic": ["p-r-ah f-eh1 t-ih-k", "jj"],
  "propitious": ["p-r-ah p-ih1 sh-ah-s", "jj"],
  "proponent": ["p-r-ah p-ow1 n-ah-n-t", "nn"],
  "proportion": ["p-r-ah p-ao1-r sh-ah-n", "nn"],
  "proportional": ["p-r-ah p-ao1-r sh-ah n-ah-l", "jj nn"],
  "proportionally": ["p-r-ah p-ao1-r sh-ah-n ah l-iy", "rb"],
  "proportionate": ["p-r-ah p-ao1-r sh-ah-n ah-t", "jj"],
  "proportionately": ["p-r-ah p-ao1-r sh-ah-n ah-t l-iy", "rb"],
  "proportioned": ["p-r-ah p-ao1-r sh-ah-n-d", "jj"],
  "proposal": ["p-r-ah p-ow1 z-ah-l", "nn"],
  "propose": ["p-r-ah p-ow1-z", "vb vbp"],
  "proposed": ["p-r-ah p-ow1-z-d", "vbn vbd jj"],
  "proposition": ["p-r-aa p-ah z-ih1 sh-ah-n", "nn"],
  "propound": ["p-r-ah-p-aw1-n-d", "vb"],
  "proprietary": ["p-r-ah p-r-ay1 ah t-eh r-iy", "jj nn"],
  "proprietor": ["p-r-ah p-r-ay1 ah t-er", "nn"],
  "proprietorship": ["p-r-ah p-r-ay1 ah t-er sh-ih-p", "nn"],
  "propriety": ["p-r-ah p-r-ay1 ah t-iy", "nn"],
  "propulsion": ["p-r-ah p-ah1-l sh-ah-n", "nn"],
  "propylene": ["p-r-ow p-ah l-iy1-n", "nn"],
  "prorate": ["p-r-ow1-r-ey1-t", "vb"],
  "proration": ["p-r-ow r-ey1 sh-ah-n", "nn jj"],
  "prosaic": ["p-r-ow z-ey1 ih-k", "jj"],
  "proscribe": ["p-r-ow s-k-r-ay1-b", "vb vbp"],
  "proscription": ["p-r-ow s-k-r-ih1-p sh-ah-n", "nn"],
  "prose": ["p-r-ow1-z", "nn"],
  "prosecute": ["p-r-aa1 s-ah k-y-uw-t", "vb"],
  "prosecution": ["p-r-aa s-ah k-y-uw1 sh-ah-n", "nn"],
  "prosecutor": ["p-r-aa1 s-ih k-y-uw t-er", "nn"],
  "prosecutorial": ["p-r-aa s-ih k-y-uw t-ao1 r-iy ah-l", "jj"],
  "proselytize": ["p-r-aa1-s-ah-l-ah-t-ay-z", "vb"],
  "prospect": ["p-r-aa1 s-p-eh-k-t", "nn"],
  "prospective": ["p-r-ah s-p-eh1-k t-ih-v", "jj"],
  "prospectively": ["p-r-ah s-p-eh1-k t-ih-v l-iy", "rb"],
  "prospector": ["p-r-ao1 s-p-eh-k t-er", "nn"],
  "prospectus": ["p-r-ah s-p-eh1-k t-ah-s", "nn"],
  "prosper": ["p-r-aa1 s-p-er", "vb"],
  "prosperity": ["p-r-aa s-p-eh1 r-ah t-iy", "nn"],
  "prosperous": ["p-r-aa1 s-p-er ah-s", "jj"],
  "prostate": ["p-r-aa1 s-t-ey-t", "nn jj"],
  "prostitute": ["p-r-aa1 s-t-ah t-uw-t", "nn vb"],
  "prostitution": ["p-r-aa s-t-ah t-uw1 sh-ah-n", "nn"],
  "prostrate": ["p-r-aa1 s-t-r-ey-t", "jj"],
  "protagonist": ["p-r-ow t-ae1 g-ah n-ah-s-t", "nn"],
  "protect": ["p-r-ah t-eh1-k-t", "vb vbp"],
  "protected": ["p-r-ah t-eh1-k t-ah-d", "vbn jj vbd"],
  "protection": ["p-r-ah t-eh1-k sh-ah-n", "nn"],
  "protectionism": ["p-r-ah t-eh1-k sh-ah n-ih z-ah-m", "nn"],
  "protectionist": ["p-r-ah t-eh1-k sh-ah n-ih-s-t", "jj nn"],
  "protective": ["p-r-ah t-eh1-k t-ih-v", "jj nn"],
  "protectively": ["p-r-ah t-eh1-k t-ih-v l-iy", "rb"],
  "protector": ["p-r-ah t-eh1-k t-er", "nn"],
  "protege": ["p-r-ow1 t-ah zh-ey", "nn"],
  "protein": ["p-r-ow1 t-iy-n", "nn"],
  "protest": ["p-r-ow1 t-eh-s-t", "nn vb vbp"],
  "protestation": ["p-r-ow t-eh s-t-ey1 sh-ah-n", "nn"],
  "protester": ["p-r-ow1 t-eh s-t-er", "nn"],
  "protestor": ["p-r-ow1 t-eh s-t-er", "nn"],
  "protocol": ["p-r-ow1 t-ah k-aa-l", "nn"],
  "proton": ["p-r-ow1 t-aa-n", "nn"],
  "prototype": ["p-r-ow1 t-ah t-ay-p", "nn jj"],
  "prototypical": ["p-r-ow t-ah t-ih1 p-ih k-ah-l", "jj"],
  "protract": ["p-r-ow-t-r-ae1-k-t", "vb"],
  "protrude": ["p-r-ow t-r-uw1-d", "vb"],
  "proud": ["p-r-aw1-d", "jj"],
  "prouder": ["p-r-aw1 d-er", "rbr"],
  "proudest": ["p-r-aw1 d-ah-s-t", "jjs"],
  "proudly": ["p-r-aw1-d l-iy", "rb"],
  "prove": ["p-r-uw1-v", "vb vbp"],
  "proved": ["p-r-uw1-v-d", "vbd jj vbn"],
  "proven": ["p-r-uw1 v-ah-n", "vbn jj"],
  "provenance": ["p-r-aa1 v-ah n-ah-n-s", "nn"],
  "proverb": ["p-r-aa1 v-er-b", "nn"],
  "proverbial": ["p-r-ah v-er1 b-iy ah-l", "jj"],
  "provide": ["p-r-ah v-ay1-d", "vb vbp"],
  "providence": ["p-r-aa1 v-ah d-ah-n-s", "nn"],
  "providential": ["p-r-aa v-ah d-eh1-n ch-ah-l", "jj"],
  "provider": ["p-r-ah v-ay1 d-er", "nn"],
  "providing": ["p-r-ah v-ay1 d-ih-ng", "vbg in"],
  "province": ["p-r-aa1 v-ah-n-s", "nn"],
  "provincial": ["p-r-ah v-ih1-n sh-ah-l", "jj"],
  "provincially": ["p-r-ah v-ih1-n sh-ah l-iy", "rb"],
  "provision": ["p-r-ah v-ih1 zh-ah-n", "nn vb"],
  "provisional": ["p-r-ah v-ih1 zh-ah n-ah-l", "jj"],
  "provisionally": ["p-r-ah v-ih1 zh-ah-n ah l-iy", "rb"],
  "proviso": ["p-r-ah v-ay1 z-ow", "nn"],
  "provocation": ["p-r-aa v-ah k-ey1 sh-ah-n", "nn"],
  "provocative": ["p-r-ow v-aa1 k-ah t-ih-v", "jj"],
  "provocatively": ["p-r-ow v-aa1 k-ah t-ih-v l-iy", "rb"],
  "provoke": ["p-r-ah v-ow1-k", "vb vbp"],
  "provoked": ["p-r-ah v-ow1-k-t", "vbd jj vbn"],
  "provoking": ["p-r-ah v-ow1 k-ih-ng", "vbg jj"],
  "provost": ["p-r-ow1 v-ow-s-t", "nn"],
  "prow": ["p-r-aw1", "nn"],
  "prowess": ["p-r-aw1 ah-s", "nn"],
  "prowl": ["p-r-aw1-l", "nn vb vbp jj"],
  "proximal": ["p-r-aa1-k s-ah m-ah-l", "jj"],
  "proximate": ["p-r-aa1-k s-ah m-ah-t", "jj"],
  "proximity": ["p-r-aa-k s-ih1 m-ah t-iy", "nn"],
  "proxy": ["p-r-aa1-k s-iy", "nn jj"],
  "prude": ["p-r-uw1-d", "nn"],
  "prudence": ["p-r-uw1 d-ah-n-s", "nn"],
  "prudent": ["p-r-uw1 d-ah-n-t", "jj"],
  "prudential": ["p-r-uw d-eh1-n ch-ah-l", "jj"],
  "prudently": ["p-r-uw1 d-ah-n-t l-iy", "rb"],
  "prune": ["p-r-uw1-n", "nn vb"],
  "prurient": ["p-r-uh1 r-iy ah-n-t", "jj"],
  "pry": ["p-r-ay1", "vb"],
  "prying": ["p-r-ay1 ih-ng", "jj vbg"],
  "psalm": ["s-aa1-l-m", "nn"],
  "pseudo": ["s-uw1 d-ow", "jj"],
  "pseudonym": ["s-uw1 d-ah n-ih-m", "nn"],
  "psoriasis": ["s-er ay1 ah s-ah-s", "nn"],
  "psyche": ["s-ay1 k-iy", "nn"],
  "psychiatric": ["s-ay k-iy ae1 t-r-ih-k", "jj"],
  "psychiatrist": ["s-ah k-ay1 ah t-r-ah-s-t", "nn"],
  "psychiatry": ["s-ay k-ay1 ah t-r-iy", "nn"],
  "psychic": ["s-ay1 k-ih-k", "jj nn"],
  "psychical": ["s-ay1 k-ih k-ah-l", "jj"],
  "psychoanalysis": ["s-ay k-ow ah n-ae1 l-ah s-ah-s", "nn"],
  "psychoanalyst": ["s-ay k-ow ae1 n-ah l-ah-s-t", "nn"],
  "psychological": ["s-ay k-ah l-aa1 jh-ih k-ah-l", "jj"],
  "psychologically": ["s-ay k-ah l-aa1 jh-ih-k l-iy", "rb"],
  "psychologist": ["s-ay k-aa1 l-ah jh-ah-s-t", "nn"],
  "psychology": ["s-ay k-aa1 l-ah jh-iy", "nn"],
  "psychopath": ["s-ay1 k-ow p-ae-th", "nn"],
  "psychopathic": ["s-ay k-ah p-ae1 th-ih-k", "jj"],
  "psychotherapist": ["s-ay k-ah th-eh1 r-ah p-ih-s-t", "nn"],
  "psychotherapy": ["s-ay k-ow th-eh1 r-ah p-iy", "nn"],
  "psychotic": ["s-ay k-aa1 t-ih-k", "jj"],
  "psyllium": ["s-ih1 l-iy ah-m", "nn"],
  "pub": ["p-ah1-b", "nn"],
  "puberty": ["p-y-uw1 b-er t-iy", "nn"],
  "public": ["p-ah1 b-l-ih-k", "jj nn rb"],
  "publication": ["p-ah b-l-ih k-ey1 sh-ah-n", "nn"],
  "publicist": ["p-ah1 b-l-ih s-ih-s-t", "nn"],
  "publicity": ["p-ah b-l-ih1 s-ah t-iy", "nn"],
  "publicize": ["p-ah1 b-l-ih s-ay-z", "vb"],
  "publicized": ["p-ah1 b-l-ih s-ay-z-d", "vbn jj"],
  "publicly": ["p-ah1 b-l-ih-k l-iy", "rb"],
  "publish": ["p-ah1 b-l-ih-sh", "vb vbp"],
  "published": ["p-ah1 b-l-ih-sh-t", "vbn jj vbd"],
  "publisher": ["p-ah1 b-l-ih sh-er", "nn"],
  "publishing": ["p-ah1 b-l-ih sh-ih-ng", "jj vbg"],
  "puckish": ["p-ah1 k-ih-sh", "jj"],
  "pudding": ["p-uh1 d-ih-ng", "nn"],
  "puddle": ["p-ah1 d-ah-l", "nn"],
  "puerile": ["p-y-uw r-iy1-l", "jj"],
  "puff": ["p-ah1-f", "nn vb"],
  "puffery": ["p-ah1 f-er iy", "nn"],
  "puffy": ["p-ah1 f-iy", "jj"],
  "pugnacious": ["p-ah-g n-ae1 sh-ih-s", "jj"],
  "pull": ["p-uh1-l", "vb vbp nn"],
  "pullback": ["p-uh1-l b-ae-k", "nn"],
  "pulley": ["p-uh1 l-iy", "nn"],
  "pullout": ["p-uh1-l aw-t", "nn"],
  "pulmonary": ["p-uh1-l m-ah n-eh r-iy", "jj"],
  "pulp": ["p-ah1-l-p", "nn vb"],
  "pulpit": ["p-uh1-l p-ih-t", "nn"],
  "pulpwood": ["p-ah1-l-p w-uh-d", "nn"],
  "pulsate": ["p-ah1-l s-ey-t", "vb"],
  "pulse": ["p-ah1-l-s", "nn vb"],
  "pulverize": ["p-ah1-l v-er ay-z", "vb"],
  "pummel": ["p-ah1 m-ah-l", "vb"],
  "pummeling": ["p-ah1 m-ah-l ih-ng", "nn"],
  "pump": ["p-ah1-m-p", "vb vbp nn"],
  "pumpkin": ["p-ah1-m-p k-ih-n", "nn"],
  "pun": ["p-ah1-n", "nn"],
  "punch": ["p-ah1-n-ch", "nn vbp vb"],
  "punchy": ["p-ah1-n ch-iy", "jj"],
  "punctuality": ["p-ah-ng-k ch-uw ae1 l-ih t-iy", "nn"],
  "punctuate": ["p-ah1-ng-k-ch-uw-ey-t", "vb"],
  "punctuation": ["p-ah-ng-k ch-uw ey1 sh-ah-n", "nn"],
  "puncture": ["p-ah1-ng-k-ch-er", "vb"],
  "punctured": ["p-ah1-ng-k ch-er-d", "jj vbn"],
  "pundit": ["p-ah1-n d-ih-t", "nn"],
  "pungent": ["p-ah1-n jh-ah-n-t", "jj"],
  "pungently": ["p-ah1-n jh-ah-n-t l-iy", "rb"],
  "punish": ["p-ah1 n-ih-sh", "vb vbp"],
  "punishable": ["p-ah1 n-ih sh-ah b-ah-l", "jj"],
  "punishing": ["p-ah1 n-ih sh-ih-ng", "vbg jj"],
  "punishment": ["p-ah1 n-ih-sh m-ah-n-t", "nn"],
  "punitive": ["p-y-uw1 n-ah t-ih-v", "jj"],
  "punk": ["p-ah1-ng-k", "nn jj"],
  "punky": ["p-ah1-ng k-iy", "jj"],
  "punt": ["p-ah1-n-t", "nn"],
  "puny": ["p-y-uw1 n-iy", "jj"],
  "pup": ["p-ah1-p", "nn"],
  "pupil": ["p-y-uw1 p-ah-l", "nn"],
  "puppet": ["p-ah1 p-ah-t", "nn"],
  "puppeteer": ["p-ah p-ah t-iy1-r", "nn"],
  "puppy": ["p-ah1 p-iy", "nn"],
  "purchase": ["p-er1 ch-ah-s", "nn vb vbp"],
  "purchased": ["p-er1 ch-ah-s-t", "vbn jj vbd"],
  "purchaser": ["p-er1 ch-ah s-er", "nn"],
  "purchasing": ["p-er1 ch-ah s-ih-ng", "vbg jj"],
  "pure": ["p-y-uh1-r", "jj"],
  "purely": ["p-y-uh1-r l-iy", "rb"],
  "purest": ["p-y-uh1 r-ah-s-t", "jjs"],
  "purgatory": ["p-er1 g-ah t-ao r-iy", "nn"],
  "purge": ["p-er1-jh", "nn vb"],
  "purification": ["p-y-uh r-ah f-ah k-ey1 sh-ah-n", "nn"],
  "purified": ["p-y-uh1 r-ah f-ay-d", "vbn"],
  "purifier": ["p-y-uh1 r-ah f-ay er", "nn"],
  "purify": ["p-y-uh1 r-ah f-ay", "vb vbp"],
  "purist": ["p-y-uh1 r-ah-s-t", "nn"],
  "puritan": ["p-y-uh1 r-ah t-ah-n", "jj"],
  "puritanical": ["p-y-uh r-ah t-ae1 n-ih k-ah-l", "jj"],
  "purity": ["p-y-uh1 r-ah t-iy", "nn"],
  "purloin": ["p-er-l-oy1-n", "vb"],
  "purple": ["p-er1 p-ah-l", "jj nn"],
  "purport": ["p-er1 p-ao-r-t", "vb vbp"],
  "purported": ["p-er p-ao1-r t-ih-d", "jj vbd"],
  "purportedly": ["p-er p-ao-r t-ih-d l-iy", "rb"],
  "purpose": ["p-er1 p-ah-s", "nn"],
  "purposeful": ["p-er1 p-ah-s f-ah-l", "jj"],
  "purposefully": ["p-er1 p-ah-s f-ah l-iy", "rb"],
  "purposeless": ["p-er1 p-ah-s l-ah-s", "jj"],
  "purposely": ["p-er1 p-ah-s l-iy", "rb"],
  "purr": ["p-er1", "vb"],
  "purse": ["p-er1-s", "nn vb"],
  "pursue": ["p-er s-uw1", "vb vbp"],
  "pursued": ["p-er s-uw1-d", "vbn jj vbd"],
  "pursuer": ["p-er s-uw1 er", "nn"],
  "pursuit": ["p-er s-uw1-t", "nn"],
  "purveyor": ["p-er v-ey1 er", "nn"],
  "purview": ["p-er1 v-y-uw", "nn"],
  "push": ["p-uh1-sh", "vb vbp nn"],
  "pusher": ["p-uh1 sh-er", "nn"],
  "pushing": ["p-uh1 sh-ih-ng", "vbg jj nn"],
  "pushover": ["p-uh1-sh ow v-er", "nn"],
  "pushup": ["p-uh1 sh-ah-p", "nn"],
  "pushy": ["p-uh1 sh-iy", "jj"],
  "pussy": ["p-uh1 s-iy", "nn"],
  "pussycat": ["p-uh1 s-iy k-ae-t", "nn"],
  "put": ["p-uh1-t", "vb jj nn vbp vbd vbn"],
  "putative": ["p-y-uw1 t-ah t-ih-v", "jj"],
  "putt": ["p-ah1-t", "nn vb"],
  "puttable": ["p-ah1 t-ah b-ah-l", "jj"],
  "putter": ["p-ah1 t-er", "nn"],
  "putty": ["p-ah1 t-iy", "nn"],
  "puzzle": ["p-ah1 z-ah-l", "nn vb"],
  "puzzled": ["p-ah1 z-ah-l-d", "vbn jj vbd"],
  "puzzlement": ["p-ah1 z-ah-l m-ah-n-t", "nn"],
  "puzzler": ["p-ah1-z l-er", "nn"],
  "puzzling": ["p-ah1 z-ah-l ih-ng", "jj vbg"],
  "pylon": ["p-ay1 l-aa-n", "nn"],
  "pyramid": ["p-ih1 r-ah m-ih-d", "nn vb"],
  "python": ["p-ay1 th-aa-n", "nn"],
  "quack": ["k-w-ae1-k", "nn uh"],
  "quadrennial": ["k-w-aa d-r-eh1 n-iy ah-l", "jj"],
  "quadriceps": ["k-w-aa1 d-r-ah s-eh-p-s", "nn"],
  "quadruple": ["k-w-aa d-r-uw1 p-ah-l", "vb"],
  "quagmire": ["k-w-ae1-g m-ay er", "nn"],
  "quaint": ["k-w-ey1-n-t", "jj"],
  "quaintly": ["k-w-ey1-n-t l-iy", "rb"],
  "quake": ["k-w-ey1-k", "nn vb"],
  "qualification": ["k-w-aa l-ah f-ah k-ey1 sh-ah-n", "nn"],
  "qualified": ["k-w-aa1 l-ah f-ay-d", "vbn jj vbd"],
  "qualify": ["k-w-aa1 l-ah f-ay", "vb vbp"],
  "qualitative": ["k-w-aa1 l-ah t-ey t-ih-v", "jj"],
  "quality": ["k-w-aa1 l-ah t-iy", "nn jj"],
  "qualm": ["k-w-aa1-m", "nn"],
  "quam": ["k-w-aa1-m", "nn"],
  "quandary": ["k-w-aa1-n d-er iy", "nn"],
  "quantified": ["k-w-aa1-n t-ih f-ay-d", "vbn"],
  "quantify": ["k-w-aa1-n t-ih f-ay", "vb"],
  "quantitative": ["k-w-aa1-n t-ih t-ey t-ih-v", "jj"],
  "quantity": ["k-w-aa1-n t-ah t-iy", "nn"],
  "quantum": ["k-w-aa1-n t-ah-m", "nn"],
  "quarantine": ["k-w-ao1 r-ah-n t-iy-n", "vb"],
  "quarrel": ["k-w-ao1 r-ah-l", "nn vb"],
  "quarrelsome": ["k-w-ao1 r-ah-l s-ah-m", "jj"],
  "quarry": ["k-w-ao1 r-iy", "nn"],
  "quart": ["k-w-ao1-r-t", "nn"],
  "quarter": ["k-w-ao1-r t-er", "nn"],
  "quarterback": ["k-w-ao1-r t-er b-ae-k", "nn"],
  "quarterly": ["k-w-ao1-r t-er l-iy", "jj nn rb"],
  "quartet": ["k-w-ao-r t-eh1-t", "nn"],
  "quartz": ["k-w-ao1-r-t-s", "nn"],
  "quash": ["k-w-ao1-sh", "vb"],
  "queasiness": ["k-w-iy1 z-iy n-ah-s", "nn"],
  "queen": ["k-w-iy1-n", "nn"],
  "queer": ["k-w-ih1-r", "jj"],
  "quell": ["k-w-eh1-l", "vb"],
  "quench": ["k-w-eh1-n-ch", "vb"],
  "quenching": ["k-w-eh1-n ch-ih-ng", "nn"],
  "querulous": ["k-w-eh1 r-ah l-ah-s", "jj"],
  "query": ["k-w-iy1 r-iy", "nn"],
  "quest": ["k-w-eh1-s-t", "nn"],
  "question": ["k-w-eh1-s ch-ah-n", "nn vb vbp"],
  "questionable": ["k-w-eh1-s ch-ah n-ah b-ah-l", "jj"],
  "questioner": ["k-w-eh1-s ch-ah n-er", "nn"],
  "questioning": ["k-w-eh1-s ch-ah n-ih-ng", "vbg jj"],
  "questionnaire": ["k-w-eh-s ch-ah n-eh1-r", "nn"],
  "queue": ["k-y-uw1", "nn vb"],
  "quibble": ["k-w-ih1 b-ah-l", "vb"],
  "quiche": ["k-iy1-sh", "nn"],
  "quick": ["k-w-ih1-k", "jj nn rb"],
  "quicken": ["k-w-ih1 k-ah-n", "vb"],
  "quicker": ["k-w-ih1 k-er", "jjr rbr jj"],
  "quickest": ["k-w-ih1 k-ih-s-t", "jjs"],
  "quickie": ["k-w-ih1 k-iy", "nn jj"],
  "quickly": ["k-w-ih1-k l-iy", "rb"],
  "quickness": ["k-w-ih1-k n-ah-s", "nn"],
  "quicksand": ["k-w-ih1-k s-ae-n-d", "nn"],
  "quicksilver": ["k-w-ih1-k s-ih1-l v-er", "jj nn"],
  "quid": ["k-w-ih1-d", "nn"],
  "quiescent": ["k-w-ay eh1 s-ah-n-t", "jj"],
  "quiet": ["k-w-ay1 ah-t", "jj nn vb"],
  "quieter": ["k-w-ay1 ah t-er", "jjr"],
  "quietly": ["k-w-ay1 ah-t l-iy", "rb"],
  "quietness": ["k-w-ay1 ah-t n-ah-s", "nn"],
  "quill": ["k-w-ih1-l", "nn"],
  "quilt": ["k-w-ih1-l-t", "nn"],
  "quilted": ["k-w-ih1-l t-ih-d", "jj"],
  "quince": ["k-w-ih1-n-s", "nn"],
  "quinine": ["k-w-ay1 n-ay-n", "nn"],
  "quintessential": ["k-w-ih-n t-ih s-eh1-n sh-ah-l", "jj"],
  "quintet": ["k-w-ih-n t-eh1-t", "nn"],
  "quintuple": ["k-w-ih1-n t-uw p-ah-l", "rb vb"],
  "quip": ["k-w-ih1-p", "nn"],
  "quipped": ["k-w-ih1-p-t", "vbd nn"],
  "quirk": ["k-w-er1-k", "nn"],
  "quirky": ["k-w-er1 k-iy", "jj"],
  "quisling": ["k-w-ih1-z l-ih-ng", "nn"],
  "quit": ["k-w-ih1-t", "vb vbd vbn vbp nn"],
  "quite": ["k-w-ay1-t", "rb pdt"],
  "quiver": ["k-w-ih1-v-er", "vb"],
  "quixotic": ["k-w-ih-k s-aa1 t-ih-k", "jj"],
  "quiz": ["k-w-ih1-z", "nn vb"],
  "quorum": ["k-w-ao1 r-ah-m", "nn"],
  "quota": ["k-w-ow1 t-ah", "nn"],
  "quotation": ["k-w-ow t-ey1 sh-ah-n", "nn"],
  "quote": ["k-w-ow1-t", "vb vbp nn"],
  "quoted": ["k-w-ow1 t-ah-d", "vbn jj vbd"],
  "quotient": ["k-w-ow1 t-ih ah-n-t", "nn"],
  "rabbi": ["r-ae1 b-ay", "nn"],
  "rabbit": ["r-ae1 b-ah-t", "nn"],
  "rabble": ["r-ae1 b-ah-l", "nn"],
  "rabid": ["r-ae1 b-ih-d", "jj"],
  "raccoon": ["r-ae k-uw1-n", "nn"],
  "race": ["r-ey1-s", "nn vb"],
  "racehorse": ["r-ey1-s hh-ao-r-s", "nn"],
  "racer": ["r-ey1 s-er", "nn"],
  "racetrack": ["r-ey1-s t-r-ae-k", "nn"],
  "raceway": ["r-ey1-s w-ey", "nn"],
  "racial": ["r-ey1 sh-ah-l", "jj"],
  "racially": ["r-ey1 sh-ah l-iy", "rb"],
  "racing": ["r-ey1 s-ih-ng", "vbg jj nn"],
  "racism": ["r-ey1 s-ih z-ah-m", "nn"],
  "racist": ["r-ey1 s-ih-s-t", "jj nn"],
  "rack": ["r-ae1-k", "nn vb vbp"],
  "racket": ["r-ae1 k-ih-t", "nn"],
  "racketeer": ["r-ae k-ih t-ih1-r", "nn vb"],
  "racy": ["r-ey1 s-iy", "jj"],
  "radar": ["r-ey1 d-aa-r", "nn"],
  "radial": ["r-ey1 d-iy ah-l", "jj"],
  "radiance": ["r-ey1 d-iy ah-n-s", "nn"],
  "radiant": ["r-ey1 d-iy ah-n-t", "jj"],
  "radiate": ["r-ey1 d-iy ah-t", "vb vbp"],
  "radiated": ["r-ey1 d-iy ey t-ah-d", "vbd vbn jj"],
  "radiation": ["r-ey d-iy ey1 sh-ah-n", "nn"],
  "radiator": ["r-ey1 d-iy ey t-er", "nn"],
  "radical": ["r-ae1 d-ah k-ah-l", "jj nn"],
  "radicalism": ["r-ae1 d-ih k-ah l-ih z-ah-m", "nn"],
  "radicalize": ["r-ae1-d-ih-k-ah-l-ay-z", "vb"],
  "radically": ["r-ae1 d-ih-k l-iy", "rb"],
  "radio": ["r-ey1 d-iy ow", "nn vb"],
  "radioactive": ["r-ey d-iy ow ae1-k t-ih-v", "jj"],
  "radioactivity": ["r-ey1 d-iy ow ae-k t-ih1 v-ah t-iy", "nn"],
  "radioed": ["r-ey1 d-iy ow-d", "jj vbd"],
  "radiography": ["r-ey d-iy aa1 g-r-ah f-iy", "nn"],
  "radish": ["r-ae1 d-ih-sh", "nn"],
  "radius": ["r-ey1 d-iy ah-s", "nn"],
  "radon": ["r-ey1 d-aa-n", "nn"],
  "raffish": ["r-ae1 f-ih-sh", "jj"],
  "raft": ["r-ae1-f-t", "nn"],
  "rafter": ["r-ae1-f t-er", "nn"],
  "rag": ["r-ae1-g", "nn"],
  "rage": ["r-ey1-jh", "nn vb"],
  "ragged": ["r-ae1 g-ah-d", "jj"],
  "raging": ["r-ey1 jh-ih-ng", "vbg jj"],
  "ragtime": ["r-ae1-g t-ay-m", "nn"],
  "raid": ["r-ey1-d", "nn vb"],
  "raider": ["r-ey1 d-er", "nn"],
  "rail": ["r-ey1-l", "nn vb"],
  "railbike": ["r-ey1-l b-ay-k", "nn"],
  "railbiker": ["r-ey1-l b-ih k-er", "nn"],
  "railcar": ["r-ey1-l k-aa-r", "nn"],
  "railing": ["r-ey1 l-ih-ng", "nn"],
  "railroad": ["r-ey1-l r-ow-d", "nn vb"],
  "railway": ["r-ey1-l w-ey", "nn"],
  "rain": ["r-ey1-n", "nn vb"],
  "rainbow": ["r-ey1-n b-ow", "nn"],
  "raincoat": ["r-ey1-n k-ow-t", "nn"],
  "raindrop": ["r-ey1-n d-r-aa-p", "nn"],
  "rainfall": ["r-ey1-n f-ao-l", "nn"],
  "rainier": ["r-ey n-ih1-r", "jjr"],
  "rainstorm": ["r-ey1-n s-t-ao-r-m", "nn"],
  "rainwater": ["r-ey1-n w-ao t-er", "nn"],
  "rainy": ["r-ey1 n-iy", "jj"],
  "raise": ["r-ey1-z", "vb vbp nn"],
  "raised": ["r-ey1-z-d", "vbn vbd jj"],
  "raiser": ["r-ey1 z-er", "nn"],
  "raisin": ["r-ey1 z-ih-n", "nn"],
  "raising": ["r-ey1 z-ih-ng", "vbg rp"],
  "rake": ["r-ey1-k", "nn vb vbp"],
  "rakish": ["r-ey1 k-ih-sh", "jj"],
  "rallied": ["r-ae1 l-iy-d", "vbd vbn"],
  "rally": ["r-ae1 l-iy", "nn vbp vb"],
  "rallying": ["r-ae1 l-iy ih-ng", "vbg jj nn"],
  "ram": ["r-ae1-m", "vb nn"],
  "ramble": ["r-ae1-m b-ah-l", "vb vbp nn"],
  "rambling": ["r-ae1-m b-l-ih-ng", "nn jj"],
  "rambunctious": ["r-ae-m b-ah1-ng-k sh-ah-s", "jj"],
  "ramification": ["r-ae m-ah f-ah k-ey1 sh-ah-n", "nn"],
  "ramp": ["r-ae1-m-p", "nn vb"],
  "rampage": ["r-ae1-m p-ey-jh", "nn"],
  "rampant": ["r-ae1-m p-ah-n-t", "jj rb"],
  "rampart": ["r-ae1-m p-aa-r-t", "nn"],
  "ramshackle": ["r-ae1-m sh-ae k-ah-l", "jj"],
  "ran": ["r-ae1-n", "vbd"],
  "ranch": ["r-ae1-n-ch", "nn"],
  "rancher": ["r-ae1-n ch-er", "nn"],
  "rancid": ["r-ae1-n s-ih-d", "jj"],
  "rancor": ["r-ae1-ng k-er", "nn"],
  "rancorous": ["r-ae1-ng k-er ah-s", "jj"],
  "random": ["r-ae1-n d-ah-m", "jj nn"],
  "randomly": ["r-ae1-n d-ah-m l-iy", "rb"],
  "randomness": ["r-ae1-n d-ah-m n-ah-s", "nn"],
  "rang": ["r-ae1-ng", "vbd"],
  "range": ["r-ey1-n-jh", "nn jj vb vbp vbz"],
  "ranger": ["r-ey1-n jh-er", "nn"],
  "rangy": ["r-ey1-n jh-iy", "jj"],
  "rank": ["r-ae1-ng-k", "nn vbp jj vb"],
  "ranked": ["r-ae1-ng-k-t", "vbd vbn jj"],
  "ranking": ["r-ae1-ng k-ih-ng", "jj vbg"],
  "rankle": ["r-ae1-ng-k-ah-l", "vb"],
  "ransack": ["r-ae1-n s-ae-k", "vb"],
  "ransom": ["r-ae1-n s-ah-m", "nn"],
  "rant": ["r-ae1-n-t", "vb"],
  "rap": ["r-ae1-p", "nn vb vbp"],
  "rapacious": ["r-ah p-ae1 sh-ih-s", "jj"],
  "rape": ["r-ey1-p", "nn vb vbp"],
  "raped": ["r-ey1-p-t", "vbn vbd jj"],
  "rapid": ["r-ae1 p-ah-d", "jj"],
  "rapidity": ["r-ah p-ih1 d-ah t-iy", "nn"],
  "rapidly": ["r-ae1 p-ah-d l-iy", "rb"],
  "rapier": ["r-ey1 p-iy er", "nn"],
  "rapist": ["r-ey1 p-ih-s-t", "nn"],
  "rapped": ["r-ae1-p-t", "vbd vbn"],
  "rapport": ["r-ae p-ao1-r", "nn"],
  "rapt": ["r-ae1-p-t", "jj"],
  "raptor": ["r-ae1-p t-er", "nn"],
  "rapture": ["r-ae1-p ch-er", "nn"],
  "rare": ["r-eh1-r", "jj"],
  "rarefied": ["r-eh1 r-ah f-ay-d", "vbn"],
  "rarefy": ["r-eh1-r-ah-f-ay", "vb"],
  "rarely": ["r-eh1-r l-iy", "rb"],
  "rarer": ["r-eh1 r-er", "jjr"],
  "rarest": ["r-eh1 r-ah-s-t", "jjs"],
  "rarity": ["r-eh1 r-ah t-iy", "nn"],
  "rascal": ["r-ae1-s k-ah-l", "nn"],
  "rash": ["r-ae1-sh", "nn jj"],
  "raspberry": ["r-ae1-z b-eh r-iy", "jj nn"],
  "rasped": ["r-ae1-s-p-t", "vbd"],
  "raspy": ["r-ae1-s p-iy", "nn"],
  "rat": ["r-ae1-t", "nn vb"],
  "ratchet": ["r-ae1 ch-ah-t", "vb"],
  "rate": ["r-ey1-t", "nn vbp vb"],
  "rated": ["r-ey1 t-ah-d", "vbn jj vbd"],
  "ratepayer": ["r-ey1-t p-ey er", "nn"],
  "rather": ["r-ae1 dh-er", "rb in"],
  "ratification": ["r-ae t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "ratify": ["r-ae1 t-ah f-ay", "vb vbp"],
  "rating": ["r-ey1 t-ih-ng", "nn vbg"],
  "ratio": ["r-ey1 sh-iy ow", "nn"],
  "ration": ["r-ae1 sh-ah-n", "nn vb"],
  "rational": ["r-ae1 sh-ah n-ah-l", "jj"],
  "rationale": ["r-ae sh-ah n-ae1-l", "nn"],
  "rationality": ["r-ae sh-ah n-ae1 l-ih t-iy", "nn"],
  "rationalization": ["r-ae sh-ah-n ah l-ih z-ey1 sh-ah-n", "nn"],
  "rationalize": ["r-ae1 sh-ah-n ah l-ay-z", "vb vbp"],
  "rationalized": ["r-ae1 sh-ah-n ah l-ay-z-d", "jj vbn"],
  "rationally": ["r-ae1 sh-ah-n ah l-iy", "rb"],
  "rationing": ["r-ae1 sh-ah-n ih-ng", "nn"],
  "rattle": ["r-ae1 t-ah-l", "nn vb"],
  "rattled": ["r-ae1 t-ah-l-d", "vbn jj vbd"],
  "rattler": ["r-ae1 t-ah-l er", "nn"],
  "rattlesnake": ["r-ae1 t-ah-l s-n-ey-k", "nn"],
  "ratty": ["r-ae1 t-iy", "jj"],
  "raucous": ["r-ao1 k-ah-s", "jj"],
  "ravage": ["r-ae1 v-ih-jh", "vb"],
  "rave": ["r-ey1-v", "vbp jj vb"],
  "ravenous": ["r-ae1 v-ah n-ah-s", "jj"],
  "raw": ["r-aa1", "jj"],
  "rawhide": ["r-ao1 hh-ay-d", "nn"],
  "ray": ["r-ey1", "nn"],
  "rayon": ["r-ey1 ah-n", "nn"],
  "raze": ["r-ey1-z", "vb"],
  "razor": ["r-ey1 z-er", "nn"],
  "razorback": ["r-ey1 z-er b-ae-k", "nn"],
  "reach": ["r-iy1-ch", "vb vbp nn"],
  "reacquire": ["r-iy ah k-w-ay1-r", "vb"],
  "react": ["r-iy ae1-k-t", "vb vbp"],
  "reaction": ["r-iy ae1-k sh-ah-n", "nn"],
  "reactionary": ["r-iy ae1-k sh-ah-n eh r-iy", "jj nn"],
  "reactivate": ["r-iy1-ae1-k-t-ah-v-ey-t", "vb"],
  "reactivity": ["r-iy ae-k t-ih1 v-ah t-iy", "nn"],
  "reactor": ["r-iy ae1-k t-er", "nn"],
  "read": ["r-eh1-d", "vb nn vbp vbd vbn"],
  "readable": ["r-iy1 d-ah b-ah-l", "jj"],
  "reader": ["r-iy1 d-er", "nn"],
  "readership": ["r-iy1 d-er sh-ih-p", "nn"],
  "readied": ["r-eh1 d-iy-d", "vbn vbd"],
  "readily": ["r-eh1 d-ah l-iy", "rb"],
  "readiness": ["r-eh1 d-iy n-ah-s", "nn"],
  "reading": ["r-eh1 d-ih-ng", "nn vbg"],
  "readjust": ["r-iy ah jh-ah1-s-t", "vb"],
  "readmit": ["r-iy-ah-d-m-ih1-t", "vb"],
  "ready": ["r-eh1 d-iy", "jj rb vb"],
  "reaffirm": ["r-iy ah f-er1-m", "vb vbp"],
  "reaffirmation": ["r-iy ae f-er m-ey1 sh-ah-n", "nn"],
  "reagent": ["r-iy ey1 jh-ah-n-t", "nn"],
  "real": ["r-iy1-l", "jj nn rb"],
  "realestate": ["r-iy1 l-ih s-t-ey-t", "nn vb"],
  "realign": ["r-iy ah l-ay1-n", "vb"],
  "realigned": ["r-iy ah l-ay1-n-d", "vbd jj"],
  "realignment": ["r-iy ah l-ay1-n m-ah-n-t", "nn"],
  "realism": ["r-iy1 l-ih z-ah-m", "nn"],
  "realist": ["r-iy1 l-ih-s-t", "nn"],
  "realistic": ["r-iy ah l-ih1 s-t-ih-k", "jj"],
  "realistically": ["r-iy ah l-ih1 s-t-ih-k l-iy", "rb"],
  "reality": ["r-iy ae1 l-ah t-iy", "nn"],
  "realization": ["r-iy1 l-ah z-ey1 sh-ah-n", "nn"],
  "realize": ["r-iy1 l-ay-z", "vb vbp"],
  "reallocate": ["r-iy ae1 l-ah k-ey-t", "vb"],
  "really": ["r-ih1 l-iy", "rb"],
  "realm": ["r-eh1-l-m", "nn"],
  "realtor": ["r-iy1 ah-l t-er", "nn"],
  "ream": ["r-iy1-m", "nn vb"],
  "reap": ["r-iy1-p", "vb vbp"],
  "reaper": ["r-iy1 p-er", "nn"],
  "reappear": ["r-iy ah p-ih1-r", "vbp vb"],
  "reappearance": ["r-iy ah p-ih1 r-ah-n-s", "nn"],
  "reappoint": ["r-iy-ah-p-oy1-n-t", "vb"],
  "reappraisal": ["r-iy ah p-r-ey1 z-ah-l", "nn"],
  "reappraise": ["r-iy ah p-r-ey1-z", "vb vbp"],
  "rear": ["r-ih1-r", "jj nn vb"],
  "rearm": ["r-iy1 aa1-r-m", "vb"],
  "rearrange": ["r-iy er ey1-n-jh", "vb"],
  "rearrangement": ["r-iy er ey1-n-jh m-ah-n-t", "nn"],
  "reason": ["r-iy1 z-ah-n", "nn vb vbp"],
  "reasonable": ["r-iy1 z-ah-n ah b-ah-l", "jj"],
  "reasonably": ["r-iy1 z-ah-n ah b-l-iy", "rb"],
  "reasoned": ["r-iy1 z-ah-n-d", "vbd jj vbn"],
  "reassemble": ["r-iy ah s-eh1-m b-ah-l", "vb"],
  "reassert": ["r-iy ah s-er1-t", "vb"],
  "reassess": ["r-iy ah s-eh1-s", "vb nn"],
  "reassessment": ["r-iy ah s-eh1-s m-ah-n-t", "nn"],
  "reassign": ["r-iy ah s-ay1-n", "vb"],
  "reassignment": ["r-iy ah s-ay1-n m-ah-n-t", "nn"],
  "reassume": ["r-iy ah s-uw1-m", "vb"],
  "reassurance": ["r-iy ah sh-uh1 r-ah-n-s", "nn"],
  "reassure": ["r-iy ah sh-uh1-r", "vb"],
  "reassuring": ["r-iy ah sh-uh1 r-ih-ng", "vbg jj"],
  "reassuringly": ["r-iy ah sh-er1 ih-ng l-iy", "rb"],
  "reauthorize": ["r-iy ao1 th-er ay-z", "vb"],
  "reawaken": ["r-iy-ah-w-ey1-k-ah-n", "vb"],
  "rebalance": ["r-iy b-ae1 l-ah-n-s", "vb"],
  "rebate": ["r-iy1 b-ey-t", "nn vb"],
  "rebel": ["r-eh1 b-ah-l", "nn vbp jj vb"],
  "rebellion": ["r-ih b-eh1-l y-ah-n", "nn"],
  "rebellious": ["r-ih b-eh1-l y-ah-s", "jj"],
  "rebirth": ["r-iy b-er1-th", "nn"],
  "reborn": ["r-iy1 b-ao1-r-n", "vbn jj"],
  "rebound": ["r-iy b-aw1-n-d", "nn vbp vb"],
  "rebuff": ["r-ih b-ah1-f", "nn vb"],
  "rebuild": ["r-iy b-ih1-l-d", "vb"],
  "rebuilder": ["r-iy b-ih1-l d-er", "nn"],
  "rebuilt": ["r-iy b-ih1-l-t", "vbn"],
  "rebuke": ["r-iy b-y-uw1-k", "vb nn"],
  "rebut": ["r-ih b-ah1-t", "vb"],
  "rebuttal": ["r-ih b-ah1 t-ah-l", "nn"],
  "recalcitrant": ["r-ih k-ae1-l s-ih t-r-ah-n-t", "jj"],
  "recalculate": ["r-iy-k-ae1-l-k-y-ah-l-ey-t", "vb"],
  "recalculation": ["r-iy k-ae-l k-y-ah l-ey1 sh-ah-n", "nn"],
  "recall": ["r-iy1 k-ao-l", "vb nn vbp"],
  "recant": ["r-iy-k-ae1-n-t", "vb"],
  "recantation": ["r-eh k-ah-n t-ey1 sh-ah-n", "nn"],
  "recast": ["r-iy k-ae1-s-t", "vb"],
  "recede": ["r-ih s-iy1-d", "vbp vb"],
  "receipt": ["r-ih s-iy1-t", "nn"],
  "receivable": ["r-ih s-iy1 v-ah b-ah-l", "jj nn"],
  "receive": ["r-ah s-iy1-v", "vb vbp"],
  "received": ["r-ah s-iy1-v-d", "vbd vbn jj"],
  "receiver": ["r-ah s-iy1 v-er", "nn"],
  "receivership": ["r-ih s-iy1 v-er sh-ih-p", "nn"],
  "recent": ["r-iy1 s-ah-n-t", "jj"],
  "recently": ["r-iy1 s-ah-n-t l-iy", "rb"],
  "receptacle": ["r-ah s-eh1-p t-ah k-ah-l", "nn"],
  "reception": ["r-ih s-eh1-p sh-ah-n", "nn"],
  "receptionist": ["r-ih s-eh1-p sh-ah n-ih-s-t", "nn"],
  "receptive": ["r-ih s-eh1-p t-ih-v", "jj"],
  "receptivity": ["r-iy1 s-eh-p t-ih1 v-ih t-iy", "nn"],
  "receptor": ["r-iy s-eh1-p t-er", "nn"],
  "recess": ["r-ih s-eh1-s", "nn vb"],
  "recession": ["r-ih s-eh1 sh-ah-n", "nn"],
  "recessionary": ["r-iy s-eh1 sh-ah-n eh r-iy", "jj"],
  "recharge": ["r-iy ch-aa1-r-jh", "nn vb"],
  "rechargeable": ["r-iy ch-aa1-r jh-ah b-ah-l", "jj"],
  "recheck": ["r-iy1 ch-eh1-k", "vb vbp"],
  "recipe": ["r-eh1 s-ah p-iy", "nn"],
  "recipient": ["r-ah s-ih1 p-iy ah-n-t", "jj nn"],
  "reciprocal": ["r-ih s-ih1 p-r-ah k-ah-l", "jj"],
  "reciprocate": ["r-ih s-ih1 p-r-ah k-ey-t", "vb"],
  "reciprocity": ["r-eh s-ih p-r-aa1 s-ih t-iy", "nn"],
  "recital": ["r-ah s-ay1 t-ah-l", "nn"],
  "recitation": ["r-eh s-ah t-ey1 sh-ah-n", "nn"],
  "recite": ["r-ah s-ay1-t", "vb vbp"],
  "reckless": ["r-eh1-k l-ah-s", "jj"],
  "recklessly": ["r-eh1-k l-ah-s l-iy", "rb"],
  "recklessness": ["r-eh1-k l-ah-s n-ah-s", "nn"],
  "reckon": ["r-eh1 k-ah-n", "vbp vb"],
  "reckoning": ["r-eh1 k-ah n-ih-ng", "nn vbg"],
  "reclaim": ["r-iy k-l-ey1-m", "vb vbp"],
  "reclaimed": ["r-iy k-l-ey1-m-d", "vbn vbd jj"],
  "reclamation": ["r-eh k-l-ah m-ey1 sh-ah-n", "nn"],
  "reclassification": ["r-iy k-l-ae s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "reclassified": ["r-iy k-l-ae1 s-ah f-ay-d", "vbd vbn"],
  "reclassify": ["r-iy-k-l-ae1-s-ih-f-ay", "vb"],
  "recline": ["r-ih-k-l-ay1-n", "vb"],
  "recliner": ["r-ih k-l-ay1 n-er", "nn"],
  "reclining": ["r-ih k-l-ay1 n-ih-ng", "vbg jj"],
  "recluse": ["r-ih k-l-uw1-s", "nn"],
  "reclusive": ["r-ih k-l-uw1 s-ih-v", "jj"],
  "recognition": ["r-eh k-ah-g n-ih1 sh-ah-n", "nn"],
  "recognizable": ["r-eh k-ah-g n-ay1 z-ah b-ah-l", "jj"],
  "recognizably": ["r-eh1 k-ah-g n-ay z-ah b-l-iy", "rb"],
  "recognizance": ["r-ih k-aa1 n-ah z-ah-n-s", "nn"],
  "recognize": ["r-eh1 k-ah-g n-ay-z", "vb vbp"],
  "recognized": ["r-eh1 k-ah-g n-ay-z-d", "vbn jj vbd"],
  "recoil": ["r-iy k-oy1-l", "nn vb vbp"],
  "recollect": ["r-eh k-ah l-eh1-k-t", "vb vbp"],
  "recollection": ["r-eh k-ah l-eh1-k sh-ah-n", "nn"],
  "recombinant": ["r-ih k-aa1-m b-ih n-ah-n-t", "jj"],
  "recommend": ["r-eh k-ah m-eh1-n-d", "vb vbp"],
  "recommendation": ["r-eh k-ah m-ah-n d-ey1 sh-ah-n", "nn"],
  "recommended": ["r-eh k-ah m-eh1-n d-ah-d", "vbd vbn jj"],
  "recompense": ["r-eh1 k-ah-m p-eh-n-s", "nn"],
  "reconcile": ["r-eh1 k-ah-n s-ay-l", "vb"],
  "reconciliation": ["r-eh k-ah-n s-ih l-iy ey1 sh-ah-n", "nn"],
  "recondite": ["r-eh1 k-ah-n d-ay-t", "jj"],
  "recondition": ["r-iy-k-ah-n-d-ih1-sh-ah-n", "vb"],
  "reconfiguration": ["r-iy k-ah-n f-ih g-y-er ey1 sh-ah-n", "nn"],
  "reconfigure": ["r-iy k-ah-n f-ih1 g-y-er", "nn"],
  "reconfirm": ["r-iy k-ah-n f-er1-m", "vb"],
  "reconfirmation": ["r-iy k-aa-n f-er m-ey1 sh-ah-n", "nn"],
  "reconnaissance": ["r-iy k-aa1 n-ah s-ah-n-s", "nn"],
  "reconnect": ["r-iy k-ah n-eh1-k-t", "vb"],
  "reconsider": ["r-iy k-ah-n s-ih1 d-er", "vb vbp"],
  "reconsideration": ["r-iy k-ah-n s-ih d-er ey1 sh-ah-n", "nn"],
  "reconstitute": ["r-iy k-aa1-n s-t-ah t-uw-t", "vb"],
  "reconstruct": ["r-iy k-ah-n s-t-r-ah1-k-t", "vb vbp"],
  "reconstructed": ["r-iy k-ah-n s-t-r-ah1-k t-ih-d", "jj vbd vbn"],
  "reconstruction": ["r-iy k-ah-n s-t-r-ah1-k sh-ah-n", "nn"],
  "reconvene": ["r-iy-k-ah-n-v-iy1-n", "vb"],
  "record": ["r-ah k-ao1-r-d", "nn jj vb vbp"],
  "recorded": ["r-ah k-ao1-r d-ah-d", "vbn vbd jj"],
  "recorder": ["r-ih k-ao1-r d-er", "nn"],
  "recording": ["r-ah k-ao1-r d-ih-ng", "nn vbg"],
  "recordkeeping": ["r-eh1 k-er-d k-iy p-ih-ng", "nn"],
  "recount": ["r-ih k-aw1-n-t", "vb nn"],
  "recoup": ["r-ih k-uw1-p", "vb"],
  "recourse": ["r-iy1 k-ao-r-s", "nn"],
  "recover": ["r-ih k-ah1 v-er", "vb vbp"],
  "recoverable": ["r-ih k-ah1 v-er ah b-ah-l", "jj"],
  "recovery": ["r-ih k-ah1 v-r-iy", "nn"],
  "recreate": ["r-eh1 k-r-iy ey-t", "vb vbp"],
  "recreation": ["r-eh k-r-iy ey1 sh-ah-n", "nn"],
  "recreational": ["r-eh k-r-iy ey1 sh-ah-n ah-l", "jj"],
  "recrimination": ["r-ih k-r-ih m-ih n-ey1 sh-ah-n", "nn"],
  "recruit": ["r-ah k-r-uw1-t", "vb vbp nn"],
  "recruiter": ["r-ih k-r-uw1 t-er", "nn"],
  "recruitment": ["r-ah k-r-uw1-t m-ah-n-t", "nn"],
  "rectangle": ["r-eh1-k t-ae-ng g-ah-l", "nn"],
  "rectangular": ["r-eh-k t-ae1-ng g-y-ah l-er", "jj"],
  "rectification": ["r-eh-k t-ah f-ah k-ey1 sh-ah-n", "nn"],
  "rectified": ["r-eh1-k t-ah f-ay-d", "vbn"],
  "rectifier": ["r-eh1-k t-ah f-ay er", "nn"],
  "rectify": ["r-eh1-k t-ah f-ay", "vb"],
  "rectitude": ["r-eh1-k t-ih t-uw-d", "nn"],
  "rector": ["r-eh1-k t-er", "nn"],
  "rectum": ["r-eh1-k t-ah-m", "nn"],
  "recuperate": ["r-ih k-uw1 p-er ey-t", "vb"],
  "recuperation": ["r-ih k-uw p-er ey1 sh-ah-n", "nn"],
  "recur": ["r-ih k-er1", "vb vbp"],
  "recurrence": ["r-ih k-er1 ah-n-s", "nn"],
  "recurrent": ["r-ih k-er1 ah-n-t", "jj"],
  "recuse": ["r-ih-k-y-uw1-z", "vb"],
  "recyclable": ["r-iy s-ay1 k-l-ah b-ah-l", "jj"],
  "recycle": ["r-iy s-ay1 k-ah-l", "vb"],
  "recycled": ["r-iy s-ay1 k-ah-l-d", "vbn jj vbd"],
  "recycler": ["r-iy s-ay1 k-l-er", "nn"],
  "red": ["r-eh1-d", "jj nn"],
  "redcoat": ["r-eh1-d k-ow-t", "nn"],
  "redder": ["r-eh1 d-er", "jjr rbr"],
  "reddish": ["r-eh1 d-ih-sh", "jj"],
  "redecorate": ["r-iy-d-eh1-k-er-ey-t", "vb"],
  "redecoration": ["r-iy d-eh k-er ey1 sh-ah-n", "nn"],
  "redeem": ["r-ih d-iy1-m", "vb vbp"],
  "redeemable": ["r-ih d-iy1 m-ah b-ah-l", "jj"],
  "redeeming": ["r-ih d-iy1 m-ih-ng", "vbg jj"],
  "redefine": ["r-iy d-ih f-ay1-n", "vb"],
  "redefinition": ["r-iy d-eh f-ah n-ih1 sh-ah-n", "nn"],
  "redemption": ["r-ih d-eh1-m-p sh-ah-n", "nn"],
  "redemptive": ["r-ih d-eh1-m-p t-ih-v", "jj"],
  "redeploy": ["r-iy d-ih p-l-oy1", "vb"],
  "redeployment": ["r-iy d-ih p-l-oy1 m-ah-n-t", "nn"],
  "redeposition": ["r-iy d-eh p-ah z-ih1 sh-ah-n", "nn"],
  "redesign": ["r-iy d-ih-z ay1-n", "nn vb"],
  "redesigned": ["r-iy d-ih-z ay1-n-d", "vbn vbd jj"],
  "redevelop": ["r-iy d-ih-v eh1 l-ah-p", "vb"],
  "redhead": ["r-eh1-d hh-eh-d", "nn"],
  "redheaded": ["r-eh1-d hh-eh d-ih-d", "jj"],
  "redirect": ["r-iy d-er eh1-k-t", "vb"],
  "redirection": ["r-iy d-er eh1-k sh-ah-n", "nn"],
  "rediscover": ["r-iy d-ih-s k-ah1 v-er", "vb"],
  "rediscovery": ["r-iy d-ih-s k-ah1 v-r-iy", "nn"],
  "redistribute": ["r-iy d-ih-s t-r-ih1 b-y-uw-t", "vb vbp"],
  "redistribution": ["r-iy d-ih-s t-r-ah b-y-uw1 sh-ah-n", "nn"],
  "redistrict": ["r-iy d-ih1-s t-r-ih-k-t", "vb"],
  "redneck": ["r-eh1-d n-eh-k", "nn"],
  "redo": ["r-iy d-uw1", "vb"],
  "redone": ["r-iy d-ah1-n", "jj nn"],
  "redouble": ["r-iy d-ah1 b-ah-l", "vb"],
  "redoubt": ["r-ah d-aw1-t", "nn"],
  "redound": ["r-ih d-aw1-n-d", "vb"],
  "redraw": ["r-iy d-r-ao1", "vb"],
  "redrawn": ["r-iy d-r-ao1-n", "jj"],
  "redress": ["r-ih d-r-eh1-s", "vb nn"],
  "reduce": ["r-ah d-uw1-s", "vb vbp"],
  "reduced": ["r-ah d-uw1-s-t", "vbn vbd jj"],
  "reduction": ["r-ah d-ah1-k sh-ah-n", "nn"],
  "redundancy": ["r-ih d-ah1-n d-ah-n s-iy", "nn"],
  "redundant": ["r-ih d-ah1-n d-ah-n-t", "jj"],
  "redwood": ["r-eh1-d w-uh-d", "nn"],
  "reed": ["r-iy1-d", "nn"],
  "reedy": ["r-iy1 d-iy", "jj"],
  "reef": ["r-iy1-f", "nn"],
  "reek": ["r-iy1-k", "vb vbp nn"],
  "reel": ["r-iy1-l", "nn vbp vb"],
  "reemerge": ["r-iy-ih-m-er1-jh", "vb"],
  "reestablish": ["r-iy ih s-t-ae1 b-l-ih-sh", "vb"],
  "reexamination": ["r-iy ih-g z-ae m-ah n-ey1 sh-ah-n", "nn"],
  "reexamine": ["r-iy eh-g z-ae1 m-ah-n", "vb"],
  "refer": ["r-ah f-er1", "vb vbp"],
  "referee": ["r-eh f-er iy1", "nn"],
  "reference": ["r-eh1 f-er ah-n-s", "nn"],
  "referenda": ["r-eh f-er eh1-n d-ah", "nn"],
  "referendum": ["r-eh f-er eh1-n d-ah-m", "nn"],
  "referral": ["r-ih f-er1 ah-l", "nn"],
  "refile": ["r-iy f-ay1-l", "vb"],
  "refill": ["r-iy1 f-ih-l", "nn vb"],
  "refinance": ["r-iy f-ah n-ae1-n-s", "vb"],
  "refine": ["r-ah f-ay1-n", "vb"],
  "refined": ["r-ah f-ay1-n-d", "jj vbn"],
  "refinement": ["r-ah f-ay1-n m-ah-n-t", "nn"],
  "refiner": ["r-ih f-ay1 n-er", "nn"],
  "refinery": ["r-ih f-ay1 n-er iy", "nn"],
  "refit": ["r-iy-f-ih1-t", "vb"],
  "reflect": ["r-ah f-l-eh1-k-t", "vb vbp"],
  "reflected": ["r-ah f-l-eh1-k t-ah-d", "vbd jj vbn"],
  "reflecting": ["r-ah f-l-eh1-k t-ih-ng", "vbg jj"],
  "reflection": ["r-ah f-l-eh1-k sh-ah-n", "nn"],
  "reflective": ["r-ih f-l-eh1-k t-ih-v", "jj"],
  "reflex": ["r-iy1 f-l-eh-k-s", "nn jj"],
  "reflexively": ["r-iy f-l-eh1-k s-ih-v l-iy", "rb"],
  "refocus": ["r-iy f-ow1 k-ah-s", "vb"],
  "reforestation": ["r-iy f-ao r-ah s-t-ey1 sh-ah-n", "nn"],
  "reform": ["r-ah f-ao1-r-m", "nn vb"],
  "reformation": ["r-eh f-er m-ey1 sh-ah-n", "nn"],
  "reformatory": ["r-ih f-ao1-r m-ah t-ao r-iy", "nn"],
  "reformed": ["r-ih f-ao1-r-m-d", "vbn jj vbd"],
  "reformer": ["r-ih f-ao1-r m-er", "jj nn"],
  "reformist": ["r-ih f-ao1-r m-ih-s-t", "nn jj"],
  "reformulate": ["r-iy-f-ao1-r-m-y-ah-l-ey-t", "vb"],
  "reformulated": ["r-iy f-ao1-r m-y-ah l-ey t-ih-d", "vbn jj"],
  "refractive": ["r-ah f-r-ae1-k t-ih-v", "jj"],
  "refractory": ["r-ah f-r-ae1-k t-er iy", "jj nn"],
  "refrain": ["r-ih f-r-ey1-n", "vb nn"],
  "refresh": ["r-ih f-r-eh1-sh", "vb vbp"],
  "refreshed": ["r-iy f-r-eh1-sh-t", "jj vbd vbn"],
  "refresher": ["r-ih f-r-eh1 sh-er", "nn"],
  "refreshing": ["r-ih f-r-eh1 sh-ih-ng", "jj vbg"],
  "refreshingly": ["r-iy f-r-eh1 sh-ih-ng l-iy", "rb"],
  "refreshment": ["r-ah f-r-eh1-sh m-ah-n-t", "nn"],
  "refrigerant": ["r-ih f-r-ih1 jh-er ah-n-t", "nn"],
  "refrigerate": ["r-ih-f-r-ih1-jh-er-ey-t", "vb"],
  "refrigerated": ["r-ih f-r-ih1 jh-er ey t-ih-d", "vbn jj"],
  "refrigeration": ["r-ih f-r-ih jh-er ey1 sh-ah-n", "nn"],
  "refrigerator": ["r-ah f-r-ih1 jh-er ey t-er", "nn"],
  "refuel": ["r-iy f-y-uw1 ah-l", "vb"],
  "refuge": ["r-eh1 f-y-uw-jh", "nn"],
  "refugee": ["r-eh1 f-y-uw jh-iy", "nn"],
  "refund": ["r-ih f-ah1-n-d", "nn vb"],
  "refundable": ["r-ih f-ah1-n d-ah b-ah-l", "jj"],
  "refunding": ["r-ih f-ah1-n d-ih-ng", "vbg jj"],
  "refurbish": ["r-iy f-er1 b-ih-sh", "vb"],
  "refusal": ["r-ah f-y-uw1 z-ah-l", "nn"],
  "refuse": ["r-ah f-y-uw1-z", "vb vbp nn"],
  "refute": ["r-ih f-y-uw1-t", "vb"],
  "regain": ["r-ih g-ey1-n", "vb vbp"],
  "regal": ["r-iy1 g-ah-l", "jj"],
  "regale": ["r-iy1 g-eh1-l", "vb"],
  "regalia": ["r-ih g-ey1 l-y-ah", "nn"],
  "regard": ["r-ah g-aa1-r-d", "nn vb vbp"],
  "regarded": ["r-ah g-aa1-r d-ah-d", "vbn jj vbd"],
  "regardless": ["r-ah g-aa1-r-d l-ah-s", "rb"],
  "regatta": ["r-ah g-aa1 t-ah", "nn"],
  "regenerate": ["r-iy jh-eh1 n-er ey-t", "vb"],
  "regeneration": ["r-iy jh-eh1 n-er ey1 sh-ah-n", "nn"],
  "regent": ["r-iy1 jh-ah-n-t", "nn"],
  "reggae": ["r-eh1 g-ey", "nn"],
  "regime": ["r-ah zh-iy1-m", "nn"],
  "regimen": ["r-eh1 jh-ah m-ah-n", "nn"],
  "regiment": ["r-eh1 jh-ah m-ah-n-t", "nn vb"],
  "regimentation": ["r-eh jh-ah m-eh-n t-ey1 sh-ah-n", "nn"],
  "regimented": ["r-eh1 jh-ah m-eh-n t-ih-d", "vbn jj"],
  "region": ["r-iy1 jh-ah-n", "nn"],
  "regional": ["r-iy1 jh-ah n-ah-l", "jj"],
  "regionally": ["r-iy1 jh-ah-n ah l-iy", "rb"],
  "register": ["r-eh1 jh-ih s-t-er", "vb nn vbp"],
  "registered": ["r-eh1 jh-ih s-t-er-d", "vbn vbd jj"],
  "registrant": ["r-eh1 jh-ah-s t-r-ah-n-t", "nn"],
  "registrar": ["r-eh1 jh-ih s-t-r-aa-r", "nn"],
  "registration": ["r-eh jh-ih-s t-r-ey1 sh-ah-n", "nn"],
  "registry": ["r-eh1 jh-ih-s t-r-iy", "nn"],
  "regress": ["r-iy1 g-r-eh-s", "vb"],
  "regression": ["r-ah g-r-eh1 sh-ah-n", "nn"],
  "regressive": ["r-ah g-r-eh1 s-ih-v", "jj"],
  "regret": ["r-ah g-r-eh1-t", "vbp nn vb"],
  "regrettable": ["r-ih g-r-eh1 t-ah b-ah-l", "jj"],
  "regrettably": ["r-ih g-r-eh1 t-ah b-l-iy", "rb"],
  "regroup": ["r-iy g-r-uw1-p", "vb vbp"],
  "regular": ["r-eh1 g-y-ah l-er", "jj"],
  "regularity": ["r-eh g-y-ah l-eh1 r-ah t-iy", "nn"],
  "regularly": ["r-eh1 g-y-ah l-er l-iy", "rb"],
  "regulate": ["r-eh1 g-y-ah l-ey-t", "vb vbp"],
  "regulated": ["r-eh1 g-y-ah l-ey t-ah-d", "vbn jj vbd"],
  "regulation": ["r-eh g-y-ah l-ey1 sh-ah-n", "nn jj"],
  "regulative": ["r-eh1 g-y-ah l-ey t-ih-v", "jj"],
  "regulator": ["r-eh1 g-y-ah l-ey t-er", "nn"],
  "regulatory": ["r-eh1 g-y-ah l-ah t-ao r-iy", "jj"],
  "rehabilitate": ["r-iy-hh ah b-ih1 l-ah t-ey-t", "vb"],
  "rehabilitation": ["r-iy-hh ah b-ih l-ah t-ey1 sh-ah-n", "nn"],
  "rehash": ["r-iy hh-ae1-sh", "nn vb vbp"],
  "rehear": ["r-iy hh-ih1-r", "vb"],
  "rehearing": ["r-iy hh-ih1 r-ih-ng", "nn"],
  "rehearsal": ["r-ih hh-er1 s-ah-l", "nn"],
  "rehearse": ["r-iy hh-er1-s", "vb"],
  "reign": ["r-ey1-n", "nn vbp vb"],
  "reignite": ["r-iy ih-g n-ay1-t", "vb nn"],
  "reimburse": ["r-iy ih-m b-er1-s", "vb vbp"],
  "reimbursement": ["r-iy ih-m b-er1-s m-ah-n-t", "nn"],
  "reimpose": ["r-iy ih-m p-ow1-z", "vb jj"],
  "rein": ["r-ey1-n", "vb nn"],
  "reincarnate": ["r-iy-ih-n-k-aa1-r-n-ey-t", "vb"],
  "reinforce": ["r-iy ih-n f-ao1-r-s", "vb vbp"],
  "reinforced": ["r-iy ih-n f-ao1-r-s-t", "vbn vbd jj"],
  "reinforcement": ["r-iy ih-n f-ao1-r-s m-ah-n-t", "nn"],
  "reinstate": ["r-iy ih-n s-t-ey1-t", "vb"],
  "reinstatement": ["r-iy ih-n s-t-ey1-t m-ah-n-t", "nn"],
  "reinstitute": ["r-iy-ih1-n-s-t-ih-t-uw-t", "vb"],
  "reinsurance": ["r-iy ih-n sh-uh1 r-ah-n-s", "nn"],
  "reinsure": ["r-iy ih-n sh-uh1-r", "vb"],
  "reintegrate": ["r-iy-ih1-n-t-ah-g-r-ey-t", "vb"],
  "reinterpret": ["r-iy ih-n t-er1 p-r-ah-t", "vb"],
  "reinterpretation": ["r-iy ih-n t-er p-r-ah t-ey1 sh-ah-n", "nn"],
  "reintroduce": ["r-iy ih-n t-r-ah d-uw1-s", "vbp vb"],
  "reinvent": ["r-iy ih-n v-eh1-n-t", "vb"],
  "reinvest": ["r-iy ih-n v-eh1-s-t", "vb vbp"],
  "reinvestment": ["r-iy ih-n v-eh1-s-t m-ah-n-t", "nn"],
  "reinvigorate": ["r-iy ih-n v-ih1 g-er ey-t", "vb"],
  "reinvigoration": ["r-iy ih-n v-ih g-er ey1 sh-ah-n", "nn"],
  "reissue": ["r-iy ih1 sh-uw", "nn"],
  "reiterate": ["r-iy ih1 t-er ey-t", "vb vbp"],
  "reiteration": ["r-iy ih t-er ey1 sh-ah-n", "nn"],
  "reject": ["r-ih jh-eh1-k-t", "vb vbp"],
  "rejection": ["r-ih jh-eh1-k sh-ah-n", "nn"],
  "rejigger": ["r-iy jh-ih1 g-er", "vb"],
  "rejoice": ["r-ih jh-oy1-s", "vbp vb"],
  "rejoin": ["r-iy jh-oy1-n", "vb vbp"],
  "rejoinder": ["r-ih jh-oy1-n d-er", "nn"],
  "rejuvenate": ["r-ih jh-uw1 v-ah n-ey-t", "vb"],
  "rejuvenated": ["r-ih jh-uw1 v-ah n-ey t-ih-d", "vbn jj"],
  "rejuvenation": ["r-ih jh-uw v-ah n-ey1 sh-ah-n", "nn"],
  "rekindle": ["r-iy k-ih1-n d-ah-l", "vb"],
  "relaid": ["r-iy l-ey1-d", "vbd"],
  "relapse": ["r-iy l-ae1-p-s", "nn"],
  "relate": ["r-ih l-ey1-t", "vbp vb"],
  "related": ["r-ih l-ey1 t-ih-d", "vbn jj vbd"],
  "relation": ["r-iy l-ey1 sh-ah-n", "nn"],
  "relational": ["r-iy l-ey1 sh-ah n-ah-l", "jj"],
  "relationship": ["r-iy l-ey1 sh-ah-n sh-ih-p", "nn"],
  "relative": ["r-eh1 l-ah t-ih-v", "jj nn"],
  "relatively": ["r-eh1 l-ah t-ih-v l-iy", "rb"],
  "relativism": ["r-eh1 l-ah t-ih v-ih z-ah-m", "nn"],
  "relativistic": ["r-eh l-ah t-ih v-ih1 s-t-ih-k", "jj"],
  "relativity": ["r-eh l-ah t-ih1 v-ah t-iy", "nn"],
  "relaunch": ["r-iy l-ao1-n-ch", "vb"],
  "relax": ["r-ih l-ae1-k-s", "vb vbp"],
  "relaxation": ["r-iy l-ae-k s-ey1 sh-ah-n", "nn"],
  "relaxed": ["r-ih l-ae1-k-s-t", "vbn jj vbd"],
  "relaxing": ["r-ih l-ae1-k s-ih-ng", "vbg jj"],
  "relay": ["r-iy1 l-ey", "vb nn vbp"],
  "release": ["r-iy l-iy1-s", "nn vbp vb"],
  "relegate": ["r-eh1-l-ah-g-ey-t", "vb"],
  "relent": ["r-ih l-eh1-n-t", "vbp vb"],
  "relentless": ["r-ih l-eh1-n-t l-ih-s", "jj"],
  "relentlessly": ["r-ih l-eh1-n-t l-ah-s l-iy", "rb"],
  "relevance": ["r-eh1 l-ah v-ah-n-s", "nn"],
  "relevancy": ["r-eh1 l-ah v-ah-n s-iy", "nn"],
  "relevant": ["r-eh1 l-ah v-ah-n-t", "jj"],
  "reliability": ["r-iy l-ay ah b-ih1 l-ah t-iy", "nn"],
  "reliable": ["r-ih l-ay1 ah b-ah-l", "jj"],
  "reliably": ["r-ih l-ay1 ah b-l-iy", "rb"],
  "reliance": ["r-ih l-ay1 ah-n-s", "nn"],
  "reliant": ["r-ih l-ay1 ah-n-t", "jj"],
  "relic": ["r-eh1 l-ih-k", "nn"],
  "relief": ["r-ih l-iy1-f", "nn"],
  "relieve": ["r-ih l-iy1-v", "vb"],
  "relieved": ["r-ih l-iy1-v-d", "vbn vbd jj"],
  "reliever": ["r-iy l-iy1 v-er", "nn"],
  "religion": ["r-ih l-ih1 jh-ah-n", "nn"],
  "religious": ["r-ih l-ih1 jh-ah-s", "jj in nn"],
  "religiously": ["r-ih l-ih1 jh-ah-s l-iy", "rb"],
  "relinquish": ["r-ih l-ih1-ng k-w-ih-sh", "vb vbp"],
  "relish": ["r-eh1 l-ih-sh", "nn vb"],
  "relive": ["r-iy l-ih1-v", "vbp vb"],
  "relocate": ["r-iy l-ow1 k-ey-t", "vb nn vbp"],
  "relocation": ["r-iy l-ow1 k-ey1 sh-ah-n", "nn"],
  "reluctance": ["r-ih l-ah1-k t-ah-n-s", "nn"],
  "reluctant": ["r-ih l-ah1-k t-ah-n-t", "jj"],
  "reluctantly": ["r-ih l-ah1-k t-ah-n-t l-iy", "rb"],
  "rely": ["r-ih l-ay1", "vb vbp"],
  "remade": ["r-iy m-ey1-d", "vbd vbn"],
  "remain": ["r-ih m-ey1-n", "vb vbp"],
  "remainder": ["r-ih m-ey1-n d-er", "nn"],
  "remaining": ["r-ih m-ey1 n-ih-ng", "vbg jj"],
  "remake": ["r-iy1 m-ey1-k", "vb"],
  "remand": ["r-ih-m-ae1-n-d", "vb"],
  "remark": ["r-ih m-aa1-r-k", "nn vb"],
  "remarkable": ["r-ih m-aa1-r k-ah b-ah-l", "jj"],
  "remarkably": ["r-ih m-aa1-r k-ah b-l-iy", "rb"],
  "remarried": ["r-iy m-eh1 r-iy-d", "vbd vbn"],
  "remarry": ["r-iy m-eh1 r-iy", "vb"],
  "remarrying": ["r-iy m-eh1 r-iy ih-ng", "nn"],
  "rematch": ["r-iy1 m-ae1-ch", "nn"],
  "remedial": ["r-ih m-iy1 d-iy ah-l", "jj"],
  "remediation": ["r-ih m-iy d-iy ey1 sh-ah-n", "nn"],
  "remedied": ["r-eh1 m-ah d-iy-d", "vbn"],
  "remedy": ["r-eh1 m-ah d-iy", "nn vb"],
  "remember": ["r-ih m-eh1-m b-er", "vb vbp"],
  "remembered": ["r-ih m-eh1-m b-er-d", "vbd jj vbn"],
  "remembrance": ["r-iy m-eh1-m b-r-ah-n-s", "nn"],
  "remind": ["r-iy m-ay1-n-d", "vb vbp"],
  "reminder": ["r-iy m-ay1-n d-er", "nn"],
  "reminisce": ["r-eh-m-ah-n-ih1-s", "vb"],
  "reminiscence": ["r-eh m-ah n-ih1 s-ah-n-s", "nn"],
  "reminiscent": ["r-eh m-ah n-ih1 s-ah-n-t", "jj nn"],
  "remiss": ["r-iy m-ih1-s", "jj"],
  "remission": ["r-iy m-ih1 sh-ah-n", "nn"],
  "remit": ["r-iy-m-ih1-t", "vb"],
  "remittance": ["r-iy m-ih1 t-ah-n s-ih", "nn"],
  "remnant": ["r-eh1-m n-ah-n-t", "nn"],
  "remodel": ["r-iy-m-aa1-d-ah-l", "vb"],
  "remorse": ["r-ih m-ao1-r-s", "nn"],
  "remorseless": ["r-ih m-ao1-r-s l-ah-s", "jj"],
  "remote": ["r-ih m-ow1-t", "jj"],
  "remotely": ["r-iy m-ow1-t l-iy", "rb"],
  "remoteness": ["r-iy m-ow1-t n-ah-s", "nn"],
  "remotest": ["r-ih m-ow1 t-ah-s-t", "jjs"],
  "removable": ["r-ih m-uw1 v-ah b-ah-l", "jj"],
  "removal": ["r-ih m-uw1 v-ah-l", "nn"],
  "remove": ["r-iy m-uw1-v", "vb vbp"],
  "removed": ["r-iy m-uw1-v-d", "vbn jj vbd"],
  "remuneration": ["r-ih m-y-uw n-er ey1 sh-ah-n", "nn"],
  "remunerative": ["r-iy m-y-uw1 n-er ah t-ih-v", "jj"],
  "renaissance": ["r-eh n-ah s-aa1-n-s", "nn"],
  "renal": ["r-iy1 n-ah-l", "jj"],
  "rename": ["r-iy n-ey1-m", "vb"],
  "renationalize": ["r-iy n-ae1 sh-ah-n ah l-ay-z", "vb"],
  "render": ["r-eh1-n d-er", "vb vbp"],
  "rendezvous": ["r-aa1-n d-ih v-uw", "nn"],
  "rendition": ["r-eh-n d-ih1 sh-ah-n", "nn"],
  "renegade": ["r-eh1 n-ah g-ey-d", "nn"],
  "renege": ["r-ih n-ih1-g", "vb"],
  "renegotiate": ["r-iy n-ih g-ow1 sh-iy ey-t", "vb"],
  "renegotiation": ["r-iy n-ih g-ow sh-iy ey1 sh-ah-n", "nn"],
  "renew": ["r-ih n-uw1", "vb vbp"],
  "renewable": ["r-iy n-uw1 ah b-ah-l", "jj"],
  "renewal": ["r-ih n-uw1 ah-l", "nn"],
  "renewed": ["r-ih n-uw1-d", "vbn vbd jj"],
  "renounce": ["r-ih n-aw1-n-s", "vb"],
  "renovate": ["r-eh1 n-ah v-ey-t", "vb"],
  "renovated": ["r-eh1 n-ah v-ey t-ih-d", "vbn jj"],
  "renovation": ["r-eh n-ah v-ey1 sh-ah-n", "nn"],
  "renown": ["r-ih n-aw1-n", "nn vb"],
  "renowned": ["r-ih n-aw1-n-d", "jj vbn"],
  "rent": ["r-eh1-n-t", "nn vb vbp"],
  "rental": ["r-eh1-n t-ah-l", "jj nn"],
  "rented": ["r-eh1-n t-ah-d", "vbn jj vbd"],
  "renter": ["r-eh1-n t-er", "nn"],
  "renunciation": ["r-ih n-ah-n s-iy ey1 sh-ah-n", "nn"],
  "reoffer": ["r-iy-ao1-f-er", "vb"],
  "reoffered": ["r-iy ao1 f-er-d", "vbn jj vbd"],
  "reopen": ["r-iy ow1 p-ah-n", "vb vbp"],
  "reopened": ["r-iy ow1 p-ah-n-d", "vbd vbn"],
  "reorder": ["r-iy ao1-r d-er", "vb"],
  "reordering": ["r-iy ao1-r d-er ih-ng", "nn vbg"],
  "reorganization": ["r-iy ao-r g-ah n-ah z-ey1 sh-ah-n", "nn"],
  "reorganize": ["r-iy ao1-r g-ah n-ay-z", "vb"],
  "reorganized": ["r-iy ao1-r g-ah n-ay-z-d", "vbn jj vbd"],
  "reorient": ["r-iy ao1 r-iy eh-n-t", "vb"],
  "rep": ["r-eh1-p", "nn"],
  "repackage": ["r-iy p-ae1 k-ih-jh", "vb"],
  "repaid": ["r-iy p-ey1-d", "vbn vbd"],
  "repaint": ["r-iy-p-ey1-n-t", "vb"],
  "repainted": ["r-iy p-ey1-n t-ah-d", "vbn jj"],
  "repair": ["r-ih p-eh1-r", "nn vb vbp"],
  "repairman": ["r-ih p-eh1-r m-ae-n", "nn"],
  "reparation": ["r-eh p-er ey1 sh-ah-n", "nn"],
  "repartee": ["r-eh p-er t-iy1", "nn"],
  "repatriate": ["r-iy p-ey1 t-r-iy ey-t", "vb vbp"],
  "repatriation": ["r-iy p-ey t-r-iy ey1 sh-ah-n", "nn"],
  "repay": ["r-iy p-ey1", "vb vbp"],
  "repayable": ["r-iy p-ey1 ah b-ah-l", "jj"],
  "repayment": ["r-iy p-ey1 m-ah-n-t", "nn"],
  "repeal": ["r-ih p-iy1-l", "nn vb"],
  "repeat": ["r-ih p-iy1-t", "vb jj nn vbp"],
  "repeated": ["r-ih p-iy1 t-ih-d", "vbn jj vbd"],
  "repeatedly": ["r-ih p-iy1 t-ih-d l-iy", "rb"],
  "repeater": ["r-ih p-iy1 t-er", "nn"],
  "repeating": ["r-ih p-iy1 t-ih-ng", "vbg jj"],
  "repel": ["r-ih p-eh1-l", "vb vbp"],
  "repellent": ["r-ih p-eh1 l-ah-n-t", "jj nn"],
  "repent": ["r-ih p-eh1-n-t", "vb vbp"],
  "repentance": ["r-ih p-eh1-n t-ah-n-s", "nn"],
  "repercussion": ["r-iy p-er k-ah1 sh-ah-n", "nn"],
  "repertoire": ["r-eh1 p-er t-w-aa-r", "nn"],
  "repertory": ["r-eh1 p-er t-ao r-iy", "nn"],
  "repetition": ["r-eh p-ah t-ih1 sh-ah-n", "nn"],
  "repetitious": ["r-eh p-ah t-ih1 sh-ah-s", "jj"],
  "repetitive": ["r-ih p-eh1 t-ih t-ih-v", "jj"],
  "rephrase": ["r-iy f-r-ey1-z", "vb"],
  "replace": ["r-iy p-l-ey1-s", "vb vbp"],
  "replacement": ["r-ih p-l-ey1-s m-ah-n-t", "nn jj"],
  "replant": ["r-iy-p-l-ae1-n-t", "vb"],
  "replay": ["r-iy p-l-ey1", "nn vb"],
  "replenish": ["r-iy p-l-eh1 n-ih-sh", "vb"],
  "replenishment": ["r-ih p-l-eh1 n-ih-sh m-ah-n-t", "nn"],
  "replete": ["r-iy p-l-iy1-t", "jj"],
  "replica": ["r-eh1 p-l-ih k-ah", "nn"],
  "replicate": ["r-eh1 p-l-ah k-ey-t", "vb"],
  "replication": ["r-eh p-l-ah k-ey1 sh-ah-n", "nn"],
  "replied": ["r-ih p-l-ay1-d", "vbd vbn"],
  "reply": ["r-ih p-l-ay1", "nn vb vbp"],
  "report": ["r-iy p-ao1-r-t", "nn vbp vb"],
  "reportage": ["r-ih p-ao1-r t-ih-jh", "nn"],
  "reported": ["r-iy p-ao1-r t-ah-d", "vbd jj vbn"],
  "reportedly": ["r-ih p-ao1-r t-ah-d l-iy", "rb"],
  "reporter": ["r-ih p-ao1-r t-er", "nn"],
  "reportorial": ["r-eh p-er t-ao1 r-iy ah-l", "jj"],
  "repose": ["r-iy p-ow1-z", "nn"],
  "reposition": ["r-iy p-ah z-ih1 sh-ah-n", "vb"],
  "repositioning": ["r-iy p-ah z-ih1 sh-ah-n ih-ng", "nn vbg"],
  "repository": ["r-iy p-aa1 z-ah t-ao r-iy", "nn"],
  "repossess": ["r-iy p-ah z-eh1-s", "vb"],
  "repossessed": ["r-iy p-ah z-eh1-s-t", "jj vbn"],
  "reprehensible": ["r-eh p-r-ih hh-eh1-n s-ah b-ah-l", "jj"],
  "represent": ["r-eh p-r-ah z-eh1-n-t", "vb vbp"],
  "representation": ["r-eh p-r-ah z-eh-n t-ey1 sh-ah-n", "nn"],
  "representational": ["r-eh p-r-ah z-ah-n t-ey1 sh-ah n-ah-l", "jj nn"],
  "representative": ["r-eh p-r-ah z-eh1-n t-ah t-ih-v", "nn jj"],
  "repress": ["r-iy p-r-eh1-s", "vb"],
  "repressed": ["r-iy p-r-eh1-s-t", "vbn jj"],
  "repression": ["r-iy p-r-eh1 sh-ah-n", "nn"],
  "repressive": ["r-iy p-r-eh1 s-ih-v", "jj"],
  "reprice": ["r-iy p-r-ay1-s", "vb"],
  "repricing": ["r-iy p-r-ay1 s-ih-ng", "nn"],
  "reprieve": ["r-iy p-r-iy1-v", "nn"],
  "reprimand": ["r-eh1-p-r-ah-m-ae-n-d", "vb"],
  "reprint": ["r-iy p-r-ih1-n-t", "vb"],
  "reprisal": ["r-iy p-r-ay1 z-ah-l", "nn"],
  "reproach": ["r-iy p-r-ow1-ch", "nn"],
  "reprocess": ["r-iy p-r-ao1 s-eh-s", "vb"],
  "reproduce": ["r-iy p-r-ah d-uw1-s", "vb"],
  "reproduction": ["r-iy p-r-ah d-ah1-k sh-ah-n", "nn"],
  "reproductive": ["r-iy p-r-ah d-ah1-k t-ih-v", "jj"],
  "reptile": ["r-eh1-p t-ay-l", "nn"],
  "republic": ["r-iy p-ah1 b-l-ah-k", "nn"],
  "republican": ["r-ih p-ah1 b-l-ih k-ah-n", "jj"],
  "repudiate": ["r-iy p-y-uw1 d-iy ey-t", "vb"],
  "repudiation": ["r-ih p-y-uw d-iy ey1 sh-ah-n", "nn"],
  "repugnant": ["r-ih p-ah1-g n-ah-n-t", "jj"],
  "repulse": ["r-iy-p-ah1-l-s", "vb"],
  "repulsive": ["r-iy p-ah1-l s-ih-v", "jj"],
  "repurchase": ["r-iy p-er1 ch-ah-s", "nn jj vb"],
  "reputable": ["r-eh1 p-y-ah t-ah b-ah-l", "jj"],
  "reputation": ["r-eh p-y-ah t-ey1 sh-ah-n", "nn"],
  "repute": ["r-iy p-y-uw1-t", "nn vb"],
  "reputed": ["r-ih p-y-uw1 t-ih-d", "vbn jj"],
  "reputedly": ["r-ih p-y-uw1 t-ih-d l-iy", "rb"],
  "requalify": ["r-iy k-w-aa1 l-ah f-ay", "vb"],
  "request": ["r-ih k-w-eh1-s-t", "nn vb vbp"],
  "require": ["r-iy k-w-ay1 er", "vb vbp"],
  "required": ["r-iy k-w-ay1 er-d", "vbn vbd jj"],
  "requirement": ["r-ih k-w-ay1-r m-ah-n-t", "nn"],
  "requisite": ["r-eh1 k-w-ah z-ah-t", "jj"],
  "requisition": ["r-eh-k-w-ah-z-ih1-sh-ah-n", "vb"],
  "reread": ["r-iy1 r-iy1-d", "vb vbd vbn"],
  "reroute": ["r-iy-r-uw1-t", "vb"],
  "rerun": ["r-iy1 r-ah1-n", "nn"],
  "resale": ["r-iy1 s-ey-l", "nn"],
  "reschedule": ["r-iy s-k-eh1 jh-uw-l", "vb"],
  "rescind": ["r-ih s-ih1-n-d", "vb"],
  "rescission": ["r-ih s-ih1 zh-ah-n", "nn"],
  "rescue": ["r-eh1 s-k-y-uw", "nn vb"],
  "rescuer": ["r-eh1 s-k-y-uw er", "nn"],
  "reseacher": ["r-iy s-er1 ch-er", "nn"],
  "research": ["r-iy s-er1-ch", "nn vb vbp"],
  "researcher": ["r-iy1 s-er ch-er", "nn"],
  "resell": ["r-iy s-eh1-l", "vb vbp jj"],
  "reseller": ["r-iy s-eh1 l-er", "jj nn"],
  "resemblance": ["r-ih z-eh1-m b-l-ah-n-s", "nn"],
  "resemble": ["r-ih z-eh1-m b-ah-l", "vb vbp"],
  "resent": ["r-ih z-eh1-n-t", "vbp vb"],
  "resentful": ["r-ih z-eh1-n-t f-ah-l", "jj"],
  "resentment": ["r-ih z-eh1-n-t m-ah-n-t", "nn"],
  "reservation": ["r-eh z-er v-ey1 sh-ah-n", "nn"],
  "reserve": ["r-ih z-er1-v", "nn jj vb vbp"],
  "reserved": ["r-ih z-er1-v-d", "vbn vbd jj"],
  "reservist": ["r-ih z-er1 v-ih-s-t", "nn"],
  "reservoir": ["r-eh1 z-ah v-w-aa-r", "nn"],
  "reset": ["r-iy s-eh1-t", "nn vbn jj vb"],
  "resettable": ["r-iy s-eh1 t-ah b-ah-l", "jj"],
  "resettle": ["r-iy s-eh1 t-ah-l", "vb"],
  "resettlement": ["r-iy s-eh1 t-ah-l m-ah-n-t", "nn"],
  "reshape": ["r-iy sh-ey1-p", "vb"],
  "reshuffle": ["r-iy sh-ah1 f-ah-l", "nn vb"],
  "reside": ["r-ih z-ay1-d", "vbp vb"],
  "residence": ["r-eh1 z-ih d-ah-n-s", "nn"],
  "residency": ["r-eh1 z-ih d-ah-n s-iy", "nn"],
  "resident": ["r-eh1 z-ih d-ah-n-t", "nn jj"],
  "residential": ["r-eh z-ih d-eh1-n ch-ah-l", "jj"],
  "residual": ["r-ih z-ih1 jh-uw ah-l", "jj nn"],
  "residue": ["r-eh1 z-ah d-uw", "nn"],
  "resign": ["r-ih z-ay1-n", "vb vbp"],
  "resignation": ["r-eh z-ah-g n-ey1 sh-ah-n", "nn"],
  "resigned": ["r-ih z-ay1-n-d", "vbd vbn jj"],
  "resilience": ["r-ih z-ih1 l-iy ah-n-s", "nn"],
  "resiliency": ["r-ih z-ih1 l-y-ah-n s-iy", "nn"],
  "resilient": ["r-ih z-ih1 l-y-ah-n-t", "jj"],
  "resin": ["r-eh1 z-ah-n", "nn"],
  "resist": ["r-ih z-ih1-s-t", "vb vbp"],
  "resistance": ["r-ih z-ih1 s-t-ah-n-s", "nn"],
  "resistant": ["r-ih z-ih1 s-t-ah-n-t", "jj nn"],
  "resistor": ["r-ih z-ih1 s-t-er", "nn"],
  "resold": ["r-iy s-ow1-l-d", "vbd vbn"],
  "resolute": ["r-eh1 z-ah l-uw-t", "jj"],
  "resolutely": ["r-eh1 s-ah l-uw-t l-iy", "rb"],
  "resolution": ["r-eh z-ah l-uw1 sh-ah-n", "nn"],
  "resolve": ["r-iy z-aa1-l-v", "vb nn"],
  "resonance": ["r-eh1 z-ah n-ah-n-s", "nn"],
  "resonant": ["r-eh1 z-ah n-ah-n-t", "jj"],
  "resonate": ["r-eh1 z-ah n-ey-t", "vb"],
  "resort": ["r-ih z-ao1-r-t", "nn vbp vb"],
  "resounding": ["r-iy s-aw1-n d-ih-ng", "jj"],
  "resource": ["r-iy1 s-ao-r-s", "nn"],
  "resourceful": ["r-iy s-ao1-r-s f-ah-l", "jj"],
  "resourcefulness": ["r-iy s-ao1-r-s f-ah-l n-ah-s", "nn"],
  "respect": ["r-ih s-p-eh1-k-t", "nn vbp vb"],
  "respectability": ["r-iy s-p-eh-k t-ah b-ih1 l-ih t-iy", "nn"],
  "respectable": ["r-ih s-p-eh1-k t-ah b-ah-l", "jj"],
  "respected": ["r-ih s-p-eh1-k t-ih-d", "vbn jj vbd"],
  "respectful": ["r-ih s-p-eh1-k-t f-ah-l", "jj"],
  "respectfully": ["r-ih s-p-eh1-k-t f-ah l-iy", "rb"],
  "respective": ["r-ih s-p-eh1-k t-ih-v", "jj"],
  "respectively": ["r-ih s-p-eh1-k t-ih-v l-iy", "rb"],
  "respiration": ["r-eh s-p-er ey1 sh-ah-n", "nn"],
  "respirator": ["r-eh1 s-p-er ey t-er", "nn"],
  "respiratory": ["r-eh1 s-p-er ah t-ao r-iy", "jj"],
  "respite": ["r-eh1 s-p-ih-t", "nn"],
  "resplendent": ["r-iy s-p-l-eh1-n d-ah-n-t", "jj"],
  "respond": ["r-ih s-p-aa1-n-d", "vb nn vbp"],
  "respondent": ["r-ih s-p-aa1-n d-ah-n-t", "nn"],
  "response": ["r-ih s-p-aa1-n-s", "nn"],
  "responsibility": ["r-iy s-p-aa-n s-ah b-ih1 l-ah t-iy", "nn"],
  "responsible": ["r-iy s-p-aa1-n s-ah b-ah-l", "jj"],
  "responsibly": ["r-ih s-p-aa1-n s-ah b-l-iy", "rb"],
  "responsive": ["r-ih s-p-aa1-n s-ih-v", "jj"],
  "responsiveness": ["r-ih s-p-aa1-n s-ih-v n-ah-s", "nn"],
  "rest": ["r-eh1-s-t", "nn vbp vb rb"],
  "restage": ["r-iy-s-t-ey1-jh", "vb"],
  "restart": ["r-iy s-t-aa1-r-t", "vb"],
  "restate": ["r-iy s-t-ey1-t", "vb"],
  "restated": ["r-iy s-t-ey1 t-ih-d", "vbn vbd jj"],
  "restatement": ["r-iy s-t-ey1-t m-ah-n-t", "nn"],
  "restaurant": ["r-eh1 s-t-er aa-n-t", "nn"],
  "restaurateur": ["r-eh s-t-er ah t-er1", "nn"],
  "restful": ["r-eh1-s-t f-ah-l", "jj"],
  "restitution": ["r-eh s-t-ih t-uw1 sh-ah-n", "nn"],
  "restive": ["r-eh1 s-t-ih-v", "jj"],
  "restless": ["r-eh1-s-t l-ah-s", "jj"],
  "restlessly": ["r-eh1-s-t l-ah-s l-iy", "rb"],
  "restlessness": ["r-eh1-s-t l-ah-s n-ah-s", "nn"],
  "restock": ["r-iy s-t-aa1-k", "vb"],
  "restoration": ["r-eh s-t-er ey1 sh-ah-n", "nn"],
  "restore": ["r-ih s-t-ao1-r", "vb vbp"],
  "restorer": ["r-ih s-t-ao1 r-er", "nn"],
  "restrain": ["r-iy s-t-r-ey1-n", "vb"],
  "restrained": ["r-iy s-t-r-ey1-n-d", "vbn vbd jj"],
  "restraining": ["r-iy s-t-r-ey1 n-ih-ng", "vbg jj"],
  "restraint": ["r-ih s-t-r-ey1-n-t", "nn"],
  "restrict": ["r-iy s-t-r-ih1-k-t", "vb vbp"],
  "restricted": ["r-iy s-t-r-ih1-k t-ah-d", "vbn jj vbd"],
  "restricting": ["r-iy s-t-r-ih1-k t-ih-ng", "vbg jj"],
  "restriction": ["r-iy-s t-r-ih1-k sh-ah-n", "nn"],
  "restrictive": ["r-iy s-t-r-ih1-k t-ih-v", "jj"],
  "restroom": ["r-eh1-s-t r-uw-m", "nn"],
  "restructure": ["r-iy s-t-r-ah1-k ch-er", "vb vbp nn"],
  "restructured": ["r-iy s-t-r-ah1-k ch-er-d", "vbn vbd jj"],
  "restructuring": ["r-iy s-t-r-ah1-k ch-er ih-ng", "vbg nn"],
  "restyle": ["r-iy-s-t-ay1-l", "vb"],
  "restyled": ["r-iy s-t-ay1-l-d", "vbn jj"],
  "resubmit": ["r-iy s-ah-b m-ih1-t", "vb"],
  "result": ["r-ih z-ah1-l-t", "nn vbp vb"],
  "resultant": ["r-iy z-ah1-l t-ah-n-t", "jj nn"],
  "resulting": ["r-ih z-ah1-l t-ih-ng", "vbg jj"],
  "resume": ["r-ih z-uw1-m", "vb nn vbp"],
  "resumption": ["r-ih z-ah1-m-p sh-ah-n", "nn"],
  "resurface": ["r-iy-s-er1-f-ah-s", "vb"],
  "resurge": ["r-iy s-er1-jh", "vb"],
  "resurgence": ["r-iy s-er1 jh-ah-n-s", "nn"],
  "resurgent": ["r-ih s-er1 jh-ah-n-t", "jj"],
  "resurrect": ["r-eh z-er eh1-k-t", "vb vbp"],
  "resurrection": ["r-eh z-er eh1-k sh-ah-n", "nn"],
  "resuscitate": ["r-ih s-ah1 s-ih t-ey-t", "vb"],
  "resuscitation": ["r-ih s-ah s-ih t-ey1 sh-ah-n", "nn"],
  "retail": ["r-iy1 t-ey-l", "jj nn vb vbp"],
  "retailer": ["r-iy1 t-ey l-er", "nn"],
  "retain": ["r-ih t-ey1-n", "vb vbp"],
  "retained": ["r-ih t-ey1-n-d", "vbn jj vbd"],
  "retainer": ["r-ih t-ey1 n-er", "nn"],
  "retake": ["r-iy1 t-ey1-k", "vb"],
  "retaliate": ["r-ih t-ae1 l-iy ey-t", "vb"],
  "retaliation": ["r-iy t-ae l-iy ey1 sh-ah-n", "nn"],
  "retaliatory": ["r-iy t-ae1 l-y-ah t-ao r-iy", "jj"],
  "retard": ["r-ih t-aa1-r-d", "vb vbp"],
  "retardant": ["r-iy t-aa1-r d-ah-n-t", "nn"],
  "retardation": ["r-iy t-aa-r d-ey1 sh-ah-n", "nn"],
  "retarded": ["r-ih t-aa1-r d-ih-d", "jj"],
  "retelling": ["r-iy t-eh1 l-ih-ng", "nn"],
  "retention": ["r-iy t-eh1-n sh-ah-n", "nn"],
  "rethink": ["r-iy th-ih1-ng-k", "vb nn"],
  "reticence": ["r-eh1 t-ih s-ah-n-s", "nn"],
  "reticent": ["r-eh1 t-ih s-ah-n-t", "jj"],
  "retina": ["r-eh1 t-ah n-ah", "nn"],
  "retinal": ["r-eh1 t-ah n-ah-l", "jj"],
  "retinue": ["r-eh1 t-ah n-uw", "nn"],
  "retire": ["r-ih t-ay1-r", "vb vbp"],
  "retired": ["r-ih t-ay1-r-d", "vbn jj vbd"],
  "retiree": ["r-iy t-ay1 r-iy1", "nn"],
  "retirement": ["r-iy t-ay1 er m-ah-n-t", "nn"],
  "retiring": ["r-ih t-ay1 r-ih-ng", "vbg jj"],
  "retool": ["r-iy-t-uw1-l", "vb"],
  "retort": ["r-iy1 t-ao-r-t", "nn vb vbp"],
  "retouching": ["r-iy t-ah1 ch-ih-ng", "nn"],
  "retrace": ["r-iy t-r-ey1-s", "vb"],
  "retract": ["r-iy t-r-ae1-k-t", "vb"],
  "retractable": ["r-iy t-r-ae1-k t-ah b-ah-l", "jj"],
  "retracted": ["r-iy t-r-ae1-k t-ah-d", "vbn vbd jj"],
  "retraction": ["r-iy t-r-ae1-k sh-ah-n", "nn"],
  "retrain": ["r-iy t-r-ey1-n", "vb"],
  "retread": ["r-iy t-r-eh1-d", "nn"],
  "retreat": ["r-iy t-r-iy1-t", "nn vb"],
  "retrench": ["r-iy-t-r-eh1-n-ch", "vb"],
  "retrenchment": ["r-iy t-r-eh1-n-ch m-ah-n-t", "nn"],
  "retrial": ["r-iy t-r-ay1 ah-l", "nn"],
  "retribution": ["r-eh t-r-ah b-y-uw1 sh-ah-n", "nn"],
  "retried": ["r-iy t-r-ay1-d", "vbn"],
  "retrieval": ["r-ih t-r-iy1 v-ah-l", "nn"],
  "retrieve": ["r-ih t-r-iy1-v", "vb vbp"],
  "retriever": ["r-iy t-r-iy1 v-er", "nn"],
  "retro": ["r-eh1 t-r-ow", "jj"],
  "retroactive": ["r-eh t-r-ow ae1-k t-ih-v", "jj"],
  "retroactively": ["r-eh t-r-ow ae1-k t-ih-v l-iy", "rb"],
  "retroactivity": ["r-eh t-r-ow ae-k t-ih1 v-ih t-iy", "nn"],
  "retrofit": ["r-eh1 t-r-ow f-ih-t", "vb"],
  "retrofitting": ["r-eh1 t-r-ow f-ih t-ih-ng", "nn"],
  "retrograde": ["r-eh1 t-r-ah g-r-ey-d", "jj"],
  "retrospect": ["r-eh1 t-r-ah s-p-eh-k-t", "nn"],
  "retrospective": ["r-eh t-r-ah s-p-eh1-k t-ih-v", "nn jj"],
  "retrovirus": ["r-eh t-r-ow v-ay1 r-ah-s", "nn"],
  "retry": ["r-iy t-r-ay1", "vb"],
  "return": ["r-ih t-er1-n", "nn vbp jj vb"],
  "reunification": ["r-iy uw n-ah f-ah k-ey1 sh-ah-n", "nn"],
  "reunion": ["r-iy uw1 n-y-ah-n", "nn"],
  "reunite": ["r-iy uw n-ay1-t", "vb"],
  "reusable": ["r-iy uw1 z-ah b-ah-l", "jj"],
  "reuse": ["r-iy y-uw1-s", "vb"],
  "rev": ["r-eh1-v", "vb"],
  "revaluation": ["r-iy v-ae1-l y-uw ey1 sh-ah-n", "nn"],
  "revalue": ["r-iy-v-ae1-l-y-uw", "vb"],
  "revaluing": ["r-iy v-ae1-l y-uw ih-ng", "nn"],
  "revamp": ["r-iy v-ae1-m-p", "vb nn"],
  "revamped": ["r-iy v-ae1-m-p-t", "vbn vbd jj"],
  "reveal": ["r-ih v-iy1-l", "vb vbp"],
  "revealed": ["r-ih v-iy1-l-d", "vbd jj vbn"],
  "revealing": ["r-ih v-iy1 l-ih-ng", "vbg jj"],
  "revel": ["r-eh1 v-ah-l", "vb nn vbp"],
  "revelation": ["r-eh v-ah l-ey1 sh-ah-n", "nn"],
  "revelatory": ["r-ih v-eh1 l-ah t-ao r-iy", "jj"],
  "reveler": ["r-eh1 v-ah l-er", "nn"],
  "revelry": ["r-eh1 v-ah-l r-iy", "nn"],
  "revenge": ["r-iy v-eh1-n-jh", "nn"],
  "revenue": ["r-eh1 v-ah n-uw", "nn"],
  "reverberate": ["r-ih v-er1 b-er ah-t", "vb"],
  "reverberation": ["r-iy v-er b-er ey1 sh-ah-n", "nn"],
  "revere": ["r-ih-v-ih1-r", "vb"],
  "revered": ["r-ih v-ih1-r-d", "vbn jj"],
  "reverence": ["r-eh1 v-er ah-n-s", "nn"],
  "reverent": ["r-eh1 v-er ah-n-t", "jj"],
  "reverential": ["r-eh v-er eh1-n ch-ah-l", "jj"],
  "reverie": ["r-eh1 v-er iy", "nn"],
  "reversal": ["r-ih v-er1 s-ah-l", "nn"],
  "reverse": ["r-ih v-er1-s", "vb jj nn rb vbp"],
  "reversed": ["r-ih v-er1-s-t", "vbd jj vbn"],
  "reversible": ["r-ih v-er1 s-ah b-ah-l", "jj"],
  "revert": ["r-ih v-er1-t", "vb vbp"],
  "review": ["r-iy v-y-uw1", "nn vb vbp"],
  "reviewer": ["r-iy v-y-uw1 er", "nn"],
  "revile": ["r-iy-v-ay1-l", "vb"],
  "reviled": ["r-iy v-ay1-l-d", "vbn jj"],
  "revise": ["r-ih v-ay1-z", "vb"],
  "revised": ["r-ih v-ay1-z-d", "vbn vbd jj"],
  "revision": ["r-iy v-ih1 zh-ah-n", "nn"],
  "revisionist": ["r-iy v-ih1 zh-ah-n ih-s-t", "jj"],
  "revisit": ["r-iy v-ih1 z-ih-t", "vb nn"],
  "revitalization": ["r-iy v-ay t-ah l-ah z-ey1 sh-ah-n", "nn jj"],
  "revitalize": ["r-iy v-ay1 t-ah l-ay-z", "vb"],
  "revival": ["r-ih v-ay1 v-ah-l", "nn"],
  "revive": ["r-ih v-ay1-v", "vb vbp"],
  "reviving": ["r-ih v-ay1 v-ih-ng", "vbg jj"],
  "revocable": ["r-eh1 v-ah k-ah b-ah-l", "jj"],
  "revocation": ["r-eh v-ah k-ey1 sh-ah-n", "nn"],
  "revoke": ["r-ih v-ow1-k", "vb"],
  "revolt": ["r-ih v-ow1-l-t", "nn vb"],
  "revolting": ["r-iy v-ow1-l t-ih-ng", "jj"],
  "revolution": ["r-eh v-ah l-uw1 sh-ah-n", "nn"],
  "revolutionary": ["r-eh v-ah l-uw1 sh-ah-n eh r-iy", "jj nn"],
  "revolutionist": ["r-eh v-ah l-uw1 sh-ah-n ih-s-t", "nn"],
  "revolutionize": ["r-eh v-ah l-uw1 sh-ah-n ay-z", "vb"],
  "revolve": ["r-iy v-aa1-l-v", "vb vbp"],
  "revolver": ["r-ih v-aa1-l v-er", "nn"],
  "revolving": ["r-iy v-aa1-l v-ih-ng", "vbg jj"],
  "revulsion": ["r-ih v-ah1-l sh-ah-n", "nn"],
  "reward": ["r-ih w-ao1-r-d", "nn vb vbp"],
  "rewarding": ["r-ih w-ao1-r d-ih-ng", "jj vbg"],
  "rework": ["r-iy-w-er1-k", "vb"],
  "reworking": ["r-iy w-er1 k-ih-ng", "nn"],
  "rewrite": ["r-iy r-ay1-t", "vb nn"],
  "rewritten": ["r-iy r-ih1 t-ah-n", "vbn"],
  "rewrote": ["r-iy r-ow1-t", "vbd"],
  "rhapsodic": ["r-ae-p s-aa1 d-ih-k", "jj"],
  "rhapsody": ["r-ae1-p s-ah d-iy", "nn"],
  "rhetoric": ["r-eh1 t-er ih-k", "nn"],
  "rhetorical": ["r-ih t-ao1 r-ih k-ah-l", "jj"],
  "rhetorician": ["r-eh t-er ih1 sh-ah-n", "nn"],
  "rheumatic": ["r-uw m-ae1 t-ih-k", "jj"],
  "rheumatism": ["r-uw1 m-ah t-ih z-ah-m", "nn"],
  "rheumatoid": ["r-uw1 m-ah t-oy-d", "jj"],
  "rhinestone": ["r-ay1-n s-t-ow-n", "nn"],
  "rhino": ["r-ay1 n-ow", "nn"],
  "rhinoceros": ["r-ay n-aa1 s-er ah-s", "nn"],
  "rhododendron": ["r-ow d-ah d-eh1-n d-r-ah-n", "nn"],
  "rhyme": ["r-ay1-m", "nn vb"],
  "rhythm": ["r-ih1 dh-ah-m", "nn"],
  "rhythmic": ["r-ih1-dh m-ih-k", "jj"],
  "rhythmically": ["r-ih1-dh m-ih-k l-iy", "rb"],
  "rib": ["r-ih1-b", "nn"],
  "ribbed": ["r-ih1-b-d", "jj"],
  "ribbing": ["r-ih1 b-ih-ng", "nn"],
  "ribbon": ["r-ih1 b-ah-n", "nn"],
  "rice": ["r-ay1-s", "nn"],
  "rich": ["r-ih1-ch", "jj"],
  "richer": ["r-ih1 ch-er", "jjr"],
  "riches": ["r-ih1 ch-ah-z", "nns"],
  "richest": ["r-ih1 ch-ah-s-t", "jjs"],
  "richly": ["r-ih1-ch l-iy", "rb"],
  "richness": ["r-ih1-ch n-ah-s", "nn"],
  "rickety": ["r-ih1 k-ah t-iy", "jj"],
  "ricochet": ["r-ih1-k-ah-sh-ey", "vb"],
  "rid": ["r-ih1-d", "jj vbn vbd rb vb"],
  "riddance": ["r-ih1 d-ah-n-s", "nn"],
  "ridden": ["r-ih1 d-ah-n", "vbn"],
  "riddle": ["r-ih1 d-ah-l", "nn vb"],
  "riddled": ["r-ih1 d-ah-l-d", "vbn jj"],
  "ride": ["r-ay1-d", "vb nn vbp"],
  "rider": ["r-ay1 d-er", "nn"],
  "ridership": ["r-ay1 d-er sh-ih-p", "nn"],
  "ridge": ["r-ih1-jh", "nn"],
  "ridicule": ["r-ih1 d-ah k-y-uw-l", "nn vb"],
  "ridiculous": ["r-ih d-ih1 k-y-ah l-ah-s", "jj"],
  "ridiculously": ["r-ah d-ih1 k-y-ah l-ah-s l-iy", "rb"],
  "riding": ["r-ay1 d-ih-ng", "vbg jj nn"],
  "rife": ["r-ay1-f", "jj"],
  "riff": ["r-ih1-f", "nn"],
  "riffle": ["r-ih1 f-ah-l", "vb"],
  "rifle": ["r-ay1 f-ah-l", "nn"],
  "rifled": ["r-ay1 f-ah-l-d", "jj"],
  "rifleman": ["r-ay1 f-ah-l m-ah-n", "nn"],
  "rifling": ["r-ay1 f-l-ih-ng", "nn"],
  "rift": ["r-ih1-f-t", "nn"],
  "rig": ["r-ih1-g", "nn vbp vb"],
  "rigged": ["r-ih1-g-d", "vbn vbd jj"],
  "rigging": ["r-ih1 g-ih-ng", "nn"],
  "right": ["r-ay1-t", "nn rb vb in jj"],
  "righteous": ["r-ay1 ch-ah-s", "jj"],
  "righteousness": ["r-ay1 ch-ah-s n-ah-s", "nn"],
  "rightful": ["r-ay1-t f-ah-l", "jj"],
  "rightfully": ["r-ay1-t f-ah l-iy", "rb"],
  "rightist": ["r-ay1 t-ih-s-t", "jj"],
  "rightly": ["r-ay1-t l-iy", "rb"],
  "rightness": ["r-ay1-t n-ah-s", "nn"],
  "rightward": ["r-ay1-t w-er-d", "jj"],
  "rigid": ["r-ih1 jh-ah-d", "jj"],
  "rigidity": ["r-ih jh-ih1 d-ah t-iy", "nn"],
  "rigidly": ["r-ih1 jh-ih-d l-iy", "rb"],
  "rigor": ["r-ih1 g-er", "nn"],
  "rigorous": ["r-ih1 g-er ah-s", "jj"],
  "rigorously": ["r-ih1 g-er ah-s l-iy", "rb"],
  "rile": ["r-ay1-l", "vbp vb"],
  "rill": ["r-ih1-l", "nn"],
  "rim": ["r-ih1-m", "nn"],
  "rimmed": ["r-ih1-m-d", "jj vbd"],
  "rind": ["r-ay1-n-d", "nn"],
  "ring": ["r-ih1-ng", "nn vb vbp"],
  "ringed": ["r-ih1-ng-d", "jj vbn"],
  "ringer": ["r-ih1 ng-er", "nn"],
  "ringleader": ["r-ih1-ng l-iy d-er", "nn"],
  "ringside": ["r-ih1-ng s-ay-d", "nn"],
  "rink": ["r-ih1-ng-k", "nn"],
  "rinse": ["r-ih1-n-s", "nn vb"],
  "rinsing": ["r-ih1-n s-ih-ng", "nn vbg"],
  "riot": ["r-ay1 ah-t", "nn vb"],
  "rioter": ["r-ay1 ah t-er", "nn"],
  "rioting": ["r-ay1 ah t-ih-ng", "nn"],
  "riotous": ["r-ay1 ah t-ah-s", "jj"],
  "rip": ["r-ih1-p", "vb nn"],
  "ripe": ["r-ay1-p", "jj"],
  "ripen": ["r-ay1 p-ah-n", "vb vbp"],
  "ripening": ["r-ay1 p-ah n-ih-ng", "vbg jj"],
  "ripple": ["r-ih1 p-ah-l", "nn vb vbp jj"],
  "rise": ["r-ay1-z", "vbp vb"],
  "risen": ["r-ih1 z-ah-n", "n vbn"],
  "rising": ["r-ay1 z-ih-ng", "vbg jj"],
  "risk": ["r-ih1-s-k", "nn vbp vb"],
  "riskier": ["r-ih1-s-k iy er", "jjr rbr nn"],
  "riskiest": ["r-ih1-s k-iy ah-s-t", "jjs"],
  "riskiness": ["r-ih1-s-k iy n-ah-s", "nn"],
  "risky": ["r-ih1-s k-iy", "jj"],
  "rite": ["r-ay1-t", "nn"],
  "ritual": ["r-ih1 ch-uw ah-l", "nn"],
  "ritzy": ["r-ih1-t s-iy", "jj"],
  "rival": ["r-ay1 v-ah-l", "jj nn vb vbp"],
  "rivalry": ["r-ay1 v-ah-l r-iy", "nn"],
  "riven": ["r-ih1 v-ah-n", "vbn"],
  "river": ["r-ih1 v-er", "nn"],
  "riverbank": ["r-ih1 v-er b-ae-ng-k", "nn"],
  "riverboat": ["r-ih1 v-er b-ow-t", "nn"],
  "riverfront": ["r-ih1 v-er f-r-ah-n-t", "nn"],
  "riverside": ["r-ih1 v-er s-ay-d", "nn"],
  "rivet": ["r-ih1-v-ah-t", "vb"],
  "riveting": ["r-ih1 v-ah t-ih-ng", "vbg jj"],
  "roach": ["r-ow1-ch", "nn"],
  "road": ["r-ow1-d", "nn"],
  "roadblock": ["r-ow1-d b-l-aa-k", "nn"],
  "roadrunner": ["r-ow1 d-r-ah n-er", "nn"],
  "roadside": ["r-ow1-d s-ay-d", "nn jj"],
  "roadster": ["r-ow1-d s-t-er", "nn"],
  "roadway": ["r-ow1-d w-ey", "nn"],
  "roam": ["r-ow1-m", "vb vbp"],
  "roar": ["r-ao1-r", "nn vb"],
  "roaring": ["r-ao1 r-ih-ng", "vbg jj nn"],
  "roast": ["r-ow1-s-t", "nn vb"],
  "roasted": ["r-ow1 s-t-ah-d", "vbn jj vbd"],
  "roaster": ["r-ow1 s-t-er", "nn"],
  "rob": ["r-aa1-b", "vb vbp"],
  "robber": ["r-aa1 b-er", "nn"],
  "robbery": ["r-aa1 b-er iy", "nn"],
  "robe": ["r-ow1-b", "nn"],
  "robin": ["r-aa1 b-ah-n", "nn"],
  "robot": ["r-ow1 b-aa-t", "nn"],
  "robotic": ["r-ow b-aa1 t-ih-k", "jj"],
  "robust": ["r-ow b-ah1-s-t", "jj"],
  "robustly": ["r-ow b-ah1-s-t l-iy", "rb"],
  "robustness": ["r-ow b-ah1-s-t n-ah-s", "nn"],
  "rock": ["r-aa1-k", "nn jj vb vbp"],
  "rocker": ["r-aa1 k-er", "nn"],
  "rocket": ["r-aa1 k-ah-t", "nn vb"],
  "rocking": ["r-aa1 k-ih-ng", "nn jj vbg"],
  "rocky": ["r-aa1 k-iy", "jj"],
  "rococo": ["r-ah k-ow1 k-ow", "jj nn"],
  "rod": ["r-aa1-d", "nn"],
  "rodding": ["r-aa1 d-ih-ng", "nn"],
  "rode": ["r-ow1-d", "vbd"],
  "rodent": ["r-ow1 d-ah-n-t", "nn"],
  "rodeo": ["r-ow1 d-iy ow", "nn"],
  "roemer": ["r-ow1 m-er", "nn"],
  "rogue": ["r-ow1-g", "jj"],
  "roil": ["r-oy1-l", "vb"],
  "roiling": ["r-oy1 l-ih-ng", "vbg jj"],
  "role": ["r-ow1-l", "nn"],
  "roleplaying": ["r-ow1-l p-l-ey ih-ng", "nn"],
  "roll": ["r-ow1-l", "nn vb vbp"],
  "rollback": ["r-ow1-l b-ae-k", "nn"],
  "rolled": ["r-ow1-l-d", "vbd vbn jj"],
  "roller": ["r-ow1 l-er", "nn"],
  "rollercoaster": ["r-ow1 l-er k-ow s-t-er", "nn jj"],
  "rollicking": ["r-aa1 l-ih k-ih-ng", "jj"],
  "rolling": ["r-ow1 l-ih-ng", "vbg jj nn"],
  "rollout": ["r-ow1-l aw-t", "nn"],
  "rollover": ["r-ow1 l-ow v-er", "nn"],
  "romance": ["r-ow m-ae1-n-s", "nn vb"],
  "romantic": ["r-ow m-ae1-n t-ih-k", "jj nn"],
  "romantically": ["r-ow m-ae1-n t-ih k-ah l-iy", "rb"],
  "romanticism": ["r-ow m-ae1-n t-ah s-ih z-ah-m", "nn"],
  "romanticize": ["r-ow m-ae1-n t-ah s-ay-z", "vb"],
  "romanticizing": ["r-ow m-ae1-n t-ah s-ay z-ih-ng", "nn"],
  "romp": ["r-aa1-m-p", "nn vb vbp"],
  "roof": ["r-uw1-f", "nn vb"],
  "roofer": ["r-uw1 f-er", "nn"],
  "roofing": ["r-uw1 f-ih-ng", "nn"],
  "rooftop": ["r-uw1-f t-aa-p", "nn"],
  "rooftree": ["r-uw1-f t-r-iy", "nn"],
  "rook": ["r-uh1-k", "nn"],
  "rookie": ["r-uh1 k-iy", "nn"],
  "room": ["r-uw1-m", "nn vb"],
  "roomful": ["r-uw1-m f-uh-l", "nn"],
  "roomier": ["r-uw1 m-iy er", "jjr"],
  "roominess": ["r-uw1 m-iy n-ah-s", "nn"],
  "roommate": ["r-uw1-m ey-t", "nn"],
  "roomy": ["r-uw1 m-iy", "jj"],
  "roost": ["r-uw1-s-t", "vb nn"],
  "rooster": ["r-uw1 s-t-er", "nn"],
  "root": ["r-uw1-t", "nn vbp vb"],
  "rooted": ["r-uw1 t-ah-d", "vbn jj"],
  "rootless": ["r-uw1-t l-ah-s", "jj"],
  "rope": ["r-ow1-p", "nn vb"],
  "roper": ["r-ow1 p-er", "nn"],
  "rosary": ["r-ow1 z-er iy", "nn"],
  "rose": ["r-ow1-z", "vbd jj nn"],
  "rosebush": ["r-ow1-z b-uh-sh", "nn"],
  "rosette": ["r-ow1 z-eh1-t", "nn"],
  "rosier": ["r-ow1 z-iy er", "jjr rbr"],
  "roster": ["r-aa1 s-t-er", "nn"],
  "rostrum": ["r-aa1-s t-r-ah-m", "nn"],
  "rosy": ["r-ow1 z-iy", "jj"],
  "rot": ["r-aa1-t", "nn vb"],
  "rotary": ["r-ow1 t-er iy", "jj"],
  "rotate": ["r-ow1 t-ey-t", "vb"],
  "rotation": ["r-ow t-ey1 sh-ah-n", "nn"],
  "rotational": ["r-ow t-ey1 sh-ah n-ah-l", "jj"],
  "rote": ["r-ow1-t", "nn jj"],
  "rotor": ["r-ow1 t-er", "nn"],
  "rotten": ["r-aa1 t-ah-n", "jj"],
  "rotund": ["r-ow t-ah1-n-d", "jj"],
  "rotunda": ["r-ow t-ah1-n d-ah", "nn"],
  "rouge": ["r-uw1-zh", "nn"],
  "rough": ["r-ah1-f", "jj rb nn vb"],
  "rougher": ["r-ah1 f-er", "jjr"],
  "roughest": ["r-ah1 f-ah-s-t", "jjs"],
  "roughly": ["r-ah1-f l-iy", "rb"],
  "roughneck": ["r-ah1-f n-eh-k", "nn"],
  "roughshod": ["r-ah1-f sh-aa1-d", "jj"],
  "roulette": ["r-uw l-eh1-t", "nn"],
  "round": ["r-aw1-n-d", "nn in jj vbp rb vb"],
  "roundabout": ["r-aw1-n-d ah b-aw-t", "jj"],
  "rounded": ["r-aw1-n d-ah-d", "vbn jj vbd"],
  "rounder": ["r-aw1-n d-er", "jjr"],
  "roundhead": ["r-aw1-n-d hh-eh-d", "nn jj"],
  "roundhouse": ["r-aw1-n-d hh-aw-s", "nn"],
  "roundly": ["r-aw1-n-d l-iy", "rb"],
  "roundtable": ["r-aw1-n-d t-ey b-ah-l", "jj"],
  "roundtrip": ["r-aw-n-d t-r-ih1-p", "nn"],
  "roundup": ["r-aw1-n-d ah-p", "nn"],
  "rouse": ["r-aw1-s", "vb"],
  "rousing": ["r-aw1 z-ih-ng", "jj nn"],
  "rout": ["r-aw1-t", "nn vb"],
  "route": ["r-uw1-t", "nn vbp in rb vb"],
  "routine": ["r-uw t-iy1-n", "jj nn"],
  "routinely": ["r-uw t-iy1-n l-iy", "rb"],
  "rove": ["r-ow1-v", "vb"],
  "row": ["r-ow1", "nn vbp vb"],
  "rowdiness": ["r-aw1 d-iy n-ah-s", "nn"],
  "rowdy": ["r-aw1 d-iy", "jj nn"],
  "rowing": ["r-ow1 ih-ng", "nn"],
  "royal": ["r-oy1 ah-l", "jj nn"],
  "royalty": ["r-oy1 ah-l t-iy", "nn"],
  "rub": ["r-ah1-b", "nn vb vbp"],
  "rubber": ["r-ah1 b-er", "nn"],
  "rubberize": ["r-ah1-b-er-ay-z", "vb"],
  "rubbery": ["r-ah1 b-er iy", "jj"],
  "rubbish": ["r-ah1 b-ih-sh", "nn jj"],
  "rubble": ["r-ah1 b-ah-l", "nn"],
  "ruble": ["r-uw1 b-ah-l", "nn"],
  "rubout": ["r-ah1 b-aw-t", "nn"],
  "rubric": ["r-uw1 b-r-ih-k", "nn"],
  "ruby": ["r-uw1 b-iy", "nn"],
  "ruckus": ["r-ah1 k-ah-s", "nn"],
  "rudder": ["r-ah1 d-er", "nn"],
  "rudderless": ["r-ah1 d-er l-ah-s", "jj"],
  "ruddy": ["r-ah1 d-iy", "jj rb"],
  "rude": ["r-uw1-d", "jj"],
  "rudely": ["r-uw1-d l-iy", "rb"],
  "rudeness": ["r-uw1-d n-ah-s", "nn"],
  "rudiment": ["r-uw1 d-ih m-ah-n-t", "nn"],
  "rudimentary": ["r-uw d-ah m-eh1-n t-er iy", "jj"],
  "rue": ["r-uw1", "nn"],
  "rueful": ["r-uw1 f-ah-l", "jj"],
  "ruefully": ["r-uw1 f-ah l-iy", "rb"],
  "ruffle": ["r-ah1 f-ah-l", "vb"],
  "ruffled": ["r-ah1 f-ah-l-d", "vbn jj vbd"],
  "rug": ["r-ah1-g", "nn"],
  "rugged": ["r-ah1 g-ah-d", "jj"],
  "ruggedly": ["r-ah1 g-ah-d l-iy", "rb"],
  "ruin": ["r-uw1 ah-n", "nn vbp vb"],
  "ruined": ["r-uw1 ah-n-d", "vbn jj vbd"],
  "ruinous": ["r-uw1 ah n-ah-s", "jj"],
  "rule": ["r-uw1-l", "nn vbp vb"],
  "ruler": ["r-uw1 l-er", "nn"],
  "ruling": ["r-uw1 l-ih-ng", "nn vbg jj"],
  "rum": ["r-ah1-m", "nn"],
  "rumble": ["r-ah1-m b-ah-l", "nn vb vbp"],
  "rumen": ["r-uw1 m-ah-n", "nn"],
  "ruminate": ["r-uw1-m-ih-n-ey-t", "vb"],
  "rumination": ["r-uw m-ih n-ey1 sh-ah-n", "nn"],
  "rummage": ["r-ah1 m-ih-jh", "vb"],
  "rummaging": ["r-ah1 m-ih jh-ih-ng", "jj"],
  "rummy": ["r-ah1 m-iy", "nn"],
  "rumor": ["r-uw1 m-er", "nn vb"],
  "rumored": ["r-uw1 m-er-d", "vbn vbd jj"],
  "rump": ["r-ah1-m-p", "nn jj"],
  "rumpled": ["r-ah1-m p-ah-l-d", "jj"],
  "run": ["r-ah1-n", "vb vbd vbn vbp nn"],
  "runabout": ["r-ah1-n ah b-aw-t", "nn"],
  "runaway": ["r-ah1-n ah w-ey", "jj vbn nn"],
  "rundown": ["r-ah1-n d-aw-n", "nn jj"],
  "rung": ["r-ah1-ng", "vbn nn"],
  "runner": ["r-ah1 n-er", "nn"],
  "running": ["r-ah1 n-ih-ng", "vbg jj rb"],
  "runoff": ["r-ah1 n-ao-f", "nn"],
  "runup": ["r-ah1 n-ah-p", "nn"],
  "runway": ["r-ah1-n w-ey", "nn"],
  "rupee": ["r-uw p-iy1", "nn"],
  "rupiah": ["r-uw p-ay1 ah", "nn"],
  "rupture": ["r-ah1-p ch-er", "nn vb"],
  "rural": ["r-uh1 r-ah-l", "jj"],
  "ruse": ["r-uw1-z", "nn"],
  "rush": ["r-ah1-sh", "nn vb vbp"],
  "rushed": ["r-ah1-sh-t", "vbd vbn jj"],
  "russe": ["r-ah1-s", "nn"],
  "rust": ["r-ah1-s-t", "nn vb"],
  "rusted": ["r-ah1 s-t-ah-d", "jj"],
  "rustic": ["r-ah1 s-t-ih-k", "jj"],
  "rusting": ["r-ah1 s-t-ih-ng", "jj"],
  "rustle": ["r-ah1-s-ah-l", "vb"],
  "rustler": ["r-ah1-s l-er", "nn"],
  "rusty": ["r-ah1 s-t-iy", "jj"],
  "rut": ["r-ah1-t", "nn"],
  "ruthless": ["r-uw1-th l-ah-s", "jj"],
  "ruthlessly": ["r-uw1-th l-ah-s l-iy", "rb"],
  "ruthlessness": ["r-uw1-th l-ah-s n-ah-s", "nn"],
  "rutted": ["r-ah1 t-ih-d", "jj"],
  "rye": ["r-ay1", "nn"],
  "sabbatical": ["s-ah b-ae1 t-ih k-ah-l", "nn jj"],
  "saber": ["s-ey1 b-er", "nn"],
  "sable": ["s-ey1 b-ah-l", "nn"],
  "sabotage": ["s-ae1 b-ah t-aa-zh", "nn vb"],
  "sabre": ["s-ey1 b-er", "nn"],
  "sac": ["s-ae1-k", "nn"],
  "saccharin": ["s-ae1 k-er ah-n", "nn"],
  "sack": ["s-ae1-k", "nn vb"],
  "sacrament": ["s-ae1 k-r-ah m-ah-n-t", "nn"],
  "sacred": ["s-ey1 k-r-ah-d", "jj"],
  "sacrifice": ["s-ae1 k-r-ah f-ay-s", "nn vb"],
  "sacrificial": ["s-ae k-r-ah f-ih1 sh-ah-l", "jj"],
  "sacrilege": ["s-ae1 k-r-ah l-ah-jh", "nn"],
  "sacrilegious": ["s-ae k-r-ah l-eh1 jh-ih-s", "jj"],
  "sacrosanct": ["s-ae1 k-r-ow s-ae-ng-k-t", "jj"],
  "sad": ["s-ae1-d", "jj"],
  "sadden": ["s-ae1-d-ah-n", "vb"],
  "saddened": ["s-ae1 d-ah-n-d", "jj vbn"],
  "sadder": ["s-ae1 d-er", "jjr"],
  "saddle": ["s-ae1 d-ah-l", "nn vb"],
  "saddlebag": ["s-ae1 d-ah-l b-ae-g", "nn"],
  "saddled": ["s-ae1 d-ah-l-d", "vbn vbd jj"],
  "sadism": ["s-ey1 d-ih z-ah-m", "nn"],
  "sadist": ["s-ey1 d-ah-s-t", "nn"],
  "sadistic": ["s-ah d-ih1 s-t-ih-k", "jj"],
  "sadly": ["s-ae1-d l-iy", "rb"],
  "sadness": ["s-ae1-d n-ah-s", "nn"],
  "safari": ["s-ah f-aa1 r-iy", "nn"],
  "safe": ["s-ey1-f", "jj nn"],
  "safeguard": ["s-ey1-f g-aa-r-d", "vb nn"],
  "safekeeping": ["s-ey1-f k-iy1 p-ih-ng", "nn"],
  "safely": ["s-ey1-f l-iy", "rb"],
  "safer": ["s-ey1 f-er", "jjr"],
  "safest": ["s-ey1 f-ah-s-t", "jjs"],
  "safety": ["s-ey1-f t-iy", "nn vb"],
  "sag": ["s-ae1-g", "vb nn vbp"],
  "saga": ["s-aa1 g-ah", "nn"],
  "sage": ["s-ey1-jh", "nn jj"],
  "sagebrush": ["s-ey1-jh b-r-ah-sh", "nn"],
  "sagging": ["s-ae1 g-ih-ng", "vbg jj nn"],
  "sago": ["s-ey1 g-ow", "nn"],
  "said": ["s-eh1-d", "vbd vbn"],
  "sail": ["s-ey1-l", "vb vbp nn"],
  "sailboat": ["s-ey1-l b-ow-t", "nn"],
  "sailor": ["s-ey1 l-er", "nn"],
  "saint": ["s-ey1-n-t", "nn"],
  "sainthood": ["s-ey1-n-t hh-uh-d", "nn"],
  "saintly": ["s-ey1-n-t l-iy", "jj"],
  "sake": ["s-ey1-k", "nn"],
  "salable": ["s-ey1 l-ah b-ah-l", "jj"],
  "salacious": ["s-ah l-ey1 sh-ah-s", "jj"],
  "salad": ["s-ae1 l-ah-d", "nn"],
  "salamander": ["s-ae l-ah m-ae1-n d-er", "nn"],
  "salami": ["s-ah l-aa1 m-iy", "nn"],
  "salaried": ["s-ae1 l-er iy-d", "jj"],
  "salary": ["s-ae1 l-er iy", "nn"],
  "sale": ["s-ey1-l", "nn"],
  "salesman": ["s-ey1-l-z m-ah-n", "nn"],
  "salesmanship": ["s-ey1-l-z m-ah-n sh-ih-p", "nn"],
  "salesperson": ["s-ey1-l-z p-er s-ah-n", "nn"],
  "salient": ["s-ey1 l-iy ah-n-t", "jj"],
  "saline": ["s-ah l-iy1-n", "nn jj"],
  "salinity": ["s-ah l-ih1 n-ah t-iy", "nn"],
  "saliva": ["s-ah l-ay1 v-ah", "nn"],
  "sally": ["s-ae1 l-iy", "vb"],
  "salmon": ["s-ae1 m-ah-n", "nn"],
  "salmonella": ["s-ae-l m-ah n-eh1 l-ah", "nn"],
  "salon": ["s-ah l-aa1-n", "nn"],
  "saloon": ["s-ah l-uw1-n", "nn"],
  "salsa": ["s-ao1-l s-ah", "nn"],
  "salt": ["s-ao1-l-t", "nn jj vb"],
  "salted": ["s-ao1-l t-ah-d", "vbn vbd jj"],
  "saltier": ["s-ao1-l t-iy er", "jjr"],
  "saltwater": ["s-ao-l-t w-aa1 t-er", "nn"],
  "salty": ["s-ao1-l t-iy", "jj"],
  "salutary": ["s-ae1 l-y-ah t-eh r-iy", "jj"],
  "salute": ["s-ah l-uw1-t", "nn vb"],
  "salvage": ["s-ae1-l v-ah-jh", "vb nn"],
  "salvation": ["s-ae-l v-ey1 sh-ah-n", "nn"],
  "salve": ["s-aa1-v", "nn vb"],
  "salvo": ["s-ae1-l v-ow", "nn"],
  "sambuca": ["s-ae-m b-y-uw1 k-ah", "nn"],
  "same": ["s-ey1-m", "jj"],
  "sameness": ["s-ey1-m n-ah-s", "nn"],
  "sample": ["s-ae1-m p-ah-l", "nn jj vb vbp"],
  "sampler": ["s-ae1-m p-l-er", "nn"],
  "sampling": ["s-ae1-m p-l-ih-ng", "nn vbg"],
  "samurai": ["s-ae1 m-uh r-ay", "nn"],
  "sanctimonious": ["s-ae-ng-k t-ah m-ow1 n-iy ah-s", "jj"],
  "sanction": ["s-ae1-ng-k sh-ah-n", "nn vbp vb"],
  "sanctity": ["s-ae1-ng-k t-ih t-iy", "nn"],
  "sanctuary": ["s-ae1-ng-k ch-uw eh r-iy", "nn"],
  "sanctum": ["s-ae1-ng-k t-ah-m", "nn"],
  "sand": ["s-ae1-n-d", "nn vb"],
  "sandal": ["s-ae1-n d-ah-l", "nn"],
  "sandbox": ["s-ae1-n-d b-aa-k-s", "nn"],
  "sander": ["s-ae1-n d-er", "nn"],
  "sandpaper": ["s-ae1-n-d p-ey p-er", "nn"],
  "sandwich": ["s-ae1-n-d w-ih-ch", "nn vb"],
  "sandy": ["s-ae1-n d-iy", "jj"],
  "sane": ["s-ey1-n", "jj"],
  "saner": ["s-ey1 n-er", "jjr"],
  "sang": ["s-ae1-ng", "vbd"],
  "sanguine": ["s-ae1-ng g-w-ih-n", "jj nn"],
  "sanitary": ["s-ae1 n-ih t-eh r-iy", "jj"],
  "sanitation": ["s-ae n-ah t-ey1 sh-ah-n", "nn"],
  "sanitize": ["s-ae1-n-ih-t-ay-z", "vb"],
  "sanitizing": ["s-ae1 n-ah t-ay z-ih-ng", "nn"],
  "sanity": ["s-ae1 n-ah t-iy", "nn"],
  "sank": ["s-ae1-ng-k", "vbd"],
  "sap": ["s-ae1-p", "vb nn"],
  "sapiens": ["s-ey1 p-iy ah-n-z", "jj"],
  "sarcasm": ["s-aa1-r k-ae z-ah-m", "nn"],
  "sarcastic": ["s-aa-r k-ae1 s-t-ih-k", "jj"],
  "sarcastically": ["s-aa-r k-ae1 s-t-ih-k l-iy", "rb"],
  "sarcoma": ["s-aa-r k-ow1 m-er", "nn"],
  "sardine": ["s-aa-r d-iy1-n", "nn"],
  "sardonic": ["s-aa-r d-aa1 n-ih-k", "jj"],
  "sardonically": ["s-aa-r d-aa1 n-ih k-ah l-iy", "rb"],
  "sari": ["s-aa1 r-iy", "nn"],
  "sash": ["s-ae1-sh", "nn"],
  "sassafras": ["s-ae1 s-ah f-r-ae-s", "nn"],
  "sassy": ["s-ae1 s-iy", "jj"],
  "sat": ["s-ae1-t", "vbd vbn"],
  "satellite": ["s-ae1 t-ah l-ay-t", "nn jj"],
  "satin": ["s-ae1 t-ah-n", "nn"],
  "satire": ["s-ae1 t-ay er", "nn"],
  "satiric": ["s-ah t-ih1 r-ih-k", "jj"],
  "satirical": ["s-ah t-ih1 r-ah k-ah-l", "jj"],
  "satirist": ["s-ae1 t-er ah-s-t", "nn"],
  "satirize": ["s-ae1-t-er-ay-z", "vb"],
  "satisfaction": ["s-ae t-ah-s f-ae1-k sh-ah-n", "nn"],
  "satisfactorily": ["s-ae t-ih-s f-ae1-k t-r-ah l-iy", "rb"],
  "satisfactory": ["s-ae t-ah-s f-ae1-k t-r-iy", "jj"],
  "satisfied": ["s-ae1 t-ah-s f-ay-d", "vbn vbd jj"],
  "satisfy": ["s-ae1 t-ah-s f-ay", "vb vbp"],
  "satisfying": ["s-ae1 t-ih-s f-ay ih-ng", "jj vbg"],
  "saturate": ["s-ae1 ch-er ey-t", "vb"],
  "saturated": ["s-ae1 ch-er ey t-ah-d", "vbn jj vbd"],
  "saturation": ["s-ae ch-er ey1 sh-ah-n", "nn"],
  "sauce": ["s-ao1-s", "nn"],
  "saucepan": ["s-ao1-s p-ae-n", "nn"],
  "saucer": ["s-ao1 s-er", "nn"],
  "saucy": ["s-ao1 s-iy", "jj"],
  "sauerkraut": ["s-aw1 er k-r-aw-t", "nn"],
  "sauna": ["s-ao1 n-ah", "nn"],
  "saunter": ["s-ao1-n t-er", "nn"],
  "sausage": ["s-ao1 s-ah-jh", "nn"],
  "saute": ["s-ao t-ey1", "vb"],
  "savage": ["s-ae1 v-ih-jh", "jj nn vb"],
  "savagely": ["s-ae1 v-ih-jh l-iy", "rb"],
  "savagery": ["s-ae1 v-ih-jh eh r-iy", "nn"],
  "save": ["s-ey1-v", "vb in vbp"],
  "saver": ["s-ey1 v-er", "nn"],
  "saving": ["s-ey1 v-ih-ng", "vbg jj nn"],
  "savior": ["s-ey1 v-y-er", "nn"],
  "savor": ["s-ey1 v-er", "vb"],
  "savory": ["s-ey1 v-er iy", "jj"],
  "savviest": ["s-ae1 v-iy ih-s-t", "jjs"],
  "savvy": ["s-ae1 v-iy", "jj vb nn"],
  "saw": ["s-ao1", "vbd nn vb"],
  "sawn": ["s-ao1-n", "vbn"],
  "sawdust": ["s-ao1 d-ah-s-t", "nn jj"],
  "sawing": ["s-ao1 ih-ng", "nn"],
  "sawmill": ["s-ao1 m-ih-l", "nn"],
  "sax": ["s-ae1-k-s", "nn"],
  "saxophone": ["s-ae1-k s-ah f-ow-n", "nn"],
  "saxophonist": ["s-ae1-k s-ah f-ow n-ih-s-t", "nn"],
  "say": ["s-ey1", "vbp nn vb uh"],
  "scab": ["s-k-ae1-b", "nn"],
  "scabbard": ["s-k-ae1 b-er-d", "nn"],
  "scad": ["s-k-ae1-d", "nn"],
  "scaffold": ["s-k-ae1 f-ah-l-d", "nn"],
  "scaffolding": ["s-k-ae1 f-ah-l d-ih-ng", "nn"],
  "scalar": ["s-k-ey1 l-er", "jj"],
  "scald": ["s-k-ao1-l-d", "vb"],
  "scale": ["s-k-ey1-l", "nn vb"],
  "scallop": ["s-k-ae1 l-ah-p", "nn"],
  "scalloped": ["s-k-aa1 l-ah-p-t", "jj"],
  "scalp": ["s-k-ae1-l-p", "nn"],
  "scalpel": ["s-k-ae1-l p-ah-l", "nn"],
  "scam": ["s-k-ae1-m", "nn"],
  "scammer": ["s-k-ae1 m-er", "nn"],
  "scamper": ["s-k-ae1-m p-er", "vb vbp"],
  "scan": ["s-k-ae1-n", "nn vbp vb"],
  "scandal": ["s-k-ae1-n d-ah-l", "nn"],
  "scandalize": ["s-k-ae1-n-d-ah-l-ay-z", "vb"],
  "scandalous": ["s-k-ae1-n d-ah l-ah-s", "jj"],
  "scanner": ["s-k-ae1 n-er", "nn"],
  "scant": ["s-k-ae1-n-t", "jj"],
  "scanty": ["s-k-ae1-n t-iy", "jj"],
  "scapegoat": ["s-k-ey1-p g-ow-t", "nn"],
  "scapegoating": ["s-k-ey1-p g-ow t-ih-ng", "nn"],
  "scar": ["s-k-aa1-r", "nn"],
  "scarce": ["s-k-eh1-r-s", "jj"],
  "scarcely": ["s-k-eh1-r-s l-iy", "rb"],
  "scarcer": ["s-k-eh1-r s-er", "jjr nn"],
  "scarcity": ["s-k-eh1-r s-ih t-iy", "nn"],
  "scare": ["s-k-eh1-r", "vb nn vbp"],
  "scared": ["s-k-eh1-r-d", "vbn jj rb vbd"],
  "scarf": ["s-k-aa1-r-f", "nn"],
  "scarlet": ["s-k-aa1-r l-ah-t", "jj"],
  "scarred": ["s-k-aa1-r-d", "jj vbn"],
  "scarves": ["s-k-aa1-r-v-z", "nn"],
  "scary": ["s-k-eh1 r-iy", "jj"],
  "scathing": ["s-k-ey1 dh-ih-ng", "jj"],
  "scatter": ["s-k-ae1 t-er", "nn vb"],
  "scattered": ["s-k-ae1 t-er-d", "vbn vbd jj"],
  "scattershot": ["s-k-ae1 t-er sh-aa-t", "jj"],
  "scavenge": ["s-k-ae1-v-ah-n-jh", "vb"],
  "scavenger": ["s-k-ae1 v-ah-n jh-er", "nn"],
  "scenario": ["s-ih n-eh1 r-iy ow", "nn"],
  "scene": ["s-iy1-n", "nn"],
  "scenery": ["s-iy1 n-er iy", "nn"],
  "scenic": ["s-iy1 n-ih-k", "jj"],
  "scent": ["s-eh1-n-t", "nn vb"],
  "scented": ["s-eh1-n t-ih-d", "jj vbn"],
  "schedule": ["s-k-eh1 jh-uh-l", "nn vb vbp"],
  "scheduled": ["s-k-eh1 jh-uh-l-d", "vbn vbd jj"],
  "schemata": ["s-k-ih m-ae1 t-ah", "nn"],
  "schematic": ["s-k-ih m-ae1 t-ih-k", "jj"],
  "scheme": ["s-k-iy1-m", "nn vb"],
  "scheming": ["s-k-iy1 m-ih-ng", "jj vbg"],
  "schilling": ["sh-ih1 l-ih-ng", "nn"],
  "schism": ["s-k-ih1 z-ah-m", "nn"],
  "schizophrenia": ["s-k-ih-t s-ah f-r-iy1 n-iy ah", "nn"],
  "schizophrenic": ["sh-ih z-ah f-r-eh1 n-ih-k", "jj nn"],
  "schmooze": ["sh-m-uw1-z", "vb"],
  "schnapps": ["sh-n-ae1-p-s", "nn"],
  "schnook": ["sh-n-uh1-k", "nn"],
  "scholar": ["s-k-aa1 l-er", "nn"],
  "scholarly": ["s-k-aa1 l-er l-iy", "jj"],
  "scholarship": ["s-k-aa1 l-er sh-ih-p", "nn"],
  "scholastic": ["s-k-ah l-ae1 s-t-ih-k", "jj nn"],
  "school": ["s-k-uw1-l", "nn vb"],
  "schoolbook": ["s-k-uw1-l b-uh-k", "nn"],
  "schoolboy": ["s-k-uw1-l b-oy", "nn"],
  "schoolchild": ["s-k-uw1-l ch-ih-l-d", "nn"],
  "schooler": ["s-k-uw1 l-er", "nn"],
  "schoolgirl": ["s-k-uw1-l g-er-l", "nn"],
  "schoolhouse": ["s-k-uw1-l hh-aw-s", "nn"],
  "schoolmaster": ["s-k-uw1-l m-ae s-t-er", "nn"],
  "schoolmate": ["s-k-uw1-l m-ey-t", "nn"],
  "schoolroom": ["s-k-uw1-l r-uw-m", "nn"],
  "schoolteacher": ["s-k-uw1-l t-iy ch-er", "nn"],
  "schoolwork": ["s-k-uw1-l w-er-k", "nn"],
  "schooner": ["s-k-uw1 n-er", "nn"],
  "science": ["s-ay1 ah-n-s", "nn jj"],
  "scientific": ["s-ay ah-n t-ih1 f-ih-k", "jj"],
  "scientifically": ["s-ay ah-n t-ih1 f-ih k-ah l-iy", "rb"],
  "scientist": ["s-ay1 ah-n t-ih-s-t", "nn"],
  "scion": ["s-ay1 ah-n", "nn"],
  "sclerosis": ["s-k-l-er ow1 s-ah-s", "nn"],
  "scoff": ["s-k-ao1-f", "vb nn vbp"],
  "scofflaw": ["s-k-aa1 f-l-ao", "nn"],
  "scold": ["s-k-ow1-l-d", "vb"],
  "scoop": ["s-k-uw1-p", "nn vb"],
  "scooter": ["s-k-uw1 t-er", "nn"],
  "scope": ["s-k-ow1-p", "nn"],
  "scorch": ["s-k-ao1-r-ch", "vb"],
  "scorched": ["s-k-ao1-r-ch-t", "jj vbd"],
  "score": ["s-k-ao1-r", "nn vb vbp"],
  "scoreboard": ["s-k-ao1-r b-ao-r-d", "nn"],
  "scorecard": ["s-k-ao1-r k-aa-r-d", "nn"],
  "scored": ["s-k-ao1-r-d", "vbd jj vbn"],
  "scorekeeper": ["s-k-ao1-r k-iy p-er", "nn"],
  "scoreless": ["s-k-ao1-r l-ah-s", "jj"],
  "scorer": ["s-k-ao1 r-er", "nn"],
  "scorn": ["s-k-ao1-r-n", "nn vb vbp"],
  "scornful": ["s-k-ao1-r-n f-ah-l", "jj"],
  "scotch": ["s-k-aa1-ch", "nn vb"],
  "scoundrel": ["s-k-aw1-n d-r-ah-l", "nn"],
  "scour": ["s-k-aw1 er", "vbp vb"],
  "scoured": ["s-k-aw1 er-d", "vbn jj vbd"],
  "scourge": ["s-k-er1-jh", "nn"],
  "scout": ["s-k-aw1-t", "nn vb"],
  "scowl": ["s-k-aw1-l", "vb"],
  "scraggly": ["s-k-r-ae1-g l-iy", "jj"],
  "scramble": ["s-k-r-ae1-m b-ah-l", "nn vbp vb"],
  "scrambled": ["s-k-r-ae1-m b-ah-l-d", "vbd jj vbn"],
  "scrap": ["s-k-r-ae1-p", "nn jj vb"],
  "scrapbook": ["s-k-r-ae1-p b-uh-k", "nn"],
  "scrape": ["s-k-r-ey1-p", "nn vb vbp"],
  "scrappy": ["s-k-r-ae1 p-iy", "jj"],
  "scratch": ["s-k-r-ae1-ch", "nn vb vbp"],
  "scratchy": ["s-k-r-ae1 ch-iy", "jj"],
  "scrawl": ["s-k-r-ao1-l", "nn vb"],
  "scrawled": ["s-k-r-ao1-l-d", "vbd jj vbn"],
  "scrawny": ["s-k-r-ao1 n-iy", "jj"],
  "scream": ["s-k-r-iy1-m", "vb vbp nn"],
  "screaming": ["s-k-r-iy1 m-ih-ng", "vbg jj nn"],
  "screech": ["s-k-r-iy1-ch", "nn vb"],
  "screeching": ["s-k-r-iy1 ch-ih-ng", "vbg jj"],
  "screed": ["s-k-r-iy1-d", "nn"],
  "screen": ["s-k-r-iy1-n", "nn vb vbp"],
  "screening": ["s-k-r-iy1 n-ih-ng", "nn vbg"],
  "screenplay": ["s-k-r-iy1-n p-l-ey", "nn"],
  "screenwriter": ["s-k-r-iy1-n r-ay t-er", "nn"],
  "screw": ["s-k-r-uw1", "nn vb"],
  "screwball": ["s-k-r-uw1 b-ao-l", "jj nn"],
  "screwdriver": ["s-k-r-uw1 d-r-ay v-er", "nn"],
  "scribble": ["s-k-r-ih1 b-ah-l", "vb"],
  "scribbler": ["s-k-r-ih1 b-l-er", "nn"],
  "scribe": ["s-k-r-ay1-b", "nn"],
  "scrimmage": ["s-k-r-ih1 m-ih-jh", "nn"],
  "scrimp": ["s-k-r-ih1-m-p", "vb"],
  "script": ["s-k-r-ih1-p-t", "nn"],
  "scriptural": ["s-k-r-ih1-p ch-er ah-l", "jj"],
  "scripture": ["s-k-r-ih1-p ch-er", "nn"],
  "scriptwriter": ["s-k-r-ih1-p-t r-ay t-er", "nn"],
  "scrivener": ["s-k-r-ih1-v n-er", "nn"],
  "scroll": ["s-k-r-ow1-l", "nn"],
  "scrounge": ["s-k-r-aw1-n-jh", "vbp vb"],
  "scrub": ["s-k-r-ah1-b", "vb jj nn"],
  "scrubber": ["s-k-r-ah1 b-er", "nn"],
  "scrubbing": ["s-k-r-ah1 b-ih-ng", "nn vbg"],
  "scrupulous": ["s-k-r-uw1 p-y-ah l-ah-s", "jj"],
  "scrupulously": ["s-k-r-uw1 p-y-ah l-ah-s l-iy", "rb"],
  "scrutinize": ["s-k-r-uw1 t-ah n-ay-z", "vb vbp"],
  "scrutiny": ["s-k-r-uw1 t-ah n-iy", "nn"],
  "scuba": ["s-k-uw1 b-ah", "nn"],
  "scuff": ["s-k-ah1-f", "vb"],
  "scuffle": ["s-k-ah1 f-ah-l", "nn"],
  "sculpt": ["s-k-ah1-l-p-t", "vb"],
  "sculptor": ["s-k-ah1-l-p t-er", "nn"],
  "sculptural": ["s-k-ah1-l-p ch-er ah-l", "jj"],
  "sculpture": ["s-k-ah1-l-p ch-er", "nn vb"],
  "sculptured": ["s-k-ah1-l-p ch-er-d", "vbn jj"],
  "scurried": ["s-k-er1 iy-d", "vbd"],
  "scurrilous": ["s-k-er1 ah l-ah-s", "jj"],
  "scurry": ["s-k-er1 iy", "nn vbp vb"],
  "scuttle": ["s-k-ah1 t-ah-l", "vb"],
  "scuttled": ["s-k-ah1 t-ah-l-d", "vbd vbn jj"],
  "sea": ["s-iy1", "nn vb vbp"],
  "seaboard": ["s-iy1 b-ao-r-d", "nn"],
  "seacoast": ["s-iy1 k-ow-s-t", "nn"],
  "seafarer": ["s-iy1 f-eh r-er", "nn"],
  "seafood": ["s-iy1 f-uw-d", "nn"],
  "seal": ["s-iy1-l", "nn vb vbp"],
  "sealant": ["s-iy1 l-ah-n-t", "nn"],
  "sealed": ["s-iy1-l-d", "vbn vbd jj"],
  "sealift": ["s-iy1 l-ih-f-t", "nn"],
  "seam": ["s-iy1-m", "nn"],
  "seaman": ["s-iy1 m-ah-n", "nn"],
  "seamless": ["s-iy1-m l-ah-s", "jj"],
  "seamlessly": ["s-iy1-m l-ah-s l-iy", "rb"],
  "seamstress": ["s-iy1-m s-t-r-ih-s", "nn"],
  "seamy": ["s-iy1 m-iy", "jj"],
  "seaport": ["s-iy1 p-ao-r-t", "nn"],
  "sear": ["s-ih1-r", "vb"],
  "search": ["s-er1-ch", "nn vb vbp"],
  "searcher": ["s-er1 ch-er", "nn"],
  "searing": ["s-ih1 r-ih-ng", "vbg jj"],
  "seashore": ["s-iy1 sh-ao-r", "nn"],
  "seaside": ["s-iy1 s-ay-d", "jj nn"],
  "season": ["s-iy1 z-ah-n", "nn vb"],
  "seasonal": ["s-iy1 z-ah n-ah-l", "jj"],
  "seasonality": ["s-iy1 z-ah n-ae l-ih t-iy", "nn"],
  "seasonally": ["s-iy1 z-ah-n ah l-iy", "rb"],
  "seasoned": ["s-iy1 z-ah-n-d", "jj vbn"],
  "seasoning": ["s-iy1 z-ah-n ih-ng", "nn"],
  "seat": ["s-iy1-t", "nn vb vbp"],
  "seated": ["s-iy1 t-ah-d", "vbn vbd jj"],
  "seating": ["s-iy1 t-ih-ng", "nn vbg"],
  "seawater": ["s-iy1 w-aa t-er", "nn"],
  "seaweed": ["s-iy1 w-iy-d", "nn"],
  "secede": ["s-ih s-iy1-d", "vb"],
  "secession": ["s-ih s-eh1 sh-ah-n", "nn"],
  "secessionist": ["s-ih s-eh1 sh-ah-n ih-s-t", "nn"],
  "seclude": ["s-ah-k-l-uw1-d", "vb"],
  "secluded": ["s-ih k-l-uw1 d-ih-d", "vbn jj"],
  "seclusion": ["s-ih k-l-uw1 zh-ah-n", "nn"],
  "second": ["s-eh1 k-ah-n-d", "nn jj rb vb"],
  "secondarily": ["s-eh k-ah-n d-eh1 r-ah l-iy", "rb"],
  "secondary": ["s-eh1 k-ah-n d-eh r-iy", "jj"],
  "secondhand": ["s-eh1 k-ah-n-d hh-ae-n-d", "jj"],
  "secondly": ["s-eh1 k-ah-n-d l-iy", "rb"],
  "secrecy": ["s-iy1 k-r-ah s-iy", "nn"],
  "secret": ["s-iy1 k-r-ah-t", "jj nn"],
  "secretarial": ["s-eh k-r-ah t-eh1 r-iy ah-l", "jj"],
  "secretary": ["s-eh1 k-r-ah t-eh r-iy", "nn"],
  "secrete": ["s-ah k-r-iy1-t", "vb"],
  "secretion": ["s-ah k-r-iy1 sh-ah-n", "nn"],
  "secretive": ["s-iy1 k-r-ah t-ih-v", "jj"],
  "secretly": ["s-iy1 k-r-ih-t l-iy", "rb"],
  "sect": ["s-eh1-k-t", "nn"],
  "sectarian": ["s-eh-k t-eh1 r-iy ah-n", "jj nn"],
  "section": ["s-eh1-k sh-ah-n", "nn"],
  "sectional": ["s-eh1-k sh-ah n-ah-l", "jj"],
  "sector": ["s-eh1-k t-er", "nn"],
  "secular": ["s-eh1 k-y-ah l-er", "jj"],
  "secularism": ["s-eh1 k-y-ah l-er ih z-ah-m", "nn"],
  "secularist": ["s-eh1 k-y-ah l-er ih-s-t", "nn"],
  "secure": ["s-ih k-y-uh1-r", "vb jj vbp"],
  "secured": ["s-ih k-y-uh1-r-d", "vbn vbd jj"],
  "securely": ["s-ih k-y-uh1-r l-iy", "rb"],
  "securitization": ["s-ih k-y-uh r-ah t-ah z-ey1 sh-ah-n", "nn"],
  "security": ["s-ih k-y-uh1 r-ah t-iy", "nn"],
  "sedan": ["s-ah d-ae1-n", "nn"],
  "sedate": ["s-ih d-ey1-t", "jj"],
  "sedative": ["s-eh1 d-ah t-ih-v", "nn"],
  "sedentary": ["s-eh1 d-ah-n t-eh r-iy", "jj"],
  "sediment": ["s-eh1 d-ah m-ah-n-t", "nn"],
  "sedimentary": ["s-eh d-ah m-eh1-n t-er iy", "jj"],
  "sedimentation": ["s-eh d-ah m-ah-n t-ey1 sh-ah-n", "nn"],
  "sedition": ["s-ih d-ih1 sh-ah-n", "nn"],
  "seditious": ["s-ih d-ih1 sh-ah-s", "jj"],
  "seduce": ["s-ih d-uw1-s", "vb"],
  "seducer": ["s-ih d-uw1 s-er", "nn"],
  "seduction": ["s-ih d-ah1-k sh-ah-n", "nn"],
  "seductive": ["s-ih d-ah1-k t-ih-v", "jj"],
  "see": ["s-iy1", "vb uh vbp"],
  "seed": ["s-iy1-d", "nn vb"],
  "seedling": ["s-iy1-d l-ih-ng", "nn"],
  "seedy": ["s-iy1 d-iy", "jj"],
  "seek": ["s-iy1-k", "vb vbp"],
  "seeker": ["s-iy1 k-er", "nn"],
  "seem": ["s-iy1-m", "vb vbp"],
  "seeming": ["s-iy1 m-ih-ng", "jj vbg"],
  "seemingly": ["s-iy1 m-ih-ng l-iy", "rb"],
  "seen": ["s-iy1-n", "vbn vbd jj"],
  "seep": ["s-iy1-p", "vb vbp"],
  "seepage": ["s-iy1 p-ih-jh", "nn"],
  "seer": ["s-iy1-r", "nn"],
  "seesaw": ["s-iy1 s-ao", "nn vb"],
  "seethe": ["s-iy1-dh", "vb vbp"],
  "seething": ["s-iy1 th-ih-ng", "vbg jj"],
  "segment": ["s-eh1-g m-ah-n-t", "nn vb vbp"],
  "segmentation": ["s-eh-g m-ah-n t-ey1 sh-ah-n", "nn"],
  "segmented": ["s-eh1-g m-eh-n t-ih-d", "jj"],
  "segregate": ["s-eh1 g-r-ah g-ey-t", "vb"],
  "segregated": ["s-eh1 g-r-ah g-ey t-ih-d", "vbn vbd jj"],
  "segregation": ["s-eh g-r-ah g-ey1 sh-ah-n", "nn"],
  "segregationist": ["s-eh g-r-ah g-ey1 sh-ah-n ih-s-t", "nn jj"],
  "seismic": ["s-ay1-z m-ih-k", "jj"],
  "seize": ["s-iy1-z", "vb vbp"],
  "seized": ["s-iy1-z-d", "vbn jj vbd"],
  "seizure": ["s-iy1 zh-er", "nn"],
  "seldom": ["s-eh1-l d-ah-m", "rb"],
  "select": ["s-ah l-eh1-k-t", "vb vbp jj"],
  "selected": ["s-ah l-eh1-k t-ah-d", "vbn jj vbd"],
  "selection": ["s-ah l-eh1-k sh-ah-n", "nn"],
  "selective": ["s-ah l-eh1-k t-ih-v", "jj"],
  "selectively": ["s-ah l-eh1-k t-ih-v l-iy", "rb"],
  "selectivity": ["s-ih l-eh-k t-ih1 v-ah t-iy", "nn"],
  "self": ["s-eh1-l-f", "nn prp"],
  "selfish": ["s-eh1-l f-ih-sh", "jj"],
  "selfishness": ["s-eh1-l f-ih-sh n-ah-s", "nn"],
  "selfless": ["s-eh1-l-f l-ah-s", "jj"],
  "sell": ["s-eh1-l", "vb vbp nn"],
  "seller": ["s-eh1 l-er", "nn"],
  "sellin": ["s-eh1 l-ih-n", "nn"],
  "selling": ["s-eh1 l-ih-ng", "vbg jj"],
  "selloff": ["s-eh1-l ao-f", "nn"],
  "sellout": ["s-eh1-l aw-t", "nn"],
  "semantic": ["s-ih m-ae1-n t-ih-k", "jj"],
  "semblance": ["s-eh1-m b-l-ah-n-s", "nn"],
  "semen": ["s-iy1 m-ah-n", "nn"],
  "semester": ["s-ah m-eh1 s-t-er", "nn"],
  "semiannual": ["s-eh m-iy ae1 n-y-ah w-ah-l", "jj"],
  "semiannually": ["s-eh m-iy ae1 n-uw ah l-iy", "rb"],
  "semiautomatic": ["s-eh m-iy ao t-ah m-ae1 t-ih-k", "jj"],
  "semicircular": ["s-eh m-iy s-er1 k-y-ah l-er", "jj"],
  "semiconductor": ["s-eh m-iy k-ah-n d-ah1-k t-er", "nn"],
  "semifinal": ["s-eh m-iy f-ay1 n-ah-l", "nn"],
  "semifinalist": ["s-eh m-iy f-ay1 n-ah-l ih-s-t", "nn"],
  "seminal": ["s-eh1 m-ah n-ah-l", "jj"],
  "seminar": ["s-eh1 m-ah n-aa-r", "nn"],
  "seminarian": ["s-eh m-ah n-eh1 r-iy ah-n", "nn"],
  "seminary": ["s-eh1 m-ah n-eh r-iy", "nn"],
  "senate": ["s-eh1 n-ah-t", "nn"],
  "senator": ["s-eh1 n-ah t-er", "nn"],
  "senatorial": ["s-eh n-ah t-ao1 r-iy ah-l", "jj"],
  "send": ["s-eh1-n-d", "vb vbp"],
  "sender": ["s-eh1-n d-er", "nn"],
  "senile": ["s-iy1 n-ay-l", "jj"],
  "senior": ["s-iy1 n-y-er", "jj nn"],
  "seniority": ["s-iy n-y-ao1 r-ih t-iy", "nn"],
  "sensation": ["s-eh-n s-ey1 sh-ah-n", "nn"],
  "sensational": ["s-eh-n s-ey1 sh-ah n-ah-l", "jj"],
  "sense": ["s-eh1-n-s", "nn vbp vb"],
  "senseless": ["s-eh1-n-s l-ah-s", "jj"],
  "sensibility": ["s-eh-n s-ih b-ih1 l-ih t-iy", "nn"],
  "sensible": ["s-eh1-n s-ah b-ah-l", "jj nn"],
  "sensibly": ["s-eh1-n s-ah b-l-iy", "rb"],
  "sensitive": ["s-eh1-n s-ah t-ih-v", "jj nn"],
  "sensitively": ["s-eh1-n s-ih t-ih-v l-iy", "rb"],
  "sensitivity": ["s-eh-n s-ih t-ih1 v-ih t-iy", "nn"],
  "sensitize": ["s-eh1-n-s-ah-t-ay-z", "vb"],
  "sensor": ["s-eh1-n s-er", "nn"],
  "sensory": ["s-eh1-n s-er iy", "jj"],
  "sensual": ["s-eh1-n ch-ah w-ah-l", "jj"],
  "sensuality": ["s-eh-n ch-ah-w ae1 l-ah t-iy", "nn"],
  "sensuous": ["s-eh1-n ch-ah-w ah-s", "jj"],
  "sent": ["s-eh1-n-t", "vbd vbn"],
  "sentence": ["s-eh1-n t-ah-n-s", "nn vb"],
  "sentiment": ["s-eh1-n t-ah m-ah-n-t", "nn"],
  "sentimental": ["s-eh-n t-ah m-eh1-n t-ah-l", "jj"],
  "sentimentality": ["s-eh-n t-ah m-eh-n t-ae1 l-ih t-iy", "nn"],
  "sentinel": ["s-eh1-n t-ah n-ah-l", "nn"],
  "sentry": ["s-eh1-n t-r-iy", "nn"],
  "separate": ["s-eh1 p-er ey-t", "jj vbp vb"],
  "separated": ["s-eh1 p-er ey t-ah-d", "vbn jj vbd"],
  "separately": ["s-eh1 p-er ah-t l-iy", "rb"],
  "separateness": ["s-eh1 p-er ah-t n-ah-s", "nn"],
  "separation": ["s-eh p-er ey1 sh-ah-n", "nn"],
  "separatist": ["s-eh1 p-er ah t-ih-s-t", "jj"],
  "sepsis": ["s-eh1-p s-ih-s", "nn"],
  "septic": ["s-eh1-p t-ih-k", "jj nn"],
  "septuagenarian": ["s-eh-p ch-uw ah jh-ah n-eh1 r-iy ah-n", "nn"],
  "septum": ["s-eh1-p t-ah-m", "nn"],
  "sequel": ["s-iy1 k-w-ah-l", "nn"],
  "sequence": ["s-iy1 k-w-ah-n-s", "nn"],
  "sequester": ["s-ih k-w-eh1 s-t-er", "nn vb vbp"],
  "sequin": ["s-iy1 k-w-ah-n", "nn"],
  "sequined": ["s-iy1 k-w-ah-n-d", "jj"],
  "serenade": ["s-eh r-ah n-ey1-d", "nn vb"],
  "serendipity": ["s-eh r-ah-n d-ih1 p-ih t-iy", "nn"],
  "serene": ["s-er iy1-n", "jj nn"],
  "serenely": ["s-er iy1 n-ah l-iy", "rb"],
  "serenity": ["s-er eh1 n-ah t-iy", "nn"],
  "serf": ["s-er1-f", "nn"],
  "sergeant": ["s-aa1-r jh-ah-n-t", "nn"],
  "serial": ["s-ih1 r-iy ah-l", "jj nn"],
  "serialize": ["s-ih1-r-iy-ah-l-ay-z", "vb"],
  "series": ["s-ih1 r-iy-z", "nn"],
  "serious": ["s-ih1 r-iy ah-s", "jj"],
  "seriously": ["s-ih1 r-iy ah-s l-iy", "rb"],
  "seriousness": ["s-ih1 r-iy ah-s n-ah-s", "nn"],
  "sermon": ["s-er1 m-ah-n", "nn"],
  "serotonin": ["s-er ah t-ow1 n-ih-n", "nn"],
  "serpent": ["s-er1 p-ah-n-t", "nn"],
  "serpentine": ["s-er1 p-ah-n t-ay-n", "jj"],
  "serum": ["s-ih1 r-ah-m", "nn"],
  "servant": ["s-er1 v-ah-n-t", "nn"],
  "serve": ["s-er1-v", "nn vb vbp"],
  "server": ["s-er1 v-er", "nn"],
  "service": ["s-er1 v-ah-s", "nn vb vbp"],
  "serviceable": ["s-er1 v-ah s-ah b-ah-l", "jj"],
  "servile": ["s-er1 v-ah-l", "jj"],
  "servitude": ["s-er1 v-ah t-uw-d", "nn"],
  "servo": ["s-er1 v-ow", "nn jj"],
  "sesame": ["s-eh1 s-ah m-iy", "nn"],
  "session": ["s-eh1 sh-ah-n", "nn"],
  "set": ["s-eh1-t", "vbn vbd vbp jj nn vb"],
  "setback": ["s-eh1-t b-ae-k", "nn"],
  "setter": ["s-eh1 t-er", "nn"],
  "settle": ["s-eh1 t-ah-l", "vb vbp"],
  "settled": ["s-eh1 t-ah-l-d", "vbd vbn jj"],
  "settlement": ["s-eh1 t-ah-l m-ah-n-t", "nn"],
  "settler": ["s-eh1 t-ah-l er", "nn"],
  "setup": ["s-eh1-t ah-p", "nn"],
  "seven": ["s-eh1 v-ah-n", "cd"],
  "seventh": ["s-eh1 v-ah-n-th", "jj"],
  "seventy": ["s-eh1 v-ah-n t-iy", "nn"],
  "sever": ["s-eh1 v-er", "vb vbp"],
  "several": ["s-eh1 v-r-ah-l", "jj rb"],
  "severance": ["s-eh1 v-er ah-n-s", "nn jj"],
  "severe": ["s-ah v-ih1-r", "jj"],
  "severely": ["s-ah v-ih1-r l-iy", "rb"],
  "severest": ["s-ah v-ih1 r-ah-s-t", "jjs"],
  "severity": ["s-ih v-eh1 r-ih t-iy", "nn"],
  "sew": ["s-ow1", "vb vbp"],
  "sewn": ["s-ow1-n", "vbn"],
  "sewage": ["s-uw1 ah-jh", "nn"],
  "sewer": ["s-uw1 er", "nn"],
  "sewing": ["s-ow1 ih-ng", "nn vbg"],
  "sex": ["s-eh1-k-s", "nn vb"],
  "sexism": ["s-eh1-k s-ih z-ah-m", "nn"],
  "sexist": ["s-eh1-k s-ih-s-t", "jj"],
  "sextet": ["s-eh-k s-t-eh1-t", "nn"],
  "sexton": ["s-eh1-k s-t-ah-n", "nn"],
  "sexual": ["s-eh1-k sh-uw ah-l", "jj"],
  "sexuality": ["s-eh-k sh-uw ae1 l-ah t-iy", "nn"],
  "sexually": ["s-eh1-k sh-uw ah l-iy", "rb"],
  "sexy": ["s-eh1-k s-iy", "jj"],
  "shabby": ["sh-ae1 b-iy", "jj"],
  "shack": ["sh-ae1-k", "nn"],
  "shackle": ["sh-ae1 k-ah-l", "vb"],
  "shad": ["sh-ae1-d", "nn"],
  "shade": ["sh-ey1-d", "nn vb"],
  "shaded": ["sh-ey1 d-ih-d", "vbn vbd jj"],
  "shading": ["sh-ey1 d-ih-ng", "nn vbg"],
  "shadow": ["sh-ae1 d-ow", "nn vb"],
  "shadowed": ["sh-ae1 d-ow-d", "vbn jj"],
  "shadowy": ["sh-ae1 d-ow iy", "jj"],
  "shady": ["sh-ey1 d-iy", "jj"],
  "shaft": ["sh-ae1-f-t", "nn"],
  "shaggy": ["sh-ae1 g-iy", "jj"],
  "shake": ["sh-ey1-k", "vb nn vbp"],
  "shaken": ["sh-ey1 k-ah-n", "vbn jj"],
  "shakeout": ["sh-ey1-k aw-t", "nn"],
  "shaker": ["sh-ey1 k-er", "nn"],
  "shakeup": ["sh-ey1-k ah-p", "nn"],
  "shaky": ["sh-ey1 k-iy", "jj"],
  "shall": ["sh-ae1-l", "md"],
  "shallow": ["sh-ae1 l-ow", "jj nn"],
  "shallower": ["sh-ae1 l-ow er", "jjr"],
  "shallowness": ["sh-ae1 l-ow n-ah-s", "nn"],
  "sham": ["sh-ae1-m", "nn jj"],
  "shambles": ["sh-ae1-m b-ah-l-z", "nn"],
  "shame": ["sh-ey1-m", "nn vb"],
  "shameful": ["sh-ey1-m f-ah-l", "jj"],
  "shameless": ["sh-ey1-m l-ah-s", "jj"],
  "shamelessly": ["sh-ey1-m l-ah-s l-iy", "rb"],
  "shampoo": ["sh-ae-m p-uw1", "nn vb"],
  "shamrock": ["sh-ae1-m r-aa-k", "nn"],
  "shanty": ["sh-ae1-n t-iy", "nn"],
  "shantytown": ["sh-ae1-n t-iy t-aw-n", "nn"],
  "shape": ["sh-ey1-p", "nn vbp vb"],
  "shaped": ["sh-ey1-p-t", "vbn vbd jj"],
  "shapeless": ["sh-ey1-p l-ah-s", "jj"],
  "shapely": ["sh-ey1-p l-iy", "jj"],
  "shard": ["sh-aa1-r-d", "nn"],
  "share": ["sh-eh1-r", "nn vbp jj vb"],
  "sharecropper": ["sh-eh1-r k-r-aa p-er", "nn"],
  "shared": ["sh-eh1-r-d", "vbn jj vbd"],
  "shareholder": ["sh-eh1-r hh-ow-l d-er", "nn"],
  "shareholding": ["sh-eh1-r hh-ow-l d-ih-ng", "nn"],
  "shareowner": ["sh-eh1 r-ow n-er", "nn"],
  "shark": ["sh-aa1-r-k", "nn"],
  "sharp": ["sh-aa1-r-p", "jj"],
  "sharpen": ["sh-aa1-r p-ah-n", "vb"],
  "sharper": ["sh-aa1-r p-er", "jjr rbr"],
  "sharpest": ["sh-aa1-r p-ah-s-t", "jjs"],
  "sharply": ["sh-aa1-r-p l-iy", "rb"],
  "sharpness": ["sh-aa1-r-p n-ah-s", "nn"],
  "sharpshooter": ["sh-aa1-r-p sh-uw t-er", "nn"],
  "shatter": ["sh-ae1 t-er", "vb"],
  "shattered": ["sh-ae1 t-er-d", "vbn jj vbd"],
  "shattering": ["sh-ae1 t-er ih-ng", "vbg jj"],
  "shatterproof": ["sh-ae1 t-er p-r-uw-f", "jj"],
  "shave": ["sh-ey1-v", "vb vbp nn"],
  "shaven": ["sh-ey1 v-ah-n", "jj"],
  "shaver": ["sh-ey1 v-er", "nn"],
  "shawl": ["sh-ao1-l", "nn"],
  "she": ["sh-iy1", "prp"],
  "sheaf": ["sh-iy1-f", "nn"],
  "shear": ["sh-ih1-r", "vb"],
  "sheath": ["sh-iy1-th", "nn"],
  "shed": ["sh-eh1-d", "vb vbd vbn vbp nn"],
  "sheen": ["sh-iy1-n", "nn"],
  "sheep": ["sh-iy1-p", "nn"],
  "sheepish": ["sh-iy1 p-ih-sh", "jj"],
  "sheepskin": ["sh-iy1-p s-k-ih-n", "nn"],
  "sheer": ["sh-ih1-r", "jj nn"],
  "sheet": ["sh-iy1-t", "nn"],
  "sheik": ["sh-iy1-k", "nn"],
  "shelf": ["sh-eh1-l-f", "nn"],
  "shell": ["sh-eh1-l", "nn jj vb"],
  "shelled": ["sh-eh1-l-d", "vbd vbn jj"],
  "shellfish": ["sh-eh1-l f-ih-sh", "nn"],
  "shellshocked": ["sh-eh1-l sh-aa-k-t", "jj"],
  "shelter": ["sh-eh1-l t-er", "nn vb"],
  "sheltered": ["sh-eh1-l t-er-d", "vbn jj"],
  "shelve": ["sh-eh1-l-v", "vb"],
  "shelved": ["sh-eh1-l-v-d", "vbd vbn"],
  "shelving": ["sh-eh1-l v-ih-ng", "nn"],
  "shenanigan": ["sh-ah n-ae1 n-ih g-ah-n", "nn"],
  "shepherd": ["sh-eh1 p-er-d", "nn vb"],
  "sherbet": ["sh-er1 b-ah-t", "nn"],
  "sheriff": ["sh-eh1 r-ah-f", "nn"],
  "sherry": ["sh-eh1 r-iy", "nn"],
  "shield": ["sh-iy1-l-d", "nn vb"],
  "shift": ["sh-ih1-f-t", "nn vb vbp"],
  "shifting": ["sh-ih1-f t-ih-ng", "vbg jj nn"],
  "shifty": ["sh-ih1-f t-iy", "jj"],
  "shill": ["sh-ih1-l", "nn"],
  "shilling": ["sh-ih1 l-ih-ng", "nn"],
  "shim": ["sh-ih1-m", "vb"],
  "shimmer": ["sh-ih1 m-er", "nn vb"],
  "shimmering": ["sh-ih1 m-er ih-ng", "vbg jj"],
  "shimmy": ["sh-ih1 m-iy", "vb vbp"],
  "shin": ["sh-ih1-n", "nn"],
  "shinbone": ["sh-ih1-n b-ow-n", "nn"],
  "shine": ["sh-ay1-n", "nn vbp vb"],
  "shingle": ["sh-ih1-ng g-ah-l", "nn"],
  "shining": ["sh-ay1 n-ih-ng", "vbg jj"],
  "shiny": ["sh-ay1 n-iy", "jj"],
  "ship": ["sh-ih1-p", "nn vbp vb"],
  "shipboard": ["sh-ih1-p b-ao-r-d", "nn jj"],
  "shipbuilder": ["sh-ih1-p b-ih-l d-er", "nn"],
  "shipbuilding": ["sh-ih1-p b-ih-l d-ih-ng", "nn"],
  "shipload": ["sh-ih1-p l-ow-d", "nn"],
  "shipmate": ["sh-ih1-p m-ey-t", "nn"],
  "shipment": ["sh-ih1-p m-ah-n-t", "nn"],
  "shipowner": ["sh-ih1-p ow n-er", "nn"],
  "shipped": ["sh-ih1-p-t", "vbn jj vbd"],
  "shipper": ["sh-ih1 p-er", "nn"],
  "shipshape": ["sh-ih1-p sh-ey-p", "jj"],
  "shipyard": ["sh-ih1-p y-aa-r-d", "nn"],
  "shirk": ["sh-er1-k", "vb"],
  "shirt": ["sh-er1-t", "nn"],
  "shirtsleeve": ["sh-er1-t s-l-iy-v", "nn"],
  "shit": ["sh-ih1-t", "nn"],
  "shiver": ["sh-ih1 v-er", "nn vb"],
  "shoal": ["sh-ow1-l", "nn"],
  "shock": ["sh-aa1-k", "nn vb"],
  "shocked": ["sh-aa1-k-t", "vbn vbd jj"],
  "shocker": ["sh-aa1 k-er", "nn"],
  "shocking": ["sh-aa1 k-ih-ng", "jj vbg"],
  "shockingly": ["sh-aa1 k-ih-ng l-iy", "rb"],
  "shod": ["sh-aa1-d", "jj"],
  "shoddy": ["sh-aa1 d-iy", "jj"],
  "shoe": ["sh-uw1", "nn"],
  "shoehorn": ["sh-uw1-hh-ao-r-n", "vb"],
  "shoelace": ["sh-uw1 l-ey-s", "nn"],
  "shoemaker": ["sh-uw1 m-ey k-er", "nn"],
  "shoestring": ["sh-uw1 s-t-r-ih-ng", "nn"],
  "shone": ["sh-ow1-n", "vbd vbn"],
  "shoo": ["sh-uw1", "vb"],
  "shook": ["sh-uh1-k", "vbd nn vbn"],
  "shoot": ["sh-uw1-t", "vb nn vbp"],
  "shooter": ["sh-uw1 t-er", "nn"],
  "shooting": ["sh-uw1 t-ih-ng", "nn vbg"],
  "shootout": ["sh-uw1-t aw-t", "nn"],
  "shop": ["sh-aa1-p", "nn vb vbp"],
  "shopkeeper": ["sh-aa1-p k-iy p-er", "nn"],
  "shoplifting": ["sh-aa1-p l-ih-f t-ih-ng", "nn"],
  "shopper": ["sh-aa1 p-er", "nn"],
  "shopping": ["sh-aa1 p-ih-ng", "nn jj vbg"],
  "shopworn": ["sh-aa1-p w-ao-r-n", "jj"],
  "shore": ["sh-ao1-r", "nn jj rb vb"],
  "shoreline": ["sh-ao1-r l-ay-n", "nn"],
  "shorn": ["sh-ao1-r-n", "vb"],
  "short": ["sh-ao1-r-t", "jj nn rb vb"],
  "shortage": ["sh-ao1-r t-ah-jh", "nn"],
  "shortcake": ["sh-ao1-r-t k-ey-k", "nn"],
  "shortchange": ["sh-ao-r-t-ch-ey1-n-jh", "vb"],
  "shortcoming": ["sh-ao1-r-t k-ah m-ih-ng", "nn"],
  "shortcut": ["sh-ao1-r-t k-ah-t", "nn"],
  "shorten": ["sh-ao1-r t-ah-n", "vb vbp"],
  "shortened": ["sh-ao1-r t-ah-n-d", "vbn jj"],
  "shorter": ["sh-ao1-r t-er", "jjr"],
  "shortest": ["sh-ao1-r t-ih-s-t", "jjs"],
  "shortfall": ["sh-ao1-r-t f-ao-l", "nn"],
  "shorthand": ["sh-ao1-r-t hh-ae-n-d", "nn"],
  "shortlived": ["sh-ao1-r-t l-ih1-v-d", "jj"],
  "shortly": ["sh-ao1-r-t l-iy", "rb"],
  "shortness": ["sh-ao1-r-t n-ah-s", "nn"],
  "shortsighted": ["sh-ao1-r-t s-ay1 t-ih-d", "jj"],
  "shortsightedness": ["sh-ao1-r-t s-ay1 t-ih-d n-ih-s", "nn"],
  "shortstop": ["sh-ao1-r-t s-t-aa-p", "nn"],
  "shortterm": ["sh-ao1-r-t t-er-m", "jj"],
  "shot": ["sh-aa1-t", "nn vbd vbn"],
  "shotgun": ["sh-aa1-t g-ah-n", "nn jj"],
  "should": ["sh-uh1-d", "md vbd"],
  "shouldn't": ["sh-uh1-d-ah-n-t", "md"],
  "shoulder": ["sh-ow1-l d-er", "nn vbp rb vb"],
  "shout": ["sh-aw1-t", "vb vbp nn"],
  "shove": ["sh-ah1-v", "vb nn"],
  "shovel": ["sh-ah1 v-ah-l", "nn vb"],
  "show": ["sh-ow1", "nn vb vbp"],
  "showcase": ["sh-ow1 k-ey-s", "nn vb"],
  "showdown": ["sh-ow1 d-aw-n", "nn"],
  "shower": ["sh-aw1 er", "nn vb vbp"],
  "showman": ["sh-ow1 m-ah-n", "nn"],
  "showmanship": ["sh-ow1 m-ah-n sh-ih-p", "nn"],
  "shown": ["sh-ow1-n", "vbn vbd"],
  "showpiece": ["sh-ow1 p-iy-s", "nn"],
  "showroom": ["sh-ow1 r-uh-m", "nn"],
  "showy": ["sh-ow1 iy", "jj"],
  "shrank": ["sh-r-ae1-ng-k", "vbd"],
  "shrapnel": ["sh-r-ae1-p n-ah-l", "nn"],
  "shred": ["sh-r-eh1-d", "nn vb"],
  "shredded": ["sh-r-eh1 d-ah-d", "jj vbd"],
  "shredder": ["sh-r-eh1 d-er", "nn"],
  "shrewd": ["sh-r-uw1-d", "jj"],
  "shrewdest": ["sh-r-uw1 d-ah-s-t", "jjs"],
  "shrewdly": ["sh-r-uw1-d l-iy", "rb"],
  "shriek": ["sh-r-iy1-k", "nn vb"],
  "shrieking": ["sh-r-iy1 k-ih-ng", "nn"],
  "shrift": ["sh-r-ih1-f-t", "nn"],
  "shrill": ["sh-r-ih1-l", "jj"],
  "shrimp": ["sh-r-ih1-m-p", "nn"],
  "shrine": ["sh-r-ay1-n", "nn"],
  "shrink": ["sh-r-ih1-ng-k", "vb nn"],
  "shrinkage": ["sh-r-ih1-ng k-ih-jh", "nn"],
  "shrivel": ["sh-r-ih1 v-ah-l", "vb"],
  "shriveled": ["sh-r-ih1 v-ah-l-d", "vbn vbd jj"],
  "shroud": ["sh-r-aw1-d", "nn vb"],
  "shrub": ["sh-r-ah1-b", "nn"],
  "shrubbery": ["sh-r-ah1 b-er iy", "nn"],
  "shrug": ["sh-r-ah1-g", "vb nn vbp"],
  "shrunk": ["sh-r-ah1-ng-k", "vbn"],
  "shrunken": ["sh-r-ah1-ng k-ah-n", "jj vbn"],
  "shuck": ["sh-ah1-k", "vb"],
  "shudder": ["sh-ah1 d-er", "vb vbp"],
  "shuddering": ["sh-ah1 d-er ih-ng", "vbg jj"],
  "shuffle": ["sh-ah1 f-ah-l", "nn vb vbp"],
  "shun": ["sh-ah1-n", "vb vbp"],
  "shut": ["sh-ah1-t", "vbn vbd jj nn vb"],
  "shutdown": ["sh-ah1-t d-aw-n", "nn"],
  "shute": ["sh-uw1-t", "vb"],
  "shutout": ["sh-ah1-t aw-t", "nn"],
  "shutter": ["sh-ah1 t-er", "nn vb"],
  "shuttered": ["sh-ah1 t-er-d", "jj vbd vbn"],
  "shuttle": ["sh-ah1 t-ah-l", "nn vb"],
  "shy": ["sh-ay1", "jj nn rb vb vbp"],
  "shyly": ["sh-ay1 l-iy", "rb"],
  "sibling": ["s-ih1 b-l-ih-ng", "nn"],
  "sic": ["s-ih1-k", "vb"],
  "sick": ["s-ih1-k", "jj"],
  "sicken": ["s-ih1-k-ah-n", "vb"],
  "sickened": ["s-ih1 k-ah-n-d", "vbn vbd jj"],
  "sickening": ["s-ih1 k-ah n-ih-ng", "jj"],
  "sicker": ["s-ih1 k-er", "jjr"],
  "sickle": ["s-ih1 k-ah-l", "jj"],
  "sickly": ["s-ih1-k l-iy", "jj"],
  "sickness": ["s-ih1-k n-ah-s", "nn"],
  "side": ["s-ay1-d", "nn vbp jj rb vb"],
  "sidekick": ["s-ay1-d k-ih-k", "nn"],
  "sideline": ["s-ay1-d l-ay-n", "nn vb"],
  "sidelined": ["s-ay1-d l-ay-n-d", "vbn jj"],
  "sideman": ["s-ay1-d m-ae-n", "nn"],
  "sideshow": ["s-ay1-d sh-ow", "nn"],
  "sidestep": ["s-ay1-d s-t-eh-p", "vb vbp"],
  "sidetrack": ["s-ay1-d t-r-ae-k", "vb"],
  "sidewalk": ["s-ay1-d w-ao-k", "nn"],
  "sideways": ["s-ay1-d w-ey-z", "rb jj"],
  "sidewinder": ["s-ay1-d w-ay-n d-er", "nn"],
  "sidewise": ["s-ay1-d w-ay-z", "rb jj"],
  "sidle": ["s-ay1 d-ah-l", "vb"],
  "siege": ["s-iy1-jh", "nn"],
  "sieve": ["s-ih1-v", "nn"],
  "sift": ["s-ih1-f-t", "vb vbp"],
  "sifting": ["s-ih1-f t-ih-ng", "nn"],
  "sigh": ["s-ay1", "nn vb vbp"],
  "sight": ["s-ay1-t", "nn vb"],
  "sighting": ["s-ay1 t-ih-ng", "nn"],
  "sightseeing": ["s-ay1-t s-iy1 ih-ng", "nn"],
  "sign": ["s-ay1-n", "nn vbp vb"],
  "signal": ["s-ih1-g n-ah-l", "nn vb vbp"],
  "signatory": ["s-ih1-g n-ah t-ao r-iy", "jj nn"],
  "signature": ["s-ih1-g n-ah ch-er", "nn"],
  "signed": ["s-ay1-n-d", "vbd jj vbn"],
  "signer": ["s-ay1 n-er", "nn"],
  "significance": ["s-ah-g n-ih1 f-ih k-ah-n-s", "nn"],
  "significant": ["s-ah-g n-ih1 f-ih k-ah-n-t", "jj"],
  "significantly": ["s-ih-g n-ih1 f-ih k-ah-n-t l-iy", "rb"],
  "signify": ["s-ih1-g n-ah f-ay", "vb"],
  "signpost": ["s-ay1-n p-ow-s-t", "nn"],
  "silence": ["s-ay1 l-ah-n-s", "nn vb"],
  "silent": ["s-ay1 l-ah-n-t", "jj"],
  "silently": ["s-ay1 l-ah-n-t l-iy", "rb"],
  "silhouette": ["s-ih l-ah-w eh1-t", "nn"],
  "silica": ["s-ih1 l-ah k-ah", "nn"],
  "silicate": ["s-ih1 l-ah k-ah-t", "nn"],
  "silicon": ["s-ih1 l-ah k-ah-n", "nn"],
  "silicone": ["s-ih1 l-ah k-ow-n", "nn"],
  "silk": ["s-ih1-l-k", "nn"],
  "silky": ["s-ih1-l k-iy", "jj"],
  "sill": ["s-ih1-l", "nn"],
  "sillier": ["s-ih1 l-iy er", "jjr"],
  "silliest": ["s-ih1 l-iy ah-s-t", "jjs"],
  "silliness": ["s-ih1 l-iy n-ah-s", "nn"],
  "silly": ["s-ih1 l-iy", "jj nn rb"],
  "silo": ["s-ay1 l-ow", "nn"],
  "silver": ["s-ih1-l v-er", "nn jj"],
  "silverware": ["s-ih1-l v-er w-eh-r", "nn"],
  "silvery": ["s-ih1-l v-er iy", "jj"],
  "simian": ["s-ih1 m-iy ah-n", "jj"],
  "similar": ["s-ih1 m-ah l-er", "jj"],
  "similarity": ["s-ih m-ah l-eh1 r-ah t-iy", "nn"],
  "similarly": ["s-ih1 m-ah l-er l-iy", "rb"],
  "simile": ["s-ih1 m-ah l-iy", "nn"],
  "similiar": ["s-ih m-ih1 l-aa-r", "jj"],
  "simmer": ["s-ih1 m-er", "vb vbp"],
  "simple": ["s-ih1-m p-ah-l", "jj nn"],
  "simpler": ["s-ih1-m p-ah l-er", "jjr rbr"],
  "simplest": ["s-ih1-m p-l-ah-s-t", "jjs"],
  "simplicity": ["s-ih-m p-l-ih1 s-ah t-iy", "nn"],
  "simplification": ["s-ih-m p-l-ah f-ih k-ey1 sh-ah-n", "nn"],
  "simplified": ["s-ih1-m p-l-ah f-ay-d", "jj vbn"],
  "simplify": ["s-ih1-m p-l-ah f-ay", "vb vbp"],
  "simplistic": ["s-ih-m p-l-ih1 s-t-ih-k", "jj"],
  "simply": ["s-ih1-m p-l-iy", "rb jj"],
  "simulate": ["s-ih1 m-y-ah l-ah-t", "vb vbp"],
  "simulated": ["s-ih1 m-y-ah l-ey t-ih-d", "vbn jj"],
  "simulation": ["s-ih m-y-ah l-ey1 sh-ah-n", "nn"],
  "simulator": ["s-ih1 m-y-ah l-ey t-er", "nn"],
  "simultaneous": ["s-ay m-ah-l t-ey1 n-iy ah-s", "jj"],
  "simultaneously": ["s-ay m-ah-l t-ey1 n-iy ah-s l-iy", "rb"],
  "sin": ["s-ih1-n", "nn vbp vb"],
  "since": ["s-ih1-n-s", "in rb"],
  "sincere": ["s-ih-n s-ih1-r", "jj"],
  "sincerely": ["s-ih-n s-ih1-r l-iy", "rb"],
  "sincerity": ["s-ih-n s-eh1 r-ah t-iy", "nn"],
  "sine": ["s-ay1-n", "nn"],
  "sinewy": ["s-ih1 n-y-uw iy", "jj"],
  "sinful": ["s-ih1-n f-ah-l", "jj"],
  "sing": ["s-ih1-ng", "vb vbp"],
  "singer": ["s-ih1 ng-er", "nn"],
  "singing": ["s-ih1 ng-ih-ng", "vbg jj nn"],
  "single": ["s-ih1-ng g-ah-l", "jj vbp nn rb vb"],
  "singlehandedly": ["s-ih-ng g-ah-l hh-ae1-n d-ih-d l-iy", "rb"],
  "singly": ["s-ih1-ng g-l-iy", "rb"],
  "singular": ["s-ih1-ng g-y-ah l-er", "jj nn"],
  "singularly": ["s-ih1-ng g-y-ah l-er l-iy", "rb"],
  "sinister": ["s-ih1 n-ih s-t-er", "jj"],
  "sink": ["s-ih1-ng-k", "vb vbp nn"],
  "sinkhole": ["s-ih1-ng-k hh-ow-l", "nn"],
  "sinking": ["s-ih1-ng k-ih-ng", "vbg jj"],
  "sinner": ["s-ih1 n-er", "nn"],
  "sinning": ["s-ih1 n-ih-ng", "nn"],
  "sinuous": ["s-ih1 n-w-ah-s", "jj"],
  "sinus": ["s-ay1 n-ah-s", "nn"],
  "sip": ["s-ih1-p", "nn"],
  "siphon": ["s-ay1 f-ah-n", "vb"],
  "sipped": ["s-ih1-p-t", "vbd"],
  "sir": ["s-er1", "nn uh"],
  "siren": ["s-ay1 r-ah-n", "jj nn"],
  "sister": ["s-ih1 s-t-er", "nn jj"],
  "sit": ["s-ih1-t", "vb vbp"],
  "sitcom": ["s-ih1-t k-aa-m", "nn"],
  "site": ["s-ay1-t", "nn"],
  "sitter": ["s-ih1 t-er", "nn"],
  "sitting": ["s-ih1 t-ih-ng", "vbg jj"],
  "situate": ["s-ih1-ch-uw-ey-t", "vb"],
  "situation": ["s-ih ch-uw ey1 sh-ah-n", "nn"],
  "six": ["s-ih1-k-s", "cd"],
  "sixth": ["s-ih1-k-s-th", "jj rb"],
  "sizable": ["s-ay1 z-ah b-ah-l", "jj"],
  "size": ["s-ay1-z", "nn vbp vb"],
  "sizeable": ["s-ay1 z-ah b-ah-l", "jj"],
  "sized": ["s-ay1-z-d", "vbd jj vbn"],
  "sizing": ["s-ay1 z-ih-ng", "nn"],
  "sizzle": ["s-ih1 z-ah-l", "nn vb"],
  "sizzling": ["s-ih1 z-ah-l ih-ng", "jj vbg"],
  "skate": ["s-k-ey1-t", "vb"],
  "skeet": ["s-k-iy1-t", "nn"],
  "skeletal": ["s-k-eh1 l-ah t-ah-l", "jj"],
  "skeleton": ["s-k-eh1 l-ah t-ah-n", "nn jj"],
  "skeptic": ["s-k-eh1-p t-ih-k", "nn"],
  "skeptical": ["s-k-eh1-p t-ah k-ah-l", "jj"],
  "skeptically": ["s-k-eh1-p t-ih k-ah l-iy", "rb"],
  "skepticism": ["s-k-eh1-p t-ih s-ih z-ah-m", "nn"],
  "sketch": ["s-k-eh1-ch", "nn vb"],
  "sketchbook": ["s-k-eh1-ch b-uh-k", "nn"],
  "sketchy": ["s-k-eh1 ch-iy", "jj"],
  "skew": ["s-k-y-uw1", "vb"],
  "skewed": ["s-k-y-uw1-d", "vbn vbd jj"],
  "skewer": ["s-k-y-uw1 er", "nn"],
  "ski": ["s-k-iy1", "nn jj vb vbp"],
  "skid": ["s-k-ih1-d", "vb"],
  "skier": ["s-k-ay1-r", "nn"],
  "skiff": ["s-k-ih1-f", "nn"],
  "skill": ["s-k-ih1-l", "nn vb"],
  "skilled": ["s-k-ih1-l-d", "jj vbn"],
  "skillet": ["s-k-ih1 l-ah-t", "nn"],
  "skillful": ["s-k-ih1-l f-ah-l", "jj"],
  "skillfully": ["s-k-ih1-l f-ah l-iy", "rb"],
  "skim": ["s-k-ih1-m", "vb vbp jj"],
  "skimmer": ["s-k-ih1 m-er", "nn"],
  "skimp": ["s-k-ih1-m-p", "vb"],
  "skimpy": ["s-k-ih1-m p-iy", "jj"],
  "skin": ["s-k-ih1-n", "nn"],
  "skinhead": ["s-k-ih1-n hh-eh-d", "nn"],
  "skinless": ["s-k-ih1-n l-ah-s", "jj"],
  "skinny": ["s-k-ih1 n-iy", "jj"],
  "skip": ["s-k-ih1-p", "vb vbp"],
  "skipper": ["s-k-ih1 p-er", "nn vb"],
  "skirmish": ["s-k-er1 m-ih-sh", "nn vb"],
  "skirt": ["s-k-er1-t", "nn vb vbp"],
  "skit": ["s-k-ih1-t", "nn"],
  "skittish": ["s-k-ih1 t-ih-sh", "jj"],
  "skittishness": ["s-k-ih1 t-ih-sh n-ah-s", "nn"],
  "skull": ["s-k-ah1-l", "nn"],
  "skunk": ["s-k-ah1-ng-k", "nn"],
  "sky": ["s-k-ay1", "nn"],
  "skylight": ["s-k-ay1 l-ay-t", "nn"],
  "skyline": ["s-k-ay1 l-ay-n", "nn"],
  "skyrocket": ["s-k-ay1 r-aa k-ah-t", "vb"],
  "skyscraper": ["s-k-ay1 s-k-r-ey p-er", "nn"],
  "skyward": ["s-k-ay1 w-er-d", "rb"],
  "skywave": ["s-k-ay1 w-ey-v", "nn"],
  "slab": ["s-l-ae1-b", "nn jj"],
  "slack": ["s-l-ae1-k", "jj vb nn"],
  "slacken": ["s-l-ae1 k-ah-n", "vb"],
  "slackened": ["s-l-ae1 k-ah-n-d", "vbd jj vbn"],
  "slag": ["s-l-ae1-g", "nn"],
  "slain": ["s-l-ey1-n", "vbn"],
  "slam": ["s-l-ae1-m", "nn vbp vb"],
  "slammer": ["s-l-ae1 m-er", "nn"],
  "slander": ["s-l-ae1-n d-er", "nn vb"],
  "slanderous": ["s-l-ae1-n d-er ah-s", "jj"],
  "slang": ["s-l-ae1-ng", "nn"],
  "slant": ["s-l-ae1-n-t", "nn vb"],
  "slanted": ["s-l-ae1-n t-ah-d", "vbn vbd jj"],
  "slanting": ["s-l-ae1-n t-ih-ng", "vbg jj"],
  "slap": ["s-l-ae1-p", "vb nn"],
  "slapping": ["s-l-ae1 p-ih-ng", "vbg jj nn"],
  "slapstick": ["s-l-ae1-p s-t-ih-k", "nn jj"],
  "slash": ["s-l-ae1-sh", "vb nn vbp"],
  "slasher": ["s-l-ae1 sh-er", "nn"],
  "slat": ["s-l-ae1-t", "nn"],
  "slate": ["s-l-ey1-t", "nn jj vb"],
  "slaughter": ["s-l-ao1 t-er", "nn vb vbp"],
  "slaughterhouse": ["s-l-ao1 t-er hh-aw-s", "nn"],
  "slave": ["s-l-ey1-v", "nn"],
  "slavery": ["s-l-ey1 v-er iy", "nn"],
  "slavish": ["s-l-ey1 v-ih-sh", "jj"],
  "slavishly": ["s-l-ae1 v-ih-sh l-iy", "rb"],
  "slay": ["s-l-ey1", "vb"],
  "slaying": ["s-l-ey1 ih-ng", "nn vbg"],
  "sleaze": ["s-l-iy1-z", "nn"],
  "sleazy": ["s-l-iy1 z-iy", "jj"],
  "sled": ["s-l-eh1-d", "vb"],
  "sleek": ["s-l-iy1-k", "jj"],
  "sleep": ["s-l-iy1-p", "vb nn vbp"],
  "sleeper": ["s-l-iy1 p-er", "nn"],
  "sleepily": ["s-l-iy1 p-ah l-iy", "rb"],
  "sleepless": ["s-l-iy1-p l-ah-s", "jj"],
  "sleepwalk": ["s-l-iy1-p-w-ao-k", "vb"],
  "sleepwalker": ["s-l-iy1-p w-ao k-er", "nn"],
  "sleepy": ["s-l-iy1 p-iy", "jj"],
  "sleet": ["s-l-iy1-t", "nn"],
  "sleeve": ["s-l-iy1-v", "nn"],
  "sleight": ["s-l-ay1-t", "nn"],
  "sleigh": ["s-l-ay1", "vb"],
  "slender": ["s-l-eh1-n d-er", "jj"],
  "slept": ["s-l-eh1-p-t", "vbd vbn"],
  "sleuth": ["s-l-uw1-th", "nn"],
  "sleuthing": ["s-l-uw1 th-ih-ng", "nn"],
  "slew": ["s-l-uw1", "nn"],
  "slice": ["s-l-ay1-s", "nn vb vbp"],
  "slick": ["s-l-ih1-k", "jj nn"],
  "slicker": ["s-l-ih1 k-er", "nn"],
  "slickly": ["s-l-ih1-k l-iy", "rb"],
  "slid": ["s-l-ih1-d", "vbd vbn"],
  "slide": ["s-l-ay1-d", "nn vbp vb"],
  "sliding": ["s-l-ay1 d-ih-ng", "vbg jj"],
  "slight": ["s-l-ay1-t", "jj vb vbp nn"],
  "slighted": ["s-l-ay1 t-ih-d", "jj vbn"],
  "slightest": ["s-l-ay1 t-ah-s-t", "jjs"],
  "slightly": ["s-l-ay1-t l-iy", "rb"],
  "slim": ["s-l-ih1-m", "jj vb"],
  "slime": ["s-l-ay1-m", "nn"],
  "slimmer": ["s-l-ih1 m-er", "rb"],
  "slimy": ["s-l-ay1 m-iy", "jj"],
  "sling": ["s-l-ih1-ng", "nn vb"],
  "slingshot": ["s-l-ih1-ng sh-aa-t", "nn"],
  "slinky": ["s-l-ih1-ng k-iy", "jj"],
  "slip": ["s-l-ih1-p", "vb nn vbp"],
  "slippage": ["s-l-ih1 p-ih-jh", "nn"],
  "slipper": ["s-l-ih1 p-er", "nn"],
  "slippery": ["s-l-ih1 p-er iy", "jj"],
  "slipshod": ["s-l-ih1-p sh-aa-d", "jj"],
  "slit": ["s-l-ih1-t", "nn vb"],
  "slither": ["s-l-ih1-dh-er", "vb"],
  "sliver": ["s-l-ih1 v-er", "nn"],
  "slob": ["s-l-aa1-b", "nn"],
  "slog": ["s-l-aa1-g", "vb"],
  "sloop": ["s-l-uw1-p", "nn"],
  "slop": ["s-l-aa1-p", "nn vb"],
  "slope": ["s-l-ow1-p", "nn"],
  "sloping": ["s-l-ow1 p-ih-ng", "vbg jj"],
  "sloppily": ["s-l-aa1 p-ah l-iy", "rb"],
  "sloppiness": ["s-l-aa1 p-iy n-ah-s", "nn"],
  "sloppy": ["s-l-aa1 p-iy", "jj"],
  "slosh": ["s-l-aa1-sh", "vb"],
  "slot": ["s-l-aa1-t", "nn"],
  "slotted": ["s-l-aa1 t-ih-d", "vbn"],
  "slouch": ["s-l-aw1-ch", "nn vb"],
  "slough": ["s-l-ah1-f", "vb"],
  "slovenliness": ["s-l-ah1 v-ah-n l-iy n-ah-s", "nn"],
  "slovenly": ["s-l-ah1 v-ah-n l-iy", "jj"],
  "slow": ["s-l-ow1", "jj vbp rb vb"],
  "slowdown": ["s-l-ow1 d-aw-n", "nn"],
  "slower": ["s-l-ow1 er", "jjr rbr"],
  "slowest": ["s-l-ow1 ah-s-t", "jjs"],
  "slowly": ["s-l-ow1 l-iy", "rb"],
  "slowness": ["s-l-ow1 n-ah-s", "nn"],
  "sludge": ["s-l-ah1-jh", "nn"],
  "slug": ["s-l-ah1-g", "nn vb"],
  "slugfest": ["s-l-ah1-g f-eh-s-t", "nn jjs"],
  "slugger": ["s-l-ah1 g-er", "nn"],
  "sluggish": ["s-l-ah1 g-ih-sh", "jj"],
  "sluggishly": ["s-l-ah1 g-ih-sh l-iy", "rb"],
  "sluggishness": ["s-l-ah1 g-ih-sh n-ah-s", "nn"],
  "sluice": ["s-l-uw1-s", "nn vb"],
  "slum": ["s-l-ah1-m", "nn"],
  "slumber": ["s-l-ah1-m b-er", "nn vb"],
  "slump": ["s-l-ah1-m-p", "nn vbp vb"],
  "slumping": ["s-l-ah1-m p-ih-ng", "vbg jj"],
  "slung": ["s-l-ah1-ng", "vbd vbn"],
  "slur": ["s-l-er1", "nn vb"],
  "slurry": ["s-l-er1 iy", "nn"],
  "slush": ["s-l-ah1-sh", "nn"],
  "sly": ["s-l-ay1", "jj"],
  "slyly": ["s-l-ay1 l-iy", "rb"],
  "slyness": ["s-l-ay1 n-ah-s", "nn"],
  "smack": ["s-m-ae1-k", "rb vb uh vbp"],
  "small": ["s-m-ao1-l", "jj"],
  "smaller": ["s-m-ao1 l-er", "jjr rbr"],
  "smallest": ["s-m-ao1 l-ah-s-t", "jjs"],
  "smallish": ["s-m-ao1 l-ih-sh", "jj"],
  "smallness": ["s-m-ao1-l n-ah-s", "nn"],
  "smallpox": ["s-m-ao1-l p-aa-k-s", "nn"],
  "smarmy": ["s-m-aa1-r m-iy", "jj"],
  "smart": ["s-m-aa1-r-t", "jj nn rb vb"],
  "smarter": ["s-m-aa1-r t-er", "rbr jjr rb"],
  "smartest": ["s-m-aa1-r t-ah-s-t", "jjs"],
  "smartly": ["s-m-aa1-r-t l-iy", "rb"],
  "smash": ["s-m-ae1-sh", "nn vb vbp"],
  "smashed": ["s-m-ae1-sh-t", "vbd jj vbn"],
  "smasher": ["s-m-ae1 sh-er", "nn"],
  "smashing": ["s-m-ae1 sh-ih-ng", "jj vbg"],
  "smattering": ["s-m-ae1 t-er ih-ng", "nn"],
  "smear": ["s-m-ih1-r", "nn vb"],
  "smeared": ["s-m-ih1-r-d", "vbn jj"],
  "smell": ["s-m-eh1-l", "nn vb vbp"],
  "smelly": ["s-m-eh1 l-iy", "jj"],
  "smelt": ["s-m-eh1-l-t", "vbd vbn"],
  "smelter": ["s-m-eh1-l t-er", "nn"],
  "smile": ["s-m-ay1-l", "nn vb vbp"],
  "smiling": ["s-m-ay1 l-ih-ng", "vbg jj nn"],
  "smilingly": ["s-m-ay1 l-ih-ng l-iy", "rb"],
  "smirk": ["s-m-er1-k", "nn vb"],
  "smithereens": ["s-m-ih dh-er iy1-n-z", "nn"],
  "smitten": ["s-m-ih1 t-ah-n", "vbn"],
  "smock": ["s-m-aa1-k", "nn"],
  "smog": ["s-m-aa1-g", "nn"],
  "smoggiest": ["s-m-aa1 g-iy ah-s-t", "jjs"],
  "smoke": ["s-m-ow1-k", "nn vb vbp"],
  "smoked": ["s-m-ow1-k-t", "vbd jj vbn"],
  "smokeless": ["s-m-ow1-k l-ah-s", "jj"],
  "smoker": ["s-m-ow1 k-er", "nn"],
  "smokescreen": ["s-m-ow1-k s-k-r-iy-n", "nn"],
  "smokestack": ["s-m-ow1-k s-t-ae-k", "nn"],
  "smoky": ["s-m-ow1 k-iy", "jj"],
  "smolder": ["s-m-ow1-l d-er", "vb vbp"],
  "smooth": ["s-m-uw1-dh", "jj vb"],
  "smoother": ["s-m-uw1 dh-er", "jj rb jjr"],
  "smoothest": ["s-m-uw1 dh-ah-s-t", "jjs"],
  "smoothly": ["s-m-uw1-dh l-iy", "rb"],
  "smoothness": ["s-m-uw1-dh n-ah-s", "nn"],
  "smorgasbord": ["s-m-ao1-r g-ah-s b-ao-r-d", "nn"],
  "smother": ["s-m-ah1 dh-er", "vb"],
  "smothered": ["s-m-ah1 dh-er-d", "vbd vbn jj"],
  "smudge": ["s-m-ah1-jh", "nn"],
  "smug": ["s-m-ah1-g", "jj"],
  "smuggle": ["s-m-ah1 g-ah-l", "vb"],
  "smuggler": ["s-m-ah1-g l-er", "nn"],
  "snack": ["s-n-ae1-k", "nn"],
  "snafu": ["s-n-ae1 f-uw", "nn"],
  "snag": ["s-n-ae1-g", "nn vb"],
  "snail": ["s-n-ey1-l", "nn"],
  "snake": ["s-n-ey1-k", "nn vb"],
  "snap": ["s-n-ae1-p", "vb vbp jj nn"],
  "snapdragon": ["s-n-ae1-p d-r-ae g-ah-n", "nn"],
  "snapped": ["s-n-ae1-p-t", "vbd vbn jj"],
  "snapper": ["s-n-ae1 p-er", "nn"],
  "snappy": ["s-n-ae1 p-iy", "jj"],
  "snapshot": ["s-n-ae1-p sh-aa-t", "nn"],
  "snare": ["s-n-eh1-r", "vb nn"],
  "snarl": ["s-n-aa1-r-l", "nn vb"],
  "snatch": ["s-n-ae1-ch", "vb vbp"],
  "snazzier": ["s-n-ae1 z-iy er", "jjr"],
  "snazzy": ["s-n-ae1 z-iy", "jj"],
  "sneak": ["s-n-iy1-k", "vb nn vbp"],
  "sneaker": ["s-n-iy1 k-er", "nn"],
  "sneaky": ["s-n-iy1 k-iy", "jj"],
  "sneer": ["s-n-ih1-r", "nn vb"],
  "sneeze": ["s-n-iy1-z", "vb"],
  "snicker": ["s-n-ih1-k-er", "vb"],
  "sniff": ["s-n-ih1-f", "vb"],
  "snip": ["s-n-ih1-p", "nn vb"],
  "snipe": ["s-n-ay1-p", "vb"],
  "sniped": ["s-n-ay1-p-t", "vbd nn"],
  "sniper": ["s-n-ay1 p-er", "nn"],
  "snippet": ["s-n-ih1 p-ah-t", "nn"],
  "snob": ["s-n-aa1-b", "nn"],
  "snobbery": ["s-n-aa1 b-er iy", "nn"],
  "snobbish": ["s-n-aa1 b-ih-sh", "jj"],
  "snooker": ["s-n-uh1 k-er", "nn"],
  "snoop": ["s-n-uw1-p", "vb"],
  "snooty": ["s-n-uw1 t-iy", "jj"],
  "snooze": ["s-n-uw1-z", "vb"],
  "snore": ["s-n-ao1-r", "vb"],
  "snort": ["s-n-ao1-r-t", "vb nn"],
  "snorting": ["s-n-ao1-r t-ih-ng", "nn"],
  "snout": ["s-n-aw1-t", "nn"],
  "snow": ["s-n-ow1", "nn vb"],
  "snowball": ["s-n-ow1 b-ao-l", "nn vb"],
  "snowbird": ["s-n-ow1 b-er-d", "nn"],
  "snowfall": ["s-n-ow1 f-aa-l", "nn"],
  "snowflake": ["s-n-ow1 f-l-ey-k", "nn"],
  "snowman": ["s-n-ow1 m-ae-n", "nn"],
  "snowstorm": ["s-n-ow1 s-t-ao-r-m", "nn"],
  "snowy": ["s-n-ow1 iy", "jj"],
  "snub": ["s-n-ah1-b", "vb"],
  "snuck": ["s-n-ah1-k", "vbd"],
  "snuff": ["s-n-ah1-f", "vb nn"],
  "snuffer": ["s-n-ah1 f-er", "nn"],
  "snug": ["s-n-ah1-g", "jj"],
  "snugly": ["s-n-ah1-g l-iy", "rb"],
  "so": ["s-ow1", "rb cc in"],
  "soak": ["s-ow1-k", "vb"],
  "soaked": ["s-ow1-k-t", "vbn jj vbd"],
  "soaking": ["s-ow1 k-ih-ng", "vbg jj"],
  "soap": ["s-ow1-p", "nn"],
  "soapbox": ["s-ow1-p b-aa-k-s", "nn"],
  "soapy": ["s-ow1 p-iy", "jj"],
  "soar": ["s-ao1-r", "vb vbp"],
  "soaring": ["s-ao1 r-ih-ng", "vbg jj"],
  "sob": ["s-aa1-b", "vb"],
  "sobbingly": ["s-aa1 b-ih-ng l-iy", "rb"],
  "sober": ["s-ow1 b-er", "jj vb"],
  "sobering": ["s-ow1 b-er ih-ng", "vbg jj"],
  "soberly": ["s-ow1 b-er l-iy", "rb"],
  "sobriety": ["s-ah b-r-ay1 ah t-iy", "nn"],
  "sobriquet": ["s-ow1 b-r-ah k-ey", "nn"],
  "socalled": ["s-ow1 k-aa1-l-d", "jj"],
  "soccer": ["s-aa1 k-er", "nn"],
  "sociable": ["s-ow1 sh-ah b-ah-l", "jj"],
  "social": ["s-ow1 sh-ah-l", "jj nn"],
  "socialism": ["s-ow1 sh-ah l-ih z-ah-m", "nn"],
  "socialist": ["s-ow1 sh-ah l-ah-s-t", "jj nn"],
  "socialistic": ["s-ow sh-ah l-ih1 s-t-ih-k", "jj"],
  "socialite": ["s-ow1 sh-ah l-ay-t", "nn"],
  "socialization": ["s-ow sh-ah l-ih z-ey1 sh-ah-n", "nn"],
  "socialize": ["s-ow1 sh-ah l-ay-z", "vb"],
  "socially": ["s-ow1 sh-ah l-iy", "rb"],
  "societal": ["s-ah s-ay1 ih t-ah-l", "jj"],
  "society": ["s-ah s-ay1 ah t-iy", "nn"],
  "socioeconomic": ["s-ow s-iy ow eh k-ah n-aa1 m-ih-k", "jj"],
  "sociological": ["s-ow s-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "sociologist": ["s-ow s-iy aa1 l-ah jh-ih-s-t", "nn"],
  "sociology": ["s-ow s-iy aa1 l-ah jh-iy", "nn"],
  "sociopath": ["s-ow1 s-iy ow p-ae-th", "nn"],
  "sock": ["s-aa1-k", "nn vb"],
  "socket": ["s-aa1 k-ah-t", "nn"],
  "sod": ["s-aa1-d", "nn"],
  "soda": ["s-ow1 d-ah", "nn"],
  "sodden": ["s-aa1 d-ah-n", "jj"],
  "sodium": ["s-ow1 d-iy ah-m", "nn"],
  "sodomy": ["s-aa1 d-ah m-iy", "nn"],
  "sofa": ["s-ow1 f-ah", "nn"],
  "soft": ["s-aa1-f-t", "jj rb"],
  "softball": ["s-ao1-f-t b-ao-l", "nn"],
  "softdrink": ["s-ao1-f-t d-r-ih-ng-k", "nn"],
  "soften": ["s-aa1 f-ah-n", "vb"],
  "softened": ["s-ao1 f-ah-n-d", "vbd vbn jj"],
  "softener": ["s-ao1 f-ah-n er", "nn"],
  "softening": ["s-ao1 f-ah-n ih-ng", "vbg jj"],
  "softer": ["s-aa1-f t-er", "jjr rb"],
  "softest": ["s-ao1-f t-ah-s-t", "jjs"],
  "softly": ["s-ao1-f-t l-iy", "rb"],
  "softness": ["s-ao1-f-t n-ah-s", "nn"],
  "software": ["s-ao1-f-t w-eh-r", "nn"],
  "softwood": ["s-ao1-f-t w-uh-d", "jj"],
  "soggy": ["s-aa1 g-iy", "jj"],
  "soil": ["s-oy1-l", "nn vb"],
  "soiled": ["s-oy1-l-d", "vbn jj vbd"],
  "sojourn": ["s-ow1 jh-er-n", "nn"],
  "solace": ["s-aa1 l-ah-s", "nn"],
  "solar": ["s-ow1 l-er", "jj"],
  "sold": ["s-ow1-l-d", "vbn vbd"],
  "solder": ["s-aa1 d-er", "jj vb"],
  "soldering": ["s-aa1 d-er ih-ng", "jj vbg"],
  "soldier": ["s-ow1-l jh-er", "nn"],
  "soldiering": ["s-ow1-l jh-er ih-ng", "nn"],
  "sole": ["s-ow1-l", "jj nn"],
  "solely": ["s-ow1-l l-iy", "rb"],
  "solemn": ["s-aa1 l-ah-m", "jj"],
  "solemnity": ["s-ah l-eh1-m n-ah t-iy", "nn"],
  "solemnly": ["s-ao1 l-ah-m l-iy", "rb"],
  "solicit": ["s-ah l-ih1 s-ih-t", "vb vbp"],
  "solicitation": ["s-ah l-ih s-ih t-ey1 sh-ah-n", "nn"],
  "solicited": ["s-ah l-ih1 s-ih t-ih-d", "vbd jj vbn"],
  "solicitor": ["s-ah l-ih1 s-ah t-er", "nn"],
  "solicitous": ["s-ah l-ih1 s-ah t-ah-s", "jj"],
  "solicitude": ["s-ah l-ih1 s-ih t-uw-d", "nn"],
  "solid": ["s-aa1 l-ah-d", "jj nn rb"],
  "solidarity": ["s-aa l-ah d-eh1 r-ah t-iy", "nn"],
  "solidify": ["s-ah l-ih1 d-ah f-ay", "vb vbp"],
  "solidity": ["s-ah l-ih1 d-ah t-iy", "nn"],
  "solidly": ["s-aa1 l-ah-d l-iy", "rb"],
  "solitary": ["s-aa1 l-ah t-eh r-iy", "jj nn"],
  "solitude": ["s-aa1 l-ah t-uw-d", "nn"],
  "solo": ["s-ow1 l-ow", "nn jj rb vb"],
  "soloist": ["s-ow1 l-ow ah-s-t", "nn"],
  "soluble": ["s-aa1 l-y-ah b-ah-l", "jj"],
  "solution": ["s-ah l-uw1 sh-ah-n", "nn"],
  "solvable": ["s-aa1-l v-ah b-ah-l", "jj"],
  "solve": ["s-aa1-l-v", "vb vbp"],
  "solvency": ["s-ao1-l v-ah-n s-iy", "nn"],
  "solvent": ["s-aa1-l v-ah-n-t", "jj nn"],
  "soma": ["s-ow1 m-ah", "nn"],
  "somber": ["s-aa1-m b-er", "jj"],
  "somberly": ["s-aa1-m b-er l-iy", "rb"],
  "some": ["s-ah1-m", "dt nn rb"],
  "somebody": ["s-ah1-m b-aa d-iy", "nn"],
  "someday": ["s-ah1-m d-ey", "rb"],
  "somehow": ["s-ah1-m hh-aw", "rb wrb"],
  "someone": ["s-ah1-m w-ah-n", "nn"],
  "someplace": ["s-ah1-m p-l-ey-s", "rb nn"],
  "somersault": ["s-ah1 m-er s-ao-l-t", "nn"],
  "somersaulting": ["s-ah1 m-er s-ao-l t-ih-ng", "jj nn"],
  "something": ["s-ah1-m th-ih-ng", "nn"],
  "sometime": ["s-ah1-m t-ay-m", "rb jj"],
  "sometimes": ["s-ah-m t-ay1-m-z", "rb"],
  "somewhat": ["s-ah1-m w-ah1-t", "rb"],
  "somewhere": ["s-ah1-m w-eh-r", "rb nn"],
  "somnolent": ["s-aa1-m n-ah l-ah-n-t", "jj"],
  "son": ["s-ah1-n", "nn"],
  "sonar": ["s-ow1 n-aa-r", "nn"],
  "sonata": ["s-ah n-aa1 t-ah", "nn"],
  "song": ["s-ao1-ng", "nn"],
  "songbird": ["s-ao1-ng b-er-d", "nn"],
  "songwriter": ["s-ao1-ng r-ay t-er", "nn"],
  "sonic": ["s-aa1 n-ih-k", "jj"],
  "sonnet": ["s-aa1 n-ih-t", "nn"],
  "sonny": ["s-ah1 n-iy", "nn"],
  "sonorous": ["s-aa1 n-er ah-s", "jj"],
  "soon": ["s-uw1-n", "rb"],
  "sooner": ["s-uw1 n-er", "rbr rb"],
  "soonest": ["s-uw1 n-ah-s-t", "jjs"],
  "soot": ["s-uh1-t", "nn"],
  "soothe": ["s-uw1-dh", "vb"],
  "soothing": ["s-uw1 dh-ih-ng", "vbg jj"],
  "soothingly": ["s-uw1 dh-ih-ng l-iy", "rb"],
  "soothsayer": ["s-uw-th s-ey1 er", "nn"],
  "sooty": ["s-uw1 t-iy", "jj"],
  "sop": ["s-aa1-p", "nn"],
  "sophisticate": ["s-ah f-ih1 s-t-ah k-ih-t", "nn"],
  "sophisticated": ["s-ah f-ih1 s-t-ah k-ey t-ih-d", "jj"],
  "sophistication": ["s-ah f-ih s-t-ah k-ey1 sh-ah-n", "nn"],
  "sophomore": ["s-aa1-f m-ao-r", "nn"],
  "sophomoric": ["s-aa f-ow m-aa1 r-ih-k", "jj"],
  "sopping": ["s-aa1 p-ih-ng", "jj vbg"],
  "soprano": ["s-ah p-r-aa1 n-ow", "nn jj"],
  "sorcery": ["s-ao1-r s-er iy", "nn"],
  "sordid": ["s-ao1-r d-ah-d", "jj"],
  "sore": ["s-ao1-r", "jj nn"],
  "sorely": ["s-ao1-r l-iy", "rb"],
  "sorghum": ["s-ao1-r g-ah-m", "nn"],
  "sorority": ["s-er ao1 r-ah t-iy", "nn"],
  "sorrel": ["s-ao1 r-ah-l", "jj nn"],
  "sorrow": ["s-aa1 r-ow", "nn"],
  "sorrowful": ["s-aa1 r-ow f-ah-l", "jj"],
  "sorry": ["s-aa1 r-iy", "jj rb uh"],
  "sort": ["s-ao1-r-t", "nn rb vb vbp"],
  "souffle": ["s-uw-f l-ey1", "nn"],
  "sought": ["s-ao1-t", "vbd vbn"],
  "souk": ["s-uw1-k", "nn"],
  "soul": ["s-ow1-l", "nn"],
  "soulful": ["s-ow1-l f-ah-l", "jj"],
  "soulless": ["s-ow1-l l-ah-s", "jj"],
  "sound": ["s-aw1-n-d", "nn jj rb vb vbp"],
  "sounder": ["s-aw1-n d-er", "jjr"],
  "sounding": ["s-aw1-n d-ih-ng", "vbg jj nn"],
  "soundly": ["s-aw1-n-d l-iy", "rb"],
  "soundness": ["s-aw1-n-d n-ah-s", "nn"],
  "soundtrack": ["s-aw1-n-d t-r-ae-k", "nn"],
  "soup": ["s-uw1-p", "nn vb"],
  "soupy": ["s-uw1 p-iy", "jj"],
  "sour": ["s-aw1 er", "jj vbp nn rb vb"],
  "source": ["s-ao1-r-s", "nn vb"],
  "soured": ["s-aw1 er-d", "vbd vbn jj"],
  "south": ["s-aw1-th", "rb jj nn"],
  "southbound": ["s-aw1-th b-aw-n-d", "jj"],
  "southeast": ["s-aw-th iy1-s-t", "rb jj nn"],
  "southeastern": ["s-aw-th iy1 s-t-er-n", "jj"],
  "southern": ["s-ah1 dh-er-n", "jj"],
  "southernmost": ["s-ah1 dh-er-n m-ow-s-t", "jj"],
  "southward": ["s-aw1-th w-er-d", "rb jj"],
  "southwest": ["s-aw-th w-eh1-s-t", "rb jj nn jjs"],
  "southwestern": ["s-aw-th w-eh1 s-t-er-n", "jj"],
  "souvenir": ["s-uw v-ah n-ih1-r", "nn"],
  "sovereign": ["s-aa1 v-r-ah-n", "jj nn"],
  "sovereignty": ["s-aa1 v-r-ah-n t-iy", "nn"],
  "soviet": ["s-ow1 v-iy ah-t", "jj"],
  "sow": ["s-aw1", "vbp nn vb"],
  "sown": ["s-ow1-n", "vbn"],
  "soy": ["s-oy1", "nn"],
  "soybean": ["s-oy1 b-iy-n", "nn"],
  "spa": ["s-p-aa1", "nn"],
  "space": ["s-p-ey1-s", "nn vb"],
  "spacecraft": ["s-p-ey1-s k-r-ae-f-t", "nn"],
  "spaced": ["s-p-ey1-s-t", "vbn jj"],
  "spacer": ["s-p-ey1 s-er", "nn"],
  "spaceship": ["s-p-ey1-s sh-ih-p", "nn"],
  "spacesuit": ["s-p-ey1-s uw-t", "nn"],
  "spacing": ["s-p-ey1 s-ih-ng", "nn jj"],
  "spacious": ["s-p-ey1 sh-ah-s", "jj"],
  "spade": ["s-p-ey1-d", "nn"],
  "spaghetti": ["s-p-ah g-eh1 t-iy", "nn"],
  "span": ["s-p-ae1-n", "nn vb vbp"],
  "spandex": ["s-p-ae1-n d-ah-k-s", "nn"],
  "spangle": ["s-p-ae1-ng g-ah-l", "nn"],
  "spaniel": ["s-p-ae1 n-y-ah-l", "nn"],
  "spanking": ["s-p-ae1-ng k-ih-ng", "jj nn"],
  "spanner": ["s-p-ae1 n-er", "nn"],
  "spare": ["s-p-eh1-r", "jj vb vbp"],
  "sparing": ["s-p-eh1 r-ih-ng", "vbg jj"],
  "sparingly": ["s-p-eh1 r-ih-ng l-iy", "rb"],
  "spark": ["s-p-aa1-r-k", "vb nn vbp"],
  "sparkle": ["s-p-aa1-r k-ah-l", "vb"],
  "sparkling": ["s-p-aa1-r k-l-ih-ng", "jj rb vbg"],
  "sparred": ["s-p-aa1-r-d", "vbd"],
  "sparrow": ["s-p-eh1 r-ow", "nn"],
  "sparse": ["s-p-aa1-r-s", "jj"],
  "sparsely": ["s-p-aa1-r-s l-iy", "rb"],
  "spasm": ["s-p-ae1 z-ah-m", "nn"],
  "spat": ["s-p-ae1-t", "vbd vbn nn"],
  "spate": ["s-p-ey1-t", "nn"],
  "spatial": ["s-p-ey1 sh-ah-l", "jj"],
  "spatter": ["s-p-ae1-t-er", "vb"],
  "spatula": ["s-p-ae1 ch-uh l-ah", "nn"],
  "spawn": ["s-p-aa1-n", "vb vbp"],
  "speak": ["s-p-iy1-k", "vb vbp"],
  "speaker": ["s-p-iy1 k-er", "nn"],
  "spear": ["s-p-ih1-r", "nn vb"],
  "spearhead": ["s-p-ih1-r hh-eh-d", "vb nn"],
  "spec": ["s-p-eh1-k", "nn"],
  "special": ["s-p-eh1 sh-ah-l", "jj nn"],
  "specialist": ["s-p-eh1 sh-ah l-ah-s-t", "nn jj"],
  "speciality": ["s-p-eh sh-iy ae1 l-ih t-iy", "nn"],
  "specialization": ["s-p-eh sh-ah l-ah z-ey1 sh-ah-n", "nn"],
  "specialize": ["s-p-eh1 sh-ah l-ay-z", "vb vbp"],
  "specialized": ["s-p-eh1 sh-ah l-ay-z-d", "jj vbd vbn"],
  "specially": ["s-p-eh1 sh-ah l-iy", "rb"],
  "specialty": ["s-p-eh1 sh-ah-l t-iy", "nn jj"],
  "species": ["s-p-iy1 sh-iy-z", "nn"],
  "specific": ["s-p-ah s-ih1 f-ih-k", "jj nn"],
  "specifically": ["s-p-ah s-ih1 f-ih-k l-iy", "rb"],
  "specification": ["s-p-eh s-ih f-ih k-ey1 sh-ah-n", "nn"],
  "specificity": ["s-p-eh s-ah f-ih1 s-ah t-iy", "nn"],
  "specified": ["s-p-eh1 s-ah f-ay-d", "vbn jj vbd"],
  "specify": ["s-p-eh1 s-ah f-ay", "vb vbp"],
  "specimen": ["s-p-eh1 s-ah m-ah-n", "nn"],
  "specious": ["s-p-iy1 sh-ah-s", "jj"],
  "speck": ["s-p-eh1-k", "nn"],
  "speckled": ["s-p-eh1 k-ah-l-d", "jj"],
  "spectacle": ["s-p-eh1-k t-ah k-ah-l", "nn"],
  "spectacular": ["s-p-eh-k t-ae1 k-y-ah l-er", "jj"],
  "spectacularly": ["s-p-eh-k t-ae1 k-y-ah l-er l-iy", "rb"],
  "spectator": ["s-p-eh1-k t-ey t-er", "nn"],
  "specter": ["s-p-eh1-k t-er", "nn"],
  "spectre": ["s-p-eh1-k t-er", "nn"],
  "spectrometer": ["s-p-eh-k t-r-aa1 m-ah t-er", "nn"],
  "spectroscopy": ["s-p-eh-k t-r-aa1 s-k-ah p-iy", "nn"],
  "spectrum": ["s-p-eh1-k t-r-ah-m", "nn"],
  "speculate": ["s-p-eh1 k-y-ah l-ey-t", "vb vbp"],
  "speculation": ["s-p-eh k-y-ah l-ey1 sh-ah-n", "nn"],
  "speculative": ["s-p-eh1 k-y-ah l-ah t-ih-v", "jj"],
  "speculator": ["s-p-eh1 k-y-ah l-ey t-er", "nn"],
  "sped": ["s-p-eh1-d", "vbd vbn"],
  "speech": ["s-p-iy1-ch", "nn"],
  "speechless": ["s-p-iy1-ch l-ah-s", "jj"],
  "speechwriter": ["s-p-iy1-ch r-ay t-er", "nn"],
  "speed": ["s-p-iy1-d", "nn vb"],
  "speedboat": ["s-p-iy1-d b-ow-t", "nn"],
  "speedier": ["s-p-iy1 d-iy er", "jjr jj"],
  "speedily": ["s-p-iy1 d-ah l-iy", "rb"],
  "speeding": ["s-p-iy1 d-ih-ng", "vbg jj nn"],
  "speedometer": ["s-p-iy d-aa1 m-ah t-er", "nn"],
  "speedup": ["s-p-iy1 d-ah-p", "nn"],
  "speedway": ["s-p-iy1-d w-ey", "nn"],
  "speedy": ["s-p-iy1 d-iy", "jj"],
  "spell": ["s-p-eh1-l", "vb nn vbp"],
  "spelt": ["s-p-eh1-l-t", "vbd vbn"],
  "spellbound": ["s-p-eh1-l b-aw-n-d", "vbn"],
  "spend": ["s-p-eh1-n-d", "vb vbp"],
  "spender": ["s-p-eh1-n d-er", "nn"],
  "spending": ["s-p-eh1-n d-ih-ng", "vbg jj"],
  "spent": ["s-p-eh1-n-t", "vbd jj vbn"],
  "sperm": ["s-p-er1-m", "nn"],
  "spew": ["s-p-y-uw1", "vb vbp"],
  "sphere": ["s-f-ih1-r", "nn"],
  "spherical": ["s-f-eh1 r-ih k-ah-l", "jj"],
  "spice": ["s-p-ay1-s", "nn vbp vb"],
  "spiced": ["s-p-ay1-s-t", "jj"],
  "spicy": ["s-p-ay1 s-iy", "jj"],
  "spider": ["s-p-ay1 d-er", "nn"],
  "spied": ["s-p-ay1-d", "vbd vbn"],
  "spiel": ["s-p-iy1-l", "nn"],
  "spiffing": ["s-p-ih1 f-ih-ng", "jj"],
  "spiffy": ["s-p-ih1 f-iy", "jj"],
  "spigot": ["s-p-ih1 g-ah-t", "nn"],
  "spike": ["s-p-ay1-k", "nn vb"],
  "spiked": ["s-p-ay1-k-t", "jj vbn"],
  "spill": ["s-p-ih1-l", "nn vb vbp"],
  "spilt": ["s-p-ih1-l-t", "vbd vbn"],
  "spillover": ["s-p-ih1-l ow v-er", "nn"],
  "spin": ["s-p-ih1-n", "vb nn"],
  "spinach": ["s-p-ih1 n-ah-ch", "nn"],
  "spinal": ["s-p-ay1 n-ah-l", "jj nn"],
  "spindle": ["s-p-ih1-n d-ah-l", "nn"],
  "spine": ["s-p-ay1-n", "nn"],
  "spineless": ["s-p-ay1-n l-ah-s", "jj"],
  "spinning": ["s-p-ih1 n-ih-ng", "vbg jj"],
  "spinoff": ["s-p-ih1-n ao-f", "nn jj"],
  "spinster": ["s-p-ih1-n s-t-er", "nn"],
  "spiral": ["s-p-ay1 r-ah-l", "nn vb"],
  "spiraling": ["s-p-ay1 r-ah-l ih-ng", "vbg jj"],
  "spire": ["s-p-ay1-r", "nn"],
  "spirit": ["s-p-ih1 r-ah-t", "nn vb"],
  "spirited": ["s-p-ih1 r-ah t-ah-d", "jj vbn"],
  "spiritual": ["s-p-ih1 r-ih ch-ah w-ah-l", "jj nn"],
  "spirituality": ["s-p-ih r-ih ch-ah-w ae1 l-ah t-iy", "nn"],
  "spiritually": ["s-p-ih1 r-ih ch-ah-w ah l-iy", "rb"],
  "spit": ["s-p-ih1-t", "vb nn vbd"],
  "spite": ["s-p-ay1-t", "nn vb"],
  "spittle": ["s-p-ih1 t-ah-l", "nn"],
  "splash": ["s-p-l-ae1-sh", "nn vb"],
  "splashy": ["s-p-l-ae1 sh-iy", "jj"],
  "splatter": ["s-p-l-ae1-t-er", "vb"],
  "spleen": ["s-p-l-iy1-n", "nn"],
  "splendid": ["s-p-l-eh1-n d-ah-d", "jj"],
  "splendidly": ["s-p-l-eh1-n d-ah-d l-iy", "rb"],
  "splendor": ["s-p-l-eh1-n d-er", "nn"],
  "splice": ["s-p-l-ay1-s", "nn vb"],
  "splint": ["s-p-l-ih1-n-t", "nn"],
  "splinter": ["s-p-l-ih1-n t-er", "nn vb vbp jj"],
  "splintered": ["s-p-l-ih1-n t-er-d", "jj vbd vbn"],
  "splintery": ["s-p-l-ih1-n t-er iy", "nn"],
  "split": ["s-p-l-ih1-t", "nn vbn jj vb vbd vbp"],
  "splitting": ["s-p-l-ih1 t-ih-ng", "vbg jj"],
  "splurge": ["s-p-l-er1-jh", "nn"],
  "spoil": ["s-p-oy1-l", "vb vbp"],
  "spoilage": ["s-p-oy1 l-ah-jh", "nn"],
  "spoiled": ["s-p-oy1-l-d", "vbn jj vbd"],
  "spoiler": ["s-p-oy1 l-er", "nn"],
  "spoke": ["s-p-ow1-k", "vbd nn"],
  "spoken": ["s-p-ow1 k-ah-n", "vbn jj"],
  "spokesman": ["s-p-ow1-k-s m-ah-n", "nn"],
  "spokesperson": ["s-p-ow1-k s-p-er s-ah-n", "nn"],
  "spokeswoman": ["s-p-ow1-k-s w-uh m-ah-n", "nn"],
  "sponge": ["s-p-ah1-n-jh", "nn vbp vb"],
  "spongy": ["s-p-ah1-n jh-iy", "jj"],
  "sponsor": ["s-p-aa1-n s-er", "nn vbp vb"],
  "sponsorship": ["s-p-aa1-n s-er sh-ih-p", "nn"],
  "spontaneity": ["s-p-aa-n t-ah n-iy1 ah t-iy", "nn"],
  "spontaneous": ["s-p-aa-n t-ey1 n-iy ah-s", "jj"],
  "spontaneously": ["s-p-aa-n t-ey1 n-iy ah-s l-iy", "rb"],
  "spoof": ["s-p-uw1-f", "nn vb"],
  "spook": ["s-p-uw1-k", "vb vbp"],
  "spooky": ["s-p-uw1 k-iy", "jj"],
  "spoon": ["s-p-uw1-n", "nn"],
  "spoonful": ["s-p-uw1-n f-uh-l", "nn"],
  "sporadic": ["s-p-er ae1 d-ih-k", "jj"],
  "sporadically": ["s-p-er ae1 d-ih-k l-iy", "rb"],
  "spore": ["s-p-ao1-r", "nn"],
  "sport": ["s-p-ao1-r-t", "nn vb"],
  "sporting": ["s-p-ao1-r t-ih-ng", "vbg jj nn"],
  "sportsman": ["s-p-ao1-r-t-s m-ah-n", "nn"],
  "sportsmanship": ["s-p-ao1-r-t-s m-ah-n sh-ih-p", "nn"],
  "sportswear": ["s-p-ao1-r-t s-w-eh-r", "nn"],
  "sportswriter": ["s-p-ao1-r-t-s r-ay t-er", "nn"],
  "sporty": ["s-p-ao1-r t-iy", "jj"],
  "spot": ["s-p-aa1-t", "nn jj vb vbp"],
  "spotless": ["s-p-aa1-t l-ah-s", "jj"],
  "spotlight": ["s-p-aa1-t l-ay-t", "nn vb"],
  "spotted": ["s-p-aa1 t-ah-d", "vbd vbn jj"],
  "spotty": ["s-p-aa1 t-iy", "jj"],
  "spousal": ["s-p-aw1 z-ah-l", "jj"],
  "spouse": ["s-p-aw1-s", "nn"],
  "spout": ["s-p-aw1-t", "nn vb vbp"],
  "spouted": ["s-p-aw1 t-ah-d", "vbd jj"],
  "sprain": ["s-p-r-ey1-n", "vb"],
  "sprang": ["s-p-r-ae1-ng", "vbd"],
  "sprawl": ["s-p-r-ao1-l", "nn vbp vb"],
  "sprawled": ["s-p-r-ao1-l-d", "vbn vbd jj"],
  "sprawling": ["s-p-r-ao1 l-ih-ng", "vbg jj"],
  "spray": ["s-p-r-ey1", "nn vb"],
  "spread": ["s-p-r-eh1-d", "nn vbd vbn vbp jj vb"],
  "spreader": ["s-p-r-eh1 d-er", "nn"],
  "spreadsheet": ["s-p-r-eh1-d sh-iy-t", "nn"],
  "spree": ["s-p-r-iy1", "nn"],
  "sprightly": ["s-p-r-ay1-t l-iy", "jj"],
  "spring": ["s-p-r-ih1-ng", "nn vb vbp"],
  "springboard": ["s-p-r-ih1-ng b-ao-r-d", "nn"],
  "springtime": ["s-p-r-ih1-ng t-ay-m", "nn"],
  "sprinkle": ["s-p-r-ih1-ng k-ah-l", "vb nn vbp"],
  "sprinkler": ["s-p-r-ih1-ng k-l-er", "nn"],
  "sprint": ["s-p-r-ih1-n-t", "nn vb"],
  "sprout": ["s-p-r-aw1-t", "vbp vb"],
  "spruce": ["s-p-r-uw1-s", "nn vb"],
  "sprung": ["s-p-r-ah1-ng", "vbd vbn"],
  "spud": ["s-p-ah1-d", "nn"],
  "spun": ["s-p-ah1-n", "vbn vbd"],
  "spunky": ["s-p-ah1-ng k-iy", "nn"],
  "spur": ["s-p-er1", "vb nn vbp"],
  "spurious": ["s-p-y-uh1 r-iy ah-s", "jj"],
  "spurn": ["s-p-er1-n", "vbp vb"],
  "spurned": ["s-p-er1-n-d", "vbn vbd jj"],
  "spurt": ["s-p-er1-t", "nn vb vbp"],
  "sputnik": ["s-p-ah1-t n-ih-k", "nn"],
  "sputter": ["s-p-ah1 t-er", "vb vbp"],
  "sputtering": ["s-p-ah1 t-er ih-ng", "jj"],
  "spy": ["s-p-ay1", "nn vb"],
  "spyglass": ["s-p-ay1 g-l-ae-s", "nn"],
  "squabble": ["s-k-w-aa1 b-ah-l", "nn vb"],
  "squad": ["s-k-w-aa1-d", "nn"],
  "squadron": ["s-k-w-aa1 d-r-ah-n", "nn"],
  "squalid": ["s-k-w-aa1 l-ah-d", "jj"],
  "squall": ["s-k-w-ao1-l", "nn"],
  "squalor": ["s-k-w-aa1 l-er", "nn"],
  "squander": ["s-k-w-aa1-n d-er", "vb"],
  "square": ["s-k-w-eh1-r", "nn jj rb vb vbp"],
  "squared": ["s-k-w-eh1-r-d", "jj vbd vbn"],
  "squarely": ["s-k-w-eh1-r l-iy", "rb"],
  "squash": ["s-k-w-aa1-sh", "nn vb"],
  "squashed": ["s-k-w-aa1-sh-t", "jj vbn"],
  "squashy": ["s-k-w-aa1 sh-iy", "jj"],
  "squat": ["s-k-w-aa1-t", "jj nn vb"],
  "squatter": ["s-k-w-aa1 t-er", "nn"],
  "squawk": ["s-k-w-ao1-k", "vb"],
  "squeak": ["s-k-w-iy1-k", "nn vb"],
  "squeaky": ["s-k-w-iy1 k-iy", "jj rb"],
  "squeal": ["s-k-w-iy1-l", "vb nn"],
  "squeamish": ["s-k-w-iy1 m-ih-sh", "jj"],
  "squeamishness": ["s-k-w-iy1 m-ih-sh n-ah-s", "nn"],
  "squeegee": ["s-k-w-iy1 jh-iy", "nn"],
  "squeeze": ["s-k-w-iy1-z", "nn vbp vb"],
  "squelch": ["s-k-w-eh1-l-ch", "vb vbp"],
  "squid": ["s-k-w-ih1-d", "nn"],
  "squint": ["s-k-w-ih1-n-t", "vb vbp"],
  "squire": ["s-k-w-ay1-r", "nn"],
  "squirm": ["s-k-w-er1-m", "vb"],
  "squirrel": ["s-k-w-er1 ah-l", "nn vb"],
  "squirt": ["s-k-w-er1-t", "nn vb"],
  "stab": ["s-t-ae1-b", "nn"],
  "stabbed": ["s-t-ae1-b-d", "vbd vbn"],
  "stability": ["s-t-ah b-ih1 l-ih t-iy", "nn"],
  "stabilization": ["s-t-ey b-ah l-ah z-ey1 sh-ah-n", "nn"],
  "stabilize": ["s-t-ey1 b-ah l-ay-z", "vb vbp"],
  "stabilizer": ["s-t-ey1 b-ah l-ay z-er", "nn"],
  "stable": ["s-t-ey1 b-ah-l", "jj nn"],
  "staccato": ["s-t-ah k-aa1 t-ow", "jj"],
  "stack": ["s-t-ae1-k", "nn vb"],
  "stacker": ["s-t-ae1 k-er", "nn"],
  "stadium": ["s-t-ey1 d-iy ah-m", "nn"],
  "staff": ["s-t-ae1-f", "nn vbp vb"],
  "staffer": ["s-t-ae1 f-er", "nn"],
  "staffing": ["s-t-ae1 f-ih-ng", "vbg jj nn"],
  "stag": ["s-t-ae1-g", "nn jj"],
  "stage": ["s-t-ey1-jh", "nn vbp vb"],
  "stagecoach": ["s-t-ey1-jh k-ow-ch", "nn"],
  "stager": ["s-t-ey1 jh-er", "nn"],
  "stagflation": ["s-t-ae-g f-l-ey1 sh-ah-n", "nn"],
  "stagger": ["s-t-ae1 g-er", "vb"],
  "staggered": ["s-t-ae1 g-er-d", "vbd jj vbn"],
  "staggering": ["s-t-ae1 g-er ih-ng", "jj vbg"],
  "stagnant": ["s-t-ae1-g n-ah-n-t", "jj"],
  "stagnate": ["s-t-ae1-g-n-ey-t", "vb"],
  "stagnation": ["s-t-ae-g n-ey1 sh-ah-n", "nn"],
  "staid": ["s-t-ey1-d", "jj vbn"],
  "stain": ["s-t-ey1-n", "nn vb"],
  "stained": ["s-t-ey1-n-d", "vbn jj vbd"],
  "stainless": ["s-t-ey1-n l-ah-s", "jj"],
  "stair": ["s-t-eh1-r", "nn"],
  "staircase": ["s-t-eh1-r k-ey-s", "nn"],
  "stairway": ["s-t-eh1-r w-ey", "nn"],
  "stake": ["s-t-ey1-k", "nn vb vbp"],
  "stale": ["s-t-ey1-l", "jj"],
  "stalemate": ["s-t-ey1-l m-ey-t", "nn"],
  "stalk": ["s-t-ao1-k", "vb vbp"],
  "stalked": ["s-t-ao1-k-t", "vbd vbn jj"],
  "stall": ["s-t-ao1-l", "nn vb"],
  "stalled": ["s-t-ao1-l-d", "vbn jj vbd"],
  "stallion": ["s-t-ae1 l-y-ah-n", "nn"],
  "stalwart": ["s-t-ao1-l w-er-t", "jj nn"],
  "stamina": ["s-t-ae1 m-ah n-ah", "nn"],
  "stamp": ["s-t-ae1-m-p", "nn vb"],
  "stampede": ["s-t-ae-m p-iy1-d", "nn vb vbp"],
  "stance": ["s-t-ae1-n-s", "nn"],
  "stanch": ["s-t-ae1-n-ch", "vb jj"],
  "stand": ["s-t-ae1-n-d", "vb nn vbp"],
  "standard": ["s-t-ae1-n d-er-d", "jj nn"],
  "standardize": ["s-t-ae1-n d-er d-ay-z", "vb"],
  "standardized": ["s-t-ae1-n d-er d-ay-z-d", "jj vbn"],
  "standby": ["s-t-ae1-n-d b-ay1", "jj nn"],
  "standing": ["s-t-ae1-n d-ih-ng", "vbg jj nn"],
  "standoff": ["s-t-ae1-n d-ao-f", "nn"],
  "standout": ["s-t-ae1-n-d aw-t", "nn"],
  "standpoint": ["s-t-ae1-n-d p-oy-n-t", "nn"],
  "standstill": ["s-t-ae1-n-d s-t-ih-l", "jj nn"],
  "standup": ["s-t-ae1-n-d ah-p", "jj nn"],
  "stank": ["s-t-ae1-n-k", "vbd"],
  "staple": ["s-t-ey1 p-ah-l", "nn jj"],
  "stapling": ["s-t-ey1 p-ah-l ih-ng", "nn"],
  "star": ["s-t-aa1-r", "nn jj vb"],
  "starboard": ["s-t-aa1-r b-er-d", "vb"],
  "starch": ["s-t-aa1-r-ch", "nn vb"],
  "starched": ["s-t-aa1-r-ch-t", "vbn jj"],
  "starchy": ["s-t-aa1-r ch-iy", "jj"],
  "stardom": ["s-t-aa1-r d-ah-m", "nn"],
  "stare": ["s-t-eh1-r", "vb vbp nn"],
  "stark": ["s-t-aa1-r-k", "jj rb"],
  "starker": ["s-t-aa1-r k-er", "jjr"],
  "starkly": ["s-t-aa1-r-k l-iy", "rb"],
  "starlet": ["s-t-aa1-r l-ah-t", "nn"],
  "starlight": ["s-t-aa1-r l-ay-t", "nn"],
  "starring": ["s-t-aa1 r-ih-ng", "vbg jj"],
  "start": ["s-t-aa1-r-t", "vb vbp nn rp"],
  "started": ["s-t-aa1-r t-ah-d", "vbd jj vbn"],
  "starter": ["s-t-aa1-r t-er", "nn jj"],
  "starting": ["s-t-aa1-r t-ih-ng", "vbg jj nn"],
  "startle": ["s-t-aa1-r t-ah-l", "vb"],
  "startled": ["s-t-aa1-r t-ah-l-d", "vbn vbd jj"],
  "startling": ["s-t-aa1-r-t l-ih-ng", "jj vbg"],
  "startlingly": ["s-t-aa1-r-t l-ih-ng l-iy", "rb"],
  "startup": ["s-t-aa1-r-t ah-p", "nn jj"],
  "starvation": ["s-t-aa-r v-ey1 sh-ah-n", "nn"],
  "starve": ["s-t-aa1-r-v", "vb"],
  "starving": ["s-t-aa1-r v-ih-ng", "vbg jj"],
  "stash": ["s-t-ae1-sh", "vb nn"],
  "stat": ["s-t-ae1-t", "nn"],
  "state": ["s-t-ey1-t", "nn jj vb vbp"],
  "stated": ["s-t-ey1 t-ah-d", "vbn jj vbd"],
  "statehood": ["s-t-ey1-t hh-uh-d", "nn"],
  "stateless": ["s-t-ey1-t l-ih-s", "jj"],
  "stately": ["s-t-ey1-t l-iy", "jj"],
  "statement": ["s-t-ey1-t m-ah-n-t", "nn"],
  "statesman": ["s-t-ey1-t-s m-ah-n", "nn"],
  "statesmanlike": ["s-t-ah t-eh1-s m-ah-n l-ay-k", "jj"],
  "statesmanship": ["s-t-ey1-t-s m-ah-n sh-ih-p", "nn"],
  "statewide": ["s-t-ey1-t w-ay-d", "jj rb"],
  "static": ["s-t-ae1 t-ih-k", "jj nn"],
  "station": ["s-t-ey1 sh-ah-n", "nn vb"],
  "stationary": ["s-t-ey1 sh-ah-n eh r-iy", "jj"],
  "stationery": ["s-t-ey1 sh-ah-n eh r-iy", "nn"],
  "statistic": ["s-t-ah t-ih1 s-t-ih-k", "nn"],
  "statistical": ["s-t-ah t-ih1 s-t-ih k-ah-l", "jj"],
  "statistically": ["s-t-ah t-ih1 s-t-ih k-ah l-iy", "rb"],
  "statistician": ["s-t-ae t-ah s-t-ih1 sh-ah-n", "nn"],
  "statuary": ["s-t-ae1 ch-uw eh r-iy", "nn"],
  "statue": ["s-t-ae1 ch-uw", "nn"],
  "stature": ["s-t-ae1 ch-er", "nn"],
  "status": ["s-t-ae1 t-ah-s", "nn"],
  "statute": ["s-t-ae1 ch-uw-t", "nn"],
  "statutory": ["s-t-ae1 ch-ah t-ao r-iy", "jj"],
  "staunch": ["s-t-ao1-n-ch", "jj vb"],
  "staunchest": ["s-t-ao1-n ch-ah-s-t", "jjs"],
  "staunchly": ["s-t-ao1-n-ch l-iy", "rb"],
  "stave": ["s-t-ey1-v", "vb"],
  "stay": ["s-t-ey1", "vb vbp nn"],
  "stayed": ["s-t-ey1-d", "vbd jj vbn"],
  "staying": ["s-t-ey1 ih-ng", "vbg jj nn"],
  "stead": ["s-t-eh1-d", "nn"],
  "steadfast": ["s-t-eh1-d f-ae-s-t", "jj rb"],
  "steadfastly": ["s-t-eh1-d f-ae-s-t l-iy", "rb"],
  "steadfastness": ["s-t-eh1-d f-ae-s-t n-ah-s", "nn"],
  "steadied": ["s-t-eh1 d-iy-d", "vbd vbn"],
  "steadier": ["s-t-eh1 d-iy er", "jjr"],
  "steadily": ["s-t-eh1 d-ah l-iy", "rb"],
  "steadiness": ["s-t-eh1 d-iy n-ih-s", "nn"],
  "steady": ["s-t-eh1 d-iy", "jj rb"],
  "steak": ["s-t-ey1-k", "nn"],
  "steakhouse": ["s-t-ey1-k hh-aw-s", "nn"],
  "steal": ["s-t-iy1-l", "vb vbp"],
  "stealing": ["s-t-iy1 l-ih-ng", "vbg jj"],
  "stealth": ["s-t-eh1-l-th", "nn"],
  "steam": ["s-t-iy1-m", "nn vb"],
  "steamboat": ["s-t-iy1-m b-ow-t", "nn"],
  "steamer": ["s-t-iy1 m-er", "nn"],
  "steamily": ["s-t-iy1 m-ah l-iy", "rb"],
  "steamroller": ["s-t-iy1-m r-ow l-er", "nn"],
  "steamship": ["s-t-iy1-m sh-ih-p", "nn"],
  "steed": ["s-t-iy1-d", "nn"],
  "steel": ["s-t-iy1-l", "nn jj"],
  "steelmaker": ["s-t-iy1-l m-ey k-er", "nn"],
  "steelmaking": ["s-t-iy1-l m-ey k-ih-ng", "nn"],
  "steelworker": ["s-t-iy1-l w-er k-er", "nn"],
  "steely": ["s-t-iy1 l-iy", "jj"],
  "steep": ["s-t-iy1-p", "jj nn vb"],
  "steeper": ["s-t-iy1 p-er", "jjr nn"],
  "steepest": ["s-t-iy1 p-ah-s-t", "jjs"],
  "steeply": ["s-t-iy1-p l-iy", "rb"],
  "steepness": ["s-t-iy1-p n-ah-s", "nn"],
  "steer": ["s-t-ih1-r", "vb nn vbp"],
  "steering": ["s-t-ih1 r-ih-ng", "nn jj vbg"],
  "stein": ["s-t-ay1-n", "nn"],
  "stellar": ["s-t-eh1 l-er", "jj"],
  "stem": ["s-t-eh1-m", "vb nn vbp"],
  "stench": ["s-t-eh1-n-ch", "nn"],
  "step": ["s-t-eh1-p", "nn vbp vb"],
  "stepchild": ["s-t-eh1-p ch-ay-l-d", "nn"],
  "stepchildren": ["s-t-eh1-p ch-ih1-l d-r-ah-n", "nn"],
  "stepladder": ["s-t-eh1-p l-ae d-er", "nn"],
  "stepmother": ["s-t-eh1-p m-ah dh-er", "nn"],
  "steppe": ["s-t-eh1-p", "nn"],
  "stepping": ["s-t-eh1 p-ih-ng", "vbg jj"],
  "stepson": ["s-t-eh1-p s-ah-n", "nn"],
  "stereo": ["s-t-eh1 r-iy ow", "nn jj"],
  "stereotype": ["s-t-eh1 r-iy ah t-ay-p", "nn vb"],
  "stereotyped": ["s-t-eh1 r-iy ah t-ay-p-t", "jj vbn"],
  "stereotypical": ["s-t-eh r-iy ow t-ih1 p-ih k-ah-l", "jj"],
  "sterile": ["s-t-eh1 r-ah-l", "jj"],
  "sterility": ["s-t-er ih1 l-ih t-iy", "nn"],
  "sterilization": ["s-t-eh r-ah l-ah z-ey1 sh-ah-n", "nn"],
  "sterilize": ["s-t-eh1 r-ah l-ay-z", "vb"],
  "sterilizer": ["s-t-eh1 r-ah l-ay z-er", "nn"],
  "sterling": ["s-t-er1 l-ih-ng", "nn jj"],
  "stern": ["s-t-er1-n", "jj nn"],
  "sternly": ["s-t-er1-n l-iy", "rb"],
  "steroid": ["s-t-er oy1-d", "jj"],
  "stethoscope": ["s-t-eh1 th-ah-s k-ow-p", "nn"],
  "stew": ["s-t-uw1", "nn vb"],
  "steward": ["s-t-uw1 er-d", "nn"],
  "stewardess": ["s-t-uw1 er d-ah-s", "nn"],
  "stewardship": ["s-t-uw1 er-d sh-ih-p", "nn"],
  "stewed": ["s-t-uw1-d", "jj vbd"],
  "stick": ["s-t-ih1-k", "vb vbp nn"],
  "sticker": ["s-t-ih1 k-er", "nn"],
  "stickier": ["s-t-ih1 k-iy er", "jjr"],
  "sticking": ["s-t-ih1 k-ih-ng", "vbg jj"],
  "stickler": ["s-t-ih1 k-ah l-er", "nn"],
  "sticky": ["s-t-ih1 k-iy", "jj"],
  "stiff": ["s-t-ih1-f", "jj vb"],
  "stiffen": ["s-t-ih1 f-ah-n", "vb"],
  "stiffening": ["s-t-ih1 f-ah-n ih-ng", "vbg jj"],
  "stiffer": ["s-t-ih1 f-er", "jjr"],
  "stiffest": ["s-t-ih1 f-ah-s-t", "jjs"],
  "stiffly": ["s-t-ih1-f l-iy", "rb nn"],
  "stiffness": ["s-t-ih1-f n-ah-s", "nn"],
  "stifle": ["s-t-ay1 f-ah-l", "vb"],
  "stifling": ["s-t-ay1 f-l-ih-ng", "vbg jj"],
  "stigma": ["s-t-ih1-g m-ah", "nn"],
  "stiletto": ["s-t-ah l-eh1 t-ow", "nn"],
  "still": ["s-t-ih1-l", "rb jj nn vb"],
  "stillness": ["s-t-ih1-l n-ah-s", "nn"],
  "stilt": ["s-t-ih1-l-t", "nn"],
  "stilted": ["s-t-ih1-l t-ih-d", "jj"],
  "stimulant": ["s-t-ih1 m-y-ah l-ah-n-t", "nn"],
  "stimulate": ["s-t-ih1 m-y-ah l-ey-t", "vb vbp"],
  "stimulating": ["s-t-ih1 m-y-ah l-ey t-ih-ng", "vbg jj"],
  "stimulation": ["s-t-ih m-y-ah l-ey1 sh-ah-n", "nn"],
  "stimulative": ["s-t-ih1 m-y-ah l-ey t-ih-v", "jj"],
  "stimulator": ["s-t-ih1 m-y-ah l-ey t-er", "nn"],
  "stimulus": ["s-t-ih1 m-y-ah l-ah-s", "nn"],
  "sting": ["s-t-ih1-ng", "nn vb"],
  "stingier": ["s-t-ih1-n jh-iy er", "jjr"],
  "stinging": ["s-t-ih1 ng-ih-ng", "jj vbg"],
  "stingy": ["s-t-ih1-n jh-iy", "jj"],
  "stink": ["s-t-ih1-ng-k", "nn vb vbp"],
  "stinking": ["s-t-ih1-ng k-ih-ng", "vbg jj"],
  "stint": ["s-t-ih1-n-t", "nn"],
  "stipend": ["s-t-ay1 p-ah-n-d", "nn"],
  "stipulate": ["s-t-ih1 p-y-ah l-ey-t", "vbp jj vb"],
  "stipulation": ["s-t-ih p-y-ah l-ey1 sh-ah-n", "nn"],
  "stir": ["s-t-er1", "vb vbp nn"],
  "stirling": ["s-t-er1 l-ih-ng", "jj"],
  "stirring": ["s-t-er1 ih-ng", "vbg jj nn"],
  "stirrup": ["s-t-er1 ah-p", "nn"],
  "stitch": ["s-t-ih1-ch", "nn vb"],
  "stitching": ["s-t-ih1 ch-ih-ng", "nn vbg"],
  "stock": ["s-t-aa1-k", "nn vbp jj vb"],
  "stockbroker": ["s-t-aa1-k b-r-ow k-er", "nn"],
  "stockholder": ["s-t-aa1-k hh-ow-l d-er", "nn"],
  "stockmarket": ["s-t-aa1-k m-aa-r k-ih-t", "nn"],
  "stockpile": ["s-t-aa1-k p-ay-l", "nn vb"],
  "stockpiling": ["s-t-aa1-k p-ay l-ih-ng", "nn"],
  "stockroom": ["s-t-aa1-k r-uw-m", "nn"],
  "stocky": ["s-t-aa1 k-iy", "jj"],
  "stockyard": ["s-t-aa1-k y-aa-r-d", "nn"],
  "stodgy": ["s-t-aa1 jh-iy", "jj"],
  "stoicism": ["s-t-ow1 ah s-ih z-ah-m", "nn"],
  "stoke": ["s-t-ow1-k", "vb"],
  "stoker": ["s-t-ow1 k-er", "nn"],
  "stole": ["s-t-ow1-l", "vbd"],
  "stolen": ["s-t-ow1 l-ah-n", "vbn jj"],
  "stolid": ["s-t-aa1 l-ah-d", "jj"],
  "stomach": ["s-t-ah1 m-ah-k", "nn vb"],
  "stomp": ["s-t-aa1-m-p", "vb"],
  "stone": ["s-t-ow1-n", "nn rb vb"],
  "stonewall": ["s-t-ow1-n-w-ao-l", "vb"],
  "stoneware": ["s-t-ow1-n w-eh-r", "nn"],
  "stony": ["s-t-ow1 n-iy", "jj"],
  "stood": ["s-t-uh1-d", "vbd vbn"],
  "stooge": ["s-t-uw1 jh-ih", "nn"],
  "stool": ["s-t-uw1-l", "nn"],
  "stoop": ["s-t-uw1-p", "vb nn vbp"],
  "stop": ["s-t-aa1-p", "vb nn vbp"],
  "stopgap": ["s-t-aa1-p g-ae-p", "nn jj"],
  "stopover": ["s-t-aa1-p ow v-er", "nn"],
  "stoppage": ["s-t-aa1 p-ih-jh", "nn"],
  "stopper": ["s-t-aa1 p-er", "nn"],
  "stopwatch": ["s-t-aa1-p w-aa-ch", "nn"],
  "storage": ["s-t-ao1 r-ah-jh", "nn jj"],
  "store": ["s-t-ao1-r", "nn vb vbp"],
  "storefront": ["s-t-ao1-r f-r-aa-n-t", "nn"],
  "storehouse": ["s-t-ao1-r hh-aw-s", "nn"],
  "storekeeper": ["s-t-ao1-r k-iy p-er", "nn"],
  "storeroom": ["s-t-ao1 r-r-uw-m", "nn"],
  "storied": ["s-t-ao1 r-iy-d", "jj"],
  "storm": ["s-t-ao1-r-m", "nn vb vbp"],
  "stormy": ["s-t-ao1-r m-iy", "jj"],
  "story": ["s-t-ao1 r-iy", "nn"],
  "storyline": ["s-t-ao1 r-iy l-ay-n", "nn"],
  "storyteller": ["s-t-ao1 r-iy t-eh l-er", "nn"],
  "storytelling": ["s-t-ao1 r-iy t-eh l-ih-ng", "nn"],
  "stout": ["s-t-aw1-t", "jj"],
  "stoutly": ["s-t-aw1-t l-iy", "rb"],
  "stove": ["s-t-ow1-v", "nn"],
  "stow": ["s-t-ow1", "vb"],
  "straddle": ["s-t-r-ae1 d-ah-l", "vb"],
  "straggle": ["s-t-r-ae1-g-ah-l", "vb"],
  "straggler": ["s-t-r-ae1 g-l-er", "nn"],
  "straight": ["s-t-r-ey1-t", "jj rb"],
  "straighten": ["s-t-r-ey1 t-ah-n", "vb"],
  "straighter": ["s-t-r-ey1 t-er", "jjr rbr"],
  "straightforward": ["s-t-r-ey1-t f-ao1-r w-er-d", "jj"],
  "strain": ["s-t-r-ey1-n", "nn vb vbp"],
  "strained": ["s-t-r-ey1-n-d", "vbd jj vbn"],
  "strait": ["s-t-r-ey1-t", "nn"],
  "straitjacket": ["s-t-r-ey1-t jh-ae k-ah-t", "nn"],
  "strand": ["s-t-r-ae1-n-d", "nn vb"],
  "strange": ["s-t-r-ey1-n-jh", "jj"],
  "strangely": ["s-t-r-ey1-n-jh l-iy", "rb"],
  "strangeness": ["s-t-r-ey1-n-jh n-ah-s", "nn"],
  "stranger": ["s-t-r-ey1-n jh-er", "nn jjr"],
  "strangest": ["s-t-r-ey1-n jh-ih-s-t", "jjs"],
  "strangle": ["s-t-r-ae1-ng-g-ah-l", "vb"],
  "strangled": ["s-t-r-ae1-ng g-ah-l-d", "vbn jj"],
  "stranglehold": ["s-t-r-ae1-ng g-ah-l hh-ow-l-d", "nn"],
  "strangulation": ["s-t-r-ae-ng g-y-ah l-ey1 sh-ah-n", "nn"],
  "strap": ["s-t-r-ae1-p", "vb jj"],
  "strapped": ["s-t-r-ae1-p-t", "vbn vbd jj"],
  "strapping": ["s-t-r-ae1 p-ih-ng", "jj vbg"],
  "stratagem": ["s-t-r-ae1 t-ah jh-ah-m", "nn"],
  "strategic": ["s-t-r-ah t-iy1 jh-ih-k", "jj"],
  "strategically": ["s-t-r-ah t-iy1 jh-ih-k l-iy", "rb"],
  "strategist": ["s-t-r-ae1 t-ih jh-ih-s-t", "nn"],
  "strategy": ["s-t-r-ae1 t-ah jh-iy", "nn"],
  "stratified": ["s-t-r-ae1 t-ah f-ay-d", "jj vbn"],
  "stratify": ["s-t-r-ae1-t-ah-f-ay", "vb"],
  "stratosphere": ["s-t-r-ae1 t-ah s-f-ih-r", "nn"],
  "stratospheric": ["s-t-r-ae t-ah s-f-ih1 r-ih-k", "jj"],
  "stratum": ["s-t-r-ae1 t-ah-m", "nn"],
  "straw": ["s-t-r-ao1", "nn jj"],
  "strawberry": ["s-t-r-ao1 b-eh r-iy", "nn"],
  "stray": ["s-t-r-ey1", "jj nn vb vbp"],
  "streak": ["s-t-r-iy1-k", "nn vb vbp"],
  "stream": ["s-t-r-iy1-m", "nn vb"],
  "streamer": ["s-t-r-iy1 m-er", "nn"],
  "streamline": ["s-t-r-iy1-m l-ay-n", "vb"],
  "streamlined": ["s-t-r-iy1-m l-ay-n-d", "jj vbd vbn"],
  "street": ["s-t-r-iy1-t", "nn"],
  "streetcar": ["s-t-r-iy1-t k-aa-r", "nn"],
  "strength": ["s-t-r-eh1-ng-k-th", "nn"],
  "strengthen": ["s-t-r-eh1-ng th-ah-n", "vb vbp"],
  "strengthened": ["s-t-r-eh1-ng th-ah-n-d", "vbn jj vbd"],
  "strenuous": ["s-t-r-eh1 n-y-uw ah-s", "jj"],
  "strenuously": ["s-t-r-eh1 n-y-uw ah-s l-iy", "rb"],
  "stress": ["s-t-r-eh1-s", "nn vbp vb"],
  "stressed": ["s-t-r-eh1-s-t", "vbd jj vbn"],
  "stressful": ["s-t-r-eh1-s f-ah-l", "jj"],
  "stretch": ["s-t-r-eh1-ch", "nn vbp jj vb"],
  "stretched": ["s-t-r-eh1-ch-t", "vbd jj vbn"],
  "stretcher": ["s-t-r-eh1 ch-er", "nn"],
  "strewn": ["s-t-r-uw1-n", "vbn"],
  "stricken": ["s-t-r-ih1 k-ah-n", "vbn jj"],
  "strict": ["s-t-r-ih1-k-t", "jj"],
  "stricter": ["s-t-r-ih1-k t-er", "jjr"],
  "strictest": ["s-t-r-ih1-k t-ah-s-t", "jjs"],
  "strictly": ["s-t-r-ih1-k-t l-iy", "rb"],
  "stricture": ["s-t-r-ih1-k ch-er", "nn"],
  "stride": ["s-t-r-ay1-d", "nn vbp vb"],
  "strident": ["s-t-r-ay1 d-ah-n-t", "jj"],
  "stridently": ["s-t-r-ay1 d-ah-n-t l-iy", "rb"],
  "strife": ["s-t-r-ay1-f", "nn"],
  "strike": ["s-t-r-ay1-k", "nn vb vbp"],
  "strikebreaker": ["s-t-r-ay1-k b-r-ey k-er", "nn"],
  "strikeout": ["s-t-r-ay1-k aw-t", "nn"],
  "striker": ["s-t-r-ay1 k-er", "nn"],
  "striking": ["s-t-r-ay1 k-ih-ng", "jj vbg"],
  "strikingly": ["s-t-r-ay1 k-ih-ng l-iy", "rb"],
  "string": ["s-t-r-ih1-ng", "nn vb"],
  "stringed": ["s-t-r-ih1-ng-d", "jj"],
  "stringent": ["s-t-r-ih1-n jh-ah-n-t", "jj"],
  "stringently": ["s-t-r-ih1-n jh-ah-n-t l-iy", "rb"],
  "stringy": ["s-t-r-ih1 ng-iy", "jj"],
  "strip": ["s-t-r-ih1-p", "nn vb vbp"],
  "stripe": ["s-t-r-ay1-p", "nn"],
  "striped": ["s-t-r-ay1-p-t", "jj"],
  "stripped": ["s-t-r-ih1-p-t", "vbn jj vbd"],
  "stripper": ["s-t-r-ih1 p-er", "nn"],
  "striptease": ["s-t-r-ih1-p t-iy-z", "nn"],
  "strive": ["s-t-r-ay1-v", "vb vbp"],
  "strobe": ["s-t-r-ow1-b", "nn"],
  "strode": ["s-t-r-ow1-d", "vbd"],
  "stroke": ["s-t-r-ow1-k", "nn vb"],
  "stroll": ["s-t-r-ow1-l", "nn vb vbp"],
  "stroller": ["s-t-r-ow1 l-er", "nn"],
  "strong": ["s-t-r-ao1-ng", "jj rb"],
  "stronger": ["s-t-r-ao1-ng er", "jjr rbr"],
  "strongest": ["s-t-r-ao1-ng g-ah-s-t", "jjs"],
  "stronghold": ["s-t-r-ao1-ng hh-ow-l-d", "nn"],
  "strongly": ["s-t-r-ao1-ng l-iy", "rb"],
  "strongman": ["s-t-r-ao1-ng m-ae-n", "nn"],
  "strove": ["s-t-r-ow1-v", "vbd"],
  "struck": ["s-t-r-ah1-k", "vbd vbn"],
  "structural": ["s-t-r-ah1-k ch-er ah-l", "jj"],
  "structurally": ["s-t-r-ah1-k ch-er ah l-iy", "rb"],
  "structure": ["s-t-r-ah1-k ch-er", "nn vb"],
  "structured": ["s-t-r-ah1-k ch-er-d", "vbn jj vbd"],
  "struggle": ["s-t-r-ah1 g-ah-l", "nn vbp vb"],
  "struggling": ["s-t-r-ah1 g-ah l-ih-ng", "vbg jj"],
  "strung": ["s-t-r-ah1-ng", "vbn vbd"],
  "strut": ["s-t-r-ah1-t", "nn"],
  "strutting": ["s-t-r-ah1 t-ih-ng", "vbg jj"],
  "strychnine": ["s-t-r-ih1-k n-ay-n", "nn"],
  "stub": ["s-t-ah1-b", "nn vb"],
  "stubble": ["s-t-ah1 b-ah-l", "jj nn"],
  "stubborn": ["s-t-ah1 b-er-n", "jj"],
  "stubbornly": ["s-t-ah1 b-er-n l-iy", "rb"],
  "stubbornness": ["s-t-ah1 b-er-n n-ah-s", "nn"],
  "stubby": ["s-t-ah1 b-iy", "jj"],
  "stucco": ["s-t-ah1 k-ow", "nn"],
  "stuck": ["s-t-ah1-k", "vbn vbd jj"],
  "stud": ["s-t-ah1-d", "nn"],
  "studded": ["s-t-ah1 d-ih-d", "vbn"],
  "student": ["s-t-uw1 d-ah-n-t", "nn"],
  "studied": ["s-t-ah1 d-iy-d", "vbn vbd jj"],
  "studio": ["s-t-uw1 d-iy ow", "nn"],
  "studious": ["s-t-uw1 d-iy ah-s", "jj"],
  "studiously": ["s-t-uw1 d-iy ah-s l-iy", "rb"],
  "study": ["s-t-ah1 d-iy", "nn vbp vb"],
  "stuff": ["s-t-ah1-f", "nn vb vbp"],
  "stuffed": ["s-t-ah1-f-t", "vbn jj vbd"],
  "stuffy": ["s-t-ah1 f-iy", "jj"],
  "stultifying": ["s-t-ah1-l t-ah f-ay ih-ng", "jj"],
  "stumble": ["s-t-ah1-m b-ah-l", "vb vbp nn"],
  "stumbling": ["s-t-ah1-m b-ah-l ih-ng", "vbg jj nn"],
  "stump": ["s-t-ah1-m-p", "nn vb"],
  "stumpage": ["s-t-ah1-m p-ih-jh", "nn"],
  "stumping": ["s-t-ah1-m p-ih-ng", "nn"],
  "stun": ["s-t-ah1-n", "vb"],
  "stung": ["s-t-ah1-ng", "vbn vbd"],
  "stunk": ["s-t-ah1-ng-k", "vbd vbn"],
  "stunned": ["s-t-ah1-n-d", "vbd vbn jj"],
  "stunning": ["s-t-ah1 n-ih-ng", "jj"],
  "stunningly": ["s-t-ah1 n-ih-ng l-iy", "rb"],
  "stunt": ["s-t-ah1-n-t", "nn vb"],
  "stupendous": ["s-t-uw p-eh1-n d-ah-s", "jj"],
  "stupid": ["s-t-uw1 p-ah-d", "jj"],
  "stupidest": ["s-t-uw1 p-ih d-ah-s-t", "jjs"],
  "stupidity": ["s-t-uw p-ih1 d-ih t-iy", "nn"],
  "stupor": ["s-t-uw1 p-er", "nn"],
  "sturdy": ["s-t-er1 d-iy", "jj"],
  "sturgeon": ["s-t-er1 jh-ah-n", "nn"],
  "stutter": ["s-t-ah1 t-er", "nn"],
  "style": ["s-t-ay1-l", "nn vb"],
  "styling": ["s-t-ay1 l-ih-ng", "nn"],
  "stylish": ["s-t-ay1 l-ih-sh", "jj"],
  "stylishly": ["s-t-ay1 l-ih-sh l-iy", "rb"],
  "stylist": ["s-t-ay1 l-ih-s-t", "nn"],
  "stylistic": ["s-t-ay l-ih1 s-t-ih-k", "jj"],
  "stylistically": ["s-t-ay l-ih1 s-t-ih-k l-iy", "rb"],
  "stylize": ["s-t-ay1-l-ay-z", "vb"],
  "stylized": ["s-t-ay1 l-ay-z-d", "jj vbn"],
  "stymie": ["s-t-ay1 m-iy", "vb"],
  "stymied": ["s-t-ay1 m-iy-d", "vbn jj"],
  "styrene": ["s-t-ay1 r-iy-n", "nn"],
  "suave": ["s-w-aa1-v", "jj"],
  "sub": ["s-ah1-b", "nn"],
  "subatomic": ["s-ah-b ah t-aa1 m-ih-k", "jj"],
  "subcommittee": ["s-ah1-b k-ah m-ih1 t-iy", "nn"],
  "subcompact": ["s-ah-b k-aa1-m p-ae-k-t", "nn jj"],
  "subconscious": ["s-ah-b k-aa1-n sh-ah-s", "jj nn"],
  "subconsciously": ["s-ah-b k-aa1-n sh-ah-s l-iy", "rb"],
  "subcontinent": ["s-ah-b k-aa1-n t-ih n-ah-n-t", "nn"],
  "subcontract": ["s-ah-b k-aa1-n t-r-ae-k-t", "vb nn"],
  "subcontractor": ["s-ah-b k-aa1-n t-r-ae-k t-er", "nn"],
  "subdivision": ["s-ah1-b d-ih v-ih zh-ah-n", "nn"],
  "subdue": ["s-ah-b d-uw1", "vb"],
  "subdued": ["s-ah-b d-uw1-d", "vbn jj vbd"],
  "subgroup": ["s-ah1-b g-r-uw-p", "nn"],
  "subject": ["s-ah-b jh-eh1-k-t", "nn jj vb"],
  "subjective": ["s-ah-b jh-eh1-k t-ih-v", "jj"],
  "subjugate": ["s-ah1-b jh-ah g-ey-t", "vb"],
  "subjugated": ["s-ah1-b jh-ah g-ey t-ih-d", "jj"],
  "sublease": ["s-ah1-b l-iy-s", "nn"],
  "sublet": ["s-ah1 b-l-eh-t", "vb vbn"],
  "sublime": ["s-ah b-l-ay1-m", "jj nn"],
  "subliminal": ["s-ah-b l-ih1 m-ih n-ah-l", "jj"],
  "submachine": ["s-ah-b m-ah sh-iy1-n", "jj"],
  "submarine": ["s-ah1-b m-er iy-n", "nn jj"],
  "submerge": ["s-ah-b m-er1-jh", "vb"],
  "submerged": ["s-ah-b m-er1-jh-d", "vbn jj"],
  "submission": ["s-ah-b m-ih1 sh-ah-n", "nn"],
  "submissive": ["s-ah-b m-ih1 s-ih-v", "jj"],
  "submit": ["s-ah-b m-ih1-t", "vb vbp"],
  "subordinate": ["s-ah b-ao1-r d-ah n-ey-t", "jj nn vb"],
  "subordinated": ["s-ah b-ao1-r d-ah n-ey t-ih-d", "vbn jj vbd"],
  "subpar": ["s-ah-b p-aa1-r", "jj"],
  "subplot": ["s-ah1-b p-l-aa-t", "nn"],
  "subpoena": ["s-ah p-iy1 n-ah", "nn vb"],
  "subscribe": ["s-ah-b s-k-r-ay1-b", "vb vbp"],
  "subscribed": ["s-ah-b s-k-r-ay1-b-d", "vbn vbd jj"],
  "subscriber": ["s-ah-b s-k-r-ay1 b-er", "nn"],
  "subscription": ["s-ah-b s-k-r-ih1-p sh-ah-n", "nn jj"],
  "subsequent": ["s-ah1-b s-ah k-w-ah-n-t", "jj"],
  "subsequently": ["s-ah1-b s-ah k-w-ah-n-t l-iy", "rb"],
  "subservience": ["s-ah-b s-er1 v-iy ah-n-s", "nn"],
  "subservient": ["s-ah-b s-er1 v-iy ah-n-t", "jj"],
  "subset": ["s-ah1-b s-eh-t", "nn"],
  "subside": ["s-ah-b s-ay1-d", "vb vbp"],
  "subsidence": ["s-ah-b s-ay1 d-ah-n-s", "nn"],
  "subsidiary": ["s-ah-b s-ih1 d-iy eh r-iy", "nn jj"],
  "subsidization": ["s-ah-b s-ih d-ih z-ey1 sh-ah-n", "nn"],
  "subsidize": ["s-ah1-b s-ih d-ay-z", "vb vbp"],
  "subsidized": ["s-ah1-b s-ih d-ay-z-d", "jj vbn"],
  "subsidy": ["s-ah1-b s-ih d-iy", "nn"],
  "subsist": ["s-ah-b s-ih1-s-t", "vb"],
  "subsistence": ["s-ah-b s-ih1 s-t-ah-n-s", "nn"],
  "subsoil": ["s-ah1-b s-oy-l", "nn"],
  "substance": ["s-ah1-b s-t-ah-n-s", "nn"],
  "substandard": ["s-ah-b s-t-ae1-n d-er-d", "jj"],
  "substantial": ["s-ah-b s-t-ae1-n ch-ah-l", "jj"],
  "substantially": ["s-ah-b s-t-ae1-n sh-ah l-iy", "rb"],
  "substantiate": ["s-ah-b s-t-ae1-n ch-iy ey-t", "vb"],
  "substantiated": ["s-ah-b s-t-ae1-n sh-iy ey t-ih-d", "jj"],
  "substantiation": ["s-ah-b s-t-ae-n ch-iy ey1 sh-ah-n", "nn"],
  "substantive": ["s-ah1-b s-t-ah-n t-ih-v", "jj nn"],
  "substantively": ["s-ah1-b s-t-ah-n t-ih-v l-iy", "rb"],
  "substitute": ["s-ah1-b s-t-ah t-uw-t", "nn jj vb vbp"],
  "substituted": ["s-ah1-b s-t-ah t-uw t-ah-d", "vbn jj vbd"],
  "substitution": ["s-ah-b s-t-ih t-uw1 sh-ah-n", "nn"],
  "substrate": ["s-ah1-b s-t-r-ey-t", "nn"],
  "subsurface": ["s-ah1-b s-er f-ah-s", "jj"],
  "subsystem": ["s-ah1-b s-ih s-t-ah-m", "nn"],
  "subterfuge": ["s-ah1-b t-er f-y-uw-jh", "nn"],
  "subterranean": ["s-ah-b t-er ey1 n-iy ah-n", "jj"],
  "subtitle": ["s-ah1-b t-ay t-ah-l", "nn vb"],
  "subtle": ["s-ah1 t-ah-l", "jj"],
  "subtler": ["s-ah1 t-ah-l er", "jjr nn"],
  "subtlety": ["s-ah1 t-ah-l t-iy", "nn"],
  "subtly": ["s-ah1 t-ah l-iy", "rb"],
  "subtract": ["s-ah-b t-r-ae1-k-t", "vb vbp"],
  "subtraction": ["s-ah-b t-r-ae1-k sh-ah-n", "nn"],
  "suburb": ["s-ah1 b-er-b", "nn"],
  "suburban": ["s-ah b-er1 b-ah-n", "jj"],
  "suburbanite": ["s-ah b-er1 b-ah n-ay-t", "jj nn"],
  "suburbia": ["s-ah b-er1 b-iy ah", "nn"],
  "subversion": ["s-ah-b v-er1 zh-ah-n", "nn"],
  "subversive": ["s-ah-b v-er1 s-ih-v", "jj"],
  "subvert": ["s-ah-b v-er1-t", "vb vbp"],
  "subway": ["s-ah1-b w-ey", "nn"],
  "subzero": ["s-ah-b z-ih1 r-ow", "jj"],
  "succeed": ["s-ah-k s-iy1-d", "vb vbp"],
  "success": ["s-ah-k s-eh1-s", "nn"],
  "successful": ["s-ah-k s-eh1-s f-ah-l", "jj"],
  "successfully": ["s-ah-k s-eh1-s f-ah l-iy", "rb"],
  "succession": ["s-ah-k s-eh1 sh-ah-n", "nn"],
  "successive": ["s-ah-k s-eh1 s-ih-v", "jj"],
  "successively": ["s-ah-k s-eh1 s-ih-v l-iy", "rb"],
  "successor": ["s-ah-k s-eh1 s-er", "nn"],
  "succinct": ["s-ah-k s-ih1-ng-k-t", "jj"],
  "succinctly": ["s-ah-k s-ih1-ng-k-t l-iy", "rb"],
  "succor": ["s-ah1 k-er", "nn"],
  "succulent": ["s-ah1 k-y-ah l-ih-n-t", "jj"],
  "succumb": ["s-ah k-ah1-m", "vb"],
  "such": ["s-ah1-ch", "jj pdt dt"],
  "suck": ["s-ah1-k", "vb nn vbp"],
  "sucker": ["s-ah1 k-er", "nn vb"],
  "suction": ["s-ah1-k sh-ah-n", "nn"],
  "sudden": ["s-ah1 d-ah-n", "jj"],
  "suddenly": ["s-ah1 d-ah-n l-iy", "rb"],
  "suddenness": ["s-ah1 d-ah-n n-ah-s", "nn"],
  "suds": ["s-ah1-d-z", "nn"],
  "sue": ["s-uw1", "vb vbp"],
  "suede": ["s-w-ey1-d", "nn"],
  "suey": ["s-uw1 iy", "nn"],
  "suffer": ["s-ah1 f-er", "vb vbp"],
  "sufferer": ["s-ah1 f-er er", "nn"],
  "suffering": ["s-ah1 f-er ih-ng", "vbg jj nn"],
  "suffice": ["s-ah f-ay1-s", "vb vbp"],
  "sufficiency": ["s-ah f-ih1 sh-ah-n s-iy", "nn"],
  "sufficient": ["s-ah f-ih1 sh-ah-n-t", "jj"],
  "sufficiently": ["s-ah f-ih1 sh-ah-n-t l-iy", "rb"],
  "suffix": ["s-ah1 f-ih-k-s", "nn"],
  "suffocate": ["s-ah1 f-ah k-ey-t", "vb"],
  "suffocating": ["s-ah1 f-ah k-ey t-ih-ng", "vbg jj"],
  "suffocation": ["s-ah f-ah k-ey1 sh-ah-n", "nn"],
  "suffrage": ["s-ah1 f-r-ih-jh", "nn"],
  "suffragette": ["s-ah f-r-ah jh-eh1-t", "nn"],
  "suffuse": ["s-ah-f-y-uw1-z", "vb"],
  "sugar": ["sh-uh1 g-er", "nn vb"],
  "sugarcane": ["sh-uh1-g er-k ey-n", "nn"],
  "sugared": ["sh-uh1 g-er-d", "jj vbn"],
  "sugary": ["sh-uh1 g-er iy", "jj"],
  "suggest": ["s-ah-g jh-eh1-s-t", "vbp vb"],
  "suggested": ["s-ah-g jh-eh1 s-t-ah-d", "vbd vbn jj"],
  "suggestion": ["s-ah-g jh-eh1-s ch-ah-n", "nn"],
  "suggestive": ["s-ah-g jh-eh1 s-t-ih-v", "jj"],
  "suicidal": ["s-uw ah s-ay1 d-ah-l", "jj"],
  "suicide": ["s-uw1 ah s-ay-d", "nn"],
  "suit": ["s-uw1-t", "nn vbp rb vb"],
  "suitability": ["s-uw t-ah b-ih1 l-ih t-iy", "nn"],
  "suitable": ["s-uw1 t-ah b-ah-l", "jj"],
  "suitably": ["s-uw1 t-ah b-l-iy", "rb"],
  "suitcase": ["s-uw1-t k-ey-s", "nn"],
  "suite": ["s-w-iy1-t", "nn"],
  "suitor": ["s-uw1 t-er", "nn"],
  "sulfide": ["s-ah1-l f-ay-d", "nn"],
  "sulfur": ["s-ah1-l f-er", "nn"],
  "sulfuric": ["s-ah-l f-y-uh1 r-ih-k", "jj"],
  "sulk": ["s-ah1-l-k", "vb"],
  "sullen": ["s-ah1 l-ah-n", "jj"],
  "sulphur": ["s-ah1-l f-er", "nn"],
  "sultan": ["s-ah1-l t-ah-n", "nn"],
  "sultry": ["s-ah1-l t-r-iy", "jj"],
  "sum": ["s-ah1-m", "nn vb"],
  "sumac": ["s-uw1 m-ae-k", "nn"],
  "summarily": ["s-ah m-eh1 r-ih l-iy", "rb"],
  "summarize": ["s-ah1 m-er ay-z", "vb"],
  "summary": ["s-ah1 m-er iy", "nn"],
  "summation": ["s-ah m-ey1 sh-ah-n", "nn"],
  "summer": ["s-ah1 m-er", "nn"],
  "summertime": ["s-ah1 m-er t-ay-m", "nn"],
  "summit": ["s-ah1 m-ah-t", "nn jj"],
  "summiteer": ["s-ah m-ih t-ih1-r", "nn"],
  "summitry": ["s-ah1 m-ih t-r-iy", "nn"],
  "summon": ["s-ah1 m-ah-n", "vb"],
  "summons": ["s-ah1 m-ah-n-z", "nn"],
  "sumptuous": ["s-ah1-m-p ch-w-ah-s", "jj"],
  "sun": ["s-ah1-n", "nn vb"],
  "sunburn": ["s-ah1-n b-er-n", "nn vb"],
  "sunder": ["s-ah1-n d-er", "vb"],
  "sundown": ["s-ah1-n d-aw-n", "nn"],
  "sundry": ["s-ah1-n d-r-iy", "jj"],
  "sunflower": ["s-ah1-n f-l-aw er", "nn"],
  "sung": ["s-ah1-ng", "vbn"],
  "sunglasses": ["s-ah1-n g-l-ae s-ih-z", "nn"],
  "sunk": ["s-ah1-ng-k", "vbn vbd"],
  "sunken": ["s-ah1-ng k-ah-n", "jj"],
  "sunlight": ["s-ah1-n l-ay-t", "nn"],
  "sunny": ["s-ah1 n-iy", "jj"],
  "sunrise": ["s-ah1-n r-ay-z", "nn"],
  "sunroof": ["s-ah1-n r-uw-f", "nn"],
  "sunset": ["s-ah1-n s-eh-t", "nn vb"],
  "sunshine": ["s-ah1-n sh-ay-n", "nn"],
  "sunshiny": ["s-ah1-n sh-ay n-iy", "jj"],
  "suntan": ["s-ah1-n t-ae-n", "nn"],
  "super": ["s-uw1 p-er", "jj nn"],
  "superb": ["s-uh p-er1-b", "jj"],
  "superbly": ["s-uw1 p-er b-l-iy", "rb"],
  "supercharged": ["s-uw p-er ch-aa1-r-jh-d", "jj"],
  "supercilious": ["s-uw p-er s-ih1 l-iy ah-s", "jj"],
  "supercomputer": ["s-uw p-er k-ah-m p-y-uw1 t-er", "nn"],
  "superconductor": ["s-uw1 p-er k-ah-n d-ah-k t-er", "nn"],
  "superfast": ["s-uw1 p-er f-ae-s-t", "jj"],
  "superficial": ["s-uw p-er f-ih1 sh-ah-l", "jj"],
  "superficially": ["s-uw1 p-er f-ih sh-ah-l l-iy", "rb"],
  "superfluous": ["s-uw1 p-er f-l-w-ah-s", "jj"],
  "supergiant": ["s-uw p-er jh-ay1 ah-n-t", "nn"],
  "superhighway": ["s-uw p-er hh-ay1 w-ey", "nn"],
  "superhuman": ["s-uw p-er hh-y-uw1 m-ah-n", "jj"],
  "superimpose": ["s-uw-p-er-ah-m-p-ow1-z", "vb"],
  "superimposed": ["s-uw p-er ah-m p-ow1-z-d", "vbn jj"],
  "superintendent": ["s-uw p-er ah-n t-eh1-n d-ah-n-t", "nn"],
  "superior": ["s-uw p-ih1 r-iy er", "jj nn"],
  "superiority": ["s-uw p-ih r-iy ao1 r-ih t-iy", "nn"],
  "superlative": ["s-uh p-er1 l-ah t-ih-v", "jj"],
  "supermarket": ["s-uw1 p-er m-aa-r k-ih-t", "nn"],
  "supernatural": ["s-uw p-er n-ae1 ch-er ah-l", "jj nn"],
  "superpower": ["s-uw p-er p-aw1 er", "nn"],
  "superregional": ["s-uw p-er r-iy1 jh-ah n-ah-l", "jj"],
  "supersede": ["s-uw p-er s-iy1-d", "vb"],
  "supersonic": ["s-uw p-er s-aa1 n-ih-k", "jj"],
  "superstar": ["s-uw p-er s-t-aa1-r", "nn"],
  "superstition": ["s-uw p-er s-t-ih1 sh-ah-n", "nn"],
  "superstitious": ["s-uw p-er s-t-ih1 sh-ah-s", "jj"],
  "superstore": ["s-uw1 p-er s-t-ao-r", "nn"],
  "superstructure": ["s-uw1 p-er s-t-r-ah-k ch-er", "nn"],
  "supertanker": ["s-uw1 p-er t-ae-ng k-er", "nn"],
  "supervise": ["s-uw1 p-er v-ay-z", "vb vbp"],
  "supervised": ["s-uw1 p-er v-ay-z-d", "vbd jj vbn"],
  "supervision": ["s-uw p-er v-ih1 zh-ah-n", "nn"],
  "supervisor": ["s-uw1 p-er v-ay z-er", "nn"],
  "supervisory": ["s-uw p-er v-ay1 z-er iy", "jj"],
  "supervoting": ["s-uw p-er v-ow1 t-ih-ng", "jj"],
  "supine": ["s-ah p-ay1-n", "nn"],
  "supper": ["s-ah1 p-er", "nn"],
  "supplant": ["s-ah p-l-ae1-n-t", "vb"],
  "supple": ["s-ah1 p-ah-l", "jj"],
  "supplement": ["s-ah1 p-l-ah m-ah-n-t", "nn vbp vb"],
  "supplemental": ["s-ah p-l-ah m-eh1-n t-ah-l", "jj"],
  "supplementary": ["s-ah p-l-ah m-eh1-n t-er iy", "jj nn"],
  "supplied": ["s-ah p-l-ay1-d", "vbn vbd"],
  "supplier": ["s-ah p-l-ay1 er", "nn"],
  "supply": ["s-ah p-l-ay1", "nn vbp vb"],
  "support": ["s-ah p-ao1-r-t", "nn vb vbp"],
  "supportable": ["s-ah p-ao1-r t-ah b-ah-l", "jj"],
  "supported": ["s-ah p-ao1-r t-ah-d", "vbn jj vbd"],
  "supporter": ["s-ah p-ao1-r t-er", "nn"],
  "supporting": ["s-ah p-ao1-r t-ih-ng", "vbg jj"],
  "supportive": ["s-ah p-ao1-r t-ih-v", "jj"],
  "suppose": ["s-ah p-ow1-z", "vbp vb"],
  "supposed": ["s-ah p-ow1-z-d", "vbn jj vbd"],
  "supposedly": ["s-ah p-ow1 z-ah-d l-iy", "rb"],
  "suppress": ["s-ah p-r-eh1-s", "vb vbp"],
  "suppressant": ["s-ah p-r-eh1 s-ah-n-t", "nn"],
  "suppressed": ["s-ah p-r-eh1-s-t", "vbn jj vbd"],
  "suppression": ["s-ah p-r-eh1 sh-ah-n", "nn"],
  "suppressor": ["s-ah p-r-eh1 s-er", "nn"],
  "supra": ["s-uw1 p-r-ah", "rb"],
  "supremacy": ["s-ah p-r-eh1 m-ah s-iy", "nn"],
  "supreme": ["s-ah p-r-iy1-m", "nn jj"],
  "supremely": ["s-uw p-r-iy1 m-ah l-iy", "rb"],
  "surcharge": ["s-er ch-aa1-r-jh", "nn"],
  "sure": ["sh-uh1-r", "jj pdt rb uh"],
  "surely": ["sh-uh1-r l-iy", "rb"],
  "surest": ["sh-uh1 r-ih-s-t", "jjs"],
  "surf": ["s-er1-f", "nn vb vbp"],
  "surface": ["s-er1 f-ah-s", "nn vb vbp"],
  "surfaceness": ["s-er1 f-ah-s n-ah-s", "nn"],
  "surfactant": ["s-er f-ae1-k t-ah-n-t", "nn"],
  "surfboard": ["s-er1-f b-ao-r-d", "nn"],
  "surfeit": ["s-er1 f-ah-t", "nn"],
  "surfer": ["s-er1 f-er", "nn"],
  "surfing": ["s-er1 f-ih-ng", "nn"],
  "surge": ["s-er1-jh", "nn vb"],
  "surgeon": ["s-er1 jh-ah-n", "nn"],
  "surgery": ["s-er1 jh-er iy", "nn"],
  "surgical": ["s-er1 jh-ih k-ah-l", "jj"],
  "surgically": ["s-er1 jh-ih k-ah l-iy", "rb"],
  "surging": ["s-er1 jh-ih-ng", "vbg jj"],
  "surly": ["s-er1 l-iy", "jj"],
  "surmise": ["s-er m-ay1-z", "vb"],
  "surmount": ["s-er m-aw1-n-t", "vb"],
  "surname": ["s-er1 n-ey-m", "nn"],
  "surpass": ["s-er p-ae1-s", "vb vbp"],
  "surplus": ["s-er1-p l-ah-s", "nn jj"],
  "surprise": ["s-er p-r-ay1-z", "nn jj rb vb"],
  "surprised": ["s-er p-r-ay1-z-d", "vbn vbd jj"],
  "surprising": ["s-er p-r-ay1 z-ih-ng", "jj vbg"],
  "surprisingly": ["s-er p-r-ay1 z-ih-ng l-iy", "rb"],
  "surreal": ["s-er iy1-l", "jj"],
  "surrealism": ["s-er iy1 l-ih z-ah-m", "nn"],
  "surrealistic": ["s-er iy l-ih1 s-t-ih-k", "jj"],
  "surrender": ["s-er eh1-n d-er", "nn vbp vb"],
  "surreptitious": ["s-er ah-p t-ih1 sh-ah-s", "jj"],
  "surreptitiously": ["s-er ah-p t-ih1 sh-ah-s l-iy", "rb"],
  "surrogacy": ["s-er1 ah g-ah s-iy", "nn"],
  "surrogate": ["s-er1 ah g-ah-t", "nn"],
  "surround": ["s-er aw1-n-d", "vbp vb"],
  "surrounding": ["s-er aw1-n d-ih-ng", "vbg jj"],
  "surtax": ["s-er1 t-ae-k-s", "nn"],
  "surveillance": ["s-er v-ey1 l-ah-n-s", "nn"],
  "survey": ["s-er v-ey1", "nn vb vbp"],
  "surveyor": ["s-er v-ey1 er", "nn"],
  "survivable": ["s-er v-ay1 v-ah b-ah-l", "jj"],
  "survival": ["s-er v-ay1 v-ah-l", "nn"],
  "survivalist": ["s-er v-ay1 v-ah l-ih-s-t", "nn"],
  "survive": ["s-er v-ay1-v", "vb vbp"],
  "survivor": ["s-er v-ay1 v-er", "nn"],
  "susceptibility": ["s-ah s-eh-p t-ah b-ih1 l-ah t-iy", "nn"],
  "susceptible": ["s-ah s-eh1-p t-ah b-ah-l", "jj nn"],
  "sushi": ["s-uw1 sh-iy", "nn"],
  "suspect": ["s-ah s-p-eh1-k-t", "vbp jj nn vb"],
  "suspected": ["s-ah s-p-eh1-k t-ah-d", "vbn vbd jj"],
  "suspend": ["s-ah s-p-eh1-n-d", "vb vbp"],
  "suspended": ["s-ah s-p-eh1-n d-ah-d", "vbn jj vbd"],
  "suspender": ["s-ah s-p-eh1-n d-er", "nn"],
  "suspense": ["s-ah s-p-eh1-n-s", "nn"],
  "suspenseful": ["s-ah s-p-eh1-n-s f-ah-l", "jj"],
  "suspension": ["s-ah s-p-eh1-n sh-ah-n", "nn"],
  "suspicion": ["s-ah s-p-ih1 sh-ah-n", "nn"],
  "suspicious": ["s-ah s-p-ih1 sh-ah-s", "jj"],
  "suspiciously": ["s-ah s-p-ih1 sh-ah-s l-iy", "rb"],
  "sustain": ["s-ah s-t-ey1-n", "vb vbp"],
  "sustainability": ["s-ah s-t-ey n-ah b-ih1 l-ih t-iy", "nn"],
  "sustainable": ["s-ah s-t-ey1 n-ah b-ah-l", "jj"],
  "sustained": ["s-ah s-t-ey1-n-d", "vbn vbd jj"],
  "sustenance": ["s-ah1 s-t-ah n-ah-n-s", "nn"],
  "suture": ["s-uw1 ch-er", "nn"],
  "svelte": ["s-v-eh1-l-t", "jj"],
  "swab": ["s-w-aa1-b", "vb"],
  "swagger": ["s-w-ae1 g-er", "nn vb"],
  "swallow": ["s-w-aa1 l-ow", "vb nn vbp"],
  "swam": ["s-w-ae1-m", "vbd"],
  "swami": ["s-w-aa1 m-iy", "nn"],
  "swamp": ["s-w-aa1-m-p", "nn vb"],
  "swampy": ["s-w-aa1-m p-iy", "jj"],
  "swan": ["s-w-aa1-n", "nn"],
  "swank": ["s-w-ae1-ng-k", "jj"],
  "swanky": ["s-w-aa1-ng k-iy", "jj"],
  "swap": ["s-w-aa1-p", "nn vbp vb"],
  "swarm": ["s-w-ao1-r-m", "nn vb"],
  "swart": ["s-w-ao1-r-t", "jj"],
  "swarthy": ["s-w-ao1-r dh-iy", "jj"],
  "swashbuckling": ["s-w-aa1-sh b-ah k-l-ih-ng", "jj"],
  "swat": ["s-w-aa1-t", "nn"],
  "swatch": ["s-w-aa1-ch", "nn"],
  "swath": ["s-w-aa1-th", "nn"],
  "swathe": ["s-w-aa1-dh", "vb"],
  "sway": ["s-w-ey1", "vb vbp nn"],
  "swear": ["s-w-eh1-r", "vb vbp"],
  "sweat": ["s-w-eh1-t", "nn vbd vbp vb"],
  "sweater": ["s-w-eh1 t-er", "nn"],
  "sweatshirt": ["s-w-eh1-t sh-er-t", "nn"],
  "sweatshop": ["s-w-eh1-t sh-aa-p", "nn"],
  "sweaty": ["s-w-eh1 t-iy", "jj"],
  "sweep": ["s-w-iy1-p", "nn vb"],
  "sweeper": ["s-w-iy1 p-er", "nn"],
  "sweeping": ["s-w-iy1 p-ih-ng", "vbg jj nn"],
  "sweepstakes": ["s-w-iy1-p s-t-ey-k-s", "nn"],
  "sweet": ["s-w-iy1-t", "jj"],
  "sweeten": ["s-w-iy1 t-ah-n", "vb"],
  "sweetened": ["s-w-iy1 t-ah-n-d", "vbn vbd jj"],
  "sweetener": ["s-w-iy1 t-ah-n er", "nn"],
  "sweetening": ["s-w-iy1 t-ah-n ih-ng", "nn"],
  "sweeter": ["s-w-iy1 t-er", "jjr"],
  "sweetest": ["s-w-iy1 t-ah-s-t", "jjs"],
  "sweetheart": ["s-w-iy1-t hh-aa-r-t", "nn jj"],
  "sweetly": ["s-w-iy1-t l-iy", "rb"],
  "sweetness": ["s-w-iy1-t n-ah-s", "nn"],
  "swell": ["s-w-eh1-l", "vb vbp jj nn"],
  "swelled": ["s-w-eh1-l-d", "vbd vbn jj"],
  "swelling": ["s-w-eh1 l-ih-ng", "vbg jj nn"],
  "sweltering": ["s-w-eh1-l t-er ih-ng", "jj"],
  "swept": ["s-w-eh1-p-t", "vbd jj vbn"],
  "swerve": ["s-w-er1-v", "vbp nn vb"],
  "swift": ["s-w-ih1-f-t", "jj nn rb"],
  "swiftest": ["s-w-ih1-f t-ah-s-t", "jjs"],
  "swiftly": ["s-w-ih1-f-t l-iy", "rb"],
  "swiftness": ["s-w-ih1-f-t n-ah-s", "nn"],
  "swig": ["s-w-ih1-g", "nn"],
  "swim": ["s-w-ih1-m", "vb vbp nn"],
  "swimmer": ["s-w-ih1 m-er", "nn"],
  "swimming": ["s-w-ih1 m-ih-ng", "vbg jj nn"],
  "swimsuit": ["s-w-ih1-m s-uw-t", "nn"],
  "swindle": ["s-w-ih1-n-d-ah-l", "vb"],
  "swindler": ["s-w-ih1-n-d l-er", "nn"],
  "swine": ["s-w-ay1-n", "nn"],
  "swing": ["s-w-ih1-ng", "nn vbp jj vb"],
  "swinger": ["s-w-ih1 ng-er", "nn"],
  "swinging": ["s-w-ih1 ng-ih-ng", "vbg jj"],
  "swipe": ["s-w-ay1-p", "nn vb"],
  "swirl": ["s-w-er1-l", "nn vb"],
  "swish": ["s-w-ih1-sh", "vb"],
  "switch": ["s-w-ih1-ch", "nn vb vbp"],
  "switchboard": ["s-w-ih1-ch b-ao-r-d", "nn"],
  "switched": ["s-w-ih1-ch-t", "vbd vbn jj"],
  "switcher": ["s-w-ih1 ch-er", "nn"],
  "swivel": ["s-w-ih1 v-ah-l", "jj nn vb"],
  "swollen": ["s-w-ow1 l-ah-n", "jj vbn"],
  "swoon": ["s-w-uw1-n", "nn"],
  "swooning": ["s-w-uw1 n-ih-ng", "nn"],
  "swoop": ["s-w-uw1-p", "nn vb"],
  "swoops": ["s-w-uw1-p-s", "nn vbz"],
  "sword": ["s-ao1-r-d", "nn"],
  "swordfish": ["s-ao1-r-d f-ih-sh", "nn"],
  "swore": ["s-w-ao1-r", "vbd"],
  "sworn": ["s-w-ao1-r-n", "vbn jj"],
  "swum": ["s-w-ah1-m", "vbn"],
  "swung": ["s-w-ah1-ng", "vbd vbn"],
  "sycamore": ["s-ih1 k-ah m-ao-r", "nn"],
  "sycophantic": ["s-ih k-ah f-ae1-n t-ih-k", "jj"],
  "syllable": ["s-ih1 l-ah b-ah-l", "nn"],
  "sylvan": ["s-ih1-l v-ah-n", "jj"],
  "symbiotic": ["s-ih-m b-iy aa1 t-ih-k", "jj"],
  "symbol": ["s-ih1-m b-ah-l", "nn"],
  "symbolic": ["s-ih-m b-aa1 l-ih-k", "jj"],
  "symbolically": ["s-ih-m b-aa1 l-ih k-ah l-iy", "rb"],
  "symbolism": ["s-ih1-m b-ah l-ih z-ah-m", "nn"],
  "symbolist": ["s-ih1-m b-ah l-ah-s-t", "nn"],
  "symbolize": ["s-ih1-m b-ah l-ay-z", "vb vbp"],
  "symmetrical": ["s-ah m-eh1 t-r-ih k-ah-l", "jj"],
  "symmetry": ["s-ih1 m-ah t-r-iy", "nn"],
  "sympathetic": ["s-ih-m p-ah th-eh1 t-ih-k", "jj"],
  "sympathetically": ["s-ih-m p-ah th-eh1 t-ih k-ah l-iy", "rb"],
  "sympathize": ["s-ih1-m p-ah th-ay-z", "vbp vb"],
  "sympathizer": ["s-ih1-m p-ah th-ay z-er", "nn"],
  "sympathy": ["s-ih1-m p-ah th-iy", "nn"],
  "symphonic": ["s-ih-m f-aa1 n-ih-k", "jj"],
  "symphony": ["s-ih1-m f-ah n-iy", "nn"],
  "symposium": ["s-ih-m p-ow1 z-iy ah-m", "nn"],
  "symptom": ["s-ih1-m-p t-ah-m", "nn"],
  "symptomatic": ["s-ih-m-p t-ah m-ae1 t-ih-k", "jj"],
  "synagogue": ["s-ih1 n-ah g-ao-g", "nn"],
  "sync": ["s-ih1-ng-k", "nn"],
  "synchronize": ["s-ih1-ng-k-r-ah-n-ay-z", "vb"],
  "synchronized": ["s-ih1-ng k-r-ah n-ay-z-d", "vbn jj"],
  "syndicate": ["s-ih1-n d-ih k-ah-t", "nn vb"],
  "syndicated": ["s-ih1-n d-ih k-ey t-ih-d", "vbn vbd jj"],
  "syndication": ["s-ih-n d-ih k-ey1 sh-ah-n", "nn"],
  "syndicator": ["s-ih1-n d-ih k-ey t-er", "nn"],
  "syndrome": ["s-ih1-n d-r-ow-m", "nn"],
  "synergistic": ["s-ih n-er jh-ih1 s-t-ih-k", "jj"],
  "synergy": ["s-ih1 n-er jh-iy", "nn"],
  "synonym": ["s-ih1 n-ah n-ih-m", "nn"],
  "synonymous": ["s-ah n-aa1 n-ah m-ah-s", "jj"],
  "synopsis": ["s-ih n-aa1-p s-ih-s", "nn"],
  "synthesis": ["s-ih1-n th-ah s-ah-s", "nn"],
  "synthesize": ["s-ih1-n th-ah s-ay-z", "vb"],
  "synthesizer": ["s-ih1-n th-ah s-ay z-er", "nn"],
  "synthetic": ["s-ih-n th-eh1 t-ih-k", "jj nn"],
  "syringe": ["s-er ih1-n-jh", "nn"],
  "syrup": ["s-er1 ah-p", "nn"],
  "system": ["s-ih1 s-t-ah-m", "nn"],
  "systematic": ["s-ih s-t-ah m-ae1 t-ih-k", "jj"],
  "systematically": ["s-ih s-t-ah m-ae1 t-ih-k l-iy", "rb"],
  "systemic": ["s-ih-s t-eh1 m-ih-k", "jj"],
  "systemwide": ["s-ih1 s-t-ah-m w-ay-d", "jj"],
  "tab": ["t-ae1-b", "nn"],
  "tabby": ["t-ae1 b-iy", "jj nn"],
  "table": ["t-ey1 b-ah-l", "nn vb"],
  "tableau": ["t-ah b-l-ow1", "nn"],
  "tablecloth": ["t-ey1 b-ah-l k-l-ao-th", "nn"],
  "tablespoon": ["t-ey1 b-ah-l s-p-uw-n", "nn"],
  "tablet": ["t-ae1 b-l-ah-t", "nn"],
  "tableware": ["t-ey1 b-ah-l w-eh-r", "nn"],
  "tabling": ["t-ey1 b-ah-l ih-ng", "vbg jj nn"],
  "tabloid": ["t-ae1 b-l-oy-d", "nn jj"],
  "taboo": ["t-ae b-uw1", "nn"],
  "tabulate": ["t-ae1 b-y-ah l-ey-t", "vb"],
  "tabulated": ["t-ae1 b-y-ah l-ey t-ih-d", "vbn jj vbd"],
  "tabulation": ["t-ae b-y-ah l-ey1 sh-ah-n", "nn"],
  "tacit": ["t-ae1 s-ih-t", "jj"],
  "tacitly": ["t-ae1 s-ih-t l-iy", "rb"],
  "tack": ["t-ae1-k", "nn vb vbp"],
  "tackle": ["t-ae1 k-ah-l", "vb vbp nn"],
  "tacky": ["t-ae1 k-iy", "jj"],
  "taco": ["t-aa1 k-ow", "nn"],
  "tact": ["t-ae1-k-t", "nn"],
  "tactful": ["t-ae1-k-t f-ah-l", "jj"],
  "tactic": ["t-ae1-k t-ih-k", "nn"],
  "tactical": ["t-ae1-k t-ih k-ah-l", "jj"],
  "tactically": ["t-ae1-k t-ih k-ah l-iy", "rb"],
  "tactician": ["t-ae-k t-ih1 sh-ah-n", "nn"],
  "tad": ["t-ae1-d", "nn rb"],
  "tadpole": ["t-ae1-d p-ow-l", "nn"],
  "taffeta": ["t-ae1 f-ah t-ah", "nn"],
  "taffy": ["t-ae1 f-iy", "jj"],
  "tag": ["t-ae1-g", "nn vb"],
  "tagged": ["t-ae1-g-d", "vbn vbd jj"],
  "tagline": ["t-ae1 g-l-ay-n", "nn"],
  "tail": ["t-ey1-l", "nn jj vb"],
  "tailgate": ["t-ey1-l g-ey-t", "nn"],
  "tailor": ["t-ey1 l-er", "vb nn"],
  "tailored": ["t-ey1 l-er-d", "vbn jj"],
  "tailpipe": ["t-ey1-l p-ay-p", "nn"],
  "tailspin": ["t-ey1-l s-p-ih-n", "nn"],
  "taint": ["t-ey1-n-t", "nn vb vbp"],
  "tainted": ["t-ey1-n t-ih-d", "vbn vbd jj"],
  "take": ["t-ey1-k", "vb nn vbp"],
  "taken": ["t-ey1 k-ah-n", "vbn vbg"],
  "takeoff": ["t-ey1-k ao-f", "nn"],
  "takeout": ["t-ey1-k aw-t", "nn"],
  "takeover": ["t-ey1-k ow v-er", "nn"],
  "taker": ["t-ey1 k-er", "nn"],
  "tale": ["t-ey1-l", "nn"],
  "talent": ["t-ae1 l-ah-n-t", "nn"],
  "talented": ["t-ae1 l-ah-n t-ah-d", "jj"],
  "talk": ["t-ao1-k", "vb vbp nn"],
  "talkative": ["t-ao1 k-ah t-ih-v", "jj"],
  "talker": ["t-ao1 k-er", "nn"],
  "talky": ["t-ao1 k-iy", "jj"],
  "tall": ["t-ao1-l", "jj"],
  "taller": ["t-ao1 l-er", "jjr"],
  "tallest": ["t-ao1 l-ih-s-t", "jjs"],
  "tallied": ["t-ae1 l-iy-d", "vbn vbd"],
  "tallow": ["t-ae1 l-ow", "nn"],
  "tally": ["t-ae1 l-iy", "nn vbp vb"],
  "tallyho": ["t-ae l-iy hh-ow1", "nn"],
  "tam": ["t-ae1-m", "nn"],
  "tambourine": ["t-ae-m b-er iy1-n", "nn"],
  "tame": ["t-ey1-m", "jj vb"],
  "tamer": ["t-ey1 m-er", "jjr"],
  "tamper": ["t-ae1-m p-er", "vb"],
  "tampon": ["t-ae1-m p-aa-n", "nn"],
  "tan": ["t-ae1-n", "jj nn"],
  "tandem": ["t-ae1-n d-ah-m", "nn jj"],
  "tang": ["t-ae1-ng", "nn"],
  "tangent": ["t-ae1-n jh-ah-n-t", "jj nn"],
  "tangential": ["t-ae-n jh-eh1-n ch-ah-l", "jj"],
  "tangible": ["t-ae1-n jh-ah b-ah-l", "jj"],
  "tangle": ["t-ae1-ng g-ah-l", "nn vbp vb"],
  "tangled": ["t-ae1-ng g-ah-l-d", "jj vbd vbn"],
  "tango": ["t-ae1-ng g-ow", "nn"],
  "tank": ["t-ae1-ng-k", "nn vb"],
  "tanker": ["t-ae1-ng k-er", "nn"],
  "tanned": ["t-ae1-n-d", "jj vbn"],
  "tanning": ["t-ae1 n-ih-ng", "nn"],
  "tansy": ["t-ae1-n z-iy", "nn"],
  "tantalize": ["t-ae1-n-t-ah-l-ay-z", "vb"],
  "tantalizing": ["t-ae1-n t-ah l-ay z-ih-ng", "vbg jj"],
  "tantamount": ["t-ae1-n t-ah m-aw-n-t", "jj"],
  "tantrum": ["t-ae1-n t-r-ah-m", "nn"],
  "tap": ["t-ae1-p", "vb nn vbp"],
  "tape": ["t-ey1-p", "nn vb vbp"],
  "taped": ["t-ey1-p-t", "vbn jj vbd"],
  "taper": ["t-ey1 p-er", "vb nn"],
  "tapered": ["t-ey1 p-er-d", "jj vbn"],
  "tapestry": ["t-ae1 p-ah-s t-r-iy", "nn"],
  "tapped": ["t-ae1-p-t", "vbd vbn"],
  "tar": ["t-aa1-r", "nn"],
  "tardiness": ["t-aa1-r d-iy n-ah-s", "nn"],
  "tardy": ["t-aa1-r d-iy", "jj"],
  "target": ["t-aa1-r g-ah-t", "nn vbp vb"],
  "targeted": ["t-aa1-r g-ah t-ih-d", "vbn vbd jj"],
  "tariff": ["t-eh1 r-ah-f", "nn"],
  "tarmac": ["t-aa1-r m-ae-k", "nn"],
  "tarnish": ["t-aa1-r n-ih-sh", "vb"],
  "tarnished": ["t-aa1-r n-ih-sh-t", "vbn jj vbd"],
  "tarpon": ["t-aa1-r p-ah-n", "nn"],
  "tarred": ["t-aa1-r-d", "vbn vbd"],
  "tarry": ["t-eh1 r-iy", "vb"],
  "tart": ["t-aa1-r-t", "jj nn"],
  "tartan": ["t-aa1-r t-ah-n", "nn"],
  "task": ["t-ae1-s-k", "nn vb"],
  "taskmaster": ["t-ae1-s-k m-ae s-t-er", "nn"],
  "tassel": ["t-ae1 s-ah-l", "nn"],
  "taste": ["t-ey1-s-t", "nn vb vbp"],
  "tasteful": ["t-ey1-s-t f-ah-l", "jj"],
  "tastefully": ["t-ey1-s-t f-ah l-iy", "rb"],
  "tasteless": ["t-ey1-s-t l-ah-s", "jj"],
  "tastier": ["t-ey1 s-t-iy er", "jjr"],
  "tasty": ["t-ey1 s-t-iy", "jj"],
  "tatter": ["t-ae1-t-er", "vb"],
  "tattered": ["t-ae1 t-er-d", "jj vbn"],
  "tattoo": ["t-ae t-uw1", "nn vb"],
  "taught": ["t-ao1-t", "vbn vbd"],
  "taunt": ["t-ao1-n-t", "nn vb"],
  "taut": ["t-ao1-t", "jj rb"],
  "tavern": ["t-ae1 v-er-n", "nn"],
  "tawdry": ["t-ao1 d-r-iy", "jj"],
  "tax": ["t-ae1-k-s", "nn vb vbp"],
  "taxable": ["t-ae1-k s-ah b-ah-l", "jj"],
  "taxation": ["t-ae-k s-ey1 sh-ah-n", "nn"],
  "taxed": ["t-ae1-k-s-t", "vbn jj vbd"],
  "taxi": ["t-ae1-k s-iy", "nn vb"],
  "taxicab": ["t-ae1-k s-iy k-ae-b", "nn"],
  "taxing": ["t-ae1-k s-ih-ng", "vbg jj nn"],
  "taxpayer": ["t-ae1-k s-p-ey er", "nn"],
  "taxpaying": ["t-ae1-k s-p-ey ih-ng", "jj"],
  "tea": ["t-iy1", "nn"],
  "teach": ["t-iy1-ch", "vb vbp"],
  "teacher": ["t-iy1 ch-er", "nn"],
  "team": ["t-iy1-m", "nn vb vbp"],
  "teammate": ["t-iy1 m-ey-t", "nn"],
  "teamster": ["t-iy1-m s-t-er", "nn"],
  "teamwork": ["t-iy1-m w-er-k", "nn"],
  "teapot": ["t-iy1 p-aa-t", "nn"],
  "tear": ["t-eh1-r", "vb vbp nn"],
  "tearfully": ["t-ih1-r f-ah l-iy", "rb"],
  "tease": ["t-iy1-z", "vb nn vbp"],
  "teaser": ["t-iy1 z-er", "nn"],
  "teasing": ["t-iy1 z-ih-ng", "jj vbg"],
  "teaspoon": ["t-iy1 s-p-uw-n", "nn"],
  "teat": ["t-iy1-t", "nn"],
  "technical": ["t-eh1-k n-ih k-ah-l", "jj"],
  "technicality": ["t-eh-k n-ih k-ae1 l-ih t-iy", "nn"],
  "technically": ["t-eh1-k n-ih k-ah l-iy", "rb"],
  "technician": ["t-eh-k n-ih1 sh-ah-n", "nn"],
  "technique": ["t-eh-k n-iy1-k", "nn"],
  "technocrat": ["t-eh1-k n-ah k-r-ae-t", "nn"],
  "technocratic": ["t-eh-k n-ah k-r-ae1 t-ih-k", "jj"],
  "technological": ["t-eh-k n-ah l-aa1 jh-ih k-ah-l", "jj"],
  "technologically": ["t-eh-k n-ah l-aa1 jh-ih k-ah l-iy", "rb"],
  "technologist": ["t-eh-k n-aa1 l-ah jh-ih-s-t", "nn"],
  "technology": ["t-eh-k n-aa1 l-ah jh-iy", "nn"],
  "teddy": ["t-eh1 d-iy", "nn"],
  "tedious": ["t-iy1 d-iy ah-s", "jj"],
  "tediously": ["t-iy1 d-iy ah-s l-iy", "rb"],
  "tedium": ["t-iy1 d-iy ah-m", "nn"],
  "tee": ["t-iy1", "nn vb"],
  "teem": ["t-iy1-m", "vb"],
  "teen": ["t-iy1-n", "jj nn"],
  "teenage": ["t-iy1 n-ey-jh", "jj"],
  "teenager": ["t-iy1-n ey jh-er", "nn"],
  "teensy": ["t-iy1-n s-iy", "jj"],
  "teeter": ["t-iy1-t-er", "vb"],
  "teetering": ["t-iy1 t-er ih-ng", "vbg jj"],
  "telecast": ["t-eh1 l-ah k-ae-s-t", "nn"],
  "telecom": ["t-eh1 l-ah k-aa-m", "nn"],
  "telecommunications": ["t-eh l-ah k-ah m-y-uw n-ah k-ey1 sh-ah-n-z", "nn"],
  "telegram": ["t-eh1 l-ah g-r-ae-m", "nn"],
  "telegraph": ["t-eh1 l-ah g-r-ae-f", "nn vbp vb"],
  "telemarketer": ["t-eh l-ah m-aa1-r k-ih t-er", "nn"],
  "telemarketing": ["t-eh l-ah m-aa1-r k-ah t-ih-ng", "nn"],
  "telepathy": ["t-ah l-eh1 p-ah th-iy", "nn"],
  "telephone": ["t-eh1 l-ah f-ow-n", "nn vb"],
  "telescope": ["t-eh1 l-ah s-k-ow-p", "nn vb"],
  "teletype": ["t-eh1 l-ah t-ay-p", "nn"],
  "televise": ["t-eh1-l-ah-v-ay-z", "vb"],
  "televised": ["t-eh1 l-ah v-ay-z-d", "vbn jj"],
  "televising": ["t-eh1 l-ah v-ay z-ih-ng", "nn"],
  "television": ["t-eh1 l-ah v-ih zh-ah-n", "nn"],
  "televison": ["t-eh1 l-ih v-ih zh-ah-n", "nn"],
  "tell": ["t-eh1-l", "vb vbp"],
  "teller": ["t-eh1 l-er", "nn"],
  "tellingly": ["t-eh1 l-ih-ng l-iy", "rb"],
  "telltale": ["t-eh1-l t-ey-l", "jj nn"],
  "temblor": ["t-eh1-m b-l-er", "nn"],
  "temerity": ["t-ah m-eh1 r-ah t-iy", "nn"],
  "temp": ["t-eh1-m-p", "nn"],
  "temper": ["t-eh1-m p-er", "nn vb"],
  "tempera": ["t-eh1-m p-er ah", "nn"],
  "temperament": ["t-eh1-m p-r-ah m-ah-n-t", "nn"],
  "temperamental": ["t-eh-m p-r-ah m-eh1-n t-ah-l", "jj"],
  "temperance": ["t-eh1-m p-er ah-n-s", "nn"],
  "temperate": ["t-eh1-m p-r-ah-t", "jj"],
  "temperature": ["t-eh1-m p-r-ah ch-er", "nn"],
  "tempest": ["t-eh1-m p-ah-s-t", "nn"],
  "tempestuous": ["t-eh-m p-eh1-s ch-uw ah-s", "jj"],
  "template": ["t-eh1-m p-l-ah-t", "nn"],
  "temple": ["t-eh1-m p-ah-l", "nn"],
  "tempo": ["t-eh1-m p-ow", "nn"],
  "temporal": ["t-eh1-m p-er ah-l", "jj nn"],
  "temporally": ["t-eh1-m p-er ah l-iy", "rb"],
  "temporarily": ["t-eh-m p-er eh1 r-ah l-iy", "rb"],
  "temporary": ["t-eh1-m p-er eh r-iy", "jj"],
  "tempore": ["t-eh1-m p-ao-r", "nn"],
  "temporize": ["t-eh1-m-p-er-ay-z", "vb"],
  "tempt": ["t-eh1-m-p-t", "vb vbp"],
  "temptation": ["t-eh-m t-ey1 sh-ah-n", "nn"],
  "tempting": ["t-eh1-m-p t-ih-ng", "jj"],
  "ten": ["t-eh1-n", "cd"],
  "tenable": ["t-eh1 n-ah b-ah-l", "jj"],
  "tenacious": ["t-ah n-ey1 sh-ah-s", "jj"],
  "tenaciously": ["t-ah n-ey1 sh-ah-s l-iy", "rb"],
  "tenacity": ["t-ah n-ae1 s-ih t-iy", "nn"],
  "tenancy": ["t-eh1 n-ah-n s-iy", "nn"],
  "tenant": ["t-eh1 n-ah-n-t", "nn"],
  "tend": ["t-eh1-n-d", "vbp vb"],
  "tended": ["t-eh1-n d-ah-d", "vbd vbn jj"],
  "tendency": ["t-eh1-n d-ah-n s-iy", "nn"],
  "tendentious": ["t-eh-n d-eh1-n sh-ah-s", "jj"],
  "tender": ["t-eh1-n d-er", "nn vbp jj vb"],
  "tendered": ["t-eh1-n d-er-d", "vbn jj vbd"],
  "tenderly": ["t-eh1-n d-er l-iy", "rb"],
  "tenderness": ["t-eh1-n d-er n-ah-s", "nn"],
  "tendon": ["t-eh1-n d-ah-n", "nn"],
  "tenement": ["t-eh1 n-ah m-ah-n-t", "nn"],
  "tenet": ["t-eh1 n-ah-t", "nn"],
  "tenfold": ["t-eh1-n f-ow-l-d", "rb jj"],
  "tennis": ["t-eh1 n-ah-s", "nn"],
  "tenor": ["t-eh1 n-er", "nn"],
  "tense": ["t-eh1-n-s", "jj nn"],
  "tensely": ["t-eh1-n-s l-iy", "rb"],
  "tensile": ["t-eh1-n s-ah-l", "jj"],
  "tension": ["t-eh1-n sh-ah-n", "nn"],
  "tent": ["t-eh1-n-t", "nn"],
  "tentacle": ["t-eh1-n t-ah k-ah-l", "nn"],
  "tentative": ["t-eh1-n t-ah t-ih-v", "jj nn"],
  "tentatively": ["t-eh1-n t-ah t-ih-v l-iy", "rb"],
  "tenth": ["t-eh1-n-th", "jj nn"],
  "tenting": ["t-eh1-n t-ih-ng", "nn"],
  "tenuous": ["t-eh1 n-y-ah-w ah-s", "jj"],
  "tenure": ["t-eh1 n-y-er", "nn"],
  "tepid": ["t-eh1 p-ih-d", "jj"],
  "tequila": ["t-ah k-iy1 l-ah", "nn"],
  "term": ["t-er1-m", "nn vb vbp"],
  "terminal": ["t-er1 m-ah n-ah-l", "nn jj"],
  "terminate": ["t-er1 m-ah n-ey-t", "vb vbp"],
  "termination": ["t-er m-ah n-ey1 sh-ah-n", "nn"],
  "terminology": ["t-er m-ih n-aa1 l-ah jh-iy", "nn"],
  "terminus": ["t-er1 m-ih n-ah-s", "nn"],
  "termite": ["t-er1 m-ay-t", "nn"],
  "terrace": ["t-eh1 r-ah-s", "nn vb"],
  "terrain": ["t-er ey1-n", "nn"],
  "terrestrial": ["t-er eh1-s t-r-iy ah-l", "jj"],
  "terrible": ["t-eh1 r-ah b-ah-l", "jj"],
  "terribly": ["t-eh1 r-ah b-l-iy", "rb"],
  "terrier": ["t-eh1 r-iy er", "nn"],
  "terrific": ["t-er ih1 f-ih-k", "jj"],
  "terrified": ["t-eh1 r-ah f-ay-d", "vbn jj vbd"],
  "terrify": ["t-eh1 r-ah f-ay", "vb"],
  "terrifying": ["t-eh1 r-ah f-ay ih-ng", "jj vbg"],
  "territorial": ["t-eh r-ih t-ao1 r-iy ah-l", "jj nn"],
  "territory": ["t-eh1 r-ih t-ao r-iy", "nn"],
  "terror": ["t-eh1 r-er", "nn"],
  "terrorism": ["t-eh1 r-er ih z-ah-m", "nn"],
  "terrorist": ["t-eh1 r-er ih-s-t", "jj nn"],
  "terroristic": ["t-eh r-er ih1 s-t-ih-k", "jj"],
  "terrorize": ["t-eh1 r-er ay-z", "vb"],
  "terry": ["t-eh1 r-iy", "nn"],
  "terse": ["t-er1-s", "jj"],
  "tersely": ["t-er1-s l-iy", "rb"],
  "tertiary": ["t-er1 sh-er iy", "jj"],
  "test": ["t-eh1-s-t", "nn vbp vb"],
  "testament": ["t-eh1 s-t-ah m-ah-n-t", "nn"],
  "tested": ["t-eh1 s-t-ah-d", "vbn vbd jj"],
  "testicle": ["t-eh1 s-t-ih k-ah-l", "nn"],
  "testify": ["t-eh1 s-t-ah f-ay", "vb vbp"],
  "testily": ["t-eh1 s-t-ah l-iy", "rb"],
  "testimonial": ["t-eh s-t-ah m-ow1 n-iy ah-l", "jj nn"],
  "testimony": ["t-eh1 s-t-ah m-ow n-iy", "nn"],
  "testosterone": ["t-eh s-t-aa1 s-t-er ow-n", "nn"],
  "testy": ["t-eh1 s-t-iy", "jj"],
  "tetanus": ["t-eh1 t-ah n-ah-s", "nn"],
  "tether": ["t-eh1-dh-er", "vb"],
  "tethered": ["t-eh1 dh-er-d", "vbn vbd jj"],
  "text": ["t-eh1-k-s-t", "nn"],
  "textbook": ["t-eh1-k-s-t b-uh-k", "nn"],
  "textile": ["t-eh1-k s-t-ay-l", "nn jj"],
  "textual": ["t-eh1-k-s ch-ah w-ah-l", "jj"],
  "texture": ["t-eh1-k-s ch-er", "nn"],
  "textured": ["t-eh1-k-s ch-er-d", "jj"],
  "than": ["dh-ae1-n", "in rb rbr"],
  "thank": ["th-ae1-ng-k", "vb vbp"],
  "thankful": ["th-ae1-ng-k f-ah-l", "jj"],
  "thankfully": ["th-ae1-ng-k f-ah l-iy", "rb"],
  "thankless": ["th-ae1-ng-k l-ah-s", "jj"],
  "thanks": ["th-ae1-ng-k-s", "uh"],
  "thanksgiving": ["th-ae-ng-k-s g-ih1 v-ih-ng", "nn"],
  "that": ["dh-ae1-t", "in dt nn rb rp uh wp wdt"],
  "thatch": ["th-ae1-ch", "nn"],
  "thaw": ["th-ao1", "nn vb"],
  "the": ["dh-ah", "dt"],
  "theater": ["th-iy1 ah t-er", "nn"],
  "theatergoer": ["th-iy1 t-er g-ow er", "nn"],
  "theatrical": ["th-iy ae1 t-r-ih k-ah-l", "jj nn"],
  "theatricality": ["th-iy ae t-r-ah k-ae1 l-ah t-iy", "nn"],
  "theatrically": ["th-iy ae1 t-r-ih k-ah l-iy", "rb"],
  "theft": ["th-eh1-f-t", "nn"],
  "their": ["dh-eh1-r", "prp$"],
  "theirs": ["dh-eh1-r-z", "prp jj"],
  "them": ["dh-eh1-m", "prp dt"],
  "thematic": ["th-iy m-ae1 t-ih-k", "jj"],
  "theme": ["th-iy1-m", "nn vb"],
  "themed": ["th-iy1-m-d", "vbn jj"],
  "themselves": ["dh-eh-m s-eh1-l-v-z", "prp"],
  "then": ["dh-eh1-n", "rb in jj"],
  "thence": ["dh-eh1-n-s", "rb"],
  "thenceforth": ["dh-eh-n-s f-ao1-r-th", "cc"],
  "theocracy": ["th-iy aa1 k-r-ah s-iy", "nn"],
  "theologian": ["th-iy ah l-ow1 jh-iy ah-n", "nn"],
  "theological": ["th-iy ah l-aa1 jh-ih k-ah-l", "jj"],
  "theology": ["th-iy aa1 l-ah jh-iy", "nn"],
  "theorem": ["th-ih1 r-ah-m", "nn"],
  "theoretical": ["th-iy er eh1 t-ih k-ah-l", "jj"],
  "theoretically": ["th-iy er eh1 t-ih k-ah l-iy", "rb"],
  "theoretician": ["th-iy er ah t-ih1 sh-ah-n", "nn"],
  "theorist": ["th-iy1 er ih-s-t", "nn"],
  "theorize": ["th-iy1 er ay-z", "vbp vb"],
  "theorizing": ["th-iy1 er ay z-ih-ng", "nn"],
  "theory": ["th-ih1 r-iy", "nn"],
  "therapeutic": ["th-eh r-ah p-y-uw1 t-ih-k", "jj nn"],
  "therapist": ["th-eh1 r-ah p-ah-s-t", "nn"],
  "therapy": ["th-eh1 r-ah p-iy", "nn"],
  "there": ["dh-eh1-r", "rb uh nn ex"],
  "thermal": ["th-er1 m-ah-l", "jj"],
  "thermometer": ["th-er m-aa1 m-ah t-er", "nn"],
  "thermonuclear": ["th-er m-ow n-uw1 k-l-iy er", "jj"],
  "thermoplastic": ["th-er m-ah p-l-ae1 s-t-ih-k", "jj"],
  "thermos": ["th-er1 m-ah-s", "nn"],
  "thermostat": ["th-er1 m-ah s-t-ae-t", "nn"],
  "thesaurus": ["th-ah s-ao1 r-ah-s", "nn"],
  "these": ["dh-iy1-z", "dt"],
  "thesis": ["th-iy1 s-ah-s", "nn"],
  "thespian": ["th-eh1 s-p-iy ah-n", "jj"],
  "they": ["dh-ey1", "prp"],
  "thiamin": ["th-ay1 ah m-ah-n", "nn"],
  "thick": ["th-ih1-k", "jj nn rb"],
  "thicken": ["th-ih1 k-ah-n", "vb"],
  "thicker": ["th-ih1 k-er", "jjr"],
  "thicket": ["th-ih1 k-ih-t", "nn"],
  "thickly": ["th-ih1-k l-iy", "rb"],
  "thickness": ["th-ih1-k n-ah-s", "nn"],
  "thief": ["th-iy1-f", "nn"],
  "thieve": ["th-iy1-v", "vb"],
  "thieving": ["th-iy1 v-ih-ng", "vbg jj nn"],
  "thigh": ["th-ay1", "nn"],
  "thimble": ["th-ih1-m b-ah-l", "nn"],
  "thin": ["th-ih1-n", "jj rb vb"],
  "thine": ["dh-ay1-n", "jj"],
  "thing": ["th-ih1-ng", "nn"],
  "think": ["th-ih1-ng-k", "vbp vb nn"],
  "thinker": ["th-ih1-ng k-er", "nn"],
  "thinking": ["th-ih1-ng k-ih-ng", "vbg jj"],
  "thinly": ["th-ih1-n l-iy", "rb"],
  "thinner": ["th-ih1 n-er", "jjr nn"],
  "thinness": ["th-ih1-n n-ih-s", "nn"],
  "thinnest": ["th-ih1 n-ih-s-t", "jjs"],
  "third": ["th-er1-d", "nn jj rb"],
  "thirst": ["th-er1-s-t", "nn"],
  "thirsty": ["th-er1 s-t-iy", "jj"],
  "thirty": ["th-er1 t-iy", "cd"],
  "this": ["dh-ih1-s", "dt rb pdt"],
  "thistle": ["th-ih1 s-ah-l", "nn"],
  "thong": ["th-ao1-ng", "nn"],
  "thorn": ["th-ao1-r-n", "nn"],
  "thorny": ["th-ao1-r n-iy", "jj"],
  "thorough": ["th-er1 ow", "jj"],
  "thoroughbred": ["th-er1 ow b-r-eh1-d", "jj nn"],
  "thoroughfare": ["th-er1 ow f-eh-r", "nn"],
  "thoroughly": ["th-er1 ow l-iy", "rb"],
  "thoroughness": ["th-er1 ow n-ah-s", "nn"],
  "those": ["dh-ow1-z", "dt"],
  "though": ["dh-ow1", "in rb"],
  "thought": ["th-ao1-t", "vbd nn vbn"],
  "thoughtful": ["th-ao1-t f-ah-l", "jj"],
  "thoughtfully": ["th-ao1-t f-ah l-iy", "rb"],
  "thoughtless": ["th-ao1-t l-ah-s", "jj"],
  "thousand": ["th-aw1 z-ah-n-d", "nn"],
  "thousandth": ["th-aw1 z-ah-n-d-th", "jj"],
  "thrall": ["th-r-ao1-l", "nn"],
  "thrash": ["th-r-ae1-sh", "vb"],
  "thrashing": ["th-r-ae1 sh-ih-ng", "nn vbg"],
  "thread": ["th-r-eh1-d", "nn vb"],
  "threadbare": ["th-r-eh1-d b-eh-r", "jj"],
  "threat": ["th-r-eh1-t", "nn"],
  "threaten": ["th-r-eh1 t-ah-n", "vb vbp"],
  "threatened": ["th-r-eh1 t-ah-n-d", "vbn vbd jj"],
  "threatening": ["th-r-eh1 t-ah-n ih-ng", "vbg jj"],
  "threateningly": ["th-r-eh1 t-ah-n ih-ng l-iy", "rb"],
  "three": ["th-r-iy1", "cd"],
  "threefold": ["th-r-iy1 f-ow-l-d", "jj rb"],
  "threemonth": ["th-r-iy1 m-ah-n-th", "jj"],
  "threesome": ["th-r-iy1 s-ah-m", "nn"],
  "threshold": ["th-r-eh1-sh ow-l-d", "nn"],
  "threw": ["th-r-uw1", "vbd"],
  "thrice": ["th-r-ay1-s", "rb"],
  "thrift": ["th-r-ih1-f-t", "nn"],
  "thrifty": ["th-r-ih1-f t-iy", "jj"],
  "thrill": ["th-r-ih1-l", "nn vb"],
  "thrilled": ["th-r-ih1-l-d", "vbn jj vbd"],
  "thriller": ["th-r-ih1 l-er", "nn"],
  "thrilling": ["th-r-ih1 l-ih-ng", "jj"],
  "thrips": ["th-r-ih1-p-s", "nn"],
  "thrive": ["th-r-ay1-v", "vb vbp"],
  "thriving": ["th-r-ay1 v-ih-ng", "vbg jj"],
  "throat": ["th-r-ow1-t", "nn"],
  "throb": ["th-r-aa1-b", "vb"],
  "thrombosis": ["th-r-aa-m b-ow1 s-ah-s", "nn"],
  "throne": ["th-r-ow1-n", "nn"],
  "throng": ["th-r-ao1-ng", "nn vb vbp"],
  "throttle": ["th-r-aa1 t-ah-l", "nn vb"],
  "through": ["th-r-uw1", "in jj rb rp"],
  "throughout": ["th-r-uw aw1-t", "in rb"],
  "throughput": ["th-r-uw1 p-uh-t", "nn"],
  "throw": ["th-r-ow1", "vb vbp nn"],
  "throwaway": ["th-r-ow1 ah w-ey", "jj"],
  "throwback": ["th-r-ow1 b-ae-k", "nn"],
  "thrower": ["th-r-ow1 er", "nn"],
  "thrown": ["th-r-ow1-n", "vbn"],
  "thru": ["th-r-uw1", "nn in"],
  "thrust": ["th-r-ah1-s-t", "nn vbd vbn vb"],
  "thruway": ["th-r-uw1 w-ey", "nn"],
  "thud": ["th-ah1-d", "nn vb"],
  "thug": ["th-ah1-g", "nn"],
  "thumb": ["th-ah1-m", "nn vb"],
  "thumbnail": ["th-ah1-m n-ey-l", "nn"],
  "thump": ["th-ah1-m-p", "nn vb"],
  "thunder": ["th-ah1-n d-er", "nn vb vbp"],
  "thundering": ["th-ah1-n d-er ih-ng", "vbg jj"],
  "thunderous": ["th-ah1-n d-er ah-s", "jj"],
  "thunderstorm": ["th-ah1-n d-er s-t-ao-r-m", "nn"],
  "thunderstruck": ["th-ah1-n d-er s-t-r-ah-k", "jj"],
  "thus": ["dh-ah1-s", "rb"],
  "thwart": ["th-w-ao1-r-t", "vb nn rb"],
  "thyroid": ["th-ay1 r-oy-d", "nn"],
  "tick": ["t-ih1-k", "vb nn"],
  "ticked": ["t-ih1-k-t", "vbd vbn jj"],
  "ticker": ["t-ih1 k-er", "nn"],
  "ticket": ["t-ih1 k-ah-t", "nn vb"],
  "tickle": ["t-ih1-k-ah-l", "vb"],
  "ticklish": ["t-ih1 k-ah-l ih-sh", "jj"],
  "tidal": ["t-ay1 d-ah-l", "jj"],
  "tidbit": ["t-ih1-d b-ih-t", "nn"],
  "tide": ["t-ay1-d", "nn vb"],
  "tidewater": ["t-ay1-d w-ao t-er", "nn"],
  "tidy": ["t-ay1 d-iy", "jj"],
  "tie": ["t-ay1", "nn vbp vb"],
  "tied": ["t-ay1-d", "vbn jj vbd"],
  "tier": ["t-iy1-r", "nn"],
  "tiered": ["t-iy1-r-d", "jj"],
  "tiff": ["t-ih1-f", "nn"],
  "tiger": ["t-ay1 g-er", "nn"],
  "tight": ["t-ay1-t", "jj rb"],
  "tighten": ["t-ay1 t-ah-n", "vb vbp"],
  "tighter": ["t-ay1 t-er", "jjr rbr"],
  "tightest": ["t-ay1 t-ah-s-t", "jjs rbs"],
  "tightfisted": ["t-ay1-t f-ih1 s-t-ih-d", "jj"],
  "tightly": ["t-ay1-t l-iy", "rb"],
  "tightness": ["t-ay1-t n-ah-s", "nn"],
  "tightrope": ["t-ay1-t r-ow-p", "nn"],
  "tile": ["t-ay1-l", "nn vb"],
  "tiled": ["t-ay1-l-d", "jj vbn"],
  "till": ["t-ih1-l", "in vb"],
  "tiller": ["t-ih1 l-er", "nn"],
  "tilt": ["t-ih1-l-t", "vb"],
  "timber": ["t-ih1-m b-er", "nn vb"],
  "timberland": ["t-ih1-m b-er l-ae-n-d", "nn"],
  "timbre": ["t-ih1-m b-er", "nn"],
  "time": ["t-ay1-m", "nn vb"],
  "timed": ["t-ay1-m-d", "vbn vbd jj"],
  "timeless": ["t-ay1-m l-ah-s", "jj"],
  "timeliness": ["t-ay1-m l-iy n-ah-s", "nn"],
  "timely": ["t-ay1-m l-iy", "jj rb"],
  "timepiece": ["t-ay1-m p-iy-s", "nn"],
  "timer": ["t-ay1 m-er", "nn"],
  "times": ["t-ay1-m-z", "vbz cc rb"],
  "timetable": ["t-ay1-m t-ey b-ah-l", "nn"],
  "timid": ["t-ih1 m-ih-d", "jj"],
  "timidity": ["t-ah m-ih1 d-ah t-iy", "nn"],
  "timidly": ["t-ih1 m-ah-d l-iy", "rb"],
  "timing": ["t-ay1 m-ih-ng", "nn vbg"],
  "timorous": ["t-ih1 m-er ah-s", "jj"],
  "timpani": ["t-ih1-m p-ah n-iy", "nn"],
  "tin": ["t-ih1-n", "nn"],
  "tincture": ["t-ih1-ng-k ch-er", "nn"],
  "tinder": ["t-ih1-n d-er", "nn"],
  "tine": ["t-ay1-n", "nn"],
  "tingle": ["t-ih1-ng-g-ah-l", "vb"],
  "tinier": ["t-ay1 n-iy er", "nn"],
  "tiniest": ["t-ay1 n-iy ah-s-t", "jjs"],
  "tinker": ["t-ih1-ng k-er", "vb"],
  "tinkle": ["t-ih1-ng-k-ah-l", "vb"],
  "tinny": ["t-ih1 n-iy", "jj nn"],
  "tinsel": ["t-ih1-n s-ah-l", "nn"],
  "tint": ["t-ih1-n-t", "vb vbp nn"],
  "tinted": ["t-ih1-n t-ih-d", "vbn jj"],
  "tintype": ["t-ih1-n t-ay-p", "nn"],
  "tiny": ["t-ay1 n-iy", "jj"],
  "tip": ["t-ih1-p", "nn vb vbp"],
  "tipoff": ["t-ih1 p-ao-f", "nn"],
  "tipper": ["t-ih1 p-er", "nn"],
  "tipple": ["t-ih1 p-ah-l", "vb vbp"],
  "tipsy": ["t-ih1-p s-iy", "jj"],
  "tiptoe": ["t-ih1-p t-ow", "vb"],
  "tirade": ["t-ay r-ey1-d", "nn"],
  "tire": ["t-ay1 er", "nn vbp vb"],
  "tired": ["t-ay1 er-d", "vbn jj vbd"],
  "tireless": ["t-ay1 er l-ah-s", "jj"],
  "tirelessly": ["t-ay1-r l-ah-s l-iy", "rb"],
  "tiremaker": ["t-ay1-r m-ey k-er", "nn"],
  "tiresome": ["t-ay1 er s-ah-m", "jj"],
  "tissue": ["t-ih1 s-y-uw", "nn"],
  "titan": ["t-ay1 t-ah-n", "nn"],
  "titanate": ["t-ay1 t-ah n-ey-t", "nn"],
  "titanic": ["t-ay t-ae1 n-ih-k", "jj"],
  "titanium": ["t-ay t-ey1 n-iy ah-m", "nn"],
  "titillate": ["t-ih1-t-ah-l-ey-t", "vb"],
  "title": ["t-ay1 t-ah-l", "nn vb"],
  "titled": ["t-ay1 t-ah-l-d", "vbn jj vbd"],
  "titter": ["t-ih1 t-er", "nn vb vbp"],
  "titular": ["t-ih1 ch-ah l-er", "jj"],
  "to": ["t-uw1", "to rb"],
  "toad": ["t-ow1-d", "nn"],
  "toast": ["t-ow1-s-t", "nn vb"],
  "toaster": ["t-ow1 s-t-er", "nn"],
  "tobacco": ["t-ah b-ae1 k-ow", "nn"],
  "today": ["t-ah d-ey1", "nn jj rb"],
  "toddler": ["t-aa1-d l-er", "nn"],
  "toe": ["t-ow1", "nn"],
  "toehold": ["t-ow1 hh-ow-l-d", "nn"],
  "toenail": ["t-ow1 n-ey-l", "nn"],
  "toffee": ["t-aa1 f-iy", "nn"],
  "tofu": ["t-ow1 f-uw", "nn"],
  "toga": ["t-ow1 g-ah", "nn"],
  "together": ["t-ah g-eh1 dh-er", "rb in rp"],
  "togetherness": ["t-ah g-eh1 dh-er n-ah-s", "nn"],
  "toil": ["t-oy1-l", "vbp nn vb"],
  "toilet": ["t-oy1 l-ah-t", "nn"],
  "toiletry": ["t-oy1 l-ah t-r-iy", "nn"],
  "token": ["t-ow1 k-ah-n", "jj nn"],
  "told": ["t-ow1-l-d", "vbd vbn"],
  "tolerable": ["t-aa1 l-er ah b-ah-l", "jj"],
  "tolerance": ["t-aa1 l-er ah-n-s", "nn"],
  "tolerant": ["t-aa1 l-er ah-n-t", "jj"],
  "tolerate": ["t-aa1 l-er ey-t", "vb vbp"],
  "tolerating": ["t-aa1 l-er ey t-ih-ng", "vbg jj"],
  "toleration": ["t-aa l-er ey1 sh-ah-n", "nn"],
  "toll": ["t-ow1-l", "nn vb"],
  "tomato": ["t-ah m-ey1 t-ow", "nn"],
  "tomb": ["t-uw1-m", "nn"],
  "tomblike": ["t-uw1-m l-ay-k", "jj"],
  "tombstone": ["t-uw1-m s-t-ow-n", "nn"],
  "tome": ["t-ow1-m", "nn"],
  "tomorrow": ["t-ah m-aa1 r-ow", "nn jj rb"],
  "ton": ["t-ah1-n", "nn"],
  "tonal": ["t-ow1 n-ah-l", "jj"],
  "tonality": ["t-ow n-ae1 l-ah t-iy", "nn"],
  "tone": ["t-ow1-n", "nn vb"],
  "toner": ["t-ow1 n-er", "nn"],
  "tongs": ["t-aa1-ng-z", "nn"],
  "tongue": ["t-ah1-ng", "nn vb"],
  "tongued": ["t-ah1-ng-d", "vbd jj"],
  "tonic": ["t-aa1 n-ih-k", "nn"],
  "tonight": ["t-ah n-ay1-t", "rb nn"],
  "tonnage": ["t-ah1 n-ah-jh", "nn"],
  "tonsil": ["t-aa1-n s-ah-l", "nn"],
  "tony": ["t-ow1 n-iy", "jj"],
  "too": ["t-uw1", "rb"],
  "took": ["t-uh1-k", "vbd"],
  "tool": ["t-uw1-l", "nn vb"],
  "tooth": ["t-uw1-th", "nn rb"],
  "toothbrush": ["t-uw1-th b-r-ah-sh", "nn"],
  "toothless": ["t-uw1-th l-ah-s", "jj"],
  "toothpaste": ["t-uw1-th p-ey-s-t", "nn"],
  "top": ["t-aa1-p", "jj nn vbp rb vb"],
  "topaz": ["t-ow1 p-ae-z", "nn"],
  "topiary": ["t-ow1 p-iy eh r-iy", "jj"],
  "topic": ["t-aa1 p-ih-k", "nn"],
  "topical": ["t-aa1 p-ah k-ah-l", "jj"],
  "topless": ["t-aa1-p l-ah-s", "jj"],
  "topographic": ["t-aa p-ah g-r-ae1 f-ih-k", "jj"],
  "topography": ["t-ah p-aa1 g-r-ah f-iy", "nn"],
  "topper": ["t-aa1 p-er", "nn"],
  "topple": ["t-aa1 p-ah-l", "vb"],
  "topsoil": ["t-aa1-p s-oy-l", "nn"],
  "torch": ["t-ao1-r-ch", "nn vb"],
  "tore": ["t-ao1-r", "vbd vbn"],
  "torment": ["t-ao1-r m-eh-n-t", "nn vb"],
  "tormented": ["t-ao1-r m-eh-n t-ih-d", "vbn jj"],
  "tormentor": ["t-ao1-r m-eh-n t-er", "nn"],
  "torn": ["t-ao1-r-n", "vbn jj"],
  "tornado": ["t-ao-r n-ey1 d-ow", "nn"],
  "torpedo": ["t-ao-r p-iy1 d-ow", "vb nn"],
  "torpid": ["t-ao1-r p-ah-d", "jj"],
  "torpor": ["t-ao1-r p-er", "nn"],
  "torque": ["t-ao1-r-k", "nn"],
  "torrent": ["t-ao1 r-ah-n-t", "nn"],
  "torrid": ["t-ao1 r-ah-d", "jj"],
  "torso": ["t-ao1-r s-ow", "nn"],
  "tort": ["t-ao1-r-t", "nn"],
  "tortilla": ["t-ao-r t-iy1 ah", "nn"],
  "tortoise": ["t-ao1-r t-ah-s", "nn"],
  "tortuous": ["t-ao1-r ch-ah-w ah-s", "jj"],
  "torture": ["t-ao1-r ch-er", "nn vbp vb"],
  "tortured": ["t-ao1-r ch-er-d", "vbn jj vbd"],
  "toss": ["t-ao1-s", "vb nn vbp"],
  "tossed": ["t-ao1-s-t", "vbd vbn jj"],
  "total": ["t-ow1 t-ah-l", "jj nn vb vbp"],
  "totalitarian": ["t-ow t-ae l-ih t-eh1 r-iy ah-n", "jj"],
  "totalitarianism": ["t-ow t-ae l-ah t-eh1 r-iy ah n-ih z-ah-m", "nn"],
  "totality": ["t-ow t-ae1 l-ah t-iy", "nn"],
  "totally": ["t-ow1 t-ah-l iy", "rb"],
  "tote": ["t-ow1-t", "vb"],
  "totem": ["t-ow1 t-ah-m", "nn"],
  "totter": ["t-aa1-t-er", "vb"],
  "tottering": ["t-aa1 t-er ih-ng", "jj vbg"],
  "touch": ["t-ah1-ch", "nn rb vb vbp"],
  "touchdown": ["t-ah1-ch d-aw-n", "nn"],
  "touching": ["t-ah1 ch-ih-ng", "vbg jj nn"],
  "touchstone": ["t-ah1-ch s-t-ow-n", "nn"],
  "touchy": ["t-ah1 ch-iy", "jj"],
  "tough": ["t-ah1-f", "jj rb vb"],
  "toughen": ["t-ah1 f-ah-n", "vb"],
  "tougher": ["t-ah1 f-er", "jjr rbr"],
  "toughest": ["t-ah1 f-ah-s-t", "jjs"],
  "toughness": ["t-ah1-f n-ah-s", "nn"],
  "tour": ["t-uh1-r", "nn vb"],
  "touring": ["t-uh1 r-ih-ng", "vbg jj nn"],
  "tourism": ["t-uh1 r-ih z-ah-m", "nn"],
  "tourist": ["t-uh1 r-ah-s-t", "nn"],
  "tournament": ["t-uh1-r n-ah m-ah-n-t", "nn"],
  "tourney": ["t-er1 n-iy", "nn"],
  "tout": ["t-aw1-t", "vb nn"],
  "tow": ["t-ow1", "nn vb"],
  "toward": ["t-ah w-ao1-r-d", "in"],
  "towards": ["t-ah w-ao1-r-d-z", "in"],
  "towel": ["t-aw1 ah-l", "nn"],
  "toweling": ["t-aw1 ah-l ih-ng", "nn"],
  "tower": ["t-aw1 er", "nn vb"],
  "towering": ["t-aw1 er ih-ng", "jj vbg"],
  "town": ["t-aw1-n", "nn"],
  "townhouse": ["t-aw1-n hh-aw-s", "nn"],
  "toxic": ["t-aa1-k s-ih-k", "jj nn"],
  "toxicity": ["t-aa-k s-ih1 s-ah t-iy", "nn"],
  "toxicologist": ["t-aa-k s-ih k-aa1 l-ah jh-ih-s-t", "nn"],
  "toxicology": ["t-aa-k s-ih k-aa1 l-ah jh-iy", "nn"],
  "toxin": ["t-aa1-k s-ah-n", "nn"],
  "toy": ["t-oy1", "nn vb"],
  "trace": ["t-r-ey1-s", "nn jj vb"],
  "traceable": ["t-r-ey1 s-ah b-ah-l", "jj"],
  "tracer": ["t-r-ey1 s-er", "nn"],
  "trachea": ["t-r-ey1 k-iy ah", "nn"],
  "tracing": ["t-r-ey1 s-ih-ng", "vbg jj nn"],
  "track": ["t-r-ae1-k", "nn vbp vb"],
  "trackage": ["t-r-ae1 k-ih-jh", "nn"],
  "tracked": ["t-r-ae1-k-t", "vbn vbd jj"],
  "tract": ["t-r-ae1-k-t", "nn"],
  "tractor": ["t-r-ae1-k t-er", "nn"],
  "trade": ["t-r-ey1-d", "nn vbp vb"],
  "tradeable": ["t-r-ey1 d-ah b-ah-l", "jj"],
  "traded": ["t-r-ey1 d-ih-d", "vbn vbd jj"],
  "trademark": ["t-r-ey1-d m-aa-r-k", "nn"],
  "tradeoff": ["t-r-ey1 d-ao-f", "nn"],
  "trader": ["t-r-ey1 d-er", "nn"],
  "trading": ["t-r-ey1 d-ih-ng", "vbg jj"],
  "tradition": ["t-r-ah d-ih1 sh-ah-n", "nn"],
  "traditional": ["t-r-ah d-ih1 sh-ah n-ah-l", "jj"],
  "traditionalist": ["t-r-ah d-ih1 sh-ah-n ah l-ih-s-t", "nn"],
  "traditionally": ["t-r-ah d-ih1 sh-ah-n ah l-iy", "rb"],
  "traffic": ["t-r-ae1 f-ih-k", "nn vb"],
  "trafficker": ["t-r-ae1 f-ih k-er", "nn"],
  "tragedy": ["t-r-ae1 jh-ah d-iy", "nn"],
  "tragic": ["t-r-ae1 jh-ih-k", "jj nn"],
  "tragically": ["t-r-ae1 jh-ih-k l-iy", "rb"],
  "tragicomic": ["t-r-ae jh-ih k-aa1 m-ih-k", "jj nn"],
  "trail": ["t-r-ey1-l", "nn vbp vb"],
  "trailer": ["t-r-ey1 l-er", "nn"],
  "train": ["t-r-ey1-n", "nn vb vbp"],
  "trained": ["t-r-ey1-n-d", "vbn vbd jj"],
  "trainer": ["t-r-ey1 n-er", "nn"],
  "training": ["t-r-ey1 n-ih-ng", "vbg jj"],
  "traipse": ["t-r-ey1-p-s", "vb"],
  "trait": ["t-r-ey1-t", "nn"],
  "traitor": ["t-r-ey1 t-er", "nn"],
  "traitorous": ["t-r-ey1 t-er ah-s", "jj"],
  "trajectory": ["t-r-ah jh-eh1-k t-er iy", "nn"],
  "trammel": ["t-r-ae1 m-ah-l", "vb"],
  "tramp": ["t-r-ae1-m-p", "jj nn vb"],
  "trample": ["t-r-ae1-m p-ah-l", "vb"],
  "trance": ["t-r-ae1-n-s", "nn"],
  "tranquil": ["t-r-ae1-ng k-w-ah-l", "jj"],
  "tranquility": ["t-r-ae-ng k-w-ih1 l-ih t-iy", "nn"],
  "tranquilizer": ["t-r-ae1-ng k-w-ah l-ay z-er", "nn"],
  "tranquilizing": ["t-r-ae1-ng k-w-ah l-ay z-ih-ng", "jj"],
  "transact": ["t-r-ae-n z-ae1-k-t", "vb"],
  "transaction": ["t-r-ae-n z-ae1-k sh-ah-n", "nn"],
  "transatlantic": ["t-r-ae-n-z ah-t l-ae1-n t-ih-k", "jj nn"],
  "transcend": ["t-r-ae-n s-eh1-n-d", "vb"],
  "transcendence": ["t-r-ae-n s-eh1-n d-ah-n-s", "nn"],
  "transcendent": ["t-r-ae-n s-eh1-n d-ah-n-t", "jj"],
  "transcendental": ["t-r-ae-n s-ah-n d-eh1-n t-ah-l", "jj"],
  "transcribe": ["t-r-ae-n s-k-r-ay1-b", "vb vbp"],
  "transcribed": ["t-r-ae-n s-k-r-ay1-b-d", "vbn jj"],
  "transcript": ["t-r-ae1-n s-k-r-ih-p-t", "nn"],
  "transcription": ["t-r-ae-n s-k-r-ih1-p sh-ah-n", "nn"],
  "transducer": ["t-r-ae-n-s d-uw1 s-er", "nn"],
  "transfer": ["t-r-ae-n-s f-er1", "nn vb vbp"],
  "transferable": ["t-r-ae-n-s f-er1 ah b-ah-l", "jj"],
  "transferrable": ["t-r-ae-n-s f-er1 ah b-ah-l", "jj"],
  "transferred": ["t-r-ae-n-s f-er1-d", "vbn vbd jj"],
  "transform": ["t-r-ae-n-s f-ao1-r-m", "vb vbp"],
  "transformation": ["t-r-ae-n-s f-er m-ey1 sh-ah-n", "nn"],
  "transformed": ["t-r-ae-n-s f-ao1-r-m-d", "vbn jj vbd"],
  "transformer": ["t-r-ae-n-s f-ao1-r m-er", "nn"],
  "transfuse": ["t-r-ae-n-s-f-y-uw1-z", "vb"],
  "transfusion": ["t-r-ae-n-s f-y-uw1 zh-ah-n", "nn"],
  "transgenic": ["t-r-ae-n-z jh-eh1 n-ih-k", "jj"],
  "transgression": ["t-r-ae-n-z g-r-eh1 sh-ah-n", "nn"],
  "transience": ["t-r-ae1-n z-iy ah-n-s", "nn"],
  "transient": ["t-r-ae1-n zh-ah-n-t", "jj"],
  "transistor": ["t-r-ae-n z-ih1 s-t-er", "nn"],
  "transit": ["t-r-ae1-n z-ah-t", "nn jj"],
  "transition": ["t-r-ae-n z-ih1 sh-ah-n", "nn"],
  "transitional": ["t-r-ae-n s-ih1 sh-ah n-ah-l", "jj"],
  "transitory": ["t-r-ae1-n z-ah t-ao r-iy", "jj"],
  "translate": ["t-r-ae-n-z l-ey1-t", "vb vbp"],
  "translation": ["t-r-ae-n-z l-ey1 sh-ah-n", "nn"],
  "translator": ["t-r-ae-n-s l-ey1 t-er", "nn"],
  "translucent": ["t-r-ae-n-s l-uw1 s-ah-n-t", "jj"],
  "transmission": ["t-r-ae-n-s m-ih1 sh-ah-n", "nn"],
  "transmit": ["t-r-ae-n-z m-ih1-t", "vb vbp"],
  "transmittable": ["t-r-ae-n-z m-ih1 t-ah b-ah-l", "jj"],
  "transmitted": ["t-r-ae-n-s m-ih1 t-ih-d", "vbn jj vbd"],
  "transmitter": ["t-r-ae-n-s m-ih1 t-er", "nn"],
  "transnational": ["t-r-ae-n-s n-ae1 sh-ah n-ah-l", "jj"],
  "transoceanic": ["t-r-ae-n-z ow sh-iy ae1 n-ih-k", "jj"],
  "transparency": ["t-r-ae-n s-p-eh1 r-ah-n s-iy", "nn"],
  "transparent": ["t-r-ae-n s-p-eh1 r-ah-n-t", "jj nn"],
  "transparently": ["t-r-ae-n s-p-eh1 r-ah-n-t l-iy", "rb"],
  "transpire": ["t-r-ae-n-s-p-ay1-er", "vb"],
  "transplant": ["t-r-ae-n-s p-l-ae1-n-t", "nn vbp vb"],
  "transplantation": ["t-r-ae-n-z p-l-ae-n t-ey1 sh-ah-n", "nn"],
  "transplanted": ["t-r-ae-n-s p-l-ae1-n t-ih-d", "vbn jj"],
  "transponder": ["t-r-ae-n-s p-aa1-n d-er", "nn"],
  "transport": ["t-r-ae-n-s p-ao1-r-t", "nn vbp vb"],
  "transportable": ["t-r-ae-n-s p-ao1-r t-ah b-ah-l", "jj"],
  "transportation": ["t-r-ae-n-s p-er t-ey1 sh-ah-n", "nn"],
  "transporter": ["t-r-ae-n-s p-ao1-r t-er", "nn"],
  "transpose": ["t-r-ae-n-s-p-ow1-z", "vb"],
  "transverse": ["t-r-ae-n-z v-er1-s", "jj nn"],
  "trap": ["t-r-ae1-p", "nn vb"],
  "trapeze": ["t-r-ah p-iy1-z", "nn"],
  "trapped": ["t-r-ae1-p-t", "vbn vbd jj"],
  "trash": ["t-r-ae1-sh", "nn vb"],
  "trauma": ["t-r-ao1 m-ah", "nn"],
  "traumatic": ["t-r-ao m-ae1 t-ih-k", "jj"],
  "traumatize": ["t-r-ao1-m-ah-t-ay-z", "vb"],
  "travail": ["t-r-ah v-ey1-l", "nn"],
  "travel": ["t-r-ae1 v-ah-l", "nn vbp vb"],
  "traveled": ["t-r-ae1 v-ah-l-d", "vbd jj vbn"],
  "traveler": ["t-r-ae1 v-ah l-er", "nn"],
  "travelled": ["t-r-ae1 v-ah-l-d", "jj vbd vbn"],
  "traveller": ["t-r-ae1 v-ah l-er", "nn"],
  "travelogue": ["t-r-ae1 v-ah l-ao-g", "nn"],
  "traverse": ["t-r-ae1 v-er-s", "vb"],
  "travesty": ["t-r-ae1 v-ah s-t-iy", "nn vb"],
  "trawler": ["t-r-ao1 l-er", "nn"],
  "tray": ["t-r-ey1", "nn"],
  "treacherous": ["t-r-eh1 ch-er ah-s", "jj"],
  "treachery": ["t-r-eh1 ch-er iy", "nn"],
  "tread": ["t-r-eh1-d", "vb nn"],
  "treadmill": ["t-r-eh1-d m-ih-l", "nn"],
  "treason": ["t-r-iy1 z-ah-n", "nn"],
  "treasure": ["t-r-eh1 zh-er", "nn vb vbp"],
  "treasured": ["t-r-eh1 zh-er-d", "vbn jj"],
  "treasurer": ["t-r-eh1 zh-er er", "nn"],
  "treasury": ["t-r-eh1 zh-er iy", "nn"],
  "treat": ["t-r-iy1-t", "vb vbp nn"],
  "treatable": ["t-r-iy1 t-ah b-ah-l", "jj"],
  "treatise": ["t-r-iy1 t-ah-s", "nn"],
  "treatment": ["t-r-iy1-t m-ah-n-t", "nn"],
  "treaty": ["t-r-iy1 t-iy", "nn"],
  "treble": ["t-r-eh1 b-ah-l", "jj nn vb"],
  "tree": ["t-r-iy1", "nn"],
  "treeless": ["t-r-iy1 l-ah-s", "jj"],
  "trek": ["t-r-eh1-k", "nn vb vbp"],
  "tremble": ["t-r-eh1-m b-ah-l", "vb nn"],
  "trembling": ["t-r-eh1-m b-ah-l ih-ng", "vbg jj"],
  "tremendous": ["t-r-ah m-eh1-n d-ah-s", "jj"],
  "tremendously": ["t-r-ah m-eh1-n d-ah-s l-iy", "rb"],
  "tremor": ["t-r-eh1 m-er", "nn"],
  "tremulous": ["t-r-eh1 m-y-ah l-ah-s", "jj"],
  "tremulously": ["t-r-eh1 m-y-ah l-ah-s l-iy", "rb"],
  "trench": ["t-r-eh1-n-ch", "nn"],
  "trenchant": ["t-r-eh1-n ch-ah-n-t", "jj"],
  "trend": ["t-r-eh1-n-d", "nn vb"],
  "trendier": ["t-r-eh1-n d-y-er", "jjr"],
  "trendiest": ["t-r-eh-n d-iy1-s-t", "jjs"],
  "trendsetter": ["t-r-eh1-n-d s-eh t-er", "nn"],
  "trendy": ["t-r-eh1-n d-iy", "jj"],
  "trepidation": ["t-r-eh p-ih d-ey1 sh-ah-n", "nn"],
  "trespass": ["t-r-eh1-s p-ae-s", "nn vb vbp"],
  "tress": ["t-r-eh1-s", "nn"],
  "trestle": ["t-r-eh1 s-ah-l", "nn"],
  "triad": ["t-r-ay1 ae-d", "nn jj"],
  "triage": ["t-r-ay1 ih-jh", "nn"],
  "trial": ["t-r-ay1 ah-l", "nn vb"],
  "triangle": ["t-r-ay1 ae-ng g-ah-l", "nn"],
  "triangular": ["t-r-ay ae1-ng g-y-ah l-er", "jj"],
  "tribal": ["t-r-ay1 b-ah-l", "jj"],
  "tribe": ["t-r-ay1-b", "nn"],
  "tribunal": ["t-r-ah b-y-uw1 n-ah-l", "nn"],
  "tribute": ["t-r-ih1 b-y-uw-t", "nn"],
  "trick": ["t-r-ih1-k", "nn vb"],
  "trickery": ["t-r-ih1 k-er iy", "nn"],
  "trickier": ["t-r-ih1 k-iy er", "jjr"],
  "trickiest": ["t-r-ih1 k-iy ah-s-t", "jjs"],
  "trickle": ["t-r-ih1 k-ah-l", "nn vb vbp"],
  "tricky": ["t-r-ih1 k-iy", "jj"],
  "tried": ["t-r-ay1-d", "vbd jj vbn"],
  "triennial": ["t-r-ay eh1 n-iy ah-l", "nn"],
  "trifle": ["t-r-ay1 f-ah-l", "nn jj rb vb"],
  "trifling": ["t-r-ay1 f-l-ih-ng", "jj"],
  "trigger": ["t-r-ih1 g-er", "vb nn vbp"],
  "triggered": ["t-r-ih1 g-er-d", "vbn vbd jj"],
  "triglyceride": ["t-r-ay g-l-ih1 s-er ay-d", "nn"],
  "trilateral": ["t-r-ay l-ae1 t-er ah-l", "jj"],
  "trillion": ["t-r-ih1 l-y-ah-n", "nn"],
  "trilogy": ["t-r-ih1 l-ah jh-iy", "nn"],
  "trim": ["t-r-ih1-m", "vb jj nn"],
  "trimester": ["t-r-ay m-eh1 s-t-er", "nn"],
  "trimmed": ["t-r-ih1-m-d", "vbn rbr vbd jj"],
  "trimmer": ["t-r-ih1 m-er", "jjr"],
  "trinket": ["t-r-ih1-ng k-ah-t", "nn"],
  "trio": ["t-r-iy1 ow", "nn"],
  "trip": ["t-r-ih1-p", "nn vb"],
  "tripartite": ["t-r-ay p-aa1-r t-ay-t", "jj"],
  "tripe": ["t-r-ay1-p", "nn"],
  "triple": ["t-r-ih1 p-ah-l", "jj nn rb vb"],
  "triplet": ["t-r-ih1 p-l-ah-t", "nn"],
  "tripod": ["t-r-ay1 p-aa-d", "nn"],
  "triptych": ["t-r-ih1-p t-ih-k", "nn"],
  "trite": ["t-r-ay1-t", "jj"],
  "triumph": ["t-r-ay1 ah-m-f", "nn vb"],
  "triumphant": ["t-r-ay ah1-m f-ah-n-t", "jj"],
  "triumphantly": ["t-r-ay ah1-m f-ah-n-t l-iy", "rb"],
  "triumvirate": ["t-r-ay ah1-m v-er ah-t", "nn"],
  "trivia": ["t-r-ih1 v-iy ah", "nn"],
  "trivial": ["t-r-ih1 v-iy ah-l", "jj nn"],
  "triviality": ["t-r-ih v-iy ae1 l-ah t-iy", "nn"],
  "trivialize": ["t-r-ih1 v-iy ah l-ay-z", "vb"],
  "troika": ["t-r-oy1 k-ah", "nn"],
  "trolley": ["t-r-aa1 l-iy", "nn"],
  "trombone": ["t-r-aa-m b-ow1-n", "nn"],
  "trombonist": ["t-r-aa-m b-ow1 n-ih-s-t", "nn"],
  "troop": ["t-r-uw1-p", "nn vb vbp"],
  "trooper": ["t-r-uw1 p-er", "nn"],
  "trophy": ["t-r-ow1 f-iy", "nn"],
  "tropic": ["t-r-aa1 p-ih-k", "nn"],
  "tropical": ["t-r-aa1 p-ih k-ah-l", "jj nn"],
  "trot": ["t-r-aa1-t", "nn vb"],
  "trotter": ["t-r-aa1 t-er", "nn"],
  "trouble": ["t-r-ah1 b-ah-l", "nn vbp jj vb"],
  "troubled": ["t-r-ah1 b-ah-l-d", "jj vbd vbn"],
  "troublemaker": ["t-r-ah1 b-ah-l m-ey k-er", "nn"],
  "troubleshooter": ["t-r-ah1 b-ah-l sh-uw t-er", "nn"],
  "troublesome": ["t-r-ah1 b-ah-l s-ah-m", "jj"],
  "troubling": ["t-r-ah1 b-ah-l ih-ng", "jj vbg"],
  "trough": ["t-r-ao1-f", "nn"],
  "trounce": ["t-r-aw1-n-s", "vb"],
  "trouncing": ["t-r-aw1-n s-ih-ng", "nn"],
  "troup": ["t-r-uw1-p", "nn"],
  "troupe": ["t-r-uw1-p", "nn"],
  "trouser": ["t-r-aw1 z-er", "nn"],
  "trout": ["t-r-aw1-t", "nn"],
  "trove": ["t-r-ow1-v", "nn"],
  "truce": ["t-r-uw1-s", "nn"],
  "truck": ["t-r-ah1-k", "nn vb vbp"],
  "trucker": ["t-r-ah1 k-er", "nn"],
  "truckload": ["t-r-ah1 k-l-ow-d", "nn"],
  "truculent": ["t-r-ah1 k-y-ah l-ah-n-t", "jj"],
  "trudge": ["t-r-ah1-jh", "nn vb"],
  "true": ["t-r-uw1", "jj"],
  "truer": ["t-r-uw1 er", "jjr"],
  "truest": ["t-r-uw1 ih-s-t", "jjs"],
  "truism": ["t-r-uw1 ih z-ah-m", "nn"],
  "truly": ["t-r-uw1 l-iy", "rb"],
  "trump": ["t-r-ah1-m-p", "nn vb"],
  "trumpet": ["t-r-ah1-m p-ah-t", "nn vb"],
  "trumpeter": ["t-r-ah1-m p-ah t-er", "nn"],
  "truncate": ["t-r-ah1-ng-k-ey-t", "vb"],
  "truncated": ["t-r-ah1-ng k-ey t-ih-d", "vbn jj"],
  "truncheon": ["t-r-ah1-n ch-ih-n", "nn"],
  "trundle": ["t-r-ah1-n d-ah-l", "nn vb vbp"],
  "trunk": ["t-r-ah1-ng-k", "nn"],
  "truss": ["t-r-ah1-s", "nn vb"],
  "trust": ["t-r-ah1-s-t", "nn vbp vb"],
  "trusted": ["t-r-ah1 s-t-ih-d", "vbn vbd jj"],
  "trustee": ["t-r-ah s-t-iy1", "nn"],
  "trusteeship": ["t-r-ah s-t-iy1 sh-ih-p", "nn"],
  "trusting": ["t-r-ah1 s-t-ih-ng", "jj vbg"],
  "trustworthy": ["t-r-ah1-s-t w-er dh-iy", "jj"],
  "truth": ["t-r-uw1-th", "nn"],
  "truthful": ["t-r-uw1-th f-ah-l", "jj"],
  "truthfully": ["t-r-uw1-th f-ah l-iy", "rb"],
  "truthfulness": ["t-r-uw1-th f-ah-l n-ah-s", "nn"],
  "try": ["t-r-ay1", "vb vbp nn"],
  "trying": ["t-r-ay1 ih-ng", "vbg jj nn"],
  "tryout": ["t-r-ay1 aw-t", "nn"],
  "tryst": ["t-r-ay1-s-t", "nn"],
  "tsunami": ["t-s-uw n-aa1 m-iy", "nn"],
  "tub": ["t-ah1-b", "nn"],
  "tuba": ["t-uw1 b-ah", "nn"],
  "tube": ["t-uw1-b", "nn"],
  "tuberculosis": ["t-ah b-er k-y-ah l-ow1 s-ih-s", "nn"],
  "tubing": ["t-uw1 b-ih-ng", "nn"],
  "tubular": ["t-uw1 b-y-ah l-er", "jj"],
  "tuck": ["t-ah1-k", "vbp vb"],
  "tuft": ["t-ah1-f-t", "nn"],
  "tug": ["t-ah1-g", "nn vb"],
  "tugboat": ["t-ah1-g b-ow-t", "nn"],
  "tuition": ["t-y-uw ih1 sh-ah-n", "nn"],
  "tulip": ["t-uw1 l-ah-p", "nn"],
  "tumble": ["t-ah1-m b-ah-l", "nn vb"],
  "tumbled": ["t-ah1-m b-ah-l-d", "vbd vbn jj"],
  "tumbler": ["t-ah1-m b-l-er", "nn"],
  "tummy": ["t-ah1 m-iy", "nn"],
  "tumor": ["t-uw1 m-er", "nn"],
  "tumult": ["t-uw1 m-ah-l-t", "nn"],
  "tumultuous": ["t-uw m-ah1-l ch-uw ah-s", "jj"],
  "tuna": ["t-uw1 n-ah", "nn"],
  "tundra": ["t-ah1-n d-r-ah", "nn"],
  "tune": ["t-uw1-n", "nn vb vbp"],
  "tuned": ["t-uw1-n-d", "vbn jj vbd"],
  "tuneful": ["t-uw1-n f-ah-l", "jj"],
  "tung": ["t-ah1-ng", "nn"],
  "tungsten": ["t-ah1-ng s-t-ah-n", "nn"],
  "tunic": ["t-uw1 n-ih-k", "nn"],
  "tunnel": ["t-ah1 n-ah-l", "nn vb vbp"],
  "turban": ["t-er1 b-ah-n", "nn"],
  "turbine": ["t-er1 b-ay-n", "nn jj"],
  "turbo": ["t-er1 b-ow", "nn"],
  "turbofan": ["t-er1 b-ow f-ae-n", "nn"],
  "turboprop": ["t-er1 b-ow p-r-aa-p", "nn"],
  "turbulence": ["t-er1 b-y-ah l-ah-n-s", "nn"],
  "turbulent": ["t-er1 b-y-ah l-ah-n-t", "jj"],
  "turf": ["t-er1-f", "nn jj"],
  "turgid": ["t-er1 jh-ih-d", "jj"],
  "turkey": ["t-er1 k-iy", "nn jj"],
  "turmoil": ["t-er1 m-oy-l", "nn"],
  "turn": ["t-er1-n", "vb nn rb vbp"],
  "turnabout": ["t-er1-n ah b-aw-t", "nn"],
  "turnaround": ["t-er1 n-er aw-n-d", "nn"],
  "turning": ["t-er1 n-ih-ng", "vbg jj nn"],
  "turnip": ["t-er1 n-ah-p", "nn"],
  "turnkey": ["t-er1-n k-iy", "nn"],
  "turnoff": ["t-er1 n-ao-f", "nn"],
  "turnout": ["t-er1-n aw-t", "nn"],
  "turnover": ["t-er1-n ow v-er", "nn"],
  "turnpike": ["t-er1-n p-ay-k", "nn"],
  "turntable": ["t-er1-n t-ey b-ah-l", "nn"],
  "turpentine": ["t-er1 p-ah-n t-ay-n", "nn"],
  "turquoise": ["t-er1 k-w-oy-z", "jj nn"],
  "turret": ["t-er1 ah-t", "nn jj"],
  "turtle": ["t-er1 t-ah-l", "nn"],
  "turtleneck": ["t-er1 t-ah-l n-eh-k", "nn"],
  "tusk": ["t-ah1-s-k", "nn"],
  "tussle": ["t-ah1 s-ah-l", "nn vb"],
  "tutelage": ["t-y-uw1 t-ih l-ih-jh", "nn"],
  "tutor": ["t-uw1 t-er", "nn vb"],
  "tutorial": ["t-uw t-ao1 r-iy ah-l", "nn"],
  "tuxedo": ["t-ah-k s-iy1 d-ow", "nn"],
  "twaddle": ["t-w-aa1 d-ah-l", "nn"],
  "twang": ["t-w-aa1-ng", "nn"],
  "twangy": ["t-w-aa1-n jh-iy", "jj"],
  "tweak": ["t-w-iy1-k", "vb"],
  "tweed": ["t-w-iy1-d", "nn"],
  "tweedy": ["t-w-iy1 d-iy", "jj"],
  "tweezer": ["t-w-iy1 z-er", "nn"],
  "twenty": ["t-w-eh1-n t-iy", "cd nn"], //#HWF
  "twice": ["t-w-ay1-s", "rb jj"],
  "twig": ["t-w-ih1-g", "nn"],
  "twilight": ["t-w-ay1 l-ay-t", "nn"],
  "twin": ["t-w-ih1-n", "jj nn"],
  "twine": ["t-w-ay1-n", "nn vb"],
  "twinge": ["t-w-ih1-n-jh", "nn"],
  "twinjet": ["t-w-ih1-n jh-eh-t", "nn"],
  "twinkle": ["t-w-ih1-ng k-ah-l", "nn vb"],
  "twirl": ["t-w-er1-l", "vb"],
  "twirler": ["t-w-er1 l-er", "nn"],
  "twist": ["t-w-ih1-s-t", "nn vbp vb"],
  "twisted": ["t-w-ih1 s-t-ah-d", "vbn jj vbd"],
  "twister": ["t-w-ih1 s-t-er", "nn"],
  "twisty": ["t-w-ih1 s-t-iy", "jj"],
  "twitch": ["t-w-ih1-ch", "nn vb"],
  "two": ["t-uw1", "cd"],
  "twosome": ["t-uw1 s-ah-m", "nn"],
  "tycoon": ["t-ay k-uw1-n", "nn"],
  "tyke": ["t-ay1-k", "nn"],
  "type": ["t-ay1-p", "nn vb"],
  "typecast": ["t-ay1-p k-ae-s-t", "vb"],
  "typed": ["t-ay1-p-t", "vbn jj vbd"],
  "typeface": ["t-ay1-p f-ey s-ah", "nn"],
  "typesetting": ["t-ay1-p s-eh t-ih-ng", "nn"],
  "typewriter": ["t-ay1-p r-ay t-er", "nn"],
  "typewriting": ["t-ay1-p r-ay t-ih-ng", "nn"],
  "typewritten": ["t-ay1-p r-ih t-ah-n", "jj vbn"],
  "typhoid": ["t-ay1 f-oy-d", "nn"],
  "typhoon": ["t-ay f-uw1-n", "nn"],
  "typhus": ["t-ay1 f-ah-s", "nn"],
  "typical": ["t-ih1 p-ah k-ah-l", "jj"],
  "typically": ["t-ih1 p-ih-k l-iy", "rb"],
  "typify": ["t-ih1 p-ah f-ay", "vbp vb"],
  "typist": ["t-ay1 p-ih-s-t", "nn"],
  "typographical": ["t-ay p-ah g-r-ae1 f-ih k-ah-l", "jj"],
  "typography": ["t-ah p-aa1 g-r-ah f-iy", "nn"],
  "tyrannical": ["t-er ae1 n-ih k-ah-l", "jj"],
  "tyranny": ["t-ih1 r-ah n-iy", "nn"],
  "tyrant": ["t-ay1 r-ah-n-t", "nn"],
  "ubiquitous": ["y-uw b-ih1 k-w-ih t-ah-s", "jj"],
  "ubiquity": ["y-uw b-ih1 k-w-ih t-iy", "nn"],
  "uglier": ["ah1-g l-iy er", "jjr"],
  "ugliness": ["ah1-g l-iy n-ah-s", "nn"],
  "ugly": ["ah1-g l-iy", "jj"],
  "ulcer": ["ah1-l s-er", "nn"],
  "ultimate": ["ah1-l t-ah m-ah-t", "jj"],
  "ultimately": ["ah1-l t-ah m-ah-t l-iy", "rb"],
  "ultimatum": ["ah-l t-ah m-ey1 t-ah-m", "nn"],
  "ultra": ["ah1-l t-r-ah", "jj"],
  "ultramodern": ["ah-l t-r-ah m-aa1 d-er-n", "jj"],
  "ultrasonic": ["ah-l t-r-ah s-aa1 n-ih-k", "jj"],
  "ultrasound": ["ah-l t-r-ah s-aw1-n-d", "nn"],
  "ultraviolet": ["ah-l t-r-ah v-ay1 ah l-ih-t", "jj nn"],
  "umbrage": ["ah1-m b-r-ih-jh", "nn"],
  "umbrella": ["ah-m b-r-eh1 l-ah", "nn"],
  "umpire": ["ah1-m p-ay er", "nn"],
  "unabashed": ["ah-n ah b-ae1-sh-t", "jj"],
  "unabated": ["ah-n ah b-ey1 t-ih-d", "jj"],
  "unable": ["ah-n ey1 b-ah-l", "jj"],
  "unabridged": ["ah-n ah b-r-ih1-jh-d", "jj"],
  "unacceptable": ["ah-n ae-k s-eh1-p t-ah b-ah-l", "jj"],
  "unacceptably": ["ah-n ae-k s-eh1-p t-ah b-l-iy", "rb"],
  "unaccompanied": ["ah-n ah k-ah1-m p-ah n-iy-d", "jj"],
  "unaccountable": ["ah-n ah k-aw1-n t-ah b-ah-l", "jj"],
  "unaccountably": ["ah-n ah k-aw1-n t-ah b-l-iy", "rb"],
  "unaccounted": ["ah-n ah k-aw1-n t-ih-d", "jj"],
  "unaccustomed": ["ah-n ah k-ah1 s-t-ah-m-d", "jj"],
  "unaddressed": ["ah-n ah d-r-eh1-s-t", "jj"],
  "unadjusted": ["ah-n ah jh-ah1 s-t-ih-d", "jj"],
  "unadorned": ["ah-n ah d-ao1-r-n-d", "jj"],
  "unadulterated": ["ah-n ah d-ah1-l t-er ey t-ih-d", "jj"],
  "unaffected": ["ah-n ah f-eh1-k t-ih-d", "jj"],
  "unaffiliated": ["ah-n ah f-ih1 l-iy ey t-ih-d", "jj"],
  "unaffordable": ["ah-n ah f-ao1-r d-ah b-ah-l", "jj"],
  "unafraid": ["ah-n ah f-r-ey1-d", "jj"],
  "unaided": ["ah-n ey1 d-ih-d", "jj"],
  "unalloyed": ["ah-n ae1 l-oy-d", "jj"],
  "unalterable": ["ah-n ao1-l t-er ah b-ah-l", "jj"],
  "unaltered": ["ah-n ao1-l t-er-d", "jj"],
  "unambiguous": ["ah n-ae-m b-ih1 g-y-ah-w ah-s", "jj"],
  "unambiguously": ["ah n-ae-m b-ih1 g-y-uw ah-s l-iy", "rb"],
  "unamended": ["ah-n ah m-eh1-n d-ih-d", "jj"],
  "unamortized": ["ah n-ae1 m-er t-ay-z-d", "jj"],
  "unanimity": ["y-uw n-ah n-ih1 m-ah t-iy", "nn"],
  "unanimous": ["y-uw n-ae1 n-ah m-ah-s", "jj"],
  "unanimously": ["y-uw n-ae1 n-ah m-ah-s l-iy", "rb"],
  "unannounced": ["ah-n ah n-aw1-n-s-t", "jj"],
  "unanswerable": ["ah-n ae-n s-er ah b-ah-l", "jj"],
  "unanswered": ["ah-n ae1-n s-er-d", "jj"],
  "unanticipated": ["ah-n ae-n t-ih1 s-ah p-ey t-ih-d", "jj"],
  "unapologetic": ["ah-n ah p-aa l-ah jh-eh1 t-ih-k", "jj"],
  "unappealing": ["ah-n ah p-iy1 l-ih-ng", "jj"],
  "unappreciated": ["ah-n ah p-r-iy1 sh-iy ey t-ih-d", "jj"],
  "unapproved": ["ah-n ah p-r-uw1-v-d", "jj"],
  "unarmed": ["ah-n aa1-r-m-d", "jj"],
  "unashamedly": ["ah-n ah sh-ey1 m-ah-d l-iy", "rb"],
  "unassailable": ["ah-n ah s-ey1 l-ah b-ah-l", "jj"],
  "unassisted": ["ah-n ah s-ih1 s-t-ih-d", "jj"],
  "unassuming": ["ah-n ah s-uw1 m-ih-ng", "jj"],
  "unattached": ["ah-n ah t-ae1-ch-t", "jj"],
  "unattainable": ["ah-n ah t-ey1 n-ah b-ah-l", "jj nn"],
  "unattended": ["ah-n ah t-eh1-n d-ih-d", "jj"],
  "unattractive": ["ah-n ah t-r-ae1-k t-ih-v", "jj"],
  "unaudited": ["ah n-ao1 d-ah t-ih-d", "jj"],
  "unauthentic": ["ah-n ao th-eh1-n t-ih-k", "jj"],
  "unauthorized": ["ah-n ao1 th-er ay-z-d", "jj"],
  "unavailability": ["ah-n ah v-ey l-ah b-ih1 l-ih t-iy", "nn"],
  "unavailable": ["ah-n ah v-ey1 l-ah b-ah-l", "jj"],
  "unavailing": ["ah-n ah v-ey1 l-ih-ng", "jj"],
  "unavoidable": ["ah-n ah v-oy1 d-ah b-ah-l", "jj"],
  "unavoidably": ["ah-n ah v-oy1 d-ah b-l-iy", "rb"],
  "unaware": ["ah-n ah w-eh1-r", "jj rb"],
  "unbalance": ["ah-n-b-ae1-l-ah-n-s", "vb"],
  "unbalanced": ["ah-n b-ae1 l-ah-n-s-t", "jj vbn"],
  "unbearable": ["ah-n b-eh1 r-ah b-ah-l", "jj"],
  "unbearably": ["ah-n b-eh1 r-ah b-l-iy", "rb"],
  "unbeknownst": ["ah-n b-iy n-ow1-n-s-t", "jj"],
  "unbelievable": ["ah-n b-ah l-iy1 v-ah b-ah-l", "jj"],
  "unbelievably": ["ah-n b-ah l-iy1 v-ah b-l-iy", "rb"],
  "unbelieving": ["ah-n b-ah l-iy1 v-ih-ng", "jj"],
  "unbiased": ["ah-n b-ay1 ah-s-t", "jj"],
  "unblemished": ["ah-n b-l-eh1 m-ih-sh-t", "jj"],
  "unborn": ["ah1-n b-ao1-r-n", "jj nn"],
  "unbound": ["ah-n b-aw1-n-d", "jj vbn"],
  "unbounded": ["ah-n b-aw1-n d-ih-d", "jj"],
  "unbridled": ["ah-n b-r-ay1 d-ah-l-d", "jj"],
  "unbroken": ["ah-n b-r-ow1 k-ah-n", "jj"],
  "unburdened": ["ah-n b-er1 d-ah-n-d", "jj"],
  "unburned": ["ah-n b-er1-n-d", "jj"],
  "uncalled": ["ah-n k-ao1-l-d", "jj"],
  "uncannily": ["ah-n k-ae1 n-ah l-iy", "rb"],
  "uncanny": ["ah-n k-ae1 n-iy", "jj"],
  "uncaring": ["ah-n k-eh1 r-ih-ng", "jj"],
  "unceasing": ["ah-n s-iy1 s-ih-ng", "jj"],
  "uncensored": ["ah-n s-eh1-n s-er-d", "jj"],
  "unceremoniously": ["ah-n s-eh r-ah m-ow1 n-iy ah-s l-iy", "rb"],
  "uncertain": ["ah-n s-er1 t-ah-n", "jj rb"],
  "uncertainty": ["ah-n s-er1 t-ah-n t-iy", "nn"],
  "unchallenged": ["ah-n ch-ae1 l-ih-n-jh-d", "jj"],
  "unchanged": ["ah-n ch-ey1-n-jh-d", "jj"],
  "unchanging": ["ah-n ch-ey1-n jh-ih-ng", "jj"],
  "uncharacteristic": ["ah-n k-eh r-ih-k t-er ih1 s-t-ih-k", "jj"],
  "uncharacteristically": ["ah-n k-eh r-ih-k t-er ih1 s-t-ih-k l-iy", "rb"],
  "uncharted": ["ah-n ch-aa1-r t-ih-d", "jj"],
  "unchecked": ["ah-n ch-eh1-k-t", "jj"],
  "unclaimed": ["ah-n k-l-ey1-m-d", "jj"],
  "unclassified": ["ah-n k-l-ae1 s-ih f-ay-d", "jj"],
  "uncle": ["ah1-ng k-ah-l", "nn"],
  "unclean": ["ah-n k-l-iy1-n", "jj"],
  "unclear": ["ah-n k-l-ih1-r", "jj"],
  "uncluttered": ["ah-n k-l-ah1 t-er-d", "jj"],
  "uncoated": ["ah-n k-ow1 t-ih-d", "jj"],
  "uncollectable": ["ah-n k-ah l-eh1-k t-ah b-ah-l", "jj"],
  "uncomfortable": ["ah-n k-ah1-m f-er t-ah b-ah-l", "jj"],
  "uncomfortably": ["ah-n k-ah1-m-f t-ah b-l-iy", "rb"],
  "uncommitted": ["ah-n k-ah m-ih1 t-ih-d", "jj"],
  "uncommon": ["ah-n k-aa1 m-ah-n", "jj rb"],
  "uncommonly": ["ah-n k-aa1 m-ah-n l-iy", "rb"],
  "uncompensated": ["ah-n k-aa1-m p-ah-n s-ey t-ih-d", "jj"],
  "uncompetitive": ["ah-n k-ah-m p-eh1 t-ah t-ih-v", "jj"],
  "uncomplicated": ["ah-n k-aa1-m p-l-ah k-ey t-ih-d", "jj"],
  "uncompromising": ["ah-n k-aa1-m p-r-ah m-ay z-ih-ng", "jj"],
  "unconcealed": ["ah-n k-ah-n s-iy1-l-d", "jj"],
  "unconcern": ["ah-n k-ah-n s-er1-n", "nn"],
  "unconcerned": ["ah-n k-ah-n s-er1-n-d", "jj"],
  "unconditional": ["ah-n k-ah-n d-ih1 sh-ah n-ah-l", "jj"],
  "unconditionally": ["ah-n k-ah-n d-ih1 sh-ah-n ah l-iy", "rb"],
  "unconfirmed": ["ah-n k-ah-n f-er1-m-d", "jj"],
  "unconnected": ["ah-n k-ah n-eh1-k t-ih-d", "jj"],
  "unconscionable": ["ah-n k-aa1-n sh-ah-n ah b-ah-l", "jj"],
  "unconscious": ["ah-n k-aa1-n sh-ah-s", "jj nn"],
  "unconsciously": ["ah-n k-aa1-n sh-ah-s l-iy", "rb"],
  "unconsolidated": ["ah-n k-ah-n s-aa1 l-ah d-ey t-ih-d", "jj"],
  "unconstitutional": ["ah-n k-aa-n s-t-ah t-uw1 sh-ah n-ah-l", "jj"],
  "uncontested": ["ah-n k-ah-n t-eh1 s-t-ih-d", "jj"],
  "uncontrollable": ["ah-n k-ah-n t-r-ow1 l-ah b-ah-l", "jj"],
  "uncontrollably": ["ah-n k-ah-n t-r-ow1 l-ah b-l-iy", "rb"],
  "uncontrolled": ["ah-n k-ah-n t-r-ow1-l-d", "jj"],
  "unconventional": ["ah-n k-ah-n v-eh1-n sh-ah n-ah-l", "jj"],
  "unconvinced": ["ah-n k-ah-n v-ih1-n-s-t", "jj"],
  "unconvincing": ["ah-n k-ah-n v-ih1-n s-ih-ng", "jj"],
  "uncooperative": ["ah-n k-ow aa1 p-er ah t-ih-v", "jj"],
  "uncorrected": ["ah-n k-er eh1-k t-ih-d", "jj"],
  "uncounted": ["ah-n k-aw1-n t-ih-d", "jj"],
  "uncouth": ["ah1-n k-uw1-th", "jj"],
  "uncover": ["ah-n k-ah1 v-er", "vb"],
  "uncovered": ["ah-n k-ah1 v-er-d", "vbn vbd jj"],
  "uncritical": ["ah-n k-r-ih1 t-ih k-ah-l", "jj"],
  "uncritically": ["ah-n k-r-ih1 t-ih k-ah l-iy", "rb"],
  "uncut": ["ah-n k-ah1-t", "jj"],
  "undamaged": ["ah-n d-ae1 m-ah-jh-d", "jj"],
  "undated": ["ah-n d-ey1 t-ih-d", "jj"],
  "undaunted": ["ah-n d-ao1-n t-ih-d", "jj"],
  "undecided": ["ah-n d-ih s-ay1 d-ih-d", "jj"],
  "undeclared": ["ah-n d-ih k-l-eh1-r-d", "jj"],
  "undefeated": ["ah-n d-ih f-iy1 t-ih-d", "jj"],
  "undefined": ["ah-n d-ih f-ay1-n-d", "jj"],
  "undelivered": ["ah-n d-ih l-ih1 v-er-d", "jj"],
  "undemocratic": ["ah-n d-eh m-ah k-r-ae1 t-ih-k", "jj"],
  "undeniable": ["ah-n d-ih n-ay1 ah b-ah-l", "jj"],
  "undeniably": ["ah-n d-ih n-ay1 ah b-l-iy", "rb"],
  "under": ["ah1-n d-er", "in jj rb rp"],
  "underachiever": ["ah1-n d-er ah ch-iy v-er", "nn"],
  "underage": ["ah1-n d-er ih-jh", "jj"],
  "underarm": ["ah-n d-er aa1-r-m", "nn"],
  "underbelly": ["ah1-n d-er b-eh l-iy", "nn"],
  "underbrush": ["ah1-n d-er b-r-ah-sh", "nn"],
  "undercover": ["ah-n d-er k-ah1 v-er", "jj"],
  "undercurrent": ["ah1-n d-er k-er ah-n-t", "nn"],
  "undercut": ["ah1-n d-er k-ah-t", "vb nn vbd vbn vbp jj"],
  "underdeveloped": ["ah-n d-er d-ih v-eh1 l-ah-p-t", "jj"],
  "underdog": ["ah1-n d-er d-ao-g", "nn"],
  "underemployed": ["ah1-n d-er ih-m p-l-oy1-d", "jj"],
  "underemployment": ["ah-n d-er ih-m p-l-oy1 m-ah-n-t", "nn"],
  "underestimate": ["ah1-n d-er eh1 s-t-ah m-ey-t", "vb"],
  "underfoot": ["ah-n d-er f-uh1-t", "rb"],
  "underfund": ["ah1-n-d-er-f-ah-n-d", "vb"],
  "underfunded": ["ah1-n d-er f-ah-n d-ih-d", "vbn jj"],
  "undergarment": ["ah1-n d-er g-aa-r m-ah-n-t", "nn"],
  "undergo": ["ah-n d-er g-ow1", "vb vbp"],
  "undergone": ["ah-n d-er g-ao1-n", "vbn"],
  "undergraduate": ["ah-n d-er g-r-ae1 jh-ah-w ah-t", "jj nn"],
  "underground": ["ah1-n d-er g-r-aw-n-d", "jj nn rb"],
  "undergrowth": ["ah1-n d-er g-r-ow-th", "nn"],
  "underhanded": ["ah1-n d-er hh-ae1-n d-ih-d", "jj"],
  "underlie": ["ah-n d-er l-ay1", "vbp vb"],
  "underline": ["ah1-n d-er l-ay-n", "vb"],
  "underling": ["ah1-n d-er l-ih-ng", "nn"],
  "underlying": ["ah-n d-er l-ay1 ih-ng", "vbg jj"],
  "undermine": ["ah1-n d-er m-ay-n", "vb vbp"],
  "undermined": ["ah-n d-er m-ay1-n-d", "vbn vbd jj"],
  "underneath": ["ah-n d-er n-iy1-th", "in nn"],
  "underpaid": ["ah1-n d-er p-ey1-d", "jj vbd vbn"],
  "underperform": ["ah1-n d-er p-er f-ao-r-m", "vb jj"],
  "underperformance": ["ah-n d-er p-er f-ao1-r m-ah-n-s", "nn"],
  "underperforming": ["ah1-n d-er p-er f-ao-r m-ih-ng", "vbg jj"],
  "underpin": ["ah1-n d-er p-ih-n", "vb"],
  "underpriced": ["ah1-n d-er p-r-ay-s-t", "jj"],
  "underrate": ["ah-n-d-er-r-ey1-t", "vb"],
  "underrepresented": ["ah-n d-er r-eh p-r-ih z-eh1-n t-ih-d", "jj"],
  "underscore": ["ah-n d-er s-k-ao1-r", "vbp nn vb"],
  "undersea": ["ah-n d-er s-iy1", "jj"],
  "underserved": ["ah-n d-er s-er1-v-d", "jj"],
  "underside": ["ah1-n d-er s-ay-d", "nn"],
  "undersized": ["ah1-n d-er s-ay-z-d", "jj"],
  "understand": ["ah-n d-er s-t-ae1-n-d", "vb vbp"],
  "understandable": ["ah-n d-er s-t-ae1-n d-ah b-ah-l", "jj"],
  "understandably": ["ah-n d-er s-t-ae1-n d-ah b-l-iy", "rb"],
  "understanding": ["ah-n d-er s-t-ae1-n d-ih-ng", "nn vbg"],
  "understate": ["ah1-n d-er s-t-ey-t", "vb vbp"],
  "understated": ["ah1-n d-er s-t-ey t-ih-d", "vbn vbd jj"],
  "understatement": ["ah1-n d-er s-t-ey-t m-ah-n-t", "nn"],
  "understood": ["ah-n d-er s-t-uh1-d", "vbn vbd"],
  "undertake": ["ah1-n d-er t-ey-k", "vb"],
  "undertaken": ["ah1-n d-er t-ey k-ah-n", "vbn"],
  "undertaker": ["ah1-n d-er t-ey k-er", "nn"],
  "undertaking": ["ah1-n d-er t-ey k-ih-ng", "nn vbg"],
  "undertone": ["ah1-n d-er t-ow-n", "nn"],
  "undertook": ["ah-n d-er t-uh1-k", "vbd"],
  "undertow": ["ah1-n d-er t-ow", "nn"],
  "underuse": ["ah-n-d-er-y-uw1-z", "vb"],
  "underutilize": ["ah1-n-d-er-y-uw-t-ah-l-ay-z", "vb"],
  "undervalue": ["ah1-n-d-er-v-ae-l-y-uw", "vb"],
  "undervalued": ["ah1-n d-er v-ae-l y-uw-d", "vbn vbd jj"],
  "underwater": ["ah1-n d-er w-ao t-er", "jj nn rb"],
  "underway": ["ah-n d-er w-ey1", "rb jj"],
  "underwear": ["ah1-n d-er w-eh-r", "nn"],
  "underweight": ["ah-n d-er w-ey1 t-ih-d", "jj"],
  "underwent": ["ah-n d-er w-eh1-n-t", "vbd"],
  "underworld": ["ah1-n d-er w-er-l-d", "nn"],
  "underwrite": ["ah1-n d-er r-ay-t", "vb vbp"],
  "underwriter": ["ah1-n d-er r-ay t-er", "nn"],
  "underwritten": ["ah1-n d-er r-ih t-ah-n", "vbn jj nn"],
  "underwrote": ["ah-n d-er r-ow1-t", "vbd nn"],
  "undeserved": ["ah-n d-ih z-er1-v-d", "jj"],
  "undesirable": ["ah-n d-ih z-ay1 r-ah b-ah-l", "jj nn"],
  "undetectable": ["ah-n d-ih t-eh1-k t-ah b-ah-l", "jj"],
  "undetected": ["ah-n d-ih t-eh1-k t-ih-d", "jj"],
  "undetermined": ["ah-n d-ih t-er1 m-ih-n-d", "jj"],
  "undeveloped": ["ah-n d-ih v-eh1 l-ah-p-t", "jj"],
  "undid": ["ah-n d-ih1-d", "vbd"],
  "undifferentiated": ["ah-n d-ih f-er eh1-n sh-iy ey t-ih-d", "jj"],
  "undiluted": ["ah-n d-ah l-uw1 t-ih-d", "jj"],
  "undiminished": ["ah-n d-ah m-ih1 n-ih-sh-t", "jj"],
  "undisciplined": ["ah-n d-ih1 s-ih p-l-ih-n-d", "jj"],
  "undisclosed": ["ah-n d-ih-s k-l-ow1-z-d", "jj"],
  "undisguised": ["ah-n d-ih-s g-ay1-z-d", "jj"],
  "undisputed": ["ah-n d-ih s-p-y-uw1 t-ih-d", "jj"],
  "undistinguished": ["ah-n d-ih s-t-ih1-ng g-w-ih-sh-t", "jj"],
  "undisturbed": ["ah-n d-ih s-t-er1-b-d", "jj"],
  "undiversified": ["ah-n d-ih v-er1 s-ih f-ay-d", "jj"],
  "undivided": ["ah-n d-ah v-ay1 d-ih-d", "jj"],
  "undo": ["ah-n d-uw1", "vb"],
  "undoing": ["ah-n d-uw1 ih-ng", "nn vbg"],
  "undone": ["ah-n d-ah1-n", "vbn jj"],
  "undoubtedly": ["ah-n d-aw1 t-ih-d l-iy", "rb"],
  "undreamed": ["ah-n d-r-iy1-m-d", "jj"],
  "undress": ["ah-n d-r-eh1-s", "nn"],
  "undue": ["ah-n d-uw1", "jj"],
  "undulating": ["ah1-n jh-ah l-ey t-ih-ng", "jj"],
  "unduly": ["ah-n d-uw1 l-iy", "rb"],
  "undying": ["ah-n d-ay1 ih-ng", "jj"],
  "unearned": ["ah-n er1-n-d", "jj"],
  "unearth": ["ah-n er1-th", "vb"],
  "unearthly": ["ah-n er1-th l-iy", "jj"],
  "unease": ["ah-n iy1-z", "nn"],
  "uneasily": ["ah-n iy1 z-ah l-iy", "rb"],
  "uneasiness": ["ah-n iy1 z-iy n-ah-s", "nn"],
  "uneasy": ["ah-n iy1 z-iy", "jj"],
  "uneconomic": ["ah-n eh k-ah n-aa1 m-ih-k", "jj"],
  "uneconomical": ["ah-n eh k-ah n-aa1 m-ih k-ah-l", "jj"],
  "uneducated": ["ah-n eh1 jh-uh k-ey t-ih-d", "jj"],
  "unelected": ["ah-n ih l-eh1-k t-ih-d", "jj"],
  "unemployed": ["ah-n eh-m p-l-oy1-d", "jj"],
  "unemployment": ["ah-n ih-m p-l-oy1 m-ah-n-t", "nn"],
  "unencumbered": ["ah-n eh-n k-ah1-m b-er-d", "jj"],
  "unending": ["ah-n eh1-n d-ih-ng", "jj"],
  "unenforceable": ["ah-n eh-n f-ao1-r s-ah b-ah-l", "jj"],
  "unenlightened": ["ah-n eh-n l-ay1 t-ah-n-d", "jj"],
  "unenthusiastic": ["ah-n ih-n th-uw z-iy ae1 s-t-ih-k", "jj"],
  "unenviable": ["ah-n eh1-n v-iy ah b-ah-l", "jj"],
  "unequal": ["ah-n iy1 k-w-ah-l", "jj"],
  "unequaled": ["ah-n iy1 k-w-ah-l-d", "jj"],
  "unequivocal": ["ah-n ih k-w-ih1 v-ah k-ah-l", "jj"],
  "unequivocally": ["ah-n iy k-w-ih1 v-ah k-ah l-iy", "rb"],
  "unethical": ["ah-n eh1 th-ih k-ah-l", "jj"],
  "uneven": ["ah-n iy1 v-ah-n", "jj"],
  "unevenly": ["ah-n iy1 v-ah-n l-iy", "rb"],
  "uneventful": ["ah-n iy v-eh1-n-t f-ah-l", "jj"],
  "unexciting": ["ah-n ih-k s-ay1 t-ih-ng", "jj"],
  "unexercised": ["ah-n eh1-k s-er s-ay-z-d", "jj"],
  "unexpected": ["ah-n ih-k s-p-eh1-k t-ih-d", "jj"],
  "unexpectedly": ["ah-n ih-k s-p-eh1-k t-ih-d l-iy", "rb"],
  "unexplainable": ["ah-n ih-k s-p-l-ey1 n-ah b-ah-l", "jj"],
  "unexplained": ["ah-n ih-k s-p-l-ey1-n-d", "jj"],
  "unexplored": ["ah-n ih-k s-p-l-ao1-r-d", "jj"],
  "unfailing": ["ah-n f-ey1 l-ih-ng", "jj"],
  "unfailingly": ["ah-n f-ey1 l-ih-ng l-iy", "rb"],
  "unfair": ["ah-n f-eh1-r", "jj"],
  "unfairly": ["ah-n f-eh1-r l-iy", "rb"],
  "unfairness": ["ah-n f-eh1-r n-ah-s", "nn"],
  "unfaithful": ["ah-n f-ey1-th f-ah-l", "jj"],
  "unfamiliar": ["ah-n f-ah m-ih1 l-y-er", "jj"],
  "unfamiliarity": ["ah-n f-ah m-ih l-y-eh1 r-ah t-iy", "nn"],
  "unfashionable": ["ah-n f-ae1 sh-ah-n ah b-ah-l", "jj"],
  "unfathomable": ["ah-n f-ae1 dh-ah m-ah b-ah-l", "jj"],
  "unfavorable": ["ah-n f-ey1 v-er ah b-ah-l", "jj"],
  "unfavorably": ["ah-n f-ey1 v-er ah b-l-iy", "rb"],
  "unfazed": ["ah-n f-ey1-z-d", "jj"],
  "unfeasible": ["ah-n f-iy1 z-ah b-ah-l", "jj"],
  "unfenced": ["ah-n f-eh1-n-s-t", "jj"],
  "unfettered": ["ah-n f-eh1 t-er-d", "jj"],
  "unfilled": ["ah-n f-ih1-l-d", "jj"],
  "unfinished": ["ah-n f-ih1 n-ih-sh-t", "jj"],
  "unfit": ["ah-n f-ih1-t", "jj nn"],
  "unflagging": ["ah-n f-l-ae1 g-ih-ng", "jj"],
  "unflappable": ["ah-n f-l-ae1 p-ah b-ah-l", "jj"],
  "unflattering": ["ah-n f-l-ae1 t-er ih-ng", "jj"],
  "unflinching": ["ah-n f-l-ih1-n ch-ih-ng", "jj"],
  "unfocused": ["ah-n f-ow1 k-ah-s-t", "jj"],
  "unfold": ["ah-n f-ow1-l-d", "vb vbp"],
  "unfolding": ["ah-n f-ow1-l d-ih-ng", "vbg jj"],
  "unforeseen": ["ah-n f-ao-r s-iy1-n", "jj"],
  "unforgettable": ["ah-n f-er g-eh1 t-ah b-ah-l", "jj"],
  "unforgivable": ["ah-n f-ao-r g-ih1 v-ah b-ah-l", "jj"],
  "unforgiving": ["ah-n f-er g-ih1 v-ih-ng", "jj"],
  "unformed": ["ah-n f-ao1-r-m-d", "jj"],
  "unfortunate": ["ah-n f-ao1-r ch-ah n-ah-t", "jj nn"],
  "unfortunately": ["ah-n f-ao1-r ch-ah n-ah-t l-iy", "rb"],
  "unfounded": ["ah-n f-aw1-n d-ih-d", "jj"],
  "unfriendly": ["ah-n f-r-eh1-n-d l-iy", "jj"],
  "unfulfilled": ["ah-n f-uh-l f-ih1-l-d", "jj"],
  "unfunded": ["ah-n f-ah1-n d-ih-d", "jj"],
  "unfunnily": ["ah-n f-ah1 n-ah l-iy", "rb"],
  "unfurl": ["ah-n-f-er1-l", "vb"],
  "ungainly": ["ah-n g-ey1-n l-iy", "jj"],
  "unglamorous": ["ah-n g-l-ae1 m-er ah-s", "jj"],
  "unglued": ["ah-n g-l-uw1-d", "jj"],
  "ungovernable": ["ah-n g-ah1 v-er n-ah b-ah-l", "jj"],
  "ungrateful": ["ah-n g-r-ey1-t f-ah-l", "jj"],
  "unhappily": ["ah-n hh-ae1 p-ah l-iy", "rb"],
  "unhappiness": ["ah-n hh-ae1 p-iy n-ih-s", "nn"],
  "unhappy": ["ah-n hh-ae1 p-iy", "jj"],
  "unharmed": ["ah-n hh-aa1-r-m-d", "jj"],
  "unhealthy": ["ah-n hh-eh1-l th-iy", "jj"],
  "unheard": ["ah-n hh-er1-d", "jj"],
  "unhedged": ["ah-n hh-eh1-jh-d", "jj"],
  "unheeded": ["ah-n hh-iy1 d-ih-d", "jj"],
  "unheralded": ["ah-n hh-eh1 r-ah-l d-ih-d", "jj"],
  "unhesitatingly": ["ah-n hh-eh1 z-ih t-ey t-ih-ng l-iy", "rb"],
  "unhindered": ["ah-n hh-ih1-n d-er-d", "jj"],
  "unhinge": ["ah-n-hh-ih1-n-jh", "vb"],
  "unholy": ["ah-n hh-ow1 l-iy", "jj"],
  "unhurried": ["ah-n hh-er1 iy-d", "jj"],
  "unhurt": ["ah-n hh-er1-t", "jj"],
  "unidentified": ["ah-n ay d-eh1-n t-ah f-ay-d", "jj"],
  "unification": ["y-uw n-ah f-ah k-ey1 sh-ah-n", "nn"],
  "unified": ["y-uw1 n-ah f-ay-d", "jj vbd vbn"],
  "uniform": ["y-uw1 n-ah f-ao-r-m", "nn jj"],
  "uniformed": ["y-uw1 n-ah f-ao-r-m-d", "jj"],
  "uniformity": ["y-uw n-ah f-ao1-r m-ah t-iy", "nn"],
  "uniformly": ["y-uw1 n-ah f-ao-r-m l-iy", "rb"],
  "unify": ["y-uw1 n-ah f-ay", "vb"],
  "unifying": ["y-uw1 n-ah f-ay ih-ng", "vbg jj"],
  "unilateral": ["y-uw n-ah l-ae1 t-er ah-l", "jj"],
  "unilaterally": ["y-uw n-ah l-ae1 t-er ah l-iy", "rb"],
  "unimaginable": ["ah-n ih m-ae1 jh-ih n-ah b-ah-l", "jj"],
  "unimaginative": ["ah-n ih m-ae1 jh-ih n-ah t-ih-v", "jj"],
  "unimpaired": ["ah-n ih-m p-eh1-r-d", "jj"],
  "unimpeachable": ["ah-n ih-m p-iy1 ch-ah b-ah-l", "jj"],
  "unimpeded": ["ah-n ih-m p-iy1 d-ih-d", "jj"],
  "unimportant": ["ah-n ih-m p-ao1-r t-ah-n-t", "jj"],
  "unimpressed": ["ah-n ih-m p-r-eh1-s-t", "jj"],
  "unimpressive": ["ah-n ih-m p-r-eh1 s-ih-v", "jj"],
  "unimproved": ["ah-n ih-m p-r-uw1-v-d", "jj"],
  "unincorporated": ["ah-n ih-n k-ao1-r p-er ey t-ih-d", "jj"],
  "unindicted": ["ah-n ih-n d-ay1 t-ih-d", "jj"],
  "uninfected": ["ah-n ih-n f-eh1-k t-ih-d", "jj"],
  "uninformative": ["ah-n ih-n f-ao1-r m-ah t-ih-v", "jj"],
  "uninformed": ["ah-n ih-n f-ao1-r-m-d", "jj"],
  "uninhabitable": ["ah-n ih-n hh-ae1 b-ah t-ah b-ah-l", "jj"],
  "uninhabited": ["ah-n ih-n hh-ae1 b-ah t-ih-d", "jj"],
  "uninhibited": ["ah-n ih-n hh-ih1 b-ih t-ih-d", "jj"],
  "uninitiated": ["ah-n ih n-ih1 sh-iy ey t-ih-d", "jj"],
  "uninjured": ["ah-n ih1-n jh-er-d", "jj"],
  "uninspired": ["ah-n ih-n s-p-ay1 er-d", "jj"],
  "uninsurable": ["ah-n ih-n sh-uh1 r-ah b-ah-l", "jj"],
  "uninsured": ["ah-n ih-n sh-uh1-r-d", "jj"],
  "unintelligible": ["ah-n ih-n t-eh1 l-ah jh-ah b-ah-l", "jj"],
  "unintended": ["ah-n ih-n t-eh1-n d-ih-d", "jj"],
  "unintentional": ["ah-n ih-n t-eh1-n sh-ah n-ah-l", "jj"],
  "unintentionally": ["ah-n ih-n t-eh1-n sh-ah-n ah l-iy", "rb"],
  "uninterested": ["ah-n ih1-n t-r-ah s-t-ah-d", "jj"],
  "uninteresting": ["ah-n ih1-n t-r-ah s-t-ih-ng", "jj"],
  "uninterrupted": ["ah-n ih-n t-er ah1-p t-ih-d", "jj"],
  "uninterruptible": ["ah-n ih-n t-er ah1-p t-ah b-ah-l", "jj"],
  "uninvited": ["ah-n ih-n v-ay1 t-ih-d", "jj"],
  "uninviting": ["ah-n ih-n v-ay1 t-ih-ng", "jj"],
  "uninvolved": ["ah-n ih-n v-ao1-l-v-d", "jj"],
  "union": ["y-uw1 n-y-ah-n", "nn jj"],
  "unionist": ["y-uw1 n-y-ah n-ah-s-t", "nn"],
  "unionize": ["y-uw1-n-y-ah-n-ay-z", "vb"],
  "unionized": ["y-uw1 n-y-ah n-ay-z-d", "jj vbd vbn"],
  "unique": ["y-uw n-iy1-k", "jj nn"],
  "uniquely": ["y-uw n-iy1-k l-iy", "rb"],
  "uniqueness": ["y-uw n-iy1-k n-ah-s", "nn"],
  "unison": ["y-uw1 n-ah s-ah-n", "nn"],
  "unissued": ["ah-n ih1 sh-uw-d", "jj"],
  "unit": ["y-uw1 n-ah-t", "nn"],
  "unitary": ["y-uw1 n-ih t-eh r-iy", "jj"],
  "unite": ["y-uw1 n-ay-t", "vb vbp"],
  "united": ["y-uw n-ay1 t-ah-d", "vbn vbd jj"],
  "unitholder": ["y-uw1 n-ih-t hh-ow-l d-er", "nn"],
  "unity": ["y-uw1 n-ah t-iy", "nn"],
  "universal": ["y-uw n-ah v-er1 s-ah-l", "jj"],
  "universality": ["y-uw n-ah v-er s-ae1 l-ah t-iy", "nn"],
  "universally": ["y-uw n-ah v-er1 s-ah l-iy", "rb"],
  "universe": ["y-uw1 n-ah v-er-s", "nn"],
  "university": ["y-uw n-ah v-er1 s-ah t-iy", "nn"],
  "unjust": ["ah-n jh-ah1-s-t", "jj"],
  "unjustifiable": ["ah-n jh-ah s-t-ih f-ay1 ah b-ah-l", "jj"],
  "unjustifiably": ["ah-n jh-ah s-t-ih f-ay1 ah b-l-iy", "rb"],
  "unjustified": ["ah-n jh-ah1 s-t-ah f-ay-d", "jj"],
  "unjustly": ["ah-n jh-ah1-s-t l-iy", "rb"],
  "unkempt": ["ah-n k-eh1-m-p-t", "jj"],
  "unkind": ["ah-n k-ay1-n-d", "jj"],
  "unknowable": ["ah-n n-ow1 ah b-ah-l", "jj"],
  "unknowingly": ["ah-n n-ow1 ih-ng l-iy", "rb"],
  "unknown": ["ah-n n-ow1-n", "jj nn"],
  "unlabeled": ["ah-n l-ey1 b-ah-l-d", "jj"],
  "unlawful": ["ah-n l-ao1 f-ah-l", "jj"],
  "unlawfully": ["ah-n l-ao1 f-ah l-iy", "rb"],
  "unleaded": ["ah-n l-eh1 d-ah-d", "jj"],
  "unleash": ["ah-n l-iy1-sh", "vb vbp"],
  "unless": ["ah-n l-eh1-s", "in"],
  "unlicensed": ["ah-n l-ay1 s-ah-n-s-t", "jj"],
  "unlike": ["ah-n l-ay1-k", "in jj nn"],
  "unlikely": ["ah-n l-ay1-k l-iy", "jj rb"],
  "unlimited": ["ah-n l-ih1 m-ah t-ah-d", "jj"],
  "unlined": ["ah-n l-ay1-n-d", "jj"],
  "unlisted": ["ah-n l-ih1 s-t-ih-d", "jj"],
  "unload": ["ah-n l-ow1-d", "vb vbp"],
  "unloaded": ["ah-n l-ow1 d-ah-d", "vbn jj vbd"],
  "unlock": ["ah-n l-aa1-k", "vb vbp"],
  "unlocked": ["ah-n l-aa1-k-t", "vbd vbn jj"],
  "unlucky": ["ah-n l-ah1 k-iy", "jj"],
  "unmanageable": ["ah-n m-ae1 n-ih jh-ah b-ah-l", "jj"],
  "unmanaged": ["ah-n m-ae1 n-ih-jh-d", "jj"],
  "unmanned": ["ah-n m-ae1-n-d", "jj"],
  "unmarked": ["ah-n m-aa1-r-k-t", "jj"],
  "unmarried": ["ah-n m-eh1 r-iy-d", "jj"],
  "unmask": ["ah-n m-ae1-s-k", "vb"],
  "unmatched": ["ah-n m-ae1-ch-t", "jj"],
  "unmentioned": ["ah-n m-eh1-n ch-ah-n-d", "jj"],
  "unmet": ["ah-n m-eh1-t", "jj"],
  "unmistakable": ["ah-n m-ih s-t-ey1 k-ah b-ah-l", "jj"],
  "unmistakably": ["ah-n m-ih s-t-ey1 k-ah b-l-iy", "rb"],
  "unmixed": ["ah-n m-ih1-k-s-t", "jj"],
  "unmolested": ["ah-n m-ah l-eh1 s-t-ih-d", "jj"],
  "unmoved": ["ah-n m-uw1-v-d", "jj"],
  "unnamed": ["ah-n n-ey1-m-d", "jj"],
  "unnatural": ["ah-n n-ae1 ch-er ah-l", "jj"],
  "unnecessarily": ["ah-n n-eh1 s-ah s-eh r-ah l-iy", "rb"],
  "unnecessary": ["ah-n n-eh1 s-ah s-eh r-iy", "jj"],
  "unneeded": ["ah-n n-iy1 d-ih-d", "jj"],
  "unnerve": ["ah-n-er1-v", "vb"],
  "unnerved": ["ah-n n-er1-v-d", "vbd jj"],
  "unnerving": ["ah-n er1 v-ih-ng", "vbg jj"],
  "unnoticed": ["ah-n n-ow1 t-ih-s-t", "jj"],
  "unobtainable": ["ah-n ah-b t-ey1 n-ah b-ah-l", "jj"],
  "unobtrusive": ["ah-n ah-b t-r-uw1 s-ih-v", "jj"],
  "unoccupied": ["ah-n aa1 k-y-ah p-ay-d", "jj"],
  "unofficial": ["ah-n ah f-ih1 sh-ah-l", "jj"],
  "unofficially": ["ah-n ah f-ih1 sh-ah l-iy", "rb"],
  "unopened": ["ah-n ow1 p-ah-n-d", "jj"],
  "unopposed": ["ah-n ah p-ow1-z-d", "jj"],
  "unorganized": ["ah-n ao1-r g-ah n-ay-z-d", "jj"],
  "unorthodox": ["ah n-ao1-r th-ah d-aa-k-s", "jj"],
  "unpack": ["ah-n p-ae1-k", "vb"],
  "unpaid": ["ah-n p-ey1-d", "jj"],
  "unpalatable": ["ah-n p-ae1 l-ah t-ah b-ah-l", "jj"],
  "unparalleled": ["ah-n p-eh1 r-ah l-eh-l-d", "jj"],
  "unpatriotic": ["ah-n p-ey t-r-iy aa1 t-ih-k", "jj"],
  "unperturbed": ["ah-n p-er t-er1-b-d", "jj"],
  "unplanned": ["ah-n p-l-ae1-n-d", "jj"],
  "unpleasant": ["ah-n p-l-eh1 z-ah-n-t", "jj"],
  "unpleasantly": ["ah-n p-l-eh1 z-ah-n-t l-iy", "rb"],
  "unpleasantness": ["ah-n p-l-eh1 z-ah-n-t n-ah-s", "nn"],
  "unpopular": ["ah-n p-aa1 p-y-ah l-er", "jj"],
  "unpopularity": ["ah-n p-aa p-y-ah l-eh1 r-ih t-iy", "nn"],
  "unprecedented": ["ah-n p-r-eh1 s-ih d-eh-n t-ih-d", "jj"],
  "unprecedentedly": ["ah-n p-r-eh1 s-ah d-eh-n t-ih-d l-iy", "rb"],
  "unpredictability": ["ah-n p-r-ah d-ih-k t-ah b-ih1 l-ih t-iy", "nn"],
  "unpredictable": ["ah-n p-r-ih d-ih1-k t-ah b-ah-l", "jj"],
  "unpredictably": ["ah-n p-r-ih d-ih1-k t-ah b-l-iy", "rb"],
  "unprepared": ["ah-n p-r-iy p-eh1-r-d", "jj"],
  "unpretentious": ["ah-n p-r-iy t-eh1-n sh-ah-s", "jj"],
  "unproductive": ["ah-n p-r-ah d-ah1-k t-ih-v", "jj"],
  "unprofessional": ["ah-n p-r-ah f-eh1 sh-ah n-ah-l", "jj"],
  "unprofitable": ["ah-n p-r-aa1 f-ih t-ah b-ah-l", "jj"],
  "unpromising": ["ah-n p-r-ao1 m-ih s-ih-ng", "jj"],
  "unprotected": ["ah-n p-r-ah t-eh1-k t-ih-d", "jj"],
  "unproved": ["ah-n p-r-uw1-v-d", "jj"],
  "unproven": ["ah-n p-r-uw1 v-ah-n", "jj"],
  "unpublicized": ["ah-n p-ah1 b-l-ih s-ay-z-d", "jj"],
  "unpublished": ["ah-n p-ah1 b-l-ih-sh-t", "jj"],
  "unpunished": ["ah-n p-ah1 n-ih-sh-t", "jj"],
  "unqualified": ["ah-n k-w-aa1 l-ih f-ay-d", "jj"],
  "unquestionable": ["ah-n k-w-eh1-s ch-ah n-ah b-ah-l", "jj"],
  "unquestionably": ["ah-n k-w-eh1-s ch-ah n-ah b-l-iy", "rb"],
  "unquestioned": ["ah-n k-w-eh1-s ch-ah-n-d", "jj"],
  "unravel": ["ah-n r-ae1 v-ah-l", "vb vbp"],
  "unraveled": ["ah-n r-ae1 v-ah-l-d", "vbn jj vbd"],
  "unraveling": ["ah-n r-ae1 v-ah-l ih-ng", "jj vbg"],
  "unread": ["ah-n r-eh1-d", "jj"],
  "unreadable": ["ah-n r-iy1 d-ah b-ah-l", "jj"],
  "unreal": ["ah-n r-iy1-l", "jj"],
  "unrealistic": ["ah-n r-iy l-ih1 s-t-ih-k", "jj"],
  "unrealistically": ["ah-n r-iy ah l-ih1 s-t-ih-k l-iy", "rb"],
  "unreality": ["ah-n r-iy ae1 l-ah t-iy", "nn"],
  "unrealized": ["ah-n r-iy1 ah l-ay-z-d", "jj"],
  "unreasonable": ["ah-n r-iy1-z n-ah b-ah-l", "jj"],
  "unreasonably": ["ah-n r-iy1 z-ah-n ah b-l-iy", "rb"],
  "unreasoning": ["ah-n r-iy1-z n-ih-ng", "jj"],
  "unrecognizable": ["ah-n r-eh k-ah-g n-ay1 z-ah b-ah-l", "jj"],
  "unrecognized": ["ah-n r-eh1 k-ah-g n-ay-z-d", "jj"],
  "unreconstructed": ["ah-n r-iy k-ah-n s-t-r-ah1-k t-ih-d", "jj"],
  "unredeemed": ["ah-n r-iy d-iy1-m-d", "jj"],
  "unregistered": ["ah-n r-eh1 jh-ih s-t-er-d", "jj"],
  "unregulated": ["ah-n r-eh1 g-y-ah l-ey t-ih-d", "jj"],
  "unrelated": ["ah-n r-ih l-ey1 t-ih-d", "jj"],
  "unreleased": ["ah-n r-ih l-iy1-s-t", "jj"],
  "unrelenting": ["ah-n r-iy l-eh1-n t-ih-ng", "jj"],
  "unreliability": ["ah-n r-iy l-ay ah b-ih1 l-ih t-iy", "nn"],
  "unreliable": ["ah-n r-ih l-ay1 ah b-ah-l", "jj"],
  "unrelieved": ["ah-n r-iy l-iy1-v-d", "jj"],
  "unremarkable": ["ah-n r-ih m-aa1-r k-ah b-ah-l", "jj"],
  "unremitting": ["ah-n r-ih m-ih1 t-ih-ng", "jj"],
  "unrepentant": ["ah-n r-ih p-eh1-n t-ah-n-t", "jj"],
  "unreported": ["ah-n r-iy p-ao1-r t-ih-d", "jj"],
  "unrequited": ["ah-n r-iy k-w-ay1 t-ih-d", "jj"],
  "unresolved": ["ah-n r-ih z-aa1-l-v-d", "jj"],
  "unresponsive": ["ah-n r-iy s-p-aa1-n s-ih-v", "jj"],
  "unrest": ["ah-n r-eh1-s-t", "nn"],
  "unrestrained": ["ah-n r-iy s-t-r-ey1-n-d", "jj"],
  "unrestricted": ["ah-n r-iy s-t-r-ih1-k t-ih-d", "jj"],
  "unrivaled": ["ah-n r-ay1 v-ah-l-d", "jj"],
  "unruffled": ["ah-n r-ah1 f-ah-l-d", "jj"],
  "unruly": ["ah-n r-uw1 l-iy", "jj"],
  "unsafe": ["ah-n s-ey1-f", "jj"],
  "unsaleable": ["ah-n s-ey1 l-ah b-ah-l", "jj"],
  "unsanctioned": ["ah-n s-ae1-ng-k sh-ah-n-d", "jj"],
  "unsatisfactory": ["ah-n s-ah t-ih-s f-ae1-k t-er iy", "jj"],
  "unsatisfied": ["ah-n s-ae1 t-ih-s f-ay-d", "jj"],
  "unsatisfying": ["ah-n s-ae1 t-ih-s f-ay ih-ng", "jj"],
  "unsaturated": ["ah-n s-ae1 ch-er ey t-ih-d", "jj"],
  "unsavory": ["ah-n s-ey1 v-er iy", "jj"],
  "unscathed": ["ah-n s-k-ey1-dh-d", "jj"],
  "unscheduled": ["ah-n s-k-eh1 jh-uw-l-d", "jj"],
  "unscientific": ["ah-n s-ay ah-n t-ih1 f-ih-k", "jj"],
  "unscramble": ["ah-n s-k-r-ae1-m b-ah-l", "vb"],
  "unscrupulous": ["ah-n s-k-r-uw1 p-y-ah l-ah-s", "jj"],
  "unseal": ["ah-n s-iy1-l", "vb"],
  "unsealed": ["ah-n s-iy1-l-d", "vbn jj"],
  "unseat": ["ah-n s-iy1-t", "vb"],
  "unseated": ["ah-n s-iy1 t-ih-d", "jj vbd"],
  "unsecured": ["ah-n s-ih k-y-uh1-r-d", "jj"],
  "unseemly": ["ah-n s-iy1-m l-iy", "jj"],
  "unseen": ["ah-n s-iy1-n", "jj"],
  "unsentimental": ["ah-n s-eh-n t-ih m-eh1-n t-ah-l", "jj"],
  "unsettle": ["ah-n-s-eh1-t-ah-l", "vb"],
  "unsettled": ["ah-n s-eh1 t-ah-l-d", "jj vbd vbn"],
  "unsettling": ["ah-n s-eh1 t-ah-l ih-ng", "jj vbg"],
  "unshackled": ["ah-n sh-ae1 k-ah-l-d", "jj"],
  "unshakable": ["ah-n sh-ey1 k-ah b-ah-l", "jj"],
  "unsharpened": ["ah-n sh-aa1-r p-ah-n-d", "jj"],
  "unshaven": ["ah-n sh-ey1 v-ah-n", "jj"],
  "unsightly": ["ah-n s-ay1-t l-iy", "jj"],
  "unsigned": ["ah-n s-ay1-n-d", "jj"],
  "unskilled": ["ah-n s-k-ih1-l-d", "jj"],
  "unsmiling": ["ah-n s-m-ay1 l-ih-ng", "jj"],
  "unsold": ["ah-n s-ow1-l-d", "jj"],
  "unsolicited": ["ah-n s-ah l-ih1 s-ih t-ih-d", "jj"],
  "unsolved": ["ah-n s-aa1-l-v-d", "jj"],
  "unsophisticated": ["ah-n s-ah f-ih1 s-t-ih k-ey t-ih-d", "jj"],
  "unsound": ["ah-n s-aw1-n-d", "jj"],
  "unspeakable": ["ah-n s-p-iy1 k-ah b-ah-l", "jj"],
  "unspecified": ["ah-n s-p-eh1 s-ah f-ay-d", "jj"],
  "unspectacular": ["ah-n s-p-eh-k t-ae1 k-y-ah l-er", "jj"],
  "unspent": ["ah-n s-p-eh1-n-t", "jj"],
  "unspoiled": ["ah-n s-p-oy1-l-d", "jj"],
  "unspoken": ["ah-n s-p-ow1 k-ah-n", "jj"],
  "unstable": ["ah-n s-t-ey1 b-ah-l", "jj"],
  "unstated": ["ah-n s-t-ey1 t-ih-d", "jj"],
  "unsteady": ["ah-n s-t-eh1 d-iy", "jj vb"],
  "unstinting": ["ah-n s-t-ih1-n t-ih-ng", "jj"],
  "unstoppable": ["ah-n s-t-aa1 p-ah b-ah-l", "jj"],
  "unstructured": ["ah-n s-t-r-ah1-k sh-er-d", "jj"],
  "unstuck": ["ah-n s-t-ah1-k", "jj"],
  "unsubsidized": ["ah-n s-ah1-b s-ah d-ay-z-d", "jj"],
  "unsubstantiated": ["ah-n s-ah-b s-t-ae1-n sh-iy ey t-ih-d", "jj"],
  "unsubtle": ["ah-n s-ah1 t-ah-l", "jj"],
  "unsuccessful": ["ah-n s-ah-k s-eh1-s f-ah-l", "jj"],
  "unsuccessfully": ["ah-n s-ah-k s-eh1-s f-ah l-iy", "rb"],
  "unsuitable": ["ah-n s-uw1 t-ah b-ah-l", "jj"],
  "unsuited": ["ah-n s-uw1 t-ih-d", "jj"],
  "unsung": ["ah-n s-ah1-ng", "jj"],
  "unsupportable": ["ah-n s-ah p-ao1-r t-ah b-ah-l", "jj"],
  "unsupported": ["ah-n s-ah p-ao1-r t-ih-d", "jj"],
  "unsure": ["ah-n sh-uh1-r", "jj"],
  "unsurpassed": ["ah-n s-er p-ae1-s-t", "jj"],
  "unsurprising": ["ah-n s-er p-r-ay1 z-ih-ng", "jj"],
  "unsuspected": ["ah-n s-ah s-p-eh1-k t-ih-d", "jj"],
  "unsuspecting": ["ah-n s-ah s-p-eh1-k t-ih-ng", "jj"],
  "unsustainable": ["ah-n s-ah s-t-ey1 n-ah b-ah-l", "jj"],
  "unswerving": ["ah-n s-w-er1 v-ih-ng", "jj"],
  "unsympathetic": ["ah-n s-ih-m p-ah th-eh1 t-ih-k", "jj"],
  "untapped": ["ah-n t-ae1-p-t", "jj"],
  "untenable": ["ah-n t-eh1 n-ah b-ah-l", "jj"],
  "untested": ["ah-n t-eh1 s-t-ih-d", "jj"],
  "unthinkable": ["ah-n th-ih1-ng k-ah b-ah-l", "jj nn"],
  "unthinking": ["ah-n th-ih1-ng k-ih-ng", "jj"],
  "unthinkingly": ["ah-n th-ih1-ng k-ih-ng l-iy", "rb"],
  "untidy": ["ah-n t-ay1 d-iy", "jj"],
  "untie": ["ah-n-t-ay1", "vb"],
  "until": ["ah-n t-ih1-l", "in"],
  "untimely": ["ah-n t-ay1-m l-iy", "jj"],
  "unto": ["ah1-n t-uw", "in rp"],
  "untold": ["ah-n t-ow1-l-d", "jj"],
  "untouchable": ["ah-n t-ah1 ch-ah b-ah-l", "jj"],
  "untouched": ["ah-n t-ah1-ch-t", "jj"],
  "untoward": ["ah-n t-uw ao1-r-d", "jj"],
  "untraditional": ["ah-n t-r-ah d-ih1 sh-ah n-ah-l", "jj"],
  "untrained": ["ah-n t-r-ey1-n-d", "jj"],
  "untrammeled": ["ah-n t-r-ae1 m-ah-l-d", "jj"],
  "untreated": ["ah-n t-r-iy1 t-ih-d", "jj"],
  "untried": ["ah-n t-r-ay1-d", "jj"],
  "untrue": ["ah-n t-r-uw1", "jj"],
  "untrustworthy": ["ah-n t-r-ah1-s-t w-er dh-iy", "jj"],
  "unturned": ["ah-n t-er1-n-d", "jj"],
  "unusable": ["ah-n y-uw1 z-ah b-ah-l", "jj"],
  "unused": ["ah-n y-uw1-z-d", "jj"],
  "unusual": ["ah n-y-uw1 zh-uw ah-l", "jj"],
  "unusually": ["ah n-y-uw1 zh-uw ah-l-iy", "rb"],
  "unveil": ["ah-n v-ey1-l", "vb"],
  "unveiled": ["ah-n v-ey1-l-d", "vbd jj vbn"],
  "unverifiable": ["ah-n v-eh r-ih f-ay1 ah b-ah-l", "jj"],
  "unwanted": ["ah-n w-ao1-n t-ih-d", "jj"],
  "unwarranted": ["ah-n w-ao1 r-ah-n t-ih-d", "jj"],
  "unwary": ["ah-n w-eh1 r-iy", "jj"],
  "unwashed": ["ah-n w-aa1-sh-t", "jj"],
  "unwavering": ["ah-n w-ey1 v-er ih-ng", "jj"],
  "unwed": ["ah-n w-eh1-d", "jj"],
  "unwelcome": ["ah-n w-eh1-l k-ah-m", "jj"],
  "unwieldy": ["ah-n w-iy1-l d-iy", "jj"],
  "unwilling": ["ah-n w-ih1 l-ih-ng", "jj"],
  "unwillingness": ["ah-n w-ih1 l-ih-ng n-ih-s", "nn"],
  "unwind": ["ah-n w-ay1-n-d", "vb"],
  "unwise": ["ah-n w-ay1-z", "jj"],
  "unwisely": ["ah-n w-ay1-z l-iy", "rb"],
  "unwitting": ["ah-n w-ih1 t-ih-ng", "jj"],
  "unwittingly": ["ah-n w-ih1 t-ih-ng l-iy", "rb"],
  "unworkable": ["ah-n w-er1 k-ah b-ah-l", "jj"],
  "unworthy": ["ah-n w-er1 dh-iy", "jj nn"],
  "unwritten": ["ah-n r-ih1 t-ah-n", "jj"],
  "unyielding": ["ah-n y-iy1-l d-ih-ng", "jj"],
  "up": ["ah1-p", "in"],
  "upbeat": ["ah1-p b-iy-t", "jj nn"],
  "upbringing": ["ah1-p b-r-ih ng-ih-ng", "nn"],
  "upcoming": ["ah1-p k-ah m-ih-ng", "jj"],
  "update": ["ah-p d-ey1-t", "vb vbp nn"],
  "updated": ["ah-p d-ey1 t-ah-d", "vbn jj"],
  "upgrade": ["ah-p g-r-ey1-d", "vb jj nn"],
  "upgraded": ["ah-p g-r-ey1 d-ah-d", "vbn vbd jj"],
  "upheaval": ["ah-p hh-iy1 v-ah-l", "nn"],
  "upheld": ["ah-p hh-eh1-l-d", "vbd vbn"],
  "uphill": ["ah1-p hh-ih1-l", "jj rb"],
  "uphold": ["ah-p hh-ow1-l-d", "vb vbp"],
  "upholster": ["ah-p-ow1-l-s-t-er", "vb"],
  "upholstery": ["ah-p ow1-l s-t-er iy", "nn"],
  "upkeep": ["ah1-p k-iy-p", "nn"],
  "upland": ["ah1-p l-ah-n-d", "jj rb"],
  "uplift": ["ah1-p l-ih-f-t", "nn vb"],
  "uplifting": ["ah1-p l-ih-f t-ih-ng", "jj vbg"],
  "upmarket": ["ah1-p m-aa-r k-ah-t", "jj"],
  "upon": ["ah p-aa1-n", "in rb rp"],
  "upped": ["ah1-p-t", "vbd vbn"],
  "upper": ["ah1 p-er", "jj"],
  "uppermost": ["ah1 p-er m-ow-s-t", "jjs jj rb"],
  "upright": ["ah-p r-ay1-t", "rb jj"],
  "uprising": ["ah p-r-ay1 z-ih-ng", "nn"],
  "upriver": ["ah p-r-ih1 v-er", "jj"],
  "uproar": ["ah1-p r-ao-r", "nn"],
  "uproot": ["ah-p r-uw1-t", "vb"],
  "uprooted": ["ah-p r-uw1 t-ih-d", "vbn vbd jj"],
  "upscale": ["ah1-p s-k-ey-l", "jj nn rb"],
  "upset": ["ah-p s-eh1-t", "vbn nn vb vbd vbp jj"],
  "upsetting": ["ah-p s-eh1 t-ih-ng", "vbg jj nn"],
  "upshot": ["ah1-p sh-aa-t", "nn"],
  "upside": ["ah1-p s-ay1-d", "rb jj nn"],
  "upstage": ["ah-p-s-t-ey1-jh", "vb"],
  "upstairs": ["ah-p s-t-eh1-r-z", "nn rb jj"],
  "upstanding": ["ah1-p s-t-ae-n d-ih-ng", "jj"],
  "upstart": ["ah1-p s-t-aa-r-t", "nn jj"],
  "upstate": ["ah1-p s-t-ey1-t", "jj rb"],
  "upstream": ["ah1-p s-t-r-iy1-m", "rb jj"],
  "upsurge": ["ah1-p s-er-jh", "nn"],
  "upswing": ["ah-p s-w-ih1-ng", "nn"],
  "uptick": ["ah1-p t-ih-k", "nn jj vb"],
  "uptight": ["ah-p t-ay1-t", "jj"],
  "uptown": ["ah1-p t-aw1-n", "nn jj"],
  "uptrend": ["ah1-p t-r-eh-n-d", "nn"],
  "upturn": ["ah-p t-er1-n", "nn"],
  "upward": ["ah1-p w-er-d", "rb jj"],
  "upwardly": ["ah1-p w-er-d l-iy", "rb"],
  "uranium": ["y-er ey1 n-iy ah-m", "nn"],
  "urban": ["er1 b-ah-n", "jj"],
  "urbane": ["er b-ey1-n", "jj"],
  "urbanization": ["er b-ah n-ah z-ey1 sh-ah-n", "nn"],
  "urbanize": ["er1-b-ah-n-ay-z", "vb"],
  "urbanized": ["er1 b-ah n-ay-z-d", "vbn jj"],
  "urea": ["y-er iy1 ah", "nn"],
  "uremia": ["y-er iy1 m-iy ah", "nn"],
  "urethane": ["y-er1 ah th-ey-n", "nn"],
  "urge": ["er1-jh", "vb vbp nn"],
  "urgency": ["er1 jh-ah-n s-iy", "nn"],
  "urgent": ["er1 jh-ah-n-t", "jj"],
  "urgently": ["er1 jh-ah-n-t l-iy", "rb"],
  "urinary": ["y-er1 ah n-eh r-iy", "jj"],
  "urine": ["y-er1 ah-n", "nn"],
  "urn": ["er1-n", "nn"],
  "us": ["ah1-s", "prp"],
  "usable": ["y-uw1 z-ah b-ah-l", "jj"],
  "usage": ["y-uw1 s-ah-jh", "nn"],
  "use": ["y-uw1-s", "nn vb vbp"],
  "used": ["y-uw1-z-d", "vbn vbd jj"],
  "useful": ["y-uw1-s f-ah-l", "jj"],
  "usefully": ["y-uw1-s f-ah l-iy", "rb"],
  "usefulness": ["y-uw1-s f-ah-l n-ah-s", "nn"],
  "useless": ["y-uw1-s l-ah-s", "jj"],
  "user": ["y-uw1 z-er", "nn"],
  "usher": ["ah1 sh-er", "nn vbp vb"],
  "usual": ["y-uw1 zh-ah w-ah-l", "jj rb"],
  "usually": ["y-uw1 zh-ah-w ah l-iy", "rb"],
  "usurp": ["y-uw s-er1-p", "vb"],
  "usurpation": ["y-uw s-er p-ey1 sh-ah-n", "nn"],
  "utensil": ["y-uw t-eh1-n s-ah-l", "nn"],
  "uterus": ["y-uw1 t-er ah-s", "nn"],
  "utilitarian": ["y-uw t-ih l-ah t-eh1 r-iy ah-n", "jj"],
  "utility": ["y-uw t-ih1 l-ah t-iy", "nn jj"],
  "utilization": ["y-uw t-ah l-ah z-ey1 sh-ah-n", "nn"],
  "utilize": ["y-uw1 t-ah l-ay-z", "vb vbp"],
  "utmost": ["ah1-t m-ow-s-t", "jj nn"],
  "utopia": ["y-uw t-ow1 p-iy ah", "nn"],
  "utopian": ["y-uw t-ow1 p-iy ah-n", "jj nn"],
  "utter": ["ah1 t-er", "jj vbp vb"],
  "utterance": ["ah1 t-er ah-n-s", "nn"],
  "utterly": ["ah1 t-er l-iy", "rb"],
  "vacancy": ["v-ey1 k-ah-n s-iy", "nn"],
  "vacant": ["v-ey1 k-ah-n-t", "jj"],
  "vacate": ["v-ey1 k-ey-t", "vb"],
  "vacation": ["v-ey k-ey1 sh-ah-n", "nn vb"],
  "vacationer": ["v-ey k-ey1 sh-ah-n er", "nn"],
  "vaccination": ["v-ae-k s-ah n-ey1 sh-ah-n", "nn"],
  "vaccine": ["v-ae-k s-iy1-n", "nn"],
  "vaccinia": ["v-ah ch-iy1 n-iy ah", "nn"],
  "vacillate": ["v-ae1 s-ah l-ey-t", "vb"],
  "vacillation": ["v-ae s-ah l-ey1 sh-ah-n", "nn"],
  "vacuous": ["v-ae1 k-y-uw ah-s", "jj"],
  "vacuum": ["v-ae1 k-y-uw-m", "nn jj vb vbp"],
  "vagabond": ["v-ae1 g-ah b-aa-n-d", "nn"],
  "vagary": ["v-ey1 g-er iy", "nn"],
  "vagina": ["v-ah jh-ay1 n-ah", "nn"],
  "vaginal": ["v-ah jh-ay1 n-ah-l", "jj"],
  "vague": ["v-ey1-g", "jj"],
  "vaguely": ["v-ey1-g l-iy", "rb"],
  "vagueness": ["v-ey1-g n-ih-s", "nn"],
  "vaguer": ["v-ey1 g-er", "jjr"],
  "vaguest": ["v-ey1 g-ih-s-t", "jjs"],
  "vain": ["v-ey1-n", "jj rb"],
  "vainly": ["v-ey1-n l-iy", "rb"],
  "valet": ["v-ae l-ey1", "nn"],
  "valiant": ["v-ae1-l y-ah-n-t", "jj"],
  "valiantly": ["v-ae1-l y-ah-n-t l-iy", "rb"],
  "valid": ["v-ae1 l-ah-d", "jj"],
  "validate": ["v-ae1 l-ah d-ey-t", "vb"],
  "validation": ["v-ae l-ah d-ey1 sh-ah-n", "nn"],
  "validity": ["v-ah l-ih1 d-ah t-iy", "nn"],
  "validly": ["v-ae1 l-ih-d l-iy", "rb"],
  "valley": ["v-ae1 l-iy", "nn"],
  "valor": ["v-ae1 l-er", "nn"],
  "valuable": ["v-ae1-l y-ah b-ah-l", "jj"],
  "valuation": ["v-ae-l y-uw ey1 sh-ah-n", "nn"],
  "value": ["v-ae1-l y-uw", "nn vbp vb"],
  "valued": ["v-ae1-l y-uw-d", "vbn jj vbd"],
  "valueless": ["v-ae1-l y-uw l-ah-s", "jj"],
  "valve": ["v-ae1-l-v", "nn"],
  "vampire": ["v-ae1-m p-ay-r", "nn"],
  "van": ["v-ae1-n", "nn"],
  "vandal": ["v-ae1-n d-ah-l", "nn"],
  "vandalism": ["v-ae1-n d-ah l-ih z-ah-m", "nn"],
  "vandalize": ["v-ae1-n-d-ah-l-ay-z", "vb"],
  "vane": ["v-ey1-n", "nn"],
  "vanguard": ["v-ae1-n g-aa-r-d", "nn"],
  "vanilla": ["v-ah n-ih1 l-ah", "nn"],
  "vanish": ["v-ae1 n-ih-sh", "vbp vb"],
  "vanity": ["v-ae1 n-ah t-iy", "nn"],
  "vantage": ["v-ae1-n t-ah-jh", "nn"],
  "vapor": ["v-ey1 p-er", "nn"],
  "vaporization": ["v-ey p-er ah z-ey1 sh-ah-n", "nn"],
  "variability": ["v-eh r-iy ah b-ih1 l-ih t-iy", "nn"],
  "variable": ["v-eh1 r-iy ah b-ah-l", "jj nn"],
  "variance": ["v-eh1 r-iy ah-n-s", "nn"],
  "variant": ["v-eh1 r-iy ah-n-t", "nn jj"],
  "variation": ["v-eh r-iy ey1 sh-ah-n", "nn"],
  "varied": ["v-eh1 r-iy-d", "vbn vbd jj"],
  "variety": ["v-er ay1 ah t-iy", "nn"],
  "various": ["v-eh1 r-iy ah-s", "jj"],
  "variously": ["v-eh1 r-iy ah-s l-iy", "rb"],
  "varmint": ["v-aa1-r m-ih-n-t", "nn"],
  "varnish": ["v-aa1-r n-ih-sh", "nn"],
  "vary": ["v-eh1 r-iy", "vbp vb"],
  "varying": ["v-eh1 r-iy ih-ng", "vbg jj"],
  "vascular": ["v-ae1 s-k-y-ah l-er", "jj"],
  "vase": ["v-ey1-s", "nn"],
  "vassal": ["v-ae1 s-ah-l", "nn"],
  "vast": ["v-ae1-s-t", "jj"],
  "vastly": ["v-ae1-s-t l-iy", "rb"],
  "vat": ["v-ae1-t", "nn"],
  "vaudeville": ["v-aa1-d v-ih-l", "nn"],
  "vault": ["v-ao1-l-t", "nn vb"],
  "vaulting": ["v-ao1-l t-ih-ng", "jj vbg"],
  "vaunt": ["v-ao1-n-t", "vb"],
  "vaunted": ["v-ao1-n t-ih-d", "jj vbn"],
  "veal": ["v-iy1-l", "nn"],
  "vector": ["v-eh1-k t-er", "nn"],
  "veer": ["v-ih1-r", "vb"],
  "vegetable": ["v-eh1-jh t-ah b-ah-l", "nn"],
  "vegetarian": ["v-eh jh-ah t-eh1 r-iy ah-n", "jj"],
  "vegetation": ["v-eh jh-ah t-ey1 sh-ah-n", "nn"],
  "vehemence": ["v-iy1 ah m-ah-n-s", "nn"],
  "vehement": ["v-iy1 ah m-ah-n-t", "jj"],
  "vehemently": ["v-iy1 ah m-ah-n-t l-iy", "rb"],
  "vehicle": ["v-iy1 hh-ih k-ah-l", "nn"],
  "vehicular": ["v-iy hh-ih1 k-y-ah l-er", "jj"],
  "veil": ["v-ey1-l", "nn vb"],
  "veiled": ["v-ey1-l-d", "vbn jj"],
  "veiling": ["v-ey1 l-ih-ng", "nn"],
  "vein": ["v-ey1-n", "nn"],
  "velocity": ["v-ah l-aa1 s-ah t-iy", "nn"],
  "velvet": ["v-eh1-l v-ah-t", "nn"],
  "velvety": ["v-eh1-l v-ah t-iy", "jj"],
  "venal": ["v-iy1 n-ah-l", "jj"],
  "vend": ["v-eh1-n-d", "vb"],
  "vendetta": ["v-eh-n d-eh1 t-ah", "nn"],
  "vending": ["v-eh1-n d-ih-ng", "vbg jj"],
  "vendor": ["v-eh1-n d-er", "nn"],
  "veneer": ["v-ah n-ih1-r", "nn"],
  "venerable": ["v-eh1 n-er ah b-ah-l", "jj nn"],
  "venerate": ["v-eh1-n-er-ey-t", "vb"],
  "venereal": ["v-ah n-ih1 r-iy ah-l", "jj"],
  "vengeance": ["v-eh1-n jh-ah-n-s", "nn"],
  "venison": ["v-eh1 n-ah s-ah-n", "nn"],
  "venom": ["v-eh1 n-ah-m", "nn"],
  "venomous": ["v-eh1 n-ah m-ah-s", "jj"],
  "vent": ["v-eh1-n-t", "nn vb"],
  "ventilate": ["v-eh1-n-t-ih-l-ey-t", "vb"],
  "ventilated": ["v-eh1-n t-ah l-ey t-ih-d", "vbd vbn jj"],
  "ventilation": ["v-eh-n t-ah l-ey1 sh-ah-n", "nn"],
  "ventilator": ["v-eh1-n t-ah l-ey t-er", "nn"],
  "ventricular": ["v-eh-n t-r-ih1 k-y-uw l-er", "jj"],
  "venture": ["v-eh1-n ch-er", "nn vbp jj vb"],
  "venturesome": ["v-eh1-n ch-er s-ah-m", "jj"],
  "venue": ["v-eh1 n-y-uw", "nn"],
  "veracity": ["v-er ae1 s-ih t-iy", "nn"],
  "veranda": ["v-er ae1-n d-ah", "nn"],
  "verb": ["v-er1-b", "nn"],
  "verbal": ["v-er1 b-ah-l", "jj"],
  "verbally": ["v-er b-ae1 l-iy", "rb"],
  "verbatim": ["v-er b-ey1 t-ah-m", "rb jj"],
  "verbiage": ["v-er1 b-iy ih-jh", "nn"],
  "verdant": ["v-er1 d-ah-n-t", "jj"],
  "verdict": ["v-er1 d-ih-k-t", "nn"],
  "verge": ["v-er1-jh", "nn"],
  "verifiable": ["v-eh1 r-ah f-ay ah b-ah-l", "jj"],
  "verification": ["v-eh r-ah f-ah k-ey1 sh-ah-n", "nn"],
  "verified": ["v-eh1 r-ah f-ay-d", "vbn"],
  "verify": ["v-eh1 r-ah f-ay", "vb vbp"],
  "verisimilitude": ["v-eh r-ah s-ah m-ih1 l-ah t-uw-d", "nn"],
  "veritable": ["v-eh1 r-ih t-ah b-ah-l", "jj"],
  "verity": ["v-eh1 r-ah t-iy", "nn"],
  "vermilion": ["v-er m-ih1 l-y-ah-n", "jj nn"],
  "vernacular": ["v-er n-ae1 k-y-ah l-er", "nn jj"],
  "vernal": ["v-er1 n-ah-l", "jj"],
  "versatile": ["v-er1 s-ah t-ah-l", "jj"],
  "versatility": ["v-er s-ah t-ih1 l-ah t-iy", "nn"],
  "verse": ["v-er1-s", "nn"],
  "versed": ["v-er1-s-t", "jj"],
  "version": ["v-er1 zh-ah-n", "nn"],
  "versus": ["v-er1 s-ah-s", "in cc"],
  "vertebral": ["v-er1 t-ah b-r-ah-l", "jj"],
  "vertebrate": ["v-er1 t-ah b-r-ey-t", "nn"],
  "vertex": ["v-er1 t-eh-k-s", "nn"],
  "vertical": ["v-er1 t-ih k-ah-l", "jj nn"],
  "vertically": ["v-er1 t-ih-k l-iy", "rb"],
  "vertigo": ["v-er1 t-ih g-ow", "nn"],
  "verve": ["v-er1-v", "nn"],
  "very": ["v-eh1 r-iy", "rb jj"],
  "vessel": ["v-eh1 s-ah-l", "nn"],
  "vest": ["v-eh1-s-t", "nn vb"],
  "vested": ["v-eh1 s-t-ah-d", "vbn jj"],
  "vestige": ["v-eh1 s-t-ih-jh", "nn"],
  "vet": ["v-eh1-t", "nn"],
  "veteran": ["v-eh1 t-er ah-n", "nn jj"],
  "veterinarian": ["v-eh t-r-ah n-eh1 r-iy ah-n", "nn"],
  "veterinary": ["v-eh1 t-r-ah n-eh r-iy", "jj"],
  "veto": ["v-iy1 t-ow", "nn vb"],
  "vetted": ["v-eh1 t-ih-d", "vbn"],
  "via": ["v-ay1 ah", "in"],
  "viability": ["v-ay ah b-ih1 l-ah t-iy", "nn"],
  "viable": ["v-ay1 ah b-ah-l", "jj"],
  "viaduct": ["v-ay1 ah d-ah-k-t", "nn"],
  "vial": ["v-ay1 ah-l", "nn"],
  "vibe": ["v-ay1-b", "nn"],
  "vibrancy": ["v-ay1 b-r-ah-n s-iy", "nn"],
  "vibrant": ["v-ay1 b-r-ah-n-t", "jj"],
  "vibrate": ["v-ay1 b-r-ey-t", "vb"],
  "vibration": ["v-ay b-r-ey1 sh-ah-n", "nn"],
  "vibrato": ["v-iy b-r-aa1 t-ow", "nn"],
  "vicar": ["v-ih1 k-er", "nn"],
  "vicarious": ["v-ay k-eh1 r-iy ah-s", "jj"],
  "vicariously": ["v-ay k-eh1 r-iy ah-s l-iy", "rb"],
  "vice": ["v-ay1-s", "nn jj rb"],
  "vicinity": ["v-ah s-ih1 n-ah t-iy", "nn"],
  "vicious": ["v-ih1 sh-ah-s", "jj"],
  "viciously": ["v-ih1 sh-ah-s l-iy", "rb"],
  "vicissitude": ["v-ih s-ih1 s-ih t-uw-d", "nn"],
  "victim": ["v-ih1-k t-ah-m", "nn"],
  "victimize": ["v-ih1-k-t-ah-m-ay-z", "vb"],
  "victimized": ["v-ih1-k t-ah m-ay-z-d", "vbn jj"],
  "victimless": ["v-ih1-k t-ah-m l-ah-s", "jj"],
  "victor": ["v-ih1-k t-er", "nn"],
  "victorious": ["v-ih-k t-ao1 r-iy ah-s", "jj"],
  "victory": ["v-ih1-k t-er iy", "nn"],
  "video": ["v-ih1 d-iy ow", "nn jj"],
  "videocassette": ["v-ih1 d-iy ow k-ae s-eh-t", "nn"],
  "videotape": ["v-ih1 d-iy ow t-ey1-p", "nn vb"],
  "videotext": ["v-ih1 d-iy ow t-eh-k-s-t", "nn"],
  "view": ["v-y-uw1", "nn vbp vb"],
  "viewer": ["v-y-uw1 er", "nn"],
  "viewership": ["v-y-uw1 er sh-ih-p", "nn"],
  "viewpoint": ["v-y-uw1 p-oy-n-t", "nn"],
  "vigil": ["v-ih1 jh-ah-l", "nn"],
  "vigilance": ["v-ih1 jh-ah l-ah-n-s", "nn"],
  "vigilant": ["v-ih1 jh-ah l-ah-n-t", "jj"],
  "vigilante": ["v-ih jh-ah l-ae1-n t-ih", "nn"],
  "vigilantism": ["v-ih jh-ah l-ae1-n t-ih z-ah-m", "nn"],
  "vignette": ["v-ih-n y-eh1-t", "nn"],
  "vigor": ["v-ih1 g-er", "nn"],
  "vigorous": ["v-ih1 g-er ah-s", "jj"],
  "vigorously": ["v-ih1 g-er ah-s l-iy", "rb"],
  "vile": ["v-ay1-l", "jj"],
  "vilification": ["v-ih l-ah f-ah k-ey1 sh-ah-n", "nn"],
  "vilified": ["v-ih1 l-ah f-ay-d", "vbn"],
  "vilify": ["v-ih1-l-ih-f-ay", "vb"],
  "villa": ["v-ih1 l-ah", "nn"],
  "village": ["v-ih1 l-ah-jh", "nn"],
  "villager": ["v-ih1 l-ih jh-er", "nn"],
  "villain": ["v-ih1 l-ah-n", "nn"],
  "villainous": ["v-ih1 l-ah n-ah-s", "jj"],
  "vindicate": ["v-ih1-n d-ah k-ey-t", "vb"],
  "vindication": ["v-ih-n d-ah k-ey1 sh-ah-n", "nn"],
  "vindictive": ["v-ih-n d-ih1-k t-ih-v", "jj"],
  "vine": ["v-ay1-n", "nn"],
  "vinegar": ["v-ih1 n-ah g-er", "nn"],
  "vineyard": ["v-ih1-n y-er-d", "nn"],
  "vintage": ["v-ih1-n t-ih-jh", "jj nn"],
  "vintner": ["v-ih1-n-t n-er", "nn"],
  "vinyl": ["v-ay1 n-ah-l", "nn"],
  "violate": ["v-ay1 ah l-ey-t", "vb vbp jj"],
  "violation": ["v-ay ah l-ey1 sh-ah-n", "nn"],
  "violator": ["v-ay1 ah l-ey t-er", "nn"],
  "violence": ["v-ay1 ah l-ah-n-s", "nn"],
  "violent": ["v-ay1 ah l-ah-n-t", "jj"],
  "violently": ["v-ay1 ah l-ah-n-t l-iy", "rb"],
  "violet": ["v-ay1 ah l-ih-t", "nn"],
  "violin": ["v-ay ah l-ih1-n", "nn"],
  "violinist": ["v-ay ah l-ih1 n-ah-s-t", "nn"],
  "viper": ["v-ay1 p-er", "nn"],
  "viral": ["v-ay1 r-ah-l", "jj"],
  "virgin": ["v-er1 jh-ih-n", "jj nn"],
  "virginity": ["v-er jh-ih1 n-ih t-iy", "nn"],
  "virile": ["v-ih1 r-ah-l", "jj"],
  "virility": ["v-er ih1 l-ah t-iy", "nn"],
  "virtual": ["v-er1 ch-uw ah-l", "jj"],
  "virtually": ["v-er1 ch-uw ah l-iy", "rb in jj"],
  "virtue": ["v-er1 ch-uw", "nn"],
  "virtuosity": ["v-er ch-uw aa1 s-ih t-iy", "nn"],
  "virtuoso": ["v-er ch-uw ow1 s-ow", "jj nn"],
  "virtuous": ["v-er1 ch-uw ah-s", "jj"],
  "virulence": ["v-ih1 r-ah l-ah-n-s", "nn"],
  "virulent": ["v-ih1 r-ah l-ah-n-t", "jj"],
  "virus": ["v-ay1 r-ah-s", "nn"],
  "visa": ["v-iy1 z-ah", "nn"],
  "visage": ["v-ih1 z-ah-jh", "nn"],
  "visceral": ["v-ih1 s-er ah-l", "jj"],
  "viscosity": ["v-ih-s k-aa1 s-ah t-iy", "nn"],
  "viscous": ["v-ih1-s k-ah-s", "jj"],
  "vise": ["v-ay1-s", "nn"],
  "visibility": ["v-ih z-ah b-ih1 l-ih t-iy", "nn"],
  "visible": ["v-ih1 z-ah b-ah-l", "jj"],
  "visibly": ["v-ih1 z-ah b-l-iy", "rb"],
  "vision": ["v-ih1 zh-ah-n", "nn"],
  "visionary": ["v-ih1 zh-ah-n eh r-iy", "jj"],
  "visit": ["v-ih1 z-ah-t", "nn vb vbp"],
  "visitation": ["v-ih z-ah t-ey1 sh-ah-n", "nn"],
  "visiting": ["v-ih1 z-ah t-ih-ng", "vbg jj"],
  "visitor": ["v-ih1 z-ah t-er", "nn"],
  "vista": ["v-ih1 s-t-ah", "nn"],
  "visual": ["v-ih1 zh-ah w-ah-l", "jj"],
  "visualization": ["v-ih zh-w-ah l-ah z-ey1 sh-ah-n", "nn"],
  "visualize": ["v-ih1 zh-w-ah l-ay-z", "vb"],
  "visually": ["v-ih1 zh-w-ah l-iy", "rb"],
  "vital": ["v-ay1 t-ah-l", "jj"],
  "vitality": ["v-ay t-ae1 l-ah t-iy", "nn"],
  "vitally": ["v-ay1 t-ah l-iy", "rb"],
  "vitamin": ["v-ay1 t-ah m-ah-n", "nn"],
  "vitriol": ["v-ih1 t-r-iy ah-l", "nn"],
  "vitriolic": ["v-ih t-r-iy aa1 l-ih-k", "jj"],
  "vivacious": ["v-ah v-ey1 sh-ah-s", "jj"],
  "vivid": ["v-ih1 v-ah-d", "jj"],
  "vividly": ["v-ih1 v-ah-d l-iy", "rb"],
  "vividness": ["v-ih1 v-ah-d n-ah-s", "nn"],
  "vocabulary": ["v-ow k-ae1 b-y-ah l-eh r-iy", "nn"],
  "vocal": ["v-ow1 k-ah-l", "jj nn"],
  "vocalist": ["v-ow1 k-ah l-ih-s-t", "nn"],
  "vocally": ["v-ow1 k-ah l-iy", "rb"],
  "vocation": ["v-ow k-ey1 sh-ah-n", "nn"],
  "vocational": ["v-ow k-ey1 sh-ah n-ah-l", "jj"],
  "vociferous": ["v-ow s-ih1 f-er ah-s", "jj"],
  "vociferously": ["v-ah s-ih1 f-er ah-s l-iy", "rb"],
  "vodka": ["v-aa1-d k-ah", "nn"],
  "vogue": ["v-ow1-g", "nn"],
  "voice": ["v-oy1-s", "nn vbp vb"],
  "voiced": ["v-oy1-s-t", "vbd jj vbn"],
  "voiceless": ["v-oy1-s l-ah-s", "jj"],
  "void": ["v-oy1-d", "nn jj vb"],
  "volatile": ["v-aa1 l-ah t-ah-l", "jj"],
  "volatility": ["v-aa l-ah t-ih1 l-ah t-iy", "nn"],
  "volcanic": ["v-aa-l k-ae1 n-ih-k", "jj"],
  "volcano": ["v-aa-l k-ey1 n-ow", "nn"],
  "volition": ["v-ow l-ih1 sh-ah-n", "nn"],
  "volley": ["v-aa1 l-iy", "nn"],
  "volleyball": ["v-aa1 l-iy b-ao-l", "nn"],
  "volt": ["v-ow1-l-t", "nn"],
  "voltage": ["v-ow1-l t-ah-jh", "nn"],
  "voluble": ["v-aa1 l-y-ah b-ah-l", "jj"],
  "volume": ["v-aa1 l-y-uw-m", "nn"],
  "voluminous": ["v-ah l-uw1 m-ah n-ah-s", "jj"],
  "voluntarily": ["v-aa l-ah-n t-eh1 r-ah l-iy", "rb"],
  "voluntary": ["v-aa1 l-ah-n t-eh r-iy", "jj"],
  "volunteer": ["v-aa l-ah-n t-ih1-r", "nn vb vbp"],
  "voluptuous": ["v-ah l-ah1-p ch-ah-w ah-s", "jj"],
  "vomit": ["v-aa1 m-ah-t", "vb vbp"],
  "voodoo": ["v-uw1 d-uw", "nn"],
  "voracious": ["v-ao r-ey1 sh-ah-s", "jj"],
  "vortex": ["v-ao1-r t-eh-k-s", "nn"],
  "vote": ["v-ow1-t", "nn vb vbp"],
  "voter": ["v-ow1 t-er", "nn"],
  "voting": ["v-ow1 t-ih-ng", "nn jj vbg"],
  "voucher": ["v-aw1 ch-er", "nn"],
  "vow": ["v-aw1", "nn vb vbp"],
  "vowel": ["v-aw1 ah-l", "nn jj"],
  "voyage": ["v-oy1 ah-jh", "nn"],
  "voyager": ["v-oy1 ah jh-er", "nn"],
  "voyeurism": ["v-oy y-uw1 r-ih z-ah-m", "nn"],
  "vulgar": ["v-ah1-l g-er", "jj"],
  "vulnerability": ["v-ah-l n-er ah b-ih1 l-ih t-iy", "nn"],
  "vulnerable": ["v-ah1-l n-er ah b-ah-l", "jj"],
  "vulture": ["v-ah1-l ch-er", "nn"],
  "wacky": ["w-ae1 k-iy", "jj"],
  "wad": ["w-aa1-d", "nn vb"],
  "wade": ["w-ey1-d", "vb"],
  "wafer": ["w-ey1 f-er", "nn"],
  "waffle": ["w-aa1 f-ah-l", "nn vb"],
  "waffling": ["w-aa1 f-l-ih-ng", "vbg jj nn"],
  "waft": ["w-aa1-f-t", "vb"],
  "wag": ["w-ae1-g", "vb vbp"],
  "wage": ["w-ey1-jh", "nn vb"],
  "wager": ["w-ey1 jh-er", "nn vb"],
  "waggle": ["w-ae1 g-ah-l", "vb"],
  "wagon": ["w-ae1 g-ah-n", "nn"],
  "waif": ["w-ey1-f", "nn"],
  "wail": ["w-ey1-l", "nn vb"],
  "waist": ["w-ey1-s-t", "nn"],
  "wait": ["w-ey1-t", "vb vbp nn"],
  "waiter": ["w-ey1 t-er", "nn"],
  "waiting": ["w-ey1 t-ih-ng", "vbg jj"],
  "waitress": ["w-ey1 t-r-ah-s", "nn"],
  "waive": ["w-ey1-v", "vb"],
  "waiver": ["w-ey1 v-er", "nn"],
  "wake": ["w-ey1-k", "vbp vb"],
  "waking": ["w-ey1 k-ih-ng", "vbg jj"],
  "wale": ["w-ey1-l", "nn"],
  "walk": ["w-ao1-k", "vb vbp nn"],
  "walker": ["w-ao1 k-er", "nn"],
  "walking": ["w-ao1 k-ih-ng", "vbg jj"],
  "walkout": ["w-ao1-k aw-t", "nn"],
  "walkway": ["w-ao1-k w-ey", "nn"],
  "wall": ["w-ao1-l", "nn vbp vb"],
  "wallboard": ["w-ao1-l b-ao-r-d", "nn"],
  "walled": ["w-ao1-l-d", "jj vbn"],
  "wallet": ["w-ao1 l-ah-t", "nn"],
  "wallflower": ["w-ao1-l f-l-aw er", "nn"],
  "wallop": ["w-aa1 l-ah-p", "nn vb"],
  "walloping": ["w-ao1 l-ah p-ih-ng", "jj nn"],
  "wallow": ["w-aa1 l-ow", "vb"],
  "wallpaper": ["w-ao1-l p-ey p-er", "nn"],
  "walnut": ["w-ao1-l n-ah-t", "nn"],
  "walrus": ["w-ao1-l r-ah-s", "nn"],
  "waltz": ["w-ao1-l-t-s", "nn vb"],
  "wan": ["w-aa1-n", "jj"],
  "wand": ["w-aa1-n-d", "nn"],
  "wander": ["w-aa1-n d-er", "vb vbp"],
  "wanderer": ["w-aa1-n d-er er", "nn"],
  "wane": ["w-ey1-n", "vb vbp nn"],
  "wangle": ["w-ae1-ng-g-ah-l", "vb"],
  "want": ["w-aa1-n-t", "vbp vb nn"],
  "wanted": ["w-aa1-n t-ah-d", "vbd jj vbn"],
  "wanton": ["w-ao1-n t-ah-n", "jj"],
  "war": ["w-ao1-r", "nn"],
  "warble": ["w-ao1-r-b-ah-l", "vb"],
  "ward": ["w-ao1-r-d", "nn vb"],
  "warden": ["w-ao1-r d-ah-n", "nn"],
  "wardrobe": ["w-ao1-r-d r-ow-b", "nn"],
  "ware": ["w-eh1-r", "nn"],
  "warehouse": ["w-eh1-r hh-aw-s", "nn vb"],
  "warehousing": ["w-eh1-r hh-aw z-ih-ng", "nn"],
  "warfare": ["w-ao1-r f-eh-r", "nn"],
  "warhead": ["w-ao1-r hh-eh-d", "nn"],
  "warily": ["w-eh1 r-ah l-iy", "rb"],
  "wariness": ["w-eh1 r-iy n-ih-s", "nn"],
  "warlike": ["w-ao1-r l-ay-k", "jj"],
  "warlord": ["w-ao1-r l-ao-r-d", "nn"],
  "warm": ["w-ao1-r-m", "jj vb"],
  "warmer": ["w-ao1-r m-er", "jjr"],
  "warmish": ["w-ao1-r m-ih-sh", "jj"],
  "warmly": ["w-ao1-r-m l-iy", "rb"],
  "warmth": ["w-ao1-r-m-th", "nn"],
  "warmup": ["w-ao1-r m-ah-p", "nn"],
  "warn": ["w-ao1-r-n", "vb vbp"],
  "warning": ["w-ao1-r n-ih-ng", "nn vbg"],
  "warningly": ["w-ao1-r n-ih-ng l-iy", "rb"],
  "warp": ["w-ao1-r-p", "nn vb"],
  "warped": ["w-ao1-r-p-t", "vbn jj"],
  "warrant": ["w-ao1 r-ah-n-t", "nn vbp vb"],
  "warranted": ["w-ao1 r-ah-n t-ih-d", "vbn jj vbd"],
  "warrantless": ["w-ao1 r-ah-n-t l-ah-s", "jj"],
  "warranty": ["w-ao1 r-ah-n t-iy", "nn"],
  "warren": ["w-ao1 r-ah-n", "nn"],
  "warrior": ["w-ao1 r-iy er", "nn"],
  "warship": ["w-ao1-r sh-ih-p", "nn"],
  "wart": ["w-ao1-r-t", "nn"],
  "wartime": ["w-ao1-r t-ay-m", "nn"],
  "wary": ["w-eh1 r-iy", "jj"],
  "was": ["w-aa1-z", "vbd"],
  "wasn't": ["w-aa1-z-ah-n-t", "vbd"],
  "wash": ["w-aa1-sh", "nn vbp vb"],
  "washable": ["w-aa1 sh-ah b-ah-l", "jj"],
  "washbasin": ["w-aa1-sh b-ey s-ah-n", "nn"],
  "washboard": ["w-aa1-sh b-ao-r-d", "nn"],
  "washed": ["w-aa1-sh-t", "vbn vbd jj"],
  "washer": ["w-aa1 sh-er", "nn"],
  "washout": ["w-aa1-sh aw-t", "nn"],
  "wasp": ["w-aa1-s-p", "nn"],
  "waste": ["w-ey1-s-t", "nn vbp jj vb"],
  "wastebasket": ["w-ey1-s-t b-ae s-k-ah-t", "nn"],
  "wasted": ["w-ey1 s-t-ah-d", "vbn vbd jj"],
  "wasteful": ["w-ey1-s-t f-ah-l", "jj"],
  "wasteland": ["w-ey1-s-t l-ae-n-d", "nn"],
  "wastepaper": ["w-ey1-s-t p-ey p-er", "nn"],
  "wastewater": ["w-ey1-s-t w-ao t-er", "nn"],
  "wasting": ["w-ey1 s-t-ih-ng", "vbg jj nn"],
  "watch": ["w-aa1-ch", "vb jj nn vbp"],
  "watchdog": ["w-aa1-ch d-ao-g", "nn jj"],
  "watched": ["w-aa1-ch-t", "vbd vbn jj"],
  "watcher": ["w-aa1 ch-er", "nn"],
  "watchful": ["w-aa1-ch f-ah-l", "jj"],
  "watchman": ["w-aa1-ch m-ah-n", "nn"],
  "watchword": ["w-aa1-ch w-er-d", "nn"],
  "water": ["w-ao1 t-er", "nn vb jj"],
  "watercolor": ["w-ao1 t-er k-ah l-er", "nn"],
  "waterfall": ["w-ao1 t-er f-ao-l", "nn"],
  "waterfront": ["w-ao1 t-er f-r-ah-n-t", "nn"],
  "waterlogged": ["w-ao1 t-er l-aa-g-d", "jj"],
  "watermelon": ["w-ao1 t-er m-eh l-ah-n", "nn"],
  "waterproof": ["w-ao1 t-er p-r-uw-f", "nn"],
  "waterproofing": ["w-ao1 t-er p-r-uw f-ih-ng", "nn"],
  "watershed": ["w-ao1 t-er sh-eh-d", "nn jj"],
  "waterway": ["w-ao1 t-er w-ey", "nn"],
  "waterworks": ["w-ao1 t-er w-er-k-s", "nn"],
  "watery": ["w-ao1 t-er iy", "jj"],
  "watt": ["w-aa1-t", "nn"],
  "wattle": ["w-aa1 t-ah-l", "nn"],
  "wave": ["w-ey1-v", "nn vb vbp"],
  "wavelength": ["w-ey1-v l-eh-ng-th", "nn"],
  "waver": ["w-ey1 v-er", "vbp nn vb"],
  "wavy": ["w-ey1 v-iy", "jj"],
  "wax": ["w-ae1-k-s", "nn vb"],
  "waxed": ["w-ae1-k-s-t", "vbd jj vbn"],
  "waxing": ["w-ae1-k s-ih-ng", "nn"],
  "waxy": ["w-ae1-k s-iy", "jj"],
  "way": ["w-ey1", "nn rb"],
  "waylaid": ["w-ey1 l-ey-d", "vbn"],
  "wayside": ["w-ey1 s-ay-d", "nn"],
  "wayward": ["w-ey1 w-er-d", "jj"],
  "we": ["w-iy1", "prp"],
  "weak": ["w-iy1-k", "jj"],
  "weaken": ["w-iy1 k-ah-n", "vb vbp"],
  "weakened": ["w-iy1 k-ah-n-d", "vbn jj vbd"],
  "weakening": ["w-iy1 k-ah n-ih-ng", "vbg jj"],
  "weaker": ["w-iy1 k-er", "jjr rbr"],
  "weakest": ["w-iy1 k-ah-s-t", "jjs"],
  "weakly": ["w-iy1-k l-iy", "rb"],
  "weakness": ["w-iy1-k n-ah-s", "nn"],
  "wealth": ["w-eh1-l-th", "nn"],
  "wealthier": ["w-eh1-l th-iy er", "jjr"],
  "wealthiest": ["w-eh1-l th-iy ah-s-t", "jjs"],
  "wealthy": ["w-eh1-l th-iy", "jj"],
  "wean": ["w-iy1-n", "vb"],
  "weapon": ["w-eh1 p-ah-n", "nn"],
  "weaponry": ["w-eh1 p-ah-n r-iy", "nn"],
  "wear": ["w-eh1-r", "vb jj nn vbp"],
  "wearied": ["w-ih1 r-iy-d", "vbd"],
  "wearily": ["w-eh1 r-ah l-iy", "rb"],
  "weariness": ["w-ih1 r-iy n-ah-s", "nn"],
  "wearisome": ["w-ih1 r-iy s-ah-m", "jj"],
  "weary": ["w-ih1 r-iy", "jj vb"],
  "weasel": ["w-iy1 z-ah-l", "nn"],
  "weather": ["w-eh1 dh-er", "nn vb vbp"],
  "weatherman": ["w-eh1 dh-er m-ae-n", "nn"],
  "weatherproof": ["w-eh1 dh-er p-r-uw-f", "jj"],
  "weave": ["w-iy1-v", "vb nn"],
  "weaver": ["w-iy1 v-er", "nn"],
  "web": ["w-eh1-b", "nn jj"],
  "wed": ["w-eh1-d", "vbn vb"],
  "wedded": ["w-eh1 d-ah-d", "vbn jj"],
  "wedding": ["w-eh1 d-ih-ng", "nn"],
  "wedge": ["w-eh1-jh", "nn vb"],
  "wedlock": ["w-eh1-d l-aa-k", "nn"],
  "wee": ["w-iy1", "jj prp"],
  "weed": ["w-iy1-d", "nn vb"],
  "week": ["w-iy1-k", "nn"],
  "weekday": ["w-iy1-k d-ey", "nn jj"],
  "weekend": ["w-iy1-k eh-n-d", "nn"],
  "weeklong": ["w-iy1-k l-ao-ng", "jj nn"],
  "weekly": ["w-iy1-k l-iy", "jj rb nn"],
  "weep": ["w-iy1-p", "vb nn"],
  "weevil": ["w-iy1 v-ah-l", "nn"],
  "weigh": ["w-ey1", "vb vbp"],
  "weight": ["w-ey1-t", "nn vb"],
  "weighted": ["w-ey1 t-ih-d", "jj vbd vbn"],
  "weighting": ["w-ey1 t-ih-ng", "nn"],
  "weightlessness": ["w-ey1-t l-ah-s n-ah-s", "nn"],
  "weighty": ["w-ey1 t-iy", "jj"],
  "weir": ["w-iy1-r", "nn"],
  "weird": ["w-ih1-r-d", "jj nn"],
  "weirdest": ["w-ih1-r d-ah-s-t", "jjs"],
  "weirdly": ["w-ih1-r-d l-iy", "rb"],
  "weirdo": ["w-ih1-r d-ow", "nn"],
  "welcome": ["w-eh1-l k-ah-m", "jj nn vb vbp"],
  "welcoming": ["w-eh1-l k-ah m-ih-ng", "vbg jj"],
  "weld": ["w-eh1-l-d", "vb nn"],
  "welfare": ["w-eh1-l f-eh-r", "nn"],
  "well": ["w-eh1-l", "rb vbp jj nn vb uh"],
  "wellhead": ["w-eh1-l hh-eh-d", "nn"],
  "wellness": ["w-eh1-l n-ah-s", "nn"],
  "wellspring": ["w-eh1-l s-p-r-ih-ng", "nn"],
  "welter": ["w-eh1-l t-er", "nn"],
  "went": ["w-eh1-n-t", "vbd vbn"],
  "wept": ["w-eh1-p-t", "vbd vbn"],
  "were": ["w-er", "vbd"],
  "weren't": ["w-er-ah-n-t", "vbd"],
  "west": ["w-eh1-s-t", "nn jj rb jjs"],
  "westbound": ["w-eh1-s-t b-aw-n-d", "jj"],
  "westerly": ["w-eh1 s-t-er l-iy", "jj rb"],
  "western": ["w-eh1 s-t-er-n", "jj"],
  "westward": ["w-eh1-s-t w-er-d", "rb jj nn"],
  "wet": ["w-eh1-t", "jj nn vbd vb vbp"],
  "wetland": ["w-eh1-t l-ae-n-d", "nn"],
  "wetness": ["w-eh1-t n-ah-s", "nn"],
  "whack": ["w-ae1-k", "vb nn"],
  "whale": ["w-ey1-l", "nn"],
  "whaling": ["w-ey1 l-ih-ng", "nn"],
  "whammy": ["w-ae1 m-iy", "nn"],
  "wharf": ["w-ao1-r-f", "nn"],
  "what": ["w-ah1-t", "wp wdt in"],
  "whatever": ["w-ah-t eh1 v-er", "wdt rb wp"],
  "whatsoever": ["w-ah-t s-ow eh1 v-er", "rb wp"],
  "wheat": ["w-iy1-t", "nn jj"],
  "wheel": ["w-iy1-l", "nn vb vbp"],
  "wheelchair": ["w-iy1-l ch-eh-r", "nn"],
  "wheeled": ["w-iy1-l-d", "vbd jj vbn"],
  "wheeze": ["w-iy1-z", "vb nn"],
  "wheezing": ["w-iy1 z-ih-ng", "vbg jj"],
  "when": ["w-eh1-n", "wrb in"],
  "whence": ["w-eh1-n-s", "wrb"],
  "whenever": ["w-eh-n eh1 v-er", "wrb"],
  "where": ["w-eh1-r", "wrb"],
  "whereabouts": ["w-eh1 r-ah b-aw-t-s", "nn"],
  "whereas": ["w-eh r-ae1-z", "in"],
  "whereby": ["w-eh-r b-ay1", "wrb"],
  "wherein": ["w-eh r-ih1-n", "wrb rb"],
  "whereupon": ["w-eh1 r-ah p-aa1-n", "in"],
  "wherever": ["w-eh r-eh1 v-er", "wrb"],
  "wherewithal": ["w-eh1-r w-ih dh-ao-l", "nn jj"],
  "whet": ["w-eh1-t", "vb"],
  "whether": ["w-eh1 dh-er", "in cc"],
  "which": ["w-ih1-ch", "wdt wp"],
  "whichever": ["w-ih-ch eh1 v-er", "wdt"],
  "whiff": ["w-ih1-f", "nn"],
  "while": ["w-ay1-l", "in jj nn rb vb"],
  "whim": ["w-ih1-m", "nn"],
  "whimper": ["w-ih1-m p-er", "nn vb"],
  "whimsical": ["w-ih1-m z-ih k-ah-l", "jj"],
  "whimsy": ["w-ih1-m s-iy", "nn"],
  "whine": ["w-ay1-n", "nn vb"],
  "whip": ["w-ih1-p", "nn vb"],
  "whiplash": ["w-ih1-p l-ae-sh", "nn"],
  "whipped": ["w-ih1-p-t", "vbd vbn jj"],
  "whipping": ["w-ih1 p-ih-ng", "vbg jj nn"],
  "whirl": ["w-er1-l", "nn vb vbp"],
  "whirling": ["w-er1 l-ih-ng", "vbg jj nn"],
  "whirlpool": ["w-er1-l p-uw-l", "nn"],
  "whirlwind": ["w-er1-l w-ih-n-d", "nn jj"],
  "whisk": ["w-ih1-s-k", "vb"],
  "whisker": ["w-ih1 s-k-er", "nn"],
  "whiskey": ["w-ih1-s k-iy", "nn"],
  "whisky": ["w-ih1-s k-iy", "nn"],
  "whisper": ["w-ih1 s-p-er", "nn vb"],
  "whispered": ["w-ih1 s-p-er-d", "vbd vbn jj"],
  "whistle": ["w-ih1 s-ah-l", "nn vb vbp"],
  "whistleblower": ["w-ih1 s-ah-l b-l-ow er", "nn"],
  "white": ["w-ay1-t", "jj nn"],
  "whitely": ["w-ay1-t l-iy", "rb"],
  "whiteness": ["w-ay1-t n-ah-s", "nn"],
  "whitetail": ["w-ay1-t t-ey-l", "nn"],
  "whitewash": ["w-ay1-t w-aa-sh", "nn vb"],
  "whitish": ["w-ay1 t-ih-sh", "jj"],
  "whittle": ["w-ih1 t-ah-l", "vb vbp"],
  "whiz": ["w-ih1-z", "nn vb uh"],
  "who": ["hh-uw1", "wp nn"],
  "whoever": ["hh-uw eh1 v-er", "wp"],
  "whole": ["hh-ow1-l", "jj nn rp"],
  "wholehearted": ["hh-ow1-l hh-aa-r t-ih-d", "jj"],
  "wholeheartedly": ["hh-ow1-l hh-aa-r t-ih-d l-iy", "rb"],
  "wholesale": ["hh-ow1-l s-ey-l", "jj nn vb"],
  "wholesaler": ["hh-ow1-l s-ey l-er", "nn"],
  "wholesome": ["hh-ow1-l s-ah-m", "jj"],
  "wholly": ["hh-ow1 l-iy", "rb"],
  "whom": ["hh-uw1-m", "wp"],
  "whoop": ["w-uw1-p", "nn vb"],
  "whoosh": ["w-uw1-sh", "vb vbp nn"],
  "whopper": ["w-aa1 p-er", "nn"],
  "whopping": ["w-aa1 p-ih-ng", "jj"],
  "whore": ["hh-ao1-r", "nn"],
  "whorl": ["w-er1-l", "nn"],
  "whose": ["hh-uw1-z", "wp$"],
  "whosoever": ["hh-uw s-ow eh1 v-er", "wp"],
  "why": ["w-ay1", "wrb"],
  "wick": ["w-ih1-k", "nn"],
  "wicked": ["w-ih1 k-ah-d", "jj"],
  "wickedly": ["w-ih1 k-ih-d l-iy", "rb"],
  "wickedness": ["w-ih1 k-ah-d n-ah-s", "nn"],
  "wicker": ["w-ih1 k-er", "nn"],
  "wicket": ["w-ih1 k-ah-t", "nn"],
  "wide": ["w-ay1-d", "jj rb"],
  "widely": ["w-ay1-d l-iy", "rb"],
  "widen": ["w-ay1 d-ah-n", "vb vbp"],
  "wider": ["w-ay1 d-er", "jjr rbr"],
  "widespread": ["w-ay1-d s-p-r-eh1-d", "jj"],
  "widest": ["w-ay1 d-ah-s-t", "jjs"],
  "widget": ["w-ih1 jh-ih-t", "nn"],
  "widow": ["w-ih1 d-ow", "nn vb"],
  "widowed": ["w-ih1 d-ow-d", "vbn jj"],
  "widower": ["w-ih1 d-ow er", "nn"],
  "width": ["w-ih1-d-th", "nn"],
  "wield": ["w-iy1-l-d", "vb vbp"],
  "wiener": ["w-iy1 n-er", "nn"],
  "wife": ["w-ay1-f", "nn"],
  "wig": ["w-ih1-g", "nn"],
  "wiggle": ["w-ih1 g-ah-l", "nn jj vb vbp"],
  "wild": ["w-ay1-l-d", "jj rb"],
  "wildcat": ["w-ay1-l-d k-ae-t", "nn jj"],
  "wildcatter": ["w-ay1-l-d k-ae t-er", "nn"],
  "wilderness": ["w-ih1-l d-er n-ah-s", "nn"],
  "wildest": ["w-ay1-l d-ih-s-t", "jjs"],
  "wildflower": ["w-ay1-l-d f-l-aw-r", "nn"],
  "wildlife": ["w-ay1-l-d l-ay-f", "nn"],
  "wildly": ["w-ay1-l-d l-iy", "rb"],
  "wildness": ["w-ay1-l-d n-ah-s", "nn"],
  "wile": ["w-ay1-l", "nn"],
  "will": ["w-ih1-l", "md vbp nn vb"],
  "willful": ["w-ih1-l f-ah-l", "jj"],
  "willfully": ["w-ih1-l f-ah l-iy", "rb"],
  "william": ["w-ih1 l-y-ah-m", "nn"],
  "willing": ["w-ih1 l-ih-ng", "jj vbg"],
  "willingly": ["w-ih1 l-ih-ng l-iy", "rb"],
  "willingness": ["w-ih1 l-ih-ng n-ah-s", "nn"],
  "willow": ["w-ih1 l-ow", "nn"],
  "willowy": ["w-ih1 l-ah-w iy", "jj"],
  "willpower": ["w-ih1-l p-aw er", "nn"],
  "willy": ["w-ih1 l-iy", "rb"],
  "wilt": ["w-ih1-l-t", "vb"],
  "wilted": ["w-ih1-l t-ih-d", "jj vbn"],
  "wily": ["w-ay1 l-iy", "jj"],
  "wimp": ["w-ih1-m-p", "nn vb"],
  "win": ["w-ih1-n", "vb nn vbp"],
  "wince": ["w-ih1-n-s", "nn vb"],
  "wind": ["w-ay1-n-d", "nn vbp vb"],
  "winded": ["w-ih1-n d-ih-d", "jj vbn"],
  "winder": ["w-ih1-n d-er", "nn"],
  "windfall": ["w-ih1-n-d f-ao-l", "nn"],
  "winding": ["w-ay1-n d-ih-ng", "vbg jj nn"],
  "windmill": ["w-ih1-n-d m-ih-l", "nn"],
  "window": ["w-ih1-n d-ow", "nn"],
  "windowless": ["w-ih1-n d-ow l-ah-s", "jj"],
  "windowpane": ["w-ih1-n d-ow p-ey-n", "nn"],
  "windshield": ["w-ih1-n-d sh-iy-l-d", "nn"],
  "windstorm": ["w-ih1-n-d s-t-ao-r-m", "nn"],
  "windswept": ["w-ih1-n s-w-eh-p-t", "jj"],
  "windup": ["w-ay1-n d-ah-p", "nn"],
  "windy": ["w-ih1-n d-iy", "jj"],
  "wine": ["w-ay1-n", "nn jj"],
  "winery": ["w-ay1 n-er iy", "nn"],
  "wing": ["w-ih1-ng", "nn vb"],
  "winged": ["w-ih1-ng-d", "vbd vbn jj"],
  "winger": ["w-ih1 ng-er", "nn"],
  "wingman": ["w-ih1-ng m-ah-n", "nn"],
  "wink": ["w-ih1-ng-k", "nn vb"],
  "winner": ["w-ih1 n-er", "nn"],
  "winning": ["w-ih1 n-ih-ng", "vbg jj nn"],
  "wino": ["w-iy1 n-ow", "nn"],
  "winsome": ["w-ih1-n s-ah-m", "jj"],
  "winter": ["w-ih1-n t-er", "nn vb"],
  "wintertime": ["w-ih1-n t-er t-ay-m", "nn"],
  "wintry": ["w-ih1-n t-r-iy", "jj"],
  "wipe": ["w-ay1-p", "vb vbp"],
  "wipeout": ["w-ay1-p aw-t", "nn"],
  "wire": ["w-ay1 er", "nn vb"],
  "wireless": ["w-ay1-r l-ih-s", "jj"],
  "wireline": ["w-ay1-r l-ay-n", "jj"],
  "wiretap": ["w-ay1 er t-ae-p", "nn"],
  "wiry": ["w-ih1 r-iy", "jj"],
  "wisdom": ["w-ih1-z d-ah-m", "nn"],
  "wise": ["w-ay1-z", "jj"],
  "wisecrack": ["w-ay1-z k-r-ae-k", "nn"],
  "wisely": ["w-ay1-z l-iy", "rb"],
  "wiser": ["w-ay1 z-er", "jjr rbr"],
  "wisest": ["w-ay1 z-ah-s-t", "jjs"],
  "wish": ["w-ih1-sh", "vbp nn vb"],
  "wisher": ["w-ih1 sh-er", "nn"],
  "wishful": ["w-ih1-sh f-ah-l", "jj"],
  "wisp": ["w-ih1-s-p", "nn"],
  "wispy": ["w-ih1 s-p-iy", "jj"],
  "wistful": ["w-ih1-s-t f-ah-l", "jj"],
  "wistfully": ["w-ih1-s-t f-ah l-iy", "rb"],
  "wit": ["w-ih1-t", "nn"],
  "witch": ["w-ih1-ch", "nn"],
  "witchcraft": ["w-ih1-ch k-r-ae-f-t", "nn"],
  "witching": ["w-ih1 ch-ih-ng", "jj nn"],
  "with": ["w-ih1-dh", "in jj rb rp"],
  "withdraw": ["w-ih-dh d-r-ao1", "vb vbp"],
  "withdrawal": ["w-ih-dh d-r-ao1 ah-l", "nn"],
  "withdrawn": ["w-ih-th d-r-ao1-n", "vbn"],
  "withdrew": ["w-ih-th d-r-uw1", "vbd"],
  "wither": ["w-ih1 dh-er", "vb vbp"],
  "withered": ["w-ih1 dh-er-d", "jj vbn"],
  "withering": ["w-ih1 dh-er ih-ng", "vbg jj"],
  "withheld": ["w-ih-th hh-eh1-l-d", "vbn vbd"],
  "withhold": ["w-ih-th hh-ow1-l-d", "vb vbp"],
  "within": ["w-ih dh-ih1-n", "in rb"],
  "without": ["w-ih th-aw1-t", "in"],
  "withstand": ["w-ih-th s-t-ae1-n-d", "vb vbp"],
  "withstood": ["w-ih-th s-t-uh1-d", "vbd vbn"],
  "witness": ["w-ih1-t n-ah-s", "nn vb"],
  "wittily": ["w-ih1 t-ah l-iy", "rb"],
  "wittingly": ["w-ih1 t-ih-ng l-iy", "rb"],
  "witty": ["w-ih1 t-iy", "jj"],
  "wizard": ["w-ih1 z-er-d", "nn"],
  "wobble": ["w-aa1 b-ah-l", "vb nn"],
  "wobbly": ["w-aa1 b-ah-l iy", "jj"],
  "woe": ["w-ow1", "nn"],
  "woeful": ["w-ow1 f-ah-l", "jj"],
  "woefully": ["w-ow1 f-ah l-iy", "rb"],
  "woke": ["w-ow1-k", "vbd"],
  "woken": ["w-ow1 k-ah-n", "vbn"],
  "wolf": ["w-uh1-l-f", "nn"],
  "woman": ["w-uh1 m-ah-n", "nn"],
  "women": ["w-ih1 m-eh-n", "nns"],
  "womanhood": ["w-uh1 m-ah-n hh-uh-d", "nn"],
  "womanize": ["w-uh1-m-ah-n-ay-z", "vb"],
  "womb": ["w-uw1-m", "nn"],
  "won": ["w-ah1-n", "vbd nn vbn"],
  "wonder": ["w-ah1-n d-er", "nn vbp jj vb"],
  "wonderful": ["w-ah1-n d-er f-ah-l", "jj"],
  "wonderfully": ["w-ah1-n d-er f-ah l-iy", "rb"],
  "wonderfulness": ["w-ah1-n d-er f-ah-l n-ah-s", "nn"],
  "wonderland": ["w-ah1-n d-er l-ae-n-d", "nn"],
  "wondrous": ["w-ah1-n d-r-ah-s", "jj"],
  "won't": ["w-ow1-n-t", "vbp"],
  "woo": ["w-uw1", "vb vbp"],
  "wood": ["w-uh1-d", "nn"],
  "wooded": ["w-uh1 d-ih-d", "jj"],
  "wooden": ["w-uh1 d-ah-n", "jj"],
  "woodland": ["w-uh1-d l-ae-n-d", "jj"],
  "woodpecker": ["w-uh1-d p-eh k-er", "nn"],
  "woodwind": ["w-uh1-d w-ih-n-d", "nn"],
  "woodwork": ["w-uh1-d w-er-k", "nn"],
  "woodworking": ["w-uh1-d w-er k-ih-ng", "nn"],
  "woof": ["w-uw1-f", "nn"],
  "wool": ["w-uh1-l", "nn"],
  "woolen": ["w-uh1 l-ah-n", "jj"],
  "woolly": ["w-uh1 l-iy", "jj"],
  "woozy": ["w-uw1 z-iy", "jj"],
  "word": ["w-er1-d", "nn vb"],
  "worded": ["w-er1 d-ih-d", "vbn jj vbd"],
  "wording": ["w-er1 d-ih-ng", "nn"],
  "wore": ["w-ao1-r", "vbd"],
  "work": ["w-er1-k", "nn vb vbp"],
  "workable": ["w-er1 k-ah b-ah-l", "jj"],
  "workaholic": ["w-er1 k-ah hh-aa1 l-ih-k", "nn jj"],
  "workbench": ["w-er1-k b-eh-n-ch", "nn"],
  "workday": ["w-er1-k d-ey", "nn"],
  "worker": ["w-er1 k-er", "nn"],
  "workforce": ["w-er1-k f-ao-r-s", "nn"],
  "workhorse": ["w-er1-k hh-ao-r-s", "nn"],
  "working": ["w-er1 k-ih-ng", "vbg jj nn"],
  "workload": ["w-er1-k l-ow-d", "nn"],
  "workman": ["w-er1-k m-ah-n", "nn"],
  "workmanlike": ["w-er1-k m-ae-n l-ay-k", "jj"],
  "workmanship": ["w-er1-k m-ah-n sh-ih-p", "nn"],
  "workout": ["w-er1-k aw-t", "nn"],
  "workplace": ["w-er1-k p-l-ey-s", "nn jj"],
  "workroom": ["w-er1-k r-uw-m", "nn"],
  "worksheet": ["w-er1-k sh-iy-t", "nn"],
  "workshop": ["w-er1-k sh-aa-p", "nn"],
  "workstation": ["w-er1-k s-t-ey sh-ah-n", "nn"],
  "workweek": ["w-er1-k w-iy-k", "nn"],
  "world": ["w-er1-l-d", "nn rb"],
  "worldly": ["w-er1-l-d l-iy", "jj"],
  "worldwide": ["w-er1-l-d w-ay1-d", "jj rb"],
  "worm": ["w-er1-m", "nn"],
  "worn": ["w-ao1-r-n", "vbn jj"],
  "worried": ["w-er1 iy-d", "vbn vbd jj"],
  "worrier": ["w-er1 iy er", "nn"],
  "worrisome": ["w-er1 iy s-ah-m", "jj"],
  "worry": ["w-er1 iy", "vb nn vbp"],
  "worrying": ["w-er1 iy ih-ng", "vbg jj"],
  "worse": ["w-er1-s", "jj"],
  "worsen": ["w-er1 s-ah-n", "vb"],
  "worsening": ["w-er1 s-ah-n ih-ng", "vbg jj"],
  "worship": ["w-er1 sh-ah-p", "nn vb vbp"],
  "worshipful": ["w-er1 sh-ah-p f-ah-l", "jj"],
  "worshipper": ["w-er1 sh-ih p-er", "nn"],
  "worst": ["w-er1-s-t", "jjs rbs jj"],
  "worsted": ["w-er1 s-t-ih-d", "jj nn"],
  "worth": ["w-er1-th", "jj in nn rb vbn"],
  "worthier": ["w-er1 dh-iy er", "jjr"],
  "worthiest": ["w-er1 dh-iy ah-s-t", "jjs"],
  "worthiness": ["w-er1 dh-iy n-ih-s", "nn"],
  "worthless": ["w-er1-th l-ah-s", "jj"],
  "worthwhile": ["w-er1-th w-ay1-l", "jj"],
  "worthy": ["w-er1 dh-iy", "jj"],
  "would": ["w-uh1-d", "md vbd"],
  "wouldn't": ["w-uh1-d-ah-n-t", "md"],
  "wound": ["w-aw1-n-d", "nn vbd vbn vb"],
  "wounded": ["w-uw1-n d-ah-d", "vbn jj"],
  "wove": ["w-ow1-v", "vbd"],
  "woven": ["w-ow1 v-ah-n", "vbn jj"],
  "wow": ["w-aw1", "vb"],
  "wrack": ["r-ae1-k", "vb vbp"],
  "wrangle": ["r-ae1-ng-g-ah-l", "vb"],
  "wrangler": ["r-ae1-ng g-ah l-er", "nn"],
  "wrap": ["r-ae1-p", "vb nn vbp"],
  "wrapper": ["r-ae1 p-er", "nn"],
  "wrath": ["r-ae1-th", "nn"],
  "wreak": ["r-iy1-k", "vb"],
  "wreath": ["r-iy1-th", "nn"],
  "wreck": ["r-eh1-k", "nn vb"],
  "wreckage": ["r-eh1 k-ah-jh", "nn"],
  "wrecked": ["r-eh1-k-t", "vbd jj vbn"],
  "wrecker": ["r-eh1 k-er", "nn"],
  "wrench": ["r-eh1-n-ch", "vb nn"],
  "wrenching": ["r-eh1-n ch-ih-ng", "jj vbg"],
  "wrest": ["r-eh1-s-t", "vb"],
  "wrestle": ["r-eh1 s-ah-l", "vb"],
  "wrestler": ["r-eh1 s-ah l-er", "nn"],
  "wretched": ["r-eh1 ch-ih-d", "jj"],
  "wring": ["r-ih1-ng", "vb"],
  "wrinkle": ["r-ih1-ng k-ah-l", "nn vb"],
  "wrinkled": ["r-ih1-ng k-ah-l-d", "jj vbd vbn"],
  "wrist": ["r-ih1-s-t", "nn"],
  "wristwatch": ["r-ih1-s-t w-aa-ch", "nn"],
  "writ": ["r-ih1-t", "nn vbn"],
  "write": ["r-ay1-t", "vb vbp"],
  "writedown": ["r-ay1-t d-aw-n", "nn"],
  "writeoff": ["r-ay1 t-ao-f", "nn"],
  "writer": ["r-ay1 t-er", "nn"],
  "writhe": ["r-ih1-th", "vb"],
  "writhing": ["r-ay1 dh-ih-ng", "vbg jj nn"],
  "written": ["r-ih1 t-ah-n", "vbn jj"],
  "wrong": ["r-ao1-ng", "jj nn rb vb"],
  "wrongdoer": ["r-ao1-ng d-uw1 er", "nn"],
  "wrongdoing": ["r-ao1-ng d-uw ih-ng", "nn"],
  "wronged": ["r-ao1-ng-d", "vbn jj"],
  "wrongful": ["r-ao1-ng f-ah-l", "jj"],
  "wrongfully": ["r-ao1-ng f-ah l-iy", "rb"],
  "wrongly": ["r-ao1-ng l-iy", "rb"],
  "wrote": ["r-ow1-t", "vbd"],
  "wrought": ["r-ao1-t", "vbn vbd jj"],
  "wrung": ["r-ah1-ng", "vbd vbn"],
  "wry": ["r-ay1", "jj"],
  "wryly": ["r-ay1 l-iy", "rb"],
  "xenon": ["z-iy1 n-aa-n", "nn"],
  "xenophobia": ["z-eh n-ah f-ow1 b-iy ah", "nn"],
  "xenophobic": ["z-eh n-ah f-aa1 b-ih-k", "jj"],
  "yacht": ["y-aa1-t", "nn"],
  "yachting": ["y-aa1 t-ih-ng", "nn"],
  "yachtsman": ["y-aa1-t-s m-ah-n", "nn"],
  "yank": ["y-ae1-ng-k", "vb"],
  "yard": ["y-aa1-r-d", "nn"],
  "yardage": ["y-aa1-r d-ih-jh", "nn"],
  "yardstick": ["y-aa1-r-d s-t-ih-k", "nn"],
  "yarn": ["y-aa1-r-n", "nn"],
  "yawn": ["y-ao1-n", "nn vb"],
  "yawning": ["y-ao1 n-ih-ng", "vbg jj"],
  "yeah": ["y-ae1", "uh nn"],
  "year": ["y-ih1-r", "nn jj"],
  "yearbook": ["y-ih1-r b-uh-k", "nn"],
  "yearling": ["y-er1 l-ih-ng", "jj"],
  "yearly": ["y-ih1-r l-iy", "jj rb"],
  "yearn": ["y-er1-n", "vb vbp nn"],
  "yearning": ["y-er1 n-ih-ng", "nn vbg"],
  "yeast": ["y-iy1-s-t", "nn"],
  "yell": ["y-eh1-l", "nn vb"],
  "yellow": ["y-eh1 l-ow", "jj nn vb"],
  "yellowish": ["y-eh1 l-ow ih-sh", "jj"],
  "yes": ["y-eh1-s", "uh rb"],
  "yesterday": ["y-eh1 s-t-er d-ey", "nn rb"],
  "yet": ["y-eh1-t", "rb cc"],
  "yield": ["y-iy1-l-d", "vb vbp"],
  "yielding": ["y-iy1-l d-ih-ng", "vbg jj nn"],
  "yodel": ["y-ow1 d-ah-l", "nn vb"],
  "yoga": ["y-ow1 g-ah", "nn"],
  "yogurt": ["y-ow1 g-er-t", "nn"],
  "yoke": ["y-ow1-k", "nn"],
  "yolk": ["y-ow1-k", "nn"],
  "yonder": ["y-aa1-n d-er", "nn"],
  "you": ["y-uw1", "prp rp"],
  "young": ["y-ah1-ng", "jj"],
  "younger": ["y-ah1-ng g-er", "jjr"],
  "youngest": ["y-ah1-ng g-ah-s-t", "jjs"],
  "youngster": ["y-ah1-ng s-t-er", "nn"],
  "your": ["y-ao1-r", "prp$"],
  "yours": ["y-uh1-r-z", "prp jj"],
  "yourself": ["y-er s-eh1-l-f", "prp"],
  "yourselves": ["y-uh-r s-eh1-l-v-z", "prp"],
  "youth": ["y-uw1-th", "nn"],
  "youthful": ["y-uw1-th f-ah-l", "jj"],
  "yoyo": ["y-ow1 y-ow", "nn"],
  "yummy": ["y-ah1 m-iy", "jj nn"],
  "yuppie": ["y-ah1 p-iy", "nn"],
  "zany": ["z-ey1 n-iy", "jj"],
  "zap": ["z-ae1-p", "vb vbp"],
  "zeal": ["z-iy1-l", "nn"],
  "zealot": ["z-eh1 l-ah-t", "nn"],
  "zealous": ["z-eh1 l-ah-s", "jj"],
  "zealously": ["z-iy1 l-ah-s l-iy", "rb"],
  "zebra": ["z-iy1 b-r-ah", "nn"],
  "zenith": ["z-iy1 n-ah-th", "nn"],
  "zero": ["z-ih1 r-ow", "cd"],
  "zest": ["z-eh1-s-t", "nn"],
  "zigzag": ["z-ih1-g z-ae-g", "vb"],
  "zilch": ["z-ih1-l-ch", "nn jj"],
  "zinc": ["z-ih1-ng-k", "nn"],
  "zip": ["z-ih1-p", "vbp vb"],
  "zipper": ["z-ih1 p-er", "nn"],
  "zippo": ["z-ih1 p-ow", "nn"],
  "zombie": ["z-aa1-m b-iy", "nn"],
  "zone": ["z-ow1-n", "nn"],
  "zoo": ["z-uw1", "nn"],
  "zoologist": ["z-ow aa1 l-ah jh-ah-s-t", "nn"],
  "zoology": ["z-ow aa1 l-ah jh-iy", "nn"],
  "zoom": ["z-uw1-m", "vb"],
  "twelve": ["t-w-eh1-l-v", "cd"],
  "thirteen": ["th-er1 t-iy-n", "cd"],
  "fourteen": ["f-ao1-r t-iy-n", "cd"],
  "fifteen": ["f-ih1-f t-iy-n", "cd"],
  "sixteen": ["s-ih1-k-s t-iy-n", "cd"],
  "seventeen": ["s-eh1-v-ah-n t-iy-n", "cd"],
  "eighteen": ["ey1 t-iy-n", "cd"],
  "nineteen": ["n-ay1-n t-iy-n", "cd"],
  "forty": ["f-ao1-r t-iy", "cd"],
  "fifty": ["f-ih1-f t-iy", "cd"],
  "sixty": ["s-ih1-k-s t-iy", "cd"]
};
